webpackJsonp([1,0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.warning = undefined;
	
	var _extends2 = __webpack_require__(131);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _typeof2 = __webpack_require__(52);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports.format = format;
	exports.isEmptyValue = isEmptyValue;
	exports.isEmptyObject = isEmptyObject;
	exports.asyncMap = asyncMap;
	exports.complementError = complementError;
	exports.deepMerge = deepMerge;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var formatRegExp = /%[sdj%]/g;
	
	var warning = exports.warning = function warning() {};
	
	// don't print warning message when in production env or node runtime
	if (false) {
	  exports.warning = warning = function warning(type, errors) {
	    if (typeof console !== 'undefined' && console.warn) {
	      if (errors.every(function (e) {
	        return typeof e === 'string';
	      })) {
	        console.warn(type, errors);
	      }
	    }
	  };
	}
	
	function format() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  var i = 1;
	  var f = args[0];
	  var len = args.length;
	  if (typeof f === 'function') {
	    return f.apply(null, args.slice(1));
	  }
	  if (typeof f === 'string') {
	    var str = String(f).replace(formatRegExp, function (x) {
	      if (x === '%%') {
	        return '%';
	      }
	      if (i >= len) {
	        return x;
	      }
	      switch (x) {
	        case '%s':
	          return String(args[i++]);
	        case '%d':
	          return Number(args[i++]);
	        case '%j':
	          try {
	            return JSON.stringify(args[i++]);
	          } catch (_) {
	            return '[Circular]';
	          }
	          break;
	        default:
	          return x;
	      }
	    });
	    for (var arg = args[i]; i < len; arg = args[++i]) {
	      str += ' ' + arg;
	    }
	    return str;
	  }
	  return f;
	}
	
	function isNativeStringType(type) {
	  return type === 'string' || type === 'url' || type === 'hex' || type === 'email' || type === 'pattern';
	}
	
	function isEmptyValue(value, type) {
	  if (value === undefined || value === null) {
	    return true;
	  }
	  if (type === 'array' && Array.isArray(value) && !value.length) {
	    return true;
	  }
	  if (isNativeStringType(type) && typeof value === 'string' && !value) {
	    return true;
	  }
	  return false;
	}
	
	function isEmptyObject(obj) {
	  return Object.keys(obj).length === 0;
	}
	
	function asyncParallelArray(arr, func, callback) {
	  var results = [];
	  var total = 0;
	  var arrLength = arr.length;
	
	  function count(errors) {
	    results.push.apply(results, errors);
	    total++;
	    if (total === arrLength) {
	      callback(results);
	    }
	  }
	
	  arr.forEach(function (a) {
	    func(a, count);
	  });
	}
	
	function asyncSerialArray(arr, func, callback) {
	  var index = 0;
	  var arrLength = arr.length;
	
	  function next(errors) {
	    if (errors && errors.length) {
	      callback(errors);
	      return;
	    }
	    var original = index;
	    index = index + 1;
	    if (original < arrLength) {
	      func(arr[original], next);
	    } else {
	      callback([]);
	    }
	  }
	
	  next([]);
	}
	
	function flattenObjArr(objArr) {
	  var ret = [];
	  Object.keys(objArr).forEach(function (k) {
	    ret.push.apply(ret, objArr[k]);
	  });
	  return ret;
	}
	
	function asyncMap(objArr, option, func, callback) {
	  if (option.first) {
	    var flattenArr = flattenObjArr(objArr);
	    return asyncSerialArray(flattenArr, func, callback);
	  }
	  var firstFields = option.firstFields || [];
	  if (firstFields === true) {
	    firstFields = Object.keys(objArr);
	  }
	  var objArrKeys = Object.keys(objArr);
	  var objArrLength = objArrKeys.length;
	  var total = 0;
	  var results = [];
	  var next = function next(errors) {
	    results.push.apply(results, errors);
	    total++;
	    if (total === objArrLength) {
	      callback(results);
	    }
	  };
	  objArrKeys.forEach(function (key) {
	    var arr = objArr[key];
	    if (firstFields.indexOf(key) !== -1) {
	      asyncSerialArray(arr, func, next);
	    } else {
	      asyncParallelArray(arr, func, next);
	    }
	  });
	}
	
	function complementError(rule) {
	  return function (oe) {
	    if (oe && oe.message) {
	      oe.field = oe.field || rule.fullField;
	      return oe;
	    }
	    return {
	      message: oe,
	      field: oe.field || rule.fullField
	    };
	  };
	}
	
	function deepMerge(target, source) {
	  if (source) {
	    for (var s in source) {
	      if (source.hasOwnProperty(s)) {
	        var value = source[s];
	        if ((typeof value === 'undefined' ? 'undefined' : (0, _typeof3['default'])(value)) === 'object' && (0, _typeof3['default'])(target[s]) === 'object') {
	          target[s] = (0, _extends3['default'])({}, target[s], value);
	        } else {
	          target[s] = value;
	        }
	      }
	    }
	  }
	  return target;
	}

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	if (true) {
	  module.exports = __webpack_require__(486)
	} else {
	  module.exports = require('./vue.runtime.common.dev.js')
	}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(239);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _required = __webpack_require__(129);
	
	var _required2 = _interopRequireDefault(_required);
	
	var _whitespace = __webpack_require__(410);
	
	var _whitespace2 = _interopRequireDefault(_whitespace);
	
	var _type = __webpack_require__(409);
	
	var _type2 = _interopRequireDefault(_type);
	
	var _range = __webpack_require__(408);
	
	var _range2 = _interopRequireDefault(_range);
	
	var _enum = __webpack_require__(406);
	
	var _enum2 = _interopRequireDefault(_enum);
	
	var _pattern = __webpack_require__(407);
	
	var _pattern2 = _interopRequireDefault(_pattern);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = {
	  required: _required2['default'],
	  whitespace: _whitespace2['default'],
	  type: _type2['default'],
	  range: _range2['default'],
	  'enum': _enum2['default'],
	  pattern: _pattern2['default']
	};
	module.exports = exports['default'];

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(69)('wks');
	var uid = __webpack_require__(49);
	var Symbol = __webpack_require__(8).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 10 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.5.3' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.isEmpty = exports.isEqual = exports.arrayEquals = exports.looseEqual = exports.capitalize = exports.kebabCase = exports.autoprefixer = exports.isFirefox = exports.isEdge = exports.isIE = exports.coerceTruthyValueToArray = exports.arrayFind = exports.arrayFindIndex = exports.escapeRegexpString = exports.valueEquals = exports.generateId = exports.getValueByPath = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.noop = noop;
	exports.hasOwn = hasOwn;
	exports.toObject = toObject;
	exports.getPropByPath = getPropByPath;
	exports.rafThrottle = rafThrottle;
	exports.objToArray = objToArray;
	
	var _vue = __webpack_require__(3);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _types = __webpack_require__(148);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	function noop() {};
	
	function hasOwn(obj, key) {
	  return hasOwnProperty.call(obj, key);
	};
	
	function extend(to, _from) {
	  for (var key in _from) {
	    to[key] = _from[key];
	  }
	  return to;
	};
	
	function toObject(arr) {
	  var res = {};
	  for (var i = 0; i < arr.length; i++) {
	    if (arr[i]) {
	      extend(res, arr[i]);
	    }
	  }
	  return res;
	};
	
	var getValueByPath = exports.getValueByPath = function getValueByPath(object, prop) {
	  prop = prop || '';
	  var paths = prop.split('.');
	  var current = object;
	  var result = null;
	  for (var i = 0, j = paths.length; i < j; i++) {
	    var path = paths[i];
	    if (!current) break;
	
	    if (i === j - 1) {
	      result = current[path];
	      break;
	    }
	    current = current[path];
	  }
	  return result;
	};
	
	function getPropByPath(obj, path, strict) {
	  var tempObj = obj;
	  path = path.replace(/\[(\w+)\]/g, '.$1');
	  path = path.replace(/^\./, '');
	
	  var keyArr = path.split('.');
	  var i = 0;
	  for (var len = keyArr.length; i < len - 1; ++i) {
	    if (!tempObj && !strict) break;
	    var key = keyArr[i];
	    if (key in tempObj) {
	      tempObj = tempObj[key];
	    } else {
	      if (strict) {
	        throw new Error('please transfer a valid prop path to form item!');
	      }
	      break;
	    }
	  }
	  return {
	    o: tempObj,
	    k: keyArr[i],
	    v: tempObj ? tempObj[keyArr[i]] : null
	  };
	};
	
	var generateId = exports.generateId = function generateId() {
	  return Math.floor(Math.random() * 10000);
	};
	
	var valueEquals = exports.valueEquals = function valueEquals(a, b) {
	  // see: https://stackoverflow.com/questions/3115982/how-to-check-if-two-arrays-are-equal-with-javascript
	  if (a === b) return true;
	  if (!(a instanceof Array)) return false;
	  if (!(b instanceof Array)) return false;
	  if (a.length !== b.length) return false;
	  for (var i = 0; i !== a.length; ++i) {
	    if (a[i] !== b[i]) return false;
	  }
	  return true;
	};
	
	var escapeRegexpString = exports.escapeRegexpString = function escapeRegexpString() {
	  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  return String(value).replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
	};
	
	// TODO: use native Array.find, Array.findIndex when IE support is dropped
	var arrayFindIndex = exports.arrayFindIndex = function arrayFindIndex(arr, pred) {
	  for (var i = 0; i !== arr.length; ++i) {
	    if (pred(arr[i])) {
	      return i;
	    }
	  }
	  return -1;
	};
	
	var arrayFind = exports.arrayFind = function arrayFind(arr, pred) {
	  var idx = arrayFindIndex(arr, pred);
	  return idx !== -1 ? arr[idx] : undefined;
	};
	
	// coerce truthy value to array
	var coerceTruthyValueToArray = exports.coerceTruthyValueToArray = function coerceTruthyValueToArray(val) {
	  if (Array.isArray(val)) {
	    return val;
	  } else if (val) {
	    return [val];
	  } else {
	    return [];
	  }
	};
	
	var isIE = exports.isIE = function isIE() {
	  return !_vue2.default.prototype.$isServer && !isNaN(Number(document.documentMode));
	};
	
	var isEdge = exports.isEdge = function isEdge() {
	  return !_vue2.default.prototype.$isServer && navigator.userAgent.indexOf('Edge') > -1;
	};
	
	var isFirefox = exports.isFirefox = function isFirefox() {
	  return !_vue2.default.prototype.$isServer && !!window.navigator.userAgent.match(/firefox/i);
	};
	
	var autoprefixer = exports.autoprefixer = function autoprefixer(style) {
	  if ((typeof style === 'undefined' ? 'undefined' : _typeof(style)) !== 'object') return style;
	  var rules = ['transform', 'transition', 'animation'];
	  var prefixes = ['ms-', 'webkit-'];
	  rules.forEach(function (rule) {
	    var value = style[rule];
	    if (rule && value) {
	      prefixes.forEach(function (prefix) {
	        style[prefix + rule] = value;
	      });
	    }
	  });
	  return style;
	};
	
	var kebabCase = exports.kebabCase = function kebabCase(str) {
	  var hyphenateRE = /([^-])([A-Z])/g;
	  return str.replace(hyphenateRE, '$1-$2').replace(hyphenateRE, '$1-$2').toLowerCase();
	};
	
	var capitalize = exports.capitalize = function capitalize(str) {
	  if (!(0, _types.isString)(str)) return str;
	  return str.charAt(0).toUpperCase() + str.slice(1);
	};
	
	var looseEqual = exports.looseEqual = function looseEqual(a, b) {
	  var isObjectA = (0, _types.isObject)(a);
	  var isObjectB = (0, _types.isObject)(b);
	  if (isObjectA && isObjectB) {
	    return JSON.stringify(a) === JSON.stringify(b);
	  } else if (!isObjectA && !isObjectB) {
	    return String(a) === String(b);
	  } else {
	    return false;
	  }
	};
	
	var arrayEquals = exports.arrayEquals = function arrayEquals(arrayA, arrayB) {
	  arrayA = arrayA || [];
	  arrayB = arrayB || [];
	
	  if (arrayA.length !== arrayB.length) {
	    return false;
	  }
	
	  for (var i = 0; i < arrayA.length; i++) {
	    if (!looseEqual(arrayA[i], arrayB[i])) {
	      return false;
	    }
	  }
	
	  return true;
	};
	
	var isEqual = exports.isEqual = function isEqual(value1, value2) {
	  if (Array.isArray(value1) && Array.isArray(value2)) {
	    return arrayEquals(value1, value2);
	  }
	  return looseEqual(value1, value2);
	};
	
	var isEmpty = exports.isEmpty = function isEmpty(val) {
	  // null or undefined
	  if (val == null) return true;
	
	  if (typeof val === 'boolean') return false;
	
	  if (typeof val === 'number') return !val;
	
	  if (val instanceof Error) return val.message === '';
	
	  switch (Object.prototype.toString.call(val)) {
	    // String or Array
	    case '[object String]':
	    case '[object Array]':
	      return !val.length;
	
	    // Map or Set or File
	    case '[object File]':
	    case '[object Map]':
	    case '[object Set]':
	      {
	        return !val.size;
	      }
	    // Plain Object
	    case '[object Object]':
	      {
	        return !Object.keys(val).length;
	      }
	  }
	
	  return false;
	};
	
	function rafThrottle(fn) {
	  var locked = false;
	  return function () {
	    var _this = this;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    if (locked) return;
	    locked = true;
	    window.requestAnimationFrame(function (_) {
	      fn.apply(_this, args);
	      locked = false;
	    });
	  };
	}
	
	function objToArray(obj) {
	  if (Array.isArray(obj)) {
	    return obj;
	  }
	  return isEmpty(obj) ? [] : [obj];
	}

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(24);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.isInContainer = exports.getScrollContainer = exports.isScroll = exports.getStyle = exports.once = exports.off = exports.on = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* istanbul ignore next */
	
	exports.hasClass = hasClass;
	exports.addClass = addClass;
	exports.removeClass = removeClass;
	exports.setStyle = setStyle;
	
	var _vue = __webpack_require__(3);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isServer = _vue2.default.prototype.$isServer;
	var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
	var MOZ_HACK_REGEXP = /^moz([A-Z])/;
	var ieVersion = isServer ? 0 : Number(document.documentMode);
	
	/* istanbul ignore next */
	var trim = function trim(string) {
	  return (string || '').replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, '');
	};
	/* istanbul ignore next */
	var camelCase = function camelCase(name) {
	  return name.replace(SPECIAL_CHARS_REGEXP, function (_, separator, letter, offset) {
	    return offset ? letter.toUpperCase() : letter;
	  }).replace(MOZ_HACK_REGEXP, 'Moz$1');
	};
	
	/* istanbul ignore next */
	var on = exports.on = function () {
	  if (!isServer && document.addEventListener) {
	    return function (element, event, handler) {
	      if (element && event && handler) {
	        element.addEventListener(event, handler, false);
	      }
	    };
	  } else {
	    return function (element, event, handler) {
	      if (element && event && handler) {
	        element.attachEvent('on' + event, handler);
	      }
	    };
	  }
	}();
	
	/* istanbul ignore next */
	var off = exports.off = function () {
	  if (!isServer && document.removeEventListener) {
	    return function (element, event, handler) {
	      if (element && event) {
	        element.removeEventListener(event, handler, false);
	      }
	    };
	  } else {
	    return function (element, event, handler) {
	      if (element && event) {
	        element.detachEvent('on' + event, handler);
	      }
	    };
	  }
	}();
	
	/* istanbul ignore next */
	var once = exports.once = function once(el, event, fn) {
	  var listener = function listener() {
	    if (fn) {
	      fn.apply(this, arguments);
	    }
	    off(el, event, listener);
	  };
	  on(el, event, listener);
	};
	
	/* istanbul ignore next */
	function hasClass(el, cls) {
	  if (!el || !cls) return false;
	  if (cls.indexOf(' ') !== -1) throw new Error('className should not contain space.');
	  if (el.classList) {
	    return el.classList.contains(cls);
	  } else {
	    return (' ' + el.className + ' ').indexOf(' ' + cls + ' ') > -1;
	  }
	};
	
	/* istanbul ignore next */
	function addClass(el, cls) {
	  if (!el) return;
	  var curClass = el.className;
	  var classes = (cls || '').split(' ');
	
	  for (var i = 0, j = classes.length; i < j; i++) {
	    var clsName = classes[i];
	    if (!clsName) continue;
	
	    if (el.classList) {
	      el.classList.add(clsName);
	    } else if (!hasClass(el, clsName)) {
	      curClass += ' ' + clsName;
	    }
	  }
	  if (!el.classList) {
	    el.className = curClass;
	  }
	};
	
	/* istanbul ignore next */
	function removeClass(el, cls) {
	  if (!el || !cls) return;
	  var classes = cls.split(' ');
	  var curClass = ' ' + el.className + ' ';
	
	  for (var i = 0, j = classes.length; i < j; i++) {
	    var clsName = classes[i];
	    if (!clsName) continue;
	
	    if (el.classList) {
	      el.classList.remove(clsName);
	    } else if (hasClass(el, clsName)) {
	      curClass = curClass.replace(' ' + clsName + ' ', ' ');
	    }
	  }
	  if (!el.classList) {
	    el.className = trim(curClass);
	  }
	};
	
	/* istanbul ignore next */
	var getStyle = exports.getStyle = ieVersion < 9 ? function (element, styleName) {
	  if (isServer) return;
	  if (!element || !styleName) return null;
	  styleName = camelCase(styleName);
	  if (styleName === 'float') {
	    styleName = 'styleFloat';
	  }
	  try {
	    switch (styleName) {
	      case 'opacity':
	        try {
	          return element.filters.item('alpha').opacity / 100;
	        } catch (e) {
	          return 1.0;
	        }
	      default:
	        return element.style[styleName] || element.currentStyle ? element.currentStyle[styleName] : null;
	    }
	  } catch (e) {
	    return element.style[styleName];
	  }
	} : function (element, styleName) {
	  if (isServer) return;
	  if (!element || !styleName) return null;
	  styleName = camelCase(styleName);
	  if (styleName === 'float') {
	    styleName = 'cssFloat';
	  }
	  try {
	    var computed = document.defaultView.getComputedStyle(element, '');
	    return element.style[styleName] || computed ? computed[styleName] : null;
	  } catch (e) {
	    return element.style[styleName];
	  }
	};
	
	/* istanbul ignore next */
	function setStyle(element, styleName, value) {
	  if (!element || !styleName) return;
	
	  if ((typeof styleName === 'undefined' ? 'undefined' : _typeof(styleName)) === 'object') {
	    for (var prop in styleName) {
	      if (styleName.hasOwnProperty(prop)) {
	        setStyle(element, prop, styleName[prop]);
	      }
	    }
	  } else {
	    styleName = camelCase(styleName);
	    if (styleName === 'opacity' && ieVersion < 9) {
	      element.style.filter = isNaN(value) ? '' : 'alpha(opacity=' + value * 100 + ')';
	    } else {
	      element.style[styleName] = value;
	    }
	  }
	};
	
	var isScroll = exports.isScroll = function isScroll(el, vertical) {
	  if (isServer) return;
	
	  var determinedDirection = vertical !== null || vertical !== undefined;
	  var overflow = determinedDirection ? vertical ? getStyle(el, 'overflow-y') : getStyle(el, 'overflow-x') : getStyle(el, 'overflow');
	
	  return overflow.match(/(scroll|auto)/);
	};
	
	var getScrollContainer = exports.getScrollContainer = function getScrollContainer(el, vertical) {
	  if (isServer) return;
	
	  var parent = el;
	  while (parent) {
	    if ([window, document, document.documentElement].includes(parent)) {
	      return window;
	    }
	    if (isScroll(parent, vertical)) {
	      return parent;
	    }
	    parent = parent.parentNode;
	  }
	
	  return parent;
	};
	
	var isInContainer = exports.isInContainer = function isInContainer(el, container) {
	  if (isServer || !el || !container) return false;
	
	  var elRect = el.getBoundingClientRect();
	  var containerRect = void 0;
	
	  if ([window, document, document.documentElement, null, undefined].includes(container)) {
	    containerRect = {
	      top: 0,
	      right: window.innerWidth,
	      bottom: window.innerHeight,
	      left: 0
	    };
	  } else {
	    containerRect = container.getBoundingClientRect();
	  }
	
	  return elRect.top < containerRect.bottom && elRect.bottom > containerRect.top && elRect.right > containerRect.left && elRect.left < containerRect.right;
	};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(16);
	var IE8_DOM_DEFINE = __webpack_require__(109);
	var toPrimitive = __webpack_require__(73);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(20) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 19 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(36)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(8);
	var core = __webpack_require__(10);
	var ctx = __webpack_require__(35);
	var hide = __webpack_require__(23);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && key in exports) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 22 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(18);
	var createDesc = __webpack_require__(38);
	module.exports = __webpack_require__(20) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 24 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(42)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 26 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 27 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	function _broadcast(componentName, eventName, params) {
	  this.$children.forEach(function (child) {
	    var name = child.$options.componentName;
	
	    if (name === componentName) {
	      child.$emit.apply(child, [eventName].concat(params));
	    } else {
	      _broadcast.apply(child, [componentName, eventName].concat([params]));
	    }
	  });
	}
	exports.default = {
	  methods: {
	    dispatch: function dispatch(componentName, eventName, params) {
	      var parent = this.$parent || this.$root;
	      var name = parent.$options.componentName;
	
	      while (parent && (!name || name !== componentName)) {
	        parent = parent.$parent;
	
	        if (parent) {
	          name = parent.$options.componentName;
	        }
	      }
	      if (parent) {
	        parent.$emit.apply(parent, [eventName].concat(params));
	      }
	    },
	    broadcast: function broadcast(componentName, eventName, params) {
	      _broadcast.call(this, componentName, eventName, params);
	    }
	  }
	};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(110);
	var defined = __webpack_require__(63);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(30);
	var createDesc = __webpack_require__(57);
	module.exports = __webpack_require__(25) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(53);
	var IE8_DOM_DEFINE = __webpack_require__(134);
	var toPrimitive = __webpack_require__(92);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(25) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(135);
	var defined = __webpack_require__(82);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(89)('wks');
	var uid = __webpack_require__(58);
	var Symbol = __webpack_require__(19).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * vuex v2.5.0
	 * (c) 2017 Evan You
	 * @license MIT
	 */
	'use strict';
	
	var applyMixin = function (Vue) {
	  var version = Number(Vue.version.split('.')[0]);
	
	  if (version >= 2) {
	    Vue.mixin({ beforeCreate: vuexInit });
	  } else {
	    // override init and inject vuex init procedure
	    // for 1.x backwards compatibility.
	    var _init = Vue.prototype._init;
	    Vue.prototype._init = function (options) {
	      if ( options === void 0 ) options = {};
	
	      options.init = options.init
	        ? [vuexInit].concat(options.init)
	        : vuexInit;
	      _init.call(this, options);
	    };
	  }
	
	  /**
	   * Vuex init hook, injected into each instances init hooks list.
	   */
	
	  function vuexInit () {
	    var options = this.$options;
	    // store injection
	    if (options.store) {
	      this.$store = typeof options.store === 'function'
	        ? options.store()
	        : options.store;
	    } else if (options.parent && options.parent.$store) {
	      this.$store = options.parent.$store;
	    }
	  }
	};
	
	var devtoolHook =
	  typeof window !== 'undefined' &&
	  window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
	
	function devtoolPlugin (store) {
	  if (!devtoolHook) { return }
	
	  store._devtoolHook = devtoolHook;
	
	  devtoolHook.emit('vuex:init', store);
	
	  devtoolHook.on('vuex:travel-to-state', function (targetState) {
	    store.replaceState(targetState);
	  });
	
	  store.subscribe(function (mutation, state) {
	    devtoolHook.emit('vuex:mutation', mutation, state);
	  });
	}
	
	/**
	 * Get the first item that pass the test
	 * by second argument function
	 *
	 * @param {Array} list
	 * @param {Function} f
	 * @return {*}
	 */
	/**
	 * Deep copy the given object considering circular structure.
	 * This function caches all nested objects and its copies.
	 * If it detects circular structure, use cached copy to avoid infinite loop.
	 *
	 * @param {*} obj
	 * @param {Array<Object>} cache
	 * @return {*}
	 */
	
	
	/**
	 * forEach for object
	 */
	function forEachValue (obj, fn) {
	  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
	}
	
	function isObject (obj) {
	  return obj !== null && typeof obj === 'object'
	}
	
	function isPromise (val) {
	  return val && typeof val.then === 'function'
	}
	
	function assert (condition, msg) {
	  if (!condition) { throw new Error(("[vuex] " + msg)) }
	}
	
	var Module = function Module (rawModule, runtime) {
	  this.runtime = runtime;
	  this._children = Object.create(null);
	  this._rawModule = rawModule;
	  var rawState = rawModule.state;
	  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
	};
	
	var prototypeAccessors$1 = { namespaced: { configurable: true } };
	
	prototypeAccessors$1.namespaced.get = function () {
	  return !!this._rawModule.namespaced
	};
	
	Module.prototype.addChild = function addChild (key, module) {
	  this._children[key] = module;
	};
	
	Module.prototype.removeChild = function removeChild (key) {
	  delete this._children[key];
	};
	
	Module.prototype.getChild = function getChild (key) {
	  return this._children[key]
	};
	
	Module.prototype.update = function update (rawModule) {
	  this._rawModule.namespaced = rawModule.namespaced;
	  if (rawModule.actions) {
	    this._rawModule.actions = rawModule.actions;
	  }
	  if (rawModule.mutations) {
	    this._rawModule.mutations = rawModule.mutations;
	  }
	  if (rawModule.getters) {
	    this._rawModule.getters = rawModule.getters;
	  }
	};
	
	Module.prototype.forEachChild = function forEachChild (fn) {
	  forEachValue(this._children, fn);
	};
	
	Module.prototype.forEachGetter = function forEachGetter (fn) {
	  if (this._rawModule.getters) {
	    forEachValue(this._rawModule.getters, fn);
	  }
	};
	
	Module.prototype.forEachAction = function forEachAction (fn) {
	  if (this._rawModule.actions) {
	    forEachValue(this._rawModule.actions, fn);
	  }
	};
	
	Module.prototype.forEachMutation = function forEachMutation (fn) {
	  if (this._rawModule.mutations) {
	    forEachValue(this._rawModule.mutations, fn);
	  }
	};
	
	Object.defineProperties( Module.prototype, prototypeAccessors$1 );
	
	var ModuleCollection = function ModuleCollection (rawRootModule) {
	  // register root module (Vuex.Store options)
	  this.register([], rawRootModule, false);
	};
	
	ModuleCollection.prototype.get = function get (path) {
	  return path.reduce(function (module, key) {
	    return module.getChild(key)
	  }, this.root)
	};
	
	ModuleCollection.prototype.getNamespace = function getNamespace (path) {
	  var module = this.root;
	  return path.reduce(function (namespace, key) {
	    module = module.getChild(key);
	    return namespace + (module.namespaced ? key + '/' : '')
	  }, '')
	};
	
	ModuleCollection.prototype.update = function update$1 (rawRootModule) {
	  update([], this.root, rawRootModule);
	};
	
	ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
	    var this$1 = this;
	    if ( runtime === void 0 ) runtime = true;
	
	  if (false) {
	    assertRawModule(path, rawModule);
	  }
	
	  var newModule = new Module(rawModule, runtime);
	  if (path.length === 0) {
	    this.root = newModule;
	  } else {
	    var parent = this.get(path.slice(0, -1));
	    parent.addChild(path[path.length - 1], newModule);
	  }
	
	  // register nested modules
	  if (rawModule.modules) {
	    forEachValue(rawModule.modules, function (rawChildModule, key) {
	      this$1.register(path.concat(key), rawChildModule, runtime);
	    });
	  }
	};
	
	ModuleCollection.prototype.unregister = function unregister (path) {
	  var parent = this.get(path.slice(0, -1));
	  var key = path[path.length - 1];
	  if (!parent.getChild(key).runtime) { return }
	
	  parent.removeChild(key);
	};
	
	function update (path, targetModule, newModule) {
	  if (false) {
	    assertRawModule(path, newModule);
	  }
	
	  // update target module
	  targetModule.update(newModule);
	
	  // update nested modules
	  if (newModule.modules) {
	    for (var key in newModule.modules) {
	      if (!targetModule.getChild(key)) {
	        if (false) {
	          console.warn(
	            "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
	            'manual reload is needed'
	          );
	        }
	        return
	      }
	      update(
	        path.concat(key),
	        targetModule.getChild(key),
	        newModule.modules[key]
	      );
	    }
	  }
	}
	
	var functionAssert = {
	  assert: function (value) { return typeof value === 'function'; },
	  expected: 'function'
	};
	
	var objectAssert = {
	  assert: function (value) { return typeof value === 'function' ||
	    (typeof value === 'object' && typeof value.handler === 'function'); },
	  expected: 'function or object with "handler" function'
	};
	
	var assertTypes = {
	  getters: functionAssert,
	  mutations: functionAssert,
	  actions: objectAssert
	};
	
	function assertRawModule (path, rawModule) {
	  Object.keys(assertTypes).forEach(function (key) {
	    if (!rawModule[key]) { return }
	
	    var assertOptions = assertTypes[key];
	
	    forEachValue(rawModule[key], function (value, type) {
	      assert(
	        assertOptions.assert(value),
	        makeAssertionMessage(path, key, type, value, assertOptions.expected)
	      );
	    });
	  });
	}
	
	function makeAssertionMessage (path, key, type, value, expected) {
	  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
	  if (path.length > 0) {
	    buf += " in module \"" + (path.join('.')) + "\"";
	  }
	  buf += " is " + (JSON.stringify(value)) + ".";
	  return buf
	}
	
	var Vue; // bind on install
	
	var Store = function Store (options) {
	  var this$1 = this;
	  if ( options === void 0 ) options = {};
	
	  // Auto install if it is not done yet and `window` has `Vue`.
	  // To allow users to avoid auto-installation in some cases,
	  // this code should be placed here. See #731
	  if (!Vue && typeof window !== 'undefined' && window.Vue) {
	    install(window.Vue);
	  }
	
	  if (false) {
	    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
	    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
	    assert(this instanceof Store, "Store must be called with the new operator.");
	  }
	
	  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
	  var strict = options.strict; if ( strict === void 0 ) strict = false;
	
	  var state = options.state; if ( state === void 0 ) state = {};
	  if (typeof state === 'function') {
	    state = state() || {};
	  }
	
	  // store internal state
	  this._committing = false;
	  this._actions = Object.create(null);
	  this._actionSubscribers = [];
	  this._mutations = Object.create(null);
	  this._wrappedGetters = Object.create(null);
	  this._modules = new ModuleCollection(options);
	  this._modulesNamespaceMap = Object.create(null);
	  this._subscribers = [];
	  this._watcherVM = new Vue();
	
	  // bind commit and dispatch to self
	  var store = this;
	  var ref = this;
	  var dispatch = ref.dispatch;
	  var commit = ref.commit;
	  this.dispatch = function boundDispatch (type, payload) {
	    return dispatch.call(store, type, payload)
	  };
	  this.commit = function boundCommit (type, payload, options) {
	    return commit.call(store, type, payload, options)
	  };
	
	  // strict mode
	  this.strict = strict;
	
	  // init root module.
	  // this also recursively registers all sub-modules
	  // and collects all module getters inside this._wrappedGetters
	  installModule(this, state, [], this._modules.root);
	
	  // initialize the store vm, which is responsible for the reactivity
	  // (also registers _wrappedGetters as computed properties)
	  resetStoreVM(this, state);
	
	  // apply plugins
	  plugins.forEach(function (plugin) { return plugin(this$1); });
	
	  if (Vue.config.devtools) {
	    devtoolPlugin(this);
	  }
	};
	
	var prototypeAccessors = { state: { configurable: true } };
	
	prototypeAccessors.state.get = function () {
	  return this._vm._data.$$state
	};
	
	prototypeAccessors.state.set = function (v) {
	  if (false) {
	    assert(false, "Use store.replaceState() to explicit replace store state.");
	  }
	};
	
	Store.prototype.commit = function commit (_type, _payload, _options) {
	    var this$1 = this;
	
	  // check object-style commit
	  var ref = unifyObjectStyle(_type, _payload, _options);
	    var type = ref.type;
	    var payload = ref.payload;
	    var options = ref.options;
	
	  var mutation = { type: type, payload: payload };
	  var entry = this._mutations[type];
	  if (!entry) {
	    if (false) {
	      console.error(("[vuex] unknown mutation type: " + type));
	    }
	    return
	  }
	  this._withCommit(function () {
	    entry.forEach(function commitIterator (handler) {
	      handler(payload);
	    });
	  });
	  this._subscribers.forEach(function (sub) { return sub(mutation, this$1.state); });
	
	  if (
	    false
	  ) {
	    console.warn(
	      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
	      'Use the filter functionality in the vue-devtools'
	    );
	  }
	};
	
	Store.prototype.dispatch = function dispatch (_type, _payload) {
	    var this$1 = this;
	
	  // check object-style dispatch
	  var ref = unifyObjectStyle(_type, _payload);
	    var type = ref.type;
	    var payload = ref.payload;
	
	  var action = { type: type, payload: payload };
	  var entry = this._actions[type];
	  if (!entry) {
	    if (false) {
	      console.error(("[vuex] unknown action type: " + type));
	    }
	    return
	  }
	
	  this._actionSubscribers.forEach(function (sub) { return sub(action, this$1.state); });
	
	  return entry.length > 1
	    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
	    : entry[0](payload)
	};
	
	Store.prototype.subscribe = function subscribe (fn) {
	  return genericSubscribe(fn, this._subscribers)
	};
	
	Store.prototype.subscribeAction = function subscribeAction (fn) {
	  return genericSubscribe(fn, this._actionSubscribers)
	};
	
	Store.prototype.watch = function watch (getter, cb, options) {
	    var this$1 = this;
	
	  if (false) {
	    assert(typeof getter === 'function', "store.watch only accepts a function.");
	  }
	  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
	};
	
	Store.prototype.replaceState = function replaceState (state) {
	    var this$1 = this;
	
	  this._withCommit(function () {
	    this$1._vm._data.$$state = state;
	  });
	};
	
	Store.prototype.registerModule = function registerModule (path, rawModule, options) {
	    if ( options === void 0 ) options = {};
	
	  if (typeof path === 'string') { path = [path]; }
	
	  if (false) {
	    assert(Array.isArray(path), "module path must be a string or an Array.");
	    assert(path.length > 0, 'cannot register the root module by using registerModule.');
	  }
	
	  this._modules.register(path, rawModule);
	  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
	  // reset store to update getters...
	  resetStoreVM(this, this.state);
	};
	
	Store.prototype.unregisterModule = function unregisterModule (path) {
	    var this$1 = this;
	
	  if (typeof path === 'string') { path = [path]; }
	
	  if (false) {
	    assert(Array.isArray(path), "module path must be a string or an Array.");
	  }
	
	  this._modules.unregister(path);
	  this._withCommit(function () {
	    var parentState = getNestedState(this$1.state, path.slice(0, -1));
	    Vue.delete(parentState, path[path.length - 1]);
	  });
	  resetStore(this);
	};
	
	Store.prototype.hotUpdate = function hotUpdate (newOptions) {
	  this._modules.update(newOptions);
	  resetStore(this, true);
	};
	
	Store.prototype._withCommit = function _withCommit (fn) {
	  var committing = this._committing;
	  this._committing = true;
	  fn();
	  this._committing = committing;
	};
	
	Object.defineProperties( Store.prototype, prototypeAccessors );
	
	function genericSubscribe (fn, subs) {
	  if (subs.indexOf(fn) < 0) {
	    subs.push(fn);
	  }
	  return function () {
	    var i = subs.indexOf(fn);
	    if (i > -1) {
	      subs.splice(i, 1);
	    }
	  }
	}
	
	function resetStore (store, hot) {
	  store._actions = Object.create(null);
	  store._mutations = Object.create(null);
	  store._wrappedGetters = Object.create(null);
	  store._modulesNamespaceMap = Object.create(null);
	  var state = store.state;
	  // init all modules
	  installModule(store, state, [], store._modules.root, true);
	  // reset vm
	  resetStoreVM(store, state, hot);
	}
	
	function resetStoreVM (store, state, hot) {
	  var oldVm = store._vm;
	
	  // bind store public getters
	  store.getters = {};
	  var wrappedGetters = store._wrappedGetters;
	  var computed = {};
	  forEachValue(wrappedGetters, function (fn, key) {
	    // use computed to leverage its lazy-caching mechanism
	    computed[key] = function () { return fn(store); };
	    Object.defineProperty(store.getters, key, {
	      get: function () { return store._vm[key]; },
	      enumerable: true // for local getters
	    });
	  });
	
	  // use a Vue instance to store the state tree
	  // suppress warnings just in case the user has added
	  // some funky global mixins
	  var silent = Vue.config.silent;
	  Vue.config.silent = true;
	  store._vm = new Vue({
	    data: {
	      $$state: state
	    },
	    computed: computed
	  });
	  Vue.config.silent = silent;
	
	  // enable strict mode for new vm
	  if (store.strict) {
	    enableStrictMode(store);
	  }
	
	  if (oldVm) {
	    if (hot) {
	      // dispatch changes in all subscribed watchers
	      // to force getter re-evaluation for hot reloading.
	      store._withCommit(function () {
	        oldVm._data.$$state = null;
	      });
	    }
	    Vue.nextTick(function () { return oldVm.$destroy(); });
	  }
	}
	
	function installModule (store, rootState, path, module, hot) {
	  var isRoot = !path.length;
	  var namespace = store._modules.getNamespace(path);
	
	  // register in namespace map
	  if (module.namespaced) {
	    store._modulesNamespaceMap[namespace] = module;
	  }
	
	  // set state
	  if (!isRoot && !hot) {
	    var parentState = getNestedState(rootState, path.slice(0, -1));
	    var moduleName = path[path.length - 1];
	    store._withCommit(function () {
	      Vue.set(parentState, moduleName, module.state);
	    });
	  }
	
	  var local = module.context = makeLocalContext(store, namespace, path);
	
	  module.forEachMutation(function (mutation, key) {
	    var namespacedType = namespace + key;
	    registerMutation(store, namespacedType, mutation, local);
	  });
	
	  module.forEachAction(function (action, key) {
	    var type = action.root ? key : namespace + key;
	    var handler = action.handler || action;
	    registerAction(store, type, handler, local);
	  });
	
	  module.forEachGetter(function (getter, key) {
	    var namespacedType = namespace + key;
	    registerGetter(store, namespacedType, getter, local);
	  });
	
	  module.forEachChild(function (child, key) {
	    installModule(store, rootState, path.concat(key), child, hot);
	  });
	}
	
	/**
	 * make localized dispatch, commit, getters and state
	 * if there is no namespace, just use root ones
	 */
	function makeLocalContext (store, namespace, path) {
	  var noNamespace = namespace === '';
	
	  var local = {
	    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
	      var args = unifyObjectStyle(_type, _payload, _options);
	      var payload = args.payload;
	      var options = args.options;
	      var type = args.type;
	
	      if (!options || !options.root) {
	        type = namespace + type;
	        if (false) {
	          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
	          return
	        }
	      }
	
	      return store.dispatch(type, payload)
	    },
	
	    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
	      var args = unifyObjectStyle(_type, _payload, _options);
	      var payload = args.payload;
	      var options = args.options;
	      var type = args.type;
	
	      if (!options || !options.root) {
	        type = namespace + type;
	        if (false) {
	          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
	          return
	        }
	      }
	
	      store.commit(type, payload, options);
	    }
	  };
	
	  // getters and state object must be gotten lazily
	  // because they will be changed by vm update
	  Object.defineProperties(local, {
	    getters: {
	      get: noNamespace
	        ? function () { return store.getters; }
	        : function () { return makeLocalGetters(store, namespace); }
	    },
	    state: {
	      get: function () { return getNestedState(store.state, path); }
	    }
	  });
	
	  return local
	}
	
	function makeLocalGetters (store, namespace) {
	  var gettersProxy = {};
	
	  var splitPos = namespace.length;
	  Object.keys(store.getters).forEach(function (type) {
	    // skip if the target getter is not match this namespace
	    if (type.slice(0, splitPos) !== namespace) { return }
	
	    // extract local getter type
	    var localType = type.slice(splitPos);
	
	    // Add a port to the getters proxy.
	    // Define as getter property because
	    // we do not want to evaluate the getters in this time.
	    Object.defineProperty(gettersProxy, localType, {
	      get: function () { return store.getters[type]; },
	      enumerable: true
	    });
	  });
	
	  return gettersProxy
	}
	
	function registerMutation (store, type, handler, local) {
	  var entry = store._mutations[type] || (store._mutations[type] = []);
	  entry.push(function wrappedMutationHandler (payload) {
	    handler.call(store, local.state, payload);
	  });
	}
	
	function registerAction (store, type, handler, local) {
	  var entry = store._actions[type] || (store._actions[type] = []);
	  entry.push(function wrappedActionHandler (payload, cb) {
	    var res = handler.call(store, {
	      dispatch: local.dispatch,
	      commit: local.commit,
	      getters: local.getters,
	      state: local.state,
	      rootGetters: store.getters,
	      rootState: store.state
	    }, payload, cb);
	    if (!isPromise(res)) {
	      res = Promise.resolve(res);
	    }
	    if (store._devtoolHook) {
	      return res.catch(function (err) {
	        store._devtoolHook.emit('vuex:error', err);
	        throw err
	      })
	    } else {
	      return res
	    }
	  });
	}
	
	function registerGetter (store, type, rawGetter, local) {
	  if (store._wrappedGetters[type]) {
	    if (false) {
	      console.error(("[vuex] duplicate getter key: " + type));
	    }
	    return
	  }
	  store._wrappedGetters[type] = function wrappedGetter (store) {
	    return rawGetter(
	      local.state, // local state
	      local.getters, // local getters
	      store.state, // root state
	      store.getters // root getters
	    )
	  };
	}
	
	function enableStrictMode (store) {
	  store._vm.$watch(function () { return this._data.$$state }, function () {
	    if (false) {
	      assert(store._committing, "Do not mutate vuex store state outside mutation handlers.");
	    }
	  }, { deep: true, sync: true });
	}
	
	function getNestedState (state, path) {
	  return path.length
	    ? path.reduce(function (state, key) { return state[key]; }, state)
	    : state
	}
	
	function unifyObjectStyle (type, payload, options) {
	  if (isObject(type) && type.type) {
	    options = payload;
	    payload = type;
	    type = type.type;
	  }
	
	  if (false) {
	    assert(typeof type === 'string', ("Expects string as the type, but found " + (typeof type) + "."));
	  }
	
	  return { type: type, payload: payload, options: options }
	}
	
	function install (_Vue) {
	  if (Vue && _Vue === Vue) {
	    if (false) {
	      console.error(
	        '[vuex] already installed. Vue.use(Vuex) should be called only once.'
	      );
	    }
	    return
	  }
	  Vue = _Vue;
	  applyMixin(Vue);
	}
	
	var mapState = normalizeNamespace(function (namespace, states) {
	  var res = {};
	  normalizeMap(states).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;
	
	    res[key] = function mappedState () {
	      var state = this.$store.state;
	      var getters = this.$store.getters;
	      if (namespace) {
	        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
	        if (!module) {
	          return
	        }
	        state = module.context.state;
	        getters = module.context.getters;
	      }
	      return typeof val === 'function'
	        ? val.call(this, state, getters)
	        : state[val]
	    };
	    // mark vuex getter for devtools
	    res[key].vuex = true;
	  });
	  return res
	});
	
	var mapMutations = normalizeNamespace(function (namespace, mutations) {
	  var res = {};
	  normalizeMap(mutations).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;
	
	    res[key] = function mappedMutation () {
	      var args = [], len = arguments.length;
	      while ( len-- ) args[ len ] = arguments[ len ];
	
	      var commit = this.$store.commit;
	      if (namespace) {
	        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
	        if (!module) {
	          return
	        }
	        commit = module.context.commit;
	      }
	      return typeof val === 'function'
	        ? val.apply(this, [commit].concat(args))
	        : commit.apply(this.$store, [val].concat(args))
	    };
	  });
	  return res
	});
	
	var mapGetters = normalizeNamespace(function (namespace, getters) {
	  var res = {};
	  normalizeMap(getters).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;
	
	    val = namespace + val;
	    res[key] = function mappedGetter () {
	      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
	        return
	      }
	      if (false) {
	        console.error(("[vuex] unknown getter: " + val));
	        return
	      }
	      return this.$store.getters[val]
	    };
	    // mark vuex getter for devtools
	    res[key].vuex = true;
	  });
	  return res
	});
	
	var mapActions = normalizeNamespace(function (namespace, actions) {
	  var res = {};
	  normalizeMap(actions).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;
	
	    res[key] = function mappedAction () {
	      var args = [], len = arguments.length;
	      while ( len-- ) args[ len ] = arguments[ len ];
	
	      var dispatch = this.$store.dispatch;
	      if (namespace) {
	        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
	        if (!module) {
	          return
	        }
	        dispatch = module.context.dispatch;
	      }
	      return typeof val === 'function'
	        ? val.apply(this, [dispatch].concat(args))
	        : dispatch.apply(this.$store, [val].concat(args))
	    };
	  });
	  return res
	});
	
	var createNamespacedHelpers = function (namespace) { return ({
	  mapState: mapState.bind(null, namespace),
	  mapGetters: mapGetters.bind(null, namespace),
	  mapMutations: mapMutations.bind(null, namespace),
	  mapActions: mapActions.bind(null, namespace)
	}); };
	
	function normalizeMap (map) {
	  return Array.isArray(map)
	    ? map.map(function (key) { return ({ key: key, val: key }); })
	    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
	}
	
	function normalizeNamespace (fn) {
	  return function (namespace, map) {
	    if (typeof namespace !== 'string') {
	      map = namespace;
	      namespace = '';
	    } else if (namespace.charAt(namespace.length - 1) !== '/') {
	      namespace += '/';
	    }
	    return fn(namespace, map)
	  }
	}
	
	function getModuleByNamespace (store, helper, namespace) {
	  var module = store._modulesNamespaceMap[namespace];
	  if (false) {
	    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
	  }
	  return module
	}
	
	var index = {
	  Store: Store,
	  install: install,
	  version: '2.5.0',
	  mapState: mapState,
	  mapMutations: mapMutations,
	  mapGetters: mapGetters,
	  mapActions: mapActions,
	  createNamespacedHelpers: createNamespacedHelpers
	};
	
	module.exports = index;


/***/ }),
/* 34 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(44);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 36 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 37 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 38 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(80);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),
/* 40 */,
/* 41 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 42 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 43 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 44 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 45 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(117);
	var enumBugKeys = __webpack_require__(65);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 47 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(18).f;
	var has = __webpack_require__(22);
	var TAG = __webpack_require__(9)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 49 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(227)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(113)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 51 */,
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(428);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(427);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(43);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 54 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(139);
	var enumBugKeys = __webpack_require__(83);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 56 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 57 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 58 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 59 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (target) {
	  for (var i = 1, j = arguments.length; i < j; i++) {
	    var source = arguments[i] || {};
	    for (var prop in source) {
	      if (source.hasOwnProperty(prop)) {
	        var value = source[prop];
	        if (value !== undefined) {
	          target[prop] = value;
	        }
	      }
	    }
	  }
	
	  return target;
	};
	
	;

/***/ }),
/* 60 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.isDef = isDef;
	exports.isKorean = isKorean;
	function isDef(val) {
	  return val !== undefined && val !== null;
	}
	function isKorean(text) {
	  var reg = /([(\uAC00-\uD7AF)|(\u3130-\u318F)])+/gi;
	  return reg.test(text);
	}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _vue = __webpack_require__(3);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _popup = __webpack_require__(147);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PopperJS = _vue2.default.prototype.$isServer ? function () {} : __webpack_require__(476);
	var stop = function stop(e) {
	  return e.stopPropagation();
	};
	
	/**
	 * @param {HTMLElement} [reference=$refs.reference] - The reference element used to position the popper.
	 * @param {HTMLElement} [popper=$refs.popper] - The HTML element used as popper, or a configuration used to generate the popper.
	 * @param {String} [placement=button] - Placement of the popper accepted values: top(-start, -end), right(-start, -end), bottom(-start, -end), left(-start, -end)
	 * @param {Number} [offset=0] - Amount of pixels the popper will be shifted (can be negative).
	 * @param {Boolean} [visible=false] Visibility of the popup element.
	 * @param {Boolean} [visible-arrow=false] Visibility of the arrow, no style.
	 */
	exports.default = {
	  props: {
	    transformOrigin: {
	      type: [Boolean, String],
	      default: true
	    },
	    placement: {
	      type: String,
	      default: 'bottom'
	    },
	    boundariesPadding: {
	      type: Number,
	      default: 5
	    },
	    reference: {},
	    popper: {},
	    offset: {
	      default: 0
	    },
	    value: Boolean,
	    visibleArrow: Boolean,
	    arrowOffset: {
	      type: Number,
	      default: 35
	    },
	    appendToBody: {
	      type: Boolean,
	      default: true
	    },
	    popperOptions: {
	      type: Object,
	      default: function _default() {
	        return {
	          gpuAcceleration: false
	        };
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      showPopper: false,
	      currentPlacement: ''
	    };
	  },
	
	
	  watch: {
	    value: {
	      immediate: true,
	      handler: function handler(val) {
	        this.showPopper = val;
	        this.$emit('input', val);
	      }
	    },
	
	    showPopper: function showPopper(val) {
	      if (this.disabled) return;
	      val ? this.updatePopper() : this.destroyPopper();
	      this.$emit('input', val);
	    }
	  },
	
	  methods: {
	    createPopper: function createPopper() {
	      var _this = this;
	
	      if (this.$isServer) return;
	      this.currentPlacement = this.currentPlacement || this.placement;
	      if (!/^(top|bottom|left|right)(-start|-end)?$/g.test(this.currentPlacement)) {
	        return;
	      }
	
	      var options = this.popperOptions;
	      var popper = this.popperElm = this.popperElm || this.popper || this.$refs.popper;
	      var reference = this.referenceElm = this.referenceElm || this.reference || this.$refs.reference;
	
	      if (!reference && this.$slots.reference && this.$slots.reference[0]) {
	        reference = this.referenceElm = this.$slots.reference[0].elm;
	      }
	
	      if (!popper || !reference) return;
	      if (this.visibleArrow) this.appendArrow(popper);
	      if (this.appendToBody) document.body.appendChild(this.popperElm);
	      if (this.popperJS && this.popperJS.destroy) {
	        this.popperJS.destroy();
	      }
	
	      options.placement = this.currentPlacement;
	      options.offset = this.offset;
	      options.arrowOffset = this.arrowOffset;
	      this.popperJS = new PopperJS(reference, popper, options);
	      this.popperJS.onCreate(function (_) {
	        _this.$emit('created', _this);
	        _this.resetTransformOrigin();
	        _this.$nextTick(_this.updatePopper);
	      });
	      if (typeof options.onUpdate === 'function') {
	        this.popperJS.onUpdate(options.onUpdate);
	      }
	      this.popperJS._popper.style.zIndex = _popup.PopupManager.nextZIndex();
	      this.popperElm.addEventListener('click', stop);
	    },
	    updatePopper: function updatePopper() {
	      var popperJS = this.popperJS;
	      if (popperJS) {
	        popperJS.update();
	        if (popperJS._popper) {
	          popperJS._popper.style.zIndex = _popup.PopupManager.nextZIndex();
	        }
	      } else {
	        this.createPopper();
	      }
	    },
	    doDestroy: function doDestroy(forceDestroy) {
	      /* istanbul ignore if */
	      if (!this.popperJS || this.showPopper && !forceDestroy) return;
	      this.popperJS.destroy();
	      this.popperJS = null;
	    },
	    destroyPopper: function destroyPopper() {
	      if (this.popperJS) {
	        this.resetTransformOrigin();
	      }
	    },
	    resetTransformOrigin: function resetTransformOrigin() {
	      if (!this.transformOrigin) return;
	      var placementMap = {
	        top: 'bottom',
	        bottom: 'top',
	        left: 'right',
	        right: 'left'
	      };
	      var placement = this.popperJS._popper.getAttribute('x-placement').split('-')[0];
	      var origin = placementMap[placement];
	      this.popperJS._popper.style.transformOrigin = typeof this.transformOrigin === 'string' ? this.transformOrigin : ['top', 'bottom'].indexOf(placement) > -1 ? 'center ' + origin : origin + ' center';
	    },
	    appendArrow: function appendArrow(element) {
	      var hash = void 0;
	      if (this.appended) {
	        return;
	      }
	
	      this.appended = true;
	
	      for (var item in element.attributes) {
	        if (/^_v-/.test(element.attributes[item].name)) {
	          hash = element.attributes[item].name;
	          break;
	        }
	      }
	
	      var arrow = document.createElement('div');
	
	      if (hash) {
	        arrow.setAttribute(hash, '');
	      }
	      arrow.setAttribute('x-arrow', '');
	      arrow.className = 'popper__arrow';
	      element.appendChild(arrow);
	    }
	  },
	
	  beforeDestroy: function beforeDestroy() {
	    this.doDestroy(true);
	    if (this.popperElm && this.popperElm.parentNode === document.body) {
	      this.popperElm.removeEventListener('click', stop);
	      document.body.removeChild(this.popperElm);
	    }
	  },
	
	
	  // call destroy in keep-alive mode
	  deactivated: function deactivated() {
	    this.$options.beforeDestroy[0].call(this);
	  }
	};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable no-undefined */
	
	var throttle = __webpack_require__(104);
	
	/**
	 * Debounce execution of a function. Debouncing, unlike throttling,
	 * guarantees that a function is only executed a single time, either at the
	 * very beginning of a series of calls, or at the very end.
	 *
	 * @param  {Number}   delay         A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
	 * @param  {Boolean}  [atBegin]     Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
	 *                                  after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
	 *                                  (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
	 * @param  {Function} callback      A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
	 *                                  to `callback` when the debounced-function is executed.
	 *
	 * @return {Function} A new, debounced function.
	 */
	module.exports = function ( delay, atBegin, callback ) {
		return callback === undefined ? throttle(delay, atBegin, false) : throttle(delay, callback, atBegin !== false);
	};


/***/ }),
/* 63 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(24);
	var document = __webpack_require__(8).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 65 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(44);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 67 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(69)('keys');
	var uid = __webpack_require__(49);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(8);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};


/***/ }),
/* 70 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(70);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(63);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(24);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(8);
	var core = __webpack_require__(10);
	var LIBRARY = __webpack_require__(45);
	var wksExt = __webpack_require__(75);
	var defineProperty = __webpack_require__(18).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(9);


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(107);
	var ITERATOR = __webpack_require__(9)('iterator');
	var Iterators = __webpack_require__(37);
	module.exports = __webpack_require__(10).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(231);
	var global = __webpack_require__(8);
	var hide = __webpack_require__(23);
	var Iterators = __webpack_require__(37);
	var TO_STRING_TAG = __webpack_require__(9)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.4';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      reLeadingDot = /^\./,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)',
	      rsOrdUpper = '\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Adds the key-value `pair` to `map`.
	   *
	   * @private
	   * @param {Object} map The map to modify.
	   * @param {Array} pair The key-value pair to add.
	   * @returns {Object} Returns `map`.
	   */
	  function addMapEntry(map, pair) {
	    // Don't return `map.set` because it's not chainable in IE 11.
	    map.set(pair[0], pair[1]);
	    return map;
	  }
	
	  /**
	   * Adds `value` to `set`.
	   *
	   * @private
	   * @param {Object} set The set to modify.
	   * @param {*} value The value to add.
	   * @returns {Object} Returns `set`.
	   */
	  function addSetEntry(set, value) {
	    // Don't return `set.add` because it's not chainable in IE 11.
	    set.add(value);
	    return set;
	  }
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, baseClone, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = object[key],
	          srcValue = source[key],
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `map`.
	     *
	     * @private
	     * @param {Object} map The map to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned map.
	     */
	    function cloneMap(map, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
	      return arrayReduce(array, addMapEntry, new map.constructor);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of `set`.
	     *
	     * @private
	     * @param {Object} set The set to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned set.
	     */
	    function cloneSet(set, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
	      return arrayReduce(array, addSetEntry, new set.constructor);
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, cloneFunc, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return cloneMap(object, isDeep, cloneFunc);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return cloneSet(object, isDeep, cloneFunc);
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return !!length &&
	        (typeof value == 'number' || reIsUint.test(value)) &&
	        (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (reLeadingDot.test(string)) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            result = wait - timeSinceLastCall;
	
	        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(args) {
	      args.push(undefined, customDefaultsAssignIn);
	      return apply(assignInWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(199)(module)))

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(202), __esModule: true };

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(204), __esModule: true };

/***/ }),
/* 81 */,
/* 82 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 83 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(19);
	var core = __webpack_require__(41);
	var ctx = __webpack_require__(435);
	var hide = __webpack_require__(29);
	var has = __webpack_require__(26);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 85 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 86 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(30).f;
	var has = __webpack_require__(26);
	var TAG = __webpack_require__(32)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(89)('keys');
	var uid = __webpack_require__(58);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(41);
	var global = __webpack_require__(19);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(54) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 90 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(82);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(43);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(19);
	var core = __webpack_require__(41);
	var LIBRARY = __webpack_require__(54);
	var wksExt = __webpack_require__(94);
	var defineProperty = __webpack_require__(30).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(32);


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 76);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 11:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(142);
	
	/***/ }),
	
	/***/ 21:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(60);
	
	/***/ }),
	
	/***/ 4:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(27);
	
	/***/ }),
	
	/***/ 76:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/input/src/input.vue?vue&type=template&id=343dd774&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      class: [
	        _vm.type === "textarea" ? "el-textarea" : "el-input",
	        _vm.inputSize ? "el-input--" + _vm.inputSize : "",
	        {
	          "is-disabled": _vm.inputDisabled,
	          "is-exceed": _vm.inputExceed,
	          "el-input-group": _vm.$slots.prepend || _vm.$slots.append,
	          "el-input-group--append": _vm.$slots.append,
	          "el-input-group--prepend": _vm.$slots.prepend,
	          "el-input--prefix": _vm.$slots.prefix || _vm.prefixIcon,
	          "el-input--suffix":
	            _vm.$slots.suffix ||
	            _vm.suffixIcon ||
	            _vm.clearable ||
	            _vm.showPassword
	        }
	      ],
	      on: {
	        mouseenter: function($event) {
	          _vm.hovering = true
	        },
	        mouseleave: function($event) {
	          _vm.hovering = false
	        }
	      }
	    },
	    [
	      _vm.type !== "textarea"
	        ? [
	            _vm.$slots.prepend
	              ? _c(
	                  "div",
	                  { staticClass: "el-input-group__prepend" },
	                  [_vm._t("prepend")],
	                  2
	                )
	              : _vm._e(),
	            _vm.type !== "textarea"
	              ? _c(
	                  "input",
	                  _vm._b(
	                    {
	                      ref: "input",
	                      staticClass: "el-input__inner",
	                      attrs: {
	                        tabindex: _vm.tabindex,
	                        type: _vm.showPassword
	                          ? _vm.passwordVisible
	                            ? "text"
	                            : "password"
	                          : _vm.type,
	                        disabled: _vm.inputDisabled,
	                        readonly: _vm.readonly,
	                        autocomplete: _vm.autoComplete || _vm.autocomplete,
	                        "aria-label": _vm.label
	                      },
	                      on: {
	                        compositionstart: _vm.handleCompositionStart,
	                        compositionupdate: _vm.handleCompositionUpdate,
	                        compositionend: _vm.handleCompositionEnd,
	                        input: _vm.handleInput,
	                        focus: _vm.handleFocus,
	                        blur: _vm.handleBlur,
	                        change: _vm.handleChange
	                      }
	                    },
	                    "input",
	                    _vm.$attrs,
	                    false
	                  )
	                )
	              : _vm._e(),
	            _vm.$slots.prefix || _vm.prefixIcon
	              ? _c(
	                  "span",
	                  { staticClass: "el-input__prefix" },
	                  [
	                    _vm._t("prefix"),
	                    _vm.prefixIcon
	                      ? _c("i", {
	                          staticClass: "el-input__icon",
	                          class: _vm.prefixIcon
	                        })
	                      : _vm._e()
	                  ],
	                  2
	                )
	              : _vm._e(),
	            _vm.getSuffixVisible()
	              ? _c("span", { staticClass: "el-input__suffix" }, [
	                  _c(
	                    "span",
	                    { staticClass: "el-input__suffix-inner" },
	                    [
	                      !_vm.showClear ||
	                      !_vm.showPwdVisible ||
	                      !_vm.isWordLimitVisible
	                        ? [
	                            _vm._t("suffix"),
	                            _vm.suffixIcon
	                              ? _c("i", {
	                                  staticClass: "el-input__icon",
	                                  class: _vm.suffixIcon
	                                })
	                              : _vm._e()
	                          ]
	                        : _vm._e(),
	                      _vm.showClear
	                        ? _c("i", {
	                            staticClass:
	                              "el-input__icon el-icon-circle-close el-input__clear",
	                            on: {
	                              mousedown: function($event) {
	                                $event.preventDefault()
	                              },
	                              click: _vm.clear
	                            }
	                          })
	                        : _vm._e(),
	                      _vm.showPwdVisible
	                        ? _c("i", {
	                            staticClass:
	                              "el-input__icon el-icon-view el-input__clear",
	                            on: { click: _vm.handlePasswordVisible }
	                          })
	                        : _vm._e(),
	                      _vm.isWordLimitVisible
	                        ? _c("span", { staticClass: "el-input__count" }, [
	                            _c(
	                              "span",
	                              { staticClass: "el-input__count-inner" },
	                              [
	                                _vm._v(
	                                  "\n            " +
	                                    _vm._s(_vm.textLength) +
	                                    "/" +
	                                    _vm._s(_vm.upperLimit) +
	                                    "\n          "
	                                )
	                              ]
	                            )
	                          ])
	                        : _vm._e()
	                    ],
	                    2
	                  ),
	                  _vm.validateState
	                    ? _c("i", {
	                        staticClass: "el-input__icon",
	                        class: ["el-input__validateIcon", _vm.validateIcon]
	                      })
	                    : _vm._e()
	                ])
	              : _vm._e(),
	            _vm.$slots.append
	              ? _c(
	                  "div",
	                  { staticClass: "el-input-group__append" },
	                  [_vm._t("append")],
	                  2
	                )
	              : _vm._e()
	          ]
	        : _c(
	            "textarea",
	            _vm._b(
	              {
	                ref: "textarea",
	                staticClass: "el-textarea__inner",
	                style: _vm.textareaStyle,
	                attrs: {
	                  tabindex: _vm.tabindex,
	                  disabled: _vm.inputDisabled,
	                  readonly: _vm.readonly,
	                  autocomplete: _vm.autoComplete || _vm.autocomplete,
	                  "aria-label": _vm.label
	                },
	                on: {
	                  compositionstart: _vm.handleCompositionStart,
	                  compositionupdate: _vm.handleCompositionUpdate,
	                  compositionend: _vm.handleCompositionEnd,
	                  input: _vm.handleInput,
	                  focus: _vm.handleFocus,
	                  blur: _vm.handleBlur,
	                  change: _vm.handleChange
	                }
	              },
	              "textarea",
	              _vm.$attrs,
	              false
	            )
	          ),
	      _vm.isWordLimitVisible && _vm.type === "textarea"
	        ? _c("span", { staticClass: "el-input__count" }, [
	            _vm._v(_vm._s(_vm.textLength) + "/" + _vm._s(_vm.upperLimit))
	          ])
	        : _vm._e()
	    ],
	    2
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/input/src/input.vue?vue&type=template&id=343dd774&
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
	var emitter_ = __webpack_require__(4);
	var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/migrating"
	var migrating_ = __webpack_require__(11);
	var migrating_default = /*#__PURE__*/__webpack_require__.n(migrating_);
	
	// CONCATENATED MODULE: ./packages/input/src/calcTextareaHeight.js
	var hiddenTextarea = void 0;
	
	var HIDDEN_STYLE = '\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n';
	
	var CONTEXT_STYLE = ['letter-spacing', 'line-height', 'padding-top', 'padding-bottom', 'font-family', 'font-weight', 'font-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-left', 'padding-right', 'border-width', 'box-sizing'];
	
	function calculateNodeStyling(targetElement) {
	  var style = window.getComputedStyle(targetElement);
	
	  var boxSizing = style.getPropertyValue('box-sizing');
	
	  var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));
	
	  var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));
	
	  var contextStyle = CONTEXT_STYLE.map(function (name) {
	    return name + ':' + style.getPropertyValue(name);
	  }).join(';');
	
	  return { contextStyle: contextStyle, paddingSize: paddingSize, borderSize: borderSize, boxSizing: boxSizing };
	}
	
	function calcTextareaHeight(targetElement) {
	  var minRows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  var maxRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  if (!hiddenTextarea) {
	    hiddenTextarea = document.createElement('textarea');
	    document.body.appendChild(hiddenTextarea);
	  }
	
	  var _calculateNodeStyling = calculateNodeStyling(targetElement),
	      paddingSize = _calculateNodeStyling.paddingSize,
	      borderSize = _calculateNodeStyling.borderSize,
	      boxSizing = _calculateNodeStyling.boxSizing,
	      contextStyle = _calculateNodeStyling.contextStyle;
	
	  hiddenTextarea.setAttribute('style', contextStyle + ';' + HIDDEN_STYLE);
	  hiddenTextarea.value = targetElement.value || targetElement.placeholder || '';
	
	  var height = hiddenTextarea.scrollHeight;
	  var result = {};
	
	  if (boxSizing === 'border-box') {
	    height = height + borderSize;
	  } else if (boxSizing === 'content-box') {
	    height = height - paddingSize;
	  }
	
	  hiddenTextarea.value = '';
	  var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;
	
	  if (minRows !== null) {
	    var minHeight = singleRowHeight * minRows;
	    if (boxSizing === 'border-box') {
	      minHeight = minHeight + paddingSize + borderSize;
	    }
	    height = Math.max(minHeight, height);
	    result.minHeight = minHeight + 'px';
	  }
	  if (maxRows !== null) {
	    var maxHeight = singleRowHeight * maxRows;
	    if (boxSizing === 'border-box') {
	      maxHeight = maxHeight + paddingSize + borderSize;
	    }
	    height = Math.min(maxHeight, height);
	  }
	  result.height = height + 'px';
	  hiddenTextarea.parentNode && hiddenTextarea.parentNode.removeChild(hiddenTextarea);
	  hiddenTextarea = null;
	  return result;
	};
	// EXTERNAL MODULE: external "element-ui/lib/utils/merge"
	var merge_ = __webpack_require__(9);
	var merge_default = /*#__PURE__*/__webpack_require__.n(merge_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/shared"
	var shared_ = __webpack_require__(21);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/input/src/input.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	/* harmony default export */ var inputvue_type_script_lang_js_ = ({
	  name: 'ElInput',
	
	  componentName: 'ElInput',
	
	  mixins: [emitter_default.a, migrating_default.a],
	
	  inheritAttrs: false,
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  data: function data() {
	    return {
	      textareaCalcStyle: {},
	      hovering: false,
	      focused: false,
	      isComposing: false,
	      passwordVisible: false
	    };
	  },
	
	
	  props: {
	    value: [String, Number],
	    size: String,
	    resize: String,
	    form: String,
	    disabled: Boolean,
	    readonly: Boolean,
	    type: {
	      type: String,
	      default: 'text'
	    },
	    autosize: {
	      type: [Boolean, Object],
	      default: false
	    },
	    autocomplete: {
	      type: String,
	      default: 'off'
	    },
	    /** @Deprecated in next major version */
	    autoComplete: {
	      type: String,
	      validator: function validator(val) {
	         false && false;
	        return true;
	      }
	    },
	    validateEvent: {
	      type: Boolean,
	      default: true
	    },
	    suffixIcon: String,
	    prefixIcon: String,
	    label: String,
	    clearable: {
	      type: Boolean,
	      default: false
	    },
	    showPassword: {
	      type: Boolean,
	      default: false
	    },
	    showWordLimit: {
	      type: Boolean,
	      default: false
	    },
	    tabindex: String
	  },
	
	  computed: {
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    validateState: function validateState() {
	      return this.elFormItem ? this.elFormItem.validateState : '';
	    },
	    needStatusIcon: function needStatusIcon() {
	      return this.elForm ? this.elForm.statusIcon : false;
	    },
	    validateIcon: function validateIcon() {
	      return {
	        validating: 'el-icon-loading',
	        success: 'el-icon-circle-check',
	        error: 'el-icon-circle-close'
	      }[this.validateState];
	    },
	    textareaStyle: function textareaStyle() {
	      return merge_default()({}, this.textareaCalcStyle, { resize: this.resize });
	    },
	    inputSize: function inputSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    inputDisabled: function inputDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    },
	    nativeInputValue: function nativeInputValue() {
	      return this.value === null || this.value === undefined ? '' : String(this.value);
	    },
	    showClear: function showClear() {
	      return this.clearable && !this.inputDisabled && !this.readonly && this.nativeInputValue && (this.focused || this.hovering);
	    },
	    showPwdVisible: function showPwdVisible() {
	      return this.showPassword && !this.inputDisabled && !this.readonly && (!!this.nativeInputValue || this.focused);
	    },
	    isWordLimitVisible: function isWordLimitVisible() {
	      return this.showWordLimit && this.$attrs.maxlength && (this.type === 'text' || this.type === 'textarea') && !this.inputDisabled && !this.readonly && !this.showPassword;
	    },
	    upperLimit: function upperLimit() {
	      return this.$attrs.maxlength;
	    },
	    textLength: function textLength() {
	      if (typeof this.value === 'number') {
	        return String(this.value).length;
	      }
	
	      return (this.value || '').length;
	    },
	    inputExceed: function inputExceed() {
	      // show exceed style if length of initial value greater then maxlength
	      return this.isWordLimitVisible && this.textLength > this.upperLimit;
	    }
	  },
	
	  watch: {
	    value: function value(val) {
	      this.$nextTick(this.resizeTextarea);
	      if (this.validateEvent) {
	        this.dispatch('ElFormItem', 'el.form.change', [val]);
	      }
	    },
	
	    // native input value is set explicitly
	    // do not use v-model / :value in template
	    // see: https://github.com/ElemeFE/element/issues/14521
	    nativeInputValue: function nativeInputValue() {
	      this.setNativeInputValue();
	    },
	
	    // when change between <input> and <textarea>,
	    // update DOM dependent value and styles
	    // https://github.com/ElemeFE/element/issues/14857
	    type: function type() {
	      var _this = this;
	
	      this.$nextTick(function () {
	        _this.setNativeInputValue();
	        _this.resizeTextarea();
	        _this.updateIconOffset();
	      });
	    }
	  },
	
	  methods: {
	    focus: function focus() {
	      this.getInput().focus();
	    },
	    blur: function blur() {
	      this.getInput().blur();
	    },
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'icon': 'icon is removed, use suffix-icon / prefix-icon instead.',
	          'on-icon-click': 'on-icon-click is removed.'
	        },
	        events: {
	          'click': 'click is removed.'
	        }
	      };
	    },
	    handleBlur: function handleBlur(event) {
	      this.focused = false;
	      this.$emit('blur', event);
	      if (this.validateEvent) {
	        this.dispatch('ElFormItem', 'el.form.blur', [this.value]);
	      }
	    },
	    select: function select() {
	      this.getInput().select();
	    },
	    resizeTextarea: function resizeTextarea() {
	      if (this.$isServer) return;
	      var autosize = this.autosize,
	          type = this.type;
	
	      if (type !== 'textarea') return;
	      if (!autosize) {
	        this.textareaCalcStyle = {
	          minHeight: calcTextareaHeight(this.$refs.textarea).minHeight
	        };
	        return;
	      }
	      var minRows = autosize.minRows;
	      var maxRows = autosize.maxRows;
	
	      this.textareaCalcStyle = calcTextareaHeight(this.$refs.textarea, minRows, maxRows);
	    },
	    setNativeInputValue: function setNativeInputValue() {
	      var input = this.getInput();
	      if (!input) return;
	      if (input.value === this.nativeInputValue) return;
	      input.value = this.nativeInputValue;
	    },
	    handleFocus: function handleFocus(event) {
	      this.focused = true;
	      this.$emit('focus', event);
	    },
	    handleCompositionStart: function handleCompositionStart() {
	      this.isComposing = true;
	    },
	    handleCompositionUpdate: function handleCompositionUpdate(event) {
	      var text = event.target.value;
	      var lastCharacter = text[text.length - 1] || '';
	      this.isComposing = !Object(shared_["isKorean"])(lastCharacter);
	    },
	    handleCompositionEnd: function handleCompositionEnd(event) {
	      if (this.isComposing) {
	        this.isComposing = false;
	        this.handleInput(event);
	      }
	    },
	    handleInput: function handleInput(event) {
	      // should not emit input during composition
	      // see: https://github.com/ElemeFE/element/issues/10516
	      if (this.isComposing) return;
	
	      // hack for https://github.com/ElemeFE/element/issues/8548
	      // should remove the following line when we don't support IE
	      if (event.target.value === this.nativeInputValue) return;
	
	      this.$emit('input', event.target.value);
	
	      // ensure native input value is controlled
	      // see: https://github.com/ElemeFE/element/issues/12850
	      this.$nextTick(this.setNativeInputValue);
	    },
	    handleChange: function handleChange(event) {
	      this.$emit('change', event.target.value);
	    },
	    calcIconOffset: function calcIconOffset(place) {
	      var elList = [].slice.call(this.$el.querySelectorAll('.el-input__' + place) || []);
	      if (!elList.length) return;
	      var el = null;
	      for (var i = 0; i < elList.length; i++) {
	        if (elList[i].parentNode === this.$el) {
	          el = elList[i];
	          break;
	        }
	      }
	      if (!el) return;
	      var pendantMap = {
	        suffix: 'append',
	        prefix: 'prepend'
	      };
	
	      var pendant = pendantMap[place];
	      if (this.$slots[pendant]) {
	        el.style.transform = 'translateX(' + (place === 'suffix' ? '-' : '') + this.$el.querySelector('.el-input-group__' + pendant).offsetWidth + 'px)';
	      } else {
	        el.removeAttribute('style');
	      }
	    },
	    updateIconOffset: function updateIconOffset() {
	      this.calcIconOffset('prefix');
	      this.calcIconOffset('suffix');
	    },
	    clear: function clear() {
	      this.$emit('input', '');
	      this.$emit('change', '');
	      this.$emit('clear');
	    },
	    handlePasswordVisible: function handlePasswordVisible() {
	      var _this2 = this;
	
	      this.passwordVisible = !this.passwordVisible;
	      this.$nextTick(function () {
	        _this2.focus();
	      });
	    },
	    getInput: function getInput() {
	      return this.$refs.input || this.$refs.textarea;
	    },
	    getSuffixVisible: function getSuffixVisible() {
	      return this.$slots.suffix || this.suffixIcon || this.showClear || this.showPassword || this.isWordLimitVisible || this.validateState && this.needStatusIcon;
	    }
	  },
	
	  created: function created() {
	    this.$on('inputSelect', this.select);
	  },
	  mounted: function mounted() {
	    this.setNativeInputValue();
	    this.resizeTextarea();
	    this.updateIconOffset();
	  },
	  updated: function updated() {
	    this.$nextTick(this.updateIconOffset);
	  }
	});
	// CONCATENATED MODULE: ./packages/input/src/input.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_inputvue_type_script_lang_js_ = (inputvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/input/src/input.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_inputvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/input/src/input.vue"
	/* harmony default export */ var input = (component.exports);
	// CONCATENATED MODULE: ./packages/input/index.js
	
	
	/* istanbul ignore next */
	input.install = function (Vue) {
	  Vue.component(input.name, input);
	};
	
	/* harmony default export */ var packages_input = __webpack_exports__["default"] = (input);
	
	/***/ }),
	
	/***/ 9:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(59);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.i18n = exports.use = exports.t = undefined;
	
	var _zhCN = __webpack_require__(466);
	
	var _zhCN2 = _interopRequireDefault(_zhCN);
	
	var _vue = __webpack_require__(3);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _deepmerge = __webpack_require__(458);
	
	var _deepmerge2 = _interopRequireDefault(_deepmerge);
	
	var _format = __webpack_require__(465);
	
	var _format2 = _interopRequireDefault(_format);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var format = (0, _format2.default)(_vue2.default);
	var lang = _zhCN2.default;
	var merged = false;
	var i18nHandler = function i18nHandler() {
	  var vuei18n = Object.getPrototypeOf(this || _vue2.default).$t;
	  if (typeof vuei18n === 'function' && !!_vue2.default.locale) {
	    if (!merged) {
	      merged = true;
	      _vue2.default.locale(_vue2.default.config.lang, (0, _deepmerge2.default)(lang, _vue2.default.locale(_vue2.default.config.lang) || {}, { clone: true }));
	    }
	    return vuei18n.apply(this, arguments);
	  }
	};
	
	var t = exports.t = function t(path, options) {
	  var value = i18nHandler.apply(this, arguments);
	  if (value !== null && value !== undefined) return value;
	
	  var array = path.split('.');
	  var current = lang;
	
	  for (var i = 0, j = array.length; i < j; i++) {
	    var property = array[i];
	    value = current[property];
	    if (i === j - 1) return format(value, options);
	    if (!value) return '';
	    current = value;
	  }
	  return '';
	};
	
	var use = exports.use = function use(l) {
	  lang = l || lang;
	};
	
	var i18n = exports.i18n = function i18n(fn) {
	  i18nHandler = fn || i18nHandler;
	};
	
	exports.default = { use: use, t: t, i18n: i18n };

/***/ }),
/* 97 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (ref) {
	  return {
	    methods: {
	      focus: function focus() {
	        this.$refs[ref].focus();
	      }
	    }
	  };
	};
	
	;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _locale = __webpack_require__(96);
	
	exports.default = {
	  methods: {
	    t: function t() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _locale.t.apply(this, args);
	    }
	  }
	};

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 127);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 127:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/resize-event"
	var resize_event_ = __webpack_require__(16);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/scrollbar-width"
	var scrollbar_width_ = __webpack_require__(38);
	var scrollbar_width_default = /*#__PURE__*/__webpack_require__.n(scrollbar_width_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/util"
	var util_ = __webpack_require__(3);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/dom"
	var dom_ = __webpack_require__(2);
	
	// CONCATENATED MODULE: ./packages/scrollbar/src/util.js
	var BAR_MAP = {
	  vertical: {
	    offset: 'offsetHeight',
	    scroll: 'scrollTop',
	    scrollSize: 'scrollHeight',
	    size: 'height',
	    key: 'vertical',
	    axis: 'Y',
	    client: 'clientY',
	    direction: 'top'
	  },
	  horizontal: {
	    offset: 'offsetWidth',
	    scroll: 'scrollLeft',
	    scrollSize: 'scrollWidth',
	    size: 'width',
	    key: 'horizontal',
	    axis: 'X',
	    client: 'clientX',
	    direction: 'left'
	  }
	};
	
	function renderThumbStyle(_ref) {
	  var move = _ref.move,
	      size = _ref.size,
	      bar = _ref.bar;
	
	  var style = {};
	  var translate = 'translate' + bar.axis + '(' + move + '%)';
	
	  style[bar.size] = size;
	  style.transform = translate;
	  style.msTransform = translate;
	  style.webkitTransform = translate;
	
	  return style;
	};
	// CONCATENATED MODULE: ./packages/scrollbar/src/bar.js
	
	
	
	/* istanbul ignore next */
	/* harmony default export */ var src_bar = ({
	  name: 'Bar',
	
	  props: {
	    vertical: Boolean,
	    size: String,
	    move: Number
	  },
	
	  computed: {
	    bar: function bar() {
	      return BAR_MAP[this.vertical ? 'vertical' : 'horizontal'];
	    },
	    wrap: function wrap() {
	      return this.$parent.wrap;
	    }
	  },
	
	  render: function render(h) {
	    var size = this.size,
	        move = this.move,
	        bar = this.bar;
	
	
	    return h(
	      'div',
	      {
	        'class': ['el-scrollbar__bar', 'is-' + bar.key],
	        on: {
	          'mousedown': this.clickTrackHandler
	        }
	      },
	      [h('div', {
	        ref: 'thumb',
	        'class': 'el-scrollbar__thumb',
	        on: {
	          'mousedown': this.clickThumbHandler
	        },
	
	        style: renderThumbStyle({ size: size, move: move, bar: bar }) })]
	    );
	  },
	
	
	  methods: {
	    clickThumbHandler: function clickThumbHandler(e) {
	      // prevent click event of right button
	      if (e.ctrlKey || e.button === 2) {
	        return;
	      }
	      this.startDrag(e);
	      this[this.bar.axis] = e.currentTarget[this.bar.offset] - (e[this.bar.client] - e.currentTarget.getBoundingClientRect()[this.bar.direction]);
	    },
	    clickTrackHandler: function clickTrackHandler(e) {
	      var offset = Math.abs(e.target.getBoundingClientRect()[this.bar.direction] - e[this.bar.client]);
	      var thumbHalf = this.$refs.thumb[this.bar.offset] / 2;
	      var thumbPositionPercentage = (offset - thumbHalf) * 100 / this.$el[this.bar.offset];
	
	      this.wrap[this.bar.scroll] = thumbPositionPercentage * this.wrap[this.bar.scrollSize] / 100;
	    },
	    startDrag: function startDrag(e) {
	      e.stopImmediatePropagation();
	      this.cursorDown = true;
	
	      Object(dom_["on"])(document, 'mousemove', this.mouseMoveDocumentHandler);
	      Object(dom_["on"])(document, 'mouseup', this.mouseUpDocumentHandler);
	      document.onselectstart = function () {
	        return false;
	      };
	    },
	    mouseMoveDocumentHandler: function mouseMoveDocumentHandler(e) {
	      if (this.cursorDown === false) return;
	      var prevPage = this[this.bar.axis];
	
	      if (!prevPage) return;
	
	      var offset = (this.$el.getBoundingClientRect()[this.bar.direction] - e[this.bar.client]) * -1;
	      var thumbClickPosition = this.$refs.thumb[this.bar.offset] - prevPage;
	      var thumbPositionPercentage = (offset - thumbClickPosition) * 100 / this.$el[this.bar.offset];
	
	      this.wrap[this.bar.scroll] = thumbPositionPercentage * this.wrap[this.bar.scrollSize] / 100;
	    },
	    mouseUpDocumentHandler: function mouseUpDocumentHandler(e) {
	      this.cursorDown = false;
	      this[this.bar.axis] = 0;
	      Object(dom_["off"])(document, 'mousemove', this.mouseMoveDocumentHandler);
	      document.onselectstart = null;
	    }
	  },
	
	  destroyed: function destroyed() {
	    Object(dom_["off"])(document, 'mouseup', this.mouseUpDocumentHandler);
	  }
	});
	// CONCATENATED MODULE: ./packages/scrollbar/src/main.js
	// reference https://github.com/noeldelgado/gemini-scrollbar/blob/master/index.js
	
	
	
	
	
	
	/* istanbul ignore next */
	/* harmony default export */ var main = ({
	  name: 'ElScrollbar',
	
	  components: { Bar: src_bar },
	
	  props: {
	    native: Boolean,
	    wrapStyle: {},
	    wrapClass: {},
	    viewClass: {},
	    viewStyle: {},
	    noresize: Boolean, // 如果 container 尺寸不会发生变化，最好设置它可以优化性能
	    tag: {
	      type: String,
	      default: 'div'
	    }
	  },
	
	  data: function data() {
	    return {
	      sizeWidth: '0',
	      sizeHeight: '0',
	      moveX: 0,
	      moveY: 0
	    };
	  },
	
	
	  computed: {
	    wrap: function wrap() {
	      return this.$refs.wrap;
	    }
	  },
	
	  render: function render(h) {
	    var gutter = scrollbar_width_default()();
	    var style = this.wrapStyle;
	
	    if (gutter) {
	      var gutterWith = '-' + gutter + 'px';
	      var gutterStyle = 'margin-bottom: ' + gutterWith + '; margin-right: ' + gutterWith + ';';
	
	      if (Array.isArray(this.wrapStyle)) {
	        style = Object(util_["toObject"])(this.wrapStyle);
	        style.marginRight = style.marginBottom = gutterWith;
	      } else if (typeof this.wrapStyle === 'string') {
	        style += gutterStyle;
	      } else {
	        style = gutterStyle;
	      }
	    }
	    var view = h(this.tag, {
	      class: ['el-scrollbar__view', this.viewClass],
	      style: this.viewStyle,
	      ref: 'resize'
	    }, this.$slots.default);
	    var wrap = h(
	      'div',
	      {
	        ref: 'wrap',
	        style: style,
	        on: {
	          'scroll': this.handleScroll
	        },
	
	        'class': [this.wrapClass, 'el-scrollbar__wrap', gutter ? '' : 'el-scrollbar__wrap--hidden-default'] },
	      [[view]]
	    );
	    var nodes = void 0;
	
	    if (!this.native) {
	      nodes = [wrap, h(src_bar, {
	        attrs: {
	          move: this.moveX,
	          size: this.sizeWidth }
	      }), h(src_bar, {
	        attrs: {
	          vertical: true,
	          move: this.moveY,
	          size: this.sizeHeight }
	      })];
	    } else {
	      nodes = [h(
	        'div',
	        {
	          ref: 'wrap',
	          'class': [this.wrapClass, 'el-scrollbar__wrap'],
	          style: style },
	        [[view]]
	      )];
	    }
	    return h('div', { class: 'el-scrollbar' }, nodes);
	  },
	
	
	  methods: {
	    handleScroll: function handleScroll() {
	      var wrap = this.wrap;
	
	      this.moveY = wrap.scrollTop * 100 / wrap.clientHeight;
	      this.moveX = wrap.scrollLeft * 100 / wrap.clientWidth;
	    },
	    update: function update() {
	      var heightPercentage = void 0,
	          widthPercentage = void 0;
	      var wrap = this.wrap;
	      if (!wrap) return;
	
	      heightPercentage = wrap.clientHeight * 100 / wrap.scrollHeight;
	      widthPercentage = wrap.clientWidth * 100 / wrap.scrollWidth;
	
	      this.sizeHeight = heightPercentage < 100 ? heightPercentage + '%' : '';
	      this.sizeWidth = widthPercentage < 100 ? widthPercentage + '%' : '';
	    }
	  },
	
	  mounted: function mounted() {
	    if (this.native) return;
	    this.$nextTick(this.update);
	    !this.noresize && Object(resize_event_["addResizeListener"])(this.$refs.resize, this.update);
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.native) return;
	    !this.noresize && Object(resize_event_["removeResizeListener"])(this.$refs.resize, this.update);
	  }
	});
	// CONCATENATED MODULE: ./packages/scrollbar/index.js
	
	
	/* istanbul ignore next */
	main.install = function (Vue) {
	  Vue.component(main.name, main);
	};
	
	/* harmony default export */ var scrollbar = __webpack_exports__["default"] = (main);
	
	/***/ }),
	
	/***/ 16:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(101);
	
	/***/ }),
	
	/***/ 2:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(17);
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(15);
	
	/***/ }),
	
	/***/ 38:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(103);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 100 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var aria = aria || {};
	
	aria.Utils = aria.Utils || {};
	
	/**
	 * @desc Set focus on descendant nodes until the first focusable element is
	 *       found.
	 * @param element
	 *          DOM node for which to find the first focusable descendant.
	 * @returns
	 *  true if a focusable element is found and focus is set.
	 */
	aria.Utils.focusFirstDescendant = function (element) {
	  for (var i = 0; i < element.childNodes.length; i++) {
	    var child = element.childNodes[i];
	    if (aria.Utils.attemptFocus(child) || aria.Utils.focusFirstDescendant(child)) {
	      return true;
	    }
	  }
	  return false;
	};
	
	/**
	 * @desc Find the last descendant node that is focusable.
	 * @param element
	 *          DOM node for which to find the last focusable descendant.
	 * @returns
	 *  true if a focusable element is found and focus is set.
	 */
	
	aria.Utils.focusLastDescendant = function (element) {
	  for (var i = element.childNodes.length - 1; i >= 0; i--) {
	    var child = element.childNodes[i];
	    if (aria.Utils.attemptFocus(child) || aria.Utils.focusLastDescendant(child)) {
	      return true;
	    }
	  }
	  return false;
	};
	
	/**
	 * @desc Set Attempt to set focus on the current node.
	 * @param element
	 *          The node to attempt to focus on.
	 * @returns
	 *  true if element is focused.
	 */
	aria.Utils.attemptFocus = function (element) {
	  if (!aria.Utils.isFocusable(element)) {
	    return false;
	  }
	  aria.Utils.IgnoreUtilFocusChanges = true;
	  try {
	    element.focus();
	  } catch (e) {}
	  aria.Utils.IgnoreUtilFocusChanges = false;
	  return document.activeElement === element;
	};
	
	aria.Utils.isFocusable = function (element) {
	  if (element.tabIndex > 0 || element.tabIndex === 0 && element.getAttribute('tabIndex') !== null) {
	    return true;
	  }
	
	  if (element.disabled) {
	    return false;
	  }
	
	  switch (element.nodeName) {
	    case 'A':
	      return !!element.href && element.rel !== 'ignore';
	    case 'INPUT':
	      return element.type !== 'hidden' && element.type !== 'file';
	    case 'BUTTON':
	    case 'SELECT':
	    case 'TEXTAREA':
	      return true;
	    default:
	      return false;
	  }
	};
	
	/**
	 * 触发一个事件
	 * mouseenter, mouseleave, mouseover, keyup, change, click 等
	 * @param  {Element} elm
	 * @param  {String} name
	 * @param  {*} opts
	 */
	aria.Utils.triggerEvent = function (elm, name) {
	  var eventName = void 0;
	
	  if (/^mouse|click/.test(name)) {
	    eventName = 'MouseEvents';
	  } else if (/^key/.test(name)) {
	    eventName = 'KeyboardEvent';
	  } else {
	    eventName = 'HTMLEvents';
	  }
	  var evt = document.createEvent(eventName);
	
	  for (var _len = arguments.length, opts = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    opts[_key - 2] = arguments[_key];
	  }
	
	  evt.initEvent.apply(evt, [name].concat(opts));
	  elm.dispatchEvent ? elm.dispatchEvent(evt) : elm.fireEvent('on' + name, evt);
	
	  return elm;
	};
	
	aria.Utils.keys = {
	  tab: 9,
	  enter: 13,
	  space: 32,
	  left: 37,
	  up: 38,
	  right: 39,
	  down: 40,
	  esc: 27
	};
	
	exports.default = aria.Utils;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.removeResizeListener = exports.addResizeListener = undefined;
	
	var _resizeObserverPolyfill = __webpack_require__(484);
	
	var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isServer = typeof window === 'undefined';
	
	/* istanbul ignore next */
	var resizeHandler = function resizeHandler(entries) {
	  for (var _iterator = entries, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	    var _ref;
	
	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }
	
	    var entry = _ref;
	
	    var listeners = entry.target.__resizeListeners__ || [];
	    if (listeners.length) {
	      listeners.forEach(function (fn) {
	        fn();
	      });
	    }
	  }
	};
	
	/* istanbul ignore next */
	var addResizeListener = exports.addResizeListener = function addResizeListener(element, fn) {
	  if (isServer) return;
	  if (!element.__resizeListeners__) {
	    element.__resizeListeners__ = [];
	    element.__ro__ = new _resizeObserverPolyfill2.default(resizeHandler);
	    element.__ro__.observe(element);
	  }
	  element.__resizeListeners__.push(fn);
	};
	
	/* istanbul ignore next */
	var removeResizeListener = exports.removeResizeListener = function removeResizeListener(element, fn) {
	  if (!element || !element.__resizeListeners__) return;
	  element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
	  if (!element.__resizeListeners__.length) {
	    element.__ro__.disconnect();
	  }
	};

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = scrollIntoView;
	
	var _vue = __webpack_require__(3);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function scrollIntoView(container, selected) {
	  if (_vue2.default.prototype.$isServer) return;
	
	  if (!selected) {
	    container.scrollTop = 0;
	    return;
	  }
	
	  var offsetParents = [];
	  var pointer = selected.offsetParent;
	  while (pointer && container !== pointer && container.contains(pointer)) {
	    offsetParents.push(pointer);
	    pointer = pointer.offsetParent;
	  }
	  var top = selected.offsetTop + offsetParents.reduce(function (prev, curr) {
	    return prev + curr.offsetTop;
	  }, 0);
	  var bottom = top + selected.offsetHeight;
	  var viewRectTop = container.scrollTop;
	  var viewRectBottom = viewRectTop + container.clientHeight;
	
	  if (top < viewRectTop) {
	    container.scrollTop = top;
	  } else if (bottom > viewRectBottom) {
	    container.scrollTop = bottom - container.clientHeight;
	  }
	}

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function () {
	  if (_vue2.default.prototype.$isServer) return 0;
	  if (scrollBarWidth !== undefined) return scrollBarWidth;
	
	  var outer = document.createElement('div');
	  outer.className = 'el-scrollbar__wrap';
	  outer.style.visibility = 'hidden';
	  outer.style.width = '100px';
	  outer.style.position = 'absolute';
	  outer.style.top = '-9999px';
	  document.body.appendChild(outer);
	
	  var widthNoScroll = outer.offsetWidth;
	  outer.style.overflow = 'scroll';
	
	  var inner = document.createElement('div');
	  inner.style.width = '100%';
	  outer.appendChild(inner);
	
	  var widthWithScroll = inner.offsetWidth;
	  outer.parentNode.removeChild(outer);
	  scrollBarWidth = widthNoScroll - widthWithScroll;
	
	  return scrollBarWidth;
	};
	
	var _vue = __webpack_require__(3);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scrollBarWidth = void 0;
	
	;

/***/ }),
/* 104 */
/***/ (function(module, exports) {

	/* eslint-disable no-undefined,no-param-reassign,no-shadow */
	
	/**
	 * Throttle execution of a function. Especially useful for rate limiting
	 * execution of handlers on events like resize and scroll.
	 *
	 * @param  {Number}    delay          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
	 * @param  {Boolean}   [noTrailing]   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
	 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
	 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
	 *                                    the internal counter is reset)
	 * @param  {Function}  callback       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
	 *                                    to `callback` when the throttled-function is executed.
	 * @param  {Boolean}   [debounceMode] If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
	 *                                    schedule `callback` to execute after `delay` ms.
	 *
	 * @return {Function}  A new, throttled, function.
	 */
	module.exports = function ( delay, noTrailing, callback, debounceMode ) {
	
		// After wrapper has stopped being called, this timeout ensures that
		// `callback` is executed at the proper times in `throttle` and `end`
		// debounce modes.
		var timeoutID;
	
		// Keep track of the last time `callback` was executed.
		var lastExec = 0;
	
		// `noTrailing` defaults to falsy.
		if ( typeof noTrailing !== 'boolean' ) {
			debounceMode = callback;
			callback = noTrailing;
			noTrailing = undefined;
		}
	
		// The `wrapper` function encapsulates all of the throttling / debouncing
		// functionality and when executed will limit the rate at which `callback`
		// is executed.
		function wrapper () {
	
			var self = this;
			var elapsed = Number(new Date()) - lastExec;
			var args = arguments;
	
			// Execute `callback` and update the `lastExec` timestamp.
			function exec () {
				lastExec = Number(new Date());
				callback.apply(self, args);
			}
	
			// If `debounceMode` is true (at begin) this is used to clear the flag
			// to allow future `callback` executions.
			function clear () {
				timeoutID = undefined;
			}
	
			if ( debounceMode && !timeoutID ) {
				// Since `wrapper` is being called for the first time and
				// `debounceMode` is true (at begin), execute `callback`.
				exec();
			}
	
			// Clear any existing timeout.
			if ( timeoutID ) {
				clearTimeout(timeoutID);
			}
	
			if ( debounceMode === undefined && elapsed > delay ) {
				// In throttle mode, if `delay` time has been exceeded, execute
				// `callback`.
				exec();
	
			} else if ( noTrailing !== true ) {
				// In trailing throttle mode, since `delay` time has not been
				// exceeded, schedule `callback` to execute `delay` ms after most
				// recent execution.
				//
				// If `debounceMode` is true (at begin), schedule `clear` to execute
				// after `delay` ms.
				//
				// If `debounceMode` is false (at end), schedule `callback` to
				// execute after `delay` ms.
				timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
			}
	
		}
	
		// Return the wrapper function.
		return wrapper;
	
	};


/***/ }),
/* 105 */,
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * vue-resource v1.3.4
	 * https://github.com/pagekit/vue-resource
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	/**
	 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
	 */
	
	var RESOLVED = 0;
	var REJECTED = 1;
	var PENDING  = 2;
	
	function Promise$1(executor) {
	
	    this.state = PENDING;
	    this.value = undefined;
	    this.deferred = [];
	
	    var promise = this;
	
	    try {
	        executor(function (x) {
	            promise.resolve(x);
	        }, function (r) {
	            promise.reject(r);
	        });
	    } catch (e) {
	        promise.reject(e);
	    }
	}
	
	Promise$1.reject = function (r) {
	    return new Promise$1(function (resolve, reject) {
	        reject(r);
	    });
	};
	
	Promise$1.resolve = function (x) {
	    return new Promise$1(function (resolve, reject) {
	        resolve(x);
	    });
	};
	
	Promise$1.all = function all(iterable) {
	    return new Promise$1(function (resolve, reject) {
	        var count = 0, result = [];
	
	        if (iterable.length === 0) {
	            resolve(result);
	        }
	
	        function resolver(i) {
	            return function (x) {
	                result[i] = x;
	                count += 1;
	
	                if (count === iterable.length) {
	                    resolve(result);
	                }
	            };
	        }
	
	        for (var i = 0; i < iterable.length; i += 1) {
	            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
	        }
	    });
	};
	
	Promise$1.race = function race(iterable) {
	    return new Promise$1(function (resolve, reject) {
	        for (var i = 0; i < iterable.length; i += 1) {
	            Promise$1.resolve(iterable[i]).then(resolve, reject);
	        }
	    });
	};
	
	var p$1 = Promise$1.prototype;
	
	p$1.resolve = function resolve(x) {
	    var promise = this;
	
	    if (promise.state === PENDING) {
	        if (x === promise) {
	            throw new TypeError('Promise settled with itself.');
	        }
	
	        var called = false;
	
	        try {
	            var then = x && x['then'];
	
	            if (x !== null && typeof x === 'object' && typeof then === 'function') {
	                then.call(x, function (x) {
	                    if (!called) {
	                        promise.resolve(x);
	                    }
	                    called = true;
	
	                }, function (r) {
	                    if (!called) {
	                        promise.reject(r);
	                    }
	                    called = true;
	                });
	                return;
	            }
	        } catch (e) {
	            if (!called) {
	                promise.reject(e);
	            }
	            return;
	        }
	
	        promise.state = RESOLVED;
	        promise.value = x;
	        promise.notify();
	    }
	};
	
	p$1.reject = function reject(reason) {
	    var promise = this;
	
	    if (promise.state === PENDING) {
	        if (reason === promise) {
	            throw new TypeError('Promise settled with itself.');
	        }
	
	        promise.state = REJECTED;
	        promise.value = reason;
	        promise.notify();
	    }
	};
	
	p$1.notify = function notify() {
	    var promise = this;
	
	    nextTick(function () {
	        if (promise.state !== PENDING) {
	            while (promise.deferred.length) {
	                var deferred = promise.deferred.shift(),
	                    onResolved = deferred[0],
	                    onRejected = deferred[1],
	                    resolve = deferred[2],
	                    reject = deferred[3];
	
	                try {
	                    if (promise.state === RESOLVED) {
	                        if (typeof onResolved === 'function') {
	                            resolve(onResolved.call(undefined, promise.value));
	                        } else {
	                            resolve(promise.value);
	                        }
	                    } else if (promise.state === REJECTED) {
	                        if (typeof onRejected === 'function') {
	                            resolve(onRejected.call(undefined, promise.value));
	                        } else {
	                            reject(promise.value);
	                        }
	                    }
	                } catch (e) {
	                    reject(e);
	                }
	            }
	        }
	    });
	};
	
	p$1.then = function then(onResolved, onRejected) {
	    var promise = this;
	
	    return new Promise$1(function (resolve, reject) {
	        promise.deferred.push([onResolved, onRejected, resolve, reject]);
	        promise.notify();
	    });
	};
	
	p$1.catch = function (onRejected) {
	    return this.then(undefined, onRejected);
	};
	
	/**
	 * Promise adapter.
	 */
	
	if (typeof Promise === 'undefined') {
	    window.Promise = Promise$1;
	}
	
	function PromiseObj(executor, context) {
	
	    if (executor instanceof Promise) {
	        this.promise = executor;
	    } else {
	        this.promise = new Promise(executor.bind(context));
	    }
	
	    this.context = context;
	}
	
	PromiseObj.all = function (iterable, context) {
	    return new PromiseObj(Promise.all(iterable), context);
	};
	
	PromiseObj.resolve = function (value, context) {
	    return new PromiseObj(Promise.resolve(value), context);
	};
	
	PromiseObj.reject = function (reason, context) {
	    return new PromiseObj(Promise.reject(reason), context);
	};
	
	PromiseObj.race = function (iterable, context) {
	    return new PromiseObj(Promise.race(iterable), context);
	};
	
	var p = PromiseObj.prototype;
	
	p.bind = function (context) {
	    this.context = context;
	    return this;
	};
	
	p.then = function (fulfilled, rejected) {
	
	    if (fulfilled && fulfilled.bind && this.context) {
	        fulfilled = fulfilled.bind(this.context);
	    }
	
	    if (rejected && rejected.bind && this.context) {
	        rejected = rejected.bind(this.context);
	    }
	
	    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
	};
	
	p.catch = function (rejected) {
	
	    if (rejected && rejected.bind && this.context) {
	        rejected = rejected.bind(this.context);
	    }
	
	    return new PromiseObj(this.promise.catch(rejected), this.context);
	};
	
	p.finally = function (callback) {
	
	    return this.then(function (value) {
	            callback.call(this);
	            return value;
	        }, function (reason) {
	            callback.call(this);
	            return Promise.reject(reason);
	        }
	    );
	};
	
	/**
	 * Utility functions.
	 */
	
	var ref = {};
	var hasOwnProperty = ref.hasOwnProperty;
	
	var ref$1 = [];
	var slice = ref$1.slice;
	var debug = false;
	var ntick;
	
	var inBrowser = typeof window !== 'undefined';
	
	var Util = function (ref) {
	    var config = ref.config;
	    var nextTick = ref.nextTick;
	
	    ntick = nextTick;
	    debug = config.debug || !config.silent;
	};
	
	function warn(msg) {
	    if (typeof console !== 'undefined' && debug) {
	        console.warn('[VueResource warn]: ' + msg);
	    }
	}
	
	function error(msg) {
	    if (typeof console !== 'undefined') {
	        console.error(msg);
	    }
	}
	
	function nextTick(cb, ctx) {
	    return ntick(cb, ctx);
	}
	
	function trim(str) {
	    return str ? str.replace(/^\s*|\s*$/g, '') : '';
	}
	
	function trimEnd(str, chars) {
	
	    if (str && chars === undefined) {
	        return str.replace(/\s+$/, '');
	    }
	
	    if (!str || !chars) {
	        return str;
	    }
	
	    return str.replace(new RegExp(("[" + chars + "]+$")), '');
	}
	
	function toLower(str) {
	    return str ? str.toLowerCase() : '';
	}
	
	function toUpper(str) {
	    return str ? str.toUpperCase() : '';
	}
	
	var isArray = Array.isArray;
	
	function isString(val) {
	    return typeof val === 'string';
	}
	
	
	
	function isFunction(val) {
	    return typeof val === 'function';
	}
	
	function isObject(obj) {
	    return obj !== null && typeof obj === 'object';
	}
	
	function isPlainObject(obj) {
	    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
	}
	
	function isBlob(obj) {
	    return typeof Blob !== 'undefined' && obj instanceof Blob;
	}
	
	function isFormData(obj) {
	    return typeof FormData !== 'undefined' && obj instanceof FormData;
	}
	
	function when(value, fulfilled, rejected) {
	
	    var promise = PromiseObj.resolve(value);
	
	    if (arguments.length < 2) {
	        return promise;
	    }
	
	    return promise.then(fulfilled, rejected);
	}
	
	function options(fn, obj, opts) {
	
	    opts = opts || {};
	
	    if (isFunction(opts)) {
	        opts = opts.call(obj);
	    }
	
	    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
	}
	
	function each(obj, iterator) {
	
	    var i, key;
	
	    if (isArray(obj)) {
	        for (i = 0; i < obj.length; i++) {
	            iterator.call(obj[i], obj[i], i);
	        }
	    } else if (isObject(obj)) {
	        for (key in obj) {
	            if (hasOwnProperty.call(obj, key)) {
	                iterator.call(obj[key], obj[key], key);
	            }
	        }
	    }
	
	    return obj;
	}
	
	var assign = Object.assign || _assign;
	
	function merge(target) {
	
	    var args = slice.call(arguments, 1);
	
	    args.forEach(function (source) {
	        _merge(target, source, true);
	    });
	
	    return target;
	}
	
	function defaults(target) {
	
	    var args = slice.call(arguments, 1);
	
	    args.forEach(function (source) {
	
	        for (var key in source) {
	            if (target[key] === undefined) {
	                target[key] = source[key];
	            }
	        }
	
	    });
	
	    return target;
	}
	
	function _assign(target) {
	
	    var args = slice.call(arguments, 1);
	
	    args.forEach(function (source) {
	        _merge(target, source);
	    });
	
	    return target;
	}
	
	function _merge(target, source, deep) {
	    for (var key in source) {
	        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
	            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
	                target[key] = {};
	            }
	            if (isArray(source[key]) && !isArray(target[key])) {
	                target[key] = [];
	            }
	            _merge(target[key], source[key], deep);
	        } else if (source[key] !== undefined) {
	            target[key] = source[key];
	        }
	    }
	}
	
	/**
	 * Root Prefix Transform.
	 */
	
	var root = function (options$$1, next) {
	
	    var url = next(options$$1);
	
	    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
	        url = trimEnd(options$$1.root, '/') + '/' + url;
	    }
	
	    return url;
	};
	
	/**
	 * Query Parameter Transform.
	 */
	
	var query = function (options$$1, next) {
	
	    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);
	
	    each(options$$1.params, function (value, key) {
	        if (urlParams.indexOf(key) === -1) {
	            query[key] = value;
	        }
	    });
	
	    query = Url.params(query);
	
	    if (query) {
	        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
	    }
	
	    return url;
	};
	
	/**
	 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
	 */
	
	function expand(url, params, variables) {
	
	    var tmpl = parse(url), expanded = tmpl.expand(params);
	
	    if (variables) {
	        variables.push.apply(variables, tmpl.vars);
	    }
	
	    return expanded;
	}
	
	function parse(template) {
	
	    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];
	
	    return {
	        vars: variables,
	        expand: function expand(context) {
	            return template.replace(/\{([^\{\}]+)\}|([^\{\}]+)/g, function (_, expression, literal) {
	                if (expression) {
	
	                    var operator = null, values = [];
	
	                    if (operators.indexOf(expression.charAt(0)) !== -1) {
	                        operator = expression.charAt(0);
	                        expression = expression.substr(1);
	                    }
	
	                    expression.split(/,/g).forEach(function (variable) {
	                        var tmp = /([^:\*]*)(?::(\d+)|(\*))?/.exec(variable);
	                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
	                        variables.push(tmp[1]);
	                    });
	
	                    if (operator && operator !== '+') {
	
	                        var separator = ',';
	
	                        if (operator === '?') {
	                            separator = '&';
	                        } else if (operator !== '#') {
	                            separator = operator;
	                        }
	
	                        return (values.length !== 0 ? operator : '') + values.join(separator);
	                    } else {
	                        return values.join(',');
	                    }
	
	                } else {
	                    return encodeReserved(literal);
	                }
	            });
	        }
	    };
	}
	
	function getValues(context, operator, key, modifier) {
	
	    var value = context[key], result = [];
	
	    if (isDefined(value) && value !== '') {
	        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
	            value = value.toString();
	
	            if (modifier && modifier !== '*') {
	                value = value.substring(0, parseInt(modifier, 10));
	            }
	
	            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
	        } else {
	            if (modifier === '*') {
	                if (Array.isArray(value)) {
	                    value.filter(isDefined).forEach(function (value) {
	                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
	                    });
	                } else {
	                    Object.keys(value).forEach(function (k) {
	                        if (isDefined(value[k])) {
	                            result.push(encodeValue(operator, value[k], k));
	                        }
	                    });
	                }
	            } else {
	                var tmp = [];
	
	                if (Array.isArray(value)) {
	                    value.filter(isDefined).forEach(function (value) {
	                        tmp.push(encodeValue(operator, value));
	                    });
	                } else {
	                    Object.keys(value).forEach(function (k) {
	                        if (isDefined(value[k])) {
	                            tmp.push(encodeURIComponent(k));
	                            tmp.push(encodeValue(operator, value[k].toString()));
	                        }
	                    });
	                }
	
	                if (isKeyOperator(operator)) {
	                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
	                } else if (tmp.length !== 0) {
	                    result.push(tmp.join(','));
	                }
	            }
	        }
	    } else {
	        if (operator === ';') {
	            result.push(encodeURIComponent(key));
	        } else if (value === '' && (operator === '&' || operator === '?')) {
	            result.push(encodeURIComponent(key) + '=');
	        } else if (value === '') {
	            result.push('');
	        }
	    }
	
	    return result;
	}
	
	function isDefined(value) {
	    return value !== undefined && value !== null;
	}
	
	function isKeyOperator(operator) {
	    return operator === ';' || operator === '&' || operator === '?';
	}
	
	function encodeValue(operator, value, key) {
	
	    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);
	
	    if (key) {
	        return encodeURIComponent(key) + '=' + value;
	    } else {
	        return value;
	    }
	}
	
	function encodeReserved(str) {
	    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
	        if (!/%[0-9A-Fa-f]/.test(part)) {
	            part = encodeURI(part);
	        }
	        return part;
	    }).join('');
	}
	
	/**
	 * URL Template (RFC 6570) Transform.
	 */
	
	var template = function (options) {
	
	    var variables = [], url = expand(options.url, options.params, variables);
	
	    variables.forEach(function (key) {
	        delete options.params[key];
	    });
	
	    return url;
	};
	
	/**
	 * Service for URL templating.
	 */
	
	function Url(url, params) {
	
	    var self = this || {}, options$$1 = url, transform;
	
	    if (isString(url)) {
	        options$$1 = {url: url, params: params};
	    }
	
	    options$$1 = merge({}, Url.options, self.$options, options$$1);
	
	    Url.transforms.forEach(function (handler) {
	
	        if (isString(handler)) {
	            handler = Url.transform[handler];
	        }
	
	        if (isFunction(handler)) {
	            transform = factory(handler, transform, self.$vm);
	        }
	
	    });
	
	    return transform(options$$1);
	}
	
	/**
	 * Url options.
	 */
	
	Url.options = {
	    url: '',
	    root: null,
	    params: {}
	};
	
	/**
	 * Url transforms.
	 */
	
	Url.transform = {template: template, query: query, root: root};
	Url.transforms = ['template', 'query', 'root'];
	
	/**
	 * Encodes a Url parameter string.
	 *
	 * @param {Object} obj
	 */
	
	Url.params = function (obj) {
	
	    var params = [], escape = encodeURIComponent;
	
	    params.add = function (key, value) {
	
	        if (isFunction(value)) {
	            value = value();
	        }
	
	        if (value === null) {
	            value = '';
	        }
	
	        this.push(escape(key) + '=' + escape(value));
	    };
	
	    serialize(params, obj);
	
	    return params.join('&').replace(/%20/g, '+');
	};
	
	/**
	 * Parse a URL and return its components.
	 *
	 * @param {String} url
	 */
	
	Url.parse = function (url) {
	
	    var el = document.createElement('a');
	
	    if (document.documentMode) {
	        el.href = url;
	        url = el.href;
	    }
	
	    el.href = url;
	
	    return {
	        href: el.href,
	        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
	        port: el.port,
	        host: el.host,
	        hostname: el.hostname,
	        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
	        search: el.search ? el.search.replace(/^\?/, '') : '',
	        hash: el.hash ? el.hash.replace(/^#/, '') : ''
	    };
	};
	
	function factory(handler, next, vm) {
	    return function (options$$1) {
	        return handler.call(vm, options$$1, next);
	    };
	}
	
	function serialize(params, obj, scope) {
	
	    var array = isArray(obj), plain = isPlainObject(obj), hash;
	
	    each(obj, function (value, key) {
	
	        hash = isObject(value) || isArray(value);
	
	        if (scope) {
	            key = scope + '[' + (plain || hash ? key : '') + ']';
	        }
	
	        if (!scope && array) {
	            params.add(value.name, value.value);
	        } else if (hash) {
	            serialize(params, value, key);
	        } else {
	            params.add(key, value);
	        }
	    });
	}
	
	/**
	 * XDomain client (Internet Explorer).
	 */
	
	var xdrClient = function (request) {
	    return new PromiseObj(function (resolve) {
	
	        var xdr = new XDomainRequest(), handler = function (ref) {
	            var type = ref.type;
	
	
	            var status = 0;
	
	            if (type === 'load') {
	                status = 200;
	            } else if (type === 'error') {
	                status = 500;
	            }
	
	            resolve(request.respondWith(xdr.responseText, {status: status}));
	        };
	
	        request.abort = function () { return xdr.abort(); };
	
	        xdr.open(request.method, request.getUrl());
	
	        if (request.timeout) {
	            xdr.timeout = request.timeout;
	        }
	
	        xdr.onload = handler;
	        xdr.onabort = handler;
	        xdr.onerror = handler;
	        xdr.ontimeout = handler;
	        xdr.onprogress = function () {};
	        xdr.send(request.getBody());
	    });
	};
	
	/**
	 * CORS Interceptor.
	 */
	
	var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();
	
	var cors = function (request, next) {
	
	    if (inBrowser) {
	
	        var orgUrl = Url.parse(location.href);
	        var reqUrl = Url.parse(request.getUrl());
	
	        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {
	
	            request.crossOrigin = true;
	            request.emulateHTTP = false;
	
	            if (!SUPPORTS_CORS) {
	                request.client = xdrClient;
	            }
	        }
	    }
	
	    next();
	};
	
	/**
	 * Form data Interceptor.
	 */
	
	var form = function (request, next) {
	
	    if (isFormData(request.body)) {
	
	        request.headers.delete('Content-Type');
	
	    } else if (isObject(request.body) && request.emulateJSON) {
	
	        request.body = Url.params(request.body);
	        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
	    }
	
	    next();
	};
	
	/**
	 * JSON Interceptor.
	 */
	
	var json = function (request, next) {
	
	    var type = request.headers.get('Content-Type') || '';
	
	    if (isObject(request.body) && type.indexOf('application/json') === 0) {
	        request.body = JSON.stringify(request.body);
	    }
	
	    next(function (response) {
	
	        return response.bodyText ? when(response.text(), function (text) {
	
	            type = response.headers.get('Content-Type') || '';
	
	            if (type.indexOf('application/json') === 0 || isJson(text)) {
	
	                try {
	                    response.body = JSON.parse(text);
	                } catch (e) {
	                    response.body = null;
	                }
	
	            } else {
	                response.body = text;
	            }
	
	            return response;
	
	        }) : response;
	
	    });
	};
	
	function isJson(str) {
	
	    var start = str.match(/^\[|^\{(?!\{)/), end = {'[': /]$/, '{': /}$/};
	
	    return start && end[start[0]].test(str);
	}
	
	/**
	 * JSONP client (Browser).
	 */
	
	var jsonpClient = function (request) {
	    return new PromiseObj(function (resolve) {
	
	        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;
	
	        handler = function (ref) {
	            var type = ref.type;
	
	
	            var status = 0;
	
	            if (type === 'load' && body !== null) {
	                status = 200;
	            } else if (type === 'error') {
	                status = 500;
	            }
	
	            if (status && window[callback]) {
	                delete window[callback];
	                document.body.removeChild(script);
	            }
	
	            resolve(request.respondWith(body, {status: status}));
	        };
	
	        window[callback] = function (result) {
	            body = JSON.stringify(result);
	        };
	
	        request.abort = function () {
	            handler({type: 'abort'});
	        };
	
	        request.params[name] = callback;
	
	        if (request.timeout) {
	            setTimeout(request.abort, request.timeout);
	        }
	
	        script = document.createElement('script');
	        script.src = request.getUrl();
	        script.type = 'text/javascript';
	        script.async = true;
	        script.onload = handler;
	        script.onerror = handler;
	
	        document.body.appendChild(script);
	    });
	};
	
	/**
	 * JSONP Interceptor.
	 */
	
	var jsonp = function (request, next) {
	
	    if (request.method == 'JSONP') {
	        request.client = jsonpClient;
	    }
	
	    next();
	};
	
	/**
	 * Before Interceptor.
	 */
	
	var before = function (request, next) {
	
	    if (isFunction(request.before)) {
	        request.before.call(this, request);
	    }
	
	    next();
	};
	
	/**
	 * HTTP method override Interceptor.
	 */
	
	var method = function (request, next) {
	
	    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
	        request.headers.set('X-HTTP-Method-Override', request.method);
	        request.method = 'POST';
	    }
	
	    next();
	};
	
	/**
	 * Header Interceptor.
	 */
	
	var header = function (request, next) {
	
	    var headers = assign({}, Http.headers.common,
	        !request.crossOrigin ? Http.headers.custom : {},
	        Http.headers[toLower(request.method)]
	    );
	
	    each(headers, function (value, name) {
	        if (!request.headers.has(name)) {
	            request.headers.set(name, value);
	        }
	    });
	
	    next();
	};
	
	/**
	 * XMLHttp client (Browser).
	 */
	
	var xhrClient = function (request) {
	    return new PromiseObj(function (resolve) {
	
	        var xhr = new XMLHttpRequest(), handler = function (event) {
	
	            var response = request.respondWith(
	                'response' in xhr ? xhr.response : xhr.responseText, {
	                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
	                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
	                }
	            );
	
	            each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
	                response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
	            });
	
	            resolve(response);
	        };
	
	        request.abort = function () { return xhr.abort(); };
	
	        if (request.progress) {
	            if (request.method === 'GET') {
	                xhr.addEventListener('progress', request.progress);
	            } else if (/^(POST|PUT)$/i.test(request.method)) {
	                xhr.upload.addEventListener('progress', request.progress);
	            }
	        }
	
	        xhr.open(request.method, request.getUrl(), true);
	
	        if (request.timeout) {
	            xhr.timeout = request.timeout;
	        }
	
	        if (request.responseType && 'responseType' in xhr) {
	            xhr.responseType = request.responseType;
	        }
	
	        if (request.withCredentials || request.credentials) {
	            xhr.withCredentials = true;
	        }
	
	        if (!request.crossOrigin) {
	            request.headers.set('X-Requested-With', 'XMLHttpRequest');
	        }
	
	        request.headers.forEach(function (value, name) {
	            xhr.setRequestHeader(name, value);
	        });
	
	        xhr.onload = handler;
	        xhr.onabort = handler;
	        xhr.onerror = handler;
	        xhr.ontimeout = handler;
	        xhr.send(request.getBody());
	    });
	};
	
	/**
	 * Http client (Node).
	 */
	
	var nodeClient = function (request) {
	
	    var client = __webpack_require__(487);
	
	    return new PromiseObj(function (resolve) {
	
	        var url = request.getUrl();
	        var body = request.getBody();
	        var method = request.method;
	        var headers = {}, handler;
	
	        request.headers.forEach(function (value, name) {
	            headers[name] = value;
	        });
	
	        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {
	
	            var response = request.respondWith(resp.body, {
	                    status: resp.statusCode,
	                    statusText: trim(resp.statusMessage)
	                }
	            );
	
	            each(resp.headers, function (value, name) {
	                response.headers.set(name, value);
	            });
	
	            resolve(response);
	
	        }, function (error$$1) { return handler(error$$1.response); });
	    });
	};
	
	/**
	 * Base client.
	 */
	
	var Client = function (context) {
	
	    var reqHandlers = [sendRequest], resHandlers = [], handler;
	
	    if (!isObject(context)) {
	        context = null;
	    }
	
	    function Client(request) {
	        return new PromiseObj(function (resolve, reject) {
	
	            function exec() {
	
	                handler = reqHandlers.pop();
	
	                if (isFunction(handler)) {
	                    handler.call(context, request, next);
	                } else {
	                    warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
	                    next();
	                }
	            }
	
	            function next(response) {
	
	                if (isFunction(response)) {
	
	                    resHandlers.unshift(response);
	
	                } else if (isObject(response)) {
	
	                    resHandlers.forEach(function (handler) {
	                        response = when(response, function (response) {
	                            return handler.call(context, response) || response;
	                        }, reject);
	                    });
	
	                    when(response, resolve, reject);
	
	                    return;
	                }
	
	                exec();
	            }
	
	            exec();
	
	        }, context);
	    }
	
	    Client.use = function (handler) {
	        reqHandlers.push(handler);
	    };
	
	    return Client;
	};
	
	function sendRequest(request, resolve) {
	
	    var client = request.client || (inBrowser ? xhrClient : nodeClient);
	
	    resolve(client(request));
	}
	
	/**
	 * HTTP Headers.
	 */
	
	var Headers = function Headers(headers) {
	    var this$1 = this;
	
	
	    this.map = {};
	
	    each(headers, function (value, name) { return this$1.append(name, value); });
	};
	
	Headers.prototype.has = function has (name) {
	    return getName(this.map, name) !== null;
	};
	
	Headers.prototype.get = function get (name) {
	
	    var list = this.map[getName(this.map, name)];
	
	    return list ? list.join() : null;
	};
	
	Headers.prototype.getAll = function getAll (name) {
	    return this.map[getName(this.map, name)] || [];
	};
	
	Headers.prototype.set = function set (name, value) {
	    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
	};
	
	Headers.prototype.append = function append (name, value){
	
	    var list = this.map[getName(this.map, name)];
	
	    if (list) {
	        list.push(trim(value));
	    } else {
	        this.set(name, value);
	    }
	};
	
	Headers.prototype.delete = function delete$1 (name){
	    delete this.map[getName(this.map, name)];
	};
	
	Headers.prototype.deleteAll = function deleteAll (){
	    this.map = {};
	};
	
	Headers.prototype.forEach = function forEach (callback, thisArg) {
	        var this$1 = this;
	
	    each(this.map, function (list, name) {
	        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
	    });
	};
	
	function getName(map, name) {
	    return Object.keys(map).reduce(function (prev, curr) {
	        return toLower(name) === toLower(curr) ? curr : prev;
	    }, null);
	}
	
	function normalizeName(name) {
	
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	        throw new TypeError('Invalid character in header field name');
	    }
	
	    return trim(name);
	}
	
	/**
	 * HTTP Response.
	 */
	
	var Response = function Response(body, ref) {
	    var url = ref.url;
	    var headers = ref.headers;
	    var status = ref.status;
	    var statusText = ref.statusText;
	
	
	    this.url = url;
	    this.ok = status >= 200 && status < 300;
	    this.status = status || 0;
	    this.statusText = statusText || '';
	    this.headers = new Headers(headers);
	    this.body = body;
	
	    if (isString(body)) {
	
	        this.bodyText = body;
	
	    } else if (isBlob(body)) {
	
	        this.bodyBlob = body;
	
	        if (isBlobText(body)) {
	            this.bodyText = blobText(body);
	        }
	    }
	};
	
	Response.prototype.blob = function blob () {
	    return when(this.bodyBlob);
	};
	
	Response.prototype.text = function text () {
	    return when(this.bodyText);
	};
	
	Response.prototype.json = function json () {
	    return when(this.text(), function (text) { return JSON.parse(text); });
	};
	
	Object.defineProperty(Response.prototype, 'data', {
	
	    get: function get() {
	        return this.body;
	    },
	
	    set: function set(body) {
	        this.body = body;
	    }
	
	});
	
	function blobText(body) {
	    return new PromiseObj(function (resolve) {
	
	        var reader = new FileReader();
	
	        reader.readAsText(body);
	        reader.onload = function () {
	            resolve(reader.result);
	        };
	
	    });
	}
	
	function isBlobText(body) {
	    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
	}
	
	/**
	 * HTTP Request.
	 */
	
	var Request = function Request(options$$1) {
	
	    this.body = null;
	    this.params = {};
	
	    assign(this, options$$1, {
	        method: toUpper(options$$1.method || 'GET')
	    });
	
	    if (!(this.headers instanceof Headers)) {
	        this.headers = new Headers(this.headers);
	    }
	};
	
	Request.prototype.getUrl = function getUrl (){
	    return Url(this);
	};
	
	Request.prototype.getBody = function getBody (){
	    return this.body;
	};
	
	Request.prototype.respondWith = function respondWith (body, options$$1) {
	    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
	};
	
	/**
	 * Service for sending network requests.
	 */
	
	var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
	var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};
	
	function Http(options$$1) {
	
	    var self = this || {}, client = Client(self.$vm);
	
	    defaults(options$$1 || {}, self.$options, Http.options);
	
	    Http.interceptors.forEach(function (handler) {
	
	        if (isString(handler)) {
	            handler = Http.interceptor[handler];
	        }
	
	        if (isFunction(handler)) {
	            client.use(handler);
	        }
	
	    });
	
	    return client(new Request(options$$1)).then(function (response) {
	
	        return response.ok ? response : PromiseObj.reject(response);
	
	    }, function (response) {
	
	        if (response instanceof Error) {
	            error(response);
	        }
	
	        return PromiseObj.reject(response);
	    });
	}
	
	Http.options = {};
	
	Http.headers = {
	    put: JSON_CONTENT_TYPE,
	    post: JSON_CONTENT_TYPE,
	    patch: JSON_CONTENT_TYPE,
	    delete: JSON_CONTENT_TYPE,
	    common: COMMON_HEADERS,
	    custom: {}
	};
	
	Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
	Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];
	
	['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {
	
	    Http[method$$1] = function (url, options$$1) {
	        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
	    };
	
	});
	
	['post', 'put', 'patch'].forEach(function (method$$1) {
	
	    Http[method$$1] = function (url, body, options$$1) {
	        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
	    };
	
	});
	
	/**
	 * Service for interacting with RESTful services.
	 */
	
	function Resource(url, params, actions, options$$1) {
	
	    var self = this || {}, resource = {};
	
	    actions = assign({},
	        Resource.actions,
	        actions
	    );
	
	    each(actions, function (action, name) {
	
	        action = merge({url: url, params: assign({}, params)}, options$$1, action);
	
	        resource[name] = function () {
	            return (self.$http || Http)(opts(action, arguments));
	        };
	    });
	
	    return resource;
	}
	
	function opts(action, args) {
	
	    var options$$1 = assign({}, action), params = {}, body;
	
	    switch (args.length) {
	
	        case 2:
	
	            params = args[0];
	            body = args[1];
	
	            break;
	
	        case 1:
	
	            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
	                body = args[0];
	            } else {
	                params = args[0];
	            }
	
	            break;
	
	        case 0:
	
	            break;
	
	        default:
	
	            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
	    }
	
	    options$$1.body = body;
	    options$$1.params = assign({}, options$$1.params, params);
	
	    return options$$1;
	}
	
	Resource.actions = {
	
	    get: {method: 'GET'},
	    save: {method: 'POST'},
	    query: {method: 'GET'},
	    update: {method: 'PUT'},
	    remove: {method: 'DELETE'},
	    delete: {method: 'DELETE'}
	
	};
	
	/**
	 * Install plugin.
	 */
	
	function plugin(Vue) {
	
	    if (plugin.installed) {
	        return;
	    }
	
	    Util(Vue);
	
	    Vue.url = Url;
	    Vue.http = Http;
	    Vue.resource = Resource;
	    Vue.Promise = PromiseObj;
	
	    Object.defineProperties(Vue.prototype, {
	
	        $url: {
	            get: function get() {
	                return options(Vue.url, this, this.$options.url);
	            }
	        },
	
	        $http: {
	            get: function get() {
	                return options(Vue.http, this, this.$options.http);
	            }
	        },
	
	        $resource: {
	            get: function get() {
	                return Vue.resource.bind(this);
	            }
	        },
	
	        $promise: {
	            get: function get() {
	                var this$1 = this;
	
	                return function (executor) { return new Vue.Promise(executor, this$1); };
	            }
	        }
	
	    });
	}
	
	if (typeof window !== 'undefined' && window.Vue) {
	    window.Vue.use(plugin);
	}
	
	module.exports = plugin;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(34);
	var TAG = __webpack_require__(9)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(8).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(20) && !__webpack_require__(36)(function () {
	  return Object.defineProperty(__webpack_require__(64)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(34);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(37);
	var ITERATOR = __webpack_require__(9)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(16);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(45);
	var $export = __webpack_require__(21);
	var redefine = __webpack_require__(120);
	var hide = __webpack_require__(23);
	var has = __webpack_require__(22);
	var Iterators = __webpack_require__(37);
	var $iterCreate = __webpack_require__(216);
	var setToStringTag = __webpack_require__(48);
	var getPrototypeOf = __webpack_require__(224);
	var ITERATOR = __webpack_require__(9)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(9)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(16);
	var dPs = __webpack_require__(221);
	var enumBugKeys = __webpack_require__(65);
	var IE_PROTO = __webpack_require__(68)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(64)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(108).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(117);
	var hiddenKeys = __webpack_require__(65).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(22);
	var toIObject = __webpack_require__(28);
	var arrayIndexOf = __webpack_require__(210)(false);
	var IE_PROTO = __webpack_require__(68)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 118 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(16);
	var isObject = __webpack_require__(24);
	var newPromiseCapability = __webpack_require__(66);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(23);


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(16);
	var aFunction = __webpack_require__(44);
	var SPECIES = __webpack_require__(9)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(35);
	var invoke = __webpack_require__(214);
	var html = __webpack_require__(108);
	var cel = __webpack_require__(64);
	var global = __webpack_require__(8);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(34)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 123 */
/***/ (function(module, exports) {



/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	  * vue-router v2.8.1
	  * (c) 2017 Evan You
	  * @license MIT
	  */
	'use strict';
	
	/*  */
	
	function assert (condition, message) {
	  if (!condition) {
	    throw new Error(("[vue-router] " + message))
	  }
	}
	
	function warn (condition, message) {
	  if (false) {
	    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
	  }
	}
	
	function isError (err) {
	  return Object.prototype.toString.call(err).indexOf('Error') > -1
	}
	
	var View = {
	  name: 'router-view',
	  functional: true,
	  props: {
	    name: {
	      type: String,
	      default: 'default'
	    }
	  },
	  render: function render (_, ref) {
	    var props = ref.props;
	    var children = ref.children;
	    var parent = ref.parent;
	    var data = ref.data;
	
	    data.routerView = true;
	
	    // directly use parent context's createElement() function
	    // so that components rendered by router-view can resolve named slots
	    var h = parent.$createElement;
	    var name = props.name;
	    var route = parent.$route;
	    var cache = parent._routerViewCache || (parent._routerViewCache = {});
	
	    // determine current view depth, also check to see if the tree
	    // has been toggled inactive but kept-alive.
	    var depth = 0;
	    var inactive = false;
	    while (parent && parent._routerRoot !== parent) {
	      if (parent.$vnode && parent.$vnode.data.routerView) {
	        depth++;
	      }
	      if (parent._inactive) {
	        inactive = true;
	      }
	      parent = parent.$parent;
	    }
	    data.routerViewDepth = depth;
	
	    // render previous view if the tree is inactive and kept-alive
	    if (inactive) {
	      return h(cache[name], data, children)
	    }
	
	    var matched = route.matched[depth];
	    // render empty node if no matched route
	    if (!matched) {
	      cache[name] = null;
	      return h()
	    }
	
	    var component = cache[name] = matched.components[name];
	
	    // attach instance registration hook
	    // this will be called in the instance's injected lifecycle hooks
	    data.registerRouteInstance = function (vm, val) {
	      // val could be undefined for unregistration
	      var current = matched.instances[name];
	      if (
	        (val && current !== vm) ||
	        (!val && current === vm)
	      ) {
	        matched.instances[name] = val;
	      }
	    }
	
	    // also register instance in prepatch hook
	    // in case the same component instance is reused across different routes
	    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
	      matched.instances[name] = vnode.componentInstance;
	    };
	
	    // resolve props
	    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
	    if (propsToPass) {
	      // clone to prevent mutation
	      propsToPass = data.props = extend({}, propsToPass);
	      // pass non-declared props as attrs
	      var attrs = data.attrs = data.attrs || {};
	      for (var key in propsToPass) {
	        if (!component.props || !(key in component.props)) {
	          attrs[key] = propsToPass[key];
	          delete propsToPass[key];
	        }
	      }
	    }
	
	    return h(component, data, children)
	  }
	};
	
	function resolveProps (route, config) {
	  switch (typeof config) {
	    case 'undefined':
	      return
	    case 'object':
	      return config
	    case 'function':
	      return config(route)
	    case 'boolean':
	      return config ? route.params : undefined
	    default:
	      if (false) {
	        warn(
	          false,
	          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
	          "expecting an object, function or boolean."
	        );
	      }
	  }
	}
	
	function extend (to, from) {
	  for (var key in from) {
	    to[key] = from[key];
	  }
	  return to
	}
	
	/*  */
	
	var encodeReserveRE = /[!'()*]/g;
	var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
	var commaRE = /%2C/g;
	
	// fixed encodeURIComponent which is more conformant to RFC3986:
	// - escapes [!'()*]
	// - preserve commas
	var encode = function (str) { return encodeURIComponent(str)
	  .replace(encodeReserveRE, encodeReserveReplacer)
	  .replace(commaRE, ','); };
	
	var decode = decodeURIComponent;
	
	function resolveQuery (
	  query,
	  extraQuery,
	  _parseQuery
	) {
	  if ( extraQuery === void 0 ) extraQuery = {};
	
	  var parse = _parseQuery || parseQuery;
	  var parsedQuery;
	  try {
	    parsedQuery = parse(query || '');
	  } catch (e) {
	    ("production") !== 'production' && warn(false, e.message);
	    parsedQuery = {};
	  }
	  for (var key in extraQuery) {
	    parsedQuery[key] = extraQuery[key];
	  }
	  return parsedQuery
	}
	
	function parseQuery (query) {
	  var res = {};
	
	  query = query.trim().replace(/^(\?|#|&)/, '');
	
	  if (!query) {
	    return res
	  }
	
	  query.split('&').forEach(function (param) {
	    var parts = param.replace(/\+/g, ' ').split('=');
	    var key = decode(parts.shift());
	    var val = parts.length > 0
	      ? decode(parts.join('='))
	      : null;
	
	    if (res[key] === undefined) {
	      res[key] = val;
	    } else if (Array.isArray(res[key])) {
	      res[key].push(val);
	    } else {
	      res[key] = [res[key], val];
	    }
	  });
	
	  return res
	}
	
	function stringifyQuery (obj) {
	  var res = obj ? Object.keys(obj).map(function (key) {
	    var val = obj[key];
	
	    if (val === undefined) {
	      return ''
	    }
	
	    if (val === null) {
	      return encode(key)
	    }
	
	    if (Array.isArray(val)) {
	      var result = [];
	      val.forEach(function (val2) {
	        if (val2 === undefined) {
	          return
	        }
	        if (val2 === null) {
	          result.push(encode(key));
	        } else {
	          result.push(encode(key) + '=' + encode(val2));
	        }
	      });
	      return result.join('&')
	    }
	
	    return encode(key) + '=' + encode(val)
	  }).filter(function (x) { return x.length > 0; }).join('&') : null;
	  return res ? ("?" + res) : ''
	}
	
	/*  */
	
	
	var trailingSlashRE = /\/?$/;
	
	function createRoute (
	  record,
	  location,
	  redirectedFrom,
	  router
	) {
	  var stringifyQuery$$1 = router && router.options.stringifyQuery;
	
	  var query = location.query || {};
	  try {
	    query = clone(query);
	  } catch (e) {}
	
	  var route = {
	    name: location.name || (record && record.name),
	    meta: (record && record.meta) || {},
	    path: location.path || '/',
	    hash: location.hash || '',
	    query: query,
	    params: location.params || {},
	    fullPath: getFullPath(location, stringifyQuery$$1),
	    matched: record ? formatMatch(record) : []
	  };
	  if (redirectedFrom) {
	    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
	  }
	  return Object.freeze(route)
	}
	
	function clone (value) {
	  if (Array.isArray(value)) {
	    return value.map(clone)
	  } else if (value && typeof value === 'object') {
	    var res = {};
	    for (var key in value) {
	      res[key] = clone(value[key]);
	    }
	    return res
	  } else {
	    return value
	  }
	}
	
	// the starting route that represents the initial state
	var START = createRoute(null, {
	  path: '/'
	});
	
	function formatMatch (record) {
	  var res = [];
	  while (record) {
	    res.unshift(record);
	    record = record.parent;
	  }
	  return res
	}
	
	function getFullPath (
	  ref,
	  _stringifyQuery
	) {
	  var path = ref.path;
	  var query = ref.query; if ( query === void 0 ) query = {};
	  var hash = ref.hash; if ( hash === void 0 ) hash = '';
	
	  var stringify = _stringifyQuery || stringifyQuery;
	  return (path || '/') + stringify(query) + hash
	}
	
	function isSameRoute (a, b) {
	  if (b === START) {
	    return a === b
	  } else if (!b) {
	    return false
	  } else if (a.path && b.path) {
	    return (
	      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
	      a.hash === b.hash &&
	      isObjectEqual(a.query, b.query)
	    )
	  } else if (a.name && b.name) {
	    return (
	      a.name === b.name &&
	      a.hash === b.hash &&
	      isObjectEqual(a.query, b.query) &&
	      isObjectEqual(a.params, b.params)
	    )
	  } else {
	    return false
	  }
	}
	
	function isObjectEqual (a, b) {
	  if ( a === void 0 ) a = {};
	  if ( b === void 0 ) b = {};
	
	  // handle null value #1566
	  if (!a || !b) { return a === b }
	  var aKeys = Object.keys(a);
	  var bKeys = Object.keys(b);
	  if (aKeys.length !== bKeys.length) {
	    return false
	  }
	  return aKeys.every(function (key) {
	    var aVal = a[key];
	    var bVal = b[key];
	    // check nested equality
	    if (typeof aVal === 'object' && typeof bVal === 'object') {
	      return isObjectEqual(aVal, bVal)
	    }
	    return String(aVal) === String(bVal)
	  })
	}
	
	function isIncludedRoute (current, target) {
	  return (
	    current.path.replace(trailingSlashRE, '/').indexOf(
	      target.path.replace(trailingSlashRE, '/')
	    ) === 0 &&
	    (!target.hash || current.hash === target.hash) &&
	    queryIncludes(current.query, target.query)
	  )
	}
	
	function queryIncludes (current, target) {
	  for (var key in target) {
	    if (!(key in current)) {
	      return false
	    }
	  }
	  return true
	}
	
	/*  */
	
	// work around weird flow bug
	var toTypes = [String, Object];
	var eventTypes = [String, Array];
	
	var Link = {
	  name: 'router-link',
	  props: {
	    to: {
	      type: toTypes,
	      required: true
	    },
	    tag: {
	      type: String,
	      default: 'a'
	    },
	    exact: Boolean,
	    append: Boolean,
	    replace: Boolean,
	    activeClass: String,
	    exactActiveClass: String,
	    event: {
	      type: eventTypes,
	      default: 'click'
	    }
	  },
	  render: function render (h) {
	    var this$1 = this;
	
	    var router = this.$router;
	    var current = this.$route;
	    var ref = router.resolve(this.to, current, this.append);
	    var location = ref.location;
	    var route = ref.route;
	    var href = ref.href;
	
	    var classes = {};
	    var globalActiveClass = router.options.linkActiveClass;
	    var globalExactActiveClass = router.options.linkExactActiveClass;
	    // Support global empty active class
	    var activeClassFallback = globalActiveClass == null
	            ? 'router-link-active'
	            : globalActiveClass;
	    var exactActiveClassFallback = globalExactActiveClass == null
	            ? 'router-link-exact-active'
	            : globalExactActiveClass;
	    var activeClass = this.activeClass == null
	            ? activeClassFallback
	            : this.activeClass;
	    var exactActiveClass = this.exactActiveClass == null
	            ? exactActiveClassFallback
	            : this.exactActiveClass;
	    var compareTarget = location.path
	      ? createRoute(null, location, null, router)
	      : route;
	
	    classes[exactActiveClass] = isSameRoute(current, compareTarget);
	    classes[activeClass] = this.exact
	      ? classes[exactActiveClass]
	      : isIncludedRoute(current, compareTarget);
	
	    var handler = function (e) {
	      if (guardEvent(e)) {
	        if (this$1.replace) {
	          router.replace(location);
	        } else {
	          router.push(location);
	        }
	      }
	    };
	
	    var on = { click: guardEvent };
	    if (Array.isArray(this.event)) {
	      this.event.forEach(function (e) { on[e] = handler; });
	    } else {
	      on[this.event] = handler;
	    }
	
	    var data = {
	      class: classes
	    };
	
	    if (this.tag === 'a') {
	      data.on = on;
	      data.attrs = { href: href };
	    } else {
	      // find the first <a> child and apply listener and href
	      var a = findAnchor(this.$slots.default);
	      if (a) {
	        // in case the <a> is a static node
	        a.isStatic = false;
	        var extend = _Vue.util.extend;
	        var aData = a.data = extend({}, a.data);
	        aData.on = on;
	        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
	        aAttrs.href = href;
	      } else {
	        // doesn't have <a> child, apply listener to self
	        data.on = on;
	      }
	    }
	
	    return h(this.tag, data, this.$slots.default)
	  }
	};
	
	function guardEvent (e) {
	  // don't redirect with control keys
	  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
	  // don't redirect when preventDefault called
	  if (e.defaultPrevented) { return }
	  // don't redirect on right click
	  if (e.button !== undefined && e.button !== 0) { return }
	  // don't redirect if `target="_blank"`
	  if (e.currentTarget && e.currentTarget.getAttribute) {
	    var target = e.currentTarget.getAttribute('target');
	    if (/\b_blank\b/i.test(target)) { return }
	  }
	  // this may be a Weex event which doesn't have this method
	  if (e.preventDefault) {
	    e.preventDefault();
	  }
	  return true
	}
	
	function findAnchor (children) {
	  if (children) {
	    var child;
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      if (child.tag === 'a') {
	        return child
	      }
	      if (child.children && (child = findAnchor(child.children))) {
	        return child
	      }
	    }
	  }
	}
	
	var _Vue;
	
	function install (Vue) {
	  if (install.installed && _Vue === Vue) { return }
	  install.installed = true;
	
	  _Vue = Vue;
	
	  var isDef = function (v) { return v !== undefined; };
	
	  var registerInstance = function (vm, callVal) {
	    var i = vm.$options._parentVnode;
	    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
	      i(vm, callVal);
	    }
	  };
	
	  Vue.mixin({
	    beforeCreate: function beforeCreate () {
	      if (isDef(this.$options.router)) {
	        this._routerRoot = this;
	        this._router = this.$options.router;
	        this._router.init(this);
	        Vue.util.defineReactive(this, '_route', this._router.history.current);
	      } else {
	        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
	      }
	      registerInstance(this, this);
	    },
	    destroyed: function destroyed () {
	      registerInstance(this);
	    }
	  });
	
	  Object.defineProperty(Vue.prototype, '$router', {
	    get: function get () { return this._routerRoot._router }
	  });
	
	  Object.defineProperty(Vue.prototype, '$route', {
	    get: function get () { return this._routerRoot._route }
	  });
	
	  Vue.component('router-view', View);
	  Vue.component('router-link', Link);
	
	  var strats = Vue.config.optionMergeStrategies;
	  // use the same hook merging strategy for route hooks
	  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
	}
	
	/*  */
	
	var inBrowser = typeof window !== 'undefined';
	
	/*  */
	
	function resolvePath (
	  relative,
	  base,
	  append
	) {
	  var firstChar = relative.charAt(0);
	  if (firstChar === '/') {
	    return relative
	  }
	
	  if (firstChar === '?' || firstChar === '#') {
	    return base + relative
	  }
	
	  var stack = base.split('/');
	
	  // remove trailing segment if:
	  // - not appending
	  // - appending to trailing slash (last segment is empty)
	  if (!append || !stack[stack.length - 1]) {
	    stack.pop();
	  }
	
	  // resolve relative path
	  var segments = relative.replace(/^\//, '').split('/');
	  for (var i = 0; i < segments.length; i++) {
	    var segment = segments[i];
	    if (segment === '..') {
	      stack.pop();
	    } else if (segment !== '.') {
	      stack.push(segment);
	    }
	  }
	
	  // ensure leading slash
	  if (stack[0] !== '') {
	    stack.unshift('');
	  }
	
	  return stack.join('/')
	}
	
	function parsePath (path) {
	  var hash = '';
	  var query = '';
	
	  var hashIndex = path.indexOf('#');
	  if (hashIndex >= 0) {
	    hash = path.slice(hashIndex);
	    path = path.slice(0, hashIndex);
	  }
	
	  var queryIndex = path.indexOf('?');
	  if (queryIndex >= 0) {
	    query = path.slice(queryIndex + 1);
	    path = path.slice(0, queryIndex);
	  }
	
	  return {
	    path: path,
	    query: query,
	    hash: hash
	  }
	}
	
	function cleanPath (path) {
	  return path.replace(/\/\//g, '/')
	}
	
	var isarray = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};
	
	/**
	 * Expose `pathToRegexp`.
	 */
	var pathToRegexp_1 = pathToRegexp;
	var parse_1 = parse;
	var compile_1 = compile;
	var tokensToFunction_1 = tokensToFunction;
	var tokensToRegExp_1 = tokensToRegExp;
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g');
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = [];
	  var key = 0;
	  var index = 0;
	  var path = '';
	  var defaultDelimiter = options && options.delimiter || '/';
	  var res;
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0];
	    var escaped = res[1];
	    var offset = res.index;
	    path += str.slice(index, offset);
	    index = offset + m.length;
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1];
	      continue
	    }
	
	    var next = str[index];
	    var prefix = res[2];
	    var name = res[3];
	    var capture = res[4];
	    var group = res[5];
	    var modifier = res[6];
	    var asterisk = res[7];
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path);
	      path = '';
	    }
	
	    var partial = prefix != null && next != null && next !== prefix;
	    var repeat = modifier === '+' || modifier === '*';
	    var optional = modifier === '?' || modifier === '*';
	    var delimiter = res[2] || defaultDelimiter;
	    var pattern = capture || group;
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    });
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index);
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path);
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options))
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length);
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
	    }
	  }
	
	  return function (obj, opts) {
	    var path = '';
	    var data = obj || {};
	    var options = opts || {};
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i];
	
	      if (typeof token === 'string') {
	        path += token;
	
	        continue
	      }
	
	      var value = data[token.name];
	      var segment;
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix;
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j]);
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment;
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value);
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment;
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys;
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g);
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      });
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = [];
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source);
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options);
	    keys = [];
	  }
	
	  options = options || {};
	
	  var strict = options.strict;
	  var end = options.end !== false;
	  var route = '';
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i];
	
	    if (typeof token === 'string') {
	      route += escapeString(token);
	    } else {
	      var prefix = escapeString(token.prefix);
	      var capture = '(?:' + token.pattern + ')';
	
	      keys.push(token);
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*';
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?';
	        } else {
	          capture = prefix + '(' + capture + ')?';
	        }
	      } else {
	        capture = prefix + '(' + capture + ')';
	      }
	
	      route += capture;
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/');
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
	  }
	
	  if (end) {
	    route += '$';
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options);
	    keys = [];
	  }
	
	  options = options || {};
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}
	
	pathToRegexp_1.parse = parse_1;
	pathToRegexp_1.compile = compile_1;
	pathToRegexp_1.tokensToFunction = tokensToFunction_1;
	pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;
	
	/*  */
	
	// $flow-disable-line
	var regexpCompileCache = Object.create(null);
	
	function fillParams (
	  path,
	  params,
	  routeMsg
	) {
	  try {
	    var filler =
	      regexpCompileCache[path] ||
	      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
	    return filler(params || {}, { pretty: true })
	  } catch (e) {
	    if (false) {
	      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
	    }
	    return ''
	  }
	}
	
	/*  */
	
	function createRouteMap (
	  routes,
	  oldPathList,
	  oldPathMap,
	  oldNameMap
	) {
	  // the path list is used to control path matching priority
	  var pathList = oldPathList || [];
	  // $flow-disable-line
	  var pathMap = oldPathMap || Object.create(null);
	  // $flow-disable-line
	  var nameMap = oldNameMap || Object.create(null);
	
	  routes.forEach(function (route) {
	    addRouteRecord(pathList, pathMap, nameMap, route);
	  });
	
	  // ensure wildcard routes are always at the end
	  for (var i = 0, l = pathList.length; i < l; i++) {
	    if (pathList[i] === '*') {
	      pathList.push(pathList.splice(i, 1)[0]);
	      l--;
	      i--;
	    }
	  }
	
	  return {
	    pathList: pathList,
	    pathMap: pathMap,
	    nameMap: nameMap
	  }
	}
	
	function addRouteRecord (
	  pathList,
	  pathMap,
	  nameMap,
	  route,
	  parent,
	  matchAs
	) {
	  var path = route.path;
	  var name = route.name;
	  if (false) {
	    assert(path != null, "\"path\" is required in a route configuration.");
	    assert(
	      typeof route.component !== 'string',
	      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
	      "string id. Use an actual component instead."
	    );
	  }
	
	  var pathToRegexpOptions = route.pathToRegexpOptions || {};
	  var normalizedPath = normalizePath(
	    path,
	    parent,
	    pathToRegexpOptions.strict
	  );
	
	  if (typeof route.caseSensitive === 'boolean') {
	    pathToRegexpOptions.sensitive = route.caseSensitive;
	  }
	
	  var record = {
	    path: normalizedPath,
	    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
	    components: route.components || { default: route.component },
	    instances: {},
	    name: name,
	    parent: parent,
	    matchAs: matchAs,
	    redirect: route.redirect,
	    beforeEnter: route.beforeEnter,
	    meta: route.meta || {},
	    props: route.props == null
	      ? {}
	      : route.components
	        ? route.props
	        : { default: route.props }
	  };
	
	  if (route.children) {
	    // Warn if route is named, does not redirect and has a default child route.
	    // If users navigate to this route by name, the default child will
	    // not be rendered (GH Issue #629)
	    if (false) {
	      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
	        warn(
	          false,
	          "Named Route '" + (route.name) + "' has a default child route. " +
	          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
	          "the default child route will not be rendered. Remove the name from " +
	          "this route and use the name of the default child route for named " +
	          "links instead."
	        );
	      }
	    }
	    route.children.forEach(function (child) {
	      var childMatchAs = matchAs
	        ? cleanPath((matchAs + "/" + (child.path)))
	        : undefined;
	      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
	    });
	  }
	
	  if (route.alias !== undefined) {
	    var aliases = Array.isArray(route.alias)
	      ? route.alias
	      : [route.alias];
	
	    aliases.forEach(function (alias) {
	      var aliasRoute = {
	        path: alias,
	        children: route.children
	      };
	      addRouteRecord(
	        pathList,
	        pathMap,
	        nameMap,
	        aliasRoute,
	        parent,
	        record.path || '/' // matchAs
	      );
	    });
	  }
	
	  if (!pathMap[record.path]) {
	    pathList.push(record.path);
	    pathMap[record.path] = record;
	  }
	
	  if (name) {
	    if (!nameMap[name]) {
	      nameMap[name] = record;
	    } else if (false) {
	      warn(
	        false,
	        "Duplicate named routes definition: " +
	        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
	      );
	    }
	  }
	}
	
	function compileRouteRegex (path, pathToRegexpOptions) {
	  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
	  if (false) {
	    var keys = Object.create(null);
	    regex.keys.forEach(function (key) {
	      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
	      keys[key.name] = true;
	    });
	  }
	  return regex
	}
	
	function normalizePath (path, parent, strict) {
	  if (!strict) { path = path.replace(/\/$/, ''); }
	  if (path[0] === '/') { return path }
	  if (parent == null) { return path }
	  return cleanPath(((parent.path) + "/" + path))
	}
	
	/*  */
	
	
	function normalizeLocation (
	  raw,
	  current,
	  append,
	  router
	) {
	  var next = typeof raw === 'string' ? { path: raw } : raw;
	  // named target
	  if (next.name || next._normalized) {
	    return next
	  }
	
	  // relative params
	  if (!next.path && next.params && current) {
	    next = assign({}, next);
	    next._normalized = true;
	    var params = assign(assign({}, current.params), next.params);
	    if (current.name) {
	      next.name = current.name;
	      next.params = params;
	    } else if (current.matched.length) {
	      var rawPath = current.matched[current.matched.length - 1].path;
	      next.path = fillParams(rawPath, params, ("path " + (current.path)));
	    } else if (false) {
	      warn(false, "relative params navigation requires a current route.");
	    }
	    return next
	  }
	
	  var parsedPath = parsePath(next.path || '');
	  var basePath = (current && current.path) || '/';
	  var path = parsedPath.path
	    ? resolvePath(parsedPath.path, basePath, append || next.append)
	    : basePath;
	
	  var query = resolveQuery(
	    parsedPath.query,
	    next.query,
	    router && router.options.parseQuery
	  );
	
	  var hash = next.hash || parsedPath.hash;
	  if (hash && hash.charAt(0) !== '#') {
	    hash = "#" + hash;
	  }
	
	  return {
	    _normalized: true,
	    path: path,
	    query: query,
	    hash: hash
	  }
	}
	
	function assign (a, b) {
	  for (var key in b) {
	    a[key] = b[key];
	  }
	  return a
	}
	
	/*  */
	
	
	function createMatcher (
	  routes,
	  router
	) {
	  var ref = createRouteMap(routes);
	  var pathList = ref.pathList;
	  var pathMap = ref.pathMap;
	  var nameMap = ref.nameMap;
	
	  function addRoutes (routes) {
	    createRouteMap(routes, pathList, pathMap, nameMap);
	  }
	
	  function match (
	    raw,
	    currentRoute,
	    redirectedFrom
	  ) {
	    var location = normalizeLocation(raw, currentRoute, false, router);
	    var name = location.name;
	
	    if (name) {
	      var record = nameMap[name];
	      if (false) {
	        warn(record, ("Route with name '" + name + "' does not exist"));
	      }
	      if (!record) { return _createRoute(null, location) }
	      var paramNames = record.regex.keys
	        .filter(function (key) { return !key.optional; })
	        .map(function (key) { return key.name; });
	
	      if (typeof location.params !== 'object') {
	        location.params = {};
	      }
	
	      if (currentRoute && typeof currentRoute.params === 'object') {
	        for (var key in currentRoute.params) {
	          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
	            location.params[key] = currentRoute.params[key];
	          }
	        }
	      }
	
	      if (record) {
	        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
	        return _createRoute(record, location, redirectedFrom)
	      }
	    } else if (location.path) {
	      location.params = {};
	      for (var i = 0; i < pathList.length; i++) {
	        var path = pathList[i];
	        var record$1 = pathMap[path];
	        if (matchRoute(record$1.regex, location.path, location.params)) {
	          return _createRoute(record$1, location, redirectedFrom)
	        }
	      }
	    }
	    // no match
	    return _createRoute(null, location)
	  }
	
	  function redirect (
	    record,
	    location
	  ) {
	    var originalRedirect = record.redirect;
	    var redirect = typeof originalRedirect === 'function'
	        ? originalRedirect(createRoute(record, location, null, router))
	        : originalRedirect;
	
	    if (typeof redirect === 'string') {
	      redirect = { path: redirect };
	    }
	
	    if (!redirect || typeof redirect !== 'object') {
	      if (false) {
	        warn(
	          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
	        );
	      }
	      return _createRoute(null, location)
	    }
	
	    var re = redirect;
	    var name = re.name;
	    var path = re.path;
	    var query = location.query;
	    var hash = location.hash;
	    var params = location.params;
	    query = re.hasOwnProperty('query') ? re.query : query;
	    hash = re.hasOwnProperty('hash') ? re.hash : hash;
	    params = re.hasOwnProperty('params') ? re.params : params;
	
	    if (name) {
	      // resolved named direct
	      var targetRecord = nameMap[name];
	      if (false) {
	        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
	      }
	      return match({
	        _normalized: true,
	        name: name,
	        query: query,
	        hash: hash,
	        params: params
	      }, undefined, location)
	    } else if (path) {
	      // 1. resolve relative redirect
	      var rawPath = resolveRecordPath(path, record);
	      // 2. resolve params
	      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
	      // 3. rematch with existing query and hash
	      return match({
	        _normalized: true,
	        path: resolvedPath,
	        query: query,
	        hash: hash
	      }, undefined, location)
	    } else {
	      if (false) {
	        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
	      }
	      return _createRoute(null, location)
	    }
	  }
	
	  function alias (
	    record,
	    location,
	    matchAs
	  ) {
	    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
	    var aliasedMatch = match({
	      _normalized: true,
	      path: aliasedPath
	    });
	    if (aliasedMatch) {
	      var matched = aliasedMatch.matched;
	      var aliasedRecord = matched[matched.length - 1];
	      location.params = aliasedMatch.params;
	      return _createRoute(aliasedRecord, location)
	    }
	    return _createRoute(null, location)
	  }
	
	  function _createRoute (
	    record,
	    location,
	    redirectedFrom
	  ) {
	    if (record && record.redirect) {
	      return redirect(record, redirectedFrom || location)
	    }
	    if (record && record.matchAs) {
	      return alias(record, location, record.matchAs)
	    }
	    return createRoute(record, location, redirectedFrom, router)
	  }
	
	  return {
	    match: match,
	    addRoutes: addRoutes
	  }
	}
	
	function matchRoute (
	  regex,
	  path,
	  params
	) {
	  var m = path.match(regex);
	
	  if (!m) {
	    return false
	  } else if (!params) {
	    return true
	  }
	
	  for (var i = 1, len = m.length; i < len; ++i) {
	    var key = regex.keys[i - 1];
	    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
	    if (key) {
	      params[key.name] = val;
	    }
	  }
	
	  return true
	}
	
	function resolveRecordPath (path, record) {
	  return resolvePath(path, record.parent ? record.parent.path : '/', true)
	}
	
	/*  */
	
	
	var positionStore = Object.create(null);
	
	function setupScroll () {
	  // Fix for #1585 for Firefox
	  window.history.replaceState({ key: getStateKey() }, '');
	  window.addEventListener('popstate', function (e) {
	    saveScrollPosition();
	    if (e.state && e.state.key) {
	      setStateKey(e.state.key);
	    }
	  });
	}
	
	function handleScroll (
	  router,
	  to,
	  from,
	  isPop
	) {
	  if (!router.app) {
	    return
	  }
	
	  var behavior = router.options.scrollBehavior;
	  if (!behavior) {
	    return
	  }
	
	  if (false) {
	    assert(typeof behavior === 'function', "scrollBehavior must be a function");
	  }
	
	  // wait until re-render finishes before scrolling
	  router.app.$nextTick(function () {
	    var position = getScrollPosition();
	    var shouldScroll = behavior(to, from, isPop ? position : null);
	
	    if (!shouldScroll) {
	      return
	    }
	
	    if (typeof shouldScroll.then === 'function') {
	      shouldScroll.then(function (shouldScroll) {
	        scrollToPosition((shouldScroll), position);
	      }).catch(function (err) {
	        if (false) {
	          assert(false, err.toString());
	        }
	      });
	    } else {
	      scrollToPosition(shouldScroll, position);
	    }
	  });
	}
	
	function saveScrollPosition () {
	  var key = getStateKey();
	  if (key) {
	    positionStore[key] = {
	      x: window.pageXOffset,
	      y: window.pageYOffset
	    };
	  }
	}
	
	function getScrollPosition () {
	  var key = getStateKey();
	  if (key) {
	    return positionStore[key]
	  }
	}
	
	function getElementPosition (el, offset) {
	  var docEl = document.documentElement;
	  var docRect = docEl.getBoundingClientRect();
	  var elRect = el.getBoundingClientRect();
	  return {
	    x: elRect.left - docRect.left - offset.x,
	    y: elRect.top - docRect.top - offset.y
	  }
	}
	
	function isValidPosition (obj) {
	  return isNumber(obj.x) || isNumber(obj.y)
	}
	
	function normalizePosition (obj) {
	  return {
	    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
	    y: isNumber(obj.y) ? obj.y : window.pageYOffset
	  }
	}
	
	function normalizeOffset (obj) {
	  return {
	    x: isNumber(obj.x) ? obj.x : 0,
	    y: isNumber(obj.y) ? obj.y : 0
	  }
	}
	
	function isNumber (v) {
	  return typeof v === 'number'
	}
	
	function scrollToPosition (shouldScroll, position) {
	  var isObject = typeof shouldScroll === 'object';
	  if (isObject && typeof shouldScroll.selector === 'string') {
	    var el = document.querySelector(shouldScroll.selector);
	    if (el) {
	      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
	      offset = normalizeOffset(offset);
	      position = getElementPosition(el, offset);
	    } else if (isValidPosition(shouldScroll)) {
	      position = normalizePosition(shouldScroll);
	    }
	  } else if (isObject && isValidPosition(shouldScroll)) {
	    position = normalizePosition(shouldScroll);
	  }
	
	  if (position) {
	    window.scrollTo(position.x, position.y);
	  }
	}
	
	/*  */
	
	var supportsPushState = inBrowser && (function () {
	  var ua = window.navigator.userAgent;
	
	  if (
	    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
	    ua.indexOf('Mobile Safari') !== -1 &&
	    ua.indexOf('Chrome') === -1 &&
	    ua.indexOf('Windows Phone') === -1
	  ) {
	    return false
	  }
	
	  return window.history && 'pushState' in window.history
	})();
	
	// use User Timing api (if present) for more accurate key precision
	var Time = inBrowser && window.performance && window.performance.now
	  ? window.performance
	  : Date;
	
	var _key = genKey();
	
	function genKey () {
	  return Time.now().toFixed(3)
	}
	
	function getStateKey () {
	  return _key
	}
	
	function setStateKey (key) {
	  _key = key;
	}
	
	function pushState (url, replace) {
	  saveScrollPosition();
	  // try...catch the pushState call to get around Safari
	  // DOM Exception 18 where it limits to 100 pushState calls
	  var history = window.history;
	  try {
	    if (replace) {
	      history.replaceState({ key: _key }, '', url);
	    } else {
	      _key = genKey();
	      history.pushState({ key: _key }, '', url);
	    }
	  } catch (e) {
	    window.location[replace ? 'replace' : 'assign'](url);
	  }
	}
	
	function replaceState (url) {
	  pushState(url, true);
	}
	
	/*  */
	
	function runQueue (queue, fn, cb) {
	  var step = function (index) {
	    if (index >= queue.length) {
	      cb();
	    } else {
	      if (queue[index]) {
	        fn(queue[index], function () {
	          step(index + 1);
	        });
	      } else {
	        step(index + 1);
	      }
	    }
	  };
	  step(0);
	}
	
	/*  */
	
	function resolveAsyncComponents (matched) {
	  return function (to, from, next) {
	    var hasAsync = false;
	    var pending = 0;
	    var error = null;
	
	    flatMapComponents(matched, function (def, _, match, key) {
	      // if it's a function and doesn't have cid attached,
	      // assume it's an async component resolve function.
	      // we are not using Vue's default async resolving mechanism because
	      // we want to halt the navigation until the incoming component has been
	      // resolved.
	      if (typeof def === 'function' && def.cid === undefined) {
	        hasAsync = true;
	        pending++;
	
	        var resolve = once(function (resolvedDef) {
	          if (isESModule(resolvedDef)) {
	            resolvedDef = resolvedDef.default;
	          }
	          // save resolved on async factory in case it's used elsewhere
	          def.resolved = typeof resolvedDef === 'function'
	            ? resolvedDef
	            : _Vue.extend(resolvedDef);
	          match.components[key] = resolvedDef;
	          pending--;
	          if (pending <= 0) {
	            next();
	          }
	        });
	
	        var reject = once(function (reason) {
	          var msg = "Failed to resolve async component " + key + ": " + reason;
	          ("production") !== 'production' && warn(false, msg);
	          if (!error) {
	            error = isError(reason)
	              ? reason
	              : new Error(msg);
	            next(error);
	          }
	        });
	
	        var res;
	        try {
	          res = def(resolve, reject);
	        } catch (e) {
	          reject(e);
	        }
	        if (res) {
	          if (typeof res.then === 'function') {
	            res.then(resolve, reject);
	          } else {
	            // new syntax in Vue 2.3
	            var comp = res.component;
	            if (comp && typeof comp.then === 'function') {
	              comp.then(resolve, reject);
	            }
	          }
	        }
	      }
	    });
	
	    if (!hasAsync) { next(); }
	  }
	}
	
	function flatMapComponents (
	  matched,
	  fn
	) {
	  return flatten(matched.map(function (m) {
	    return Object.keys(m.components).map(function (key) { return fn(
	      m.components[key],
	      m.instances[key],
	      m, key
	    ); })
	  }))
	}
	
	function flatten (arr) {
	  return Array.prototype.concat.apply([], arr)
	}
	
	var hasSymbol =
	  typeof Symbol === 'function' &&
	  typeof Symbol.toStringTag === 'symbol';
	
	function isESModule (obj) {
	  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
	}
	
	// in Webpack 2, require.ensure now also returns a Promise
	// so the resolve/reject functions may get called an extra time
	// if the user uses an arrow function shorthand that happens to
	// return that Promise.
	function once (fn) {
	  var called = false;
	  return function () {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];
	
	    if (called) { return }
	    called = true;
	    return fn.apply(this, args)
	  }
	}
	
	/*  */
	
	var History = function History (router, base) {
	  this.router = router;
	  this.base = normalizeBase(base);
	  // start with a route object that stands for "nowhere"
	  this.current = START;
	  this.pending = null;
	  this.ready = false;
	  this.readyCbs = [];
	  this.readyErrorCbs = [];
	  this.errorCbs = [];
	};
	
	History.prototype.listen = function listen (cb) {
	  this.cb = cb;
	};
	
	History.prototype.onReady = function onReady (cb, errorCb) {
	  if (this.ready) {
	    cb();
	  } else {
	    this.readyCbs.push(cb);
	    if (errorCb) {
	      this.readyErrorCbs.push(errorCb);
	    }
	  }
	};
	
	History.prototype.onError = function onError (errorCb) {
	  this.errorCbs.push(errorCb);
	};
	
	History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
	    var this$1 = this;
	
	  var route = this.router.match(location, this.current);
	  this.confirmTransition(route, function () {
	    this$1.updateRoute(route);
	    onComplete && onComplete(route);
	    this$1.ensureURL();
	
	    // fire ready cbs once
	    if (!this$1.ready) {
	      this$1.ready = true;
	      this$1.readyCbs.forEach(function (cb) { cb(route); });
	    }
	  }, function (err) {
	    if (onAbort) {
	      onAbort(err);
	    }
	    if (err && !this$1.ready) {
	      this$1.ready = true;
	      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
	    }
	  });
	};
	
	History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
	    var this$1 = this;
	
	  var current = this.current;
	  var abort = function (err) {
	    if (isError(err)) {
	      if (this$1.errorCbs.length) {
	        this$1.errorCbs.forEach(function (cb) { cb(err); });
	      } else {
	        warn(false, 'uncaught error during route navigation:');
	        console.error(err);
	      }
	    }
	    onAbort && onAbort(err);
	  };
	  if (
	    isSameRoute(route, current) &&
	    // in the case the route map has been dynamically appended to
	    route.matched.length === current.matched.length
	  ) {
	    this.ensureURL();
	    return abort()
	  }
	
	  var ref = resolveQueue(this.current.matched, route.matched);
	    var updated = ref.updated;
	    var deactivated = ref.deactivated;
	    var activated = ref.activated;
	
	  var queue = [].concat(
	    // in-component leave guards
	    extractLeaveGuards(deactivated),
	    // global before hooks
	    this.router.beforeHooks,
	    // in-component update hooks
	    extractUpdateHooks(updated),
	    // in-config enter guards
	    activated.map(function (m) { return m.beforeEnter; }),
	    // async components
	    resolveAsyncComponents(activated)
	  );
	
	  this.pending = route;
	  var iterator = function (hook, next) {
	    if (this$1.pending !== route) {
	      return abort()
	    }
	    try {
	      hook(route, current, function (to) {
	        if (to === false || isError(to)) {
	          // next(false) -> abort navigation, ensure current URL
	          this$1.ensureURL(true);
	          abort(to);
	        } else if (
	          typeof to === 'string' ||
	          (typeof to === 'object' && (
	            typeof to.path === 'string' ||
	            typeof to.name === 'string'
	          ))
	        ) {
	          // next('/') or next({ path: '/' }) -> redirect
	          abort();
	          if (typeof to === 'object' && to.replace) {
	            this$1.replace(to);
	          } else {
	            this$1.push(to);
	          }
	        } else {
	          // confirm transition and pass on the value
	          next(to);
	        }
	      });
	    } catch (e) {
	      abort(e);
	    }
	  };
	
	  runQueue(queue, iterator, function () {
	    var postEnterCbs = [];
	    var isValid = function () { return this$1.current === route; };
	    // wait until async components are resolved before
	    // extracting in-component enter guards
	    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
	    var queue = enterGuards.concat(this$1.router.resolveHooks);
	    runQueue(queue, iterator, function () {
	      if (this$1.pending !== route) {
	        return abort()
	      }
	      this$1.pending = null;
	      onComplete(route);
	      if (this$1.router.app) {
	        this$1.router.app.$nextTick(function () {
	          postEnterCbs.forEach(function (cb) { cb(); });
	        });
	      }
	    });
	  });
	};
	
	History.prototype.updateRoute = function updateRoute (route) {
	  var prev = this.current;
	  this.current = route;
	  this.cb && this.cb(route);
	  this.router.afterHooks.forEach(function (hook) {
	    hook && hook(route, prev);
	  });
	};
	
	function normalizeBase (base) {
	  if (!base) {
	    if (inBrowser) {
	      // respect <base> tag
	      var baseEl = document.querySelector('base');
	      base = (baseEl && baseEl.getAttribute('href')) || '/';
	      // strip full URL origin
	      base = base.replace(/^https?:\/\/[^\/]+/, '');
	    } else {
	      base = '/';
	    }
	  }
	  // make sure there's the starting slash
	  if (base.charAt(0) !== '/') {
	    base = '/' + base;
	  }
	  // remove trailing slash
	  return base.replace(/\/$/, '')
	}
	
	function resolveQueue (
	  current,
	  next
	) {
	  var i;
	  var max = Math.max(current.length, next.length);
	  for (i = 0; i < max; i++) {
	    if (current[i] !== next[i]) {
	      break
	    }
	  }
	  return {
	    updated: next.slice(0, i),
	    activated: next.slice(i),
	    deactivated: current.slice(i)
	  }
	}
	
	function extractGuards (
	  records,
	  name,
	  bind,
	  reverse
	) {
	  var guards = flatMapComponents(records, function (def, instance, match, key) {
	    var guard = extractGuard(def, name);
	    if (guard) {
	      return Array.isArray(guard)
	        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
	        : bind(guard, instance, match, key)
	    }
	  });
	  return flatten(reverse ? guards.reverse() : guards)
	}
	
	function extractGuard (
	  def,
	  key
	) {
	  if (typeof def !== 'function') {
	    // extend now so that global mixins are applied.
	    def = _Vue.extend(def);
	  }
	  return def.options[key]
	}
	
	function extractLeaveGuards (deactivated) {
	  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
	}
	
	function extractUpdateHooks (updated) {
	  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
	}
	
	function bindGuard (guard, instance) {
	  if (instance) {
	    return function boundRouteGuard () {
	      return guard.apply(instance, arguments)
	    }
	  }
	}
	
	function extractEnterGuards (
	  activated,
	  cbs,
	  isValid
	) {
	  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
	    return bindEnterGuard(guard, match, key, cbs, isValid)
	  })
	}
	
	function bindEnterGuard (
	  guard,
	  match,
	  key,
	  cbs,
	  isValid
	) {
	  return function routeEnterGuard (to, from, next) {
	    return guard(to, from, function (cb) {
	      next(cb);
	      if (typeof cb === 'function') {
	        cbs.push(function () {
	          // #750
	          // if a router-view is wrapped with an out-in transition,
	          // the instance may not have been registered at this time.
	          // we will need to poll for registration until current route
	          // is no longer valid.
	          poll(cb, match.instances, key, isValid);
	        });
	      }
	    })
	  }
	}
	
	function poll (
	  cb, // somehow flow cannot infer this is a function
	  instances,
	  key,
	  isValid
	) {
	  if (instances[key]) {
	    cb(instances[key]);
	  } else if (isValid()) {
	    setTimeout(function () {
	      poll(cb, instances, key, isValid);
	    }, 16);
	  }
	}
	
	/*  */
	
	
	var HTML5History = (function (History$$1) {
	  function HTML5History (router, base) {
	    var this$1 = this;
	
	    History$$1.call(this, router, base);
	
	    var expectScroll = router.options.scrollBehavior;
	
	    if (expectScroll) {
	      setupScroll();
	    }
	
	    var initLocation = getLocation(this.base);
	    window.addEventListener('popstate', function (e) {
	      var current = this$1.current;
	
	      // Avoiding first `popstate` event dispatched in some browsers but first
	      // history route not updated since async guard at the same time.
	      var location = getLocation(this$1.base);
	      if (this$1.current === START && location === initLocation) {
	        return
	      }
	
	      this$1.transitionTo(location, function (route) {
	        if (expectScroll) {
	          handleScroll(router, route, current, true);
	        }
	      });
	    });
	  }
	
	  if ( History$$1 ) HTML5History.__proto__ = History$$1;
	  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
	  HTML5History.prototype.constructor = HTML5History;
	
	  HTML5History.prototype.go = function go (n) {
	    window.history.go(n);
	  };
	
	  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    var ref = this;
	    var fromRoute = ref.current;
	    this.transitionTo(location, function (route) {
	      pushState(cleanPath(this$1.base + route.fullPath));
	      handleScroll(this$1.router, route, fromRoute, false);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    var ref = this;
	    var fromRoute = ref.current;
	    this.transitionTo(location, function (route) {
	      replaceState(cleanPath(this$1.base + route.fullPath));
	      handleScroll(this$1.router, route, fromRoute, false);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  HTML5History.prototype.ensureURL = function ensureURL (push) {
	    if (getLocation(this.base) !== this.current.fullPath) {
	      var current = cleanPath(this.base + this.current.fullPath);
	      push ? pushState(current) : replaceState(current);
	    }
	  };
	
	  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
	    return getLocation(this.base)
	  };
	
	  return HTML5History;
	}(History));
	
	function getLocation (base) {
	  var path = window.location.pathname;
	  if (base && path.indexOf(base) === 0) {
	    path = path.slice(base.length);
	  }
	  return (path || '/') + window.location.search + window.location.hash
	}
	
	/*  */
	
	
	var HashHistory = (function (History$$1) {
	  function HashHistory (router, base, fallback) {
	    History$$1.call(this, router, base);
	    // check history fallback deeplinking
	    if (fallback && checkFallback(this.base)) {
	      return
	    }
	    ensureSlash();
	  }
	
	  if ( History$$1 ) HashHistory.__proto__ = History$$1;
	  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
	  HashHistory.prototype.constructor = HashHistory;
	
	  // this is delayed until the app mounts
	  // to avoid the hashchange listener being fired too early
	  HashHistory.prototype.setupListeners = function setupListeners () {
	    var this$1 = this;
	
	    var router = this.router;
	    var expectScroll = router.options.scrollBehavior;
	    var supportsScroll = supportsPushState && expectScroll;
	
	    if (supportsScroll) {
	      setupScroll();
	    }
	
	    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
	      var current = this$1.current;
	      if (!ensureSlash()) {
	        return
	      }
	      this$1.transitionTo(getHash(), function (route) {
	        if (supportsScroll) {
	          handleScroll(this$1.router, route, current, true);
	        }
	        if (!supportsPushState) {
	          replaceHash(route.fullPath);
	        }
	      });
	    });
	  };
	
	  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    var ref = this;
	    var fromRoute = ref.current;
	    this.transitionTo(location, function (route) {
	      pushHash(route.fullPath);
	      handleScroll(this$1.router, route, fromRoute, false);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    var ref = this;
	    var fromRoute = ref.current;
	    this.transitionTo(location, function (route) {
	      replaceHash(route.fullPath);
	      handleScroll(this$1.router, route, fromRoute, false);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  HashHistory.prototype.go = function go (n) {
	    window.history.go(n);
	  };
	
	  HashHistory.prototype.ensureURL = function ensureURL (push) {
	    var current = this.current.fullPath;
	    if (getHash() !== current) {
	      push ? pushHash(current) : replaceHash(current);
	    }
	  };
	
	  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
	    return getHash()
	  };
	
	  return HashHistory;
	}(History));
	
	function checkFallback (base) {
	  var location = getLocation(base);
	  if (!/^\/#/.test(location)) {
	    window.location.replace(
	      cleanPath(base + '/#' + location)
	    );
	    return true
	  }
	}
	
	function ensureSlash () {
	  var path = getHash();
	  if (path.charAt(0) === '/') {
	    return true
	  }
	  replaceHash('/' + path);
	  return false
	}
	
	function getHash () {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var index = href.indexOf('#');
	  return index === -1 ? '' : href.slice(index + 1)
	}
	
	function getUrl (path) {
	  var href = window.location.href;
	  var i = href.indexOf('#');
	  var base = i >= 0 ? href.slice(0, i) : href;
	  return (base + "#" + path)
	}
	
	function pushHash (path) {
	  if (supportsPushState) {
	    pushState(getUrl(path));
	  } else {
	    window.location.hash = path;
	  }
	}
	
	function replaceHash (path) {
	  if (supportsPushState) {
	    replaceState(getUrl(path));
	  } else {
	    window.location.replace(getUrl(path));
	  }
	}
	
	/*  */
	
	
	var AbstractHistory = (function (History$$1) {
	  function AbstractHistory (router, base) {
	    History$$1.call(this, router, base);
	    this.stack = [];
	    this.index = -1;
	  }
	
	  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
	  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
	  AbstractHistory.prototype.constructor = AbstractHistory;
	
	  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    this.transitionTo(location, function (route) {
	      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
	      this$1.index++;
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    this.transitionTo(location, function (route) {
	      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  AbstractHistory.prototype.go = function go (n) {
	    var this$1 = this;
	
	    var targetIndex = this.index + n;
	    if (targetIndex < 0 || targetIndex >= this.stack.length) {
	      return
	    }
	    var route = this.stack[targetIndex];
	    this.confirmTransition(route, function () {
	      this$1.index = targetIndex;
	      this$1.updateRoute(route);
	    });
	  };
	
	  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
	    var current = this.stack[this.stack.length - 1];
	    return current ? current.fullPath : '/'
	  };
	
	  AbstractHistory.prototype.ensureURL = function ensureURL () {
	    // noop
	  };
	
	  return AbstractHistory;
	}(History));
	
	/*  */
	
	var VueRouter = function VueRouter (options) {
	  if ( options === void 0 ) options = {};
	
	  this.app = null;
	  this.apps = [];
	  this.options = options;
	  this.beforeHooks = [];
	  this.resolveHooks = [];
	  this.afterHooks = [];
	  this.matcher = createMatcher(options.routes || [], this);
	
	  var mode = options.mode || 'hash';
	  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
	  if (this.fallback) {
	    mode = 'hash';
	  }
	  if (!inBrowser) {
	    mode = 'abstract';
	  }
	  this.mode = mode;
	
	  switch (mode) {
	    case 'history':
	      this.history = new HTML5History(this, options.base);
	      break
	    case 'hash':
	      this.history = new HashHistory(this, options.base, this.fallback);
	      break
	    case 'abstract':
	      this.history = new AbstractHistory(this, options.base);
	      break
	    default:
	      if (false) {
	        assert(false, ("invalid mode: " + mode));
	      }
	  }
	};
	
	var prototypeAccessors = { currentRoute: { configurable: true } };
	
	VueRouter.prototype.match = function match (
	  raw,
	  current,
	  redirectedFrom
	) {
	  return this.matcher.match(raw, current, redirectedFrom)
	};
	
	prototypeAccessors.currentRoute.get = function () {
	  return this.history && this.history.current
	};
	
	VueRouter.prototype.init = function init (app /* Vue component instance */) {
	    var this$1 = this;
	
	  ("production") !== 'production' && assert(
	    install.installed,
	    "not installed. Make sure to call `Vue.use(VueRouter)` " +
	    "before creating root instance."
	  );
	
	  this.apps.push(app);
	
	  // main app already initialized.
	  if (this.app) {
	    return
	  }
	
	  this.app = app;
	
	  var history = this.history;
	
	  if (history instanceof HTML5History) {
	    history.transitionTo(history.getCurrentLocation());
	  } else if (history instanceof HashHistory) {
	    var setupHashListener = function () {
	      history.setupListeners();
	    };
	    history.transitionTo(
	      history.getCurrentLocation(),
	      setupHashListener,
	      setupHashListener
	    );
	  }
	
	  history.listen(function (route) {
	    this$1.apps.forEach(function (app) {
	      app._route = route;
	    });
	  });
	};
	
	VueRouter.prototype.beforeEach = function beforeEach (fn) {
	  return registerHook(this.beforeHooks, fn)
	};
	
	VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
	  return registerHook(this.resolveHooks, fn)
	};
	
	VueRouter.prototype.afterEach = function afterEach (fn) {
	  return registerHook(this.afterHooks, fn)
	};
	
	VueRouter.prototype.onReady = function onReady (cb, errorCb) {
	  this.history.onReady(cb, errorCb);
	};
	
	VueRouter.prototype.onError = function onError (errorCb) {
	  this.history.onError(errorCb);
	};
	
	VueRouter.prototype.push = function push (location, onComplete, onAbort) {
	  this.history.push(location, onComplete, onAbort);
	};
	
	VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
	  this.history.replace(location, onComplete, onAbort);
	};
	
	VueRouter.prototype.go = function go (n) {
	  this.history.go(n);
	};
	
	VueRouter.prototype.back = function back () {
	  this.go(-1);
	};
	
	VueRouter.prototype.forward = function forward () {
	  this.go(1);
	};
	
	VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
	  var route = to
	    ? to.matched
	      ? to
	      : this.resolve(to).route
	    : this.currentRoute;
	  if (!route) {
	    return []
	  }
	  return [].concat.apply([], route.matched.map(function (m) {
	    return Object.keys(m.components).map(function (key) {
	      return m.components[key]
	    })
	  }))
	};
	
	VueRouter.prototype.resolve = function resolve (
	  to,
	  current,
	  append
	) {
	  var location = normalizeLocation(
	    to,
	    current || this.history.current,
	    append,
	    this
	  );
	  var route = this.match(location, current);
	  var fullPath = route.redirectedFrom || route.fullPath;
	  var base = this.history.base;
	  var href = createHref(base, fullPath, this.mode);
	  return {
	    location: location,
	    route: route,
	    href: href,
	    // for backwards compat
	    normalizedTo: location,
	    resolved: route
	  }
	};
	
	VueRouter.prototype.addRoutes = function addRoutes (routes) {
	  this.matcher.addRoutes(routes);
	  if (this.history.current !== START) {
	    this.history.transitionTo(this.history.getCurrentLocation());
	  }
	};
	
	Object.defineProperties( VueRouter.prototype, prototypeAccessors );
	
	function registerHook (list, fn) {
	  list.push(fn);
	  return function () {
	    var i = list.indexOf(fn);
	    if (i > -1) { list.splice(i, 1); }
	  }
	}
	
	function createHref (base, fullPath, mode) {
	  var path = mode === 'hash' ? '#' + fullPath : fullPath;
	  return base ? cleanPath(base + '/' + path) : path
	}
	
	VueRouter.install = install;
	VueRouter.version = '2.8.1';
	
	if (inBrowser && window.Vue) {
	  window.Vue.use(VueRouter);
	}
	
	module.exports = VueRouter;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(203), __esModule: true };

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(205), __esModule: true };

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(241);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(240);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 128 */,
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(2);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	/**
	 *  Rule for validating required fields.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param source The source object being validated.
	 *  @param errors An array of errors that this rule may add
	 *  validation errors to.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function required(rule, value, source, errors, options, type) {
	  if (rule.required && (!source.hasOwnProperty(rule.field) || util.isEmptyValue(value, type || rule.type))) {
	    errors.push(util.format(options.messages.required, rule.fullField));
	  }
	}
	
	exports['default'] = required;
	module.exports = exports['default'];

/***/ }),
/* 130 */
/***/ (function(module, exports) {

	var nestRE = /^(attrs|props|on|nativeOn|class|style|hook)$/
	
	module.exports = function mergeJSXProps (objs) {
	  return objs.reduce(function (a, b) {
	    var aa, bb, key, nestedKey, temp
	    for (key in b) {
	      aa = a[key]
	      bb = b[key]
	      if (aa && nestRE.test(key)) {
	        // normalize class
	        if (key === 'class') {
	          if (typeof aa === 'string') {
	            temp = aa
	            a[key] = aa = {}
	            aa[temp] = true
	          }
	          if (typeof bb === 'string') {
	            temp = bb
	            b[key] = bb = {}
	            bb[temp] = true
	          }
	        }
	        if (key === 'on' || key === 'nativeOn' || key === 'hook') {
	          // merge functions
	          for (nestedKey in bb) {
	            aa[nestedKey] = mergeFn(aa[nestedKey], bb[nestedKey])
	          }
	        } else if (Array.isArray(aa)) {
	          a[key] = aa.concat(bb)
	        } else if (Array.isArray(bb)) {
	          a[key] = [aa].concat(bb)
	        } else {
	          for (nestedKey in bb) {
	            aa[nestedKey] = bb[nestedKey]
	          }
	        }
	      } else {
	        a[key] = b[key]
	      }
	    }
	    return a
	  }, {})
	}
	
	function mergeFn (a, b) {
	  return function () {
	    a && a.apply(this, arguments)
	    b && b.apply(this, arguments)
	  }
	}


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(426);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),
/* 132 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(43);
	var document = __webpack_require__(19).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(25) && !__webpack_require__(42)(function () {
	  return Object.defineProperty(__webpack_require__(133)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(132);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(54);
	var $export = __webpack_require__(84);
	var redefine = __webpack_require__(140);
	var hide = __webpack_require__(29);
	var Iterators = __webpack_require__(85);
	var $iterCreate = __webpack_require__(439);
	var setToStringTag = __webpack_require__(87);
	var getPrototypeOf = __webpack_require__(446);
	var ITERATOR = __webpack_require__(32)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(53);
	var dPs = __webpack_require__(443);
	var enumBugKeys = __webpack_require__(83);
	var IE_PROTO = __webpack_require__(88)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(133)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(437).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(139);
	var hiddenKeys = __webpack_require__(83).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(26);
	var toIObject = __webpack_require__(31);
	var arrayIndexOf = __webpack_require__(434)(false);
	var IE_PROTO = __webpack_require__(88)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(29);


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 83);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 4:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(27);
	
	/***/ }),
	
	/***/ 83:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox.vue?vue&type=template&id=d0387074&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "label",
	    {
	      staticClass: "el-checkbox",
	      class: [
	        _vm.border && _vm.checkboxSize
	          ? "el-checkbox--" + _vm.checkboxSize
	          : "",
	        { "is-disabled": _vm.isDisabled },
	        { "is-bordered": _vm.border },
	        { "is-checked": _vm.isChecked }
	      ],
	      attrs: { id: _vm.id }
	    },
	    [
	      _c(
	        "span",
	        {
	          staticClass: "el-checkbox__input",
	          class: {
	            "is-disabled": _vm.isDisabled,
	            "is-checked": _vm.isChecked,
	            "is-indeterminate": _vm.indeterminate,
	            "is-focus": _vm.focus
	          },
	          attrs: {
	            tabindex: _vm.indeterminate ? 0 : false,
	            role: _vm.indeterminate ? "checkbox" : false,
	            "aria-checked": _vm.indeterminate ? "mixed" : false
	          }
	        },
	        [
	          _c("span", { staticClass: "el-checkbox__inner" }),
	          _vm.trueLabel || _vm.falseLabel
	            ? _c("input", {
	                directives: [
	                  {
	                    name: "model",
	                    rawName: "v-model",
	                    value: _vm.model,
	                    expression: "model"
	                  }
	                ],
	                staticClass: "el-checkbox__original",
	                attrs: {
	                  type: "checkbox",
	                  "aria-hidden": _vm.indeterminate ? "true" : "false",
	                  name: _vm.name,
	                  disabled: _vm.isDisabled,
	                  "true-value": _vm.trueLabel,
	                  "false-value": _vm.falseLabel
	                },
	                domProps: {
	                  checked: Array.isArray(_vm.model)
	                    ? _vm._i(_vm.model, null) > -1
	                    : _vm._q(_vm.model, _vm.trueLabel)
	                },
	                on: {
	                  change: [
	                    function($event) {
	                      var $$a = _vm.model,
	                        $$el = $event.target,
	                        $$c = $$el.checked ? _vm.trueLabel : _vm.falseLabel
	                      if (Array.isArray($$a)) {
	                        var $$v = null,
	                          $$i = _vm._i($$a, $$v)
	                        if ($$el.checked) {
	                          $$i < 0 && (_vm.model = $$a.concat([$$v]))
	                        } else {
	                          $$i > -1 &&
	                            (_vm.model = $$a
	                              .slice(0, $$i)
	                              .concat($$a.slice($$i + 1)))
	                        }
	                      } else {
	                        _vm.model = $$c
	                      }
	                    },
	                    _vm.handleChange
	                  ],
	                  focus: function($event) {
	                    _vm.focus = true
	                  },
	                  blur: function($event) {
	                    _vm.focus = false
	                  }
	                }
	              })
	            : _c("input", {
	                directives: [
	                  {
	                    name: "model",
	                    rawName: "v-model",
	                    value: _vm.model,
	                    expression: "model"
	                  }
	                ],
	                staticClass: "el-checkbox__original",
	                attrs: {
	                  type: "checkbox",
	                  "aria-hidden": _vm.indeterminate ? "true" : "false",
	                  disabled: _vm.isDisabled,
	                  name: _vm.name
	                },
	                domProps: {
	                  value: _vm.label,
	                  checked: Array.isArray(_vm.model)
	                    ? _vm._i(_vm.model, _vm.label) > -1
	                    : _vm.model
	                },
	                on: {
	                  change: [
	                    function($event) {
	                      var $$a = _vm.model,
	                        $$el = $event.target,
	                        $$c = $$el.checked ? true : false
	                      if (Array.isArray($$a)) {
	                        var $$v = _vm.label,
	                          $$i = _vm._i($$a, $$v)
	                        if ($$el.checked) {
	                          $$i < 0 && (_vm.model = $$a.concat([$$v]))
	                        } else {
	                          $$i > -1 &&
	                            (_vm.model = $$a
	                              .slice(0, $$i)
	                              .concat($$a.slice($$i + 1)))
	                        }
	                      } else {
	                        _vm.model = $$c
	                      }
	                    },
	                    _vm.handleChange
	                  ],
	                  focus: function($event) {
	                    _vm.focus = true
	                  },
	                  blur: function($event) {
	                    _vm.focus = false
	                  }
	                }
	              })
	        ]
	      ),
	      _vm.$slots.default || _vm.label
	        ? _c(
	            "span",
	            { staticClass: "el-checkbox__label" },
	            [
	              _vm._t("default"),
	              !_vm.$slots.default ? [_vm._v(_vm._s(_vm.label))] : _vm._e()
	            ],
	            2
	          )
	        : _vm._e()
	    ]
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue?vue&type=template&id=d0387074&
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
	var emitter_ = __webpack_require__(4);
	var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var checkboxvue_type_script_lang_js_ = ({
	  name: 'ElCheckbox',
	
	  mixins: [emitter_default.a],
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  componentName: 'ElCheckbox',
	
	  data: function data() {
	    return {
	      selfModel: false,
	      focus: false,
	      isLimitExceeded: false
	    };
	  },
	
	
	  computed: {
	    model: {
	      get: function get() {
	        return this.isGroup ? this.store : this.value !== undefined ? this.value : this.selfModel;
	      },
	      set: function set(val) {
	        if (this.isGroup) {
	          this.isLimitExceeded = false;
	          this._checkboxGroup.min !== undefined && val.length < this._checkboxGroup.min && (this.isLimitExceeded = true);
	
	          this._checkboxGroup.max !== undefined && val.length > this._checkboxGroup.max && (this.isLimitExceeded = true);
	
	          this.isLimitExceeded === false && this.dispatch('ElCheckboxGroup', 'input', [val]);
	        } else {
	          this.$emit('input', val);
	          this.selfModel = val;
	        }
	      }
	    },
	
	    isChecked: function isChecked() {
	      if ({}.toString.call(this.model) === '[object Boolean]') {
	        return this.model;
	      } else if (Array.isArray(this.model)) {
	        return this.model.indexOf(this.label) > -1;
	      } else if (this.model !== null && this.model !== undefined) {
	        return this.model === this.trueLabel;
	      }
	    },
	    isGroup: function isGroup() {
	      var parent = this.$parent;
	      while (parent) {
	        if (parent.$options.componentName !== 'ElCheckboxGroup') {
	          parent = parent.$parent;
	        } else {
	          this._checkboxGroup = parent;
	          return true;
	        }
	      }
	      return false;
	    },
	    store: function store() {
	      return this._checkboxGroup ? this._checkboxGroup.value : this.value;
	    },
	
	
	    /* used to make the isDisabled judgment under max/min props */
	    isLimitDisabled: function isLimitDisabled() {
	      var _checkboxGroup = this._checkboxGroup,
	          max = _checkboxGroup.max,
	          min = _checkboxGroup.min;
	
	      return !!(max || min) && this.model.length >= max && !this.isChecked || this.model.length <= min && this.isChecked;
	    },
	    isDisabled: function isDisabled() {
	      return this.isGroup ? this._checkboxGroup.disabled || this.disabled || (this.elForm || {}).disabled || this.isLimitDisabled : this.disabled || (this.elForm || {}).disabled;
	    },
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    checkboxSize: function checkboxSize() {
	      var temCheckboxSize = this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	      return this.isGroup ? this._checkboxGroup.checkboxGroupSize || temCheckboxSize : temCheckboxSize;
	    }
	  },
	
	  props: {
	    value: {},
	    label: {},
	    indeterminate: Boolean,
	    disabled: Boolean,
	    checked: Boolean,
	    name: String,
	    trueLabel: [String, Number],
	    falseLabel: [String, Number],
	    id: String, /* 当indeterminate为真时，为controls提供相关连的checkbox的id，表明元素间的控制关系*/
	    controls: String, /* 当indeterminate为真时，为controls提供相关连的checkbox的id，表明元素间的控制关系*/
	    border: Boolean,
	    size: String
	  },
	
	  methods: {
	    addToStore: function addToStore() {
	      if (Array.isArray(this.model) && this.model.indexOf(this.label) === -1) {
	        this.model.push(this.label);
	      } else {
	        this.model = this.trueLabel || true;
	      }
	    },
	    handleChange: function handleChange(ev) {
	      var _this = this;
	
	      if (this.isLimitExceeded) return;
	      var value = void 0;
	      if (ev.target.checked) {
	        value = this.trueLabel === undefined ? true : this.trueLabel;
	      } else {
	        value = this.falseLabel === undefined ? false : this.falseLabel;
	      }
	      this.$emit('change', value, ev);
	      this.$nextTick(function () {
	        if (_this.isGroup) {
	          _this.dispatch('ElCheckboxGroup', 'change', [_this._checkboxGroup.value]);
	        }
	      });
	    }
	  },
	
	  created: function created() {
	    this.checked && this.addToStore();
	  },
	  mounted: function mounted() {
	    // 为indeterminate元素 添加aria-controls 属性
	    if (this.indeterminate) {
	      this.$el.setAttribute('aria-controls', this.controls);
	    }
	  },
	
	
	  watch: {
	    value: function value(_value) {
	      this.dispatch('ElFormItem', 'el.form.change', _value);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_checkboxvue_type_script_lang_js_ = (checkboxvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_checkboxvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/checkbox/src/checkbox.vue"
	/* harmony default export */ var src_checkbox = (component.exports);
	// CONCATENATED MODULE: ./packages/checkbox/index.js
	
	
	/* istanbul ignore next */
	src_checkbox.install = function (Vue) {
	  Vue.component(src_checkbox.name, src_checkbox);
	};
	
	/* harmony default export */ var packages_checkbox = __webpack_exports__["default"] = (src_checkbox);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _util = __webpack_require__(15);
	
	/**
	 * Show migrating guide in browser console.
	 *
	 * Usage:
	 * import Migrating from 'element-ui/src/mixins/migrating';
	 *
	 * mixins: [Migrating]
	 *
	 * add getMigratingConfig method for your component.
	 *  getMigratingConfig() {
	 *    return {
	 *      props: {
	 *        'allow-no-selection': 'allow-no-selection is removed.',
	 *        'selection-mode': 'selection-mode is removed.'
	 *      },
	 *      events: {
	 *        selectionchange: 'selectionchange is renamed to selection-change.'
	 *      }
	 *    };
	 *  },
	 */
	exports.default = {
	  mounted: function mounted() {
	    if (true) return;
	    if (!this.$vnode) return;
	
	    var _getMigratingConfig = this.getMigratingConfig(),
	        _getMigratingConfig$p = _getMigratingConfig.props,
	        props = _getMigratingConfig$p === undefined ? {} : _getMigratingConfig$p,
	        _getMigratingConfig$e = _getMigratingConfig.events,
	        events = _getMigratingConfig$e === undefined ? {} : _getMigratingConfig$e;
	
	    var _$vnode = this.$vnode,
	        data = _$vnode.data,
	        componentOptions = _$vnode.componentOptions;
	
	    var definedProps = data.attrs || {};
	    var definedEvents = componentOptions.listeners || {};
	
	    for (var propName in definedProps) {
	      propName = (0, _util.kebabCase)(propName); // compatible with camel case
	      if (props[propName]) {
	        console.warn('[Element Migrating][' + this.$options.name + '][Attribute]: ' + props[propName]);
	      }
	    }
	
	    for (var eventName in definedEvents) {
	      eventName = (0, _util.kebabCase)(eventName); // compatible with camel case
	      if (events[eventName]) {
	        console.warn('[Element Migrating][' + this.$options.name + '][Event]: ' + events[eventName]);
	      }
	    }
	  },
	
	  methods: {
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {},
	        events: {}
	      };
	    }
	  }
	};

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 116);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 116:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio.vue?vue&type=template&id=69cd6268&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "label",
	    {
	      staticClass: "el-radio",
	      class: [
	        _vm.border && _vm.radioSize ? "el-radio--" + _vm.radioSize : "",
	        { "is-disabled": _vm.isDisabled },
	        { "is-focus": _vm.focus },
	        { "is-bordered": _vm.border },
	        { "is-checked": _vm.model === _vm.label }
	      ],
	      attrs: {
	        role: "radio",
	        "aria-checked": _vm.model === _vm.label,
	        "aria-disabled": _vm.isDisabled,
	        tabindex: _vm.tabIndex
	      },
	      on: {
	        keydown: function($event) {
	          if (
	            !("button" in $event) &&
	            _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])
	          ) {
	            return null
	          }
	          $event.stopPropagation()
	          $event.preventDefault()
	          _vm.model = _vm.isDisabled ? _vm.model : _vm.label
	        }
	      }
	    },
	    [
	      _c(
	        "span",
	        {
	          staticClass: "el-radio__input",
	          class: {
	            "is-disabled": _vm.isDisabled,
	            "is-checked": _vm.model === _vm.label
	          }
	        },
	        [
	          _c("span", { staticClass: "el-radio__inner" }),
	          _c("input", {
	            directives: [
	              {
	                name: "model",
	                rawName: "v-model",
	                value: _vm.model,
	                expression: "model"
	              }
	            ],
	            ref: "radio",
	            staticClass: "el-radio__original",
	            attrs: {
	              type: "radio",
	              "aria-hidden": "true",
	              name: _vm.name,
	              disabled: _vm.isDisabled,
	              tabindex: "-1"
	            },
	            domProps: {
	              value: _vm.label,
	              checked: _vm._q(_vm.model, _vm.label)
	            },
	            on: {
	              focus: function($event) {
	                _vm.focus = true
	              },
	              blur: function($event) {
	                _vm.focus = false
	              },
	              change: [
	                function($event) {
	                  _vm.model = _vm.label
	                },
	                _vm.handleChange
	              ]
	            }
	          })
	        ]
	      ),
	      _c(
	        "span",
	        {
	          staticClass: "el-radio__label",
	          on: {
	            keydown: function($event) {
	              $event.stopPropagation()
	            }
	          }
	        },
	        [
	          _vm._t("default"),
	          !_vm.$slots.default ? [_vm._v(_vm._s(_vm.label))] : _vm._e()
	        ],
	        2
	      )
	    ]
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/radio/src/radio.vue?vue&type=template&id=69cd6268&
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
	var emitter_ = __webpack_require__(4);
	var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var radiovue_type_script_lang_js_ = ({
	  name: 'ElRadio',
	
	  mixins: [emitter_default.a],
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  componentName: 'ElRadio',
	
	  props: {
	    value: {},
	    label: {},
	    disabled: Boolean,
	    name: String,
	    border: Boolean,
	    size: String
	  },
	
	  data: function data() {
	    return {
	      focus: false
	    };
	  },
	
	  computed: {
	    isGroup: function isGroup() {
	      var parent = this.$parent;
	      while (parent) {
	        if (parent.$options.componentName !== 'ElRadioGroup') {
	          parent = parent.$parent;
	        } else {
	          this._radioGroup = parent;
	          return true;
	        }
	      }
	      return false;
	    },
	
	    model: {
	      get: function get() {
	        return this.isGroup ? this._radioGroup.value : this.value;
	      },
	      set: function set(val) {
	        if (this.isGroup) {
	          this.dispatch('ElRadioGroup', 'input', [val]);
	        } else {
	          this.$emit('input', val);
	        }
	        this.$refs.radio && (this.$refs.radio.checked = this.model === this.label);
	      }
	    },
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    radioSize: function radioSize() {
	      var temRadioSize = this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	      return this.isGroup ? this._radioGroup.radioGroupSize || temRadioSize : temRadioSize;
	    },
	    isDisabled: function isDisabled() {
	      return this.isGroup ? this._radioGroup.disabled || this.disabled || (this.elForm || {}).disabled : this.disabled || (this.elForm || {}).disabled;
	    },
	    tabIndex: function tabIndex() {
	      return this.isDisabled || this.isGroup && this.model !== this.label ? -1 : 0;
	    }
	  },
	
	  methods: {
	    handleChange: function handleChange() {
	      var _this = this;
	
	      this.$nextTick(function () {
	        _this.$emit('change', _this.model);
	        _this.isGroup && _this.dispatch('ElRadioGroup', 'handleChange', _this.model);
	      });
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/radio/src/radio.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_radiovue_type_script_lang_js_ = (radiovue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/radio/src/radio.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_radiovue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/radio/src/radio.vue"
	/* harmony default export */ var src_radio = (component.exports);
	// CONCATENATED MODULE: ./packages/radio/index.js
	
	
	/* istanbul ignore next */
	src_radio.install = function (Vue) {
	  Vue.component(src_radio.name, src_radio);
	};
	
	/* harmony default export */ var packages_radio = __webpack_exports__["default"] = (src_radio);
	
	/***/ }),
	
	/***/ 4:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(27);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 144 */
/***/ (function(module, exports) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 124);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 124:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tag/src/tag.vue?vue&type=script&lang=js&
	
	/* harmony default export */ var tagvue_type_script_lang_js_ = ({
	  name: 'ElTag',
	  props: {
	    text: String,
	    closable: Boolean,
	    type: String,
	    hit: Boolean,
	    disableTransitions: Boolean,
	    color: String,
	    size: String,
	    effect: {
	      type: String,
	      default: 'light',
	      validator: function validator(val) {
	        return ['dark', 'light', 'plain'].indexOf(val) !== -1;
	      }
	    }
	  },
	  methods: {
	    handleClose: function handleClose(event) {
	      event.stopPropagation();
	      this.$emit('close', event);
	    },
	    handleClick: function handleClick(event) {
	      this.$emit('click', event);
	    }
	  },
	  computed: {
	    tagSize: function tagSize() {
	      return this.size || (this.$ELEMENT || {}).size;
	    }
	  },
	  render: function render(h) {
	    var type = this.type,
	        tagSize = this.tagSize,
	        hit = this.hit,
	        effect = this.effect;
	
	    var classes = ['el-tag', type ? 'el-tag--' + type : '', tagSize ? 'el-tag--' + tagSize : '', effect ? 'el-tag--' + effect : '', hit && 'is-hit'];
	    var tagEl = h(
	      'span',
	      {
	        'class': classes,
	        style: { backgroundColor: this.color },
	        on: {
	          'click': this.handleClick
	        }
	      },
	      [this.$slots.default, this.closable && h('i', { 'class': 'el-tag__close el-icon-close', on: {
	          'click': this.handleClose
	        }
	      })]
	    );
	
	    return this.disableTransitions ? tagEl : h(
	      'transition',
	      {
	        attrs: { name: 'el-zoom-in-center' }
	      },
	      [tagEl]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/tag/src/tag.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_tagvue_type_script_lang_js_ = (tagvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/tag/src/tag.vue
	var render, staticRenderFns
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_tagvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/tag/src/tag.vue"
	/* harmony default export */ var tag = (component.exports);
	// CONCATENATED MODULE: ./packages/tag/index.js
	
	
	/* istanbul ignore next */
	tag.install = function (Vue) {
	  Vue.component(tag.name, tag);
	};
	
	/* harmony default export */ var packages_tag = __webpack_exports__["default"] = (tag);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _vue = __webpack_require__(3);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _dom = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var nodeList = [];
	var ctx = '@@clickoutsideContext';
	
	var startClick = void 0;
	var seed = 0;
	
	!_vue2.default.prototype.$isServer && (0, _dom.on)(document, 'mousedown', function (e) {
	  return startClick = e;
	});
	
	!_vue2.default.prototype.$isServer && (0, _dom.on)(document, 'mouseup', function (e) {
	  nodeList.forEach(function (node) {
	    return node[ctx].documentHandler(e, startClick);
	  });
	});
	
	function createDocumentHandler(el, binding, vnode) {
	  return function () {
	    var mouseup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var mousedown = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    if (!vnode || !vnode.context || !mouseup.target || !mousedown.target || el.contains(mouseup.target) || el.contains(mousedown.target) || el === mouseup.target || vnode.context.popperElm && (vnode.context.popperElm.contains(mouseup.target) || vnode.context.popperElm.contains(mousedown.target))) return;
	
	    if (binding.expression && el[ctx].methodName && vnode.context[el[ctx].methodName]) {
	      vnode.context[el[ctx].methodName]();
	    } else {
	      el[ctx].bindingFn && el[ctx].bindingFn();
	    }
	  };
	}
	
	/**
	 * v-clickoutside
	 * @desc 点击元素外面才会触发的事件
	 * @example
	 * ```vue
	 * <div v-element-clickoutside="handleClose">
	 * ```
	 */
	exports.default = {
	  bind: function bind(el, binding, vnode) {
	    nodeList.push(el);
	    var id = seed++;
	    el[ctx] = {
	      id: id,
	      documentHandler: createDocumentHandler(el, binding, vnode),
	      methodName: binding.expression,
	      bindingFn: binding.value
	    };
	  },
	  update: function update(el, binding, vnode) {
	    el[ctx].documentHandler = createDocumentHandler(el, binding, vnode);
	    el[ctx].methodName = binding.expression;
	    el[ctx].bindingFn = binding.value;
	  },
	  unbind: function unbind(el) {
	    var len = nodeList.length;
	
	    for (var i = 0; i < len; i++) {
	      if (nodeList[i][ctx].id === el[ctx].id) {
	        nodeList.splice(i, 1);
	        break;
	      }
	    }
	    delete el[ctx];
	  }
	};

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/* Modified from https://github.com/taylorhakes/fecha
	 *
	 * The MIT License (MIT)
	 *
	 * Copyright (c) 2015 Taylor Hakes
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 *     The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 *     THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 *     FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 *     OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	
	/*eslint-disable*/
	// 把 YYYY-MM-DD 改成了 yyyy-MM-dd
	(function (main) {
	  'use strict';
	
	  /**
	   * Parse or format dates
	   * @class fecha
	   */
	
	  var fecha = {};
	  var token = /d{1,4}|M{1,4}|yy(?:yy)?|S{1,3}|Do|ZZ|([HhMsDm])\1?|[aA]|"[^"]*"|'[^']*'/g;
	  var twoDigits = '\\d\\d?';
	  var threeDigits = '\\d{3}';
	  var fourDigits = '\\d{4}';
	  var word = '[^\\s]+';
	  var literal = /\[([^]*?)\]/gm;
	  var noop = function noop() {};
	
	  function regexEscape(str) {
	    return str.replace(/[|\\{()[^$+*?.-]/g, '\\$&');
	  }
	
	  function shorten(arr, sLen) {
	    var newArr = [];
	    for (var i = 0, len = arr.length; i < len; i++) {
	      newArr.push(arr[i].substr(0, sLen));
	    }
	    return newArr;
	  }
	
	  function monthUpdate(arrName) {
	    return function (d, v, i18n) {
	      var index = i18n[arrName].indexOf(v.charAt(0).toUpperCase() + v.substr(1).toLowerCase());
	      if (~index) {
	        d.month = index;
	      }
	    };
	  }
	
	  function pad(val, len) {
	    val = String(val);
	    len = len || 2;
	    while (val.length < len) {
	      val = '0' + val;
	    }
	    return val;
	  }
	
	  var dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
	  var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	  var monthNamesShort = shorten(monthNames, 3);
	  var dayNamesShort = shorten(dayNames, 3);
	  fecha.i18n = {
	    dayNamesShort: dayNamesShort,
	    dayNames: dayNames,
	    monthNamesShort: monthNamesShort,
	    monthNames: monthNames,
	    amPm: ['am', 'pm'],
	    DoFn: function DoFn(D) {
	      return D + ['th', 'st', 'nd', 'rd'][D % 10 > 3 ? 0 : (D - D % 10 !== 10) * D % 10];
	    }
	  };
	
	  var formatFlags = {
	    D: function D(dateObj) {
	      return dateObj.getDay();
	    },
	    DD: function DD(dateObj) {
	      return pad(dateObj.getDay());
	    },
	    Do: function Do(dateObj, i18n) {
	      return i18n.DoFn(dateObj.getDate());
	    },
	    d: function d(dateObj) {
	      return dateObj.getDate();
	    },
	    dd: function dd(dateObj) {
	      return pad(dateObj.getDate());
	    },
	    ddd: function ddd(dateObj, i18n) {
	      return i18n.dayNamesShort[dateObj.getDay()];
	    },
	    dddd: function dddd(dateObj, i18n) {
	      return i18n.dayNames[dateObj.getDay()];
	    },
	    M: function M(dateObj) {
	      return dateObj.getMonth() + 1;
	    },
	    MM: function MM(dateObj) {
	      return pad(dateObj.getMonth() + 1);
	    },
	    MMM: function MMM(dateObj, i18n) {
	      return i18n.monthNamesShort[dateObj.getMonth()];
	    },
	    MMMM: function MMMM(dateObj, i18n) {
	      return i18n.monthNames[dateObj.getMonth()];
	    },
	    yy: function yy(dateObj) {
	      return pad(String(dateObj.getFullYear()), 4).substr(2);
	    },
	    yyyy: function yyyy(dateObj) {
	      return pad(dateObj.getFullYear(), 4);
	    },
	    h: function h(dateObj) {
	      return dateObj.getHours() % 12 || 12;
	    },
	    hh: function hh(dateObj) {
	      return pad(dateObj.getHours() % 12 || 12);
	    },
	    H: function H(dateObj) {
	      return dateObj.getHours();
	    },
	    HH: function HH(dateObj) {
	      return pad(dateObj.getHours());
	    },
	    m: function m(dateObj) {
	      return dateObj.getMinutes();
	    },
	    mm: function mm(dateObj) {
	      return pad(dateObj.getMinutes());
	    },
	    s: function s(dateObj) {
	      return dateObj.getSeconds();
	    },
	    ss: function ss(dateObj) {
	      return pad(dateObj.getSeconds());
	    },
	    S: function S(dateObj) {
	      return Math.round(dateObj.getMilliseconds() / 100);
	    },
	    SS: function SS(dateObj) {
	      return pad(Math.round(dateObj.getMilliseconds() / 10), 2);
	    },
	    SSS: function SSS(dateObj) {
	      return pad(dateObj.getMilliseconds(), 3);
	    },
	    a: function a(dateObj, i18n) {
	      return dateObj.getHours() < 12 ? i18n.amPm[0] : i18n.amPm[1];
	    },
	    A: function A(dateObj, i18n) {
	      return dateObj.getHours() < 12 ? i18n.amPm[0].toUpperCase() : i18n.amPm[1].toUpperCase();
	    },
	    ZZ: function ZZ(dateObj) {
	      var o = dateObj.getTimezoneOffset();
	      return (o > 0 ? '-' : '+') + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4);
	    }
	  };
	
	  var parseFlags = {
	    d: [twoDigits, function (d, v) {
	      d.day = v;
	    }],
	    Do: [twoDigits + word, function (d, v) {
	      d.day = parseInt(v, 10);
	    }],
	    M: [twoDigits, function (d, v) {
	      d.month = v - 1;
	    }],
	    yy: [twoDigits, function (d, v) {
	      var da = new Date(),
	          cent = +('' + da.getFullYear()).substr(0, 2);
	      d.year = '' + (v > 68 ? cent - 1 : cent) + v;
	    }],
	    h: [twoDigits, function (d, v) {
	      d.hour = v;
	    }],
	    m: [twoDigits, function (d, v) {
	      d.minute = v;
	    }],
	    s: [twoDigits, function (d, v) {
	      d.second = v;
	    }],
	    yyyy: [fourDigits, function (d, v) {
	      d.year = v;
	    }],
	    S: ['\\d', function (d, v) {
	      d.millisecond = v * 100;
	    }],
	    SS: ['\\d{2}', function (d, v) {
	      d.millisecond = v * 10;
	    }],
	    SSS: [threeDigits, function (d, v) {
	      d.millisecond = v;
	    }],
	    D: [twoDigits, noop],
	    ddd: [word, noop],
	    MMM: [word, monthUpdate('monthNamesShort')],
	    MMMM: [word, monthUpdate('monthNames')],
	    a: [word, function (d, v, i18n) {
	      var val = v.toLowerCase();
	      if (val === i18n.amPm[0]) {
	        d.isPm = false;
	      } else if (val === i18n.amPm[1]) {
	        d.isPm = true;
	      }
	    }],
	    ZZ: ['[^\\s]*?[\\+\\-]\\d\\d:?\\d\\d|[^\\s]*?Z', function (d, v) {
	      var parts = (v + '').match(/([+-]|\d\d)/gi),
	          minutes;
	
	      if (parts) {
	        minutes = +(parts[1] * 60) + parseInt(parts[2], 10);
	        d.timezoneOffset = parts[0] === '+' ? minutes : -minutes;
	      }
	    }]
	  };
	  parseFlags.dd = parseFlags.d;
	  parseFlags.dddd = parseFlags.ddd;
	  parseFlags.DD = parseFlags.D;
	  parseFlags.mm = parseFlags.m;
	  parseFlags.hh = parseFlags.H = parseFlags.HH = parseFlags.h;
	  parseFlags.MM = parseFlags.M;
	  parseFlags.ss = parseFlags.s;
	  parseFlags.A = parseFlags.a;
	
	  // Some common format strings
	  fecha.masks = {
	    default: 'ddd MMM dd yyyy HH:mm:ss',
	    shortDate: 'M/D/yy',
	    mediumDate: 'MMM d, yyyy',
	    longDate: 'MMMM d, yyyy',
	    fullDate: 'dddd, MMMM d, yyyy',
	    shortTime: 'HH:mm',
	    mediumTime: 'HH:mm:ss',
	    longTime: 'HH:mm:ss.SSS'
	  };
	
	  /***
	   * Format a date
	   * @method format
	   * @param {Date|number} dateObj
	   * @param {string} mask Format of the date, i.e. 'mm-dd-yy' or 'shortDate'
	   */
	  fecha.format = function (dateObj, mask, i18nSettings) {
	    var i18n = i18nSettings || fecha.i18n;
	
	    if (typeof dateObj === 'number') {
	      dateObj = new Date(dateObj);
	    }
	
	    if (Object.prototype.toString.call(dateObj) !== '[object Date]' || isNaN(dateObj.getTime())) {
	      throw new Error('Invalid Date in fecha.format');
	    }
	
	    mask = fecha.masks[mask] || mask || fecha.masks['default'];
	
	    var literals = [];
	
	    // Make literals inactive by replacing them with ??
	    mask = mask.replace(literal, function ($0, $1) {
	      literals.push($1);
	      return '@@@';
	    });
	    // Apply formatting rules
	    mask = mask.replace(token, function ($0) {
	      return $0 in formatFlags ? formatFlags[$0](dateObj, i18n) : $0.slice(1, $0.length - 1);
	    });
	    // Inline literal values back into the formatted value
	    return mask.replace(/@@@/g, function () {
	      return literals.shift();
	    });
	  };
	
	  /**
	   * Parse a date string into an object, changes - into /
	   * @method parse
	   * @param {string} dateStr Date string
	   * @param {string} format Date parse format
	   * @returns {Date|boolean}
	   */
	  fecha.parse = function (dateStr, format, i18nSettings) {
	    var i18n = i18nSettings || fecha.i18n;
	
	    if (typeof format !== 'string') {
	      throw new Error('Invalid format in fecha.parse');
	    }
	
	    format = fecha.masks[format] || format;
	
	    // Avoid regular expression denial of service, fail early for really long strings
	    // https://www.owasp.org/index.php/Regular_expression_Denial_of_Service_-_ReDoS
	    if (dateStr.length > 1000) {
	      return null;
	    }
	
	    var dateInfo = {};
	    var parseInfo = [];
	    var literals = [];
	    format = format.replace(literal, function ($0, $1) {
	      literals.push($1);
	      return '@@@';
	    });
	    var newFormat = regexEscape(format).replace(token, function ($0) {
	      if (parseFlags[$0]) {
	        var info = parseFlags[$0];
	        parseInfo.push(info[1]);
	        return '(' + info[0] + ')';
	      }
	
	      return $0;
	    });
	    newFormat = newFormat.replace(/@@@/g, function () {
	      return literals.shift();
	    });
	    var matches = dateStr.match(new RegExp(newFormat, 'i'));
	    if (!matches) {
	      return null;
	    }
	
	    for (var i = 1; i < matches.length; i++) {
	      parseInfo[i - 1](dateInfo, matches[i], i18n);
	    }
	
	    var today = new Date();
	    if (dateInfo.isPm === true && dateInfo.hour != null && +dateInfo.hour !== 12) {
	      dateInfo.hour = +dateInfo.hour + 12;
	    } else if (dateInfo.isPm === false && +dateInfo.hour === 12) {
	      dateInfo.hour = 0;
	    }
	
	    var date;
	    if (dateInfo.timezoneOffset != null) {
	      dateInfo.minute = +(dateInfo.minute || 0) - +dateInfo.timezoneOffset;
	      date = new Date(Date.UTC(dateInfo.year || today.getFullYear(), dateInfo.month || 0, dateInfo.day || 1, dateInfo.hour || 0, dateInfo.minute || 0, dateInfo.second || 0, dateInfo.millisecond || 0));
	    } else {
	      date = new Date(dateInfo.year || today.getFullYear(), dateInfo.month || 0, dateInfo.day || 1, dateInfo.hour || 0, dateInfo.minute || 0, dateInfo.second || 0, dateInfo.millisecond || 0);
	    }
	    return date;
	  };
	
	  /* istanbul ignore next */
	  if (typeof module !== 'undefined' && module.exports) {
	    module.exports = fecha;
	  } else if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return fecha;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else {
	    main.fecha = fecha;
	  }
	})(undefined);

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.PopupManager = undefined;
	
	var _vue = __webpack_require__(3);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _merge = __webpack_require__(59);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _popupManager = __webpack_require__(477);
	
	var _popupManager2 = _interopRequireDefault(_popupManager);
	
	var _scrollbarWidth = __webpack_require__(103);
	
	var _scrollbarWidth2 = _interopRequireDefault(_scrollbarWidth);
	
	var _dom = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var idSeed = 1;
	
	var scrollBarWidth = void 0;
	
	exports.default = {
	  props: {
	    visible: {
	      type: Boolean,
	      default: false
	    },
	    openDelay: {},
	    closeDelay: {},
	    zIndex: {},
	    modal: {
	      type: Boolean,
	      default: false
	    },
	    modalFade: {
	      type: Boolean,
	      default: true
	    },
	    modalClass: {},
	    modalAppendToBody: {
	      type: Boolean,
	      default: false
	    },
	    lockScroll: {
	      type: Boolean,
	      default: true
	    },
	    closeOnPressEscape: {
	      type: Boolean,
	      default: false
	    },
	    closeOnClickModal: {
	      type: Boolean,
	      default: false
	    }
	  },
	
	  beforeMount: function beforeMount() {
	    this._popupId = 'popup-' + idSeed++;
	    _popupManager2.default.register(this._popupId, this);
	  },
	  beforeDestroy: function beforeDestroy() {
	    _popupManager2.default.deregister(this._popupId);
	    _popupManager2.default.closeModal(this._popupId);
	
	    this.restoreBodyStyle();
	  },
	  data: function data() {
	    return {
	      opened: false,
	      bodyPaddingRight: null,
	      computedBodyPaddingRight: 0,
	      withoutHiddenClass: true,
	      rendered: false
	    };
	  },
	
	
	  watch: {
	    visible: function visible(val) {
	      var _this = this;
	
	      if (val) {
	        if (this._opening) return;
	        if (!this.rendered) {
	          this.rendered = true;
	          _vue2.default.nextTick(function () {
	            _this.open();
	          });
	        } else {
	          this.open();
	        }
	      } else {
	        this.close();
	      }
	    }
	  },
	
	  methods: {
	    open: function open(options) {
	      var _this2 = this;
	
	      if (!this.rendered) {
	        this.rendered = true;
	      }
	
	      var props = (0, _merge2.default)({}, this.$props || this, options);
	
	      if (this._closeTimer) {
	        clearTimeout(this._closeTimer);
	        this._closeTimer = null;
	      }
	      clearTimeout(this._openTimer);
	
	      var openDelay = Number(props.openDelay);
	      if (openDelay > 0) {
	        this._openTimer = setTimeout(function () {
	          _this2._openTimer = null;
	          _this2.doOpen(props);
	        }, openDelay);
	      } else {
	        this.doOpen(props);
	      }
	    },
	    doOpen: function doOpen(props) {
	      if (this.$isServer) return;
	      if (this.willOpen && !this.willOpen()) return;
	      if (this.opened) return;
	
	      this._opening = true;
	
	      var dom = this.$el;
	
	      var modal = props.modal;
	
	      var zIndex = props.zIndex;
	      if (zIndex) {
	        _popupManager2.default.zIndex = zIndex;
	      }
	
	      if (modal) {
	        if (this._closing) {
	          _popupManager2.default.closeModal(this._popupId);
	          this._closing = false;
	        }
	        _popupManager2.default.openModal(this._popupId, _popupManager2.default.nextZIndex(), this.modalAppendToBody ? undefined : dom, props.modalClass, props.modalFade);
	        if (props.lockScroll) {
	          this.withoutHiddenClass = !(0, _dom.hasClass)(document.body, 'el-popup-parent--hidden');
	          if (this.withoutHiddenClass) {
	            this.bodyPaddingRight = document.body.style.paddingRight;
	            this.computedBodyPaddingRight = parseInt((0, _dom.getStyle)(document.body, 'paddingRight'), 10);
	          }
	          scrollBarWidth = (0, _scrollbarWidth2.default)();
	          var bodyHasOverflow = document.documentElement.clientHeight < document.body.scrollHeight;
	          var bodyOverflowY = (0, _dom.getStyle)(document.body, 'overflowY');
	          if (scrollBarWidth > 0 && (bodyHasOverflow || bodyOverflowY === 'scroll') && this.withoutHiddenClass) {
	            document.body.style.paddingRight = this.computedBodyPaddingRight + scrollBarWidth + 'px';
	          }
	          (0, _dom.addClass)(document.body, 'el-popup-parent--hidden');
	        }
	      }
	
	      if (getComputedStyle(dom).position === 'static') {
	        dom.style.position = 'absolute';
	      }
	
	      dom.style.zIndex = _popupManager2.default.nextZIndex();
	      this.opened = true;
	
	      this.onOpen && this.onOpen();
	
	      this.doAfterOpen();
	    },
	    doAfterOpen: function doAfterOpen() {
	      this._opening = false;
	    },
	    close: function close() {
	      var _this3 = this;
	
	      if (this.willClose && !this.willClose()) return;
	
	      if (this._openTimer !== null) {
	        clearTimeout(this._openTimer);
	        this._openTimer = null;
	      }
	      clearTimeout(this._closeTimer);
	
	      var closeDelay = Number(this.closeDelay);
	
	      if (closeDelay > 0) {
	        this._closeTimer = setTimeout(function () {
	          _this3._closeTimer = null;
	          _this3.doClose();
	        }, closeDelay);
	      } else {
	        this.doClose();
	      }
	    },
	    doClose: function doClose() {
	      this._closing = true;
	
	      this.onClose && this.onClose();
	
	      if (this.lockScroll) {
	        setTimeout(this.restoreBodyStyle, 200);
	      }
	
	      this.opened = false;
	
	      this.doAfterClose();
	    },
	    doAfterClose: function doAfterClose() {
	      _popupManager2.default.closeModal(this._popupId);
	      this._closing = false;
	    },
	    restoreBodyStyle: function restoreBodyStyle() {
	      if (this.modal && this.withoutHiddenClass) {
	        document.body.style.paddingRight = this.bodyPaddingRight;
	        (0, _dom.removeClass)(document.body, 'el-popup-parent--hidden');
	      }
	      this.withoutHiddenClass = true;
	    }
	  }
	};
	exports.PopupManager = _popupManager2.default;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.isDefined = exports.isUndefined = exports.isFunction = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.isString = isString;
	exports.isObject = isObject;
	exports.isHtmlElement = isHtmlElement;
	
	var _vue = __webpack_require__(3);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isString(obj) {
	  return Object.prototype.toString.call(obj) === '[object String]';
	}
	
	function isObject(obj) {
	  return Object.prototype.toString.call(obj) === '[object Object]';
	}
	
	function isHtmlElement(node) {
	  return node && node.nodeType === Node.ELEMENT_NODE;
	}
	
	/**
	 *  - Inspired:
	 *    https://github.com/jashkenas/underscore/blob/master/modules/isFunction.js
	 */
	var isFunction = function isFunction(functionToCheck) {
	  var getType = {};
	  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	};
	
	if (typeof /./ !== 'function' && (typeof Int8Array === 'undefined' ? 'undefined' : _typeof(Int8Array)) !== 'object' && (_vue2.default.prototype.$isServer || typeof document.childNodes !== 'function')) {
	  exports.isFunction = isFunction = function isFunction(obj) {
	    return typeof obj === 'function' || false;
	  };
	}
	
	exports.isFunction = isFunction;
	var isUndefined = exports.isUndefined = function isUndefined(val) {
	  return val === void 0;
	};
	
	var isDefined = exports.isDefined = function isDefined(val) {
	  return val !== undefined && val !== null;
	};

/***/ }),
/* 149 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g = (function() { return this })() || Function("return this")();
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(151);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}


/***/ }),
/* 151 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // In sloppy mode, unbound `this` refers to the global object, fallback to
	  // Function constructor if we're in global strict mode. That is sadly a form
	  // of indirect eval which violates Content Security Policy.
	  (function() { return this })() || Function("return this")()
	);


/***/ }),
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(149)))

/***/ }),
/* 199 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(198);
	exports.setImmediate = setImmediate;
	exports.clearImmediate = clearImmediate;


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(50);
	__webpack_require__(230);
	module.exports = __webpack_require__(10).Array.from;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(77);
	__webpack_require__(50);
	module.exports = __webpack_require__(229);


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(10);
	var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
	module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(232);
	module.exports = __webpack_require__(10).Object.assign;


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(123);
	__webpack_require__(50);
	__webpack_require__(77);
	__webpack_require__(233);
	__webpack_require__(235);
	__webpack_require__(236);
	module.exports = __webpack_require__(10).Promise;


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(234);
	__webpack_require__(123);
	__webpack_require__(237);
	__webpack_require__(238);
	module.exports = __webpack_require__(10).Symbol;


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(50);
	__webpack_require__(77);
	module.exports = __webpack_require__(75).f('iterator');


/***/ }),
/* 208 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 209 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(28);
	var toLength = __webpack_require__(71);
	var toAbsoluteIndex = __webpack_require__(228);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(18);
	var createDesc = __webpack_require__(38);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(46);
	var gOPS = __webpack_require__(67);
	var pIE = __webpack_require__(47);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(35);
	var call = __webpack_require__(112);
	var isArrayIter = __webpack_require__(111);
	var anObject = __webpack_require__(16);
	var toLength = __webpack_require__(71);
	var getIterFn = __webpack_require__(76);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 214 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(34);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(115);
	var descriptor = __webpack_require__(38);
	var setToStringTag = __webpack_require__(48);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(23)(IteratorPrototype, __webpack_require__(9)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 217 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(49)('meta');
	var isObject = __webpack_require__(24);
	var has = __webpack_require__(22);
	var setDesc = __webpack_require__(18).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(36)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(8);
	var macrotask = __webpack_require__(122).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(34)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    var promise = Promise.resolve();
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(46);
	var gOPS = __webpack_require__(67);
	var pIE = __webpack_require__(47);
	var toObject = __webpack_require__(72);
	var IObject = __webpack_require__(110);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(36)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(18);
	var anObject = __webpack_require__(16);
	var getKeys = __webpack_require__(46);
	
	module.exports = __webpack_require__(20) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(47);
	var createDesc = __webpack_require__(38);
	var toIObject = __webpack_require__(28);
	var toPrimitive = __webpack_require__(73);
	var has = __webpack_require__(22);
	var IE8_DOM_DEFINE = __webpack_require__(109);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(20) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(28);
	var gOPN = __webpack_require__(116).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(22);
	var toObject = __webpack_require__(72);
	var IE_PROTO = __webpack_require__(68)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	var hide = __webpack_require__(23);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    if (safe && target[key]) target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(8);
	var core = __webpack_require__(10);
	var dP = __webpack_require__(18);
	var DESCRIPTORS = __webpack_require__(20);
	var SPECIES = __webpack_require__(9)('species');
	
	module.exports = function (KEY) {
	  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(70);
	var defined = __webpack_require__(63);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(70);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(16);
	var get = __webpack_require__(76);
	module.exports = __webpack_require__(10).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(35);
	var $export = __webpack_require__(21);
	var toObject = __webpack_require__(72);
	var call = __webpack_require__(112);
	var isArrayIter = __webpack_require__(111);
	var toLength = __webpack_require__(71);
	var createProperty = __webpack_require__(211);
	var getIterFn = __webpack_require__(76);
	
	$export($export.S + $export.F * !__webpack_require__(114)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(208);
	var step = __webpack_require__(217);
	var Iterators = __webpack_require__(37);
	var toIObject = __webpack_require__(28);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(113)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(21);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(220) });


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(45);
	var global = __webpack_require__(8);
	var ctx = __webpack_require__(35);
	var classof = __webpack_require__(107);
	var $export = __webpack_require__(21);
	var isObject = __webpack_require__(24);
	var aFunction = __webpack_require__(44);
	var anInstance = __webpack_require__(209);
	var forOf = __webpack_require__(213);
	var speciesConstructor = __webpack_require__(121);
	var task = __webpack_require__(122).set;
	var microtask = __webpack_require__(219)();
	var newPromiseCapabilityModule = __webpack_require__(66);
	var perform = __webpack_require__(118);
	var promiseResolve = __webpack_require__(119);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(9)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value);
	            if (domain) domain.exit();
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(225)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(48)($Promise, PROMISE);
	__webpack_require__(226)(PROMISE);
	Wrapper = __webpack_require__(10)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(114)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(8);
	var has = __webpack_require__(22);
	var DESCRIPTORS = __webpack_require__(20);
	var $export = __webpack_require__(21);
	var redefine = __webpack_require__(120);
	var META = __webpack_require__(218).KEY;
	var $fails = __webpack_require__(36);
	var shared = __webpack_require__(69);
	var setToStringTag = __webpack_require__(48);
	var uid = __webpack_require__(49);
	var wks = __webpack_require__(9);
	var wksExt = __webpack_require__(75);
	var wksDefine = __webpack_require__(74);
	var enumKeys = __webpack_require__(212);
	var isArray = __webpack_require__(215);
	var anObject = __webpack_require__(16);
	var isObject = __webpack_require__(24);
	var toIObject = __webpack_require__(28);
	var toPrimitive = __webpack_require__(73);
	var createDesc = __webpack_require__(38);
	var _create = __webpack_require__(115);
	var gOPNExt = __webpack_require__(223);
	var $GOPD = __webpack_require__(222);
	var $DP = __webpack_require__(18);
	var $keys = __webpack_require__(46);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(116).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(47).f = $propertyIsEnumerable;
	  __webpack_require__(67).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(45)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(23)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(21);
	var core = __webpack_require__(10);
	var global = __webpack_require__(8);
	var speciesConstructor = __webpack_require__(121);
	var promiseResolve = __webpack_require__(119);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(21);
	var newPromiseCapability = __webpack_require__(66);
	var perform = __webpack_require__(118);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(74)('asyncIterator');


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(74)('observable');


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(201), __esModule: true };

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(206), __esModule: true };

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(207), __esModule: true };

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _promise = __webpack_require__(126);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (fn) {
	  return function () {
	    var gen = fn.apply(this, arguments);
	    return new _promise2.default(function (resolve, reject) {
	      function step(key, arg) {
	        try {
	          var info = gen[key](arg);
	          var value = info.value;
	        } catch (error) {
	          reject(error);
	          return;
	        }
	
	        if (info.done) {
	          resolve(value);
	        } else {
	          return _promise2.default.resolve(value).then(function (value) {
	            step("next", value);
	          }, function (err) {
	            step("throw", err);
	          });
	        }
	      }
	
	      return step("next");
	    });
	  };
	};

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(150);


/***/ }),
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(131);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _typeof2 = __webpack_require__(52);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _util = __webpack_require__(2);
	
	var _validator = __webpack_require__(416);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _messages2 = __webpack_require__(405);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Encapsulates a validation schema.
	 *
	 *  @param descriptor An object declaring validation rules
	 *  for this schema.
	 */
	function Schema(descriptor) {
	  this.rules = null;
	  this._messages = _messages2.messages;
	  this.define(descriptor);
	}
	
	Schema.prototype = {
	  messages: function messages(_messages) {
	    if (_messages) {
	      this._messages = (0, _util.deepMerge)((0, _messages2.newMessages)(), _messages);
	    }
	    return this._messages;
	  },
	  define: function define(rules) {
	    if (!rules) {
	      throw new Error('Cannot configure a schema with no rules');
	    }
	    if ((typeof rules === 'undefined' ? 'undefined' : (0, _typeof3['default'])(rules)) !== 'object' || Array.isArray(rules)) {
	      throw new Error('Rules must be an object');
	    }
	    this.rules = {};
	    var z = void 0;
	    var item = void 0;
	    for (z in rules) {
	      if (rules.hasOwnProperty(z)) {
	        item = rules[z];
	        this.rules[z] = Array.isArray(item) ? item : [item];
	      }
	    }
	  },
	  validate: function validate(source_) {
	    var _this = this;
	
	    var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var oc = arguments[2];
	
	    var source = source_;
	    var options = o;
	    var callback = oc;
	    if (typeof options === 'function') {
	      callback = options;
	      options = {};
	    }
	    if (!this.rules || Object.keys(this.rules).length === 0) {
	      if (callback) {
	        callback();
	      }
	      return;
	    }
	    function complete(results) {
	      var i = void 0;
	      var field = void 0;
	      var errors = [];
	      var fields = {};
	
	      function add(e) {
	        if (Array.isArray(e)) {
	          errors = errors.concat.apply(errors, e);
	        } else {
	          errors.push(e);
	        }
	      }
	
	      for (i = 0; i < results.length; i++) {
	        add(results[i]);
	      }
	      if (!errors.length) {
	        errors = null;
	        fields = null;
	      } else {
	        for (i = 0; i < errors.length; i++) {
	          field = errors[i].field;
	          fields[field] = fields[field] || [];
	          fields[field].push(errors[i]);
	        }
	      }
	      callback(errors, fields);
	    }
	
	    if (options.messages) {
	      var messages = this.messages();
	      if (messages === _messages2.messages) {
	        messages = (0, _messages2.newMessages)();
	      }
	      (0, _util.deepMerge)(messages, options.messages);
	      options.messages = messages;
	    } else {
	      options.messages = this.messages();
	    }
	    var arr = void 0;
	    var value = void 0;
	    var series = {};
	    var keys = options.keys || Object.keys(this.rules);
	    keys.forEach(function (z) {
	      arr = _this.rules[z];
	      value = source[z];
	      arr.forEach(function (r) {
	        var rule = r;
	        if (typeof rule.transform === 'function') {
	          if (source === source_) {
	            source = (0, _extends3['default'])({}, source);
	          }
	          value = source[z] = rule.transform(value);
	        }
	        if (typeof rule === 'function') {
	          rule = {
	            validator: rule
	          };
	        } else {
	          rule = (0, _extends3['default'])({}, rule);
	        }
	        rule.validator = _this.getValidationMethod(rule);
	        rule.field = z;
	        rule.fullField = rule.fullField || z;
	        rule.type = _this.getType(rule);
	        if (!rule.validator) {
	          return;
	        }
	        series[z] = series[z] || [];
	        series[z].push({
	          rule: rule,
	          value: value,
	          source: source,
	          field: z
	        });
	      });
	    });
	    var errorFields = {};
	    (0, _util.asyncMap)(series, options, function (data, doIt) {
	      var rule = data.rule;
	      var deep = (rule.type === 'object' || rule.type === 'array') && ((0, _typeof3['default'])(rule.fields) === 'object' || (0, _typeof3['default'])(rule.defaultField) === 'object');
	      deep = deep && (rule.required || !rule.required && data.value);
	      rule.field = data.field;
	      function addFullfield(key, schema) {
	        return (0, _extends3['default'])({}, schema, {
	          fullField: rule.fullField + '.' + key
	        });
	      }
	
	      function cb() {
	        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	        var errors = e;
	        if (!Array.isArray(errors)) {
	          errors = [errors];
	        }
	        if (errors.length) {
	          (0, _util.warning)('async-validator:', errors);
	        }
	        if (errors.length && rule.message) {
	          errors = [].concat(rule.message);
	        }
	
	        errors = errors.map((0, _util.complementError)(rule));
	
	        if (options.first && errors.length) {
	          errorFields[rule.field] = 1;
	          return doIt(errors);
	        }
	        if (!deep) {
	          doIt(errors);
	        } else {
	          // if rule is required but the target object
	          // does not exist fail at the rule level and don't
	          // go deeper
	          if (rule.required && !data.value) {
	            if (rule.message) {
	              errors = [].concat(rule.message).map((0, _util.complementError)(rule));
	            } else if (options.error) {
	              errors = [options.error(rule, (0, _util.format)(options.messages.required, rule.field))];
	            } else {
	              errors = [];
	            }
	            return doIt(errors);
	          }
	
	          var fieldsSchema = {};
	          if (rule.defaultField) {
	            for (var k in data.value) {
	              if (data.value.hasOwnProperty(k)) {
	                fieldsSchema[k] = rule.defaultField;
	              }
	            }
	          }
	          fieldsSchema = (0, _extends3['default'])({}, fieldsSchema, data.rule.fields);
	          for (var f in fieldsSchema) {
	            if (fieldsSchema.hasOwnProperty(f)) {
	              var fieldSchema = Array.isArray(fieldsSchema[f]) ? fieldsSchema[f] : [fieldsSchema[f]];
	              fieldsSchema[f] = fieldSchema.map(addFullfield.bind(null, f));
	            }
	          }
	          var schema = new Schema(fieldsSchema);
	          schema.messages(options.messages);
	          if (data.rule.options) {
	            data.rule.options.messages = options.messages;
	            data.rule.options.error = options.error;
	          }
	          schema.validate(data.value, data.rule.options || options, function (errs) {
	            doIt(errs && errs.length ? errors.concat(errs) : errs);
	          });
	        }
	      }
	
	      var res = rule.validator(rule, data.value, cb, data.source, options);
	      if (res && res.then) {
	        res.then(function () {
	          return cb();
	        }, function (e) {
	          return cb(e);
	        });
	      }
	    }, function (results) {
	      complete(results);
	    });
	  },
	  getType: function getType(rule) {
	    if (rule.type === undefined && rule.pattern instanceof RegExp) {
	      rule.type = 'pattern';
	    }
	    if (typeof rule.validator !== 'function' && rule.type && !_validator2['default'].hasOwnProperty(rule.type)) {
	      throw new Error((0, _util.format)('Unknown rule type %s', rule.type));
	    }
	    return rule.type || 'string';
	  },
	  getValidationMethod: function getValidationMethod(rule) {
	    if (typeof rule.validator === 'function') {
	      return rule.validator;
	    }
	    var keys = Object.keys(rule);
	    var messageIndex = keys.indexOf('message');
	    if (messageIndex !== -1) {
	      keys.splice(messageIndex, 1);
	    }
	    if (keys.length === 1 && keys[0] === 'required') {
	      return _validator2['default'].required;
	    }
	    return _validator2['default'][this.getType(rule)] || false;
	  }
	};
	
	Schema.register = function register(type, validator) {
	  if (typeof validator !== 'function') {
	    throw new Error('Cannot register a validator by type, validator is not a function');
	  }
	  _validator2['default'][type] = validator;
	};
	
	Schema.messages = _messages2.messages;
	
	exports['default'] = Schema;
	module.exports = exports['default'];

/***/ }),
/* 405 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.newMessages = newMessages;
	function newMessages() {
	  return {
	    'default': 'Validation error on field %s',
	    required: '%s is required',
	    'enum': '%s must be one of %s',
	    whitespace: '%s cannot be empty',
	    date: {
	      format: '%s date %s is invalid for format %s',
	      parse: '%s date could not be parsed, %s is invalid ',
	      invalid: '%s date %s is invalid'
	    },
	    types: {
	      string: '%s is not a %s',
	      method: '%s is not a %s (function)',
	      array: '%s is not an %s',
	      object: '%s is not an %s',
	      number: '%s is not a %s',
	      date: '%s is not a %s',
	      boolean: '%s is not a %s',
	      integer: '%s is not an %s',
	      float: '%s is not a %s',
	      regexp: '%s is not a valid %s',
	      email: '%s is not a valid %s',
	      url: '%s is not a valid %s',
	      hex: '%s is not a valid %s'
	    },
	    string: {
	      len: '%s must be exactly %s characters',
	      min: '%s must be at least %s characters',
	      max: '%s cannot be longer than %s characters',
	      range: '%s must be between %s and %s characters'
	    },
	    number: {
	      len: '%s must equal %s',
	      min: '%s cannot be less than %s',
	      max: '%s cannot be greater than %s',
	      range: '%s must be between %s and %s'
	    },
	    array: {
	      len: '%s must be exactly %s in length',
	      min: '%s cannot be less than %s in length',
	      max: '%s cannot be greater than %s in length',
	      range: '%s must be between %s and %s in length'
	    },
	    pattern: {
	      mismatch: '%s value %s does not match pattern %s'
	    },
	    clone: function clone() {
	      var cloned = JSON.parse(JSON.stringify(this));
	      cloned.clone = this.clone;
	      return cloned;
	    }
	  };
	}
	
	var messages = exports.messages = newMessages();

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(2);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var ENUM = 'enum';
	
	/**
	 *  Rule for validating a value exists in an enumerable list.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param source The source object being validated.
	 *  @param errors An array of errors that this rule may add
	 *  validation errors to.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function enumerable(rule, value, source, errors, options) {
	  rule[ENUM] = Array.isArray(rule[ENUM]) ? rule[ENUM] : [];
	  if (rule[ENUM].indexOf(value) === -1) {
	    errors.push(util.format(options.messages[ENUM], rule.fullField, rule[ENUM].join(', ')));
	  }
	}
	
	exports['default'] = enumerable;
	module.exports = exports['default'];

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(2);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	/**
	 *  Rule for validating a regular expression pattern.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param source The source object being validated.
	 *  @param errors An array of errors that this rule may add
	 *  validation errors to.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function pattern(rule, value, source, errors, options) {
	  if (rule.pattern) {
	    if (rule.pattern instanceof RegExp) {
	      // if a RegExp instance is passed, reset `lastIndex` in case its `global`
	      // flag is accidentally set to `true`, which in a validation scenario
	      // is not necessary and the result might be misleading
	      rule.pattern.lastIndex = 0;
	      if (!rule.pattern.test(value)) {
	        errors.push(util.format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
	      }
	    } else if (typeof rule.pattern === 'string') {
	      var _pattern = new RegExp(rule.pattern);
	      if (!_pattern.test(value)) {
	        errors.push(util.format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
	      }
	    }
	  }
	}
	
	exports['default'] = pattern;
	module.exports = exports['default'];

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(2);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	/**
	 *  Rule for validating minimum and maximum allowed values.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param source The source object being validated.
	 *  @param errors An array of errors that this rule may add
	 *  validation errors to.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function range(rule, value, source, errors, options) {
	  var len = typeof rule.len === 'number';
	  var min = typeof rule.min === 'number';
	  var max = typeof rule.max === 'number';
	  // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）
	  var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
	  var val = value;
	  var key = null;
	  var num = typeof value === 'number';
	  var str = typeof value === 'string';
	  var arr = Array.isArray(value);
	  if (num) {
	    key = 'number';
	  } else if (str) {
	    key = 'string';
	  } else if (arr) {
	    key = 'array';
	  }
	  // if the value is not of a supported type for range validation
	  // the validation rule rule should use the
	  // type property to also test for a particular type
	  if (!key) {
	    return false;
	  }
	  if (arr) {
	    val = value.length;
	  }
	  if (str) {
	    // 处理码点大于U+010000的文字length属性不准确的bug，如"𠮷𠮷𠮷".lenght !== 3
	    val = value.replace(spRegexp, '_').length;
	  }
	  if (len) {
	    if (val !== rule.len) {
	      errors.push(util.format(options.messages[key].len, rule.fullField, rule.len));
	    }
	  } else if (min && !max && val < rule.min) {
	    errors.push(util.format(options.messages[key].min, rule.fullField, rule.min));
	  } else if (max && !min && val > rule.max) {
	    errors.push(util.format(options.messages[key].max, rule.fullField, rule.max));
	  } else if (min && max && (val < rule.min || val > rule.max)) {
	    errors.push(util.format(options.messages[key].range, rule.fullField, rule.min, rule.max));
	  }
	}
	
	exports['default'] = range;
	module.exports = exports['default'];

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(52);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _util = __webpack_require__(2);
	
	var util = _interopRequireWildcard(_util);
	
	var _required = __webpack_require__(129);
	
	var _required2 = _interopRequireDefault(_required);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/* eslint max-len:0 */
	
	var pattern = {
	  // http://emailregex.com/
	  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
	  url: new RegExp('^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$', 'i'),
	  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
	};
	
	var types = {
	  integer: function integer(value) {
	    return types.number(value) && parseInt(value, 10) === value;
	  },
	  float: function float(value) {
	    return types.number(value) && !types.integer(value);
	  },
	  array: function array(value) {
	    return Array.isArray(value);
	  },
	  regexp: function regexp(value) {
	    if (value instanceof RegExp) {
	      return true;
	    }
	    try {
	      return !!new RegExp(value);
	    } catch (e) {
	      return false;
	    }
	  },
	  date: function date(value) {
	    return typeof value.getTime === 'function' && typeof value.getMonth === 'function' && typeof value.getYear === 'function';
	  },
	  number: function number(value) {
	    if (isNaN(value)) {
	      return false;
	    }
	    return typeof value === 'number';
	  },
	  object: function object(value) {
	    return (typeof value === 'undefined' ? 'undefined' : (0, _typeof3['default'])(value)) === 'object' && !types.array(value);
	  },
	  method: function method(value) {
	    return typeof value === 'function';
	  },
	  email: function email(value) {
	    return typeof value === 'string' && !!value.match(pattern.email) && value.length < 255;
	  },
	  url: function url(value) {
	    return typeof value === 'string' && !!value.match(pattern.url);
	  },
	  hex: function hex(value) {
	    return typeof value === 'string' && !!value.match(pattern.hex);
	  }
	};
	
	/**
	 *  Rule for validating the type of a value.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param source The source object being validated.
	 *  @param errors An array of errors that this rule may add
	 *  validation errors to.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function type(rule, value, source, errors, options) {
	  if (rule.required && value === undefined) {
	    (0, _required2['default'])(rule, value, source, errors, options);
	    return;
	  }
	  var custom = ['integer', 'float', 'array', 'regexp', 'object', 'method', 'email', 'number', 'date', 'url', 'hex'];
	  var ruleType = rule.type;
	  if (custom.indexOf(ruleType) > -1) {
	    if (!types[ruleType](value)) {
	      errors.push(util.format(options.messages.types[ruleType], rule.fullField, rule.type));
	    }
	    // straight typeof check
	  } else if (ruleType && (typeof value === 'undefined' ? 'undefined' : (0, _typeof3['default'])(value)) !== rule.type) {
	    errors.push(util.format(options.messages.types[ruleType], rule.fullField, rule.type));
	  }
	}
	
	exports['default'] = type;
	module.exports = exports['default'];

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(2);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	/**
	 *  Rule for validating whitespace.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param source The source object being validated.
	 *  @param errors An array of errors that this rule may add
	 *  validation errors to.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function whitespace(rule, value, source, errors, options) {
	  if (/^\s+$/.test(value) || value === '') {
	    errors.push(util.format(options.messages.whitespace, rule.fullField));
	  }
	}
	
	exports['default'] = whitespace;
	module.exports = exports['default'];

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(7);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates an array.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function array(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value, 'array') && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options, 'array');
	    if (!(0, _util.isEmptyValue)(value, 'array')) {
	      _rule2['default'].type(rule, value, source, errors, options);
	      _rule2['default'].range(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = array;
	module.exports = exports['default'];

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(2);
	
	var _rule = __webpack_require__(7);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates a boolean.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function boolean(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (value !== undefined) {
	      _rule2['default'].type(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = boolean;
	module.exports = exports['default'];

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(7);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function date(rule, value, callback, source, options) {
	  // console.log('integer rule called %j', rule);
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  // console.log('validate on %s value', value);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (!(0, _util.isEmptyValue)(value)) {
	      var dateObject = void 0;
	
	      if (typeof value === 'number') {
	        dateObject = new Date(value);
	      } else {
	        dateObject = value;
	      }
	
	      _rule2['default'].type(rule, dateObject, source, errors, options);
	      if (dateObject) {
	        _rule2['default'].range(rule, dateObject.getTime(), source, errors, options);
	      }
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = date;
	module.exports = exports['default'];

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(7);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ENUM = 'enum';
	
	/**
	 *  Validates an enumerable list.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function enumerable(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (value) {
	      _rule2['default'][ENUM](rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = enumerable;
	module.exports = exports['default'];

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(7);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates a number is a floating point number.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function floatFn(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (value !== undefined) {
	      _rule2['default'].type(rule, value, source, errors, options);
	      _rule2['default'].range(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = floatFn;
	module.exports = exports['default'];

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _string = __webpack_require__(424);
	
	var _string2 = _interopRequireDefault(_string);
	
	var _method = __webpack_require__(418);
	
	var _method2 = _interopRequireDefault(_method);
	
	var _number = __webpack_require__(419);
	
	var _number2 = _interopRequireDefault(_number);
	
	var _boolean = __webpack_require__(412);
	
	var _boolean2 = _interopRequireDefault(_boolean);
	
	var _regexp = __webpack_require__(422);
	
	var _regexp2 = _interopRequireDefault(_regexp);
	
	var _integer = __webpack_require__(417);
	
	var _integer2 = _interopRequireDefault(_integer);
	
	var _float = __webpack_require__(415);
	
	var _float2 = _interopRequireDefault(_float);
	
	var _array = __webpack_require__(411);
	
	var _array2 = _interopRequireDefault(_array);
	
	var _object = __webpack_require__(420);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _enum = __webpack_require__(414);
	
	var _enum2 = _interopRequireDefault(_enum);
	
	var _pattern = __webpack_require__(421);
	
	var _pattern2 = _interopRequireDefault(_pattern);
	
	var _date = __webpack_require__(413);
	
	var _date2 = _interopRequireDefault(_date);
	
	var _required = __webpack_require__(423);
	
	var _required2 = _interopRequireDefault(_required);
	
	var _type = __webpack_require__(425);
	
	var _type2 = _interopRequireDefault(_type);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = {
	  string: _string2['default'],
	  method: _method2['default'],
	  number: _number2['default'],
	  boolean: _boolean2['default'],
	  regexp: _regexp2['default'],
	  integer: _integer2['default'],
	  float: _float2['default'],
	  array: _array2['default'],
	  object: _object2['default'],
	  'enum': _enum2['default'],
	  pattern: _pattern2['default'],
	  date: _date2['default'],
	  url: _type2['default'],
	  hex: _type2['default'],
	  email: _type2['default'],
	  required: _required2['default']
	};
	module.exports = exports['default'];

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(7);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates a number is an integer.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function integer(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (value !== undefined) {
	      _rule2['default'].type(rule, value, source, errors, options);
	      _rule2['default'].range(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = integer;
	module.exports = exports['default'];

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(7);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates a function.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function method(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (value !== undefined) {
	      _rule2['default'].type(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = method;
	module.exports = exports['default'];

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(7);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates a number.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function number(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (value !== undefined) {
	      _rule2['default'].type(rule, value, source, errors, options);
	      _rule2['default'].range(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = number;
	module.exports = exports['default'];

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(7);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates an object.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function object(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (value !== undefined) {
	      _rule2['default'].type(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = object;
	module.exports = exports['default'];

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(7);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates a regular expression pattern.
	 *
	 *  Performs validation when a rule only contains
	 *  a pattern property but is not declared as a string type.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function pattern(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value, 'string') && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (!(0, _util.isEmptyValue)(value, 'string')) {
	      _rule2['default'].pattern(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = pattern;
	module.exports = exports['default'];

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(7);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates the regular expression type.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function regexp(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (!(0, _util.isEmptyValue)(value)) {
	      _rule2['default'].type(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = regexp;
	module.exports = exports['default'];

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(52);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _rule = __webpack_require__(7);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function required(rule, value, callback, source, options) {
	  var errors = [];
	  var type = Array.isArray(value) ? 'array' : typeof value === 'undefined' ? 'undefined' : (0, _typeof3['default'])(value);
	  _rule2['default'].required(rule, value, source, errors, options, type);
	  callback(errors);
	}
	
	exports['default'] = required;
	module.exports = exports['default'];

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(7);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Performs validation for string types.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function string(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value, 'string') && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options, 'string');
	    if (!(0, _util.isEmptyValue)(value, 'string')) {
	      _rule2['default'].type(rule, value, source, errors, options);
	      _rule2['default'].range(rule, value, source, errors, options);
	      _rule2['default'].pattern(rule, value, source, errors, options);
	      if (rule.whitespace === true) {
	        _rule2['default'].whitespace(rule, value, source, errors, options);
	      }
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = string;
	module.exports = exports['default'];

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(7);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function type(rule, value, callback, source, options) {
	  var ruleType = rule.type;
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value, ruleType) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options, ruleType);
	    if (!(0, _util.isEmptyValue)(value, ruleType)) {
	      _rule2['default'].type(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = type;
	module.exports = exports['default'];

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(429), __esModule: true };

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(430), __esModule: true };

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(431), __esModule: true };

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(451);
	module.exports = __webpack_require__(41).Object.assign;


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(454);
	__webpack_require__(452);
	__webpack_require__(455);
	__webpack_require__(456);
	module.exports = __webpack_require__(41).Symbol;


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(453);
	__webpack_require__(457);
	module.exports = __webpack_require__(94).f('iterator');


/***/ }),
/* 432 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 433 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(31);
	var toLength = __webpack_require__(449);
	var toAbsoluteIndex = __webpack_require__(448);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(432);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(55);
	var gOPS = __webpack_require__(86);
	var pIE = __webpack_require__(56);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(19).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(132);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(137);
	var descriptor = __webpack_require__(57);
	var setToStringTag = __webpack_require__(87);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(29)(IteratorPrototype, __webpack_require__(32)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 440 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(58)('meta');
	var isObject = __webpack_require__(43);
	var has = __webpack_require__(26);
	var setDesc = __webpack_require__(30).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(42)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(25);
	var getKeys = __webpack_require__(55);
	var gOPS = __webpack_require__(86);
	var pIE = __webpack_require__(56);
	var toObject = __webpack_require__(91);
	var IObject = __webpack_require__(135);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(42)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(30);
	var anObject = __webpack_require__(53);
	var getKeys = __webpack_require__(55);
	
	module.exports = __webpack_require__(25) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(56);
	var createDesc = __webpack_require__(57);
	var toIObject = __webpack_require__(31);
	var toPrimitive = __webpack_require__(92);
	var has = __webpack_require__(26);
	var IE8_DOM_DEFINE = __webpack_require__(134);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(25) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(31);
	var gOPN = __webpack_require__(138).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(26);
	var toObject = __webpack_require__(91);
	var IE_PROTO = __webpack_require__(88)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(90);
	var defined = __webpack_require__(82);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(90);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(90);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(433);
	var step = __webpack_require__(440);
	var Iterators = __webpack_require__(85);
	var toIObject = __webpack_require__(31);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(136)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(84);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(442) });


/***/ }),
/* 452 */
/***/ (function(module, exports) {



/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(447)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(136)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(19);
	var has = __webpack_require__(26);
	var DESCRIPTORS = __webpack_require__(25);
	var $export = __webpack_require__(84);
	var redefine = __webpack_require__(140);
	var META = __webpack_require__(441).KEY;
	var $fails = __webpack_require__(42);
	var shared = __webpack_require__(89);
	var setToStringTag = __webpack_require__(87);
	var uid = __webpack_require__(58);
	var wks = __webpack_require__(32);
	var wksExt = __webpack_require__(94);
	var wksDefine = __webpack_require__(93);
	var enumKeys = __webpack_require__(436);
	var isArray = __webpack_require__(438);
	var anObject = __webpack_require__(53);
	var isObject = __webpack_require__(43);
	var toObject = __webpack_require__(91);
	var toIObject = __webpack_require__(31);
	var toPrimitive = __webpack_require__(92);
	var createDesc = __webpack_require__(57);
	var _create = __webpack_require__(137);
	var gOPNExt = __webpack_require__(445);
	var $GOPD = __webpack_require__(444);
	var $GOPS = __webpack_require__(86);
	var $DP = __webpack_require__(30);
	var $keys = __webpack_require__(55);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(138).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(56).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(54)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(29)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(93)('asyncIterator');


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(93)('observable');


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(450);
	var global = __webpack_require__(19);
	var hide = __webpack_require__(29);
	var Iterators = __webpack_require__(85);
	var TO_STRING_TAG = __webpack_require__(32)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 458 */
/***/ (function(module, exports) {

	'use strict';
	
	var isMergeableObject = function isMergeableObject(value) {
		return isNonNullObject(value)
			&& !isSpecial(value)
	};
	
	function isNonNullObject(value) {
		return !!value && typeof value === 'object'
	}
	
	function isSpecial(value) {
		var stringValue = Object.prototype.toString.call(value);
	
		return stringValue === '[object RegExp]'
			|| stringValue === '[object Date]'
			|| isReactElement(value)
	}
	
	// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
	var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;
	
	function isReactElement(value) {
		return value.$$typeof === REACT_ELEMENT_TYPE
	}
	
	function emptyTarget(val) {
	    return Array.isArray(val) ? [] : {}
	}
	
	function cloneIfNecessary(value, optionsArgument) {
	    var clone = optionsArgument && optionsArgument.clone === true;
	    return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
	}
	
	function defaultArrayMerge(target, source, optionsArgument) {
	    var destination = target.slice();
	    source.forEach(function(e, i) {
	        if (typeof destination[i] === 'undefined') {
	            destination[i] = cloneIfNecessary(e, optionsArgument);
	        } else if (isMergeableObject(e)) {
	            destination[i] = deepmerge(target[i], e, optionsArgument);
	        } else if (target.indexOf(e) === -1) {
	            destination.push(cloneIfNecessary(e, optionsArgument));
	        }
	    });
	    return destination
	}
	
	function mergeObject(target, source, optionsArgument) {
	    var destination = {};
	    if (isMergeableObject(target)) {
	        Object.keys(target).forEach(function(key) {
	            destination[key] = cloneIfNecessary(target[key], optionsArgument);
	        });
	    }
	    Object.keys(source).forEach(function(key) {
	        if (!isMergeableObject(source[key]) || !target[key]) {
	            destination[key] = cloneIfNecessary(source[key], optionsArgument);
	        } else {
	            destination[key] = deepmerge(target[key], source[key], optionsArgument);
	        }
	    });
	    return destination
	}
	
	function deepmerge(target, source, optionsArgument) {
	    var sourceIsArray = Array.isArray(source);
	    var targetIsArray = Array.isArray(target);
	    var options = optionsArgument || { arrayMerge: defaultArrayMerge };
	    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
	
	    if (!sourceAndTargetTypesMatch) {
	        return cloneIfNecessary(source, optionsArgument)
	    } else if (sourceIsArray) {
	        var arrayMerge = options.arrayMerge || defaultArrayMerge;
	        return arrayMerge(target, source, optionsArgument)
	    } else {
	        return mergeObject(target, source, optionsArgument)
	    }
	}
	
	deepmerge.all = function deepmergeAll(array, optionsArgument) {
	    if (!Array.isArray(array) || array.length < 2) {
	        throw new Error('first argument should be an array with at least two elements')
	    }
	
	    // we are sure there are at least 2 values, so it is safe to have no initial value
	    return array.reduce(function(prev, next) {
	        return deepmerge(prev, next, optionsArgument)
	    })
	};
	
	var deepmerge_1 = deepmerge;
	
	module.exports = deepmerge_1;


/***/ }),
/* 459 */
/***/ (function(module, exports) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 99);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 99:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button-group.vue?vue&type=template&id=3d8661d0&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("div", { staticClass: "el-button-group" }, [_vm._t("default")], 2)
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/button/src/button-group.vue?vue&type=template&id=3d8661d0&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button-group.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	
	/* harmony default export */ var button_groupvue_type_script_lang_js_ = ({
	  name: 'ElButtonGroup'
	});
	// CONCATENATED MODULE: ./packages/button/src/button-group.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_button_groupvue_type_script_lang_js_ = (button_groupvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/button/src/button-group.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_button_groupvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/button/src/button-group.vue"
	/* harmony default export */ var button_group = (component.exports);
	// CONCATENATED MODULE: ./packages/button-group/index.js
	
	
	/* istanbul ignore next */
	button_group.install = function (Vue) {
	  Vue.component(button_group.name, button_group);
	};
	
	/* harmony default export */ var packages_button_group = __webpack_exports__["default"] = (button_group);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 460 */
/***/ (function(module, exports) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 97);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 97:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button.vue?vue&type=template&id=ca859fb4&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "button",
	    {
	      staticClass: "el-button",
	      class: [
	        _vm.type ? "el-button--" + _vm.type : "",
	        _vm.buttonSize ? "el-button--" + _vm.buttonSize : "",
	        {
	          "is-disabled": _vm.buttonDisabled,
	          "is-loading": _vm.loading,
	          "is-plain": _vm.plain,
	          "is-round": _vm.round,
	          "is-circle": _vm.circle
	        }
	      ],
	      attrs: {
	        disabled: _vm.buttonDisabled || _vm.loading,
	        autofocus: _vm.autofocus,
	        type: _vm.nativeType
	      },
	      on: { click: _vm.handleClick }
	    },
	    [
	      _vm.loading ? _c("i", { staticClass: "el-icon-loading" }) : _vm._e(),
	      _vm.icon && !_vm.loading ? _c("i", { class: _vm.icon }) : _vm._e(),
	      _vm.$slots.default ? _c("span", [_vm._t("default")], 2) : _vm._e()
	    ]
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/button/src/button.vue?vue&type=template&id=ca859fb4&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var buttonvue_type_script_lang_js_ = ({
	  name: 'ElButton',
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  props: {
	    type: {
	      type: String,
	      default: 'default'
	    },
	    size: String,
	    icon: {
	      type: String,
	      default: ''
	    },
	    nativeType: {
	      type: String,
	      default: 'button'
	    },
	    loading: Boolean,
	    disabled: Boolean,
	    plain: Boolean,
	    autofocus: Boolean,
	    round: Boolean,
	    circle: Boolean
	  },
	
	  computed: {
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    buttonSize: function buttonSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    buttonDisabled: function buttonDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    }
	  },
	
	  methods: {
	    handleClick: function handleClick(evt) {
	      this.$emit('click', evt);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/button/src/button.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_buttonvue_type_script_lang_js_ = (buttonvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/button/src/button.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_buttonvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/button/src/button.vue"
	/* harmony default export */ var src_button = (component.exports);
	// CONCATENATED MODULE: ./packages/button/index.js
	
	
	/* istanbul ignore next */
	src_button.install = function (Vue) {
	  Vue.component(src_button.name, src_button);
	};
	
	/* harmony default export */ var packages_button = __webpack_exports__["default"] = (src_button);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 59);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 15:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(99);
	
	/***/ }),
	
	/***/ 18:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(141);
	
	/***/ }),
	
	/***/ 21:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(60);
	
	/***/ }),
	
	/***/ 26:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(130);
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(15);
	
	/***/ }),
	
	/***/ 31:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(102);
	
	/***/ }),
	
	/***/ 40:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(100);
	
	/***/ }),
	
	/***/ 51:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(143);
	
	/***/ }),
	
	/***/ 59:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-panel.vue?vue&type=template&id=34932346&
	var cascader_panelvue_type_template_id_34932346_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      class: ["el-cascader-panel", _vm.border && "is-bordered"],
	      on: { keydown: _vm.handleKeyDown }
	    },
	    _vm._l(_vm.menus, function(menu, index) {
	      return _c("cascader-menu", {
	        key: index,
	        ref: "menu",
	        refInFor: true,
	        attrs: { index: index, nodes: menu }
	      })
	    }),
	    1
	  )
	}
	var staticRenderFns = []
	cascader_panelvue_type_template_id_34932346_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-panel.vue?vue&type=template&id=34932346&
	
	// EXTERNAL MODULE: external "babel-helper-vue-jsx-merge-props"
	var external_babel_helper_vue_jsx_merge_props_ = __webpack_require__(26);
	var external_babel_helper_vue_jsx_merge_props_default = /*#__PURE__*/__webpack_require__.n(external_babel_helper_vue_jsx_merge_props_);
	
	// EXTERNAL MODULE: external "element-ui/lib/scrollbar"
	var scrollbar_ = __webpack_require__(15);
	var scrollbar_default = /*#__PURE__*/__webpack_require__.n(scrollbar_);
	
	// EXTERNAL MODULE: external "element-ui/lib/checkbox"
	var checkbox_ = __webpack_require__(18);
	var checkbox_default = /*#__PURE__*/__webpack_require__.n(checkbox_);
	
	// EXTERNAL MODULE: external "element-ui/lib/radio"
	var radio_ = __webpack_require__(51);
	var radio_default = /*#__PURE__*/__webpack_require__.n(radio_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/util"
	var util_ = __webpack_require__(3);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-node.vue?vue&type=script&lang=js&
	
	
	
	
	
	
	var stopPropagation = function stopPropagation(e) {
	  return e.stopPropagation();
	};
	
	/* harmony default export */ var cascader_nodevue_type_script_lang_js_ = ({
	  inject: ['panel'],
	
	  components: {
	    ElCheckbox: checkbox_default.a,
	    ElRadio: radio_default.a
	  },
	
	  props: {
	    node: {
	      required: true
	    },
	    nodeId: String
	  },
	
	  computed: {
	    config: function config() {
	      return this.panel.config;
	    },
	    isLeaf: function isLeaf() {
	      return this.node.isLeaf;
	    },
	    isDisabled: function isDisabled() {
	      return this.node.isDisabled;
	    },
	    checkedValue: function checkedValue() {
	      return this.panel.checkedValue;
	    },
	    isChecked: function isChecked() {
	      return this.node.isSameNode(this.checkedValue);
	    },
	    inActivePath: function inActivePath() {
	      return this.isInPath(this.panel.activePath);
	    },
	    inCheckedPath: function inCheckedPath() {
	      var _this = this;
	
	      if (!this.config.checkStrictly) return false;
	
	      return this.panel.checkedNodePaths.some(function (checkedPath) {
	        return _this.isInPath(checkedPath);
	      });
	    },
	    value: function value() {
	      return this.node.getValueByOption();
	    }
	  },
	
	  methods: {
	    handleExpand: function handleExpand() {
	      var _this2 = this;
	
	      var panel = this.panel,
	          node = this.node,
	          isDisabled = this.isDisabled,
	          config = this.config;
	      var multiple = config.multiple,
	          checkStrictly = config.checkStrictly;
	
	
	      if (!checkStrictly && isDisabled || node.loading) return;
	
	      if (config.lazy && !node.loaded) {
	        panel.lazyLoad(node, function () {
	          // do not use cached leaf value here, invoke this.isLeaf to get new value.
	          var isLeaf = _this2.isLeaf;
	
	
	          if (!isLeaf) _this2.handleExpand();
	          if (multiple) {
	            // if leaf sync checked state, else clear checked state
	            var checked = isLeaf ? node.checked : false;
	            _this2.handleMultiCheckChange(checked);
	          }
	        });
	      } else {
	        panel.handleExpand(node);
	      }
	    },
	    handleCheckChange: function handleCheckChange() {
	      var panel = this.panel,
	          value = this.value,
	          node = this.node;
	
	      panel.handleCheckChange(value);
	      panel.handleExpand(node);
	    },
	    handleMultiCheckChange: function handleMultiCheckChange(checked) {
	      this.node.doCheck(checked);
	      this.panel.calculateMultiCheckedValue();
	    },
	    isInPath: function isInPath(pathNodes) {
	      var node = this.node;
	
	      var selectedPathNode = pathNodes[node.level - 1] || {};
	      return selectedPathNode.uid === node.uid;
	    },
	    renderPrefix: function renderPrefix(h) {
	      var isLeaf = this.isLeaf,
	          isChecked = this.isChecked,
	          config = this.config;
	      var checkStrictly = config.checkStrictly,
	          multiple = config.multiple;
	
	
	      if (multiple) {
	        return this.renderCheckbox(h);
	      } else if (checkStrictly) {
	        return this.renderRadio(h);
	      } else if (isLeaf && isChecked) {
	        return this.renderCheckIcon(h);
	      }
	
	      return null;
	    },
	    renderPostfix: function renderPostfix(h) {
	      var node = this.node,
	          isLeaf = this.isLeaf;
	
	
	      if (node.loading) {
	        return this.renderLoadingIcon(h);
	      } else if (!isLeaf) {
	        return this.renderExpandIcon(h);
	      }
	
	      return null;
	    },
	    renderCheckbox: function renderCheckbox(h) {
	      var node = this.node,
	          config = this.config,
	          isDisabled = this.isDisabled;
	
	      var events = {
	        on: { change: this.handleMultiCheckChange },
	        nativeOn: {}
	      };
	
	      if (config.checkStrictly) {
	        // when every node is selectable, click event should not trigger expand event.
	        events.nativeOn.click = stopPropagation;
	      }
	
	      return h('el-checkbox', external_babel_helper_vue_jsx_merge_props_default()([{
	        attrs: {
	          value: node.checked,
	          indeterminate: node.indeterminate,
	          disabled: isDisabled
	        }
	      }, events]));
	    },
	    renderRadio: function renderRadio(h) {
	      var checkedValue = this.checkedValue,
	          value = this.value,
	          isDisabled = this.isDisabled;
	
	      // to keep same reference if value cause radio's checked state is calculated by reference comparision;
	
	      if (Object(util_["isEqual"])(value, checkedValue)) {
	        value = checkedValue;
	      }
	
	      return h(
	        'el-radio',
	        {
	          attrs: {
	            value: checkedValue,
	            label: value,
	            disabled: isDisabled
	          },
	          on: {
	            'change': this.handleCheckChange
	          },
	          nativeOn: {
	            'click': stopPropagation
	          }
	        },
	        [h('span')]
	      );
	    },
	    renderCheckIcon: function renderCheckIcon(h) {
	      return h('i', { 'class': 'el-icon-check el-cascader-node__prefix' });
	    },
	    renderLoadingIcon: function renderLoadingIcon(h) {
	      return h('i', { 'class': 'el-icon-loading el-cascader-node__postfix' });
	    },
	    renderExpandIcon: function renderExpandIcon(h) {
	      return h('i', { 'class': 'el-icon-arrow-right el-cascader-node__postfix' });
	    },
	    renderContent: function renderContent(h) {
	      var panel = this.panel,
	          node = this.node;
	
	      var render = panel.renderLabelFn;
	      var vnode = render ? render({ node: node, data: node.data }) : null;
	
	      return h(
	        'span',
	        { 'class': 'el-cascader-node__label' },
	        [vnode || node.label]
	      );
	    }
	  },
	
	  render: function render(h) {
	    var _this3 = this;
	
	    var inActivePath = this.inActivePath,
	        inCheckedPath = this.inCheckedPath,
	        isChecked = this.isChecked,
	        isLeaf = this.isLeaf,
	        isDisabled = this.isDisabled,
	        config = this.config,
	        nodeId = this.nodeId;
	    var expandTrigger = config.expandTrigger,
	        checkStrictly = config.checkStrictly,
	        multiple = config.multiple;
	
	    var disabled = !checkStrictly && isDisabled;
	    var events = { on: {} };
	
	    if (expandTrigger === 'click') {
	      events.on.click = this.handleExpand;
	    } else {
	      events.on.mouseenter = function (e) {
	        _this3.handleExpand();
	        _this3.$emit('expand', e);
	      };
	      events.on.focus = function (e) {
	        _this3.handleExpand();
	        _this3.$emit('expand', e);
	      };
	    }
	    if (isLeaf && !isDisabled && !checkStrictly && !multiple) {
	      events.on.click = this.handleCheckChange;
	    }
	
	    return h(
	      'li',
	      external_babel_helper_vue_jsx_merge_props_default()([{
	        attrs: {
	          role: 'menuitem',
	          id: nodeId,
	          'aria-expanded': inActivePath,
	          tabindex: disabled ? null : -1
	        },
	        'class': {
	          'el-cascader-node': true,
	          'is-selectable': checkStrictly,
	          'in-active-path': inActivePath,
	          'in-checked-path': inCheckedPath,
	          'is-active': isChecked,
	          'is-disabled': disabled
	        }
	      }, events]),
	      [this.renderPrefix(h), this.renderContent(h), this.renderPostfix(h)]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-node.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_cascader_nodevue_type_script_lang_js_ = (cascader_nodevue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-node.vue
	var cascader_node_render, cascader_node_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_cascader_nodevue_type_script_lang_js_,
	  cascader_node_render,
	  cascader_node_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/cascader-panel/src/cascader-node.vue"
	/* harmony default export */ var cascader_node = (component.exports);
	// EXTERNAL MODULE: external "element-ui/lib/mixins/locale"
	var locale_ = __webpack_require__(6);
	var locale_default = /*#__PURE__*/__webpack_require__.n(locale_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-menu.vue?vue&type=script&lang=js&
	
	
	
	
	
	
	
	/* harmony default export */ var cascader_menuvue_type_script_lang_js_ = ({
	  name: 'ElCascaderMenu',
	
	  mixins: [locale_default.a],
	
	  inject: ['panel'],
	
	  components: {
	    ElScrollbar: scrollbar_default.a,
	    CascaderNode: cascader_node
	  },
	
	  props: {
	    nodes: {
	      type: Array,
	      required: true
	    },
	    index: Number
	  },
	
	  data: function data() {
	    return {
	      activeNode: null,
	      hoverTimer: null,
	      id: Object(util_["generateId"])()
	    };
	  },
	
	
	  computed: {
	    isEmpty: function isEmpty() {
	      return !this.nodes.length;
	    },
	    menuId: function menuId() {
	      return 'cascader-menu-' + this.id + '-' + this.index;
	    }
	  },
	
	  methods: {
	    handleExpand: function handleExpand(e) {
	      this.activeNode = e.target;
	    },
	    handleMouseMove: function handleMouseMove(e) {
	      var activeNode = this.activeNode,
	          hoverTimer = this.hoverTimer;
	      var hoverZone = this.$refs.hoverZone;
	
	
	      if (!activeNode || !hoverZone) return;
	
	      if (activeNode.contains(e.target)) {
	        clearTimeout(hoverTimer);
	
	        var _$el$getBoundingClien = this.$el.getBoundingClientRect(),
	            left = _$el$getBoundingClien.left;
	
	        var startX = e.clientX - left;
	        var _$el = this.$el,
	            offsetWidth = _$el.offsetWidth,
	            offsetHeight = _$el.offsetHeight;
	
	        var top = activeNode.offsetTop;
	        var bottom = top + activeNode.offsetHeight;
	
	        hoverZone.innerHTML = '\n          <path style="pointer-events: auto;" fill="transparent" d="M' + startX + ' ' + top + ' L' + offsetWidth + ' 0 V' + top + ' Z" />\n          <path style="pointer-events: auto;" fill="transparent" d="M' + startX + ' ' + bottom + ' L' + offsetWidth + ' ' + offsetHeight + ' V' + bottom + ' Z" />\n        ';
	      } else if (!hoverTimer) {
	        this.hoverTimer = setTimeout(this.clearHoverZone, this.panel.config.hoverThreshold);
	      }
	    },
	    clearHoverZone: function clearHoverZone() {
	      var hoverZone = this.$refs.hoverZone;
	
	      if (!hoverZone) return;
	      hoverZone.innerHTML = '';
	    },
	    renderEmptyText: function renderEmptyText(h) {
	      return h(
	        'div',
	        { 'class': 'el-cascader-menu__empty-text' },
	        [this.t('el.cascader.noData')]
	      );
	    },
	    renderNodeList: function renderNodeList(h) {
	      var menuId = this.menuId;
	      var isHoverMenu = this.panel.isHoverMenu;
	
	      var events = { on: {} };
	
	      if (isHoverMenu) {
	        events.on.expand = this.handleExpand;
	      }
	
	      var nodes = this.nodes.map(function (node, index) {
	        var hasChildren = node.hasChildren;
	
	        return h('cascader-node', external_babel_helper_vue_jsx_merge_props_default()([{
	          key: node.uid,
	          attrs: { node: node,
	            'node-id': menuId + '-' + index,
	            'aria-haspopup': hasChildren,
	            'aria-owns': hasChildren ? menuId : null
	          }
	        }, events]));
	      });
	
	      return [].concat(nodes, [isHoverMenu ? h('svg', { ref: 'hoverZone', 'class': 'el-cascader-menu__hover-zone' }) : null]);
	    }
	  },
	
	  render: function render(h) {
	    var isEmpty = this.isEmpty,
	        menuId = this.menuId;
	
	    var events = { nativeOn: {} };
	
	    // optimize hover to expand experience (#8010)
	    if (this.panel.isHoverMenu) {
	      events.nativeOn.mousemove = this.handleMouseMove;
	      // events.nativeOn.mouseleave = this.clearHoverZone;
	    }
	
	    return h(
	      'el-scrollbar',
	      external_babel_helper_vue_jsx_merge_props_default()([{
	        attrs: {
	          tag: 'ul',
	          role: 'menu',
	          id: menuId,
	
	          'wrap-class': 'el-cascader-menu__wrap',
	          'view-class': {
	            'el-cascader-menu__list': true,
	            'is-empty': isEmpty
	          }
	        },
	        'class': 'el-cascader-menu' }, events]),
	      [isEmpty ? this.renderEmptyText(h) : this.renderNodeList(h)]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-menu.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_cascader_menuvue_type_script_lang_js_ = (cascader_menuvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-menu.vue
	var cascader_menu_render, cascader_menu_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var cascader_menu_component = Object(componentNormalizer["a" /* default */])(
	  src_cascader_menuvue_type_script_lang_js_,
	  cascader_menu_render,
	  cascader_menu_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var cascader_menu_api; }
	cascader_menu_component.options.__file = "packages/cascader-panel/src/cascader-menu.vue"
	/* harmony default export */ var cascader_menu = (cascader_menu_component.exports);
	// EXTERNAL MODULE: external "element-ui/lib/utils/shared"
	var shared_ = __webpack_require__(21);
	
	// CONCATENATED MODULE: ./packages/cascader-panel/src/node.js
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	
	
	
	var uid = 0;
	
	var node_Node = function () {
	  function Node(data, config, parentNode) {
	    _classCallCheck(this, Node);
	
	    this.data = data;
	    this.config = config;
	    this.parent = parentNode || null;
	    this.level = !this.parent ? 1 : this.parent.level + 1;
	    this.uid = uid++;
	
	    this.initState();
	    this.initChildren();
	  }
	
	  Node.prototype.initState = function initState() {
	    var _config = this.config,
	        valueKey = _config.value,
	        labelKey = _config.label;
	
	
	    this.value = this.data[valueKey];
	    this.label = this.data[labelKey];
	    this.pathNodes = this.calculatePathNodes();
	    this.path = this.pathNodes.map(function (node) {
	      return node.value;
	    });
	    this.pathLabels = this.pathNodes.map(function (node) {
	      return node.label;
	    });
	
	    // lazy load
	    this.loading = false;
	    this.loaded = false;
	  };
	
	  Node.prototype.initChildren = function initChildren() {
	    var _this = this;
	
	    var config = this.config;
	
	    var childrenKey = config.children;
	    var childrenData = this.data[childrenKey];
	    this.hasChildren = Array.isArray(childrenData);
	    this.children = (childrenData || []).map(function (child) {
	      return new Node(child, config, _this);
	    });
	  };
	
	  Node.prototype.calculatePathNodes = function calculatePathNodes() {
	    var nodes = [this];
	    var parent = this.parent;
	
	    while (parent) {
	      nodes.unshift(parent);
	      parent = parent.parent;
	    }
	
	    return nodes;
	  };
	
	  Node.prototype.getPath = function getPath() {
	    return this.path;
	  };
	
	  Node.prototype.getValue = function getValue() {
	    return this.value;
	  };
	
	  Node.prototype.getValueByOption = function getValueByOption() {
	    return this.config.emitPath ? this.getPath() : this.getValue();
	  };
	
	  Node.prototype.getText = function getText(allLevels, separator) {
	    return allLevels ? this.pathLabels.join(separator) : this.label;
	  };
	
	  Node.prototype.isSameNode = function isSameNode(checkedValue) {
	    var value = this.getValueByOption();
	    return this.config.multiple && Array.isArray(checkedValue) ? checkedValue.some(function (val) {
	      return Object(util_["isEqual"])(val, value);
	    }) : Object(util_["isEqual"])(checkedValue, value);
	  };
	
	  Node.prototype.broadcast = function broadcast(event) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var handlerName = 'onParent' + Object(util_["capitalize"])(event);
	
	    this.children.forEach(function (child) {
	      if (child) {
	        // bottom up
	        child.broadcast.apply(child, [event].concat(args));
	        child[handlerName] && child[handlerName].apply(child, args);
	      }
	    });
	  };
	
	  Node.prototype.emit = function emit(event) {
	    var parent = this.parent;
	
	    var handlerName = 'onChild' + Object(util_["capitalize"])(event);
	    if (parent) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        args[_key2 - 1] = arguments[_key2];
	      }
	
	      parent[handlerName] && parent[handlerName].apply(parent, args);
	      parent.emit.apply(parent, [event].concat(args));
	    }
	  };
	
	  Node.prototype.onParentCheck = function onParentCheck(checked) {
	    if (!this.isDisabled) {
	      this.setCheckState(checked);
	    }
	  };
	
	  Node.prototype.onChildCheck = function onChildCheck() {
	    var children = this.children;
	
	    var validChildren = children.filter(function (child) {
	      return !child.isDisabled;
	    });
	    var checked = validChildren.length ? validChildren.every(function (child) {
	      return child.checked;
	    }) : false;
	
	    this.setCheckState(checked);
	  };
	
	  Node.prototype.setCheckState = function setCheckState(checked) {
	    var totalNum = this.children.length;
	    var checkedNum = this.children.reduce(function (c, p) {
	      var num = p.checked ? 1 : p.indeterminate ? 0.5 : 0;
	      return c + num;
	    }, 0);
	
	    this.checked = checked;
	    this.indeterminate = checkedNum !== totalNum && checkedNum > 0;
	  };
	
	  Node.prototype.syncCheckState = function syncCheckState(checkedValue) {
	    var value = this.getValueByOption();
	    var checked = this.isSameNode(checkedValue, value);
	
	    this.doCheck(checked);
	  };
	
	  Node.prototype.doCheck = function doCheck(checked) {
	    if (this.checked !== checked) {
	      if (this.config.checkStrictly) {
	        this.checked = checked;
	      } else {
	        // bottom up to unify the calculation of the indeterminate state
	        this.broadcast('check', checked);
	        this.setCheckState(checked);
	        this.emit('check');
	      }
	    }
	  };
	
	  _createClass(Node, [{
	    key: 'isDisabled',
	    get: function get() {
	      var data = this.data,
	          parent = this.parent,
	          config = this.config;
	
	      var disabledKey = config.disabled;
	      var checkStrictly = config.checkStrictly;
	
	      return data[disabledKey] || !checkStrictly && parent && parent.isDisabled;
	    }
	  }, {
	    key: 'isLeaf',
	    get: function get() {
	      var data = this.data,
	          loaded = this.loaded,
	          hasChildren = this.hasChildren,
	          children = this.children;
	      var _config2 = this.config,
	          lazy = _config2.lazy,
	          leafKey = _config2.leaf;
	
	      if (lazy) {
	        var isLeaf = Object(shared_["isDef"])(data[leafKey]) ? data[leafKey] : loaded ? !children.length : false;
	        this.hasChildren = !isLeaf;
	        return isLeaf;
	      }
	      return !hasChildren;
	    }
	  }]);
	
	  return Node;
	}();
	
	/* harmony default export */ var src_node = (node_Node);
	// CONCATENATED MODULE: ./packages/cascader-panel/src/store.js
	function store_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	
	
	
	var flatNodes = function flatNodes(data, leafOnly) {
	  return data.reduce(function (res, node) {
	    if (node.isLeaf) {
	      res.push(node);
	    } else {
	      !leafOnly && res.push(node);
	      res = res.concat(flatNodes(node.children, leafOnly));
	    }
	    return res;
	  }, []);
	};
	
	var store_Store = function () {
	  function Store(data, config) {
	    store_classCallCheck(this, Store);
	
	    this.config = config;
	    this.initNodes(data);
	  }
	
	  Store.prototype.initNodes = function initNodes(data) {
	    var _this = this;
	
	    data = Object(util_["coerceTruthyValueToArray"])(data);
	    this.nodes = data.map(function (nodeData) {
	      return new src_node(nodeData, _this.config);
	    });
	    this.flattedNodes = this.getFlattedNodes(false, false);
	    this.leafNodes = this.getFlattedNodes(true, false);
	  };
	
	  Store.prototype.appendNode = function appendNode(nodeData, parentNode) {
	    var node = new src_node(nodeData, this.config, parentNode);
	    var children = parentNode ? parentNode.children : this.nodes;
	
	    children.push(node);
	  };
	
	  Store.prototype.appendNodes = function appendNodes(nodeDataList, parentNode) {
	    var _this2 = this;
	
	    nodeDataList = Object(util_["coerceTruthyValueToArray"])(nodeDataList);
	    nodeDataList.forEach(function (nodeData) {
	      return _this2.appendNode(nodeData, parentNode);
	    });
	  };
	
	  Store.prototype.getNodes = function getNodes() {
	    return this.nodes;
	  };
	
	  Store.prototype.getFlattedNodes = function getFlattedNodes(leafOnly) {
	    var cached = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    var cachedNodes = leafOnly ? this.leafNodes : this.flattedNodes;
	    return cached ? cachedNodes : flatNodes(this.nodes, leafOnly);
	  };
	
	  Store.prototype.getNodeByValue = function getNodeByValue(value) {
	    if (value) {
	      var nodes = this.getFlattedNodes(false, !this.config.lazy).filter(function (node) {
	        return Object(util_["valueEquals"])(node.path, value) || node.value === value;
	      });
	      return nodes && nodes.length ? nodes[0] : null;
	    }
	    return null;
	  };
	
	  return Store;
	}();
	
	/* harmony default export */ var src_store = (store_Store);
	// EXTERNAL MODULE: external "element-ui/lib/utils/merge"
	var merge_ = __webpack_require__(9);
	var merge_default = /*#__PURE__*/__webpack_require__.n(merge_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/aria-utils"
	var aria_utils_ = __webpack_require__(40);
	var aria_utils_default = /*#__PURE__*/__webpack_require__.n(aria_utils_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/scroll-into-view"
	var scroll_into_view_ = __webpack_require__(31);
	var scroll_into_view_default = /*#__PURE__*/__webpack_require__.n(scroll_into_view_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-panel.vue?vue&type=script&lang=js&
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	var KeyCode = aria_utils_default.a.keys;
	
	var DefaultProps = {
	  expandTrigger: 'click', // or hover
	  multiple: false,
	  checkStrictly: false, // whether all nodes can be selected
	  emitPath: true, // wether to emit an array of all levels value in which node is located
	  lazy: false,
	  lazyLoad: util_["noop"],
	  value: 'value',
	  label: 'label',
	  children: 'children',
	  leaf: 'leaf',
	  disabled: 'disabled',
	  hoverThreshold: 500
	};
	
	var cascader_panelvue_type_script_lang_js_isLeaf = function isLeaf(el) {
	  return !el.getAttribute('aria-owns');
	};
	
	var getSibling = function getSibling(el, distance) {
	  var parentNode = el.parentNode;
	
	  if (parentNode) {
	    var siblings = parentNode.querySelectorAll('.el-cascader-node[tabindex="-1"]');
	    var index = Array.prototype.indexOf.call(siblings, el);
	    return siblings[index + distance] || null;
	  }
	  return null;
	};
	
	var getMenuIndex = function getMenuIndex(el, distance) {
	  if (!el) return;
	  var pieces = el.id.split('-');
	  return Number(pieces[pieces.length - 2]);
	};
	
	var focusNode = function focusNode(el) {
	  if (!el) return;
	  el.focus();
	  !cascader_panelvue_type_script_lang_js_isLeaf(el) && el.click();
	};
	
	var checkNode = function checkNode(el) {
	  if (!el) return;
	
	  var input = el.querySelector('input');
	  if (input) {
	    input.click();
	  } else if (cascader_panelvue_type_script_lang_js_isLeaf(el)) {
	    el.click();
	  }
	};
	
	/* harmony default export */ var cascader_panelvue_type_script_lang_js_ = ({
	  name: 'ElCascaderPanel',
	
	  components: {
	    CascaderMenu: cascader_menu
	  },
	
	  props: {
	    value: {},
	    options: Array,
	    props: Object,
	    border: {
	      type: Boolean,
	      default: true
	    },
	    renderLabel: Function
	  },
	
	  provide: function provide() {
	    return {
	      panel: this
	    };
	  },
	  data: function data() {
	    return {
	      checkedValue: null,
	      checkedNodePaths: [],
	      store: [],
	      menus: [],
	      activePath: [],
	      loadCount: 0
	    };
	  },
	
	
	  computed: {
	    config: function config() {
	      return merge_default()(_extends({}, DefaultProps), this.props || {});
	    },
	    multiple: function multiple() {
	      return this.config.multiple;
	    },
	    checkStrictly: function checkStrictly() {
	      return this.config.checkStrictly;
	    },
	    leafOnly: function leafOnly() {
	      return !this.checkStrictly;
	    },
	    isHoverMenu: function isHoverMenu() {
	      return this.config.expandTrigger === 'hover';
	    },
	    renderLabelFn: function renderLabelFn() {
	      return this.renderLabel || this.$scopedSlots.default;
	    }
	  },
	
	  watch: {
	    options: {
	      handler: function handler() {
	        this.initStore();
	      },
	      immediate: true,
	      deep: true
	    },
	    value: function value() {
	      this.syncCheckedValue();
	      this.checkStrictly && this.calculateCheckedNodePaths();
	    },
	    checkedValue: function checkedValue(val) {
	      if (!Object(util_["isEqual"])(val, this.value)) {
	        this.checkStrictly && this.calculateCheckedNodePaths();
	        this.$emit('input', val);
	        this.$emit('change', val);
	      }
	    }
	  },
	
	  mounted: function mounted() {
	    if (!Object(util_["isEmpty"])(this.value)) {
	      this.syncCheckedValue();
	    }
	  },
	
	
	  methods: {
	    initStore: function initStore() {
	      var config = this.config,
	          options = this.options;
	
	      if (config.lazy && Object(util_["isEmpty"])(options)) {
	        this.lazyLoad();
	      } else {
	        this.store = new src_store(options, config);
	        this.menus = [this.store.getNodes()];
	        this.syncMenuState();
	      }
	    },
	    syncCheckedValue: function syncCheckedValue() {
	      var value = this.value,
	          checkedValue = this.checkedValue;
	
	      if (!Object(util_["isEqual"])(value, checkedValue)) {
	        this.activePath = [];
	        this.checkedValue = value;
	        this.syncMenuState();
	      }
	    },
	    syncMenuState: function syncMenuState() {
	      var multiple = this.multiple,
	          checkStrictly = this.checkStrictly;
	
	      this.syncActivePath();
	      multiple && this.syncMultiCheckState();
	      checkStrictly && this.calculateCheckedNodePaths();
	      this.$nextTick(this.scrollIntoView);
	    },
	    syncMultiCheckState: function syncMultiCheckState() {
	      var _this = this;
	
	      var nodes = this.getFlattedNodes(this.leafOnly);
	
	      nodes.forEach(function (node) {
	        node.syncCheckState(_this.checkedValue);
	      });
	    },
	    syncActivePath: function syncActivePath() {
	      var _this2 = this;
	
	      var store = this.store,
	          multiple = this.multiple,
	          activePath = this.activePath,
	          checkedValue = this.checkedValue;
	
	
	      if (!Object(util_["isEmpty"])(activePath)) {
	        var nodes = activePath.map(function (node) {
	          return _this2.getNodeByValue(node.getValue());
	        });
	        this.expandNodes(nodes);
	      } else if (!Object(util_["isEmpty"])(checkedValue)) {
	        var value = multiple ? checkedValue[0] : checkedValue;
	        var checkedNode = this.getNodeByValue(value) || {};
	        var _nodes = (checkedNode.pathNodes || []).slice(0, -1);
	        this.expandNodes(_nodes);
	      } else {
	        this.activePath = [];
	        this.menus = [store.getNodes()];
	      }
	    },
	    expandNodes: function expandNodes(nodes) {
	      var _this3 = this;
	
	      nodes.forEach(function (node) {
	        return _this3.handleExpand(node, true /* silent */);
	      });
	    },
	    calculateCheckedNodePaths: function calculateCheckedNodePaths() {
	      var _this4 = this;
	
	      var checkedValue = this.checkedValue,
	          multiple = this.multiple;
	
	      var checkedValues = multiple ? Object(util_["coerceTruthyValueToArray"])(checkedValue) : [checkedValue];
	      this.checkedNodePaths = checkedValues.map(function (v) {
	        var checkedNode = _this4.getNodeByValue(v);
	        return checkedNode ? checkedNode.pathNodes : [];
	      });
	    },
	    handleKeyDown: function handleKeyDown(e) {
	      var target = e.target,
	          keyCode = e.keyCode;
	
	
	      switch (keyCode) {
	        case KeyCode.up:
	          var prev = getSibling(target, -1);
	          focusNode(prev);
	          break;
	        case KeyCode.down:
	          var next = getSibling(target, 1);
	          focusNode(next);
	          break;
	        case KeyCode.left:
	          var preMenu = this.$refs.menu[getMenuIndex(target) - 1];
	          if (preMenu) {
	            var expandedNode = preMenu.$el.querySelector('.el-cascader-node[aria-expanded="true"]');
	            focusNode(expandedNode);
	          }
	          break;
	        case KeyCode.right:
	          var nextMenu = this.$refs.menu[getMenuIndex(target) + 1];
	          if (nextMenu) {
	            var firstNode = nextMenu.$el.querySelector('.el-cascader-node[tabindex="-1"]');
	            focusNode(firstNode);
	          }
	          break;
	        case KeyCode.enter:
	          checkNode(target);
	          break;
	        case KeyCode.esc:
	        case KeyCode.tab:
	          this.$emit('close');
	          break;
	        default:
	          return;
	      }
	    },
	    handleExpand: function handleExpand(node, silent) {
	      var activePath = this.activePath;
	      var level = node.level;
	
	      var path = activePath.slice(0, level - 1);
	      var menus = this.menus.slice(0, level);
	
	      if (!node.isLeaf) {
	        path.push(node);
	        menus.push(node.children);
	      }
	
	      this.activePath = path;
	      this.menus = menus;
	
	      if (!silent) {
	        var pathValues = path.map(function (node) {
	          return node.getValue();
	        });
	        var activePathValues = activePath.map(function (node) {
	          return node.getValue();
	        });
	        if (!Object(util_["valueEquals"])(pathValues, activePathValues)) {
	          this.$emit('active-item-change', pathValues); // Deprecated
	          this.$emit('expand-change', pathValues);
	        }
	      }
	    },
	    handleCheckChange: function handleCheckChange(value) {
	      this.checkedValue = value;
	    },
	    lazyLoad: function lazyLoad(node, onFullfiled) {
	      var _this5 = this;
	
	      var config = this.config;
	
	      if (!node) {
	        node = node || { root: true, level: 0 };
	        this.store = new src_store([], config);
	        this.menus = [this.store.getNodes()];
	      }
	      node.loading = true;
	      var resolve = function resolve(dataList) {
	        var parent = node.root ? null : node;
	        dataList && dataList.length && _this5.store.appendNodes(dataList, parent);
	        node.loading = false;
	        node.loaded = true;
	
	        // dispose default value on lazy load mode
	        if (Array.isArray(_this5.checkedValue)) {
	          var nodeValue = _this5.checkedValue[_this5.loadCount++];
	          var valueKey = _this5.config.value;
	          var leafKey = _this5.config.leaf;
	
	          if (Array.isArray(dataList) && dataList.filter(function (item) {
	            return item[valueKey] === nodeValue;
	          }).length > 0) {
	            var checkedNode = _this5.store.getNodeByValue(nodeValue);
	
	            if (!checkedNode.data[leafKey]) {
	              _this5.lazyLoad(checkedNode, function () {
	                _this5.handleExpand(checkedNode);
	              });
	            }
	
	            if (_this5.loadCount === _this5.checkedValue.length) {
	              _this5.$parent.computePresentText();
	            }
	          }
	        }
	
	        onFullfiled && onFullfiled(dataList);
	      };
	      config.lazyLoad(node, resolve);
	    },
	
	
	    /**
	     * public methods
	    */
	    calculateMultiCheckedValue: function calculateMultiCheckedValue() {
	      this.checkedValue = this.getCheckedNodes(this.leafOnly).map(function (node) {
	        return node.getValueByOption();
	      });
	    },
	    scrollIntoView: function scrollIntoView() {
	      if (this.$isServer) return;
	
	      var menus = this.$refs.menu || [];
	      menus.forEach(function (menu) {
	        var menuElement = menu.$el;
	        if (menuElement) {
	          var container = menuElement.querySelector('.el-scrollbar__wrap');
	          var activeNode = menuElement.querySelector('.el-cascader-node.is-active') || menuElement.querySelector('.el-cascader-node.in-active-path');
	          scroll_into_view_default()(container, activeNode);
	        }
	      });
	    },
	    getNodeByValue: function getNodeByValue(val) {
	      return this.store.getNodeByValue(val);
	    },
	    getFlattedNodes: function getFlattedNodes(leafOnly) {
	      var cached = !this.config.lazy;
	      return this.store.getFlattedNodes(leafOnly, cached);
	    },
	    getCheckedNodes: function getCheckedNodes(leafOnly) {
	      var checkedValue = this.checkedValue,
	          multiple = this.multiple;
	
	      if (multiple) {
	        var nodes = this.getFlattedNodes(leafOnly);
	        return nodes.filter(function (node) {
	          return node.checked;
	        });
	      } else {
	        return Object(util_["isEmpty"])(checkedValue) ? [] : [this.getNodeByValue(checkedValue)];
	      }
	    },
	    clearCheckedNodes: function clearCheckedNodes() {
	      var config = this.config,
	          leafOnly = this.leafOnly;
	      var multiple = config.multiple,
	          emitPath = config.emitPath;
	
	      if (multiple) {
	        this.getCheckedNodes(leafOnly).filter(function (node) {
	          return !node.isDisabled;
	        }).forEach(function (node) {
	          return node.doCheck(false);
	        });
	        this.calculateMultiCheckedValue();
	      } else {
	        this.checkedValue = emitPath ? [] : null;
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-panel.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_cascader_panelvue_type_script_lang_js_ = (cascader_panelvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-panel.vue
	
	
	
	
	
	/* normalize component */
	
	var cascader_panel_component = Object(componentNormalizer["a" /* default */])(
	  src_cascader_panelvue_type_script_lang_js_,
	  cascader_panelvue_type_template_id_34932346_render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var cascader_panel_api; }
	cascader_panel_component.options.__file = "packages/cascader-panel/src/cascader-panel.vue"
	/* harmony default export */ var cascader_panel = (cascader_panel_component.exports);
	// CONCATENATED MODULE: ./packages/cascader-panel/index.js
	
	
	/* istanbul ignore next */
	cascader_panel.install = function (Vue) {
	  Vue.component(cascader_panel.name, cascader_panel);
	};
	
	/* harmony default export */ var packages_cascader_panel = __webpack_exports__["default"] = (cascader_panel);
	
	/***/ }),
	
	/***/ 6:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(98);
	
	/***/ }),
	
	/***/ 9:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(59);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 86);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 4:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(27);
	
	/***/ }),
	
	/***/ 86:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-group.vue?vue&type=template&id=7289a290&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-checkbox-group",
	      attrs: { role: "group", "aria-label": "checkbox-group" }
	    },
	    [_vm._t("default")],
	    2
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue?vue&type=template&id=7289a290&
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
	var emitter_ = __webpack_require__(4);
	var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-group.vue?vue&type=script&lang=js&
	
	
	
	/* harmony default export */ var checkbox_groupvue_type_script_lang_js_ = ({
	  name: 'ElCheckboxGroup',
	
	  componentName: 'ElCheckboxGroup',
	
	  mixins: [emitter_default.a],
	
	  inject: {
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  props: {
	    value: {},
	    disabled: Boolean,
	    min: Number,
	    max: Number,
	    size: String,
	    fill: String,
	    textColor: String
	  },
	
	  computed: {
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    checkboxGroupSize: function checkboxGroupSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    }
	  },
	
	  watch: {
	    value: function value(_value) {
	      this.dispatch('ElFormItem', 'el.form.change', [_value]);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_checkbox_groupvue_type_script_lang_js_ = (checkbox_groupvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_checkbox_groupvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/checkbox/src/checkbox-group.vue"
	/* harmony default export */ var checkbox_group = (component.exports);
	// CONCATENATED MODULE: ./packages/checkbox-group/index.js
	
	
	/* istanbul ignore next */
	checkbox_group.install = function (Vue) {
	  Vue.component(checkbox_group.name, checkbox_group);
	};
	
	/* harmony default export */ var packages_checkbox_group = __webpack_exports__["default"] = (checkbox_group);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 45);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(475);
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(17);
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(15);
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(27);
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(98);
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(61);
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(3);
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(59);
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(95);
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(142);
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(145);
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(147);
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(460);
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(101);
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(62);
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(96);
	
	/***/ }),
	/* 16 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(141);
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(99);
	
	/***/ }),
	/* 18 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(148);
	
	/***/ }),
	/* 19 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(60);
	
	/***/ }),
	/* 20 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(146);
	
	/***/ }),
	/* 21 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(472);
	
	/***/ }),
	/* 22 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(97);
	
	/***/ }),
	/* 23 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(478);
	
	/***/ }),
	/* 24 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(130);
	
	/***/ }),
	/* 25 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(104);
	
	/***/ }),
	/* 26 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(471);
	
	/***/ }),
	/* 27 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(102);
	
	/***/ }),
	/* 28 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(459);
	
	/***/ }),
	/* 29 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(144);
	
	/***/ }),
	/* 30 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(103);
	
	/***/ }),
	/* 31 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(462);
	
	/***/ }),
	/* 32 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(473);
	
	/***/ }),
	/* 33 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(469);
	
	/***/ }),
	/* 34 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(100);
	
	/***/ }),
	/* 35 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(485);
	
	/***/ }),
	/* 36 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(470);
	
	/***/ }),
	/* 37 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(467);
	
	/***/ }),
	/* 38 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(479);
	
	/***/ }),
	/* 39 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(474);
	
	/***/ }),
	/* 40 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(404);
	
	/***/ }),
	/* 41 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(464);
	
	/***/ }),
	/* 42 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(461);
	
	/***/ }),
	/* 43 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(143);
	
	/***/ }),
	/* 44 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(468);
	
	/***/ }),
	/* 45 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = __webpack_require__(46);
	
	
	/***/ }),
	/* 46 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/pagination/src/pager.vue?vue&type=template&id=7274f267&
	var pagervue_type_template_id_7274f267_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "ul",
	    { staticClass: "el-pager", on: { click: _vm.onPagerClick } },
	    [
	      _vm.pageCount > 0
	        ? _c(
	            "li",
	            {
	              staticClass: "number",
	              class: { active: _vm.currentPage === 1, disabled: _vm.disabled }
	            },
	            [_vm._v("1")]
	          )
	        : _vm._e(),
	      _vm.showPrevMore
	        ? _c("li", {
	            staticClass: "el-icon more btn-quickprev",
	            class: [_vm.quickprevIconClass, { disabled: _vm.disabled }],
	            on: {
	              mouseenter: function($event) {
	                _vm.onMouseenter("left")
	              },
	              mouseleave: function($event) {
	                _vm.quickprevIconClass = "el-icon-more"
	              }
	            }
	          })
	        : _vm._e(),
	      _vm._l(_vm.pagers, function(pager) {
	        return _c(
	          "li",
	          {
	            key: pager,
	            staticClass: "number",
	            class: { active: _vm.currentPage === pager, disabled: _vm.disabled }
	          },
	          [_vm._v(_vm._s(pager))]
	        )
	      }),
	      _vm.showNextMore
	        ? _c("li", {
	            staticClass: "el-icon more btn-quicknext",
	            class: [_vm.quicknextIconClass, { disabled: _vm.disabled }],
	            on: {
	              mouseenter: function($event) {
	                _vm.onMouseenter("right")
	              },
	              mouseleave: function($event) {
	                _vm.quicknextIconClass = "el-icon-more"
	              }
	            }
	          })
	        : _vm._e(),
	      _vm.pageCount > 1
	        ? _c(
	            "li",
	            {
	              staticClass: "number",
	              class: {
	                active: _vm.currentPage === _vm.pageCount,
	                disabled: _vm.disabled
	              }
	            },
	            [_vm._v(_vm._s(_vm.pageCount))]
	          )
	        : _vm._e()
	    ],
	    2
	  )
	}
	var staticRenderFns = []
	pagervue_type_template_id_7274f267_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/pagination/src/pager.vue?vue&type=template&id=7274f267&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/pagination/src/pager.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var pagervue_type_script_lang_js_ = ({
	  name: 'ElPager',
	
	  props: {
	    currentPage: Number,
	
	    pageCount: Number,
	
	    pagerCount: Number,
	
	    disabled: Boolean
	  },
	
	  watch: {
	    showPrevMore: function showPrevMore(val) {
	      if (!val) this.quickprevIconClass = 'el-icon-more';
	    },
	    showNextMore: function showNextMore(val) {
	      if (!val) this.quicknextIconClass = 'el-icon-more';
	    }
	  },
	
	  methods: {
	    onPagerClick: function onPagerClick(event) {
	      var target = event.target;
	      if (target.tagName === 'UL' || this.disabled) {
	        return;
	      }
	
	      var newPage = Number(event.target.textContent);
	      var pageCount = this.pageCount;
	      var currentPage = this.currentPage;
	      var pagerCountOffset = this.pagerCount - 2;
	
	      if (target.className.indexOf('more') !== -1) {
	        if (target.className.indexOf('quickprev') !== -1) {
	          newPage = currentPage - pagerCountOffset;
	        } else if (target.className.indexOf('quicknext') !== -1) {
	          newPage = currentPage + pagerCountOffset;
	        }
	      }
	
	      /* istanbul ignore if */
	      if (!isNaN(newPage)) {
	        if (newPage < 1) {
	          newPage = 1;
	        }
	
	        if (newPage > pageCount) {
	          newPage = pageCount;
	        }
	      }
	
	      if (newPage !== currentPage) {
	        this.$emit('change', newPage);
	      }
	    },
	    onMouseenter: function onMouseenter(direction) {
	      if (this.disabled) return;
	      if (direction === 'left') {
	        this.quickprevIconClass = 'el-icon-d-arrow-left';
	      } else {
	        this.quicknextIconClass = 'el-icon-d-arrow-right';
	      }
	    }
	  },
	
	  computed: {
	    pagers: function pagers() {
	      var pagerCount = this.pagerCount;
	      var halfPagerCount = (pagerCount - 1) / 2;
	
	      var currentPage = Number(this.currentPage);
	      var pageCount = Number(this.pageCount);
	
	      var showPrevMore = false;
	      var showNextMore = false;
	
	      if (pageCount > pagerCount) {
	        if (currentPage > pagerCount - halfPagerCount) {
	          showPrevMore = true;
	        }
	
	        if (currentPage < pageCount - halfPagerCount) {
	          showNextMore = true;
	        }
	      }
	
	      var array = [];
	
	      if (showPrevMore && !showNextMore) {
	        var startPage = pageCount - (pagerCount - 2);
	        for (var i = startPage; i < pageCount; i++) {
	          array.push(i);
	        }
	      } else if (!showPrevMore && showNextMore) {
	        for (var _i = 2; _i < pagerCount; _i++) {
	          array.push(_i);
	        }
	      } else if (showPrevMore && showNextMore) {
	        var offset = Math.floor(pagerCount / 2) - 1;
	        for (var _i2 = currentPage - offset; _i2 <= currentPage + offset; _i2++) {
	          array.push(_i2);
	        }
	      } else {
	        for (var _i3 = 2; _i3 < pageCount; _i3++) {
	          array.push(_i3);
	        }
	      }
	
	      this.showPrevMore = showPrevMore;
	      this.showNextMore = showNextMore;
	
	      return array;
	    }
	  },
	
	  data: function data() {
	    return {
	      current: null,
	      showPrevMore: false,
	      showNextMore: false,
	      quicknextIconClass: 'el-icon-more',
	      quickprevIconClass: 'el-icon-more'
	    };
	  }
	});
	// CONCATENATED MODULE: ./packages/pagination/src/pager.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_pagervue_type_script_lang_js_ = (pagervue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	// CONCATENATED MODULE: ./packages/pagination/src/pager.vue
	
	
	
	
	
	/* normalize component */
	
	var component = normalizeComponent(
	  src_pagervue_type_script_lang_js_,
	  pagervue_type_template_id_7274f267_render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/pagination/src/pager.vue"
	/* harmony default export */ var pager = (component.exports);
	// EXTERNAL MODULE: external "element-ui/lib/select"
	var select_ = __webpack_require__(36);
	var select_default = /*#__PURE__*/__webpack_require__.n(select_);
	
	// EXTERNAL MODULE: external "element-ui/lib/option"
	var option_ = __webpack_require__(37);
	var option_default = /*#__PURE__*/__webpack_require__.n(option_);
	
	// EXTERNAL MODULE: external "element-ui/lib/input"
	var input_ = __webpack_require__(8);
	var input_default = /*#__PURE__*/__webpack_require__.n(input_);
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/locale"
	var locale_ = __webpack_require__(4);
	var locale_default = /*#__PURE__*/__webpack_require__.n(locale_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/util"
	var util_ = __webpack_require__(2);
	
	// CONCATENATED MODULE: ./packages/pagination/src/pagination.js
	
	
	
	
	
	
	
	/* harmony default export */ var pagination = ({
	  name: 'ElPagination',
	
	  props: {
	    pageSize: {
	      type: Number,
	      default: 10
	    },
	
	    small: Boolean,
	
	    total: Number,
	
	    pageCount: Number,
	
	    pagerCount: {
	      type: Number,
	      validator: function validator(value) {
	        return (value | 0) === value && value > 4 && value < 22 && value % 2 === 1;
	      },
	
	      default: 7
	    },
	
	    currentPage: {
	      type: Number,
	      default: 1
	    },
	
	    layout: {
	      default: 'prev, pager, next, jumper, ->, total'
	    },
	
	    pageSizes: {
	      type: Array,
	      default: function _default() {
	        return [10, 20, 30, 40, 50, 100];
	      }
	    },
	
	    popperClass: String,
	
	    prevText: String,
	
	    nextText: String,
	
	    background: Boolean,
	
	    disabled: Boolean,
	
	    hideOnSinglePage: Boolean
	  },
	
	  data: function data() {
	    return {
	      internalCurrentPage: 1,
	      internalPageSize: 0,
	      lastEmittedPage: -1,
	      userChangePageSize: false
	    };
	  },
	  render: function render(h) {
	    var layout = this.layout;
	    if (!layout) return null;
	    if (this.hideOnSinglePage && (!this.internalPageCount || this.internalPageCount === 1)) return null;
	
	    var template = h('div', { 'class': ['el-pagination', {
	        'is-background': this.background,
	        'el-pagination--small': this.small
	      }] });
	    var TEMPLATE_MAP = {
	      prev: h('prev'),
	      jumper: h('jumper'),
	      pager: h('pager', {
	        attrs: { currentPage: this.internalCurrentPage, pageCount: this.internalPageCount, pagerCount: this.pagerCount, disabled: this.disabled },
	        on: {
	          'change': this.handleCurrentChange
	        }
	      }),
	      next: h('next'),
	      sizes: h('sizes', {
	        attrs: { pageSizes: this.pageSizes }
	      }),
	      slot: h('slot', [this.$slots.default ? this.$slots.default : '']),
	      total: h('total')
	    };
	    var components = layout.split(',').map(function (item) {
	      return item.trim();
	    });
	    var rightWrapper = h('div', { 'class': 'el-pagination__rightwrapper' });
	    var haveRightWrapper = false;
	
	    template.children = template.children || [];
	    rightWrapper.children = rightWrapper.children || [];
	    components.forEach(function (compo) {
	      if (compo === '->') {
	        haveRightWrapper = true;
	        return;
	      }
	
	      if (!haveRightWrapper) {
	        template.children.push(TEMPLATE_MAP[compo]);
	      } else {
	        rightWrapper.children.push(TEMPLATE_MAP[compo]);
	      }
	    });
	
	    if (haveRightWrapper) {
	      template.children.unshift(rightWrapper);
	    }
	
	    return template;
	  },
	
	
	  components: {
	    Prev: {
	      render: function render(h) {
	        return h(
	          'button',
	          {
	            attrs: {
	              type: 'button',
	
	              disabled: this.$parent.disabled || this.$parent.internalCurrentPage <= 1
	            },
	            'class': 'btn-prev', on: {
	              'click': this.$parent.prev
	            }
	          },
	          [this.$parent.prevText ? h('span', [this.$parent.prevText]) : h('i', { 'class': 'el-icon el-icon-arrow-left' })]
	        );
	      }
	    },
	
	    Next: {
	      render: function render(h) {
	        return h(
	          'button',
	          {
	            attrs: {
	              type: 'button',
	
	              disabled: this.$parent.disabled || this.$parent.internalCurrentPage === this.$parent.internalPageCount || this.$parent.internalPageCount === 0
	            },
	            'class': 'btn-next', on: {
	              'click': this.$parent.next
	            }
	          },
	          [this.$parent.nextText ? h('span', [this.$parent.nextText]) : h('i', { 'class': 'el-icon el-icon-arrow-right' })]
	        );
	      }
	    },
	
	    Sizes: {
	      mixins: [locale_default.a],
	
	      props: {
	        pageSizes: Array
	      },
	
	      watch: {
	        pageSizes: {
	          immediate: true,
	          handler: function handler(newVal, oldVal) {
	            if (Object(util_["valueEquals"])(newVal, oldVal)) return;
	            if (Array.isArray(newVal)) {
	              this.$parent.internalPageSize = newVal.indexOf(this.$parent.pageSize) > -1 ? this.$parent.pageSize : this.pageSizes[0];
	            }
	          }
	        }
	      },
	
	      render: function render(h) {
	        var _this = this;
	
	        return h(
	          'span',
	          { 'class': 'el-pagination__sizes' },
	          [h(
	            'el-select',
	            {
	              attrs: {
	                value: this.$parent.internalPageSize,
	                popperClass: this.$parent.popperClass || '',
	                size: 'mini',
	
	                disabled: this.$parent.disabled },
	              on: {
	                'input': this.handleChange
	              }
	            },
	            [this.pageSizes.map(function (item) {
	              return h('el-option', {
	                attrs: {
	                  value: item,
	                  label: item + _this.t('el.pagination.pagesize') }
	              });
	            })]
	          )]
	        );
	      },
	
	
	      components: {
	        ElSelect: select_default.a,
	        ElOption: option_default.a
	      },
	
	      methods: {
	        handleChange: function handleChange(val) {
	          if (val !== this.$parent.internalPageSize) {
	            this.$parent.internalPageSize = val = parseInt(val, 10);
	            this.$parent.userChangePageSize = true;
	            this.$parent.$emit('update:pageSize', val);
	            this.$parent.$emit('size-change', val);
	          }
	        }
	      }
	    },
	
	    Jumper: {
	      mixins: [locale_default.a],
	
	      components: { ElInput: input_default.a },
	
	      data: function data() {
	        return {
	          userInput: null
	        };
	      },
	
	
	      watch: {
	        '$parent.internalCurrentPage': function $parentInternalCurrentPage() {
	          this.userInput = null;
	        }
	      },
	
	      methods: {
	        handleKeyup: function handleKeyup(_ref) {
	          var keyCode = _ref.keyCode,
	              target = _ref.target;
	
	          // Chrome, Safari, Firefox triggers change event on Enter
	          // Hack for IE: https://github.com/ElemeFE/element/issues/11710
	          // Drop this method when we no longer supports IE
	          if (keyCode === 13) {
	            this.handleChange(target.value);
	          }
	        },
	        handleInput: function handleInput(value) {
	          this.userInput = value;
	        },
	        handleChange: function handleChange(value) {
	          this.$parent.internalCurrentPage = this.$parent.getValidCurrentPage(value);
	          this.$parent.emitChange();
	          this.userInput = null;
	        }
	      },
	
	      render: function render(h) {
	        return h(
	          'span',
	          { 'class': 'el-pagination__jump' },
	          [this.t('el.pagination.goto'), h('el-input', {
	            'class': 'el-pagination__editor is-in-pagination',
	            attrs: { min: 1,
	              max: this.$parent.internalPageCount,
	              value: this.userInput !== null ? this.userInput : this.$parent.internalCurrentPage,
	              type: 'number',
	              disabled: this.$parent.disabled
	            },
	            nativeOn: {
	              'keyup': this.handleKeyup
	            },
	            on: {
	              'input': this.handleInput,
	              'change': this.handleChange
	            }
	          }), this.t('el.pagination.pageClassifier')]
	        );
	      }
	    },
	
	    Total: {
	      mixins: [locale_default.a],
	
	      render: function render(h) {
	        return typeof this.$parent.total === 'number' ? h(
	          'span',
	          { 'class': 'el-pagination__total' },
	          [this.t('el.pagination.total', { total: this.$parent.total })]
	        ) : '';
	      }
	    },
	
	    Pager: pager
	  },
	
	  methods: {
	    handleCurrentChange: function handleCurrentChange(val) {
	      this.internalCurrentPage = this.getValidCurrentPage(val);
	      this.userChangePageSize = true;
	      this.emitChange();
	    },
	    prev: function prev() {
	      if (this.disabled) return;
	      var newVal = this.internalCurrentPage - 1;
	      this.internalCurrentPage = this.getValidCurrentPage(newVal);
	      this.$emit('prev-click', this.internalCurrentPage);
	      this.emitChange();
	    },
	    next: function next() {
	      if (this.disabled) return;
	      var newVal = this.internalCurrentPage + 1;
	      this.internalCurrentPage = this.getValidCurrentPage(newVal);
	      this.$emit('next-click', this.internalCurrentPage);
	      this.emitChange();
	    },
	    getValidCurrentPage: function getValidCurrentPage(value) {
	      value = parseInt(value, 10);
	
	      var havePageCount = typeof this.internalPageCount === 'number';
	
	      var resetValue = void 0;
	      if (!havePageCount) {
	        if (isNaN(value) || value < 1) resetValue = 1;
	      } else {
	        if (value < 1) {
	          resetValue = 1;
	        } else if (value > this.internalPageCount) {
	          resetValue = this.internalPageCount;
	        }
	      }
	
	      if (resetValue === undefined && isNaN(value)) {
	        resetValue = 1;
	      } else if (resetValue === 0) {
	        resetValue = 1;
	      }
	
	      return resetValue === undefined ? value : resetValue;
	    },
	    emitChange: function emitChange() {
	      var _this2 = this;
	
	      this.$nextTick(function () {
	        if (_this2.internalCurrentPage !== _this2.lastEmittedPage || _this2.userChangePageSize) {
	          _this2.$emit('current-change', _this2.internalCurrentPage);
	          _this2.lastEmittedPage = _this2.internalCurrentPage;
	          _this2.userChangePageSize = false;
	        }
	      });
	    }
	  },
	
	  computed: {
	    internalPageCount: function internalPageCount() {
	      if (typeof this.total === 'number') {
	        return Math.max(1, Math.ceil(this.total / this.internalPageSize));
	      } else if (typeof this.pageCount === 'number') {
	        return Math.max(1, this.pageCount);
	      }
	      return null;
	    }
	  },
	
	  watch: {
	    currentPage: {
	      immediate: true,
	      handler: function handler(val) {
	        this.internalCurrentPage = this.getValidCurrentPage(val);
	      }
	    },
	
	    pageSize: {
	      immediate: true,
	      handler: function handler(val) {
	        this.internalPageSize = isNaN(val) ? 10 : val;
	      }
	    },
	
	    internalCurrentPage: {
	      immediate: true,
	      handler: function handler(newVal) {
	        this.$emit('update:currentPage', newVal);
	        this.lastEmittedPage = -1;
	      }
	    },
	
	    internalPageCount: function internalPageCount(newVal) {
	      /* istanbul ignore if */
	      var oldPage = this.internalCurrentPage;
	      if (newVal > 0 && oldPage === 0) {
	        this.internalCurrentPage = 1;
	      } else if (oldPage > newVal) {
	        this.internalCurrentPage = newVal === 0 ? 1 : newVal;
	        this.userChangePageSize && this.emitChange();
	      }
	      this.userChangePageSize = false;
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/pagination/index.js
	
	
	/* istanbul ignore next */
	pagination.install = function (Vue) {
	  Vue.component(pagination.name, pagination);
	};
	
	/* harmony default export */ var packages_pagination = (pagination);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/dialog/src/component.vue?vue&type=template&id=60140e62&
	var componentvue_type_template_id_60140e62_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    {
	      attrs: { name: "dialog-fade" },
	      on: { "after-enter": _vm.afterEnter, "after-leave": _vm.afterLeave }
	    },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.visible,
	              expression: "visible"
	            }
	          ],
	          staticClass: "el-dialog__wrapper",
	          on: {
	            click: function($event) {
	              if ($event.target !== $event.currentTarget) {
	                return null
	              }
	              return _vm.handleWrapperClick($event)
	            }
	          }
	        },
	        [
	          _c(
	            "div",
	            {
	              key: _vm.key,
	              ref: "dialog",
	              class: [
	                "el-dialog",
	                {
	                  "is-fullscreen": _vm.fullscreen,
	                  "el-dialog--center": _vm.center
	                },
	                _vm.customClass
	              ],
	              style: _vm.style,
	              attrs: {
	                role: "dialog",
	                "aria-modal": "true",
	                "aria-label": _vm.title || "dialog"
	              }
	            },
	            [
	              _c(
	                "div",
	                { staticClass: "el-dialog__header" },
	                [
	                  _vm._t("title", [
	                    _c("span", { staticClass: "el-dialog__title" }, [
	                      _vm._v(_vm._s(_vm.title))
	                    ])
	                  ]),
	                  _vm.showClose
	                    ? _c(
	                        "button",
	                        {
	                          staticClass: "el-dialog__headerbtn",
	                          attrs: { type: "button", "aria-label": "Close" },
	                          on: { click: _vm.handleClose }
	                        },
	                        [
	                          _c("i", {
	                            staticClass:
	                              "el-dialog__close el-icon el-icon-close"
	                          })
	                        ]
	                      )
	                    : _vm._e()
	                ],
	                2
	              ),
	              _vm.rendered
	                ? _c(
	                    "div",
	                    { staticClass: "el-dialog__body" },
	                    [_vm._t("default")],
	                    2
	                  )
	                : _vm._e(),
	              _vm.$slots.footer
	                ? _c(
	                    "div",
	                    { staticClass: "el-dialog__footer" },
	                    [_vm._t("footer")],
	                    2
	                  )
	                : _vm._e()
	            ]
	          )
	        ]
	      )
	    ]
	  )
	}
	var componentvue_type_template_id_60140e62_staticRenderFns = []
	componentvue_type_template_id_60140e62_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/dialog/src/component.vue?vue&type=template&id=60140e62&
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/popup"
	var popup_ = __webpack_require__(11);
	var popup_default = /*#__PURE__*/__webpack_require__.n(popup_);
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/migrating"
	var migrating_ = __webpack_require__(9);
	var migrating_default = /*#__PURE__*/__webpack_require__.n(migrating_);
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
	var emitter_ = __webpack_require__(3);
	var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/dialog/src/component.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var componentvue_type_script_lang_js_ = ({
	  name: 'ElDialog',
	
	  mixins: [popup_default.a, emitter_default.a, migrating_default.a],
	
	  props: {
	    title: {
	      type: String,
	      default: ''
	    },
	
	    modal: {
	      type: Boolean,
	      default: true
	    },
	
	    modalAppendToBody: {
	      type: Boolean,
	      default: true
	    },
	
	    appendToBody: {
	      type: Boolean,
	      default: false
	    },
	
	    lockScroll: {
	      type: Boolean,
	      default: true
	    },
	
	    closeOnClickModal: {
	      type: Boolean,
	      default: true
	    },
	
	    closeOnPressEscape: {
	      type: Boolean,
	      default: true
	    },
	
	    showClose: {
	      type: Boolean,
	      default: true
	    },
	
	    width: String,
	
	    fullscreen: Boolean,
	
	    customClass: {
	      type: String,
	      default: ''
	    },
	
	    top: {
	      type: String,
	      default: '15vh'
	    },
	    beforeClose: Function,
	    center: {
	      type: Boolean,
	      default: false
	    },
	
	    destroyOnClose: Boolean
	  },
	
	  data: function data() {
	    return {
	      closed: false,
	      key: 0
	    };
	  },
	
	
	  watch: {
	    visible: function visible(val) {
	      var _this = this;
	
	      if (val) {
	        this.closed = false;
	        this.$emit('open');
	        this.$el.addEventListener('scroll', this.updatePopper);
	        this.$nextTick(function () {
	          _this.$refs.dialog.scrollTop = 0;
	        });
	        if (this.appendToBody) {
	          document.body.appendChild(this.$el);
	        }
	      } else {
	        this.$el.removeEventListener('scroll', this.updatePopper);
	        if (!this.closed) this.$emit('close');
	        if (this.destroyOnClose) {
	          this.$nextTick(function () {
	            _this.key++;
	          });
	        }
	      }
	    }
	  },
	
	  computed: {
	    style: function style() {
	      var style = {};
	      if (!this.fullscreen) {
	        style.marginTop = this.top;
	        if (this.width) {
	          style.width = this.width;
	        }
	      }
	      return style;
	    }
	  },
	
	  methods: {
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'size': 'size is removed.'
	        }
	      };
	    },
	    handleWrapperClick: function handleWrapperClick() {
	      if (!this.closeOnClickModal) return;
	      this.handleClose();
	    },
	    handleClose: function handleClose() {
	      if (typeof this.beforeClose === 'function') {
	        this.beforeClose(this.hide);
	      } else {
	        this.hide();
	      }
	    },
	    hide: function hide(cancel) {
	      if (cancel !== false) {
	        this.$emit('update:visible', false);
	        this.$emit('close');
	        this.closed = true;
	      }
	    },
	    updatePopper: function updatePopper() {
	      this.broadcast('ElSelectDropdown', 'updatePopper');
	      this.broadcast('ElDropdownMenu', 'updatePopper');
	    },
	    afterEnter: function afterEnter() {
	      this.$emit('opened');
	    },
	    afterLeave: function afterLeave() {
	      this.$emit('closed');
	    }
	  },
	
	  mounted: function mounted() {
	    if (this.visible) {
	      this.rendered = true;
	      this.open();
	      if (this.appendToBody) {
	        document.body.appendChild(this.$el);
	      }
	    }
	  },
	  destroyed: function destroyed() {
	    // if appendToBody is true, remove DOM node after destroy
	    if (this.appendToBody && this.$el && this.$el.parentNode) {
	      this.$el.parentNode.removeChild(this.$el);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/dialog/src/component.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_componentvue_type_script_lang_js_ = (componentvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/dialog/src/component.vue
	
	
	
	
	
	/* normalize component */
	
	var component_component = normalizeComponent(
	  src_componentvue_type_script_lang_js_,
	  componentvue_type_template_id_60140e62_render,
	  componentvue_type_template_id_60140e62_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var component_api; }
	component_component.options.__file = "packages/dialog/src/component.vue"
	/* harmony default export */ var src_component = (component_component.exports);
	// CONCATENATED MODULE: ./packages/dialog/index.js
	
	
	/* istanbul ignore next */
	src_component.install = function (Vue) {
	  Vue.component(src_component.name, src_component);
	};
	
	/* harmony default export */ var dialog = (src_component);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/autocomplete/src/autocomplete.vue?vue&type=template&id=152f2ee6&
	var autocompletevue_type_template_id_152f2ee6_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      directives: [
	        {
	          name: "clickoutside",
	          rawName: "v-clickoutside",
	          value: _vm.close,
	          expression: "close"
	        }
	      ],
	      staticClass: "el-autocomplete",
	      attrs: {
	        "aria-haspopup": "listbox",
	        role: "combobox",
	        "aria-expanded": _vm.suggestionVisible,
	        "aria-owns": _vm.id
	      }
	    },
	    [
	      _c(
	        "el-input",
	        _vm._b(
	          {
	            ref: "input",
	            on: {
	              input: _vm.handleInput,
	              change: _vm.handleChange,
	              focus: _vm.handleFocus,
	              blur: _vm.handleBlur,
	              clear: _vm.handleClear
	            },
	            nativeOn: {
	              keydown: [
	                function($event) {
	                  if (
	                    !("button" in $event) &&
	                    _vm._k($event.keyCode, "up", 38, $event.key, [
	                      "Up",
	                      "ArrowUp"
	                    ])
	                  ) {
	                    return null
	                  }
	                  $event.preventDefault()
	                  _vm.highlight(_vm.highlightedIndex - 1)
	                },
	                function($event) {
	                  if (
	                    !("button" in $event) &&
	                    _vm._k($event.keyCode, "down", 40, $event.key, [
	                      "Down",
	                      "ArrowDown"
	                    ])
	                  ) {
	                    return null
	                  }
	                  $event.preventDefault()
	                  _vm.highlight(_vm.highlightedIndex + 1)
	                },
	                function($event) {
	                  if (
	                    !("button" in $event) &&
	                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
	                  ) {
	                    return null
	                  }
	                  return _vm.handleKeyEnter($event)
	                },
	                function($event) {
	                  if (
	                    !("button" in $event) &&
	                    _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
	                  ) {
	                    return null
	                  }
	                  return _vm.close($event)
	                }
	              ]
	            }
	          },
	          "el-input",
	          [_vm.$props, _vm.$attrs],
	          false
	        ),
	        [
	          _vm.$slots.prepend
	            ? _c("template", { slot: "prepend" }, [_vm._t("prepend")], 2)
	            : _vm._e(),
	          _vm.$slots.append
	            ? _c("template", { slot: "append" }, [_vm._t("append")], 2)
	            : _vm._e(),
	          _vm.$slots.prefix
	            ? _c("template", { slot: "prefix" }, [_vm._t("prefix")], 2)
	            : _vm._e(),
	          _vm.$slots.suffix
	            ? _c("template", { slot: "suffix" }, [_vm._t("suffix")], 2)
	            : _vm._e()
	        ],
	        2
	      ),
	      _c(
	        "el-autocomplete-suggestions",
	        {
	          ref: "suggestions",
	          class: [_vm.popperClass ? _vm.popperClass : ""],
	          attrs: {
	            "visible-arrow": "",
	            "popper-options": _vm.popperOptions,
	            "append-to-body": _vm.popperAppendToBody,
	            placement: _vm.placement,
	            id: _vm.id
	          }
	        },
	        _vm._l(_vm.suggestions, function(item, index) {
	          return _c(
	            "li",
	            {
	              key: index,
	              class: { highlighted: _vm.highlightedIndex === index },
	              attrs: {
	                id: _vm.id + "-item-" + index,
	                role: "option",
	                "aria-selected": _vm.highlightedIndex === index
	              },
	              on: {
	                click: function($event) {
	                  _vm.select(item)
	                }
	              }
	            },
	            [
	              _vm._t(
	                "default",
	                [
	                  _vm._v("\n        " + _vm._s(item[_vm.valueKey]) + "\n      ")
	                ],
	                { item: item }
	              )
	            ],
	            2
	          )
	        }),
	        0
	      )
	    ],
	    1
	  )
	}
	var autocompletevue_type_template_id_152f2ee6_staticRenderFns = []
	autocompletevue_type_template_id_152f2ee6_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete.vue?vue&type=template&id=152f2ee6&
	
	// EXTERNAL MODULE: external "throttle-debounce/debounce"
	var debounce_ = __webpack_require__(14);
	var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/clickoutside"
	var clickoutside_ = __webpack_require__(10);
	var clickoutside_default = /*#__PURE__*/__webpack_require__.n(clickoutside_);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/autocomplete/src/autocomplete-suggestions.vue?vue&type=template&id=cd10dcf0&
	var autocomplete_suggestionsvue_type_template_id_cd10dcf0_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    { attrs: { name: "el-zoom-in-top" }, on: { "after-leave": _vm.doDestroy } },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.showPopper,
	              expression: "showPopper"
	            }
	          ],
	          staticClass: "el-autocomplete-suggestion el-popper",
	          class: {
	            "is-loading": !_vm.parent.hideLoading && _vm.parent.loading
	          },
	          style: { width: _vm.dropdownWidth },
	          attrs: { role: "region" }
	        },
	        [
	          _c(
	            "el-scrollbar",
	            {
	              attrs: {
	                tag: "ul",
	                "wrap-class": "el-autocomplete-suggestion__wrap",
	                "view-class": "el-autocomplete-suggestion__list"
	              }
	            },
	            [
	              !_vm.parent.hideLoading && _vm.parent.loading
	                ? _c("li", [_c("i", { staticClass: "el-icon-loading" })])
	                : _vm._t("default")
	            ],
	            2
	          )
	        ],
	        1
	      )
	    ]
	  )
	}
	var autocomplete_suggestionsvue_type_template_id_cd10dcf0_staticRenderFns = []
	autocomplete_suggestionsvue_type_template_id_cd10dcf0_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete-suggestions.vue?vue&type=template&id=cd10dcf0&
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/vue-popper"
	var vue_popper_ = __webpack_require__(5);
	var vue_popper_default = /*#__PURE__*/__webpack_require__.n(vue_popper_);
	
	// EXTERNAL MODULE: external "element-ui/lib/scrollbar"
	var scrollbar_ = __webpack_require__(17);
	var scrollbar_default = /*#__PURE__*/__webpack_require__.n(scrollbar_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/autocomplete/src/autocomplete-suggestions.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var autocomplete_suggestionsvue_type_script_lang_js_ = ({
	  components: { ElScrollbar: scrollbar_default.a },
	  mixins: [vue_popper_default.a, emitter_default.a],
	
	  componentName: 'ElAutocompleteSuggestions',
	
	  data: function data() {
	    return {
	      parent: this.$parent,
	      dropdownWidth: ''
	    };
	  },
	
	
	  props: {
	    options: {
	      default: function _default() {
	        return {
	          gpuAcceleration: false
	        };
	      }
	    },
	    id: String
	  },
	
	  methods: {
	    select: function select(item) {
	      this.dispatch('ElAutocomplete', 'item-click', item);
	    }
	  },
	
	  updated: function updated() {
	    var _this = this;
	
	    this.$nextTick(function (_) {
	      _this.popperJS && _this.updatePopper();
	    });
	  },
	  mounted: function mounted() {
	    this.$parent.popperElm = this.popperElm = this.$el;
	    this.referenceElm = this.$parent.$refs.input.$refs.input || this.$parent.$refs.input.$refs.textarea;
	    this.referenceList = this.$el.querySelector('.el-autocomplete-suggestion__list');
	    this.referenceList.setAttribute('role', 'listbox');
	    this.referenceList.setAttribute('id', this.id);
	  },
	  created: function created() {
	    var _this2 = this;
	
	    this.$on('visible', function (val, inputWidth) {
	      _this2.dropdownWidth = inputWidth + 'px';
	      _this2.showPopper = val;
	    });
	  }
	});
	// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete-suggestions.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_autocomplete_suggestionsvue_type_script_lang_js_ = (autocomplete_suggestionsvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete-suggestions.vue
	
	
	
	
	
	/* normalize component */
	
	var autocomplete_suggestions_component = normalizeComponent(
	  src_autocomplete_suggestionsvue_type_script_lang_js_,
	  autocomplete_suggestionsvue_type_template_id_cd10dcf0_render,
	  autocomplete_suggestionsvue_type_template_id_cd10dcf0_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var autocomplete_suggestions_api; }
	autocomplete_suggestions_component.options.__file = "packages/autocomplete/src/autocomplete-suggestions.vue"
	/* harmony default export */ var autocomplete_suggestions = (autocomplete_suggestions_component.exports);
	// EXTERNAL MODULE: external "element-ui/lib/mixins/focus"
	var focus_ = __webpack_require__(22);
	var focus_default = /*#__PURE__*/__webpack_require__.n(focus_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/autocomplete/src/autocomplete.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	
	/* harmony default export */ var autocompletevue_type_script_lang_js_ = ({
	  name: 'ElAutocomplete',
	
	  mixins: [emitter_default.a, focus_default()('input'), migrating_default.a],
	
	  inheritAttrs: false,
	
	  componentName: 'ElAutocomplete',
	
	  components: {
	    ElInput: input_default.a,
	    ElAutocompleteSuggestions: autocomplete_suggestions
	  },
	
	  directives: { Clickoutside: clickoutside_default.a },
	
	  props: {
	    valueKey: {
	      type: String,
	      default: 'value'
	    },
	    popperClass: String,
	    popperOptions: Object,
	    placeholder: String,
	    clearable: {
	      type: Boolean,
	      default: false
	    },
	    disabled: Boolean,
	    name: String,
	    size: String,
	    value: String,
	    maxlength: Number,
	    minlength: Number,
	    autofocus: Boolean,
	    fetchSuggestions: Function,
	    triggerOnFocus: {
	      type: Boolean,
	      default: true
	    },
	    customItem: String,
	    selectWhenUnmatched: {
	      type: Boolean,
	      default: false
	    },
	    prefixIcon: String,
	    suffixIcon: String,
	    label: String,
	    debounce: {
	      type: Number,
	      default: 300
	    },
	    placement: {
	      type: String,
	      default: 'bottom-start'
	    },
	    hideLoading: Boolean,
	    popperAppendToBody: {
	      type: Boolean,
	      default: true
	    },
	    highlightFirstItem: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      activated: false,
	      suggestions: [],
	      loading: false,
	      highlightedIndex: -1,
	      suggestionDisabled: false
	    };
	  },
	
	  computed: {
	    suggestionVisible: function suggestionVisible() {
	      var suggestions = this.suggestions;
	      var isValidData = Array.isArray(suggestions) && suggestions.length > 0;
	      return (isValidData || this.loading) && this.activated;
	    },
	    id: function id() {
	      return 'el-autocomplete-' + Object(util_["generateId"])();
	    }
	  },
	  watch: {
	    suggestionVisible: function suggestionVisible(val) {
	      var $input = this.getInput();
	      if ($input) {
	        this.broadcast('ElAutocompleteSuggestions', 'visible', [val, $input.offsetWidth]);
	      }
	    }
	  },
	  methods: {
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'custom-item': 'custom-item is removed, use scoped slot instead.',
	          'props': 'props is removed, use value-key instead.'
	        }
	      };
	    },
	    getData: function getData(queryString) {
	      var _this = this;
	
	      if (this.suggestionDisabled) {
	        return;
	      }
	      this.loading = true;
	      this.fetchSuggestions(queryString, function (suggestions) {
	        _this.loading = false;
	        if (_this.suggestionDisabled) {
	          return;
	        }
	        if (Array.isArray(suggestions)) {
	          _this.suggestions = suggestions;
	          _this.highlightedIndex = _this.highlightFirstItem ? 0 : -1;
	        } else {
	          console.error('[Element Error][Autocomplete]autocomplete suggestions must be an array');
	        }
	      });
	    },
	    handleInput: function handleInput(value) {
	      this.$emit('input', value);
	      this.suggestionDisabled = false;
	      if (!this.triggerOnFocus && !value) {
	        this.suggestionDisabled = true;
	        this.suggestions = [];
	        return;
	      }
	      this.debouncedGetData(value);
	    },
	    handleChange: function handleChange(value) {
	      this.$emit('change', value);
	    },
	    handleFocus: function handleFocus(event) {
	      this.activated = true;
	      this.$emit('focus', event);
	      if (this.triggerOnFocus) {
	        this.debouncedGetData(this.value);
	      }
	    },
	    handleBlur: function handleBlur(event) {
	      this.$emit('blur', event);
	    },
	    handleClear: function handleClear() {
	      this.activated = false;
	      this.$emit('clear');
	    },
	    close: function close(e) {
	      this.activated = false;
	    },
	    handleKeyEnter: function handleKeyEnter(e) {
	      var _this2 = this;
	
	      if (this.suggestionVisible && this.highlightedIndex >= 0 && this.highlightedIndex < this.suggestions.length) {
	        e.preventDefault();
	        this.select(this.suggestions[this.highlightedIndex]);
	      } else if (this.selectWhenUnmatched) {
	        this.$emit('select', { value: this.value });
	        this.$nextTick(function (_) {
	          _this2.suggestions = [];
	          _this2.highlightedIndex = -1;
	        });
	      }
	    },
	    select: function select(item) {
	      var _this3 = this;
	
	      this.$emit('input', item[this.valueKey]);
	      this.$emit('select', item);
	      this.$nextTick(function (_) {
	        _this3.suggestions = [];
	        _this3.highlightedIndex = -1;
	      });
	    },
	    highlight: function highlight(index) {
	      if (!this.suggestionVisible || this.loading) {
	        return;
	      }
	      if (index < 0) {
	        this.highlightedIndex = -1;
	        return;
	      }
	      if (index >= this.suggestions.length) {
	        index = this.suggestions.length - 1;
	      }
	      var suggestion = this.$refs.suggestions.$el.querySelector('.el-autocomplete-suggestion__wrap');
	      var suggestionList = suggestion.querySelectorAll('.el-autocomplete-suggestion__list li');
	
	      var highlightItem = suggestionList[index];
	      var scrollTop = suggestion.scrollTop;
	      var offsetTop = highlightItem.offsetTop;
	
	      if (offsetTop + highlightItem.scrollHeight > scrollTop + suggestion.clientHeight) {
	        suggestion.scrollTop += highlightItem.scrollHeight;
	      }
	      if (offsetTop < scrollTop) {
	        suggestion.scrollTop -= highlightItem.scrollHeight;
	      }
	      this.highlightedIndex = index;
	      var $input = this.getInput();
	      $input.setAttribute('aria-activedescendant', this.id + '-item-' + this.highlightedIndex);
	    },
	    getInput: function getInput() {
	      return this.$refs.input.getInput();
	    }
	  },
	  mounted: function mounted() {
	    var _this4 = this;
	
	    this.debouncedGetData = debounce_default()(this.debounce, this.getData);
	    this.$on('item-click', function (item) {
	      _this4.select(item);
	    });
	    var $input = this.getInput();
	    $input.setAttribute('role', 'textbox');
	    $input.setAttribute('aria-autocomplete', 'list');
	    $input.setAttribute('aria-controls', 'id');
	    $input.setAttribute('aria-activedescendant', this.id + '-item-' + this.highlightedIndex);
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.$refs.suggestions.$destroy();
	  }
	});
	// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_autocompletevue_type_script_lang_js_ = (autocompletevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete.vue
	
	
	
	
	
	/* normalize component */
	
	var autocomplete_component = normalizeComponent(
	  src_autocompletevue_type_script_lang_js_,
	  autocompletevue_type_template_id_152f2ee6_render,
	  autocompletevue_type_template_id_152f2ee6_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var autocomplete_api; }
	autocomplete_component.options.__file = "packages/autocomplete/src/autocomplete.vue"
	/* harmony default export */ var autocomplete = (autocomplete_component.exports);
	// CONCATENATED MODULE: ./packages/autocomplete/index.js
	
	
	/* istanbul ignore next */
	autocomplete.install = function (Vue) {
	  Vue.component(autocomplete.name, autocomplete);
	};
	
	/* harmony default export */ var packages_autocomplete = (autocomplete);
	// EXTERNAL MODULE: external "element-ui/lib/button"
	var button_ = __webpack_require__(12);
	var button_default = /*#__PURE__*/__webpack_require__.n(button_);
	
	// EXTERNAL MODULE: external "element-ui/lib/button-group"
	var button_group_ = __webpack_require__(28);
	var button_group_default = /*#__PURE__*/__webpack_require__.n(button_group_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/dropdown/src/dropdown.vue?vue&type=script&lang=js&
	
	
	
	
	
	
	
	
	/* harmony default export */ var dropdownvue_type_script_lang_js_ = ({
	  name: 'ElDropdown',
	
	  componentName: 'ElDropdown',
	
	  mixins: [emitter_default.a, migrating_default.a],
	
	  directives: { Clickoutside: clickoutside_default.a },
	
	  components: {
	    ElButton: button_default.a,
	    ElButtonGroup: button_group_default.a
	  },
	
	  provide: function provide() {
	    return {
	      dropdown: this
	    };
	  },
	
	
	  props: {
	    trigger: {
	      type: String,
	      default: 'hover'
	    },
	    type: String,
	    size: {
	      type: String,
	      default: ''
	    },
	    splitButton: Boolean,
	    hideOnClick: {
	      type: Boolean,
	      default: true
	    },
	    placement: {
	      type: String,
	      default: 'bottom-end'
	    },
	    visibleArrow: {
	      default: true
	    },
	    showTimeout: {
	      type: Number,
	      default: 250
	    },
	    hideTimeout: {
	      type: Number,
	      default: 150
	    },
	    tabindex: {
	      type: Number,
	      default: 0
	    }
	  },
	
	  data: function data() {
	    return {
	      timeout: null,
	      visible: false,
	      triggerElm: null,
	      menuItems: null,
	      menuItemsArray: null,
	      dropdownElm: null,
	      focusing: false,
	      listId: 'dropdown-menu-' + Object(util_["generateId"])()
	    };
	  },
	
	
	  computed: {
	    dropdownSize: function dropdownSize() {
	      return this.size || (this.$ELEMENT || {}).size;
	    }
	  },
	
	  mounted: function mounted() {
	    this.$on('menu-item-click', this.handleMenuItemClick);
	  },
	
	
	  watch: {
	    visible: function visible(val) {
	      this.broadcast('ElDropdownMenu', 'visible', val);
	      this.$emit('visible-change', val);
	    },
	    focusing: function focusing(val) {
	      var selfDefine = this.$el.querySelector('.el-dropdown-selfdefine');
	      if (selfDefine) {
	        // 自定义
	        if (val) {
	          selfDefine.className += ' focusing';
	        } else {
	          selfDefine.className = selfDefine.className.replace('focusing', '');
	        }
	      }
	    }
	  },
	
	  methods: {
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'menu-align': 'menu-align is renamed to placement.'
	        }
	      };
	    },
	    show: function show() {
	      var _this = this;
	
	      if (this.triggerElm.disabled) return;
	      clearTimeout(this.timeout);
	      this.timeout = setTimeout(function () {
	        _this.visible = true;
	      }, this.trigger === 'click' ? 0 : this.showTimeout);
	    },
	    hide: function hide() {
	      var _this2 = this;
	
	      if (this.triggerElm.disabled) return;
	      this.removeTabindex();
	      if (this.tabindex >= 0) {
	        this.resetTabindex(this.triggerElm);
	      }
	      clearTimeout(this.timeout);
	      this.timeout = setTimeout(function () {
	        _this2.visible = false;
	      }, this.trigger === 'click' ? 0 : this.hideTimeout);
	    },
	    handleClick: function handleClick() {
	      if (this.triggerElm.disabled) return;
	      if (this.visible) {
	        this.hide();
	      } else {
	        this.show();
	      }
	    },
	    handleTriggerKeyDown: function handleTriggerKeyDown(ev) {
	      var keyCode = ev.keyCode;
	      if ([38, 40].indexOf(keyCode) > -1) {
	        // up/down
	        this.removeTabindex();
	        this.resetTabindex(this.menuItems[0]);
	        this.menuItems[0].focus();
	        ev.preventDefault();
	        ev.stopPropagation();
	      } else if (keyCode === 13) {
	        // space enter选中
	        this.handleClick();
	      } else if ([9, 27].indexOf(keyCode) > -1) {
	        // tab || esc
	        this.hide();
	      }
	    },
	    handleItemKeyDown: function handleItemKeyDown(ev) {
	      var keyCode = ev.keyCode;
	      var target = ev.target;
	      var currentIndex = this.menuItemsArray.indexOf(target);
	      var max = this.menuItemsArray.length - 1;
	      var nextIndex = void 0;
	      if ([38, 40].indexOf(keyCode) > -1) {
	        // up/down
	        if (keyCode === 38) {
	          // up
	          nextIndex = currentIndex !== 0 ? currentIndex - 1 : 0;
	        } else {
	          // down
	          nextIndex = currentIndex < max ? currentIndex + 1 : max;
	        }
	        this.removeTabindex();
	        this.resetTabindex(this.menuItems[nextIndex]);
	        this.menuItems[nextIndex].focus();
	        ev.preventDefault();
	        ev.stopPropagation();
	      } else if (keyCode === 13) {
	        // enter选中
	        this.triggerElmFocus();
	        target.click();
	        if (this.hideOnClick) {
	          // click关闭
	          this.visible = false;
	        }
	      } else if ([9, 27].indexOf(keyCode) > -1) {
	        // tab // esc
	        this.hide();
	        this.triggerElmFocus();
	      }
	    },
	    resetTabindex: function resetTabindex(ele) {
	      // 下次tab时组件聚焦元素
	      this.removeTabindex();
	      ele.setAttribute('tabindex', '0'); // 下次期望的聚焦元素
	    },
	    removeTabindex: function removeTabindex() {
	      this.triggerElm.setAttribute('tabindex', '-1');
	      this.menuItemsArray.forEach(function (item) {
	        item.setAttribute('tabindex', '-1');
	      });
	    },
	    initAria: function initAria() {
	      this.dropdownElm.setAttribute('id', this.listId);
	      this.triggerElm.setAttribute('aria-haspopup', 'list');
	      this.triggerElm.setAttribute('aria-controls', this.listId);
	
	      if (!this.splitButton) {
	        // 自定义
	        this.triggerElm.setAttribute('role', 'button');
	        this.triggerElm.setAttribute('tabindex', this.tabindex);
	        this.triggerElm.setAttribute('class', (this.triggerElm.getAttribute('class') || '') + ' el-dropdown-selfdefine'); // 控制
	      }
	    },
	    initEvent: function initEvent() {
	      var _this3 = this;
	
	      var trigger = this.trigger,
	          show = this.show,
	          hide = this.hide,
	          handleClick = this.handleClick,
	          splitButton = this.splitButton,
	          handleTriggerKeyDown = this.handleTriggerKeyDown,
	          handleItemKeyDown = this.handleItemKeyDown;
	
	      this.triggerElm = splitButton ? this.$refs.trigger.$el : this.$slots.default[0].elm;
	
	      var dropdownElm = this.dropdownElm;
	
	      this.triggerElm.addEventListener('keydown', handleTriggerKeyDown); // triggerElm keydown
	      dropdownElm.addEventListener('keydown', handleItemKeyDown, true); // item keydown
	      // 控制自定义元素的样式
	      if (!splitButton) {
	        this.triggerElm.addEventListener('focus', function () {
	          _this3.focusing = true;
	        });
	        this.triggerElm.addEventListener('blur', function () {
	          _this3.focusing = false;
	        });
	        this.triggerElm.addEventListener('click', function () {
	          _this3.focusing = false;
	        });
	      }
	      if (trigger === 'hover') {
	        this.triggerElm.addEventListener('mouseenter', show);
	        this.triggerElm.addEventListener('mouseleave', hide);
	        dropdownElm.addEventListener('mouseenter', show);
	        dropdownElm.addEventListener('mouseleave', hide);
	      } else if (trigger === 'click') {
	        this.triggerElm.addEventListener('click', handleClick);
	      }
	    },
	    handleMenuItemClick: function handleMenuItemClick(command, instance) {
	      if (this.hideOnClick) {
	        this.visible = false;
	      }
	      this.$emit('command', command, instance);
	    },
	    triggerElmFocus: function triggerElmFocus() {
	      this.triggerElm.focus && this.triggerElm.focus();
	    },
	    initDomOperation: function initDomOperation() {
	      this.dropdownElm = this.popperElm;
	      this.menuItems = this.dropdownElm.querySelectorAll("[tabindex='-1']");
	      this.menuItemsArray = [].slice.call(this.menuItems);
	
	      this.initEvent();
	      this.initAria();
	    }
	  },
	
	  render: function render(h) {
	    var _this4 = this;
	
	    var hide = this.hide,
	        splitButton = this.splitButton,
	        type = this.type,
	        dropdownSize = this.dropdownSize;
	
	
	    var handleMainButtonClick = function handleMainButtonClick(event) {
	      _this4.$emit('click', event);
	      hide();
	    };
	
	    var triggerElm = !splitButton ? this.$slots.default : h('el-button-group', [h(
	      'el-button',
	      {
	        attrs: { type: type, size: dropdownSize },
	        nativeOn: {
	          'click': handleMainButtonClick
	        }
	      },
	      [this.$slots.default]
	    ), h(
	      'el-button',
	      { ref: 'trigger', attrs: { type: type, size: dropdownSize },
	        'class': 'el-dropdown__caret-button' },
	      [h('i', { 'class': 'el-dropdown__icon el-icon-arrow-down' })]
	    )]);
	
	    return h(
	      'div',
	      { 'class': 'el-dropdown', directives: [{
	          name: 'clickoutside',
	          value: hide
	        }]
	      },
	      [triggerElm, this.$slots.dropdown]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/dropdown/src/dropdown.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_dropdownvue_type_script_lang_js_ = (dropdownvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/dropdown/src/dropdown.vue
	var dropdown_render, dropdown_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var dropdown_component = normalizeComponent(
	  src_dropdownvue_type_script_lang_js_,
	  dropdown_render,
	  dropdown_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var dropdown_api; }
	dropdown_component.options.__file = "packages/dropdown/src/dropdown.vue"
	/* harmony default export */ var dropdown = (dropdown_component.exports);
	// CONCATENATED MODULE: ./packages/dropdown/index.js
	
	
	/* istanbul ignore next */
	dropdown.install = function (Vue) {
	  Vue.component(dropdown.name, dropdown);
	};
	
	/* harmony default export */ var packages_dropdown = (dropdown);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/dropdown/src/dropdown-menu.vue?vue&type=template&id=0da6b714&
	var dropdown_menuvue_type_template_id_0da6b714_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    { attrs: { name: "el-zoom-in-top" }, on: { "after-leave": _vm.doDestroy } },
	    [
	      _c(
	        "ul",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.showPopper,
	              expression: "showPopper"
	            }
	          ],
	          staticClass: "el-dropdown-menu el-popper",
	          class: [_vm.size && "el-dropdown-menu--" + _vm.size]
	        },
	        [_vm._t("default")],
	        2
	      )
	    ]
	  )
	}
	var dropdown_menuvue_type_template_id_0da6b714_staticRenderFns = []
	dropdown_menuvue_type_template_id_0da6b714_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-menu.vue?vue&type=template&id=0da6b714&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/dropdown/src/dropdown-menu.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var dropdown_menuvue_type_script_lang_js_ = ({
	  name: 'ElDropdownMenu',
	
	  componentName: 'ElDropdownMenu',
	
	  mixins: [vue_popper_default.a],
	
	  props: {
	    visibleArrow: {
	      type: Boolean,
	      default: true
	    },
	    arrowOffset: {
	      type: Number,
	      default: 0
	    }
	  },
	
	  data: function data() {
	    return {
	      size: this.dropdown.dropdownSize
	    };
	  },
	
	
	  inject: ['dropdown'],
	
	  created: function created() {
	    var _this = this;
	
	    this.$on('updatePopper', function () {
	      if (_this.showPopper) _this.updatePopper();
	    });
	    this.$on('visible', function (val) {
	      _this.showPopper = val;
	    });
	  },
	  mounted: function mounted() {
	    this.dropdown.popperElm = this.popperElm = this.$el;
	    this.referenceElm = this.dropdown.$el;
	    // compatible with 2.6 new v-slot syntax
	    // issue link https://github.com/ElemeFE/element/issues/14345
	    this.dropdown.initDomOperation();
	  },
	
	
	  watch: {
	    'dropdown.placement': {
	      immediate: true,
	      handler: function handler(val) {
	        this.currentPlacement = val;
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-menu.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_dropdown_menuvue_type_script_lang_js_ = (dropdown_menuvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-menu.vue
	
	
	
	
	
	/* normalize component */
	
	var dropdown_menu_component = normalizeComponent(
	  src_dropdown_menuvue_type_script_lang_js_,
	  dropdown_menuvue_type_template_id_0da6b714_render,
	  dropdown_menuvue_type_template_id_0da6b714_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var dropdown_menu_api; }
	dropdown_menu_component.options.__file = "packages/dropdown/src/dropdown-menu.vue"
	/* harmony default export */ var dropdown_menu = (dropdown_menu_component.exports);
	// CONCATENATED MODULE: ./packages/dropdown-menu/index.js
	
	
	/* istanbul ignore next */
	dropdown_menu.install = function (Vue) {
	  Vue.component(dropdown_menu.name, dropdown_menu);
	};
	
	/* harmony default export */ var packages_dropdown_menu = (dropdown_menu);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/dropdown/src/dropdown-item.vue?vue&type=template&id=6359102a&
	var dropdown_itemvue_type_template_id_6359102a_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "li",
	    {
	      staticClass: "el-dropdown-menu__item",
	      class: {
	        "is-disabled": _vm.disabled,
	        "el-dropdown-menu__item--divided": _vm.divided
	      },
	      attrs: {
	        "aria-disabled": _vm.disabled,
	        tabindex: _vm.disabled ? null : -1
	      },
	      on: { click: _vm.handleClick }
	    },
	    [_vm.icon ? _c("i", { class: _vm.icon }) : _vm._e(), _vm._t("default")],
	    2
	  )
	}
	var dropdown_itemvue_type_template_id_6359102a_staticRenderFns = []
	dropdown_itemvue_type_template_id_6359102a_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-item.vue?vue&type=template&id=6359102a&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/dropdown/src/dropdown-item.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var dropdown_itemvue_type_script_lang_js_ = ({
	  name: 'ElDropdownItem',
	
	  mixins: [emitter_default.a],
	
	  props: {
	    command: {},
	    disabled: Boolean,
	    divided: Boolean,
	    icon: String
	  },
	
	  methods: {
	    handleClick: function handleClick(e) {
	      this.dispatch('ElDropdown', 'menu-item-click', [this.command, this]);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-item.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_dropdown_itemvue_type_script_lang_js_ = (dropdown_itemvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-item.vue
	
	
	
	
	
	/* normalize component */
	
	var dropdown_item_component = normalizeComponent(
	  src_dropdown_itemvue_type_script_lang_js_,
	  dropdown_itemvue_type_template_id_6359102a_render,
	  dropdown_itemvue_type_template_id_6359102a_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var dropdown_item_api; }
	dropdown_item_component.options.__file = "packages/dropdown/src/dropdown-item.vue"
	/* harmony default export */ var dropdown_item = (dropdown_item_component.exports);
	// CONCATENATED MODULE: ./packages/dropdown-item/index.js
	
	
	/* istanbul ignore next */
	dropdown_item.install = function (Vue) {
	  Vue.component(dropdown_item.name, dropdown_item);
	};
	
	/* harmony default export */ var packages_dropdown_item = (dropdown_item);
	// CONCATENATED MODULE: ./src/utils/aria-utils.js
	var aria = aria || {};
	
	aria.Utils = aria.Utils || {};
	
	/**
	 * @desc Set focus on descendant nodes until the first focusable element is
	 *       found.
	 * @param element
	 *          DOM node for which to find the first focusable descendant.
	 * @returns
	 *  true if a focusable element is found and focus is set.
	 */
	aria.Utils.focusFirstDescendant = function (element) {
	  for (var i = 0; i < element.childNodes.length; i++) {
	    var child = element.childNodes[i];
	    if (aria.Utils.attemptFocus(child) || aria.Utils.focusFirstDescendant(child)) {
	      return true;
	    }
	  }
	  return false;
	};
	
	/**
	 * @desc Find the last descendant node that is focusable.
	 * @param element
	 *          DOM node for which to find the last focusable descendant.
	 * @returns
	 *  true if a focusable element is found and focus is set.
	 */
	
	aria.Utils.focusLastDescendant = function (element) {
	  for (var i = element.childNodes.length - 1; i >= 0; i--) {
	    var child = element.childNodes[i];
	    if (aria.Utils.attemptFocus(child) || aria.Utils.focusLastDescendant(child)) {
	      return true;
	    }
	  }
	  return false;
	};
	
	/**
	 * @desc Set Attempt to set focus on the current node.
	 * @param element
	 *          The node to attempt to focus on.
	 * @returns
	 *  true if element is focused.
	 */
	aria.Utils.attemptFocus = function (element) {
	  if (!aria.Utils.isFocusable(element)) {
	    return false;
	  }
	  aria.Utils.IgnoreUtilFocusChanges = true;
	  try {
	    element.focus();
	  } catch (e) {}
	  aria.Utils.IgnoreUtilFocusChanges = false;
	  return document.activeElement === element;
	};
	
	aria.Utils.isFocusable = function (element) {
	  if (element.tabIndex > 0 || element.tabIndex === 0 && element.getAttribute('tabIndex') !== null) {
	    return true;
	  }
	
	  if (element.disabled) {
	    return false;
	  }
	
	  switch (element.nodeName) {
	    case 'A':
	      return !!element.href && element.rel !== 'ignore';
	    case 'INPUT':
	      return element.type !== 'hidden' && element.type !== 'file';
	    case 'BUTTON':
	    case 'SELECT':
	    case 'TEXTAREA':
	      return true;
	    default:
	      return false;
	  }
	};
	
	/**
	 * 触发一个事件
	 * mouseenter, mouseleave, mouseover, keyup, change, click 等
	 * @param  {Element} elm
	 * @param  {String} name
	 * @param  {*} opts
	 */
	aria.Utils.triggerEvent = function (elm, name) {
	  var eventName = void 0;
	
	  if (/^mouse|click/.test(name)) {
	    eventName = 'MouseEvents';
	  } else if (/^key/.test(name)) {
	    eventName = 'KeyboardEvent';
	  } else {
	    eventName = 'HTMLEvents';
	  }
	  var evt = document.createEvent(eventName);
	
	  for (var _len = arguments.length, opts = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    opts[_key - 2] = arguments[_key];
	  }
	
	  evt.initEvent.apply(evt, [name].concat(opts));
	  elm.dispatchEvent ? elm.dispatchEvent(evt) : elm.fireEvent('on' + name, evt);
	
	  return elm;
	};
	
	aria.Utils.keys = {
	  tab: 9,
	  enter: 13,
	  space: 32,
	  left: 37,
	  up: 38,
	  right: 39,
	  down: 40,
	  esc: 27
	};
	
	/* harmony default export */ var aria_utils = (aria.Utils);
	// CONCATENATED MODULE: ./src/utils/menu/aria-submenu.js
	
	
	var SubMenu = function SubMenu(parent, domNode) {
	  this.domNode = domNode;
	  this.parent = parent;
	  this.subMenuItems = [];
	  this.subIndex = 0;
	  this.init();
	};
	
	SubMenu.prototype.init = function () {
	  this.subMenuItems = this.domNode.querySelectorAll('li');
	  this.addListeners();
	};
	
	SubMenu.prototype.gotoSubIndex = function (idx) {
	  if (idx === this.subMenuItems.length) {
	    idx = 0;
	  } else if (idx < 0) {
	    idx = this.subMenuItems.length - 1;
	  }
	  this.subMenuItems[idx].focus();
	  this.subIndex = idx;
	};
	
	SubMenu.prototype.addListeners = function () {
	  var _this = this;
	
	  var keys = aria_utils.keys;
	  var parentNode = this.parent.domNode;
	  Array.prototype.forEach.call(this.subMenuItems, function (el) {
	    el.addEventListener('keydown', function (event) {
	      var prevDef = false;
	      switch (event.keyCode) {
	        case keys.down:
	          _this.gotoSubIndex(_this.subIndex + 1);
	          prevDef = true;
	          break;
	        case keys.up:
	          _this.gotoSubIndex(_this.subIndex - 1);
	          prevDef = true;
	          break;
	        case keys.tab:
	          aria_utils.triggerEvent(parentNode, 'mouseleave');
	          break;
	        case keys.enter:
	        case keys.space:
	          prevDef = true;
	          event.currentTarget.click();
	          break;
	      }
	      if (prevDef) {
	        event.preventDefault();
	        event.stopPropagation();
	      }
	      return false;
	    });
	  });
	};
	
	/* harmony default export */ var aria_submenu = (SubMenu);
	// CONCATENATED MODULE: ./src/utils/menu/aria-menuitem.js
	
	
	
	var MenuItem = function MenuItem(domNode) {
	  this.domNode = domNode;
	  this.submenu = null;
	  this.init();
	};
	
	MenuItem.prototype.init = function () {
	  this.domNode.setAttribute('tabindex', '0');
	  var menuChild = this.domNode.querySelector('.el-menu');
	  if (menuChild) {
	    this.submenu = new aria_submenu(this, menuChild);
	  }
	  this.addListeners();
	};
	
	MenuItem.prototype.addListeners = function () {
	  var _this = this;
	
	  var keys = aria_utils.keys;
	  this.domNode.addEventListener('keydown', function (event) {
	    var prevDef = false;
	    switch (event.keyCode) {
	      case keys.down:
	        aria_utils.triggerEvent(event.currentTarget, 'mouseenter');
	        _this.submenu && _this.submenu.gotoSubIndex(0);
	        prevDef = true;
	        break;
	      case keys.up:
	        aria_utils.triggerEvent(event.currentTarget, 'mouseenter');
	        _this.submenu && _this.submenu.gotoSubIndex(_this.submenu.subMenuItems.length - 1);
	        prevDef = true;
	        break;
	      case keys.tab:
	        aria_utils.triggerEvent(event.currentTarget, 'mouseleave');
	        break;
	      case keys.enter:
	      case keys.space:
	        prevDef = true;
	        event.currentTarget.click();
	        break;
	    }
	    if (prevDef) {
	      event.preventDefault();
	    }
	  });
	};
	
	/* harmony default export */ var aria_menuitem = (MenuItem);
	// CONCATENATED MODULE: ./src/utils/menu/aria-menubar.js
	
	
	var Menu = function Menu(domNode) {
	  this.domNode = domNode;
	  this.init();
	};
	
	Menu.prototype.init = function () {
	  var menuChildren = this.domNode.childNodes;
	  [].filter.call(menuChildren, function (child) {
	    return child.nodeType === 1;
	  }).forEach(function (child) {
	    new aria_menuitem(child); // eslint-disable-line
	  });
	};
	/* harmony default export */ var aria_menubar = (Menu);
	// EXTERNAL MODULE: external "element-ui/lib/utils/dom"
	var dom_ = __webpack_require__(1);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu.vue?vue&type=script&lang=js&
	
	
	
	
	
	
	/* harmony default export */ var menuvue_type_script_lang_js_ = ({
	  name: 'ElMenu',
	
	  render: function render(h) {
	    var component = h(
	      'ul',
	      {
	        attrs: {
	          role: 'menubar'
	        },
	        key: +this.collapse,
	        style: { backgroundColor: this.backgroundColor || '' },
	        'class': {
	          'el-menu--horizontal': this.mode === 'horizontal',
	          'el-menu--collapse': this.collapse,
	          "el-menu": true
	        }
	      },
	      [this.$slots.default]
	    );
	
	    if (this.collapseTransition) {
	      return h('el-menu-collapse-transition', [component]);
	    } else {
	      return component;
	    }
	  },
	
	
	  componentName: 'ElMenu',
	
	  mixins: [emitter_default.a, migrating_default.a],
	
	  provide: function provide() {
	    return {
	      rootMenu: this
	    };
	  },
	
	
	  components: {
	    'el-menu-collapse-transition': {
	      functional: true,
	      render: function render(createElement, context) {
	        var data = {
	          props: {
	            mode: 'out-in'
	          },
	          on: {
	            beforeEnter: function beforeEnter(el) {
	              el.style.opacity = 0.2;
	            },
	            enter: function enter(el) {
	              Object(dom_["addClass"])(el, 'el-opacity-transition');
	              el.style.opacity = 1;
	            },
	            afterEnter: function afterEnter(el) {
	              Object(dom_["removeClass"])(el, 'el-opacity-transition');
	              el.style.opacity = '';
	            },
	            beforeLeave: function beforeLeave(el) {
	              if (!el.dataset) el.dataset = {};
	
	              if (Object(dom_["hasClass"])(el, 'el-menu--collapse')) {
	                Object(dom_["removeClass"])(el, 'el-menu--collapse');
	                el.dataset.oldOverflow = el.style.overflow;
	                el.dataset.scrollWidth = el.clientWidth;
	                Object(dom_["addClass"])(el, 'el-menu--collapse');
	              } else {
	                Object(dom_["addClass"])(el, 'el-menu--collapse');
	                el.dataset.oldOverflow = el.style.overflow;
	                el.dataset.scrollWidth = el.clientWidth;
	                Object(dom_["removeClass"])(el, 'el-menu--collapse');
	              }
	
	              el.style.width = el.scrollWidth + 'px';
	              el.style.overflow = 'hidden';
	            },
	            leave: function leave(el) {
	              Object(dom_["addClass"])(el, 'horizontal-collapse-transition');
	              el.style.width = el.dataset.scrollWidth + 'px';
	            }
	          }
	        };
	        return createElement('transition', data, context.children);
	      }
	    }
	  },
	
	  props: {
	    mode: {
	      type: String,
	      default: 'vertical'
	    },
	    defaultActive: {
	      type: String,
	      default: ''
	    },
	    defaultOpeneds: Array,
	    uniqueOpened: Boolean,
	    router: Boolean,
	    menuTrigger: {
	      type: String,
	      default: 'hover'
	    },
	    collapse: Boolean,
	    backgroundColor: String,
	    textColor: String,
	    activeTextColor: String,
	    collapseTransition: {
	      type: Boolean,
	      default: true
	    }
	  },
	  data: function data() {
	    return {
	      activeIndex: this.defaultActive,
	      openedMenus: this.defaultOpeneds && !this.collapse ? this.defaultOpeneds.slice(0) : [],
	      items: {},
	      submenus: {}
	    };
	  },
	
	  computed: {
	    hoverBackground: function hoverBackground() {
	      return this.backgroundColor ? this.mixColor(this.backgroundColor, 0.2) : '';
	    },
	    isMenuPopup: function isMenuPopup() {
	      return this.mode === 'horizontal' || this.mode === 'vertical' && this.collapse;
	    }
	  },
	  watch: {
	    defaultActive: function defaultActive(value) {
	      if (!this.items[value]) {
	        this.activeIndex = null;
	      }
	      this.updateActiveIndex(value);
	    },
	    defaultOpeneds: function defaultOpeneds(value) {
	      if (!this.collapse) {
	        this.openedMenus = value;
	      }
	    },
	    collapse: function collapse(value) {
	      if (value) this.openedMenus = [];
	      this.broadcast('ElSubmenu', 'toggle-collapse', value);
	    }
	  },
	  methods: {
	    updateActiveIndex: function updateActiveIndex(val) {
	      var item = this.items[val] || this.items[this.activeIndex] || this.items[this.defaultActive];
	      if (item) {
	        this.activeIndex = item.index;
	        this.initOpenedMenu();
	      } else {
	        this.activeIndex = null;
	      }
	    },
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'theme': 'theme is removed.'
	        }
	      };
	    },
	    getColorChannels: function getColorChannels(color) {
	      color = color.replace('#', '');
	      if (/^[0-9a-fA-F]{3}$/.test(color)) {
	        color = color.split('');
	        for (var i = 2; i >= 0; i--) {
	          color.splice(i, 0, color[i]);
	        }
	        color = color.join('');
	      }
	      if (/^[0-9a-fA-F]{6}$/.test(color)) {
	        return {
	          red: parseInt(color.slice(0, 2), 16),
	          green: parseInt(color.slice(2, 4), 16),
	          blue: parseInt(color.slice(4, 6), 16)
	        };
	      } else {
	        return {
	          red: 255,
	          green: 255,
	          blue: 255
	        };
	      }
	    },
	    mixColor: function mixColor(color, percent) {
	      var _getColorChannels = this.getColorChannels(color),
	          red = _getColorChannels.red,
	          green = _getColorChannels.green,
	          blue = _getColorChannels.blue;
	
	      if (percent > 0) {
	        // shade given color
	        red *= 1 - percent;
	        green *= 1 - percent;
	        blue *= 1 - percent;
	      } else {
	        // tint given color
	        red += (255 - red) * percent;
	        green += (255 - green) * percent;
	        blue += (255 - blue) * percent;
	      }
	      return 'rgb(' + Math.round(red) + ', ' + Math.round(green) + ', ' + Math.round(blue) + ')';
	    },
	    addItem: function addItem(item) {
	      this.$set(this.items, item.index, item);
	    },
	    removeItem: function removeItem(item) {
	      delete this.items[item.index];
	    },
	    addSubmenu: function addSubmenu(item) {
	      this.$set(this.submenus, item.index, item);
	    },
	    removeSubmenu: function removeSubmenu(item) {
	      delete this.submenus[item.index];
	    },
	    openMenu: function openMenu(index, indexPath) {
	      var openedMenus = this.openedMenus;
	      if (openedMenus.indexOf(index) !== -1) return;
	      // 将不在该菜单路径下的其余菜单收起
	      // collapse all menu that are not under current menu item
	      if (this.uniqueOpened) {
	        this.openedMenus = openedMenus.filter(function (index) {
	          return indexPath.indexOf(index) !== -1;
	        });
	      }
	      this.openedMenus.push(index);
	    },
	    closeMenu: function closeMenu(index) {
	      var i = this.openedMenus.indexOf(index);
	      if (i !== -1) {
	        this.openedMenus.splice(i, 1);
	      }
	    },
	    handleSubmenuClick: function handleSubmenuClick(submenu) {
	      var index = submenu.index,
	          indexPath = submenu.indexPath;
	
	      var isOpened = this.openedMenus.indexOf(index) !== -1;
	
	      if (isOpened) {
	        this.closeMenu(index);
	        this.$emit('close', index, indexPath);
	      } else {
	        this.openMenu(index, indexPath);
	        this.$emit('open', index, indexPath);
	      }
	    },
	    handleItemClick: function handleItemClick(item) {
	      var _this = this;
	
	      var index = item.index,
	          indexPath = item.indexPath;
	
	      var oldActiveIndex = this.activeIndex;
	      var hasIndex = item.index !== null;
	
	      if (hasIndex) {
	        this.activeIndex = item.index;
	      }
	
	      this.$emit('select', index, indexPath, item);
	
	      if (this.mode === 'horizontal' || this.collapse) {
	        this.openedMenus = [];
	      }
	
	      if (this.router && hasIndex) {
	        this.routeToItem(item, function (error) {
	          _this.activeIndex = oldActiveIndex;
	          if (error) {
	            // vue-router 3.1.0+ push/replace cause NavigationDuplicated error 
	            // https://github.com/ElemeFE/element/issues/17044
	            if (error.name === 'NavigationDuplicated') return;
	            console.error(error);
	          }
	        });
	      }
	    },
	
	    // 初始化展开菜单
	    // initialize opened menu
	    initOpenedMenu: function initOpenedMenu() {
	      var _this2 = this;
	
	      var index = this.activeIndex;
	      var activeItem = this.items[index];
	      if (!activeItem || this.mode === 'horizontal' || this.collapse) return;
	
	      var indexPath = activeItem.indexPath;
	
	      // 展开该菜单项的路径上所有子菜单
	      // expand all submenus of the menu item
	      indexPath.forEach(function (index) {
	        var submenu = _this2.submenus[index];
	        submenu && _this2.openMenu(index, submenu.indexPath);
	      });
	    },
	    routeToItem: function routeToItem(item, onError) {
	      var route = item.route || item.index;
	      try {
	        this.$router.push(route, function () {}, onError);
	      } catch (e) {
	        console.error(e);
	      }
	    },
	    open: function open(index) {
	      var _this3 = this;
	
	      var indexPath = this.submenus[index.toString()].indexPath;
	
	      indexPath.forEach(function (i) {
	        return _this3.openMenu(i, indexPath);
	      });
	    },
	    close: function close(index) {
	      this.closeMenu(index);
	    }
	  },
	  mounted: function mounted() {
	    this.initOpenedMenu();
	    this.$on('item-click', this.handleItemClick);
	    this.$on('submenu-click', this.handleSubmenuClick);
	    if (this.mode === 'horizontal') {
	      new aria_menubar(this.$el); // eslint-disable-line
	    }
	    this.$watch('items', this.updateActiveIndex);
	  }
	});
	// CONCATENATED MODULE: ./packages/menu/src/menu.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_menuvue_type_script_lang_js_ = (menuvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/menu/src/menu.vue
	var menu_render, menu_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var menu_component = normalizeComponent(
	  src_menuvue_type_script_lang_js_,
	  menu_render,
	  menu_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var menu_api; }
	menu_component.options.__file = "packages/menu/src/menu.vue"
	/* harmony default export */ var src_menu = (menu_component.exports);
	// CONCATENATED MODULE: ./packages/menu/index.js
	
	
	/* istanbul ignore next */
	src_menu.install = function (Vue) {
	  Vue.component(src_menu.name, src_menu);
	};
	
	/* harmony default export */ var packages_menu = (src_menu);
	// EXTERNAL MODULE: external "element-ui/lib/transitions/collapse-transition"
	var collapse_transition_ = __webpack_require__(21);
	var collapse_transition_default = /*#__PURE__*/__webpack_require__.n(collapse_transition_);
	
	// CONCATENATED MODULE: ./packages/menu/src/menu-mixin.js
	/* harmony default export */ var menu_mixin = ({
	  inject: ['rootMenu'],
	  computed: {
	    indexPath: function indexPath() {
	      var path = [this.index];
	      var parent = this.$parent;
	      while (parent.$options.componentName !== 'ElMenu') {
	        if (parent.index) {
	          path.unshift(parent.index);
	        }
	        parent = parent.$parent;
	      }
	      return path;
	    },
	    parentMenu: function parentMenu() {
	      var parent = this.$parent;
	      while (parent && ['ElMenu', 'ElSubmenu'].indexOf(parent.$options.componentName) === -1) {
	        parent = parent.$parent;
	      }
	      return parent;
	    },
	    paddingStyle: function paddingStyle() {
	      if (this.rootMenu.mode !== 'vertical') return {};
	
	      var padding = 20;
	      var parent = this.$parent;
	
	      if (this.rootMenu.collapse) {
	        padding = 20;
	      } else {
	        while (parent && parent.$options.componentName !== 'ElMenu') {
	          if (parent.$options.componentName === 'ElSubmenu') {
	            padding += 20;
	          }
	          parent = parent.$parent;
	        }
	      }
	      return { paddingLeft: padding + 'px' };
	    }
	  }
	});
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/submenu.vue?vue&type=script&lang=js&
	
	
	
	
	
	
	var poperMixins = {
	  props: {
	    transformOrigin: {
	      type: [Boolean, String],
	      default: false
	    },
	    offset: vue_popper_default.a.props.offset,
	    boundariesPadding: vue_popper_default.a.props.boundariesPadding,
	    popperOptions: vue_popper_default.a.props.popperOptions
	  },
	  data: vue_popper_default.a.data,
	  methods: vue_popper_default.a.methods,
	  beforeDestroy: vue_popper_default.a.beforeDestroy,
	  deactivated: vue_popper_default.a.deactivated
	};
	
	/* harmony default export */ var submenuvue_type_script_lang_js_ = ({
	  name: 'ElSubmenu',
	
	  componentName: 'ElSubmenu',
	
	  mixins: [menu_mixin, emitter_default.a, poperMixins],
	
	  components: { ElCollapseTransition: collapse_transition_default.a },
	
	  props: {
	    index: {
	      type: String,
	      required: true
	    },
	    showTimeout: {
	      type: Number,
	      default: 300
	    },
	    hideTimeout: {
	      type: Number,
	      default: 300
	    },
	    popperClass: String,
	    disabled: Boolean,
	    popperAppendToBody: {
	      type: Boolean,
	      default: undefined
	    }
	  },
	
	  data: function data() {
	    return {
	      popperJS: null,
	      timeout: null,
	      items: {},
	      submenus: {},
	      mouseInChild: false
	    };
	  },
	
	  watch: {
	    opened: function opened(val) {
	      var _this = this;
	
	      if (this.isMenuPopup) {
	        this.$nextTick(function (_) {
	          _this.updatePopper();
	        });
	      }
	    }
	  },
	  computed: {
	    // popper option
	    appendToBody: function appendToBody() {
	      return this.popperAppendToBody === undefined ? this.isFirstLevel : this.popperAppendToBody;
	    },
	    menuTransitionName: function menuTransitionName() {
	      return this.rootMenu.collapse ? 'el-zoom-in-left' : 'el-zoom-in-top';
	    },
	    opened: function opened() {
	      return this.rootMenu.openedMenus.indexOf(this.index) > -1;
	    },
	    active: function active() {
	      var isActive = false;
	      var submenus = this.submenus;
	      var items = this.items;
	
	      Object.keys(items).forEach(function (index) {
	        if (items[index].active) {
	          isActive = true;
	        }
	      });
	
	      Object.keys(submenus).forEach(function (index) {
	        if (submenus[index].active) {
	          isActive = true;
	        }
	      });
	
	      return isActive;
	    },
	    hoverBackground: function hoverBackground() {
	      return this.rootMenu.hoverBackground;
	    },
	    backgroundColor: function backgroundColor() {
	      return this.rootMenu.backgroundColor || '';
	    },
	    activeTextColor: function activeTextColor() {
	      return this.rootMenu.activeTextColor || '';
	    },
	    textColor: function textColor() {
	      return this.rootMenu.textColor || '';
	    },
	    mode: function mode() {
	      return this.rootMenu.mode;
	    },
	    isMenuPopup: function isMenuPopup() {
	      return this.rootMenu.isMenuPopup;
	    },
	    titleStyle: function titleStyle() {
	      if (this.mode !== 'horizontal') {
	        return {
	          color: this.textColor
	        };
	      }
	      return {
	        borderBottomColor: this.active ? this.rootMenu.activeTextColor ? this.activeTextColor : '' : 'transparent',
	        color: this.active ? this.activeTextColor : this.textColor
	      };
	    },
	    isFirstLevel: function isFirstLevel() {
	      var isFirstLevel = true;
	      var parent = this.$parent;
	      while (parent && parent !== this.rootMenu) {
	        if (['ElSubmenu', 'ElMenuItemGroup'].indexOf(parent.$options.componentName) > -1) {
	          isFirstLevel = false;
	          break;
	        } else {
	          parent = parent.$parent;
	        }
	      }
	      return isFirstLevel;
	    }
	  },
	  methods: {
	    handleCollapseToggle: function handleCollapseToggle(value) {
	      if (value) {
	        this.initPopper();
	      } else {
	        this.doDestroy();
	      }
	    },
	    addItem: function addItem(item) {
	      this.$set(this.items, item.index, item);
	    },
	    removeItem: function removeItem(item) {
	      delete this.items[item.index];
	    },
	    addSubmenu: function addSubmenu(item) {
	      this.$set(this.submenus, item.index, item);
	    },
	    removeSubmenu: function removeSubmenu(item) {
	      delete this.submenus[item.index];
	    },
	    handleClick: function handleClick() {
	      var rootMenu = this.rootMenu,
	          disabled = this.disabled;
	
	      if (rootMenu.menuTrigger === 'hover' && rootMenu.mode === 'horizontal' || rootMenu.collapse && rootMenu.mode === 'vertical' || disabled) {
	        return;
	      }
	      this.dispatch('ElMenu', 'submenu-click', this);
	    },
	    handleMouseenter: function handleMouseenter(event) {
	      var _this2 = this;
	
	      var showTimeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.showTimeout;
	
	
	      if (!('ActiveXObject' in window) && event.type === 'focus' && !event.relatedTarget) {
	        return;
	      }
	      var rootMenu = this.rootMenu,
	          disabled = this.disabled;
	
	      if (rootMenu.menuTrigger === 'click' && rootMenu.mode === 'horizontal' || !rootMenu.collapse && rootMenu.mode === 'vertical' || disabled) {
	        return;
	      }
	      this.dispatch('ElSubmenu', 'mouse-enter-child');
	      clearTimeout(this.timeout);
	      this.timeout = setTimeout(function () {
	        _this2.rootMenu.openMenu(_this2.index, _this2.indexPath);
	      }, showTimeout);
	
	      if (this.appendToBody) {
	        this.$parent.$el.dispatchEvent(new MouseEvent('mouseenter'));
	      }
	    },
	    handleMouseleave: function handleMouseleave() {
	      var _this3 = this;
	
	      var deepDispatch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      var rootMenu = this.rootMenu;
	
	      if (rootMenu.menuTrigger === 'click' && rootMenu.mode === 'horizontal' || !rootMenu.collapse && rootMenu.mode === 'vertical') {
	        return;
	      }
	      this.dispatch('ElSubmenu', 'mouse-leave-child');
	      clearTimeout(this.timeout);
	      this.timeout = setTimeout(function () {
	        !_this3.mouseInChild && _this3.rootMenu.closeMenu(_this3.index);
	      }, this.hideTimeout);
	
	      if (this.appendToBody && deepDispatch) {
	        if (this.$parent.$options.name === 'ElSubmenu') {
	          this.$parent.handleMouseleave(true);
	        }
	      }
	    },
	    handleTitleMouseenter: function handleTitleMouseenter() {
	      if (this.mode === 'horizontal' && !this.rootMenu.backgroundColor) return;
	      var title = this.$refs['submenu-title'];
	      title && (title.style.backgroundColor = this.rootMenu.hoverBackground);
	    },
	    handleTitleMouseleave: function handleTitleMouseleave() {
	      if (this.mode === 'horizontal' && !this.rootMenu.backgroundColor) return;
	      var title = this.$refs['submenu-title'];
	      title && (title.style.backgroundColor = this.rootMenu.backgroundColor || '');
	    },
	    updatePlacement: function updatePlacement() {
	      this.currentPlacement = this.mode === 'horizontal' && this.isFirstLevel ? 'bottom-start' : 'right-start';
	    },
	    initPopper: function initPopper() {
	      this.referenceElm = this.$el;
	      this.popperElm = this.$refs.menu;
	      this.updatePlacement();
	    }
	  },
	  created: function created() {
	    var _this4 = this;
	
	    this.$on('toggle-collapse', this.handleCollapseToggle);
	    this.$on('mouse-enter-child', function () {
	      _this4.mouseInChild = true;
	      clearTimeout(_this4.timeout);
	    });
	    this.$on('mouse-leave-child', function () {
	      _this4.mouseInChild = false;
	      clearTimeout(_this4.timeout);
	    });
	  },
	  mounted: function mounted() {
	    this.parentMenu.addSubmenu(this);
	    this.rootMenu.addSubmenu(this);
	    this.initPopper();
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.parentMenu.removeSubmenu(this);
	    this.rootMenu.removeSubmenu(this);
	  },
	  render: function render(h) {
	    var _this5 = this;
	
	    var active = this.active,
	        opened = this.opened,
	        paddingStyle = this.paddingStyle,
	        titleStyle = this.titleStyle,
	        backgroundColor = this.backgroundColor,
	        rootMenu = this.rootMenu,
	        currentPlacement = this.currentPlacement,
	        menuTransitionName = this.menuTransitionName,
	        mode = this.mode,
	        disabled = this.disabled,
	        popperClass = this.popperClass,
	        $slots = this.$slots,
	        isFirstLevel = this.isFirstLevel;
	
	
	    var popupMenu = h(
	      'transition',
	      {
	        attrs: { name: menuTransitionName }
	      },
	      [h(
	        'div',
	        {
	          ref: 'menu',
	          directives: [{
	            name: 'show',
	            value: opened
	          }],
	
	          'class': ['el-menu--' + mode, popperClass],
	          on: {
	            'mouseenter': function mouseenter($event) {
	              return _this5.handleMouseenter($event, 100);
	            },
	            'mouseleave': function mouseleave() {
	              return _this5.handleMouseleave(true);
	            },
	            'focus': function focus($event) {
	              return _this5.handleMouseenter($event, 100);
	            }
	          }
	        },
	        [h(
	          'ul',
	          {
	            attrs: {
	              role: 'menu'
	            },
	            'class': ['el-menu el-menu--popup', 'el-menu--popup-' + currentPlacement],
	            style: { backgroundColor: rootMenu.backgroundColor || '' } },
	          [$slots.default]
	        )]
	      )]
	    );
	
	    var inlineMenu = h('el-collapse-transition', [h(
	      'ul',
	      {
	        attrs: {
	          role: 'menu'
	        },
	        'class': 'el-menu el-menu--inline',
	        directives: [{
	          name: 'show',
	          value: opened
	        }],
	
	        style: { backgroundColor: rootMenu.backgroundColor || '' } },
	      [$slots.default]
	    )]);
	
	    var submenuTitleIcon = rootMenu.mode === 'horizontal' && isFirstLevel || rootMenu.mode === 'vertical' && !rootMenu.collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-right';
	
	    return h(
	      'li',
	      {
	        'class': {
	          'el-submenu': true,
	          'is-active': active,
	          'is-opened': opened,
	          'is-disabled': disabled
	        },
	        attrs: { role: 'menuitem',
	          'aria-haspopup': 'true',
	          'aria-expanded': opened
	        },
	        on: {
	          'mouseenter': this.handleMouseenter,
	          'mouseleave': function mouseleave() {
	            return _this5.handleMouseleave(false);
	          },
	          'focus': this.handleMouseenter
	        }
	      },
	      [h(
	        'div',
	        {
	          'class': 'el-submenu__title',
	          ref: 'submenu-title',
	          on: {
	            'click': this.handleClick,
	            'mouseenter': this.handleTitleMouseenter,
	            'mouseleave': this.handleTitleMouseleave
	          },
	
	          style: [paddingStyle, titleStyle, { backgroundColor: backgroundColor }]
	        },
	        [$slots.title, h('i', { 'class': ['el-submenu__icon-arrow', submenuTitleIcon] })]
	      ), this.isMenuPopup ? popupMenu : inlineMenu]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/menu/src/submenu.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_submenuvue_type_script_lang_js_ = (submenuvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/menu/src/submenu.vue
	var submenu_render, submenu_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var submenu_component = normalizeComponent(
	  src_submenuvue_type_script_lang_js_,
	  submenu_render,
	  submenu_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var submenu_api; }
	submenu_component.options.__file = "packages/menu/src/submenu.vue"
	/* harmony default export */ var submenu = (submenu_component.exports);
	// CONCATENATED MODULE: ./packages/submenu/index.js
	
	
	/* istanbul ignore next */
	submenu.install = function (Vue) {
	  Vue.component(submenu.name, submenu);
	};
	
	/* harmony default export */ var packages_submenu = (submenu);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu-item.vue?vue&type=template&id=2a5dbfea&
	var menu_itemvue_type_template_id_2a5dbfea_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "li",
	    {
	      staticClass: "el-menu-item",
	      class: {
	        "is-active": _vm.active,
	        "is-disabled": _vm.disabled
	      },
	      style: [
	        _vm.paddingStyle,
	        _vm.itemStyle,
	        { backgroundColor: _vm.backgroundColor }
	      ],
	      attrs: { role: "menuitem", tabindex: "-1" },
	      on: {
	        click: _vm.handleClick,
	        mouseenter: _vm.onMouseEnter,
	        focus: _vm.onMouseEnter,
	        blur: _vm.onMouseLeave,
	        mouseleave: _vm.onMouseLeave
	      }
	    },
	    [
	      _vm.parentMenu.$options.componentName === "ElMenu" &&
	      _vm.rootMenu.collapse &&
	      _vm.$slots.title
	        ? _c("el-tooltip", { attrs: { effect: "dark", placement: "right" } }, [
	            _c(
	              "div",
	              { attrs: { slot: "content" }, slot: "content" },
	              [_vm._t("title")],
	              2
	            ),
	            _c(
	              "div",
	              {
	                staticStyle: {
	                  position: "absolute",
	                  left: "0",
	                  top: "0",
	                  height: "100%",
	                  width: "100%",
	                  display: "inline-block",
	                  "box-sizing": "border-box",
	                  padding: "0 20px"
	                }
	              },
	              [_vm._t("default")],
	              2
	            )
	          ])
	        : [_vm._t("default"), _vm._t("title")]
	    ],
	    2
	  )
	}
	var menu_itemvue_type_template_id_2a5dbfea_staticRenderFns = []
	menu_itemvue_type_template_id_2a5dbfea_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/menu/src/menu-item.vue?vue&type=template&id=2a5dbfea&
	
	// EXTERNAL MODULE: external "element-ui/lib/tooltip"
	var tooltip_ = __webpack_require__(26);
	var tooltip_default = /*#__PURE__*/__webpack_require__.n(tooltip_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu-item.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var menu_itemvue_type_script_lang_js_ = ({
	  name: 'ElMenuItem',
	
	  componentName: 'ElMenuItem',
	
	  mixins: [menu_mixin, emitter_default.a],
	
	  components: { ElTooltip: tooltip_default.a },
	
	  props: {
	    index: {
	      default: null,
	      validator: function validator(val) {
	        return typeof val === 'string' || val === null;
	      }
	    },
	    route: [String, Object],
	    disabled: Boolean
	  },
	  computed: {
	    active: function active() {
	      return this.index === this.rootMenu.activeIndex;
	    },
	    hoverBackground: function hoverBackground() {
	      return this.rootMenu.hoverBackground;
	    },
	    backgroundColor: function backgroundColor() {
	      return this.rootMenu.backgroundColor || '';
	    },
	    activeTextColor: function activeTextColor() {
	      return this.rootMenu.activeTextColor || '';
	    },
	    textColor: function textColor() {
	      return this.rootMenu.textColor || '';
	    },
	    mode: function mode() {
	      return this.rootMenu.mode;
	    },
	    itemStyle: function itemStyle() {
	      var style = {
	        color: this.active ? this.activeTextColor : this.textColor
	      };
	      if (this.mode === 'horizontal' && !this.isNested) {
	        style.borderBottomColor = this.active ? this.rootMenu.activeTextColor ? this.activeTextColor : '' : 'transparent';
	      }
	      return style;
	    },
	    isNested: function isNested() {
	      return this.parentMenu !== this.rootMenu;
	    }
	  },
	  methods: {
	    onMouseEnter: function onMouseEnter() {
	      if (this.mode === 'horizontal' && !this.rootMenu.backgroundColor) return;
	      this.$el.style.backgroundColor = this.hoverBackground;
	    },
	    onMouseLeave: function onMouseLeave() {
	      if (this.mode === 'horizontal' && !this.rootMenu.backgroundColor) return;
	      this.$el.style.backgroundColor = this.backgroundColor;
	    },
	    handleClick: function handleClick() {
	      if (!this.disabled) {
	        this.dispatch('ElMenu', 'item-click', this);
	        this.$emit('click', this);
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.parentMenu.addItem(this);
	    this.rootMenu.addItem(this);
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.parentMenu.removeItem(this);
	    this.rootMenu.removeItem(this);
	  }
	});
	// CONCATENATED MODULE: ./packages/menu/src/menu-item.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_menu_itemvue_type_script_lang_js_ = (menu_itemvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/menu/src/menu-item.vue
	
	
	
	
	
	/* normalize component */
	
	var menu_item_component = normalizeComponent(
	  src_menu_itemvue_type_script_lang_js_,
	  menu_itemvue_type_template_id_2a5dbfea_render,
	  menu_itemvue_type_template_id_2a5dbfea_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var menu_item_api; }
	menu_item_component.options.__file = "packages/menu/src/menu-item.vue"
	/* harmony default export */ var menu_item = (menu_item_component.exports);
	// CONCATENATED MODULE: ./packages/menu-item/index.js
	
	
	/* istanbul ignore next */
	menu_item.install = function (Vue) {
	  Vue.component(menu_item.name, menu_item);
	};
	
	/* harmony default export */ var packages_menu_item = (menu_item);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu-item-group.vue?vue&type=template&id=543b7bdc&
	var menu_item_groupvue_type_template_id_543b7bdc_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("li", { staticClass: "el-menu-item-group" }, [
	    _c(
	      "div",
	      {
	        staticClass: "el-menu-item-group__title",
	        style: { paddingLeft: _vm.levelPadding + "px" }
	      },
	      [!_vm.$slots.title ? [_vm._v(_vm._s(_vm.title))] : _vm._t("title")],
	      2
	    ),
	    _c("ul", [_vm._t("default")], 2)
	  ])
	}
	var menu_item_groupvue_type_template_id_543b7bdc_staticRenderFns = []
	menu_item_groupvue_type_template_id_543b7bdc_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/menu/src/menu-item-group.vue?vue&type=template&id=543b7bdc&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu-item-group.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var menu_item_groupvue_type_script_lang_js_ = ({
	  name: 'ElMenuItemGroup',
	
	  componentName: 'ElMenuItemGroup',
	
	  inject: ['rootMenu'],
	  props: {
	    title: {
	      type: String
	    }
	  },
	  data: function data() {
	    return {
	      paddingLeft: 20
	    };
	  },
	
	  computed: {
	    levelPadding: function levelPadding() {
	      var padding = 20;
	      var parent = this.$parent;
	      if (this.rootMenu.collapse) return 20;
	      while (parent && parent.$options.componentName !== 'ElMenu') {
	        if (parent.$options.componentName === 'ElSubmenu') {
	          padding += 20;
	        }
	        parent = parent.$parent;
	      }
	      return padding;
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/menu/src/menu-item-group.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_menu_item_groupvue_type_script_lang_js_ = (menu_item_groupvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/menu/src/menu-item-group.vue
	
	
	
	
	
	/* normalize component */
	
	var menu_item_group_component = normalizeComponent(
	  src_menu_item_groupvue_type_script_lang_js_,
	  menu_item_groupvue_type_template_id_543b7bdc_render,
	  menu_item_groupvue_type_template_id_543b7bdc_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var menu_item_group_api; }
	menu_item_group_component.options.__file = "packages/menu/src/menu-item-group.vue"
	/* harmony default export */ var menu_item_group = (menu_item_group_component.exports);
	// CONCATENATED MODULE: ./packages/menu-item-group/index.js
	
	
	/* istanbul ignore next */
	menu_item_group.install = function (Vue) {
	  Vue.component(menu_item_group.name, menu_item_group);
	};
	
	/* harmony default export */ var packages_menu_item_group = (menu_item_group);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/input/src/input.vue?vue&type=template&id=343dd774&
	var inputvue_type_template_id_343dd774_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      class: [
	        _vm.type === "textarea" ? "el-textarea" : "el-input",
	        _vm.inputSize ? "el-input--" + _vm.inputSize : "",
	        {
	          "is-disabled": _vm.inputDisabled,
	          "is-exceed": _vm.inputExceed,
	          "el-input-group": _vm.$slots.prepend || _vm.$slots.append,
	          "el-input-group--append": _vm.$slots.append,
	          "el-input-group--prepend": _vm.$slots.prepend,
	          "el-input--prefix": _vm.$slots.prefix || _vm.prefixIcon,
	          "el-input--suffix":
	            _vm.$slots.suffix ||
	            _vm.suffixIcon ||
	            _vm.clearable ||
	            _vm.showPassword
	        }
	      ],
	      on: {
	        mouseenter: function($event) {
	          _vm.hovering = true
	        },
	        mouseleave: function($event) {
	          _vm.hovering = false
	        }
	      }
	    },
	    [
	      _vm.type !== "textarea"
	        ? [
	            _vm.$slots.prepend
	              ? _c(
	                  "div",
	                  { staticClass: "el-input-group__prepend" },
	                  [_vm._t("prepend")],
	                  2
	                )
	              : _vm._e(),
	            _vm.type !== "textarea"
	              ? _c(
	                  "input",
	                  _vm._b(
	                    {
	                      ref: "input",
	                      staticClass: "el-input__inner",
	                      attrs: {
	                        tabindex: _vm.tabindex,
	                        type: _vm.showPassword
	                          ? _vm.passwordVisible
	                            ? "text"
	                            : "password"
	                          : _vm.type,
	                        disabled: _vm.inputDisabled,
	                        readonly: _vm.readonly,
	                        autocomplete: _vm.autoComplete || _vm.autocomplete,
	                        "aria-label": _vm.label
	                      },
	                      on: {
	                        compositionstart: _vm.handleCompositionStart,
	                        compositionupdate: _vm.handleCompositionUpdate,
	                        compositionend: _vm.handleCompositionEnd,
	                        input: _vm.handleInput,
	                        focus: _vm.handleFocus,
	                        blur: _vm.handleBlur,
	                        change: _vm.handleChange
	                      }
	                    },
	                    "input",
	                    _vm.$attrs,
	                    false
	                  )
	                )
	              : _vm._e(),
	            _vm.$slots.prefix || _vm.prefixIcon
	              ? _c(
	                  "span",
	                  { staticClass: "el-input__prefix" },
	                  [
	                    _vm._t("prefix"),
	                    _vm.prefixIcon
	                      ? _c("i", {
	                          staticClass: "el-input__icon",
	                          class: _vm.prefixIcon
	                        })
	                      : _vm._e()
	                  ],
	                  2
	                )
	              : _vm._e(),
	            _vm.getSuffixVisible()
	              ? _c("span", { staticClass: "el-input__suffix" }, [
	                  _c(
	                    "span",
	                    { staticClass: "el-input__suffix-inner" },
	                    [
	                      !_vm.showClear ||
	                      !_vm.showPwdVisible ||
	                      !_vm.isWordLimitVisible
	                        ? [
	                            _vm._t("suffix"),
	                            _vm.suffixIcon
	                              ? _c("i", {
	                                  staticClass: "el-input__icon",
	                                  class: _vm.suffixIcon
	                                })
	                              : _vm._e()
	                          ]
	                        : _vm._e(),
	                      _vm.showClear
	                        ? _c("i", {
	                            staticClass:
	                              "el-input__icon el-icon-circle-close el-input__clear",
	                            on: {
	                              mousedown: function($event) {
	                                $event.preventDefault()
	                              },
	                              click: _vm.clear
	                            }
	                          })
	                        : _vm._e(),
	                      _vm.showPwdVisible
	                        ? _c("i", {
	                            staticClass:
	                              "el-input__icon el-icon-view el-input__clear",
	                            on: { click: _vm.handlePasswordVisible }
	                          })
	                        : _vm._e(),
	                      _vm.isWordLimitVisible
	                        ? _c("span", { staticClass: "el-input__count" }, [
	                            _c(
	                              "span",
	                              { staticClass: "el-input__count-inner" },
	                              [
	                                _vm._v(
	                                  "\n            " +
	                                    _vm._s(_vm.textLength) +
	                                    "/" +
	                                    _vm._s(_vm.upperLimit) +
	                                    "\n          "
	                                )
	                              ]
	                            )
	                          ])
	                        : _vm._e()
	                    ],
	                    2
	                  ),
	                  _vm.validateState
	                    ? _c("i", {
	                        staticClass: "el-input__icon",
	                        class: ["el-input__validateIcon", _vm.validateIcon]
	                      })
	                    : _vm._e()
	                ])
	              : _vm._e(),
	            _vm.$slots.append
	              ? _c(
	                  "div",
	                  { staticClass: "el-input-group__append" },
	                  [_vm._t("append")],
	                  2
	                )
	              : _vm._e()
	          ]
	        : _c(
	            "textarea",
	            _vm._b(
	              {
	                ref: "textarea",
	                staticClass: "el-textarea__inner",
	                style: _vm.textareaStyle,
	                attrs: {
	                  tabindex: _vm.tabindex,
	                  disabled: _vm.inputDisabled,
	                  readonly: _vm.readonly,
	                  autocomplete: _vm.autoComplete || _vm.autocomplete,
	                  "aria-label": _vm.label
	                },
	                on: {
	                  compositionstart: _vm.handleCompositionStart,
	                  compositionupdate: _vm.handleCompositionUpdate,
	                  compositionend: _vm.handleCompositionEnd,
	                  input: _vm.handleInput,
	                  focus: _vm.handleFocus,
	                  blur: _vm.handleBlur,
	                  change: _vm.handleChange
	                }
	              },
	              "textarea",
	              _vm.$attrs,
	              false
	            )
	          ),
	      _vm.isWordLimitVisible && _vm.type === "textarea"
	        ? _c("span", { staticClass: "el-input__count" }, [
	            _vm._v(_vm._s(_vm.textLength) + "/" + _vm._s(_vm.upperLimit))
	          ])
	        : _vm._e()
	    ],
	    2
	  )
	}
	var inputvue_type_template_id_343dd774_staticRenderFns = []
	inputvue_type_template_id_343dd774_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/input/src/input.vue?vue&type=template&id=343dd774&
	
	// CONCATENATED MODULE: ./packages/input/src/calcTextareaHeight.js
	var hiddenTextarea = void 0;
	
	var HIDDEN_STYLE = '\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n';
	
	var CONTEXT_STYLE = ['letter-spacing', 'line-height', 'padding-top', 'padding-bottom', 'font-family', 'font-weight', 'font-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-left', 'padding-right', 'border-width', 'box-sizing'];
	
	function calculateNodeStyling(targetElement) {
	  var style = window.getComputedStyle(targetElement);
	
	  var boxSizing = style.getPropertyValue('box-sizing');
	
	  var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));
	
	  var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));
	
	  var contextStyle = CONTEXT_STYLE.map(function (name) {
	    return name + ':' + style.getPropertyValue(name);
	  }).join(';');
	
	  return { contextStyle: contextStyle, paddingSize: paddingSize, borderSize: borderSize, boxSizing: boxSizing };
	}
	
	function calcTextareaHeight(targetElement) {
	  var minRows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  var maxRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  if (!hiddenTextarea) {
	    hiddenTextarea = document.createElement('textarea');
	    document.body.appendChild(hiddenTextarea);
	  }
	
	  var _calculateNodeStyling = calculateNodeStyling(targetElement),
	      paddingSize = _calculateNodeStyling.paddingSize,
	      borderSize = _calculateNodeStyling.borderSize,
	      boxSizing = _calculateNodeStyling.boxSizing,
	      contextStyle = _calculateNodeStyling.contextStyle;
	
	  hiddenTextarea.setAttribute('style', contextStyle + ';' + HIDDEN_STYLE);
	  hiddenTextarea.value = targetElement.value || targetElement.placeholder || '';
	
	  var height = hiddenTextarea.scrollHeight;
	  var result = {};
	
	  if (boxSizing === 'border-box') {
	    height = height + borderSize;
	  } else if (boxSizing === 'content-box') {
	    height = height - paddingSize;
	  }
	
	  hiddenTextarea.value = '';
	  var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;
	
	  if (minRows !== null) {
	    var minHeight = singleRowHeight * minRows;
	    if (boxSizing === 'border-box') {
	      minHeight = minHeight + paddingSize + borderSize;
	    }
	    height = Math.max(minHeight, height);
	    result.minHeight = minHeight + 'px';
	  }
	  if (maxRows !== null) {
	    var maxHeight = singleRowHeight * maxRows;
	    if (boxSizing === 'border-box') {
	      maxHeight = maxHeight + paddingSize + borderSize;
	    }
	    height = Math.min(maxHeight, height);
	  }
	  result.height = height + 'px';
	  hiddenTextarea.parentNode && hiddenTextarea.parentNode.removeChild(hiddenTextarea);
	  hiddenTextarea = null;
	  return result;
	};
	// EXTERNAL MODULE: external "element-ui/lib/utils/merge"
	var merge_ = __webpack_require__(7);
	var merge_default = /*#__PURE__*/__webpack_require__.n(merge_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/shared"
	var shared_ = __webpack_require__(19);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/input/src/input.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	/* harmony default export */ var inputvue_type_script_lang_js_ = ({
	  name: 'ElInput',
	
	  componentName: 'ElInput',
	
	  mixins: [emitter_default.a, migrating_default.a],
	
	  inheritAttrs: false,
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  data: function data() {
	    return {
	      textareaCalcStyle: {},
	      hovering: false,
	      focused: false,
	      isComposing: false,
	      passwordVisible: false
	    };
	  },
	
	
	  props: {
	    value: [String, Number],
	    size: String,
	    resize: String,
	    form: String,
	    disabled: Boolean,
	    readonly: Boolean,
	    type: {
	      type: String,
	      default: 'text'
	    },
	    autosize: {
	      type: [Boolean, Object],
	      default: false
	    },
	    autocomplete: {
	      type: String,
	      default: 'off'
	    },
	    /** @Deprecated in next major version */
	    autoComplete: {
	      type: String,
	      validator: function validator(val) {
	         false && false;
	        return true;
	      }
	    },
	    validateEvent: {
	      type: Boolean,
	      default: true
	    },
	    suffixIcon: String,
	    prefixIcon: String,
	    label: String,
	    clearable: {
	      type: Boolean,
	      default: false
	    },
	    showPassword: {
	      type: Boolean,
	      default: false
	    },
	    showWordLimit: {
	      type: Boolean,
	      default: false
	    },
	    tabindex: String
	  },
	
	  computed: {
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    validateState: function validateState() {
	      return this.elFormItem ? this.elFormItem.validateState : '';
	    },
	    needStatusIcon: function needStatusIcon() {
	      return this.elForm ? this.elForm.statusIcon : false;
	    },
	    validateIcon: function validateIcon() {
	      return {
	        validating: 'el-icon-loading',
	        success: 'el-icon-circle-check',
	        error: 'el-icon-circle-close'
	      }[this.validateState];
	    },
	    textareaStyle: function textareaStyle() {
	      return merge_default()({}, this.textareaCalcStyle, { resize: this.resize });
	    },
	    inputSize: function inputSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    inputDisabled: function inputDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    },
	    nativeInputValue: function nativeInputValue() {
	      return this.value === null || this.value === undefined ? '' : String(this.value);
	    },
	    showClear: function showClear() {
	      return this.clearable && !this.inputDisabled && !this.readonly && this.nativeInputValue && (this.focused || this.hovering);
	    },
	    showPwdVisible: function showPwdVisible() {
	      return this.showPassword && !this.inputDisabled && !this.readonly && (!!this.nativeInputValue || this.focused);
	    },
	    isWordLimitVisible: function isWordLimitVisible() {
	      return this.showWordLimit && this.$attrs.maxlength && (this.type === 'text' || this.type === 'textarea') && !this.inputDisabled && !this.readonly && !this.showPassword;
	    },
	    upperLimit: function upperLimit() {
	      return this.$attrs.maxlength;
	    },
	    textLength: function textLength() {
	      if (typeof this.value === 'number') {
	        return String(this.value).length;
	      }
	
	      return (this.value || '').length;
	    },
	    inputExceed: function inputExceed() {
	      // show exceed style if length of initial value greater then maxlength
	      return this.isWordLimitVisible && this.textLength > this.upperLimit;
	    }
	  },
	
	  watch: {
	    value: function value(val) {
	      this.$nextTick(this.resizeTextarea);
	      if (this.validateEvent) {
	        this.dispatch('ElFormItem', 'el.form.change', [val]);
	      }
	    },
	
	    // native input value is set explicitly
	    // do not use v-model / :value in template
	    // see: https://github.com/ElemeFE/element/issues/14521
	    nativeInputValue: function nativeInputValue() {
	      this.setNativeInputValue();
	    },
	
	    // when change between <input> and <textarea>,
	    // update DOM dependent value and styles
	    // https://github.com/ElemeFE/element/issues/14857
	    type: function type() {
	      var _this = this;
	
	      this.$nextTick(function () {
	        _this.setNativeInputValue();
	        _this.resizeTextarea();
	        _this.updateIconOffset();
	      });
	    }
	  },
	
	  methods: {
	    focus: function focus() {
	      this.getInput().focus();
	    },
	    blur: function blur() {
	      this.getInput().blur();
	    },
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'icon': 'icon is removed, use suffix-icon / prefix-icon instead.',
	          'on-icon-click': 'on-icon-click is removed.'
	        },
	        events: {
	          'click': 'click is removed.'
	        }
	      };
	    },
	    handleBlur: function handleBlur(event) {
	      this.focused = false;
	      this.$emit('blur', event);
	      if (this.validateEvent) {
	        this.dispatch('ElFormItem', 'el.form.blur', [this.value]);
	      }
	    },
	    select: function select() {
	      this.getInput().select();
	    },
	    resizeTextarea: function resizeTextarea() {
	      if (this.$isServer) return;
	      var autosize = this.autosize,
	          type = this.type;
	
	      if (type !== 'textarea') return;
	      if (!autosize) {
	        this.textareaCalcStyle = {
	          minHeight: calcTextareaHeight(this.$refs.textarea).minHeight
	        };
	        return;
	      }
	      var minRows = autosize.minRows;
	      var maxRows = autosize.maxRows;
	
	      this.textareaCalcStyle = calcTextareaHeight(this.$refs.textarea, minRows, maxRows);
	    },
	    setNativeInputValue: function setNativeInputValue() {
	      var input = this.getInput();
	      if (!input) return;
	      if (input.value === this.nativeInputValue) return;
	      input.value = this.nativeInputValue;
	    },
	    handleFocus: function handleFocus(event) {
	      this.focused = true;
	      this.$emit('focus', event);
	    },
	    handleCompositionStart: function handleCompositionStart() {
	      this.isComposing = true;
	    },
	    handleCompositionUpdate: function handleCompositionUpdate(event) {
	      var text = event.target.value;
	      var lastCharacter = text[text.length - 1] || '';
	      this.isComposing = !Object(shared_["isKorean"])(lastCharacter);
	    },
	    handleCompositionEnd: function handleCompositionEnd(event) {
	      if (this.isComposing) {
	        this.isComposing = false;
	        this.handleInput(event);
	      }
	    },
	    handleInput: function handleInput(event) {
	      // should not emit input during composition
	      // see: https://github.com/ElemeFE/element/issues/10516
	      if (this.isComposing) return;
	
	      // hack for https://github.com/ElemeFE/element/issues/8548
	      // should remove the following line when we don't support IE
	      if (event.target.value === this.nativeInputValue) return;
	
	      this.$emit('input', event.target.value);
	
	      // ensure native input value is controlled
	      // see: https://github.com/ElemeFE/element/issues/12850
	      this.$nextTick(this.setNativeInputValue);
	    },
	    handleChange: function handleChange(event) {
	      this.$emit('change', event.target.value);
	    },
	    calcIconOffset: function calcIconOffset(place) {
	      var elList = [].slice.call(this.$el.querySelectorAll('.el-input__' + place) || []);
	      if (!elList.length) return;
	      var el = null;
	      for (var i = 0; i < elList.length; i++) {
	        if (elList[i].parentNode === this.$el) {
	          el = elList[i];
	          break;
	        }
	      }
	      if (!el) return;
	      var pendantMap = {
	        suffix: 'append',
	        prefix: 'prepend'
	      };
	
	      var pendant = pendantMap[place];
	      if (this.$slots[pendant]) {
	        el.style.transform = 'translateX(' + (place === 'suffix' ? '-' : '') + this.$el.querySelector('.el-input-group__' + pendant).offsetWidth + 'px)';
	      } else {
	        el.removeAttribute('style');
	      }
	    },
	    updateIconOffset: function updateIconOffset() {
	      this.calcIconOffset('prefix');
	      this.calcIconOffset('suffix');
	    },
	    clear: function clear() {
	      this.$emit('input', '');
	      this.$emit('change', '');
	      this.$emit('clear');
	    },
	    handlePasswordVisible: function handlePasswordVisible() {
	      var _this2 = this;
	
	      this.passwordVisible = !this.passwordVisible;
	      this.$nextTick(function () {
	        _this2.focus();
	      });
	    },
	    getInput: function getInput() {
	      return this.$refs.input || this.$refs.textarea;
	    },
	    getSuffixVisible: function getSuffixVisible() {
	      return this.$slots.suffix || this.suffixIcon || this.showClear || this.showPassword || this.isWordLimitVisible || this.validateState && this.needStatusIcon;
	    }
	  },
	
	  created: function created() {
	    this.$on('inputSelect', this.select);
	  },
	  mounted: function mounted() {
	    this.setNativeInputValue();
	    this.resizeTextarea();
	    this.updateIconOffset();
	  },
	  updated: function updated() {
	    this.$nextTick(this.updateIconOffset);
	  }
	});
	// CONCATENATED MODULE: ./packages/input/src/input.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_inputvue_type_script_lang_js_ = (inputvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/input/src/input.vue
	
	
	
	
	
	/* normalize component */
	
	var input_component = normalizeComponent(
	  src_inputvue_type_script_lang_js_,
	  inputvue_type_template_id_343dd774_render,
	  inputvue_type_template_id_343dd774_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var input_api; }
	input_component.options.__file = "packages/input/src/input.vue"
	/* harmony default export */ var src_input = (input_component.exports);
	// CONCATENATED MODULE: ./packages/input/index.js
	
	
	/* istanbul ignore next */
	src_input.install = function (Vue) {
	  Vue.component(src_input.name, src_input);
	};
	
	/* harmony default export */ var packages_input = (src_input);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/input-number/src/input-number.vue?vue&type=template&id=42f8cf66&
	var input_numbervue_type_template_id_42f8cf66_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      class: [
	        "el-input-number",
	        _vm.inputNumberSize ? "el-input-number--" + _vm.inputNumberSize : "",
	        { "is-disabled": _vm.inputNumberDisabled },
	        { "is-without-controls": !_vm.controls },
	        { "is-controls-right": _vm.controlsAtRight }
	      ],
	      on: {
	        dragstart: function($event) {
	          $event.preventDefault()
	        }
	      }
	    },
	    [
	      _vm.controls
	        ? _c(
	            "span",
	            {
	              directives: [
	                {
	                  name: "repeat-click",
	                  rawName: "v-repeat-click",
	                  value: _vm.decrease,
	                  expression: "decrease"
	                }
	              ],
	              staticClass: "el-input-number__decrease",
	              class: { "is-disabled": _vm.minDisabled },
	              attrs: { role: "button" },
	              on: {
	                keydown: function($event) {
	                  if (
	                    !("button" in $event) &&
	                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
	                  ) {
	                    return null
	                  }
	                  return _vm.decrease($event)
	                }
	              }
	            },
	            [
	              _c("i", {
	                class:
	                  "el-icon-" + (_vm.controlsAtRight ? "arrow-down" : "minus")
	              })
	            ]
	          )
	        : _vm._e(),
	      _vm.controls
	        ? _c(
	            "span",
	            {
	              directives: [
	                {
	                  name: "repeat-click",
	                  rawName: "v-repeat-click",
	                  value: _vm.increase,
	                  expression: "increase"
	                }
	              ],
	              staticClass: "el-input-number__increase",
	              class: { "is-disabled": _vm.maxDisabled },
	              attrs: { role: "button" },
	              on: {
	                keydown: function($event) {
	                  if (
	                    !("button" in $event) &&
	                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
	                  ) {
	                    return null
	                  }
	                  return _vm.increase($event)
	                }
	              }
	            },
	            [
	              _c("i", {
	                class: "el-icon-" + (_vm.controlsAtRight ? "arrow-up" : "plus")
	              })
	            ]
	          )
	        : _vm._e(),
	      _c("el-input", {
	        ref: "input",
	        attrs: {
	          value: _vm.displayValue,
	          placeholder: _vm.placeholder,
	          disabled: _vm.inputNumberDisabled,
	          size: _vm.inputNumberSize,
	          max: _vm.max,
	          min: _vm.min,
	          name: _vm.name,
	          label: _vm.label
	        },
	        on: {
	          blur: _vm.handleBlur,
	          focus: _vm.handleFocus,
	          input: _vm.handleInput,
	          change: _vm.handleInputChange
	        },
	        nativeOn: {
	          keydown: [
	            function($event) {
	              if (
	                !("button" in $event) &&
	                _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
	              ) {
	                return null
	              }
	              $event.preventDefault()
	              return _vm.increase($event)
	            },
	            function($event) {
	              if (
	                !("button" in $event) &&
	                _vm._k($event.keyCode, "down", 40, $event.key, [
	                  "Down",
	                  "ArrowDown"
	                ])
	              ) {
	                return null
	              }
	              $event.preventDefault()
	              return _vm.decrease($event)
	            }
	          ]
	        }
	      })
	    ],
	    1
	  )
	}
	var input_numbervue_type_template_id_42f8cf66_staticRenderFns = []
	input_numbervue_type_template_id_42f8cf66_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/input-number/src/input-number.vue?vue&type=template&id=42f8cf66&
	
	// CONCATENATED MODULE: ./src/directives/repeat-click.js
	
	
	/* harmony default export */ var repeat_click = ({
	  bind: function bind(el, binding, vnode) {
	    var interval = null;
	    var startTime = void 0;
	    var handler = function handler() {
	      return vnode.context[binding.expression].apply();
	    };
	    var clear = function clear() {
	      if (Date.now() - startTime < 100) {
	        handler();
	      }
	      clearInterval(interval);
	      interval = null;
	    };
	
	    Object(dom_["on"])(el, 'mousedown', function (e) {
	      if (e.button !== 0) return;
	      startTime = Date.now();
	      Object(dom_["once"])(document, 'mouseup', clear);
	      clearInterval(interval);
	      interval = setInterval(handler, 100);
	    });
	  }
	});
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/input-number/src/input-number.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var input_numbervue_type_script_lang_js_ = ({
	  name: 'ElInputNumber',
	  mixins: [focus_default()('input')],
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	  directives: {
	    repeatClick: repeat_click
	  },
	  components: {
	    ElInput: input_default.a
	  },
	  props: {
	    step: {
	      type: Number,
	      default: 1
	    },
	    stepStrictly: {
	      type: Boolean,
	      default: false
	    },
	    max: {
	      type: Number,
	      default: Infinity
	    },
	    min: {
	      type: Number,
	      default: -Infinity
	    },
	    value: {},
	    disabled: Boolean,
	    size: String,
	    controls: {
	      type: Boolean,
	      default: true
	    },
	    controlsPosition: {
	      type: String,
	      default: ''
	    },
	    name: String,
	    label: String,
	    placeholder: String,
	    precision: {
	      type: Number,
	      validator: function validator(val) {
	        return val >= 0 && val === parseInt(val, 10);
	      }
	    }
	  },
	  data: function data() {
	    return {
	      currentValue: 0,
	      userInput: null
	    };
	  },
	
	  watch: {
	    value: {
	      immediate: true,
	      handler: function handler(value) {
	        var newVal = value === undefined ? value : Number(value);
	        if (newVal !== undefined) {
	          if (isNaN(newVal)) {
	            return;
	          }
	
	          if (this.stepStrictly) {
	            var stepPrecision = this.getPrecision(this.step);
	            var precisionFactor = Math.pow(10, stepPrecision);
	            newVal = Math.round(newVal / this.step) * precisionFactor * this.step / precisionFactor;
	          }
	
	          if (this.precision !== undefined) {
	            newVal = this.toPrecision(newVal, this.precision);
	          }
	        }
	        if (newVal >= this.max) newVal = this.max;
	        if (newVal <= this.min) newVal = this.min;
	        this.currentValue = newVal;
	        this.userInput = null;
	        this.$emit('input', newVal);
	      }
	    }
	  },
	  computed: {
	    minDisabled: function minDisabled() {
	      return this._decrease(this.value, this.step) < this.min;
	    },
	    maxDisabled: function maxDisabled() {
	      return this._increase(this.value, this.step) > this.max;
	    },
	    numPrecision: function numPrecision() {
	      var value = this.value,
	          step = this.step,
	          getPrecision = this.getPrecision,
	          precision = this.precision;
	
	      var stepPrecision = getPrecision(step);
	      if (precision !== undefined) {
	        if (stepPrecision > precision) {
	          console.warn('[Element Warn][InputNumber]precision should not be less than the decimal places of step');
	        }
	        return precision;
	      } else {
	        return Math.max(getPrecision(value), stepPrecision);
	      }
	    },
	    controlsAtRight: function controlsAtRight() {
	      return this.controls && this.controlsPosition === 'right';
	    },
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    inputNumberSize: function inputNumberSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    inputNumberDisabled: function inputNumberDisabled() {
	      return this.disabled || !!(this.elForm || {}).disabled;
	    },
	    displayValue: function displayValue() {
	      if (this.userInput !== null) {
	        return this.userInput;
	      }
	
	      var currentValue = this.currentValue;
	
	      if (typeof currentValue === 'number') {
	        if (this.stepStrictly) {
	          var stepPrecision = this.getPrecision(this.step);
	          var precisionFactor = Math.pow(10, stepPrecision);
	          currentValue = Math.round(currentValue / this.step) * precisionFactor * this.step / precisionFactor;
	        }
	
	        if (this.precision !== undefined) {
	          currentValue = currentValue.toFixed(this.precision);
	        }
	      }
	
	      return currentValue;
	    }
	  },
	  methods: {
	    toPrecision: function toPrecision(num, precision) {
	      if (precision === undefined) precision = this.numPrecision;
	      return parseFloat(Math.round(num * Math.pow(10, precision)) / Math.pow(10, precision));
	    },
	    getPrecision: function getPrecision(value) {
	      if (value === undefined) return 0;
	      var valueString = value.toString();
	      var dotPosition = valueString.indexOf('.');
	      var precision = 0;
	      if (dotPosition !== -1) {
	        precision = valueString.length - dotPosition - 1;
	      }
	      return precision;
	    },
	    _increase: function _increase(val, step) {
	      if (typeof val !== 'number' && val !== undefined) return this.currentValue;
	
	      var precisionFactor = Math.pow(10, this.numPrecision);
	      // Solve the accuracy problem of JS decimal calculation by converting the value to integer.
	      return this.toPrecision((precisionFactor * val + precisionFactor * step) / precisionFactor);
	    },
	    _decrease: function _decrease(val, step) {
	      if (typeof val !== 'number' && val !== undefined) return this.currentValue;
	
	      var precisionFactor = Math.pow(10, this.numPrecision);
	
	      return this.toPrecision((precisionFactor * val - precisionFactor * step) / precisionFactor);
	    },
	    increase: function increase() {
	      if (this.inputNumberDisabled || this.maxDisabled) return;
	      var value = this.value || 0;
	      var newVal = this._increase(value, this.step);
	      this.setCurrentValue(newVal);
	    },
	    decrease: function decrease() {
	      if (this.inputNumberDisabled || this.minDisabled) return;
	      var value = this.value || 0;
	      var newVal = this._decrease(value, this.step);
	      this.setCurrentValue(newVal);
	    },
	    handleBlur: function handleBlur(event) {
	      this.$emit('blur', event);
	    },
	    handleFocus: function handleFocus(event) {
	      this.$emit('focus', event);
	    },
	    setCurrentValue: function setCurrentValue(newVal) {
	      var oldVal = this.currentValue;
	      if (typeof newVal === 'number' && this.precision !== undefined) {
	        newVal = this.toPrecision(newVal, this.precision);
	      }
	      if (newVal >= this.max) newVal = this.max;
	      if (newVal <= this.min) newVal = this.min;
	      if (oldVal === newVal) return;
	      this.userInput = null;
	      this.$emit('input', newVal);
	      this.$emit('change', newVal, oldVal);
	      this.currentValue = newVal;
	    },
	    handleInput: function handleInput(value) {
	      this.userInput = value;
	    },
	    handleInputChange: function handleInputChange(value) {
	      var newVal = value === '' ? undefined : Number(value);
	      if (!isNaN(newVal) || value === '') {
	        this.setCurrentValue(newVal);
	      }
	      this.userInput = null;
	    },
	    select: function select() {
	      this.$refs.input.select();
	    }
	  },
	  mounted: function mounted() {
	    var innerInput = this.$refs.input.$refs.input;
	    innerInput.setAttribute('role', 'spinbutton');
	    innerInput.setAttribute('aria-valuemax', this.max);
	    innerInput.setAttribute('aria-valuemin', this.min);
	    innerInput.setAttribute('aria-valuenow', this.currentValue);
	    innerInput.setAttribute('aria-disabled', this.inputNumberDisabled);
	  },
	  updated: function updated() {
	    if (!this.$refs || !this.$refs.input) return;
	    var innerInput = this.$refs.input.$refs.input;
	    innerInput.setAttribute('aria-valuenow', this.currentValue);
	  }
	});
	// CONCATENATED MODULE: ./packages/input-number/src/input-number.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_input_numbervue_type_script_lang_js_ = (input_numbervue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/input-number/src/input-number.vue
	
	
	
	
	
	/* normalize component */
	
	var input_number_component = normalizeComponent(
	  src_input_numbervue_type_script_lang_js_,
	  input_numbervue_type_template_id_42f8cf66_render,
	  input_numbervue_type_template_id_42f8cf66_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var input_number_api; }
	input_number_component.options.__file = "packages/input-number/src/input-number.vue"
	/* harmony default export */ var input_number = (input_number_component.exports);
	// CONCATENATED MODULE: ./packages/input-number/index.js
	
	
	/* istanbul ignore next */
	input_number.install = function (Vue) {
	  Vue.component(input_number.name, input_number);
	};
	
	/* harmony default export */ var packages_input_number = (input_number);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio.vue?vue&type=template&id=69cd6268&
	var radiovue_type_template_id_69cd6268_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "label",
	    {
	      staticClass: "el-radio",
	      class: [
	        _vm.border && _vm.radioSize ? "el-radio--" + _vm.radioSize : "",
	        { "is-disabled": _vm.isDisabled },
	        { "is-focus": _vm.focus },
	        { "is-bordered": _vm.border },
	        { "is-checked": _vm.model === _vm.label }
	      ],
	      attrs: {
	        role: "radio",
	        "aria-checked": _vm.model === _vm.label,
	        "aria-disabled": _vm.isDisabled,
	        tabindex: _vm.tabIndex
	      },
	      on: {
	        keydown: function($event) {
	          if (
	            !("button" in $event) &&
	            _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])
	          ) {
	            return null
	          }
	          $event.stopPropagation()
	          $event.preventDefault()
	          _vm.model = _vm.isDisabled ? _vm.model : _vm.label
	        }
	      }
	    },
	    [
	      _c(
	        "span",
	        {
	          staticClass: "el-radio__input",
	          class: {
	            "is-disabled": _vm.isDisabled,
	            "is-checked": _vm.model === _vm.label
	          }
	        },
	        [
	          _c("span", { staticClass: "el-radio__inner" }),
	          _c("input", {
	            directives: [
	              {
	                name: "model",
	                rawName: "v-model",
	                value: _vm.model,
	                expression: "model"
	              }
	            ],
	            ref: "radio",
	            staticClass: "el-radio__original",
	            attrs: {
	              type: "radio",
	              "aria-hidden": "true",
	              name: _vm.name,
	              disabled: _vm.isDisabled,
	              tabindex: "-1"
	            },
	            domProps: {
	              value: _vm.label,
	              checked: _vm._q(_vm.model, _vm.label)
	            },
	            on: {
	              focus: function($event) {
	                _vm.focus = true
	              },
	              blur: function($event) {
	                _vm.focus = false
	              },
	              change: [
	                function($event) {
	                  _vm.model = _vm.label
	                },
	                _vm.handleChange
	              ]
	            }
	          })
	        ]
	      ),
	      _c(
	        "span",
	        {
	          staticClass: "el-radio__label",
	          on: {
	            keydown: function($event) {
	              $event.stopPropagation()
	            }
	          }
	        },
	        [
	          _vm._t("default"),
	          !_vm.$slots.default ? [_vm._v(_vm._s(_vm.label))] : _vm._e()
	        ],
	        2
	      )
	    ]
	  )
	}
	var radiovue_type_template_id_69cd6268_staticRenderFns = []
	radiovue_type_template_id_69cd6268_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/radio/src/radio.vue?vue&type=template&id=69cd6268&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var radiovue_type_script_lang_js_ = ({
	  name: 'ElRadio',
	
	  mixins: [emitter_default.a],
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  componentName: 'ElRadio',
	
	  props: {
	    value: {},
	    label: {},
	    disabled: Boolean,
	    name: String,
	    border: Boolean,
	    size: String
	  },
	
	  data: function data() {
	    return {
	      focus: false
	    };
	  },
	
	  computed: {
	    isGroup: function isGroup() {
	      var parent = this.$parent;
	      while (parent) {
	        if (parent.$options.componentName !== 'ElRadioGroup') {
	          parent = parent.$parent;
	        } else {
	          this._radioGroup = parent;
	          return true;
	        }
	      }
	      return false;
	    },
	
	    model: {
	      get: function get() {
	        return this.isGroup ? this._radioGroup.value : this.value;
	      },
	      set: function set(val) {
	        if (this.isGroup) {
	          this.dispatch('ElRadioGroup', 'input', [val]);
	        } else {
	          this.$emit('input', val);
	        }
	        this.$refs.radio && (this.$refs.radio.checked = this.model === this.label);
	      }
	    },
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    radioSize: function radioSize() {
	      var temRadioSize = this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	      return this.isGroup ? this._radioGroup.radioGroupSize || temRadioSize : temRadioSize;
	    },
	    isDisabled: function isDisabled() {
	      return this.isGroup ? this._radioGroup.disabled || this.disabled || (this.elForm || {}).disabled : this.disabled || (this.elForm || {}).disabled;
	    },
	    tabIndex: function tabIndex() {
	      return this.isDisabled || this.isGroup && this.model !== this.label ? -1 : 0;
	    }
	  },
	
	  methods: {
	    handleChange: function handleChange() {
	      var _this = this;
	
	      this.$nextTick(function () {
	        _this.$emit('change', _this.model);
	        _this.isGroup && _this.dispatch('ElRadioGroup', 'handleChange', _this.model);
	      });
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/radio/src/radio.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_radiovue_type_script_lang_js_ = (radiovue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/radio/src/radio.vue
	
	
	
	
	
	/* normalize component */
	
	var radio_component = normalizeComponent(
	  src_radiovue_type_script_lang_js_,
	  radiovue_type_template_id_69cd6268_render,
	  radiovue_type_template_id_69cd6268_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var radio_api; }
	radio_component.options.__file = "packages/radio/src/radio.vue"
	/* harmony default export */ var src_radio = (radio_component.exports);
	// CONCATENATED MODULE: ./packages/radio/index.js
	
	
	/* istanbul ignore next */
	src_radio.install = function (Vue) {
	  Vue.component(src_radio.name, src_radio);
	};
	
	/* harmony default export */ var packages_radio = (src_radio);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio-group.vue?vue&type=template&id=818a704c&
	var radio_groupvue_type_template_id_818a704c_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    _vm._elTag,
	    {
	      tag: "component",
	      staticClass: "el-radio-group",
	      attrs: { role: "radiogroup" },
	      on: { keydown: _vm.handleKeydown }
	    },
	    [_vm._t("default")],
	    2
	  )
	}
	var radio_groupvue_type_template_id_818a704c_staticRenderFns = []
	radio_groupvue_type_template_id_818a704c_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/radio/src/radio-group.vue?vue&type=template&id=818a704c&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio-group.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	var keyCode = Object.freeze({
	  LEFT: 37,
	  UP: 38,
	  RIGHT: 39,
	  DOWN: 40
	});
	/* harmony default export */ var radio_groupvue_type_script_lang_js_ = ({
	  name: 'ElRadioGroup',
	
	  componentName: 'ElRadioGroup',
	
	  inject: {
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  mixins: [emitter_default.a],
	
	  props: {
	    value: {},
	    size: String,
	    fill: String,
	    textColor: String,
	    disabled: Boolean
	  },
	
	  computed: {
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    _elTag: function _elTag() {
	      return (this.$vnode.data || {}).tag || 'div';
	    },
	    radioGroupSize: function radioGroupSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    }
	  },
	
	  created: function created() {
	    var _this = this;
	
	    this.$on('handleChange', function (value) {
	      _this.$emit('change', value);
	    });
	  },
	  mounted: function mounted() {
	    // 当radioGroup没有默认选项时，第一个可以选中Tab导航
	    var radios = this.$el.querySelectorAll('[type=radio]');
	    var firstLabel = this.$el.querySelectorAll('[role=radio]')[0];
	    if (![].some.call(radios, function (radio) {
	      return radio.checked;
	    }) && firstLabel) {
	      firstLabel.tabIndex = 0;
	    }
	  },
	
	  methods: {
	    handleKeydown: function handleKeydown(e) {
	      // 左右上下按键 可以在radio组内切换不同选项
	      var target = e.target;
	      var className = target.nodeName === 'INPUT' ? '[type=radio]' : '[role=radio]';
	      var radios = this.$el.querySelectorAll(className);
	      var length = radios.length;
	      var index = [].indexOf.call(radios, target);
	      var roleRadios = this.$el.querySelectorAll('[role=radio]');
	      switch (e.keyCode) {
	        case keyCode.LEFT:
	        case keyCode.UP:
	          e.stopPropagation();
	          e.preventDefault();
	          if (index === 0) {
	            roleRadios[length - 1].click();
	            roleRadios[length - 1].focus();
	          } else {
	            roleRadios[index - 1].click();
	            roleRadios[index - 1].focus();
	          }
	          break;
	        case keyCode.RIGHT:
	        case keyCode.DOWN:
	          if (index === length - 1) {
	            e.stopPropagation();
	            e.preventDefault();
	            roleRadios[0].click();
	            roleRadios[0].focus();
	          } else {
	            roleRadios[index + 1].click();
	            roleRadios[index + 1].focus();
	          }
	          break;
	        default:
	          break;
	      }
	    }
	  },
	  watch: {
	    value: function value(_value) {
	      this.dispatch('ElFormItem', 'el.form.change', [this.value]);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/radio/src/radio-group.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_radio_groupvue_type_script_lang_js_ = (radio_groupvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/radio/src/radio-group.vue
	
	
	
	
	
	/* normalize component */
	
	var radio_group_component = normalizeComponent(
	  src_radio_groupvue_type_script_lang_js_,
	  radio_groupvue_type_template_id_818a704c_render,
	  radio_groupvue_type_template_id_818a704c_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var radio_group_api; }
	radio_group_component.options.__file = "packages/radio/src/radio-group.vue"
	/* harmony default export */ var radio_group = (radio_group_component.exports);
	// CONCATENATED MODULE: ./packages/radio-group/index.js
	
	
	/* istanbul ignore next */
	radio_group.install = function (Vue) {
	  Vue.component(radio_group.name, radio_group);
	};
	
	/* harmony default export */ var packages_radio_group = (radio_group);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio-button.vue?vue&type=template&id=18a77a32&
	var radio_buttonvue_type_template_id_18a77a32_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "label",
	    {
	      staticClass: "el-radio-button",
	      class: [
	        _vm.size ? "el-radio-button--" + _vm.size : "",
	        { "is-active": _vm.value === _vm.label },
	        { "is-disabled": _vm.isDisabled },
	        { "is-focus": _vm.focus }
	      ],
	      attrs: {
	        role: "radio",
	        "aria-checked": _vm.value === _vm.label,
	        "aria-disabled": _vm.isDisabled,
	        tabindex: _vm.tabIndex
	      },
	      on: {
	        keydown: function($event) {
	          if (
	            !("button" in $event) &&
	            _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])
	          ) {
	            return null
	          }
	          $event.stopPropagation()
	          $event.preventDefault()
	          _vm.value = _vm.isDisabled ? _vm.value : _vm.label
	        }
	      }
	    },
	    [
	      _c("input", {
	        directives: [
	          {
	            name: "model",
	            rawName: "v-model",
	            value: _vm.value,
	            expression: "value"
	          }
	        ],
	        staticClass: "el-radio-button__orig-radio",
	        attrs: {
	          type: "radio",
	          name: _vm.name,
	          disabled: _vm.isDisabled,
	          tabindex: "-1"
	        },
	        domProps: { value: _vm.label, checked: _vm._q(_vm.value, _vm.label) },
	        on: {
	          change: [
	            function($event) {
	              _vm.value = _vm.label
	            },
	            _vm.handleChange
	          ],
	          focus: function($event) {
	            _vm.focus = true
	          },
	          blur: function($event) {
	            _vm.focus = false
	          }
	        }
	      }),
	      _c(
	        "span",
	        {
	          staticClass: "el-radio-button__inner",
	          style: _vm.value === _vm.label ? _vm.activeStyle : null,
	          on: {
	            keydown: function($event) {
	              $event.stopPropagation()
	            }
	          }
	        },
	        [
	          _vm._t("default"),
	          !_vm.$slots.default ? [_vm._v(_vm._s(_vm.label))] : _vm._e()
	        ],
	        2
	      )
	    ]
	  )
	}
	var radio_buttonvue_type_template_id_18a77a32_staticRenderFns = []
	radio_buttonvue_type_template_id_18a77a32_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/radio/src/radio-button.vue?vue&type=template&id=18a77a32&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio-button.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var radio_buttonvue_type_script_lang_js_ = ({
	  name: 'ElRadioButton',
	
	  mixins: [emitter_default.a],
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  props: {
	    label: {},
	    disabled: Boolean,
	    name: String
	  },
	  data: function data() {
	    return {
	      focus: false
	    };
	  },
	
	  computed: {
	    value: {
	      get: function get() {
	        return this._radioGroup.value;
	      },
	      set: function set(value) {
	        this._radioGroup.$emit('input', value);
	      }
	    },
	    _radioGroup: function _radioGroup() {
	      var parent = this.$parent;
	      while (parent) {
	        if (parent.$options.componentName !== 'ElRadioGroup') {
	          parent = parent.$parent;
	        } else {
	          return parent;
	        }
	      }
	      return false;
	    },
	    activeStyle: function activeStyle() {
	      return {
	        backgroundColor: this._radioGroup.fill || '',
	        borderColor: this._radioGroup.fill || '',
	        boxShadow: this._radioGroup.fill ? '-1px 0 0 0 ' + this._radioGroup.fill : '',
	        color: this._radioGroup.textColor || ''
	      };
	    },
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    size: function size() {
	      return this._radioGroup.radioGroupSize || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    isDisabled: function isDisabled() {
	      return this.disabled || this._radioGroup.disabled || (this.elForm || {}).disabled;
	    },
	    tabIndex: function tabIndex() {
	      return this.isDisabled || this._radioGroup && this.value !== this.label ? -1 : 0;
	    }
	  },
	
	  methods: {
	    handleChange: function handleChange() {
	      var _this = this;
	
	      this.$nextTick(function () {
	        _this.dispatch('ElRadioGroup', 'handleChange', _this.value);
	      });
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/radio/src/radio-button.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_radio_buttonvue_type_script_lang_js_ = (radio_buttonvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/radio/src/radio-button.vue
	
	
	
	
	
	/* normalize component */
	
	var radio_button_component = normalizeComponent(
	  src_radio_buttonvue_type_script_lang_js_,
	  radio_buttonvue_type_template_id_18a77a32_render,
	  radio_buttonvue_type_template_id_18a77a32_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var radio_button_api; }
	radio_button_component.options.__file = "packages/radio/src/radio-button.vue"
	/* harmony default export */ var radio_button = (radio_button_component.exports);
	// CONCATENATED MODULE: ./packages/radio-button/index.js
	
	
	/* istanbul ignore next */
	radio_button.install = function (Vue) {
	  Vue.component(radio_button.name, radio_button);
	};
	
	/* harmony default export */ var packages_radio_button = (radio_button);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox.vue?vue&type=template&id=d0387074&
	var checkboxvue_type_template_id_d0387074_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "label",
	    {
	      staticClass: "el-checkbox",
	      class: [
	        _vm.border && _vm.checkboxSize
	          ? "el-checkbox--" + _vm.checkboxSize
	          : "",
	        { "is-disabled": _vm.isDisabled },
	        { "is-bordered": _vm.border },
	        { "is-checked": _vm.isChecked }
	      ],
	      attrs: { id: _vm.id }
	    },
	    [
	      _c(
	        "span",
	        {
	          staticClass: "el-checkbox__input",
	          class: {
	            "is-disabled": _vm.isDisabled,
	            "is-checked": _vm.isChecked,
	            "is-indeterminate": _vm.indeterminate,
	            "is-focus": _vm.focus
	          },
	          attrs: {
	            tabindex: _vm.indeterminate ? 0 : false,
	            role: _vm.indeterminate ? "checkbox" : false,
	            "aria-checked": _vm.indeterminate ? "mixed" : false
	          }
	        },
	        [
	          _c("span", { staticClass: "el-checkbox__inner" }),
	          _vm.trueLabel || _vm.falseLabel
	            ? _c("input", {
	                directives: [
	                  {
	                    name: "model",
	                    rawName: "v-model",
	                    value: _vm.model,
	                    expression: "model"
	                  }
	                ],
	                staticClass: "el-checkbox__original",
	                attrs: {
	                  type: "checkbox",
	                  "aria-hidden": _vm.indeterminate ? "true" : "false",
	                  name: _vm.name,
	                  disabled: _vm.isDisabled,
	                  "true-value": _vm.trueLabel,
	                  "false-value": _vm.falseLabel
	                },
	                domProps: {
	                  checked: Array.isArray(_vm.model)
	                    ? _vm._i(_vm.model, null) > -1
	                    : _vm._q(_vm.model, _vm.trueLabel)
	                },
	                on: {
	                  change: [
	                    function($event) {
	                      var $$a = _vm.model,
	                        $$el = $event.target,
	                        $$c = $$el.checked ? _vm.trueLabel : _vm.falseLabel
	                      if (Array.isArray($$a)) {
	                        var $$v = null,
	                          $$i = _vm._i($$a, $$v)
	                        if ($$el.checked) {
	                          $$i < 0 && (_vm.model = $$a.concat([$$v]))
	                        } else {
	                          $$i > -1 &&
	                            (_vm.model = $$a
	                              .slice(0, $$i)
	                              .concat($$a.slice($$i + 1)))
	                        }
	                      } else {
	                        _vm.model = $$c
	                      }
	                    },
	                    _vm.handleChange
	                  ],
	                  focus: function($event) {
	                    _vm.focus = true
	                  },
	                  blur: function($event) {
	                    _vm.focus = false
	                  }
	                }
	              })
	            : _c("input", {
	                directives: [
	                  {
	                    name: "model",
	                    rawName: "v-model",
	                    value: _vm.model,
	                    expression: "model"
	                  }
	                ],
	                staticClass: "el-checkbox__original",
	                attrs: {
	                  type: "checkbox",
	                  "aria-hidden": _vm.indeterminate ? "true" : "false",
	                  disabled: _vm.isDisabled,
	                  name: _vm.name
	                },
	                domProps: {
	                  value: _vm.label,
	                  checked: Array.isArray(_vm.model)
	                    ? _vm._i(_vm.model, _vm.label) > -1
	                    : _vm.model
	                },
	                on: {
	                  change: [
	                    function($event) {
	                      var $$a = _vm.model,
	                        $$el = $event.target,
	                        $$c = $$el.checked ? true : false
	                      if (Array.isArray($$a)) {
	                        var $$v = _vm.label,
	                          $$i = _vm._i($$a, $$v)
	                        if ($$el.checked) {
	                          $$i < 0 && (_vm.model = $$a.concat([$$v]))
	                        } else {
	                          $$i > -1 &&
	                            (_vm.model = $$a
	                              .slice(0, $$i)
	                              .concat($$a.slice($$i + 1)))
	                        }
	                      } else {
	                        _vm.model = $$c
	                      }
	                    },
	                    _vm.handleChange
	                  ],
	                  focus: function($event) {
	                    _vm.focus = true
	                  },
	                  blur: function($event) {
	                    _vm.focus = false
	                  }
	                }
	              })
	        ]
	      ),
	      _vm.$slots.default || _vm.label
	        ? _c(
	            "span",
	            { staticClass: "el-checkbox__label" },
	            [
	              _vm._t("default"),
	              !_vm.$slots.default ? [_vm._v(_vm._s(_vm.label))] : _vm._e()
	            ],
	            2
	          )
	        : _vm._e()
	    ]
	  )
	}
	var checkboxvue_type_template_id_d0387074_staticRenderFns = []
	checkboxvue_type_template_id_d0387074_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue?vue&type=template&id=d0387074&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var checkboxvue_type_script_lang_js_ = ({
	  name: 'ElCheckbox',
	
	  mixins: [emitter_default.a],
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  componentName: 'ElCheckbox',
	
	  data: function data() {
	    return {
	      selfModel: false,
	      focus: false,
	      isLimitExceeded: false
	    };
	  },
	
	
	  computed: {
	    model: {
	      get: function get() {
	        return this.isGroup ? this.store : this.value !== undefined ? this.value : this.selfModel;
	      },
	      set: function set(val) {
	        if (this.isGroup) {
	          this.isLimitExceeded = false;
	          this._checkboxGroup.min !== undefined && val.length < this._checkboxGroup.min && (this.isLimitExceeded = true);
	
	          this._checkboxGroup.max !== undefined && val.length > this._checkboxGroup.max && (this.isLimitExceeded = true);
	
	          this.isLimitExceeded === false && this.dispatch('ElCheckboxGroup', 'input', [val]);
	        } else {
	          this.$emit('input', val);
	          this.selfModel = val;
	        }
	      }
	    },
	
	    isChecked: function isChecked() {
	      if ({}.toString.call(this.model) === '[object Boolean]') {
	        return this.model;
	      } else if (Array.isArray(this.model)) {
	        return this.model.indexOf(this.label) > -1;
	      } else if (this.model !== null && this.model !== undefined) {
	        return this.model === this.trueLabel;
	      }
	    },
	    isGroup: function isGroup() {
	      var parent = this.$parent;
	      while (parent) {
	        if (parent.$options.componentName !== 'ElCheckboxGroup') {
	          parent = parent.$parent;
	        } else {
	          this._checkboxGroup = parent;
	          return true;
	        }
	      }
	      return false;
	    },
	    store: function store() {
	      return this._checkboxGroup ? this._checkboxGroup.value : this.value;
	    },
	
	
	    /* used to make the isDisabled judgment under max/min props */
	    isLimitDisabled: function isLimitDisabled() {
	      var _checkboxGroup = this._checkboxGroup,
	          max = _checkboxGroup.max,
	          min = _checkboxGroup.min;
	
	      return !!(max || min) && this.model.length >= max && !this.isChecked || this.model.length <= min && this.isChecked;
	    },
	    isDisabled: function isDisabled() {
	      return this.isGroup ? this._checkboxGroup.disabled || this.disabled || (this.elForm || {}).disabled || this.isLimitDisabled : this.disabled || (this.elForm || {}).disabled;
	    },
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    checkboxSize: function checkboxSize() {
	      var temCheckboxSize = this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	      return this.isGroup ? this._checkboxGroup.checkboxGroupSize || temCheckboxSize : temCheckboxSize;
	    }
	  },
	
	  props: {
	    value: {},
	    label: {},
	    indeterminate: Boolean,
	    disabled: Boolean,
	    checked: Boolean,
	    name: String,
	    trueLabel: [String, Number],
	    falseLabel: [String, Number],
	    id: String, /* 当indeterminate为真时，为controls提供相关连的checkbox的id，表明元素间的控制关系*/
	    controls: String, /* 当indeterminate为真时，为controls提供相关连的checkbox的id，表明元素间的控制关系*/
	    border: Boolean,
	    size: String
	  },
	
	  methods: {
	    addToStore: function addToStore() {
	      if (Array.isArray(this.model) && this.model.indexOf(this.label) === -1) {
	        this.model.push(this.label);
	      } else {
	        this.model = this.trueLabel || true;
	      }
	    },
	    handleChange: function handleChange(ev) {
	      var _this = this;
	
	      if (this.isLimitExceeded) return;
	      var value = void 0;
	      if (ev.target.checked) {
	        value = this.trueLabel === undefined ? true : this.trueLabel;
	      } else {
	        value = this.falseLabel === undefined ? false : this.falseLabel;
	      }
	      this.$emit('change', value, ev);
	      this.$nextTick(function () {
	        if (_this.isGroup) {
	          _this.dispatch('ElCheckboxGroup', 'change', [_this._checkboxGroup.value]);
	        }
	      });
	    }
	  },
	
	  created: function created() {
	    this.checked && this.addToStore();
	  },
	  mounted: function mounted() {
	    // 为indeterminate元素 添加aria-controls 属性
	    if (this.indeterminate) {
	      this.$el.setAttribute('aria-controls', this.controls);
	    }
	  },
	
	
	  watch: {
	    value: function value(_value) {
	      this.dispatch('ElFormItem', 'el.form.change', _value);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_checkboxvue_type_script_lang_js_ = (checkboxvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue
	
	
	
	
	
	/* normalize component */
	
	var checkbox_component = normalizeComponent(
	  src_checkboxvue_type_script_lang_js_,
	  checkboxvue_type_template_id_d0387074_render,
	  checkboxvue_type_template_id_d0387074_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var checkbox_api; }
	checkbox_component.options.__file = "packages/checkbox/src/checkbox.vue"
	/* harmony default export */ var src_checkbox = (checkbox_component.exports);
	// CONCATENATED MODULE: ./packages/checkbox/index.js
	
	
	/* istanbul ignore next */
	src_checkbox.install = function (Vue) {
	  Vue.component(src_checkbox.name, src_checkbox);
	};
	
	/* harmony default export */ var packages_checkbox = (src_checkbox);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-button.vue?vue&type=template&id=478e906e&
	var checkbox_buttonvue_type_template_id_478e906e_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "label",
	    {
	      staticClass: "el-checkbox-button",
	      class: [
	        _vm.size ? "el-checkbox-button--" + _vm.size : "",
	        { "is-disabled": _vm.isDisabled },
	        { "is-checked": _vm.isChecked },
	        { "is-focus": _vm.focus }
	      ],
	      attrs: {
	        role: "checkbox",
	        "aria-checked": _vm.isChecked,
	        "aria-disabled": _vm.isDisabled
	      }
	    },
	    [
	      _vm.trueLabel || _vm.falseLabel
	        ? _c("input", {
	            directives: [
	              {
	                name: "model",
	                rawName: "v-model",
	                value: _vm.model,
	                expression: "model"
	              }
	            ],
	            staticClass: "el-checkbox-button__original",
	            attrs: {
	              type: "checkbox",
	              name: _vm.name,
	              disabled: _vm.isDisabled,
	              "true-value": _vm.trueLabel,
	              "false-value": _vm.falseLabel
	            },
	            domProps: {
	              checked: Array.isArray(_vm.model)
	                ? _vm._i(_vm.model, null) > -1
	                : _vm._q(_vm.model, _vm.trueLabel)
	            },
	            on: {
	              change: [
	                function($event) {
	                  var $$a = _vm.model,
	                    $$el = $event.target,
	                    $$c = $$el.checked ? _vm.trueLabel : _vm.falseLabel
	                  if (Array.isArray($$a)) {
	                    var $$v = null,
	                      $$i = _vm._i($$a, $$v)
	                    if ($$el.checked) {
	                      $$i < 0 && (_vm.model = $$a.concat([$$v]))
	                    } else {
	                      $$i > -1 &&
	                        (_vm.model = $$a
	                          .slice(0, $$i)
	                          .concat($$a.slice($$i + 1)))
	                    }
	                  } else {
	                    _vm.model = $$c
	                  }
	                },
	                _vm.handleChange
	              ],
	              focus: function($event) {
	                _vm.focus = true
	              },
	              blur: function($event) {
	                _vm.focus = false
	              }
	            }
	          })
	        : _c("input", {
	            directives: [
	              {
	                name: "model",
	                rawName: "v-model",
	                value: _vm.model,
	                expression: "model"
	              }
	            ],
	            staticClass: "el-checkbox-button__original",
	            attrs: {
	              type: "checkbox",
	              name: _vm.name,
	              disabled: _vm.isDisabled
	            },
	            domProps: {
	              value: _vm.label,
	              checked: Array.isArray(_vm.model)
	                ? _vm._i(_vm.model, _vm.label) > -1
	                : _vm.model
	            },
	            on: {
	              change: [
	                function($event) {
	                  var $$a = _vm.model,
	                    $$el = $event.target,
	                    $$c = $$el.checked ? true : false
	                  if (Array.isArray($$a)) {
	                    var $$v = _vm.label,
	                      $$i = _vm._i($$a, $$v)
	                    if ($$el.checked) {
	                      $$i < 0 && (_vm.model = $$a.concat([$$v]))
	                    } else {
	                      $$i > -1 &&
	                        (_vm.model = $$a
	                          .slice(0, $$i)
	                          .concat($$a.slice($$i + 1)))
	                    }
	                  } else {
	                    _vm.model = $$c
	                  }
	                },
	                _vm.handleChange
	              ],
	              focus: function($event) {
	                _vm.focus = true
	              },
	              blur: function($event) {
	                _vm.focus = false
	              }
	            }
	          }),
	      _vm.$slots.default || _vm.label
	        ? _c(
	            "span",
	            {
	              staticClass: "el-checkbox-button__inner",
	              style: _vm.isChecked ? _vm.activeStyle : null
	            },
	            [_vm._t("default", [_vm._v(_vm._s(_vm.label))])],
	            2
	          )
	        : _vm._e()
	    ]
	  )
	}
	var checkbox_buttonvue_type_template_id_478e906e_staticRenderFns = []
	checkbox_buttonvue_type_template_id_478e906e_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-button.vue?vue&type=template&id=478e906e&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-button.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var checkbox_buttonvue_type_script_lang_js_ = ({
	  name: 'ElCheckboxButton',
	
	  mixins: [emitter_default.a],
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  data: function data() {
	    return {
	      selfModel: false,
	      focus: false,
	      isLimitExceeded: false
	    };
	  },
	
	
	  props: {
	    value: {},
	    label: {},
	    disabled: Boolean,
	    checked: Boolean,
	    name: String,
	    trueLabel: [String, Number],
	    falseLabel: [String, Number]
	  },
	  computed: {
	    model: {
	      get: function get() {
	        return this._checkboxGroup ? this.store : this.value !== undefined ? this.value : this.selfModel;
	      },
	      set: function set(val) {
	        if (this._checkboxGroup) {
	          this.isLimitExceeded = false;
	          this._checkboxGroup.min !== undefined && val.length < this._checkboxGroup.min && (this.isLimitExceeded = true);
	
	          this._checkboxGroup.max !== undefined && val.length > this._checkboxGroup.max && (this.isLimitExceeded = true);
	
	          this.isLimitExceeded === false && this.dispatch('ElCheckboxGroup', 'input', [val]);
	        } else if (this.value !== undefined) {
	          this.$emit('input', val);
	        } else {
	          this.selfModel = val;
	        }
	      }
	    },
	
	    isChecked: function isChecked() {
	      if ({}.toString.call(this.model) === '[object Boolean]') {
	        return this.model;
	      } else if (Array.isArray(this.model)) {
	        return this.model.indexOf(this.label) > -1;
	      } else if (this.model !== null && this.model !== undefined) {
	        return this.model === this.trueLabel;
	      }
	    },
	    _checkboxGroup: function _checkboxGroup() {
	      var parent = this.$parent;
	      while (parent) {
	        if (parent.$options.componentName !== 'ElCheckboxGroup') {
	          parent = parent.$parent;
	        } else {
	          return parent;
	        }
	      }
	      return false;
	    },
	    store: function store() {
	      return this._checkboxGroup ? this._checkboxGroup.value : this.value;
	    },
	    activeStyle: function activeStyle() {
	      return {
	        backgroundColor: this._checkboxGroup.fill || '',
	        borderColor: this._checkboxGroup.fill || '',
	        color: this._checkboxGroup.textColor || '',
	        'box-shadow': '-1px 0 0 0 ' + this._checkboxGroup.fill
	
	      };
	    },
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    size: function size() {
	      return this._checkboxGroup.checkboxGroupSize || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	
	
	    /* used to make the isDisabled judgment under max/min props */
	    isLimitDisabled: function isLimitDisabled() {
	      var _checkboxGroup2 = this._checkboxGroup,
	          max = _checkboxGroup2.max,
	          min = _checkboxGroup2.min;
	
	      return !!(max || min) && this.model.length >= max && !this.isChecked || this.model.length <= min && this.isChecked;
	    },
	    isDisabled: function isDisabled() {
	      return this._checkboxGroup ? this._checkboxGroup.disabled || this.disabled || (this.elForm || {}).disabled || this.isLimitDisabled : this.disabled || (this.elForm || {}).disabled;
	    }
	  },
	  methods: {
	    addToStore: function addToStore() {
	      if (Array.isArray(this.model) && this.model.indexOf(this.label) === -1) {
	        this.model.push(this.label);
	      } else {
	        this.model = this.trueLabel || true;
	      }
	    },
	    handleChange: function handleChange(ev) {
	      var _this = this;
	
	      if (this.isLimitExceeded) return;
	      var value = void 0;
	      if (ev.target.checked) {
	        value = this.trueLabel === undefined ? true : this.trueLabel;
	      } else {
	        value = this.falseLabel === undefined ? false : this.falseLabel;
	      }
	      this.$emit('change', value, ev);
	      this.$nextTick(function () {
	        if (_this._checkboxGroup) {
	          _this.dispatch('ElCheckboxGroup', 'change', [_this._checkboxGroup.value]);
	        }
	      });
	    }
	  },
	
	  created: function created() {
	    this.checked && this.addToStore();
	  }
	});
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-button.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_checkbox_buttonvue_type_script_lang_js_ = (checkbox_buttonvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-button.vue
	
	
	
	
	
	/* normalize component */
	
	var checkbox_button_component = normalizeComponent(
	  src_checkbox_buttonvue_type_script_lang_js_,
	  checkbox_buttonvue_type_template_id_478e906e_render,
	  checkbox_buttonvue_type_template_id_478e906e_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var checkbox_button_api; }
	checkbox_button_component.options.__file = "packages/checkbox/src/checkbox-button.vue"
	/* harmony default export */ var checkbox_button = (checkbox_button_component.exports);
	// CONCATENATED MODULE: ./packages/checkbox-button/index.js
	
	
	/* istanbul ignore next */
	checkbox_button.install = function (Vue) {
	  Vue.component(checkbox_button.name, checkbox_button);
	};
	
	/* harmony default export */ var packages_checkbox_button = (checkbox_button);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-group.vue?vue&type=template&id=7289a290&
	var checkbox_groupvue_type_template_id_7289a290_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-checkbox-group",
	      attrs: { role: "group", "aria-label": "checkbox-group" }
	    },
	    [_vm._t("default")],
	    2
	  )
	}
	var checkbox_groupvue_type_template_id_7289a290_staticRenderFns = []
	checkbox_groupvue_type_template_id_7289a290_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue?vue&type=template&id=7289a290&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-group.vue?vue&type=script&lang=js&
	
	
	
	/* harmony default export */ var checkbox_groupvue_type_script_lang_js_ = ({
	  name: 'ElCheckboxGroup',
	
	  componentName: 'ElCheckboxGroup',
	
	  mixins: [emitter_default.a],
	
	  inject: {
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  props: {
	    value: {},
	    disabled: Boolean,
	    min: Number,
	    max: Number,
	    size: String,
	    fill: String,
	    textColor: String
	  },
	
	  computed: {
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    checkboxGroupSize: function checkboxGroupSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    }
	  },
	
	  watch: {
	    value: function value(_value) {
	      this.dispatch('ElFormItem', 'el.form.change', [_value]);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_checkbox_groupvue_type_script_lang_js_ = (checkbox_groupvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue
	
	
	
	
	
	/* normalize component */
	
	var checkbox_group_component = normalizeComponent(
	  src_checkbox_groupvue_type_script_lang_js_,
	  checkbox_groupvue_type_template_id_7289a290_render,
	  checkbox_groupvue_type_template_id_7289a290_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var checkbox_group_api; }
	checkbox_group_component.options.__file = "packages/checkbox/src/checkbox-group.vue"
	/* harmony default export */ var checkbox_group = (checkbox_group_component.exports);
	// CONCATENATED MODULE: ./packages/checkbox-group/index.js
	
	
	/* istanbul ignore next */
	checkbox_group.install = function (Vue) {
	  Vue.component(checkbox_group.name, checkbox_group);
	};
	
	/* harmony default export */ var packages_checkbox_group = (checkbox_group);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/switch/src/component.vue?vue&type=template&id=2dcd8fbb&
	var componentvue_type_template_id_2dcd8fbb_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-switch",
	      class: { "is-disabled": _vm.switchDisabled, "is-checked": _vm.checked },
	      attrs: {
	        role: "switch",
	        "aria-checked": _vm.checked,
	        "aria-disabled": _vm.switchDisabled
	      },
	      on: {
	        click: function($event) {
	          $event.preventDefault()
	          return _vm.switchValue($event)
	        }
	      }
	    },
	    [
	      _c("input", {
	        ref: "input",
	        staticClass: "el-switch__input",
	        attrs: {
	          type: "checkbox",
	          id: _vm.id,
	          name: _vm.name,
	          "true-value": _vm.activeValue,
	          "false-value": _vm.inactiveValue,
	          disabled: _vm.switchDisabled
	        },
	        on: {
	          change: _vm.handleChange,
	          keydown: function($event) {
	            if (
	              !("button" in $event) &&
	              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
	            ) {
	              return null
	            }
	            return _vm.switchValue($event)
	          }
	        }
	      }),
	      _vm.inactiveIconClass || _vm.inactiveText
	        ? _c(
	            "span",
	            {
	              class: [
	                "el-switch__label",
	                "el-switch__label--left",
	                !_vm.checked ? "is-active" : ""
	              ]
	            },
	            [
	              _vm.inactiveIconClass
	                ? _c("i", { class: [_vm.inactiveIconClass] })
	                : _vm._e(),
	              !_vm.inactiveIconClass && _vm.inactiveText
	                ? _c("span", { attrs: { "aria-hidden": _vm.checked } }, [
	                    _vm._v(_vm._s(_vm.inactiveText))
	                  ])
	                : _vm._e()
	            ]
	          )
	        : _vm._e(),
	      _c("span", {
	        ref: "core",
	        staticClass: "el-switch__core",
	        style: { width: _vm.coreWidth + "px" }
	      }),
	      _vm.activeIconClass || _vm.activeText
	        ? _c(
	            "span",
	            {
	              class: [
	                "el-switch__label",
	                "el-switch__label--right",
	                _vm.checked ? "is-active" : ""
	              ]
	            },
	            [
	              _vm.activeIconClass
	                ? _c("i", { class: [_vm.activeIconClass] })
	                : _vm._e(),
	              !_vm.activeIconClass && _vm.activeText
	                ? _c("span", { attrs: { "aria-hidden": !_vm.checked } }, [
	                    _vm._v(_vm._s(_vm.activeText))
	                  ])
	                : _vm._e()
	            ]
	          )
	        : _vm._e()
	    ]
	  )
	}
	var componentvue_type_template_id_2dcd8fbb_staticRenderFns = []
	componentvue_type_template_id_2dcd8fbb_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/switch/src/component.vue?vue&type=template&id=2dcd8fbb&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/switch/src/component.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var switch_src_componentvue_type_script_lang_js_ = ({
	  name: 'ElSwitch',
	  mixins: [focus_default()('input'), migrating_default.a, emitter_default.a],
	  inject: {
	    elForm: {
	      default: ''
	    }
	  },
	  props: {
	    value: {
	      type: [Boolean, String, Number],
	      default: false
	    },
	    disabled: {
	      type: Boolean,
	      default: false
	    },
	    width: {
	      type: Number,
	      default: 40
	    },
	    activeIconClass: {
	      type: String,
	      default: ''
	    },
	    inactiveIconClass: {
	      type: String,
	      default: ''
	    },
	    activeText: String,
	    inactiveText: String,
	    activeColor: {
	      type: String,
	      default: ''
	    },
	    inactiveColor: {
	      type: String,
	      default: ''
	    },
	    activeValue: {
	      type: [Boolean, String, Number],
	      default: true
	    },
	    inactiveValue: {
	      type: [Boolean, String, Number],
	      default: false
	    },
	    name: {
	      type: String,
	      default: ''
	    },
	    validateEvent: {
	      type: Boolean,
	      default: true
	    },
	    id: String
	  },
	  data: function data() {
	    return {
	      coreWidth: this.width
	    };
	  },
	  created: function created() {
	    if (!~[this.activeValue, this.inactiveValue].indexOf(this.value)) {
	      this.$emit('input', this.inactiveValue);
	    }
	  },
	
	  computed: {
	    checked: function checked() {
	      return this.value === this.activeValue;
	    },
	    switchDisabled: function switchDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    }
	  },
	  watch: {
	    checked: function checked() {
	      this.$refs.input.checked = this.checked;
	      if (this.activeColor || this.inactiveColor) {
	        this.setBackgroundColor();
	      }
	      if (this.validateEvent) {
	        this.dispatch('ElFormItem', 'el.form.change', [this.value]);
	      }
	    }
	  },
	  methods: {
	    handleChange: function handleChange(event) {
	      var _this = this;
	
	      var val = this.checked ? this.inactiveValue : this.activeValue;
	      this.$emit('input', val);
	      this.$emit('change', val);
	      this.$nextTick(function () {
	        // set input's checked property
	        // in case parent refuses to change component's value
	        _this.$refs.input.checked = _this.checked;
	      });
	    },
	    setBackgroundColor: function setBackgroundColor() {
	      var newColor = this.checked ? this.activeColor : this.inactiveColor;
	      this.$refs.core.style.borderColor = newColor;
	      this.$refs.core.style.backgroundColor = newColor;
	    },
	    switchValue: function switchValue() {
	      !this.switchDisabled && this.handleChange();
	    },
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'on-color': 'on-color is renamed to active-color.',
	          'off-color': 'off-color is renamed to inactive-color.',
	          'on-text': 'on-text is renamed to active-text.',
	          'off-text': 'off-text is renamed to inactive-text.',
	          'on-value': 'on-value is renamed to active-value.',
	          'off-value': 'off-value is renamed to inactive-value.',
	          'on-icon-class': 'on-icon-class is renamed to active-icon-class.',
	          'off-icon-class': 'off-icon-class is renamed to inactive-icon-class.'
	        }
	      };
	    }
	  },
	  mounted: function mounted() {
	    /* istanbul ignore if */
	    this.coreWidth = this.width || 40;
	    if (this.activeColor || this.inactiveColor) {
	      this.setBackgroundColor();
	    }
	    this.$refs.input.checked = this.checked;
	  }
	});
	// CONCATENATED MODULE: ./packages/switch/src/component.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_switch_src_componentvue_type_script_lang_js_ = (switch_src_componentvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/switch/src/component.vue
	
	
	
	
	
	/* normalize component */
	
	var src_component_component = normalizeComponent(
	  packages_switch_src_componentvue_type_script_lang_js_,
	  componentvue_type_template_id_2dcd8fbb_render,
	  componentvue_type_template_id_2dcd8fbb_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var src_component_api; }
	src_component_component.options.__file = "packages/switch/src/component.vue"
	/* harmony default export */ var switch_src_component = (src_component_component.exports);
	// CONCATENATED MODULE: ./packages/switch/index.js
	
	
	/* istanbul ignore next */
	switch_src_component.install = function (Vue) {
	  Vue.component(switch_src_component.name, switch_src_component);
	};
	
	/* harmony default export */ var packages_switch = (switch_src_component);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select.vue?vue&type=template&id=0e4aade6&
	var selectvue_type_template_id_0e4aade6_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      directives: [
	        {
	          name: "clickoutside",
	          rawName: "v-clickoutside",
	          value: _vm.handleClose,
	          expression: "handleClose"
	        }
	      ],
	      staticClass: "el-select",
	      class: [_vm.selectSize ? "el-select--" + _vm.selectSize : ""],
	      on: {
	        click: function($event) {
	          $event.stopPropagation()
	          return _vm.toggleMenu($event)
	        }
	      }
	    },
	    [
	      _vm.multiple
	        ? _c(
	            "div",
	            {
	              ref: "tags",
	              staticClass: "el-select__tags",
	              style: { "max-width": _vm.inputWidth - 32 + "px", width: "100%" }
	            },
	            [
	              _vm.collapseTags && _vm.selected.length
	                ? _c(
	                    "span",
	                    [
	                      _c(
	                        "el-tag",
	                        {
	                          attrs: {
	                            closable: !_vm.selectDisabled,
	                            size: _vm.collapseTagSize,
	                            hit: _vm.selected[0].hitState,
	                            type: "info",
	                            "disable-transitions": ""
	                          },
	                          on: {
	                            close: function($event) {
	                              _vm.deleteTag($event, _vm.selected[0])
	                            }
	                          }
	                        },
	                        [
	                          _c("span", { staticClass: "el-select__tags-text" }, [
	                            _vm._v(_vm._s(_vm.selected[0].currentLabel))
	                          ])
	                        ]
	                      ),
	                      _vm.selected.length > 1
	                        ? _c(
	                            "el-tag",
	                            {
	                              attrs: {
	                                closable: false,
	                                size: _vm.collapseTagSize,
	                                type: "info",
	                                "disable-transitions": ""
	                              }
	                            },
	                            [
	                              _c(
	                                "span",
	                                { staticClass: "el-select__tags-text" },
	                                [_vm._v("+ " + _vm._s(_vm.selected.length - 1))]
	                              )
	                            ]
	                          )
	                        : _vm._e()
	                    ],
	                    1
	                  )
	                : _vm._e(),
	              !_vm.collapseTags
	                ? _c(
	                    "transition-group",
	                    { on: { "after-leave": _vm.resetInputHeight } },
	                    _vm._l(_vm.selected, function(item) {
	                      return _c(
	                        "el-tag",
	                        {
	                          key: _vm.getValueKey(item),
	                          attrs: {
	                            closable: !_vm.selectDisabled,
	                            size: _vm.collapseTagSize,
	                            hit: item.hitState,
	                            type: "info",
	                            "disable-transitions": ""
	                          },
	                          on: {
	                            close: function($event) {
	                              _vm.deleteTag($event, item)
	                            }
	                          }
	                        },
	                        [
	                          _c("span", { staticClass: "el-select__tags-text" }, [
	                            _vm._v(_vm._s(item.currentLabel))
	                          ])
	                        ]
	                      )
	                    }),
	                    1
	                  )
	                : _vm._e(),
	              _vm.filterable
	                ? _c("input", {
	                    directives: [
	                      {
	                        name: "model",
	                        rawName: "v-model",
	                        value: _vm.query,
	                        expression: "query"
	                      }
	                    ],
	                    ref: "input",
	                    staticClass: "el-select__input",
	                    class: [_vm.selectSize ? "is-" + _vm.selectSize : ""],
	                    style: {
	                      "flex-grow": "1",
	                      width: _vm.inputLength / (_vm.inputWidth - 32) + "%",
	                      "max-width": _vm.inputWidth - 42 + "px"
	                    },
	                    attrs: {
	                      type: "text",
	                      disabled: _vm.selectDisabled,
	                      autocomplete: _vm.autoComplete || _vm.autocomplete
	                    },
	                    domProps: { value: _vm.query },
	                    on: {
	                      focus: _vm.handleFocus,
	                      blur: function($event) {
	                        _vm.softFocus = false
	                      },
	                      keyup: _vm.managePlaceholder,
	                      keydown: [
	                        _vm.resetInputState,
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k($event.keyCode, "down", 40, $event.key, [
	                              "Down",
	                              "ArrowDown"
	                            ])
	                          ) {
	                            return null
	                          }
	                          $event.preventDefault()
	                          _vm.navigateOptions("next")
	                        },
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k($event.keyCode, "up", 38, $event.key, [
	                              "Up",
	                              "ArrowUp"
	                            ])
	                          ) {
	                            return null
	                          }
	                          $event.preventDefault()
	                          _vm.navigateOptions("prev")
	                        },
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k(
	                              $event.keyCode,
	                              "enter",
	                              13,
	                              $event.key,
	                              "Enter"
	                            )
	                          ) {
	                            return null
	                          }
	                          $event.preventDefault()
	                          return _vm.selectOption($event)
	                        },
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k($event.keyCode, "esc", 27, $event.key, [
	                              "Esc",
	                              "Escape"
	                            ])
	                          ) {
	                            return null
	                          }
	                          $event.stopPropagation()
	                          $event.preventDefault()
	                          _vm.visible = false
	                        },
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k(
	                              $event.keyCode,
	                              "delete",
	                              [8, 46],
	                              $event.key,
	                              ["Backspace", "Delete", "Del"]
	                            )
	                          ) {
	                            return null
	                          }
	                          return _vm.deletePrevTag($event)
	                        },
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
	                          ) {
	                            return null
	                          }
	                          _vm.visible = false
	                        }
	                      ],
	                      compositionstart: _vm.handleComposition,
	                      compositionupdate: _vm.handleComposition,
	                      compositionend: _vm.handleComposition,
	                      input: [
	                        function($event) {
	                          if ($event.target.composing) {
	                            return
	                          }
	                          _vm.query = $event.target.value
	                        },
	                        _vm.debouncedQueryChange
	                      ]
	                    }
	                  })
	                : _vm._e()
	            ],
	            1
	          )
	        : _vm._e(),
	      _c(
	        "el-input",
	        {
	          ref: "reference",
	          class: { "is-focus": _vm.visible },
	          attrs: {
	            type: "text",
	            placeholder: _vm.currentPlaceholder,
	            name: _vm.name,
	            id: _vm.id,
	            autocomplete: _vm.autoComplete || _vm.autocomplete,
	            size: _vm.selectSize,
	            disabled: _vm.selectDisabled,
	            readonly: _vm.readonly,
	            "validate-event": false,
	            tabindex: _vm.multiple && _vm.filterable ? "-1" : null
	          },
	          on: { focus: _vm.handleFocus, blur: _vm.handleBlur },
	          nativeOn: {
	            keyup: function($event) {
	              return _vm.debouncedOnInputChange($event)
	            },
	            keydown: [
	              function($event) {
	                if (
	                  !("button" in $event) &&
	                  _vm._k($event.keyCode, "down", 40, $event.key, [
	                    "Down",
	                    "ArrowDown"
	                  ])
	                ) {
	                  return null
	                }
	                $event.stopPropagation()
	                $event.preventDefault()
	                _vm.navigateOptions("next")
	              },
	              function($event) {
	                if (
	                  !("button" in $event) &&
	                  _vm._k($event.keyCode, "up", 38, $event.key, [
	                    "Up",
	                    "ArrowUp"
	                  ])
	                ) {
	                  return null
	                }
	                $event.stopPropagation()
	                $event.preventDefault()
	                _vm.navigateOptions("prev")
	              },
	              function($event) {
	                if (
	                  !("button" in $event) &&
	                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
	                ) {
	                  return null
	                }
	                $event.preventDefault()
	                return _vm.selectOption($event)
	              },
	              function($event) {
	                if (
	                  !("button" in $event) &&
	                  _vm._k($event.keyCode, "esc", 27, $event.key, [
	                    "Esc",
	                    "Escape"
	                  ])
	                ) {
	                  return null
	                }
	                $event.stopPropagation()
	                $event.preventDefault()
	                _vm.visible = false
	              },
	              function($event) {
	                if (
	                  !("button" in $event) &&
	                  _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
	                ) {
	                  return null
	                }
	                _vm.visible = false
	              }
	            ],
	            paste: function($event) {
	              return _vm.debouncedOnInputChange($event)
	            },
	            mouseenter: function($event) {
	              _vm.inputHovering = true
	            },
	            mouseleave: function($event) {
	              _vm.inputHovering = false
	            }
	          },
	          model: {
	            value: _vm.selectedLabel,
	            callback: function($$v) {
	              _vm.selectedLabel = $$v
	            },
	            expression: "selectedLabel"
	          }
	        },
	        [
	          _vm.$slots.prefix
	            ? _c("template", { slot: "prefix" }, [_vm._t("prefix")], 2)
	            : _vm._e(),
	          _c("template", { slot: "suffix" }, [
	            _c("i", {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value: !_vm.showClose,
	                  expression: "!showClose"
	                }
	              ],
	              class: [
	                "el-select__caret",
	                "el-input__icon",
	                "el-icon-" + _vm.iconClass
	              ]
	            }),
	            _vm.showClose
	              ? _c("i", {
	                  staticClass:
	                    "el-select__caret el-input__icon el-icon-circle-close",
	                  on: { click: _vm.handleClearClick }
	                })
	              : _vm._e()
	          ])
	        ],
	        2
	      ),
	      _c(
	        "transition",
	        {
	          attrs: { name: "el-zoom-in-top" },
	          on: {
	            "before-enter": _vm.handleMenuEnter,
	            "after-leave": _vm.doDestroy
	          }
	        },
	        [
	          _c(
	            "el-select-menu",
	            {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value: _vm.visible && _vm.emptyText !== false,
	                  expression: "visible && emptyText !== false"
	                }
	              ],
	              ref: "popper",
	              attrs: { "append-to-body": _vm.popperAppendToBody }
	            },
	            [
	              _c(
	                "el-scrollbar",
	                {
	                  directives: [
	                    {
	                      name: "show",
	                      rawName: "v-show",
	                      value: _vm.options.length > 0 && !_vm.loading,
	                      expression: "options.length > 0 && !loading"
	                    }
	                  ],
	                  ref: "scrollbar",
	                  class: {
	                    "is-empty":
	                      !_vm.allowCreate &&
	                      _vm.query &&
	                      _vm.filteredOptionsCount === 0
	                  },
	                  attrs: {
	                    tag: "ul",
	                    "wrap-class": "el-select-dropdown__wrap",
	                    "view-class": "el-select-dropdown__list"
	                  }
	                },
	                [
	                  _vm.showNewOption
	                    ? _c("el-option", {
	                        attrs: { value: _vm.query, created: "" }
	                      })
	                    : _vm._e(),
	                  _vm._t("default")
	                ],
	                2
	              ),
	              _vm.emptyText &&
	              (!_vm.allowCreate ||
	                _vm.loading ||
	                (_vm.allowCreate && _vm.options.length === 0))
	                ? [
	                    _vm.$slots.empty
	                      ? _vm._t("empty")
	                      : _c("p", { staticClass: "el-select-dropdown__empty" }, [
	                          _vm._v(
	                            "\n          " +
	                              _vm._s(_vm.emptyText) +
	                              "\n        "
	                          )
	                        ])
	                  ]
	                : _vm._e()
	            ],
	            2
	          )
	        ],
	        1
	      )
	    ],
	    1
	  )
	}
	var selectvue_type_template_id_0e4aade6_staticRenderFns = []
	selectvue_type_template_id_0e4aade6_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/select/src/select.vue?vue&type=template&id=0e4aade6&
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select-dropdown.vue?vue&type=template&id=06828748&
	var select_dropdownvue_type_template_id_06828748_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-select-dropdown el-popper",
	      class: [{ "is-multiple": _vm.$parent.multiple }, _vm.popperClass],
	      style: { minWidth: _vm.minWidth }
	    },
	    [_vm._t("default")],
	    2
	  )
	}
	var select_dropdownvue_type_template_id_06828748_staticRenderFns = []
	select_dropdownvue_type_template_id_06828748_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue?vue&type=template&id=06828748&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select-dropdown.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var select_dropdownvue_type_script_lang_js_ = ({
	  name: 'ElSelectDropdown',
	
	  componentName: 'ElSelectDropdown',
	
	  mixins: [vue_popper_default.a],
	
	  props: {
	    placement: {
	      default: 'bottom-start'
	    },
	
	    boundariesPadding: {
	      default: 0
	    },
	
	    popperOptions: {
	      default: function _default() {
	        return {
	          gpuAcceleration: false
	        };
	      }
	    },
	
	    visibleArrow: {
	      default: true
	    },
	
	    appendToBody: {
	      type: Boolean,
	      default: true
	    }
	  },
	
	  data: function data() {
	    return {
	      minWidth: ''
	    };
	  },
	
	
	  computed: {
	    popperClass: function popperClass() {
	      return this.$parent.popperClass;
	    }
	  },
	
	  watch: {
	    '$parent.inputWidth': function $parentInputWidth() {
	      this.minWidth = this.$parent.$el.getBoundingClientRect().width + 'px';
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.referenceElm = this.$parent.$refs.reference.$el;
	    this.$parent.popperElm = this.popperElm = this.$el;
	    this.$on('updatePopper', function () {
	      if (_this.$parent.visible) _this.updatePopper();
	    });
	    this.$on('destroyPopper', this.destroyPopper);
	  }
	});
	// CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_select_dropdownvue_type_script_lang_js_ = (select_dropdownvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue
	
	
	
	
	
	/* normalize component */
	
	var select_dropdown_component = normalizeComponent(
	  src_select_dropdownvue_type_script_lang_js_,
	  select_dropdownvue_type_template_id_06828748_render,
	  select_dropdownvue_type_template_id_06828748_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var select_dropdown_api; }
	select_dropdown_component.options.__file = "packages/select/src/select-dropdown.vue"
	/* harmony default export */ var select_dropdown = (select_dropdown_component.exports);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=template&id=7a44c642&
	var optionvue_type_template_id_7a44c642_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "li",
	    {
	      directives: [
	        {
	          name: "show",
	          rawName: "v-show",
	          value: _vm.visible,
	          expression: "visible"
	        }
	      ],
	      staticClass: "el-select-dropdown__item",
	      class: {
	        selected: _vm.itemSelected,
	        "is-disabled": _vm.disabled || _vm.groupDisabled || _vm.limitReached,
	        hover: _vm.hover
	      },
	      on: {
	        mouseenter: _vm.hoverItem,
	        click: function($event) {
	          $event.stopPropagation()
	          return _vm.selectOptionClick($event)
	        }
	      }
	    },
	    [_vm._t("default", [_c("span", [_vm._v(_vm._s(_vm.currentLabel))])])],
	    2
	  )
	}
	var optionvue_type_template_id_7a44c642_staticRenderFns = []
	optionvue_type_template_id_7a44c642_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=template&id=7a44c642&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=script&lang=js&
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	/* harmony default export */ var optionvue_type_script_lang_js_ = ({
	  mixins: [emitter_default.a],
	
	  name: 'ElOption',
	
	  componentName: 'ElOption',
	
	  inject: ['select'],
	
	  props: {
	    value: {
	      required: true
	    },
	    label: [String, Number],
	    created: Boolean,
	    disabled: {
	      type: Boolean,
	      default: false
	    }
	  },
	
	  data: function data() {
	    return {
	      index: -1,
	      groupDisabled: false,
	      visible: true,
	      hitState: false,
	      hover: false
	    };
	  },
	
	
	  computed: {
	    isObject: function isObject() {
	      return Object.prototype.toString.call(this.value).toLowerCase() === '[object object]';
	    },
	    currentLabel: function currentLabel() {
	      return this.label || (this.isObject ? '' : this.value);
	    },
	    currentValue: function currentValue() {
	      return this.value || this.label || '';
	    },
	    itemSelected: function itemSelected() {
	      if (!this.select.multiple) {
	        return this.isEqual(this.value, this.select.value);
	      } else {
	        return this.contains(this.select.value, this.value);
	      }
	    },
	    limitReached: function limitReached() {
	      if (this.select.multiple) {
	        return !this.itemSelected && (this.select.value || []).length >= this.select.multipleLimit && this.select.multipleLimit > 0;
	      } else {
	        return false;
	      }
	    }
	  },
	
	  watch: {
	    currentLabel: function currentLabel() {
	      if (!this.created && !this.select.remote) this.dispatch('ElSelect', 'setSelected');
	    },
	    value: function value(val, oldVal) {
	      var _select = this.select,
	          remote = _select.remote,
	          valueKey = _select.valueKey;
	
	      if (!this.created && !remote) {
	        if (valueKey && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' && (typeof oldVal === 'undefined' ? 'undefined' : _typeof(oldVal)) === 'object' && val[valueKey] === oldVal[valueKey]) {
	          return;
	        }
	        this.dispatch('ElSelect', 'setSelected');
	      }
	    }
	  },
	
	  methods: {
	    isEqual: function isEqual(a, b) {
	      if (!this.isObject) {
	        return a === b;
	      } else {
	        var valueKey = this.select.valueKey;
	        return Object(util_["getValueByPath"])(a, valueKey) === Object(util_["getValueByPath"])(b, valueKey);
	      }
	    },
	    contains: function contains() {
	      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var target = arguments[1];
	
	      if (!this.isObject) {
	        return arr && arr.indexOf(target) > -1;
	      } else {
	        var valueKey = this.select.valueKey;
	        return arr && arr.some(function (item) {
	          return Object(util_["getValueByPath"])(item, valueKey) === Object(util_["getValueByPath"])(target, valueKey);
	        });
	      }
	    },
	    handleGroupDisabled: function handleGroupDisabled(val) {
	      this.groupDisabled = val;
	    },
	    hoverItem: function hoverItem() {
	      if (!this.disabled && !this.groupDisabled) {
	        this.select.hoverIndex = this.select.options.indexOf(this);
	      }
	    },
	    selectOptionClick: function selectOptionClick() {
	      if (this.disabled !== true && this.groupDisabled !== true) {
	        this.dispatch('ElSelect', 'handleOptionClick', [this, true]);
	      }
	    },
	    queryChange: function queryChange(query) {
	      this.visible = new RegExp(Object(util_["escapeRegexpString"])(query), 'i').test(this.currentLabel) || this.created;
	      if (!this.visible) {
	        this.select.filteredOptionsCount--;
	      }
	    }
	  },
	
	  created: function created() {
	    this.select.options.push(this);
	    this.select.cachedOptions.push(this);
	    this.select.optionsCount++;
	    this.select.filteredOptionsCount++;
	
	    this.$on('queryChange', this.queryChange);
	    this.$on('handleGroupDisabled', this.handleGroupDisabled);
	  },
	  beforeDestroy: function beforeDestroy() {
	    var _select2 = this.select,
	        selected = _select2.selected,
	        multiple = _select2.multiple;
	
	    var selectedOptions = multiple ? selected : [selected];
	    var index = this.select.cachedOptions.indexOf(this);
	    var selectedIndex = selectedOptions.indexOf(this);
	
	    // if option is not selected, remove it from cache
	    if (index > -1 && selectedIndex < 0) {
	      this.select.cachedOptions.splice(index, 1);
	    }
	    this.select.onOptionDestroy(this.select.options.indexOf(this));
	  }
	});
	// CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_optionvue_type_script_lang_js_ = (optionvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/select/src/option.vue
	
	
	
	
	
	/* normalize component */
	
	var option_component = normalizeComponent(
	  src_optionvue_type_script_lang_js_,
	  optionvue_type_template_id_7a44c642_render,
	  optionvue_type_template_id_7a44c642_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var option_api; }
	option_component.options.__file = "packages/select/src/option.vue"
	/* harmony default export */ var src_option = (option_component.exports);
	// EXTERNAL MODULE: external "element-ui/lib/tag"
	var tag_ = __webpack_require__(29);
	var tag_default = /*#__PURE__*/__webpack_require__.n(tag_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/resize-event"
	var resize_event_ = __webpack_require__(13);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/scroll-into-view"
	var scroll_into_view_ = __webpack_require__(27);
	var scroll_into_view_default = /*#__PURE__*/__webpack_require__.n(scroll_into_view_);
	
	// CONCATENATED MODULE: ./packages/select/src/navigation-mixin.js
	/* harmony default export */ var navigation_mixin = ({
	  data: function data() {
	    return {
	      hoverOption: -1
	    };
	  },
	
	
	  computed: {
	    optionsAllDisabled: function optionsAllDisabled() {
	      return this.options.filter(function (option) {
	        return option.visible;
	      }).every(function (option) {
	        return option.disabled;
	      });
	    }
	  },
	
	  watch: {
	    hoverIndex: function hoverIndex(val) {
	      var _this = this;
	
	      if (typeof val === 'number' && val > -1) {
	        this.hoverOption = this.options[val] || {};
	      }
	      this.options.forEach(function (option) {
	        option.hover = _this.hoverOption === option;
	      });
	    }
	  },
	
	  methods: {
	    navigateOptions: function navigateOptions(direction) {
	      var _this2 = this;
	
	      if (!this.visible) {
	        this.visible = true;
	        return;
	      }
	      if (this.options.length === 0 || this.filteredOptionsCount === 0) return;
	      if (!this.optionsAllDisabled) {
	        if (direction === 'next') {
	          this.hoverIndex++;
	          if (this.hoverIndex === this.options.length) {
	            this.hoverIndex = 0;
	          }
	        } else if (direction === 'prev') {
	          this.hoverIndex--;
	          if (this.hoverIndex < 0) {
	            this.hoverIndex = this.options.length - 1;
	          }
	        }
	        var option = this.options[this.hoverIndex];
	        if (option.disabled === true || option.groupDisabled === true || !option.visible) {
	          this.navigateOptions(direction);
	        }
	        this.$nextTick(function () {
	          return _this2.scrollToOption(_this2.hoverOption);
	        });
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	/* harmony default export */ var selectvue_type_script_lang_js_ = ({
	  mixins: [emitter_default.a, locale_default.a, focus_default()('reference'), navigation_mixin],
	
	  name: 'ElSelect',
	
	  componentName: 'ElSelect',
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  provide: function provide() {
	    return {
	      'select': this
	    };
	  },
	
	
	  computed: {
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    readonly: function readonly() {
	      return !this.filterable || this.multiple || !Object(util_["isIE"])() && !Object(util_["isEdge"])() && !this.visible;
	    },
	    showClose: function showClose() {
	      var hasValue = this.multiple ? Array.isArray(this.value) && this.value.length > 0 : this.value !== undefined && this.value !== null && this.value !== '';
	      var criteria = this.clearable && !this.selectDisabled && this.inputHovering && hasValue;
	      return criteria;
	    },
	    iconClass: function iconClass() {
	      return this.remote && this.filterable ? '' : this.visible ? 'arrow-up is-reverse' : 'arrow-up';
	    },
	    debounce: function debounce() {
	      return this.remote ? 300 : 0;
	    },
	    emptyText: function emptyText() {
	      if (this.loading) {
	        return this.loadingText || this.t('el.select.loading');
	      } else {
	        if (this.remote && this.query === '' && this.options.length === 0) return false;
	        if (this.filterable && this.query && this.options.length > 0 && this.filteredOptionsCount === 0) {
	          return this.noMatchText || this.t('el.select.noMatch');
	        }
	        if (this.options.length === 0) {
	          return this.noDataText || this.t('el.select.noData');
	        }
	      }
	      return null;
	    },
	    showNewOption: function showNewOption() {
	      var _this = this;
	
	      var hasExistingOption = this.options.filter(function (option) {
	        return !option.created;
	      }).some(function (option) {
	        return option.currentLabel === _this.query;
	      });
	      return this.filterable && this.allowCreate && this.query !== '' && !hasExistingOption;
	    },
	    selectSize: function selectSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    selectDisabled: function selectDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    },
	    collapseTagSize: function collapseTagSize() {
	      return ['small', 'mini'].indexOf(this.selectSize) > -1 ? 'mini' : 'small';
	    },
	    propPlaceholder: function propPlaceholder() {
	      return typeof this.placeholder !== 'undefined' ? this.placeholder : this.t('el.select.placeholder');
	    }
	  },
	
	  components: {
	    ElInput: input_default.a,
	    ElSelectMenu: select_dropdown,
	    ElOption: src_option,
	    ElTag: tag_default.a,
	    ElScrollbar: scrollbar_default.a
	  },
	
	  directives: { Clickoutside: clickoutside_default.a },
	
	  props: {
	    name: String,
	    id: String,
	    value: {
	      required: true
	    },
	    autocomplete: {
	      type: String,
	      default: 'off'
	    },
	    /** @Deprecated in next major version */
	    autoComplete: {
	      type: String,
	      validator: function validator(val) {
	         false && false;
	        return true;
	      }
	    },
	    automaticDropdown: Boolean,
	    size: String,
	    disabled: Boolean,
	    clearable: Boolean,
	    filterable: Boolean,
	    allowCreate: Boolean,
	    loading: Boolean,
	    popperClass: String,
	    remote: Boolean,
	    loadingText: String,
	    noMatchText: String,
	    noDataText: String,
	    remoteMethod: Function,
	    filterMethod: Function,
	    multiple: Boolean,
	    multipleLimit: {
	      type: Number,
	      default: 0
	    },
	    placeholder: {
	      type: String,
	      required: false
	    },
	    defaultFirstOption: Boolean,
	    reserveKeyword: Boolean,
	    valueKey: {
	      type: String,
	      default: 'value'
	    },
	    collapseTags: Boolean,
	    popperAppendToBody: {
	      type: Boolean,
	      default: true
	    }
	  },
	
	  data: function data() {
	    return {
	      options: [],
	      cachedOptions: [],
	      createdLabel: null,
	      createdSelected: false,
	      selected: this.multiple ? [] : {},
	      inputLength: 20,
	      inputWidth: 0,
	      initialInputHeight: 0,
	      cachedPlaceHolder: '',
	      optionsCount: 0,
	      filteredOptionsCount: 0,
	      visible: false,
	      softFocus: false,
	      selectedLabel: '',
	      hoverIndex: -1,
	      query: '',
	      previousQuery: null,
	      inputHovering: false,
	      currentPlaceholder: '',
	      menuVisibleOnFocus: false,
	      isOnComposition: false,
	      isSilentBlur: false
	    };
	  },
	
	
	  watch: {
	    selectDisabled: function selectDisabled() {
	      var _this2 = this;
	
	      this.$nextTick(function () {
	        _this2.resetInputHeight();
	      });
	    },
	    propPlaceholder: function propPlaceholder(val) {
	      this.cachedPlaceHolder = this.currentPlaceholder = val;
	    },
	    value: function value(val, oldVal) {
	      if (this.multiple) {
	        this.resetInputHeight();
	        if (val && val.length > 0 || this.$refs.input && this.query !== '') {
	          this.currentPlaceholder = '';
	        } else {
	          this.currentPlaceholder = this.cachedPlaceHolder;
	        }
	        if (this.filterable && !this.reserveKeyword) {
	          this.query = '';
	          this.handleQueryChange(this.query);
	        }
	      }
	      this.setSelected();
	      if (this.filterable && !this.multiple) {
	        this.inputLength = 20;
	      }
	      if (!Object(util_["valueEquals"])(val, oldVal)) {
	        this.dispatch('ElFormItem', 'el.form.change', val);
	      }
	    },
	    visible: function visible(val) {
	      var _this3 = this;
	
	      if (!val) {
	        this.broadcast('ElSelectDropdown', 'destroyPopper');
	        if (this.$refs.input) {
	          this.$refs.input.blur();
	        }
	        this.query = '';
	        this.previousQuery = null;
	        this.selectedLabel = '';
	        this.inputLength = 20;
	        this.menuVisibleOnFocus = false;
	        this.resetHoverIndex();
	        this.$nextTick(function () {
	          if (_this3.$refs.input && _this3.$refs.input.value === '' && _this3.selected.length === 0) {
	            _this3.currentPlaceholder = _this3.cachedPlaceHolder;
	          }
	        });
	        if (!this.multiple) {
	          if (this.selected) {
	            if (this.filterable && this.allowCreate && this.createdSelected && this.createdLabel) {
	              this.selectedLabel = this.createdLabel;
	            } else {
	              this.selectedLabel = this.selected.currentLabel;
	            }
	            if (this.filterable) this.query = this.selectedLabel;
	          }
	
	          if (this.filterable) {
	            this.currentPlaceholder = this.cachedPlaceHolder;
	          }
	        }
	      } else {
	        this.broadcast('ElSelectDropdown', 'updatePopper');
	        if (this.filterable) {
	          this.query = this.remote ? '' : this.selectedLabel;
	          this.handleQueryChange(this.query);
	          if (this.multiple) {
	            this.$refs.input.focus();
	          } else {
	            if (!this.remote) {
	              this.broadcast('ElOption', 'queryChange', '');
	              this.broadcast('ElOptionGroup', 'queryChange');
	            }
	
	            if (this.selectedLabel) {
	              this.currentPlaceholder = this.selectedLabel;
	              this.selectedLabel = '';
	            }
	          }
	        }
	      }
	      this.$emit('visible-change', val);
	    },
	    options: function options() {
	      var _this4 = this;
	
	      if (this.$isServer) return;
	      this.$nextTick(function () {
	        _this4.broadcast('ElSelectDropdown', 'updatePopper');
	      });
	      if (this.multiple) {
	        this.resetInputHeight();
	      }
	      var inputs = this.$el.querySelectorAll('input');
	      if ([].indexOf.call(inputs, document.activeElement) === -1) {
	        this.setSelected();
	      }
	      if (this.defaultFirstOption && (this.filterable || this.remote) && this.filteredOptionsCount) {
	        this.checkDefaultFirstOption();
	      }
	    }
	  },
	
	  methods: {
	    handleComposition: function handleComposition(event) {
	      var _this5 = this;
	
	      var text = event.target.value;
	      if (event.type === 'compositionend') {
	        this.isOnComposition = false;
	        this.$nextTick(function (_) {
	          return _this5.handleQueryChange(text);
	        });
	      } else {
	        var lastCharacter = text[text.length - 1] || '';
	        this.isOnComposition = !Object(shared_["isKorean"])(lastCharacter);
	      }
	    },
	    handleQueryChange: function handleQueryChange(val) {
	      var _this6 = this;
	
	      if (this.previousQuery === val || this.isOnComposition) return;
	      if (this.previousQuery === null && (typeof this.filterMethod === 'function' || typeof this.remoteMethod === 'function')) {
	        this.previousQuery = val;
	        return;
	      }
	      this.previousQuery = val;
	      this.$nextTick(function () {
	        if (_this6.visible) _this6.broadcast('ElSelectDropdown', 'updatePopper');
	      });
	      this.hoverIndex = -1;
	      if (this.multiple && this.filterable) {
	        this.$nextTick(function () {
	          var length = _this6.$refs.input.value.length * 15 + 20;
	          _this6.inputLength = _this6.collapseTags ? Math.min(50, length) : length;
	          _this6.managePlaceholder();
	          _this6.resetInputHeight();
	        });
	      }
	      if (this.remote && typeof this.remoteMethod === 'function') {
	        this.hoverIndex = -1;
	        this.remoteMethod(val);
	      } else if (typeof this.filterMethod === 'function') {
	        this.filterMethod(val);
	        this.broadcast('ElOptionGroup', 'queryChange');
	      } else {
	        this.filteredOptionsCount = this.optionsCount;
	        this.broadcast('ElOption', 'queryChange', val);
	        this.broadcast('ElOptionGroup', 'queryChange');
	      }
	      if (this.defaultFirstOption && (this.filterable || this.remote) && this.filteredOptionsCount) {
	        this.checkDefaultFirstOption();
	      }
	    },
	    scrollToOption: function scrollToOption(option) {
	      var target = Array.isArray(option) && option[0] ? option[0].$el : option.$el;
	      if (this.$refs.popper && target) {
	        var menu = this.$refs.popper.$el.querySelector('.el-select-dropdown__wrap');
	        scroll_into_view_default()(menu, target);
	      }
	      this.$refs.scrollbar && this.$refs.scrollbar.handleScroll();
	    },
	    handleMenuEnter: function handleMenuEnter() {
	      var _this7 = this;
	
	      this.$nextTick(function () {
	        return _this7.scrollToOption(_this7.selected);
	      });
	    },
	    emitChange: function emitChange(val) {
	      if (!Object(util_["valueEquals"])(this.value, val)) {
	        this.$emit('change', val);
	      }
	    },
	    getOption: function getOption(value) {
	      var option = void 0;
	      var isObject = Object.prototype.toString.call(value).toLowerCase() === '[object object]';
	      var isNull = Object.prototype.toString.call(value).toLowerCase() === '[object null]';
	      var isUndefined = Object.prototype.toString.call(value).toLowerCase() === '[object undefined]';
	
	      for (var i = this.cachedOptions.length - 1; i >= 0; i--) {
	        var cachedOption = this.cachedOptions[i];
	        var isEqual = isObject ? Object(util_["getValueByPath"])(cachedOption.value, this.valueKey) === Object(util_["getValueByPath"])(value, this.valueKey) : cachedOption.value === value;
	        if (isEqual) {
	          option = cachedOption;
	          break;
	        }
	      }
	      if (option) return option;
	      var label = !isObject && !isNull && !isUndefined ? value : '';
	      var newOption = {
	        value: value,
	        currentLabel: label
	      };
	      if (this.multiple) {
	        newOption.hitState = false;
	      }
	      return newOption;
	    },
	    setSelected: function setSelected() {
	      var _this8 = this;
	
	      if (!this.multiple) {
	        var option = this.getOption(this.value);
	        if (option.created) {
	          this.createdLabel = option.currentLabel;
	          this.createdSelected = true;
	        } else {
	          this.createdSelected = false;
	        }
	        this.selectedLabel = option.currentLabel;
	        this.selected = option;
	        if (this.filterable) this.query = this.selectedLabel;
	        return;
	      }
	      var result = [];
	      if (Array.isArray(this.value)) {
	        this.value.forEach(function (value) {
	          result.push(_this8.getOption(value));
	        });
	      }
	      this.selected = result;
	      this.$nextTick(function () {
	        _this8.resetInputHeight();
	      });
	    },
	    handleFocus: function handleFocus(event) {
	      if (!this.softFocus) {
	        if (this.automaticDropdown || this.filterable) {
	          this.visible = true;
	          if (this.filterable) {
	            this.menuVisibleOnFocus = true;
	          }
	        }
	        this.$emit('focus', event);
	      } else {
	        this.softFocus = false;
	      }
	    },
	    blur: function blur() {
	      this.visible = false;
	      this.$refs.reference.blur();
	    },
	    handleBlur: function handleBlur(event) {
	      var _this9 = this;
	
	      setTimeout(function () {
	        if (_this9.isSilentBlur) {
	          _this9.isSilentBlur = false;
	        } else {
	          _this9.$emit('blur', event);
	        }
	      }, 50);
	      this.softFocus = false;
	    },
	    handleClearClick: function handleClearClick(event) {
	      this.deleteSelected(event);
	    },
	    doDestroy: function doDestroy() {
	      this.$refs.popper && this.$refs.popper.doDestroy();
	    },
	    handleClose: function handleClose() {
	      this.visible = false;
	    },
	    toggleLastOptionHitState: function toggleLastOptionHitState(hit) {
	      if (!Array.isArray(this.selected)) return;
	      var option = this.selected[this.selected.length - 1];
	      if (!option) return;
	
	      if (hit === true || hit === false) {
	        option.hitState = hit;
	        return hit;
	      }
	
	      option.hitState = !option.hitState;
	      return option.hitState;
	    },
	    deletePrevTag: function deletePrevTag(e) {
	      if (e.target.value.length <= 0 && !this.toggleLastOptionHitState()) {
	        var value = this.value.slice();
	        value.pop();
	        this.$emit('input', value);
	        this.emitChange(value);
	      }
	    },
	    managePlaceholder: function managePlaceholder() {
	      if (this.currentPlaceholder !== '') {
	        this.currentPlaceholder = this.$refs.input.value ? '' : this.cachedPlaceHolder;
	      }
	    },
	    resetInputState: function resetInputState(e) {
	      if (e.keyCode !== 8) this.toggleLastOptionHitState(false);
	      this.inputLength = this.$refs.input.value.length * 15 + 20;
	      this.resetInputHeight();
	    },
	    resetInputHeight: function resetInputHeight() {
	      var _this10 = this;
	
	      if (this.collapseTags && !this.filterable) return;
	      this.$nextTick(function () {
	        if (!_this10.$refs.reference) return;
	        var inputChildNodes = _this10.$refs.reference.$el.childNodes;
	        var input = [].filter.call(inputChildNodes, function (item) {
	          return item.tagName === 'INPUT';
	        })[0];
	        var tags = _this10.$refs.tags;
	        var sizeInMap = _this10.initialInputHeight || 40;
	        input.style.height = _this10.selected.length === 0 ? sizeInMap + 'px' : Math.max(tags ? tags.clientHeight + (tags.clientHeight > sizeInMap ? 6 : 0) : 0, sizeInMap) + 'px';
	        if (_this10.visible && _this10.emptyText !== false) {
	          _this10.broadcast('ElSelectDropdown', 'updatePopper');
	        }
	      });
	    },
	    resetHoverIndex: function resetHoverIndex() {
	      var _this11 = this;
	
	      setTimeout(function () {
	        if (!_this11.multiple) {
	          _this11.hoverIndex = _this11.options.indexOf(_this11.selected);
	        } else {
	          if (_this11.selected.length > 0) {
	            _this11.hoverIndex = Math.min.apply(null, _this11.selected.map(function (item) {
	              return _this11.options.indexOf(item);
	            }));
	          } else {
	            _this11.hoverIndex = -1;
	          }
	        }
	      }, 300);
	    },
	    handleOptionSelect: function handleOptionSelect(option, byClick) {
	      var _this12 = this;
	
	      if (this.multiple) {
	        var value = (this.value || []).slice();
	        var optionIndex = this.getValueIndex(value, option.value);
	        if (optionIndex > -1) {
	          value.splice(optionIndex, 1);
	        } else if (this.multipleLimit <= 0 || value.length < this.multipleLimit) {
	          value.push(option.value);
	        }
	        this.$emit('input', value);
	        this.emitChange(value);
	        if (option.created) {
	          this.query = '';
	          this.handleQueryChange('');
	          this.inputLength = 20;
	        }
	        if (this.filterable) this.$refs.input.focus();
	      } else {
	        this.$emit('input', option.value);
	        this.emitChange(option.value);
	        this.visible = false;
	      }
	      this.isSilentBlur = byClick;
	      this.setSoftFocus();
	      if (this.visible) return;
	      this.$nextTick(function () {
	        _this12.scrollToOption(option);
	      });
	    },
	    setSoftFocus: function setSoftFocus() {
	      this.softFocus = true;
	      var input = this.$refs.input || this.$refs.reference;
	      if (input) {
	        input.focus();
	      }
	    },
	    getValueIndex: function getValueIndex() {
	      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var value = arguments[1];
	
	      var isObject = Object.prototype.toString.call(value).toLowerCase() === '[object object]';
	      if (!isObject) {
	        return arr.indexOf(value);
	      } else {
	        var valueKey = this.valueKey;
	        var index = -1;
	        arr.some(function (item, i) {
	          if (Object(util_["getValueByPath"])(item, valueKey) === Object(util_["getValueByPath"])(value, valueKey)) {
	            index = i;
	            return true;
	          }
	          return false;
	        });
	        return index;
	      }
	    },
	    toggleMenu: function toggleMenu() {
	      if (!this.selectDisabled) {
	        if (this.menuVisibleOnFocus) {
	          this.menuVisibleOnFocus = false;
	        } else {
	          this.visible = !this.visible;
	        }
	        if (this.visible) {
	          (this.$refs.input || this.$refs.reference).focus();
	        }
	      }
	    },
	    selectOption: function selectOption() {
	      if (!this.visible) {
	        this.toggleMenu();
	      } else {
	        if (this.options[this.hoverIndex]) {
	          this.handleOptionSelect(this.options[this.hoverIndex]);
	        }
	      }
	    },
	    deleteSelected: function deleteSelected(event) {
	      event.stopPropagation();
	      var value = this.multiple ? [] : '';
	      this.$emit('input', value);
	      this.emitChange(value);
	      this.visible = false;
	      this.$emit('clear');
	    },
	    deleteTag: function deleteTag(event, tag) {
	      var index = this.selected.indexOf(tag);
	      if (index > -1 && !this.selectDisabled) {
	        var value = this.value.slice();
	        value.splice(index, 1);
	        this.$emit('input', value);
	        this.emitChange(value);
	        this.$emit('remove-tag', tag.value);
	      }
	      event.stopPropagation();
	    },
	    onInputChange: function onInputChange() {
	      if (this.filterable && this.query !== this.selectedLabel) {
	        this.query = this.selectedLabel;
	        this.handleQueryChange(this.query);
	      }
	    },
	    onOptionDestroy: function onOptionDestroy(index) {
	      if (index > -1) {
	        this.optionsCount--;
	        this.filteredOptionsCount--;
	        this.options.splice(index, 1);
	      }
	    },
	    resetInputWidth: function resetInputWidth() {
	      this.inputWidth = this.$refs.reference.$el.getBoundingClientRect().width;
	    },
	    handleResize: function handleResize() {
	      this.resetInputWidth();
	      if (this.multiple) this.resetInputHeight();
	    },
	    checkDefaultFirstOption: function checkDefaultFirstOption() {
	      this.hoverIndex = -1;
	      // highlight the created option
	      var hasCreated = false;
	      for (var i = this.options.length - 1; i >= 0; i--) {
	        if (this.options[i].created) {
	          hasCreated = true;
	          this.hoverIndex = i;
	          break;
	        }
	      }
	      if (hasCreated) return;
	      for (var _i = 0; _i !== this.options.length; ++_i) {
	        var option = this.options[_i];
	        if (this.query) {
	          // highlight first options that passes the filter
	          if (!option.disabled && !option.groupDisabled && option.visible) {
	            this.hoverIndex = _i;
	            break;
	          }
	        } else {
	          // highlight currently selected option
	          if (option.itemSelected) {
	            this.hoverIndex = _i;
	            break;
	          }
	        }
	      }
	    },
	    getValueKey: function getValueKey(item) {
	      if (Object.prototype.toString.call(item.value).toLowerCase() !== '[object object]') {
	        return item.value;
	      } else {
	        return Object(util_["getValueByPath"])(item.value, this.valueKey);
	      }
	    }
	  },
	
	  created: function created() {
	    var _this13 = this;
	
	    this.cachedPlaceHolder = this.currentPlaceholder = this.propPlaceholder;
	    if (this.multiple && !Array.isArray(this.value)) {
	      this.$emit('input', []);
	    }
	    if (!this.multiple && Array.isArray(this.value)) {
	      this.$emit('input', '');
	    }
	
	    this.debouncedOnInputChange = debounce_default()(this.debounce, function () {
	      _this13.onInputChange();
	    });
	
	    this.debouncedQueryChange = debounce_default()(this.debounce, function (e) {
	      _this13.handleQueryChange(e.target.value);
	    });
	
	    this.$on('handleOptionClick', this.handleOptionSelect);
	    this.$on('setSelected', this.setSelected);
	  },
	  mounted: function mounted() {
	    var _this14 = this;
	
	    if (this.multiple && Array.isArray(this.value) && this.value.length > 0) {
	      this.currentPlaceholder = '';
	    }
	    Object(resize_event_["addResizeListener"])(this.$el, this.handleResize);
	
	    var reference = this.$refs.reference;
	    if (reference && reference.$el) {
	      var sizeMap = {
	        medium: 36,
	        small: 32,
	        mini: 28
	      };
	      var input = reference.$el.querySelector('input');
	      this.initialInputHeight = input.getBoundingClientRect().height || sizeMap[this.selectSize];
	    }
	    if (this.remote && this.multiple) {
	      this.resetInputHeight();
	    }
	    this.$nextTick(function () {
	      if (reference && reference.$el) {
	        _this14.inputWidth = reference.$el.getBoundingClientRect().width;
	      }
	    });
	    this.setSelected();
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.$el && this.handleResize) Object(resize_event_["removeResizeListener"])(this.$el, this.handleResize);
	  }
	});
	// CONCATENATED MODULE: ./packages/select/src/select.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_selectvue_type_script_lang_js_ = (selectvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/select/src/select.vue
	
	
	
	
	
	/* normalize component */
	
	var select_component = normalizeComponent(
	  src_selectvue_type_script_lang_js_,
	  selectvue_type_template_id_0e4aade6_render,
	  selectvue_type_template_id_0e4aade6_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var select_api; }
	select_component.options.__file = "packages/select/src/select.vue"
	/* harmony default export */ var src_select = (select_component.exports);
	// CONCATENATED MODULE: ./packages/select/index.js
	
	
	/* istanbul ignore next */
	src_select.install = function (Vue) {
	  Vue.component(src_select.name, src_select);
	};
	
	/* harmony default export */ var packages_select = (src_select);
	// CONCATENATED MODULE: ./packages/option/index.js
	
	
	/* istanbul ignore next */
	src_option.install = function (Vue) {
	  Vue.component(src_option.name, src_option);
	};
	
	/* harmony default export */ var packages_option = (src_option);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option-group.vue?vue&type=template&id=6685e5de&
	var option_groupvue_type_template_id_6685e5de_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "ul",
	    {
	      directives: [
	        {
	          name: "show",
	          rawName: "v-show",
	          value: _vm.visible,
	          expression: "visible"
	        }
	      ],
	      staticClass: "el-select-group__wrap"
	    },
	    [
	      _c("li", { staticClass: "el-select-group__title" }, [
	        _vm._v(_vm._s(_vm.label))
	      ]),
	      _c("li", [
	        _c("ul", { staticClass: "el-select-group" }, [_vm._t("default")], 2)
	      ])
	    ]
	  )
	}
	var option_groupvue_type_template_id_6685e5de_staticRenderFns = []
	option_groupvue_type_template_id_6685e5de_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/select/src/option-group.vue?vue&type=template&id=6685e5de&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option-group.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var option_groupvue_type_script_lang_js_ = ({
	  mixins: [emitter_default.a],
	
	  name: 'ElOptionGroup',
	
	  componentName: 'ElOptionGroup',
	
	  props: {
	    label: String,
	    disabled: {
	      type: Boolean,
	      default: false
	    }
	  },
	
	  data: function data() {
	    return {
	      visible: true
	    };
	  },
	
	
	  watch: {
	    disabled: function disabled(val) {
	      this.broadcast('ElOption', 'handleGroupDisabled', val);
	    }
	  },
	
	  methods: {
	    queryChange: function queryChange() {
	      this.visible = this.$children && Array.isArray(this.$children) && this.$children.some(function (option) {
	        return option.visible === true;
	      });
	    }
	  },
	
	  created: function created() {
	    this.$on('queryChange', this.queryChange);
	  },
	  mounted: function mounted() {
	    if (this.disabled) {
	      this.broadcast('ElOption', 'handleGroupDisabled', this.disabled);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/select/src/option-group.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_option_groupvue_type_script_lang_js_ = (option_groupvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/select/src/option-group.vue
	
	
	
	
	
	/* normalize component */
	
	var option_group_component = normalizeComponent(
	  src_option_groupvue_type_script_lang_js_,
	  option_groupvue_type_template_id_6685e5de_render,
	  option_groupvue_type_template_id_6685e5de_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var option_group_api; }
	option_group_component.options.__file = "packages/select/src/option-group.vue"
	/* harmony default export */ var option_group = (option_group_component.exports);
	// CONCATENATED MODULE: ./packages/option-group/index.js
	
	
	/* istanbul ignore next */
	option_group.install = function (Vue) {
	  Vue.component(option_group.name, option_group);
	};
	
	/* harmony default export */ var packages_option_group = (option_group);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button.vue?vue&type=template&id=ca859fb4&
	var buttonvue_type_template_id_ca859fb4_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "button",
	    {
	      staticClass: "el-button",
	      class: [
	        _vm.type ? "el-button--" + _vm.type : "",
	        _vm.buttonSize ? "el-button--" + _vm.buttonSize : "",
	        {
	          "is-disabled": _vm.buttonDisabled,
	          "is-loading": _vm.loading,
	          "is-plain": _vm.plain,
	          "is-round": _vm.round,
	          "is-circle": _vm.circle
	        }
	      ],
	      attrs: {
	        disabled: _vm.buttonDisabled || _vm.loading,
	        autofocus: _vm.autofocus,
	        type: _vm.nativeType
	      },
	      on: { click: _vm.handleClick }
	    },
	    [
	      _vm.loading ? _c("i", { staticClass: "el-icon-loading" }) : _vm._e(),
	      _vm.icon && !_vm.loading ? _c("i", { class: _vm.icon }) : _vm._e(),
	      _vm.$slots.default ? _c("span", [_vm._t("default")], 2) : _vm._e()
	    ]
	  )
	}
	var buttonvue_type_template_id_ca859fb4_staticRenderFns = []
	buttonvue_type_template_id_ca859fb4_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/button/src/button.vue?vue&type=template&id=ca859fb4&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var buttonvue_type_script_lang_js_ = ({
	  name: 'ElButton',
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  props: {
	    type: {
	      type: String,
	      default: 'default'
	    },
	    size: String,
	    icon: {
	      type: String,
	      default: ''
	    },
	    nativeType: {
	      type: String,
	      default: 'button'
	    },
	    loading: Boolean,
	    disabled: Boolean,
	    plain: Boolean,
	    autofocus: Boolean,
	    round: Boolean,
	    circle: Boolean
	  },
	
	  computed: {
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    buttonSize: function buttonSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    buttonDisabled: function buttonDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    }
	  },
	
	  methods: {
	    handleClick: function handleClick(evt) {
	      this.$emit('click', evt);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/button/src/button.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_buttonvue_type_script_lang_js_ = (buttonvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/button/src/button.vue
	
	
	
	
	
	/* normalize component */
	
	var button_component = normalizeComponent(
	  src_buttonvue_type_script_lang_js_,
	  buttonvue_type_template_id_ca859fb4_render,
	  buttonvue_type_template_id_ca859fb4_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var button_api; }
	button_component.options.__file = "packages/button/src/button.vue"
	/* harmony default export */ var src_button = (button_component.exports);
	// CONCATENATED MODULE: ./packages/button/index.js
	
	
	/* istanbul ignore next */
	src_button.install = function (Vue) {
	  Vue.component(src_button.name, src_button);
	};
	
	/* harmony default export */ var packages_button = (src_button);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button-group.vue?vue&type=template&id=3d8661d0&
	var button_groupvue_type_template_id_3d8661d0_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("div", { staticClass: "el-button-group" }, [_vm._t("default")], 2)
	}
	var button_groupvue_type_template_id_3d8661d0_staticRenderFns = []
	button_groupvue_type_template_id_3d8661d0_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/button/src/button-group.vue?vue&type=template&id=3d8661d0&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button-group.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	
	/* harmony default export */ var button_groupvue_type_script_lang_js_ = ({
	  name: 'ElButtonGroup'
	});
	// CONCATENATED MODULE: ./packages/button/src/button-group.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_button_groupvue_type_script_lang_js_ = (button_groupvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/button/src/button-group.vue
	
	
	
	
	
	/* normalize component */
	
	var button_group_component = normalizeComponent(
	  src_button_groupvue_type_script_lang_js_,
	  button_groupvue_type_template_id_3d8661d0_render,
	  button_groupvue_type_template_id_3d8661d0_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var button_group_api; }
	button_group_component.options.__file = "packages/button/src/button-group.vue"
	/* harmony default export */ var button_group = (button_group_component.exports);
	// CONCATENATED MODULE: ./packages/button-group/index.js
	
	
	/* istanbul ignore next */
	button_group.install = function (Vue) {
	  Vue.component(button_group.name, button_group);
	};
	
	/* harmony default export */ var packages_button_group = (button_group);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/table/src/table.vue?vue&type=template&id=493fe34e&
	var tablevue_type_template_id_493fe34e_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-table",
	      class: [
	        {
	          "el-table--fit": _vm.fit,
	          "el-table--striped": _vm.stripe,
	          "el-table--border": _vm.border || _vm.isGroup,
	          "el-table--hidden": _vm.isHidden,
	          "el-table--group": _vm.isGroup,
	          "el-table--fluid-height": _vm.maxHeight,
	          "el-table--scrollable-x": _vm.layout.scrollX,
	          "el-table--scrollable-y": _vm.layout.scrollY,
	          "el-table--enable-row-hover": !_vm.store.states.isComplex,
	          "el-table--enable-row-transition":
	            (_vm.store.states.data || []).length !== 0 &&
	            (_vm.store.states.data || []).length < 100
	        },
	        _vm.tableSize ? "el-table--" + _vm.tableSize : ""
	      ],
	      on: {
	        mouseleave: function($event) {
	          _vm.handleMouseLeave($event)
	        }
	      }
	    },
	    [
	      _c(
	        "div",
	        { ref: "hiddenColumns", staticClass: "hidden-columns" },
	        [_vm._t("default")],
	        2
	      ),
	      _vm.showHeader
	        ? _c(
	            "div",
	            {
	              directives: [
	                {
	                  name: "mousewheel",
	                  rawName: "v-mousewheel",
	                  value: _vm.handleHeaderFooterMousewheel,
	                  expression: "handleHeaderFooterMousewheel"
	                }
	              ],
	              ref: "headerWrapper",
	              staticClass: "el-table__header-wrapper"
	            },
	            [
	              _c("table-header", {
	                ref: "tableHeader",
	                style: {
	                  width: _vm.layout.bodyWidth ? _vm.layout.bodyWidth + "px" : ""
	                },
	                attrs: {
	                  store: _vm.store,
	                  border: _vm.border,
	                  "default-sort": _vm.defaultSort
	                }
	              })
	            ],
	            1
	          )
	        : _vm._e(),
	      _c(
	        "div",
	        {
	          ref: "bodyWrapper",
	          staticClass: "el-table__body-wrapper",
	          class: [
	            _vm.layout.scrollX
	              ? "is-scrolling-" + _vm.scrollPosition
	              : "is-scrolling-none"
	          ],
	          style: [_vm.bodyHeight]
	        },
	        [
	          _c("table-body", {
	            style: {
	              width: _vm.bodyWidth
	            },
	            attrs: {
	              context: _vm.context,
	              store: _vm.store,
	              stripe: _vm.stripe,
	              "row-class-name": _vm.rowClassName,
	              "row-style": _vm.rowStyle,
	              highlight: _vm.highlightCurrentRow
	            }
	          }),
	          !_vm.data || _vm.data.length === 0
	            ? _c(
	                "div",
	                {
	                  ref: "emptyBlock",
	                  staticClass: "el-table__empty-block",
	                  style: _vm.emptyBlockStyle
	                },
	                [
	                  _c(
	                    "span",
	                    { staticClass: "el-table__empty-text" },
	                    [
	                      _vm._t("empty", [
	                        _vm._v(
	                          _vm._s(_vm.emptyText || _vm.t("el.table.emptyText"))
	                        )
	                      ])
	                    ],
	                    2
	                  )
	                ]
	              )
	            : _vm._e(),
	          _vm.$slots.append
	            ? _c(
	                "div",
	                {
	                  ref: "appendWrapper",
	                  staticClass: "el-table__append-wrapper"
	                },
	                [_vm._t("append")],
	                2
	              )
	            : _vm._e()
	        ],
	        1
	      ),
	      _vm.showSummary
	        ? _c(
	            "div",
	            {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value: _vm.data && _vm.data.length > 0,
	                  expression: "data && data.length > 0"
	                },
	                {
	                  name: "mousewheel",
	                  rawName: "v-mousewheel",
	                  value: _vm.handleHeaderFooterMousewheel,
	                  expression: "handleHeaderFooterMousewheel"
	                }
	              ],
	              ref: "footerWrapper",
	              staticClass: "el-table__footer-wrapper"
	            },
	            [
	              _c("table-footer", {
	                style: {
	                  width: _vm.layout.bodyWidth ? _vm.layout.bodyWidth + "px" : ""
	                },
	                attrs: {
	                  store: _vm.store,
	                  border: _vm.border,
	                  "sum-text": _vm.sumText || _vm.t("el.table.sumText"),
	                  "summary-method": _vm.summaryMethod,
	                  "default-sort": _vm.defaultSort
	                }
	              })
	            ],
	            1
	          )
	        : _vm._e(),
	      _vm.fixedColumns.length > 0
	        ? _c(
	            "div",
	            {
	              directives: [
	                {
	                  name: "mousewheel",
	                  rawName: "v-mousewheel",
	                  value: _vm.handleFixedMousewheel,
	                  expression: "handleFixedMousewheel"
	                }
	              ],
	              ref: "fixedWrapper",
	              staticClass: "el-table__fixed",
	              style: [
	                {
	                  width: _vm.layout.fixedWidth
	                    ? _vm.layout.fixedWidth + "px"
	                    : ""
	                },
	                _vm.fixedHeight
	              ]
	            },
	            [
	              _vm.showHeader
	                ? _c(
	                    "div",
	                    {
	                      ref: "fixedHeaderWrapper",
	                      staticClass: "el-table__fixed-header-wrapper"
	                    },
	                    [
	                      _c("table-header", {
	                        ref: "fixedTableHeader",
	                        style: {
	                          width: _vm.bodyWidth
	                        },
	                        attrs: {
	                          fixed: "left",
	                          border: _vm.border,
	                          store: _vm.store
	                        }
	                      })
	                    ],
	                    1
	                  )
	                : _vm._e(),
	              _c(
	                "div",
	                {
	                  ref: "fixedBodyWrapper",
	                  staticClass: "el-table__fixed-body-wrapper",
	                  style: [
	                    {
	                      top: _vm.layout.headerHeight + "px"
	                    },
	                    _vm.fixedBodyHeight
	                  ]
	                },
	                [
	                  _c("table-body", {
	                    style: {
	                      width: _vm.bodyWidth
	                    },
	                    attrs: {
	                      fixed: "left",
	                      store: _vm.store,
	                      stripe: _vm.stripe,
	                      highlight: _vm.highlightCurrentRow,
	                      "row-class-name": _vm.rowClassName,
	                      "row-style": _vm.rowStyle
	                    }
	                  }),
	                  _vm.$slots.append
	                    ? _c("div", {
	                        staticClass: "el-table__append-gutter",
	                        style: { height: _vm.layout.appendHeight + "px" }
	                      })
	                    : _vm._e()
	                ],
	                1
	              ),
	              _vm.showSummary
	                ? _c(
	                    "div",
	                    {
	                      directives: [
	                        {
	                          name: "show",
	                          rawName: "v-show",
	                          value: _vm.data && _vm.data.length > 0,
	                          expression: "data && data.length > 0"
	                        }
	                      ],
	                      ref: "fixedFooterWrapper",
	                      staticClass: "el-table__fixed-footer-wrapper"
	                    },
	                    [
	                      _c("table-footer", {
	                        style: {
	                          width: _vm.bodyWidth
	                        },
	                        attrs: {
	                          fixed: "left",
	                          border: _vm.border,
	                          "sum-text": _vm.sumText || _vm.t("el.table.sumText"),
	                          "summary-method": _vm.summaryMethod,
	                          store: _vm.store
	                        }
	                      })
	                    ],
	                    1
	                  )
	                : _vm._e()
	            ]
	          )
	        : _vm._e(),
	      _vm.rightFixedColumns.length > 0
	        ? _c(
	            "div",
	            {
	              directives: [
	                {
	                  name: "mousewheel",
	                  rawName: "v-mousewheel",
	                  value: _vm.handleFixedMousewheel,
	                  expression: "handleFixedMousewheel"
	                }
	              ],
	              ref: "rightFixedWrapper",
	              staticClass: "el-table__fixed-right",
	              style: [
	                {
	                  width: _vm.layout.rightFixedWidth
	                    ? _vm.layout.rightFixedWidth + "px"
	                    : "",
	                  right: _vm.layout.scrollY
	                    ? (_vm.border
	                        ? _vm.layout.gutterWidth
	                        : _vm.layout.gutterWidth || 0) + "px"
	                    : ""
	                },
	                _vm.fixedHeight
	              ]
	            },
	            [
	              _vm.showHeader
	                ? _c(
	                    "div",
	                    {
	                      ref: "rightFixedHeaderWrapper",
	                      staticClass: "el-table__fixed-header-wrapper"
	                    },
	                    [
	                      _c("table-header", {
	                        ref: "rightFixedTableHeader",
	                        style: {
	                          width: _vm.bodyWidth
	                        },
	                        attrs: {
	                          fixed: "right",
	                          border: _vm.border,
	                          store: _vm.store
	                        }
	                      })
	                    ],
	                    1
	                  )
	                : _vm._e(),
	              _c(
	                "div",
	                {
	                  ref: "rightFixedBodyWrapper",
	                  staticClass: "el-table__fixed-body-wrapper",
	                  style: [
	                    {
	                      top: _vm.layout.headerHeight + "px"
	                    },
	                    _vm.fixedBodyHeight
	                  ]
	                },
	                [
	                  _c("table-body", {
	                    style: {
	                      width: _vm.bodyWidth
	                    },
	                    attrs: {
	                      fixed: "right",
	                      store: _vm.store,
	                      stripe: _vm.stripe,
	                      "row-class-name": _vm.rowClassName,
	                      "row-style": _vm.rowStyle,
	                      highlight: _vm.highlightCurrentRow
	                    }
	                  }),
	                  _vm.$slots.append
	                    ? _c("div", {
	                        staticClass: "el-table__append-gutter",
	                        style: { height: _vm.layout.appendHeight + "px" }
	                      })
	                    : _vm._e()
	                ],
	                1
	              ),
	              _vm.showSummary
	                ? _c(
	                    "div",
	                    {
	                      directives: [
	                        {
	                          name: "show",
	                          rawName: "v-show",
	                          value: _vm.data && _vm.data.length > 0,
	                          expression: "data && data.length > 0"
	                        }
	                      ],
	                      ref: "rightFixedFooterWrapper",
	                      staticClass: "el-table__fixed-footer-wrapper"
	                    },
	                    [
	                      _c("table-footer", {
	                        style: {
	                          width: _vm.bodyWidth
	                        },
	                        attrs: {
	                          fixed: "right",
	                          border: _vm.border,
	                          "sum-text": _vm.sumText || _vm.t("el.table.sumText"),
	                          "summary-method": _vm.summaryMethod,
	                          store: _vm.store
	                        }
	                      })
	                    ],
	                    1
	                  )
	                : _vm._e()
	            ]
	          )
	        : _vm._e(),
	      _vm.rightFixedColumns.length > 0
	        ? _c("div", {
	            ref: "rightFixedPatch",
	            staticClass: "el-table__fixed-right-patch",
	            style: {
	              width: _vm.layout.scrollY ? _vm.layout.gutterWidth + "px" : "0",
	              height: _vm.layout.headerHeight + "px"
	            }
	          })
	        : _vm._e(),
	      _c("div", {
	        directives: [
	          {
	            name: "show",
	            rawName: "v-show",
	            value: _vm.resizeProxyVisible,
	            expression: "resizeProxyVisible"
	          }
	        ],
	        ref: "resizeProxy",
	        staticClass: "el-table__column-resize-proxy"
	      })
	    ]
	  )
	}
	var tablevue_type_template_id_493fe34e_staticRenderFns = []
	tablevue_type_template_id_493fe34e_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/table/src/table.vue?vue&type=template&id=493fe34e&
	
	// EXTERNAL MODULE: external "element-ui/lib/checkbox"
	var checkbox_ = __webpack_require__(16);
	var checkbox_default = /*#__PURE__*/__webpack_require__.n(checkbox_);
	
	// EXTERNAL MODULE: external "throttle-debounce"
	var external_throttle_debounce_ = __webpack_require__(35);
	
	// EXTERNAL MODULE: external "normalize-wheel"
	var external_normalize_wheel_ = __webpack_require__(38);
	var external_normalize_wheel_default = /*#__PURE__*/__webpack_require__.n(external_normalize_wheel_);
	
	// CONCATENATED MODULE: ./src/directives/mousewheel.js
	
	
	var isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
	
	var mousewheel_mousewheel = function mousewheel(element, callback) {
	  if (element && element.addEventListener) {
	    element.addEventListener(isFirefox ? 'DOMMouseScroll' : 'mousewheel', function (event) {
	      var normalized = external_normalize_wheel_default()(event);
	      callback && callback.apply(this, [event, normalized]);
	    });
	  }
	};
	
	/* harmony default export */ var directives_mousewheel = ({
	  bind: function bind(el, binding) {
	    mousewheel_mousewheel(el, binding.value);
	  }
	});
	// EXTERNAL MODULE: external "vue"
	var external_vue_ = __webpack_require__(6);
	var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
	
	// CONCATENATED MODULE: ./packages/table/src/util.js
	var util_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	
	
	var getCell = function getCell(event) {
	  var cell = event.target;
	
	  while (cell && cell.tagName.toUpperCase() !== 'HTML') {
	    if (cell.tagName.toUpperCase() === 'TD') {
	      return cell;
	    }
	    cell = cell.parentNode;
	  }
	
	  return null;
	};
	
	var util_isObject = function isObject(obj) {
	  return obj !== null && (typeof obj === 'undefined' ? 'undefined' : util_typeof(obj)) === 'object';
	};
	
	var util_orderBy = function orderBy(array, sortKey, reverse, sortMethod, sortBy) {
	  if (!sortKey && !sortMethod && (!sortBy || Array.isArray(sortBy) && !sortBy.length)) {
	    return array;
	  }
	  if (typeof reverse === 'string') {
	    reverse = reverse === 'descending' ? -1 : 1;
	  } else {
	    reverse = reverse && reverse < 0 ? -1 : 1;
	  }
	  var getKey = sortMethod ? null : function (value, index) {
	    if (sortBy) {
	      if (!Array.isArray(sortBy)) {
	        sortBy = [sortBy];
	      }
	      return sortBy.map(function (by) {
	        if (typeof by === 'string') {
	          return Object(util_["getValueByPath"])(value, by);
	        } else {
	          return by(value, index, array);
	        }
	      });
	    }
	    if (sortKey !== '$key') {
	      if (util_isObject(value) && '$value' in value) value = value.$value;
	    }
	    return [util_isObject(value) ? Object(util_["getValueByPath"])(value, sortKey) : value];
	  };
	  var compare = function compare(a, b) {
	    if (sortMethod) {
	      return sortMethod(a.value, b.value);
	    }
	    for (var i = 0, len = a.key.length; i < len; i++) {
	      if (a.key[i] < b.key[i]) {
	        return -1;
	      }
	      if (a.key[i] > b.key[i]) {
	        return 1;
	      }
	    }
	    return 0;
	  };
	  return array.map(function (value, index) {
	    return {
	      value: value,
	      index: index,
	      key: getKey ? getKey(value, index) : null
	    };
	  }).sort(function (a, b) {
	    var order = compare(a, b);
	    if (!order) {
	      // make stable https://en.wikipedia.org/wiki/Sorting_algorithm#Stability
	      order = a.index - b.index;
	    }
	    return order * reverse;
	  }).map(function (item) {
	    return item.value;
	  });
	};
	
	var getColumnById = function getColumnById(table, columnId) {
	  var column = null;
	  table.columns.forEach(function (item) {
	    if (item.id === columnId) {
	      column = item;
	    }
	  });
	  return column;
	};
	
	var getColumnByKey = function getColumnByKey(table, columnKey) {
	  var column = null;
	  for (var i = 0; i < table.columns.length; i++) {
	    var item = table.columns[i];
	    if (item.columnKey === columnKey) {
	      column = item;
	      break;
	    }
	  }
	  return column;
	};
	
	var getColumnByCell = function getColumnByCell(table, cell) {
	  var matches = (cell.className || '').match(/el-table_[^\s]+/gm);
	  if (matches) {
	    return getColumnById(table, matches[0]);
	  }
	  return null;
	};
	
	var getRowIdentity = function getRowIdentity(row, rowKey) {
	  if (!row) throw new Error('row is required when get row identity');
	  if (typeof rowKey === 'string') {
	    if (rowKey.indexOf('.') < 0) {
	      return row[rowKey];
	    }
	    var key = rowKey.split('.');
	    var current = row;
	    for (var i = 0; i < key.length; i++) {
	      current = current[key[i]];
	    }
	    return current;
	  } else if (typeof rowKey === 'function') {
	    return rowKey.call(null, row);
	  }
	};
	
	var getKeysMap = function getKeysMap(array, rowKey) {
	  var arrayMap = {};
	  (array || []).forEach(function (row, index) {
	    arrayMap[getRowIdentity(row, rowKey)] = { row: row, index: index };
	  });
	  return arrayMap;
	};
	
	function hasOwn(obj, key) {
	  return Object.prototype.hasOwnProperty.call(obj, key);
	}
	
	function mergeOptions(defaults, config) {
	  var options = {};
	  var key = void 0;
	  for (key in defaults) {
	    options[key] = defaults[key];
	  }
	  for (key in config) {
	    if (hasOwn(config, key)) {
	      var value = config[key];
	      if (typeof value !== 'undefined') {
	        options[key] = value;
	      }
	    }
	  }
	  return options;
	}
	
	function parseWidth(width) {
	  if (width !== undefined) {
	    width = parseInt(width, 10);
	    if (isNaN(width)) {
	      width = null;
	    }
	  }
	  return width;
	}
	
	function parseMinWidth(minWidth) {
	  if (typeof minWidth !== 'undefined') {
	    minWidth = parseWidth(minWidth);
	    if (isNaN(minWidth)) {
	      minWidth = 80;
	    }
	  }
	  return minWidth;
	};
	
	function parseHeight(height) {
	  if (typeof height === 'number') {
	    return height;
	  }
	  if (typeof height === 'string') {
	    if (/^\d+(?:px)?$/.test(height)) {
	      return parseInt(height, 10);
	    } else {
	      return height;
	    }
	  }
	  return null;
	}
	
	// https://github.com/reduxjs/redux/blob/master/src/compose.js
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}
	
	function toggleRowStatus(statusArr, row, newVal) {
	  var changed = false;
	  var index = statusArr.indexOf(row);
	  var included = index !== -1;
	
	  var addRow = function addRow() {
	    statusArr.push(row);
	    changed = true;
	  };
	  var removeRow = function removeRow() {
	    statusArr.splice(index, 1);
	    changed = true;
	  };
	
	  if (typeof newVal === 'boolean') {
	    if (newVal && !included) {
	      addRow();
	    } else if (!newVal && included) {
	      removeRow();
	    }
	  } else {
	    if (included) {
	      removeRow();
	    } else {
	      addRow();
	    }
	  }
	  return changed;
	}
	
	function walkTreeNode(root, cb) {
	  var childrenKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'children';
	  var lazyKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'hasChildren';
	
	  var isNil = function isNil(array) {
	    return !(Array.isArray(array) && array.length);
	  };
	
	  function _walker(parent, children, level) {
	    cb(parent, children, level);
	    children.forEach(function (item) {
	      if (item[lazyKey]) {
	        cb(item, null, level + 1);
	        return;
	      }
	      var children = item[childrenKey];
	      if (!isNil(children)) {
	        _walker(item, children, level + 1);
	      }
	    });
	  }
	
	  root.forEach(function (item) {
	    if (item[lazyKey]) {
	      cb(item, null, 0);
	      return;
	    }
	    var children = item[childrenKey];
	    if (!isNil(children)) {
	      _walker(item, children, 0);
	    }
	  });
	}
	// CONCATENATED MODULE: ./packages/table/src/store/expand.js
	
	
	/* harmony default export */ var expand = ({
	  data: function data() {
	    return {
	      states: {
	        defaultExpandAll: false,
	        expandRows: []
	      }
	    };
	  },
	
	
	  methods: {
	    updateExpandRows: function updateExpandRows() {
	      var _states = this.states,
	          _states$data = _states.data,
	          data = _states$data === undefined ? [] : _states$data,
	          rowKey = _states.rowKey,
	          defaultExpandAll = _states.defaultExpandAll,
	          expandRows = _states.expandRows;
	
	      if (defaultExpandAll) {
	        this.states.expandRows = data.slice();
	      } else if (rowKey) {
	        // TODO：这里的代码可以优化
	        var expandRowsMap = getKeysMap(expandRows, rowKey);
	        this.states.expandRows = data.reduce(function (prev, row) {
	          var rowId = getRowIdentity(row, rowKey);
	          var rowInfo = expandRowsMap[rowId];
	          if (rowInfo) {
	            prev.push(row);
	          }
	          return prev;
	        }, []);
	      } else {
	        this.states.expandRows = [];
	      }
	    },
	    toggleRowExpansion: function toggleRowExpansion(row, expanded) {
	      var changed = toggleRowStatus(this.states.expandRows, row, expanded);
	      if (changed) {
	        this.table.$emit('expand-change', row, this.states.expandRows.slice());
	        this.scheduleLayout();
	      }
	    },
	    setExpandRowKeys: function setExpandRowKeys(rowKeys) {
	      this.assertRowKey();
	      // TODO：这里的代码可以优化
	      var _states2 = this.states,
	          data = _states2.data,
	          rowKey = _states2.rowKey;
	
	      var keysMap = getKeysMap(data, rowKey);
	      this.states.expandRows = rowKeys.reduce(function (prev, cur) {
	        var info = keysMap[cur];
	        if (info) {
	          prev.push(info.row);
	        }
	        return prev;
	      }, []);
	    },
	    isRowExpanded: function isRowExpanded(row) {
	      var _states3 = this.states,
	          _states3$expandRows = _states3.expandRows,
	          expandRows = _states3$expandRows === undefined ? [] : _states3$expandRows,
	          rowKey = _states3.rowKey;
	
	      if (rowKey) {
	        var expandMap = getKeysMap(expandRows, rowKey);
	        return !!expandMap[getRowIdentity(row, rowKey)];
	      }
	      return expandRows.indexOf(row) !== -1;
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/table/src/store/current.js
	
	
	
	/* harmony default export */ var store_current = ({
	  data: function data() {
	    return {
	      states: {
	        // 不可响应的，设置 currentRowKey 时，data 不一定存在，也许无法算出正确的 currentRow
	        // 把该值缓存一下，当用户点击修改 currentRow 时，把该值重置为 null
	        _currentRowKey: null,
	        currentRow: null
	      }
	    };
	  },
	
	
	  methods: {
	    setCurrentRowKey: function setCurrentRowKey(key) {
	      this.assertRowKey();
	      this.states._currentRowKey = key;
	      this.setCurrentRowByKey(key);
	    },
	    restoreCurrentRowKey: function restoreCurrentRowKey() {
	      this.states._currentRowKey = null;
	    },
	    setCurrentRowByKey: function setCurrentRowByKey(key) {
	      var states = this.states;
	      var _states$data = states.data,
	          data = _states$data === undefined ? [] : _states$data,
	          rowKey = states.rowKey;
	
	      var currentRow = null;
	      if (rowKey) {
	        currentRow = Object(util_["arrayFind"])(data, function (item) {
	          return getRowIdentity(item, rowKey) === key;
	        });
	      }
	      states.currentRow = currentRow;
	    },
	    updateCurrentRow: function updateCurrentRow(currentRow) {
	      var states = this.states,
	          table = this.table;
	
	      var oldCurrentRow = states.currentRow;
	      if (currentRow && currentRow !== oldCurrentRow) {
	        states.currentRow = currentRow;
	        table.$emit('current-change', currentRow, oldCurrentRow);
	        return;
	      }
	      if (!currentRow && oldCurrentRow) {
	        states.currentRow = null;
	        table.$emit('current-change', null, oldCurrentRow);
	      }
	    },
	    updateCurrentRowData: function updateCurrentRowData() {
	      var states = this.states,
	          table = this.table;
	      var rowKey = states.rowKey,
	          _currentRowKey = states._currentRowKey;
	      // data 为 null 时，解构时的默认值会被忽略
	
	      var data = states.data || [];
	      var oldCurrentRow = states.currentRow;
	
	      // 当 currentRow 不在 data 中时尝试更新数据
	      if (data.indexOf(oldCurrentRow) === -1 && oldCurrentRow) {
	        if (rowKey) {
	          var currentRowKey = getRowIdentity(oldCurrentRow, rowKey);
	          this.setCurrentRowByKey(currentRowKey);
	        } else {
	          states.currentRow = null;
	        }
	        if (states.currentRow === null) {
	          table.$emit('current-change', null, oldCurrentRow);
	        }
	      } else if (_currentRowKey) {
	        // 把初始时下设置的 rowKey 转化成 rowData
	        this.setCurrentRowByKey(_currentRowKey);
	        this.restoreCurrentRowKey();
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/table/src/store/tree.js
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	
	
	/* harmony default export */ var tree = ({
	  data: function data() {
	    return {
	      states: {
	        // defaultExpandAll 存在于 expand.js 中，这里不重复添加
	        // 在展开行中，expandRowKeys 会被转化成 expandRows，expandRowKeys 这个属性只是记录了 TreeTable 行的展开
	        // TODO: 拆分为独立的 TreeTable，统一用法
	        expandRowKeys: [],
	        treeData: {},
	        indent: 16,
	        lazy: false,
	        lazyTreeNodeMap: {},
	        lazyColumnIdentifier: 'hasChildren',
	        childrenColumnName: 'children'
	      }
	    };
	  },
	
	
	  computed: {
	    // 嵌入型的数据，watch 无法是检测到变化 https://github.com/ElemeFE/element/issues/14998
	    // TODO: 使用 computed 解决该问题，是否会造成性能问题？
	    // @return { id: { level, children } }
	    normalizedData: function normalizedData() {
	      if (!this.states.rowKey) return {};
	      var data = this.states.data || [];
	      return this.normalize(data);
	    },
	
	    // @return { id: { children } }
	    // 针对懒加载的情形，不处理嵌套数据
	    normalizedLazyNode: function normalizedLazyNode() {
	      var _states = this.states,
	          rowKey = _states.rowKey,
	          lazyTreeNodeMap = _states.lazyTreeNodeMap,
	          lazyColumnIdentifier = _states.lazyColumnIdentifier;
	
	      var keys = Object.keys(lazyTreeNodeMap);
	      var res = {};
	      if (!keys.length) return res;
	      keys.forEach(function (key) {
	        if (lazyTreeNodeMap[key].length) {
	          var item = { children: [] };
	          lazyTreeNodeMap[key].forEach(function (row) {
	            var currentRowKey = getRowIdentity(row, rowKey);
	            item.children.push(currentRowKey);
	            if (row[lazyColumnIdentifier] && !res[currentRowKey]) {
	              res[currentRowKey] = { children: [] };
	            }
	          });
	          res[key] = item;
	        }
	      });
	      return res;
	    }
	  },
	
	  watch: {
	    normalizedData: 'updateTreeData',
	    normalizedLazyNode: 'updateTreeData'
	  },
	
	  methods: {
	    normalize: function normalize(data) {
	      var _states2 = this.states,
	          childrenColumnName = _states2.childrenColumnName,
	          lazyColumnIdentifier = _states2.lazyColumnIdentifier,
	          rowKey = _states2.rowKey,
	          lazy = _states2.lazy;
	
	      var res = {};
	      walkTreeNode(data, function (parent, children, level) {
	        var parentId = getRowIdentity(parent, rowKey);
	        if (Array.isArray(children)) {
	          res[parentId] = {
	            children: children.map(function (row) {
	              return getRowIdentity(row, rowKey);
	            }),
	            level: level
	          };
	        } else if (lazy) {
	          // 当 children 不存在且 lazy 为 true，该节点即为懒加载的节点
	          res[parentId] = {
	            children: [],
	            lazy: true,
	            level: level
	          };
	        }
	      }, childrenColumnName, lazyColumnIdentifier);
	      return res;
	    },
	    updateTreeData: function updateTreeData() {
	      var nested = this.normalizedData;
	      var normalizedLazyNode = this.normalizedLazyNode;
	      var keys = Object.keys(nested);
	      var newTreeData = {};
	      if (keys.length) {
	        var _states3 = this.states,
	            oldTreeData = _states3.treeData,
	            defaultExpandAll = _states3.defaultExpandAll,
	            expandRowKeys = _states3.expandRowKeys,
	            lazy = _states3.lazy;
	
	        var rootLazyRowKeys = [];
	        var getExpanded = function getExpanded(oldValue, key) {
	          var included = defaultExpandAll || expandRowKeys && expandRowKeys.indexOf(key) !== -1;
	          return !!(oldValue && oldValue.expanded || included);
	        };
	        // 合并 expanded 与 display，确保数据刷新后，状态不变
	        keys.forEach(function (key) {
	          var oldValue = oldTreeData[key];
	          var newValue = _extends({}, nested[key]);
	          newValue.expanded = getExpanded(oldValue, key);
	          if (newValue.lazy) {
	            var _ref = oldValue || {},
	                _ref$loaded = _ref.loaded,
	                loaded = _ref$loaded === undefined ? false : _ref$loaded,
	                _ref$loading = _ref.loading,
	                loading = _ref$loading === undefined ? false : _ref$loading;
	
	            newValue.loaded = !!loaded;
	            newValue.loading = !!loading;
	            rootLazyRowKeys.push(key);
	          }
	          newTreeData[key] = newValue;
	        });
	        // 根据懒加载数据更新 treeData
	        var lazyKeys = Object.keys(normalizedLazyNode);
	        if (lazy && lazyKeys.length && rootLazyRowKeys.length) {
	          lazyKeys.forEach(function (key) {
	            var oldValue = oldTreeData[key];
	            var lazyNodeChildren = normalizedLazyNode[key].children;
	            if (rootLazyRowKeys.indexOf(key) !== -1) {
	              // 懒加载的 root 节点，更新一下原有的数据，原来的 children 一定是空数组
	              if (newTreeData[key].children.length !== 0) {
	                throw new Error('[ElTable]children must be an empty array.');
	              }
	              newTreeData[key].children = lazyNodeChildren;
	            } else {
	              var _ref2 = oldValue || {},
	                  _ref2$loaded = _ref2.loaded,
	                  loaded = _ref2$loaded === undefined ? false : _ref2$loaded,
	                  _ref2$loading = _ref2.loading,
	                  loading = _ref2$loading === undefined ? false : _ref2$loading;
	
	              newTreeData[key] = {
	                lazy: true,
	                loaded: !!loaded,
	                loading: !!loading,
	                expanded: getExpanded(oldValue, key),
	                children: lazyNodeChildren,
	                level: ''
	              };
	            }
	          });
	        }
	      }
	      this.states.treeData = newTreeData;
	      this.updateTableScrollY();
	    },
	    updateTreeExpandKeys: function updateTreeExpandKeys(value) {
	      this.states.expandRowKeys = value;
	      this.updateTreeData();
	    },
	    toggleTreeExpansion: function toggleTreeExpansion(row, expanded) {
	      this.assertRowKey();
	
	      var _states4 = this.states,
	          rowKey = _states4.rowKey,
	          treeData = _states4.treeData;
	
	      var id = getRowIdentity(row, rowKey);
	      var data = id && treeData[id];
	      if (id && data && 'expanded' in data) {
	        var oldExpanded = data.expanded;
	        expanded = typeof expanded === 'undefined' ? !data.expanded : expanded;
	        treeData[id].expanded = expanded;
	        if (oldExpanded !== expanded) {
	          this.table.$emit('expand-change', row, expanded);
	        }
	        this.updateTableScrollY();
	      }
	    },
	    loadOrToggle: function loadOrToggle(row) {
	      this.assertRowKey();
	      var _states5 = this.states,
	          lazy = _states5.lazy,
	          treeData = _states5.treeData,
	          rowKey = _states5.rowKey;
	
	      var id = getRowIdentity(row, rowKey);
	      var data = treeData[id];
	      if (lazy && data && 'loaded' in data && !data.loaded) {
	        this.loadData(row, id, data);
	      } else {
	        this.toggleTreeExpansion(row);
	      }
	    },
	    loadData: function loadData(row, key, treeNode) {
	      var _this = this;
	
	      var load = this.table.load;
	      var _states6 = this.states,
	          lazyTreeNodeMap = _states6.lazyTreeNodeMap,
	          treeData = _states6.treeData;
	
	      if (load && !treeData[key].loaded) {
	        treeData[key].loading = true;
	        load(row, treeNode, function (data) {
	          if (!Array.isArray(data)) {
	            throw new Error('[ElTable] data must be an array');
	          }
	          treeData[key].loading = false;
	          treeData[key].loaded = true;
	          treeData[key].expanded = true;
	          if (data.length) {
	            _this.$set(lazyTreeNodeMap, key, data);
	          }
	          _this.table.$emit('expand-change', row, true);
	        });
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/table/src/store/watcher.js
	
	
	
	
	
	
	
	var watcher_sortData = function sortData(data, states) {
	  var sortingColumn = states.sortingColumn;
	  if (!sortingColumn || typeof sortingColumn.sortable === 'string') {
	    return data;
	  }
	  return util_orderBy(data, states.sortProp, states.sortOrder, sortingColumn.sortMethod, sortingColumn.sortBy);
	};
	
	var doFlattenColumns = function doFlattenColumns(columns) {
	  var result = [];
	  columns.forEach(function (column) {
	    if (column.children) {
	      result.push.apply(result, doFlattenColumns(column.children));
	    } else {
	      result.push(column);
	    }
	  });
	  return result;
	};
	
	/* harmony default export */ var watcher = (external_vue_default.a.extend({
	  data: function data() {
	    return {
	      states: {
	        // 3.0 版本后要求必须设置该属性
	        rowKey: null,
	
	        // 渲染的数据来源，是对 table 中的 data 过滤排序后的结果
	        data: [],
	
	        // 是否包含固定列
	        isComplex: false,
	
	        // 列
	        _columns: [], // 不可响应的
	        originColumns: [],
	        columns: [],
	        fixedColumns: [],
	        rightFixedColumns: [],
	        leafColumns: [],
	        fixedLeafColumns: [],
	        rightFixedLeafColumns: [],
	        leafColumnsLength: 0,
	        fixedLeafColumnsLength: 0,
	        rightFixedLeafColumnsLength: 0,
	
	        // 选择
	        isAllSelected: false,
	        selection: [],
	        reserveSelection: false,
	        selectOnIndeterminate: false,
	        selectable: null,
	
	        // 过滤
	        filters: {}, // 不可响应的
	        filteredData: null,
	
	        // 排序
	        sortingColumn: null,
	        sortProp: null,
	        sortOrder: null,
	
	        hoverRow: null
	      }
	    };
	  },
	
	
	  mixins: [expand, store_current, tree],
	
	  methods: {
	    // 检查 rowKey 是否存在
	    assertRowKey: function assertRowKey() {
	      var rowKey = this.states.rowKey;
	      if (!rowKey) throw new Error('[ElTable] prop row-key is required');
	    },
	
	
	    // 更新列
	    updateColumns: function updateColumns() {
	      var states = this.states;
	      var _columns = states._columns || [];
	      states.fixedColumns = _columns.filter(function (column) {
	        return column.fixed === true || column.fixed === 'left';
	      });
	      states.rightFixedColumns = _columns.filter(function (column) {
	        return column.fixed === 'right';
	      });
	
	      if (states.fixedColumns.length > 0 && _columns[0] && _columns[0].type === 'selection' && !_columns[0].fixed) {
	        _columns[0].fixed = true;
	        states.fixedColumns.unshift(_columns[0]);
	      }
	
	      var notFixedColumns = _columns.filter(function (column) {
	        return !column.fixed;
	      });
	      states.originColumns = [].concat(states.fixedColumns).concat(notFixedColumns).concat(states.rightFixedColumns);
	
	      var leafColumns = doFlattenColumns(notFixedColumns);
	      var fixedLeafColumns = doFlattenColumns(states.fixedColumns);
	      var rightFixedLeafColumns = doFlattenColumns(states.rightFixedColumns);
	
	      states.leafColumnsLength = leafColumns.length;
	      states.fixedLeafColumnsLength = fixedLeafColumns.length;
	      states.rightFixedLeafColumnsLength = rightFixedLeafColumns.length;
	
	      states.columns = [].concat(fixedLeafColumns).concat(leafColumns).concat(rightFixedLeafColumns);
	      states.isComplex = states.fixedColumns.length > 0 || states.rightFixedColumns.length > 0;
	    },
	
	
	    // 更新 DOM
	    scheduleLayout: function scheduleLayout(needUpdateColumns) {
	      if (needUpdateColumns) {
	        this.updateColumns();
	      }
	      this.table.debouncedUpdateLayout();
	    },
	
	
	    // 选择
	    isSelected: function isSelected(row) {
	      var _states$selection = this.states.selection,
	          selection = _states$selection === undefined ? [] : _states$selection;
	
	      return selection.indexOf(row) > -1;
	    },
	    clearSelection: function clearSelection() {
	      var states = this.states;
	      states.isAllSelected = false;
	      var oldSelection = states.selection;
	      if (oldSelection.length) {
	        states.selection = [];
	        this.table.$emit('selection-change', []);
	      }
	    },
	    cleanSelection: function cleanSelection() {
	      var states = this.states;
	      var data = states.data,
	          rowKey = states.rowKey,
	          selection = states.selection;
	
	      var deleted = void 0;
	      if (rowKey) {
	        deleted = [];
	        var selectedMap = getKeysMap(selection, rowKey);
	        var dataMap = getKeysMap(data, rowKey);
	        for (var key in selectedMap) {
	          if (selectedMap.hasOwnProperty(key) && !dataMap[key]) {
	            deleted.push(selectedMap[key].row);
	          }
	        }
	      } else {
	        deleted = selection.filter(function (item) {
	          return data.indexOf(item) === -1;
	        });
	      }
	      if (deleted.length) {
	        var newSelection = selection.filter(function (item) {
	          return deleted.indexOf(item) === -1;
	        });
	        states.selection = newSelection;
	        this.table.$emit('selection-change', newSelection.slice());
	      }
	    },
	    toggleRowSelection: function toggleRowSelection(row, selected) {
	      var emitChange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	      var changed = toggleRowStatus(this.states.selection, row, selected);
	      if (changed) {
	        var newSelection = (this.states.selection || []).slice();
	        // 调用 API 修改选中值，不触发 select 事件
	        if (emitChange) {
	          this.table.$emit('select', newSelection, row);
	        }
	        this.table.$emit('selection-change', newSelection);
	      }
	    },
	    _toggleAllSelection: function _toggleAllSelection() {
	      var states = this.states;
	      var _states$data = states.data,
	          data = _states$data === undefined ? [] : _states$data,
	          selection = states.selection;
	      // when only some rows are selected (but not all), select or deselect all of them
	      // depending on the value of selectOnIndeterminate
	
	      var value = states.selectOnIndeterminate ? !states.isAllSelected : !(states.isAllSelected || selection.length);
	      states.isAllSelected = value;
	
	      var selectionChanged = false;
	      data.forEach(function (row, index) {
	        if (states.selectable) {
	          if (states.selectable.call(null, row, index) && toggleRowStatus(selection, row, value)) {
	            selectionChanged = true;
	          }
	        } else {
	          if (toggleRowStatus(selection, row, value)) {
	            selectionChanged = true;
	          }
	        }
	      });
	
	      if (selectionChanged) {
	        this.table.$emit('selection-change', selection ? selection.slice() : []);
	      }
	      this.table.$emit('select-all', selection);
	    },
	    updateSelectionByRowKey: function updateSelectionByRowKey() {
	      var states = this.states;
	      var selection = states.selection,
	          rowKey = states.rowKey,
	          data = states.data;
	
	      var selectedMap = getKeysMap(selection, rowKey);
	      data.forEach(function (row) {
	        var rowId = getRowIdentity(row, rowKey);
	        var rowInfo = selectedMap[rowId];
	        if (rowInfo) {
	          selection[rowInfo.index] = row;
	        }
	      });
	    },
	    updateAllSelected: function updateAllSelected() {
	      var states = this.states;
	      var selection = states.selection,
	          rowKey = states.rowKey,
	          selectable = states.selectable;
	      // data 为 null 时，解构时的默认值会被忽略
	
	      var data = states.data || [];
	      if (data.length === 0) {
	        states.isAllSelected = false;
	        return;
	      }
	
	      var selectedMap = void 0;
	      if (rowKey) {
	        selectedMap = getKeysMap(selection, rowKey);
	      }
	      var isSelected = function isSelected(row) {
	        if (selectedMap) {
	          return !!selectedMap[getRowIdentity(row, rowKey)];
	        } else {
	          return selection.indexOf(row) !== -1;
	        }
	      };
	      var isAllSelected = true;
	      var selectedCount = 0;
	      for (var i = 0, j = data.length; i < j; i++) {
	        var item = data[i];
	        var isRowSelectable = selectable && selectable.call(null, item, i);
	        if (!isSelected(item)) {
	          if (!selectable || isRowSelectable) {
	            isAllSelected = false;
	            break;
	          }
	        } else {
	          selectedCount++;
	        }
	      }
	
	      if (selectedCount === 0) isAllSelected = false;
	      states.isAllSelected = isAllSelected;
	    },
	
	
	    // 过滤与排序
	    updateFilters: function updateFilters(columns, values) {
	      if (!Array.isArray(columns)) {
	        columns = [columns];
	      }
	      var states = this.states;
	      var filters = {};
	      columns.forEach(function (col) {
	        states.filters[col.id] = values;
	        filters[col.columnKey || col.id] = values;
	      });
	
	      return filters;
	    },
	    updateSort: function updateSort(column, prop, order) {
	      if (this.states.sortingColumn && this.states.sortingColumn !== column) {
	        this.states.sortingColumn.order = null;
	      }
	      this.states.sortingColumn = column;
	      this.states.sortProp = prop;
	      this.states.sortOrder = order;
	    },
	    execFilter: function execFilter() {
	      var _this = this;
	
	      var states = this.states;
	      var _data = states._data,
	          filters = states.filters;
	
	      var data = _data;
	
	      Object.keys(filters).forEach(function (columnId) {
	        var values = states.filters[columnId];
	        if (!values || values.length === 0) return;
	        var column = getColumnById(_this.states, columnId);
	        if (column && column.filterMethod) {
	          data = data.filter(function (row) {
	            return values.some(function (value) {
	              return column.filterMethod.call(null, value, row, column);
	            });
	          });
	        }
	      });
	
	      states.filteredData = data;
	    },
	    execSort: function execSort() {
	      var states = this.states;
	      states.data = watcher_sortData(states.filteredData, states);
	    },
	
	
	    // 根据 filters 与 sort 去过滤 data
	    execQuery: function execQuery(ignore) {
	      if (!(ignore && ignore.filter)) {
	        this.execFilter();
	      }
	      this.execSort();
	    },
	    clearFilter: function clearFilter(columnKeys) {
	      var states = this.states;
	      var _table$$refs = this.table.$refs,
	          tableHeader = _table$$refs.tableHeader,
	          fixedTableHeader = _table$$refs.fixedTableHeader,
	          rightFixedTableHeader = _table$$refs.rightFixedTableHeader;
	
	
	      var panels = {};
	      if (tableHeader) panels = merge_default()(panels, tableHeader.filterPanels);
	      if (fixedTableHeader) panels = merge_default()(panels, fixedTableHeader.filterPanels);
	      if (rightFixedTableHeader) panels = merge_default()(panels, rightFixedTableHeader.filterPanels);
	
	      var keys = Object.keys(panels);
	      if (!keys.length) return;
	
	      if (typeof columnKeys === 'string') {
	        columnKeys = [columnKeys];
	      }
	
	      if (Array.isArray(columnKeys)) {
	        var columns = columnKeys.map(function (key) {
	          return getColumnByKey(states, key);
	        });
	        keys.forEach(function (key) {
	          var column = columns.find(function (col) {
	            return col.id === key;
	          });
	          if (column) {
	            // TODO: 优化这里的代码
	            panels[key].filteredValue = [];
	          }
	        });
	        this.commit('filterChange', {
	          column: columns,
	          values: [],
	          silent: true,
	          multi: true
	        });
	      } else {
	        keys.forEach(function (key) {
	          // TODO: 优化这里的代码
	          panels[key].filteredValue = [];
	        });
	
	        states.filters = {};
	        this.commit('filterChange', {
	          column: {},
	          values: [],
	          silent: true
	        });
	      }
	    },
	    clearSort: function clearSort() {
	      var states = this.states;
	      if (!states.sortingColumn) return;
	
	      this.updateSort(null, null, null);
	      this.commit('changeSortCondition', {
	        silent: true
	      });
	    },
	
	
	    // 适配层，expand-row-keys 在 Expand 与 TreeTable 中都有使用
	    setExpandRowKeysAdapter: function setExpandRowKeysAdapter(val) {
	      // 这里会触发额外的计算，但为了兼容性，暂时这么做
	      this.setExpandRowKeys(val);
	      this.updateTreeExpandKeys(val);
	    },
	
	
	    // 展开行与 TreeTable 都要使用
	    toggleRowExpansionAdapter: function toggleRowExpansionAdapter(row, expanded) {
	      var hasExpandColumn = this.states.columns.some(function (_ref) {
	        var type = _ref.type;
	        return type === 'expand';
	      });
	      if (hasExpandColumn) {
	        this.toggleRowExpansion(row, expanded);
	      } else {
	        this.toggleTreeExpansion(row, expanded);
	      }
	    }
	  }
	}));
	// CONCATENATED MODULE: ./packages/table/src/store/index.js
	
	
	
	
	watcher.prototype.mutations = {
	  setData: function setData(states, data) {
	    var dataInstanceChanged = states._data !== data;
	    states._data = data;
	
	    this.execQuery();
	    // 数据变化，更新部分数据。
	    // 没有使用 computed，而是手动更新部分数据 https://github.com/vuejs/vue/issues/6660#issuecomment-331417140
	    this.updateCurrentRowData();
	    this.updateExpandRows();
	    if (states.reserveSelection) {
	      this.assertRowKey();
	      this.updateSelectionByRowKey();
	    } else {
	      if (dataInstanceChanged) {
	        this.clearSelection();
	      } else {
	        this.cleanSelection();
	      }
	    }
	    this.updateAllSelected();
	
	    this.updateTableScrollY();
	  },
	  insertColumn: function insertColumn(states, column, index, parent) {
	    var array = states._columns;
	    if (parent) {
	      array = parent.children;
	      if (!array) array = parent.children = [];
	    }
	
	    if (typeof index !== 'undefined') {
	      array.splice(index, 0, column);
	    } else {
	      array.push(column);
	    }
	
	    if (column.type === 'selection') {
	      states.selectable = column.selectable;
	      states.reserveSelection = column.reserveSelection;
	    }
	
	    if (this.table.$ready) {
	      this.updateColumns(); // hack for dynamics insert column
	      this.scheduleLayout();
	    }
	  },
	  removeColumn: function removeColumn(states, column, parent) {
	    var array = states._columns;
	    if (parent) {
	      array = parent.children;
	      if (!array) array = parent.children = [];
	    }
	    if (array) {
	      array.splice(array.indexOf(column), 1);
	    }
	
	    if (this.table.$ready) {
	      this.updateColumns(); // hack for dynamics remove column
	      this.scheduleLayout();
	    }
	  },
	  sort: function sort(states, options) {
	    var prop = options.prop,
	        order = options.order,
	        init = options.init;
	
	    if (prop) {
	      var column = Object(util_["arrayFind"])(states.columns, function (column) {
	        return column.property === prop;
	      });
	      if (column) {
	        column.order = order;
	        this.updateSort(column, prop, order);
	        this.commit('changeSortCondition', { init: init });
	      }
	    }
	  },
	  changeSortCondition: function changeSortCondition(states, options) {
	    // 修复 pr https://github.com/ElemeFE/element/pull/15012 导致的 bug
	    var column = states.sortingColumn,
	        prop = states.sortProp,
	        order = states.sortOrder;
	
	    if (order === null) {
	      states.sortingColumn = null;
	      states.sortProp = null;
	    }
	    var ingore = { filter: true };
	    this.execQuery(ingore);
	
	    if (!options || !(options.silent || options.init)) {
	      this.table.$emit('sort-change', {
	        column: column,
	        prop: prop,
	        order: order
	      });
	    }
	
	    this.updateTableScrollY();
	  },
	  filterChange: function filterChange(states, options) {
	    var column = options.column,
	        values = options.values,
	        silent = options.silent;
	
	    var newFilters = this.updateFilters(column, values);
	
	    this.execQuery();
	
	    if (!silent) {
	      this.table.$emit('filter-change', newFilters);
	    }
	
	    this.updateTableScrollY();
	  },
	  toggleAllSelection: function toggleAllSelection() {
	    this.toggleAllSelection();
	  },
	  rowSelectedChanged: function rowSelectedChanged(states, row) {
	    this.toggleRowSelection(row);
	    this.updateAllSelected();
	  },
	  setHoverRow: function setHoverRow(states, row) {
	    states.hoverRow = row;
	  },
	  setCurrentRow: function setCurrentRow(states, row) {
	    this.updateCurrentRow(row);
	  }
	};
	
	watcher.prototype.commit = function (name) {
	  var mutations = this.mutations;
	  if (mutations[name]) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    mutations[name].apply(this, [this.states].concat(args));
	  } else {
	    throw new Error('Action not found: ' + name);
	  }
	};
	
	watcher.prototype.updateTableScrollY = function () {
	  external_vue_default.a.nextTick(this.table.updateScrollY);
	};
	
	/* harmony default export */ var src_store = (watcher);
	// CONCATENATED MODULE: ./packages/table/src/store/helper.js
	
	
	
	function createStore(table) {
	  var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (!table) {
	    throw new Error('Table is required.');
	  }
	
	  var store = new src_store();
	  store.table = table;
	  // fix https://github.com/ElemeFE/element/issues/14075
	  // related pr https://github.com/ElemeFE/element/pull/14146
	  store.toggleAllSelection = debounce_default()(10, store._toggleAllSelection);
	  Object.keys(initialState).forEach(function (key) {
	    store.states[key] = initialState[key];
	  });
	  return store;
	}
	
	function mapStates(mapper) {
	  var res = {};
	  Object.keys(mapper).forEach(function (key) {
	    var value = mapper[key];
	    var fn = void 0;
	    if (typeof value === 'string') {
	      fn = function fn() {
	        return this.store.states[value];
	      };
	    } else if (typeof value === 'function') {
	      fn = function fn() {
	        return value.call(this, this.store.states);
	      };
	    } else {
	      console.error('invalid value type');
	    }
	    if (fn) {
	      res[key] = fn;
	    }
	  });
	  return res;
	};
	// EXTERNAL MODULE: external "element-ui/lib/utils/scrollbar-width"
	var scrollbar_width_ = __webpack_require__(30);
	var scrollbar_width_default = /*#__PURE__*/__webpack_require__.n(scrollbar_width_);
	
	// CONCATENATED MODULE: ./packages/table/src/table-layout.js
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	
	
	
	
	var table_layout_TableLayout = function () {
	  function TableLayout(options) {
	    _classCallCheck(this, TableLayout);
	
	    this.observers = [];
	    this.table = null;
	    this.store = null;
	    this.columns = null;
	    this.fit = true;
	    this.showHeader = true;
	
	    this.height = null;
	    this.scrollX = false;
	    this.scrollY = false;
	    this.bodyWidth = null;
	    this.fixedWidth = null;
	    this.rightFixedWidth = null;
	    this.tableHeight = null;
	    this.headerHeight = 44; // Table Header Height
	    this.appendHeight = 0; // Append Slot Height
	    this.footerHeight = 44; // Table Footer Height
	    this.viewportHeight = null; // Table Height - Scroll Bar Height
	    this.bodyHeight = null; // Table Height - Table Header Height
	    this.fixedBodyHeight = null; // Table Height - Table Header Height - Scroll Bar Height
	    this.gutterWidth = scrollbar_width_default()();
	
	    for (var name in options) {
	      if (options.hasOwnProperty(name)) {
	        this[name] = options[name];
	      }
	    }
	
	    if (!this.table) {
	      throw new Error('table is required for Table Layout');
	    }
	    if (!this.store) {
	      throw new Error('store is required for Table Layout');
	    }
	  }
	
	  TableLayout.prototype.updateScrollY = function updateScrollY() {
	    var height = this.height;
	    if (height === null) return false;
	    var bodyWrapper = this.table.bodyWrapper;
	    if (this.table.$el && bodyWrapper) {
	      var body = bodyWrapper.querySelector('.el-table__body');
	      var prevScrollY = this.scrollY;
	      var scrollY = body.offsetHeight > this.bodyHeight;
	      this.scrollY = scrollY;
	      return prevScrollY !== scrollY;
	    }
	    return false;
	  };
	
	  TableLayout.prototype.setHeight = function setHeight(value) {
	    var _this = this;
	
	    var prop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'height';
	
	    if (external_vue_default.a.prototype.$isServer) return;
	    var el = this.table.$el;
	    value = parseHeight(value);
	    this.height = value;
	
	    if (!el && (value || value === 0)) return external_vue_default.a.nextTick(function () {
	      return _this.setHeight(value, prop);
	    });
	
	    if (typeof value === 'number') {
	      el.style[prop] = value + 'px';
	      this.updateElsHeight();
	    } else if (typeof value === 'string') {
	      el.style[prop] = value;
	      this.updateElsHeight();
	    }
	  };
	
	  TableLayout.prototype.setMaxHeight = function setMaxHeight(value) {
	    this.setHeight(value, 'max-height');
	  };
	
	  TableLayout.prototype.getFlattenColumns = function getFlattenColumns() {
	    var flattenColumns = [];
	    var columns = this.table.columns;
	    columns.forEach(function (column) {
	      if (column.isColumnGroup) {
	        flattenColumns.push.apply(flattenColumns, column.columns);
	      } else {
	        flattenColumns.push(column);
	      }
	    });
	
	    return flattenColumns;
	  };
	
	  TableLayout.prototype.updateElsHeight = function updateElsHeight() {
	    var _this2 = this;
	
	    if (!this.table.$ready) return external_vue_default.a.nextTick(function () {
	      return _this2.updateElsHeight();
	    });
	    var _table$$refs = this.table.$refs,
	        headerWrapper = _table$$refs.headerWrapper,
	        appendWrapper = _table$$refs.appendWrapper,
	        footerWrapper = _table$$refs.footerWrapper;
	
	    this.appendHeight = appendWrapper ? appendWrapper.offsetHeight : 0;
	
	    if (this.showHeader && !headerWrapper) return;
	
	    // fix issue (https://github.com/ElemeFE/element/pull/16956)
	    var headerTrElm = headerWrapper ? headerWrapper.querySelector('.el-table__header tr') : null;
	    var noneHeader = this.headerDisplayNone(headerTrElm);
	
	    var headerHeight = this.headerHeight = !this.showHeader ? 0 : headerWrapper.offsetHeight;
	    if (this.showHeader && !noneHeader && headerWrapper.offsetWidth > 0 && (this.table.columns || []).length > 0 && headerHeight < 2) {
	      return external_vue_default.a.nextTick(function () {
	        return _this2.updateElsHeight();
	      });
	    }
	    var tableHeight = this.tableHeight = this.table.$el.clientHeight;
	    var footerHeight = this.footerHeight = footerWrapper ? footerWrapper.offsetHeight : 0;
	    if (this.height !== null) {
	      this.bodyHeight = tableHeight - headerHeight - footerHeight + (footerWrapper ? 1 : 0);
	    }
	    this.fixedBodyHeight = this.scrollX ? this.bodyHeight - this.gutterWidth : this.bodyHeight;
	
	    var noData = !(this.store.states.data && this.store.states.data.length);
	    this.viewportHeight = this.scrollX ? tableHeight - (noData ? 0 : this.gutterWidth) : tableHeight;
	
	    this.updateScrollY();
	    this.notifyObservers('scrollable');
	  };
	
	  TableLayout.prototype.headerDisplayNone = function headerDisplayNone(elm) {
	    if (!elm) return true;
	    var headerChild = elm;
	    while (headerChild.tagName !== 'DIV') {
	      if (getComputedStyle(headerChild).display === 'none') {
	        return true;
	      }
	      headerChild = headerChild.parentElement;
	    }
	    return false;
	  };
	
	  TableLayout.prototype.updateColumnsWidth = function updateColumnsWidth() {
	    if (external_vue_default.a.prototype.$isServer) return;
	    var fit = this.fit;
	    var bodyWidth = this.table.$el.clientWidth;
	    var bodyMinWidth = 0;
	
	    var flattenColumns = this.getFlattenColumns();
	    var flexColumns = flattenColumns.filter(function (column) {
	      return typeof column.width !== 'number';
	    });
	
	    flattenColumns.forEach(function (column) {
	      // Clean those columns whose width changed from flex to unflex
	      if (typeof column.width === 'number' && column.realWidth) column.realWidth = null;
	    });
	
	    if (flexColumns.length > 0 && fit) {
	      flattenColumns.forEach(function (column) {
	        bodyMinWidth += column.width || column.minWidth || 80;
	      });
	
	      var scrollYWidth = this.scrollY ? this.gutterWidth : 0;
	
	      if (bodyMinWidth <= bodyWidth - scrollYWidth) {
	        // DON'T HAVE SCROLL BAR
	        this.scrollX = false;
	
	        var totalFlexWidth = bodyWidth - scrollYWidth - bodyMinWidth;
	
	        if (flexColumns.length === 1) {
	          flexColumns[0].realWidth = (flexColumns[0].minWidth || 80) + totalFlexWidth;
	        } else {
	          var allColumnsWidth = flexColumns.reduce(function (prev, column) {
	            return prev + (column.minWidth || 80);
	          }, 0);
	          var flexWidthPerPixel = totalFlexWidth / allColumnsWidth;
	          var noneFirstWidth = 0;
	
	          flexColumns.forEach(function (column, index) {
	            if (index === 0) return;
	            var flexWidth = Math.floor((column.minWidth || 80) * flexWidthPerPixel);
	            noneFirstWidth += flexWidth;
	            column.realWidth = (column.minWidth || 80) + flexWidth;
	          });
	
	          flexColumns[0].realWidth = (flexColumns[0].minWidth || 80) + totalFlexWidth - noneFirstWidth;
	        }
	      } else {
	        // HAVE HORIZONTAL SCROLL BAR
	        this.scrollX = true;
	        flexColumns.forEach(function (column) {
	          column.realWidth = column.minWidth;
	        });
	      }
	
	      this.bodyWidth = Math.max(bodyMinWidth, bodyWidth);
	      this.table.resizeState.width = this.bodyWidth;
	    } else {
	      flattenColumns.forEach(function (column) {
	        if (!column.width && !column.minWidth) {
	          column.realWidth = 80;
	        } else {
	          column.realWidth = column.width || column.minWidth;
	        }
	
	        bodyMinWidth += column.realWidth;
	      });
	      this.scrollX = bodyMinWidth > bodyWidth;
	
	      this.bodyWidth = bodyMinWidth;
	    }
	
	    var fixedColumns = this.store.states.fixedColumns;
	
	    if (fixedColumns.length > 0) {
	      var fixedWidth = 0;
	      fixedColumns.forEach(function (column) {
	        fixedWidth += column.realWidth || column.width;
	      });
	
	      this.fixedWidth = fixedWidth;
	    }
	
	    var rightFixedColumns = this.store.states.rightFixedColumns;
	    if (rightFixedColumns.length > 0) {
	      var rightFixedWidth = 0;
	      rightFixedColumns.forEach(function (column) {
	        rightFixedWidth += column.realWidth || column.width;
	      });
	
	      this.rightFixedWidth = rightFixedWidth;
	    }
	
	    this.notifyObservers('columns');
	  };
	
	  TableLayout.prototype.addObserver = function addObserver(observer) {
	    this.observers.push(observer);
	  };
	
	  TableLayout.prototype.removeObserver = function removeObserver(observer) {
	    var index = this.observers.indexOf(observer);
	    if (index !== -1) {
	      this.observers.splice(index, 1);
	    }
	  };
	
	  TableLayout.prototype.notifyObservers = function notifyObservers(event) {
	    var _this3 = this;
	
	    var observers = this.observers;
	    observers.forEach(function (observer) {
	      switch (event) {
	        case 'columns':
	          observer.onColumnsChange(_this3);
	          break;
	        case 'scrollable':
	          observer.onScrollableChange(_this3);
	          break;
	        default:
	          throw new Error('Table Layout don\'t have event ' + event + '.');
	      }
	    });
	  };
	
	  return TableLayout;
	}();
	
	/* harmony default export */ var table_layout = (table_layout_TableLayout);
	// CONCATENATED MODULE: ./packages/table/src/layout-observer.js
	/* harmony default export */ var layout_observer = ({
	  created: function created() {
	    this.tableLayout.addObserver(this);
	  },
	  destroyed: function destroyed() {
	    this.tableLayout.removeObserver(this);
	  },
	
	
	  computed: {
	    tableLayout: function tableLayout() {
	      var layout = this.layout;
	      if (!layout && this.table) {
	        layout = this.table.layout;
	      }
	      if (!layout) {
	        throw new Error('Can not find table layout.');
	      }
	      return layout;
	    }
	  },
	
	  mounted: function mounted() {
	    this.onColumnsChange(this.tableLayout);
	    this.onScrollableChange(this.tableLayout);
	  },
	  updated: function updated() {
	    if (this.__updated__) return;
	    this.onColumnsChange(this.tableLayout);
	    this.onScrollableChange(this.tableLayout);
	    this.__updated__ = true;
	  },
	
	
	  methods: {
	    onColumnsChange: function onColumnsChange(layout) {
	      var cols = this.$el.querySelectorAll('colgroup > col');
	      if (!cols.length) return;
	      var flattenColumns = layout.getFlattenColumns();
	      var columnsMap = {};
	      flattenColumns.forEach(function (column) {
	        columnsMap[column.id] = column;
	      });
	      for (var i = 0, j = cols.length; i < j; i++) {
	        var col = cols[i];
	        var name = col.getAttribute('name');
	        var column = columnsMap[name];
	        if (column) {
	          col.setAttribute('width', column.realWidth || column.width);
	        }
	      }
	    },
	    onScrollableChange: function onScrollableChange(layout) {
	      var cols = this.$el.querySelectorAll('colgroup > col[name=gutter]');
	      for (var i = 0, j = cols.length; i < j; i++) {
	        var col = cols[i];
	        col.setAttribute('width', layout.scrollY ? layout.gutterWidth : '0');
	      }
	      var ths = this.$el.querySelectorAll('th.gutter');
	      for (var _i = 0, _j = ths.length; _i < _j; _i++) {
	        var th = ths[_i];
	        th.style.width = layout.scrollY ? layout.gutterWidth + 'px' : '0';
	        th.style.display = layout.scrollY ? '' : 'none';
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/table/src/table-body.js
	var table_body_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var table_body_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	
	
	
	
	
	
	
	
	
	/* harmony default export */ var table_body = ({
	  name: 'ElTableBody',
	
	  mixins: [layout_observer],
	
	  components: {
	    ElCheckbox: checkbox_default.a,
	    ElTooltip: tooltip_default.a
	  },
	
	  props: {
	    store: {
	      required: true
	    },
	    stripe: Boolean,
	    context: {},
	    rowClassName: [String, Function],
	    rowStyle: [Object, Function],
	    fixed: String,
	    highlight: Boolean
	  },
	
	  render: function render(h) {
	    var _this = this;
	
	    var data = this.data || [];
	    return h(
	      'table',
	      {
	        'class': 'el-table__body',
	        attrs: { cellspacing: '0',
	          cellpadding: '0',
	          border: '0' }
	      },
	      [h('colgroup', [this.columns.map(function (column) {
	        return h('col', {
	          attrs: { name: column.id },
	          key: column.id });
	      })]), h('tbody', [data.reduce(function (acc, row) {
	        return acc.concat(_this.wrappedRowRender(row, acc.length));
	      }, []), h('el-tooltip', {
	        attrs: { effect: this.table.tooltipEffect, placement: 'top', content: this.tooltipContent },
	        ref: 'tooltip' })])]
	    );
	  },
	
	
	  computed: table_body_extends({
	    table: function table() {
	      return this.$parent;
	    }
	  }, mapStates({
	    data: 'data',
	    columns: 'columns',
	    treeIndent: 'indent',
	    leftFixedLeafCount: 'fixedLeafColumnsLength',
	    rightFixedLeafCount: 'rightFixedLeafColumnsLength',
	    columnsCount: function columnsCount(states) {
	      return states.columns.length;
	    },
	    leftFixedCount: function leftFixedCount(states) {
	      return states.fixedColumns.length;
	    },
	    rightFixedCount: function rightFixedCount(states) {
	      return states.rightFixedColumns.length;
	    },
	    hasExpandColumn: function hasExpandColumn(states) {
	      return states.columns.some(function (_ref) {
	        var type = _ref.type;
	        return type === 'expand';
	      });
	    }
	  }), {
	    firstDefaultColumnIndex: function firstDefaultColumnIndex() {
	      return Object(util_["arrayFindIndex"])(this.columns, function (_ref2) {
	        var type = _ref2.type;
	        return type === 'default';
	      });
	    }
	  }),
	
	  watch: {
	    // don't trigger getter of currentRow in getCellClass. see https://jsfiddle.net/oe2b4hqt/
	    // update DOM manually. see https://github.com/ElemeFE/element/pull/13954/files#diff-9b450c00d0a9dec0ffad5a3176972e40
	    'store.states.hoverRow': function storeStatesHoverRow(newVal, oldVal) {
	      var _this2 = this;
	
	      if (!this.store.states.isComplex || this.$isServer) return;
	      var raf = window.requestAnimationFrame;
	      if (!raf) {
	        raf = function raf(fn) {
	          return setTimeout(fn, 16);
	        };
	      }
	      raf(function () {
	        var rows = _this2.$el.querySelectorAll('.el-table__row');
	        var oldRow = rows[oldVal];
	        var newRow = rows[newVal];
	        if (oldRow) {
	          Object(dom_["removeClass"])(oldRow, 'hover-row');
	        }
	        if (newRow) {
	          Object(dom_["addClass"])(newRow, 'hover-row');
	        }
	      });
	    }
	  },
	
	  data: function data() {
	    return {
	      tooltipContent: ''
	    };
	  },
	  created: function created() {
	    this.activateTooltip = debounce_default()(50, function (tooltip) {
	      return tooltip.handleShowPopper();
	    });
	  },
	
	
	  methods: {
	    getKeyOfRow: function getKeyOfRow(row, index) {
	      var rowKey = this.table.rowKey;
	      if (rowKey) {
	        return getRowIdentity(row, rowKey);
	      }
	      return index;
	    },
	    isColumnHidden: function isColumnHidden(index) {
	      if (this.fixed === true || this.fixed === 'left') {
	        return index >= this.leftFixedLeafCount;
	      } else if (this.fixed === 'right') {
	        return index < this.columnsCount - this.rightFixedLeafCount;
	      } else {
	        return index < this.leftFixedLeafCount || index >= this.columnsCount - this.rightFixedLeafCount;
	      }
	    },
	    getSpan: function getSpan(row, column, rowIndex, columnIndex) {
	      var rowspan = 1;
	      var colspan = 1;
	      var fn = this.table.spanMethod;
	      if (typeof fn === 'function') {
	        var result = fn({
	          row: row,
	          column: column,
	          rowIndex: rowIndex,
	          columnIndex: columnIndex
	        });
	        if (Array.isArray(result)) {
	          rowspan = result[0];
	          colspan = result[1];
	        } else if ((typeof result === 'undefined' ? 'undefined' : table_body_typeof(result)) === 'object') {
	          rowspan = result.rowspan;
	          colspan = result.colspan;
	        }
	      }
	      return { rowspan: rowspan, colspan: colspan };
	    },
	    getRowStyle: function getRowStyle(row, rowIndex) {
	      var rowStyle = this.table.rowStyle;
	      if (typeof rowStyle === 'function') {
	        return rowStyle.call(null, {
	          row: row,
	          rowIndex: rowIndex
	        });
	      }
	      return rowStyle || null;
	    },
	    getRowClass: function getRowClass(row, rowIndex) {
	      var classes = ['el-table__row'];
	      if (this.table.highlightCurrentRow && row === this.store.states.currentRow) {
	        classes.push('current-row');
	      }
	
	      if (this.stripe && rowIndex % 2 === 1) {
	        classes.push('el-table__row--striped');
	      }
	      var rowClassName = this.table.rowClassName;
	      if (typeof rowClassName === 'string') {
	        classes.push(rowClassName);
	      } else if (typeof rowClassName === 'function') {
	        classes.push(rowClassName.call(null, {
	          row: row,
	          rowIndex: rowIndex
	        }));
	      }
	
	      if (this.store.states.expandRows.indexOf(row) > -1) {
	        classes.push('expanded');
	      }
	
	      return classes;
	    },
	    getCellStyle: function getCellStyle(rowIndex, columnIndex, row, column) {
	      var cellStyle = this.table.cellStyle;
	      if (typeof cellStyle === 'function') {
	        return cellStyle.call(null, {
	          rowIndex: rowIndex,
	          columnIndex: columnIndex,
	          row: row,
	          column: column
	        });
	      }
	      return cellStyle;
	    },
	    getCellClass: function getCellClass(rowIndex, columnIndex, row, column) {
	      var classes = [column.id, column.align, column.className];
	
	      if (this.isColumnHidden(columnIndex)) {
	        classes.push('is-hidden');
	      }
	
	      var cellClassName = this.table.cellClassName;
	      if (typeof cellClassName === 'string') {
	        classes.push(cellClassName);
	      } else if (typeof cellClassName === 'function') {
	        classes.push(cellClassName.call(null, {
	          rowIndex: rowIndex,
	          columnIndex: columnIndex,
	          row: row,
	          column: column
	        }));
	      }
	
	      return classes.join(' ');
	    },
	    getColspanRealWidth: function getColspanRealWidth(columns, colspan, index) {
	      if (colspan < 1) {
	        return columns[index].realWidth;
	      }
	      var widthArr = columns.map(function (_ref3) {
	        var realWidth = _ref3.realWidth;
	        return realWidth;
	      }).slice(index, index + colspan);
	      return widthArr.reduce(function (acc, width) {
	        return acc + width;
	      }, -1);
	    },
	    handleCellMouseEnter: function handleCellMouseEnter(event, row) {
	      var table = this.table;
	      var cell = getCell(event);
	
	      if (cell) {
	        var column = getColumnByCell(table, cell);
	        var hoverState = table.hoverState = { cell: cell, column: column, row: row };
	        table.$emit('cell-mouse-enter', hoverState.row, hoverState.column, hoverState.cell, event);
	      }
	
	      // 判断是否text-overflow, 如果是就显示tooltip
	      var cellChild = event.target.querySelector('.cell');
	      if (!(Object(dom_["hasClass"])(cellChild, 'el-tooltip') && cellChild.childNodes.length)) {
	        return;
	      }
	      // use range width instead of scrollWidth to determine whether the text is overflowing
	      // to address a potential FireFox bug: https://bugzilla.mozilla.org/show_bug.cgi?id=1074543#c3
	      var range = document.createRange();
	      range.setStart(cellChild, 0);
	      range.setEnd(cellChild, cellChild.childNodes.length);
	      var rangeWidth = range.getBoundingClientRect().width;
	      var padding = (parseInt(Object(dom_["getStyle"])(cellChild, 'paddingLeft'), 10) || 0) + (parseInt(Object(dom_["getStyle"])(cellChild, 'paddingRight'), 10) || 0);
	      if ((rangeWidth + padding > cellChild.offsetWidth || cellChild.scrollWidth > cellChild.offsetWidth) && this.$refs.tooltip) {
	        var tooltip = this.$refs.tooltip;
	        // TODO 会引起整个 Table 的重新渲染，需要优化
	        this.tooltipContent = cell.innerText || cell.textContent;
	        tooltip.referenceElm = cell;
	        tooltip.$refs.popper && (tooltip.$refs.popper.style.display = 'none');
	        tooltip.doDestroy();
	        tooltip.setExpectedState(true);
	        this.activateTooltip(tooltip);
	      }
	    },
	    handleCellMouseLeave: function handleCellMouseLeave(event) {
	      var tooltip = this.$refs.tooltip;
	      if (tooltip) {
	        tooltip.setExpectedState(false);
	        tooltip.handleClosePopper();
	      }
	      var cell = getCell(event);
	      if (!cell) return;
	
	      var oldHoverState = this.table.hoverState || {};
	      this.table.$emit('cell-mouse-leave', oldHoverState.row, oldHoverState.column, oldHoverState.cell, event);
	    },
	
	
	    handleMouseEnter: debounce_default()(30, function (index) {
	      this.store.commit('setHoverRow', index);
	    }),
	
	    handleMouseLeave: debounce_default()(30, function () {
	      this.store.commit('setHoverRow', null);
	    }),
	
	    handleContextMenu: function handleContextMenu(event, row) {
	      this.handleEvent(event, row, 'contextmenu');
	    },
	    handleDoubleClick: function handleDoubleClick(event, row) {
	      this.handleEvent(event, row, 'dblclick');
	    },
	    handleClick: function handleClick(event, row) {
	      this.store.commit('setCurrentRow', row);
	      this.handleEvent(event, row, 'click');
	    },
	    handleEvent: function handleEvent(event, row, name) {
	      var table = this.table;
	      var cell = getCell(event);
	      var column = void 0;
	      if (cell) {
	        column = getColumnByCell(table, cell);
	        if (column) {
	          table.$emit('cell-' + name, row, column, cell, event);
	        }
	      }
	      table.$emit('row-' + name, row, column, event);
	    },
	    rowRender: function rowRender(row, $index, treeRowData) {
	      var _this3 = this;
	
	      var h = this.$createElement;
	      var treeIndent = this.treeIndent,
	          columns = this.columns,
	          firstDefaultColumnIndex = this.firstDefaultColumnIndex;
	
	      var columnsHidden = columns.map(function (column, index) {
	        return _this3.isColumnHidden(index);
	      });
	      var rowClasses = this.getRowClass(row, $index);
	      var display = true;
	      if (treeRowData) {
	        rowClasses.push('el-table__row--level-' + treeRowData.level);
	        display = treeRowData.display;
	      }
	      // 指令 v-show 会覆盖 row-style 中 display
	      // 使用 :style 代替 v-show https://github.com/ElemeFE/element/issues/16995
	      var displayStyle = display ? null : {
	        display: 'none'
	      };
	      return h(
	        'tr',
	        {
	          style: [displayStyle, this.getRowStyle(row, $index)],
	          'class': rowClasses,
	          key: this.getKeyOfRow(row, $index),
	          on: {
	            'dblclick': function dblclick($event) {
	              return _this3.handleDoubleClick($event, row);
	            },
	            'click': function click($event) {
	              return _this3.handleClick($event, row);
	            },
	            'contextmenu': function contextmenu($event) {
	              return _this3.handleContextMenu($event, row);
	            },
	            'mouseenter': function mouseenter(_) {
	              return _this3.handleMouseEnter($index);
	            },
	            'mouseleave': this.handleMouseLeave
	          }
	        },
	        [columns.map(function (column, cellIndex) {
	          var _getSpan = _this3.getSpan(row, column, $index, cellIndex),
	              rowspan = _getSpan.rowspan,
	              colspan = _getSpan.colspan;
	
	          if (!rowspan || !colspan) {
	            return null;
	          }
	          var columnData = table_body_extends({}, column);
	          columnData.realWidth = _this3.getColspanRealWidth(columns, colspan, cellIndex);
	          var data = {
	            store: _this3.store,
	            _self: _this3.context || _this3.table.$vnode.context,
	            column: columnData,
	            row: row,
	            $index: $index
	          };
	          if (cellIndex === firstDefaultColumnIndex && treeRowData) {
	            data.treeNode = {
	              indent: treeRowData.level * treeIndent,
	              level: treeRowData.level
	            };
	            if (typeof treeRowData.expanded === 'boolean') {
	              data.treeNode.expanded = treeRowData.expanded;
	              // 表明是懒加载
	              if ('loading' in treeRowData) {
	                data.treeNode.loading = treeRowData.loading;
	              }
	              if ('noLazyChildren' in treeRowData) {
	                data.treeNode.noLazyChildren = treeRowData.noLazyChildren;
	              }
	            }
	          }
	          return h(
	            'td',
	            {
	              style: _this3.getCellStyle($index, cellIndex, row, column),
	              'class': _this3.getCellClass($index, cellIndex, row, column),
	              attrs: { rowspan: rowspan,
	                colspan: colspan
	              },
	              on: {
	                'mouseenter': function mouseenter($event) {
	                  return _this3.handleCellMouseEnter($event, row);
	                },
	                'mouseleave': _this3.handleCellMouseLeave
	              }
	            },
	            [column.renderCell.call(_this3._renderProxy, _this3.$createElement, data, columnsHidden[cellIndex])]
	          );
	        })]
	      );
	    },
	    wrappedRowRender: function wrappedRowRender(row, $index) {
	      var _this4 = this;
	
	      var h = this.$createElement;
	
	      var store = this.store;
	      var isRowExpanded = store.isRowExpanded,
	          assertRowKey = store.assertRowKey;
	      var _store$states = store.states,
	          treeData = _store$states.treeData,
	          lazyTreeNodeMap = _store$states.lazyTreeNodeMap,
	          childrenColumnName = _store$states.childrenColumnName,
	          rowKey = _store$states.rowKey;
	
	      if (this.hasExpandColumn && isRowExpanded(row)) {
	        var renderExpanded = this.table.renderExpanded;
	        var tr = this.rowRender(row, $index);
	        if (!renderExpanded) {
	          console.error('[Element Error]renderExpanded is required.');
	          return tr;
	        }
	        // 使用二维数组，避免修改 $index
	        return [[tr, h(
	          'tr',
	          { key: 'expanded-row__' + tr.key },
	          [h(
	            'td',
	            {
	              attrs: { colspan: this.columnsCount },
	              'class': 'el-table__expanded-cell' },
	            [renderExpanded(this.$createElement, { row: row, $index: $index, store: this.store })]
	          )]
	        )]];
	      } else if (Object.keys(treeData).length) {
	        assertRowKey();
	        // TreeTable 时，rowKey 必须由用户设定，不使用 getKeyOfRow 计算
	        // 在调用 rowRender 函数时，仍然会计算 rowKey，不太好的操作
	        var key = getRowIdentity(row, rowKey);
	        var cur = treeData[key];
	        var treeRowData = null;
	        if (cur) {
	          treeRowData = {
	            expanded: cur.expanded,
	            level: cur.level,
	            display: true
	          };
	          if (typeof cur.lazy === 'boolean') {
	            if (typeof cur.loaded === 'boolean' && cur.loaded) {
	              treeRowData.noLazyChildren = !(cur.children && cur.children.length);
	            }
	            treeRowData.loading = cur.loading;
	          }
	        }
	        var tmp = [this.rowRender(row, $index, treeRowData)];
	        // 渲染嵌套数据
	        if (cur) {
	          // currentRow 记录的是 index，所以还需主动增加 TreeTable 的 index
	          var i = 0;
	          var traverse = function traverse(children, parent) {
	            if (!(children && children.length && parent)) return;
	            children.forEach(function (node) {
	              // 父节点的 display 状态影响子节点的显示状态
	              var innerTreeRowData = {
	                display: parent.display && parent.expanded,
	                level: parent.level + 1
	              };
	              var childKey = getRowIdentity(node, rowKey);
	              if (childKey === undefined || childKey === null) {
	                throw new Error('for nested data item, row-key is required.');
	              }
	              cur = table_body_extends({}, treeData[childKey]);
	              // 对于当前节点，分成有无子节点两种情况。
	              // 如果包含子节点的，设置 expanded 属性。
	              // 对于它子节点的 display 属性由它本身的 expanded 与 display 共同决定。
	              if (cur) {
	                innerTreeRowData.expanded = cur.expanded;
	                // 懒加载的某些节点，level 未知
	                cur.level = cur.level || innerTreeRowData.level;
	                cur.display = !!(cur.expanded && innerTreeRowData.display);
	                if (typeof cur.lazy === 'boolean') {
	                  if (typeof cur.loaded === 'boolean' && cur.loaded) {
	                    innerTreeRowData.noLazyChildren = !(cur.children && cur.children.length);
	                  }
	                  innerTreeRowData.loading = cur.loading;
	                }
	              }
	              i++;
	              tmp.push(_this4.rowRender(node, $index + i, innerTreeRowData));
	              if (cur) {
	                var _nodes = lazyTreeNodeMap[childKey] || node[childrenColumnName];
	                traverse(_nodes, cur);
	              }
	            });
	          };
	          // 对于 root 节点，display 一定为 true
	          cur.display = true;
	          var nodes = lazyTreeNodeMap[key] || row[childrenColumnName];
	          traverse(nodes, cur);
	        }
	        return tmp;
	      } else {
	        return this.rowRender(row, $index);
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/table/src/filter-panel.vue?vue&type=template&id=7f2c919f&
	var filter_panelvue_type_template_id_7f2c919f_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("transition", { attrs: { name: "el-zoom-in-top" } }, [
	    _vm.multiple
	      ? _c(
	          "div",
	          {
	            directives: [
	              {
	                name: "clickoutside",
	                rawName: "v-clickoutside",
	                value: _vm.handleOutsideClick,
	                expression: "handleOutsideClick"
	              },
	              {
	                name: "show",
	                rawName: "v-show",
	                value: _vm.showPopper,
	                expression: "showPopper"
	              }
	            ],
	            staticClass: "el-table-filter"
	          },
	          [
	            _c(
	              "div",
	              { staticClass: "el-table-filter__content" },
	              [
	                _c(
	                  "el-scrollbar",
	                  { attrs: { "wrap-class": "el-table-filter__wrap" } },
	                  [
	                    _c(
	                      "el-checkbox-group",
	                      {
	                        staticClass: "el-table-filter__checkbox-group",
	                        model: {
	                          value: _vm.filteredValue,
	                          callback: function($$v) {
	                            _vm.filteredValue = $$v
	                          },
	                          expression: "filteredValue"
	                        }
	                      },
	                      _vm._l(_vm.filters, function(filter) {
	                        return _c(
	                          "el-checkbox",
	                          { key: filter.value, attrs: { label: filter.value } },
	                          [_vm._v(_vm._s(filter.text))]
	                        )
	                      }),
	                      1
	                    )
	                  ],
	                  1
	                )
	              ],
	              1
	            ),
	            _c("div", { staticClass: "el-table-filter__bottom" }, [
	              _c(
	                "button",
	                {
	                  class: { "is-disabled": _vm.filteredValue.length === 0 },
	                  attrs: { disabled: _vm.filteredValue.length === 0 },
	                  on: { click: _vm.handleConfirm }
	                },
	                [_vm._v(_vm._s(_vm.t("el.table.confirmFilter")))]
	              ),
	              _c("button", { on: { click: _vm.handleReset } }, [
	                _vm._v(_vm._s(_vm.t("el.table.resetFilter")))
	              ])
	            ])
	          ]
	        )
	      : _c(
	          "div",
	          {
	            directives: [
	              {
	                name: "clickoutside",
	                rawName: "v-clickoutside",
	                value: _vm.handleOutsideClick,
	                expression: "handleOutsideClick"
	              },
	              {
	                name: "show",
	                rawName: "v-show",
	                value: _vm.showPopper,
	                expression: "showPopper"
	              }
	            ],
	            staticClass: "el-table-filter"
	          },
	          [
	            _c(
	              "ul",
	              { staticClass: "el-table-filter__list" },
	              [
	                _c(
	                  "li",
	                  {
	                    staticClass: "el-table-filter__list-item",
	                    class: {
	                      "is-active":
	                        _vm.filterValue === undefined ||
	                        _vm.filterValue === null
	                    },
	                    on: {
	                      click: function($event) {
	                        _vm.handleSelect(null)
	                      }
	                    }
	                  },
	                  [_vm._v(_vm._s(_vm.t("el.table.clearFilter")))]
	                ),
	                _vm._l(_vm.filters, function(filter) {
	                  return _c(
	                    "li",
	                    {
	                      key: filter.value,
	                      staticClass: "el-table-filter__list-item",
	                      class: { "is-active": _vm.isActive(filter) },
	                      attrs: { label: filter.value },
	                      on: {
	                        click: function($event) {
	                          _vm.handleSelect(filter.value)
	                        }
	                      }
	                    },
	                    [_vm._v(_vm._s(filter.text))]
	                  )
	                })
	              ],
	              2
	            )
	          ]
	        )
	  ])
	}
	var filter_panelvue_type_template_id_7f2c919f_staticRenderFns = []
	filter_panelvue_type_template_id_7f2c919f_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/table/src/filter-panel.vue?vue&type=template&id=7f2c919f&
	
	// CONCATENATED MODULE: ./packages/table/src/dropdown.js
	
	var dropdowns = [];
	
	!external_vue_default.a.prototype.$isServer && document.addEventListener('click', function (event) {
	  dropdowns.forEach(function (dropdown) {
	    var target = event.target;
	    if (!dropdown || !dropdown.$el) return;
	    if (target === dropdown.$el || dropdown.$el.contains(target)) {
	      return;
	    }
	    dropdown.handleOutsideClick && dropdown.handleOutsideClick(event);
	  });
	});
	
	/* harmony default export */ var src_dropdown = ({
	  open: function open(instance) {
	    if (instance) {
	      dropdowns.push(instance);
	    }
	  },
	  close: function close(instance) {
	    var index = dropdowns.indexOf(instance);
	    if (index !== -1) {
	      dropdowns.splice(instance, 1);
	    }
	  }
	});
	// EXTERNAL MODULE: external "element-ui/lib/checkbox-group"
	var checkbox_group_ = __webpack_require__(31);
	var checkbox_group_default = /*#__PURE__*/__webpack_require__.n(checkbox_group_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/table/src/filter-panel.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	
	/* harmony default export */ var filter_panelvue_type_script_lang_js_ = ({
	  name: 'ElTableFilterPanel',
	
	  mixins: [vue_popper_default.a, locale_default.a],
	
	  directives: {
	    Clickoutside: clickoutside_default.a
	  },
	
	  components: {
	    ElCheckbox: checkbox_default.a,
	    ElCheckboxGroup: checkbox_group_default.a,
	    ElScrollbar: scrollbar_default.a
	  },
	
	  props: {
	    placement: {
	      type: String,
	      default: 'bottom-end'
	    }
	  },
	
	  methods: {
	    isActive: function isActive(filter) {
	      return filter.value === this.filterValue;
	    },
	    handleOutsideClick: function handleOutsideClick() {
	      var _this = this;
	
	      setTimeout(function () {
	        _this.showPopper = false;
	      }, 16);
	    },
	    handleConfirm: function handleConfirm() {
	      this.confirmFilter(this.filteredValue);
	      this.handleOutsideClick();
	    },
	    handleReset: function handleReset() {
	      this.filteredValue = [];
	      this.confirmFilter(this.filteredValue);
	      this.handleOutsideClick();
	    },
	    handleSelect: function handleSelect(filterValue) {
	      this.filterValue = filterValue;
	
	      if (typeof filterValue !== 'undefined' && filterValue !== null) {
	        this.confirmFilter(this.filteredValue);
	      } else {
	        this.confirmFilter([]);
	      }
	
	      this.handleOutsideClick();
	    },
	    confirmFilter: function confirmFilter(filteredValue) {
	      this.table.store.commit('filterChange', {
	        column: this.column,
	        values: filteredValue
	      });
	      this.table.store.updateAllSelected();
	    }
	  },
	
	  data: function data() {
	    return {
	      table: null,
	      cell: null,
	      column: null
	    };
	  },
	
	
	  computed: {
	    filters: function filters() {
	      return this.column && this.column.filters;
	    },
	
	
	    filterValue: {
	      get: function get() {
	        return (this.column.filteredValue || [])[0];
	      },
	      set: function set(value) {
	        if (this.filteredValue) {
	          if (typeof value !== 'undefined' && value !== null) {
	            this.filteredValue.splice(0, 1, value);
	          } else {
	            this.filteredValue.splice(0, 1);
	          }
	        }
	      }
	    },
	
	    filteredValue: {
	      get: function get() {
	        if (this.column) {
	          return this.column.filteredValue || [];
	        }
	        return [];
	      },
	      set: function set(value) {
	        if (this.column) {
	          this.column.filteredValue = value;
	        }
	      }
	    },
	
	    multiple: function multiple() {
	      if (this.column) {
	        return this.column.filterMultiple;
	      }
	      return true;
	    }
	  },
	
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.popperElm = this.$el;
	    this.referenceElm = this.cell;
	    this.table.bodyWrapper.addEventListener('scroll', function () {
	      _this2.updatePopper();
	    });
	
	    this.$watch('showPopper', function (value) {
	      if (_this2.column) _this2.column.filterOpened = value;
	      if (value) {
	        src_dropdown.open(_this2);
	      } else {
	        src_dropdown.close(_this2);
	      }
	    });
	  },
	
	  watch: {
	    showPopper: function showPopper(val) {
	      if (val === true && parseInt(this.popperJS._popper.style.zIndex, 10) < popup_["PopupManager"].zIndex) {
	        this.popperJS._popper.style.zIndex = popup_["PopupManager"].nextZIndex();
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/table/src/filter-panel.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_filter_panelvue_type_script_lang_js_ = (filter_panelvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/table/src/filter-panel.vue
	
	
	
	
	
	/* normalize component */
	
	var filter_panel_component = normalizeComponent(
	  src_filter_panelvue_type_script_lang_js_,
	  filter_panelvue_type_template_id_7f2c919f_render,
	  filter_panelvue_type_template_id_7f2c919f_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var filter_panel_api; }
	filter_panel_component.options.__file = "packages/table/src/filter-panel.vue"
	/* harmony default export */ var filter_panel = (filter_panel_component.exports);
	// CONCATENATED MODULE: ./packages/table/src/table-header.js
	var table_header_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	
	
	
	
	
	
	
	var getAllColumns = function getAllColumns(columns) {
	  var result = [];
	  columns.forEach(function (column) {
	    if (column.children) {
	      result.push(column);
	      result.push.apply(result, getAllColumns(column.children));
	    } else {
	      result.push(column);
	    }
	  });
	  return result;
	};
	
	var convertToRows = function convertToRows(originColumns) {
	  var maxLevel = 1;
	  var traverse = function traverse(column, parent) {
	    if (parent) {
	      column.level = parent.level + 1;
	      if (maxLevel < column.level) {
	        maxLevel = column.level;
	      }
	    }
	    if (column.children) {
	      var colSpan = 0;
	      column.children.forEach(function (subColumn) {
	        traverse(subColumn, column);
	        colSpan += subColumn.colSpan;
	      });
	      column.colSpan = colSpan;
	    } else {
	      column.colSpan = 1;
	    }
	  };
	
	  originColumns.forEach(function (column) {
	    column.level = 1;
	    traverse(column);
	  });
	
	  var rows = [];
	  for (var i = 0; i < maxLevel; i++) {
	    rows.push([]);
	  }
	
	  var allColumns = getAllColumns(originColumns);
	
	  allColumns.forEach(function (column) {
	    if (!column.children) {
	      column.rowSpan = maxLevel - column.level + 1;
	    } else {
	      column.rowSpan = 1;
	    }
	    rows[column.level - 1].push(column);
	  });
	
	  return rows;
	};
	
	/* harmony default export */ var table_header = ({
	  name: 'ElTableHeader',
	
	  mixins: [layout_observer],
	
	  render: function render(h) {
	    var _this = this;
	
	    var originColumns = this.store.states.originColumns;
	    var columnRows = convertToRows(originColumns, this.columns);
	    // 是否拥有多级表头
	    var isGroup = columnRows.length > 1;
	    if (isGroup) this.$parent.isGroup = true;
	    return h(
	      'table',
	      {
	        'class': 'el-table__header',
	        attrs: { cellspacing: '0',
	          cellpadding: '0',
	          border: '0' }
	      },
	      [h('colgroup', [this.columns.map(function (column) {
	        return h('col', {
	          attrs: { name: column.id },
	          key: column.id });
	      }), this.hasGutter ? h('col', {
	        attrs: { name: 'gutter' }
	      }) : '']), h(
	        'thead',
	        { 'class': [{ 'is-group': isGroup, 'has-gutter': this.hasGutter }] },
	        [this._l(columnRows, function (columns, rowIndex) {
	          return h(
	            'tr',
	            {
	              style: _this.getHeaderRowStyle(rowIndex),
	              'class': _this.getHeaderRowClass(rowIndex)
	            },
	            [columns.map(function (column, cellIndex) {
	              return h(
	                'th',
	                {
	                  attrs: {
	                    colspan: column.colSpan,
	                    rowspan: column.rowSpan
	                  },
	                  on: {
	                    'mousemove': function mousemove($event) {
	                      return _this.handleMouseMove($event, column);
	                    },
	                    'mouseout': _this.handleMouseOut,
	                    'mousedown': function mousedown($event) {
	                      return _this.handleMouseDown($event, column);
	                    },
	                    'click': function click($event) {
	                      return _this.handleHeaderClick($event, column);
	                    },
	                    'contextmenu': function contextmenu($event) {
	                      return _this.handleHeaderContextMenu($event, column);
	                    }
	                  },
	
	                  style: _this.getHeaderCellStyle(rowIndex, cellIndex, columns, column),
	                  'class': _this.getHeaderCellClass(rowIndex, cellIndex, columns, column),
	                  key: column.id },
	                [h(
	                  'div',
	                  { 'class': ['cell', column.filteredValue && column.filteredValue.length > 0 ? 'highlight' : '', column.labelClassName] },
	                  [column.renderHeader ? column.renderHeader.call(_this._renderProxy, h, { column: column, $index: cellIndex, store: _this.store, _self: _this.$parent.$vnode.context }) : column.label, column.sortable ? h(
	                    'span',
	                    {
	                      'class': 'caret-wrapper',
	                      on: {
	                        'click': function click($event) {
	                          return _this.handleSortClick($event, column);
	                        }
	                      }
	                    },
	                    [h('i', { 'class': 'sort-caret ascending',
	                      on: {
	                        'click': function click($event) {
	                          return _this.handleSortClick($event, column, 'ascending');
	                        }
	                      }
	                    }), h('i', { 'class': 'sort-caret descending',
	                      on: {
	                        'click': function click($event) {
	                          return _this.handleSortClick($event, column, 'descending');
	                        }
	                      }
	                    })]
	                  ) : '', column.filterable ? h(
	                    'span',
	                    {
	                      'class': 'el-table__column-filter-trigger',
	                      on: {
	                        'click': function click($event) {
	                          return _this.handleFilterClick($event, column);
	                        }
	                      }
	                    },
	                    [h('i', { 'class': ['el-icon-arrow-down', column.filterOpened ? 'el-icon-arrow-up' : ''] })]
	                  ) : '']
	                )]
	              );
	            }), _this.hasGutter ? h('th', { 'class': 'gutter' }) : '']
	          );
	        })]
	      )]
	    );
	  },
	
	
	  props: {
	    fixed: String,
	    store: {
	      required: true
	    },
	    border: Boolean,
	    defaultSort: {
	      type: Object,
	      default: function _default() {
	        return {
	          prop: '',
	          order: ''
	        };
	      }
	    }
	  },
	
	  components: {
	    ElCheckbox: checkbox_default.a
	  },
	
	  computed: table_header_extends({
	    table: function table() {
	      return this.$parent;
	    },
	    hasGutter: function hasGutter() {
	      return !this.fixed && this.tableLayout.gutterWidth;
	    }
	  }, mapStates({
	    columns: 'columns',
	    isAllSelected: 'isAllSelected',
	    leftFixedLeafCount: 'fixedLeafColumnsLength',
	    rightFixedLeafCount: 'rightFixedLeafColumnsLength',
	    columnsCount: function columnsCount(states) {
	      return states.columns.length;
	    },
	    leftFixedCount: function leftFixedCount(states) {
	      return states.fixedColumns.length;
	    },
	    rightFixedCount: function rightFixedCount(states) {
	      return states.rightFixedColumns.length;
	    }
	  })),
	
	  created: function created() {
	    this.filterPanels = {};
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    // nextTick 是有必要的 https://github.com/ElemeFE/element/pull/11311
	    this.$nextTick(function () {
	      var _defaultSort = _this2.defaultSort,
	          prop = _defaultSort.prop,
	          order = _defaultSort.order;
	
	      var init = true;
	      _this2.store.commit('sort', { prop: prop, order: order, init: init });
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    var panels = this.filterPanels;
	    for (var prop in panels) {
	      if (panels.hasOwnProperty(prop) && panels[prop]) {
	        panels[prop].$destroy(true);
	      }
	    }
	  },
	
	
	  methods: {
	    isCellHidden: function isCellHidden(index, columns) {
	      var start = 0;
	      for (var i = 0; i < index; i++) {
	        start += columns[i].colSpan;
	      }
	      var after = start + columns[index].colSpan - 1;
	      if (this.fixed === true || this.fixed === 'left') {
	        return after >= this.leftFixedLeafCount;
	      } else if (this.fixed === 'right') {
	        return start < this.columnsCount - this.rightFixedLeafCount;
	      } else {
	        return after < this.leftFixedLeafCount || start >= this.columnsCount - this.rightFixedLeafCount;
	      }
	    },
	    getHeaderRowStyle: function getHeaderRowStyle(rowIndex) {
	      var headerRowStyle = this.table.headerRowStyle;
	      if (typeof headerRowStyle === 'function') {
	        return headerRowStyle.call(null, { rowIndex: rowIndex });
	      }
	      return headerRowStyle;
	    },
	    getHeaderRowClass: function getHeaderRowClass(rowIndex) {
	      var classes = [];
	
	      var headerRowClassName = this.table.headerRowClassName;
	      if (typeof headerRowClassName === 'string') {
	        classes.push(headerRowClassName);
	      } else if (typeof headerRowClassName === 'function') {
	        classes.push(headerRowClassName.call(null, { rowIndex: rowIndex }));
	      }
	
	      return classes.join(' ');
	    },
	    getHeaderCellStyle: function getHeaderCellStyle(rowIndex, columnIndex, row, column) {
	      var headerCellStyle = this.table.headerCellStyle;
	      if (typeof headerCellStyle === 'function') {
	        return headerCellStyle.call(null, {
	          rowIndex: rowIndex,
	          columnIndex: columnIndex,
	          row: row,
	          column: column
	        });
	      }
	      return headerCellStyle;
	    },
	    getHeaderCellClass: function getHeaderCellClass(rowIndex, columnIndex, row, column) {
	      var classes = [column.id, column.order, column.headerAlign, column.className, column.labelClassName];
	
	      if (rowIndex === 0 && this.isCellHidden(columnIndex, row)) {
	        classes.push('is-hidden');
	      }
	
	      if (!column.children) {
	        classes.push('is-leaf');
	      }
	
	      if (column.sortable) {
	        classes.push('is-sortable');
	      }
	
	      var headerCellClassName = this.table.headerCellClassName;
	      if (typeof headerCellClassName === 'string') {
	        classes.push(headerCellClassName);
	      } else if (typeof headerCellClassName === 'function') {
	        classes.push(headerCellClassName.call(null, {
	          rowIndex: rowIndex,
	          columnIndex: columnIndex,
	          row: row,
	          column: column
	        }));
	      }
	
	      return classes.join(' ');
	    },
	    toggleAllSelection: function toggleAllSelection(event) {
	      event.stopPropagation();
	      this.store.commit('toggleAllSelection');
	    },
	    handleFilterClick: function handleFilterClick(event, column) {
	      event.stopPropagation();
	      var target = event.target;
	      var cell = target.tagName === 'TH' ? target : target.parentNode;
	      if (Object(dom_["hasClass"])(cell, 'noclick')) return;
	      cell = cell.querySelector('.el-table__column-filter-trigger') || cell;
	      var table = this.$parent;
	
	      var filterPanel = this.filterPanels[column.id];
	
	      if (filterPanel && column.filterOpened) {
	        filterPanel.showPopper = false;
	        return;
	      }
	
	      if (!filterPanel) {
	        filterPanel = new external_vue_default.a(filter_panel);
	        this.filterPanels[column.id] = filterPanel;
	        if (column.filterPlacement) {
	          filterPanel.placement = column.filterPlacement;
	        }
	        filterPanel.table = table;
	        filterPanel.cell = cell;
	        filterPanel.column = column;
	        !this.$isServer && filterPanel.$mount(document.createElement('div'));
	      }
	
	      setTimeout(function () {
	        filterPanel.showPopper = true;
	      }, 16);
	    },
	    handleHeaderClick: function handleHeaderClick(event, column) {
	      if (!column.filters && column.sortable) {
	        this.handleSortClick(event, column);
	      } else if (column.filterable && !column.sortable) {
	        this.handleFilterClick(event, column);
	      }
	
	      this.$parent.$emit('header-click', column, event);
	    },
	    handleHeaderContextMenu: function handleHeaderContextMenu(event, column) {
	      this.$parent.$emit('header-contextmenu', column, event);
	    },
	    handleMouseDown: function handleMouseDown(event, column) {
	      var _this3 = this;
	
	      if (this.$isServer) return;
	      if (column.children && column.children.length > 0) return;
	      /* istanbul ignore if */
	      if (this.draggingColumn && this.border) {
	        this.dragging = true;
	
	        this.$parent.resizeProxyVisible = true;
	
	        var table = this.$parent;
	        var tableEl = table.$el;
	        var tableLeft = tableEl.getBoundingClientRect().left;
	        var columnEl = this.$el.querySelector('th.' + column.id);
	        var columnRect = columnEl.getBoundingClientRect();
	        var minLeft = columnRect.left - tableLeft + 30;
	
	        Object(dom_["addClass"])(columnEl, 'noclick');
	
	        this.dragState = {
	          startMouseLeft: event.clientX,
	          startLeft: columnRect.right - tableLeft,
	          startColumnLeft: columnRect.left - tableLeft,
	          tableLeft: tableLeft
	        };
	
	        var resizeProxy = table.$refs.resizeProxy;
	        resizeProxy.style.left = this.dragState.startLeft + 'px';
	
	        document.onselectstart = function () {
	          return false;
	        };
	        document.ondragstart = function () {
	          return false;
	        };
	
	        var handleMouseMove = function handleMouseMove(event) {
	          var deltaLeft = event.clientX - _this3.dragState.startMouseLeft;
	          var proxyLeft = _this3.dragState.startLeft + deltaLeft;
	
	          resizeProxy.style.left = Math.max(minLeft, proxyLeft) + 'px';
	        };
	
	        var handleMouseUp = function handleMouseUp() {
	          if (_this3.dragging) {
	            var _dragState = _this3.dragState,
	                startColumnLeft = _dragState.startColumnLeft,
	                startLeft = _dragState.startLeft;
	
	            var finalLeft = parseInt(resizeProxy.style.left, 10);
	            var columnWidth = finalLeft - startColumnLeft;
	            column.width = column.realWidth = columnWidth;
	            table.$emit('header-dragend', column.width, startLeft - startColumnLeft, column, event);
	
	            _this3.store.scheduleLayout();
	
	            document.body.style.cursor = '';
	            _this3.dragging = false;
	            _this3.draggingColumn = null;
	            _this3.dragState = {};
	
	            table.resizeProxyVisible = false;
	          }
	
	          document.removeEventListener('mousemove', handleMouseMove);
	          document.removeEventListener('mouseup', handleMouseUp);
	          document.onselectstart = null;
	          document.ondragstart = null;
	
	          setTimeout(function () {
	            Object(dom_["removeClass"])(columnEl, 'noclick');
	          }, 0);
	        };
	
	        document.addEventListener('mousemove', handleMouseMove);
	        document.addEventListener('mouseup', handleMouseUp);
	      }
	    },
	    handleMouseMove: function handleMouseMove(event, column) {
	      if (column.children && column.children.length > 0) return;
	      var target = event.target;
	      while (target && target.tagName !== 'TH') {
	        target = target.parentNode;
	      }
	
	      if (!column || !column.resizable) return;
	
	      if (!this.dragging && this.border) {
	        var rect = target.getBoundingClientRect();
	
	        var bodyStyle = document.body.style;
	        if (rect.width > 12 && rect.right - event.pageX < 8) {
	          bodyStyle.cursor = 'col-resize';
	          if (Object(dom_["hasClass"])(target, 'is-sortable')) {
	            target.style.cursor = 'col-resize';
	          }
	          this.draggingColumn = column;
	        } else if (!this.dragging) {
	          bodyStyle.cursor = '';
	          if (Object(dom_["hasClass"])(target, 'is-sortable')) {
	            target.style.cursor = 'pointer';
	          }
	          this.draggingColumn = null;
	        }
	      }
	    },
	    handleMouseOut: function handleMouseOut() {
	      if (this.$isServer) return;
	      document.body.style.cursor = '';
	    },
	    toggleOrder: function toggleOrder(_ref) {
	      var order = _ref.order,
	          sortOrders = _ref.sortOrders;
	
	      if (order === '') return sortOrders[0];
	      var index = sortOrders.indexOf(order || null);
	      return sortOrders[index > sortOrders.length - 2 ? 0 : index + 1];
	    },
	    handleSortClick: function handleSortClick(event, column, givenOrder) {
	      event.stopPropagation();
	      var order = column.order === givenOrder ? null : givenOrder || this.toggleOrder(column);
	
	      var target = event.target;
	      while (target && target.tagName !== 'TH') {
	        target = target.parentNode;
	      }
	
	      if (target && target.tagName === 'TH') {
	        if (Object(dom_["hasClass"])(target, 'noclick')) {
	          Object(dom_["removeClass"])(target, 'noclick');
	          return;
	        }
	      }
	
	      if (!column.sortable) return;
	
	      var states = this.store.states;
	      var sortProp = states.sortProp;
	      var sortOrder = void 0;
	      var sortingColumn = states.sortingColumn;
	
	      if (sortingColumn !== column || sortingColumn === column && sortingColumn.order === null) {
	        if (sortingColumn) {
	          sortingColumn.order = null;
	        }
	        states.sortingColumn = column;
	        sortProp = column.property;
	      }
	
	      if (!order) {
	        sortOrder = column.order = null;
	      } else {
	        sortOrder = column.order = order;
	      }
	
	      states.sortProp = sortProp;
	      states.sortOrder = sortOrder;
	
	      this.store.commit('changeSortCondition');
	    }
	  },
	
	  data: function data() {
	    return {
	      draggingColumn: null,
	      dragging: false,
	      dragState: {}
	    };
	  }
	});
	// CONCATENATED MODULE: ./packages/table/src/table-footer.js
	var table_footer_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	
	
	
	/* harmony default export */ var table_footer = ({
	  name: 'ElTableFooter',
	
	  mixins: [layout_observer],
	
	  render: function render(h) {
	    var _this = this;
	
	    var sums = [];
	    if (this.summaryMethod) {
	      sums = this.summaryMethod({ columns: this.columns, data: this.store.states.data });
	    } else {
	      this.columns.forEach(function (column, index) {
	        if (index === 0) {
	          sums[index] = _this.sumText;
	          return;
	        }
	        var values = _this.store.states.data.map(function (item) {
	          return Number(item[column.property]);
	        });
	        var precisions = [];
	        var notNumber = true;
	        values.forEach(function (value) {
	          if (!isNaN(value)) {
	            notNumber = false;
	            var decimal = ('' + value).split('.')[1];
	            precisions.push(decimal ? decimal.length : 0);
	          }
	        });
	        var precision = Math.max.apply(null, precisions);
	        if (!notNumber) {
	          sums[index] = values.reduce(function (prev, curr) {
	            var value = Number(curr);
	            if (!isNaN(value)) {
	              return parseFloat((prev + curr).toFixed(Math.min(precision, 20)));
	            } else {
	              return prev;
	            }
	          }, 0);
	        } else {
	          sums[index] = '';
	        }
	      });
	    }
	
	    return h(
	      'table',
	      {
	        'class': 'el-table__footer',
	        attrs: { cellspacing: '0',
	          cellpadding: '0',
	          border: '0' }
	      },
	      [h('colgroup', [this.columns.map(function (column) {
	        return h('col', {
	          attrs: { name: column.id },
	          key: column.id });
	      }), this.hasGutter ? h('col', {
	        attrs: { name: 'gutter' }
	      }) : '']), h(
	        'tbody',
	        { 'class': [{ 'has-gutter': this.hasGutter }] },
	        [h('tr', [this.columns.map(function (column, cellIndex) {
	          return h(
	            'td',
	            {
	              key: cellIndex,
	              attrs: { colspan: column.colSpan,
	                rowspan: column.rowSpan
	              },
	              'class': _this.getRowClasses(column, cellIndex) },
	            [h(
	              'div',
	              { 'class': ['cell', column.labelClassName] },
	              [sums[cellIndex]]
	            )]
	          );
	        }), this.hasGutter ? h('th', { 'class': 'gutter' }) : ''])]
	      )]
	    );
	  },
	
	
	  props: {
	    fixed: String,
	    store: {
	      required: true
	    },
	    summaryMethod: Function,
	    sumText: String,
	    border: Boolean,
	    defaultSort: {
	      type: Object,
	      default: function _default() {
	        return {
	          prop: '',
	          order: ''
	        };
	      }
	    }
	  },
	
	  computed: table_footer_extends({
	    table: function table() {
	      return this.$parent;
	    },
	    hasGutter: function hasGutter() {
	      return !this.fixed && this.tableLayout.gutterWidth;
	    }
	  }, mapStates({
	    columns: 'columns',
	    isAllSelected: 'isAllSelected',
	    leftFixedLeafCount: 'fixedLeafColumnsLength',
	    rightFixedLeafCount: 'rightFixedLeafColumnsLength',
	    columnsCount: function columnsCount(states) {
	      return states.columns.length;
	    },
	    leftFixedCount: function leftFixedCount(states) {
	      return states.fixedColumns.length;
	    },
	    rightFixedCount: function rightFixedCount(states) {
	      return states.rightFixedColumns.length;
	    }
	  })),
	
	  methods: {
	    isCellHidden: function isCellHidden(index, columns, column) {
	      if (this.fixed === true || this.fixed === 'left') {
	        return index >= this.leftFixedLeafCount;
	      } else if (this.fixed === 'right') {
	        var before = 0;
	        for (var i = 0; i < index; i++) {
	          before += columns[i].colSpan;
	        }
	        return before < this.columnsCount - this.rightFixedLeafCount;
	      } else if (!this.fixed && column.fixed) {
	        // hide cell when footer instance is not fixed and column is fixed
	        return true;
	      } else {
	        return index < this.leftFixedCount || index >= this.columnsCount - this.rightFixedCount;
	      }
	    },
	    getRowClasses: function getRowClasses(column, cellIndex) {
	      var classes = [column.id, column.align, column.labelClassName];
	      if (column.className) {
	        classes.push(column.className);
	      }
	      if (this.isCellHidden(cellIndex, this.columns, column)) {
	        classes.push('is-hidden');
	      }
	      if (!column.children) {
	        classes.push('is-leaf');
	      }
	      return classes;
	    }
	  }
	});
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/table/src/table.vue?vue&type=script&lang=js&
	var tablevue_type_script_lang_js_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var tableIdSeed = 1;
	
	/* harmony default export */ var tablevue_type_script_lang_js_ = ({
	  name: 'ElTable',
	
	  mixins: [locale_default.a, migrating_default.a],
	
	  directives: {
	    Mousewheel: directives_mousewheel
	  },
	
	  props: {
	    data: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	
	    size: String,
	
	    width: [String, Number],
	
	    height: [String, Number],
	
	    maxHeight: [String, Number],
	
	    fit: {
	      type: Boolean,
	      default: true
	    },
	
	    stripe: Boolean,
	
	    border: Boolean,
	
	    rowKey: [String, Function],
	
	    context: {},
	
	    showHeader: {
	      type: Boolean,
	      default: true
	    },
	
	    showSummary: Boolean,
	
	    sumText: String,
	
	    summaryMethod: Function,
	
	    rowClassName: [String, Function],
	
	    rowStyle: [Object, Function],
	
	    cellClassName: [String, Function],
	
	    cellStyle: [Object, Function],
	
	    headerRowClassName: [String, Function],
	
	    headerRowStyle: [Object, Function],
	
	    headerCellClassName: [String, Function],
	
	    headerCellStyle: [Object, Function],
	
	    highlightCurrentRow: Boolean,
	
	    currentRowKey: [String, Number],
	
	    emptyText: String,
	
	    expandRowKeys: Array,
	
	    defaultExpandAll: Boolean,
	
	    defaultSort: Object,
	
	    tooltipEffect: String,
	
	    spanMethod: Function,
	
	    selectOnIndeterminate: {
	      type: Boolean,
	      default: true
	    },
	
	    indent: {
	      type: Number,
	      default: 16
	    },
	
	    treeProps: {
	      type: Object,
	      default: function _default() {
	        return {
	          hasChildren: 'hasChildren',
	          children: 'children'
	        };
	      }
	    },
	
	    lazy: Boolean,
	
	    load: Function
	  },
	
	  components: {
	    TableHeader: table_header,
	    TableFooter: table_footer,
	    TableBody: table_body,
	    ElCheckbox: checkbox_default.a
	  },
	
	  methods: {
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        events: {
	          expand: 'expand is renamed to expand-change'
	        }
	      };
	    },
	    setCurrentRow: function setCurrentRow(row) {
	      this.store.commit('setCurrentRow', row);
	    },
	    toggleRowSelection: function toggleRowSelection(row, selected) {
	      this.store.toggleRowSelection(row, selected, false);
	      this.store.updateAllSelected();
	    },
	    toggleRowExpansion: function toggleRowExpansion(row, expanded) {
	      this.store.toggleRowExpansionAdapter(row, expanded);
	    },
	    clearSelection: function clearSelection() {
	      this.store.clearSelection();
	    },
	    clearFilter: function clearFilter(columnKeys) {
	      this.store.clearFilter(columnKeys);
	    },
	    clearSort: function clearSort() {
	      this.store.clearSort();
	    },
	    handleMouseLeave: function handleMouseLeave() {
	      this.store.commit('setHoverRow', null);
	      if (this.hoverState) this.hoverState = null;
	    },
	    updateScrollY: function updateScrollY() {
	      var changed = this.layout.updateScrollY();
	      if (changed) {
	        this.layout.notifyObservers('scrollable');
	        this.layout.updateColumnsWidth();
	      }
	    },
	    handleFixedMousewheel: function handleFixedMousewheel(event, data) {
	      var bodyWrapper = this.bodyWrapper;
	      if (Math.abs(data.spinY) > 0) {
	        var currentScrollTop = bodyWrapper.scrollTop;
	        if (data.pixelY < 0 && currentScrollTop !== 0) {
	          event.preventDefault();
	        }
	        if (data.pixelY > 0 && bodyWrapper.scrollHeight - bodyWrapper.clientHeight > currentScrollTop) {
	          event.preventDefault();
	        }
	        bodyWrapper.scrollTop += Math.ceil(data.pixelY / 5);
	      } else {
	        bodyWrapper.scrollLeft += Math.ceil(data.pixelX / 5);
	      }
	    },
	    handleHeaderFooterMousewheel: function handleHeaderFooterMousewheel(event, data) {
	      var pixelX = data.pixelX,
	          pixelY = data.pixelY;
	
	      if (Math.abs(pixelX) >= Math.abs(pixelY)) {
	        this.bodyWrapper.scrollLeft += data.pixelX / 5;
	      }
	    },
	
	
	    // TODO 使用 CSS transform
	    syncPostion: Object(external_throttle_debounce_["throttle"])(20, function () {
	      var _bodyWrapper = this.bodyWrapper,
	          scrollLeft = _bodyWrapper.scrollLeft,
	          scrollTop = _bodyWrapper.scrollTop,
	          offsetWidth = _bodyWrapper.offsetWidth,
	          scrollWidth = _bodyWrapper.scrollWidth;
	      var _$refs = this.$refs,
	          headerWrapper = _$refs.headerWrapper,
	          footerWrapper = _$refs.footerWrapper,
	          fixedBodyWrapper = _$refs.fixedBodyWrapper,
	          rightFixedBodyWrapper = _$refs.rightFixedBodyWrapper;
	
	      if (headerWrapper) headerWrapper.scrollLeft = scrollLeft;
	      if (footerWrapper) footerWrapper.scrollLeft = scrollLeft;
	      if (fixedBodyWrapper) fixedBodyWrapper.scrollTop = scrollTop;
	      if (rightFixedBodyWrapper) rightFixedBodyWrapper.scrollTop = scrollTop;
	      var maxScrollLeftPosition = scrollWidth - offsetWidth - 1;
	      if (scrollLeft >= maxScrollLeftPosition) {
	        this.scrollPosition = 'right';
	      } else if (scrollLeft === 0) {
	        this.scrollPosition = 'left';
	      } else {
	        this.scrollPosition = 'middle';
	      }
	    }),
	
	    bindEvents: function bindEvents() {
	      this.bodyWrapper.addEventListener('scroll', this.syncPostion, { passive: true });
	      if (this.fit) {
	        Object(resize_event_["addResizeListener"])(this.$el, this.resizeListener);
	      }
	    },
	    unbindEvents: function unbindEvents() {
	      this.bodyWrapper.removeEventListener('scroll', this.syncPostion, { passive: true });
	      if (this.fit) {
	        Object(resize_event_["removeResizeListener"])(this.$el, this.resizeListener);
	      }
	    },
	    resizeListener: function resizeListener() {
	      if (!this.$ready) return;
	      var shouldUpdateLayout = false;
	      var el = this.$el;
	      var _resizeState = this.resizeState,
	          oldWidth = _resizeState.width,
	          oldHeight = _resizeState.height;
	
	
	      var width = el.offsetWidth;
	      if (oldWidth !== width) {
	        shouldUpdateLayout = true;
	      }
	
	      var height = el.offsetHeight;
	      if ((this.height || this.shouldUpdateHeight) && oldHeight !== height) {
	        shouldUpdateLayout = true;
	      }
	
	      if (shouldUpdateLayout) {
	        this.resizeState.width = width;
	        this.resizeState.height = height;
	        this.doLayout();
	      }
	    },
	    doLayout: function doLayout() {
	      if (this.shouldUpdateHeight) {
	        this.layout.updateElsHeight();
	      }
	      this.layout.updateColumnsWidth();
	    },
	    sort: function sort(prop, order) {
	      this.store.commit('sort', { prop: prop, order: order });
	    },
	    toggleAllSelection: function toggleAllSelection() {
	      this.store.commit('toggleAllSelection');
	    }
	  },
	
	  computed: tablevue_type_script_lang_js_extends({
	    tableSize: function tableSize() {
	      return this.size || (this.$ELEMENT || {}).size;
	    },
	    bodyWrapper: function bodyWrapper() {
	      return this.$refs.bodyWrapper;
	    },
	    shouldUpdateHeight: function shouldUpdateHeight() {
	      return this.height || this.maxHeight || this.fixedColumns.length > 0 || this.rightFixedColumns.length > 0;
	    },
	    bodyWidth: function bodyWidth() {
	      var _layout = this.layout,
	          bodyWidth = _layout.bodyWidth,
	          scrollY = _layout.scrollY,
	          gutterWidth = _layout.gutterWidth;
	
	      return bodyWidth ? bodyWidth - (scrollY ? gutterWidth : 0) + 'px' : '';
	    },
	    bodyHeight: function bodyHeight() {
	      var _layout2 = this.layout,
	          _layout2$headerHeight = _layout2.headerHeight,
	          headerHeight = _layout2$headerHeight === undefined ? 0 : _layout2$headerHeight,
	          bodyHeight = _layout2.bodyHeight,
	          _layout2$footerHeight = _layout2.footerHeight,
	          footerHeight = _layout2$footerHeight === undefined ? 0 : _layout2$footerHeight;
	
	      if (this.height) {
	        return {
	          height: bodyHeight ? bodyHeight + 'px' : ''
	        };
	      } else if (this.maxHeight) {
	        var maxHeight = parseHeight(this.maxHeight);
	        if (typeof maxHeight === 'number') {
	          return {
	            'max-height': maxHeight - footerHeight - (this.showHeader ? headerHeight : 0) + 'px'
	          };
	        }
	      }
	      return {};
	    },
	    fixedBodyHeight: function fixedBodyHeight() {
	      if (this.height) {
	        return {
	          height: this.layout.fixedBodyHeight ? this.layout.fixedBodyHeight + 'px' : ''
	        };
	      } else if (this.maxHeight) {
	        var maxHeight = parseHeight(this.maxHeight);
	        if (typeof maxHeight === 'number') {
	          maxHeight = this.layout.scrollX ? maxHeight - this.layout.gutterWidth : maxHeight;
	          if (this.showHeader) {
	            maxHeight -= this.layout.headerHeight;
	          }
	          maxHeight -= this.layout.footerHeight;
	          return {
	            'max-height': maxHeight + 'px'
	          };
	        }
	      }
	      return {};
	    },
	    fixedHeight: function fixedHeight() {
	      if (this.maxHeight) {
	        if (this.showSummary) {
	          return {
	            bottom: 0
	          };
	        }
	        return {
	          bottom: this.layout.scrollX && this.data.length ? this.layout.gutterWidth + 'px' : ''
	        };
	      } else {
	        if (this.showSummary) {
	          return {
	            height: this.layout.tableHeight ? this.layout.tableHeight + 'px' : ''
	          };
	        }
	        return {
	          height: this.layout.viewportHeight ? this.layout.viewportHeight + 'px' : ''
	        };
	      }
	    },
	    emptyBlockStyle: function emptyBlockStyle() {
	      if (this.data && this.data.length) return null;
	      var height = '100%';
	      if (this.layout.appendHeight) {
	        height = 'calc(100% - ' + this.layout.appendHeight + 'px)';
	      }
	      return {
	        width: this.bodyWidth,
	        height: height
	      };
	    }
	  }, mapStates({
	    selection: 'selection',
	    columns: 'columns',
	    tableData: 'data',
	    fixedColumns: 'fixedColumns',
	    rightFixedColumns: 'rightFixedColumns'
	  })),
	
	  watch: {
	    height: {
	      immediate: true,
	      handler: function handler(value) {
	        this.layout.setHeight(value);
	      }
	    },
	
	    maxHeight: {
	      immediate: true,
	      handler: function handler(value) {
	        this.layout.setMaxHeight(value);
	      }
	    },
	
	    currentRowKey: {
	      immediate: true,
	      handler: function handler(value) {
	        if (!this.rowKey) return;
	        this.store.setCurrentRowKey(value);
	      }
	    },
	
	    data: {
	      immediate: true,
	      handler: function handler(value) {
	        this.store.commit('setData', value);
	      }
	    },
	
	    expandRowKeys: {
	      immediate: true,
	      handler: function handler(newVal) {
	        if (newVal) {
	          this.store.setExpandRowKeysAdapter(newVal);
	        }
	      }
	    }
	  },
	
	  created: function created() {
	    var _this = this;
	
	    this.tableId = 'el-table_' + tableIdSeed++;
	    this.debouncedUpdateLayout = Object(external_throttle_debounce_["debounce"])(50, function () {
	      return _this.doLayout();
	    });
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.bindEvents();
	    this.store.updateColumns();
	    this.doLayout();
	
	    this.resizeState = {
	      width: this.$el.offsetWidth,
	      height: this.$el.offsetHeight
	    };
	
	    // init filters
	    this.store.states.columns.forEach(function (column) {
	      if (column.filteredValue && column.filteredValue.length) {
	        _this2.store.commit('filterChange', {
	          column: column,
	          values: column.filteredValue,
	          silent: true
	        });
	      }
	    });
	
	    this.$ready = true;
	  },
	  destroyed: function destroyed() {
	    this.unbindEvents();
	  },
	  data: function data() {
	    var _treeProps = this.treeProps,
	        _treeProps$hasChildre = _treeProps.hasChildren,
	        hasChildren = _treeProps$hasChildre === undefined ? 'hasChildren' : _treeProps$hasChildre,
	        _treeProps$children = _treeProps.children,
	        children = _treeProps$children === undefined ? 'children' : _treeProps$children;
	
	    this.store = createStore(this, {
	      rowKey: this.rowKey,
	      defaultExpandAll: this.defaultExpandAll,
	      selectOnIndeterminate: this.selectOnIndeterminate,
	      // TreeTable 的相关配置
	      indent: this.indent,
	      lazy: this.lazy,
	      lazyColumnIdentifier: hasChildren,
	      childrenColumnName: children
	    });
	    var layout = new table_layout({
	      store: this.store,
	      table: this,
	      fit: this.fit,
	      showHeader: this.showHeader
	    });
	    return {
	      layout: layout,
	      isHidden: false,
	      renderExpanded: null,
	      resizeProxyVisible: false,
	      resizeState: {
	        width: null,
	        height: null
	      },
	      // 是否拥有多级表头
	      isGroup: false,
	      scrollPosition: 'left'
	    };
	  }
	});
	// CONCATENATED MODULE: ./packages/table/src/table.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_tablevue_type_script_lang_js_ = (tablevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/table/src/table.vue
	
	
	
	
	
	/* normalize component */
	
	var table_component = normalizeComponent(
	  src_tablevue_type_script_lang_js_,
	  tablevue_type_template_id_493fe34e_render,
	  tablevue_type_template_id_493fe34e_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var table_api; }
	table_component.options.__file = "packages/table/src/table.vue"
	/* harmony default export */ var src_table = (table_component.exports);
	// CONCATENATED MODULE: ./packages/table/index.js
	
	
	/* istanbul ignore next */
	src_table.install = function (Vue) {
	  Vue.component(src_table.name, src_table);
	};
	
	/* harmony default export */ var packages_table = (src_table);
	// CONCATENATED MODULE: ./packages/table/src/config.js
	
	
	var cellStarts = {
	  default: {
	    order: ''
	  },
	  selection: {
	    width: 48,
	    minWidth: 48,
	    realWidth: 48,
	    order: '',
	    className: 'el-table-column--selection'
	  },
	  expand: {
	    width: 48,
	    minWidth: 48,
	    realWidth: 48,
	    order: ''
	  },
	  index: {
	    width: 48,
	    minWidth: 48,
	    realWidth: 48,
	    order: ''
	  }
	};
	
	// 这些选项不应该被覆盖
	var cellForced = {
	  selection: {
	    renderHeader: function renderHeader(h, _ref) {
	      var store = _ref.store;
	
	      return h('el-checkbox', {
	        attrs: {
	          disabled: store.states.data && store.states.data.length === 0,
	          indeterminate: store.states.selection.length > 0 && !this.isAllSelected,
	
	          value: this.isAllSelected },
	        nativeOn: {
	          'click': this.toggleAllSelection
	        }
	      });
	    },
	    renderCell: function renderCell(h, _ref2) {
	      var row = _ref2.row,
	          column = _ref2.column,
	          store = _ref2.store,
	          $index = _ref2.$index;
	
	      return h('el-checkbox', {
	        nativeOn: {
	          'click': function click(event) {
	            return event.stopPropagation();
	          }
	        },
	        attrs: {
	          value: store.isSelected(row),
	          disabled: column.selectable ? !column.selectable.call(null, row, $index) : false
	        },
	        on: {
	          'input': function input() {
	            store.commit('rowSelectedChanged', row);
	          }
	        }
	      });
	    },
	    sortable: false,
	    resizable: false
	  },
	  index: {
	    renderHeader: function renderHeader(h, _ref3) {
	      var column = _ref3.column;
	
	      return column.label || '#';
	    },
	    renderCell: function renderCell(h, _ref4) {
	      var $index = _ref4.$index,
	          column = _ref4.column;
	
	      var i = $index + 1;
	      var index = column.index;
	
	      if (typeof index === 'number') {
	        i = $index + index;
	      } else if (typeof index === 'function') {
	        i = index($index);
	      }
	
	      return h('div', [i]);
	    },
	    sortable: false
	  },
	  expand: {
	    renderHeader: function renderHeader(h, _ref5) {
	      var column = _ref5.column;
	
	      return column.label || '';
	    },
	    renderCell: function renderCell(h, _ref6) {
	      var row = _ref6.row,
	          store = _ref6.store;
	
	      var classes = ['el-table__expand-icon'];
	      if (store.states.expandRows.indexOf(row) > -1) {
	        classes.push('el-table__expand-icon--expanded');
	      }
	      var callback = function callback(e) {
	        e.stopPropagation();
	        store.toggleRowExpansion(row);
	      };
	      return h(
	        'div',
	        { 'class': classes,
	          on: {
	            'click': callback
	          }
	        },
	        [h('i', { 'class': 'el-icon el-icon-arrow-right' })]
	      );
	    },
	    sortable: false,
	    resizable: false,
	    className: 'el-table__expand-column'
	  }
	};
	
	function defaultRenderCell(h, _ref7) {
	  var row = _ref7.row,
	      column = _ref7.column,
	      $index = _ref7.$index;
	
	  var property = column.property;
	  var value = property && Object(util_["getPropByPath"])(row, property).v;
	  if (column && column.formatter) {
	    return column.formatter(row, column, value, $index);
	  }
	  return value;
	}
	
	function treeCellPrefix(h, _ref8) {
	  var row = _ref8.row,
	      treeNode = _ref8.treeNode,
	      store = _ref8.store;
	
	  if (!treeNode) return null;
	  var ele = [];
	  var callback = function callback(e) {
	    e.stopPropagation();
	    store.loadOrToggle(row);
	  };
	  if (treeNode.indent) {
	    ele.push(h('span', { 'class': 'el-table__indent', style: { 'padding-left': treeNode.indent + 'px' } }));
	  }
	  if (typeof treeNode.expanded === 'boolean' && !treeNode.noLazyChildren) {
	    var expandClasses = ['el-table__expand-icon', treeNode.expanded ? 'el-table__expand-icon--expanded' : ''];
	    var iconClasses = ['el-icon-arrow-right'];
	    if (treeNode.loading) {
	      iconClasses = ['el-icon-loading'];
	    }
	    ele.push(h(
	      'div',
	      { 'class': expandClasses,
	        on: {
	          'click': callback
	        }
	      },
	      [h('i', { 'class': iconClasses })]
	    ));
	  } else {
	    ele.push(h('span', { 'class': 'el-table__placeholder' }));
	  }
	  return ele;
	}
	// CONCATENATED MODULE: ./packages/table/src/table-column.js
	var table_column_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	
	
	
	
	var columnIdSeed = 1;
	
	/* harmony default export */ var table_column = ({
	  name: 'ElTableColumn',
	
	  props: {
	    type: {
	      type: String,
	      default: 'default'
	    },
	    label: String,
	    className: String,
	    labelClassName: String,
	    property: String,
	    prop: String,
	    width: {},
	    minWidth: {},
	    renderHeader: Function,
	    sortable: {
	      type: [Boolean, String],
	      default: false
	    },
	    sortMethod: Function,
	    sortBy: [String, Function, Array],
	    resizable: {
	      type: Boolean,
	      default: true
	    },
	    columnKey: String,
	    align: String,
	    headerAlign: String,
	    showTooltipWhenOverflow: Boolean,
	    showOverflowTooltip: Boolean,
	    fixed: [Boolean, String],
	    formatter: Function,
	    selectable: Function,
	    reserveSelection: Boolean,
	    filterMethod: Function,
	    filteredValue: Array,
	    filters: Array,
	    filterPlacement: String,
	    filterMultiple: {
	      type: Boolean,
	      default: true
	    },
	    index: [Number, Function],
	    sortOrders: {
	      type: Array,
	      default: function _default() {
	        return ['ascending', 'descending', null];
	      },
	      validator: function validator(val) {
	        return val.every(function (order) {
	          return ['ascending', 'descending', null].indexOf(order) > -1;
	        });
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      isSubColumn: false,
	      columns: []
	    };
	  },
	
	
	  computed: {
	    owner: function owner() {
	      var parent = this.$parent;
	      while (parent && !parent.tableId) {
	        parent = parent.$parent;
	      }
	      return parent;
	    },
	    columnOrTableParent: function columnOrTableParent() {
	      var parent = this.$parent;
	      while (parent && !parent.tableId && !parent.columnId) {
	        parent = parent.$parent;
	      }
	      return parent;
	    },
	    realWidth: function realWidth() {
	      return parseWidth(this.width);
	    },
	    realMinWidth: function realMinWidth() {
	      return parseMinWidth(this.minWidth);
	    },
	    realAlign: function realAlign() {
	      return this.align ? 'is-' + this.align : null;
	    },
	    realHeaderAlign: function realHeaderAlign() {
	      return this.headerAlign ? 'is-' + this.headerAlign : this.realAlign;
	    }
	  },
	
	  methods: {
	    getPropsData: function getPropsData() {
	      var _this = this;
	
	      for (var _len = arguments.length, props = Array(_len), _key = 0; _key < _len; _key++) {
	        props[_key] = arguments[_key];
	      }
	
	      return props.reduce(function (prev, cur) {
	        if (Array.isArray(cur)) {
	          cur.forEach(function (key) {
	            prev[key] = _this[key];
	          });
	        }
	        return prev;
	      }, {});
	    },
	    getColumnElIndex: function getColumnElIndex(children, child) {
	      return [].indexOf.call(children, child);
	    },
	    setColumnWidth: function setColumnWidth(column) {
	      if (this.realWidth) {
	        column.width = this.realWidth;
	      }
	      if (this.realMinWidth) {
	        column.minWidth = this.realMinWidth;
	      }
	      if (!column.minWidth) {
	        column.minWidth = 80;
	      }
	      column.realWidth = column.width === undefined ? column.minWidth : column.width;
	      return column;
	    },
	    setColumnForcedProps: function setColumnForcedProps(column) {
	      // 对于特定类型的 column，某些属性不允许设置
	      var type = column.type;
	      var source = cellForced[type] || {};
	      Object.keys(source).forEach(function (prop) {
	        var value = source[prop];
	        if (value !== undefined) {
	          column[prop] = prop === 'className' ? column[prop] + ' ' + value : value;
	        }
	      });
	      return column;
	    },
	    setColumnRenders: function setColumnRenders(column) {
	      var _this2 = this;
	
	      var h = this.$createElement;
	
	      // renderHeader 属性不推荐使用。
	      if (this.renderHeader) {
	        console.warn('[Element Warn][TableColumn]Comparing to render-header, scoped-slot header is easier to use. We recommend users to use scoped-slot header.');
	      } else if (column.type !== 'selection') {
	        column.renderHeader = function (h, scope) {
	          var renderHeader = _this2.$scopedSlots.header;
	          return renderHeader ? renderHeader(scope) : column.label;
	        };
	      }
	
	      var originRenderCell = column.renderCell;
	      // TODO: 这里的实现调整
	      if (column.type === 'expand') {
	        // 对于展开行，renderCell 不允许配置的。在上一步中已经设置过，这里需要简单封装一下。
	        column.renderCell = function (h, data) {
	          return h(
	            'div',
	            { 'class': 'cell' },
	            [originRenderCell(h, data)]
	          );
	        };
	        this.owner.renderExpanded = function (h, data) {
	          return _this2.$scopedSlots.default ? _this2.$scopedSlots.default(data) : _this2.$slots.default;
	        };
	      } else {
	        originRenderCell = originRenderCell || defaultRenderCell;
	        // 对 renderCell 进行包装
	        column.renderCell = function (h, data) {
	          var children = null;
	          if (_this2.$scopedSlots.default) {
	            children = _this2.$scopedSlots.default(data);
	          } else {
	            children = originRenderCell(h, data);
	          }
	          var prefix = treeCellPrefix(h, data);
	          var props = {
	            class: 'cell',
	            style: {}
	          };
	          if (column.showOverflowTooltip) {
	            props.class += ' el-tooltip';
	            props.style = { width: (data.column.realWidth || data.column.width) - 1 + 'px' };
	          }
	          return h(
	            'div',
	            props,
	            [prefix, children]
	          );
	        };
	      }
	      return column;
	    },
	    registerNormalWatchers: function registerNormalWatchers() {
	      var _this3 = this;
	
	      var props = ['label', 'property', 'filters', 'filterMultiple', 'sortable', 'index', 'formatter', 'className', 'labelClassName', 'showOverflowTooltip'];
	      // 一些属性具有别名
	      var aliases = {
	        prop: 'property',
	        realAlign: 'align',
	        realHeaderAlign: 'headerAlign',
	        realWidth: 'width'
	      };
	      var allAliases = props.reduce(function (prev, cur) {
	        prev[cur] = cur;
	        return prev;
	      }, aliases);
	
	      Object.keys(allAliases).forEach(function (key) {
	        var columnKey = aliases[key];
	
	        _this3.$watch(key, function (newVal) {
	          _this3.columnConfig[columnKey] = newVal;
	        });
	      });
	    },
	    registerComplexWatchers: function registerComplexWatchers() {
	      var _this4 = this;
	
	      var props = ['fixed'];
	      var aliases = {
	        realWidth: 'width',
	        realMinWidth: 'minWidth'
	      };
	      var allAliases = props.reduce(function (prev, cur) {
	        prev[cur] = cur;
	        return prev;
	      }, aliases);
	
	      Object.keys(allAliases).forEach(function (key) {
	        var columnKey = aliases[key];
	
	        _this4.$watch(key, function (newVal) {
	          _this4.columnConfig[columnKey] = newVal;
	          var updateColumns = columnKey === 'fixed';
	          _this4.owner.store.scheduleLayout(updateColumns);
	        });
	      });
	    }
	  },
	
	  components: {
	    ElCheckbox: checkbox_default.a
	  },
	
	  beforeCreate: function beforeCreate() {
	    this.row = {};
	    this.column = {};
	    this.$index = 0;
	    this.columnId = '';
	  },
	  created: function created() {
	    var parent = this.columnOrTableParent;
	    this.isSubColumn = this.owner !== parent;
	    this.columnId = (parent.tableId || parent.columnId) + '_column_' + columnIdSeed++;
	
	    var type = this.type || 'default';
	    var sortable = this.sortable === '' ? true : this.sortable;
	    var defaults = table_column_extends({}, cellStarts[type], {
	      id: this.columnId,
	      type: type,
	      property: this.prop || this.property,
	      align: this.realAlign,
	      headerAlign: this.realHeaderAlign,
	      showOverflowTooltip: this.showOverflowTooltip || this.showTooltipWhenOverflow,
	      // filter 相关属性
	      filterable: this.filters || this.filterMethod,
	      filteredValue: [],
	      filterPlacement: '',
	      isColumnGroup: false,
	      filterOpened: false,
	      // sort 相关属性
	      sortable: sortable,
	      // index 列
	      index: this.index
	    });
	
	    var basicProps = ['columnKey', 'label', 'className', 'labelClassName', 'type', 'renderHeader', 'formatter', 'fixed', 'resizable'];
	    var sortProps = ['sortMethod', 'sortBy', 'sortOrders'];
	    var selectProps = ['selectable', 'reserveSelection'];
	    var filterProps = ['filterMethod', 'filters', 'filterMultiple', 'filterOpened', 'filteredValue', 'filterPlacement'];
	
	    var column = this.getPropsData(basicProps, sortProps, selectProps, filterProps);
	    column = mergeOptions(defaults, column);
	
	    // 注意 compose 中函数执行的顺序是从右到左
	    var chains = compose(this.setColumnRenders, this.setColumnWidth, this.setColumnForcedProps);
	    column = chains(column);
	
	    this.columnConfig = column;
	
	    // 注册 watcher
	    this.registerNormalWatchers();
	    this.registerComplexWatchers();
	  },
	  mounted: function mounted() {
	    var owner = this.owner;
	    var parent = this.columnOrTableParent;
	    var children = this.isSubColumn ? parent.$el.children : parent.$refs.hiddenColumns.children;
	    var columnIndex = this.getColumnElIndex(children, this.$el);
	
	    owner.store.commit('insertColumn', this.columnConfig, columnIndex, this.isSubColumn ? parent.columnConfig : null);
	  },
	  destroyed: function destroyed() {
	    if (!this.$parent) return;
	    var parent = this.$parent;
	    this.owner.store.commit('removeColumn', this.columnConfig, this.isSubColumn ? parent.columnConfig : null);
	  },
	  render: function render(h) {
	    // slots 也要渲染，需要计算合并表头
	    return h('div', this.$slots.default);
	  }
	});
	// CONCATENATED MODULE: ./packages/table-column/index.js
	
	
	/* istanbul ignore next */
	table_column.install = function (Vue) {
	  Vue.component(table_column.name, table_column);
	};
	
	/* harmony default export */ var packages_table_column = (table_column);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/picker.vue?vue&type=template&id=79ae069f&
	var pickervue_type_template_id_79ae069f_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return !_vm.ranged
	    ? _c(
	        "el-input",
	        _vm._b(
	          {
	            directives: [
	              {
	                name: "clickoutside",
	                rawName: "v-clickoutside",
	                value: _vm.handleClose,
	                expression: "handleClose"
	              }
	            ],
	            ref: "reference",
	            staticClass: "el-date-editor",
	            class: "el-date-editor--" + _vm.type,
	            attrs: {
	              readonly:
	                !_vm.editable ||
	                _vm.readonly ||
	                _vm.type === "dates" ||
	                _vm.type === "week",
	              disabled: _vm.pickerDisabled,
	              size: _vm.pickerSize,
	              name: _vm.name,
	              placeholder: _vm.placeholder,
	              value: _vm.displayValue,
	              validateEvent: false
	            },
	            on: {
	              focus: _vm.handleFocus,
	              input: function(value) {
	                return (_vm.userInput = value)
	              },
	              change: _vm.handleChange
	            },
	            nativeOn: {
	              keydown: function($event) {
	                return _vm.handleKeydown($event)
	              },
	              mouseenter: function($event) {
	                return _vm.handleMouseEnter($event)
	              },
	              mouseleave: function($event) {
	                _vm.showClose = false
	              }
	            }
	          },
	          "el-input",
	          _vm.firstInputId,
	          false
	        ),
	        [
	          _c("i", {
	            staticClass: "el-input__icon",
	            class: _vm.triggerClass,
	            attrs: { slot: "prefix" },
	            on: { click: _vm.handleFocus },
	            slot: "prefix"
	          }),
	          _vm.haveTrigger
	            ? _c("i", {
	                staticClass: "el-input__icon",
	                class: [_vm.showClose ? "" + _vm.clearIcon : ""],
	                attrs: { slot: "suffix" },
	                on: { click: _vm.handleClickIcon },
	                slot: "suffix"
	              })
	            : _vm._e()
	        ]
	      )
	    : _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "clickoutside",
	              rawName: "v-clickoutside",
	              value: _vm.handleClose,
	              expression: "handleClose"
	            }
	          ],
	          ref: "reference",
	          staticClass: "el-date-editor el-range-editor el-input__inner",
	          class: [
	            "el-date-editor--" + _vm.type,
	            _vm.pickerSize ? "el-range-editor--" + _vm.pickerSize : "",
	            _vm.pickerDisabled ? "is-disabled" : "",
	            _vm.pickerVisible ? "is-active" : ""
	          ],
	          on: {
	            click: _vm.handleRangeClick,
	            mouseenter: _vm.handleMouseEnter,
	            mouseleave: function($event) {
	              _vm.showClose = false
	            },
	            keydown: _vm.handleKeydown
	          }
	        },
	        [
	          _c("i", {
	            class: ["el-input__icon", "el-range__icon", _vm.triggerClass]
	          }),
	          _c(
	            "input",
	            _vm._b(
	              {
	                staticClass: "el-range-input",
	                attrs: {
	                  autocomplete: "off",
	                  placeholder: _vm.startPlaceholder,
	                  disabled: _vm.pickerDisabled,
	                  readonly: !_vm.editable || _vm.readonly,
	                  name: _vm.name && _vm.name[0]
	                },
	                domProps: { value: _vm.displayValue && _vm.displayValue[0] },
	                on: {
	                  input: _vm.handleStartInput,
	                  change: _vm.handleStartChange,
	                  focus: _vm.handleFocus
	                }
	              },
	              "input",
	              _vm.firstInputId,
	              false
	            )
	          ),
	          _vm._t("range-separator", [
	            _c("span", { staticClass: "el-range-separator" }, [
	              _vm._v(_vm._s(_vm.rangeSeparator))
	            ])
	          ]),
	          _c(
	            "input",
	            _vm._b(
	              {
	                staticClass: "el-range-input",
	                attrs: {
	                  autocomplete: "off",
	                  placeholder: _vm.endPlaceholder,
	                  disabled: _vm.pickerDisabled,
	                  readonly: !_vm.editable || _vm.readonly,
	                  name: _vm.name && _vm.name[1]
	                },
	                domProps: { value: _vm.displayValue && _vm.displayValue[1] },
	                on: {
	                  input: _vm.handleEndInput,
	                  change: _vm.handleEndChange,
	                  focus: _vm.handleFocus
	                }
	              },
	              "input",
	              _vm.secondInputId,
	              false
	            )
	          ),
	          _vm.haveTrigger
	            ? _c("i", {
	                staticClass: "el-input__icon el-range__close-icon",
	                class: [_vm.showClose ? "" + _vm.clearIcon : ""],
	                on: { click: _vm.handleClickIcon }
	              })
	            : _vm._e()
	        ],
	        2
	      )
	}
	var pickervue_type_template_id_79ae069f_staticRenderFns = []
	pickervue_type_template_id_79ae069f_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/picker.vue?vue&type=template&id=79ae069f&
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/date-util"
	var date_util_ = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/picker.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	var NewPopper = {
	  props: {
	    appendToBody: vue_popper_default.a.props.appendToBody,
	    offset: vue_popper_default.a.props.offset,
	    boundariesPadding: vue_popper_default.a.props.boundariesPadding,
	    arrowOffset: vue_popper_default.a.props.arrowOffset
	  },
	  methods: vue_popper_default.a.methods,
	  data: function data() {
	    return merge_default()({ visibleArrow: true }, vue_popper_default.a.data);
	  },
	
	  beforeDestroy: vue_popper_default.a.beforeDestroy
	};
	
	var DEFAULT_FORMATS = {
	  date: 'yyyy-MM-dd',
	  month: 'yyyy-MM',
	  datetime: 'yyyy-MM-dd HH:mm:ss',
	  time: 'HH:mm:ss',
	  week: 'yyyywWW',
	  timerange: 'HH:mm:ss',
	  daterange: 'yyyy-MM-dd',
	  monthrange: 'yyyy-MM',
	  datetimerange: 'yyyy-MM-dd HH:mm:ss',
	  year: 'yyyy'
	};
	var HAVE_TRIGGER_TYPES = ['date', 'datetime', 'time', 'time-select', 'week', 'month', 'year', 'daterange', 'monthrange', 'timerange', 'datetimerange', 'dates'];
	var pickervue_type_script_lang_js_DATE_FORMATTER = function DATE_FORMATTER(value, format) {
	  if (format === 'timestamp') return value.getTime();
	  return Object(date_util_["formatDate"])(value, format);
	};
	var pickervue_type_script_lang_js_DATE_PARSER = function DATE_PARSER(text, format) {
	  if (format === 'timestamp') return new Date(Number(text));
	  return Object(date_util_["parseDate"])(text, format);
	};
	var RANGE_FORMATTER = function RANGE_FORMATTER(value, format) {
	  if (Array.isArray(value) && value.length === 2) {
	    var start = value[0];
	    var end = value[1];
	
	    if (start && end) {
	      return [pickervue_type_script_lang_js_DATE_FORMATTER(start, format), pickervue_type_script_lang_js_DATE_FORMATTER(end, format)];
	    }
	  }
	  return '';
	};
	var RANGE_PARSER = function RANGE_PARSER(array, format, separator) {
	  if (!Array.isArray(array)) {
	    array = array.split(separator);
	  }
	  if (array.length === 2) {
	    var range1 = array[0];
	    var range2 = array[1];
	
	    return [pickervue_type_script_lang_js_DATE_PARSER(range1, format), pickervue_type_script_lang_js_DATE_PARSER(range2, format)];
	  }
	  return [];
	};
	var TYPE_VALUE_RESOLVER_MAP = {
	  default: {
	    formatter: function formatter(value) {
	      if (!value) return '';
	      return '' + value;
	    },
	    parser: function parser(text) {
	      if (text === undefined || text === '') return null;
	      return text;
	    }
	  },
	  week: {
	    formatter: function formatter(value, format) {
	      var week = Object(date_util_["getWeekNumber"])(value);
	      var month = value.getMonth();
	      var trueDate = new Date(value);
	      if (week === 1 && month === 11) {
	        trueDate.setHours(0, 0, 0, 0);
	        trueDate.setDate(trueDate.getDate() + 3 - (trueDate.getDay() + 6) % 7);
	      }
	      var date = Object(date_util_["formatDate"])(trueDate, format);
	
	      date = /WW/.test(date) ? date.replace(/WW/, week < 10 ? '0' + week : week) : date.replace(/W/, week);
	      return date;
	    },
	    parser: function parser(text, format) {
	      // parse as if a normal date
	      return TYPE_VALUE_RESOLVER_MAP.date.parser(text, format);
	    }
	  },
	  date: {
	    formatter: pickervue_type_script_lang_js_DATE_FORMATTER,
	    parser: pickervue_type_script_lang_js_DATE_PARSER
	  },
	  datetime: {
	    formatter: pickervue_type_script_lang_js_DATE_FORMATTER,
	    parser: pickervue_type_script_lang_js_DATE_PARSER
	  },
	  daterange: {
	    formatter: RANGE_FORMATTER,
	    parser: RANGE_PARSER
	  },
	  monthrange: {
	    formatter: RANGE_FORMATTER,
	    parser: RANGE_PARSER
	  },
	  datetimerange: {
	    formatter: RANGE_FORMATTER,
	    parser: RANGE_PARSER
	  },
	  timerange: {
	    formatter: RANGE_FORMATTER,
	    parser: RANGE_PARSER
	  },
	  time: {
	    formatter: pickervue_type_script_lang_js_DATE_FORMATTER,
	    parser: pickervue_type_script_lang_js_DATE_PARSER
	  },
	  month: {
	    formatter: pickervue_type_script_lang_js_DATE_FORMATTER,
	    parser: pickervue_type_script_lang_js_DATE_PARSER
	  },
	  year: {
	    formatter: pickervue_type_script_lang_js_DATE_FORMATTER,
	    parser: pickervue_type_script_lang_js_DATE_PARSER
	  },
	  number: {
	    formatter: function formatter(value) {
	      if (!value) return '';
	      return '' + value;
	    },
	    parser: function parser(text) {
	      var result = Number(text);
	
	      if (!isNaN(text)) {
	        return result;
	      } else {
	        return null;
	      }
	    }
	  },
	  dates: {
	    formatter: function formatter(value, format) {
	      return value.map(function (date) {
	        return pickervue_type_script_lang_js_DATE_FORMATTER(date, format);
	      });
	    },
	    parser: function parser(value, format) {
	      return (typeof value === 'string' ? value.split(', ') : value).map(function (date) {
	        return date instanceof Date ? date : pickervue_type_script_lang_js_DATE_PARSER(date, format);
	      });
	    }
	  }
	};
	var PLACEMENT_MAP = {
	  left: 'bottom-start',
	  center: 'bottom',
	  right: 'bottom-end'
	};
	
	var parseAsFormatAndType = function parseAsFormatAndType(value, customFormat, type) {
	  var rangeSeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '-';
	
	  if (!value) return null;
	  var parser = (TYPE_VALUE_RESOLVER_MAP[type] || TYPE_VALUE_RESOLVER_MAP['default']).parser;
	  var format = customFormat || DEFAULT_FORMATS[type];
	  return parser(value, format, rangeSeparator);
	};
	
	var formatAsFormatAndType = function formatAsFormatAndType(value, customFormat, type) {
	  if (!value) return null;
	  var formatter = (TYPE_VALUE_RESOLVER_MAP[type] || TYPE_VALUE_RESOLVER_MAP['default']).formatter;
	  var format = customFormat || DEFAULT_FORMATS[type];
	  return formatter(value, format);
	};
	
	/*
	 * Considers:
	 *   1. Date object
	 *   2. date string
	 *   3. array of 1 or 2
	 */
	var valueEquals = function valueEquals(a, b) {
	  // considers Date object and string
	  var dateEquals = function dateEquals(a, b) {
	    var aIsDate = a instanceof Date;
	    var bIsDate = b instanceof Date;
	    if (aIsDate && bIsDate) {
	      return a.getTime() === b.getTime();
	    }
	    if (!aIsDate && !bIsDate) {
	      return a === b;
	    }
	    return false;
	  };
	
	  var aIsArray = a instanceof Array;
	  var bIsArray = b instanceof Array;
	  if (aIsArray && bIsArray) {
	    if (a.length !== b.length) {
	      return false;
	    }
	    return a.every(function (item, index) {
	      return dateEquals(item, b[index]);
	    });
	  }
	  if (!aIsArray && !bIsArray) {
	    return dateEquals(a, b);
	  }
	  return false;
	};
	
	var isString = function isString(val) {
	  return typeof val === 'string' || val instanceof String;
	};
	
	var pickervue_type_script_lang_js_validator = function validator(val) {
	  // either: String, Array of String, null / undefined
	  return val === null || val === undefined || isString(val) || Array.isArray(val) && val.length === 2 && val.every(isString);
	};
	
	/* harmony default export */ var pickervue_type_script_lang_js_ = ({
	  mixins: [emitter_default.a, NewPopper],
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  props: {
	    size: String,
	    format: String,
	    valueFormat: String,
	    readonly: Boolean,
	    placeholder: String,
	    startPlaceholder: String,
	    endPlaceholder: String,
	    prefixIcon: String,
	    clearIcon: {
	      type: String,
	      default: 'el-icon-circle-close'
	    },
	    name: {
	      default: '',
	      validator: pickervue_type_script_lang_js_validator
	    },
	    disabled: Boolean,
	    clearable: {
	      type: Boolean,
	      default: true
	    },
	    id: {
	      default: '',
	      validator: pickervue_type_script_lang_js_validator
	    },
	    popperClass: String,
	    editable: {
	      type: Boolean,
	      default: true
	    },
	    align: {
	      type: String,
	      default: 'left'
	    },
	    value: {},
	    defaultValue: {},
	    defaultTime: {},
	    rangeSeparator: {
	      default: '-'
	    },
	    pickerOptions: {},
	    unlinkPanels: Boolean,
	    validateEvent: {
	      type: Boolean,
	      default: true
	    }
	  },
	
	  components: { ElInput: input_default.a },
	
	  directives: { Clickoutside: clickoutside_default.a },
	
	  data: function data() {
	    return {
	      pickerVisible: false,
	      showClose: false,
	      userInput: null,
	      valueOnOpen: null, // value when picker opens, used to determine whether to emit change
	      unwatchPickerOptions: null
	    };
	  },
	
	
	  watch: {
	    pickerVisible: function pickerVisible(val) {
	      if (this.readonly || this.pickerDisabled) return;
	      if (val) {
	        this.showPicker();
	        this.valueOnOpen = Array.isArray(this.value) ? [].concat(this.value) : this.value;
	      } else {
	        this.hidePicker();
	        this.emitChange(this.value);
	        this.userInput = null;
	        if (this.validateEvent) {
	          this.dispatch('ElFormItem', 'el.form.blur');
	        }
	        this.$emit('blur', this);
	        this.blur();
	      }
	    },
	
	    parsedValue: {
	      immediate: true,
	      handler: function handler(val) {
	        if (this.picker) {
	          this.picker.value = val;
	        }
	      }
	    },
	    defaultValue: function defaultValue(val) {
	      // NOTE: should eventually move to jsx style picker + panel ?
	      if (this.picker) {
	        this.picker.defaultValue = val;
	      }
	    },
	    value: function value(val, oldVal) {
	      if (!valueEquals(val, oldVal) && !this.pickerVisible && this.validateEvent) {
	        this.dispatch('ElFormItem', 'el.form.change', val);
	      }
	    }
	  },
	
	  computed: {
	    ranged: function ranged() {
	      return this.type.indexOf('range') > -1;
	    },
	    reference: function reference() {
	      var reference = this.$refs.reference;
	      return reference.$el || reference;
	    },
	    refInput: function refInput() {
	      if (this.reference) {
	        return [].slice.call(this.reference.querySelectorAll('input'));
	      }
	      return [];
	    },
	    valueIsEmpty: function valueIsEmpty() {
	      var val = this.value;
	      if (Array.isArray(val)) {
	        for (var i = 0, len = val.length; i < len; i++) {
	          if (val[i]) {
	            return false;
	          }
	        }
	      } else {
	        if (val) {
	          return false;
	        }
	      }
	      return true;
	    },
	    triggerClass: function triggerClass() {
	      return this.prefixIcon || (this.type.indexOf('time') !== -1 ? 'el-icon-time' : 'el-icon-date');
	    },
	    selectionMode: function selectionMode() {
	      if (this.type === 'week') {
	        return 'week';
	      } else if (this.type === 'month') {
	        return 'month';
	      } else if (this.type === 'year') {
	        return 'year';
	      } else if (this.type === 'dates') {
	        return 'dates';
	      }
	
	      return 'day';
	    },
	    haveTrigger: function haveTrigger() {
	      if (typeof this.showTrigger !== 'undefined') {
	        return this.showTrigger;
	      }
	      return HAVE_TRIGGER_TYPES.indexOf(this.type) !== -1;
	    },
	    displayValue: function displayValue() {
	      var formattedValue = formatAsFormatAndType(this.parsedValue, this.format, this.type, this.rangeSeparator);
	      if (Array.isArray(this.userInput)) {
	        return [this.userInput[0] || formattedValue && formattedValue[0] || '', this.userInput[1] || formattedValue && formattedValue[1] || ''];
	      } else if (this.userInput !== null) {
	        return this.userInput;
	      } else if (formattedValue) {
	        return this.type === 'dates' ? formattedValue.join(', ') : formattedValue;
	      } else {
	        return '';
	      }
	    },
	    parsedValue: function parsedValue() {
	      if (!this.value) return this.value; // component value is not set
	      if (this.type === 'time-select') return this.value; // time-select does not require parsing, this might change in next major version
	
	      var valueIsDateObject = Object(date_util_["isDateObject"])(this.value) || Array.isArray(this.value) && this.value.every(date_util_["isDateObject"]);
	      if (valueIsDateObject) {
	        return this.value;
	      }
	
	      if (this.valueFormat) {
	        return parseAsFormatAndType(this.value, this.valueFormat, this.type, this.rangeSeparator) || this.value;
	      }
	
	      // NOTE: deal with common but incorrect usage, should remove in next major version
	      // user might provide string / timestamp without value-format, coerce them into date (or array of date)
	      return Array.isArray(this.value) ? this.value.map(function (val) {
	        return new Date(val);
	      }) : new Date(this.value);
	    },
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    pickerSize: function pickerSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    pickerDisabled: function pickerDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    },
	    firstInputId: function firstInputId() {
	      var obj = {};
	      var id = void 0;
	      if (this.ranged) {
	        id = this.id && this.id[0];
	      } else {
	        id = this.id;
	      }
	      if (id) obj.id = id;
	      return obj;
	    },
	    secondInputId: function secondInputId() {
	      var obj = {};
	      var id = void 0;
	      if (this.ranged) {
	        id = this.id && this.id[1];
	      }
	      if (id) obj.id = id;
	      return obj;
	    }
	  },
	
	  created: function created() {
	    // vue-popper
	    this.popperOptions = {
	      boundariesPadding: 0,
	      gpuAcceleration: false
	    };
	    this.placement = PLACEMENT_MAP[this.align] || PLACEMENT_MAP.left;
	
	    this.$on('fieldReset', this.handleFieldReset);
	  },
	
	
	  methods: {
	    focus: function focus() {
	      if (!this.ranged) {
	        this.$refs.reference.focus();
	      } else {
	        this.handleFocus();
	      }
	    },
	    blur: function blur() {
	      this.refInput.forEach(function (input) {
	        return input.blur();
	      });
	    },
	
	
	    // {parse, formatTo} Value deals maps component value with internal Date
	    parseValue: function parseValue(value) {
	      var isParsed = Object(date_util_["isDateObject"])(value) || Array.isArray(value) && value.every(date_util_["isDateObject"]);
	      if (this.valueFormat && !isParsed) {
	        return parseAsFormatAndType(value, this.valueFormat, this.type, this.rangeSeparator) || value;
	      } else {
	        return value;
	      }
	    },
	    formatToValue: function formatToValue(date) {
	      var isFormattable = Object(date_util_["isDateObject"])(date) || Array.isArray(date) && date.every(date_util_["isDateObject"]);
	      if (this.valueFormat && isFormattable) {
	        return formatAsFormatAndType(date, this.valueFormat, this.type, this.rangeSeparator);
	      } else {
	        return date;
	      }
	    },
	
	
	    // {parse, formatTo} String deals with user input
	    parseString: function parseString(value) {
	      var type = Array.isArray(value) ? this.type : this.type.replace('range', '');
	      return parseAsFormatAndType(value, this.format, type);
	    },
	    formatToString: function formatToString(value) {
	      var type = Array.isArray(value) ? this.type : this.type.replace('range', '');
	      return formatAsFormatAndType(value, this.format, type);
	    },
	    handleMouseEnter: function handleMouseEnter() {
	      if (this.readonly || this.pickerDisabled) return;
	      if (!this.valueIsEmpty && this.clearable) {
	        this.showClose = true;
	      }
	    },
	    handleChange: function handleChange() {
	      if (this.userInput) {
	        var value = this.parseString(this.displayValue);
	        if (value) {
	          this.picker.value = value;
	          if (this.isValidValue(value)) {
	            this.emitInput(value);
	            this.userInput = null;
	          }
	        }
	      }
	      if (this.userInput === '') {
	        this.emitInput(null);
	        this.emitChange(null);
	        this.userInput = null;
	      }
	    },
	    handleStartInput: function handleStartInput(event) {
	      if (this.userInput) {
	        this.userInput = [event.target.value, this.userInput[1]];
	      } else {
	        this.userInput = [event.target.value, null];
	      }
	    },
	    handleEndInput: function handleEndInput(event) {
	      if (this.userInput) {
	        this.userInput = [this.userInput[0], event.target.value];
	      } else {
	        this.userInput = [null, event.target.value];
	      }
	    },
	    handleStartChange: function handleStartChange(event) {
	      var value = this.parseString(this.userInput && this.userInput[0]);
	      if (value) {
	        this.userInput = [this.formatToString(value), this.displayValue[1]];
	        var newValue = [value, this.picker.value && this.picker.value[1]];
	        this.picker.value = newValue;
	        if (this.isValidValue(newValue)) {
	          this.emitInput(newValue);
	          this.userInput = null;
	        }
	      }
	    },
	    handleEndChange: function handleEndChange(event) {
	      var value = this.parseString(this.userInput && this.userInput[1]);
	      if (value) {
	        this.userInput = [this.displayValue[0], this.formatToString(value)];
	        var newValue = [this.picker.value && this.picker.value[0], value];
	        this.picker.value = newValue;
	        if (this.isValidValue(newValue)) {
	          this.emitInput(newValue);
	          this.userInput = null;
	        }
	      }
	    },
	    handleClickIcon: function handleClickIcon(event) {
	      if (this.readonly || this.pickerDisabled) return;
	      if (this.showClose) {
	        this.valueOnOpen = this.value;
	        event.stopPropagation();
	        this.emitInput(null);
	        this.emitChange(null);
	        this.showClose = false;
	        if (this.picker && typeof this.picker.handleClear === 'function') {
	          this.picker.handleClear();
	        }
	      } else {
	        this.pickerVisible = !this.pickerVisible;
	      }
	    },
	    handleClose: function handleClose() {
	      if (!this.pickerVisible) return;
	      this.pickerVisible = false;
	
	      if (this.type === 'dates') {
	        // restore to former value
	        var oldValue = parseAsFormatAndType(this.valueOnOpen, this.valueFormat, this.type, this.rangeSeparator) || this.valueOnOpen;
	        this.emitInput(oldValue);
	      }
	    },
	    handleFieldReset: function handleFieldReset(initialValue) {
	      this.userInput = initialValue === '' ? null : initialValue;
	    },
	    handleFocus: function handleFocus() {
	      var type = this.type;
	
	      if (HAVE_TRIGGER_TYPES.indexOf(type) !== -1 && !this.pickerVisible) {
	        this.pickerVisible = true;
	      }
	      this.$emit('focus', this);
	    },
	    handleKeydown: function handleKeydown(event) {
	      var _this = this;
	
	      var keyCode = event.keyCode;
	
	      // ESC
	      if (keyCode === 27) {
	        this.pickerVisible = false;
	        event.stopPropagation();
	        return;
	      }
	
	      // Tab
	      if (keyCode === 9) {
	        if (!this.ranged) {
	          this.handleChange();
	          this.pickerVisible = this.picker.visible = false;
	          this.blur();
	          event.stopPropagation();
	        } else {
	          // user may change focus between two input
	          setTimeout(function () {
	            if (_this.refInput.indexOf(document.activeElement) === -1) {
	              _this.pickerVisible = false;
	              _this.blur();
	              event.stopPropagation();
	            }
	          }, 0);
	        }
	        return;
	      }
	
	      // Enter
	      if (keyCode === 13) {
	        if (this.userInput === '' || this.isValidValue(this.parseString(this.displayValue))) {
	          this.handleChange();
	          this.pickerVisible = this.picker.visible = false;
	          this.blur();
	        }
	        event.stopPropagation();
	        return;
	      }
	
	      // if user is typing, do not let picker handle key input
	      if (this.userInput) {
	        event.stopPropagation();
	        return;
	      }
	
	      // delegate other keys to panel
	      if (this.picker && this.picker.handleKeydown) {
	        this.picker.handleKeydown(event);
	      }
	    },
	    handleRangeClick: function handleRangeClick() {
	      var type = this.type;
	
	      if (HAVE_TRIGGER_TYPES.indexOf(type) !== -1 && !this.pickerVisible) {
	        this.pickerVisible = true;
	      }
	      this.$emit('focus', this);
	    },
	    hidePicker: function hidePicker() {
	      if (this.picker) {
	        this.picker.resetView && this.picker.resetView();
	        this.pickerVisible = this.picker.visible = false;
	        this.destroyPopper();
	      }
	    },
	    showPicker: function showPicker() {
	      var _this2 = this;
	
	      if (this.$isServer) return;
	      if (!this.picker) {
	        this.mountPicker();
	      }
	      this.pickerVisible = this.picker.visible = true;
	
	      this.updatePopper();
	
	      this.picker.value = this.parsedValue;
	      this.picker.resetView && this.picker.resetView();
	
	      this.$nextTick(function () {
	        _this2.picker.adjustSpinners && _this2.picker.adjustSpinners();
	      });
	    },
	    mountPicker: function mountPicker() {
	      var _this3 = this;
	
	      this.picker = new external_vue_default.a(this.panel).$mount();
	      this.picker.defaultValue = this.defaultValue;
	      this.picker.defaultTime = this.defaultTime;
	      this.picker.popperClass = this.popperClass;
	      this.popperElm = this.picker.$el;
	      this.picker.width = this.reference.getBoundingClientRect().width;
	      this.picker.showTime = this.type === 'datetime' || this.type === 'datetimerange';
	      this.picker.selectionMode = this.selectionMode;
	      this.picker.unlinkPanels = this.unlinkPanels;
	      this.picker.arrowControl = this.arrowControl || this.timeArrowControl || false;
	      this.$watch('format', function (format) {
	        _this3.picker.format = format;
	      });
	
	      var updateOptions = function updateOptions() {
	        var options = _this3.pickerOptions;
	
	        if (options && options.selectableRange) {
	          var ranges = options.selectableRange;
	          var parser = TYPE_VALUE_RESOLVER_MAP.datetimerange.parser;
	          var format = DEFAULT_FORMATS.timerange;
	
	          ranges = Array.isArray(ranges) ? ranges : [ranges];
	          _this3.picker.selectableRange = ranges.map(function (range) {
	            return parser(range, format, _this3.rangeSeparator);
	          });
	        }
	
	        for (var option in options) {
	          if (options.hasOwnProperty(option) &&
	          // 忽略 time-picker 的该配置项
	          option !== 'selectableRange') {
	            _this3.picker[option] = options[option];
	          }
	        }
	
	        // main format must prevail over undocumented pickerOptions.format
	        if (_this3.format) {
	          _this3.picker.format = _this3.format;
	        }
	      };
	      updateOptions();
	      this.unwatchPickerOptions = this.$watch('pickerOptions', function () {
	        return updateOptions();
	      }, { deep: true });
	      this.$el.appendChild(this.picker.$el);
	      this.picker.resetView && this.picker.resetView();
	
	      this.picker.$on('dodestroy', this.doDestroy);
	      this.picker.$on('pick', function () {
	        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	        var visible = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        _this3.userInput = null;
	        _this3.pickerVisible = _this3.picker.visible = visible;
	        _this3.emitInput(date);
	        _this3.picker.resetView && _this3.picker.resetView();
	      });
	
	      this.picker.$on('select-range', function (start, end, pos) {
	        if (_this3.refInput.length === 0) return;
	        if (!pos || pos === 'min') {
	          _this3.refInput[0].setSelectionRange(start, end);
	          _this3.refInput[0].focus();
	        } else if (pos === 'max') {
	          _this3.refInput[1].setSelectionRange(start, end);
	          _this3.refInput[1].focus();
	        }
	      });
	    },
	    unmountPicker: function unmountPicker() {
	      if (this.picker) {
	        this.picker.$destroy();
	        this.picker.$off();
	        if (typeof this.unwatchPickerOptions === 'function') {
	          this.unwatchPickerOptions();
	        }
	        this.picker.$el.parentNode.removeChild(this.picker.$el);
	      }
	    },
	    emitChange: function emitChange(val) {
	      // determine user real change only
	      if (!valueEquals(val, this.valueOnOpen)) {
	        this.$emit('change', val);
	        this.valueOnOpen = val;
	        if (this.validateEvent) {
	          this.dispatch('ElFormItem', 'el.form.change', val);
	        }
	      }
	    },
	    emitInput: function emitInput(val) {
	      var formatted = this.formatToValue(val);
	      if (!valueEquals(this.value, formatted)) {
	        this.$emit('input', formatted);
	      }
	    },
	    isValidValue: function isValidValue(value) {
	      if (!this.picker) {
	        this.mountPicker();
	      }
	      if (this.picker.isValidValue) {
	        return value && this.picker.isValidValue(value);
	      } else {
	        return true;
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/picker.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_pickervue_type_script_lang_js_ = (pickervue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/picker.vue
	
	
	
	
	
	/* normalize component */
	
	var picker_component = normalizeComponent(
	  src_pickervue_type_script_lang_js_,
	  pickervue_type_template_id_79ae069f_render,
	  pickervue_type_template_id_79ae069f_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var picker_api; }
	picker_component.options.__file = "packages/date-picker/src/picker.vue"
	/* harmony default export */ var picker = (picker_component.exports);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/date.vue?vue&type=template&id=2440d4ea&
	var datevue_type_template_id_2440d4ea_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    {
	      attrs: { name: "el-zoom-in-top" },
	      on: { "after-enter": _vm.handleEnter, "after-leave": _vm.handleLeave }
	    },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.visible,
	              expression: "visible"
	            }
	          ],
	          staticClass: "el-picker-panel el-date-picker el-popper",
	          class: [
	            {
	              "has-sidebar": _vm.$slots.sidebar || _vm.shortcuts,
	              "has-time": _vm.showTime
	            },
	            _vm.popperClass
	          ]
	        },
	        [
	          _c(
	            "div",
	            { staticClass: "el-picker-panel__body-wrapper" },
	            [
	              _vm._t("sidebar"),
	              _vm.shortcuts
	                ? _c(
	                    "div",
	                    { staticClass: "el-picker-panel__sidebar" },
	                    _vm._l(_vm.shortcuts, function(shortcut, key) {
	                      return _c(
	                        "button",
	                        {
	                          key: key,
	                          staticClass: "el-picker-panel__shortcut",
	                          attrs: { type: "button" },
	                          on: {
	                            click: function($event) {
	                              _vm.handleShortcutClick(shortcut)
	                            }
	                          }
	                        },
	                        [_vm._v(_vm._s(shortcut.text))]
	                      )
	                    }),
	                    0
	                  )
	                : _vm._e(),
	              _c("div", { staticClass: "el-picker-panel__body" }, [
	                _vm.showTime
	                  ? _c("div", { staticClass: "el-date-picker__time-header" }, [
	                      _c(
	                        "span",
	                        { staticClass: "el-date-picker__editor-wrap" },
	                        [
	                          _c("el-input", {
	                            attrs: {
	                              placeholder: _vm.t("el.datepicker.selectDate"),
	                              value: _vm.visibleDate,
	                              size: "small"
	                            },
	                            on: {
	                              input: function(val) {
	                                return (_vm.userInputDate = val)
	                              },
	                              change: _vm.handleVisibleDateChange
	                            }
	                          })
	                        ],
	                        1
	                      ),
	                      _c(
	                        "span",
	                        {
	                          directives: [
	                            {
	                              name: "clickoutside",
	                              rawName: "v-clickoutside",
	                              value: _vm.handleTimePickClose,
	                              expression: "handleTimePickClose"
	                            }
	                          ],
	                          staticClass: "el-date-picker__editor-wrap"
	                        },
	                        [
	                          _c("el-input", {
	                            ref: "input",
	                            attrs: {
	                              placeholder: _vm.t("el.datepicker.selectTime"),
	                              value: _vm.visibleTime,
	                              size: "small"
	                            },
	                            on: {
	                              focus: function($event) {
	                                _vm.timePickerVisible = true
	                              },
	                              input: function(val) {
	                                return (_vm.userInputTime = val)
	                              },
	                              change: _vm.handleVisibleTimeChange
	                            }
	                          }),
	                          _c("time-picker", {
	                            ref: "timepicker",
	                            attrs: {
	                              "time-arrow-control": _vm.arrowControl,
	                              visible: _vm.timePickerVisible
	                            },
	                            on: {
	                              pick: _vm.handleTimePick,
	                              mounted: _vm.proxyTimePickerDataProperties
	                            }
	                          })
	                        ],
	                        1
	                      )
	                    ])
	                  : _vm._e(),
	                _c(
	                  "div",
	                  {
	                    directives: [
	                      {
	                        name: "show",
	                        rawName: "v-show",
	                        value: _vm.currentView !== "time",
	                        expression: "currentView !== 'time'"
	                      }
	                    ],
	                    staticClass: "el-date-picker__header",
	                    class: {
	                      "el-date-picker__header--bordered":
	                        _vm.currentView === "year" ||
	                        _vm.currentView === "month"
	                    }
	                  },
	                  [
	                    _c("button", {
	                      staticClass:
	                        "el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-d-arrow-left",
	                      attrs: {
	                        type: "button",
	                        "aria-label": _vm.t("el.datepicker.prevYear")
	                      },
	                      on: { click: _vm.prevYear }
	                    }),
	                    _c("button", {
	                      directives: [
	                        {
	                          name: "show",
	                          rawName: "v-show",
	                          value: _vm.currentView === "date",
	                          expression: "currentView === 'date'"
	                        }
	                      ],
	                      staticClass:
	                        "el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-arrow-left",
	                      attrs: {
	                        type: "button",
	                        "aria-label": _vm.t("el.datepicker.prevMonth")
	                      },
	                      on: { click: _vm.prevMonth }
	                    }),
	                    _c(
	                      "span",
	                      {
	                        staticClass: "el-date-picker__header-label",
	                        attrs: { role: "button" },
	                        on: { click: _vm.showYearPicker }
	                      },
	                      [_vm._v(_vm._s(_vm.yearLabel))]
	                    ),
	                    _c(
	                      "span",
	                      {
	                        directives: [
	                          {
	                            name: "show",
	                            rawName: "v-show",
	                            value: _vm.currentView === "date",
	                            expression: "currentView === 'date'"
	                          }
	                        ],
	                        staticClass: "el-date-picker__header-label",
	                        class: { active: _vm.currentView === "month" },
	                        attrs: { role: "button" },
	                        on: { click: _vm.showMonthPicker }
	                      },
	                      [
	                        _vm._v(
	                          _vm._s(_vm.t("el.datepicker.month" + (_vm.month + 1)))
	                        )
	                      ]
	                    ),
	                    _c("button", {
	                      staticClass:
	                        "el-picker-panel__icon-btn el-date-picker__next-btn el-icon-d-arrow-right",
	                      attrs: {
	                        type: "button",
	                        "aria-label": _vm.t("el.datepicker.nextYear")
	                      },
	                      on: { click: _vm.nextYear }
	                    }),
	                    _c("button", {
	                      directives: [
	                        {
	                          name: "show",
	                          rawName: "v-show",
	                          value: _vm.currentView === "date",
	                          expression: "currentView === 'date'"
	                        }
	                      ],
	                      staticClass:
	                        "el-picker-panel__icon-btn el-date-picker__next-btn el-icon-arrow-right",
	                      attrs: {
	                        type: "button",
	                        "aria-label": _vm.t("el.datepicker.nextMonth")
	                      },
	                      on: { click: _vm.nextMonth }
	                    })
	                  ]
	                ),
	                _c(
	                  "div",
	                  { staticClass: "el-picker-panel__content" },
	                  [
	                    _c("date-table", {
	                      directives: [
	                        {
	                          name: "show",
	                          rawName: "v-show",
	                          value: _vm.currentView === "date",
	                          expression: "currentView === 'date'"
	                        }
	                      ],
	                      attrs: {
	                        "selection-mode": _vm.selectionMode,
	                        "first-day-of-week": _vm.firstDayOfWeek,
	                        value: _vm.value,
	                        "default-value": _vm.defaultValue
	                          ? new Date(_vm.defaultValue)
	                          : null,
	                        date: _vm.date,
	                        "cell-class-name": _vm.cellClassName,
	                        "disabled-date": _vm.disabledDate
	                      },
	                      on: { pick: _vm.handleDatePick }
	                    }),
	                    _c("year-table", {
	                      directives: [
	                        {
	                          name: "show",
	                          rawName: "v-show",
	                          value: _vm.currentView === "year",
	                          expression: "currentView === 'year'"
	                        }
	                      ],
	                      attrs: {
	                        value: _vm.value,
	                        "default-value": _vm.defaultValue
	                          ? new Date(_vm.defaultValue)
	                          : null,
	                        date: _vm.date,
	                        "disabled-date": _vm.disabledDate
	                      },
	                      on: { pick: _vm.handleYearPick }
	                    }),
	                    _c("month-table", {
	                      directives: [
	                        {
	                          name: "show",
	                          rawName: "v-show",
	                          value: _vm.currentView === "month",
	                          expression: "currentView === 'month'"
	                        }
	                      ],
	                      attrs: {
	                        value: _vm.value,
	                        "default-value": _vm.defaultValue
	                          ? new Date(_vm.defaultValue)
	                          : null,
	                        date: _vm.date,
	                        "disabled-date": _vm.disabledDate
	                      },
	                      on: { pick: _vm.handleMonthPick }
	                    })
	                  ],
	                  1
	                )
	              ])
	            ],
	            2
	          ),
	          _c(
	            "div",
	            {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value: _vm.footerVisible && _vm.currentView === "date",
	                  expression: "footerVisible && currentView === 'date'"
	                }
	              ],
	              staticClass: "el-picker-panel__footer"
	            },
	            [
	              _c(
	                "el-button",
	                {
	                  directives: [
	                    {
	                      name: "show",
	                      rawName: "v-show",
	                      value: _vm.selectionMode !== "dates",
	                      expression: "selectionMode !== 'dates'"
	                    }
	                  ],
	                  staticClass: "el-picker-panel__link-btn",
	                  attrs: { size: "mini", type: "text" },
	                  on: { click: _vm.changeToNow }
	                },
	                [
	                  _vm._v(
	                    "\n        " +
	                      _vm._s(_vm.t("el.datepicker.now")) +
	                      "\n      "
	                  )
	                ]
	              ),
	              _c(
	                "el-button",
	                {
	                  staticClass: "el-picker-panel__link-btn",
	                  attrs: { plain: "", size: "mini" },
	                  on: { click: _vm.confirm }
	                },
	                [
	                  _vm._v(
	                    "\n        " +
	                      _vm._s(_vm.t("el.datepicker.confirm")) +
	                      "\n      "
	                  )
	                ]
	              )
	            ],
	            1
	          )
	        ]
	      )
	    ]
	  )
	}
	var datevue_type_template_id_2440d4ea_staticRenderFns = []
	datevue_type_template_id_2440d4ea_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/date.vue?vue&type=template&id=2440d4ea&
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time.vue?vue&type=template&id=3d939089&
	var timevue_type_template_id_3d939089_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    {
	      attrs: { name: "el-zoom-in-top" },
	      on: {
	        "after-leave": function($event) {
	          _vm.$emit("dodestroy")
	        }
	      }
	    },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.visible,
	              expression: "visible"
	            }
	          ],
	          staticClass: "el-time-panel el-popper",
	          class: _vm.popperClass
	        },
	        [
	          _c(
	            "div",
	            {
	              staticClass: "el-time-panel__content",
	              class: { "has-seconds": _vm.showSeconds }
	            },
	            [
	              _c("time-spinner", {
	                ref: "spinner",
	                attrs: {
	                  "arrow-control": _vm.useArrow,
	                  "show-seconds": _vm.showSeconds,
	                  "am-pm-mode": _vm.amPmMode,
	                  date: _vm.date
	                },
	                on: {
	                  change: _vm.handleChange,
	                  "select-range": _vm.setSelectionRange
	                }
	              })
	            ],
	            1
	          ),
	          _c("div", { staticClass: "el-time-panel__footer" }, [
	            _c(
	              "button",
	              {
	                staticClass: "el-time-panel__btn cancel",
	                attrs: { type: "button" },
	                on: { click: _vm.handleCancel }
	              },
	              [_vm._v(_vm._s(_vm.t("el.datepicker.cancel")))]
	            ),
	            _c(
	              "button",
	              {
	                staticClass: "el-time-panel__btn",
	                class: { confirm: !_vm.disabled },
	                attrs: { type: "button" },
	                on: {
	                  click: function($event) {
	                    _vm.handleConfirm()
	                  }
	                }
	              },
	              [_vm._v(_vm._s(_vm.t("el.datepicker.confirm")))]
	            )
	          ])
	        ]
	      )
	    ]
	  )
	}
	var timevue_type_template_id_3d939089_staticRenderFns = []
	timevue_type_template_id_3d939089_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/time.vue?vue&type=template&id=3d939089&
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/time-spinner.vue?vue&type=template&id=1facadeb&
	var time_spinnervue_type_template_id_1facadeb_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-time-spinner",
	      class: { "has-seconds": _vm.showSeconds }
	    },
	    [
	      !_vm.arrowControl
	        ? [
	            _c(
	              "el-scrollbar",
	              {
	                ref: "hours",
	                staticClass: "el-time-spinner__wrapper",
	                attrs: {
	                  "wrap-style": "max-height: inherit;",
	                  "view-class": "el-time-spinner__list",
	                  noresize: "",
	                  tag: "ul"
	                },
	                nativeOn: {
	                  mouseenter: function($event) {
	                    _vm.emitSelectRange("hours")
	                  },
	                  mousemove: function($event) {
	                    _vm.adjustCurrentSpinner("hours")
	                  }
	                }
	              },
	              _vm._l(_vm.hoursList, function(disabled, hour) {
	                return _c(
	                  "li",
	                  {
	                    key: hour,
	                    staticClass: "el-time-spinner__item",
	                    class: { active: hour === _vm.hours, disabled: disabled },
	                    on: {
	                      click: function($event) {
	                        _vm.handleClick("hours", {
	                          value: hour,
	                          disabled: disabled
	                        })
	                      }
	                    }
	                  },
	                  [
	                    _vm._v(
	                      _vm._s(
	                        ("0" + (_vm.amPmMode ? hour % 12 || 12 : hour)).slice(
	                          -2
	                        )
	                      ) + _vm._s(_vm.amPm(hour))
	                    )
	                  ]
	                )
	              }),
	              0
	            ),
	            _c(
	              "el-scrollbar",
	              {
	                ref: "minutes",
	                staticClass: "el-time-spinner__wrapper",
	                attrs: {
	                  "wrap-style": "max-height: inherit;",
	                  "view-class": "el-time-spinner__list",
	                  noresize: "",
	                  tag: "ul"
	                },
	                nativeOn: {
	                  mouseenter: function($event) {
	                    _vm.emitSelectRange("minutes")
	                  },
	                  mousemove: function($event) {
	                    _vm.adjustCurrentSpinner("minutes")
	                  }
	                }
	              },
	              _vm._l(_vm.minutesList, function(enabled, key) {
	                return _c(
	                  "li",
	                  {
	                    key: key,
	                    staticClass: "el-time-spinner__item",
	                    class: { active: key === _vm.minutes, disabled: !enabled },
	                    on: {
	                      click: function($event) {
	                        _vm.handleClick("minutes", {
	                          value: key,
	                          disabled: false
	                        })
	                      }
	                    }
	                  },
	                  [_vm._v(_vm._s(("0" + key).slice(-2)))]
	                )
	              }),
	              0
	            ),
	            _c(
	              "el-scrollbar",
	              {
	                directives: [
	                  {
	                    name: "show",
	                    rawName: "v-show",
	                    value: _vm.showSeconds,
	                    expression: "showSeconds"
	                  }
	                ],
	                ref: "seconds",
	                staticClass: "el-time-spinner__wrapper",
	                attrs: {
	                  "wrap-style": "max-height: inherit;",
	                  "view-class": "el-time-spinner__list",
	                  noresize: "",
	                  tag: "ul"
	                },
	                nativeOn: {
	                  mouseenter: function($event) {
	                    _vm.emitSelectRange("seconds")
	                  },
	                  mousemove: function($event) {
	                    _vm.adjustCurrentSpinner("seconds")
	                  }
	                }
	              },
	              _vm._l(60, function(second, key) {
	                return _c(
	                  "li",
	                  {
	                    key: key,
	                    staticClass: "el-time-spinner__item",
	                    class: { active: key === _vm.seconds },
	                    on: {
	                      click: function($event) {
	                        _vm.handleClick("seconds", {
	                          value: key,
	                          disabled: false
	                        })
	                      }
	                    }
	                  },
	                  [_vm._v(_vm._s(("0" + key).slice(-2)))]
	                )
	              }),
	              0
	            )
	          ]
	        : _vm._e(),
	      _vm.arrowControl
	        ? [
	            _c(
	              "div",
	              {
	                staticClass: "el-time-spinner__wrapper is-arrow",
	                on: {
	                  mouseenter: function($event) {
	                    _vm.emitSelectRange("hours")
	                  }
	                }
	              },
	              [
	                _c("i", {
	                  directives: [
	                    {
	                      name: "repeat-click",
	                      rawName: "v-repeat-click",
	                      value: _vm.decrease,
	                      expression: "decrease"
	                    }
	                  ],
	                  staticClass: "el-time-spinner__arrow el-icon-arrow-up"
	                }),
	                _c("i", {
	                  directives: [
	                    {
	                      name: "repeat-click",
	                      rawName: "v-repeat-click",
	                      value: _vm.increase,
	                      expression: "increase"
	                    }
	                  ],
	                  staticClass: "el-time-spinner__arrow el-icon-arrow-down"
	                }),
	                _c(
	                  "ul",
	                  { ref: "hours", staticClass: "el-time-spinner__list" },
	                  _vm._l(_vm.arrowHourList, function(hour, key) {
	                    return _c(
	                      "li",
	                      {
	                        key: key,
	                        staticClass: "el-time-spinner__item",
	                        class: {
	                          active: hour === _vm.hours,
	                          disabled: _vm.hoursList[hour]
	                        }
	                      },
	                      [
	                        _vm._v(
	                          _vm._s(
	                            hour === undefined
	                              ? ""
	                              : (
	                                  "0" + (_vm.amPmMode ? hour % 12 || 12 : hour)
	                                ).slice(-2) + _vm.amPm(hour)
	                          )
	                        )
	                      ]
	                    )
	                  }),
	                  0
	                )
	              ]
	            ),
	            _c(
	              "div",
	              {
	                staticClass: "el-time-spinner__wrapper is-arrow",
	                on: {
	                  mouseenter: function($event) {
	                    _vm.emitSelectRange("minutes")
	                  }
	                }
	              },
	              [
	                _c("i", {
	                  directives: [
	                    {
	                      name: "repeat-click",
	                      rawName: "v-repeat-click",
	                      value: _vm.decrease,
	                      expression: "decrease"
	                    }
	                  ],
	                  staticClass: "el-time-spinner__arrow el-icon-arrow-up"
	                }),
	                _c("i", {
	                  directives: [
	                    {
	                      name: "repeat-click",
	                      rawName: "v-repeat-click",
	                      value: _vm.increase,
	                      expression: "increase"
	                    }
	                  ],
	                  staticClass: "el-time-spinner__arrow el-icon-arrow-down"
	                }),
	                _c(
	                  "ul",
	                  { ref: "minutes", staticClass: "el-time-spinner__list" },
	                  _vm._l(_vm.arrowMinuteList, function(minute, key) {
	                    return _c(
	                      "li",
	                      {
	                        key: key,
	                        staticClass: "el-time-spinner__item",
	                        class: { active: minute === _vm.minutes }
	                      },
	                      [
	                        _vm._v(
	                          "\n          " +
	                            _vm._s(
	                              minute === undefined
	                                ? ""
	                                : ("0" + minute).slice(-2)
	                            ) +
	                            "\n        "
	                        )
	                      ]
	                    )
	                  }),
	                  0
	                )
	              ]
	            ),
	            _vm.showSeconds
	              ? _c(
	                  "div",
	                  {
	                    staticClass: "el-time-spinner__wrapper is-arrow",
	                    on: {
	                      mouseenter: function($event) {
	                        _vm.emitSelectRange("seconds")
	                      }
	                    }
	                  },
	                  [
	                    _c("i", {
	                      directives: [
	                        {
	                          name: "repeat-click",
	                          rawName: "v-repeat-click",
	                          value: _vm.decrease,
	                          expression: "decrease"
	                        }
	                      ],
	                      staticClass: "el-time-spinner__arrow el-icon-arrow-up"
	                    }),
	                    _c("i", {
	                      directives: [
	                        {
	                          name: "repeat-click",
	                          rawName: "v-repeat-click",
	                          value: _vm.increase,
	                          expression: "increase"
	                        }
	                      ],
	                      staticClass: "el-time-spinner__arrow el-icon-arrow-down"
	                    }),
	                    _c(
	                      "ul",
	                      { ref: "seconds", staticClass: "el-time-spinner__list" },
	                      _vm._l(_vm.arrowSecondList, function(second, key) {
	                        return _c(
	                          "li",
	                          {
	                            key: key,
	                            staticClass: "el-time-spinner__item",
	                            class: { active: second === _vm.seconds }
	                          },
	                          [
	                            _vm._v(
	                              "\n          " +
	                                _vm._s(
	                                  second === undefined
	                                    ? ""
	                                    : ("0" + second).slice(-2)
	                                ) +
	                                "\n        "
	                            )
	                          ]
	                        )
	                      }),
	                      0
	                    )
	                  ]
	                )
	              : _vm._e()
	          ]
	        : _vm._e()
	    ],
	    2
	  )
	}
	var time_spinnervue_type_template_id_1facadeb_staticRenderFns = []
	time_spinnervue_type_template_id_1facadeb_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/time-spinner.vue?vue&type=template&id=1facadeb&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/time-spinner.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var time_spinnervue_type_script_lang_js_ = ({
	  components: { ElScrollbar: scrollbar_default.a },
	
	  directives: {
	    repeatClick: repeat_click
	  },
	
	  props: {
	    date: {},
	    defaultValue: {}, // reserved for future use
	    showSeconds: {
	      type: Boolean,
	      default: true
	    },
	    arrowControl: Boolean,
	    amPmMode: {
	      type: String,
	      default: '' // 'a': am/pm; 'A': AM/PM
	    }
	  },
	
	  computed: {
	    hours: function hours() {
	      return this.date.getHours();
	    },
	    minutes: function minutes() {
	      return this.date.getMinutes();
	    },
	    seconds: function seconds() {
	      return this.date.getSeconds();
	    },
	    hoursList: function hoursList() {
	      return Object(date_util_["getRangeHours"])(this.selectableRange);
	    },
	    minutesList: function minutesList() {
	      return Object(date_util_["getRangeMinutes"])(this.selectableRange, this.hours);
	    },
	    arrowHourList: function arrowHourList() {
	      var hours = this.hours;
	      return [hours > 0 ? hours - 1 : undefined, hours, hours < 23 ? hours + 1 : undefined];
	    },
	    arrowMinuteList: function arrowMinuteList() {
	      var minutes = this.minutes;
	      return [minutes > 0 ? minutes - 1 : undefined, minutes, minutes < 59 ? minutes + 1 : undefined];
	    },
	    arrowSecondList: function arrowSecondList() {
	      var seconds = this.seconds;
	      return [seconds > 0 ? seconds - 1 : undefined, seconds, seconds < 59 ? seconds + 1 : undefined];
	    }
	  },
	
	  data: function data() {
	    return {
	      selectableRange: [],
	      currentScrollbar: null
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.$nextTick(function () {
	      !_this.arrowControl && _this.bindScrollEvent();
	    });
	  },
	
	
	  methods: {
	    increase: function increase() {
	      this.scrollDown(1);
	    },
	    decrease: function decrease() {
	      this.scrollDown(-1);
	    },
	    modifyDateField: function modifyDateField(type, value) {
	      switch (type) {
	        case 'hours':
	          this.$emit('change', Object(date_util_["modifyTime"])(this.date, value, this.minutes, this.seconds));break;
	        case 'minutes':
	          this.$emit('change', Object(date_util_["modifyTime"])(this.date, this.hours, value, this.seconds));break;
	        case 'seconds':
	          this.$emit('change', Object(date_util_["modifyTime"])(this.date, this.hours, this.minutes, value));break;
	      }
	    },
	    handleClick: function handleClick(type, _ref) {
	      var value = _ref.value,
	          disabled = _ref.disabled;
	
	      if (!disabled) {
	        this.modifyDateField(type, value);
	        this.emitSelectRange(type);
	        this.adjustSpinner(type, value);
	      }
	    },
	    emitSelectRange: function emitSelectRange(type) {
	      if (type === 'hours') {
	        this.$emit('select-range', 0, 2);
	      } else if (type === 'minutes') {
	        this.$emit('select-range', 3, 5);
	      } else if (type === 'seconds') {
	        this.$emit('select-range', 6, 8);
	      }
	      this.currentScrollbar = type;
	    },
	    bindScrollEvent: function bindScrollEvent() {
	      var _this2 = this;
	
	      var bindFuntion = function bindFuntion(type) {
	        _this2.$refs[type].wrap.onscroll = function (e) {
	          // TODO: scroll is emitted when set scrollTop programatically
	          // should find better solutions in the future!
	          _this2.handleScroll(type, e);
	        };
	      };
	      bindFuntion('hours');
	      bindFuntion('minutes');
	      bindFuntion('seconds');
	    },
	    handleScroll: function handleScroll(type) {
	      var value = Math.min(Math.round((this.$refs[type].wrap.scrollTop - (this.scrollBarHeight(type) * 0.5 - 10) / this.typeItemHeight(type) + 3) / this.typeItemHeight(type)), type === 'hours' ? 23 : 59);
	      this.modifyDateField(type, value);
	    },
	
	
	    // NOTE: used by datetime / date-range panel
	    //       renamed from adjustScrollTop
	    //       should try to refactory it
	    adjustSpinners: function adjustSpinners() {
	      this.adjustSpinner('hours', this.hours);
	      this.adjustSpinner('minutes', this.minutes);
	      this.adjustSpinner('seconds', this.seconds);
	    },
	    adjustCurrentSpinner: function adjustCurrentSpinner(type) {
	      this.adjustSpinner(type, this[type]);
	    },
	    adjustSpinner: function adjustSpinner(type, value) {
	      if (this.arrowControl) return;
	      var el = this.$refs[type].wrap;
	      if (el) {
	        el.scrollTop = Math.max(0, value * this.typeItemHeight(type));
	      }
	    },
	    scrollDown: function scrollDown(step) {
	      var _this3 = this;
	
	      if (!this.currentScrollbar) {
	        this.emitSelectRange('hours');
	      }
	
	      var label = this.currentScrollbar;
	      var hoursList = this.hoursList;
	      var now = this[label];
	
	      if (this.currentScrollbar === 'hours') {
	        var total = Math.abs(step);
	        step = step > 0 ? 1 : -1;
	        var length = hoursList.length;
	        while (length-- && total) {
	          now = (now + step + hoursList.length) % hoursList.length;
	          if (hoursList[now]) {
	            continue;
	          }
	          total--;
	        }
	        if (hoursList[now]) return;
	      } else {
	        now = (now + step + 60) % 60;
	      }
	
	      this.modifyDateField(label, now);
	      this.adjustSpinner(label, now);
	      this.$nextTick(function () {
	        return _this3.emitSelectRange(_this3.currentScrollbar);
	      });
	    },
	    amPm: function amPm(hour) {
	      var shouldShowAmPm = this.amPmMode.toLowerCase() === 'a';
	      if (!shouldShowAmPm) return '';
	      var isCapital = this.amPmMode === 'A';
	      var content = hour < 12 ? ' am' : ' pm';
	      if (isCapital) content = content.toUpperCase();
	      return content;
	    },
	    typeItemHeight: function typeItemHeight(type) {
	      return this.$refs[type].$el.querySelector('li').offsetHeight;
	    },
	    scrollBarHeight: function scrollBarHeight(type) {
	      return this.$refs[type].$el.offsetHeight;
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/time-spinner.vue?vue&type=script&lang=js&
	 /* harmony default export */ var basic_time_spinnervue_type_script_lang_js_ = (time_spinnervue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/time-spinner.vue
	
	
	
	
	
	/* normalize component */
	
	var time_spinner_component = normalizeComponent(
	  basic_time_spinnervue_type_script_lang_js_,
	  time_spinnervue_type_template_id_1facadeb_render,
	  time_spinnervue_type_template_id_1facadeb_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var time_spinner_api; }
	time_spinner_component.options.__file = "packages/date-picker/src/basic/time-spinner.vue"
	/* harmony default export */ var time_spinner = (time_spinner_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var timevue_type_script_lang_js_ = ({
	  mixins: [locale_default.a],
	
	  components: {
	    TimeSpinner: time_spinner
	  },
	
	  props: {
	    visible: Boolean,
	    timeArrowControl: Boolean
	  },
	
	  watch: {
	    visible: function visible(val) {
	      var _this = this;
	
	      if (val) {
	        this.oldValue = this.value;
	        this.$nextTick(function () {
	          return _this.$refs.spinner.emitSelectRange('hours');
	        });
	      } else {
	        this.needInitAdjust = true;
	      }
	    },
	    value: function value(newVal) {
	      var _this2 = this;
	
	      var date = void 0;
	      if (newVal instanceof Date) {
	        date = Object(date_util_["limitTimeRange"])(newVal, this.selectableRange, this.format);
	      } else if (!newVal) {
	        date = this.defaultValue ? new Date(this.defaultValue) : new Date();
	      }
	
	      this.date = date;
	      if (this.visible && this.needInitAdjust) {
	        this.$nextTick(function (_) {
	          return _this2.adjustSpinners();
	        });
	        this.needInitAdjust = false;
	      }
	    },
	    selectableRange: function selectableRange(val) {
	      this.$refs.spinner.selectableRange = val;
	    },
	    defaultValue: function defaultValue(val) {
	      if (!Object(date_util_["isDate"])(this.value)) {
	        this.date = val ? new Date(val) : new Date();
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      popperClass: '',
	      format: 'HH:mm:ss',
	      value: '',
	      defaultValue: null,
	      date: new Date(),
	      oldValue: new Date(),
	      selectableRange: [],
	      selectionRange: [0, 2],
	      disabled: false,
	      arrowControl: false,
	      needInitAdjust: true
	    };
	  },
	
	
	  computed: {
	    showSeconds: function showSeconds() {
	      return (this.format || '').indexOf('ss') !== -1;
	    },
	    useArrow: function useArrow() {
	      return this.arrowControl || this.timeArrowControl || false;
	    },
	    amPmMode: function amPmMode() {
	      if ((this.format || '').indexOf('A') !== -1) return 'A';
	      if ((this.format || '').indexOf('a') !== -1) return 'a';
	      return '';
	    }
	  },
	
	  methods: {
	    handleCancel: function handleCancel() {
	      this.$emit('pick', this.oldValue, false);
	    },
	    handleChange: function handleChange(date) {
	      // this.visible avoids edge cases, when use scrolls during panel closing animation
	      if (this.visible) {
	        this.date = Object(date_util_["clearMilliseconds"])(date);
	        // if date is out of range, do not emit
	        if (this.isValidValue(this.date)) {
	          this.$emit('pick', this.date, true);
	        }
	      }
	    },
	    setSelectionRange: function setSelectionRange(start, end) {
	      this.$emit('select-range', start, end);
	      this.selectionRange = [start, end];
	    },
	    handleConfirm: function handleConfirm() {
	      var visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      var first = arguments[1];
	
	      if (first) return;
	      var date = Object(date_util_["clearMilliseconds"])(Object(date_util_["limitTimeRange"])(this.date, this.selectableRange, this.format));
	      this.$emit('pick', date, visible, first);
	    },
	    handleKeydown: function handleKeydown(event) {
	      var keyCode = event.keyCode;
	      var mapping = { 38: -1, 40: 1, 37: -1, 39: 1 };
	
	      // Left or Right
	      if (keyCode === 37 || keyCode === 39) {
	        var step = mapping[keyCode];
	        this.changeSelectionRange(step);
	        event.preventDefault();
	        return;
	      }
	
	      // Up or Down
	      if (keyCode === 38 || keyCode === 40) {
	        var _step = mapping[keyCode];
	        this.$refs.spinner.scrollDown(_step);
	        event.preventDefault();
	        return;
	      }
	    },
	    isValidValue: function isValidValue(date) {
	      return Object(date_util_["timeWithinRange"])(date, this.selectableRange, this.format);
	    },
	    adjustSpinners: function adjustSpinners() {
	      return this.$refs.spinner.adjustSpinners();
	    },
	    changeSelectionRange: function changeSelectionRange(step) {
	      var list = [0, 3].concat(this.showSeconds ? [6] : []);
	      var mapping = ['hours', 'minutes'].concat(this.showSeconds ? ['seconds'] : []);
	      var index = list.indexOf(this.selectionRange[0]);
	      var next = (index + step + list.length) % list.length;
	      this.$refs.spinner.emitSelectRange(mapping[next]);
	    }
	  },
	
	  mounted: function mounted() {
	    var _this3 = this;
	
	    this.$nextTick(function () {
	      return _this3.handleConfirm(true, true);
	    });
	    this.$emit('mounted');
	  }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/time.vue?vue&type=script&lang=js&
	 /* harmony default export */ var panel_timevue_type_script_lang_js_ = (timevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/time.vue
	
	
	
	
	
	/* normalize component */
	
	var time_component = normalizeComponent(
	  panel_timevue_type_script_lang_js_,
	  timevue_type_template_id_3d939089_render,
	  timevue_type_template_id_3d939089_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var time_api; }
	time_component.options.__file = "packages/date-picker/src/panel/time.vue"
	/* harmony default export */ var panel_time = (time_component.exports);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/year-table.vue?vue&type=template&id=c86ab5e0&
	var year_tablevue_type_template_id_c86ab5e0_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "table",
	    { staticClass: "el-year-table", on: { click: _vm.handleYearTableClick } },
	    [
	      _c("tbody", [
	        _c("tr", [
	          _c(
	            "td",
	            {
	              staticClass: "available",
	              class: _vm.getCellStyle(_vm.startYear + 0)
	            },
	            [_c("a", { staticClass: "cell" }, [_vm._v(_vm._s(_vm.startYear))])]
	          ),
	          _c(
	            "td",
	            {
	              staticClass: "available",
	              class: _vm.getCellStyle(_vm.startYear + 1)
	            },
	            [
	              _c("a", { staticClass: "cell" }, [
	                _vm._v(_vm._s(_vm.startYear + 1))
	              ])
	            ]
	          ),
	          _c(
	            "td",
	            {
	              staticClass: "available",
	              class: _vm.getCellStyle(_vm.startYear + 2)
	            },
	            [
	              _c("a", { staticClass: "cell" }, [
	                _vm._v(_vm._s(_vm.startYear + 2))
	              ])
	            ]
	          ),
	          _c(
	            "td",
	            {
	              staticClass: "available",
	              class: _vm.getCellStyle(_vm.startYear + 3)
	            },
	            [
	              _c("a", { staticClass: "cell" }, [
	                _vm._v(_vm._s(_vm.startYear + 3))
	              ])
	            ]
	          )
	        ]),
	        _c("tr", [
	          _c(
	            "td",
	            {
	              staticClass: "available",
	              class: _vm.getCellStyle(_vm.startYear + 4)
	            },
	            [
	              _c("a", { staticClass: "cell" }, [
	                _vm._v(_vm._s(_vm.startYear + 4))
	              ])
	            ]
	          ),
	          _c(
	            "td",
	            {
	              staticClass: "available",
	              class: _vm.getCellStyle(_vm.startYear + 5)
	            },
	            [
	              _c("a", { staticClass: "cell" }, [
	                _vm._v(_vm._s(_vm.startYear + 5))
	              ])
	            ]
	          ),
	          _c(
	            "td",
	            {
	              staticClass: "available",
	              class: _vm.getCellStyle(_vm.startYear + 6)
	            },
	            [
	              _c("a", { staticClass: "cell" }, [
	                _vm._v(_vm._s(_vm.startYear + 6))
	              ])
	            ]
	          ),
	          _c(
	            "td",
	            {
	              staticClass: "available",
	              class: _vm.getCellStyle(_vm.startYear + 7)
	            },
	            [
	              _c("a", { staticClass: "cell" }, [
	                _vm._v(_vm._s(_vm.startYear + 7))
	              ])
	            ]
	          )
	        ]),
	        _c("tr", [
	          _c(
	            "td",
	            {
	              staticClass: "available",
	              class: _vm.getCellStyle(_vm.startYear + 8)
	            },
	            [
	              _c("a", { staticClass: "cell" }, [
	                _vm._v(_vm._s(_vm.startYear + 8))
	              ])
	            ]
	          ),
	          _c(
	            "td",
	            {
	              staticClass: "available",
	              class: _vm.getCellStyle(_vm.startYear + 9)
	            },
	            [
	              _c("a", { staticClass: "cell" }, [
	                _vm._v(_vm._s(_vm.startYear + 9))
	              ])
	            ]
	          ),
	          _c("td"),
	          _c("td")
	        ])
	      ])
	    ]
	  )
	}
	var year_tablevue_type_template_id_c86ab5e0_staticRenderFns = []
	year_tablevue_type_template_id_c86ab5e0_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/year-table.vue?vue&type=template&id=c86ab5e0&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/year-table.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	var year_tablevue_type_script_lang_js_datesInYear = function datesInYear(year) {
	  var numOfDays = Object(date_util_["getDayCountOfYear"])(year);
	  var firstDay = new Date(year, 0, 1);
	  return Object(date_util_["range"])(numOfDays).map(function (n) {
	    return Object(date_util_["nextDate"])(firstDay, n);
	  });
	};
	
	/* harmony default export */ var year_tablevue_type_script_lang_js_ = ({
	  props: {
	    disabledDate: {},
	    value: {},
	    defaultValue: {
	      validator: function validator(val) {
	        // null or valid Date Object
	        return val === null || val instanceof Date && Object(date_util_["isDate"])(val);
	      }
	    },
	    date: {}
	  },
	
	  computed: {
	    startYear: function startYear() {
	      return Math.floor(this.date.getFullYear() / 10) * 10;
	    }
	  },
	
	  methods: {
	    getCellStyle: function getCellStyle(year) {
	      var style = {};
	      var today = new Date();
	
	      style.disabled = typeof this.disabledDate === 'function' ? year_tablevue_type_script_lang_js_datesInYear(year).every(this.disabledDate) : false;
	      style.current = Object(util_["arrayFindIndex"])(Object(util_["coerceTruthyValueToArray"])(this.value), function (date) {
	        return date.getFullYear() === year;
	      }) >= 0;
	      style.today = today.getFullYear() === year;
	      style.default = this.defaultValue && this.defaultValue.getFullYear() === year;
	
	      return style;
	    },
	    handleYearTableClick: function handleYearTableClick(event) {
	      var target = event.target;
	      if (target.tagName === 'A') {
	        if (Object(dom_["hasClass"])(target.parentNode, 'disabled')) return;
	        var year = target.textContent || target.innerText;
	        this.$emit('pick', Number(year));
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/year-table.vue?vue&type=script&lang=js&
	 /* harmony default export */ var basic_year_tablevue_type_script_lang_js_ = (year_tablevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/year-table.vue
	
	
	
	
	
	/* normalize component */
	
	var year_table_component = normalizeComponent(
	  basic_year_tablevue_type_script_lang_js_,
	  year_tablevue_type_template_id_c86ab5e0_render,
	  year_tablevue_type_template_id_c86ab5e0_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var year_table_api; }
	year_table_component.options.__file = "packages/date-picker/src/basic/year-table.vue"
	/* harmony default export */ var year_table = (year_table_component.exports);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/month-table.vue?vue&type=template&id=654d4f42&
	var month_tablevue_type_template_id_654d4f42_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "table",
	    {
	      staticClass: "el-month-table",
	      on: { click: _vm.handleMonthTableClick, mousemove: _vm.handleMouseMove }
	    },
	    [
	      _c(
	        "tbody",
	        _vm._l(_vm.rows, function(row, key) {
	          return _c(
	            "tr",
	            { key: key },
	            _vm._l(row, function(cell, key) {
	              return _c("td", { key: key, class: _vm.getCellStyle(cell) }, [
	                _c("div", [
	                  _c("a", { staticClass: "cell" }, [
	                    _vm._v(
	                      _vm._s(
	                        _vm.t("el.datepicker.months." + _vm.months[cell.text])
	                      )
	                    )
	                  ])
	                ])
	              ])
	            }),
	            0
	          )
	        }),
	        0
	      )
	    ]
	  )
	}
	var month_tablevue_type_template_id_654d4f42_staticRenderFns = []
	month_tablevue_type_template_id_654d4f42_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/month-table.vue?vue&type=template&id=654d4f42&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/month-table.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	var month_tablevue_type_script_lang_js_datesInMonth = function datesInMonth(year, month) {
	  var numOfDays = Object(date_util_["getDayCountOfMonth"])(year, month);
	  var firstDay = new Date(year, month, 1);
	  return Object(date_util_["range"])(numOfDays).map(function (n) {
	    return Object(date_util_["nextDate"])(firstDay, n);
	  });
	};
	
	var clearDate = function clearDate(date) {
	  return new Date(date.getFullYear(), date.getMonth());
	};
	
	var getMonthTimestamp = function getMonthTimestamp(time) {
	  if (typeof time === 'number' || typeof time === 'string') {
	    return clearDate(new Date(time)).getTime();
	  } else if (time instanceof Date) {
	    return clearDate(time).getTime();
	  } else {
	    return NaN;
	  }
	};
	/* harmony default export */ var month_tablevue_type_script_lang_js_ = ({
	  props: {
	    disabledDate: {},
	    value: {},
	    selectionMode: {
	      default: 'month'
	    },
	    minDate: {},
	
	    maxDate: {},
	    defaultValue: {
	      validator: function validator(val) {
	        // null or valid Date Object
	        return val === null || Object(date_util_["isDate"])(val) || Array.isArray(val) && val.every(date_util_["isDate"]);
	      }
	    },
	    date: {},
	    rangeState: {
	      default: function _default() {
	        return {
	          endDate: null,
	          selecting: false
	        };
	      }
	    }
	  },
	
	  mixins: [locale_default.a],
	
	  watch: {
	    'rangeState.endDate': function rangeStateEndDate(newVal) {
	      this.markRange(this.minDate, newVal);
	    },
	    minDate: function minDate(newVal, oldVal) {
	      if (getMonthTimestamp(newVal) !== getMonthTimestamp(oldVal)) {
	        this.markRange(this.minDate, this.maxDate);
	      }
	    },
	    maxDate: function maxDate(newVal, oldVal) {
	      if (getMonthTimestamp(newVal) !== getMonthTimestamp(oldVal)) {
	        this.markRange(this.minDate, this.maxDate);
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      months: ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'],
	      tableRows: [[], [], []],
	      lastRow: null,
	      lastColumn: null
	    };
	  },
	
	
	  methods: {
	    cellMatchesDate: function cellMatchesDate(cell, date) {
	      var value = new Date(date);
	      return this.date.getFullYear() === value.getFullYear() && Number(cell.text) === value.getMonth();
	    },
	    getCellStyle: function getCellStyle(cell) {
	      var _this = this;
	
	      var style = {};
	      var year = this.date.getFullYear();
	      var today = new Date();
	      var month = cell.text;
	      var defaultValue = this.defaultValue ? Array.isArray(this.defaultValue) ? this.defaultValue : [this.defaultValue] : [];
	      style.disabled = typeof this.disabledDate === 'function' ? month_tablevue_type_script_lang_js_datesInMonth(year, month).every(this.disabledDate) : false;
	      style.current = Object(util_["arrayFindIndex"])(Object(util_["coerceTruthyValueToArray"])(this.value), function (date) {
	        return date.getFullYear() === year && date.getMonth() === month;
	      }) >= 0;
	      style.today = today.getFullYear() === year && today.getMonth() === month;
	      style.default = defaultValue.some(function (date) {
	        return _this.cellMatchesDate(cell, date);
	      });
	
	      if (cell.inRange) {
	        style['in-range'] = true;
	
	        if (cell.start) {
	          style['start-date'] = true;
	        }
	
	        if (cell.end) {
	          style['end-date'] = true;
	        }
	      }
	      return style;
	    },
	    getMonthOfCell: function getMonthOfCell(month) {
	      var year = this.date.getFullYear();
	      return new Date(year, month, 1);
	    },
	    markRange: function markRange(minDate, maxDate) {
	      minDate = getMonthTimestamp(minDate);
	      maxDate = getMonthTimestamp(maxDate) || minDate;
	      var _ref = [Math.min(minDate, maxDate), Math.max(minDate, maxDate)];
	      minDate = _ref[0];
	      maxDate = _ref[1];
	
	      var rows = this.rows;
	      for (var i = 0, k = rows.length; i < k; i++) {
	        var row = rows[i];
	        for (var j = 0, l = row.length; j < l; j++) {
	
	          var cell = row[j];
	          var index = i * 4 + j;
	          var time = new Date(this.date.getFullYear(), index).getTime();
	
	          cell.inRange = minDate && time >= minDate && time <= maxDate;
	          cell.start = minDate && time === minDate;
	          cell.end = maxDate && time === maxDate;
	        }
	      }
	    },
	    handleMouseMove: function handleMouseMove(event) {
	      if (!this.rangeState.selecting) return;
	
	      var target = event.target;
	      if (target.tagName === 'A') {
	        target = target.parentNode.parentNode;
	      }
	      if (target.tagName === 'DIV') {
	        target = target.parentNode;
	      }
	      if (target.tagName !== 'TD') return;
	
	      var row = target.parentNode.rowIndex;
	      var column = target.cellIndex;
	      // can not select disabled date
	      if (this.rows[row][column].disabled) return;
	
	      // only update rangeState when mouse moves to a new cell
	      // this avoids frequent Date object creation and improves performance
	      if (row !== this.lastRow || column !== this.lastColumn) {
	        this.lastRow = row;
	        this.lastColumn = column;
	        this.$emit('changerange', {
	          minDate: this.minDate,
	          maxDate: this.maxDate,
	          rangeState: {
	            selecting: true,
	            endDate: this.getMonthOfCell(row * 4 + column)
	          }
	        });
	      }
	    },
	    handleMonthTableClick: function handleMonthTableClick(event) {
	      var target = event.target;
	      if (target.tagName === 'A') {
	        target = target.parentNode.parentNode;
	      }
	      if (target.tagName === 'DIV') {
	        target = target.parentNode;
	      }
	      if (target.tagName !== 'TD') return;
	      if (Object(dom_["hasClass"])(target, 'disabled')) return;
	      var column = target.cellIndex;
	      var row = target.parentNode.rowIndex;
	      var month = row * 4 + column;
	      var newDate = this.getMonthOfCell(month);
	      if (this.selectionMode === 'range') {
	        if (!this.rangeState.selecting) {
	          this.$emit('pick', { minDate: newDate, maxDate: null });
	          this.rangeState.selecting = true;
	        } else {
	          if (newDate >= this.minDate) {
	            this.$emit('pick', { minDate: this.minDate, maxDate: newDate });
	          } else {
	            this.$emit('pick', { minDate: newDate, maxDate: this.minDate });
	          }
	          this.rangeState.selecting = false;
	        }
	      } else {
	        this.$emit('pick', month);
	      }
	    }
	  },
	
	  computed: {
	    rows: function rows() {
	      var _this2 = this;
	
	      // TODO: refactory rows / getCellClasses
	      var rows = this.tableRows;
	      var disabledDate = this.disabledDate;
	      var selectedDate = [];
	      var now = getMonthTimestamp(new Date());
	
	      for (var i = 0; i < 3; i++) {
	        var row = rows[i];
	
	        var _loop = function _loop(j) {
	          var cell = row[j];
	          if (!cell) {
	            cell = { row: i, column: j, type: 'normal', inRange: false, start: false, end: false };
	          }
	
	          cell.type = 'normal';
	
	          var index = i * 4 + j;
	          var time = new Date(_this2.date.getFullYear(), index).getTime();
	          cell.inRange = time >= getMonthTimestamp(_this2.minDate) && time <= getMonthTimestamp(_this2.maxDate);
	          cell.start = _this2.minDate && time === getMonthTimestamp(_this2.minDate);
	          cell.end = _this2.maxDate && time === getMonthTimestamp(_this2.maxDate);
	          var isToday = time === now;
	
	          if (isToday) {
	            cell.type = 'today';
	          }
	          cell.text = index;
	          var cellDate = new Date(time);
	          cell.disabled = typeof disabledDate === 'function' && disabledDate(cellDate);
	          cell.selected = Object(util_["arrayFind"])(selectedDate, function (date) {
	            return date.getTime() === cellDate.getTime();
	          });
	
	          _this2.$set(row, j, cell);
	        };
	
	        for (var j = 0; j < 4; j++) {
	          _loop(j);
	        }
	      }
	      return rows;
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/month-table.vue?vue&type=script&lang=js&
	 /* harmony default export */ var basic_month_tablevue_type_script_lang_js_ = (month_tablevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/month-table.vue
	
	
	
	
	
	/* normalize component */
	
	var month_table_component = normalizeComponent(
	  basic_month_tablevue_type_script_lang_js_,
	  month_tablevue_type_template_id_654d4f42_render,
	  month_tablevue_type_template_id_654d4f42_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var month_table_api; }
	month_table_component.options.__file = "packages/date-picker/src/basic/month-table.vue"
	/* harmony default export */ var month_table = (month_table_component.exports);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/date-table.vue?vue&type=template&id=5d1f3341&
	var date_tablevue_type_template_id_5d1f3341_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "table",
	    {
	      staticClass: "el-date-table",
	      class: { "is-week-mode": _vm.selectionMode === "week" },
	      attrs: { cellspacing: "0", cellpadding: "0" },
	      on: { click: _vm.handleClick, mousemove: _vm.handleMouseMove }
	    },
	    [
	      _c(
	        "tbody",
	        [
	          _c(
	            "tr",
	            [
	              _vm.showWeekNumber
	                ? _c("th", [_vm._v(_vm._s(_vm.t("el.datepicker.week")))])
	                : _vm._e(),
	              _vm._l(_vm.WEEKS, function(week, key) {
	                return _c("th", { key: key }, [
	                  _vm._v(_vm._s(_vm.t("el.datepicker.weeks." + week)))
	                ])
	              })
	            ],
	            2
	          ),
	          _vm._l(_vm.rows, function(row, key) {
	            return _c(
	              "tr",
	              {
	                key: key,
	                staticClass: "el-date-table__row",
	                class: { current: _vm.isWeekActive(row[1]) }
	              },
	              _vm._l(row, function(cell, key) {
	                return _c("td", { key: key, class: _vm.getCellClasses(cell) }, [
	                  _c("div", [
	                    _c("span", [
	                      _vm._v("\n          " + _vm._s(cell.text) + "\n        ")
	                    ])
	                  ])
	                ])
	              }),
	              0
	            )
	          })
	        ],
	        2
	      )
	    ]
	  )
	}
	var date_tablevue_type_template_id_5d1f3341_staticRenderFns = []
	date_tablevue_type_template_id_5d1f3341_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/date-table.vue?vue&type=template&id=5d1f3341&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/date-table.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	var _WEEKS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
	var date_tablevue_type_script_lang_js_getDateTimestamp = function getDateTimestamp(time) {
	  if (typeof time === 'number' || typeof time === 'string') {
	    return Object(date_util_["clearTime"])(new Date(time)).getTime();
	  } else if (time instanceof Date) {
	    return Object(date_util_["clearTime"])(time).getTime();
	  } else {
	    return NaN;
	  }
	};
	
	// remove the first element that satisfies `pred` from arr
	// return a new array if modification occurs
	// return the original array otherwise
	var date_tablevue_type_script_lang_js_removeFromArray = function removeFromArray(arr, pred) {
	  var idx = typeof pred === 'function' ? Object(util_["arrayFindIndex"])(arr, pred) : arr.indexOf(pred);
	  return idx >= 0 ? [].concat(arr.slice(0, idx), arr.slice(idx + 1)) : arr;
	};
	
	/* harmony default export */ var date_tablevue_type_script_lang_js_ = ({
	  mixins: [locale_default.a],
	
	  props: {
	    firstDayOfWeek: {
	      default: 7,
	      type: Number,
	      validator: function validator(val) {
	        return val >= 1 && val <= 7;
	      }
	    },
	
	    value: {},
	
	    defaultValue: {
	      validator: function validator(val) {
	        // either: null, valid Date object, Array of valid Date objects
	        return val === null || Object(date_util_["isDate"])(val) || Array.isArray(val) && val.every(date_util_["isDate"]);
	      }
	    },
	
	    date: {},
	
	    selectionMode: {
	      default: 'day'
	    },
	
	    showWeekNumber: {
	      type: Boolean,
	      default: false
	    },
	
	    disabledDate: {},
	
	    cellClassName: {},
	
	    minDate: {},
	
	    maxDate: {},
	
	    rangeState: {
	      default: function _default() {
	        return {
	          endDate: null,
	          selecting: false
	        };
	      }
	    }
	  },
	
	  computed: {
	    offsetDay: function offsetDay() {
	      var week = this.firstDayOfWeek;
	      // 周日为界限，左右偏移的天数，3217654 例如周一就是 -1，目的是调整前两行日期的位置
	      return week > 3 ? 7 - week : -week;
	    },
	    WEEKS: function WEEKS() {
	      var week = this.firstDayOfWeek;
	      return _WEEKS.concat(_WEEKS).slice(week, week + 7);
	    },
	    year: function year() {
	      return this.date.getFullYear();
	    },
	    month: function month() {
	      return this.date.getMonth();
	    },
	    startDate: function startDate() {
	      return Object(date_util_["getStartDateOfMonth"])(this.year, this.month);
	    },
	    rows: function rows() {
	      var _this = this;
	
	      // TODO: refactory rows / getCellClasses
	      var date = new Date(this.year, this.month, 1);
	      var day = Object(date_util_["getFirstDayOfMonth"])(date); // day of first day
	      var dateCountOfMonth = Object(date_util_["getDayCountOfMonth"])(date.getFullYear(), date.getMonth());
	      var dateCountOfLastMonth = Object(date_util_["getDayCountOfMonth"])(date.getFullYear(), date.getMonth() === 0 ? 11 : date.getMonth() - 1);
	
	      day = day === 0 ? 7 : day;
	
	      var offset = this.offsetDay;
	      var rows = this.tableRows;
	      var count = 1;
	
	      var startDate = this.startDate;
	      var disabledDate = this.disabledDate;
	      var cellClassName = this.cellClassName;
	      var selectedDate = this.selectionMode === 'dates' ? Object(util_["coerceTruthyValueToArray"])(this.value) : [];
	      var now = date_tablevue_type_script_lang_js_getDateTimestamp(new Date());
	
	      for (var i = 0; i < 6; i++) {
	        var row = rows[i];
	
	        if (this.showWeekNumber) {
	          if (!row[0]) {
	            row[0] = { type: 'week', text: Object(date_util_["getWeekNumber"])(Object(date_util_["nextDate"])(startDate, i * 7 + 1)) };
	          }
	        }
	
	        var _loop = function _loop(j) {
	          var cell = row[_this.showWeekNumber ? j + 1 : j];
	          if (!cell) {
	            cell = { row: i, column: j, type: 'normal', inRange: false, start: false, end: false };
	          }
	
	          cell.type = 'normal';
	
	          var index = i * 7 + j;
	          var time = Object(date_util_["nextDate"])(startDate, index - offset).getTime();
	          cell.inRange = time >= date_tablevue_type_script_lang_js_getDateTimestamp(_this.minDate) && time <= date_tablevue_type_script_lang_js_getDateTimestamp(_this.maxDate);
	          cell.start = _this.minDate && time === date_tablevue_type_script_lang_js_getDateTimestamp(_this.minDate);
	          cell.end = _this.maxDate && time === date_tablevue_type_script_lang_js_getDateTimestamp(_this.maxDate);
	          var isToday = time === now;
	
	          if (isToday) {
	            cell.type = 'today';
	          }
	
	          if (i >= 0 && i <= 1) {
	            var numberOfDaysFromPreviousMonth = day + offset < 0 ? 7 + day + offset : day + offset;
	
	            if (j + i * 7 >= numberOfDaysFromPreviousMonth) {
	              cell.text = count++;
	            } else {
	              cell.text = dateCountOfLastMonth - (numberOfDaysFromPreviousMonth - j % 7) + 1 + i * 7;
	              cell.type = 'prev-month';
	            }
	          } else {
	            if (count <= dateCountOfMonth) {
	              cell.text = count++;
	            } else {
	              cell.text = count++ - dateCountOfMonth;
	              cell.type = 'next-month';
	            }
	          }
	
	          var cellDate = new Date(time);
	          cell.disabled = typeof disabledDate === 'function' && disabledDate(cellDate);
	          cell.selected = Object(util_["arrayFind"])(selectedDate, function (date) {
	            return date.getTime() === cellDate.getTime();
	          });
	          cell.customClass = typeof cellClassName === 'function' && cellClassName(cellDate);
	          _this.$set(row, _this.showWeekNumber ? j + 1 : j, cell);
	        };
	
	        for (var j = 0; j < 7; j++) {
	          _loop(j);
	        }
	
	        if (this.selectionMode === 'week') {
	          var start = this.showWeekNumber ? 1 : 0;
	          var end = this.showWeekNumber ? 7 : 6;
	          var isWeekActive = this.isWeekActive(row[start + 1]);
	
	          row[start].inRange = isWeekActive;
	          row[start].start = isWeekActive;
	          row[end].inRange = isWeekActive;
	          row[end].end = isWeekActive;
	        }
	      }
	
	      return rows;
	    }
	  },
	
	  watch: {
	    'rangeState.endDate': function rangeStateEndDate(newVal) {
	      this.markRange(this.minDate, newVal);
	    },
	    minDate: function minDate(newVal, oldVal) {
	      if (date_tablevue_type_script_lang_js_getDateTimestamp(newVal) !== date_tablevue_type_script_lang_js_getDateTimestamp(oldVal)) {
	        this.markRange(this.minDate, this.maxDate);
	      }
	    },
	    maxDate: function maxDate(newVal, oldVal) {
	      if (date_tablevue_type_script_lang_js_getDateTimestamp(newVal) !== date_tablevue_type_script_lang_js_getDateTimestamp(oldVal)) {
	        this.markRange(this.minDate, this.maxDate);
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      tableRows: [[], [], [], [], [], []],
	      lastRow: null,
	      lastColumn: null
	    };
	  },
	
	
	  methods: {
	    cellMatchesDate: function cellMatchesDate(cell, date) {
	      var value = new Date(date);
	      return this.year === value.getFullYear() && this.month === value.getMonth() && Number(cell.text) === value.getDate();
	    },
	    getCellClasses: function getCellClasses(cell) {
	      var _this2 = this;
	
	      var selectionMode = this.selectionMode;
	      var defaultValue = this.defaultValue ? Array.isArray(this.defaultValue) ? this.defaultValue : [this.defaultValue] : [];
	
	      var classes = [];
	      if ((cell.type === 'normal' || cell.type === 'today') && !cell.disabled) {
	        classes.push('available');
	        if (cell.type === 'today') {
	          classes.push('today');
	        }
	      } else {
	        classes.push(cell.type);
	      }
	
	      if (cell.type === 'normal' && defaultValue.some(function (date) {
	        return _this2.cellMatchesDate(cell, date);
	      })) {
	        classes.push('default');
	      }
	
	      if (selectionMode === 'day' && (cell.type === 'normal' || cell.type === 'today') && this.cellMatchesDate(cell, this.value)) {
	        classes.push('current');
	      }
	
	      if (cell.inRange && (cell.type === 'normal' || cell.type === 'today' || this.selectionMode === 'week')) {
	        classes.push('in-range');
	
	        if (cell.start) {
	          classes.push('start-date');
	        }
	
	        if (cell.end) {
	          classes.push('end-date');
	        }
	      }
	
	      if (cell.disabled) {
	        classes.push('disabled');
	      }
	
	      if (cell.selected) {
	        classes.push('selected');
	      }
	
	      if (cell.customClass) {
	        classes.push(cell.customClass);
	      }
	
	      return classes.join(' ');
	    },
	    getDateOfCell: function getDateOfCell(row, column) {
	      var offsetFromStart = row * 7 + (column - (this.showWeekNumber ? 1 : 0)) - this.offsetDay;
	      return Object(date_util_["nextDate"])(this.startDate, offsetFromStart);
	    },
	    isWeekActive: function isWeekActive(cell) {
	      if (this.selectionMode !== 'week') return false;
	      var newDate = new Date(this.year, this.month, 1);
	      var year = newDate.getFullYear();
	      var month = newDate.getMonth();
	
	      if (cell.type === 'prev-month') {
	        newDate.setMonth(month === 0 ? 11 : month - 1);
	        newDate.setFullYear(month === 0 ? year - 1 : year);
	      }
	
	      if (cell.type === 'next-month') {
	        newDate.setMonth(month === 11 ? 0 : month + 1);
	        newDate.setFullYear(month === 11 ? year + 1 : year);
	      }
	
	      newDate.setDate(parseInt(cell.text, 10));
	
	      if (Object(date_util_["isDate"])(this.value)) {
	        var dayOffset = (this.value.getDay() - this.firstDayOfWeek + 7) % 7 - 1;
	        var weekDate = Object(date_util_["prevDate"])(this.value, dayOffset);
	        return weekDate.getTime() === newDate.getTime();
	      }
	      return false;
	    },
	    markRange: function markRange(minDate, maxDate) {
	      minDate = date_tablevue_type_script_lang_js_getDateTimestamp(minDate);
	      maxDate = date_tablevue_type_script_lang_js_getDateTimestamp(maxDate) || minDate;
	      var _ref = [Math.min(minDate, maxDate), Math.max(minDate, maxDate)];
	      minDate = _ref[0];
	      maxDate = _ref[1];
	
	
	      var startDate = this.startDate;
	      var rows = this.rows;
	      for (var i = 0, k = rows.length; i < k; i++) {
	        var row = rows[i];
	        for (var j = 0, l = row.length; j < l; j++) {
	          if (this.showWeekNumber && j === 0) continue;
	
	          var _cell = row[j];
	          var index = i * 7 + j + (this.showWeekNumber ? -1 : 0);
	          var time = Object(date_util_["nextDate"])(startDate, index - this.offsetDay).getTime();
	
	          _cell.inRange = minDate && time >= minDate && time <= maxDate;
	          _cell.start = minDate && time === minDate;
	          _cell.end = maxDate && time === maxDate;
	        }
	      }
	    },
	    handleMouseMove: function handleMouseMove(event) {
	      if (!this.rangeState.selecting) return;
	
	      var target = event.target;
	      if (target.tagName === 'SPAN') {
	        target = target.parentNode.parentNode;
	      }
	      if (target.tagName === 'DIV') {
	        target = target.parentNode;
	      }
	      if (target.tagName !== 'TD') return;
	
	      var row = target.parentNode.rowIndex - 1;
	      var column = target.cellIndex;
	
	      // can not select disabled date
	      if (this.rows[row][column].disabled) return;
	
	      // only update rangeState when mouse moves to a new cell
	      // this avoids frequent Date object creation and improves performance
	      if (row !== this.lastRow || column !== this.lastColumn) {
	        this.lastRow = row;
	        this.lastColumn = column;
	        this.$emit('changerange', {
	          minDate: this.minDate,
	          maxDate: this.maxDate,
	          rangeState: {
	            selecting: true,
	            endDate: this.getDateOfCell(row, column)
	          }
	        });
	      }
	    },
	    handleClick: function handleClick(event) {
	      var target = event.target;
	      if (target.tagName === 'SPAN') {
	        target = target.parentNode.parentNode;
	      }
	      if (target.tagName === 'DIV') {
	        target = target.parentNode;
	      }
	
	      if (target.tagName !== 'TD') return;
	
	      var row = target.parentNode.rowIndex - 1;
	      var column = this.selectionMode === 'week' ? 1 : target.cellIndex;
	      var cell = this.rows[row][column];
	
	      if (cell.disabled || cell.type === 'week') return;
	
	      var newDate = this.getDateOfCell(row, column);
	
	      if (this.selectionMode === 'range') {
	        if (!this.rangeState.selecting) {
	          this.$emit('pick', { minDate: newDate, maxDate: null });
	          this.rangeState.selecting = true;
	        } else {
	          if (newDate >= this.minDate) {
	            this.$emit('pick', { minDate: this.minDate, maxDate: newDate });
	          } else {
	            this.$emit('pick', { minDate: newDate, maxDate: this.minDate });
	          }
	          this.rangeState.selecting = false;
	        }
	      } else if (this.selectionMode === 'day') {
	        this.$emit('pick', newDate);
	      } else if (this.selectionMode === 'week') {
	        var weekNumber = Object(date_util_["getWeekNumber"])(newDate);
	        var value = newDate.getFullYear() + 'w' + weekNumber;
	        this.$emit('pick', {
	          year: newDate.getFullYear(),
	          week: weekNumber,
	          value: value,
	          date: newDate
	        });
	      } else if (this.selectionMode === 'dates') {
	        var _value = this.value || [];
	        var newValue = cell.selected ? date_tablevue_type_script_lang_js_removeFromArray(_value, function (date) {
	          return date.getTime() === newDate.getTime();
	        }) : [].concat(_value, [newDate]);
	        this.$emit('pick', newValue);
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/date-table.vue?vue&type=script&lang=js&
	 /* harmony default export */ var basic_date_tablevue_type_script_lang_js_ = (date_tablevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/date-table.vue
	
	
	
	
	
	/* normalize component */
	
	var date_table_component = normalizeComponent(
	  basic_date_tablevue_type_script_lang_js_,
	  date_tablevue_type_template_id_5d1f3341_render,
	  date_tablevue_type_template_id_5d1f3341_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var date_table_api; }
	date_table_component.options.__file = "packages/date-picker/src/basic/date-table.vue"
	/* harmony default export */ var date_table = (date_table_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/date.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	
	
	/* harmony default export */ var datevue_type_script_lang_js_ = ({
	  mixins: [locale_default.a],
	
	  directives: { Clickoutside: clickoutside_default.a },
	
	  watch: {
	    showTime: function showTime(val) {
	      var _this = this;
	
	      /* istanbul ignore if */
	      if (!val) return;
	      this.$nextTick(function (_) {
	        var inputElm = _this.$refs.input.$el;
	        if (inputElm) {
	          _this.pickerWidth = inputElm.getBoundingClientRect().width + 10;
	        }
	      });
	    },
	    value: function value(val) {
	      if (this.selectionMode === 'dates' && this.value) return;
	      if (Object(date_util_["isDate"])(val)) {
	        this.date = new Date(val);
	      } else {
	        this.date = this.getDefaultValue();
	      }
	    },
	    defaultValue: function defaultValue(val) {
	      if (!Object(date_util_["isDate"])(this.value)) {
	        this.date = val ? new Date(val) : new Date();
	      }
	    },
	    timePickerVisible: function timePickerVisible(val) {
	      var _this2 = this;
	
	      if (val) this.$nextTick(function () {
	        return _this2.$refs.timepicker.adjustSpinners();
	      });
	    },
	    selectionMode: function selectionMode(newVal) {
	      if (newVal === 'month') {
	        /* istanbul ignore next */
	        if (this.currentView !== 'year' || this.currentView !== 'month') {
	          this.currentView = 'month';
	        }
	      } else if (newVal === 'dates') {
	        this.currentView = 'date';
	      }
	    }
	  },
	
	  methods: {
	    proxyTimePickerDataProperties: function proxyTimePickerDataProperties() {
	      var _this3 = this;
	
	      var format = function format(timeFormat) {
	        _this3.$refs.timepicker.format = timeFormat;
	      };
	      var value = function value(_value) {
	        _this3.$refs.timepicker.value = _value;
	      };
	      var date = function date(_date) {
	        _this3.$refs.timepicker.date = _date;
	      };
	      var selectableRange = function selectableRange(_selectableRange) {
	        _this3.$refs.timepicker.selectableRange = _selectableRange;
	      };
	
	      this.$watch('value', value);
	      this.$watch('date', date);
	      this.$watch('selectableRange', selectableRange);
	
	      format(this.timeFormat);
	      value(this.value);
	      date(this.date);
	      selectableRange(this.selectableRange);
	    },
	    handleClear: function handleClear() {
	      this.date = this.getDefaultValue();
	      this.$emit('pick', null);
	    },
	    emit: function emit(value) {
	      var _this4 = this;
	
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      if (!value) {
	        this.$emit.apply(this, ['pick', value].concat(args));
	      } else if (Array.isArray(value)) {
	        var dates = value.map(function (date) {
	          return _this4.showTime ? Object(date_util_["clearMilliseconds"])(date) : Object(date_util_["clearTime"])(date);
	        });
	        this.$emit.apply(this, ['pick', dates].concat(args));
	      } else {
	        this.$emit.apply(this, ['pick', this.showTime ? Object(date_util_["clearMilliseconds"])(value) : Object(date_util_["clearTime"])(value)].concat(args));
	      }
	      this.userInputDate = null;
	      this.userInputTime = null;
	    },
	
	
	    // resetDate() {
	    //   this.date = new Date(this.date);
	    // },
	
	    showMonthPicker: function showMonthPicker() {
	      this.currentView = 'month';
	    },
	    showYearPicker: function showYearPicker() {
	      this.currentView = 'year';
	    },
	
	
	    // XXX: 没用到
	    // handleLabelClick() {
	    //   if (this.currentView === 'date') {
	    //     this.showMonthPicker();
	    //   } else if (this.currentView === 'month') {
	    //     this.showYearPicker();
	    //   }
	    // },
	
	    prevMonth: function prevMonth() {
	      this.date = Object(date_util_["prevMonth"])(this.date);
	    },
	    nextMonth: function nextMonth() {
	      this.date = Object(date_util_["nextMonth"])(this.date);
	    },
	    prevYear: function prevYear() {
	      if (this.currentView === 'year') {
	        this.date = Object(date_util_["prevYear"])(this.date, 10);
	      } else {
	        this.date = Object(date_util_["prevYear"])(this.date);
	      }
	    },
	    nextYear: function nextYear() {
	      if (this.currentView === 'year') {
	        this.date = Object(date_util_["nextYear"])(this.date, 10);
	      } else {
	        this.date = Object(date_util_["nextYear"])(this.date);
	      }
	    },
	    handleShortcutClick: function handleShortcutClick(shortcut) {
	      if (shortcut.onClick) {
	        shortcut.onClick(this);
	      }
	    },
	    handleTimePick: function handleTimePick(value, visible, first) {
	      if (Object(date_util_["isDate"])(value)) {
	        var newDate = this.value ? Object(date_util_["modifyTime"])(this.value, value.getHours(), value.getMinutes(), value.getSeconds()) : Object(date_util_["modifyWithTimeString"])(this.getDefaultValue(), this.defaultTime);
	        this.date = newDate;
	        this.emit(this.date, true);
	      } else {
	        this.emit(value, true);
	      }
	      if (!first) {
	        this.timePickerVisible = visible;
	      }
	    },
	    handleTimePickClose: function handleTimePickClose() {
	      this.timePickerVisible = false;
	    },
	    handleMonthPick: function handleMonthPick(month) {
	      if (this.selectionMode === 'month') {
	        this.date = Object(date_util_["modifyDate"])(this.date, this.year, month, 1);
	        this.emit(this.date);
	      } else {
	        this.date = Object(date_util_["changeYearMonthAndClampDate"])(this.date, this.year, month);
	        // TODO: should emit intermediate value ??
	        // this.emit(this.date);
	        this.currentView = 'date';
	      }
	    },
	    handleDatePick: function handleDatePick(value) {
	      if (this.selectionMode === 'day') {
	        var newDate = this.value ? Object(date_util_["modifyDate"])(this.value, value.getFullYear(), value.getMonth(), value.getDate()) : Object(date_util_["modifyWithTimeString"])(value, this.defaultTime);
	        // change default time while out of selectableRange
	        if (!this.checkDateWithinRange(newDate)) {
	          newDate = Object(date_util_["modifyDate"])(this.selectableRange[0][0], value.getFullYear(), value.getMonth(), value.getDate());
	        }
	        this.date = newDate;
	        this.emit(this.date, this.showTime);
	      } else if (this.selectionMode === 'week') {
	        this.emit(value.date);
	      } else if (this.selectionMode === 'dates') {
	        this.emit(value, true); // set false to keep panel open
	      }
	    },
	    handleYearPick: function handleYearPick(year) {
	      if (this.selectionMode === 'year') {
	        this.date = Object(date_util_["modifyDate"])(this.date, year, 0, 1);
	        this.emit(this.date);
	      } else {
	        this.date = Object(date_util_["changeYearMonthAndClampDate"])(this.date, year, this.month);
	        // TODO: should emit intermediate value ??
	        // this.emit(this.date, true);
	        this.currentView = 'month';
	      }
	    },
	    changeToNow: function changeToNow() {
	      // NOTE: not a permanent solution
	      //       consider disable "now" button in the future
	      if ((!this.disabledDate || !this.disabledDate(new Date())) && this.checkDateWithinRange(new Date())) {
	        this.date = new Date();
	        this.emit(this.date);
	      }
	    },
	    confirm: function confirm() {
	      if (this.selectionMode === 'dates') {
	        this.emit(this.value);
	      } else {
	        // value were emitted in handle{Date,Time}Pick, nothing to update here
	        // deal with the scenario where: user opens the picker, then confirm without doing anything
	        var value = this.value ? this.value : Object(date_util_["modifyWithTimeString"])(this.getDefaultValue(), this.defaultTime);
	        this.date = new Date(value); // refresh date
	        this.emit(value);
	      }
	    },
	    resetView: function resetView() {
	      if (this.selectionMode === 'month') {
	        this.currentView = 'month';
	      } else if (this.selectionMode === 'year') {
	        this.currentView = 'year';
	      } else {
	        this.currentView = 'date';
	      }
	    },
	    handleEnter: function handleEnter() {
	      document.body.addEventListener('keydown', this.handleKeydown);
	    },
	    handleLeave: function handleLeave() {
	      this.$emit('dodestroy');
	      document.body.removeEventListener('keydown', this.handleKeydown);
	    },
	    handleKeydown: function handleKeydown(event) {
	      var keyCode = event.keyCode;
	      var list = [38, 40, 37, 39];
	      if (this.visible && !this.timePickerVisible) {
	        if (list.indexOf(keyCode) !== -1) {
	          this.handleKeyControl(keyCode);
	          event.stopPropagation();
	          event.preventDefault();
	        }
	        if (keyCode === 13 && this.userInputDate === null && this.userInputTime === null) {
	          // Enter
	          this.emit(this.date, false);
	        }
	      }
	    },
	    handleKeyControl: function handleKeyControl(keyCode) {
	      var mapping = {
	        'year': {
	          38: -4, 40: 4, 37: -1, 39: 1, offset: function offset(date, step) {
	            return date.setFullYear(date.getFullYear() + step);
	          }
	        },
	        'month': {
	          38: -4, 40: 4, 37: -1, 39: 1, offset: function offset(date, step) {
	            return date.setMonth(date.getMonth() + step);
	          }
	        },
	        'week': {
	          38: -1, 40: 1, 37: -1, 39: 1, offset: function offset(date, step) {
	            return date.setDate(date.getDate() + step * 7);
	          }
	        },
	        'day': {
	          38: -7, 40: 7, 37: -1, 39: 1, offset: function offset(date, step) {
	            return date.setDate(date.getDate() + step);
	          }
	        }
	      };
	      var mode = this.selectionMode;
	      var year = 3.1536e10;
	      var now = this.date.getTime();
	      var newDate = new Date(this.date.getTime());
	      while (Math.abs(now - newDate.getTime()) <= year) {
	        var map = mapping[mode];
	        map.offset(newDate, map[keyCode]);
	        if (typeof this.disabledDate === 'function' && this.disabledDate(newDate)) {
	          continue;
	        }
	        this.date = newDate;
	        this.$emit('pick', newDate, true);
	        break;
	      }
	    },
	    handleVisibleTimeChange: function handleVisibleTimeChange(value) {
	      var time = Object(date_util_["parseDate"])(value, this.timeFormat);
	      if (time && this.checkDateWithinRange(time)) {
	        this.date = Object(date_util_["modifyDate"])(time, this.year, this.month, this.monthDate);
	        this.userInputTime = null;
	        this.$refs.timepicker.value = this.date;
	        this.timePickerVisible = false;
	        this.emit(this.date, true);
	      }
	    },
	    handleVisibleDateChange: function handleVisibleDateChange(value) {
	      var date = Object(date_util_["parseDate"])(value, this.dateFormat);
	      if (date) {
	        if (typeof this.disabledDate === 'function' && this.disabledDate(date)) {
	          return;
	        }
	        this.date = Object(date_util_["modifyTime"])(date, this.date.getHours(), this.date.getMinutes(), this.date.getSeconds());
	        this.userInputDate = null;
	        this.resetView();
	        this.emit(this.date, true);
	      }
	    },
	    isValidValue: function isValidValue(value) {
	      return value && !isNaN(value) && (typeof this.disabledDate === 'function' ? !this.disabledDate(value) : true) && this.checkDateWithinRange(value);
	    },
	    getDefaultValue: function getDefaultValue() {
	      // if default-value is set, return it
	      // otherwise, return now (the moment this method gets called)
	      return this.defaultValue ? new Date(this.defaultValue) : new Date();
	    },
	    checkDateWithinRange: function checkDateWithinRange(date) {
	      return this.selectableRange.length > 0 ? Object(date_util_["timeWithinRange"])(date, this.selectableRange, this.format || 'HH:mm:ss') : true;
	    }
	  },
	
	  components: {
	    TimePicker: panel_time, YearTable: year_table, MonthTable: month_table, DateTable: date_table, ElInput: input_default.a, ElButton: button_default.a
	  },
	
	  data: function data() {
	    return {
	      popperClass: '',
	      date: new Date(),
	      value: '',
	      defaultValue: null, // use getDefaultValue() for time computation
	      defaultTime: null,
	      showTime: false,
	      selectionMode: 'day',
	      shortcuts: '',
	      visible: false,
	      currentView: 'date',
	      disabledDate: '',
	      cellClassName: '',
	      selectableRange: [],
	      firstDayOfWeek: 7,
	      showWeekNumber: false,
	      timePickerVisible: false,
	      format: '',
	      arrowControl: false,
	      userInputDate: null,
	      userInputTime: null
	    };
	  },
	
	
	  computed: {
	    year: function year() {
	      return this.date.getFullYear();
	    },
	    month: function month() {
	      return this.date.getMonth();
	    },
	    week: function week() {
	      return Object(date_util_["getWeekNumber"])(this.date);
	    },
	    monthDate: function monthDate() {
	      return this.date.getDate();
	    },
	    footerVisible: function footerVisible() {
	      return this.showTime || this.selectionMode === 'dates';
	    },
	    visibleTime: function visibleTime() {
	      if (this.userInputTime !== null) {
	        return this.userInputTime;
	      } else {
	        return Object(date_util_["formatDate"])(this.value || this.defaultValue, this.timeFormat);
	      }
	    },
	    visibleDate: function visibleDate() {
	      if (this.userInputDate !== null) {
	        return this.userInputDate;
	      } else {
	        return Object(date_util_["formatDate"])(this.value || this.defaultValue, this.dateFormat);
	      }
	    },
	    yearLabel: function yearLabel() {
	      var yearTranslation = this.t('el.datepicker.year');
	      if (this.currentView === 'year') {
	        var startYear = Math.floor(this.year / 10) * 10;
	        if (yearTranslation) {
	          return startYear + ' ' + yearTranslation + ' - ' + (startYear + 9) + ' ' + yearTranslation;
	        }
	        return startYear + ' - ' + (startYear + 9);
	      }
	      return this.year + ' ' + yearTranslation;
	    },
	    timeFormat: function timeFormat() {
	      if (this.format) {
	        return Object(date_util_["extractTimeFormat"])(this.format);
	      } else {
	        return 'HH:mm:ss';
	      }
	    },
	    dateFormat: function dateFormat() {
	      if (this.format) {
	        return Object(date_util_["extractDateFormat"])(this.format);
	      } else {
	        return 'yyyy-MM-dd';
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/date.vue?vue&type=script&lang=js&
	 /* harmony default export */ var panel_datevue_type_script_lang_js_ = (datevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/date.vue
	
	
	
	
	
	/* normalize component */
	
	var date_component = normalizeComponent(
	  panel_datevue_type_script_lang_js_,
	  datevue_type_template_id_2440d4ea_render,
	  datevue_type_template_id_2440d4ea_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var date_api; }
	date_component.options.__file = "packages/date-picker/src/panel/date.vue"
	/* harmony default export */ var panel_date = (date_component.exports);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/date-range.vue?vue&type=template&id=2652849a&
	var date_rangevue_type_template_id_2652849a_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    {
	      attrs: { name: "el-zoom-in-top" },
	      on: {
	        "after-leave": function($event) {
	          _vm.$emit("dodestroy")
	        }
	      }
	    },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.visible,
	              expression: "visible"
	            }
	          ],
	          staticClass: "el-picker-panel el-date-range-picker el-popper",
	          class: [
	            {
	              "has-sidebar": _vm.$slots.sidebar || _vm.shortcuts,
	              "has-time": _vm.showTime
	            },
	            _vm.popperClass
	          ]
	        },
	        [
	          _c(
	            "div",
	            { staticClass: "el-picker-panel__body-wrapper" },
	            [
	              _vm._t("sidebar"),
	              _vm.shortcuts
	                ? _c(
	                    "div",
	                    { staticClass: "el-picker-panel__sidebar" },
	                    _vm._l(_vm.shortcuts, function(shortcut, key) {
	                      return _c(
	                        "button",
	                        {
	                          key: key,
	                          staticClass: "el-picker-panel__shortcut",
	                          attrs: { type: "button" },
	                          on: {
	                            click: function($event) {
	                              _vm.handleShortcutClick(shortcut)
	                            }
	                          }
	                        },
	                        [_vm._v(_vm._s(shortcut.text))]
	                      )
	                    }),
	                    0
	                  )
	                : _vm._e(),
	              _c("div", { staticClass: "el-picker-panel__body" }, [
	                _vm.showTime
	                  ? _c(
	                      "div",
	                      { staticClass: "el-date-range-picker__time-header" },
	                      [
	                        _c(
	                          "span",
	                          { staticClass: "el-date-range-picker__editors-wrap" },
	                          [
	                            _c(
	                              "span",
	                              {
	                                staticClass:
	                                  "el-date-range-picker__time-picker-wrap"
	                              },
	                              [
	                                _c("el-input", {
	                                  ref: "minInput",
	                                  staticClass: "el-date-range-picker__editor",
	                                  attrs: {
	                                    size: "small",
	                                    disabled: _vm.rangeState.selecting,
	                                    placeholder: _vm.t(
	                                      "el.datepicker.startDate"
	                                    ),
	                                    value: _vm.minVisibleDate
	                                  },
	                                  on: {
	                                    input: function(val) {
	                                      return _vm.handleDateInput(val, "min")
	                                    },
	                                    change: function(val) {
	                                      return _vm.handleDateChange(val, "min")
	                                    }
	                                  }
	                                })
	                              ],
	                              1
	                            ),
	                            _c(
	                              "span",
	                              {
	                                directives: [
	                                  {
	                                    name: "clickoutside",
	                                    rawName: "v-clickoutside",
	                                    value: _vm.handleMinTimeClose,
	                                    expression: "handleMinTimeClose"
	                                  }
	                                ],
	                                staticClass:
	                                  "el-date-range-picker__time-picker-wrap"
	                              },
	                              [
	                                _c("el-input", {
	                                  staticClass: "el-date-range-picker__editor",
	                                  attrs: {
	                                    size: "small",
	                                    disabled: _vm.rangeState.selecting,
	                                    placeholder: _vm.t(
	                                      "el.datepicker.startTime"
	                                    ),
	                                    value: _vm.minVisibleTime
	                                  },
	                                  on: {
	                                    focus: function($event) {
	                                      _vm.minTimePickerVisible = true
	                                    },
	                                    input: function(val) {
	                                      return _vm.handleTimeInput(val, "min")
	                                    },
	                                    change: function(val) {
	                                      return _vm.handleTimeChange(val, "min")
	                                    }
	                                  }
	                                }),
	                                _c("time-picker", {
	                                  ref: "minTimePicker",
	                                  attrs: {
	                                    "time-arrow-control": _vm.arrowControl,
	                                    visible: _vm.minTimePickerVisible
	                                  },
	                                  on: {
	                                    pick: _vm.handleMinTimePick,
	                                    mounted: function($event) {
	                                      _vm.$refs.minTimePicker.format =
	                                        _vm.timeFormat
	                                    }
	                                  }
	                                })
	                              ],
	                              1
	                            )
	                          ]
	                        ),
	                        _c("span", { staticClass: "el-icon-arrow-right" }),
	                        _c(
	                          "span",
	                          {
	                            staticClass:
	                              "el-date-range-picker__editors-wrap is-right"
	                          },
	                          [
	                            _c(
	                              "span",
	                              {
	                                staticClass:
	                                  "el-date-range-picker__time-picker-wrap"
	                              },
	                              [
	                                _c("el-input", {
	                                  staticClass: "el-date-range-picker__editor",
	                                  attrs: {
	                                    size: "small",
	                                    disabled: _vm.rangeState.selecting,
	                                    placeholder: _vm.t("el.datepicker.endDate"),
	                                    value: _vm.maxVisibleDate,
	                                    readonly: !_vm.minDate
	                                  },
	                                  on: {
	                                    input: function(val) {
	                                      return _vm.handleDateInput(val, "max")
	                                    },
	                                    change: function(val) {
	                                      return _vm.handleDateChange(val, "max")
	                                    }
	                                  }
	                                })
	                              ],
	                              1
	                            ),
	                            _c(
	                              "span",
	                              {
	                                directives: [
	                                  {
	                                    name: "clickoutside",
	                                    rawName: "v-clickoutside",
	                                    value: _vm.handleMaxTimeClose,
	                                    expression: "handleMaxTimeClose"
	                                  }
	                                ],
	                                staticClass:
	                                  "el-date-range-picker__time-picker-wrap"
	                              },
	                              [
	                                _c("el-input", {
	                                  staticClass: "el-date-range-picker__editor",
	                                  attrs: {
	                                    size: "small",
	                                    disabled: _vm.rangeState.selecting,
	                                    placeholder: _vm.t("el.datepicker.endTime"),
	                                    value: _vm.maxVisibleTime,
	                                    readonly: !_vm.minDate
	                                  },
	                                  on: {
	                                    focus: function($event) {
	                                      _vm.minDate &&
	                                        (_vm.maxTimePickerVisible = true)
	                                    },
	                                    input: function(val) {
	                                      return _vm.handleTimeInput(val, "max")
	                                    },
	                                    change: function(val) {
	                                      return _vm.handleTimeChange(val, "max")
	                                    }
	                                  }
	                                }),
	                                _c("time-picker", {
	                                  ref: "maxTimePicker",
	                                  attrs: {
	                                    "time-arrow-control": _vm.arrowControl,
	                                    visible: _vm.maxTimePickerVisible
	                                  },
	                                  on: {
	                                    pick: _vm.handleMaxTimePick,
	                                    mounted: function($event) {
	                                      _vm.$refs.maxTimePicker.format =
	                                        _vm.timeFormat
	                                    }
	                                  }
	                                })
	                              ],
	                              1
	                            )
	                          ]
	                        )
	                      ]
	                    )
	                  : _vm._e(),
	                _c(
	                  "div",
	                  {
	                    staticClass:
	                      "el-picker-panel__content el-date-range-picker__content is-left"
	                  },
	                  [
	                    _c("div", { staticClass: "el-date-range-picker__header" }, [
	                      _c("button", {
	                        staticClass:
	                          "el-picker-panel__icon-btn el-icon-d-arrow-left",
	                        attrs: { type: "button" },
	                        on: { click: _vm.leftPrevYear }
	                      }),
	                      _c("button", {
	                        staticClass:
	                          "el-picker-panel__icon-btn el-icon-arrow-left",
	                        attrs: { type: "button" },
	                        on: { click: _vm.leftPrevMonth }
	                      }),
	                      _vm.unlinkPanels
	                        ? _c("button", {
	                            staticClass:
	                              "el-picker-panel__icon-btn el-icon-d-arrow-right",
	                            class: { "is-disabled": !_vm.enableYearArrow },
	                            attrs: {
	                              type: "button",
	                              disabled: !_vm.enableYearArrow
	                            },
	                            on: { click: _vm.leftNextYear }
	                          })
	                        : _vm._e(),
	                      _vm.unlinkPanels
	                        ? _c("button", {
	                            staticClass:
	                              "el-picker-panel__icon-btn el-icon-arrow-right",
	                            class: { "is-disabled": !_vm.enableMonthArrow },
	                            attrs: {
	                              type: "button",
	                              disabled: !_vm.enableMonthArrow
	                            },
	                            on: { click: _vm.leftNextMonth }
	                          })
	                        : _vm._e(),
	                      _c("div", [_vm._v(_vm._s(_vm.leftLabel))])
	                    ]),
	                    _c("date-table", {
	                      attrs: {
	                        "selection-mode": "range",
	                        date: _vm.leftDate,
	                        "default-value": _vm.defaultValue,
	                        "min-date": _vm.minDate,
	                        "max-date": _vm.maxDate,
	                        "range-state": _vm.rangeState,
	                        "disabled-date": _vm.disabledDate,
	                        "cell-class-name": _vm.cellClassName,
	                        "first-day-of-week": _vm.firstDayOfWeek
	                      },
	                      on: {
	                        changerange: _vm.handleChangeRange,
	                        pick: _vm.handleRangePick
	                      }
	                    })
	                  ],
	                  1
	                ),
	                _c(
	                  "div",
	                  {
	                    staticClass:
	                      "el-picker-panel__content el-date-range-picker__content is-right"
	                  },
	                  [
	                    _c("div", { staticClass: "el-date-range-picker__header" }, [
	                      _vm.unlinkPanels
	                        ? _c("button", {
	                            staticClass:
	                              "el-picker-panel__icon-btn el-icon-d-arrow-left",
	                            class: { "is-disabled": !_vm.enableYearArrow },
	                            attrs: {
	                              type: "button",
	                              disabled: !_vm.enableYearArrow
	                            },
	                            on: { click: _vm.rightPrevYear }
	                          })
	                        : _vm._e(),
	                      _vm.unlinkPanels
	                        ? _c("button", {
	                            staticClass:
	                              "el-picker-panel__icon-btn el-icon-arrow-left",
	                            class: { "is-disabled": !_vm.enableMonthArrow },
	                            attrs: {
	                              type: "button",
	                              disabled: !_vm.enableMonthArrow
	                            },
	                            on: { click: _vm.rightPrevMonth }
	                          })
	                        : _vm._e(),
	                      _c("button", {
	                        staticClass:
	                          "el-picker-panel__icon-btn el-icon-d-arrow-right",
	                        attrs: { type: "button" },
	                        on: { click: _vm.rightNextYear }
	                      }),
	                      _c("button", {
	                        staticClass:
	                          "el-picker-panel__icon-btn el-icon-arrow-right",
	                        attrs: { type: "button" },
	                        on: { click: _vm.rightNextMonth }
	                      }),
	                      _c("div", [_vm._v(_vm._s(_vm.rightLabel))])
	                    ]),
	                    _c("date-table", {
	                      attrs: {
	                        "selection-mode": "range",
	                        date: _vm.rightDate,
	                        "default-value": _vm.defaultValue,
	                        "min-date": _vm.minDate,
	                        "max-date": _vm.maxDate,
	                        "range-state": _vm.rangeState,
	                        "disabled-date": _vm.disabledDate,
	                        "cell-class-name": _vm.cellClassName,
	                        "first-day-of-week": _vm.firstDayOfWeek
	                      },
	                      on: {
	                        changerange: _vm.handleChangeRange,
	                        pick: _vm.handleRangePick
	                      }
	                    })
	                  ],
	                  1
	                )
	              ])
	            ],
	            2
	          ),
	          _vm.showTime
	            ? _c(
	                "div",
	                { staticClass: "el-picker-panel__footer" },
	                [
	                  _c(
	                    "el-button",
	                    {
	                      staticClass: "el-picker-panel__link-btn",
	                      attrs: { size: "mini", type: "text" },
	                      on: { click: _vm.handleClear }
	                    },
	                    [
	                      _vm._v(
	                        "\n        " +
	                          _vm._s(_vm.t("el.datepicker.clear")) +
	                          "\n      "
	                      )
	                    ]
	                  ),
	                  _c(
	                    "el-button",
	                    {
	                      staticClass: "el-picker-panel__link-btn",
	                      attrs: {
	                        plain: "",
	                        size: "mini",
	                        disabled: _vm.btnDisabled
	                      },
	                      on: {
	                        click: function($event) {
	                          _vm.handleConfirm(false)
	                        }
	                      }
	                    },
	                    [
	                      _vm._v(
	                        "\n        " +
	                          _vm._s(_vm.t("el.datepicker.confirm")) +
	                          "\n      "
	                      )
	                    ]
	                  )
	                ],
	                1
	              )
	            : _vm._e()
	        ]
	      )
	    ]
	  )
	}
	var date_rangevue_type_template_id_2652849a_staticRenderFns = []
	date_rangevue_type_template_id_2652849a_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/date-range.vue?vue&type=template&id=2652849a&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/date-range.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	var date_rangevue_type_script_lang_js_calcDefaultValue = function calcDefaultValue(defaultValue) {
	  if (Array.isArray(defaultValue)) {
	    return [new Date(defaultValue[0]), new Date(defaultValue[1])];
	  } else if (defaultValue) {
	    return [new Date(defaultValue), Object(date_util_["nextDate"])(new Date(defaultValue), 1)];
	  } else {
	    return [new Date(), Object(date_util_["nextDate"])(new Date(), 1)];
	  }
	};
	
	/* harmony default export */ var date_rangevue_type_script_lang_js_ = ({
	  mixins: [locale_default.a],
	
	  directives: { Clickoutside: clickoutside_default.a },
	
	  computed: {
	    btnDisabled: function btnDisabled() {
	      return !(this.minDate && this.maxDate && !this.selecting && this.isValidValue([this.minDate, this.maxDate]));
	    },
	    leftLabel: function leftLabel() {
	      return this.leftDate.getFullYear() + ' ' + this.t('el.datepicker.year') + ' ' + this.t('el.datepicker.month' + (this.leftDate.getMonth() + 1));
	    },
	    rightLabel: function rightLabel() {
	      return this.rightDate.getFullYear() + ' ' + this.t('el.datepicker.year') + ' ' + this.t('el.datepicker.month' + (this.rightDate.getMonth() + 1));
	    },
	    leftYear: function leftYear() {
	      return this.leftDate.getFullYear();
	    },
	    leftMonth: function leftMonth() {
	      return this.leftDate.getMonth();
	    },
	    leftMonthDate: function leftMonthDate() {
	      return this.leftDate.getDate();
	    },
	    rightYear: function rightYear() {
	      return this.rightDate.getFullYear();
	    },
	    rightMonth: function rightMonth() {
	      return this.rightDate.getMonth();
	    },
	    rightMonthDate: function rightMonthDate() {
	      return this.rightDate.getDate();
	    },
	    minVisibleDate: function minVisibleDate() {
	      if (this.dateUserInput.min !== null) return this.dateUserInput.min;
	      if (this.minDate) return Object(date_util_["formatDate"])(this.minDate, this.dateFormat);
	      return '';
	    },
	    maxVisibleDate: function maxVisibleDate() {
	      if (this.dateUserInput.max !== null) return this.dateUserInput.max;
	      if (this.maxDate || this.minDate) return Object(date_util_["formatDate"])(this.maxDate || this.minDate, this.dateFormat);
	      return '';
	    },
	    minVisibleTime: function minVisibleTime() {
	      if (this.timeUserInput.min !== null) return this.timeUserInput.min;
	      if (this.minDate) return Object(date_util_["formatDate"])(this.minDate, this.timeFormat);
	      return '';
	    },
	    maxVisibleTime: function maxVisibleTime() {
	      if (this.timeUserInput.max !== null) return this.timeUserInput.max;
	      if (this.maxDate || this.minDate) return Object(date_util_["formatDate"])(this.maxDate || this.minDate, this.timeFormat);
	      return '';
	    },
	    timeFormat: function timeFormat() {
	      if (this.format) {
	        return Object(date_util_["extractTimeFormat"])(this.format);
	      } else {
	        return 'HH:mm:ss';
	      }
	    },
	    dateFormat: function dateFormat() {
	      if (this.format) {
	        return Object(date_util_["extractDateFormat"])(this.format);
	      } else {
	        return 'yyyy-MM-dd';
	      }
	    },
	    enableMonthArrow: function enableMonthArrow() {
	      var nextMonth = (this.leftMonth + 1) % 12;
	      var yearOffset = this.leftMonth + 1 >= 12 ? 1 : 0;
	      return this.unlinkPanels && new Date(this.leftYear + yearOffset, nextMonth) < new Date(this.rightYear, this.rightMonth);
	    },
	    enableYearArrow: function enableYearArrow() {
	      return this.unlinkPanels && this.rightYear * 12 + this.rightMonth - (this.leftYear * 12 + this.leftMonth + 1) >= 12;
	    }
	  },
	
	  data: function data() {
	    return {
	      popperClass: '',
	      value: [],
	      defaultValue: null,
	      defaultTime: null,
	      minDate: '',
	      maxDate: '',
	      leftDate: new Date(),
	      rightDate: Object(date_util_["nextMonth"])(new Date()),
	      rangeState: {
	        endDate: null,
	        selecting: false,
	        row: null,
	        column: null
	      },
	      showTime: false,
	      shortcuts: '',
	      visible: '',
	      disabledDate: '',
	      cellClassName: '',
	      firstDayOfWeek: 7,
	      minTimePickerVisible: false,
	      maxTimePickerVisible: false,
	      format: '',
	      arrowControl: false,
	      unlinkPanels: false,
	      dateUserInput: {
	        min: null,
	        max: null
	      },
	      timeUserInput: {
	        min: null,
	        max: null
	      }
	    };
	  },
	
	
	  watch: {
	    minDate: function minDate(val) {
	      var _this = this;
	
	      this.dateUserInput.min = null;
	      this.timeUserInput.min = null;
	      this.$nextTick(function () {
	        if (_this.$refs.maxTimePicker && _this.maxDate && _this.maxDate < _this.minDate) {
	          var format = 'HH:mm:ss';
	          _this.$refs.maxTimePicker.selectableRange = [[Object(date_util_["parseDate"])(Object(date_util_["formatDate"])(_this.minDate, format), format), Object(date_util_["parseDate"])('23:59:59', format)]];
	        }
	      });
	      if (val && this.$refs.minTimePicker) {
	        this.$refs.minTimePicker.date = val;
	        this.$refs.minTimePicker.value = val;
	      }
	    },
	    maxDate: function maxDate(val) {
	      this.dateUserInput.max = null;
	      this.timeUserInput.max = null;
	      if (val && this.$refs.maxTimePicker) {
	        this.$refs.maxTimePicker.date = val;
	        this.$refs.maxTimePicker.value = val;
	      }
	    },
	    minTimePickerVisible: function minTimePickerVisible(val) {
	      var _this2 = this;
	
	      if (val) {
	        this.$nextTick(function () {
	          _this2.$refs.minTimePicker.date = _this2.minDate;
	          _this2.$refs.minTimePicker.value = _this2.minDate;
	          _this2.$refs.minTimePicker.adjustSpinners();
	        });
	      }
	    },
	    maxTimePickerVisible: function maxTimePickerVisible(val) {
	      var _this3 = this;
	
	      if (val) {
	        this.$nextTick(function () {
	          _this3.$refs.maxTimePicker.date = _this3.maxDate;
	          _this3.$refs.maxTimePicker.value = _this3.maxDate;
	          _this3.$refs.maxTimePicker.adjustSpinners();
	        });
	      }
	    },
	    value: function value(newVal) {
	      if (!newVal) {
	        this.minDate = null;
	        this.maxDate = null;
	      } else if (Array.isArray(newVal)) {
	        this.minDate = Object(date_util_["isDate"])(newVal[0]) ? new Date(newVal[0]) : null;
	        this.maxDate = Object(date_util_["isDate"])(newVal[1]) ? new Date(newVal[1]) : null;
	        if (this.minDate) {
	          this.leftDate = this.minDate;
	          if (this.unlinkPanels && this.maxDate) {
	            var minDateYear = this.minDate.getFullYear();
	            var minDateMonth = this.minDate.getMonth();
	            var maxDateYear = this.maxDate.getFullYear();
	            var maxDateMonth = this.maxDate.getMonth();
	            this.rightDate = minDateYear === maxDateYear && minDateMonth === maxDateMonth ? Object(date_util_["nextMonth"])(this.maxDate) : this.maxDate;
	          } else {
	            this.rightDate = Object(date_util_["nextMonth"])(this.leftDate);
	          }
	        } else {
	          this.leftDate = date_rangevue_type_script_lang_js_calcDefaultValue(this.defaultValue)[0];
	          this.rightDate = Object(date_util_["nextMonth"])(this.leftDate);
	        }
	      }
	    },
	    defaultValue: function defaultValue(val) {
	      if (!Array.isArray(this.value)) {
	        var _calcDefaultValue = date_rangevue_type_script_lang_js_calcDefaultValue(val),
	            left = _calcDefaultValue[0],
	            right = _calcDefaultValue[1];
	
	        this.leftDate = left;
	        this.rightDate = val && val[1] && this.unlinkPanels ? right : Object(date_util_["nextMonth"])(this.leftDate);
	      }
	    }
	  },
	
	  methods: {
	    handleClear: function handleClear() {
	      this.minDate = null;
	      this.maxDate = null;
	      this.leftDate = date_rangevue_type_script_lang_js_calcDefaultValue(this.defaultValue)[0];
	      this.rightDate = Object(date_util_["nextMonth"])(this.leftDate);
	      this.$emit('pick', null);
	    },
	    handleChangeRange: function handleChangeRange(val) {
	      this.minDate = val.minDate;
	      this.maxDate = val.maxDate;
	      this.rangeState = val.rangeState;
	    },
	    handleDateInput: function handleDateInput(value, type) {
	      this.dateUserInput[type] = value;
	      if (value.length !== this.dateFormat.length) return;
	      var parsedValue = Object(date_util_["parseDate"])(value, this.dateFormat);
	
	      if (parsedValue) {
	        if (typeof this.disabledDate === 'function' && this.disabledDate(new Date(parsedValue))) {
	          return;
	        }
	        if (type === 'min') {
	          this.minDate = Object(date_util_["modifyDate"])(this.minDate || new Date(), parsedValue.getFullYear(), parsedValue.getMonth(), parsedValue.getDate());
	          this.leftDate = new Date(parsedValue);
	          if (!this.unlinkPanels) {
	            this.rightDate = Object(date_util_["nextMonth"])(this.leftDate);
	          }
	        } else {
	          this.maxDate = Object(date_util_["modifyDate"])(this.maxDate || new Date(), parsedValue.getFullYear(), parsedValue.getMonth(), parsedValue.getDate());
	          this.rightDate = new Date(parsedValue);
	          if (!this.unlinkPanels) {
	            this.leftDate = Object(date_util_["prevMonth"])(parsedValue);
	          }
	        }
	      }
	    },
	    handleDateChange: function handleDateChange(value, type) {
	      var parsedValue = Object(date_util_["parseDate"])(value, this.dateFormat);
	      if (parsedValue) {
	        if (type === 'min') {
	          this.minDate = Object(date_util_["modifyDate"])(this.minDate, parsedValue.getFullYear(), parsedValue.getMonth(), parsedValue.getDate());
	          if (this.minDate > this.maxDate) {
	            this.maxDate = this.minDate;
	          }
	        } else {
	          this.maxDate = Object(date_util_["modifyDate"])(this.maxDate, parsedValue.getFullYear(), parsedValue.getMonth(), parsedValue.getDate());
	          if (this.maxDate < this.minDate) {
	            this.minDate = this.maxDate;
	          }
	        }
	      }
	    },
	    handleTimeInput: function handleTimeInput(value, type) {
	      var _this4 = this;
	
	      this.timeUserInput[type] = value;
	      if (value.length !== this.timeFormat.length) return;
	      var parsedValue = Object(date_util_["parseDate"])(value, this.timeFormat);
	
	      if (parsedValue) {
	        if (type === 'min') {
	          this.minDate = Object(date_util_["modifyTime"])(this.minDate, parsedValue.getHours(), parsedValue.getMinutes(), parsedValue.getSeconds());
	          this.$nextTick(function (_) {
	            return _this4.$refs.minTimePicker.adjustSpinners();
	          });
	        } else {
	          this.maxDate = Object(date_util_["modifyTime"])(this.maxDate, parsedValue.getHours(), parsedValue.getMinutes(), parsedValue.getSeconds());
	          this.$nextTick(function (_) {
	            return _this4.$refs.maxTimePicker.adjustSpinners();
	          });
	        }
	      }
	    },
	    handleTimeChange: function handleTimeChange(value, type) {
	      var parsedValue = Object(date_util_["parseDate"])(value, this.timeFormat);
	      if (parsedValue) {
	        if (type === 'min') {
	          this.minDate = Object(date_util_["modifyTime"])(this.minDate, parsedValue.getHours(), parsedValue.getMinutes(), parsedValue.getSeconds());
	          if (this.minDate > this.maxDate) {
	            this.maxDate = this.minDate;
	          }
	          this.$refs.minTimePicker.value = this.minDate;
	          this.minTimePickerVisible = false;
	        } else {
	          this.maxDate = Object(date_util_["modifyTime"])(this.maxDate, parsedValue.getHours(), parsedValue.getMinutes(), parsedValue.getSeconds());
	          if (this.maxDate < this.minDate) {
	            this.minDate = this.maxDate;
	          }
	          this.$refs.maxTimePicker.value = this.minDate;
	          this.maxTimePickerVisible = false;
	        }
	      }
	    },
	    handleRangePick: function handleRangePick(val) {
	      var _this5 = this;
	
	      var close = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      var defaultTime = this.defaultTime || [];
	      var minDate = Object(date_util_["modifyWithTimeString"])(val.minDate, defaultTime[0]);
	      var maxDate = Object(date_util_["modifyWithTimeString"])(val.maxDate, defaultTime[1]);
	
	      if (this.maxDate === maxDate && this.minDate === minDate) {
	        return;
	      }
	      this.onPick && this.onPick(val);
	      this.maxDate = maxDate;
	      this.minDate = minDate;
	
	      // workaround for https://github.com/ElemeFE/element/issues/7539, should remove this block when we don't have to care about Chromium 55 - 57
	      setTimeout(function () {
	        _this5.maxDate = maxDate;
	        _this5.minDate = minDate;
	      }, 10);
	      if (!close || this.showTime) return;
	      this.handleConfirm();
	    },
	    handleShortcutClick: function handleShortcutClick(shortcut) {
	      if (shortcut.onClick) {
	        shortcut.onClick(this);
	      }
	    },
	    handleMinTimePick: function handleMinTimePick(value, visible, first) {
	      this.minDate = this.minDate || new Date();
	      if (value) {
	        this.minDate = Object(date_util_["modifyTime"])(this.minDate, value.getHours(), value.getMinutes(), value.getSeconds());
	      }
	
	      if (!first) {
	        this.minTimePickerVisible = visible;
	      }
	
	      if (!this.maxDate || this.maxDate && this.maxDate.getTime() < this.minDate.getTime()) {
	        this.maxDate = new Date(this.minDate);
	      }
	    },
	    handleMinTimeClose: function handleMinTimeClose() {
	      this.minTimePickerVisible = false;
	    },
	    handleMaxTimePick: function handleMaxTimePick(value, visible, first) {
	      if (this.maxDate && value) {
	        this.maxDate = Object(date_util_["modifyTime"])(this.maxDate, value.getHours(), value.getMinutes(), value.getSeconds());
	      }
	
	      if (!first) {
	        this.maxTimePickerVisible = visible;
	      }
	
	      if (this.maxDate && this.minDate && this.minDate.getTime() > this.maxDate.getTime()) {
	        this.minDate = new Date(this.maxDate);
	      }
	    },
	    handleMaxTimeClose: function handleMaxTimeClose() {
	      this.maxTimePickerVisible = false;
	    },
	
	
	    // leftPrev*, rightNext* need to take care of `unlinkPanels`
	    leftPrevYear: function leftPrevYear() {
	      this.leftDate = Object(date_util_["prevYear"])(this.leftDate);
	      if (!this.unlinkPanels) {
	        this.rightDate = Object(date_util_["nextMonth"])(this.leftDate);
	      }
	    },
	    leftPrevMonth: function leftPrevMonth() {
	      this.leftDate = Object(date_util_["prevMonth"])(this.leftDate);
	      if (!this.unlinkPanels) {
	        this.rightDate = Object(date_util_["nextMonth"])(this.leftDate);
	      }
	    },
	    rightNextYear: function rightNextYear() {
	      if (!this.unlinkPanels) {
	        this.leftDate = Object(date_util_["nextYear"])(this.leftDate);
	        this.rightDate = Object(date_util_["nextMonth"])(this.leftDate);
	      } else {
	        this.rightDate = Object(date_util_["nextYear"])(this.rightDate);
	      }
	    },
	    rightNextMonth: function rightNextMonth() {
	      if (!this.unlinkPanels) {
	        this.leftDate = Object(date_util_["nextMonth"])(this.leftDate);
	        this.rightDate = Object(date_util_["nextMonth"])(this.leftDate);
	      } else {
	        this.rightDate = Object(date_util_["nextMonth"])(this.rightDate);
	      }
	    },
	
	
	    // leftNext*, rightPrev* are called when `unlinkPanels` is true
	    leftNextYear: function leftNextYear() {
	      this.leftDate = Object(date_util_["nextYear"])(this.leftDate);
	    },
	    leftNextMonth: function leftNextMonth() {
	      this.leftDate = Object(date_util_["nextMonth"])(this.leftDate);
	    },
	    rightPrevYear: function rightPrevYear() {
	      this.rightDate = Object(date_util_["prevYear"])(this.rightDate);
	    },
	    rightPrevMonth: function rightPrevMonth() {
	      this.rightDate = Object(date_util_["prevMonth"])(this.rightDate);
	    },
	    handleConfirm: function handleConfirm() {
	      var visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (this.isValidValue([this.minDate, this.maxDate])) {
	        this.$emit('pick', [this.minDate, this.maxDate], visible);
	      }
	    },
	    isValidValue: function isValidValue(value) {
	      return Array.isArray(value) && value && value[0] && value[1] && Object(date_util_["isDate"])(value[0]) && Object(date_util_["isDate"])(value[1]) && value[0].getTime() <= value[1].getTime() && (typeof this.disabledDate === 'function' ? !this.disabledDate(value[0]) && !this.disabledDate(value[1]) : true);
	    },
	    resetView: function resetView() {
	      // NOTE: this is a hack to reset {min, max}Date on picker open.
	      // TODO: correct way of doing so is to refactor {min, max}Date to be dependent on value and internal selection state
	      //       an alternative would be resetView whenever picker becomes visible, should also investigate date-panel's resetView
	      if (this.minDate && this.maxDate == null) this.rangeState.selecting = false;
	      this.minDate = this.value && Object(date_util_["isDate"])(this.value[0]) ? new Date(this.value[0]) : null;
	      this.maxDate = this.value && Object(date_util_["isDate"])(this.value[0]) ? new Date(this.value[1]) : null;
	    }
	  },
	
	  components: { TimePicker: panel_time, DateTable: date_table, ElInput: input_default.a, ElButton: button_default.a }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/date-range.vue?vue&type=script&lang=js&
	 /* harmony default export */ var panel_date_rangevue_type_script_lang_js_ = (date_rangevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/date-range.vue
	
	
	
	
	
	/* normalize component */
	
	var date_range_component = normalizeComponent(
	  panel_date_rangevue_type_script_lang_js_,
	  date_rangevue_type_template_id_2652849a_render,
	  date_rangevue_type_template_id_2652849a_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var date_range_api; }
	date_range_component.options.__file = "packages/date-picker/src/panel/date-range.vue"
	/* harmony default export */ var date_range = (date_range_component.exports);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/month-range.vue?vue&type=template&id=f2645fb8&
	var month_rangevue_type_template_id_f2645fb8_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    {
	      attrs: { name: "el-zoom-in-top" },
	      on: {
	        "after-leave": function($event) {
	          _vm.$emit("dodestroy")
	        }
	      }
	    },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.visible,
	              expression: "visible"
	            }
	          ],
	          staticClass: "el-picker-panel el-date-range-picker el-popper",
	          class: [
	            {
	              "has-sidebar": _vm.$slots.sidebar || _vm.shortcuts
	            },
	            _vm.popperClass
	          ]
	        },
	        [
	          _c(
	            "div",
	            { staticClass: "el-picker-panel__body-wrapper" },
	            [
	              _vm._t("sidebar"),
	              _vm.shortcuts
	                ? _c(
	                    "div",
	                    { staticClass: "el-picker-panel__sidebar" },
	                    _vm._l(_vm.shortcuts, function(shortcut, key) {
	                      return _c(
	                        "button",
	                        {
	                          key: key,
	                          staticClass: "el-picker-panel__shortcut",
	                          attrs: { type: "button" },
	                          on: {
	                            click: function($event) {
	                              _vm.handleShortcutClick(shortcut)
	                            }
	                          }
	                        },
	                        [_vm._v(_vm._s(shortcut.text))]
	                      )
	                    }),
	                    0
	                  )
	                : _vm._e(),
	              _c("div", { staticClass: "el-picker-panel__body" }, [
	                _c(
	                  "div",
	                  {
	                    staticClass:
	                      "el-picker-panel__content el-date-range-picker__content is-left"
	                  },
	                  [
	                    _c("div", { staticClass: "el-date-range-picker__header" }, [
	                      _c("button", {
	                        staticClass:
	                          "el-picker-panel__icon-btn el-icon-d-arrow-left",
	                        attrs: { type: "button" },
	                        on: { click: _vm.leftPrevYear }
	                      }),
	                      _vm.unlinkPanels
	                        ? _c("button", {
	                            staticClass:
	                              "el-picker-panel__icon-btn el-icon-d-arrow-right",
	                            class: { "is-disabled": !_vm.enableYearArrow },
	                            attrs: {
	                              type: "button",
	                              disabled: !_vm.enableYearArrow
	                            },
	                            on: { click: _vm.leftNextYear }
	                          })
	                        : _vm._e(),
	                      _c("div", [_vm._v(_vm._s(_vm.leftLabel))])
	                    ]),
	                    _c("month-table", {
	                      attrs: {
	                        "selection-mode": "range",
	                        date: _vm.leftDate,
	                        "default-value": _vm.defaultValue,
	                        "min-date": _vm.minDate,
	                        "max-date": _vm.maxDate,
	                        "range-state": _vm.rangeState,
	                        "disabled-date": _vm.disabledDate
	                      },
	                      on: {
	                        changerange: _vm.handleChangeRange,
	                        pick: _vm.handleRangePick
	                      }
	                    })
	                  ],
	                  1
	                ),
	                _c(
	                  "div",
	                  {
	                    staticClass:
	                      "el-picker-panel__content el-date-range-picker__content is-right"
	                  },
	                  [
	                    _c("div", { staticClass: "el-date-range-picker__header" }, [
	                      _vm.unlinkPanels
	                        ? _c("button", {
	                            staticClass:
	                              "el-picker-panel__icon-btn el-icon-d-arrow-left",
	                            class: { "is-disabled": !_vm.enableYearArrow },
	                            attrs: {
	                              type: "button",
	                              disabled: !_vm.enableYearArrow
	                            },
	                            on: { click: _vm.rightPrevYear }
	                          })
	                        : _vm._e(),
	                      _c("button", {
	                        staticClass:
	                          "el-picker-panel__icon-btn el-icon-d-arrow-right",
	                        attrs: { type: "button" },
	                        on: { click: _vm.rightNextYear }
	                      }),
	                      _c("div", [_vm._v(_vm._s(_vm.rightLabel))])
	                    ]),
	                    _c("month-table", {
	                      attrs: {
	                        "selection-mode": "range",
	                        date: _vm.rightDate,
	                        "default-value": _vm.defaultValue,
	                        "min-date": _vm.minDate,
	                        "max-date": _vm.maxDate,
	                        "range-state": _vm.rangeState,
	                        "disabled-date": _vm.disabledDate
	                      },
	                      on: {
	                        changerange: _vm.handleChangeRange,
	                        pick: _vm.handleRangePick
	                      }
	                    })
	                  ],
	                  1
	                )
	              ])
	            ],
	            2
	          )
	        ]
	      )
	    ]
	  )
	}
	var month_rangevue_type_template_id_f2645fb8_staticRenderFns = []
	month_rangevue_type_template_id_f2645fb8_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/month-range.vue?vue&type=template&id=f2645fb8&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/month-range.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	var month_rangevue_type_script_lang_js_calcDefaultValue = function calcDefaultValue(defaultValue) {
	  if (Array.isArray(defaultValue)) {
	    return [new Date(defaultValue[0]), new Date(defaultValue[1])];
	  } else if (defaultValue) {
	    return [new Date(defaultValue), Object(date_util_["nextMonth"])(new Date(defaultValue))];
	  } else {
	    return [new Date(), Object(date_util_["nextMonth"])(new Date())];
	  }
	};
	/* harmony default export */ var month_rangevue_type_script_lang_js_ = ({
	  mixins: [locale_default.a],
	
	  directives: { Clickoutside: clickoutside_default.a },
	
	  computed: {
	    btnDisabled: function btnDisabled() {
	      return !(this.minDate && this.maxDate && !this.selecting && this.isValidValue([this.minDate, this.maxDate]));
	    },
	    leftLabel: function leftLabel() {
	      return this.leftDate.getFullYear() + ' ' + this.t('el.datepicker.year');
	    },
	    rightLabel: function rightLabel() {
	      return this.rightDate.getFullYear() + ' ' + this.t('el.datepicker.year');
	    },
	    leftYear: function leftYear() {
	      return this.leftDate.getFullYear();
	    },
	    rightYear: function rightYear() {
	      return this.rightDate.getFullYear() === this.leftDate.getFullYear() ? this.leftDate.getFullYear() + 1 : this.rightDate.getFullYear();
	    },
	    enableYearArrow: function enableYearArrow() {
	      return this.unlinkPanels && this.rightYear > this.leftYear + 1;
	    }
	  },
	
	  data: function data() {
	    return {
	      popperClass: '',
	      value: [],
	      defaultValue: null,
	      defaultTime: null,
	      minDate: '',
	      maxDate: '',
	      leftDate: new Date(),
	      rightDate: Object(date_util_["nextYear"])(new Date()),
	      rangeState: {
	        endDate: null,
	        selecting: false,
	        row: null,
	        column: null
	      },
	      shortcuts: '',
	      visible: '',
	      disabledDate: '',
	      format: '',
	      arrowControl: false,
	      unlinkPanels: false
	    };
	  },
	
	
	  watch: {
	    value: function value(newVal) {
	      if (!newVal) {
	        this.minDate = null;
	        this.maxDate = null;
	      } else if (Array.isArray(newVal)) {
	        this.minDate = Object(date_util_["isDate"])(newVal[0]) ? new Date(newVal[0]) : null;
	        this.maxDate = Object(date_util_["isDate"])(newVal[1]) ? new Date(newVal[1]) : null;
	        if (this.minDate) {
	          this.leftDate = this.minDate;
	          if (this.unlinkPanels && this.maxDate) {
	            var minDateYear = this.minDate.getFullYear();
	            var maxDateYear = this.maxDate.getFullYear();
	            this.rightDate = minDateYear === maxDateYear ? Object(date_util_["nextYear"])(this.maxDate) : this.maxDate;
	          } else {
	            this.rightDate = Object(date_util_["nextYear"])(this.leftDate);
	          }
	        } else {
	          this.leftDate = month_rangevue_type_script_lang_js_calcDefaultValue(this.defaultValue)[0];
	          this.rightDate = Object(date_util_["nextYear"])(this.leftDate);
	        }
	      }
	    },
	    defaultValue: function defaultValue(val) {
	      if (!Array.isArray(this.value)) {
	        var _calcDefaultValue = month_rangevue_type_script_lang_js_calcDefaultValue(val),
	            left = _calcDefaultValue[0],
	            right = _calcDefaultValue[1];
	
	        this.leftDate = left;
	        this.rightDate = val && val[1] && left.getFullYear() !== right.getFullYear() && this.unlinkPanels ? right : Object(date_util_["nextYear"])(this.leftDate);
	      }
	    }
	  },
	
	  methods: {
	    handleClear: function handleClear() {
	      this.minDate = null;
	      this.maxDate = null;
	      this.leftDate = month_rangevue_type_script_lang_js_calcDefaultValue(this.defaultValue)[0];
	      this.rightDate = Object(date_util_["nextYear"])(this.leftDate);
	      this.$emit('pick', null);
	    },
	    handleChangeRange: function handleChangeRange(val) {
	      this.minDate = val.minDate;
	      this.maxDate = val.maxDate;
	      this.rangeState = val.rangeState;
	    },
	    handleRangePick: function handleRangePick(val) {
	      var _this = this;
	
	      var close = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      var defaultTime = this.defaultTime || [];
	      var minDate = Object(date_util_["modifyWithTimeString"])(val.minDate, defaultTime[0]);
	      var maxDate = Object(date_util_["modifyWithTimeString"])(val.maxDate, defaultTime[1]);
	      if (this.maxDate === maxDate && this.minDate === minDate) {
	        return;
	      }
	      this.onPick && this.onPick(val);
	      this.maxDate = maxDate;
	      this.minDate = minDate;
	
	      // workaround for https://github.com/ElemeFE/element/issues/7539, should remove this block when we don't have to care about Chromium 55 - 57
	      setTimeout(function () {
	        _this.maxDate = maxDate;
	        _this.minDate = minDate;
	      }, 10);
	      if (!close) return;
	      this.handleConfirm();
	    },
	    handleShortcutClick: function handleShortcutClick(shortcut) {
	      if (shortcut.onClick) {
	        shortcut.onClick(this);
	      }
	    },
	
	
	    // leftPrev*, rightNext* need to take care of `unlinkPanels`
	    leftPrevYear: function leftPrevYear() {
	      this.leftDate = Object(date_util_["prevYear"])(this.leftDate);
	      if (!this.unlinkPanels) {
	        this.rightDate = Object(date_util_["prevYear"])(this.rightDate);
	      }
	    },
	    rightNextYear: function rightNextYear() {
	      if (!this.unlinkPanels) {
	        this.leftDate = Object(date_util_["nextYear"])(this.leftDate);
	      }
	      this.rightDate = Object(date_util_["nextYear"])(this.rightDate);
	    },
	
	
	    // leftNext*, rightPrev* are called when `unlinkPanels` is true
	    leftNextYear: function leftNextYear() {
	      this.leftDate = Object(date_util_["nextYear"])(this.leftDate);
	    },
	    rightPrevYear: function rightPrevYear() {
	      this.rightDate = Object(date_util_["prevYear"])(this.rightDate);
	    },
	    handleConfirm: function handleConfirm() {
	      var visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (this.isValidValue([this.minDate, this.maxDate])) {
	        this.$emit('pick', [this.minDate, this.maxDate], visible);
	      }
	    },
	    isValidValue: function isValidValue(value) {
	      return Array.isArray(value) && value && value[0] && value[1] && Object(date_util_["isDate"])(value[0]) && Object(date_util_["isDate"])(value[1]) && value[0].getTime() <= value[1].getTime() && (typeof this.disabledDate === 'function' ? !this.disabledDate(value[0]) && !this.disabledDate(value[1]) : true);
	    },
	    resetView: function resetView() {
	      // NOTE: this is a hack to reset {min, max}Date on picker open.
	      // TODO: correct way of doing so is to refactor {min, max}Date to be dependent on value and internal selection state
	      //       an alternative would be resetView whenever picker becomes visible, should also investigate date-panel's resetView
	      this.minDate = this.value && Object(date_util_["isDate"])(this.value[0]) ? new Date(this.value[0]) : null;
	      this.maxDate = this.value && Object(date_util_["isDate"])(this.value[0]) ? new Date(this.value[1]) : null;
	    }
	  },
	
	  components: { MonthTable: month_table, ElInput: input_default.a, ElButton: button_default.a }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/month-range.vue?vue&type=script&lang=js&
	 /* harmony default export */ var panel_month_rangevue_type_script_lang_js_ = (month_rangevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/month-range.vue
	
	
	
	
	
	/* normalize component */
	
	var month_range_component = normalizeComponent(
	  panel_month_rangevue_type_script_lang_js_,
	  month_rangevue_type_template_id_f2645fb8_render,
	  month_rangevue_type_template_id_f2645fb8_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var month_range_api; }
	month_range_component.options.__file = "packages/date-picker/src/panel/month-range.vue"
	/* harmony default export */ var month_range = (month_range_component.exports);
	// CONCATENATED MODULE: ./packages/date-picker/src/picker/date-picker.js
	
	
	
	
	
	var date_picker_getPanel = function getPanel(type) {
	  if (type === 'daterange' || type === 'datetimerange') {
	    return date_range;
	  } else if (type === 'monthrange') {
	    return month_range;
	  }
	  return panel_date;
	};
	
	/* harmony default export */ var date_picker = ({
	  mixins: [picker],
	
	  name: 'ElDatePicker',
	
	  props: {
	    type: {
	      type: String,
	      default: 'date'
	    },
	    timeArrowControl: Boolean
	  },
	
	  watch: {
	    type: function type(_type) {
	      if (this.picker) {
	        this.unmountPicker();
	        this.panel = date_picker_getPanel(_type);
	        this.mountPicker();
	      } else {
	        this.panel = date_picker_getPanel(_type);
	      }
	    }
	  },
	
	  created: function created() {
	    this.panel = date_picker_getPanel(this.type);
	  }
	});
	// CONCATENATED MODULE: ./packages/date-picker/index.js
	
	
	/* istanbul ignore next */
	date_picker.install = function install(Vue) {
	  Vue.component(date_picker.name, date_picker);
	};
	
	/* harmony default export */ var packages_date_picker = (date_picker);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time-select.vue?vue&type=template&id=51ab9320&
	var time_selectvue_type_template_id_51ab9320_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    {
	      attrs: { name: "el-zoom-in-top" },
	      on: {
	        "before-enter": _vm.handleMenuEnter,
	        "after-leave": function($event) {
	          _vm.$emit("dodestroy")
	        }
	      }
	    },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.visible,
	              expression: "visible"
	            }
	          ],
	          ref: "popper",
	          staticClass: "el-picker-panel time-select el-popper",
	          class: _vm.popperClass,
	          style: { width: _vm.width + "px" }
	        },
	        [
	          _c(
	            "el-scrollbar",
	            {
	              attrs: { noresize: "", "wrap-class": "el-picker-panel__content" }
	            },
	            _vm._l(_vm.items, function(item) {
	              return _c(
	                "div",
	                {
	                  key: item.value,
	                  staticClass: "time-select-item",
	                  class: {
	                    selected: _vm.value === item.value,
	                    disabled: item.disabled,
	                    default: item.value === _vm.defaultValue
	                  },
	                  attrs: { disabled: item.disabled },
	                  on: {
	                    click: function($event) {
	                      _vm.handleClick(item)
	                    }
	                  }
	                },
	                [_vm._v(_vm._s(item.value))]
	              )
	            }),
	            0
	          )
	        ],
	        1
	      )
	    ]
	  )
	}
	var time_selectvue_type_template_id_51ab9320_staticRenderFns = []
	time_selectvue_type_template_id_51ab9320_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-select.vue?vue&type=template&id=51ab9320&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time-select.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	var parseTime = function parseTime(time) {
	  var values = (time || '').split(':');
	  if (values.length >= 2) {
	    var hours = parseInt(values[0], 10);
	    var minutes = parseInt(values[1], 10);
	
	    return {
	      hours: hours,
	      minutes: minutes
	    };
	  }
	  /* istanbul ignore next */
	  return null;
	};
	
	var compareTime = function compareTime(time1, time2) {
	  var value1 = parseTime(time1);
	  var value2 = parseTime(time2);
	
	  var minutes1 = value1.minutes + value1.hours * 60;
	  var minutes2 = value2.minutes + value2.hours * 60;
	
	  if (minutes1 === minutes2) {
	    return 0;
	  }
	
	  return minutes1 > minutes2 ? 1 : -1;
	};
	
	var formatTime = function formatTime(time) {
	  return (time.hours < 10 ? '0' + time.hours : time.hours) + ':' + (time.minutes < 10 ? '0' + time.minutes : time.minutes);
	};
	
	var nextTime = function nextTime(time, step) {
	  var timeValue = parseTime(time);
	  var stepValue = parseTime(step);
	
	  var next = {
	    hours: timeValue.hours,
	    minutes: timeValue.minutes
	  };
	
	  next.minutes += stepValue.minutes;
	  next.hours += stepValue.hours;
	
	  next.hours += Math.floor(next.minutes / 60);
	  next.minutes = next.minutes % 60;
	
	  return formatTime(next);
	};
	
	/* harmony default export */ var time_selectvue_type_script_lang_js_ = ({
	  components: { ElScrollbar: scrollbar_default.a },
	
	  watch: {
	    value: function value(val) {
	      var _this = this;
	
	      if (!val) return;
	      this.$nextTick(function () {
	        return _this.scrollToOption();
	      });
	    }
	  },
	
	  methods: {
	    handleClick: function handleClick(item) {
	      if (!item.disabled) {
	        this.$emit('pick', item.value);
	      }
	    },
	    handleClear: function handleClear() {
	      this.$emit('pick', null);
	    },
	    scrollToOption: function scrollToOption() {
	      var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.selected';
	
	      var menu = this.$refs.popper.querySelector('.el-picker-panel__content');
	      scroll_into_view_default()(menu, menu.querySelector(selector));
	    },
	    handleMenuEnter: function handleMenuEnter() {
	      var _this2 = this;
	
	      var selected = this.items.map(function (item) {
	        return item.value;
	      }).indexOf(this.value) !== -1;
	      var hasDefault = this.items.map(function (item) {
	        return item.value;
	      }).indexOf(this.defaultValue) !== -1;
	      var option = selected && '.selected' || hasDefault && '.default' || '.time-select-item:not(.disabled)';
	      this.$nextTick(function () {
	        return _this2.scrollToOption(option);
	      });
	    },
	    scrollDown: function scrollDown(step) {
	      var items = this.items;
	      var length = items.length;
	      var total = items.length;
	      var index = items.map(function (item) {
	        return item.value;
	      }).indexOf(this.value);
	      while (total--) {
	        index = (index + step + length) % length;
	        if (!items[index].disabled) {
	          this.$emit('pick', items[index].value, true);
	          return;
	        }
	      }
	    },
	    isValidValue: function isValidValue(date) {
	      return this.items.filter(function (item) {
	        return !item.disabled;
	      }).map(function (item) {
	        return item.value;
	      }).indexOf(date) !== -1;
	    },
	    handleKeydown: function handleKeydown(event) {
	      var keyCode = event.keyCode;
	      if (keyCode === 38 || keyCode === 40) {
	        var mapping = { 40: 1, 38: -1 };
	        var offset = mapping[keyCode.toString()];
	        this.scrollDown(offset);
	        event.stopPropagation();
	        return;
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      popperClass: '',
	      start: '09:00',
	      end: '18:00',
	      step: '00:30',
	      value: '',
	      defaultValue: '',
	      visible: false,
	      minTime: '',
	      maxTime: '',
	      width: 0
	    };
	  },
	
	
	  computed: {
	    items: function items() {
	      var start = this.start;
	      var end = this.end;
	      var step = this.step;
	
	      var result = [];
	
	      if (start && end && step) {
	        var current = start;
	        while (compareTime(current, end) <= 0) {
	          result.push({
	            value: current,
	            disabled: compareTime(current, this.minTime || '-1:-1') <= 0 || compareTime(current, this.maxTime || '100:100') >= 0
	          });
	          current = nextTime(current, step);
	        }
	      }
	
	      return result;
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-select.vue?vue&type=script&lang=js&
	 /* harmony default export */ var panel_time_selectvue_type_script_lang_js_ = (time_selectvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-select.vue
	
	
	
	
	
	/* normalize component */
	
	var time_select_component = normalizeComponent(
	  panel_time_selectvue_type_script_lang_js_,
	  time_selectvue_type_template_id_51ab9320_render,
	  time_selectvue_type_template_id_51ab9320_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var time_select_api; }
	time_select_component.options.__file = "packages/date-picker/src/panel/time-select.vue"
	/* harmony default export */ var time_select = (time_select_component.exports);
	// CONCATENATED MODULE: ./packages/date-picker/src/picker/time-select.js
	
	
	
	/* harmony default export */ var picker_time_select = ({
	  mixins: [picker],
	
	  name: 'ElTimeSelect',
	
	  componentName: 'ElTimeSelect',
	
	  props: {
	    type: {
	      type: String,
	      default: 'time-select'
	    }
	  },
	
	  beforeCreate: function beforeCreate() {
	    this.panel = time_select;
	  }
	});
	// CONCATENATED MODULE: ./packages/time-select/index.js
	
	
	/* istanbul ignore next */
	picker_time_select.install = function (Vue) {
	  Vue.component(picker_time_select.name, picker_time_select);
	};
	
	/* harmony default export */ var packages_time_select = (picker_time_select);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time-range.vue?vue&type=template&id=fb28660e&
	var time_rangevue_type_template_id_fb28660e_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    {
	      attrs: { name: "el-zoom-in-top" },
	      on: {
	        "after-leave": function($event) {
	          _vm.$emit("dodestroy")
	        }
	      }
	    },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.visible,
	              expression: "visible"
	            }
	          ],
	          staticClass: "el-time-range-picker el-picker-panel el-popper",
	          class: _vm.popperClass
	        },
	        [
	          _c("div", { staticClass: "el-time-range-picker__content" }, [
	            _c("div", { staticClass: "el-time-range-picker__cell" }, [
	              _c("div", { staticClass: "el-time-range-picker__header" }, [
	                _vm._v(_vm._s(_vm.t("el.datepicker.startTime")))
	              ]),
	              _c(
	                "div",
	                {
	                  staticClass:
	                    "el-time-range-picker__body el-time-panel__content",
	                  class: {
	                    "has-seconds": _vm.showSeconds,
	                    "is-arrow": _vm.arrowControl
	                  }
	                },
	                [
	                  _c("time-spinner", {
	                    ref: "minSpinner",
	                    attrs: {
	                      "show-seconds": _vm.showSeconds,
	                      "am-pm-mode": _vm.amPmMode,
	                      "arrow-control": _vm.arrowControl,
	                      date: _vm.minDate
	                    },
	                    on: {
	                      change: _vm.handleMinChange,
	                      "select-range": _vm.setMinSelectionRange
	                    }
	                  })
	                ],
	                1
	              )
	            ]),
	            _c("div", { staticClass: "el-time-range-picker__cell" }, [
	              _c("div", { staticClass: "el-time-range-picker__header" }, [
	                _vm._v(_vm._s(_vm.t("el.datepicker.endTime")))
	              ]),
	              _c(
	                "div",
	                {
	                  staticClass:
	                    "el-time-range-picker__body el-time-panel__content",
	                  class: {
	                    "has-seconds": _vm.showSeconds,
	                    "is-arrow": _vm.arrowControl
	                  }
	                },
	                [
	                  _c("time-spinner", {
	                    ref: "maxSpinner",
	                    attrs: {
	                      "show-seconds": _vm.showSeconds,
	                      "am-pm-mode": _vm.amPmMode,
	                      "arrow-control": _vm.arrowControl,
	                      date: _vm.maxDate
	                    },
	                    on: {
	                      change: _vm.handleMaxChange,
	                      "select-range": _vm.setMaxSelectionRange
	                    }
	                  })
	                ],
	                1
	              )
	            ])
	          ]),
	          _c("div", { staticClass: "el-time-panel__footer" }, [
	            _c(
	              "button",
	              {
	                staticClass: "el-time-panel__btn cancel",
	                attrs: { type: "button" },
	                on: {
	                  click: function($event) {
	                    _vm.handleCancel()
	                  }
	                }
	              },
	              [_vm._v(_vm._s(_vm.t("el.datepicker.cancel")))]
	            ),
	            _c(
	              "button",
	              {
	                staticClass: "el-time-panel__btn confirm",
	                attrs: { type: "button", disabled: _vm.btnDisabled },
	                on: {
	                  click: function($event) {
	                    _vm.handleConfirm()
	                  }
	                }
	              },
	              [_vm._v(_vm._s(_vm.t("el.datepicker.confirm")))]
	            )
	          ])
	        ]
	      )
	    ]
	  )
	}
	var time_rangevue_type_template_id_fb28660e_staticRenderFns = []
	time_rangevue_type_template_id_fb28660e_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-range.vue?vue&type=template&id=fb28660e&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time-range.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	var MIN_TIME = Object(date_util_["parseDate"])('00:00:00', 'HH:mm:ss');
	var MAX_TIME = Object(date_util_["parseDate"])('23:59:59', 'HH:mm:ss');
	
	var time_rangevue_type_script_lang_js_minTimeOfDay = function minTimeOfDay(date) {
	  return Object(date_util_["modifyDate"])(MIN_TIME, date.getFullYear(), date.getMonth(), date.getDate());
	};
	
	var time_rangevue_type_script_lang_js_maxTimeOfDay = function maxTimeOfDay(date) {
	  return Object(date_util_["modifyDate"])(MAX_TIME, date.getFullYear(), date.getMonth(), date.getDate());
	};
	
	// increase time by amount of milliseconds, but within the range of day
	var advanceTime = function advanceTime(date, amount) {
	  return new Date(Math.min(date.getTime() + amount, time_rangevue_type_script_lang_js_maxTimeOfDay(date).getTime()));
	};
	
	/* harmony default export */ var time_rangevue_type_script_lang_js_ = ({
	  mixins: [locale_default.a],
	
	  components: { TimeSpinner: time_spinner },
	
	  computed: {
	    showSeconds: function showSeconds() {
	      return (this.format || '').indexOf('ss') !== -1;
	    },
	    offset: function offset() {
	      return this.showSeconds ? 11 : 8;
	    },
	    spinner: function spinner() {
	      return this.selectionRange[0] < this.offset ? this.$refs.minSpinner : this.$refs.maxSpinner;
	    },
	    btnDisabled: function btnDisabled() {
	      return this.minDate.getTime() > this.maxDate.getTime();
	    },
	    amPmMode: function amPmMode() {
	      if ((this.format || '').indexOf('A') !== -1) return 'A';
	      if ((this.format || '').indexOf('a') !== -1) return 'a';
	      return '';
	    }
	  },
	
	  data: function data() {
	    return {
	      popperClass: '',
	      minDate: new Date(),
	      maxDate: new Date(),
	      value: [],
	      oldValue: [new Date(), new Date()],
	      defaultValue: null,
	      format: 'HH:mm:ss',
	      visible: false,
	      selectionRange: [0, 2],
	      arrowControl: false
	    };
	  },
	
	
	  watch: {
	    value: function value(_value) {
	      if (Array.isArray(_value)) {
	        this.minDate = new Date(_value[0]);
	        this.maxDate = new Date(_value[1]);
	      } else {
	        if (Array.isArray(this.defaultValue)) {
	          this.minDate = new Date(this.defaultValue[0]);
	          this.maxDate = new Date(this.defaultValue[1]);
	        } else if (this.defaultValue) {
	          this.minDate = new Date(this.defaultValue);
	          this.maxDate = advanceTime(new Date(this.defaultValue), 60 * 60 * 1000);
	        } else {
	          this.minDate = new Date();
	          this.maxDate = advanceTime(new Date(), 60 * 60 * 1000);
	        }
	      }
	    },
	    visible: function visible(val) {
	      var _this = this;
	
	      if (val) {
	        this.oldValue = this.value;
	        this.$nextTick(function () {
	          return _this.$refs.minSpinner.emitSelectRange('hours');
	        });
	      }
	    }
	  },
	
	  methods: {
	    handleClear: function handleClear() {
	      this.$emit('pick', null);
	    },
	    handleCancel: function handleCancel() {
	      this.$emit('pick', this.oldValue);
	    },
	    handleMinChange: function handleMinChange(date) {
	      this.minDate = Object(date_util_["clearMilliseconds"])(date);
	      this.handleChange();
	    },
	    handleMaxChange: function handleMaxChange(date) {
	      this.maxDate = Object(date_util_["clearMilliseconds"])(date);
	      this.handleChange();
	    },
	    handleChange: function handleChange() {
	      if (this.isValidValue([this.minDate, this.maxDate])) {
	        this.$refs.minSpinner.selectableRange = [[time_rangevue_type_script_lang_js_minTimeOfDay(this.minDate), this.maxDate]];
	        this.$refs.maxSpinner.selectableRange = [[this.minDate, time_rangevue_type_script_lang_js_maxTimeOfDay(this.maxDate)]];
	        this.$emit('pick', [this.minDate, this.maxDate], true);
	      }
	    },
	    setMinSelectionRange: function setMinSelectionRange(start, end) {
	      this.$emit('select-range', start, end, 'min');
	      this.selectionRange = [start, end];
	    },
	    setMaxSelectionRange: function setMaxSelectionRange(start, end) {
	      this.$emit('select-range', start, end, 'max');
	      this.selectionRange = [start + this.offset, end + this.offset];
	    },
	    handleConfirm: function handleConfirm() {
	      var visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      var minSelectableRange = this.$refs.minSpinner.selectableRange;
	      var maxSelectableRange = this.$refs.maxSpinner.selectableRange;
	
	      this.minDate = Object(date_util_["limitTimeRange"])(this.minDate, minSelectableRange, this.format);
	      this.maxDate = Object(date_util_["limitTimeRange"])(this.maxDate, maxSelectableRange, this.format);
	
	      this.$emit('pick', [this.minDate, this.maxDate], visible);
	    },
	    adjustSpinners: function adjustSpinners() {
	      this.$refs.minSpinner.adjustSpinners();
	      this.$refs.maxSpinner.adjustSpinners();
	    },
	    changeSelectionRange: function changeSelectionRange(step) {
	      var list = this.showSeconds ? [0, 3, 6, 11, 14, 17] : [0, 3, 8, 11];
	      var mapping = ['hours', 'minutes'].concat(this.showSeconds ? ['seconds'] : []);
	      var index = list.indexOf(this.selectionRange[0]);
	      var next = (index + step + list.length) % list.length;
	      var half = list.length / 2;
	      if (next < half) {
	        this.$refs.minSpinner.emitSelectRange(mapping[next]);
	      } else {
	        this.$refs.maxSpinner.emitSelectRange(mapping[next - half]);
	      }
	    },
	    isValidValue: function isValidValue(date) {
	      return Array.isArray(date) && Object(date_util_["timeWithinRange"])(this.minDate, this.$refs.minSpinner.selectableRange) && Object(date_util_["timeWithinRange"])(this.maxDate, this.$refs.maxSpinner.selectableRange);
	    },
	    handleKeydown: function handleKeydown(event) {
	      var keyCode = event.keyCode;
	      var mapping = { 38: -1, 40: 1, 37: -1, 39: 1 };
	
	      // Left or Right
	      if (keyCode === 37 || keyCode === 39) {
	        var step = mapping[keyCode];
	        this.changeSelectionRange(step);
	        event.preventDefault();
	        return;
	      }
	
	      // Up or Down
	      if (keyCode === 38 || keyCode === 40) {
	        var _step = mapping[keyCode];
	        this.spinner.scrollDown(_step);
	        event.preventDefault();
	        return;
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-range.vue?vue&type=script&lang=js&
	 /* harmony default export */ var panel_time_rangevue_type_script_lang_js_ = (time_rangevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-range.vue
	
	
	
	
	
	/* normalize component */
	
	var time_range_component = normalizeComponent(
	  panel_time_rangevue_type_script_lang_js_,
	  time_rangevue_type_template_id_fb28660e_render,
	  time_rangevue_type_template_id_fb28660e_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var time_range_api; }
	time_range_component.options.__file = "packages/date-picker/src/panel/time-range.vue"
	/* harmony default export */ var time_range = (time_range_component.exports);
	// CONCATENATED MODULE: ./packages/date-picker/src/picker/time-picker.js
	
	
	
	
	/* harmony default export */ var time_picker = ({
	  mixins: [picker],
	
	  name: 'ElTimePicker',
	
	  props: {
	    isRange: Boolean,
	    arrowControl: Boolean
	  },
	
	  data: function data() {
	    return {
	      type: ''
	    };
	  },
	
	
	  watch: {
	    isRange: function isRange(_isRange) {
	      if (this.picker) {
	        this.unmountPicker();
	        this.type = _isRange ? 'timerange' : 'time';
	        this.panel = _isRange ? time_range : panel_time;
	        this.mountPicker();
	      } else {
	        this.type = _isRange ? 'timerange' : 'time';
	        this.panel = _isRange ? time_range : panel_time;
	      }
	    }
	  },
	
	  created: function created() {
	    this.type = this.isRange ? 'timerange' : 'time';
	    this.panel = this.isRange ? time_range : panel_time;
	  }
	});
	// CONCATENATED MODULE: ./packages/time-picker/index.js
	
	
	/* istanbul ignore next */
	time_picker.install = function (Vue) {
	  Vue.component(time_picker.name, time_picker);
	};
	
	/* harmony default export */ var packages_time_picker = (time_picker);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/popover/src/main.vue?vue&type=template&id=52060272&
	var mainvue_type_template_id_52060272_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "span",
	    [
	      _c(
	        "transition",
	        {
	          attrs: { name: _vm.transition },
	          on: {
	            "after-enter": _vm.handleAfterEnter,
	            "after-leave": _vm.handleAfterLeave
	          }
	        },
	        [
	          _c(
	            "div",
	            {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value: !_vm.disabled && _vm.showPopper,
	                  expression: "!disabled && showPopper"
	                }
	              ],
	              ref: "popper",
	              staticClass: "el-popover el-popper",
	              class: [_vm.popperClass, _vm.content && "el-popover--plain"],
	              style: { width: _vm.width + "px" },
	              attrs: {
	                role: "tooltip",
	                id: _vm.tooltipId,
	                "aria-hidden":
	                  _vm.disabled || !_vm.showPopper ? "true" : "false"
	              }
	            },
	            [
	              _vm.title
	                ? _c("div", {
	                    staticClass: "el-popover__title",
	                    domProps: { textContent: _vm._s(_vm.title) }
	                  })
	                : _vm._e(),
	              _vm._t("default", [_vm._v(_vm._s(_vm.content))])
	            ],
	            2
	          )
	        ]
	      ),
	      _c(
	        "span",
	        { ref: "wrapper", staticClass: "el-popover__reference-wrapper" },
	        [_vm._t("reference")],
	        2
	      )
	    ],
	    1
	  )
	}
	var mainvue_type_template_id_52060272_staticRenderFns = []
	mainvue_type_template_id_52060272_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/popover/src/main.vue?vue&type=template&id=52060272&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/popover/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	/* harmony default export */ var mainvue_type_script_lang_js_ = ({
	  name: 'ElPopover',
	
	  mixins: [vue_popper_default.a],
	
	  props: {
	    trigger: {
	      type: String,
	      default: 'click',
	      validator: function validator(value) {
	        return ['click', 'focus', 'hover', 'manual'].indexOf(value) > -1;
	      }
	    },
	    openDelay: {
	      type: Number,
	      default: 0
	    },
	    closeDelay: {
	      type: Number,
	      default: 200
	    },
	    title: String,
	    disabled: Boolean,
	    content: String,
	    reference: {},
	    popperClass: String,
	    width: {},
	    visibleArrow: {
	      default: true
	    },
	    arrowOffset: {
	      type: Number,
	      default: 0
	    },
	    transition: {
	      type: String,
	      default: 'fade-in-linear'
	    },
	    tabindex: {
	      type: Number,
	      default: 0
	    }
	  },
	
	  computed: {
	    tooltipId: function tooltipId() {
	      return 'el-popover-' + Object(util_["generateId"])();
	    }
	  },
	  watch: {
	    showPopper: function showPopper(val) {
	      if (this.disabled) {
	        return;
	      }
	      val ? this.$emit('show') : this.$emit('hide');
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    var reference = this.referenceElm = this.reference || this.$refs.reference;
	    var popper = this.popper || this.$refs.popper;
	
	    if (!reference && this.$refs.wrapper.children) {
	      reference = this.referenceElm = this.$refs.wrapper.children[0];
	    }
	    // 可访问性
	    if (reference) {
	      Object(dom_["addClass"])(reference, 'el-popover__reference');
	      reference.setAttribute('aria-describedby', this.tooltipId);
	      reference.setAttribute('tabindex', this.tabindex); // tab序列
	      popper.setAttribute('tabindex', 0);
	
	      if (this.trigger !== 'click') {
	        Object(dom_["on"])(reference, 'focusin', function () {
	          _this.handleFocus();
	          var instance = reference.__vue__;
	          if (instance && typeof instance.focus === 'function') {
	            instance.focus();
	          }
	        });
	        Object(dom_["on"])(popper, 'focusin', this.handleFocus);
	        Object(dom_["on"])(reference, 'focusout', this.handleBlur);
	        Object(dom_["on"])(popper, 'focusout', this.handleBlur);
	      }
	      Object(dom_["on"])(reference, 'keydown', this.handleKeydown);
	      Object(dom_["on"])(reference, 'click', this.handleClick);
	    }
	    if (this.trigger === 'click') {
	      Object(dom_["on"])(reference, 'click', this.doToggle);
	      Object(dom_["on"])(document, 'click', this.handleDocumentClick);
	    } else if (this.trigger === 'hover') {
	      Object(dom_["on"])(reference, 'mouseenter', this.handleMouseEnter);
	      Object(dom_["on"])(popper, 'mouseenter', this.handleMouseEnter);
	      Object(dom_["on"])(reference, 'mouseleave', this.handleMouseLeave);
	      Object(dom_["on"])(popper, 'mouseleave', this.handleMouseLeave);
	    } else if (this.trigger === 'focus') {
	      if (this.tabindex < 0) {
	        console.warn('[Element Warn][Popover]a negative taindex means that the element cannot be focused by tab key');
	      }
	      if (reference.querySelector('input, textarea')) {
	        Object(dom_["on"])(reference, 'focusin', this.doShow);
	        Object(dom_["on"])(reference, 'focusout', this.doClose);
	      } else {
	        Object(dom_["on"])(reference, 'mousedown', this.doShow);
	        Object(dom_["on"])(reference, 'mouseup', this.doClose);
	      }
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.cleanup();
	  },
	  deactivated: function deactivated() {
	    this.cleanup();
	  },
	
	
	  methods: {
	    doToggle: function doToggle() {
	      this.showPopper = !this.showPopper;
	    },
	    doShow: function doShow() {
	      this.showPopper = true;
	    },
	    doClose: function doClose() {
	      this.showPopper = false;
	    },
	    handleFocus: function handleFocus() {
	      Object(dom_["addClass"])(this.referenceElm, 'focusing');
	      if (this.trigger === 'click' || this.trigger === 'focus') this.showPopper = true;
	    },
	    handleClick: function handleClick() {
	      Object(dom_["removeClass"])(this.referenceElm, 'focusing');
	    },
	    handleBlur: function handleBlur() {
	      Object(dom_["removeClass"])(this.referenceElm, 'focusing');
	      if (this.trigger === 'click' || this.trigger === 'focus') this.showPopper = false;
	    },
	    handleMouseEnter: function handleMouseEnter() {
	      var _this2 = this;
	
	      clearTimeout(this._timer);
	      if (this.openDelay) {
	        this._timer = setTimeout(function () {
	          _this2.showPopper = true;
	        }, this.openDelay);
	      } else {
	        this.showPopper = true;
	      }
	    },
	    handleKeydown: function handleKeydown(ev) {
	      if (ev.keyCode === 27 && this.trigger !== 'manual') {
	        // esc
	        this.doClose();
	      }
	    },
	    handleMouseLeave: function handleMouseLeave() {
	      var _this3 = this;
	
	      clearTimeout(this._timer);
	      if (this.closeDelay) {
	        this._timer = setTimeout(function () {
	          _this3.showPopper = false;
	        }, this.closeDelay);
	      } else {
	        this.showPopper = false;
	      }
	    },
	    handleDocumentClick: function handleDocumentClick(e) {
	      var reference = this.reference || this.$refs.reference;
	      var popper = this.popper || this.$refs.popper;
	
	      if (!reference && this.$refs.wrapper.children) {
	        reference = this.referenceElm = this.$refs.wrapper.children[0];
	      }
	      if (!this.$el || !reference || this.$el.contains(e.target) || reference.contains(e.target) || !popper || popper.contains(e.target)) return;
	      this.showPopper = false;
	    },
	    handleAfterEnter: function handleAfterEnter() {
	      this.$emit('after-enter');
	    },
	    handleAfterLeave: function handleAfterLeave() {
	      this.$emit('after-leave');
	      this.doDestroy();
	    },
	    cleanup: function cleanup() {
	      if (this.openDelay || this.closeDelay) {
	        clearTimeout(this._timer);
	      }
	    }
	  },
	
	  destroyed: function destroyed() {
	    var reference = this.reference;
	
	    Object(dom_["off"])(reference, 'click', this.doToggle);
	    Object(dom_["off"])(reference, 'mouseup', this.doClose);
	    Object(dom_["off"])(reference, 'mousedown', this.doShow);
	    Object(dom_["off"])(reference, 'focusin', this.doShow);
	    Object(dom_["off"])(reference, 'focusout', this.doClose);
	    Object(dom_["off"])(reference, 'mousedown', this.doShow);
	    Object(dom_["off"])(reference, 'mouseup', this.doClose);
	    Object(dom_["off"])(reference, 'mouseleave', this.handleMouseLeave);
	    Object(dom_["off"])(reference, 'mouseenter', this.handleMouseEnter);
	    Object(dom_["off"])(document, 'click', this.handleDocumentClick);
	  }
	});
	// CONCATENATED MODULE: ./packages/popover/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_mainvue_type_script_lang_js_ = (mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/popover/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var main_component = normalizeComponent(
	  src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_52060272_render,
	  mainvue_type_template_id_52060272_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var main_api; }
	main_component.options.__file = "packages/popover/src/main.vue"
	/* harmony default export */ var main = (main_component.exports);
	// CONCATENATED MODULE: ./packages/popover/src/directive.js
	var getReference = function getReference(el, binding, vnode) {
	  var _ref = binding.expression ? binding.value : binding.arg;
	  var popper = vnode.context.$refs[_ref];
	  if (popper) {
	    if (Array.isArray(popper)) {
	      popper[0].$refs.reference = el;
	    } else {
	      popper.$refs.reference = el;
	    }
	  }
	};
	
	/* harmony default export */ var directive = ({
	  bind: function bind(el, binding, vnode) {
	    getReference(el, binding, vnode);
	  },
	  inserted: function inserted(el, binding, vnode) {
	    getReference(el, binding, vnode);
	  }
	});
	// CONCATENATED MODULE: ./packages/popover/index.js
	
	
	
	
	external_vue_default.a.directive('popover', directive);
	
	/* istanbul ignore next */
	main.install = function (Vue) {
	  Vue.directive('popover', directive);
	  Vue.component(main.name, main);
	};
	main.directive = directive;
	
	/* harmony default export */ var popover = (main);
	// CONCATENATED MODULE: ./packages/tooltip/src/main.js
	
	
	
	
	
	
	/* harmony default export */ var src_main = ({
	  name: 'ElTooltip',
	
	  mixins: [vue_popper_default.a],
	
	  props: {
	    openDelay: {
	      type: Number,
	      default: 0
	    },
	    disabled: Boolean,
	    manual: Boolean,
	    effect: {
	      type: String,
	      default: 'dark'
	    },
	    arrowOffset: {
	      type: Number,
	      default: 0
	    },
	    popperClass: String,
	    content: String,
	    visibleArrow: {
	      default: true
	    },
	    transition: {
	      type: String,
	      default: 'el-fade-in-linear'
	    },
	    popperOptions: {
	      default: function _default() {
	        return {
	          boundariesPadding: 10,
	          gpuAcceleration: false
	        };
	      }
	    },
	    enterable: {
	      type: Boolean,
	      default: true
	    },
	    hideAfter: {
	      type: Number,
	      default: 0
	    },
	    tabindex: {
	      type: Number,
	      default: 0
	    }
	  },
	
	  data: function data() {
	    return {
	      tooltipId: 'el-tooltip-' + Object(util_["generateId"])(),
	      timeoutPending: null,
	      focusing: false
	    };
	  },
	  beforeCreate: function beforeCreate() {
	    var _this = this;
	
	    if (this.$isServer) return;
	
	    this.popperVM = new external_vue_default.a({
	      data: { node: '' },
	      render: function render(h) {
	        return this.node;
	      }
	    }).$mount();
	
	    this.debounceClose = debounce_default()(200, function () {
	      return _this.handleClosePopper();
	    });
	  },
	  render: function render(h) {
	    var _this2 = this;
	
	    if (this.popperVM) {
	      this.popperVM.node = h(
	        'transition',
	        {
	          attrs: {
	            name: this.transition
	          },
	          on: {
	            'afterLeave': this.doDestroy
	          }
	        },
	        [h(
	          'div',
	          {
	            on: {
	              'mouseleave': function mouseleave() {
	                _this2.setExpectedState(false);_this2.debounceClose();
	              },
	              'mouseenter': function mouseenter() {
	                _this2.setExpectedState(true);
	              }
	            },
	
	            ref: 'popper',
	            attrs: { role: 'tooltip',
	              id: this.tooltipId,
	              'aria-hidden': this.disabled || !this.showPopper ? 'true' : 'false'
	            },
	            directives: [{
	              name: 'show',
	              value: !this.disabled && this.showPopper
	            }],
	
	            'class': ['el-tooltip__popper', 'is-' + this.effect, this.popperClass] },
	          [this.$slots.content || this.content]
	        )]
	      );
	    }
	
	    var firstElement = this.getFirstElement();
	    if (!firstElement) return null;
	
	    var data = firstElement.data = firstElement.data || {};
	    data.staticClass = this.addTooltipClass(data.staticClass);
	
	    return firstElement;
	  },
	  mounted: function mounted() {
	    var _this3 = this;
	
	    this.referenceElm = this.$el;
	    if (this.$el.nodeType === 1) {
	      this.$el.setAttribute('aria-describedby', this.tooltipId);
	      this.$el.setAttribute('tabindex', this.tabindex);
	      Object(dom_["on"])(this.referenceElm, 'mouseenter', this.show);
	      Object(dom_["on"])(this.referenceElm, 'mouseleave', this.hide);
	      Object(dom_["on"])(this.referenceElm, 'focus', function () {
	        if (!_this3.$slots.default || !_this3.$slots.default.length) {
	          _this3.handleFocus();
	          return;
	        }
	        var instance = _this3.$slots.default[0].componentInstance;
	        if (instance && instance.focus) {
	          instance.focus();
	        } else {
	          _this3.handleFocus();
	        }
	      });
	      Object(dom_["on"])(this.referenceElm, 'blur', this.handleBlur);
	      Object(dom_["on"])(this.referenceElm, 'click', this.removeFocusing);
	    }
	    // fix issue https://github.com/ElemeFE/element/issues/14424
	    if (this.value && this.popperVM) {
	      this.popperVM.$nextTick(function () {
	        if (_this3.value) {
	          _this3.updatePopper();
	        }
	      });
	    }
	  },
	
	  watch: {
	    focusing: function focusing(val) {
	      if (val) {
	        Object(dom_["addClass"])(this.referenceElm, 'focusing');
	      } else {
	        Object(dom_["removeClass"])(this.referenceElm, 'focusing');
	      }
	    }
	  },
	  methods: {
	    show: function show() {
	      this.setExpectedState(true);
	      this.handleShowPopper();
	    },
	    hide: function hide() {
	      this.setExpectedState(false);
	      this.debounceClose();
	    },
	    handleFocus: function handleFocus() {
	      this.focusing = true;
	      this.show();
	    },
	    handleBlur: function handleBlur() {
	      this.focusing = false;
	      this.hide();
	    },
	    removeFocusing: function removeFocusing() {
	      this.focusing = false;
	    },
	    addTooltipClass: function addTooltipClass(prev) {
	      if (!prev) {
	        return 'el-tooltip';
	      } else {
	        return 'el-tooltip ' + prev.replace('el-tooltip', '');
	      }
	    },
	    handleShowPopper: function handleShowPopper() {
	      var _this4 = this;
	
	      if (!this.expectedState || this.manual) return;
	      clearTimeout(this.timeout);
	      this.timeout = setTimeout(function () {
	        _this4.showPopper = true;
	      }, this.openDelay);
	
	      if (this.hideAfter > 0) {
	        this.timeoutPending = setTimeout(function () {
	          _this4.showPopper = false;
	        }, this.hideAfter);
	      }
	    },
	    handleClosePopper: function handleClosePopper() {
	      if (this.enterable && this.expectedState || this.manual) return;
	      clearTimeout(this.timeout);
	
	      if (this.timeoutPending) {
	        clearTimeout(this.timeoutPending);
	      }
	      this.showPopper = false;
	
	      if (this.disabled) {
	        this.doDestroy();
	      }
	    },
	    setExpectedState: function setExpectedState(expectedState) {
	      if (expectedState === false) {
	        clearTimeout(this.timeoutPending);
	      }
	      this.expectedState = expectedState;
	    },
	    getFirstElement: function getFirstElement() {
	      var slots = this.$slots.default;
	      if (!Array.isArray(slots)) return null;
	      var element = null;
	      for (var index = 0; index < slots.length; index++) {
	        if (slots[index] && slots[index].tag) {
	          element = slots[index];
	        };
	      }
	      return element;
	    }
	  },
	
	  beforeDestroy: function beforeDestroy() {
	    this.popperVM && this.popperVM.$destroy();
	  },
	  destroyed: function destroyed() {
	    var reference = this.referenceElm;
	    if (reference.nodeType === 1) {
	      Object(dom_["off"])(reference, 'mouseenter', this.show);
	      Object(dom_["off"])(reference, 'mouseleave', this.hide);
	      Object(dom_["off"])(reference, 'focus', this.handleFocus);
	      Object(dom_["off"])(reference, 'blur', this.handleBlur);
	      Object(dom_["off"])(reference, 'click', this.removeFocusing);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/tooltip/index.js
	
	
	/* istanbul ignore next */
	src_main.install = function (Vue) {
	  Vue.component(src_main.name, src_main);
	};
	
	/* harmony default export */ var packages_tooltip = (src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/message-box/src/main.vue?vue&type=template&id=6b29b012&
	var mainvue_type_template_id_6b29b012_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("transition", { attrs: { name: "msgbox-fade" } }, [
	    _c(
	      "div",
	      {
	        directives: [
	          {
	            name: "show",
	            rawName: "v-show",
	            value: _vm.visible,
	            expression: "visible"
	          }
	        ],
	        staticClass: "el-message-box__wrapper",
	        attrs: {
	          tabindex: "-1",
	          role: "dialog",
	          "aria-modal": "true",
	          "aria-label": _vm.title || "dialog"
	        },
	        on: {
	          click: function($event) {
	            if ($event.target !== $event.currentTarget) {
	              return null
	            }
	            return _vm.handleWrapperClick($event)
	          }
	        }
	      },
	      [
	        _c(
	          "div",
	          {
	            staticClass: "el-message-box",
	            class: [_vm.customClass, _vm.center && "el-message-box--center"]
	          },
	          [
	            _vm.title !== null
	              ? _c("div", { staticClass: "el-message-box__header" }, [
	                  _c("div", { staticClass: "el-message-box__title" }, [
	                    _vm.icon && _vm.center
	                      ? _c("div", {
	                          class: ["el-message-box__status", _vm.icon]
	                        })
	                      : _vm._e(),
	                    _c("span", [_vm._v(_vm._s(_vm.title))])
	                  ]),
	                  _vm.showClose
	                    ? _c(
	                        "button",
	                        {
	                          staticClass: "el-message-box__headerbtn",
	                          attrs: { type: "button", "aria-label": "Close" },
	                          on: {
	                            click: function($event) {
	                              _vm.handleAction(
	                                _vm.distinguishCancelAndClose
	                                  ? "close"
	                                  : "cancel"
	                              )
	                            },
	                            keydown: function($event) {
	                              if (
	                                !("button" in $event) &&
	                                _vm._k(
	                                  $event.keyCode,
	                                  "enter",
	                                  13,
	                                  $event.key,
	                                  "Enter"
	                                )
	                              ) {
	                                return null
	                              }
	                              _vm.handleAction(
	                                _vm.distinguishCancelAndClose
	                                  ? "close"
	                                  : "cancel"
	                              )
	                            }
	                          }
	                        },
	                        [
	                          _c("i", {
	                            staticClass: "el-message-box__close el-icon-close"
	                          })
	                        ]
	                      )
	                    : _vm._e()
	                ])
	              : _vm._e(),
	            _c("div", { staticClass: "el-message-box__content" }, [
	              _c("div", { staticClass: "el-message-box__container" }, [
	                _vm.icon && !_vm.center && _vm.message !== ""
	                  ? _c("div", { class: ["el-message-box__status", _vm.icon] })
	                  : _vm._e(),
	                _vm.message !== ""
	                  ? _c(
	                      "div",
	                      { staticClass: "el-message-box__message" },
	                      [
	                        _vm._t("default", [
	                          !_vm.dangerouslyUseHTMLString
	                            ? _c("p", [_vm._v(_vm._s(_vm.message))])
	                            : _c("p", {
	                                domProps: { innerHTML: _vm._s(_vm.message) }
	                              })
	                        ])
	                      ],
	                      2
	                    )
	                  : _vm._e()
	              ]),
	              _c(
	                "div",
	                {
	                  directives: [
	                    {
	                      name: "show",
	                      rawName: "v-show",
	                      value: _vm.showInput,
	                      expression: "showInput"
	                    }
	                  ],
	                  staticClass: "el-message-box__input"
	                },
	                [
	                  _c("el-input", {
	                    ref: "input",
	                    attrs: {
	                      type: _vm.inputType,
	                      placeholder: _vm.inputPlaceholder
	                    },
	                    nativeOn: {
	                      keydown: function($event) {
	                        if (
	                          !("button" in $event) &&
	                          _vm._k(
	                            $event.keyCode,
	                            "enter",
	                            13,
	                            $event.key,
	                            "Enter"
	                          )
	                        ) {
	                          return null
	                        }
	                        return _vm.handleInputEnter($event)
	                      }
	                    },
	                    model: {
	                      value: _vm.inputValue,
	                      callback: function($$v) {
	                        _vm.inputValue = $$v
	                      },
	                      expression: "inputValue"
	                    }
	                  }),
	                  _c(
	                    "div",
	                    {
	                      staticClass: "el-message-box__errormsg",
	                      style: {
	                        visibility: !!_vm.editorErrorMessage
	                          ? "visible"
	                          : "hidden"
	                      }
	                    },
	                    [_vm._v(_vm._s(_vm.editorErrorMessage))]
	                  )
	                ],
	                1
	              )
	            ]),
	            _c(
	              "div",
	              { staticClass: "el-message-box__btns" },
	              [
	                _vm.showCancelButton
	                  ? _c(
	                      "el-button",
	                      {
	                        class: [_vm.cancelButtonClasses],
	                        attrs: {
	                          loading: _vm.cancelButtonLoading,
	                          round: _vm.roundButton,
	                          size: "small"
	                        },
	                        on: {
	                          keydown: function($event) {
	                            if (
	                              !("button" in $event) &&
	                              _vm._k(
	                                $event.keyCode,
	                                "enter",
	                                13,
	                                $event.key,
	                                "Enter"
	                              )
	                            ) {
	                              return null
	                            }
	                            _vm.handleAction("cancel")
	                          }
	                        },
	                        nativeOn: {
	                          click: function($event) {
	                            _vm.handleAction("cancel")
	                          }
	                        }
	                      },
	                      [
	                        _vm._v(
	                          "\n          " +
	                            _vm._s(
	                              _vm.cancelButtonText ||
	                                _vm.t("el.messagebox.cancel")
	                            ) +
	                            "\n        "
	                        )
	                      ]
	                    )
	                  : _vm._e(),
	                _c(
	                  "el-button",
	                  {
	                    directives: [
	                      {
	                        name: "show",
	                        rawName: "v-show",
	                        value: _vm.showConfirmButton,
	                        expression: "showConfirmButton"
	                      }
	                    ],
	                    ref: "confirm",
	                    class: [_vm.confirmButtonClasses],
	                    attrs: {
	                      loading: _vm.confirmButtonLoading,
	                      round: _vm.roundButton,
	                      size: "small"
	                    },
	                    on: {
	                      keydown: function($event) {
	                        if (
	                          !("button" in $event) &&
	                          _vm._k(
	                            $event.keyCode,
	                            "enter",
	                            13,
	                            $event.key,
	                            "Enter"
	                          )
	                        ) {
	                          return null
	                        }
	                        _vm.handleAction("confirm")
	                      }
	                    },
	                    nativeOn: {
	                      click: function($event) {
	                        _vm.handleAction("confirm")
	                      }
	                    }
	                  },
	                  [
	                    _vm._v(
	                      "\n          " +
	                        _vm._s(
	                          _vm.confirmButtonText ||
	                            _vm.t("el.messagebox.confirm")
	                        ) +
	                        "\n        "
	                    )
	                  ]
	                )
	              ],
	              1
	            )
	          ]
	        )
	      ]
	    )
	  ])
	}
	var mainvue_type_template_id_6b29b012_staticRenderFns = []
	mainvue_type_template_id_6b29b012_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/message-box/src/main.vue?vue&type=template&id=6b29b012&
	
	// EXTERNAL MODULE: external "element-ui/lib/locale"
	var lib_locale_ = __webpack_require__(15);
	var lib_locale_default = /*#__PURE__*/__webpack_require__.n(lib_locale_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/aria-dialog"
	var aria_dialog_ = __webpack_require__(39);
	var aria_dialog_default = /*#__PURE__*/__webpack_require__.n(aria_dialog_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/message-box/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	var messageBox = void 0;
	var typeMap = {
	  success: 'success',
	  info: 'info',
	  warning: 'warning',
	  error: 'error'
	};
	
	/* harmony default export */ var message_box_src_mainvue_type_script_lang_js_ = ({
	  mixins: [popup_default.a, locale_default.a],
	
	  props: {
	    modal: {
	      default: true
	    },
	    lockScroll: {
	      default: true
	    },
	    showClose: {
	      type: Boolean,
	      default: true
	    },
	    closeOnClickModal: {
	      default: true
	    },
	    closeOnPressEscape: {
	      default: true
	    },
	    closeOnHashChange: {
	      default: true
	    },
	    center: {
	      default: false,
	      type: Boolean
	    },
	    roundButton: {
	      default: false,
	      type: Boolean
	    }
	  },
	
	  components: {
	    ElInput: input_default.a,
	    ElButton: button_default.a
	  },
	
	  computed: {
	    icon: function icon() {
	      var type = this.type,
	          iconClass = this.iconClass;
	
	      return iconClass || (type && typeMap[type] ? 'el-icon-' + typeMap[type] : '');
	    },
	    confirmButtonClasses: function confirmButtonClasses() {
	      return 'el-button--primary ' + this.confirmButtonClass;
	    },
	    cancelButtonClasses: function cancelButtonClasses() {
	      return '' + this.cancelButtonClass;
	    }
	  },
	
	  methods: {
	    getSafeClose: function getSafeClose() {
	      var _this = this;
	
	      var currentId = this.uid;
	      return function () {
	        _this.$nextTick(function () {
	          if (currentId === _this.uid) _this.doClose();
	        });
	      };
	    },
	    doClose: function doClose() {
	      var _this2 = this;
	
	      if (!this.visible) return;
	      this.visible = false;
	      this._closing = true;
	
	      this.onClose && this.onClose();
	      messageBox.closeDialog(); // 解绑
	      if (this.lockScroll) {
	        setTimeout(this.restoreBodyStyle, 200);
	      }
	      this.opened = false;
	      this.doAfterClose();
	      setTimeout(function () {
	        if (_this2.action) _this2.callback(_this2.action, _this2);
	      });
	    },
	    handleWrapperClick: function handleWrapperClick() {
	      if (this.closeOnClickModal) {
	        this.handleAction(this.distinguishCancelAndClose ? 'close' : 'cancel');
	      }
	    },
	    handleInputEnter: function handleInputEnter() {
	      if (this.inputType !== 'textarea') {
	        return this.handleAction('confirm');
	      }
	    },
	    handleAction: function handleAction(action) {
	      if (this.$type === 'prompt' && action === 'confirm' && !this.validate()) {
	        return;
	      }
	      this.action = action;
	      if (typeof this.beforeClose === 'function') {
	        this.close = this.getSafeClose();
	        this.beforeClose(action, this, this.close);
	      } else {
	        this.doClose();
	      }
	    },
	    validate: function validate() {
	      if (this.$type === 'prompt') {
	        var inputPattern = this.inputPattern;
	        if (inputPattern && !inputPattern.test(this.inputValue || '')) {
	          this.editorErrorMessage = this.inputErrorMessage || Object(lib_locale_["t"])('el.messagebox.error');
	          Object(dom_["addClass"])(this.getInputElement(), 'invalid');
	          return false;
	        }
	        var inputValidator = this.inputValidator;
	        if (typeof inputValidator === 'function') {
	          var validateResult = inputValidator(this.inputValue);
	          if (validateResult === false) {
	            this.editorErrorMessage = this.inputErrorMessage || Object(lib_locale_["t"])('el.messagebox.error');
	            Object(dom_["addClass"])(this.getInputElement(), 'invalid');
	            return false;
	          }
	          if (typeof validateResult === 'string') {
	            this.editorErrorMessage = validateResult;
	            Object(dom_["addClass"])(this.getInputElement(), 'invalid');
	            return false;
	          }
	        }
	      }
	      this.editorErrorMessage = '';
	      Object(dom_["removeClass"])(this.getInputElement(), 'invalid');
	      return true;
	    },
	    getFirstFocus: function getFirstFocus() {
	      var btn = this.$el.querySelector('.el-message-box__btns .el-button');
	      var title = this.$el.querySelector('.el-message-box__btns .el-message-box__title');
	      return btn || title;
	    },
	    getInputElement: function getInputElement() {
	      var inputRefs = this.$refs.input.$refs;
	      return inputRefs.input || inputRefs.textarea;
	    },
	    handleClose: function handleClose() {
	      this.handleAction('close');
	    }
	  },
	
	  watch: {
	    inputValue: {
	      immediate: true,
	      handler: function handler(val) {
	        var _this3 = this;
	
	        this.$nextTick(function (_) {
	          if (_this3.$type === 'prompt' && val !== null) {
	            _this3.validate();
	          }
	        });
	      }
	    },
	
	    visible: function visible(val) {
	      var _this4 = this;
	
	      if (val) {
	        this.uid++;
	        if (this.$type === 'alert' || this.$type === 'confirm') {
	          this.$nextTick(function () {
	            _this4.$refs.confirm.$el.focus();
	          });
	        }
	        this.focusAfterClosed = document.activeElement;
	        messageBox = new aria_dialog_default.a(this.$el, this.focusAfterClosed, this.getFirstFocus());
	      }
	
	      // prompt
	      if (this.$type !== 'prompt') return;
	      if (val) {
	        setTimeout(function () {
	          if (_this4.$refs.input && _this4.$refs.input.$el) {
	            _this4.getInputElement().focus();
	          }
	        }, 500);
	      } else {
	        this.editorErrorMessage = '';
	        Object(dom_["removeClass"])(this.getInputElement(), 'invalid');
	      }
	    }
	  },
	
	  mounted: function mounted() {
	    var _this5 = this;
	
	    this.$nextTick(function () {
	      if (_this5.closeOnHashChange) {
	        window.addEventListener('hashchange', _this5.close);
	      }
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.closeOnHashChange) {
	      window.removeEventListener('hashchange', this.close);
	    }
	    setTimeout(function () {
	      messageBox.closeDialog();
	    });
	  },
	  data: function data() {
	    return {
	      uid: 1,
	      title: undefined,
	      message: '',
	      type: '',
	      iconClass: '',
	      customClass: '',
	      showInput: false,
	      inputValue: null,
	      inputPlaceholder: '',
	      inputType: 'text',
	      inputPattern: null,
	      inputValidator: null,
	      inputErrorMessage: '',
	      showConfirmButton: true,
	      showCancelButton: false,
	      action: '',
	      confirmButtonText: '',
	      cancelButtonText: '',
	      confirmButtonLoading: false,
	      cancelButtonLoading: false,
	      confirmButtonClass: '',
	      confirmButtonDisabled: false,
	      cancelButtonClass: '',
	      editorErrorMessage: null,
	      callback: null,
	      dangerouslyUseHTMLString: false,
	      focusAfterClosed: null,
	      isOnComposition: false,
	      distinguishCancelAndClose: false
	    };
	  }
	});
	// CONCATENATED MODULE: ./packages/message-box/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_message_box_src_mainvue_type_script_lang_js_ = (message_box_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/message-box/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var src_main_component = normalizeComponent(
	  packages_message_box_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_6b29b012_render,
	  mainvue_type_template_id_6b29b012_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var src_main_api; }
	src_main_component.options.__file = "packages/message-box/src/main.vue"
	/* harmony default export */ var message_box_src_main = (src_main_component.exports);
	// EXTERNAL MODULE: external "element-ui/lib/utils/vdom"
	var vdom_ = __webpack_require__(23);
	
	// CONCATENATED MODULE: ./packages/message-box/src/main.js
	var main_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var main_defaults = {
	  title: null,
	  message: '',
	  type: '',
	  iconClass: '',
	  showInput: false,
	  showClose: true,
	  modalFade: true,
	  lockScroll: true,
	  closeOnClickModal: true,
	  closeOnPressEscape: true,
	  closeOnHashChange: true,
	  inputValue: null,
	  inputPlaceholder: '',
	  inputType: 'text',
	  inputPattern: null,
	  inputValidator: null,
	  inputErrorMessage: '',
	  showConfirmButton: true,
	  showCancelButton: false,
	  confirmButtonPosition: 'right',
	  confirmButtonHighlight: false,
	  cancelButtonHighlight: false,
	  confirmButtonText: '',
	  cancelButtonText: '',
	  confirmButtonClass: '',
	  cancelButtonClass: '',
	  customClass: '',
	  beforeClose: null,
	  dangerouslyUseHTMLString: false,
	  center: false,
	  roundButton: false,
	  distinguishCancelAndClose: false
	};
	
	
	
	
	
	
	var MessageBoxConstructor = external_vue_default.a.extend(message_box_src_main);
	
	var currentMsg = void 0,
	    main_instance = void 0;
	var msgQueue = [];
	
	var defaultCallback = function defaultCallback(action) {
	  if (currentMsg) {
	    var callback = currentMsg.callback;
	    if (typeof callback === 'function') {
	      if (main_instance.showInput) {
	        callback(main_instance.inputValue, action);
	      } else {
	        callback(action);
	      }
	    }
	    if (currentMsg.resolve) {
	      if (action === 'confirm') {
	        if (main_instance.showInput) {
	          currentMsg.resolve({ value: main_instance.inputValue, action: action });
	        } else {
	          currentMsg.resolve(action);
	        }
	      } else if (currentMsg.reject && (action === 'cancel' || action === 'close')) {
	        currentMsg.reject(action);
	      }
	    }
	  }
	};
	
	var initInstance = function initInstance() {
	  main_instance = new MessageBoxConstructor({
	    el: document.createElement('div')
	  });
	
	  main_instance.callback = defaultCallback;
	};
	
	var main_showNextMsg = function showNextMsg() {
	  if (!main_instance) {
	    initInstance();
	  }
	  main_instance.action = '';
	
	  if (!main_instance.visible || main_instance.closeTimer) {
	    if (msgQueue.length > 0) {
	      currentMsg = msgQueue.shift();
	
	      var options = currentMsg.options;
	      for (var prop in options) {
	        if (options.hasOwnProperty(prop)) {
	          main_instance[prop] = options[prop];
	        }
	      }
	      if (options.callback === undefined) {
	        main_instance.callback = defaultCallback;
	      }
	
	      var oldCb = main_instance.callback;
	      main_instance.callback = function (action, instance) {
	        oldCb(action, instance);
	        showNextMsg();
	      };
	      if (Object(vdom_["isVNode"])(main_instance.message)) {
	        main_instance.$slots.default = [main_instance.message];
	        main_instance.message = null;
	      } else {
	        delete main_instance.$slots.default;
	      }
	      ['modal', 'showClose', 'closeOnClickModal', 'closeOnPressEscape', 'closeOnHashChange'].forEach(function (prop) {
	        if (main_instance[prop] === undefined) {
	          main_instance[prop] = true;
	        }
	      });
	      document.body.appendChild(main_instance.$el);
	
	      external_vue_default.a.nextTick(function () {
	        main_instance.visible = true;
	      });
	    }
	  }
	};
	
	var main_MessageBox = function MessageBox(options, callback) {
	  if (external_vue_default.a.prototype.$isServer) return;
	  if (typeof options === 'string' || Object(vdom_["isVNode"])(options)) {
	    options = {
	      message: options
	    };
	    if (typeof arguments[1] === 'string') {
	      options.title = arguments[1];
	    }
	  } else if (options.callback && !callback) {
	    callback = options.callback;
	  }
	
	  if (typeof Promise !== 'undefined') {
	    return new Promise(function (resolve, reject) {
	      // eslint-disable-line
	      msgQueue.push({
	        options: merge_default()({}, main_defaults, MessageBox.defaults, options),
	        callback: callback,
	        resolve: resolve,
	        reject: reject
	      });
	
	      main_showNextMsg();
	    });
	  } else {
	    msgQueue.push({
	      options: merge_default()({}, main_defaults, MessageBox.defaults, options),
	      callback: callback
	    });
	
	    main_showNextMsg();
	  }
	};
	
	main_MessageBox.setDefaults = function (defaults) {
	  main_MessageBox.defaults = defaults;
	};
	
	main_MessageBox.alert = function (message, title, options) {
	  if ((typeof title === 'undefined' ? 'undefined' : main_typeof(title)) === 'object') {
	    options = title;
	    title = '';
	  } else if (title === undefined) {
	    title = '';
	  }
	  return main_MessageBox(merge_default()({
	    title: title,
	    message: message,
	    $type: 'alert',
	    closeOnPressEscape: false,
	    closeOnClickModal: false
	  }, options));
	};
	
	main_MessageBox.confirm = function (message, title, options) {
	  if ((typeof title === 'undefined' ? 'undefined' : main_typeof(title)) === 'object') {
	    options = title;
	    title = '';
	  } else if (title === undefined) {
	    title = '';
	  }
	  return main_MessageBox(merge_default()({
	    title: title,
	    message: message,
	    $type: 'confirm',
	    showCancelButton: true
	  }, options));
	};
	
	main_MessageBox.prompt = function (message, title, options) {
	  if ((typeof title === 'undefined' ? 'undefined' : main_typeof(title)) === 'object') {
	    options = title;
	    title = '';
	  } else if (title === undefined) {
	    title = '';
	  }
	  return main_MessageBox(merge_default()({
	    title: title,
	    message: message,
	    showCancelButton: true,
	    showInput: true,
	    $type: 'prompt'
	  }, options));
	};
	
	main_MessageBox.close = function () {
	  main_instance.doClose();
	  main_instance.visible = false;
	  msgQueue = [];
	  currentMsg = null;
	};
	
	/* harmony default export */ var packages_message_box_src_main = (main_MessageBox);
	
	// CONCATENATED MODULE: ./packages/message-box/index.js
	
	/* harmony default export */ var message_box = (packages_message_box_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/breadcrumb/src/breadcrumb.vue?vue&type=template&id=4b464c06&
	var breadcrumbvue_type_template_id_4b464c06_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-breadcrumb",
	      attrs: { "aria-label": "Breadcrumb", role: "navigation" }
	    },
	    [_vm._t("default")],
	    2
	  )
	}
	var breadcrumbvue_type_template_id_4b464c06_staticRenderFns = []
	breadcrumbvue_type_template_id_4b464c06_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb.vue?vue&type=template&id=4b464c06&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/breadcrumb/src/breadcrumb.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	
	/* harmony default export */ var breadcrumbvue_type_script_lang_js_ = ({
	  name: 'ElBreadcrumb',
	
	  props: {
	    separator: {
	      type: String,
	      default: '/'
	    },
	    separatorClass: {
	      type: String,
	      default: ''
	    }
	  },
	
	  provide: function provide() {
	    return {
	      elBreadcrumb: this
	    };
	  },
	  mounted: function mounted() {
	    var items = this.$el.querySelectorAll('.el-breadcrumb__item');
	    if (items.length) {
	      items[items.length - 1].setAttribute('aria-current', 'page');
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_breadcrumbvue_type_script_lang_js_ = (breadcrumbvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb.vue
	
	
	
	
	
	/* normalize component */
	
	var breadcrumb_component = normalizeComponent(
	  src_breadcrumbvue_type_script_lang_js_,
	  breadcrumbvue_type_template_id_4b464c06_render,
	  breadcrumbvue_type_template_id_4b464c06_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var breadcrumb_api; }
	breadcrumb_component.options.__file = "packages/breadcrumb/src/breadcrumb.vue"
	/* harmony default export */ var breadcrumb = (breadcrumb_component.exports);
	// CONCATENATED MODULE: ./packages/breadcrumb/index.js
	
	
	/* istanbul ignore next */
	breadcrumb.install = function (Vue) {
	  Vue.component(breadcrumb.name, breadcrumb);
	};
	
	/* harmony default export */ var packages_breadcrumb = (breadcrumb);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/breadcrumb/src/breadcrumb-item.vue?vue&type=template&id=fcf9eaac&
	var breadcrumb_itemvue_type_template_id_fcf9eaac_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("span", { staticClass: "el-breadcrumb__item" }, [
	    _c(
	      "span",
	      {
	        ref: "link",
	        class: ["el-breadcrumb__inner", _vm.to ? "is-link" : ""],
	        attrs: { role: "link" }
	      },
	      [_vm._t("default")],
	      2
	    ),
	    _vm.separatorClass
	      ? _c("i", {
	          staticClass: "el-breadcrumb__separator",
	          class: _vm.separatorClass
	        })
	      : _c(
	          "span",
	          {
	            staticClass: "el-breadcrumb__separator",
	            attrs: { role: "presentation" }
	          },
	          [_vm._v(_vm._s(_vm.separator))]
	        )
	  ])
	}
	var breadcrumb_itemvue_type_template_id_fcf9eaac_staticRenderFns = []
	breadcrumb_itemvue_type_template_id_fcf9eaac_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb-item.vue?vue&type=template&id=fcf9eaac&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/breadcrumb/src/breadcrumb-item.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var breadcrumb_itemvue_type_script_lang_js_ = ({
	  name: 'ElBreadcrumbItem',
	  props: {
	    to: {},
	    replace: Boolean
	  },
	  data: function data() {
	    return {
	      separator: '',
	      separatorClass: ''
	    };
	  },
	
	
	  inject: ['elBreadcrumb'],
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.separator = this.elBreadcrumb.separator;
	    this.separatorClass = this.elBreadcrumb.separatorClass;
	    var link = this.$refs.link;
	    link.setAttribute('role', 'link');
	    link.addEventListener('click', function (_) {
	      var to = _this.to,
	          $router = _this.$router;
	
	      if (!to || !$router) return;
	      _this.replace ? $router.replace(to) : $router.push(to);
	    });
	  }
	});
	// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb-item.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_breadcrumb_itemvue_type_script_lang_js_ = (breadcrumb_itemvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb-item.vue
	
	
	
	
	
	/* normalize component */
	
	var breadcrumb_item_component = normalizeComponent(
	  src_breadcrumb_itemvue_type_script_lang_js_,
	  breadcrumb_itemvue_type_template_id_fcf9eaac_render,
	  breadcrumb_itemvue_type_template_id_fcf9eaac_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var breadcrumb_item_api; }
	breadcrumb_item_component.options.__file = "packages/breadcrumb/src/breadcrumb-item.vue"
	/* harmony default export */ var breadcrumb_item = (breadcrumb_item_component.exports);
	// CONCATENATED MODULE: ./packages/breadcrumb-item/index.js
	
	
	/* istanbul ignore next */
	breadcrumb_item.install = function (Vue) {
	  Vue.component(breadcrumb_item.name, breadcrumb_item);
	};
	
	/* harmony default export */ var packages_breadcrumb_item = (breadcrumb_item);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/form.vue?vue&type=template&id=a1b5ff34&
	var formvue_type_template_id_a1b5ff34_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "form",
	    {
	      staticClass: "el-form",
	      class: [
	        _vm.labelPosition ? "el-form--label-" + _vm.labelPosition : "",
	        { "el-form--inline": _vm.inline }
	      ]
	    },
	    [_vm._t("default")],
	    2
	  )
	}
	var formvue_type_template_id_a1b5ff34_staticRenderFns = []
	formvue_type_template_id_a1b5ff34_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/form/src/form.vue?vue&type=template&id=a1b5ff34&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/form.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var formvue_type_script_lang_js_ = ({
	  name: 'ElForm',
	
	  componentName: 'ElForm',
	
	  provide: function provide() {
	    return {
	      elForm: this
	    };
	  },
	
	
	  props: {
	    model: Object,
	    rules: Object,
	    labelPosition: String,
	    labelWidth: String,
	    labelSuffix: {
	      type: String,
	      default: ''
	    },
	    inline: Boolean,
	    inlineMessage: Boolean,
	    statusIcon: Boolean,
	    showMessage: {
	      type: Boolean,
	      default: true
	    },
	    size: String,
	    disabled: Boolean,
	    validateOnRuleChange: {
	      type: Boolean,
	      default: true
	    },
	    hideRequiredAsterisk: {
	      type: Boolean,
	      default: false
	    }
	  },
	  watch: {
	    rules: function rules() {
	      // remove then add event listeners on form-item after form rules change
	      this.fields.forEach(function (field) {
	        field.removeValidateEvents();
	        field.addValidateEvents();
	      });
	
	      if (this.validateOnRuleChange) {
	        this.validate(function () {});
	      }
	    }
	  },
	  computed: {
	    autoLabelWidth: function autoLabelWidth() {
	      if (!this.potentialLabelWidthArr.length) return 0;
	      var max = Math.max.apply(Math, this.potentialLabelWidthArr);
	      return max ? max + 'px' : '';
	    }
	  },
	  data: function data() {
	    return {
	      fields: [],
	      potentialLabelWidthArr: [] // use this array to calculate auto width
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    this.$on('el.form.addField', function (field) {
	      if (field) {
	        _this.fields.push(field);
	      }
	    });
	    /* istanbul ignore next */
	    this.$on('el.form.removeField', function (field) {
	      if (field.prop) {
	        _this.fields.splice(_this.fields.indexOf(field), 1);
	      }
	    });
	  },
	
	  methods: {
	    resetFields: function resetFields() {
	      if (!this.model) {
	        console.warn('[Element Warn][Form]model is required for resetFields to work.');
	        return;
	      }
	      this.fields.forEach(function (field) {
	        field.resetField();
	      });
	    },
	    clearValidate: function clearValidate() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	      var fields = props.length ? typeof props === 'string' ? this.fields.filter(function (field) {
	        return props === field.prop;
	      }) : this.fields.filter(function (field) {
	        return props.indexOf(field.prop) > -1;
	      }) : this.fields;
	      fields.forEach(function (field) {
	        field.clearValidate();
	      });
	    },
	    validate: function validate(callback) {
	      var _this2 = this;
	
	      if (!this.model) {
	        console.warn('[Element Warn][Form]model is required for validate to work!');
	        return;
	      }
	
	      var promise = void 0;
	      // if no callback, return promise
	      if (typeof callback !== 'function' && window.Promise) {
	        promise = new window.Promise(function (resolve, reject) {
	          callback = function callback(valid) {
	            valid ? resolve(valid) : reject(valid);
	          };
	        });
	      }
	
	      var valid = true;
	      var count = 0;
	      // 如果需要验证的fields为空，调用验证时立刻返回callback
	      if (this.fields.length === 0 && callback) {
	        callback(true);
	      }
	      var invalidFields = {};
	      this.fields.forEach(function (field) {
	        field.validate('', function (message, field) {
	          if (message) {
	            valid = false;
	          }
	          invalidFields = merge_default()({}, invalidFields, field);
	          if (typeof callback === 'function' && ++count === _this2.fields.length) {
	            callback(valid, invalidFields);
	          }
	        });
	      });
	
	      if (promise) {
	        return promise;
	      }
	    },
	    validateField: function validateField(props, cb) {
	      props = [].concat(props);
	      var fields = this.fields.filter(function (field) {
	        return props.indexOf(field.prop) !== -1;
	      });
	      if (!fields.length) {
	        console.warn('[Element Warn]please pass correct props!');
	        return;
	      }
	
	      fields.forEach(function (field) {
	        field.validate('', cb);
	      });
	    },
	    getLabelWidthIndex: function getLabelWidthIndex(width) {
	      var index = this.potentialLabelWidthArr.indexOf(width);
	      // it's impossible
	      if (index === -1) {
	        throw new Error('[ElementForm]unpected width ', width);
	      }
	      return index;
	    },
	    registerLabelWidth: function registerLabelWidth(val, oldVal) {
	      if (val && oldVal) {
	        var index = this.getLabelWidthIndex(oldVal);
	        this.potentialLabelWidthArr.splice(index, 1, val);
	      } else if (val) {
	        this.potentialLabelWidthArr.push(val);
	      }
	    },
	    deregisterLabelWidth: function deregisterLabelWidth(val) {
	      var index = this.getLabelWidthIndex(val);
	      this.potentialLabelWidthArr.splice(index, 1);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/form/src/form.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_formvue_type_script_lang_js_ = (formvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/form/src/form.vue
	
	
	
	
	
	/* normalize component */
	
	var form_component = normalizeComponent(
	  src_formvue_type_script_lang_js_,
	  formvue_type_template_id_a1b5ff34_render,
	  formvue_type_template_id_a1b5ff34_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var form_api; }
	form_component.options.__file = "packages/form/src/form.vue"
	/* harmony default export */ var src_form = (form_component.exports);
	// CONCATENATED MODULE: ./packages/form/index.js
	
	
	/* istanbul ignore next */
	src_form.install = function (Vue) {
	  Vue.component(src_form.name, src_form);
	};
	
	/* harmony default export */ var packages_form = (src_form);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/form-item.vue?vue&type=template&id=b6f3db6c&
	var form_itemvue_type_template_id_b6f3db6c_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-form-item",
	      class: [
	        {
	          "el-form-item--feedback": _vm.elForm && _vm.elForm.statusIcon,
	          "is-error": _vm.validateState === "error",
	          "is-validating": _vm.validateState === "validating",
	          "is-success": _vm.validateState === "success",
	          "is-required": _vm.isRequired || _vm.required,
	          "is-no-asterisk": _vm.elForm && _vm.elForm.hideRequiredAsterisk
	        },
	        _vm.sizeClass ? "el-form-item--" + _vm.sizeClass : ""
	      ]
	    },
	    [
	      _c(
	        "label-wrap",
	        {
	          attrs: {
	            "is-auto-width": _vm.labelStyle && _vm.labelStyle.width === "auto",
	            "update-all": _vm.form.labelWidth === "auto"
	          }
	        },
	        [
	          _vm.label || _vm.$slots.label
	            ? _c(
	                "label",
	                {
	                  staticClass: "el-form-item__label",
	                  style: _vm.labelStyle,
	                  attrs: { for: _vm.labelFor }
	                },
	                [
	                  _vm._t("label", [
	                    _vm._v(_vm._s(_vm.label + _vm.form.labelSuffix))
	                  ])
	                ],
	                2
	              )
	            : _vm._e()
	        ]
	      ),
	      _c(
	        "div",
	        { staticClass: "el-form-item__content", style: _vm.contentStyle },
	        [
	          _vm._t("default"),
	          _c(
	            "transition",
	            { attrs: { name: "el-zoom-in-top" } },
	            [
	              _vm.validateState === "error" &&
	              _vm.showMessage &&
	              _vm.form.showMessage
	                ? _vm._t(
	                    "error",
	                    [
	                      _c(
	                        "div",
	                        {
	                          staticClass: "el-form-item__error",
	                          class: {
	                            "el-form-item__error--inline":
	                              typeof _vm.inlineMessage === "boolean"
	                                ? _vm.inlineMessage
	                                : (_vm.elForm && _vm.elForm.inlineMessage) ||
	                                  false
	                          }
	                        },
	                        [
	                          _vm._v(
	                            "\n          " +
	                              _vm._s(_vm.validateMessage) +
	                              "\n        "
	                          )
	                        ]
	                      )
	                    ],
	                    { error: _vm.validateMessage }
	                  )
	                : _vm._e()
	            ],
	            2
	          )
	        ],
	        2
	      )
	    ],
	    1
	  )
	}
	var form_itemvue_type_template_id_b6f3db6c_staticRenderFns = []
	form_itemvue_type_template_id_b6f3db6c_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/form/src/form-item.vue?vue&type=template&id=b6f3db6c&
	
	// EXTERNAL MODULE: external "async-validator"
	var external_async_validator_ = __webpack_require__(40);
	var external_async_validator_default = /*#__PURE__*/__webpack_require__.n(external_async_validator_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/label-wrap.vue?vue&type=script&lang=js&
	
	
	/* harmony default export */ var label_wrapvue_type_script_lang_js_ = ({
	  props: {
	    isAutoWidth: Boolean,
	    updateAll: Boolean
	  },
	
	  inject: ['elForm', 'elFormItem'],
	
	  render: function render() {
	    var h = arguments[0];
	
	    var slots = this.$slots.default;
	    if (!slots) return null;
	    if (this.isAutoWidth) {
	      var autoLabelWidth = this.elForm.autoLabelWidth;
	      var style = {};
	      if (autoLabelWidth && autoLabelWidth !== 'auto') {
	        var marginLeft = parseInt(autoLabelWidth, 10) - this.computedWidth;
	        if (marginLeft) {
	          style.marginLeft = marginLeft + 'px';
	        }
	      }
	      return h(
	        'div',
	        { 'class': 'el-form-item__label-wrap', style: style },
	        [slots]
	      );
	    } else {
	      return slots[0];
	    }
	  },
	
	
	  methods: {
	    getLabelWidth: function getLabelWidth() {
	      if (this.$el && this.$el.firstElementChild) {
	        var computedWidth = window.getComputedStyle(this.$el.firstElementChild).width;
	        return Math.ceil(parseFloat(computedWidth));
	      } else {
	        return 0;
	      }
	    },
	    updateLabelWidth: function updateLabelWidth() {
	      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'update';
	
	      if (this.$slots.default && this.isAutoWidth && this.$el.firstElementChild) {
	        if (action === 'update') {
	          this.computedWidth = this.getLabelWidth();
	        } else if (action === 'remove') {
	          this.elForm.deregisterLabelWidth(this.computedWidth);
	        }
	      }
	    }
	  },
	
	  watch: {
	    computedWidth: function computedWidth(val, oldVal) {
	      if (this.updateAll) {
	        this.elForm.registerLabelWidth(val, oldVal);
	        this.elFormItem.updateComputedLabelWidth(val);
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      computedWidth: 0
	    };
	  },
	  mounted: function mounted() {
	    this.updateLabelWidth('update');
	  },
	  updated: function updated() {
	    this.updateLabelWidth('update');
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.updateLabelWidth('remove');
	  }
	});
	// CONCATENATED MODULE: ./packages/form/src/label-wrap.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_label_wrapvue_type_script_lang_js_ = (label_wrapvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/form/src/label-wrap.vue
	var label_wrap_render, label_wrap_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var label_wrap_component = normalizeComponent(
	  src_label_wrapvue_type_script_lang_js_,
	  label_wrap_render,
	  label_wrap_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var label_wrap_api; }
	label_wrap_component.options.__file = "packages/form/src/label-wrap.vue"
	/* harmony default export */ var label_wrap = (label_wrap_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/form-item.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	/* harmony default export */ var form_itemvue_type_script_lang_js_ = ({
	  name: 'ElFormItem',
	
	  componentName: 'ElFormItem',
	
	  mixins: [emitter_default.a],
	
	  provide: function provide() {
	    return {
	      elFormItem: this
	    };
	  },
	
	
	  inject: ['elForm'],
	
	  props: {
	    label: String,
	    labelWidth: String,
	    prop: String,
	    required: {
	      type: Boolean,
	      default: undefined
	    },
	    rules: [Object, Array],
	    error: String,
	    validateStatus: String,
	    for: String,
	    inlineMessage: {
	      type: [String, Boolean],
	      default: ''
	    },
	    showMessage: {
	      type: Boolean,
	      default: true
	    },
	    size: String
	  },
	  components: {
	    // use this component to calculate auto width
	    LabelWrap: label_wrap
	  },
	  watch: {
	    error: {
	      immediate: true,
	      handler: function handler(value) {
	        this.validateMessage = value;
	        this.validateState = value ? 'error' : '';
	      }
	    },
	    validateStatus: function validateStatus(value) {
	      this.validateState = value;
	    }
	  },
	  computed: {
	    labelFor: function labelFor() {
	      return this.for || this.prop;
	    },
	    labelStyle: function labelStyle() {
	      var ret = {};
	      if (this.form.labelPosition === 'top') return ret;
	      var labelWidth = this.labelWidth || this.form.labelWidth;
	      if (labelWidth) {
	        ret.width = labelWidth;
	      }
	      return ret;
	    },
	    contentStyle: function contentStyle() {
	      var ret = {};
	      var label = this.label;
	      if (this.form.labelPosition === 'top' || this.form.inline) return ret;
	      if (!label && !this.labelWidth && this.isNested) return ret;
	      var labelWidth = this.labelWidth || this.form.labelWidth;
	      if (labelWidth === 'auto') {
	        if (this.labelWidth === 'auto') {
	          ret.marginLeft = this.computedLabelWidth;
	        } else if (this.form.labelWidth === 'auto') {
	          ret.marginLeft = this.elForm.autoLabelWidth;
	        }
	      } else {
	        ret.marginLeft = labelWidth;
	      }
	      return ret;
	    },
	    form: function form() {
	      var parent = this.$parent;
	      var parentName = parent.$options.componentName;
	      while (parentName !== 'ElForm') {
	        if (parentName === 'ElFormItem') {
	          this.isNested = true;
	        }
	        parent = parent.$parent;
	        parentName = parent.$options.componentName;
	      }
	      return parent;
	    },
	    fieldValue: function fieldValue() {
	      var model = this.form.model;
	      if (!model || !this.prop) {
	        return;
	      }
	
	      var path = this.prop;
	      if (path.indexOf(':') !== -1) {
	        path = path.replace(/:/, '.');
	      }
	
	      return Object(util_["getPropByPath"])(model, path, true).v;
	    },
	    isRequired: function isRequired() {
	      var rules = this.getRules();
	      var isRequired = false;
	
	      if (rules && rules.length) {
	        rules.every(function (rule) {
	          if (rule.required) {
	            isRequired = true;
	            return false;
	          }
	          return true;
	        });
	      }
	      return isRequired;
	    },
	    _formSize: function _formSize() {
	      return this.elForm.size;
	    },
	    elFormItemSize: function elFormItemSize() {
	      return this.size || this._formSize;
	    },
	    sizeClass: function sizeClass() {
	      return this.elFormItemSize || (this.$ELEMENT || {}).size;
	    }
	  },
	  data: function data() {
	    return {
	      validateState: '',
	      validateMessage: '',
	      validateDisabled: false,
	      validator: {},
	      isNested: false,
	      computedLabelWidth: ''
	    };
	  },
	
	  methods: {
	    validate: function validate(trigger) {
	      var _this = this;
	
	      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : util_["noop"];
	
	      this.validateDisabled = false;
	      var rules = this.getFilteredRule(trigger);
	      if ((!rules || rules.length === 0) && this.required === undefined) {
	        callback();
	        return true;
	      }
	
	      this.validateState = 'validating';
	
	      var descriptor = {};
	      if (rules && rules.length > 0) {
	        rules.forEach(function (rule) {
	          delete rule.trigger;
	        });
	      }
	      descriptor[this.prop] = rules;
	
	      var validator = new external_async_validator_default.a(descriptor);
	      var model = {};
	
	      model[this.prop] = this.fieldValue;
	
	      validator.validate(model, { firstFields: true }, function (errors, invalidFields) {
	        _this.validateState = !errors ? 'success' : 'error';
	        _this.validateMessage = errors ? errors[0].message : '';
	
	        callback(_this.validateMessage, invalidFields);
	        _this.elForm && _this.elForm.$emit('validate', _this.prop, !errors, _this.validateMessage || null);
	      });
	    },
	    clearValidate: function clearValidate() {
	      this.validateState = '';
	      this.validateMessage = '';
	      this.validateDisabled = false;
	    },
	    resetField: function resetField() {
	      var _this2 = this;
	
	      this.validateState = '';
	      this.validateMessage = '';
	
	      var model = this.form.model;
	      var value = this.fieldValue;
	      var path = this.prop;
	      if (path.indexOf(':') !== -1) {
	        path = path.replace(/:/, '.');
	      }
	
	      var prop = Object(util_["getPropByPath"])(model, path, true);
	
	      this.validateDisabled = true;
	      if (Array.isArray(value)) {
	        prop.o[prop.k] = [].concat(this.initialValue);
	      } else {
	        prop.o[prop.k] = this.initialValue;
	      }
	
	      // reset validateDisabled after onFieldChange triggered
	      this.$nextTick(function () {
	        _this2.validateDisabled = false;
	      });
	
	      this.broadcast('ElTimeSelect', 'fieldReset', this.initialValue);
	    },
	    getRules: function getRules() {
	      var formRules = this.form.rules;
	      var selfRules = this.rules;
	      var requiredRule = this.required !== undefined ? { required: !!this.required } : [];
	
	      var prop = Object(util_["getPropByPath"])(formRules, this.prop || '');
	      formRules = formRules ? prop.o[this.prop || ''] || prop.v : [];
	
	      return [].concat(selfRules || formRules || []).concat(requiredRule);
	    },
	    getFilteredRule: function getFilteredRule(trigger) {
	      var rules = this.getRules();
	
	      return rules.filter(function (rule) {
	        if (!rule.trigger || trigger === '') return true;
	        if (Array.isArray(rule.trigger)) {
	          return rule.trigger.indexOf(trigger) > -1;
	        } else {
	          return rule.trigger === trigger;
	        }
	      }).map(function (rule) {
	        return merge_default()({}, rule);
	      });
	    },
	    onFieldBlur: function onFieldBlur() {
	      this.validate('blur');
	    },
	    onFieldChange: function onFieldChange() {
	      if (this.validateDisabled) {
	        this.validateDisabled = false;
	        return;
	      }
	
	      this.validate('change');
	    },
	    updateComputedLabelWidth: function updateComputedLabelWidth(width) {
	      this.computedLabelWidth = width ? width + 'px' : '';
	    },
	    addValidateEvents: function addValidateEvents() {
	      var rules = this.getRules();
	
	      if (rules.length || this.required !== undefined) {
	        this.$on('el.form.blur', this.onFieldBlur);
	        this.$on('el.form.change', this.onFieldChange);
	      }
	    },
	    removeValidateEvents: function removeValidateEvents() {
	      this.$off();
	    }
	  },
	  mounted: function mounted() {
	    if (this.prop) {
	      this.dispatch('ElForm', 'el.form.addField', [this]);
	
	      var initialValue = this.fieldValue;
	      if (Array.isArray(initialValue)) {
	        initialValue = [].concat(initialValue);
	      }
	      Object.defineProperty(this, 'initialValue', {
	        value: initialValue
	      });
	
	      this.addValidateEvents();
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.dispatch('ElForm', 'el.form.removeField', [this]);
	  }
	});
	// CONCATENATED MODULE: ./packages/form/src/form-item.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_form_itemvue_type_script_lang_js_ = (form_itemvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/form/src/form-item.vue
	
	
	
	
	
	/* normalize component */
	
	var form_item_component = normalizeComponent(
	  src_form_itemvue_type_script_lang_js_,
	  form_itemvue_type_template_id_b6f3db6c_render,
	  form_itemvue_type_template_id_b6f3db6c_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var form_item_api; }
	form_item_component.options.__file = "packages/form/src/form-item.vue"
	/* harmony default export */ var form_item = (form_item_component.exports);
	// CONCATENATED MODULE: ./packages/form-item/index.js
	
	
	/* istanbul ignore next */
	form_item.install = function (Vue) {
	  Vue.component(form_item.name, form_item);
	};
	
	/* harmony default export */ var packages_form_item = (form_item);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tab-bar.vue?vue&type=template&id=2031f33a&
	var tab_barvue_type_template_id_2031f33a_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("div", {
	    staticClass: "el-tabs__active-bar",
	    class: "is-" + _vm.rootTabs.tabPosition,
	    style: _vm.barStyle
	  })
	}
	var tab_barvue_type_template_id_2031f33a_staticRenderFns = []
	tab_barvue_type_template_id_2031f33a_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/tabs/src/tab-bar.vue?vue&type=template&id=2031f33a&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tab-bar.vue?vue&type=script&lang=js&
	//
	//
	//
	
	
	/* harmony default export */ var tab_barvue_type_script_lang_js_ = ({
	  name: 'TabBar',
	
	  props: {
	    tabs: Array
	  },
	
	  inject: ['rootTabs'],
	
	  computed: {
	    barStyle: {
	      get: function get() {
	        var _this = this;
	
	        var style = {};
	        var offset = 0;
	        var tabSize = 0;
	        var sizeName = ['top', 'bottom'].indexOf(this.rootTabs.tabPosition) !== -1 ? 'width' : 'height';
	        var sizeDir = sizeName === 'width' ? 'x' : 'y';
	        var firstUpperCase = function firstUpperCase(str) {
	          return str.toLowerCase().replace(/( |^)[a-z]/g, function (L) {
	            return L.toUpperCase();
	          });
	        };
	        this.tabs.every(function (tab, index) {
	          var $el = Object(util_["arrayFind"])(_this.$parent.$refs.tabs || [], function (t) {
	            return t.id.replace('tab-', '') === tab.paneName;
	          });
	          if (!$el) {
	            return false;
	          }
	
	          if (!tab.active) {
	            offset += $el['client' + firstUpperCase(sizeName)];
	            return true;
	          } else {
	            tabSize = $el['client' + firstUpperCase(sizeName)];
	            var tabStyles = window.getComputedStyle($el);
	            if (sizeName === 'width' && _this.tabs.length > 1) {
	              tabSize -= parseFloat(tabStyles.paddingLeft) + parseFloat(tabStyles.paddingRight);
	            }
	            if (sizeName === 'width') {
	              offset += parseFloat(tabStyles.paddingLeft);
	            }
	            return false;
	          }
	        });
	
	        var transform = 'translate' + firstUpperCase(sizeDir) + '(' + offset + 'px)';
	        style[sizeName] = tabSize + 'px';
	        style.transform = transform;
	        style.msTransform = transform;
	        style.webkitTransform = transform;
	
	        return style;
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/tabs/src/tab-bar.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_tab_barvue_type_script_lang_js_ = (tab_barvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/tabs/src/tab-bar.vue
	
	
	
	
	
	/* normalize component */
	
	var tab_bar_component = normalizeComponent(
	  src_tab_barvue_type_script_lang_js_,
	  tab_barvue_type_template_id_2031f33a_render,
	  tab_barvue_type_template_id_2031f33a_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var tab_bar_api; }
	tab_bar_component.options.__file = "packages/tabs/src/tab-bar.vue"
	/* harmony default export */ var tab_bar = (tab_bar_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tab-nav.vue?vue&type=script&lang=js&
	
	
	
	
	function noop() {}
	var tab_navvue_type_script_lang_js_firstUpperCase = function firstUpperCase(str) {
	  return str.toLowerCase().replace(/( |^)[a-z]/g, function (L) {
	    return L.toUpperCase();
	  });
	};
	
	/* harmony default export */ var tab_navvue_type_script_lang_js_ = ({
	  name: 'TabNav',
	
	  components: {
	    TabBar: tab_bar
	  },
	
	  inject: ['rootTabs'],
	
	  props: {
	    panes: Array,
	    currentName: String,
	    editable: Boolean,
	    onTabClick: {
	      type: Function,
	      default: noop
	    },
	    onTabRemove: {
	      type: Function,
	      default: noop
	    },
	    type: String,
	    stretch: Boolean
	  },
	
	  data: function data() {
	    return {
	      scrollable: false,
	      navOffset: 0,
	      isFocus: false,
	      focusable: true
	    };
	  },
	
	
	  computed: {
	    navStyle: function navStyle() {
	      var dir = ['top', 'bottom'].indexOf(this.rootTabs.tabPosition) !== -1 ? 'X' : 'Y';
	      return {
	        transform: 'translate' + dir + '(-' + this.navOffset + 'px)'
	      };
	    },
	    sizeName: function sizeName() {
	      return ['top', 'bottom'].indexOf(this.rootTabs.tabPosition) !== -1 ? 'width' : 'height';
	    }
	  },
	
	  methods: {
	    scrollPrev: function scrollPrev() {
	      var containerSize = this.$refs.navScroll['offset' + tab_navvue_type_script_lang_js_firstUpperCase(this.sizeName)];
	      var currentOffset = this.navOffset;
	
	      if (!currentOffset) return;
	
	      var newOffset = currentOffset > containerSize ? currentOffset - containerSize : 0;
	
	      this.navOffset = newOffset;
	    },
	    scrollNext: function scrollNext() {
	      var navSize = this.$refs.nav['offset' + tab_navvue_type_script_lang_js_firstUpperCase(this.sizeName)];
	      var containerSize = this.$refs.navScroll['offset' + tab_navvue_type_script_lang_js_firstUpperCase(this.sizeName)];
	      var currentOffset = this.navOffset;
	
	      if (navSize - currentOffset <= containerSize) return;
	
	      var newOffset = navSize - currentOffset > containerSize * 2 ? currentOffset + containerSize : navSize - containerSize;
	
	      this.navOffset = newOffset;
	    },
	    scrollToActiveTab: function scrollToActiveTab() {
	      if (!this.scrollable) return;
	      var nav = this.$refs.nav;
	      var activeTab = this.$el.querySelector('.is-active');
	      if (!activeTab) return;
	      var navScroll = this.$refs.navScroll;
	      var isHorizontal = ['top', 'bottom'].indexOf(this.rootTabs.tabPosition) !== -1;
	      var activeTabBounding = activeTab.getBoundingClientRect();
	      var navScrollBounding = navScroll.getBoundingClientRect();
	      var maxOffset = isHorizontal ? nav.offsetWidth - navScrollBounding.width : nav.offsetHeight - navScrollBounding.height;
	      var currentOffset = this.navOffset;
	      var newOffset = currentOffset;
	
	      if (isHorizontal) {
	        if (activeTabBounding.left < navScrollBounding.left) {
	          newOffset = currentOffset - (navScrollBounding.left - activeTabBounding.left);
	        }
	        if (activeTabBounding.right > navScrollBounding.right) {
	          newOffset = currentOffset + activeTabBounding.right - navScrollBounding.right;
	        }
	      } else {
	        if (activeTabBounding.top < navScrollBounding.top) {
	          newOffset = currentOffset - (navScrollBounding.top - activeTabBounding.top);
	        }
	        if (activeTabBounding.bottom > navScrollBounding.bottom) {
	          newOffset = currentOffset + (activeTabBounding.bottom - navScrollBounding.bottom);
	        }
	      }
	      newOffset = Math.max(newOffset, 0);
	      this.navOffset = Math.min(newOffset, maxOffset);
	    },
	    update: function update() {
	      if (!this.$refs.nav) return;
	      var sizeName = this.sizeName;
	      var navSize = this.$refs.nav['offset' + tab_navvue_type_script_lang_js_firstUpperCase(sizeName)];
	      var containerSize = this.$refs.navScroll['offset' + tab_navvue_type_script_lang_js_firstUpperCase(sizeName)];
	      var currentOffset = this.navOffset;
	
	      if (containerSize < navSize) {
	        var _currentOffset = this.navOffset;
	        this.scrollable = this.scrollable || {};
	        this.scrollable.prev = _currentOffset;
	        this.scrollable.next = _currentOffset + containerSize < navSize;
	        if (navSize - _currentOffset < containerSize) {
	          this.navOffset = navSize - containerSize;
	        }
	      } else {
	        this.scrollable = false;
	        if (currentOffset > 0) {
	          this.navOffset = 0;
	        }
	      }
	    },
	    changeTab: function changeTab(e) {
	      var keyCode = e.keyCode;
	      var nextIndex = void 0;
	      var currentIndex = void 0,
	          tabList = void 0;
	      if ([37, 38, 39, 40].indexOf(keyCode) !== -1) {
	        // 左右上下键更换tab
	        tabList = e.currentTarget.querySelectorAll('[role=tab]');
	        currentIndex = Array.prototype.indexOf.call(tabList, e.target);
	      } else {
	        return;
	      }
	      if (keyCode === 37 || keyCode === 38) {
	        // left
	        if (currentIndex === 0) {
	          // first
	          nextIndex = tabList.length - 1;
	        } else {
	          nextIndex = currentIndex - 1;
	        }
	      } else {
	        // right
	        if (currentIndex < tabList.length - 1) {
	          // not last
	          nextIndex = currentIndex + 1;
	        } else {
	          nextIndex = 0;
	        }
	      }
	      tabList[nextIndex].focus(); // 改变焦点元素
	      tabList[nextIndex].click(); // 选中下一个tab
	      this.setFocus();
	    },
	    setFocus: function setFocus() {
	      if (this.focusable) {
	        this.isFocus = true;
	      }
	    },
	    removeFocus: function removeFocus() {
	      this.isFocus = false;
	    },
	    visibilityChangeHandler: function visibilityChangeHandler() {
	      var _this = this;
	
	      var visibility = document.visibilityState;
	      if (visibility === 'hidden') {
	        this.focusable = false;
	      } else if (visibility === 'visible') {
	        setTimeout(function () {
	          _this.focusable = true;
	        }, 50);
	      }
	    },
	    windowBlurHandler: function windowBlurHandler() {
	      this.focusable = false;
	    },
	    windowFocusHandler: function windowFocusHandler() {
	      var _this2 = this;
	
	      setTimeout(function () {
	        _this2.focusable = true;
	      }, 50);
	    }
	  },
	
	  updated: function updated() {
	    this.update();
	  },
	  render: function render(h) {
	    var _this3 = this;
	
	    var type = this.type,
	        panes = this.panes,
	        editable = this.editable,
	        stretch = this.stretch,
	        onTabClick = this.onTabClick,
	        onTabRemove = this.onTabRemove,
	        navStyle = this.navStyle,
	        scrollable = this.scrollable,
	        scrollNext = this.scrollNext,
	        scrollPrev = this.scrollPrev,
	        changeTab = this.changeTab,
	        setFocus = this.setFocus,
	        removeFocus = this.removeFocus;
	
	    var scrollBtn = scrollable ? [h(
	      'span',
	      { 'class': ['el-tabs__nav-prev', scrollable.prev ? '' : 'is-disabled'], on: {
	          'click': scrollPrev
	        }
	      },
	      [h('i', { 'class': 'el-icon-arrow-left' })]
	    ), h(
	      'span',
	      { 'class': ['el-tabs__nav-next', scrollable.next ? '' : 'is-disabled'], on: {
	          'click': scrollNext
	        }
	      },
	      [h('i', { 'class': 'el-icon-arrow-right' })]
	    )] : null;
	
	    var tabs = this._l(panes, function (pane, index) {
	      var _ref;
	
	      var tabName = pane.name || pane.index || index;
	      var closable = pane.isClosable || editable;
	
	      pane.index = '' + index;
	
	      var btnClose = closable ? h('span', { 'class': 'el-icon-close', on: {
	          'click': function click(ev) {
	            onTabRemove(pane, ev);
	          }
	        }
	      }) : null;
	
	      var tabLabelContent = pane.$slots.label || pane.label;
	      var tabindex = pane.active ? 0 : -1;
	      return h(
	        'div',
	        {
	          'class': (_ref = {
	            'el-tabs__item': true
	          }, _ref['is-' + _this3.rootTabs.tabPosition] = true, _ref['is-active'] = pane.active, _ref['is-disabled'] = pane.disabled, _ref['is-closable'] = closable, _ref['is-focus'] = _this3.isFocus, _ref),
	          attrs: { id: 'tab-' + tabName,
	
	            'aria-controls': 'pane-' + tabName,
	            role: 'tab',
	            'aria-selected': pane.active,
	
	            tabindex: tabindex
	          },
	          key: 'tab-' + tabName, ref: 'tabs', refInFor: true,
	          on: {
	            'focus': function focus() {
	              setFocus();
	            },
	            'blur': function blur() {
	              removeFocus();
	            },
	            'click': function click(ev) {
	              removeFocus();onTabClick(pane, tabName, ev);
	            },
	            'keydown': function keydown(ev) {
	              if (closable && (ev.keyCode === 46 || ev.keyCode === 8)) {
	                onTabRemove(pane, ev);
	              }
	            }
	          }
	        },
	        [tabLabelContent, btnClose]
	      );
	    });
	    return h(
	      'div',
	      { 'class': ['el-tabs__nav-wrap', scrollable ? 'is-scrollable' : '', 'is-' + this.rootTabs.tabPosition] },
	      [scrollBtn, h(
	        'div',
	        { 'class': ['el-tabs__nav-scroll'], ref: 'navScroll' },
	        [h(
	          'div',
	          {
	            'class': ['el-tabs__nav', 'is-' + this.rootTabs.tabPosition, stretch && ['top', 'bottom'].indexOf(this.rootTabs.tabPosition) !== -1 ? 'is-stretch' : ''],
	            ref: 'nav',
	            style: navStyle,
	            attrs: { role: 'tablist'
	            },
	            on: {
	              'keydown': changeTab
	            }
	          },
	          [!type ? h('tab-bar', {
	            attrs: { tabs: panes }
	          }) : null, tabs]
	        )]
	      )]
	    );
	  },
	  mounted: function mounted() {
	    var _this4 = this;
	
	    Object(resize_event_["addResizeListener"])(this.$el, this.update);
	    document.addEventListener('visibilitychange', this.visibilityChangeHandler);
	    window.addEventListener('blur', this.windowBlurHandler);
	    window.addEventListener('focus', this.windowFocusHandler);
	    setTimeout(function () {
	      _this4.scrollToActiveTab();
	    }, 0);
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.$el && this.update) Object(resize_event_["removeResizeListener"])(this.$el, this.update);
	    document.removeEventListener('visibilitychange', this.visibilityChangeHandler);
	    window.removeEventListener('blur', this.windowBlurHandler);
	    window.removeEventListener('focus', this.windowFocusHandler);
	  }
	});
	// CONCATENATED MODULE: ./packages/tabs/src/tab-nav.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_tab_navvue_type_script_lang_js_ = (tab_navvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/tabs/src/tab-nav.vue
	var tab_nav_render, tab_nav_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var tab_nav_component = normalizeComponent(
	  src_tab_navvue_type_script_lang_js_,
	  tab_nav_render,
	  tab_nav_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var tab_nav_api; }
	tab_nav_component.options.__file = "packages/tabs/src/tab-nav.vue"
	/* harmony default export */ var tab_nav = (tab_nav_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tabs.vue?vue&type=script&lang=js&
	
	
	
	/* harmony default export */ var tabsvue_type_script_lang_js_ = ({
	  name: 'ElTabs',
	
	  components: {
	    TabNav: tab_nav
	  },
	
	  props: {
	    type: String,
	    activeName: String,
	    closable: Boolean,
	    addable: Boolean,
	    value: {},
	    editable: Boolean,
	    tabPosition: {
	      type: String,
	      default: 'top'
	    },
	    beforeLeave: Function,
	    stretch: Boolean
	  },
	
	  provide: function provide() {
	    return {
	      rootTabs: this
	    };
	  },
	  data: function data() {
	    return {
	      currentName: this.value || this.activeName,
	      panes: []
	    };
	  },
	
	
	  watch: {
	    activeName: function activeName(value) {
	      this.setCurrentName(value);
	    },
	    value: function value(_value) {
	      this.setCurrentName(_value);
	    },
	    currentName: function currentName(value) {
	      var _this = this;
	
	      if (this.$refs.nav) {
	        this.$nextTick(function () {
	          _this.$refs.nav.$nextTick(function (_) {
	            _this.$refs.nav.scrollToActiveTab();
	          });
	        });
	      }
	    }
	  },
	
	  methods: {
	    calcPaneInstances: function calcPaneInstances() {
	      var _this2 = this;
	
	      var isForceUpdate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (this.$slots.default) {
	        var paneSlots = this.$slots.default.filter(function (vnode) {
	          return vnode.tag && vnode.componentOptions && vnode.componentOptions.Ctor.options.name === 'ElTabPane';
	        });
	        // update indeed
	        var panes = paneSlots.map(function (_ref) {
	          var componentInstance = _ref.componentInstance;
	          return componentInstance;
	        });
	        var panesChanged = !(panes.length === this.panes.length && panes.every(function (pane, index) {
	          return pane === _this2.panes[index];
	        }));
	        if (isForceUpdate || panesChanged) {
	          this.panes = panes;
	        }
	      } else if (this.panes.length !== 0) {
	        this.panes = [];
	      }
	    },
	    handleTabClick: function handleTabClick(tab, tabName, event) {
	      if (tab.disabled) return;
	      this.setCurrentName(tabName);
	      this.$emit('tab-click', tab, event);
	    },
	    handleTabRemove: function handleTabRemove(pane, ev) {
	      if (pane.disabled) return;
	      ev.stopPropagation();
	      this.$emit('edit', pane.name, 'remove');
	      this.$emit('tab-remove', pane.name);
	    },
	    handleTabAdd: function handleTabAdd() {
	      this.$emit('edit', null, 'add');
	      this.$emit('tab-add');
	    },
	    setCurrentName: function setCurrentName(value) {
	      var _this3 = this;
	
	      var changeCurrentName = function changeCurrentName() {
	        _this3.currentName = value;
	        _this3.$emit('input', value);
	      };
	      if (this.currentName !== value && this.beforeLeave) {
	        var before = this.beforeLeave(value, this.currentName);
	        if (before && before.then) {
	          before.then(function () {
	            changeCurrentName();
	            _this3.$refs.nav && _this3.$refs.nav.removeFocus();
	          }, function () {
	            // https://github.com/ElemeFE/element/pull/14816
	            // ignore promise rejection in `before-leave` hook
	          });
	        } else if (before !== false) {
	          changeCurrentName();
	        }
	      } else {
	        changeCurrentName();
	      }
	    }
	  },
	
	  render: function render(h) {
	    var _ref2;
	
	    var type = this.type,
	        handleTabClick = this.handleTabClick,
	        handleTabRemove = this.handleTabRemove,
	        handleTabAdd = this.handleTabAdd,
	        currentName = this.currentName,
	        panes = this.panes,
	        editable = this.editable,
	        addable = this.addable,
	        tabPosition = this.tabPosition,
	        stretch = this.stretch;
	
	
	    var newButton = editable || addable ? h(
	      'span',
	      {
	        'class': 'el-tabs__new-tab',
	        on: {
	          'click': handleTabAdd,
	          'keydown': function keydown(ev) {
	            if (ev.keyCode === 13) {
	              handleTabAdd();
	            }
	          }
	        },
	        attrs: {
	          tabindex: '0'
	        }
	      },
	      [h('i', { 'class': 'el-icon-plus' })]
	    ) : null;
	
	    var navData = {
	      props: {
	        currentName: currentName,
	        onTabClick: handleTabClick,
	        onTabRemove: handleTabRemove,
	        editable: editable,
	        type: type,
	        panes: panes,
	        stretch: stretch
	      },
	      ref: 'nav'
	    };
	    var header = h(
	      'div',
	      { 'class': ['el-tabs__header', 'is-' + tabPosition] },
	      [newButton, h('tab-nav', navData)]
	    );
	    var panels = h(
	      'div',
	      { 'class': 'el-tabs__content' },
	      [this.$slots.default]
	    );
	
	    return h(
	      'div',
	      { 'class': (_ref2 = {
	          'el-tabs': true,
	          'el-tabs--card': type === 'card'
	        }, _ref2['el-tabs--' + tabPosition] = true, _ref2['el-tabs--border-card'] = type === 'border-card', _ref2) },
	      [tabPosition !== 'bottom' ? [header, panels] : [panels, header]]
	    );
	  },
	  created: function created() {
	    if (!this.currentName) {
	      this.setCurrentName('0');
	    }
	
	    this.$on('tab-nav-update', this.calcPaneInstances.bind(null, true));
	  },
	  mounted: function mounted() {
	    this.calcPaneInstances();
	  },
	  updated: function updated() {
	    this.calcPaneInstances();
	  }
	});
	// CONCATENATED MODULE: ./packages/tabs/src/tabs.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_tabsvue_type_script_lang_js_ = (tabsvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/tabs/src/tabs.vue
	var tabs_render, tabs_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var tabs_component = normalizeComponent(
	  src_tabsvue_type_script_lang_js_,
	  tabs_render,
	  tabs_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var tabs_api; }
	tabs_component.options.__file = "packages/tabs/src/tabs.vue"
	/* harmony default export */ var tabs = (tabs_component.exports);
	// CONCATENATED MODULE: ./packages/tabs/index.js
	
	
	/* istanbul ignore next */
	tabs.install = function (Vue) {
	  Vue.component(tabs.name, tabs);
	};
	
	/* harmony default export */ var packages_tabs = (tabs);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tab-pane.vue?vue&type=template&id=9145a070&
	var tab_panevue_type_template_id_9145a070_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return !_vm.lazy || _vm.loaded || _vm.active
	    ? _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.active,
	              expression: "active"
	            }
	          ],
	          staticClass: "el-tab-pane",
	          attrs: {
	            role: "tabpanel",
	            "aria-hidden": !_vm.active,
	            id: "pane-" + _vm.paneName,
	            "aria-labelledby": "tab-" + _vm.paneName
	          }
	        },
	        [_vm._t("default")],
	        2
	      )
	    : _vm._e()
	}
	var tab_panevue_type_template_id_9145a070_staticRenderFns = []
	tab_panevue_type_template_id_9145a070_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/tabs/src/tab-pane.vue?vue&type=template&id=9145a070&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tab-pane.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var tab_panevue_type_script_lang_js_ = ({
	  name: 'ElTabPane',
	
	  componentName: 'ElTabPane',
	
	  props: {
	    label: String,
	    labelContent: Function,
	    name: String,
	    closable: Boolean,
	    disabled: Boolean,
	    lazy: Boolean
	  },
	
	  data: function data() {
	    return {
	      index: null,
	      loaded: false
	    };
	  },
	
	
	  computed: {
	    isClosable: function isClosable() {
	      return this.closable || this.$parent.closable;
	    },
	    active: function active() {
	      var active = this.$parent.currentName === (this.name || this.index);
	      if (active) {
	        this.loaded = true;
	      }
	      return active;
	    },
	    paneName: function paneName() {
	      return this.name || this.index;
	    }
	  },
	
	  updated: function updated() {
	    this.$parent.$emit('tab-nav-update');
	  }
	});
	// CONCATENATED MODULE: ./packages/tabs/src/tab-pane.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_tab_panevue_type_script_lang_js_ = (tab_panevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/tabs/src/tab-pane.vue
	
	
	
	
	
	/* normalize component */
	
	var tab_pane_component = normalizeComponent(
	  src_tab_panevue_type_script_lang_js_,
	  tab_panevue_type_template_id_9145a070_render,
	  tab_panevue_type_template_id_9145a070_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var tab_pane_api; }
	tab_pane_component.options.__file = "packages/tabs/src/tab-pane.vue"
	/* harmony default export */ var tab_pane = (tab_pane_component.exports);
	// CONCATENATED MODULE: ./packages/tab-pane/index.js
	
	
	/* istanbul ignore next */
	tab_pane.install = function (Vue) {
	  Vue.component(tab_pane.name, tab_pane);
	};
	
	/* harmony default export */ var packages_tab_pane = (tab_pane);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tag/src/tag.vue?vue&type=script&lang=js&
	
	/* harmony default export */ var tagvue_type_script_lang_js_ = ({
	  name: 'ElTag',
	  props: {
	    text: String,
	    closable: Boolean,
	    type: String,
	    hit: Boolean,
	    disableTransitions: Boolean,
	    color: String,
	    size: String,
	    effect: {
	      type: String,
	      default: 'light',
	      validator: function validator(val) {
	        return ['dark', 'light', 'plain'].indexOf(val) !== -1;
	      }
	    }
	  },
	  methods: {
	    handleClose: function handleClose(event) {
	      event.stopPropagation();
	      this.$emit('close', event);
	    },
	    handleClick: function handleClick(event) {
	      this.$emit('click', event);
	    }
	  },
	  computed: {
	    tagSize: function tagSize() {
	      return this.size || (this.$ELEMENT || {}).size;
	    }
	  },
	  render: function render(h) {
	    var type = this.type,
	        tagSize = this.tagSize,
	        hit = this.hit,
	        effect = this.effect;
	
	    var classes = ['el-tag', type ? 'el-tag--' + type : '', tagSize ? 'el-tag--' + tagSize : '', effect ? 'el-tag--' + effect : '', hit && 'is-hit'];
	    var tagEl = h(
	      'span',
	      {
	        'class': classes,
	        style: { backgroundColor: this.color },
	        on: {
	          'click': this.handleClick
	        }
	      },
	      [this.$slots.default, this.closable && h('i', { 'class': 'el-tag__close el-icon-close', on: {
	          'click': this.handleClose
	        }
	      })]
	    );
	
	    return this.disableTransitions ? tagEl : h(
	      'transition',
	      {
	        attrs: { name: 'el-zoom-in-center' }
	      },
	      [tagEl]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/tag/src/tag.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_tagvue_type_script_lang_js_ = (tagvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/tag/src/tag.vue
	var tag_render, tag_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var tag_component = normalizeComponent(
	  src_tagvue_type_script_lang_js_,
	  tag_render,
	  tag_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var tag_api; }
	tag_component.options.__file = "packages/tag/src/tag.vue"
	/* harmony default export */ var src_tag = (tag_component.exports);
	// CONCATENATED MODULE: ./packages/tag/index.js
	
	
	/* istanbul ignore next */
	src_tag.install = function (Vue) {
	  Vue.component(src_tag.name, src_tag);
	};
	
	/* harmony default export */ var packages_tag = (src_tag);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/tree/src/tree.vue?vue&type=template&id=547575a6&
	var treevue_type_template_id_547575a6_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-tree",
	      class: {
	        "el-tree--highlight-current": _vm.highlightCurrent,
	        "is-dragging": !!_vm.dragState.draggingNode,
	        "is-drop-not-allow": !_vm.dragState.allowDrop,
	        "is-drop-inner": _vm.dragState.dropType === "inner"
	      },
	      attrs: { role: "tree" }
	    },
	    [
	      _vm._l(_vm.root.childNodes, function(child) {
	        return _c("el-tree-node", {
	          key: _vm.getNodeKey(child),
	          attrs: {
	            node: child,
	            props: _vm.props,
	            "render-after-expand": _vm.renderAfterExpand,
	            "show-checkbox": _vm.showCheckbox,
	            "render-content": _vm.renderContent
	          },
	          on: { "node-expand": _vm.handleNodeExpand }
	        })
	      }),
	      _vm.isEmpty
	        ? _c("div", { staticClass: "el-tree__empty-block" }, [
	            _c("span", { staticClass: "el-tree__empty-text" }, [
	              _vm._v(_vm._s(_vm.emptyText))
	            ])
	          ])
	        : _vm._e(),
	      _c("div", {
	        directives: [
	          {
	            name: "show",
	            rawName: "v-show",
	            value: _vm.dragState.showDropIndicator,
	            expression: "dragState.showDropIndicator"
	          }
	        ],
	        ref: "dropIndicator",
	        staticClass: "el-tree__drop-indicator"
	      })
	    ],
	    2
	  )
	}
	var treevue_type_template_id_547575a6_staticRenderFns = []
	treevue_type_template_id_547575a6_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/tree/src/tree.vue?vue&type=template&id=547575a6&
	
	// CONCATENATED MODULE: ./packages/tree/src/model/util.js
	var NODE_KEY = '$treeNodeId';
	
	var markNodeData = function markNodeData(node, data) {
	  if (!data || data[NODE_KEY]) return;
	  Object.defineProperty(data, NODE_KEY, {
	    value: node.id,
	    enumerable: false,
	    configurable: false,
	    writable: false
	  });
	};
	
	var util_getNodeKey = function getNodeKey(key, data) {
	  if (!key) return data[NODE_KEY];
	  return data[key];
	};
	
	var findNearestComponent = function findNearestComponent(element, componentName) {
	  var target = element;
	  while (target && target.tagName !== 'BODY') {
	    if (target.__vue__ && target.__vue__.$options.name === componentName) {
	      return target.__vue__;
	    }
	    target = target.parentNode;
	  }
	  return null;
	};
	// CONCATENATED MODULE: ./packages/tree/src/model/node.js
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function node_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	
	
	
	
	var getChildState = function getChildState(node) {
	  var all = true;
	  var none = true;
	  var allWithoutDisable = true;
	  for (var i = 0, j = node.length; i < j; i++) {
	    var n = node[i];
	    if (n.checked !== true || n.indeterminate) {
	      all = false;
	      if (!n.disabled) {
	        allWithoutDisable = false;
	      }
	    }
	    if (n.checked !== false || n.indeterminate) {
	      none = false;
	    }
	  }
	
	  return { all: all, none: none, allWithoutDisable: allWithoutDisable, half: !all && !none };
	};
	
	var reInitChecked = function reInitChecked(node) {
	  if (node.childNodes.length === 0) return;
	
	  var _getChildState = getChildState(node.childNodes),
	      all = _getChildState.all,
	      none = _getChildState.none,
	      half = _getChildState.half;
	
	  if (all) {
	    node.checked = true;
	    node.indeterminate = false;
	  } else if (half) {
	    node.checked = false;
	    node.indeterminate = true;
	  } else if (none) {
	    node.checked = false;
	    node.indeterminate = false;
	  }
	
	  var parent = node.parent;
	  if (!parent || parent.level === 0) return;
	
	  if (!node.store.checkStrictly) {
	    reInitChecked(parent);
	  }
	};
	
	var getPropertyFromData = function getPropertyFromData(node, prop) {
	  var props = node.store.props;
	  var data = node.data || {};
	  var config = props[prop];
	
	  if (typeof config === 'function') {
	    return config(data, node);
	  } else if (typeof config === 'string') {
	    return data[config];
	  } else if (typeof config === 'undefined') {
	    var dataProp = data[prop];
	    return dataProp === undefined ? '' : dataProp;
	  }
	};
	
	var nodeIdSeed = 0;
	
	var node_Node = function () {
	  function Node(options) {
	    node_classCallCheck(this, Node);
	
	    this.id = nodeIdSeed++;
	    this.text = null;
	    this.checked = false;
	    this.indeterminate = false;
	    this.data = null;
	    this.expanded = false;
	    this.parent = null;
	    this.visible = true;
	    this.isCurrent = false;
	
	    for (var name in options) {
	      if (options.hasOwnProperty(name)) {
	        this[name] = options[name];
	      }
	    }
	
	    // internal
	    this.level = 0;
	    this.loaded = false;
	    this.childNodes = [];
	    this.loading = false;
	
	    if (this.parent) {
	      this.level = this.parent.level + 1;
	    }
	
	    var store = this.store;
	    if (!store) {
	      throw new Error('[Node]store is required!');
	    }
	    store.registerNode(this);
	
	    var props = store.props;
	    if (props && typeof props.isLeaf !== 'undefined') {
	      var isLeaf = getPropertyFromData(this, 'isLeaf');
	      if (typeof isLeaf === 'boolean') {
	        this.isLeafByUser = isLeaf;
	      }
	    }
	
	    if (store.lazy !== true && this.data) {
	      this.setData(this.data);
	
	      if (store.defaultExpandAll) {
	        this.expanded = true;
	      }
	    } else if (this.level > 0 && store.lazy && store.defaultExpandAll) {
	      this.expand();
	    }
	    if (!Array.isArray(this.data)) {
	      markNodeData(this, this.data);
	    }
	    if (!this.data) return;
	    var defaultExpandedKeys = store.defaultExpandedKeys;
	    var key = store.key;
	    if (key && defaultExpandedKeys && defaultExpandedKeys.indexOf(this.key) !== -1) {
	      this.expand(null, store.autoExpandParent);
	    }
	
	    if (key && store.currentNodeKey !== undefined && this.key === store.currentNodeKey) {
	      store.currentNode = this;
	      store.currentNode.isCurrent = true;
	    }
	
	    if (store.lazy) {
	      store._initDefaultCheckedNode(this);
	    }
	
	    this.updateLeafState();
	  }
	
	  Node.prototype.setData = function setData(data) {
	    if (!Array.isArray(data)) {
	      markNodeData(this, data);
	    }
	
	    this.data = data;
	    this.childNodes = [];
	
	    var children = void 0;
	    if (this.level === 0 && this.data instanceof Array) {
	      children = this.data;
	    } else {
	      children = getPropertyFromData(this, 'children') || [];
	    }
	
	    for (var i = 0, j = children.length; i < j; i++) {
	      this.insertChild({ data: children[i] });
	    }
	  };
	
	  Node.prototype.contains = function contains(target) {
	    var deep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    var walk = function walk(parent) {
	      var children = parent.childNodes || [];
	      var result = false;
	      for (var i = 0, j = children.length; i < j; i++) {
	        var child = children[i];
	        if (child === target || deep && walk(child)) {
	          result = true;
	          break;
	        }
	      }
	      return result;
	    };
	
	    return walk(this);
	  };
	
	  Node.prototype.remove = function remove() {
	    var parent = this.parent;
	    if (parent) {
	      parent.removeChild(this);
	    }
	  };
	
	  Node.prototype.insertChild = function insertChild(child, index, batch) {
	    if (!child) throw new Error('insertChild error: child is required.');
	
	    if (!(child instanceof Node)) {
	      if (!batch) {
	        var children = this.getChildren(true);
	        if (children.indexOf(child.data) === -1) {
	          if (typeof index === 'undefined' || index < 0) {
	            children.push(child.data);
	          } else {
	            children.splice(index, 0, child.data);
	          }
	        }
	      }
	      merge_default()(child, {
	        parent: this,
	        store: this.store
	      });
	      child = new Node(child);
	    }
	
	    child.level = this.level + 1;
	
	    if (typeof index === 'undefined' || index < 0) {
	      this.childNodes.push(child);
	    } else {
	      this.childNodes.splice(index, 0, child);
	    }
	
	    this.updateLeafState();
	  };
	
	  Node.prototype.insertBefore = function insertBefore(child, ref) {
	    var index = void 0;
	    if (ref) {
	      index = this.childNodes.indexOf(ref);
	    }
	    this.insertChild(child, index);
	  };
	
	  Node.prototype.insertAfter = function insertAfter(child, ref) {
	    var index = void 0;
	    if (ref) {
	      index = this.childNodes.indexOf(ref);
	      if (index !== -1) index += 1;
	    }
	    this.insertChild(child, index);
	  };
	
	  Node.prototype.removeChild = function removeChild(child) {
	    var children = this.getChildren() || [];
	    var dataIndex = children.indexOf(child.data);
	    if (dataIndex > -1) {
	      children.splice(dataIndex, 1);
	    }
	
	    var index = this.childNodes.indexOf(child);
	
	    if (index > -1) {
	      this.store && this.store.deregisterNode(child);
	      child.parent = null;
	      this.childNodes.splice(index, 1);
	    }
	
	    this.updateLeafState();
	  };
	
	  Node.prototype.removeChildByData = function removeChildByData(data) {
	    var targetNode = null;
	
	    for (var i = 0; i < this.childNodes.length; i++) {
	      if (this.childNodes[i].data === data) {
	        targetNode = this.childNodes[i];
	        break;
	      }
	    }
	
	    if (targetNode) {
	      this.removeChild(targetNode);
	    }
	  };
	
	  Node.prototype.expand = function expand(callback, expandParent) {
	    var _this = this;
	
	    var done = function done() {
	      if (expandParent) {
	        var parent = _this.parent;
	        while (parent.level > 0) {
	          parent.expanded = true;
	          parent = parent.parent;
	        }
	      }
	      _this.expanded = true;
	      if (callback) callback();
	    };
	
	    if (this.shouldLoadData()) {
	      this.loadData(function (data) {
	        if (data instanceof Array) {
	          if (_this.checked) {
	            _this.setChecked(true, true);
	          } else if (!_this.store.checkStrictly) {
	            reInitChecked(_this);
	          }
	          done();
	        }
	      });
	    } else {
	      done();
	    }
	  };
	
	  Node.prototype.doCreateChildren = function doCreateChildren(array) {
	    var _this2 = this;
	
	    var defaultProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    array.forEach(function (item) {
	      _this2.insertChild(merge_default()({ data: item }, defaultProps), undefined, true);
	    });
	  };
	
	  Node.prototype.collapse = function collapse() {
	    this.expanded = false;
	  };
	
	  Node.prototype.shouldLoadData = function shouldLoadData() {
	    return this.store.lazy === true && this.store.load && !this.loaded;
	  };
	
	  Node.prototype.updateLeafState = function updateLeafState() {
	    if (this.store.lazy === true && this.loaded !== true && typeof this.isLeafByUser !== 'undefined') {
	      this.isLeaf = this.isLeafByUser;
	      return;
	    }
	    var childNodes = this.childNodes;
	    if (!this.store.lazy || this.store.lazy === true && this.loaded === true) {
	      this.isLeaf = !childNodes || childNodes.length === 0;
	      return;
	    }
	    this.isLeaf = false;
	  };
	
	  Node.prototype.setChecked = function setChecked(value, deep, recursion, passValue) {
	    var _this3 = this;
	
	    this.indeterminate = value === 'half';
	    this.checked = value === true;
	
	    if (this.store.checkStrictly) return;
	
	    if (!(this.shouldLoadData() && !this.store.checkDescendants)) {
	      var _getChildState2 = getChildState(this.childNodes),
	          all = _getChildState2.all,
	          allWithoutDisable = _getChildState2.allWithoutDisable;
	
	      if (!this.isLeaf && !all && allWithoutDisable) {
	        this.checked = false;
	        value = false;
	      }
	
	      var handleDescendants = function handleDescendants() {
	        if (deep) {
	          var childNodes = _this3.childNodes;
	          for (var i = 0, j = childNodes.length; i < j; i++) {
	            var child = childNodes[i];
	            passValue = passValue || value !== false;
	            var isCheck = child.disabled ? child.checked : passValue;
	            child.setChecked(isCheck, deep, true, passValue);
	          }
	
	          var _getChildState3 = getChildState(childNodes),
	              half = _getChildState3.half,
	              _all = _getChildState3.all;
	
	          if (!_all) {
	            _this3.checked = _all;
	            _this3.indeterminate = half;
	          }
	        }
	      };
	
	      if (this.shouldLoadData()) {
	        // Only work on lazy load data.
	        this.loadData(function () {
	          handleDescendants();
	          reInitChecked(_this3);
	        }, {
	          checked: value !== false
	        });
	        return;
	      } else {
	        handleDescendants();
	      }
	    }
	
	    var parent = this.parent;
	    if (!parent || parent.level === 0) return;
	
	    if (!recursion) {
	      reInitChecked(parent);
	    }
	  };
	
	  Node.prototype.getChildren = function getChildren() {
	    var forceInit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    // this is data
	    if (this.level === 0) return this.data;
	    var data = this.data;
	    if (!data) return null;
	
	    var props = this.store.props;
	    var children = 'children';
	    if (props) {
	      children = props.children || 'children';
	    }
	
	    if (data[children] === undefined) {
	      data[children] = null;
	    }
	
	    if (forceInit && !data[children]) {
	      data[children] = [];
	    }
	
	    return data[children];
	  };
	
	  Node.prototype.updateChildren = function updateChildren() {
	    var _this4 = this;
	
	    var newData = this.getChildren() || [];
	    var oldData = this.childNodes.map(function (node) {
	      return node.data;
	    });
	
	    var newDataMap = {};
	    var newNodes = [];
	
	    newData.forEach(function (item, index) {
	      var key = item[NODE_KEY];
	      var isNodeExists = !!key && Object(util_["arrayFindIndex"])(oldData, function (data) {
	        return data[NODE_KEY] === key;
	      }) >= 0;
	      if (isNodeExists) {
	        newDataMap[key] = { index: index, data: item };
	      } else {
	        newNodes.push({ index: index, data: item });
	      }
	    });
	
	    if (!this.store.lazy) {
	      oldData.forEach(function (item) {
	        if (!newDataMap[item[NODE_KEY]]) _this4.removeChildByData(item);
	      });
	    }
	
	    newNodes.forEach(function (_ref) {
	      var index = _ref.index,
	          data = _ref.data;
	
	      _this4.insertChild({ data: data }, index);
	    });
	
	    this.updateLeafState();
	  };
	
	  Node.prototype.loadData = function loadData(callback) {
	    var _this5 = this;
	
	    var defaultProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    if (this.store.lazy === true && this.store.load && !this.loaded && (!this.loading || Object.keys(defaultProps).length)) {
	      this.loading = true;
	
	      var resolve = function resolve(children) {
	        _this5.loaded = true;
	        _this5.loading = false;
	        _this5.childNodes = [];
	
	        _this5.doCreateChildren(children, defaultProps);
	
	        _this5.updateLeafState();
	        if (callback) {
	          callback.call(_this5, children);
	        }
	      };
	
	      this.store.load(this, resolve);
	    } else {
	      if (callback) {
	        callback.call(this);
	      }
	    }
	  };
	
	  _createClass(Node, [{
	    key: 'label',
	    get: function get() {
	      return getPropertyFromData(this, 'label');
	    }
	  }, {
	    key: 'key',
	    get: function get() {
	      var nodeKey = this.store.key;
	      if (this.data) return this.data[nodeKey];
	      return null;
	    }
	  }, {
	    key: 'disabled',
	    get: function get() {
	      return getPropertyFromData(this, 'disabled');
	    }
	  }, {
	    key: 'nextSibling',
	    get: function get() {
	      var parent = this.parent;
	      if (parent) {
	        var index = parent.childNodes.indexOf(this);
	        if (index > -1) {
	          return parent.childNodes[index + 1];
	        }
	      }
	      return null;
	    }
	  }, {
	    key: 'previousSibling',
	    get: function get() {
	      var parent = this.parent;
	      if (parent) {
	        var index = parent.childNodes.indexOf(this);
	        if (index > -1) {
	          return index > 0 ? parent.childNodes[index - 1] : null;
	        }
	      }
	      return null;
	    }
	  }]);
	
	  return Node;
	}();
	
	/* harmony default export */ var model_node = (node_Node);
	// CONCATENATED MODULE: ./packages/tree/src/model/tree-store.js
	var tree_store_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function tree_store_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	
	
	
	var tree_store_TreeStore = function () {
	  function TreeStore(options) {
	    var _this = this;
	
	    tree_store_classCallCheck(this, TreeStore);
	
	    this.currentNode = null;
	    this.currentNodeKey = null;
	
	    for (var option in options) {
	      if (options.hasOwnProperty(option)) {
	        this[option] = options[option];
	      }
	    }
	
	    this.nodesMap = {};
	
	    this.root = new model_node({
	      data: this.data,
	      store: this
	    });
	
	    if (this.lazy && this.load) {
	      var loadFn = this.load;
	      loadFn(this.root, function (data) {
	        _this.root.doCreateChildren(data);
	        _this._initDefaultCheckedNodes();
	      });
	    } else {
	      this._initDefaultCheckedNodes();
	    }
	  }
	
	  TreeStore.prototype.filter = function filter(value) {
	    var filterNodeMethod = this.filterNodeMethod;
	    var lazy = this.lazy;
	    var traverse = function traverse(node) {
	      var childNodes = node.root ? node.root.childNodes : node.childNodes;
	
	      childNodes.forEach(function (child) {
	        child.visible = filterNodeMethod.call(child, value, child.data, child);
	
	        traverse(child);
	      });
	
	      if (!node.visible && childNodes.length) {
	        var allHidden = true;
	        allHidden = !childNodes.some(function (child) {
	          return child.visible;
	        });
	
	        if (node.root) {
	          node.root.visible = allHidden === false;
	        } else {
	          node.visible = allHidden === false;
	        }
	      }
	      if (!value) return;
	
	      if (node.visible && !node.isLeaf && !lazy) node.expand();
	    };
	
	    traverse(this);
	  };
	
	  TreeStore.prototype.setData = function setData(newVal) {
	    var instanceChanged = newVal !== this.root.data;
	    if (instanceChanged) {
	      this.root.setData(newVal);
	      this._initDefaultCheckedNodes();
	    } else {
	      this.root.updateChildren();
	    }
	  };
	
	  TreeStore.prototype.getNode = function getNode(data) {
	    if (data instanceof model_node) return data;
	    var key = (typeof data === 'undefined' ? 'undefined' : tree_store_typeof(data)) !== 'object' ? data : util_getNodeKey(this.key, data);
	    return this.nodesMap[key] || null;
	  };
	
	  TreeStore.prototype.insertBefore = function insertBefore(data, refData) {
	    var refNode = this.getNode(refData);
	    refNode.parent.insertBefore({ data: data }, refNode);
	  };
	
	  TreeStore.prototype.insertAfter = function insertAfter(data, refData) {
	    var refNode = this.getNode(refData);
	    refNode.parent.insertAfter({ data: data }, refNode);
	  };
	
	  TreeStore.prototype.remove = function remove(data) {
	    var node = this.getNode(data);
	
	    if (node && node.parent) {
	      if (node === this.currentNode) {
	        this.currentNode = null;
	      }
	      node.parent.removeChild(node);
	    }
	  };
	
	  TreeStore.prototype.append = function append(data, parentData) {
	    var parentNode = parentData ? this.getNode(parentData) : this.root;
	
	    if (parentNode) {
	      parentNode.insertChild({ data: data });
	    }
	  };
	
	  TreeStore.prototype._initDefaultCheckedNodes = function _initDefaultCheckedNodes() {
	    var _this2 = this;
	
	    var defaultCheckedKeys = this.defaultCheckedKeys || [];
	    var nodesMap = this.nodesMap;
	
	    defaultCheckedKeys.forEach(function (checkedKey) {
	      var node = nodesMap[checkedKey];
	
	      if (node) {
	        node.setChecked(true, !_this2.checkStrictly);
	      }
	    });
	  };
	
	  TreeStore.prototype._initDefaultCheckedNode = function _initDefaultCheckedNode(node) {
	    var defaultCheckedKeys = this.defaultCheckedKeys || [];
	
	    if (defaultCheckedKeys.indexOf(node.key) !== -1) {
	      node.setChecked(true, !this.checkStrictly);
	    }
	  };
	
	  TreeStore.prototype.setDefaultCheckedKey = function setDefaultCheckedKey(newVal) {
	    if (newVal !== this.defaultCheckedKeys) {
	      this.defaultCheckedKeys = newVal;
	      this._initDefaultCheckedNodes();
	    }
	  };
	
	  TreeStore.prototype.registerNode = function registerNode(node) {
	    var key = this.key;
	    if (!key || !node || !node.data) return;
	
	    var nodeKey = node.key;
	    if (nodeKey !== undefined) this.nodesMap[node.key] = node;
	  };
	
	  TreeStore.prototype.deregisterNode = function deregisterNode(node) {
	    var _this3 = this;
	
	    var key = this.key;
	    if (!key || !node || !node.data) return;
	
	    node.childNodes.forEach(function (child) {
	      _this3.deregisterNode(child);
	    });
	
	    delete this.nodesMap[node.key];
	  };
	
	  TreeStore.prototype.getCheckedNodes = function getCheckedNodes() {
	    var leafOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    var includeHalfChecked = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    var checkedNodes = [];
	    var traverse = function traverse(node) {
	      var childNodes = node.root ? node.root.childNodes : node.childNodes;
	
	      childNodes.forEach(function (child) {
	        if ((child.checked || includeHalfChecked && child.indeterminate) && (!leafOnly || leafOnly && child.isLeaf)) {
	          checkedNodes.push(child.data);
	        }
	
	        traverse(child);
	      });
	    };
	
	    traverse(this);
	
	    return checkedNodes;
	  };
	
	  TreeStore.prototype.getCheckedKeys = function getCheckedKeys() {
	    var _this4 = this;
	
	    var leafOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    return this.getCheckedNodes(leafOnly).map(function (data) {
	      return (data || {})[_this4.key];
	    });
	  };
	
	  TreeStore.prototype.getHalfCheckedNodes = function getHalfCheckedNodes() {
	    var nodes = [];
	    var traverse = function traverse(node) {
	      var childNodes = node.root ? node.root.childNodes : node.childNodes;
	
	      childNodes.forEach(function (child) {
	        if (child.indeterminate) {
	          nodes.push(child.data);
	        }
	
	        traverse(child);
	      });
	    };
	
	    traverse(this);
	
	    return nodes;
	  };
	
	  TreeStore.prototype.getHalfCheckedKeys = function getHalfCheckedKeys() {
	    var _this5 = this;
	
	    return this.getHalfCheckedNodes().map(function (data) {
	      return (data || {})[_this5.key];
	    });
	  };
	
	  TreeStore.prototype._getAllNodes = function _getAllNodes() {
	    var allNodes = [];
	    var nodesMap = this.nodesMap;
	    for (var nodeKey in nodesMap) {
	      if (nodesMap.hasOwnProperty(nodeKey)) {
	        allNodes.push(nodesMap[nodeKey]);
	      }
	    }
	
	    return allNodes;
	  };
	
	  TreeStore.prototype.updateChildren = function updateChildren(key, data) {
	    var node = this.nodesMap[key];
	    if (!node) return;
	    var childNodes = node.childNodes;
	    for (var i = childNodes.length - 1; i >= 0; i--) {
	      var child = childNodes[i];
	      this.remove(child.data);
	    }
	    for (var _i = 0, j = data.length; _i < j; _i++) {
	      var _child = data[_i];
	      this.append(_child, node.data);
	    }
	  };
	
	  TreeStore.prototype._setCheckedKeys = function _setCheckedKeys(key) {
	    var leafOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    var checkedKeys = arguments[2];
	
	    var allNodes = this._getAllNodes().sort(function (a, b) {
	      return b.level - a.level;
	    });
	    var cache = Object.create(null);
	    var keys = Object.keys(checkedKeys);
	    allNodes.forEach(function (node) {
	      return node.setChecked(false, false);
	    });
	    for (var i = 0, j = allNodes.length; i < j; i++) {
	      var node = allNodes[i];
	      var nodeKey = node.data[key].toString();
	      var checked = keys.indexOf(nodeKey) > -1;
	      if (!checked) {
	        if (node.checked && !cache[nodeKey]) {
	          node.setChecked(false, false);
	        }
	        continue;
	      }
	
	      var parent = node.parent;
	      while (parent && parent.level > 0) {
	        cache[parent.data[key]] = true;
	        parent = parent.parent;
	      }
	
	      if (node.isLeaf || this.checkStrictly) {
	        node.setChecked(true, false);
	        continue;
	      }
	      node.setChecked(true, true);
	
	      if (leafOnly) {
	        (function () {
	          node.setChecked(false, false);
	          var traverse = function traverse(node) {
	            var childNodes = node.childNodes;
	            childNodes.forEach(function (child) {
	              if (!child.isLeaf) {
	                child.setChecked(false, false);
	              }
	              traverse(child);
	            });
	          };
	          traverse(node);
	        })();
	      }
	    }
	  };
	
	  TreeStore.prototype.setCheckedNodes = function setCheckedNodes(array) {
	    var leafOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    var key = this.key;
	    var checkedKeys = {};
	    array.forEach(function (item) {
	      checkedKeys[(item || {})[key]] = true;
	    });
	
	    this._setCheckedKeys(key, leafOnly, checkedKeys);
	  };
	
	  TreeStore.prototype.setCheckedKeys = function setCheckedKeys(keys) {
	    var leafOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    this.defaultCheckedKeys = keys;
	    var key = this.key;
	    var checkedKeys = {};
	    keys.forEach(function (key) {
	      checkedKeys[key] = true;
	    });
	
	    this._setCheckedKeys(key, leafOnly, checkedKeys);
	  };
	
	  TreeStore.prototype.setDefaultExpandedKeys = function setDefaultExpandedKeys(keys) {
	    var _this6 = this;
	
	    keys = keys || [];
	    this.defaultExpandedKeys = keys;
	
	    keys.forEach(function (key) {
	      var node = _this6.getNode(key);
	      if (node) node.expand(null, _this6.autoExpandParent);
	    });
	  };
	
	  TreeStore.prototype.setChecked = function setChecked(data, checked, deep) {
	    var node = this.getNode(data);
	
	    if (node) {
	      node.setChecked(!!checked, deep);
	    }
	  };
	
	  TreeStore.prototype.getCurrentNode = function getCurrentNode() {
	    return this.currentNode;
	  };
	
	  TreeStore.prototype.setCurrentNode = function setCurrentNode(currentNode) {
	    var prevCurrentNode = this.currentNode;
	    if (prevCurrentNode) {
	      prevCurrentNode.isCurrent = false;
	    }
	    this.currentNode = currentNode;
	    this.currentNode.isCurrent = true;
	  };
	
	  TreeStore.prototype.setUserCurrentNode = function setUserCurrentNode(node) {
	    var key = node[this.key];
	    var currNode = this.nodesMap[key];
	    this.setCurrentNode(currNode);
	  };
	
	  TreeStore.prototype.setCurrentNodeKey = function setCurrentNodeKey(key) {
	    if (key === null || key === undefined) {
	      this.currentNode && (this.currentNode.isCurrent = false);
	      this.currentNode = null;
	      return;
	    }
	    var node = this.getNode(key);
	    if (node) {
	      this.setCurrentNode(node);
	    }
	  };
	
	  return TreeStore;
	}();
	
	/* harmony default export */ var tree_store = (tree_store_TreeStore);
	;
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/tree/src/tree-node.vue?vue&type=template&id=3ba3ef0e&
	var tree_nodevue_type_template_id_3ba3ef0e_render = function() {
	  var this$1 = this
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      directives: [
	        {
	          name: "show",
	          rawName: "v-show",
	          value: _vm.node.visible,
	          expression: "node.visible"
	        }
	      ],
	      ref: "node",
	      staticClass: "el-tree-node",
	      class: {
	        "is-expanded": _vm.expanded,
	        "is-current": _vm.node.isCurrent,
	        "is-hidden": !_vm.node.visible,
	        "is-focusable": !_vm.node.disabled,
	        "is-checked": !_vm.node.disabled && _vm.node.checked
	      },
	      attrs: {
	        role: "treeitem",
	        tabindex: "-1",
	        "aria-expanded": _vm.expanded,
	        "aria-disabled": _vm.node.disabled,
	        "aria-checked": _vm.node.checked,
	        draggable: _vm.tree.draggable
	      },
	      on: {
	        click: function($event) {
	          $event.stopPropagation()
	          return _vm.handleClick($event)
	        },
	        contextmenu: function($event) {
	          return this$1.handleContextMenu($event)
	        },
	        dragstart: function($event) {
	          $event.stopPropagation()
	          return _vm.handleDragStart($event)
	        },
	        dragover: function($event) {
	          $event.stopPropagation()
	          return _vm.handleDragOver($event)
	        },
	        dragend: function($event) {
	          $event.stopPropagation()
	          return _vm.handleDragEnd($event)
	        },
	        drop: function($event) {
	          $event.stopPropagation()
	          return _vm.handleDrop($event)
	        }
	      }
	    },
	    [
	      _c(
	        "div",
	        {
	          staticClass: "el-tree-node__content",
	          style: {
	            "padding-left": (_vm.node.level - 1) * _vm.tree.indent + "px"
	          }
	        },
	        [
	          _c("span", {
	            class: [
	              {
	                "is-leaf": _vm.node.isLeaf,
	                expanded: !_vm.node.isLeaf && _vm.expanded
	              },
	              "el-tree-node__expand-icon",
	              _vm.tree.iconClass ? _vm.tree.iconClass : "el-icon-caret-right"
	            ],
	            on: {
	              click: function($event) {
	                $event.stopPropagation()
	                return _vm.handleExpandIconClick($event)
	              }
	            }
	          }),
	          _vm.showCheckbox
	            ? _c("el-checkbox", {
	                attrs: {
	                  indeterminate: _vm.node.indeterminate,
	                  disabled: !!_vm.node.disabled
	                },
	                on: { change: _vm.handleCheckChange },
	                nativeOn: {
	                  click: function($event) {
	                    $event.stopPropagation()
	                  }
	                },
	                model: {
	                  value: _vm.node.checked,
	                  callback: function($$v) {
	                    _vm.$set(_vm.node, "checked", $$v)
	                  },
	                  expression: "node.checked"
	                }
	              })
	            : _vm._e(),
	          _vm.node.loading
	            ? _c("span", {
	                staticClass: "el-tree-node__loading-icon el-icon-loading"
	              })
	            : _vm._e(),
	          _c("node-content", { attrs: { node: _vm.node } })
	        ],
	        1
	      ),
	      _c("el-collapse-transition", [
	        !_vm.renderAfterExpand || _vm.childNodeRendered
	          ? _c(
	              "div",
	              {
	                directives: [
	                  {
	                    name: "show",
	                    rawName: "v-show",
	                    value: _vm.expanded,
	                    expression: "expanded"
	                  }
	                ],
	                staticClass: "el-tree-node__children",
	                attrs: { role: "group", "aria-expanded": _vm.expanded }
	              },
	              _vm._l(_vm.node.childNodes, function(child) {
	                return _c("el-tree-node", {
	                  key: _vm.getNodeKey(child),
	                  attrs: {
	                    "render-content": _vm.renderContent,
	                    "render-after-expand": _vm.renderAfterExpand,
	                    "show-checkbox": _vm.showCheckbox,
	                    node: child
	                  },
	                  on: { "node-expand": _vm.handleChildNodeExpand }
	                })
	              }),
	              1
	            )
	          : _vm._e()
	      ])
	    ],
	    1
	  )
	}
	var tree_nodevue_type_template_id_3ba3ef0e_staticRenderFns = []
	tree_nodevue_type_template_id_3ba3ef0e_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/tree/src/tree-node.vue?vue&type=template&id=3ba3ef0e&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tree/src/tree-node.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	/* harmony default export */ var tree_nodevue_type_script_lang_js_ = ({
	  name: 'ElTreeNode',
	
	  componentName: 'ElTreeNode',
	
	  mixins: [emitter_default.a],
	
	  props: {
	    node: {
	      default: function _default() {
	        return {};
	      }
	    },
	    props: {},
	    renderContent: Function,
	    renderAfterExpand: {
	      type: Boolean,
	      default: true
	    },
	    showCheckbox: {
	      type: Boolean,
	      default: false
	    }
	  },
	
	  components: {
	    ElCollapseTransition: collapse_transition_default.a,
	    ElCheckbox: checkbox_default.a,
	    NodeContent: {
	      props: {
	        node: {
	          required: true
	        }
	      },
	      render: function render(h) {
	        var parent = this.$parent;
	        var tree = parent.tree;
	        var node = this.node;
	        var data = node.data,
	            store = node.store;
	
	        return parent.renderContent ? parent.renderContent.call(parent._renderProxy, h, { _self: tree.$vnode.context, node: node, data: data, store: store }) : tree.$scopedSlots.default ? tree.$scopedSlots.default({ node: node, data: data }) : h(
	          'span',
	          { 'class': 'el-tree-node__label' },
	          [node.label]
	        );
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      tree: null,
	      expanded: false,
	      childNodeRendered: false,
	      oldChecked: null,
	      oldIndeterminate: null
	    };
	  },
	
	
	  watch: {
	    'node.indeterminate': function nodeIndeterminate(val) {
	      this.handleSelectChange(this.node.checked, val);
	    },
	    'node.checked': function nodeChecked(val) {
	      this.handleSelectChange(val, this.node.indeterminate);
	    },
	    'node.expanded': function nodeExpanded(val) {
	      var _this = this;
	
	      this.$nextTick(function () {
	        return _this.expanded = val;
	      });
	      if (val) {
	        this.childNodeRendered = true;
	      }
	    }
	  },
	
	  methods: {
	    getNodeKey: function getNodeKey(node) {
	      return util_getNodeKey(this.tree.nodeKey, node.data);
	    },
	    handleSelectChange: function handleSelectChange(checked, indeterminate) {
	      if (this.oldChecked !== checked && this.oldIndeterminate !== indeterminate) {
	        this.tree.$emit('check-change', this.node.data, checked, indeterminate);
	      }
	      this.oldChecked = checked;
	      this.indeterminate = indeterminate;
	    },
	    handleClick: function handleClick() {
	      var store = this.tree.store;
	      store.setCurrentNode(this.node);
	      this.tree.$emit('current-change', store.currentNode ? store.currentNode.data : null, store.currentNode);
	      this.tree.currentNode = this;
	      if (this.tree.expandOnClickNode) {
	        this.handleExpandIconClick();
	      }
	      if (this.tree.checkOnClickNode && !this.node.disabled) {
	        this.handleCheckChange(null, {
	          target: { checked: !this.node.checked }
	        });
	      }
	      this.tree.$emit('node-click', this.node.data, this.node, this);
	    },
	    handleContextMenu: function handleContextMenu(event) {
	      if (this.tree._events['node-contextmenu'] && this.tree._events['node-contextmenu'].length > 0) {
	        event.stopPropagation();
	        event.preventDefault();
	      }
	      this.tree.$emit('node-contextmenu', event, this.node.data, this.node, this);
	    },
	    handleExpandIconClick: function handleExpandIconClick() {
	      if (this.node.isLeaf) return;
	      if (this.expanded) {
	        this.tree.$emit('node-collapse', this.node.data, this.node, this);
	        this.node.collapse();
	      } else {
	        this.node.expand();
	        this.$emit('node-expand', this.node.data, this.node, this);
	      }
	    },
	    handleCheckChange: function handleCheckChange(value, ev) {
	      var _this2 = this;
	
	      this.node.setChecked(ev.target.checked, !this.tree.checkStrictly);
	      this.$nextTick(function () {
	        var store = _this2.tree.store;
	        _this2.tree.$emit('check', _this2.node.data, {
	          checkedNodes: store.getCheckedNodes(),
	          checkedKeys: store.getCheckedKeys(),
	          halfCheckedNodes: store.getHalfCheckedNodes(),
	          halfCheckedKeys: store.getHalfCheckedKeys()
	        });
	      });
	    },
	    handleChildNodeExpand: function handleChildNodeExpand(nodeData, node, instance) {
	      this.broadcast('ElTreeNode', 'tree-node-expand', node);
	      this.tree.$emit('node-expand', nodeData, node, instance);
	    },
	    handleDragStart: function handleDragStart(event) {
	      if (!this.tree.draggable) return;
	      this.tree.$emit('tree-node-drag-start', event, this);
	    },
	    handleDragOver: function handleDragOver(event) {
	      if (!this.tree.draggable) return;
	      this.tree.$emit('tree-node-drag-over', event, this);
	      event.preventDefault();
	    },
	    handleDrop: function handleDrop(event) {
	      event.preventDefault();
	    },
	    handleDragEnd: function handleDragEnd(event) {
	      if (!this.tree.draggable) return;
	      this.tree.$emit('tree-node-drag-end', event, this);
	    }
	  },
	
	  created: function created() {
	    var _this3 = this;
	
	    var parent = this.$parent;
	
	    if (parent.isTree) {
	      this.tree = parent;
	    } else {
	      this.tree = parent.tree;
	    }
	
	    var tree = this.tree;
	    if (!tree) {
	      console.warn('Can not find node\'s tree.');
	    }
	
	    var props = tree.props || {};
	    var childrenKey = props['children'] || 'children';
	
	    this.$watch('node.data.' + childrenKey, function () {
	      _this3.node.updateChildren();
	    });
	
	    if (this.node.expanded) {
	      this.expanded = true;
	      this.childNodeRendered = true;
	    }
	
	    if (this.tree.accordion) {
	      this.$on('tree-node-expand', function (node) {
	        if (_this3.node !== node) {
	          _this3.node.collapse();
	        }
	      });
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/tree/src/tree-node.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_tree_nodevue_type_script_lang_js_ = (tree_nodevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/tree/src/tree-node.vue
	
	
	
	
	
	/* normalize component */
	
	var tree_node_component = normalizeComponent(
	  src_tree_nodevue_type_script_lang_js_,
	  tree_nodevue_type_template_id_3ba3ef0e_render,
	  tree_nodevue_type_template_id_3ba3ef0e_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var tree_node_api; }
	tree_node_component.options.__file = "packages/tree/src/tree-node.vue"
	/* harmony default export */ var tree_node = (tree_node_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tree/src/tree.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	/* harmony default export */ var treevue_type_script_lang_js_ = ({
	  name: 'ElTree',
	
	  mixins: [emitter_default.a],
	
	  components: {
	    ElTreeNode: tree_node
	  },
	
	  data: function data() {
	    return {
	      store: null,
	      root: null,
	      currentNode: null,
	      treeItems: null,
	      checkboxItems: [],
	      dragState: {
	        showDropIndicator: false,
	        draggingNode: null,
	        dropNode: null,
	        allowDrop: true
	      }
	    };
	  },
	
	
	  props: {
	    data: {
	      type: Array
	    },
	    emptyText: {
	      type: String,
	      default: function _default() {
	        return Object(lib_locale_["t"])('el.tree.emptyText');
	      }
	    },
	    renderAfterExpand: {
	      type: Boolean,
	      default: true
	    },
	    nodeKey: String,
	    checkStrictly: Boolean,
	    defaultExpandAll: Boolean,
	    expandOnClickNode: {
	      type: Boolean,
	      default: true
	    },
	    checkOnClickNode: Boolean,
	    checkDescendants: {
	      type: Boolean,
	      default: false
	    },
	    autoExpandParent: {
	      type: Boolean,
	      default: true
	    },
	    defaultCheckedKeys: Array,
	    defaultExpandedKeys: Array,
	    currentNodeKey: [String, Number],
	    renderContent: Function,
	    showCheckbox: {
	      type: Boolean,
	      default: false
	    },
	    draggable: {
	      type: Boolean,
	      default: false
	    },
	    allowDrag: Function,
	    allowDrop: Function,
	    props: {
	      default: function _default() {
	        return {
	          children: 'children',
	          label: 'label',
	          disabled: 'disabled'
	        };
	      }
	    },
	    lazy: {
	      type: Boolean,
	      default: false
	    },
	    highlightCurrent: Boolean,
	    load: Function,
	    filterNodeMethod: Function,
	    accordion: Boolean,
	    indent: {
	      type: Number,
	      default: 18
	    },
	    iconClass: String
	  },
	
	  computed: {
	    children: {
	      set: function set(value) {
	        this.data = value;
	      },
	      get: function get() {
	        return this.data;
	      }
	    },
	
	    treeItemArray: function treeItemArray() {
	      return Array.prototype.slice.call(this.treeItems);
	    },
	    isEmpty: function isEmpty() {
	      var childNodes = this.root.childNodes;
	
	      return !childNodes || childNodes.length === 0 || childNodes.every(function (_ref) {
	        var visible = _ref.visible;
	        return !visible;
	      });
	    }
	  },
	
	  watch: {
	    defaultCheckedKeys: function defaultCheckedKeys(newVal) {
	      this.store.setDefaultCheckedKey(newVal);
	    },
	    defaultExpandedKeys: function defaultExpandedKeys(newVal) {
	      this.store.defaultExpandedKeys = newVal;
	      this.store.setDefaultExpandedKeys(newVal);
	    },
	    data: function data(newVal) {
	      this.store.setData(newVal);
	    },
	    checkboxItems: function checkboxItems(val) {
	      Array.prototype.forEach.call(val, function (checkbox) {
	        checkbox.setAttribute('tabindex', -1);
	      });
	    },
	    checkStrictly: function checkStrictly(newVal) {
	      this.store.checkStrictly = newVal;
	    }
	  },
	
	  methods: {
	    filter: function filter(value) {
	      if (!this.filterNodeMethod) throw new Error('[Tree] filterNodeMethod is required when filter');
	      this.store.filter(value);
	    },
	    getNodeKey: function getNodeKey(node) {
	      return util_getNodeKey(this.nodeKey, node.data);
	    },
	    getNodePath: function getNodePath(data) {
	      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in getNodePath');
	      var node = this.store.getNode(data);
	      if (!node) return [];
	      var path = [node.data];
	      var parent = node.parent;
	      while (parent && parent !== this.root) {
	        path.push(parent.data);
	        parent = parent.parent;
	      }
	      return path.reverse();
	    },
	    getCheckedNodes: function getCheckedNodes(leafOnly, includeHalfChecked) {
	      return this.store.getCheckedNodes(leafOnly, includeHalfChecked);
	    },
	    getCheckedKeys: function getCheckedKeys(leafOnly) {
	      return this.store.getCheckedKeys(leafOnly);
	    },
	    getCurrentNode: function getCurrentNode() {
	      var currentNode = this.store.getCurrentNode();
	      return currentNode ? currentNode.data : null;
	    },
	    getCurrentKey: function getCurrentKey() {
	      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in getCurrentKey');
	      var currentNode = this.getCurrentNode();
	      return currentNode ? currentNode[this.nodeKey] : null;
	    },
	    setCheckedNodes: function setCheckedNodes(nodes, leafOnly) {
	      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in setCheckedNodes');
	      this.store.setCheckedNodes(nodes, leafOnly);
	    },
	    setCheckedKeys: function setCheckedKeys(keys, leafOnly) {
	      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in setCheckedKeys');
	      this.store.setCheckedKeys(keys, leafOnly);
	    },
	    setChecked: function setChecked(data, checked, deep) {
	      this.store.setChecked(data, checked, deep);
	    },
	    getHalfCheckedNodes: function getHalfCheckedNodes() {
	      return this.store.getHalfCheckedNodes();
	    },
	    getHalfCheckedKeys: function getHalfCheckedKeys() {
	      return this.store.getHalfCheckedKeys();
	    },
	    setCurrentNode: function setCurrentNode(node) {
	      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in setCurrentNode');
	      this.store.setUserCurrentNode(node);
	    },
	    setCurrentKey: function setCurrentKey(key) {
	      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in setCurrentKey');
	      this.store.setCurrentNodeKey(key);
	    },
	    getNode: function getNode(data) {
	      return this.store.getNode(data);
	    },
	    remove: function remove(data) {
	      this.store.remove(data);
	    },
	    append: function append(data, parentNode) {
	      this.store.append(data, parentNode);
	    },
	    insertBefore: function insertBefore(data, refNode) {
	      this.store.insertBefore(data, refNode);
	    },
	    insertAfter: function insertAfter(data, refNode) {
	      this.store.insertAfter(data, refNode);
	    },
	    handleNodeExpand: function handleNodeExpand(nodeData, node, instance) {
	      this.broadcast('ElTreeNode', 'tree-node-expand', node);
	      this.$emit('node-expand', nodeData, node, instance);
	    },
	    updateKeyChildren: function updateKeyChildren(key, data) {
	      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in updateKeyChild');
	      this.store.updateChildren(key, data);
	    },
	    initTabIndex: function initTabIndex() {
	      this.treeItems = this.$el.querySelectorAll('.is-focusable[role=treeitem]');
	      this.checkboxItems = this.$el.querySelectorAll('input[type=checkbox]');
	      var checkedItem = this.$el.querySelectorAll('.is-checked[role=treeitem]');
	      if (checkedItem.length) {
	        checkedItem[0].setAttribute('tabindex', 0);
	        return;
	      }
	      this.treeItems[0] && this.treeItems[0].setAttribute('tabindex', 0);
	    },
	    handleKeydown: function handleKeydown(ev) {
	      var currentItem = ev.target;
	      if (currentItem.className.indexOf('el-tree-node') === -1) return;
	      var keyCode = ev.keyCode;
	      this.treeItems = this.$el.querySelectorAll('.is-focusable[role=treeitem]');
	      var currentIndex = this.treeItemArray.indexOf(currentItem);
	      var nextIndex = void 0;
	      if ([38, 40].indexOf(keyCode) > -1) {
	        // up、down
	        ev.preventDefault();
	        if (keyCode === 38) {
	          // up
	          nextIndex = currentIndex !== 0 ? currentIndex - 1 : 0;
	        } else {
	          nextIndex = currentIndex < this.treeItemArray.length - 1 ? currentIndex + 1 : 0;
	        }
	        this.treeItemArray[nextIndex].focus(); // 选中
	      }
	      if ([37, 39].indexOf(keyCode) > -1) {
	        // left、right 展开
	        ev.preventDefault();
	        currentItem.click(); // 选中
	      }
	      var hasInput = currentItem.querySelector('[type="checkbox"]');
	      if ([13, 32].indexOf(keyCode) > -1 && hasInput) {
	        // space enter选中checkbox
	        ev.preventDefault();
	        hasInput.click();
	      }
	    }
	  },
	
	  created: function created() {
	    var _this = this;
	
	    this.isTree = true;
	
	    this.store = new tree_store({
	      key: this.nodeKey,
	      data: this.data,
	      lazy: this.lazy,
	      props: this.props,
	      load: this.load,
	      currentNodeKey: this.currentNodeKey,
	      checkStrictly: this.checkStrictly,
	      checkDescendants: this.checkDescendants,
	      defaultCheckedKeys: this.defaultCheckedKeys,
	      defaultExpandedKeys: this.defaultExpandedKeys,
	      autoExpandParent: this.autoExpandParent,
	      defaultExpandAll: this.defaultExpandAll,
	      filterNodeMethod: this.filterNodeMethod
	    });
	
	    this.root = this.store.root;
	
	    var dragState = this.dragState;
	    this.$on('tree-node-drag-start', function (event, treeNode) {
	      if (typeof _this.allowDrag === 'function' && !_this.allowDrag(treeNode.node)) {
	        event.preventDefault();
	        return false;
	      }
	      event.dataTransfer.effectAllowed = 'move';
	
	      // wrap in try catch to address IE's error when first param is 'text/plain'
	      try {
	        // setData is required for draggable to work in FireFox
	        // the content has to be '' so dragging a node out of the tree won't open a new tab in FireFox
	        event.dataTransfer.setData('text/plain', '');
	      } catch (e) {}
	      dragState.draggingNode = treeNode;
	      _this.$emit('node-drag-start', treeNode.node, event);
	    });
	
	    this.$on('tree-node-drag-over', function (event, treeNode) {
	      var dropNode = findNearestComponent(event.target, 'ElTreeNode');
	      var oldDropNode = dragState.dropNode;
	      if (oldDropNode && oldDropNode !== dropNode) {
	        Object(dom_["removeClass"])(oldDropNode.$el, 'is-drop-inner');
	      }
	      var draggingNode = dragState.draggingNode;
	      if (!draggingNode || !dropNode) return;
	
	      var dropPrev = true;
	      var dropInner = true;
	      var dropNext = true;
	      var userAllowDropInner = true;
	      if (typeof _this.allowDrop === 'function') {
	        dropPrev = _this.allowDrop(draggingNode.node, dropNode.node, 'prev');
	        userAllowDropInner = dropInner = _this.allowDrop(draggingNode.node, dropNode.node, 'inner');
	        dropNext = _this.allowDrop(draggingNode.node, dropNode.node, 'next');
	      }
	      event.dataTransfer.dropEffect = dropInner ? 'move' : 'none';
	      if ((dropPrev || dropInner || dropNext) && oldDropNode !== dropNode) {
	        if (oldDropNode) {
	          _this.$emit('node-drag-leave', draggingNode.node, oldDropNode.node, event);
	        }
	        _this.$emit('node-drag-enter', draggingNode.node, dropNode.node, event);
	      }
	
	      if (dropPrev || dropInner || dropNext) {
	        dragState.dropNode = dropNode;
	      }
	
	      if (dropNode.node.nextSibling === draggingNode.node) {
	        dropNext = false;
	      }
	      if (dropNode.node.previousSibling === draggingNode.node) {
	        dropPrev = false;
	      }
	      if (dropNode.node.contains(draggingNode.node, false)) {
	        dropInner = false;
	      }
	      if (draggingNode.node === dropNode.node || draggingNode.node.contains(dropNode.node)) {
	        dropPrev = false;
	        dropInner = false;
	        dropNext = false;
	      }
	
	      var targetPosition = dropNode.$el.getBoundingClientRect();
	      var treePosition = _this.$el.getBoundingClientRect();
	
	      var dropType = void 0;
	      var prevPercent = dropPrev ? dropInner ? 0.25 : dropNext ? 0.45 : 1 : -1;
	      var nextPercent = dropNext ? dropInner ? 0.75 : dropPrev ? 0.55 : 0 : 1;
	
	      var indicatorTop = -9999;
	      var distance = event.clientY - targetPosition.top;
	      if (distance < targetPosition.height * prevPercent) {
	        dropType = 'before';
	      } else if (distance > targetPosition.height * nextPercent) {
	        dropType = 'after';
	      } else if (dropInner) {
	        dropType = 'inner';
	      } else {
	        dropType = 'none';
	      }
	
	      var iconPosition = dropNode.$el.querySelector('.el-tree-node__expand-icon').getBoundingClientRect();
	      var dropIndicator = _this.$refs.dropIndicator;
	      if (dropType === 'before') {
	        indicatorTop = iconPosition.top - treePosition.top;
	      } else if (dropType === 'after') {
	        indicatorTop = iconPosition.bottom - treePosition.top;
	      }
	      dropIndicator.style.top = indicatorTop + 'px';
	      dropIndicator.style.left = iconPosition.right - treePosition.left + 'px';
	
	      if (dropType === 'inner') {
	        Object(dom_["addClass"])(dropNode.$el, 'is-drop-inner');
	      } else {
	        Object(dom_["removeClass"])(dropNode.$el, 'is-drop-inner');
	      }
	
	      dragState.showDropIndicator = dropType === 'before' || dropType === 'after';
	      dragState.allowDrop = dragState.showDropIndicator || userAllowDropInner;
	      dragState.dropType = dropType;
	      _this.$emit('node-drag-over', draggingNode.node, dropNode.node, event);
	    });
	
	    this.$on('tree-node-drag-end', function (event) {
	      var draggingNode = dragState.draggingNode,
	          dropType = dragState.dropType,
	          dropNode = dragState.dropNode;
	
	      event.preventDefault();
	      event.dataTransfer.dropEffect = 'move';
	
	      if (draggingNode && dropNode) {
	        var draggingNodeCopy = { data: draggingNode.node.data };
	        if (dropType !== 'none') {
	          draggingNode.node.remove();
	        }
	        if (dropType === 'before') {
	          dropNode.node.parent.insertBefore(draggingNodeCopy, dropNode.node);
	        } else if (dropType === 'after') {
	          dropNode.node.parent.insertAfter(draggingNodeCopy, dropNode.node);
	        } else if (dropType === 'inner') {
	          dropNode.node.insertChild(draggingNodeCopy);
	        }
	        if (dropType !== 'none') {
	          _this.store.registerNode(draggingNodeCopy);
	        }
	
	        Object(dom_["removeClass"])(dropNode.$el, 'is-drop-inner');
	
	        _this.$emit('node-drag-end', draggingNode.node, dropNode.node, dropType, event);
	        if (dropType !== 'none') {
	          _this.$emit('node-drop', draggingNode.node, dropNode.node, dropType, event);
	        }
	      }
	      if (draggingNode && !dropNode) {
	        _this.$emit('node-drag-end', draggingNode.node, null, dropType, event);
	      }
	
	      dragState.showDropIndicator = false;
	      dragState.draggingNode = null;
	      dragState.dropNode = null;
	      dragState.allowDrop = true;
	    });
	  },
	  mounted: function mounted() {
	    this.initTabIndex();
	    this.$el.addEventListener('keydown', this.handleKeydown);
	  },
	  updated: function updated() {
	    this.treeItems = this.$el.querySelectorAll('[role=treeitem]');
	    this.checkboxItems = this.$el.querySelectorAll('input[type=checkbox]');
	  }
	});
	// CONCATENATED MODULE: ./packages/tree/src/tree.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_treevue_type_script_lang_js_ = (treevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/tree/src/tree.vue
	
	
	
	
	
	/* normalize component */
	
	var tree_component = normalizeComponent(
	  src_treevue_type_script_lang_js_,
	  treevue_type_template_id_547575a6_render,
	  treevue_type_template_id_547575a6_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var tree_api; }
	tree_component.options.__file = "packages/tree/src/tree.vue"
	/* harmony default export */ var src_tree = (tree_component.exports);
	// CONCATENATED MODULE: ./packages/tree/index.js
	
	
	/* istanbul ignore next */
	src_tree.install = function (Vue) {
	  Vue.component(src_tree.name, src_tree);
	};
	
	/* harmony default export */ var packages_tree = (src_tree);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/alert/src/main.vue?vue&type=template&id=6e53341b&
	var mainvue_type_template_id_6e53341b_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("transition", { attrs: { name: "el-alert-fade" } }, [
	    _c(
	      "div",
	      {
	        directives: [
	          {
	            name: "show",
	            rawName: "v-show",
	            value: _vm.visible,
	            expression: "visible"
	          }
	        ],
	        staticClass: "el-alert",
	        class: [
	          _vm.typeClass,
	          _vm.center ? "is-center" : "",
	          "is-" + _vm.effect
	        ],
	        attrs: { role: "alert" }
	      },
	      [
	        _vm.showIcon
	          ? _c("i", {
	              staticClass: "el-alert__icon",
	              class: [_vm.iconClass, _vm.isBigIcon]
	            })
	          : _vm._e(),
	        _c("div", { staticClass: "el-alert__content" }, [
	          _vm.title || _vm.$slots.title
	            ? _c(
	                "span",
	                { staticClass: "el-alert__title", class: [_vm.isBoldTitle] },
	                [_vm._t("title", [_vm._v(_vm._s(_vm.title))])],
	                2
	              )
	            : _vm._e(),
	          _vm.$slots.default && !_vm.description
	            ? _c(
	                "p",
	                { staticClass: "el-alert__description" },
	                [_vm._t("default")],
	                2
	              )
	            : _vm._e(),
	          _vm.description && !_vm.$slots.default
	            ? _c("p", { staticClass: "el-alert__description" }, [
	                _vm._v(_vm._s(_vm.description))
	              ])
	            : _vm._e(),
	          _c(
	            "i",
	            {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value: _vm.closable,
	                  expression: "closable"
	                }
	              ],
	              staticClass: "el-alert__closebtn",
	              class: {
	                "is-customed": _vm.closeText !== "",
	                "el-icon-close": _vm.closeText === ""
	              },
	              on: {
	                click: function($event) {
	                  _vm.close()
	                }
	              }
	            },
	            [_vm._v(_vm._s(_vm.closeText))]
	          )
	        ])
	      ]
	    )
	  ])
	}
	var mainvue_type_template_id_6e53341b_staticRenderFns = []
	mainvue_type_template_id_6e53341b_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/alert/src/main.vue?vue&type=template&id=6e53341b&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/alert/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	var TYPE_CLASSES_MAP = {
	  'success': 'el-icon-success',
	  'warning': 'el-icon-warning',
	  'error': 'el-icon-error'
	};
	/* harmony default export */ var alert_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElAlert',
	
	  props: {
	    title: {
	      type: String,
	      default: ''
	    },
	    description: {
	      type: String,
	      default: ''
	    },
	    type: {
	      type: String,
	      default: 'info'
	    },
	    closable: {
	      type: Boolean,
	      default: true
	    },
	    closeText: {
	      type: String,
	      default: ''
	    },
	    showIcon: Boolean,
	    center: Boolean,
	    effect: {
	      type: String,
	      default: 'light',
	      validator: function validator(value) {
	        return ['light', 'dark'].indexOf(value) !== -1;
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      visible: true
	    };
	  },
	
	
	  methods: {
	    close: function close() {
	      this.visible = false;
	      this.$emit('close');
	    }
	  },
	
	  computed: {
	    typeClass: function typeClass() {
	      return 'el-alert--' + this.type;
	    },
	    iconClass: function iconClass() {
	      return TYPE_CLASSES_MAP[this.type] || 'el-icon-info';
	    },
	    isBigIcon: function isBigIcon() {
	      return this.description || this.$slots.default ? 'is-big' : '';
	    },
	    isBoldTitle: function isBoldTitle() {
	      return this.description || this.$slots.default ? 'is-bold' : '';
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/alert/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_alert_src_mainvue_type_script_lang_js_ = (alert_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/alert/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var alert_src_main_component = normalizeComponent(
	  packages_alert_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_6e53341b_render,
	  mainvue_type_template_id_6e53341b_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var alert_src_main_api; }
	alert_src_main_component.options.__file = "packages/alert/src/main.vue"
	/* harmony default export */ var alert_src_main = (alert_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/alert/index.js
	
	
	/* istanbul ignore next */
	alert_src_main.install = function (Vue) {
	  Vue.component(alert_src_main.name, alert_src_main);
	};
	
	/* harmony default export */ var packages_alert = (alert_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/notification/src/main.vue?vue&type=template&id=43dbc3d8&
	var mainvue_type_template_id_43dbc3d8_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("transition", { attrs: { name: "el-notification-fade" } }, [
	    _c(
	      "div",
	      {
	        directives: [
	          {
	            name: "show",
	            rawName: "v-show",
	            value: _vm.visible,
	            expression: "visible"
	          }
	        ],
	        class: ["el-notification", _vm.customClass, _vm.horizontalClass],
	        style: _vm.positionStyle,
	        attrs: { role: "alert" },
	        on: {
	          mouseenter: function($event) {
	            _vm.clearTimer()
	          },
	          mouseleave: function($event) {
	            _vm.startTimer()
	          },
	          click: _vm.click
	        }
	      },
	      [
	        _vm.type || _vm.iconClass
	          ? _c("i", {
	              staticClass: "el-notification__icon",
	              class: [_vm.typeClass, _vm.iconClass]
	            })
	          : _vm._e(),
	        _c(
	          "div",
	          {
	            staticClass: "el-notification__group",
	            class: { "is-with-icon": _vm.typeClass || _vm.iconClass }
	          },
	          [
	            _c("h2", {
	              staticClass: "el-notification__title",
	              domProps: { textContent: _vm._s(_vm.title) }
	            }),
	            _c(
	              "div",
	              {
	                directives: [
	                  {
	                    name: "show",
	                    rawName: "v-show",
	                    value: _vm.message,
	                    expression: "message"
	                  }
	                ],
	                staticClass: "el-notification__content"
	              },
	              [
	                _vm._t("default", [
	                  !_vm.dangerouslyUseHTMLString
	                    ? _c("p", [_vm._v(_vm._s(_vm.message))])
	                    : _c("p", { domProps: { innerHTML: _vm._s(_vm.message) } })
	                ])
	              ],
	              2
	            ),
	            _vm.showClose
	              ? _c("div", {
	                  staticClass: "el-notification__closeBtn el-icon-close",
	                  on: {
	                    click: function($event) {
	                      $event.stopPropagation()
	                      return _vm.close($event)
	                    }
	                  }
	                })
	              : _vm._e()
	          ]
	        )
	      ]
	    )
	  ])
	}
	var mainvue_type_template_id_43dbc3d8_staticRenderFns = []
	mainvue_type_template_id_43dbc3d8_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/notification/src/main.vue?vue&type=template&id=43dbc3d8&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/notification/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	var mainvue_type_script_lang_js_typeMap = {
	  success: 'success',
	  info: 'info',
	  warning: 'warning',
	  error: 'error'
	};
	
	/* harmony default export */ var notification_src_mainvue_type_script_lang_js_ = ({
	  data: function data() {
	    return {
	      visible: false,
	      title: '',
	      message: '',
	      duration: 4500,
	      type: '',
	      showClose: true,
	      customClass: '',
	      iconClass: '',
	      onClose: null,
	      onClick: null,
	      closed: false,
	      verticalOffset: 0,
	      timer: null,
	      dangerouslyUseHTMLString: false,
	      position: 'top-right'
	    };
	  },
	
	
	  computed: {
	    typeClass: function typeClass() {
	      return this.type && mainvue_type_script_lang_js_typeMap[this.type] ? 'el-icon-' + mainvue_type_script_lang_js_typeMap[this.type] : '';
	    },
	    horizontalClass: function horizontalClass() {
	      return this.position.indexOf('right') > -1 ? 'right' : 'left';
	    },
	    verticalProperty: function verticalProperty() {
	      return (/^top-/.test(this.position) ? 'top' : 'bottom'
	      );
	    },
	    positionStyle: function positionStyle() {
	      var _ref;
	
	      return _ref = {}, _ref[this.verticalProperty] = this.verticalOffset + 'px', _ref;
	    }
	  },
	
	  watch: {
	    closed: function closed(newVal) {
	      if (newVal) {
	        this.visible = false;
	        this.$el.addEventListener('transitionend', this.destroyElement);
	      }
	    }
	  },
	
	  methods: {
	    destroyElement: function destroyElement() {
	      this.$el.removeEventListener('transitionend', this.destroyElement);
	      this.$destroy(true);
	      this.$el.parentNode.removeChild(this.$el);
	    },
	    click: function click() {
	      if (typeof this.onClick === 'function') {
	        this.onClick();
	      }
	    },
	    close: function close() {
	      this.closed = true;
	      if (typeof this.onClose === 'function') {
	        this.onClose();
	      }
	    },
	    clearTimer: function clearTimer() {
	      clearTimeout(this.timer);
	    },
	    startTimer: function startTimer() {
	      var _this = this;
	
	      if (this.duration > 0) {
	        this.timer = setTimeout(function () {
	          if (!_this.closed) {
	            _this.close();
	          }
	        }, this.duration);
	      }
	    },
	    keydown: function keydown(e) {
	      if (e.keyCode === 46 || e.keyCode === 8) {
	        this.clearTimer(); // detele 取消倒计时
	      } else if (e.keyCode === 27) {
	        // esc关闭消息
	        if (!this.closed) {
	          this.close();
	        }
	      } else {
	        this.startTimer(); // 恢复倒计时
	      }
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    if (this.duration > 0) {
	      this.timer = setTimeout(function () {
	        if (!_this2.closed) {
	          _this2.close();
	        }
	      }, this.duration);
	    }
	    document.addEventListener('keydown', this.keydown);
	  },
	  beforeDestroy: function beforeDestroy() {
	    document.removeEventListener('keydown', this.keydown);
	  }
	});
	// CONCATENATED MODULE: ./packages/notification/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_notification_src_mainvue_type_script_lang_js_ = (notification_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/notification/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var notification_src_main_component = normalizeComponent(
	  packages_notification_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_43dbc3d8_render,
	  mainvue_type_template_id_43dbc3d8_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var notification_src_main_api; }
	notification_src_main_component.options.__file = "packages/notification/src/main.vue"
	/* harmony default export */ var notification_src_main = (notification_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/notification/src/main.js
	
	
	
	
	
	var NotificationConstructor = external_vue_default.a.extend(notification_src_main);
	
	var src_main_instance = void 0;
	var instances = [];
	var seed = 1;
	
	var main_Notification = function Notification(options) {
	  if (external_vue_default.a.prototype.$isServer) return;
	  options = merge_default()({}, options);
	  var userOnClose = options.onClose;
	  var id = 'notification_' + seed++;
	  var position = options.position || 'top-right';
	
	  options.onClose = function () {
	    Notification.close(id, userOnClose);
	  };
	
	  src_main_instance = new NotificationConstructor({
	    data: options
	  });
	
	  if (Object(vdom_["isVNode"])(options.message)) {
	    src_main_instance.$slots.default = [options.message];
	    options.message = 'REPLACED_BY_VNODE';
	  }
	  src_main_instance.id = id;
	  src_main_instance.$mount();
	  document.body.appendChild(src_main_instance.$el);
	  src_main_instance.visible = true;
	  src_main_instance.dom = src_main_instance.$el;
	  src_main_instance.dom.style.zIndex = popup_["PopupManager"].nextZIndex();
	
	  var verticalOffset = options.offset || 0;
	  instances.filter(function (item) {
	    return item.position === position;
	  }).forEach(function (item) {
	    verticalOffset += item.$el.offsetHeight + 16;
	  });
	  verticalOffset += 16;
	  src_main_instance.verticalOffset = verticalOffset;
	  instances.push(src_main_instance);
	  return src_main_instance;
	};
	
	['success', 'warning', 'info', 'error'].forEach(function (type) {
	  main_Notification[type] = function (options) {
	    if (typeof options === 'string' || Object(vdom_["isVNode"])(options)) {
	      options = {
	        message: options
	      };
	    }
	    options.type = type;
	    return main_Notification(options);
	  };
	});
	
	main_Notification.close = function (id, userOnClose) {
	  var index = -1;
	  var len = instances.length;
	  var instance = instances.filter(function (instance, i) {
	    if (instance.id === id) {
	      index = i;
	      return true;
	    }
	    return false;
	  })[0];
	  if (!instance) return;
	
	  if (typeof userOnClose === 'function') {
	    userOnClose(instance);
	  }
	  instances.splice(index, 1);
	
	  if (len <= 1) return;
	  var position = instance.position;
	  var removedHeight = instance.dom.offsetHeight;
	  for (var i = index; i < len - 1; i++) {
	    if (instances[i].position === position) {
	      instances[i].dom.style[instance.verticalProperty] = parseInt(instances[i].dom.style[instance.verticalProperty], 10) - removedHeight - 16 + 'px';
	    }
	  }
	};
	
	main_Notification.closeAll = function () {
	  for (var i = instances.length - 1; i >= 0; i--) {
	    instances[i].close();
	  }
	};
	
	/* harmony default export */ var packages_notification_src_main = (main_Notification);
	// CONCATENATED MODULE: ./packages/notification/index.js
	
	/* harmony default export */ var notification = (packages_notification_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/slider/src/main.vue?vue&type=template&id=32708644&
	var mainvue_type_template_id_32708644_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-slider",
	      class: {
	        "is-vertical": _vm.vertical,
	        "el-slider--with-input": _vm.showInput
	      },
	      attrs: {
	        role: "slider",
	        "aria-valuemin": _vm.min,
	        "aria-valuemax": _vm.max,
	        "aria-orientation": _vm.vertical ? "vertical" : "horizontal",
	        "aria-disabled": _vm.sliderDisabled
	      }
	    },
	    [
	      _vm.showInput && !_vm.range
	        ? _c("el-input-number", {
	            ref: "input",
	            staticClass: "el-slider__input",
	            attrs: {
	              step: _vm.step,
	              disabled: _vm.sliderDisabled,
	              controls: _vm.showInputControls,
	              min: _vm.min,
	              max: _vm.max,
	              debounce: _vm.debounce,
	              size: _vm.inputSize
	            },
	            on: { change: _vm.emitChange },
	            model: {
	              value: _vm.firstValue,
	              callback: function($$v) {
	                _vm.firstValue = $$v
	              },
	              expression: "firstValue"
	            }
	          })
	        : _vm._e(),
	      _c(
	        "div",
	        {
	          ref: "slider",
	          staticClass: "el-slider__runway",
	          class: { "show-input": _vm.showInput, disabled: _vm.sliderDisabled },
	          style: _vm.runwayStyle,
	          on: { click: _vm.onSliderClick }
	        },
	        [
	          _c("div", { staticClass: "el-slider__bar", style: _vm.barStyle }),
	          _c("slider-button", {
	            ref: "button1",
	            attrs: {
	              vertical: _vm.vertical,
	              "tooltip-class": _vm.tooltipClass
	            },
	            model: {
	              value: _vm.firstValue,
	              callback: function($$v) {
	                _vm.firstValue = $$v
	              },
	              expression: "firstValue"
	            }
	          }),
	          _vm.range
	            ? _c("slider-button", {
	                ref: "button2",
	                attrs: {
	                  vertical: _vm.vertical,
	                  "tooltip-class": _vm.tooltipClass
	                },
	                model: {
	                  value: _vm.secondValue,
	                  callback: function($$v) {
	                    _vm.secondValue = $$v
	                  },
	                  expression: "secondValue"
	                }
	              })
	            : _vm._e(),
	          _vm._l(_vm.stops, function(item, key) {
	            return _vm.showStops
	              ? _c("div", {
	                  key: key,
	                  staticClass: "el-slider__stop",
	                  style: _vm.getStopStyle(item)
	                })
	              : _vm._e()
	          }),
	          _vm.markList.length > 0
	            ? [
	                _c(
	                  "div",
	                  _vm._l(_vm.markList, function(item, key) {
	                    return _c("div", {
	                      key: key,
	                      staticClass: "el-slider__stop el-slider__marks-stop",
	                      style: _vm.getStopStyle(item.position)
	                    })
	                  }),
	                  0
	                ),
	                _c(
	                  "div",
	                  { staticClass: "el-slider__marks" },
	                  _vm._l(_vm.markList, function(item, key) {
	                    return _c("slider-marker", {
	                      key: key,
	                      style: _vm.getStopStyle(item.position),
	                      attrs: { mark: item.mark }
	                    })
	                  }),
	                  1
	                )
	              ]
	            : _vm._e()
	        ],
	        2
	      )
	    ],
	    1
	  )
	}
	var mainvue_type_template_id_32708644_staticRenderFns = []
	mainvue_type_template_id_32708644_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/slider/src/main.vue?vue&type=template&id=32708644&
	
	// EXTERNAL MODULE: external "element-ui/lib/input-number"
	var input_number_ = __webpack_require__(41);
	var input_number_default = /*#__PURE__*/__webpack_require__.n(input_number_);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/slider/src/button.vue?vue&type=template&id=e72d2ad2&
	var buttonvue_type_template_id_e72d2ad2_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      ref: "button",
	      staticClass: "el-slider__button-wrapper",
	      class: { hover: _vm.hovering, dragging: _vm.dragging },
	      style: _vm.wrapperStyle,
	      attrs: { tabindex: "0" },
	      on: {
	        mouseenter: _vm.handleMouseEnter,
	        mouseleave: _vm.handleMouseLeave,
	        mousedown: _vm.onButtonDown,
	        touchstart: _vm.onButtonDown,
	        focus: _vm.handleMouseEnter,
	        blur: _vm.handleMouseLeave,
	        keydown: [
	          function($event) {
	            if (
	              !("button" in $event) &&
	              _vm._k($event.keyCode, "left", 37, $event.key, [
	                "Left",
	                "ArrowLeft"
	              ])
	            ) {
	              return null
	            }
	            if ("button" in $event && $event.button !== 0) {
	              return null
	            }
	            return _vm.onLeftKeyDown($event)
	          },
	          function($event) {
	            if (
	              !("button" in $event) &&
	              _vm._k($event.keyCode, "right", 39, $event.key, [
	                "Right",
	                "ArrowRight"
	              ])
	            ) {
	              return null
	            }
	            if ("button" in $event && $event.button !== 2) {
	              return null
	            }
	            return _vm.onRightKeyDown($event)
	          },
	          function($event) {
	            if (
	              !("button" in $event) &&
	              _vm._k($event.keyCode, "down", 40, $event.key, [
	                "Down",
	                "ArrowDown"
	              ])
	            ) {
	              return null
	            }
	            $event.preventDefault()
	            return _vm.onLeftKeyDown($event)
	          },
	          function($event) {
	            if (
	              !("button" in $event) &&
	              _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
	            ) {
	              return null
	            }
	            $event.preventDefault()
	            return _vm.onRightKeyDown($event)
	          }
	        ]
	      }
	    },
	    [
	      _c(
	        "el-tooltip",
	        {
	          ref: "tooltip",
	          attrs: {
	            placement: "top",
	            "popper-class": _vm.tooltipClass,
	            disabled: !_vm.showTooltip
	          }
	        },
	        [
	          _c("span", { attrs: { slot: "content" }, slot: "content" }, [
	            _vm._v(_vm._s(_vm.formatValue))
	          ]),
	          _c("div", {
	            staticClass: "el-slider__button",
	            class: { hover: _vm.hovering, dragging: _vm.dragging }
	          })
	        ]
	      )
	    ],
	    1
	  )
	}
	var buttonvue_type_template_id_e72d2ad2_staticRenderFns = []
	buttonvue_type_template_id_e72d2ad2_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/slider/src/button.vue?vue&type=template&id=e72d2ad2&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/slider/src/button.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var slider_src_buttonvue_type_script_lang_js_ = ({
	  name: 'ElSliderButton',
	
	  components: {
	    ElTooltip: tooltip_default.a
	  },
	
	  props: {
	    value: {
	      type: Number,
	      default: 0
	    },
	    vertical: {
	      type: Boolean,
	      default: false
	    },
	    tooltipClass: String
	  },
	
	  data: function data() {
	    return {
	      hovering: false,
	      dragging: false,
	      isClick: false,
	      startX: 0,
	      currentX: 0,
	      startY: 0,
	      currentY: 0,
	      startPosition: 0,
	      newPosition: null,
	      oldValue: this.value
	    };
	  },
	
	
	  computed: {
	    disabled: function disabled() {
	      return this.$parent.sliderDisabled;
	    },
	    max: function max() {
	      return this.$parent.max;
	    },
	    min: function min() {
	      return this.$parent.min;
	    },
	    step: function step() {
	      return this.$parent.step;
	    },
	    showTooltip: function showTooltip() {
	      return this.$parent.showTooltip;
	    },
	    precision: function precision() {
	      return this.$parent.precision;
	    },
	    currentPosition: function currentPosition() {
	      return (this.value - this.min) / (this.max - this.min) * 100 + '%';
	    },
	    enableFormat: function enableFormat() {
	      return this.$parent.formatTooltip instanceof Function;
	    },
	    formatValue: function formatValue() {
	      return this.enableFormat && this.$parent.formatTooltip(this.value) || this.value;
	    },
	    wrapperStyle: function wrapperStyle() {
	      return this.vertical ? { bottom: this.currentPosition } : { left: this.currentPosition };
	    }
	  },
	
	  watch: {
	    dragging: function dragging(val) {
	      this.$parent.dragging = val;
	    }
	  },
	
	  methods: {
	    displayTooltip: function displayTooltip() {
	      this.$refs.tooltip && (this.$refs.tooltip.showPopper = true);
	    },
	    hideTooltip: function hideTooltip() {
	      this.$refs.tooltip && (this.$refs.tooltip.showPopper = false);
	    },
	    handleMouseEnter: function handleMouseEnter() {
	      this.hovering = true;
	      this.displayTooltip();
	    },
	    handleMouseLeave: function handleMouseLeave() {
	      this.hovering = false;
	      this.hideTooltip();
	    },
	    onButtonDown: function onButtonDown(event) {
	      if (this.disabled) return;
	      event.preventDefault();
	      this.onDragStart(event);
	      window.addEventListener('mousemove', this.onDragging);
	      window.addEventListener('touchmove', this.onDragging);
	      window.addEventListener('mouseup', this.onDragEnd);
	      window.addEventListener('touchend', this.onDragEnd);
	      window.addEventListener('contextmenu', this.onDragEnd);
	    },
	    onLeftKeyDown: function onLeftKeyDown() {
	      if (this.disabled) return;
	      this.newPosition = parseFloat(this.currentPosition) - this.step / (this.max - this.min) * 100;
	      this.setPosition(this.newPosition);
	      this.$parent.emitChange();
	    },
	    onRightKeyDown: function onRightKeyDown() {
	      if (this.disabled) return;
	      this.newPosition = parseFloat(this.currentPosition) + this.step / (this.max - this.min) * 100;
	      this.setPosition(this.newPosition);
	      this.$parent.emitChange();
	    },
	    onDragStart: function onDragStart(event) {
	      this.dragging = true;
	      this.isClick = true;
	      if (event.type === 'touchstart') {
	        event.clientY = event.touches[0].clientY;
	        event.clientX = event.touches[0].clientX;
	      }
	      if (this.vertical) {
	        this.startY = event.clientY;
	      } else {
	        this.startX = event.clientX;
	      }
	      this.startPosition = parseFloat(this.currentPosition);
	      this.newPosition = this.startPosition;
	    },
	    onDragging: function onDragging(event) {
	      if (this.dragging) {
	        this.isClick = false;
	        this.displayTooltip();
	        this.$parent.resetSize();
	        var diff = 0;
	        if (event.type === 'touchmove') {
	          event.clientY = event.touches[0].clientY;
	          event.clientX = event.touches[0].clientX;
	        }
	        if (this.vertical) {
	          this.currentY = event.clientY;
	          diff = (this.startY - this.currentY) / this.$parent.sliderSize * 100;
	        } else {
	          this.currentX = event.clientX;
	          diff = (this.currentX - this.startX) / this.$parent.sliderSize * 100;
	        }
	        this.newPosition = this.startPosition + diff;
	        this.setPosition(this.newPosition);
	      }
	    },
	    onDragEnd: function onDragEnd() {
	      var _this = this;
	
	      if (this.dragging) {
	        /*
	         * 防止在 mouseup 后立即触发 click，导致滑块有几率产生一小段位移
	         * 不使用 preventDefault 是因为 mouseup 和 click 没有注册在同一个 DOM 上
	         */
	        setTimeout(function () {
	          _this.dragging = false;
	          _this.hideTooltip();
	          if (!_this.isClick) {
	            _this.setPosition(_this.newPosition);
	            _this.$parent.emitChange();
	          }
	        }, 0);
	        window.removeEventListener('mousemove', this.onDragging);
	        window.removeEventListener('touchmove', this.onDragging);
	        window.removeEventListener('mouseup', this.onDragEnd);
	        window.removeEventListener('touchend', this.onDragEnd);
	        window.removeEventListener('contextmenu', this.onDragEnd);
	      }
	    },
	    setPosition: function setPosition(newPosition) {
	      var _this2 = this;
	
	      if (newPosition === null || isNaN(newPosition)) return;
	      if (newPosition < 0) {
	        newPosition = 0;
	      } else if (newPosition > 100) {
	        newPosition = 100;
	      }
	      var lengthPerStep = 100 / ((this.max - this.min) / this.step);
	      var steps = Math.round(newPosition / lengthPerStep);
	      var value = steps * lengthPerStep * (this.max - this.min) * 0.01 + this.min;
	      value = parseFloat(value.toFixed(this.precision));
	      this.$emit('input', value);
	      this.$nextTick(function () {
	        _this2.displayTooltip();
	        _this2.$refs.tooltip && _this2.$refs.tooltip.updatePopper();
	      });
	      if (!this.dragging && this.value !== this.oldValue) {
	        this.oldValue = this.value;
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/slider/src/button.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_slider_src_buttonvue_type_script_lang_js_ = (slider_src_buttonvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/slider/src/button.vue
	
	
	
	
	
	/* normalize component */
	
	var src_button_component = normalizeComponent(
	  packages_slider_src_buttonvue_type_script_lang_js_,
	  buttonvue_type_template_id_e72d2ad2_render,
	  buttonvue_type_template_id_e72d2ad2_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var src_button_api; }
	src_button_component.options.__file = "packages/slider/src/button.vue"
	/* harmony default export */ var slider_src_button = (src_button_component.exports);
	// CONCATENATED MODULE: ./packages/slider/src/marker.js
	/* harmony default export */ var marker = ({
	  name: 'ElMarker',
	
	  props: {
	    mark: {
	      type: [String, Object]
	    }
	  },
	  render: function render() {
	    var h = arguments[0];
	
	    var label = typeof this.mark === 'string' ? this.mark : this.mark.label;
	
	    return h(
	      'div',
	      { 'class': 'el-slider__marks-text', style: this.mark.style || {} },
	      [label]
	    );
	  }
	});
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/slider/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	/* harmony default export */ var slider_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElSlider',
	
	  mixins: [emitter_default.a],
	
	  inject: {
	    elForm: {
	      default: ''
	    }
	  },
	
	  props: {
	    min: {
	      type: Number,
	      default: 0
	    },
	    max: {
	      type: Number,
	      default: 100
	    },
	    step: {
	      type: Number,
	      default: 1
	    },
	    value: {
	      type: [Number, Array],
	      default: 0
	    },
	    showInput: {
	      type: Boolean,
	      default: false
	    },
	    showInputControls: {
	      type: Boolean,
	      default: true
	    },
	    inputSize: {
	      type: String,
	      default: 'small'
	    },
	    showStops: {
	      type: Boolean,
	      default: false
	    },
	    showTooltip: {
	      type: Boolean,
	      default: true
	    },
	    formatTooltip: Function,
	    disabled: {
	      type: Boolean,
	      default: false
	    },
	    range: {
	      type: Boolean,
	      default: false
	    },
	    vertical: {
	      type: Boolean,
	      default: false
	    },
	    height: {
	      type: String
	    },
	    debounce: {
	      type: Number,
	      default: 300
	    },
	    label: {
	      type: String
	    },
	    tooltipClass: String,
	    marks: Object
	  },
	
	  components: {
	    ElInputNumber: input_number_default.a,
	    SliderButton: slider_src_button,
	    SliderMarker: marker
	  },
	
	  data: function data() {
	    return {
	      firstValue: null,
	      secondValue: null,
	      oldValue: null,
	      dragging: false,
	      sliderSize: 1
	    };
	  },
	
	
	  watch: {
	    value: function value(val, oldVal) {
	      if (this.dragging || Array.isArray(val) && Array.isArray(oldVal) && val.every(function (item, index) {
	        return item === oldVal[index];
	      })) {
	        return;
	      }
	      this.setValues();
	    },
	    dragging: function dragging(val) {
	      if (!val) {
	        this.setValues();
	      }
	    },
	    firstValue: function firstValue(val) {
	      if (this.range) {
	        this.$emit('input', [this.minValue, this.maxValue]);
	      } else {
	        this.$emit('input', val);
	      }
	    },
	    secondValue: function secondValue() {
	      if (this.range) {
	        this.$emit('input', [this.minValue, this.maxValue]);
	      }
	    },
	    min: function min() {
	      this.setValues();
	    },
	    max: function max() {
	      this.setValues();
	    }
	  },
	
	  methods: {
	    valueChanged: function valueChanged() {
	      var _this = this;
	
	      if (this.range) {
	        return ![this.minValue, this.maxValue].every(function (item, index) {
	          return item === _this.oldValue[index];
	        });
	      } else {
	        return this.value !== this.oldValue;
	      }
	    },
	    setValues: function setValues() {
	      if (this.min > this.max) {
	        console.error('[Element Error][Slider]min should not be greater than max.');
	        return;
	      }
	      var val = this.value;
	      if (this.range && Array.isArray(val)) {
	        if (val[1] < this.min) {
	          this.$emit('input', [this.min, this.min]);
	        } else if (val[0] > this.max) {
	          this.$emit('input', [this.max, this.max]);
	        } else if (val[0] < this.min) {
	          this.$emit('input', [this.min, val[1]]);
	        } else if (val[1] > this.max) {
	          this.$emit('input', [val[0], this.max]);
	        } else {
	          this.firstValue = val[0];
	          this.secondValue = val[1];
	          if (this.valueChanged()) {
	            this.dispatch('ElFormItem', 'el.form.change', [this.minValue, this.maxValue]);
	            this.oldValue = val.slice();
	          }
	        }
	      } else if (!this.range && typeof val === 'number' && !isNaN(val)) {
	        if (val < this.min) {
	          this.$emit('input', this.min);
	        } else if (val > this.max) {
	          this.$emit('input', this.max);
	        } else {
	          this.firstValue = val;
	          if (this.valueChanged()) {
	            this.dispatch('ElFormItem', 'el.form.change', val);
	            this.oldValue = val;
	          }
	        }
	      }
	    },
	    setPosition: function setPosition(percent) {
	      var targetValue = this.min + percent * (this.max - this.min) / 100;
	      if (!this.range) {
	        this.$refs.button1.setPosition(percent);
	        return;
	      }
	      var button = void 0;
	      if (Math.abs(this.minValue - targetValue) < Math.abs(this.maxValue - targetValue)) {
	        button = this.firstValue < this.secondValue ? 'button1' : 'button2';
	      } else {
	        button = this.firstValue > this.secondValue ? 'button1' : 'button2';
	      }
	      this.$refs[button].setPosition(percent);
	    },
	    onSliderClick: function onSliderClick(event) {
	      if (this.sliderDisabled || this.dragging) return;
	      this.resetSize();
	      if (this.vertical) {
	        var sliderOffsetBottom = this.$refs.slider.getBoundingClientRect().bottom;
	        this.setPosition((sliderOffsetBottom - event.clientY) / this.sliderSize * 100);
	      } else {
	        var sliderOffsetLeft = this.$refs.slider.getBoundingClientRect().left;
	        this.setPosition((event.clientX - sliderOffsetLeft) / this.sliderSize * 100);
	      }
	      this.emitChange();
	    },
	    resetSize: function resetSize() {
	      if (this.$refs.slider) {
	        this.sliderSize = this.$refs.slider['client' + (this.vertical ? 'Height' : 'Width')];
	      }
	    },
	    emitChange: function emitChange() {
	      var _this2 = this;
	
	      this.$nextTick(function () {
	        _this2.$emit('change', _this2.range ? [_this2.minValue, _this2.maxValue] : _this2.value);
	      });
	    },
	    getStopStyle: function getStopStyle(position) {
	      return this.vertical ? { 'bottom': position + '%' } : { 'left': position + '%' };
	    }
	  },
	
	  computed: {
	    stops: function stops() {
	      var _this3 = this;
	
	      if (!this.showStops || this.min > this.max) return [];
	      if (this.step === 0) {
	         false && false;
	        return [];
	      }
	      var stopCount = (this.max - this.min) / this.step;
	      var stepWidth = 100 * this.step / (this.max - this.min);
	      var result = [];
	      for (var i = 1; i < stopCount; i++) {
	        result.push(i * stepWidth);
	      }
	      if (this.range) {
	        return result.filter(function (step) {
	          return step < 100 * (_this3.minValue - _this3.min) / (_this3.max - _this3.min) || step > 100 * (_this3.maxValue - _this3.min) / (_this3.max - _this3.min);
	        });
	      } else {
	        return result.filter(function (step) {
	          return step > 100 * (_this3.firstValue - _this3.min) / (_this3.max - _this3.min);
	        });
	      }
	    },
	    markList: function markList() {
	      var _this4 = this;
	
	      if (!this.marks) {
	        return [];
	      }
	
	      var marksKeys = Object.keys(this.marks);
	      return marksKeys.map(parseFloat).sort(function (a, b) {
	        return a - b;
	      }).filter(function (point) {
	        return point <= _this4.max && point >= _this4.min;
	      }).map(function (point) {
	        return {
	          point: point,
	          position: (point - _this4.min) * 100 / (_this4.max - _this4.min),
	          mark: _this4.marks[point]
	        };
	      });
	    },
	    minValue: function minValue() {
	      return Math.min(this.firstValue, this.secondValue);
	    },
	    maxValue: function maxValue() {
	      return Math.max(this.firstValue, this.secondValue);
	    },
	    barSize: function barSize() {
	      return this.range ? 100 * (this.maxValue - this.minValue) / (this.max - this.min) + '%' : 100 * (this.firstValue - this.min) / (this.max - this.min) + '%';
	    },
	    barStart: function barStart() {
	      return this.range ? 100 * (this.minValue - this.min) / (this.max - this.min) + '%' : '0%';
	    },
	    precision: function precision() {
	      var precisions = [this.min, this.max, this.step].map(function (item) {
	        var decimal = ('' + item).split('.')[1];
	        return decimal ? decimal.length : 0;
	      });
	      return Math.max.apply(null, precisions);
	    },
	    runwayStyle: function runwayStyle() {
	      return this.vertical ? { height: this.height } : {};
	    },
	    barStyle: function barStyle() {
	      return this.vertical ? {
	        height: this.barSize,
	        bottom: this.barStart
	      } : {
	        width: this.barSize,
	        left: this.barStart
	      };
	    },
	    sliderDisabled: function sliderDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    }
	  },
	
	  mounted: function mounted() {
	    var valuetext = void 0;
	    if (this.range) {
	      if (Array.isArray(this.value)) {
	        this.firstValue = Math.max(this.min, this.value[0]);
	        this.secondValue = Math.min(this.max, this.value[1]);
	      } else {
	        this.firstValue = this.min;
	        this.secondValue = this.max;
	      }
	      this.oldValue = [this.firstValue, this.secondValue];
	      valuetext = this.firstValue + '-' + this.secondValue;
	    } else {
	      if (typeof this.value !== 'number' || isNaN(this.value)) {
	        this.firstValue = this.min;
	      } else {
	        this.firstValue = Math.min(this.max, Math.max(this.min, this.value));
	      }
	      this.oldValue = this.firstValue;
	      valuetext = this.firstValue;
	    }
	    this.$el.setAttribute('aria-valuetext', valuetext);
	
	    // label screen reader
	    this.$el.setAttribute('aria-label', this.label ? this.label : 'slider between ' + this.min + ' and ' + this.max);
	
	    this.resetSize();
	    window.addEventListener('resize', this.resetSize);
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('resize', this.resetSize);
	  }
	});
	// CONCATENATED MODULE: ./packages/slider/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_slider_src_mainvue_type_script_lang_js_ = (slider_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/slider/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var slider_src_main_component = normalizeComponent(
	  packages_slider_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_32708644_render,
	  mainvue_type_template_id_32708644_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var slider_src_main_api; }
	slider_src_main_component.options.__file = "packages/slider/src/main.vue"
	/* harmony default export */ var slider_src_main = (slider_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/slider/index.js
	
	
	/* istanbul ignore next */
	slider_src_main.install = function (Vue) {
	  Vue.component(slider_src_main.name, slider_src_main);
	};
	
	/* harmony default export */ var slider = (slider_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/loading/src/loading.vue?vue&type=template&id=eee0a7ac&
	var loadingvue_type_template_id_eee0a7ac_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    {
	      attrs: { name: "el-loading-fade" },
	      on: { "after-leave": _vm.handleAfterLeave }
	    },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.visible,
	              expression: "visible"
	            }
	          ],
	          staticClass: "el-loading-mask",
	          class: [_vm.customClass, { "is-fullscreen": _vm.fullscreen }],
	          style: { backgroundColor: _vm.background || "" }
	        },
	        [
	          _c("div", { staticClass: "el-loading-spinner" }, [
	            !_vm.spinner
	              ? _c(
	                  "svg",
	                  {
	                    staticClass: "circular",
	                    attrs: { viewBox: "25 25 50 50" }
	                  },
	                  [
	                    _c("circle", {
	                      staticClass: "path",
	                      attrs: { cx: "50", cy: "50", r: "20", fill: "none" }
	                    })
	                  ]
	                )
	              : _c("i", { class: _vm.spinner }),
	            _vm.text
	              ? _c("p", { staticClass: "el-loading-text" }, [
	                  _vm._v(_vm._s(_vm.text))
	                ])
	              : _vm._e()
	          ])
	        ]
	      )
	    ]
	  )
	}
	var loadingvue_type_template_id_eee0a7ac_staticRenderFns = []
	loadingvue_type_template_id_eee0a7ac_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/loading/src/loading.vue?vue&type=template&id=eee0a7ac&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/loading/src/loading.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var loadingvue_type_script_lang_js_ = ({
	  data: function data() {
	    return {
	      text: null,
	      spinner: null,
	      background: null,
	      fullscreen: true,
	      visible: false,
	      customClass: ''
	    };
	  },
	
	
	  methods: {
	    handleAfterLeave: function handleAfterLeave() {
	      this.$emit('after-leave');
	    },
	    setText: function setText(text) {
	      this.text = text;
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/loading/src/loading.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_loadingvue_type_script_lang_js_ = (loadingvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/loading/src/loading.vue
	
	
	
	
	
	/* normalize component */
	
	var loading_component = normalizeComponent(
	  src_loadingvue_type_script_lang_js_,
	  loadingvue_type_template_id_eee0a7ac_render,
	  loadingvue_type_template_id_eee0a7ac_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var loading_api; }
	loading_component.options.__file = "packages/loading/src/loading.vue"
	/* harmony default export */ var loading = (loading_component.exports);
	// EXTERNAL MODULE: external "element-ui/lib/utils/after-leave"
	var after_leave_ = __webpack_require__(32);
	var after_leave_default = /*#__PURE__*/__webpack_require__.n(after_leave_);
	
	// CONCATENATED MODULE: ./packages/loading/src/directive.js
	
	
	
	
	
	var Mask = external_vue_default.a.extend(loading);
	
	var loadingDirective = {};
	loadingDirective.install = function (Vue) {
	  if (Vue.prototype.$isServer) return;
	  var toggleLoading = function toggleLoading(el, binding) {
	    if (binding.value) {
	      Vue.nextTick(function () {
	        if (binding.modifiers.fullscreen) {
	          el.originalPosition = Object(dom_["getStyle"])(document.body, 'position');
	          el.originalOverflow = Object(dom_["getStyle"])(document.body, 'overflow');
	          el.maskStyle.zIndex = popup_["PopupManager"].nextZIndex();
	
	          Object(dom_["addClass"])(el.mask, 'is-fullscreen');
	          insertDom(document.body, el, binding);
	        } else {
	          Object(dom_["removeClass"])(el.mask, 'is-fullscreen');
	
	          if (binding.modifiers.body) {
	            el.originalPosition = Object(dom_["getStyle"])(document.body, 'position');
	
	            ['top', 'left'].forEach(function (property) {
	              var scroll = property === 'top' ? 'scrollTop' : 'scrollLeft';
	              el.maskStyle[property] = el.getBoundingClientRect()[property] + document.body[scroll] + document.documentElement[scroll] - parseInt(Object(dom_["getStyle"])(document.body, 'margin-' + property), 10) + 'px';
	            });
	            ['height', 'width'].forEach(function (property) {
	              el.maskStyle[property] = el.getBoundingClientRect()[property] + 'px';
	            });
	
	            insertDom(document.body, el, binding);
	          } else {
	            el.originalPosition = Object(dom_["getStyle"])(el, 'position');
	            insertDom(el, el, binding);
	          }
	        }
	      });
	    } else {
	      after_leave_default()(el.instance, function (_) {
	        if (!el.instance.hiding) return;
	        el.domVisible = false;
	        var target = binding.modifiers.fullscreen || binding.modifiers.body ? document.body : el;
	        Object(dom_["removeClass"])(target, 'el-loading-parent--relative');
	        Object(dom_["removeClass"])(target, 'el-loading-parent--hidden');
	        el.instance.hiding = false;
	      }, 300, true);
	      el.instance.visible = false;
	      el.instance.hiding = true;
	    }
	  };
	  var insertDom = function insertDom(parent, el, binding) {
	    if (!el.domVisible && Object(dom_["getStyle"])(el, 'display') !== 'none' && Object(dom_["getStyle"])(el, 'visibility') !== 'hidden') {
	      Object.keys(el.maskStyle).forEach(function (property) {
	        el.mask.style[property] = el.maskStyle[property];
	      });
	
	      if (el.originalPosition !== 'absolute' && el.originalPosition !== 'fixed') {
	        Object(dom_["addClass"])(parent, 'el-loading-parent--relative');
	      }
	      if (binding.modifiers.fullscreen && binding.modifiers.lock) {
	        Object(dom_["addClass"])(parent, 'el-loading-parent--hidden');
	      }
	      el.domVisible = true;
	
	      parent.appendChild(el.mask);
	      Vue.nextTick(function () {
	        if (el.instance.hiding) {
	          el.instance.$emit('after-leave');
	        } else {
	          el.instance.visible = true;
	        }
	      });
	      el.domInserted = true;
	    } else if (el.domVisible && el.instance.hiding === true) {
	      el.instance.visible = true;
	      el.instance.hiding = false;
	    }
	  };
	
	  Vue.directive('loading', {
	    bind: function bind(el, binding, vnode) {
	      var textExr = el.getAttribute('element-loading-text');
	      var spinnerExr = el.getAttribute('element-loading-spinner');
	      var backgroundExr = el.getAttribute('element-loading-background');
	      var customClassExr = el.getAttribute('element-loading-custom-class');
	      var vm = vnode.context;
	      var mask = new Mask({
	        el: document.createElement('div'),
	        data: {
	          text: vm && vm[textExr] || textExr,
	          spinner: vm && vm[spinnerExr] || spinnerExr,
	          background: vm && vm[backgroundExr] || backgroundExr,
	          customClass: vm && vm[customClassExr] || customClassExr,
	          fullscreen: !!binding.modifiers.fullscreen
	        }
	      });
	      el.instance = mask;
	      el.mask = mask.$el;
	      el.maskStyle = {};
	
	      binding.value && toggleLoading(el, binding);
	    },
	
	    update: function update(el, binding) {
	      el.instance.setText(el.getAttribute('element-loading-text'));
	      if (binding.oldValue !== binding.value) {
	        toggleLoading(el, binding);
	      }
	    },
	
	    unbind: function unbind(el, binding) {
	      if (el.domInserted) {
	        el.mask && el.mask.parentNode && el.mask.parentNode.removeChild(el.mask);
	        toggleLoading(el, { value: false, modifiers: binding.modifiers });
	      }
	      el.instance && el.instance.$destroy();
	    }
	  });
	};
	
	/* harmony default export */ var src_directive = (loadingDirective);
	// CONCATENATED MODULE: ./packages/loading/src/index.js
	
	
	
	
	
	
	
	var LoadingConstructor = external_vue_default.a.extend(loading);
	
	var src_defaults = {
	  text: null,
	  fullscreen: true,
	  body: false,
	  lock: false,
	  customClass: ''
	};
	
	var fullscreenLoading = void 0;
	
	LoadingConstructor.prototype.originalPosition = '';
	LoadingConstructor.prototype.originalOverflow = '';
	
	LoadingConstructor.prototype.close = function () {
	  var _this = this;
	
	  if (this.fullscreen) {
	    fullscreenLoading = undefined;
	  }
	  after_leave_default()(this, function (_) {
	    var target = _this.fullscreen || _this.body ? document.body : _this.target;
	    Object(dom_["removeClass"])(target, 'el-loading-parent--relative');
	    Object(dom_["removeClass"])(target, 'el-loading-parent--hidden');
	    if (_this.$el && _this.$el.parentNode) {
	      _this.$el.parentNode.removeChild(_this.$el);
	    }
	    _this.$destroy();
	  }, 300);
	  this.visible = false;
	};
	
	var src_addStyle = function addStyle(options, parent, instance) {
	  var maskStyle = {};
	  if (options.fullscreen) {
	    instance.originalPosition = Object(dom_["getStyle"])(document.body, 'position');
	    instance.originalOverflow = Object(dom_["getStyle"])(document.body, 'overflow');
	    maskStyle.zIndex = popup_["PopupManager"].nextZIndex();
	  } else if (options.body) {
	    instance.originalPosition = Object(dom_["getStyle"])(document.body, 'position');
	    ['top', 'left'].forEach(function (property) {
	      var scroll = property === 'top' ? 'scrollTop' : 'scrollLeft';
	      maskStyle[property] = options.target.getBoundingClientRect()[property] + document.body[scroll] + document.documentElement[scroll] + 'px';
	    });
	    ['height', 'width'].forEach(function (property) {
	      maskStyle[property] = options.target.getBoundingClientRect()[property] + 'px';
	    });
	  } else {
	    instance.originalPosition = Object(dom_["getStyle"])(parent, 'position');
	  }
	  Object.keys(maskStyle).forEach(function (property) {
	    instance.$el.style[property] = maskStyle[property];
	  });
	};
	
	var src_Loading = function Loading() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (external_vue_default.a.prototype.$isServer) return;
	  options = merge_default()({}, src_defaults, options);
	  if (typeof options.target === 'string') {
	    options.target = document.querySelector(options.target);
	  }
	  options.target = options.target || document.body;
	  if (options.target !== document.body) {
	    options.fullscreen = false;
	  } else {
	    options.body = true;
	  }
	  if (options.fullscreen && fullscreenLoading) {
	    return fullscreenLoading;
	  }
	
	  var parent = options.body ? document.body : options.target;
	  var instance = new LoadingConstructor({
	    el: document.createElement('div'),
	    data: options
	  });
	
	  src_addStyle(options, parent, instance);
	  if (instance.originalPosition !== 'absolute' && instance.originalPosition !== 'fixed') {
	    Object(dom_["addClass"])(parent, 'el-loading-parent--relative');
	  }
	  if (options.fullscreen && options.lock) {
	    Object(dom_["addClass"])(parent, 'el-loading-parent--hidden');
	  }
	  parent.appendChild(instance.$el);
	  external_vue_default.a.nextTick(function () {
	    instance.visible = true;
	  });
	  if (options.fullscreen) {
	    fullscreenLoading = instance;
	  }
	  return instance;
	};
	
	/* harmony default export */ var src = (src_Loading);
	// CONCATENATED MODULE: ./packages/loading/index.js
	
	
	
	/* harmony default export */ var packages_loading = ({
	  install: function install(Vue) {
	    Vue.use(src_directive);
	    Vue.prototype.$loading = src;
	  },
	
	  directive: src_directive,
	  service: src
	});
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/icon/src/icon.vue?vue&type=template&id=cb3fe7f4&
	var iconvue_type_template_id_cb3fe7f4_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("i", { class: "el-icon-" + _vm.name })
	}
	var iconvue_type_template_id_cb3fe7f4_staticRenderFns = []
	iconvue_type_template_id_cb3fe7f4_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/icon/src/icon.vue?vue&type=template&id=cb3fe7f4&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/icon/src/icon.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	
	/* harmony default export */ var iconvue_type_script_lang_js_ = ({
	  name: 'ElIcon',
	
	  props: {
	    name: String
	  }
	});
	// CONCATENATED MODULE: ./packages/icon/src/icon.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_iconvue_type_script_lang_js_ = (iconvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/icon/src/icon.vue
	
	
	
	
	
	/* normalize component */
	
	var icon_component = normalizeComponent(
	  src_iconvue_type_script_lang_js_,
	  iconvue_type_template_id_cb3fe7f4_render,
	  iconvue_type_template_id_cb3fe7f4_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var icon_api; }
	icon_component.options.__file = "packages/icon/src/icon.vue"
	/* harmony default export */ var icon = (icon_component.exports);
	// CONCATENATED MODULE: ./packages/icon/index.js
	
	
	/* istanbul ignore next */
	icon.install = function (Vue) {
	  Vue.component(icon.name, icon);
	};
	
	/* harmony default export */ var packages_icon = (icon);
	// CONCATENATED MODULE: ./packages/row/src/row.js
	/* harmony default export */ var src_row = ({
	  name: 'ElRow',
	
	  componentName: 'ElRow',
	
	  props: {
	    tag: {
	      type: String,
	      default: 'div'
	    },
	    gutter: Number,
	    type: String,
	    justify: {
	      type: String,
	      default: 'start'
	    },
	    align: {
	      type: String,
	      default: 'top'
	    }
	  },
	
	  computed: {
	    style: function style() {
	      var ret = {};
	
	      if (this.gutter) {
	        ret.marginLeft = '-' + this.gutter / 2 + 'px';
	        ret.marginRight = ret.marginLeft;
	      }
	
	      return ret;
	    }
	  },
	
	  render: function render(h) {
	    return h(this.tag, {
	      class: ['el-row', this.justify !== 'start' ? 'is-justify-' + this.justify : '', this.align !== 'top' ? 'is-align-' + this.align : '', { 'el-row--flex': this.type === 'flex' }],
	      style: this.style
	    }, this.$slots.default);
	  }
	});
	// CONCATENATED MODULE: ./packages/row/index.js
	
	
	/* istanbul ignore next */
	src_row.install = function (Vue) {
	  Vue.component(src_row.name, src_row);
	};
	
	/* harmony default export */ var packages_row = (src_row);
	// CONCATENATED MODULE: ./packages/col/src/col.js
	var col_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/* harmony default export */ var col = ({
	  name: 'ElCol',
	
	  props: {
	    span: {
	      type: Number,
	      default: 24
	    },
	    tag: {
	      type: String,
	      default: 'div'
	    },
	    offset: Number,
	    pull: Number,
	    push: Number,
	    xs: [Number, Object],
	    sm: [Number, Object],
	    md: [Number, Object],
	    lg: [Number, Object],
	    xl: [Number, Object]
	  },
	
	  computed: {
	    gutter: function gutter() {
	      var parent = this.$parent;
	      while (parent && parent.$options.componentName !== 'ElRow') {
	        parent = parent.$parent;
	      }
	      return parent ? parent.gutter : 0;
	    }
	  },
	  render: function render(h) {
	    var _this = this;
	
	    var classList = [];
	    var style = {};
	
	    if (this.gutter) {
	      style.paddingLeft = this.gutter / 2 + 'px';
	      style.paddingRight = style.paddingLeft;
	    }
	
	    ['span', 'offset', 'pull', 'push'].forEach(function (prop) {
	      if (_this[prop] || _this[prop] === 0) {
	        classList.push(prop !== 'span' ? 'el-col-' + prop + '-' + _this[prop] : 'el-col-' + _this[prop]);
	      }
	    });
	
	    ['xs', 'sm', 'md', 'lg', 'xl'].forEach(function (size) {
	      if (typeof _this[size] === 'number') {
	        classList.push('el-col-' + size + '-' + _this[size]);
	      } else if (col_typeof(_this[size]) === 'object') {
	        var props = _this[size];
	        Object.keys(props).forEach(function (prop) {
	          classList.push(prop !== 'span' ? 'el-col-' + size + '-' + prop + '-' + props[prop] : 'el-col-' + size + '-' + props[prop]);
	        });
	      }
	    });
	
	    return h(this.tag, {
	      class: ['el-col', classList],
	      style: style
	    }, this.$slots.default);
	  }
	});
	// CONCATENATED MODULE: ./packages/col/index.js
	
	
	/* istanbul ignore next */
	col.install = function (Vue) {
	  Vue.component(col.name, col);
	};
	
	/* harmony default export */ var packages_col = (col);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/upload-list.vue?vue&type=template&id=173fedf5&
	var upload_listvue_type_template_id_173fedf5_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition-group",
	    {
	      class: [
	        "el-upload-list",
	        "el-upload-list--" + _vm.listType,
	        { "is-disabled": _vm.disabled }
	      ],
	      attrs: { tag: "ul", name: "el-list" }
	    },
	    _vm._l(_vm.files, function(file) {
	      return _c(
	        "li",
	        {
	          key: file.uid,
	          class: [
	            "el-upload-list__item",
	            "is-" + file.status,
	            _vm.focusing ? "focusing" : ""
	          ],
	          attrs: { tabindex: "0" },
	          on: {
	            keydown: function($event) {
	              if (
	                !("button" in $event) &&
	                _vm._k($event.keyCode, "delete", [8, 46], $event.key, [
	                  "Backspace",
	                  "Delete",
	                  "Del"
	                ])
	              ) {
	                return null
	              }
	              !_vm.disabled && _vm.$emit("remove", file)
	            },
	            focus: function($event) {
	              _vm.focusing = true
	            },
	            blur: function($event) {
	              _vm.focusing = false
	            },
	            click: function($event) {
	              _vm.focusing = false
	            }
	          }
	        },
	        [
	          _vm._t(
	            "default",
	            [
	              file.status !== "uploading" &&
	              ["picture-card", "picture"].indexOf(_vm.listType) > -1
	                ? _c("img", {
	                    staticClass: "el-upload-list__item-thumbnail",
	                    attrs: { src: file.url, alt: "" }
	                  })
	                : _vm._e(),
	              _c(
	                "a",
	                {
	                  staticClass: "el-upload-list__item-name",
	                  on: {
	                    click: function($event) {
	                      _vm.handleClick(file)
	                    }
	                  }
	                },
	                [
	                  _c("i", { staticClass: "el-icon-document" }),
	                  _vm._v(_vm._s(file.name) + "\n      ")
	                ]
	              ),
	              _c(
	                "label",
	                { staticClass: "el-upload-list__item-status-label" },
	                [
	                  _c("i", {
	                    class: {
	                      "el-icon-upload-success": true,
	                      "el-icon-circle-check": _vm.listType === "text",
	                      "el-icon-check":
	                        ["picture-card", "picture"].indexOf(_vm.listType) > -1
	                    }
	                  })
	                ]
	              ),
	              !_vm.disabled
	                ? _c("i", {
	                    staticClass: "el-icon-close",
	                    on: {
	                      click: function($event) {
	                        _vm.$emit("remove", file)
	                      }
	                    }
	                  })
	                : _vm._e(),
	              !_vm.disabled
	                ? _c("i", { staticClass: "el-icon-close-tip" }, [
	                    _vm._v(_vm._s(_vm.t("el.upload.deleteTip")))
	                  ])
	                : _vm._e(),
	              file.status === "uploading"
	                ? _c("el-progress", {
	                    attrs: {
	                      type: _vm.listType === "picture-card" ? "circle" : "line",
	                      "stroke-width": _vm.listType === "picture-card" ? 6 : 2,
	                      percentage: _vm.parsePercentage(file.percentage)
	                    }
	                  })
	                : _vm._e(),
	              _vm.listType === "picture-card"
	                ? _c("span", { staticClass: "el-upload-list__item-actions" }, [
	                    _vm.handlePreview && _vm.listType === "picture-card"
	                      ? _c(
	                          "span",
	                          {
	                            staticClass: "el-upload-list__item-preview",
	                            on: {
	                              click: function($event) {
	                                _vm.handlePreview(file)
	                              }
	                            }
	                          },
	                          [_c("i", { staticClass: "el-icon-zoom-in" })]
	                        )
	                      : _vm._e(),
	                    !_vm.disabled
	                      ? _c(
	                          "span",
	                          {
	                            staticClass: "el-upload-list__item-delete",
	                            on: {
	                              click: function($event) {
	                                _vm.$emit("remove", file)
	                              }
	                            }
	                          },
	                          [_c("i", { staticClass: "el-icon-delete" })]
	                        )
	                      : _vm._e()
	                  ])
	                : _vm._e()
	            ],
	            { file: file }
	          )
	        ],
	        2
	      )
	    }),
	    0
	  )
	}
	var upload_listvue_type_template_id_173fedf5_staticRenderFns = []
	upload_listvue_type_template_id_173fedf5_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/upload/src/upload-list.vue?vue&type=template&id=173fedf5&
	
	// EXTERNAL MODULE: external "element-ui/lib/progress"
	var progress_ = __webpack_require__(33);
	var progress_default = /*#__PURE__*/__webpack_require__.n(progress_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/upload-list.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	/* harmony default export */ var upload_listvue_type_script_lang_js_ = ({
	
	  name: 'ElUploadList',
	
	  mixins: [locale_default.a],
	
	  data: function data() {
	    return {
	      focusing: false
	    };
	  },
	
	  components: { ElProgress: progress_default.a },
	
	  props: {
	    files: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    disabled: {
	      type: Boolean,
	      default: false
	    },
	    handlePreview: Function,
	    listType: String
	  },
	  methods: {
	    parsePercentage: function parsePercentage(val) {
	      return parseInt(val, 10);
	    },
	    handleClick: function handleClick(file) {
	      this.handlePreview && this.handlePreview(file);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/upload/src/upload-list.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_upload_listvue_type_script_lang_js_ = (upload_listvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/upload/src/upload-list.vue
	
	
	
	
	
	/* normalize component */
	
	var upload_list_component = normalizeComponent(
	  src_upload_listvue_type_script_lang_js_,
	  upload_listvue_type_template_id_173fedf5_render,
	  upload_listvue_type_template_id_173fedf5_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var upload_list_api; }
	upload_list_component.options.__file = "packages/upload/src/upload-list.vue"
	/* harmony default export */ var upload_list = (upload_list_component.exports);
	// EXTERNAL MODULE: external "babel-helper-vue-jsx-merge-props"
	var external_babel_helper_vue_jsx_merge_props_ = __webpack_require__(24);
	var external_babel_helper_vue_jsx_merge_props_default = /*#__PURE__*/__webpack_require__.n(external_babel_helper_vue_jsx_merge_props_);
	
	// CONCATENATED MODULE: ./packages/upload/src/ajax.js
	function getError(action, option, xhr) {
	  var msg = void 0;
	  if (xhr.response) {
	    msg = '' + (xhr.response.error || xhr.response);
	  } else if (xhr.responseText) {
	    msg = '' + xhr.responseText;
	  } else {
	    msg = 'fail to post ' + action + ' ' + xhr.status;
	  }
	
	  var err = new Error(msg);
	  err.status = xhr.status;
	  err.method = 'post';
	  err.url = action;
	  return err;
	}
	
	function getBody(xhr) {
	  var text = xhr.responseText || xhr.response;
	  if (!text) {
	    return text;
	  }
	
	  try {
	    return JSON.parse(text);
	  } catch (e) {
	    return text;
	  }
	}
	
	function upload(option) {
	  if (typeof XMLHttpRequest === 'undefined') {
	    return;
	  }
	
	  var xhr = new XMLHttpRequest();
	  var action = option.action;
	
	  if (xhr.upload) {
	    xhr.upload.onprogress = function progress(e) {
	      if (e.total > 0) {
	        e.percent = e.loaded / e.total * 100;
	      }
	      option.onProgress(e);
	    };
	  }
	
	  var formData = new FormData();
	
	  if (option.data) {
	    Object.keys(option.data).forEach(function (key) {
	      formData.append(key, option.data[key]);
	    });
	  }
	
	  formData.append(option.filename, option.file, option.file.name);
	
	  xhr.onerror = function error(e) {
	    option.onError(e);
	  };
	
	  xhr.onload = function onload() {
	    if (xhr.status < 200 || xhr.status >= 300) {
	      return option.onError(getError(action, option, xhr));
	    }
	
	    option.onSuccess(getBody(xhr));
	  };
	
	  xhr.open('post', action, true);
	
	  if (option.withCredentials && 'withCredentials' in xhr) {
	    xhr.withCredentials = true;
	  }
	
	  var headers = option.headers || {};
	
	  for (var item in headers) {
	    if (headers.hasOwnProperty(item) && headers[item] !== null) {
	      xhr.setRequestHeader(item, headers[item]);
	    }
	  }
	  xhr.send(formData);
	  return xhr;
	}
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/upload-dragger.vue?vue&type=template&id=7ebbf219&
	var upload_draggervue_type_template_id_7ebbf219_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-upload-dragger",
	      class: {
	        "is-dragover": _vm.dragover
	      },
	      on: {
	        drop: function($event) {
	          $event.preventDefault()
	          return _vm.onDrop($event)
	        },
	        dragover: function($event) {
	          $event.preventDefault()
	          return _vm.onDragover($event)
	        },
	        dragleave: function($event) {
	          $event.preventDefault()
	          _vm.dragover = false
	        }
	      }
	    },
	    [_vm._t("default")],
	    2
	  )
	}
	var upload_draggervue_type_template_id_7ebbf219_staticRenderFns = []
	upload_draggervue_type_template_id_7ebbf219_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/upload/src/upload-dragger.vue?vue&type=template&id=7ebbf219&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/upload-dragger.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var upload_draggervue_type_script_lang_js_ = ({
	  name: 'ElUploadDrag',
	  props: {
	    disabled: Boolean
	  },
	  inject: {
	    uploader: {
	      default: ''
	    }
	  },
	  data: function data() {
	    return {
	      dragover: false
	    };
	  },
	
	  methods: {
	    onDragover: function onDragover() {
	      if (!this.disabled) {
	        this.dragover = true;
	      }
	    },
	    onDrop: function onDrop(e) {
	      if (this.disabled || !this.uploader) return;
	      var accept = this.uploader.accept;
	      this.dragover = false;
	      if (!accept) {
	        this.$emit('file', e.dataTransfer.files);
	        return;
	      }
	      this.$emit('file', [].slice.call(e.dataTransfer.files).filter(function (file) {
	        var type = file.type,
	            name = file.name;
	
	        var extension = name.indexOf('.') > -1 ? '.' + name.split('.').pop() : '';
	        var baseType = type.replace(/\/.*$/, '');
	        return accept.split(',').map(function (type) {
	          return type.trim();
	        }).filter(function (type) {
	          return type;
	        }).some(function (acceptedType) {
	          if (/\..+$/.test(acceptedType)) {
	            return extension === acceptedType;
	          }
	          if (/\/\*$/.test(acceptedType)) {
	            return baseType === acceptedType.replace(/\/\*$/, '');
	          }
	          if (/^[^\/]+\/[^\/]+$/.test(acceptedType)) {
	            return type === acceptedType;
	          }
	          return false;
	        });
	      }));
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/upload/src/upload-dragger.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_upload_draggervue_type_script_lang_js_ = (upload_draggervue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/upload/src/upload-dragger.vue
	
	
	
	
	
	/* normalize component */
	
	var upload_dragger_component = normalizeComponent(
	  src_upload_draggervue_type_script_lang_js_,
	  upload_draggervue_type_template_id_7ebbf219_render,
	  upload_draggervue_type_template_id_7ebbf219_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var upload_dragger_api; }
	upload_dragger_component.options.__file = "packages/upload/src/upload-dragger.vue"
	/* harmony default export */ var upload_dragger = (upload_dragger_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/upload.vue?vue&type=script&lang=js&
	
	
	
	
	
	/* harmony default export */ var uploadvue_type_script_lang_js_ = ({
	  inject: ['uploader'],
	  components: {
	    UploadDragger: upload_dragger
	  },
	  props: {
	    type: String,
	    action: {
	      type: String,
	      required: true
	    },
	    name: {
	      type: String,
	      default: 'file'
	    },
	    data: Object,
	    headers: Object,
	    withCredentials: Boolean,
	    multiple: Boolean,
	    accept: String,
	    onStart: Function,
	    onProgress: Function,
	    onSuccess: Function,
	    onError: Function,
	    beforeUpload: Function,
	    drag: Boolean,
	    onPreview: {
	      type: Function,
	      default: function _default() {}
	    },
	    onRemove: {
	      type: Function,
	      default: function _default() {}
	    },
	    fileList: Array,
	    autoUpload: Boolean,
	    listType: String,
	    httpRequest: {
	      type: Function,
	      default: upload
	    },
	    disabled: Boolean,
	    limit: Number,
	    onExceed: Function
	  },
	
	  data: function data() {
	    return {
	      mouseover: false,
	      reqs: {}
	    };
	  },
	
	
	  methods: {
	    isImage: function isImage(str) {
	      return str.indexOf('image') !== -1;
	    },
	    handleChange: function handleChange(ev) {
	      var files = ev.target.files;
	
	      if (!files) return;
	      this.uploadFiles(files);
	    },
	    uploadFiles: function uploadFiles(files) {
	      var _this = this;
	
	      if (this.limit && this.fileList.length + files.length > this.limit) {
	        this.onExceed && this.onExceed(files, this.fileList);
	        return;
	      }
	
	      var postFiles = Array.prototype.slice.call(files);
	      if (!this.multiple) {
	        postFiles = postFiles.slice(0, 1);
	      }
	
	      if (postFiles.length === 0) {
	        return;
	      }
	
	      postFiles.forEach(function (rawFile) {
	        _this.onStart(rawFile);
	        if (_this.autoUpload) _this.upload(rawFile);
	      });
	    },
	    upload: function upload(rawFile) {
	      var _this2 = this;
	
	      this.$refs.input.value = null;
	
	      if (!this.beforeUpload) {
	        return this.post(rawFile);
	      }
	
	      var before = this.beforeUpload(rawFile);
	      if (before && before.then) {
	        before.then(function (processedFile) {
	          var fileType = Object.prototype.toString.call(processedFile);
	
	          if (fileType === '[object File]' || fileType === '[object Blob]') {
	            if (fileType === '[object Blob]') {
	              processedFile = new File([processedFile], rawFile.name, {
	                type: rawFile.type
	              });
	            }
	            for (var p in rawFile) {
	              if (rawFile.hasOwnProperty(p)) {
	                processedFile[p] = rawFile[p];
	              }
	            }
	            _this2.post(processedFile);
	          } else {
	            _this2.post(rawFile);
	          }
	        }, function () {
	          _this2.onRemove(null, rawFile);
	        });
	      } else if (before !== false) {
	        this.post(rawFile);
	      } else {
	        this.onRemove(null, rawFile);
	      }
	    },
	    abort: function abort(file) {
	      var reqs = this.reqs;
	
	      if (file) {
	        var uid = file;
	        if (file.uid) uid = file.uid;
	        if (reqs[uid]) {
	          reqs[uid].abort();
	        }
	      } else {
	        Object.keys(reqs).forEach(function (uid) {
	          if (reqs[uid]) reqs[uid].abort();
	          delete reqs[uid];
	        });
	      }
	    },
	    post: function post(rawFile) {
	      var _this3 = this;
	
	      var uid = rawFile.uid;
	
	      var options = {
	        headers: this.headers,
	        withCredentials: this.withCredentials,
	        file: rawFile,
	        data: this.data,
	        filename: this.name,
	        action: this.action,
	        onProgress: function onProgress(e) {
	          _this3.onProgress(e, rawFile);
	        },
	        onSuccess: function onSuccess(res) {
	          _this3.onSuccess(res, rawFile);
	          delete _this3.reqs[uid];
	        },
	        onError: function onError(err) {
	          _this3.onError(err, rawFile);
	          delete _this3.reqs[uid];
	        }
	      };
	      var req = this.httpRequest(options);
	      this.reqs[uid] = req;
	      if (req && req.then) {
	        req.then(options.onSuccess, options.onError);
	      }
	    },
	    handleClick: function handleClick() {
	      if (!this.disabled) {
	        this.$refs.input.value = null;
	        this.$refs.input.click();
	      }
	    },
	    handleKeydown: function handleKeydown(e) {
	      if (e.target !== e.currentTarget) return;
	      if (e.keyCode === 13 || e.keyCode === 32) {
	        this.handleClick();
	      }
	    }
	  },
	
	  render: function render(h) {
	    var handleClick = this.handleClick,
	        drag = this.drag,
	        name = this.name,
	        handleChange = this.handleChange,
	        multiple = this.multiple,
	        accept = this.accept,
	        listType = this.listType,
	        uploadFiles = this.uploadFiles,
	        disabled = this.disabled,
	        handleKeydown = this.handleKeydown;
	
	    var data = {
	      class: {
	        'el-upload': true
	      },
	      on: {
	        click: handleClick,
	        keydown: handleKeydown
	      }
	    };
	    data.class['el-upload--' + listType] = true;
	    return h(
	      'div',
	      external_babel_helper_vue_jsx_merge_props_default()([data, {
	        attrs: { tabindex: '0' }
	      }]),
	      [drag ? h(
	        'upload-dragger',
	        {
	          attrs: { disabled: disabled },
	          on: {
	            'file': uploadFiles
	          }
	        },
	        [this.$slots.default]
	      ) : this.$slots.default, h('input', { 'class': 'el-upload__input', attrs: { type: 'file', name: name, multiple: multiple, accept: accept },
	        ref: 'input', on: {
	          'change': handleChange
	        }
	      })]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/upload/src/upload.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_uploadvue_type_script_lang_js_ = (uploadvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/upload/src/upload.vue
	var upload_render, upload_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var upload_component = normalizeComponent(
	  src_uploadvue_type_script_lang_js_,
	  upload_render,
	  upload_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var upload_api; }
	upload_component.options.__file = "packages/upload/src/upload.vue"
	/* harmony default export */ var src_upload = (upload_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/index.vue?vue&type=script&lang=js&
	
	
	
	
	
	
	function srcvue_type_script_lang_js_noop() {}
	
	/* harmony default export */ var srcvue_type_script_lang_js_ = ({
	  name: 'ElUpload',
	
	  mixins: [migrating_default.a],
	
	  components: {
	    ElProgress: progress_default.a,
	    UploadList: upload_list,
	    Upload: src_upload
	  },
	
	  provide: function provide() {
	    return {
	      uploader: this
	    };
	  },
	
	
	  inject: {
	    elForm: {
	      default: ''
	    }
	  },
	
	  props: {
	    action: {
	      type: String,
	      required: true
	    },
	    headers: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    data: Object,
	    multiple: Boolean,
	    name: {
	      type: String,
	      default: 'file'
	    },
	    drag: Boolean,
	    dragger: Boolean,
	    withCredentials: Boolean,
	    showFileList: {
	      type: Boolean,
	      default: true
	    },
	    accept: String,
	    type: {
	      type: String,
	      default: 'select'
	    },
	    beforeUpload: Function,
	    beforeRemove: Function,
	    onRemove: {
	      type: Function,
	      default: srcvue_type_script_lang_js_noop
	    },
	    onChange: {
	      type: Function,
	      default: srcvue_type_script_lang_js_noop
	    },
	    onPreview: {
	      type: Function
	    },
	    onSuccess: {
	      type: Function,
	      default: srcvue_type_script_lang_js_noop
	    },
	    onProgress: {
	      type: Function,
	      default: srcvue_type_script_lang_js_noop
	    },
	    onError: {
	      type: Function,
	      default: srcvue_type_script_lang_js_noop
	    },
	    fileList: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    autoUpload: {
	      type: Boolean,
	      default: true
	    },
	    listType: {
	      type: String,
	      default: 'text' // text,picture,picture-card
	    },
	    httpRequest: Function,
	    disabled: Boolean,
	    limit: Number,
	    onExceed: {
	      type: Function,
	      default: srcvue_type_script_lang_js_noop
	    }
	  },
	
	  data: function data() {
	    return {
	      uploadFiles: [],
	      dragOver: false,
	      draging: false,
	      tempIndex: 1
	    };
	  },
	
	
	  computed: {
	    uploadDisabled: function uploadDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    }
	  },
	
	  watch: {
	    listType: function listType(type) {
	      if (type === 'picture-card' || type === 'picture') {
	        this.uploadFiles = this.uploadFiles.map(function (file) {
	          if (!file.url && file.raw) {
	            try {
	              file.url = URL.createObjectURL(file.raw);
	            } catch (err) {
	              console.error('[Element Error][Upload]', err);
	            }
	          }
	          return file;
	        });
	      }
	    },
	
	    fileList: {
	      immediate: true,
	      handler: function handler(fileList) {
	        var _this = this;
	
	        this.uploadFiles = fileList.map(function (item) {
	          item.uid = item.uid || Date.now() + _this.tempIndex++;
	          item.status = item.status || 'success';
	          return item;
	        });
	      }
	    }
	  },
	
	  methods: {
	    handleStart: function handleStart(rawFile) {
	      rawFile.uid = Date.now() + this.tempIndex++;
	      var file = {
	        status: 'ready',
	        name: rawFile.name,
	        size: rawFile.size,
	        percentage: 0,
	        uid: rawFile.uid,
	        raw: rawFile
	      };
	
	      if (this.listType === 'picture-card' || this.listType === 'picture') {
	        try {
	          file.url = URL.createObjectURL(rawFile);
	        } catch (err) {
	          console.error('[Element Error][Upload]', err);
	          return;
	        }
	      }
	
	      this.uploadFiles.push(file);
	      this.onChange(file, this.uploadFiles);
	    },
	    handleProgress: function handleProgress(ev, rawFile) {
	      var file = this.getFile(rawFile);
	      this.onProgress(ev, file, this.uploadFiles);
	      file.status = 'uploading';
	      file.percentage = ev.percent || 0;
	    },
	    handleSuccess: function handleSuccess(res, rawFile) {
	      var file = this.getFile(rawFile);
	
	      if (file) {
	        file.status = 'success';
	        file.response = res;
	
	        this.onSuccess(res, file, this.uploadFiles);
	        this.onChange(file, this.uploadFiles);
	      }
	    },
	    handleError: function handleError(err, rawFile) {
	      var file = this.getFile(rawFile);
	      var fileList = this.uploadFiles;
	
	      file.status = 'fail';
	
	      fileList.splice(fileList.indexOf(file), 1);
	
	      this.onError(err, file, this.uploadFiles);
	      this.onChange(file, this.uploadFiles);
	    },
	    handleRemove: function handleRemove(file, raw) {
	      var _this2 = this;
	
	      if (raw) {
	        file = this.getFile(raw);
	      }
	      var doRemove = function doRemove() {
	        _this2.abort(file);
	        var fileList = _this2.uploadFiles;
	        fileList.splice(fileList.indexOf(file), 1);
	        _this2.onRemove(file, fileList);
	      };
	
	      if (!this.beforeRemove) {
	        doRemove();
	      } else if (typeof this.beforeRemove === 'function') {
	        var before = this.beforeRemove(file, this.uploadFiles);
	        if (before && before.then) {
	          before.then(function () {
	            doRemove();
	          }, srcvue_type_script_lang_js_noop);
	        } else if (before !== false) {
	          doRemove();
	        }
	      }
	    },
	    getFile: function getFile(rawFile) {
	      var fileList = this.uploadFiles;
	      var target = void 0;
	      fileList.every(function (item) {
	        target = rawFile.uid === item.uid ? item : null;
	        return !target;
	      });
	      return target;
	    },
	    abort: function abort(file) {
	      this.$refs['upload-inner'].abort(file);
	    },
	    clearFiles: function clearFiles() {
	      this.uploadFiles = [];
	    },
	    submit: function submit() {
	      var _this3 = this;
	
	      this.uploadFiles.filter(function (file) {
	        return file.status === 'ready';
	      }).forEach(function (file) {
	        _this3.$refs['upload-inner'].upload(file.raw);
	      });
	    },
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'default-file-list': 'default-file-list is renamed to file-list.',
	          'show-upload-list': 'show-upload-list is renamed to show-file-list.',
	          'thumbnail-mode': 'thumbnail-mode has been deprecated, you can implement the same effect according to this case: http://element.eleme.io/#/zh-CN/component/upload#yong-hu-tou-xiang-shang-chuan'
	        }
	      };
	    }
	  },
	
	  beforeDestroy: function beforeDestroy() {
	    this.uploadFiles.forEach(function (file) {
	      if (file.url && file.url.indexOf('blob:') === 0) {
	        URL.revokeObjectURL(file.url);
	      }
	    });
	  },
	  render: function render(h) {
	    var _this4 = this;
	
	    var uploadList = void 0;
	
	    if (this.showFileList) {
	      uploadList = h(
	        upload_list,
	        {
	          attrs: {
	            disabled: this.uploadDisabled,
	            listType: this.listType,
	            files: this.uploadFiles,
	
	            handlePreview: this.onPreview },
	          on: {
	            'remove': this.handleRemove
	          }
	        },
	        [function (props) {
	          if (_this4.$scopedSlots.file) {
	            return _this4.$scopedSlots.file({
	              file: props.file
	            });
	          }
	        }]
	      );
	    }
	
	    var uploadData = {
	      props: {
	        type: this.type,
	        drag: this.drag,
	        action: this.action,
	        multiple: this.multiple,
	        'before-upload': this.beforeUpload,
	        'with-credentials': this.withCredentials,
	        headers: this.headers,
	        name: this.name,
	        data: this.data,
	        accept: this.accept,
	        fileList: this.uploadFiles,
	        autoUpload: this.autoUpload,
	        listType: this.listType,
	        disabled: this.uploadDisabled,
	        limit: this.limit,
	        'on-exceed': this.onExceed,
	        'on-start': this.handleStart,
	        'on-progress': this.handleProgress,
	        'on-success': this.handleSuccess,
	        'on-error': this.handleError,
	        'on-preview': this.onPreview,
	        'on-remove': this.handleRemove,
	        'http-request': this.httpRequest
	      },
	      ref: 'upload-inner'
	    };
	
	    var trigger = this.$slots.trigger || this.$slots.default;
	    var uploadComponent = h(
	      'upload',
	      uploadData,
	      [trigger]
	    );
	
	    return h('div', [this.listType === 'picture-card' ? uploadList : '', this.$slots.trigger ? [uploadComponent, this.$slots.default] : uploadComponent, this.$slots.tip, this.listType !== 'picture-card' ? uploadList : '']);
	  }
	});
	// CONCATENATED MODULE: ./packages/upload/src/index.vue?vue&type=script&lang=js&
	 /* harmony default export */ var upload_srcvue_type_script_lang_js_ = (srcvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/upload/src/index.vue
	var src_render, src_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var upload_src_component = normalizeComponent(
	  upload_srcvue_type_script_lang_js_,
	  src_render,
	  src_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var src_api; }
	upload_src_component.options.__file = "packages/upload/src/index.vue"
	/* harmony default export */ var upload_src = (upload_src_component.exports);
	// CONCATENATED MODULE: ./packages/upload/index.js
	
	
	/* istanbul ignore next */
	upload_src.install = function (Vue) {
	  Vue.component(upload_src.name, upload_src);
	};
	
	/* harmony default export */ var packages_upload = (upload_src);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/progress/src/progress.vue?vue&type=template&id=229ee406&
	var progressvue_type_template_id_229ee406_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-progress",
	      class: [
	        "el-progress--" + _vm.type,
	        _vm.status ? "is-" + _vm.status : "",
	        {
	          "el-progress--without-text": !_vm.showText,
	          "el-progress--text-inside": _vm.textInside
	        }
	      ],
	      attrs: {
	        role: "progressbar",
	        "aria-valuenow": _vm.percentage,
	        "aria-valuemin": "0",
	        "aria-valuemax": "100"
	      }
	    },
	    [
	      _vm.type === "line"
	        ? _c("div", { staticClass: "el-progress-bar" }, [
	            _c(
	              "div",
	              {
	                staticClass: "el-progress-bar__outer",
	                style: { height: _vm.strokeWidth + "px" }
	              },
	              [
	                _c(
	                  "div",
	                  {
	                    staticClass: "el-progress-bar__inner",
	                    style: _vm.barStyle
	                  },
	                  [
	                    _vm.showText && _vm.textInside
	                      ? _c(
	                          "div",
	                          { staticClass: "el-progress-bar__innerText" },
	                          [_vm._v(_vm._s(_vm.content))]
	                        )
	                      : _vm._e()
	                  ]
	                )
	              ]
	            )
	          ])
	        : _c(
	            "div",
	            {
	              staticClass: "el-progress-circle",
	              style: { height: _vm.width + "px", width: _vm.width + "px" }
	            },
	            [
	              _c("svg", { attrs: { viewBox: "0 0 100 100" } }, [
	                _c("path", {
	                  staticClass: "el-progress-circle__track",
	                  style: _vm.trailPathStyle,
	                  attrs: {
	                    d: _vm.trackPath,
	                    stroke: "#e5e9f2",
	                    "stroke-width": _vm.relativeStrokeWidth,
	                    fill: "none"
	                  }
	                }),
	                _c("path", {
	                  staticClass: "el-progress-circle__path",
	                  style: _vm.circlePathStyle,
	                  attrs: {
	                    d: _vm.trackPath,
	                    stroke: _vm.stroke,
	                    fill: "none",
	                    "stroke-linecap": _vm.strokeLinecap,
	                    "stroke-width": _vm.percentage ? _vm.relativeStrokeWidth : 0
	                  }
	                })
	              ])
	            ]
	          ),
	      _vm.showText && !_vm.textInside
	        ? _c(
	            "div",
	            {
	              staticClass: "el-progress__text",
	              style: { fontSize: _vm.progressTextSize + "px" }
	            },
	            [
	              !_vm.status
	                ? [_vm._v(_vm._s(_vm.content))]
	                : _c("i", { class: _vm.iconClass })
	            ],
	            2
	          )
	        : _vm._e()
	    ]
	  )
	}
	var progressvue_type_template_id_229ee406_staticRenderFns = []
	progressvue_type_template_id_229ee406_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/progress/src/progress.vue?vue&type=template&id=229ee406&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/progress/src/progress.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var progressvue_type_script_lang_js_ = ({
	  name: 'ElProgress',
	  props: {
	    type: {
	      type: String,
	      default: 'line',
	      validator: function validator(val) {
	        return ['line', 'circle', 'dashboard'].indexOf(val) > -1;
	      }
	    },
	    percentage: {
	      type: Number,
	      default: 0,
	      required: true,
	      validator: function validator(val) {
	        return val >= 0 && val <= 100;
	      }
	    },
	    status: {
	      type: String,
	      validator: function validator(val) {
	        return ['success', 'exception', 'warning'].indexOf(val) > -1;
	      }
	    },
	    strokeWidth: {
	      type: Number,
	      default: 6
	    },
	    strokeLinecap: {
	      type: String,
	      default: 'round'
	    },
	    textInside: {
	      type: Boolean,
	      default: false
	    },
	    width: {
	      type: Number,
	      default: 126
	    },
	    showText: {
	      type: Boolean,
	      default: true
	    },
	    color: {
	      type: [String, Array, Function],
	      default: ''
	    },
	    format: Function
	  },
	  computed: {
	    barStyle: function barStyle() {
	      var style = {};
	      style.width = this.percentage + '%';
	      style.backgroundColor = this.getCurrentColor(this.percentage);
	      return style;
	    },
	    relativeStrokeWidth: function relativeStrokeWidth() {
	      return (this.strokeWidth / this.width * 100).toFixed(1);
	    },
	    radius: function radius() {
	      if (this.type === 'circle' || this.type === 'dashboard') {
	        return parseInt(50 - parseFloat(this.relativeStrokeWidth) / 2, 10);
	      } else {
	        return 0;
	      }
	    },
	    trackPath: function trackPath() {
	      var radius = this.radius;
	      var isDashboard = this.type === 'dashboard';
	      return '\n        M 50 50\n        m 0 ' + (isDashboard ? '' : '-') + radius + '\n        a ' + radius + ' ' + radius + ' 0 1 1 0 ' + (isDashboard ? '-' : '') + radius * 2 + '\n        a ' + radius + ' ' + radius + ' 0 1 1 0 ' + (isDashboard ? '' : '-') + radius * 2 + '\n        ';
	    },
	    perimeter: function perimeter() {
	      return 2 * Math.PI * this.radius;
	    },
	    rate: function rate() {
	      return this.type === 'dashboard' ? 0.75 : 1;
	    },
	    strokeDashoffset: function strokeDashoffset() {
	      var offset = -1 * this.perimeter * (1 - this.rate) / 2;
	      return offset + 'px';
	    },
	    trailPathStyle: function trailPathStyle() {
	      return {
	        strokeDasharray: this.perimeter * this.rate + 'px, ' + this.perimeter + 'px',
	        strokeDashoffset: this.strokeDashoffset
	      };
	    },
	    circlePathStyle: function circlePathStyle() {
	      return {
	        strokeDasharray: this.perimeter * this.rate * (this.percentage / 100) + 'px, ' + this.perimeter + 'px',
	        strokeDashoffset: this.strokeDashoffset,
	        transition: 'stroke-dasharray 0.6s ease 0s, stroke 0.6s ease'
	      };
	    },
	    stroke: function stroke() {
	      var ret = void 0;
	      if (this.color) {
	        ret = this.getCurrentColor(this.percentage);
	      } else {
	        switch (this.status) {
	          case 'success':
	            ret = '#13ce66';
	            break;
	          case 'exception':
	            ret = '#ff4949';
	            break;
	          case 'warning':
	            ret = '#e6a23c';
	            break;
	          default:
	            ret = '#20a0ff';
	        }
	      }
	      return ret;
	    },
	    iconClass: function iconClass() {
	      if (this.status === 'warning') {
	        return 'el-icon-warning';
	      }
	      if (this.type === 'line') {
	        return this.status === 'success' ? 'el-icon-circle-check' : 'el-icon-circle-close';
	      } else {
	        return this.status === 'success' ? 'el-icon-check' : 'el-icon-close';
	      }
	    },
	    progressTextSize: function progressTextSize() {
	      return this.type === 'line' ? 12 + this.strokeWidth * 0.4 : this.width * 0.111111 + 2;
	    },
	    content: function content() {
	      if (typeof this.format === 'function') {
	        return this.format(this.percentage) || '';
	      } else {
	        return this.percentage + '%';
	      }
	    }
	  },
	  methods: {
	    getCurrentColor: function getCurrentColor(percentage) {
	      if (typeof this.color === 'function') {
	        return this.color(percentage);
	      } else if (typeof this.color === 'string') {
	        return this.color;
	      } else {
	        return this.getLevelColor(percentage);
	      }
	    },
	    getLevelColor: function getLevelColor(percentage) {
	      var colorArray = this.getColorArray().sort(function (a, b) {
	        return a.percentage - b.percentage;
	      });
	
	      for (var i = 0; i < colorArray.length; i++) {
	        if (colorArray[i].percentage > percentage) {
	          return colorArray[i].color;
	        }
	      }
	      return colorArray[colorArray.length - 1].color;
	    },
	    getColorArray: function getColorArray() {
	      var color = this.color;
	      var span = 100 / color.length;
	      return color.map(function (seriesColor, index) {
	        if (typeof seriesColor === 'string') {
	          return {
	            color: seriesColor,
	            percentage: (index + 1) * span
	          };
	        }
	        return seriesColor;
	      });
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/progress/src/progress.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_progressvue_type_script_lang_js_ = (progressvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/progress/src/progress.vue
	
	
	
	
	
	/* normalize component */
	
	var progress_component = normalizeComponent(
	  src_progressvue_type_script_lang_js_,
	  progressvue_type_template_id_229ee406_render,
	  progressvue_type_template_id_229ee406_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var progress_api; }
	progress_component.options.__file = "packages/progress/src/progress.vue"
	/* harmony default export */ var progress = (progress_component.exports);
	// CONCATENATED MODULE: ./packages/progress/index.js
	
	
	/* istanbul ignore next */
	progress.install = function (Vue) {
	  Vue.component(progress.name, progress);
	};
	
	/* harmony default export */ var packages_progress = (progress);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/spinner/src/spinner.vue?vue&type=template&id=697b8538&
	var spinnervue_type_template_id_697b8538_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("span", { staticClass: "el-spinner" }, [
	    _c(
	      "svg",
	      {
	        staticClass: "el-spinner-inner",
	        style: { width: _vm.radius / 2 + "px", height: _vm.radius / 2 + "px" },
	        attrs: { viewBox: "0 0 50 50" }
	      },
	      [
	        _c("circle", {
	          staticClass: "path",
	          attrs: {
	            cx: "25",
	            cy: "25",
	            r: "20",
	            fill: "none",
	            stroke: _vm.strokeColor,
	            "stroke-width": _vm.strokeWidth
	          }
	        })
	      ]
	    )
	  ])
	}
	var spinnervue_type_template_id_697b8538_staticRenderFns = []
	spinnervue_type_template_id_697b8538_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/spinner/src/spinner.vue?vue&type=template&id=697b8538&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/spinner/src/spinner.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var spinnervue_type_script_lang_js_ = ({
	  name: 'ElSpinner',
	  props: {
	    type: String,
	    radius: {
	      type: Number,
	      default: 100
	    },
	    strokeWidth: {
	      type: Number,
	      default: 5
	    },
	    strokeColor: {
	      type: String,
	      default: '#efefef'
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/spinner/src/spinner.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_spinnervue_type_script_lang_js_ = (spinnervue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/spinner/src/spinner.vue
	
	
	
	
	
	/* normalize component */
	
	var spinner_component = normalizeComponent(
	  src_spinnervue_type_script_lang_js_,
	  spinnervue_type_template_id_697b8538_render,
	  spinnervue_type_template_id_697b8538_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var spinner_api; }
	spinner_component.options.__file = "packages/spinner/src/spinner.vue"
	/* harmony default export */ var spinner = (spinner_component.exports);
	// CONCATENATED MODULE: ./packages/spinner/index.js
	
	
	/* istanbul ignore next */
	spinner.install = function (Vue) {
	  Vue.component(spinner.name, spinner);
	};
	
	/* harmony default export */ var packages_spinner = (spinner);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/message/src/main.vue?vue&type=template&id=455b9f60&
	var mainvue_type_template_id_455b9f60_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    {
	      attrs: { name: "el-message-fade" },
	      on: { "after-leave": _vm.handleAfterLeave }
	    },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.visible,
	              expression: "visible"
	            }
	          ],
	          class: [
	            "el-message",
	            _vm.type && !_vm.iconClass ? "el-message--" + _vm.type : "",
	            _vm.center ? "is-center" : "",
	            _vm.showClose ? "is-closable" : "",
	            _vm.customClass
	          ],
	          style: _vm.positionStyle,
	          attrs: { role: "alert" },
	          on: { mouseenter: _vm.clearTimer, mouseleave: _vm.startTimer }
	        },
	        [
	          _vm.iconClass
	            ? _c("i", { class: _vm.iconClass })
	            : _c("i", { class: _vm.typeClass }),
	          _vm._t("default", [
	            !_vm.dangerouslyUseHTMLString
	              ? _c("p", { staticClass: "el-message__content" }, [
	                  _vm._v(_vm._s(_vm.message))
	                ])
	              : _c("p", {
	                  staticClass: "el-message__content",
	                  domProps: { innerHTML: _vm._s(_vm.message) }
	                })
	          ]),
	          _vm.showClose
	            ? _c("i", {
	                staticClass: "el-message__closeBtn el-icon-close",
	                on: { click: _vm.close }
	              })
	            : _vm._e()
	        ],
	        2
	      )
	    ]
	  )
	}
	var mainvue_type_template_id_455b9f60_staticRenderFns = []
	mainvue_type_template_id_455b9f60_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/message/src/main.vue?vue&type=template&id=455b9f60&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/message/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	var src_mainvue_type_script_lang_js_typeMap = {
	  success: 'success',
	  info: 'info',
	  warning: 'warning',
	  error: 'error'
	};
	
	/* harmony default export */ var message_src_mainvue_type_script_lang_js_ = ({
	  data: function data() {
	    return {
	      visible: false,
	      message: '',
	      duration: 3000,
	      type: 'info',
	      iconClass: '',
	      customClass: '',
	      onClose: null,
	      showClose: false,
	      closed: false,
	      verticalOffset: 20,
	      timer: null,
	      dangerouslyUseHTMLString: false,
	      center: false
	    };
	  },
	
	
	  computed: {
	    typeClass: function typeClass() {
	      return this.type && !this.iconClass ? 'el-message__icon el-icon-' + src_mainvue_type_script_lang_js_typeMap[this.type] : '';
	    },
	    positionStyle: function positionStyle() {
	      return {
	        'top': this.verticalOffset + 'px'
	      };
	    }
	  },
	
	  watch: {
	    closed: function closed(newVal) {
	      if (newVal) {
	        this.visible = false;
	      }
	    }
	  },
	
	  methods: {
	    handleAfterLeave: function handleAfterLeave() {
	      this.$destroy(true);
	      this.$el.parentNode.removeChild(this.$el);
	    },
	    close: function close() {
	      this.closed = true;
	      if (typeof this.onClose === 'function') {
	        this.onClose(this);
	      }
	    },
	    clearTimer: function clearTimer() {
	      clearTimeout(this.timer);
	    },
	    startTimer: function startTimer() {
	      var _this = this;
	
	      if (this.duration > 0) {
	        this.timer = setTimeout(function () {
	          if (!_this.closed) {
	            _this.close();
	          }
	        }, this.duration);
	      }
	    },
	    keydown: function keydown(e) {
	      if (e.keyCode === 27) {
	        // esc关闭消息
	        if (!this.closed) {
	          this.close();
	        }
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.startTimer();
	    document.addEventListener('keydown', this.keydown);
	  },
	  beforeDestroy: function beforeDestroy() {
	    document.removeEventListener('keydown', this.keydown);
	  }
	});
	// CONCATENATED MODULE: ./packages/message/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_message_src_mainvue_type_script_lang_js_ = (message_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/message/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var message_src_main_component = normalizeComponent(
	  packages_message_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_455b9f60_render,
	  mainvue_type_template_id_455b9f60_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var message_src_main_api; }
	message_src_main_component.options.__file = "packages/message/src/main.vue"
	/* harmony default export */ var message_src_main = (message_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/message/src/main.js
	
	
	
	
	var MessageConstructor = external_vue_default.a.extend(message_src_main);
	
	var message_src_main_instance = void 0;
	var main_instances = [];
	var main_seed = 1;
	
	var main_Message = function Message(options) {
	  if (external_vue_default.a.prototype.$isServer) return;
	  options = options || {};
	  if (typeof options === 'string') {
	    options = {
	      message: options
	    };
	  }
	  var userOnClose = options.onClose;
	  var id = 'message_' + main_seed++;
	
	  options.onClose = function () {
	    Message.close(id, userOnClose);
	  };
	  message_src_main_instance = new MessageConstructor({
	    data: options
	  });
	  message_src_main_instance.id = id;
	  if (Object(vdom_["isVNode"])(message_src_main_instance.message)) {
	    message_src_main_instance.$slots.default = [message_src_main_instance.message];
	    message_src_main_instance.message = null;
	  }
	  message_src_main_instance.$mount();
	  document.body.appendChild(message_src_main_instance.$el);
	  var verticalOffset = options.offset || 20;
	  main_instances.forEach(function (item) {
	    verticalOffset += item.$el.offsetHeight + 16;
	  });
	  message_src_main_instance.verticalOffset = verticalOffset;
	  message_src_main_instance.visible = true;
	  message_src_main_instance.$el.style.zIndex = popup_["PopupManager"].nextZIndex();
	  main_instances.push(message_src_main_instance);
	  return message_src_main_instance;
	};
	
	['success', 'warning', 'info', 'error'].forEach(function (type) {
	  main_Message[type] = function (options) {
	    if (typeof options === 'string') {
	      options = {
	        message: options
	      };
	    }
	    options.type = type;
	    return main_Message(options);
	  };
	});
	
	main_Message.close = function (id, userOnClose) {
	  var len = main_instances.length;
	  var index = -1;
	  var removedHeight = void 0;
	  for (var i = 0; i < len; i++) {
	    if (id === main_instances[i].id) {
	      removedHeight = main_instances[i].$el.offsetHeight;
	      index = i;
	      if (typeof userOnClose === 'function') {
	        userOnClose(main_instances[i]);
	      }
	      main_instances.splice(i, 1);
	      break;
	    }
	  }
	  if (len <= 1 || index === -1 || index > main_instances.length - 1) return;
	  for (var _i = index; _i < len - 1; _i++) {
	    var dom = main_instances[_i].$el;
	    dom.style['top'] = parseInt(dom.style['top'], 10) - removedHeight - 16 + 'px';
	  }
	};
	
	main_Message.closeAll = function () {
	  for (var i = main_instances.length - 1; i >= 0; i--) {
	    main_instances[i].close();
	  }
	};
	
	/* harmony default export */ var packages_message_src_main = (main_Message);
	// CONCATENATED MODULE: ./packages/message/index.js
	
	/* harmony default export */ var packages_message = (packages_message_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/badge/src/main.vue?vue&type=template&id=7ccb6598&
	var mainvue_type_template_id_7ccb6598_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    { staticClass: "el-badge" },
	    [
	      _vm._t("default"),
	      _c("transition", { attrs: { name: "el-zoom-in-center" } }, [
	        _c("sup", {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value:
	                !_vm.hidden && (_vm.content || _vm.content === 0 || _vm.isDot),
	              expression: "!hidden && (content || content === 0 || isDot)"
	            }
	          ],
	          staticClass: "el-badge__content",
	          class: [
	            "el-badge__content--" + _vm.type,
	            {
	              "is-fixed": _vm.$slots.default,
	              "is-dot": _vm.isDot
	            }
	          ],
	          domProps: { textContent: _vm._s(_vm.content) }
	        })
	      ])
	    ],
	    2
	  )
	}
	var mainvue_type_template_id_7ccb6598_staticRenderFns = []
	mainvue_type_template_id_7ccb6598_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/badge/src/main.vue?vue&type=template&id=7ccb6598&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/badge/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var badge_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElBadge',
	
	  props: {
	    value: [String, Number],
	    max: Number,
	    isDot: Boolean,
	    hidden: Boolean,
	    type: {
	      type: String,
	      validator: function validator(val) {
	        return ['primary', 'success', 'warning', 'info', 'danger'].indexOf(val) > -1;
	      }
	    }
	  },
	
	  computed: {
	    content: function content() {
	      if (this.isDot) return;
	
	      var value = this.value;
	      var max = this.max;
	
	      if (typeof value === 'number' && typeof max === 'number') {
	        return max < value ? max + '+' : value;
	      }
	
	      return value;
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/badge/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_badge_src_mainvue_type_script_lang_js_ = (badge_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/badge/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var badge_src_main_component = normalizeComponent(
	  packages_badge_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_7ccb6598_render,
	  mainvue_type_template_id_7ccb6598_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var badge_src_main_api; }
	badge_src_main_component.options.__file = "packages/badge/src/main.vue"
	/* harmony default export */ var badge_src_main = (badge_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/badge/index.js
	
	
	/* istanbul ignore next */
	badge_src_main.install = function (Vue) {
	  Vue.component(badge_src_main.name, badge_src_main);
	};
	
	/* harmony default export */ var badge = (badge_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/card/src/main.vue?vue&type=template&id=59a4a40f&
	var mainvue_type_template_id_59a4a40f_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-card",
	      class: _vm.shadow ? "is-" + _vm.shadow + "-shadow" : "is-always-shadow"
	    },
	    [
	      _vm.$slots.header || _vm.header
	        ? _c(
	            "div",
	            { staticClass: "el-card__header" },
	            [_vm._t("header", [_vm._v(_vm._s(_vm.header))])],
	            2
	          )
	        : _vm._e(),
	      _c(
	        "div",
	        { staticClass: "el-card__body", style: _vm.bodyStyle },
	        [_vm._t("default")],
	        2
	      )
	    ]
	  )
	}
	var mainvue_type_template_id_59a4a40f_staticRenderFns = []
	mainvue_type_template_id_59a4a40f_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/card/src/main.vue?vue&type=template&id=59a4a40f&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/card/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var card_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElCard',
	  props: {
	    header: {},
	    bodyStyle: {},
	    shadow: {
	      type: String
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/card/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_card_src_mainvue_type_script_lang_js_ = (card_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/card/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var card_src_main_component = normalizeComponent(
	  packages_card_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_59a4a40f_render,
	  mainvue_type_template_id_59a4a40f_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var card_src_main_api; }
	card_src_main_component.options.__file = "packages/card/src/main.vue"
	/* harmony default export */ var card_src_main = (card_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/card/index.js
	
	
	/* istanbul ignore next */
	card_src_main.install = function (Vue) {
	  Vue.component(card_src_main.name, card_src_main);
	};
	
	/* harmony default export */ var card = (card_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/rate/src/main.vue?vue&type=template&id=ada57782&
	var mainvue_type_template_id_ada57782_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-rate",
	      attrs: {
	        role: "slider",
	        "aria-valuenow": _vm.currentValue,
	        "aria-valuetext": _vm.text,
	        "aria-valuemin": "0",
	        "aria-valuemax": _vm.max,
	        tabindex: "0"
	      },
	      on: { keydown: _vm.handleKey }
	    },
	    [
	      _vm._l(_vm.max, function(item, key) {
	        return _c(
	          "span",
	          {
	            key: key,
	            staticClass: "el-rate__item",
	            style: { cursor: _vm.rateDisabled ? "auto" : "pointer" },
	            on: {
	              mousemove: function($event) {
	                _vm.setCurrentValue(item, $event)
	              },
	              mouseleave: _vm.resetCurrentValue,
	              click: function($event) {
	                _vm.selectValue(item)
	              }
	            }
	          },
	          [
	            _c(
	              "i",
	              {
	                staticClass: "el-rate__icon",
	                class: [
	                  _vm.classes[item - 1],
	                  { hover: _vm.hoverIndex === item }
	                ],
	                style: _vm.getIconStyle(item)
	              },
	              [
	                _vm.showDecimalIcon(item)
	                  ? _c("i", {
	                      staticClass: "el-rate__decimal",
	                      class: _vm.decimalIconClass,
	                      style: _vm.decimalStyle
	                    })
	                  : _vm._e()
	              ]
	            )
	          ]
	        )
	      }),
	      _vm.showText || _vm.showScore
	        ? _c(
	            "span",
	            { staticClass: "el-rate__text", style: { color: _vm.textColor } },
	            [_vm._v(_vm._s(_vm.text))]
	          )
	        : _vm._e()
	    ],
	    2
	  )
	}
	var mainvue_type_template_id_ada57782_staticRenderFns = []
	mainvue_type_template_id_ada57782_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/rate/src/main.vue?vue&type=template&id=ada57782&
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/types"
	var types_ = __webpack_require__(18);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/rate/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var rate_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElRate',
	
	  mixins: [migrating_default.a],
	
	  inject: {
	    elForm: {
	      default: ''
	    }
	  },
	
	  data: function data() {
	    return {
	      pointerAtLeftHalf: true,
	      currentValue: this.value,
	      hoverIndex: -1
	    };
	  },
	
	
	  props: {
	    value: {
	      type: Number,
	      default: 0
	    },
	    lowThreshold: {
	      type: Number,
	      default: 2
	    },
	    highThreshold: {
	      type: Number,
	      default: 4
	    },
	    max: {
	      type: Number,
	      default: 5
	    },
	    colors: {
	      type: [Array, Object],
	      default: function _default() {
	        return ['#F7BA2A', '#F7BA2A', '#F7BA2A'];
	      }
	    },
	    voidColor: {
	      type: String,
	      default: '#C6D1DE'
	    },
	    disabledVoidColor: {
	      type: String,
	      default: '#EFF2F7'
	    },
	    iconClasses: {
	      type: [Array, Object],
	      default: function _default() {
	        return ['el-icon-star-on', 'el-icon-star-on', 'el-icon-star-on'];
	      }
	    },
	    voidIconClass: {
	      type: String,
	      default: 'el-icon-star-off'
	    },
	    disabledVoidIconClass: {
	      type: String,
	      default: 'el-icon-star-on'
	    },
	    disabled: {
	      type: Boolean,
	      default: false
	    },
	    allowHalf: {
	      type: Boolean,
	      default: false
	    },
	    showText: {
	      type: Boolean,
	      default: false
	    },
	    showScore: {
	      type: Boolean,
	      default: false
	    },
	    textColor: {
	      type: String,
	      default: '#1f2d3d'
	    },
	    texts: {
	      type: Array,
	      default: function _default() {
	        return ['极差', '失望', '一般', '满意', '惊喜'];
	      }
	    },
	    scoreTemplate: {
	      type: String,
	      default: '{value}'
	    }
	  },
	
	  computed: {
	    text: function text() {
	      var result = '';
	      if (this.showScore) {
	        result = this.scoreTemplate.replace(/\{\s*value\s*\}/, this.rateDisabled ? this.value : this.currentValue);
	      } else if (this.showText) {
	        result = this.texts[Math.ceil(this.currentValue) - 1];
	      }
	      return result;
	    },
	    decimalStyle: function decimalStyle() {
	      var width = '';
	      if (this.rateDisabled) {
	        width = this.valueDecimal + '%';
	      } else if (this.allowHalf) {
	        width = '50%';
	      }
	      return {
	        color: this.activeColor,
	        width: width
	      };
	    },
	    valueDecimal: function valueDecimal() {
	      return this.value * 100 - Math.floor(this.value) * 100;
	    },
	    classMap: function classMap() {
	      var _ref;
	
	      return Array.isArray(this.iconClasses) ? (_ref = {}, _ref[this.lowThreshold] = this.iconClasses[0], _ref[this.highThreshold] = { value: this.iconClasses[1], excluded: true }, _ref[this.max] = this.iconClasses[2], _ref) : this.iconClasses;
	    },
	    decimalIconClass: function decimalIconClass() {
	      return this.getValueFromMap(this.value, this.classMap);
	    },
	    voidClass: function voidClass() {
	      return this.rateDisabled ? this.disabledVoidIconClass : this.voidIconClass;
	    },
	    activeClass: function activeClass() {
	      return this.getValueFromMap(this.currentValue, this.classMap);
	    },
	    colorMap: function colorMap() {
	      var _ref2;
	
	      return Array.isArray(this.colors) ? (_ref2 = {}, _ref2[this.lowThreshold] = this.colors[0], _ref2[this.highThreshold] = { value: this.colors[1], excluded: true }, _ref2[this.max] = this.colors[2], _ref2) : this.colors;
	    },
	    activeColor: function activeColor() {
	      return this.getValueFromMap(this.currentValue, this.colorMap);
	    },
	    classes: function classes() {
	      var result = [];
	      var i = 0;
	      var threshold = this.currentValue;
	      if (this.allowHalf && this.currentValue !== Math.floor(this.currentValue)) {
	        threshold--;
	      }
	      for (; i < threshold; i++) {
	        result.push(this.activeClass);
	      }
	      for (; i < this.max; i++) {
	        result.push(this.voidClass);
	      }
	      return result;
	    },
	    rateDisabled: function rateDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    }
	  },
	
	  watch: {
	    value: function value(val) {
	      this.currentValue = val;
	      this.pointerAtLeftHalf = this.value !== Math.floor(this.value);
	    }
	  },
	
	  methods: {
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'text-template': 'text-template is renamed to score-template.'
	        }
	      };
	    },
	    getValueFromMap: function getValueFromMap(value, map) {
	      var matchedKeys = Object.keys(map).filter(function (key) {
	        var val = map[key];
	        var excluded = Object(types_["isObject"])(val) ? val.excluded : false;
	        return excluded ? value < key : value <= key;
	      }).sort(function (a, b) {
	        return a - b;
	      });
	      var matchedValue = map[matchedKeys[0]];
	      return Object(types_["isObject"])(matchedValue) ? matchedValue.value : matchedValue || '';
	    },
	    showDecimalIcon: function showDecimalIcon(item) {
	      var showWhenDisabled = this.rateDisabled && this.valueDecimal > 0 && item - 1 < this.value && item > this.value;
	      /* istanbul ignore next */
	      var showWhenAllowHalf = this.allowHalf && this.pointerAtLeftHalf && item - 0.5 <= this.currentValue && item > this.currentValue;
	      return showWhenDisabled || showWhenAllowHalf;
	    },
	    getIconStyle: function getIconStyle(item) {
	      var voidColor = this.rateDisabled ? this.disabledVoidColor : this.voidColor;
	      return {
	        color: item <= this.currentValue ? this.activeColor : voidColor
	      };
	    },
	    selectValue: function selectValue(value) {
	      if (this.rateDisabled) {
	        return;
	      }
	      if (this.allowHalf && this.pointerAtLeftHalf) {
	        this.$emit('input', this.currentValue);
	        this.$emit('change', this.currentValue);
	      } else {
	        this.$emit('input', value);
	        this.$emit('change', value);
	      }
	    },
	    handleKey: function handleKey(e) {
	      if (this.rateDisabled) {
	        return;
	      }
	      var currentValue = this.currentValue;
	      var keyCode = e.keyCode;
	      if (keyCode === 38 || keyCode === 39) {
	        // left / down
	        if (this.allowHalf) {
	          currentValue += 0.5;
	        } else {
	          currentValue += 1;
	        }
	        e.stopPropagation();
	        e.preventDefault();
	      } else if (keyCode === 37 || keyCode === 40) {
	        if (this.allowHalf) {
	          currentValue -= 0.5;
	        } else {
	          currentValue -= 1;
	        }
	        e.stopPropagation();
	        e.preventDefault();
	      }
	      currentValue = currentValue < 0 ? 0 : currentValue;
	      currentValue = currentValue > this.max ? this.max : currentValue;
	
	      this.$emit('input', currentValue);
	      this.$emit('change', currentValue);
	    },
	    setCurrentValue: function setCurrentValue(value, event) {
	      if (this.rateDisabled) {
	        return;
	      }
	      /* istanbul ignore if */
	      if (this.allowHalf) {
	        var target = event.target;
	        if (Object(dom_["hasClass"])(target, 'el-rate__item')) {
	          target = target.querySelector('.el-rate__icon');
	        }
	        if (Object(dom_["hasClass"])(target, 'el-rate__decimal')) {
	          target = target.parentNode;
	        }
	        this.pointerAtLeftHalf = event.offsetX * 2 <= target.clientWidth;
	        this.currentValue = this.pointerAtLeftHalf ? value - 0.5 : value;
	      } else {
	        this.currentValue = value;
	      }
	      this.hoverIndex = value;
	    },
	    resetCurrentValue: function resetCurrentValue() {
	      if (this.rateDisabled) {
	        return;
	      }
	      if (this.allowHalf) {
	        this.pointerAtLeftHalf = this.value !== Math.floor(this.value);
	      }
	      this.currentValue = this.value;
	      this.hoverIndex = -1;
	    }
	  },
	
	  created: function created() {
	    if (!this.value) {
	      this.$emit('input', 0);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/rate/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_rate_src_mainvue_type_script_lang_js_ = (rate_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/rate/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var rate_src_main_component = normalizeComponent(
	  packages_rate_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_ada57782_render,
	  mainvue_type_template_id_ada57782_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var rate_src_main_api; }
	rate_src_main_component.options.__file = "packages/rate/src/main.vue"
	/* harmony default export */ var rate_src_main = (rate_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/rate/index.js
	
	
	/* istanbul ignore next */
	rate_src_main.install = function (Vue) {
	  Vue.component(rate_src_main.name, rate_src_main);
	};
	
	/* harmony default export */ var rate = (rate_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/steps/src/steps.vue?vue&type=template&id=3c6b6dc0&
	var stepsvue_type_template_id_3c6b6dc0_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-steps",
	      class: [
	        !_vm.simple && "el-steps--" + _vm.direction,
	        _vm.simple && "el-steps--simple"
	      ]
	    },
	    [_vm._t("default")],
	    2
	  )
	}
	var stepsvue_type_template_id_3c6b6dc0_staticRenderFns = []
	stepsvue_type_template_id_3c6b6dc0_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/steps/src/steps.vue?vue&type=template&id=3c6b6dc0&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/steps/src/steps.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var stepsvue_type_script_lang_js_ = ({
	  name: 'ElSteps',
	
	  mixins: [migrating_default.a],
	
	  props: {
	    space: [Number, String],
	    active: Number,
	    direction: {
	      type: String,
	      default: 'horizontal'
	    },
	    alignCenter: Boolean,
	    simple: Boolean,
	    finishStatus: {
	      type: String,
	      default: 'finish'
	    },
	    processStatus: {
	      type: String,
	      default: 'process'
	    }
	  },
	
	  data: function data() {
	    return {
	      steps: [],
	      stepOffset: 0
	    };
	  },
	
	
	  methods: {
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'center': 'center is removed.'
	        }
	      };
	    }
	  },
	
	  watch: {
	    active: function active(newVal, oldVal) {
	      this.$emit('change', newVal, oldVal);
	    },
	    steps: function steps(_steps) {
	      _steps.forEach(function (child, index) {
	        child.index = index;
	      });
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/steps/src/steps.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_stepsvue_type_script_lang_js_ = (stepsvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/steps/src/steps.vue
	
	
	
	
	
	/* normalize component */
	
	var steps_component = normalizeComponent(
	  src_stepsvue_type_script_lang_js_,
	  stepsvue_type_template_id_3c6b6dc0_render,
	  stepsvue_type_template_id_3c6b6dc0_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var steps_api; }
	steps_component.options.__file = "packages/steps/src/steps.vue"
	/* harmony default export */ var steps = (steps_component.exports);
	// CONCATENATED MODULE: ./packages/steps/index.js
	
	
	/* istanbul ignore next */
	steps.install = function (Vue) {
	  Vue.component(steps.name, steps);
	};
	
	/* harmony default export */ var packages_steps = (steps);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/steps/src/step.vue?vue&type=template&id=f414a87a&
	var stepvue_type_template_id_f414a87a_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-step",
	      class: [
	        !_vm.isSimple && "is-" + _vm.$parent.direction,
	        _vm.isSimple && "is-simple",
	        _vm.isLast && !_vm.space && !_vm.isCenter && "is-flex",
	        _vm.isCenter && !_vm.isVertical && !_vm.isSimple && "is-center"
	      ],
	      style: _vm.style
	    },
	    [
	      _c(
	        "div",
	        { staticClass: "el-step__head", class: "is-" + _vm.currentStatus },
	        [
	          _c(
	            "div",
	            {
	              staticClass: "el-step__line",
	              style: _vm.isLast
	                ? ""
	                : { marginRight: _vm.$parent.stepOffset + "px" }
	            },
	            [
	              _c("i", {
	                staticClass: "el-step__line-inner",
	                style: _vm.lineStyle
	              })
	            ]
	          ),
	          _c(
	            "div",
	            {
	              staticClass: "el-step__icon",
	              class: "is-" + (_vm.icon ? "icon" : "text")
	            },
	            [
	              _vm.currentStatus !== "success" && _vm.currentStatus !== "error"
	                ? _vm._t("icon", [
	                    _vm.icon
	                      ? _c("i", {
	                          staticClass: "el-step__icon-inner",
	                          class: [_vm.icon]
	                        })
	                      : _vm._e(),
	                    !_vm.icon && !_vm.isSimple
	                      ? _c("div", { staticClass: "el-step__icon-inner" }, [
	                          _vm._v(_vm._s(_vm.index + 1))
	                        ])
	                      : _vm._e()
	                  ])
	                : _c("i", {
	                    staticClass: "el-step__icon-inner is-status",
	                    class: [
	                      "el-icon-" +
	                        (_vm.currentStatus === "success" ? "check" : "close")
	                    ]
	                  })
	            ],
	            2
	          )
	        ]
	      ),
	      _c("div", { staticClass: "el-step__main" }, [
	        _c(
	          "div",
	          {
	            ref: "title",
	            staticClass: "el-step__title",
	            class: ["is-" + _vm.currentStatus]
	          },
	          [_vm._t("title", [_vm._v(_vm._s(_vm.title))])],
	          2
	        ),
	        _vm.isSimple
	          ? _c("div", { staticClass: "el-step__arrow" })
	          : _c(
	              "div",
	              {
	                staticClass: "el-step__description",
	                class: ["is-" + _vm.currentStatus]
	              },
	              [_vm._t("description", [_vm._v(_vm._s(_vm.description))])],
	              2
	            )
	      ])
	    ]
	  )
	}
	var stepvue_type_template_id_f414a87a_staticRenderFns = []
	stepvue_type_template_id_f414a87a_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/steps/src/step.vue?vue&type=template&id=f414a87a&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/steps/src/step.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var stepvue_type_script_lang_js_ = ({
	  name: 'ElStep',
	
	  props: {
	    title: String,
	    icon: String,
	    description: String,
	    status: String
	  },
	
	  data: function data() {
	    return {
	      index: -1,
	      lineStyle: {},
	      internalStatus: ''
	    };
	  },
	  beforeCreate: function beforeCreate() {
	    this.$parent.steps.push(this);
	  },
	  beforeDestroy: function beforeDestroy() {
	    var steps = this.$parent.steps;
	    var index = steps.indexOf(this);
	    if (index >= 0) {
	      steps.splice(index, 1);
	    }
	  },
	
	
	  computed: {
	    currentStatus: function currentStatus() {
	      return this.status || this.internalStatus;
	    },
	    prevStatus: function prevStatus() {
	      var prevStep = this.$parent.steps[this.index - 1];
	      return prevStep ? prevStep.currentStatus : 'wait';
	    },
	    isCenter: function isCenter() {
	      return this.$parent.alignCenter;
	    },
	    isVertical: function isVertical() {
	      return this.$parent.direction === 'vertical';
	    },
	    isSimple: function isSimple() {
	      return this.$parent.simple;
	    },
	    isLast: function isLast() {
	      var parent = this.$parent;
	      return parent.steps[parent.steps.length - 1] === this;
	    },
	    stepsCount: function stepsCount() {
	      return this.$parent.steps.length;
	    },
	    space: function space() {
	      var isSimple = this.isSimple,
	          space = this.$parent.space;
	
	      return isSimple ? '' : space;
	    },
	
	    style: function style() {
	      var style = {};
	      var parent = this.$parent;
	      var len = parent.steps.length;
	
	      var space = typeof this.space === 'number' ? this.space + 'px' : this.space ? this.space : 100 / (len - (this.isCenter ? 0 : 1)) + '%';
	      style.flexBasis = space;
	      if (this.isVertical) return style;
	      if (this.isLast) {
	        style.maxWidth = 100 / this.stepsCount + '%';
	      } else {
	        style.marginRight = -this.$parent.stepOffset + 'px';
	      }
	
	      return style;
	    }
	  },
	
	  methods: {
	    updateStatus: function updateStatus(val) {
	      var prevChild = this.$parent.$children[this.index - 1];
	
	      if (val > this.index) {
	        this.internalStatus = this.$parent.finishStatus;
	      } else if (val === this.index && this.prevStatus !== 'error') {
	        this.internalStatus = this.$parent.processStatus;
	      } else {
	        this.internalStatus = 'wait';
	      }
	
	      if (prevChild) prevChild.calcProgress(this.internalStatus);
	    },
	    calcProgress: function calcProgress(status) {
	      var step = 100;
	      var style = {};
	
	      style.transitionDelay = 150 * this.index + 'ms';
	      if (status === this.$parent.processStatus) {
	        step = this.currentStatus !== 'error' ? 0 : 0;
	      } else if (status === 'wait') {
	        step = 0;
	        style.transitionDelay = -150 * this.index + 'ms';
	      }
	
	      style.borderWidth = step && !this.isSimple ? '1px' : 0;
	      this.$parent.direction === 'vertical' ? style.height = step + '%' : style.width = step + '%';
	
	      this.lineStyle = style;
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    var unwatch = this.$watch('index', function (val) {
	      _this.$watch('$parent.active', _this.updateStatus, { immediate: true });
	      _this.$watch('$parent.processStatus', function () {
	        var activeIndex = _this.$parent.active;
	        _this.updateStatus(activeIndex);
	      }, { immediate: true });
	      unwatch();
	    });
	  }
	});
	// CONCATENATED MODULE: ./packages/steps/src/step.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_stepvue_type_script_lang_js_ = (stepvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/steps/src/step.vue
	
	
	
	
	
	/* normalize component */
	
	var step_component = normalizeComponent(
	  src_stepvue_type_script_lang_js_,
	  stepvue_type_template_id_f414a87a_render,
	  stepvue_type_template_id_f414a87a_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var step_api; }
	step_component.options.__file = "packages/steps/src/step.vue"
	/* harmony default export */ var step = (step_component.exports);
	// CONCATENATED MODULE: ./packages/step/index.js
	
	
	/* istanbul ignore next */
	step.install = function (Vue) {
	  Vue.component(step.name, step);
	};
	
	/* harmony default export */ var packages_step = (step);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/carousel/src/main.vue?vue&type=template&id=5d5d1482&
	var mainvue_type_template_id_5d5d1482_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      class: _vm.carouselClasses,
	      on: {
	        mouseenter: function($event) {
	          $event.stopPropagation()
	          return _vm.handleMouseEnter($event)
	        },
	        mouseleave: function($event) {
	          $event.stopPropagation()
	          return _vm.handleMouseLeave($event)
	        }
	      }
	    },
	    [
	      _c(
	        "div",
	        {
	          staticClass: "el-carousel__container",
	          style: { height: _vm.height }
	        },
	        [
	          _vm.arrowDisplay
	            ? _c("transition", { attrs: { name: "carousel-arrow-left" } }, [
	                _c(
	                  "button",
	                  {
	                    directives: [
	                      {
	                        name: "show",
	                        rawName: "v-show",
	                        value:
	                          (_vm.arrow === "always" || _vm.hover) &&
	                          (_vm.loop || _vm.activeIndex > 0),
	                        expression:
	                          "(arrow === 'always' || hover) && (loop || activeIndex > 0)"
	                      }
	                    ],
	                    staticClass: "el-carousel__arrow el-carousel__arrow--left",
	                    attrs: { type: "button" },
	                    on: {
	                      mouseenter: function($event) {
	                        _vm.handleButtonEnter("left")
	                      },
	                      mouseleave: _vm.handleButtonLeave,
	                      click: function($event) {
	                        $event.stopPropagation()
	                        _vm.throttledArrowClick(_vm.activeIndex - 1)
	                      }
	                    }
	                  },
	                  [_c("i", { staticClass: "el-icon-arrow-left" })]
	                )
	              ])
	            : _vm._e(),
	          _vm.arrowDisplay
	            ? _c("transition", { attrs: { name: "carousel-arrow-right" } }, [
	                _c(
	                  "button",
	                  {
	                    directives: [
	                      {
	                        name: "show",
	                        rawName: "v-show",
	                        value:
	                          (_vm.arrow === "always" || _vm.hover) &&
	                          (_vm.loop || _vm.activeIndex < _vm.items.length - 1),
	                        expression:
	                          "(arrow === 'always' || hover) && (loop || activeIndex < items.length - 1)"
	                      }
	                    ],
	                    staticClass: "el-carousel__arrow el-carousel__arrow--right",
	                    attrs: { type: "button" },
	                    on: {
	                      mouseenter: function($event) {
	                        _vm.handleButtonEnter("right")
	                      },
	                      mouseleave: _vm.handleButtonLeave,
	                      click: function($event) {
	                        $event.stopPropagation()
	                        _vm.throttledArrowClick(_vm.activeIndex + 1)
	                      }
	                    }
	                  },
	                  [_c("i", { staticClass: "el-icon-arrow-right" })]
	                )
	              ])
	            : _vm._e(),
	          _vm._t("default")
	        ],
	        2
	      ),
	      _vm.indicatorPosition !== "none"
	        ? _c(
	            "ul",
	            { class: _vm.indicatorsClasses },
	            _vm._l(_vm.items, function(item, index) {
	              return _c(
	                "li",
	                {
	                  key: index,
	                  class: [
	                    "el-carousel__indicator",
	                    "el-carousel__indicator--" + _vm.direction,
	                    { "is-active": index === _vm.activeIndex }
	                  ],
	                  on: {
	                    mouseenter: function($event) {
	                      _vm.throttledIndicatorHover(index)
	                    },
	                    click: function($event) {
	                      $event.stopPropagation()
	                      _vm.handleIndicatorClick(index)
	                    }
	                  }
	                },
	                [
	                  _c("button", { staticClass: "el-carousel__button" }, [
	                    _vm.hasLabel
	                      ? _c("span", [_vm._v(_vm._s(item.label))])
	                      : _vm._e()
	                  ])
	                ]
	              )
	            }),
	            0
	          )
	        : _vm._e()
	    ]
	  )
	}
	var mainvue_type_template_id_5d5d1482_staticRenderFns = []
	mainvue_type_template_id_5d5d1482_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/carousel/src/main.vue?vue&type=template&id=5d5d1482&
	
	// EXTERNAL MODULE: external "throttle-debounce/throttle"
	var throttle_ = __webpack_require__(25);
	var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/carousel/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	/* harmony default export */ var carousel_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElCarousel',
	
	  props: {
	    initialIndex: {
	      type: Number,
	      default: 0
	    },
	    height: String,
	    trigger: {
	      type: String,
	      default: 'hover'
	    },
	    autoplay: {
	      type: Boolean,
	      default: true
	    },
	    interval: {
	      type: Number,
	      default: 3000
	    },
	    indicatorPosition: String,
	    indicator: {
	      type: Boolean,
	      default: true
	    },
	    arrow: {
	      type: String,
	      default: 'hover'
	    },
	    type: String,
	    loop: {
	      type: Boolean,
	      default: true
	    },
	    direction: {
	      type: String,
	      default: 'horizontal',
	      validator: function validator(val) {
	        return ['horizontal', 'vertical'].indexOf(val) !== -1;
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      items: [],
	      activeIndex: -1,
	      containerWidth: 0,
	      timer: null,
	      hover: false
	    };
	  },
	
	
	  computed: {
	    arrowDisplay: function arrowDisplay() {
	      return this.arrow !== 'never' && this.direction !== 'vertical';
	    },
	    hasLabel: function hasLabel() {
	      return this.items.some(function (item) {
	        return item.label.toString().length > 0;
	      });
	    },
	    carouselClasses: function carouselClasses() {
	      var classes = ['el-carousel', 'el-carousel--' + this.direction];
	      if (this.type === 'card') {
	        classes.push('el-carousel--card');
	      }
	      return classes;
	    },
	    indicatorsClasses: function indicatorsClasses() {
	      var classes = ['el-carousel__indicators', 'el-carousel__indicators--' + this.direction];
	      if (this.hasLabel) {
	        classes.push('el-carousel__indicators--labels');
	      }
	      if (this.indicatorPosition === 'outside' || this.type === 'card') {
	        classes.push('el-carousel__indicators--outside');
	      }
	      return classes;
	    }
	  },
	
	  watch: {
	    items: function items(val) {
	      if (val.length > 0) this.setActiveItem(this.initialIndex);
	    },
	    activeIndex: function activeIndex(val, oldVal) {
	      this.resetItemPosition(oldVal);
	      if (oldVal > -1) {
	        this.$emit('change', val, oldVal);
	      }
	    },
	    autoplay: function autoplay(val) {
	      val ? this.startTimer() : this.pauseTimer();
	    },
	    loop: function loop() {
	      this.setActiveItem(this.activeIndex);
	    },
	    interval: function interval() {
	      this.pauseTimer();
	      this.startTimer();
	    }
	  },
	
	  methods: {
	    handleMouseEnter: function handleMouseEnter() {
	      this.hover = true;
	      this.pauseTimer();
	    },
	    handleMouseLeave: function handleMouseLeave() {
	      this.hover = false;
	      this.startTimer();
	    },
	    itemInStage: function itemInStage(item, index) {
	      var length = this.items.length;
	      if (index === length - 1 && item.inStage && this.items[0].active || item.inStage && this.items[index + 1] && this.items[index + 1].active) {
	        return 'left';
	      } else if (index === 0 && item.inStage && this.items[length - 1].active || item.inStage && this.items[index - 1] && this.items[index - 1].active) {
	        return 'right';
	      }
	      return false;
	    },
	    handleButtonEnter: function handleButtonEnter(arrow) {
	      var _this = this;
	
	      if (this.direction === 'vertical') return;
	      this.items.forEach(function (item, index) {
	        if (arrow === _this.itemInStage(item, index)) {
	          item.hover = true;
	        }
	      });
	    },
	    handleButtonLeave: function handleButtonLeave() {
	      if (this.direction === 'vertical') return;
	      this.items.forEach(function (item) {
	        item.hover = false;
	      });
	    },
	    updateItems: function updateItems() {
	      this.items = this.$children.filter(function (child) {
	        return child.$options.name === 'ElCarouselItem';
	      });
	    },
	    resetItemPosition: function resetItemPosition(oldIndex) {
	      var _this2 = this;
	
	      this.items.forEach(function (item, index) {
	        item.translateItem(index, _this2.activeIndex, oldIndex);
	      });
	    },
	    playSlides: function playSlides() {
	      if (this.activeIndex < this.items.length - 1) {
	        this.activeIndex++;
	      } else if (this.loop) {
	        this.activeIndex = 0;
	      }
	    },
	    pauseTimer: function pauseTimer() {
	      if (this.timer) {
	        clearInterval(this.timer);
	        this.timer = null;
	      }
	    },
	    startTimer: function startTimer() {
	      if (this.interval <= 0 || !this.autoplay || this.timer) return;
	      this.timer = setInterval(this.playSlides, this.interval);
	    },
	    setActiveItem: function setActiveItem(index) {
	      if (typeof index === 'string') {
	        var filteredItems = this.items.filter(function (item) {
	          return item.name === index;
	        });
	        if (filteredItems.length > 0) {
	          index = this.items.indexOf(filteredItems[0]);
	        }
	      }
	      index = Number(index);
	      if (isNaN(index) || index !== Math.floor(index)) {
	        console.warn('[Element Warn][Carousel]index must be an integer.');
	        return;
	      }
	      var length = this.items.length;
	      var oldIndex = this.activeIndex;
	      if (index < 0) {
	        this.activeIndex = this.loop ? length - 1 : 0;
	      } else if (index >= length) {
	        this.activeIndex = this.loop ? 0 : length - 1;
	      } else {
	        this.activeIndex = index;
	      }
	      if (oldIndex === this.activeIndex) {
	        this.resetItemPosition(oldIndex);
	      }
	    },
	    prev: function prev() {
	      this.setActiveItem(this.activeIndex - 1);
	    },
	    next: function next() {
	      this.setActiveItem(this.activeIndex + 1);
	    },
	    handleIndicatorClick: function handleIndicatorClick(index) {
	      this.activeIndex = index;
	    },
	    handleIndicatorHover: function handleIndicatorHover(index) {
	      if (this.trigger === 'hover' && index !== this.activeIndex) {
	        this.activeIndex = index;
	      }
	    }
	  },
	
	  created: function created() {
	    var _this3 = this;
	
	    this.throttledArrowClick = throttle_default()(300, true, function (index) {
	      _this3.setActiveItem(index);
	    });
	    this.throttledIndicatorHover = throttle_default()(300, function (index) {
	      _this3.handleIndicatorHover(index);
	    });
	  },
	  mounted: function mounted() {
	    var _this4 = this;
	
	    this.updateItems();
	    this.$nextTick(function () {
	      Object(resize_event_["addResizeListener"])(_this4.$el, _this4.resetItemPosition);
	      if (_this4.initialIndex < _this4.items.length && _this4.initialIndex >= 0) {
	        _this4.activeIndex = _this4.initialIndex;
	      }
	      _this4.startTimer();
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.$el) Object(resize_event_["removeResizeListener"])(this.$el, this.resetItemPosition);
	    this.pauseTimer();
	  }
	});
	// CONCATENATED MODULE: ./packages/carousel/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_carousel_src_mainvue_type_script_lang_js_ = (carousel_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/carousel/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var carousel_src_main_component = normalizeComponent(
	  packages_carousel_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_5d5d1482_render,
	  mainvue_type_template_id_5d5d1482_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var carousel_src_main_api; }
	carousel_src_main_component.options.__file = "packages/carousel/src/main.vue"
	/* harmony default export */ var carousel_src_main = (carousel_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/carousel/index.js
	
	
	/* istanbul ignore next */
	carousel_src_main.install = function (Vue) {
	  Vue.component(carousel_src_main.name, carousel_src_main);
	};
	
	/* harmony default export */ var carousel = (carousel_src_main);
	// CONCATENATED MODULE: ./packages/scrollbar/src/util.js
	var BAR_MAP = {
	  vertical: {
	    offset: 'offsetHeight',
	    scroll: 'scrollTop',
	    scrollSize: 'scrollHeight',
	    size: 'height',
	    key: 'vertical',
	    axis: 'Y',
	    client: 'clientY',
	    direction: 'top'
	  },
	  horizontal: {
	    offset: 'offsetWidth',
	    scroll: 'scrollLeft',
	    scrollSize: 'scrollWidth',
	    size: 'width',
	    key: 'horizontal',
	    axis: 'X',
	    client: 'clientX',
	    direction: 'left'
	  }
	};
	
	function renderThumbStyle(_ref) {
	  var move = _ref.move,
	      size = _ref.size,
	      bar = _ref.bar;
	
	  var style = {};
	  var translate = 'translate' + bar.axis + '(' + move + '%)';
	
	  style[bar.size] = size;
	  style.transform = translate;
	  style.msTransform = translate;
	  style.webkitTransform = translate;
	
	  return style;
	};
	// CONCATENATED MODULE: ./packages/scrollbar/src/bar.js
	
	
	
	/* istanbul ignore next */
	/* harmony default export */ var src_bar = ({
	  name: 'Bar',
	
	  props: {
	    vertical: Boolean,
	    size: String,
	    move: Number
	  },
	
	  computed: {
	    bar: function bar() {
	      return BAR_MAP[this.vertical ? 'vertical' : 'horizontal'];
	    },
	    wrap: function wrap() {
	      return this.$parent.wrap;
	    }
	  },
	
	  render: function render(h) {
	    var size = this.size,
	        move = this.move,
	        bar = this.bar;
	
	
	    return h(
	      'div',
	      {
	        'class': ['el-scrollbar__bar', 'is-' + bar.key],
	        on: {
	          'mousedown': this.clickTrackHandler
	        }
	      },
	      [h('div', {
	        ref: 'thumb',
	        'class': 'el-scrollbar__thumb',
	        on: {
	          'mousedown': this.clickThumbHandler
	        },
	
	        style: renderThumbStyle({ size: size, move: move, bar: bar }) })]
	    );
	  },
	
	
	  methods: {
	    clickThumbHandler: function clickThumbHandler(e) {
	      // prevent click event of right button
	      if (e.ctrlKey || e.button === 2) {
	        return;
	      }
	      this.startDrag(e);
	      this[this.bar.axis] = e.currentTarget[this.bar.offset] - (e[this.bar.client] - e.currentTarget.getBoundingClientRect()[this.bar.direction]);
	    },
	    clickTrackHandler: function clickTrackHandler(e) {
	      var offset = Math.abs(e.target.getBoundingClientRect()[this.bar.direction] - e[this.bar.client]);
	      var thumbHalf = this.$refs.thumb[this.bar.offset] / 2;
	      var thumbPositionPercentage = (offset - thumbHalf) * 100 / this.$el[this.bar.offset];
	
	      this.wrap[this.bar.scroll] = thumbPositionPercentage * this.wrap[this.bar.scrollSize] / 100;
	    },
	    startDrag: function startDrag(e) {
	      e.stopImmediatePropagation();
	      this.cursorDown = true;
	
	      Object(dom_["on"])(document, 'mousemove', this.mouseMoveDocumentHandler);
	      Object(dom_["on"])(document, 'mouseup', this.mouseUpDocumentHandler);
	      document.onselectstart = function () {
	        return false;
	      };
	    },
	    mouseMoveDocumentHandler: function mouseMoveDocumentHandler(e) {
	      if (this.cursorDown === false) return;
	      var prevPage = this[this.bar.axis];
	
	      if (!prevPage) return;
	
	      var offset = (this.$el.getBoundingClientRect()[this.bar.direction] - e[this.bar.client]) * -1;
	      var thumbClickPosition = this.$refs.thumb[this.bar.offset] - prevPage;
	      var thumbPositionPercentage = (offset - thumbClickPosition) * 100 / this.$el[this.bar.offset];
	
	      this.wrap[this.bar.scroll] = thumbPositionPercentage * this.wrap[this.bar.scrollSize] / 100;
	    },
	    mouseUpDocumentHandler: function mouseUpDocumentHandler(e) {
	      this.cursorDown = false;
	      this[this.bar.axis] = 0;
	      Object(dom_["off"])(document, 'mousemove', this.mouseMoveDocumentHandler);
	      document.onselectstart = null;
	    }
	  },
	
	  destroyed: function destroyed() {
	    Object(dom_["off"])(document, 'mouseup', this.mouseUpDocumentHandler);
	  }
	});
	// CONCATENATED MODULE: ./packages/scrollbar/src/main.js
	// reference https://github.com/noeldelgado/gemini-scrollbar/blob/master/index.js
	
	
	
	
	
	
	/* istanbul ignore next */
	/* harmony default export */ var scrollbar_src_main = ({
	  name: 'ElScrollbar',
	
	  components: { Bar: src_bar },
	
	  props: {
	    native: Boolean,
	    wrapStyle: {},
	    wrapClass: {},
	    viewClass: {},
	    viewStyle: {},
	    noresize: Boolean, // 如果 container 尺寸不会发生变化，最好设置它可以优化性能
	    tag: {
	      type: String,
	      default: 'div'
	    }
	  },
	
	  data: function data() {
	    return {
	      sizeWidth: '0',
	      sizeHeight: '0',
	      moveX: 0,
	      moveY: 0
	    };
	  },
	
	
	  computed: {
	    wrap: function wrap() {
	      return this.$refs.wrap;
	    }
	  },
	
	  render: function render(h) {
	    var gutter = scrollbar_width_default()();
	    var style = this.wrapStyle;
	
	    if (gutter) {
	      var gutterWith = '-' + gutter + 'px';
	      var gutterStyle = 'margin-bottom: ' + gutterWith + '; margin-right: ' + gutterWith + ';';
	
	      if (Array.isArray(this.wrapStyle)) {
	        style = Object(util_["toObject"])(this.wrapStyle);
	        style.marginRight = style.marginBottom = gutterWith;
	      } else if (typeof this.wrapStyle === 'string') {
	        style += gutterStyle;
	      } else {
	        style = gutterStyle;
	      }
	    }
	    var view = h(this.tag, {
	      class: ['el-scrollbar__view', this.viewClass],
	      style: this.viewStyle,
	      ref: 'resize'
	    }, this.$slots.default);
	    var wrap = h(
	      'div',
	      {
	        ref: 'wrap',
	        style: style,
	        on: {
	          'scroll': this.handleScroll
	        },
	
	        'class': [this.wrapClass, 'el-scrollbar__wrap', gutter ? '' : 'el-scrollbar__wrap--hidden-default'] },
	      [[view]]
	    );
	    var nodes = void 0;
	
	    if (!this.native) {
	      nodes = [wrap, h(src_bar, {
	        attrs: {
	          move: this.moveX,
	          size: this.sizeWidth }
	      }), h(src_bar, {
	        attrs: {
	          vertical: true,
	          move: this.moveY,
	          size: this.sizeHeight }
	      })];
	    } else {
	      nodes = [h(
	        'div',
	        {
	          ref: 'wrap',
	          'class': [this.wrapClass, 'el-scrollbar__wrap'],
	          style: style },
	        [[view]]
	      )];
	    }
	    return h('div', { class: 'el-scrollbar' }, nodes);
	  },
	
	
	  methods: {
	    handleScroll: function handleScroll() {
	      var wrap = this.wrap;
	
	      this.moveY = wrap.scrollTop * 100 / wrap.clientHeight;
	      this.moveX = wrap.scrollLeft * 100 / wrap.clientWidth;
	    },
	    update: function update() {
	      var heightPercentage = void 0,
	          widthPercentage = void 0;
	      var wrap = this.wrap;
	      if (!wrap) return;
	
	      heightPercentage = wrap.clientHeight * 100 / wrap.scrollHeight;
	      widthPercentage = wrap.clientWidth * 100 / wrap.scrollWidth;
	
	      this.sizeHeight = heightPercentage < 100 ? heightPercentage + '%' : '';
	      this.sizeWidth = widthPercentage < 100 ? widthPercentage + '%' : '';
	    }
	  },
	
	  mounted: function mounted() {
	    if (this.native) return;
	    this.$nextTick(this.update);
	    !this.noresize && Object(resize_event_["addResizeListener"])(this.$refs.resize, this.update);
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.native) return;
	    !this.noresize && Object(resize_event_["removeResizeListener"])(this.$refs.resize, this.update);
	  }
	});
	// CONCATENATED MODULE: ./packages/scrollbar/index.js
	
	
	/* istanbul ignore next */
	scrollbar_src_main.install = function (Vue) {
	  Vue.component(scrollbar_src_main.name, scrollbar_src_main);
	};
	
	/* harmony default export */ var scrollbar = (scrollbar_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/carousel/src/item.vue?vue&type=template&id=1801ae19&
	var itemvue_type_template_id_1801ae19_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      directives: [
	        {
	          name: "show",
	          rawName: "v-show",
	          value: _vm.ready,
	          expression: "ready"
	        }
	      ],
	      staticClass: "el-carousel__item",
	      class: {
	        "is-active": _vm.active,
	        "el-carousel__item--card": _vm.$parent.type === "card",
	        "is-in-stage": _vm.inStage,
	        "is-hover": _vm.hover,
	        "is-animating": _vm.animating
	      },
	      style: _vm.itemStyle,
	      on: { click: _vm.handleItemClick }
	    },
	    [
	      _vm.$parent.type === "card"
	        ? _c("div", {
	            directives: [
	              {
	                name: "show",
	                rawName: "v-show",
	                value: !_vm.active,
	                expression: "!active"
	              }
	            ],
	            staticClass: "el-carousel__mask"
	          })
	        : _vm._e(),
	      _vm._t("default")
	    ],
	    2
	  )
	}
	var itemvue_type_template_id_1801ae19_staticRenderFns = []
	itemvue_type_template_id_1801ae19_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/carousel/src/item.vue?vue&type=template&id=1801ae19&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/carousel/src/item.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	var CARD_SCALE = 0.83;
	/* harmony default export */ var itemvue_type_script_lang_js_ = ({
	  name: 'ElCarouselItem',
	
	  props: {
	    name: String,
	    label: {
	      type: [String, Number],
	      default: ''
	    }
	  },
	
	  data: function data() {
	    return {
	      hover: false,
	      translate: 0,
	      scale: 1,
	      active: false,
	      ready: false,
	      inStage: false,
	      animating: false
	    };
	  },
	
	
	  methods: {
	    processIndex: function processIndex(index, activeIndex, length) {
	      if (activeIndex === 0 && index === length - 1) {
	        return -1;
	      } else if (activeIndex === length - 1 && index === 0) {
	        return length;
	      } else if (index < activeIndex - 1 && activeIndex - index >= length / 2) {
	        return length + 1;
	      } else if (index > activeIndex + 1 && index - activeIndex >= length / 2) {
	        return -2;
	      }
	      return index;
	    },
	    calcCardTranslate: function calcCardTranslate(index, activeIndex) {
	      var parentWidth = this.$parent.$el.offsetWidth;
	      if (this.inStage) {
	        return parentWidth * ((2 - CARD_SCALE) * (index - activeIndex) + 1) / 4;
	      } else if (index < activeIndex) {
	        return -(1 + CARD_SCALE) * parentWidth / 4;
	      } else {
	        return (3 + CARD_SCALE) * parentWidth / 4;
	      }
	    },
	    calcTranslate: function calcTranslate(index, activeIndex, isVertical) {
	      var distance = this.$parent.$el[isVertical ? 'offsetHeight' : 'offsetWidth'];
	      return distance * (index - activeIndex);
	    },
	    translateItem: function translateItem(index, activeIndex, oldIndex) {
	      var parentType = this.$parent.type;
	      var parentDirection = this.parentDirection;
	      var length = this.$parent.items.length;
	      if (parentType !== 'card' && oldIndex !== undefined) {
	        this.animating = index === activeIndex || index === oldIndex;
	      }
	      if (index !== activeIndex && length > 2 && this.$parent.loop) {
	        index = this.processIndex(index, activeIndex, length);
	      }
	      if (parentType === 'card') {
	        if (parentDirection === 'vertical') {
	          console.warn('[Element Warn][Carousel]vertical direction is not supported in card mode');
	        }
	        this.inStage = Math.round(Math.abs(index - activeIndex)) <= 1;
	        this.active = index === activeIndex;
	        this.translate = this.calcCardTranslate(index, activeIndex);
	        this.scale = this.active ? 1 : CARD_SCALE;
	      } else {
	        this.active = index === activeIndex;
	        var isVertical = parentDirection === 'vertical';
	        this.translate = this.calcTranslate(index, activeIndex, isVertical);
	        this.scale = 1;
	      }
	      this.ready = true;
	    },
	    handleItemClick: function handleItemClick() {
	      var parent = this.$parent;
	      if (parent && parent.type === 'card') {
	        var index = parent.items.indexOf(this);
	        parent.setActiveItem(index);
	      }
	    }
	  },
	
	  computed: {
	    parentDirection: function parentDirection() {
	      return this.$parent.direction;
	    },
	    itemStyle: function itemStyle() {
	      var translateType = this.parentDirection === 'vertical' ? 'translateY' : 'translateX';
	      var value = translateType + '(' + this.translate + 'px) scale(' + this.scale + ')';
	      var style = {
	        transform: value
	      };
	      return Object(util_["autoprefixer"])(style);
	    }
	  },
	
	  created: function created() {
	    this.$parent && this.$parent.updateItems();
	  },
	  destroyed: function destroyed() {
	    this.$parent && this.$parent.updateItems();
	  }
	});
	// CONCATENATED MODULE: ./packages/carousel/src/item.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_itemvue_type_script_lang_js_ = (itemvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/carousel/src/item.vue
	
	
	
	
	
	/* normalize component */
	
	var item_component = normalizeComponent(
	  src_itemvue_type_script_lang_js_,
	  itemvue_type_template_id_1801ae19_render,
	  itemvue_type_template_id_1801ae19_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var item_api; }
	item_component.options.__file = "packages/carousel/src/item.vue"
	/* harmony default export */ var src_item = (item_component.exports);
	// CONCATENATED MODULE: ./packages/carousel-item/index.js
	
	
	/* istanbul ignore next */
	src_item.install = function (Vue) {
	  Vue.component(src_item.name, src_item);
	};
	
	/* harmony default export */ var carousel_item = (src_item);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/collapse/src/collapse.vue?vue&type=template&id=461d57f4&
	var collapsevue_type_template_id_461d57f4_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-collapse",
	      attrs: { role: "tablist", "aria-multiselectable": "true" }
	    },
	    [_vm._t("default")],
	    2
	  )
	}
	var collapsevue_type_template_id_461d57f4_staticRenderFns = []
	collapsevue_type_template_id_461d57f4_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/collapse/src/collapse.vue?vue&type=template&id=461d57f4&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/collapse/src/collapse.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	
	/* harmony default export */ var collapsevue_type_script_lang_js_ = ({
	  name: 'ElCollapse',
	
	  componentName: 'ElCollapse',
	
	  props: {
	    accordion: Boolean,
	    value: {
	      type: [Array, String, Number],
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      activeNames: [].concat(this.value)
	    };
	  },
	  provide: function provide() {
	    return {
	      collapse: this
	    };
	  },
	
	
	  watch: {
	    value: function value(_value) {
	      this.activeNames = [].concat(_value);
	    }
	  },
	
	  methods: {
	    setActiveNames: function setActiveNames(activeNames) {
	      activeNames = [].concat(activeNames);
	      var value = this.accordion ? activeNames[0] : activeNames;
	      this.activeNames = activeNames;
	      this.$emit('input', value);
	      this.$emit('change', value);
	    },
	    handleItemClick: function handleItemClick(item) {
	      if (this.accordion) {
	        this.setActiveNames((this.activeNames[0] || this.activeNames[0] === 0) && this.activeNames[0] === item.name ? '' : item.name);
	      } else {
	        var activeNames = this.activeNames.slice(0);
	        var index = activeNames.indexOf(item.name);
	
	        if (index > -1) {
	          activeNames.splice(index, 1);
	        } else {
	          activeNames.push(item.name);
	        }
	        this.setActiveNames(activeNames);
	      }
	    }
	  },
	
	  created: function created() {
	    this.$on('item-click', this.handleItemClick);
	  }
	});
	// CONCATENATED MODULE: ./packages/collapse/src/collapse.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_collapsevue_type_script_lang_js_ = (collapsevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/collapse/src/collapse.vue
	
	
	
	
	
	/* normalize component */
	
	var collapse_component = normalizeComponent(
	  src_collapsevue_type_script_lang_js_,
	  collapsevue_type_template_id_461d57f4_render,
	  collapsevue_type_template_id_461d57f4_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var collapse_api; }
	collapse_component.options.__file = "packages/collapse/src/collapse.vue"
	/* harmony default export */ var collapse = (collapse_component.exports);
	// CONCATENATED MODULE: ./packages/collapse/index.js
	
	
	/* istanbul ignore next */
	collapse.install = function (Vue) {
	  Vue.component(collapse.name, collapse);
	};
	
	/* harmony default export */ var packages_collapse = (collapse);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/collapse/src/collapse-item.vue?vue&type=template&id=2d05faac&
	var collapse_itemvue_type_template_id_2d05faac_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-collapse-item",
	      class: { "is-active": _vm.isActive, "is-disabled": _vm.disabled }
	    },
	    [
	      _c(
	        "div",
	        {
	          attrs: {
	            role: "tab",
	            "aria-expanded": _vm.isActive,
	            "aria-controls": "el-collapse-content-" + _vm.id,
	            "aria-describedby": "el-collapse-content-" + _vm.id
	          }
	        },
	        [
	          _c(
	            "div",
	            {
	              staticClass: "el-collapse-item__header",
	              class: {
	                focusing: _vm.focusing,
	                "is-active": _vm.isActive
	              },
	              attrs: {
	                role: "button",
	                id: "el-collapse-head-" + _vm.id,
	                tabindex: _vm.disabled ? undefined : 0
	              },
	              on: {
	                click: _vm.handleHeaderClick,
	                keyup: function($event) {
	                  if (
	                    !("button" in $event) &&
	                    _vm._k($event.keyCode, "space", 32, $event.key, [
	                      " ",
	                      "Spacebar"
	                    ]) &&
	                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
	                  ) {
	                    return null
	                  }
	                  $event.stopPropagation()
	                  return _vm.handleEnterClick($event)
	                },
	                focus: _vm.handleFocus,
	                blur: function($event) {
	                  _vm.focusing = false
	                }
	              }
	            },
	            [
	              _vm._t("title", [_vm._v(_vm._s(_vm.title))]),
	              _c("i", {
	                staticClass: "el-collapse-item__arrow el-icon-arrow-right",
	                class: { "is-active": _vm.isActive }
	              })
	            ],
	            2
	          )
	        ]
	      ),
	      _c("el-collapse-transition", [
	        _c(
	          "div",
	          {
	            directives: [
	              {
	                name: "show",
	                rawName: "v-show",
	                value: _vm.isActive,
	                expression: "isActive"
	              }
	            ],
	            staticClass: "el-collapse-item__wrap",
	            attrs: {
	              role: "tabpanel",
	              "aria-hidden": !_vm.isActive,
	              "aria-labelledby": "el-collapse-head-" + _vm.id,
	              id: "el-collapse-content-" + _vm.id
	            }
	          },
	          [
	            _c(
	              "div",
	              { staticClass: "el-collapse-item__content" },
	              [_vm._t("default")],
	              2
	            )
	          ]
	        )
	      ])
	    ],
	    1
	  )
	}
	var collapse_itemvue_type_template_id_2d05faac_staticRenderFns = []
	collapse_itemvue_type_template_id_2d05faac_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/collapse/src/collapse-item.vue?vue&type=template&id=2d05faac&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/collapse/src/collapse-item.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var collapse_itemvue_type_script_lang_js_ = ({
	  name: 'ElCollapseItem',
	
	  componentName: 'ElCollapseItem',
	
	  mixins: [emitter_default.a],
	
	  components: { ElCollapseTransition: collapse_transition_default.a },
	
	  data: function data() {
	    return {
	      contentWrapStyle: {
	        height: 'auto',
	        display: 'block'
	      },
	      contentHeight: 0,
	      focusing: false,
	      isClick: false,
	      id: Object(util_["generateId"])()
	    };
	  },
	
	
	  inject: ['collapse'],
	
	  props: {
	    title: String,
	    name: {
	      type: [String, Number],
	      default: function _default() {
	        return this._uid;
	      }
	    },
	    disabled: Boolean
	  },
	
	  computed: {
	    isActive: function isActive() {
	      return this.collapse.activeNames.indexOf(this.name) > -1;
	    }
	  },
	
	  methods: {
	    handleFocus: function handleFocus() {
	      var _this = this;
	
	      setTimeout(function () {
	        if (!_this.isClick) {
	          _this.focusing = true;
	        } else {
	          _this.isClick = false;
	        }
	      }, 50);
	    },
	    handleHeaderClick: function handleHeaderClick() {
	      if (this.disabled) return;
	      this.dispatch('ElCollapse', 'item-click', this);
	      this.focusing = false;
	      this.isClick = true;
	    },
	    handleEnterClick: function handleEnterClick() {
	      this.dispatch('ElCollapse', 'item-click', this);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/collapse/src/collapse-item.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_collapse_itemvue_type_script_lang_js_ = (collapse_itemvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/collapse/src/collapse-item.vue
	
	
	
	
	
	/* normalize component */
	
	var collapse_item_component = normalizeComponent(
	  src_collapse_itemvue_type_script_lang_js_,
	  collapse_itemvue_type_template_id_2d05faac_render,
	  collapse_itemvue_type_template_id_2d05faac_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var collapse_item_api; }
	collapse_item_component.options.__file = "packages/collapse/src/collapse-item.vue"
	/* harmony default export */ var collapse_item = (collapse_item_component.exports);
	// CONCATENATED MODULE: ./packages/collapse-item/index.js
	
	
	/* istanbul ignore next */
	collapse_item.install = function (Vue) {
	  Vue.component(collapse_item.name, collapse_item);
	};
	
	/* harmony default export */ var packages_collapse_item = (collapse_item);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader/src/cascader.vue?vue&type=template&id=032537a6&
	var cascadervue_type_template_id_032537a6_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      directives: [
	        {
	          name: "clickoutside",
	          rawName: "v-clickoutside",
	          value: function() {
	            return _vm.toggleDropDownVisible(false)
	          },
	          expression: "() => toggleDropDownVisible(false)"
	        }
	      ],
	      ref: "reference",
	      class: [
	        "el-cascader",
	        _vm.realSize && "el-cascader--" + _vm.realSize,
	        { "is-disabled": _vm.isDisabled }
	      ],
	      on: {
	        mouseenter: function($event) {
	          _vm.inputHover = true
	        },
	        mouseleave: function($event) {
	          _vm.inputHover = false
	        },
	        click: function() {
	          return _vm.toggleDropDownVisible(_vm.readonly ? undefined : true)
	        },
	        keydown: _vm.handleKeyDown
	      }
	    },
	    [
	      _c(
	        "el-input",
	        {
	          ref: "input",
	          class: { "is-focus": _vm.dropDownVisible },
	          attrs: {
	            size: _vm.realSize,
	            placeholder: _vm.placeholder,
	            readonly: _vm.readonly,
	            disabled: _vm.isDisabled,
	            "validate-event": false
	          },
	          on: {
	            focus: _vm.handleFocus,
	            blur: _vm.handleBlur,
	            input: _vm.handleInput
	          },
	          model: {
	            value: _vm.multiple ? _vm.presentText : _vm.inputValue,
	            callback: function($$v) {
	              _vm.multiple ? _vm.presentText : (_vm.inputValue = $$v)
	            },
	            expression: "multiple ? presentText : inputValue"
	          }
	        },
	        [
	          _c("template", { slot: "suffix" }, [
	            _vm.clearBtnVisible
	              ? _c("i", {
	                  key: "clear",
	                  staticClass: "el-input__icon el-icon-circle-close",
	                  on: {
	                    click: function($event) {
	                      $event.stopPropagation()
	                      return _vm.handleClear($event)
	                    }
	                  }
	                })
	              : _c("i", {
	                  key: "arrow-down",
	                  class: [
	                    "el-input__icon",
	                    "el-icon-arrow-down",
	                    _vm.dropDownVisible && "is-reverse"
	                  ],
	                  on: {
	                    click: function($event) {
	                      $event.stopPropagation()
	                      _vm.toggleDropDownVisible()
	                    }
	                  }
	                })
	          ])
	        ],
	        2
	      ),
	      _vm.multiple
	        ? _c(
	            "div",
	            { staticClass: "el-cascader__tags" },
	            [
	              _vm._l(_vm.presentTags, function(tag) {
	                return _c(
	                  "el-tag",
	                  {
	                    key: tag.key,
	                    attrs: {
	                      type: "info",
	                      size: _vm.tagSize,
	                      hit: tag.hitState,
	                      closable: tag.closable,
	                      "disable-transitions": ""
	                    },
	                    on: {
	                      close: function($event) {
	                        _vm.deleteTag(tag)
	                      }
	                    }
	                  },
	                  [_c("span", [_vm._v(_vm._s(tag.text))])]
	                )
	              }),
	              _vm.filterable && !_vm.isDisabled
	                ? _c("input", {
	                    directives: [
	                      {
	                        name: "model",
	                        rawName: "v-model.trim",
	                        value: _vm.inputValue,
	                        expression: "inputValue",
	                        modifiers: { trim: true }
	                      }
	                    ],
	                    staticClass: "el-cascader__search-input",
	                    attrs: {
	                      type: "text",
	                      placeholder: _vm.presentTags.length ? "" : _vm.placeholder
	                    },
	                    domProps: { value: _vm.inputValue },
	                    on: {
	                      input: [
	                        function($event) {
	                          if ($event.target.composing) {
	                            return
	                          }
	                          _vm.inputValue = $event.target.value.trim()
	                        },
	                        function(e) {
	                          return _vm.handleInput(_vm.inputValue, e)
	                        }
	                      ],
	                      click: function($event) {
	                        $event.stopPropagation()
	                        _vm.toggleDropDownVisible(true)
	                      },
	                      keydown: function($event) {
	                        if (
	                          !("button" in $event) &&
	                          _vm._k(
	                            $event.keyCode,
	                            "delete",
	                            [8, 46],
	                            $event.key,
	                            ["Backspace", "Delete", "Del"]
	                          )
	                        ) {
	                          return null
	                        }
	                        return _vm.handleDelete($event)
	                      },
	                      blur: function($event) {
	                        _vm.$forceUpdate()
	                      }
	                    }
	                  })
	                : _vm._e()
	            ],
	            2
	          )
	        : _vm._e(),
	      _c(
	        "transition",
	        {
	          attrs: { name: "el-zoom-in-top" },
	          on: { "after-leave": _vm.handleDropdownLeave }
	        },
	        [
	          _c(
	            "div",
	            {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value: _vm.dropDownVisible,
	                  expression: "dropDownVisible"
	                }
	              ],
	              ref: "popper",
	              class: ["el-popper", "el-cascader__dropdown", _vm.popperClass]
	            },
	            [
	              _c("el-cascader-panel", {
	                directives: [
	                  {
	                    name: "show",
	                    rawName: "v-show",
	                    value: !_vm.filtering,
	                    expression: "!filtering"
	                  }
	                ],
	                ref: "panel",
	                attrs: {
	                  options: _vm.options,
	                  props: _vm.config,
	                  border: false,
	                  "render-label": _vm.$scopedSlots.default
	                },
	                on: {
	                  "expand-change": _vm.handleExpandChange,
	                  close: function($event) {
	                    _vm.toggleDropDownVisible(false)
	                  }
	                },
	                model: {
	                  value: _vm.checkedValue,
	                  callback: function($$v) {
	                    _vm.checkedValue = $$v
	                  },
	                  expression: "checkedValue"
	                }
	              }),
	              _vm.filterable
	                ? _c(
	                    "el-scrollbar",
	                    {
	                      directives: [
	                        {
	                          name: "show",
	                          rawName: "v-show",
	                          value: _vm.filtering,
	                          expression: "filtering"
	                        }
	                      ],
	                      ref: "suggestionPanel",
	                      staticClass: "el-cascader__suggestion-panel",
	                      attrs: {
	                        tag: "ul",
	                        "view-class": "el-cascader__suggestion-list"
	                      },
	                      nativeOn: {
	                        keydown: function($event) {
	                          return _vm.handleSuggestionKeyDown($event)
	                        }
	                      }
	                    },
	                    [
	                      _vm.suggestions.length
	                        ? _vm._l(_vm.suggestions, function(item, index) {
	                            return _c(
	                              "li",
	                              {
	                                key: item.uid,
	                                class: [
	                                  "el-cascader__suggestion-item",
	                                  item.checked && "is-checked"
	                                ],
	                                attrs: { tabindex: -1 },
	                                on: {
	                                  click: function($event) {
	                                    _vm.handleSuggestionClick(index)
	                                  }
	                                }
	                              },
	                              [
	                                _c("span", [_vm._v(_vm._s(item.text))]),
	                                item.checked
	                                  ? _c("i", { staticClass: "el-icon-check" })
	                                  : _vm._e()
	                              ]
	                            )
	                          })
	                        : _vm._t("empty", [
	                            _c(
	                              "li",
	                              { staticClass: "el-cascader__empty-text" },
	                              [_vm._v(_vm._s(_vm.t("el.cascader.noMatch")))]
	                            )
	                          ])
	                    ],
	                    2
	                  )
	                : _vm._e()
	            ],
	            1
	          )
	        ]
	      )
	    ],
	    1
	  )
	}
	var cascadervue_type_template_id_032537a6_staticRenderFns = []
	cascadervue_type_template_id_032537a6_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/cascader/src/cascader.vue?vue&type=template&id=032537a6&
	
	// EXTERNAL MODULE: external "element-ui/lib/cascader-panel"
	var cascader_panel_ = __webpack_require__(42);
	var cascader_panel_default = /*#__PURE__*/__webpack_require__.n(cascader_panel_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/aria-utils"
	var aria_utils_ = __webpack_require__(34);
	var aria_utils_default = /*#__PURE__*/__webpack_require__.n(aria_utils_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader/src/cascader.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var KeyCode = aria_utils_default.a.keys;
	
	var MigratingProps = {
	  expandTrigger: {
	    newProp: 'expandTrigger',
	    type: String
	  },
	  changeOnSelect: {
	    newProp: 'checkStrictly',
	    type: Boolean
	  },
	  hoverThreshold: {
	    newProp: 'hoverThreshold',
	    type: Number
	  }
	};
	
	var PopperMixin = {
	  props: {
	    placement: {
	      type: String,
	      default: 'bottom-start'
	    },
	    appendToBody: vue_popper_default.a.props.appendToBody,
	    visibleArrow: {
	      type: Boolean,
	      default: true
	    },
	    arrowOffset: vue_popper_default.a.props.arrowOffset,
	    offset: vue_popper_default.a.props.offset,
	    boundariesPadding: vue_popper_default.a.props.boundariesPadding,
	    popperOptions: vue_popper_default.a.props.popperOptions
	  },
	  methods: vue_popper_default.a.methods,
	  data: vue_popper_default.a.data,
	  beforeDestroy: vue_popper_default.a.beforeDestroy
	};
	
	var InputSizeMap = {
	  medium: 36,
	  small: 32,
	  mini: 28
	};
	
	/* harmony default export */ var cascadervue_type_script_lang_js_ = ({
	  name: 'ElCascader',
	
	  directives: { Clickoutside: clickoutside_default.a },
	
	  mixins: [PopperMixin, emitter_default.a, locale_default.a, migrating_default.a],
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  components: {
	    ElInput: input_default.a,
	    ElTag: tag_default.a,
	    ElScrollbar: scrollbar_default.a,
	    ElCascaderPanel: cascader_panel_default.a
	  },
	
	  props: {
	    value: {},
	    options: Array,
	    props: Object,
	    size: String,
	    placeholder: {
	      type: String,
	      default: function _default() {
	        return Object(lib_locale_["t"])('el.cascader.placeholder');
	      }
	    },
	    disabled: Boolean,
	    clearable: Boolean,
	    filterable: Boolean,
	    filterMethod: Function,
	    separator: {
	      type: String,
	      default: ' / '
	    },
	    showAllLevels: {
	      type: Boolean,
	      default: true
	    },
	    collapseTags: Boolean,
	    debounce: {
	      type: Number,
	      default: 300
	    },
	    beforeFilter: {
	      type: Function,
	      default: function _default() {
	        return function () {};
	      }
	    },
	    popperClass: String
	  },
	
	  data: function data() {
	    return {
	      dropDownVisible: false,
	      checkedValue: this.value || null,
	      inputHover: false,
	      inputValue: null,
	      presentText: null,
	      presentTags: [],
	      checkedNodes: [],
	      filtering: false,
	      suggestions: [],
	      inputInitialHeight: 0,
	      pressDeleteCount: 0
	    };
	  },
	
	
	  computed: {
	    realSize: function realSize() {
	      var _elFormItemSize = (this.elFormItem || {}).elFormItemSize;
	      return this.size || _elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    tagSize: function tagSize() {
	      return ['small', 'mini'].indexOf(this.realSize) > -1 ? 'mini' : 'small';
	    },
	    isDisabled: function isDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    },
	    config: function config() {
	      var config = this.props || {};
	      var $attrs = this.$attrs;
	
	
	      Object.keys(MigratingProps).forEach(function (oldProp) {
	        var _MigratingProps$oldPr = MigratingProps[oldProp],
	            newProp = _MigratingProps$oldPr.newProp,
	            type = _MigratingProps$oldPr.type;
	
	        var oldValue = $attrs[oldProp] || $attrs[Object(util_["kebabCase"])(oldProp)];
	        if (Object(shared_["isDef"])(oldProp) && !Object(shared_["isDef"])(config[newProp])) {
	          if (type === Boolean && oldValue === '') {
	            oldValue = true;
	          }
	          config[newProp] = oldValue;
	        }
	      });
	
	      return config;
	    },
	    multiple: function multiple() {
	      return this.config.multiple;
	    },
	    leafOnly: function leafOnly() {
	      return !this.config.checkStrictly;
	    },
	    readonly: function readonly() {
	      return !this.filterable || this.multiple;
	    },
	    clearBtnVisible: function clearBtnVisible() {
	      if (!this.clearable || this.isDisabled || this.filtering || !this.inputHover) {
	        return false;
	      }
	
	      return this.multiple ? !!this.checkedNodes.filter(function (node) {
	        return !node.isDisabled;
	      }).length : !!this.presentText;
	    },
	    panel: function panel() {
	      return this.$refs.panel;
	    }
	  },
	
	  watch: {
	    disabled: function disabled() {
	      this.computePresentContent();
	    },
	    value: function value(val) {
	      if (!Object(util_["isEqual"])(val, this.checkedValue)) {
	        this.checkedValue = val;
	        this.computePresentContent();
	      }
	    },
	    checkedValue: function checkedValue(val) {
	      var value = this.value,
	          dropDownVisible = this.dropDownVisible;
	      var _config = this.config,
	          checkStrictly = _config.checkStrictly,
	          multiple = _config.multiple;
	
	
	      if (!Object(util_["isEqual"])(val, value) || Object(types_["isUndefined"])(value)) {
	        this.computePresentContent();
	        // hide dropdown when single mode
	        if (!multiple && !checkStrictly && dropDownVisible) {
	          this.toggleDropDownVisible(false);
	        }
	
	        this.$emit('input', val);
	        this.$emit('change', val);
	        this.dispatch('ElFormItem', 'el.form.change', [val]);
	      }
	    },
	
	    options: {
	      handler: function handler() {
	        this.$nextTick(this.computePresentContent);
	      },
	      deep: true
	    },
	    presentText: function presentText(val) {
	      this.inputValue = val;
	    },
	    presentTags: function presentTags(val, oldVal) {
	      if (this.multiple && (val.length || oldVal.length)) {
	        this.$nextTick(this.updateStyle);
	      }
	    },
	    filtering: function filtering(val) {
	      this.$nextTick(this.updatePopper);
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    var input = this.$refs.input;
	
	    if (input && input.$el) {
	      this.inputInitialHeight = input.$el.offsetHeight || InputSizeMap[this.realSize] || 40;
	    }
	
	    if (!Object(util_["isEmpty"])(this.value)) {
	      this.computePresentContent();
	    }
	
	    this.filterHandler = debounce_default()(this.debounce, function () {
	      var inputValue = _this.inputValue;
	
	
	      if (!inputValue) {
	        _this.filtering = false;
	        return;
	      }
	
	      var before = _this.beforeFilter(inputValue);
	      if (before && before.then) {
	        before.then(_this.getSuggestions);
	      } else if (before !== false) {
	        _this.getSuggestions();
	      } else {
	        _this.filtering = false;
	      }
	    });
	
	    Object(resize_event_["addResizeListener"])(this.$el, this.updateStyle);
	  },
	  beforeDestroy: function beforeDestroy() {
	    Object(resize_event_["removeResizeListener"])(this.$el, this.updateStyle);
	  },
	
	
	  methods: {
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'expand-trigger': 'expand-trigger is removed, use `props.expandTrigger` instead.',
	          'change-on-select': 'change-on-select is removed, use `props.checkStrictly` instead.',
	          'hover-threshold': 'hover-threshold is removed, use `props.hoverThreshold` instead'
	        },
	        events: {
	          'active-item-change': 'active-item-change is renamed to expand-change'
	        }
	      };
	    },
	    toggleDropDownVisible: function toggleDropDownVisible(visible) {
	      var _this2 = this;
	
	      if (this.isDisabled) return;
	
	      var dropDownVisible = this.dropDownVisible;
	      var input = this.$refs.input;
	
	      visible = Object(shared_["isDef"])(visible) ? visible : !dropDownVisible;
	      if (visible !== dropDownVisible) {
	        this.dropDownVisible = visible;
	        if (visible) {
	          this.$nextTick(function () {
	            _this2.updatePopper();
	            _this2.panel.scrollIntoView();
	          });
	        }
	        input.$refs.input.setAttribute('aria-expanded', visible);
	        this.$emit('visible-change', visible);
	      }
	    },
	    handleDropdownLeave: function handleDropdownLeave() {
	      this.filtering = false;
	      this.inputValue = this.presentText;
	    },
	    handleKeyDown: function handleKeyDown(event) {
	      switch (event.keyCode) {
	        case KeyCode.enter:
	          this.toggleDropDownVisible();
	          break;
	        case KeyCode.down:
	          this.toggleDropDownVisible(true);
	          this.focusFirstNode();
	          event.preventDefault();
	          break;
	        case KeyCode.esc:
	        case KeyCode.tab:
	          this.toggleDropDownVisible(false);
	          break;
	      }
	    },
	    handleFocus: function handleFocus(e) {
	      this.$emit('focus', e);
	    },
	    handleBlur: function handleBlur(e) {
	      this.$emit('blur', e);
	    },
	    handleInput: function handleInput(val, event) {
	      !this.dropDownVisible && this.toggleDropDownVisible(true);
	
	      if (event && event.isComposing) return;
	      if (val) {
	        this.filterHandler();
	      } else {
	        this.filtering = false;
	      }
	    },
	    handleClear: function handleClear() {
	      this.presentText = '';
	      this.panel.clearCheckedNodes();
	    },
	    handleExpandChange: function handleExpandChange(value) {
	      this.$nextTick(this.updatePopper.bind(this));
	      this.$emit('expand-change', value);
	      this.$emit('active-item-change', value); // Deprecated
	    },
	    focusFirstNode: function focusFirstNode() {
	      var _this3 = this;
	
	      this.$nextTick(function () {
	        var filtering = _this3.filtering;
	        var _$refs = _this3.$refs,
	            popper = _$refs.popper,
	            suggestionPanel = _$refs.suggestionPanel;
	
	        var firstNode = null;
	
	        if (filtering && suggestionPanel) {
	          firstNode = suggestionPanel.$el.querySelector('.el-cascader__suggestion-item');
	        } else {
	          var firstMenu = popper.querySelector('.el-cascader-menu');
	          firstNode = firstMenu.querySelector('.el-cascader-node[tabindex="-1"]');
	        }
	
	        if (firstNode) {
	          firstNode.focus();
	          !filtering && firstNode.click();
	        }
	      });
	    },
	    computePresentContent: function computePresentContent() {
	      var _this4 = this;
	
	      // nextTick is required, because checked nodes may not change right now
	      this.$nextTick(function () {
	        if (_this4.config.multiple) {
	          _this4.computePresentTags();
	          _this4.presentText = _this4.presentTags.length ? ' ' : null;
	        } else {
	          _this4.computePresentText();
	        }
	      });
	    },
	    computePresentText: function computePresentText() {
	      var checkedValue = this.checkedValue,
	          config = this.config;
	
	      if (!Object(util_["isEmpty"])(checkedValue)) {
	        var node = this.panel.getNodeByValue(checkedValue);
	        if (node && (config.checkStrictly || node.isLeaf)) {
	          this.presentText = node.getText(this.showAllLevels, this.separator);
	          return;
	        }
	      }
	      this.presentText = null;
	    },
	    computePresentTags: function computePresentTags() {
	      var isDisabled = this.isDisabled,
	          leafOnly = this.leafOnly,
	          showAllLevels = this.showAllLevels,
	          separator = this.separator,
	          collapseTags = this.collapseTags;
	
	      var checkedNodes = this.getCheckedNodes(leafOnly);
	      var tags = [];
	
	      var genTag = function genTag(node) {
	        return {
	          node: node,
	          key: node.uid,
	          text: node.getText(showAllLevels, separator),
	          hitState: false,
	          closable: !isDisabled && !node.isDisabled
	        };
	      };
	
	      if (checkedNodes.length) {
	        var first = checkedNodes[0],
	            rest = checkedNodes.slice(1);
	
	        var restCount = rest.length;
	        tags.push(genTag(first));
	
	        if (restCount) {
	          if (collapseTags) {
	            tags.push({
	              key: -1,
	              text: '+ ' + restCount,
	              closable: false
	            });
	          } else {
	            rest.forEach(function (node) {
	              return tags.push(genTag(node));
	            });
	          }
	        }
	      }
	
	      this.checkedNodes = checkedNodes;
	      this.presentTags = tags;
	    },
	    getSuggestions: function getSuggestions() {
	      var _this5 = this;
	
	      var filterMethod = this.filterMethod;
	
	
	      if (!Object(types_["isFunction"])(filterMethod)) {
	        filterMethod = function filterMethod(node, keyword) {
	          return node.text.includes(keyword);
	        };
	      }
	
	      var suggestions = this.panel.getFlattedNodes(this.leafOnly).filter(function (node) {
	        if (node.isDisabled) return false;
	        node.text = node.getText(_this5.showAllLevels, _this5.separator) || '';
	        return filterMethod(node, _this5.inputValue);
	      });
	
	      if (this.multiple) {
	        this.presentTags.forEach(function (tag) {
	          tag.hitState = false;
	        });
	      } else {
	        suggestions.forEach(function (node) {
	          node.checked = Object(util_["isEqual"])(_this5.checkedValue, node.getValueByOption());
	        });
	      }
	
	      this.filtering = true;
	      this.suggestions = suggestions;
	      this.$nextTick(this.updatePopper);
	    },
	    handleSuggestionKeyDown: function handleSuggestionKeyDown(event) {
	      var keyCode = event.keyCode,
	          target = event.target;
	
	      switch (keyCode) {
	        case KeyCode.enter:
	          target.click();
	          break;
	        case KeyCode.up:
	          var prev = target.previousElementSibling;
	          prev && prev.focus();
	          break;
	        case KeyCode.down:
	          var next = target.nextElementSibling;
	          next && next.focus();
	          break;
	        case KeyCode.esc:
	        case KeyCode.tab:
	          this.toggleDropDownVisible(false);
	          break;
	      }
	    },
	    handleDelete: function handleDelete() {
	      var inputValue = this.inputValue,
	          pressDeleteCount = this.pressDeleteCount,
	          presentTags = this.presentTags;
	
	      var lastIndex = presentTags.length - 1;
	      var lastTag = presentTags[lastIndex];
	      this.pressDeleteCount = inputValue ? 0 : pressDeleteCount + 1;
	
	      if (!lastTag) return;
	
	      if (this.pressDeleteCount) {
	        if (lastTag.hitState) {
	          this.deleteTag(lastTag);
	        } else {
	          lastTag.hitState = true;
	        }
	      }
	    },
	    handleSuggestionClick: function handleSuggestionClick(index) {
	      var multiple = this.multiple;
	
	      var targetNode = this.suggestions[index];
	
	      if (multiple) {
	        var checked = targetNode.checked;
	
	        targetNode.doCheck(!checked);
	        this.panel.calculateMultiCheckedValue();
	      } else {
	        this.checkedValue = targetNode.getValueByOption();
	        this.toggleDropDownVisible(false);
	      }
	    },
	    deleteTag: function deleteTag(tag) {
	      var checkedValue = this.checkedValue;
	
	      var current = tag.node.getValueByOption();
	      var val = checkedValue.find(function (n) {
	        return Object(util_["isEqual"])(n, current);
	      });
	      this.checkedValue = checkedValue.filter(function (n) {
	        return !Object(util_["isEqual"])(n, current);
	      });
	      this.$emit('remove-tag', val);
	    },
	    updateStyle: function updateStyle() {
	      var $el = this.$el,
	          inputInitialHeight = this.inputInitialHeight;
	
	      if (this.$isServer || !$el) return;
	
	      var suggestionPanel = this.$refs.suggestionPanel;
	
	      var inputInner = $el.querySelector('.el-input__inner');
	
	      if (!inputInner) return;
	
	      var tags = $el.querySelector('.el-cascader__tags');
	      var suggestionPanelEl = null;
	
	      if (suggestionPanel && (suggestionPanelEl = suggestionPanel.$el)) {
	        var suggestionList = suggestionPanelEl.querySelector('.el-cascader__suggestion-list');
	        suggestionList.style.minWidth = inputInner.offsetWidth + 'px';
	      }
	
	      if (tags) {
	        var offsetHeight = tags.offsetHeight;
	
	        var height = Math.max(offsetHeight + 6, inputInitialHeight) + 'px';
	        inputInner.style.height = height;
	        this.updatePopper();
	      }
	    },
	
	
	    /**
	     * public methods
	    */
	    getCheckedNodes: function getCheckedNodes(leafOnly) {
	      return this.panel.getCheckedNodes(leafOnly);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/cascader/src/cascader.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_cascadervue_type_script_lang_js_ = (cascadervue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/cascader/src/cascader.vue
	
	
	
	
	
	/* normalize component */
	
	var cascader_component = normalizeComponent(
	  src_cascadervue_type_script_lang_js_,
	  cascadervue_type_template_id_032537a6_render,
	  cascadervue_type_template_id_032537a6_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var cascader_api; }
	cascader_component.options.__file = "packages/cascader/src/cascader.vue"
	/* harmony default export */ var cascader = (cascader_component.exports);
	// CONCATENATED MODULE: ./packages/cascader/index.js
	
	
	/* istanbul ignore next */
	cascader.install = function (Vue) {
	  Vue.component(cascader.name, cascader);
	};
	
	/* harmony default export */ var packages_cascader = (cascader);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/main.vue?vue&type=template&id=55c8ade7&
	var mainvue_type_template_id_55c8ade7_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      directives: [
	        {
	          name: "clickoutside",
	          rawName: "v-clickoutside",
	          value: _vm.hide,
	          expression: "hide"
	        }
	      ],
	      class: [
	        "el-color-picker",
	        _vm.colorDisabled ? "is-disabled" : "",
	        _vm.colorSize ? "el-color-picker--" + _vm.colorSize : ""
	      ]
	    },
	    [
	      _vm.colorDisabled
	        ? _c("div", { staticClass: "el-color-picker__mask" })
	        : _vm._e(),
	      _c(
	        "div",
	        {
	          staticClass: "el-color-picker__trigger",
	          on: { click: _vm.handleTrigger }
	        },
	        [
	          _c(
	            "span",
	            {
	              staticClass: "el-color-picker__color",
	              class: { "is-alpha": _vm.showAlpha }
	            },
	            [
	              _c("span", {
	                staticClass: "el-color-picker__color-inner",
	                style: {
	                  backgroundColor: _vm.displayedColor
	                }
	              }),
	              !_vm.value && !_vm.showPanelColor
	                ? _c("span", {
	                    staticClass: "el-color-picker__empty el-icon-close"
	                  })
	                : _vm._e()
	            ]
	          ),
	          _c("span", {
	            directives: [
	              {
	                name: "show",
	                rawName: "v-show",
	                value: _vm.value || _vm.showPanelColor,
	                expression: "value || showPanelColor"
	              }
	            ],
	            staticClass: "el-color-picker__icon el-icon-arrow-down"
	          })
	        ]
	      ),
	      _c("picker-dropdown", {
	        ref: "dropdown",
	        class: ["el-color-picker__panel", _vm.popperClass || ""],
	        attrs: {
	          color: _vm.color,
	          "show-alpha": _vm.showAlpha,
	          predefine: _vm.predefine
	        },
	        on: { pick: _vm.confirmValue, clear: _vm.clearValue },
	        model: {
	          value: _vm.showPicker,
	          callback: function($$v) {
	            _vm.showPicker = $$v
	          },
	          expression: "showPicker"
	        }
	      })
	    ],
	    1
	  )
	}
	var mainvue_type_template_id_55c8ade7_staticRenderFns = []
	mainvue_type_template_id_55c8ade7_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/color-picker/src/main.vue?vue&type=template&id=55c8ade7&
	
	// CONCATENATED MODULE: ./packages/color-picker/src/color.js
	var color_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function color_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var hsv2hsl = function hsv2hsl(hue, sat, val) {
	  return [hue, sat * val / ((hue = (2 - sat) * val) < 1 ? hue : 2 - hue) || 0, hue / 2];
	};
	
	// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
	// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
	var isOnePointZero = function isOnePointZero(n) {
	  return typeof n === 'string' && n.indexOf('.') !== -1 && parseFloat(n) === 1;
	};
	
	var isPercentage = function isPercentage(n) {
	  return typeof n === 'string' && n.indexOf('%') !== -1;
	};
	
	// Take input from [0, n] and return it as [0, 1]
	var bound01 = function bound01(value, max) {
	  if (isOnePointZero(value)) value = '100%';
	
	  var processPercent = isPercentage(value);
	  value = Math.min(max, Math.max(0, parseFloat(value)));
	
	  // Automatically convert percentage into number
	  if (processPercent) {
	    value = parseInt(value * max, 10) / 100;
	  }
	
	  // Handle floating point rounding errors
	  if (Math.abs(value - max) < 0.000001) {
	    return 1;
	  }
	
	  // Convert into [0, 1] range if it isn't already
	  return value % max / parseFloat(max);
	};
	
	var INT_HEX_MAP = { 10: 'A', 11: 'B', 12: 'C', 13: 'D', 14: 'E', 15: 'F' };
	
	var toHex = function toHex(_ref) {
	  var r = _ref.r,
	      g = _ref.g,
	      b = _ref.b;
	
	  var hexOne = function hexOne(value) {
	    value = Math.min(Math.round(value), 255);
	    var high = Math.floor(value / 16);
	    var low = value % 16;
	    return '' + (INT_HEX_MAP[high] || high) + (INT_HEX_MAP[low] || low);
	  };
	
	  if (isNaN(r) || isNaN(g) || isNaN(b)) return '';
	
	  return '#' + hexOne(r) + hexOne(g) + hexOne(b);
	};
	
	var HEX_INT_MAP = { A: 10, B: 11, C: 12, D: 13, E: 14, F: 15 };
	
	var parseHexChannel = function parseHexChannel(hex) {
	  if (hex.length === 2) {
	    return (HEX_INT_MAP[hex[0].toUpperCase()] || +hex[0]) * 16 + (HEX_INT_MAP[hex[1].toUpperCase()] || +hex[1]);
	  }
	
	  return HEX_INT_MAP[hex[1].toUpperCase()] || +hex[1];
	};
	
	var hsl2hsv = function hsl2hsv(hue, sat, light) {
	  sat = sat / 100;
	  light = light / 100;
	  var smin = sat;
	  var lmin = Math.max(light, 0.01);
	  var sv = void 0;
	  var v = void 0;
	
	  light *= 2;
	  sat *= light <= 1 ? light : 2 - light;
	  smin *= lmin <= 1 ? lmin : 2 - lmin;
	  v = (light + sat) / 2;
	  sv = light === 0 ? 2 * smin / (lmin + smin) : 2 * sat / (light + sat);
	
	  return {
	    h: hue,
	    s: sv * 100,
	    v: v * 100
	  };
	};
	
	// `rgbToHsv`
	// Converts an RGB color value to HSV
	// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
	// *Returns:* { h, s, v } in [0,1]
	var rgb2hsv = function rgb2hsv(r, g, b) {
	  r = bound01(r, 255);
	  g = bound01(g, 255);
	  b = bound01(b, 255);
	
	  var max = Math.max(r, g, b);
	  var min = Math.min(r, g, b);
	  var h = void 0,
	      s = void 0;
	  var v = max;
	
	  var d = max - min;
	  s = max === 0 ? 0 : d / max;
	
	  if (max === min) {
	    h = 0; // achromatic
	  } else {
	    switch (max) {
	      case r:
	        h = (g - b) / d + (g < b ? 6 : 0);
	        break;
	      case g:
	        h = (b - r) / d + 2;
	        break;
	      case b:
	        h = (r - g) / d + 4;
	        break;
	    }
	    h /= 6;
	  }
	
	  return { h: h * 360, s: s * 100, v: v * 100 };
	};
	
	// `hsvToRgb`
	// Converts an HSV color value to RGB.
	// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
	// *Returns:* { r, g, b } in the set [0, 255]
	var hsv2rgb = function hsv2rgb(h, s, v) {
	  h = bound01(h, 360) * 6;
	  s = bound01(s, 100);
	  v = bound01(v, 100);
	
	  var i = Math.floor(h);
	  var f = h - i;
	  var p = v * (1 - s);
	  var q = v * (1 - f * s);
	  var t = v * (1 - (1 - f) * s);
	  var mod = i % 6;
	  var r = [v, q, p, p, t, v][mod];
	  var g = [t, v, v, q, p, p][mod];
	  var b = [p, p, t, v, v, q][mod];
	
	  return {
	    r: Math.round(r * 255),
	    g: Math.round(g * 255),
	    b: Math.round(b * 255)
	  };
	};
	
	var Color = function () {
	  function Color(options) {
	    color_classCallCheck(this, Color);
	
	    this._hue = 0;
	    this._saturation = 100;
	    this._value = 100;
	    this._alpha = 100;
	
	    this.enableAlpha = false;
	    this.format = 'hex';
	    this.value = '';
	
	    options = options || {};
	
	    for (var option in options) {
	      if (options.hasOwnProperty(option)) {
	        this[option] = options[option];
	      }
	    }
	
	    this.doOnChange();
	  }
	
	  Color.prototype.set = function set(prop, value) {
	    if (arguments.length === 1 && (typeof prop === 'undefined' ? 'undefined' : color_typeof(prop)) === 'object') {
	      for (var p in prop) {
	        if (prop.hasOwnProperty(p)) {
	          this.set(p, prop[p]);
	        }
	      }
	
	      return;
	    }
	
	    this['_' + prop] = value;
	    this.doOnChange();
	  };
	
	  Color.prototype.get = function get(prop) {
	    return this['_' + prop];
	  };
	
	  Color.prototype.toRgb = function toRgb() {
	    return hsv2rgb(this._hue, this._saturation, this._value);
	  };
	
	  Color.prototype.fromString = function fromString(value) {
	    var _this = this;
	
	    if (!value) {
	      this._hue = 0;
	      this._saturation = 100;
	      this._value = 100;
	
	      this.doOnChange();
	      return;
	    }
	
	    var fromHSV = function fromHSV(h, s, v) {
	      _this._hue = Math.max(0, Math.min(360, h));
	      _this._saturation = Math.max(0, Math.min(100, s));
	      _this._value = Math.max(0, Math.min(100, v));
	
	      _this.doOnChange();
	    };
	
	    if (value.indexOf('hsl') !== -1) {
	      var parts = value.replace(/hsla|hsl|\(|\)/gm, '').split(/\s|,/g).filter(function (val) {
	        return val !== '';
	      }).map(function (val, index) {
	        return index > 2 ? parseFloat(val) : parseInt(val, 10);
	      });
	
	      if (parts.length === 4) {
	        this._alpha = Math.floor(parseFloat(parts[3]) * 100);
	      } else if (parts.length === 3) {
	        this._alpha = 100;
	      }
	      if (parts.length >= 3) {
	        var _hsl2hsv = hsl2hsv(parts[0], parts[1], parts[2]),
	            h = _hsl2hsv.h,
	            s = _hsl2hsv.s,
	            v = _hsl2hsv.v;
	
	        fromHSV(h, s, v);
	      }
	    } else if (value.indexOf('hsv') !== -1) {
	      var _parts = value.replace(/hsva|hsv|\(|\)/gm, '').split(/\s|,/g).filter(function (val) {
	        return val !== '';
	      }).map(function (val, index) {
	        return index > 2 ? parseFloat(val) : parseInt(val, 10);
	      });
	
	      if (_parts.length === 4) {
	        this._alpha = Math.floor(parseFloat(_parts[3]) * 100);
	      } else if (_parts.length === 3) {
	        this._alpha = 100;
	      }
	      if (_parts.length >= 3) {
	        fromHSV(_parts[0], _parts[1], _parts[2]);
	      }
	    } else if (value.indexOf('rgb') !== -1) {
	      var _parts2 = value.replace(/rgba|rgb|\(|\)/gm, '').split(/\s|,/g).filter(function (val) {
	        return val !== '';
	      }).map(function (val, index) {
	        return index > 2 ? parseFloat(val) : parseInt(val, 10);
	      });
	
	      if (_parts2.length === 4) {
	        this._alpha = Math.floor(parseFloat(_parts2[3]) * 100);
	      } else if (_parts2.length === 3) {
	        this._alpha = 100;
	      }
	      if (_parts2.length >= 3) {
	        var _rgb2hsv = rgb2hsv(_parts2[0], _parts2[1], _parts2[2]),
	            _h = _rgb2hsv.h,
	            _s = _rgb2hsv.s,
	            _v = _rgb2hsv.v;
	
	        fromHSV(_h, _s, _v);
	      }
	    } else if (value.indexOf('#') !== -1) {
	      var hex = value.replace('#', '').trim();
	      if (!/^(?:[0-9a-fA-F]{3}){1,2}|[0-9a-fA-F]{8}$/.test(hex)) return;
	      var r = void 0,
	          g = void 0,
	          b = void 0;
	
	      if (hex.length === 3) {
	        r = parseHexChannel(hex[0] + hex[0]);
	        g = parseHexChannel(hex[1] + hex[1]);
	        b = parseHexChannel(hex[2] + hex[2]);
	      } else if (hex.length === 6 || hex.length === 8) {
	        r = parseHexChannel(hex.substring(0, 2));
	        g = parseHexChannel(hex.substring(2, 4));
	        b = parseHexChannel(hex.substring(4, 6));
	      }
	
	      if (hex.length === 8) {
	        this._alpha = Math.floor(parseHexChannel(hex.substring(6)) / 255 * 100);
	      } else if (hex.length === 3 || hex.length === 6) {
	        this._alpha = 100;
	      }
	
	      var _rgb2hsv2 = rgb2hsv(r, g, b),
	          _h2 = _rgb2hsv2.h,
	          _s2 = _rgb2hsv2.s,
	          _v2 = _rgb2hsv2.v;
	
	      fromHSV(_h2, _s2, _v2);
	    }
	  };
	
	  Color.prototype.compare = function compare(color) {
	    return Math.abs(color._hue - this._hue) < 2 && Math.abs(color._saturation - this._saturation) < 1 && Math.abs(color._value - this._value) < 1 && Math.abs(color._alpha - this._alpha) < 1;
	  };
	
	  Color.prototype.doOnChange = function doOnChange() {
	    var _hue = this._hue,
	        _saturation = this._saturation,
	        _value = this._value,
	        _alpha = this._alpha,
	        format = this.format;
	
	
	    if (this.enableAlpha) {
	      switch (format) {
	        case 'hsl':
	          var hsl = hsv2hsl(_hue, _saturation / 100, _value / 100);
	          this.value = 'hsla(' + _hue + ', ' + Math.round(hsl[1] * 100) + '%, ' + Math.round(hsl[2] * 100) + '%, ' + _alpha / 100 + ')';
	          break;
	        case 'hsv':
	          this.value = 'hsva(' + _hue + ', ' + Math.round(_saturation) + '%, ' + Math.round(_value) + '%, ' + _alpha / 100 + ')';
	          break;
	        default:
	          var _hsv2rgb = hsv2rgb(_hue, _saturation, _value),
	              r = _hsv2rgb.r,
	              g = _hsv2rgb.g,
	              b = _hsv2rgb.b;
	
	          this.value = 'rgba(' + r + ', ' + g + ', ' + b + ', ' + _alpha / 100 + ')';
	      }
	    } else {
	      switch (format) {
	        case 'hsl':
	          var _hsl = hsv2hsl(_hue, _saturation / 100, _value / 100);
	          this.value = 'hsl(' + _hue + ', ' + Math.round(_hsl[1] * 100) + '%, ' + Math.round(_hsl[2] * 100) + '%)';
	          break;
	        case 'hsv':
	          this.value = 'hsv(' + _hue + ', ' + Math.round(_saturation) + '%, ' + Math.round(_value) + '%)';
	          break;
	        case 'rgb':
	          var _hsv2rgb2 = hsv2rgb(_hue, _saturation, _value),
	              _r = _hsv2rgb2.r,
	              _g = _hsv2rgb2.g,
	              _b = _hsv2rgb2.b;
	
	          this.value = 'rgb(' + _r + ', ' + _g + ', ' + _b + ')';
	          break;
	        default:
	          this.value = toHex(hsv2rgb(_hue, _saturation, _value));
	      }
	    }
	  };
	
	  return Color;
	}();
	
	/* harmony default export */ var src_color = (Color);
	;
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/picker-dropdown.vue?vue&type=template&id=06601625&
	var picker_dropdownvue_type_template_id_06601625_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    { attrs: { name: "el-zoom-in-top" }, on: { "after-leave": _vm.doDestroy } },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.showPopper,
	              expression: "showPopper"
	            }
	          ],
	          staticClass: "el-color-dropdown"
	        },
	        [
	          _c(
	            "div",
	            { staticClass: "el-color-dropdown__main-wrapper" },
	            [
	              _c("hue-slider", {
	                ref: "hue",
	                staticStyle: { float: "right" },
	                attrs: { color: _vm.color, vertical: "" }
	              }),
	              _c("sv-panel", { ref: "sl", attrs: { color: _vm.color } })
	            ],
	            1
	          ),
	          _vm.showAlpha
	            ? _c("alpha-slider", { ref: "alpha", attrs: { color: _vm.color } })
	            : _vm._e(),
	          _vm.predefine
	            ? _c("predefine", {
	                attrs: { color: _vm.color, colors: _vm.predefine }
	              })
	            : _vm._e(),
	          _c(
	            "div",
	            { staticClass: "el-color-dropdown__btns" },
	            [
	              _c(
	                "span",
	                { staticClass: "el-color-dropdown__value" },
	                [
	                  _c("el-input", {
	                    attrs: { "validate-event": false, size: "mini" },
	                    on: { blur: _vm.handleConfirm },
	                    nativeOn: {
	                      keyup: function($event) {
	                        if (
	                          !("button" in $event) &&
	                          _vm._k(
	                            $event.keyCode,
	                            "enter",
	                            13,
	                            $event.key,
	                            "Enter"
	                          )
	                        ) {
	                          return null
	                        }
	                        return _vm.handleConfirm($event)
	                      }
	                    },
	                    model: {
	                      value: _vm.customInput,
	                      callback: function($$v) {
	                        _vm.customInput = $$v
	                      },
	                      expression: "customInput"
	                    }
	                  })
	                ],
	                1
	              ),
	              _c(
	                "el-button",
	                {
	                  staticClass: "el-color-dropdown__link-btn",
	                  attrs: { size: "mini", type: "text" },
	                  on: {
	                    click: function($event) {
	                      _vm.$emit("clear")
	                    }
	                  }
	                },
	                [
	                  _vm._v(
	                    "\n        " +
	                      _vm._s(_vm.t("el.colorpicker.clear")) +
	                      "\n      "
	                  )
	                ]
	              ),
	              _c(
	                "el-button",
	                {
	                  staticClass: "el-color-dropdown__btn",
	                  attrs: { plain: "", size: "mini" },
	                  on: { click: _vm.confirmValue }
	                },
	                [
	                  _vm._v(
	                    "\n        " +
	                      _vm._s(_vm.t("el.colorpicker.confirm")) +
	                      "\n      "
	                  )
	                ]
	              )
	            ],
	            1
	          )
	        ],
	        1
	      )
	    ]
	  )
	}
	var picker_dropdownvue_type_template_id_06601625_staticRenderFns = []
	picker_dropdownvue_type_template_id_06601625_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/color-picker/src/components/picker-dropdown.vue?vue&type=template&id=06601625&
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/sv-panel.vue?vue&type=template&id=d8583596&
	var sv_panelvue_type_template_id_d8583596_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-color-svpanel",
	      style: {
	        backgroundColor: _vm.background
	      }
	    },
	    [
	      _c("div", { staticClass: "el-color-svpanel__white" }),
	      _c("div", { staticClass: "el-color-svpanel__black" }),
	      _c(
	        "div",
	        {
	          staticClass: "el-color-svpanel__cursor",
	          style: {
	            top: _vm.cursorTop + "px",
	            left: _vm.cursorLeft + "px"
	          }
	        },
	        [_c("div")]
	      )
	    ]
	  )
	}
	var sv_panelvue_type_template_id_d8583596_staticRenderFns = []
	sv_panelvue_type_template_id_d8583596_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/color-picker/src/components/sv-panel.vue?vue&type=template&id=d8583596&
	
	// CONCATENATED MODULE: ./packages/color-picker/src/draggable.js
	
	var isDragging = false;
	
	/* harmony default export */ var draggable = (function (element, options) {
	  if (external_vue_default.a.prototype.$isServer) return;
	  var moveFn = function moveFn(event) {
	    if (options.drag) {
	      options.drag(event);
	    }
	  };
	  var upFn = function upFn(event) {
	    document.removeEventListener('mousemove', moveFn);
	    document.removeEventListener('mouseup', upFn);
	    document.onselectstart = null;
	    document.ondragstart = null;
	
	    isDragging = false;
	
	    if (options.end) {
	      options.end(event);
	    }
	  };
	  element.addEventListener('mousedown', function (event) {
	    if (isDragging) return;
	    document.onselectstart = function () {
	      return false;
	    };
	    document.ondragstart = function () {
	      return false;
	    };
	
	    document.addEventListener('mousemove', moveFn);
	    document.addEventListener('mouseup', upFn);
	    isDragging = true;
	
	    if (options.start) {
	      options.start(event);
	    }
	  });
	});
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/sv-panel.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var sv_panelvue_type_script_lang_js_ = ({
	  name: 'el-sl-panel',
	
	  props: {
	    color: {
	      required: true
	    }
	  },
	
	  computed: {
	    colorValue: function colorValue() {
	      var hue = this.color.get('hue');
	      var value = this.color.get('value');
	      return { hue: hue, value: value };
	    }
	  },
	
	  watch: {
	    colorValue: function colorValue() {
	      this.update();
	    }
	  },
	
	  methods: {
	    update: function update() {
	      var saturation = this.color.get('saturation');
	      var value = this.color.get('value');
	
	      var el = this.$el;
	      var width = el.clientWidth,
	          height = el.clientHeight;
	
	
	      this.cursorLeft = saturation * width / 100;
	      this.cursorTop = (100 - value) * height / 100;
	
	      this.background = 'hsl(' + this.color.get('hue') + ', 100%, 50%)';
	    },
	    handleDrag: function handleDrag(event) {
	      var el = this.$el;
	      var rect = el.getBoundingClientRect();
	
	      var left = event.clientX - rect.left;
	      var top = event.clientY - rect.top;
	      left = Math.max(0, left);
	      left = Math.min(left, rect.width);
	
	      top = Math.max(0, top);
	      top = Math.min(top, rect.height);
	
	      this.cursorLeft = left;
	      this.cursorTop = top;
	      this.color.set({
	        saturation: left / rect.width * 100,
	        value: 100 - top / rect.height * 100
	      });
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    draggable(this.$el, {
	      drag: function drag(event) {
	        _this.handleDrag(event);
	      },
	      end: function end(event) {
	        _this.handleDrag(event);
	      }
	    });
	
	    this.update();
	  },
	  data: function data() {
	    return {
	      cursorTop: 0,
	      cursorLeft: 0,
	      background: 'hsl(0, 100%, 50%)'
	    };
	  }
	});
	// CONCATENATED MODULE: ./packages/color-picker/src/components/sv-panel.vue?vue&type=script&lang=js&
	 /* harmony default export */ var components_sv_panelvue_type_script_lang_js_ = (sv_panelvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/color-picker/src/components/sv-panel.vue
	
	
	
	
	
	/* normalize component */
	
	var sv_panel_component = normalizeComponent(
	  components_sv_panelvue_type_script_lang_js_,
	  sv_panelvue_type_template_id_d8583596_render,
	  sv_panelvue_type_template_id_d8583596_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var sv_panel_api; }
	sv_panel_component.options.__file = "packages/color-picker/src/components/sv-panel.vue"
	/* harmony default export */ var sv_panel = (sv_panel_component.exports);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/hue-slider.vue?vue&type=template&id=5cdc43b1&
	var hue_slidervue_type_template_id_5cdc43b1_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-color-hue-slider",
	      class: { "is-vertical": _vm.vertical }
	    },
	    [
	      _c("div", {
	        ref: "bar",
	        staticClass: "el-color-hue-slider__bar",
	        on: { click: _vm.handleClick }
	      }),
	      _c("div", {
	        ref: "thumb",
	        staticClass: "el-color-hue-slider__thumb",
	        style: {
	          left: _vm.thumbLeft + "px",
	          top: _vm.thumbTop + "px"
	        }
	      })
	    ]
	  )
	}
	var hue_slidervue_type_template_id_5cdc43b1_staticRenderFns = []
	hue_slidervue_type_template_id_5cdc43b1_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/color-picker/src/components/hue-slider.vue?vue&type=template&id=5cdc43b1&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/hue-slider.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var hue_slidervue_type_script_lang_js_ = ({
	  name: 'el-color-hue-slider',
	
	  props: {
	    color: {
	      required: true
	    },
	
	    vertical: Boolean
	  },
	
	  data: function data() {
	    return {
	      thumbLeft: 0,
	      thumbTop: 0
	    };
	  },
	
	
	  computed: {
	    hueValue: function hueValue() {
	      var hue = this.color.get('hue');
	      return hue;
	    }
	  },
	
	  watch: {
	    hueValue: function hueValue() {
	      this.update();
	    }
	  },
	
	  methods: {
	    handleClick: function handleClick(event) {
	      var thumb = this.$refs.thumb;
	      var target = event.target;
	
	      if (target !== thumb) {
	        this.handleDrag(event);
	      }
	    },
	    handleDrag: function handleDrag(event) {
	      var rect = this.$el.getBoundingClientRect();
	      var thumb = this.$refs.thumb;
	
	      var hue = void 0;
	
	      if (!this.vertical) {
	        var left = event.clientX - rect.left;
	        left = Math.min(left, rect.width - thumb.offsetWidth / 2);
	        left = Math.max(thumb.offsetWidth / 2, left);
	
	        hue = Math.round((left - thumb.offsetWidth / 2) / (rect.width - thumb.offsetWidth) * 360);
	      } else {
	        var top = event.clientY - rect.top;
	        top = Math.min(top, rect.height - thumb.offsetHeight / 2);
	        top = Math.max(thumb.offsetHeight / 2, top);
	
	        hue = Math.round((top - thumb.offsetHeight / 2) / (rect.height - thumb.offsetHeight) * 360);
	      }
	
	      this.color.set('hue', hue);
	    },
	    getThumbLeft: function getThumbLeft() {
	      if (this.vertical) return 0;
	      var el = this.$el;
	      var hue = this.color.get('hue');
	
	      if (!el) return 0;
	      var thumb = this.$refs.thumb;
	      return Math.round(hue * (el.offsetWidth - thumb.offsetWidth / 2) / 360);
	    },
	    getThumbTop: function getThumbTop() {
	      if (!this.vertical) return 0;
	      var el = this.$el;
	      var hue = this.color.get('hue');
	
	      if (!el) return 0;
	      var thumb = this.$refs.thumb;
	      return Math.round(hue * (el.offsetHeight - thumb.offsetHeight / 2) / 360);
	    },
	    update: function update() {
	      this.thumbLeft = this.getThumbLeft();
	      this.thumbTop = this.getThumbTop();
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    var _$refs = this.$refs,
	        bar = _$refs.bar,
	        thumb = _$refs.thumb;
	
	
	    var dragConfig = {
	      drag: function drag(event) {
	        _this.handleDrag(event);
	      },
	      end: function end(event) {
	        _this.handleDrag(event);
	      }
	    };
	
	    draggable(bar, dragConfig);
	    draggable(thumb, dragConfig);
	    this.update();
	  }
	});
	// CONCATENATED MODULE: ./packages/color-picker/src/components/hue-slider.vue?vue&type=script&lang=js&
	 /* harmony default export */ var components_hue_slidervue_type_script_lang_js_ = (hue_slidervue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/color-picker/src/components/hue-slider.vue
	
	
	
	
	
	/* normalize component */
	
	var hue_slider_component = normalizeComponent(
	  components_hue_slidervue_type_script_lang_js_,
	  hue_slidervue_type_template_id_5cdc43b1_render,
	  hue_slidervue_type_template_id_5cdc43b1_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var hue_slider_api; }
	hue_slider_component.options.__file = "packages/color-picker/src/components/hue-slider.vue"
	/* harmony default export */ var hue_slider = (hue_slider_component.exports);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/alpha-slider.vue?vue&type=template&id=068c66cb&
	var alpha_slidervue_type_template_id_068c66cb_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-color-alpha-slider",
	      class: { "is-vertical": _vm.vertical }
	    },
	    [
	      _c("div", {
	        ref: "bar",
	        staticClass: "el-color-alpha-slider__bar",
	        style: {
	          background: _vm.background
	        },
	        on: { click: _vm.handleClick }
	      }),
	      _c("div", {
	        ref: "thumb",
	        staticClass: "el-color-alpha-slider__thumb",
	        style: {
	          left: _vm.thumbLeft + "px",
	          top: _vm.thumbTop + "px"
	        }
	      })
	    ]
	  )
	}
	var alpha_slidervue_type_template_id_068c66cb_staticRenderFns = []
	alpha_slidervue_type_template_id_068c66cb_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/color-picker/src/components/alpha-slider.vue?vue&type=template&id=068c66cb&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/alpha-slider.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var alpha_slidervue_type_script_lang_js_ = ({
	  name: 'el-color-alpha-slider',
	
	  props: {
	    color: {
	      required: true
	    },
	    vertical: Boolean
	  },
	
	  watch: {
	    'color._alpha': function color_alpha() {
	      this.update();
	    },
	    'color.value': function colorValue() {
	      this.update();
	    }
	  },
	
	  methods: {
	    handleClick: function handleClick(event) {
	      var thumb = this.$refs.thumb;
	      var target = event.target;
	
	      if (target !== thumb) {
	        this.handleDrag(event);
	      }
	    },
	    handleDrag: function handleDrag(event) {
	      var rect = this.$el.getBoundingClientRect();
	      var thumb = this.$refs.thumb;
	
	
	      if (!this.vertical) {
	        var left = event.clientX - rect.left;
	        left = Math.max(thumb.offsetWidth / 2, left);
	        left = Math.min(left, rect.width - thumb.offsetWidth / 2);
	
	        this.color.set('alpha', Math.round((left - thumb.offsetWidth / 2) / (rect.width - thumb.offsetWidth) * 100));
	      } else {
	        var top = event.clientY - rect.top;
	        top = Math.max(thumb.offsetHeight / 2, top);
	        top = Math.min(top, rect.height - thumb.offsetHeight / 2);
	
	        this.color.set('alpha', Math.round((top - thumb.offsetHeight / 2) / (rect.height - thumb.offsetHeight) * 100));
	      }
	    },
	    getThumbLeft: function getThumbLeft() {
	      if (this.vertical) return 0;
	      var el = this.$el;
	      var alpha = this.color._alpha;
	
	      if (!el) return 0;
	      var thumb = this.$refs.thumb;
	      return Math.round(alpha * (el.offsetWidth - thumb.offsetWidth / 2) / 100);
	    },
	    getThumbTop: function getThumbTop() {
	      if (!this.vertical) return 0;
	      var el = this.$el;
	      var alpha = this.color._alpha;
	
	      if (!el) return 0;
	      var thumb = this.$refs.thumb;
	      return Math.round(alpha * (el.offsetHeight - thumb.offsetHeight / 2) / 100);
	    },
	    getBackground: function getBackground() {
	      if (this.color && this.color.value) {
	        var _color$toRgb = this.color.toRgb(),
	            r = _color$toRgb.r,
	            g = _color$toRgb.g,
	            b = _color$toRgb.b;
	
	        return 'linear-gradient(to right, rgba(' + r + ', ' + g + ', ' + b + ', 0) 0%, rgba(' + r + ', ' + g + ', ' + b + ', 1) 100%)';
	      }
	      return null;
	    },
	    update: function update() {
	      this.thumbLeft = this.getThumbLeft();
	      this.thumbTop = this.getThumbTop();
	      this.background = this.getBackground();
	    }
	  },
	
	  data: function data() {
	    return {
	      thumbLeft: 0,
	      thumbTop: 0,
	      background: null
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var _$refs = this.$refs,
	        bar = _$refs.bar,
	        thumb = _$refs.thumb;
	
	
	    var dragConfig = {
	      drag: function drag(event) {
	        _this.handleDrag(event);
	      },
	      end: function end(event) {
	        _this.handleDrag(event);
	      }
	    };
	
	    draggable(bar, dragConfig);
	    draggable(thumb, dragConfig);
	    this.update();
	  }
	});
	// CONCATENATED MODULE: ./packages/color-picker/src/components/alpha-slider.vue?vue&type=script&lang=js&
	 /* harmony default export */ var components_alpha_slidervue_type_script_lang_js_ = (alpha_slidervue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/color-picker/src/components/alpha-slider.vue
	
	
	
	
	
	/* normalize component */
	
	var alpha_slider_component = normalizeComponent(
	  components_alpha_slidervue_type_script_lang_js_,
	  alpha_slidervue_type_template_id_068c66cb_render,
	  alpha_slidervue_type_template_id_068c66cb_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var alpha_slider_api; }
	alpha_slider_component.options.__file = "packages/color-picker/src/components/alpha-slider.vue"
	/* harmony default export */ var alpha_slider = (alpha_slider_component.exports);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/predefine.vue?vue&type=template&id=06e03093&
	var predefinevue_type_template_id_06e03093_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("div", { staticClass: "el-color-predefine" }, [
	    _c(
	      "div",
	      { staticClass: "el-color-predefine__colors" },
	      _vm._l(_vm.rgbaColors, function(item, index) {
	        return _c(
	          "div",
	          {
	            key: _vm.colors[index],
	            staticClass: "el-color-predefine__color-selector",
	            class: { selected: item.selected, "is-alpha": item._alpha < 100 },
	            on: {
	              click: function($event) {
	                _vm.handleSelect(index)
	              }
	            }
	          },
	          [_c("div", { style: { "background-color": item.value } })]
	        )
	      }),
	      0
	    )
	  ])
	}
	var predefinevue_type_template_id_06e03093_staticRenderFns = []
	predefinevue_type_template_id_06e03093_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/color-picker/src/components/predefine.vue?vue&type=template&id=06e03093&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/predefine.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var predefinevue_type_script_lang_js_ = ({
	  props: {
	    colors: { type: Array, required: true },
	    color: { required: true }
	  },
	  data: function data() {
	    return {
	      rgbaColors: this.parseColors(this.colors, this.color)
	    };
	  },
	
	  methods: {
	    handleSelect: function handleSelect(index) {
	      this.color.fromString(this.colors[index]);
	    },
	    parseColors: function parseColors(colors, color) {
	      return colors.map(function (value) {
	        var c = new src_color();
	        c.enableAlpha = true;
	        c.format = 'rgba';
	        c.fromString(value);
	        c.selected = c.value === color.value;
	        return c;
	      });
	    }
	  },
	  watch: {
	    '$parent.currentColor': function $parentCurrentColor(val) {
	      var color = new src_color();
	      color.fromString(val);
	
	      this.rgbaColors.forEach(function (item) {
	        item.selected = color.compare(item);
	      });
	    },
	    colors: function colors(newVal) {
	      this.rgbaColors = this.parseColors(newVal, this.color);
	    },
	    color: function color(newVal) {
	      this.rgbaColors = this.parseColors(this.colors, newVal);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/color-picker/src/components/predefine.vue?vue&type=script&lang=js&
	 /* harmony default export */ var components_predefinevue_type_script_lang_js_ = (predefinevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/color-picker/src/components/predefine.vue
	
	
	
	
	
	/* normalize component */
	
	var predefine_component = normalizeComponent(
	  components_predefinevue_type_script_lang_js_,
	  predefinevue_type_template_id_06e03093_render,
	  predefinevue_type_template_id_06e03093_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var predefine_api; }
	predefine_component.options.__file = "packages/color-picker/src/components/predefine.vue"
	/* harmony default export */ var predefine = (predefine_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/picker-dropdown.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	
	/* harmony default export */ var picker_dropdownvue_type_script_lang_js_ = ({
	  name: 'el-color-picker-dropdown',
	
	  mixins: [vue_popper_default.a, locale_default.a],
	
	  components: {
	    SvPanel: sv_panel,
	    HueSlider: hue_slider,
	    AlphaSlider: alpha_slider,
	    ElInput: input_default.a,
	    ElButton: button_default.a,
	    Predefine: predefine
	  },
	
	  props: {
	    color: {
	      required: true
	    },
	    showAlpha: Boolean,
	    predefine: Array
	  },
	
	  data: function data() {
	    return {
	      customInput: ''
	    };
	  },
	
	
	  computed: {
	    currentColor: function currentColor() {
	      var parent = this.$parent;
	      return !parent.value && !parent.showPanelColor ? '' : parent.color.value;
	    }
	  },
	
	  methods: {
	    confirmValue: function confirmValue() {
	      this.$emit('pick');
	    },
	    handleConfirm: function handleConfirm() {
	      this.color.fromString(this.customInput);
	    }
	  },
	
	  mounted: function mounted() {
	    this.$parent.popperElm = this.popperElm = this.$el;
	    this.referenceElm = this.$parent.$el;
	  },
	
	
	  watch: {
	    showPopper: function showPopper(val) {
	      var _this = this;
	
	      if (val === true) {
	        this.$nextTick(function () {
	          var _$refs = _this.$refs,
	              sl = _$refs.sl,
	              hue = _$refs.hue,
	              alpha = _$refs.alpha;
	
	          sl && sl.update();
	          hue && hue.update();
	          alpha && alpha.update();
	        });
	      }
	    },
	
	
	    currentColor: {
	      immediate: true,
	      handler: function handler(val) {
	        this.customInput = val;
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/color-picker/src/components/picker-dropdown.vue?vue&type=script&lang=js&
	 /* harmony default export */ var components_picker_dropdownvue_type_script_lang_js_ = (picker_dropdownvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/color-picker/src/components/picker-dropdown.vue
	
	
	
	
	
	/* normalize component */
	
	var picker_dropdown_component = normalizeComponent(
	  components_picker_dropdownvue_type_script_lang_js_,
	  picker_dropdownvue_type_template_id_06601625_render,
	  picker_dropdownvue_type_template_id_06601625_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var picker_dropdown_api; }
	picker_dropdown_component.options.__file = "packages/color-picker/src/components/picker-dropdown.vue"
	/* harmony default export */ var picker_dropdown = (picker_dropdown_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	/* harmony default export */ var color_picker_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElColorPicker',
	
	  mixins: [emitter_default.a],
	
	  props: {
	    value: String,
	    showAlpha: Boolean,
	    colorFormat: String,
	    disabled: Boolean,
	    size: String,
	    popperClass: String,
	    predefine: Array
	  },
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  directives: { Clickoutside: clickoutside_default.a },
	
	  computed: {
	    displayedColor: function displayedColor() {
	      if (!this.value && !this.showPanelColor) {
	        return 'transparent';
	      }
	
	      return this.displayedRgb(this.color, this.showAlpha);
	    },
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    colorSize: function colorSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    colorDisabled: function colorDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    }
	  },
	
	  watch: {
	    value: function value(val) {
	      if (!val) {
	        this.showPanelColor = false;
	      } else if (val && val !== this.color.value) {
	        this.color.fromString(val);
	      }
	    },
	
	    color: {
	      deep: true,
	      handler: function handler() {
	        this.showPanelColor = true;
	      }
	    },
	    displayedColor: function displayedColor(val) {
	      if (!this.showPicker) return;
	      var currentValueColor = new src_color({
	        enableAlpha: this.showAlpha,
	        format: this.colorFormat
	      });
	      currentValueColor.fromString(this.value);
	
	      var currentValueColorRgb = this.displayedRgb(currentValueColor, this.showAlpha);
	      if (val !== currentValueColorRgb) {
	        this.$emit('active-change', val);
	      }
	    }
	  },
	
	  methods: {
	    handleTrigger: function handleTrigger() {
	      if (this.colorDisabled) return;
	      this.showPicker = !this.showPicker;
	    },
	    confirmValue: function confirmValue() {
	      var value = this.color.value;
	      this.$emit('input', value);
	      this.$emit('change', value);
	      this.dispatch('ElFormItem', 'el.form.change', value);
	      this.showPicker = false;
	    },
	    clearValue: function clearValue() {
	      this.$emit('input', null);
	      this.$emit('change', null);
	      if (this.value !== null) {
	        this.dispatch('ElFormItem', 'el.form.change', null);
	      }
	      this.showPanelColor = false;
	      this.showPicker = false;
	      this.resetColor();
	    },
	    hide: function hide() {
	      this.showPicker = false;
	      this.resetColor();
	    },
	    resetColor: function resetColor() {
	      var _this = this;
	
	      this.$nextTick(function (_) {
	        if (_this.value) {
	          _this.color.fromString(_this.value);
	        } else {
	          _this.showPanelColor = false;
	        }
	      });
	    },
	    displayedRgb: function displayedRgb(color, showAlpha) {
	      if (!(color instanceof src_color)) {
	        throw Error('color should be instance of Color Class');
	      }
	
	      var _color$toRgb = color.toRgb(),
	          r = _color$toRgb.r,
	          g = _color$toRgb.g,
	          b = _color$toRgb.b;
	
	      return showAlpha ? 'rgba(' + r + ', ' + g + ', ' + b + ', ' + color.get('alpha') / 100 + ')' : 'rgb(' + r + ', ' + g + ', ' + b + ')';
	    }
	  },
	
	  mounted: function mounted() {
	    var value = this.value;
	    if (value) {
	      this.color.fromString(value);
	    }
	    this.popperElm = this.$refs.dropdown.$el;
	  },
	  data: function data() {
	    var color = new src_color({
	      enableAlpha: this.showAlpha,
	      format: this.colorFormat
	    });
	
	    return {
	      color: color,
	      showPicker: false,
	      showPanelColor: false
	    };
	  },
	
	
	  components: {
	    PickerDropdown: picker_dropdown
	  }
	});
	// CONCATENATED MODULE: ./packages/color-picker/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_color_picker_src_mainvue_type_script_lang_js_ = (color_picker_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/color-picker/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var color_picker_src_main_component = normalizeComponent(
	  packages_color_picker_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_55c8ade7_render,
	  mainvue_type_template_id_55c8ade7_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var color_picker_src_main_api; }
	color_picker_src_main_component.options.__file = "packages/color-picker/src/main.vue"
	/* harmony default export */ var color_picker_src_main = (color_picker_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/color-picker/index.js
	
	
	/* istanbul ignore next */
	color_picker_src_main.install = function (Vue) {
	  Vue.component(color_picker_src_main.name, color_picker_src_main);
	};
	
	/* harmony default export */ var color_picker = (color_picker_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/transfer/src/main.vue?vue&type=template&id=5c654dd8&
	var mainvue_type_template_id_5c654dd8_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    { staticClass: "el-transfer" },
	    [
	      _c(
	        "transfer-panel",
	        _vm._b(
	          {
	            ref: "leftPanel",
	            attrs: {
	              data: _vm.sourceData,
	              title: _vm.titles[0] || _vm.t("el.transfer.titles.0"),
	              "default-checked": _vm.leftDefaultChecked,
	              placeholder:
	                _vm.filterPlaceholder || _vm.t("el.transfer.filterPlaceholder")
	            },
	            on: { "checked-change": _vm.onSourceCheckedChange }
	          },
	          "transfer-panel",
	          _vm.$props,
	          false
	        ),
	        [_vm._t("left-footer")],
	        2
	      ),
	      _c(
	        "div",
	        { staticClass: "el-transfer__buttons" },
	        [
	          _c(
	            "el-button",
	            {
	              class: [
	                "el-transfer__button",
	                _vm.hasButtonTexts ? "is-with-texts" : ""
	              ],
	              attrs: {
	                type: "primary",
	                disabled: _vm.rightChecked.length === 0
	              },
	              nativeOn: {
	                click: function($event) {
	                  return _vm.addToLeft($event)
	                }
	              }
	            },
	            [
	              _c("i", { staticClass: "el-icon-arrow-left" }),
	              _vm.buttonTexts[0] !== undefined
	                ? _c("span", [_vm._v(_vm._s(_vm.buttonTexts[0]))])
	                : _vm._e()
	            ]
	          ),
	          _c(
	            "el-button",
	            {
	              class: [
	                "el-transfer__button",
	                _vm.hasButtonTexts ? "is-with-texts" : ""
	              ],
	              attrs: {
	                type: "primary",
	                disabled: _vm.leftChecked.length === 0
	              },
	              nativeOn: {
	                click: function($event) {
	                  return _vm.addToRight($event)
	                }
	              }
	            },
	            [
	              _vm.buttonTexts[1] !== undefined
	                ? _c("span", [_vm._v(_vm._s(_vm.buttonTexts[1]))])
	                : _vm._e(),
	              _c("i", { staticClass: "el-icon-arrow-right" })
	            ]
	          )
	        ],
	        1
	      ),
	      _c(
	        "transfer-panel",
	        _vm._b(
	          {
	            ref: "rightPanel",
	            attrs: {
	              data: _vm.targetData,
	              title: _vm.titles[1] || _vm.t("el.transfer.titles.1"),
	              "default-checked": _vm.rightDefaultChecked,
	              placeholder:
	                _vm.filterPlaceholder || _vm.t("el.transfer.filterPlaceholder")
	            },
	            on: { "checked-change": _vm.onTargetCheckedChange }
	          },
	          "transfer-panel",
	          _vm.$props,
	          false
	        ),
	        [_vm._t("right-footer")],
	        2
	      )
	    ],
	    1
	  )
	}
	var mainvue_type_template_id_5c654dd8_staticRenderFns = []
	mainvue_type_template_id_5c654dd8_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/transfer/src/main.vue?vue&type=template&id=5c654dd8&
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/transfer/src/transfer-panel.vue?vue&type=template&id=2ddab8bd&
	var transfer_panelvue_type_template_id_2ddab8bd_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("div", { staticClass: "el-transfer-panel" }, [
	    _c(
	      "p",
	      { staticClass: "el-transfer-panel__header" },
	      [
	        _c(
	          "el-checkbox",
	          {
	            attrs: { indeterminate: _vm.isIndeterminate },
	            on: { change: _vm.handleAllCheckedChange },
	            model: {
	              value: _vm.allChecked,
	              callback: function($$v) {
	                _vm.allChecked = $$v
	              },
	              expression: "allChecked"
	            }
	          },
	          [
	            _vm._v("\n      " + _vm._s(_vm.title) + "\n      "),
	            _c("span", [_vm._v(_vm._s(_vm.checkedSummary))])
	          ]
	        )
	      ],
	      1
	    ),
	    _c(
	      "div",
	      {
	        class: [
	          "el-transfer-panel__body",
	          _vm.hasFooter ? "is-with-footer" : ""
	        ]
	      },
	      [
	        _vm.filterable
	          ? _c(
	              "el-input",
	              {
	                staticClass: "el-transfer-panel__filter",
	                attrs: { size: "small", placeholder: _vm.placeholder },
	                nativeOn: {
	                  mouseenter: function($event) {
	                    _vm.inputHover = true
	                  },
	                  mouseleave: function($event) {
	                    _vm.inputHover = false
	                  }
	                },
	                model: {
	                  value: _vm.query,
	                  callback: function($$v) {
	                    _vm.query = $$v
	                  },
	                  expression: "query"
	                }
	              },
	              [
	                _c("i", {
	                  class: ["el-input__icon", "el-icon-" + _vm.inputIcon],
	                  attrs: { slot: "prefix" },
	                  on: { click: _vm.clearQuery },
	                  slot: "prefix"
	                })
	              ]
	            )
	          : _vm._e(),
	        _c(
	          "el-checkbox-group",
	          {
	            directives: [
	              {
	                name: "show",
	                rawName: "v-show",
	                value: !_vm.hasNoMatch && _vm.data.length > 0,
	                expression: "!hasNoMatch && data.length > 0"
	              }
	            ],
	            staticClass: "el-transfer-panel__list",
	            class: { "is-filterable": _vm.filterable },
	            model: {
	              value: _vm.checked,
	              callback: function($$v) {
	                _vm.checked = $$v
	              },
	              expression: "checked"
	            }
	          },
	          _vm._l(_vm.filteredData, function(item) {
	            return _c(
	              "el-checkbox",
	              {
	                key: item[_vm.keyProp],
	                staticClass: "el-transfer-panel__item",
	                attrs: {
	                  label: item[_vm.keyProp],
	                  disabled: item[_vm.disabledProp]
	                }
	              },
	              [_c("option-content", { attrs: { option: item } })],
	              1
	            )
	          }),
	          1
	        ),
	        _c(
	          "p",
	          {
	            directives: [
	              {
	                name: "show",
	                rawName: "v-show",
	                value: _vm.hasNoMatch,
	                expression: "hasNoMatch"
	              }
	            ],
	            staticClass: "el-transfer-panel__empty"
	          },
	          [_vm._v(_vm._s(_vm.t("el.transfer.noMatch")))]
	        ),
	        _c(
	          "p",
	          {
	            directives: [
	              {
	                name: "show",
	                rawName: "v-show",
	                value: _vm.data.length === 0 && !_vm.hasNoMatch,
	                expression: "data.length === 0 && !hasNoMatch"
	              }
	            ],
	            staticClass: "el-transfer-panel__empty"
	          },
	          [_vm._v(_vm._s(_vm.t("el.transfer.noData")))]
	        )
	      ],
	      1
	    ),
	    _vm.hasFooter
	      ? _c(
	          "p",
	          { staticClass: "el-transfer-panel__footer" },
	          [_vm._t("default")],
	          2
	        )
	      : _vm._e()
	  ])
	}
	var transfer_panelvue_type_template_id_2ddab8bd_staticRenderFns = []
	transfer_panelvue_type_template_id_2ddab8bd_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/transfer/src/transfer-panel.vue?vue&type=template&id=2ddab8bd&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/transfer/src/transfer-panel.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	/* harmony default export */ var transfer_panelvue_type_script_lang_js_ = ({
	  mixins: [locale_default.a],
	
	  name: 'ElTransferPanel',
	
	  componentName: 'ElTransferPanel',
	
	  components: {
	    ElCheckboxGroup: checkbox_group_default.a,
	    ElCheckbox: checkbox_default.a,
	    ElInput: input_default.a,
	    OptionContent: {
	      props: {
	        option: Object
	      },
	      render: function render(h) {
	        var getParent = function getParent(vm) {
	          if (vm.$options.componentName === 'ElTransferPanel') {
	            return vm;
	          } else if (vm.$parent) {
	            return getParent(vm.$parent);
	          } else {
	            return vm;
	          }
	        };
	        var panel = getParent(this);
	        var transfer = panel.$parent || panel;
	        return panel.renderContent ? panel.renderContent(h, this.option) : transfer.$scopedSlots.default ? transfer.$scopedSlots.default({ option: this.option }) : h('span', [this.option[panel.labelProp] || this.option[panel.keyProp]]);
	      }
	    }
	  },
	
	  props: {
	    data: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    renderContent: Function,
	    placeholder: String,
	    title: String,
	    filterable: Boolean,
	    format: Object,
	    filterMethod: Function,
	    defaultChecked: Array,
	    props: Object
	  },
	
	  data: function data() {
	    return {
	      checked: [],
	      allChecked: false,
	      query: '',
	      inputHover: false,
	      checkChangeByUser: true
	    };
	  },
	
	
	  watch: {
	    checked: function checked(val, oldVal) {
	      this.updateAllChecked();
	      if (this.checkChangeByUser) {
	        var movedKeys = val.concat(oldVal).filter(function (v) {
	          return val.indexOf(v) === -1 || oldVal.indexOf(v) === -1;
	        });
	        this.$emit('checked-change', val, movedKeys);
	      } else {
	        this.$emit('checked-change', val);
	        this.checkChangeByUser = true;
	      }
	    },
	    data: function data() {
	      var _this = this;
	
	      var checked = [];
	      var filteredDataKeys = this.filteredData.map(function (item) {
	        return item[_this.keyProp];
	      });
	      this.checked.forEach(function (item) {
	        if (filteredDataKeys.indexOf(item) > -1) {
	          checked.push(item);
	        }
	      });
	      this.checkChangeByUser = false;
	      this.checked = checked;
	    },
	    checkableData: function checkableData() {
	      this.updateAllChecked();
	    },
	
	
	    defaultChecked: {
	      immediate: true,
	      handler: function handler(val, oldVal) {
	        var _this2 = this;
	
	        if (oldVal && val.length === oldVal.length && val.every(function (item) {
	          return oldVal.indexOf(item) > -1;
	        })) return;
	        var checked = [];
	        var checkableDataKeys = this.checkableData.map(function (item) {
	          return item[_this2.keyProp];
	        });
	        val.forEach(function (item) {
	          if (checkableDataKeys.indexOf(item) > -1) {
	            checked.push(item);
	          }
	        });
	        this.checkChangeByUser = false;
	        this.checked = checked;
	      }
	    }
	  },
	
	  computed: {
	    filteredData: function filteredData() {
	      var _this3 = this;
	
	      return this.data.filter(function (item) {
	        if (typeof _this3.filterMethod === 'function') {
	          return _this3.filterMethod(_this3.query, item);
	        } else {
	          var label = item[_this3.labelProp] || item[_this3.keyProp].toString();
	          return label.toLowerCase().indexOf(_this3.query.toLowerCase()) > -1;
	        }
	      });
	    },
	    checkableData: function checkableData() {
	      var _this4 = this;
	
	      return this.filteredData.filter(function (item) {
	        return !item[_this4.disabledProp];
	      });
	    },
	    checkedSummary: function checkedSummary() {
	      var checkedLength = this.checked.length;
	      var dataLength = this.data.length;
	      var _format = this.format,
	          noChecked = _format.noChecked,
	          hasChecked = _format.hasChecked;
	
	      if (noChecked && hasChecked) {
	        return checkedLength > 0 ? hasChecked.replace(/\${checked}/g, checkedLength).replace(/\${total}/g, dataLength) : noChecked.replace(/\${total}/g, dataLength);
	      } else {
	        return checkedLength + '/' + dataLength;
	      }
	    },
	    isIndeterminate: function isIndeterminate() {
	      var checkedLength = this.checked.length;
	      return checkedLength > 0 && checkedLength < this.checkableData.length;
	    },
	    hasNoMatch: function hasNoMatch() {
	      return this.query.length > 0 && this.filteredData.length === 0;
	    },
	    inputIcon: function inputIcon() {
	      return this.query.length > 0 && this.inputHover ? 'circle-close' : 'search';
	    },
	    labelProp: function labelProp() {
	      return this.props.label || 'label';
	    },
	    keyProp: function keyProp() {
	      return this.props.key || 'key';
	    },
	    disabledProp: function disabledProp() {
	      return this.props.disabled || 'disabled';
	    },
	    hasFooter: function hasFooter() {
	      return !!this.$slots.default;
	    }
	  },
	
	  methods: {
	    updateAllChecked: function updateAllChecked() {
	      var _this5 = this;
	
	      var checkableDataKeys = this.checkableData.map(function (item) {
	        return item[_this5.keyProp];
	      });
	      this.allChecked = checkableDataKeys.length > 0 && checkableDataKeys.every(function (item) {
	        return _this5.checked.indexOf(item) > -1;
	      });
	    },
	    handleAllCheckedChange: function handleAllCheckedChange(value) {
	      var _this6 = this;
	
	      this.checked = value ? this.checkableData.map(function (item) {
	        return item[_this6.keyProp];
	      }) : [];
	    },
	    clearQuery: function clearQuery() {
	      if (this.inputIcon === 'circle-close') {
	        this.query = '';
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/transfer/src/transfer-panel.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_transfer_panelvue_type_script_lang_js_ = (transfer_panelvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/transfer/src/transfer-panel.vue
	
	
	
	
	
	/* normalize component */
	
	var transfer_panel_component = normalizeComponent(
	  src_transfer_panelvue_type_script_lang_js_,
	  transfer_panelvue_type_template_id_2ddab8bd_render,
	  transfer_panelvue_type_template_id_2ddab8bd_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var transfer_panel_api; }
	transfer_panel_component.options.__file = "packages/transfer/src/transfer-panel.vue"
	/* harmony default export */ var transfer_panel = (transfer_panel_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/transfer/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	/* harmony default export */ var transfer_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElTransfer',
	
	  mixins: [emitter_default.a, locale_default.a, migrating_default.a],
	
	  components: {
	    TransferPanel: transfer_panel,
	    ElButton: button_default.a
	  },
	
	  props: {
	    data: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    titles: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    buttonTexts: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    filterPlaceholder: {
	      type: String,
	      default: ''
	    },
	    filterMethod: Function,
	    leftDefaultChecked: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    rightDefaultChecked: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    renderContent: Function,
	    value: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    format: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    filterable: Boolean,
	    props: {
	      type: Object,
	      default: function _default() {
	        return {
	          label: 'label',
	          key: 'key',
	          disabled: 'disabled'
	        };
	      }
	    },
	    targetOrder: {
	      type: String,
	      default: 'original'
	    }
	  },
	
	  data: function data() {
	    return {
	      leftChecked: [],
	      rightChecked: []
	    };
	  },
	
	
	  computed: {
	    dataObj: function dataObj() {
	      var key = this.props.key;
	      return this.data.reduce(function (o, cur) {
	        return (o[cur[key]] = cur) && o;
	      }, {});
	    },
	    sourceData: function sourceData() {
	      var _this = this;
	
	      return this.data.filter(function (item) {
	        return _this.value.indexOf(item[_this.props.key]) === -1;
	      });
	    },
	    targetData: function targetData() {
	      var _this2 = this;
	
	      if (this.targetOrder === 'original') {
	        return this.data.filter(function (item) {
	          return _this2.value.indexOf(item[_this2.props.key]) > -1;
	        });
	      } else {
	        return this.value.reduce(function (arr, cur) {
	          var val = _this2.dataObj[cur];
	          if (val) {
	            arr.push(val);
	          }
	          return arr;
	        }, []);
	      }
	    },
	    hasButtonTexts: function hasButtonTexts() {
	      return this.buttonTexts.length === 2;
	    }
	  },
	
	  watch: {
	    value: function value(val) {
	      this.dispatch('ElFormItem', 'el.form.change', val);
	    }
	  },
	
	  methods: {
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'footer-format': 'footer-format is renamed to format.'
	        }
	      };
	    },
	    onSourceCheckedChange: function onSourceCheckedChange(val, movedKeys) {
	      this.leftChecked = val;
	      if (movedKeys === undefined) return;
	      this.$emit('left-check-change', val, movedKeys);
	    },
	    onTargetCheckedChange: function onTargetCheckedChange(val, movedKeys) {
	      this.rightChecked = val;
	      if (movedKeys === undefined) return;
	      this.$emit('right-check-change', val, movedKeys);
	    },
	    addToLeft: function addToLeft() {
	      var currentValue = this.value.slice();
	      this.rightChecked.forEach(function (item) {
	        var index = currentValue.indexOf(item);
	        if (index > -1) {
	          currentValue.splice(index, 1);
	        }
	      });
	      this.$emit('input', currentValue);
	      this.$emit('change', currentValue, 'left', this.rightChecked);
	    },
	    addToRight: function addToRight() {
	      var _this3 = this;
	
	      var currentValue = this.value.slice();
	      var itemsToBeMoved = [];
	      var key = this.props.key;
	      this.data.forEach(function (item) {
	        var itemKey = item[key];
	        if (_this3.leftChecked.indexOf(itemKey) > -1 && _this3.value.indexOf(itemKey) === -1) {
	          itemsToBeMoved.push(itemKey);
	        }
	      });
	      currentValue = this.targetOrder === 'unshift' ? itemsToBeMoved.concat(currentValue) : currentValue.concat(itemsToBeMoved);
	      this.$emit('input', currentValue);
	      this.$emit('change', currentValue, 'right', this.leftChecked);
	    },
	    clearQuery: function clearQuery(which) {
	      if (which === 'left') {
	        this.$refs.leftPanel.query = '';
	      } else if (which === 'right') {
	        this.$refs.rightPanel.query = '';
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/transfer/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_transfer_src_mainvue_type_script_lang_js_ = (transfer_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/transfer/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var transfer_src_main_component = normalizeComponent(
	  packages_transfer_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_5c654dd8_render,
	  mainvue_type_template_id_5c654dd8_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var transfer_src_main_api; }
	transfer_src_main_component.options.__file = "packages/transfer/src/main.vue"
	/* harmony default export */ var transfer_src_main = (transfer_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/transfer/index.js
	
	
	/* istanbul ignore next */
	transfer_src_main.install = function (Vue) {
	  Vue.component(transfer_src_main.name, transfer_src_main);
	};
	
	/* harmony default export */ var transfer = (transfer_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/container/src/main.vue?vue&type=template&id=5bf181d4&
	var mainvue_type_template_id_5bf181d4_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "section",
	    { staticClass: "el-container", class: { "is-vertical": _vm.isVertical } },
	    [_vm._t("default")],
	    2
	  )
	}
	var mainvue_type_template_id_5bf181d4_staticRenderFns = []
	mainvue_type_template_id_5bf181d4_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/container/src/main.vue?vue&type=template&id=5bf181d4&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/container/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var container_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElContainer',
	
	  componentName: 'ElContainer',
	
	  props: {
	    direction: String
	  },
	
	  computed: {
	    isVertical: function isVertical() {
	      if (this.direction === 'vertical') {
	        return true;
	      } else if (this.direction === 'horizontal') {
	        return false;
	      }
	      return this.$slots && this.$slots.default ? this.$slots.default.some(function (vnode) {
	        var tag = vnode.componentOptions && vnode.componentOptions.tag;
	        return tag === 'el-header' || tag === 'el-footer';
	      }) : false;
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/container/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_container_src_mainvue_type_script_lang_js_ = (container_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/container/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var container_src_main_component = normalizeComponent(
	  packages_container_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_5bf181d4_render,
	  mainvue_type_template_id_5bf181d4_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var container_src_main_api; }
	container_src_main_component.options.__file = "packages/container/src/main.vue"
	/* harmony default export */ var container_src_main = (container_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/container/index.js
	
	
	/* istanbul ignore next */
	container_src_main.install = function (Vue) {
	  Vue.component(container_src_main.name, container_src_main);
	};
	
	/* harmony default export */ var packages_container = (container_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/header/src/main.vue?vue&type=template&id=2b296ab2&
	var mainvue_type_template_id_2b296ab2_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "header",
	    { staticClass: "el-header", style: { height: _vm.height } },
	    [_vm._t("default")],
	    2
	  )
	}
	var mainvue_type_template_id_2b296ab2_staticRenderFns = []
	mainvue_type_template_id_2b296ab2_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/header/src/main.vue?vue&type=template&id=2b296ab2&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/header/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var header_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElHeader',
	
	  componentName: 'ElHeader',
	
	  props: {
	    height: {
	      type: String,
	      default: '60px'
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/header/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_header_src_mainvue_type_script_lang_js_ = (header_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/header/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var header_src_main_component = normalizeComponent(
	  packages_header_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_2b296ab2_render,
	  mainvue_type_template_id_2b296ab2_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var header_src_main_api; }
	header_src_main_component.options.__file = "packages/header/src/main.vue"
	/* harmony default export */ var header_src_main = (header_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/header/index.js
	
	
	/* istanbul ignore next */
	header_src_main.install = function (Vue) {
	  Vue.component(header_src_main.name, header_src_main);
	};
	
	/* harmony default export */ var header = (header_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/aside/src/main.vue?vue&type=template&id=03411dbf&
	var mainvue_type_template_id_03411dbf_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "aside",
	    { staticClass: "el-aside", style: { width: _vm.width } },
	    [_vm._t("default")],
	    2
	  )
	}
	var mainvue_type_template_id_03411dbf_staticRenderFns = []
	mainvue_type_template_id_03411dbf_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/aside/src/main.vue?vue&type=template&id=03411dbf&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/aside/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var aside_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElAside',
	
	  componentName: 'ElAside',
	
	  props: {
	    width: {
	      type: String,
	      default: '300px'
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/aside/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_aside_src_mainvue_type_script_lang_js_ = (aside_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/aside/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var aside_src_main_component = normalizeComponent(
	  packages_aside_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_03411dbf_render,
	  mainvue_type_template_id_03411dbf_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var aside_src_main_api; }
	aside_src_main_component.options.__file = "packages/aside/src/main.vue"
	/* harmony default export */ var aside_src_main = (aside_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/aside/index.js
	
	
	/* istanbul ignore next */
	aside_src_main.install = function (Vue) {
	  Vue.component(aside_src_main.name, aside_src_main);
	};
	
	/* harmony default export */ var aside = (aside_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/main/src/main.vue?vue&type=template&id=2a3a7406&
	var mainvue_type_template_id_2a3a7406_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("main", { staticClass: "el-main" }, [_vm._t("default")], 2)
	}
	var mainvue_type_template_id_2a3a7406_staticRenderFns = []
	mainvue_type_template_id_2a3a7406_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/main/src/main.vue?vue&type=template&id=2a3a7406&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/main/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var main_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElMain',
	  componentName: 'ElMain'
	});
	// CONCATENATED MODULE: ./packages/main/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_main_src_mainvue_type_script_lang_js_ = (main_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/main/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var main_src_main_component = normalizeComponent(
	  packages_main_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_2a3a7406_render,
	  mainvue_type_template_id_2a3a7406_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var main_src_main_api; }
	main_src_main_component.options.__file = "packages/main/src/main.vue"
	/* harmony default export */ var main_src_main = (main_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/main/index.js
	
	
	/* istanbul ignore next */
	main_src_main.install = function (Vue) {
	  Vue.component(main_src_main.name, main_src_main);
	};
	
	/* harmony default export */ var packages_main = (main_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/footer/src/main.vue?vue&type=template&id=80210338&
	var mainvue_type_template_id_80210338_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "footer",
	    { staticClass: "el-footer", style: { height: _vm.height } },
	    [_vm._t("default")],
	    2
	  )
	}
	var mainvue_type_template_id_80210338_staticRenderFns = []
	mainvue_type_template_id_80210338_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/footer/src/main.vue?vue&type=template&id=80210338&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/footer/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var footer_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElFooter',
	
	  componentName: 'ElFooter',
	
	  props: {
	    height: {
	      type: String,
	      default: '60px'
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/footer/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_footer_src_mainvue_type_script_lang_js_ = (footer_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/footer/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var footer_src_main_component = normalizeComponent(
	  packages_footer_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_80210338_render,
	  mainvue_type_template_id_80210338_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var footer_src_main_api; }
	footer_src_main_component.options.__file = "packages/footer/src/main.vue"
	/* harmony default export */ var footer_src_main = (footer_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/footer/index.js
	
	
	/* istanbul ignore next */
	footer_src_main.install = function (Vue) {
	  Vue.component(footer_src_main.name, footer_src_main);
	};
	
	/* harmony default export */ var footer = (footer_src_main);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/timeline/src/main.vue?vue&type=script&lang=js&
	
	/* harmony default export */ var timeline_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElTimeline',
	
	  props: {
	    reverse: {
	      type: Boolean,
	      default: false
	    }
	  },
	
	  provide: function provide() {
	    return {
	      timeline: this
	    };
	  },
	  render: function render() {
	    var h = arguments[0];
	
	    var reverse = this.reverse;
	    var classes = {
	      'el-timeline': true,
	      'is-reverse': reverse
	    };
	    var slots = this.$slots.default || [];
	    if (reverse) {
	      slots = slots.reverse();
	    }
	    return h(
	      'ul',
	      { 'class': classes },
	      [slots]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/timeline/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_timeline_src_mainvue_type_script_lang_js_ = (timeline_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/timeline/src/main.vue
	var main_render, main_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var timeline_src_main_component = normalizeComponent(
	  packages_timeline_src_mainvue_type_script_lang_js_,
	  main_render,
	  main_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var timeline_src_main_api; }
	timeline_src_main_component.options.__file = "packages/timeline/src/main.vue"
	/* harmony default export */ var timeline_src_main = (timeline_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/timeline/index.js
	
	
	/* istanbul ignore next */
	timeline_src_main.install = function (Vue) {
	  Vue.component(timeline_src_main.name, timeline_src_main);
	};
	
	/* harmony default export */ var timeline = (timeline_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/timeline/src/item.vue?vue&type=template&id=61a69e50&
	var itemvue_type_template_id_61a69e50_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("li", { staticClass: "el-timeline-item" }, [
	    _c("div", { staticClass: "el-timeline-item__tail" }),
	    !_vm.$slots.dot
	      ? _c(
	          "div",
	          {
	            staticClass: "el-timeline-item__node",
	            class: [
	              "el-timeline-item__node--" + (_vm.size || ""),
	              "el-timeline-item__node--" + (_vm.type || "")
	            ],
	            style: {
	              backgroundColor: _vm.color
	            }
	          },
	          [
	            _vm.icon
	              ? _c("i", {
	                  staticClass: "el-timeline-item__icon",
	                  class: _vm.icon
	                })
	              : _vm._e()
	          ]
	        )
	      : _vm._e(),
	    _vm.$slots.dot
	      ? _c("div", { staticClass: "el-timeline-item__dot" }, [_vm._t("dot")], 2)
	      : _vm._e(),
	    _c("div", { staticClass: "el-timeline-item__wrapper" }, [
	      !_vm.hideTimestamp && _vm.placement === "top"
	        ? _c("div", { staticClass: "el-timeline-item__timestamp is-top" }, [
	            _vm._v("\n      " + _vm._s(_vm.timestamp) + "\n    ")
	          ])
	        : _vm._e(),
	      _c(
	        "div",
	        { staticClass: "el-timeline-item__content" },
	        [_vm._t("default")],
	        2
	      ),
	      !_vm.hideTimestamp && _vm.placement === "bottom"
	        ? _c("div", { staticClass: "el-timeline-item__timestamp is-bottom" }, [
	            _vm._v("\n      " + _vm._s(_vm.timestamp) + "\n    ")
	          ])
	        : _vm._e()
	    ])
	  ])
	}
	var itemvue_type_template_id_61a69e50_staticRenderFns = []
	itemvue_type_template_id_61a69e50_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/timeline/src/item.vue?vue&type=template&id=61a69e50&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/timeline/src/item.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var timeline_src_itemvue_type_script_lang_js_ = ({
	  name: 'ElTimelineItem',
	
	  inject: ['timeline'],
	
	  props: {
	    timestamp: String,
	
	    hideTimestamp: {
	      type: Boolean,
	      default: false
	    },
	
	    placement: {
	      type: String,
	      default: 'bottom'
	    },
	
	    type: String,
	
	    color: String,
	
	    size: {
	      type: String,
	      default: 'normal'
	    },
	
	    icon: String
	  }
	});
	// CONCATENATED MODULE: ./packages/timeline/src/item.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_timeline_src_itemvue_type_script_lang_js_ = (timeline_src_itemvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/timeline/src/item.vue
	
	
	
	
	
	/* normalize component */
	
	var src_item_component = normalizeComponent(
	  packages_timeline_src_itemvue_type_script_lang_js_,
	  itemvue_type_template_id_61a69e50_render,
	  itemvue_type_template_id_61a69e50_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var src_item_api; }
	src_item_component.options.__file = "packages/timeline/src/item.vue"
	/* harmony default export */ var timeline_src_item = (src_item_component.exports);
	// CONCATENATED MODULE: ./packages/timeline-item/index.js
	
	
	/* istanbul ignore next */
	timeline_src_item.install = function (Vue) {
	  Vue.component(timeline_src_item.name, timeline_src_item);
	};
	
	/* harmony default export */ var timeline_item = (timeline_src_item);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/link/src/main.vue?vue&type=template&id=01cf3b65&
	var mainvue_type_template_id_01cf3b65_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "a",
	    _vm._b(
	      {
	        class: [
	          "el-link",
	          _vm.type ? "el-link--" + _vm.type : "",
	          _vm.disabled && "is-disabled",
	          _vm.underline && !_vm.disabled && "is-underline"
	        ],
	        attrs: { href: _vm.disabled ? null : _vm.href },
	        on: { click: _vm.handleClick }
	      },
	      "a",
	      _vm.$attrs,
	      false
	    ),
	    [
	      _vm.icon ? _c("i", { class: _vm.icon }) : _vm._e(),
	      _vm.$slots.default
	        ? _c("span", { staticClass: "el-link--inner" }, [_vm._t("default")], 2)
	        : _vm._e(),
	      _vm.$slots.icon ? [_vm.$slots.icon ? _vm._t("icon") : _vm._e()] : _vm._e()
	    ],
	    2
	  )
	}
	var mainvue_type_template_id_01cf3b65_staticRenderFns = []
	mainvue_type_template_id_01cf3b65_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/link/src/main.vue?vue&type=template&id=01cf3b65&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/link/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	/* harmony default export */ var link_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElLink',
	
	  props: {
	    type: {
	      type: String,
	      default: 'default'
	    },
	    underline: {
	      type: Boolean,
	      default: true
	    },
	    disabled: Boolean,
	    href: String,
	    icon: String
	  },
	
	  methods: {
	    handleClick: function handleClick(event) {
	      if (!this.disabled) {
	        if (!this.href) {
	          this.$emit('click', event);
	        }
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/link/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_link_src_mainvue_type_script_lang_js_ = (link_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/link/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var link_src_main_component = normalizeComponent(
	  packages_link_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_01cf3b65_render,
	  mainvue_type_template_id_01cf3b65_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var link_src_main_api; }
	link_src_main_component.options.__file = "packages/link/src/main.vue"
	/* harmony default export */ var link_src_main = (link_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/link/index.js
	
	
	/* istanbul ignore next */
	link_src_main.install = function (Vue) {
	  Vue.component(link_src_main.name, link_src_main);
	};
	
	/* harmony default export */ var packages_link = (link_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/divider/src/main.vue?vue&type=template&id=7fa02a7e&functional=true&
	var mainvue_type_template_id_7fa02a7e_functional_true_render = function(_h, _vm) {
	  var _c = _vm._c
	  return _c(
	    "div",
	    _vm._g(
	      _vm._b(
	        {
	          class: [
	            _vm.data.staticClass,
	            "el-divider",
	            "el-divider--" + _vm.props.direction
	          ]
	        },
	        "div",
	        _vm.data.attrs,
	        false
	      ),
	      _vm.listeners
	    ),
	    [
	      _vm.slots().default && _vm.props.direction !== "vertical"
	        ? _c(
	            "div",
	            { class: ["el-divider__text", "is-" + _vm.props.contentPosition] },
	            [_vm._t("default")],
	            2
	          )
	        : _vm._e()
	    ]
	  )
	}
	var mainvue_type_template_id_7fa02a7e_functional_true_staticRenderFns = []
	mainvue_type_template_id_7fa02a7e_functional_true_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/divider/src/main.vue?vue&type=template&id=7fa02a7e&functional=true&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/divider/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var divider_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElDivider',
	  props: {
	    direction: {
	      type: String,
	      default: 'horizontal',
	      validator: function validator(val) {
	        return ['horizontal', 'vertical'].indexOf(val) !== -1;
	      }
	    },
	    contentPosition: {
	      type: String,
	      default: 'center',
	      validator: function validator(val) {
	        return ['left', 'center', 'right'].indexOf(val) !== -1;
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/divider/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_divider_src_mainvue_type_script_lang_js_ = (divider_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/divider/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var divider_src_main_component = normalizeComponent(
	  packages_divider_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_7fa02a7e_functional_true_render,
	  mainvue_type_template_id_7fa02a7e_functional_true_staticRenderFns,
	  true,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var divider_src_main_api; }
	divider_src_main_component.options.__file = "packages/divider/src/main.vue"
	/* harmony default export */ var divider_src_main = (divider_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/divider/index.js
	
	
	/* istanbul ignore next */
	divider_src_main.install = function (Vue) {
	  Vue.component(divider_src_main.name, divider_src_main);
	};
	
	/* harmony default export */ var divider = (divider_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/image/src/main.vue?vue&type=template&id=44d84a7c&
	var mainvue_type_template_id_44d84a7c_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    { staticClass: "el-image" },
	    [
	      _vm.loading
	        ? _vm._t("placeholder", [
	            _c("div", { staticClass: "el-image__placeholder" })
	          ])
	        : _vm.error
	        ? _vm._t("error", [
	            _c("div", { staticClass: "el-image__error" }, [
	              _vm._v(_vm._s(_vm.t("el.image.error")))
	            ])
	          ])
	        : _c(
	            "img",
	            _vm._g(
	              _vm._b(
	                {
	                  staticClass: "el-image__inner",
	                  class: {
	                    "el-image__inner--center": _vm.alignCenter,
	                    "el-image__preview": _vm.preview
	                  },
	                  style: _vm.imageStyle,
	                  attrs: { src: _vm.src },
	                  on: { click: _vm.clickHandler }
	                },
	                "img",
	                _vm.$attrs,
	                false
	              ),
	              _vm.$listeners
	            )
	          ),
	      _vm.preview
	        ? [
	            _vm.showViewer
	              ? _c("image-viewer", {
	                  attrs: {
	                    "z-index": _vm.zIndex,
	                    "initial-index": _vm.imageIndex,
	                    "on-close": _vm.closeViewer,
	                    "url-list": _vm.previewSrcList
	                  }
	                })
	              : _vm._e()
	          ]
	        : _vm._e()
	    ],
	    2
	  )
	}
	var mainvue_type_template_id_44d84a7c_staticRenderFns = []
	mainvue_type_template_id_44d84a7c_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/image/src/main.vue?vue&type=template&id=44d84a7c&
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/image/src/image-viewer.vue?vue&type=template&id=5e73b307&
	var image_viewervue_type_template_id_5e73b307_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("transition", { attrs: { name: "viewer-fade" } }, [
	    _c(
	      "div",
	      {
	        ref: "el-image-viewer__wrapper",
	        staticClass: "el-image-viewer__wrapper",
	        style: { "z-index": _vm.viewerZIndex },
	        attrs: { tabindex: "-1" }
	      },
	      [
	        _c("div", {
	          staticClass: "el-image-viewer__mask",
	          on: {
	            click: function($event) {
	              if ($event.target !== $event.currentTarget) {
	                return null
	              }
	              return _vm.handleMaskClick($event)
	            }
	          }
	        }),
	        _c(
	          "span",
	          {
	            staticClass: "el-image-viewer__btn el-image-viewer__close",
	            on: { click: _vm.hide }
	          },
	          [_c("i", { staticClass: "el-icon-close" })]
	        ),
	        !_vm.isSingle
	          ? [
	              _c(
	                "span",
	                {
	                  staticClass: "el-image-viewer__btn el-image-viewer__prev",
	                  class: { "is-disabled": !_vm.infinite && _vm.isFirst },
	                  on: { click: _vm.prev }
	                },
	                [_c("i", { staticClass: "el-icon-arrow-left" })]
	              ),
	              _c(
	                "span",
	                {
	                  staticClass: "el-image-viewer__btn el-image-viewer__next",
	                  class: { "is-disabled": !_vm.infinite && _vm.isLast },
	                  on: { click: _vm.next }
	                },
	                [_c("i", { staticClass: "el-icon-arrow-right" })]
	              )
	            ]
	          : _vm._e(),
	        _c(
	          "div",
	          { staticClass: "el-image-viewer__btn el-image-viewer__actions" },
	          [
	            _c("div", { staticClass: "el-image-viewer__actions__inner" }, [
	              _c("i", {
	                staticClass: "el-icon-zoom-out",
	                on: {
	                  click: function($event) {
	                    _vm.handleActions("zoomOut")
	                  }
	                }
	              }),
	              _c("i", {
	                staticClass: "el-icon-zoom-in",
	                on: {
	                  click: function($event) {
	                    _vm.handleActions("zoomIn")
	                  }
	                }
	              }),
	              _c("i", { staticClass: "el-image-viewer__actions__divider" }),
	              _c("i", { class: _vm.mode.icon, on: { click: _vm.toggleMode } }),
	              _c("i", { staticClass: "el-image-viewer__actions__divider" }),
	              _c("i", {
	                staticClass: "el-icon-refresh-left",
	                on: {
	                  click: function($event) {
	                    _vm.handleActions("anticlocelise")
	                  }
	                }
	              }),
	              _c("i", {
	                staticClass: "el-icon-refresh-right",
	                on: {
	                  click: function($event) {
	                    _vm.handleActions("clocelise")
	                  }
	                }
	              })
	            ])
	          ]
	        ),
	        _c(
	          "div",
	          { staticClass: "el-image-viewer__canvas" },
	          _vm._l(_vm.urlList, function(url, i) {
	            return i === _vm.index
	              ? _c("img", {
	                  key: url,
	                  ref: "img",
	                  refInFor: true,
	                  staticClass: "el-image-viewer__img",
	                  style: _vm.imgStyle,
	                  attrs: { src: _vm.currentImg },
	                  on: {
	                    load: _vm.handleImgLoad,
	                    error: _vm.handleImgError,
	                    mousedown: _vm.handleMouseDown
	                  }
	                })
	              : _vm._e()
	          }),
	          0
	        )
	      ],
	      2
	    )
	  ])
	}
	var image_viewervue_type_template_id_5e73b307_staticRenderFns = []
	image_viewervue_type_template_id_5e73b307_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/image/src/image-viewer.vue?vue&type=template&id=5e73b307&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/image/src/image-viewer.vue?vue&type=script&lang=js&
	var image_viewervue_type_script_lang_js_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	var Mode = {
	  CONTAIN: {
	    name: 'contain',
	    icon: 'el-icon-full-screen'
	  },
	  ORIGINAL: {
	    name: 'original',
	    icon: 'el-icon-c-scale-to-original'
	  }
	};
	
	var mousewheelEventName = Object(util_["isFirefox"])() ? 'DOMMouseScroll' : 'mousewheel';
	
	/* harmony default export */ var image_viewervue_type_script_lang_js_ = ({
	  name: 'elImageViewer',
	
	  props: {
	    urlList: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    zIndex: {
	      type: Number,
	      default: 2000
	    },
	    onSwitch: {
	      type: Function,
	      default: function _default() {}
	    },
	    onClose: {
	      type: Function,
	      default: function _default() {}
	    },
	    initialIndex: {
	      type: Number,
	      default: 0
	    },
	    appendToBody: {
	      type: Boolean,
	      default: true
	    },
	    maskClosable: {
	      type: Boolean,
	      default: true
	    }
	  },
	
	  data: function data() {
	    return {
	      index: this.initialIndex,
	      isShow: false,
	      infinite: true,
	      loading: false,
	      mode: Mode.CONTAIN,
	      transform: {
	        scale: 1,
	        deg: 0,
	        offsetX: 0,
	        offsetY: 0,
	        enableTransition: false
	      }
	    };
	  },
	
	  computed: {
	    isSingle: function isSingle() {
	      return this.urlList.length <= 1;
	    },
	    isFirst: function isFirst() {
	      return this.index === 0;
	    },
	    isLast: function isLast() {
	      return this.index === this.urlList.length - 1;
	    },
	    currentImg: function currentImg() {
	      return this.urlList[this.index];
	    },
	    imgStyle: function imgStyle() {
	      var _transform = this.transform,
	          scale = _transform.scale,
	          deg = _transform.deg,
	          offsetX = _transform.offsetX,
	          offsetY = _transform.offsetY,
	          enableTransition = _transform.enableTransition;
	
	      var style = {
	        transform: 'scale(' + scale + ') rotate(' + deg + 'deg)',
	        transition: enableTransition ? 'transform .3s' : '',
	        'margin-left': offsetX + 'px',
	        'margin-top': offsetY + 'px'
	      };
	      if (this.mode === Mode.CONTAIN) {
	        style.maxWidth = style.maxHeight = '100%';
	      }
	      return style;
	    },
	    viewerZIndex: function viewerZIndex() {
	      var nextZIndex = popup_["PopupManager"].nextZIndex();
	      return this.zIndex > nextZIndex ? this.zIndex : nextZIndex;
	    }
	  },
	  watch: {
	    index: {
	      handler: function handler(val) {
	        this.reset();
	        this.onSwitch(val);
	      }
	    },
	    currentImg: function currentImg(val) {
	      var _this = this;
	
	      this.$nextTick(function (_) {
	        var $img = _this.$refs.img[0];
	        if (!$img.complete) {
	          _this.loading = true;
	        }
	      });
	    }
	  },
	  methods: {
	    hide: function hide() {
	      this.deviceSupportUninstall();
	      this.onClose();
	    },
	    deviceSupportInstall: function deviceSupportInstall() {
	      var _this2 = this;
	
	      this._keyDownHandler = function (e) {
	        e.stopPropagation();
	        var keyCode = e.keyCode;
	        switch (keyCode) {
	          // ESC
	          case 27:
	            _this2.hide();
	            break;
	          // SPACE
	          case 32:
	            _this2.toggleMode();
	            break;
	          // LEFT_ARROW
	          case 37:
	            _this2.prev();
	            break;
	          // UP_ARROW
	          case 38:
	            _this2.handleActions('zoomIn');
	            break;
	          // RIGHT_ARROW
	          case 39:
	            _this2.next();
	            break;
	          // DOWN_ARROW
	          case 40:
	            _this2.handleActions('zoomOut');
	            break;
	        }
	      };
	      this._mouseWheelHandler = Object(util_["rafThrottle"])(function (e) {
	        var delta = e.wheelDelta ? e.wheelDelta : -e.detail;
	        if (delta > 0) {
	          _this2.handleActions('zoomIn', {
	            zoomRate: 0.015,
	            enableTransition: false
	          });
	        } else {
	          _this2.handleActions('zoomOut', {
	            zoomRate: 0.015,
	            enableTransition: false
	          });
	        }
	      });
	      Object(dom_["on"])(document, 'keydown', this._keyDownHandler);
	      Object(dom_["on"])(document, mousewheelEventName, this._mouseWheelHandler);
	    },
	    deviceSupportUninstall: function deviceSupportUninstall() {
	      Object(dom_["off"])(document, 'keydown', this._keyDownHandler);
	      Object(dom_["off"])(document, mousewheelEventName, this._mouseWheelHandler);
	      this._keyDownHandler = null;
	      this._mouseWheelHandler = null;
	    },
	    handleImgLoad: function handleImgLoad(e) {
	      this.loading = false;
	    },
	    handleImgError: function handleImgError(e) {
	      this.loading = false;
	      e.target.alt = '加载失败';
	    },
	    handleMouseDown: function handleMouseDown(e) {
	      var _this3 = this;
	
	      if (this.loading || e.button !== 0) return;
	
	      var _transform2 = this.transform,
	          offsetX = _transform2.offsetX,
	          offsetY = _transform2.offsetY;
	
	      var startX = e.pageX;
	      var startY = e.pageY;
	      this._dragHandler = Object(util_["rafThrottle"])(function (ev) {
	        _this3.transform.offsetX = offsetX + ev.pageX - startX;
	        _this3.transform.offsetY = offsetY + ev.pageY - startY;
	      });
	      Object(dom_["on"])(document, 'mousemove', this._dragHandler);
	      Object(dom_["on"])(document, 'mouseup', function (ev) {
	        Object(dom_["off"])(document, 'mousemove', _this3._dragHandler);
	      });
	
	      e.preventDefault();
	    },
	    handleMaskClick: function handleMaskClick() {
	      if (this.maskClosable) {
	        this.hide();
	      }
	    },
	    reset: function reset() {
	      this.transform = {
	        scale: 1,
	        deg: 0,
	        offsetX: 0,
	        offsetY: 0,
	        enableTransition: false
	      };
	    },
	    toggleMode: function toggleMode() {
	      if (this.loading) return;
	
	      var modeNames = Object.keys(Mode);
	      var modeValues = Object.values(Mode);
	      var index = modeValues.indexOf(this.mode);
	      var nextIndex = (index + 1) % modeNames.length;
	      this.mode = Mode[modeNames[nextIndex]];
	      this.reset();
	    },
	    prev: function prev() {
	      if (this.isFirst && !this.infinite) return;
	      var len = this.urlList.length;
	      this.index = (this.index - 1 + len) % len;
	    },
	    next: function next() {
	      if (this.isLast && !this.infinite) return;
	      var len = this.urlList.length;
	      this.index = (this.index + 1) % len;
	    },
	    handleActions: function handleActions(action) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      if (this.loading) return;
	
	      var _zoomRate$rotateDeg$e = image_viewervue_type_script_lang_js_extends({
	        zoomRate: 0.2,
	        rotateDeg: 90,
	        enableTransition: true
	      }, options),
	          zoomRate = _zoomRate$rotateDeg$e.zoomRate,
	          rotateDeg = _zoomRate$rotateDeg$e.rotateDeg,
	          enableTransition = _zoomRate$rotateDeg$e.enableTransition;
	
	      var transform = this.transform;
	
	      switch (action) {
	        case 'zoomOut':
	          if (transform.scale > 0.2) {
	            transform.scale = parseFloat((transform.scale - zoomRate).toFixed(3));
	          }
	          break;
	        case 'zoomIn':
	          transform.scale = parseFloat((transform.scale + zoomRate).toFixed(3));
	          break;
	        case 'clocelise':
	          transform.deg += rotateDeg;
	          break;
	        case 'anticlocelise':
	          transform.deg -= rotateDeg;
	          break;
	      }
	      transform.enableTransition = enableTransition;
	    }
	  },
	  mounted: function mounted() {
	    this.deviceSupportInstall();
	    if (this.appendToBody) {
	      document.body.appendChild(this.$el);
	    }
	    // add tabindex then wrapper can be focusable via Javascript
	    // focus wrapper so arrow key can't cause inner scroll behavior underneath
	    this.$refs['el-image-viewer__wrapper'].focus();
	  },
	  destroyed: function destroyed() {
	    // if appendToBody is true, remove DOM node after destroy
	    if (this.appendToBody && this.$el && this.$el.parentNode) {
	      this.$el.parentNode.removeChild(this.$el);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/image/src/image-viewer.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_image_viewervue_type_script_lang_js_ = (image_viewervue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/image/src/image-viewer.vue
	
	
	
	
	
	/* normalize component */
	
	var image_viewer_component = normalizeComponent(
	  src_image_viewervue_type_script_lang_js_,
	  image_viewervue_type_template_id_5e73b307_render,
	  image_viewervue_type_template_id_5e73b307_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var image_viewer_api; }
	image_viewer_component.options.__file = "packages/image/src/image-viewer.vue"
	/* harmony default export */ var image_viewer = (image_viewer_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/image/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	var isSupportObjectFit = function isSupportObjectFit() {
	  return document.documentElement.style.objectFit !== undefined;
	};
	
	var ObjectFit = {
	  NONE: 'none',
	  CONTAIN: 'contain',
	  COVER: 'cover',
	  FILL: 'fill',
	  SCALE_DOWN: 'scale-down'
	};
	
	var prevOverflow = '';
	
	/* harmony default export */ var image_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElImage',
	
	  mixins: [locale_default.a],
	  inheritAttrs: false,
	
	  components: {
	    ImageViewer: image_viewer
	  },
	
	  props: {
	    src: String,
	    fit: String,
	    lazy: Boolean,
	    scrollContainer: {},
	    previewSrcList: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    zIndex: {
	      type: Number,
	      default: 2000
	    }
	  },
	
	  data: function data() {
	    return {
	      loading: true,
	      error: false,
	      show: !this.lazy,
	      imageWidth: 0,
	      imageHeight: 0,
	      showViewer: false
	    };
	  },
	
	
	  computed: {
	    imageStyle: function imageStyle() {
	      var fit = this.fit;
	
	      if (!this.$isServer && fit) {
	        return isSupportObjectFit() ? { 'object-fit': fit } : this.getImageStyle(fit);
	      }
	      return {};
	    },
	    alignCenter: function alignCenter() {
	      return !this.$isServer && !isSupportObjectFit() && this.fit !== ObjectFit.FILL;
	    },
	    preview: function preview() {
	      var previewSrcList = this.previewSrcList;
	
	      return Array.isArray(previewSrcList) && previewSrcList.length > 0;
	    },
	    imageIndex: function imageIndex() {
	      var previewIndex = 0;
	      var srcIndex = this.previewSrcList.indexOf(this.src);
	      if (srcIndex >= 0) {
	        previewIndex = srcIndex;
	      }
	      return previewIndex;
	    }
	  },
	
	  watch: {
	    src: function src(val) {
	      this.show && this.loadImage();
	    },
	    show: function show(val) {
	      val && this.loadImage();
	    }
	  },
	
	  mounted: function mounted() {
	    if (this.lazy) {
	      this.addLazyLoadListener();
	    } else {
	      this.loadImage();
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.lazy && this.removeLazyLoadListener();
	  },
	
	
	  methods: {
	    loadImage: function loadImage() {
	      var _this = this;
	
	      if (this.$isServer) return;
	
	      // reset status
	      this.loading = true;
	      this.error = false;
	
	      var img = new Image();
	      img.onload = function (e) {
	        return _this.handleLoad(e, img);
	      };
	      img.onerror = this.handleError.bind(this);
	
	      // bind html attrs
	      // so it can behave consistently
	      Object.keys(this.$attrs).forEach(function (key) {
	        var value = _this.$attrs[key];
	        img.setAttribute(key, value);
	      });
	      img.src = this.src;
	    },
	    handleLoad: function handleLoad(e, img) {
	      this.imageWidth = img.width;
	      this.imageHeight = img.height;
	      this.loading = false;
	      this.error = false;
	    },
	    handleError: function handleError(e) {
	      this.loading = false;
	      this.error = true;
	      this.$emit('error', e);
	    },
	    handleLazyLoad: function handleLazyLoad() {
	      if (Object(dom_["isInContainer"])(this.$el, this._scrollContainer)) {
	        this.show = true;
	        this.removeLazyLoadListener();
	      }
	    },
	    addLazyLoadListener: function addLazyLoadListener() {
	      if (this.$isServer) return;
	
	      var scrollContainer = this.scrollContainer;
	
	      var _scrollContainer = null;
	
	      if (Object(types_["isHtmlElement"])(scrollContainer)) {
	        _scrollContainer = scrollContainer;
	      } else if (Object(types_["isString"])(scrollContainer)) {
	        _scrollContainer = document.querySelector(scrollContainer);
	      } else {
	        _scrollContainer = Object(dom_["getScrollContainer"])(this.$el);
	      }
	
	      if (_scrollContainer) {
	        this._scrollContainer = _scrollContainer;
	        this._lazyLoadHandler = throttle_default()(200, this.handleLazyLoad);
	        Object(dom_["on"])(_scrollContainer, 'scroll', this._lazyLoadHandler);
	        this.handleLazyLoad();
	      }
	    },
	    removeLazyLoadListener: function removeLazyLoadListener() {
	      var _scrollContainer = this._scrollContainer,
	          _lazyLoadHandler = this._lazyLoadHandler;
	
	
	      if (this.$isServer || !_scrollContainer || !_lazyLoadHandler) return;
	
	      Object(dom_["off"])(_scrollContainer, 'scroll', _lazyLoadHandler);
	      this._scrollContainer = null;
	      this._lazyLoadHandler = null;
	    },
	
	    /**
	     * simulate object-fit behavior to compatible with IE11 and other browsers which not support object-fit
	     */
	    getImageStyle: function getImageStyle(fit) {
	      var imageWidth = this.imageWidth,
	          imageHeight = this.imageHeight;
	      var _$el = this.$el,
	          containerWidth = _$el.clientWidth,
	          containerHeight = _$el.clientHeight;
	
	
	      if (!imageWidth || !imageHeight || !containerWidth || !containerHeight) return {};
	
	      var imageAspectRatio = imageWidth / imageHeight;
	      var containerAspectRatio = containerWidth / containerHeight;
	
	      if (fit === ObjectFit.SCALE_DOWN) {
	        var isSmaller = imageWidth < containerWidth && imageHeight < containerHeight;
	        fit = isSmaller ? ObjectFit.NONE : ObjectFit.CONTAIN;
	      }
	
	      switch (fit) {
	        case ObjectFit.NONE:
	          return { width: 'auto', height: 'auto' };
	        case ObjectFit.CONTAIN:
	          return imageAspectRatio < containerAspectRatio ? { width: 'auto' } : { height: 'auto' };
	        case ObjectFit.COVER:
	          return imageAspectRatio < containerAspectRatio ? { height: 'auto' } : { width: 'auto' };
	        default:
	          return {};
	      }
	    },
	    clickHandler: function clickHandler() {
	      // don't show viewer when preview is false
	      if (!this.preview) {
	        return;
	      }
	      // prevent body scroll
	      prevOverflow = document.body.style.overflow;
	      document.body.style.overflow = 'hidden';
	      this.showViewer = true;
	    },
	    closeViewer: function closeViewer() {
	      document.body.style.overflow = prevOverflow;
	      this.showViewer = false;
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/image/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_image_src_mainvue_type_script_lang_js_ = (image_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/image/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var image_src_main_component = normalizeComponent(
	  packages_image_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_44d84a7c_render,
	  mainvue_type_template_id_44d84a7c_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var image_src_main_api; }
	image_src_main_component.options.__file = "packages/image/src/main.vue"
	/* harmony default export */ var image_src_main = (image_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/image/index.js
	
	
	/* istanbul ignore next */
	image_src_main.install = function (Vue) {
	  Vue.component(image_src_main.name, image_src_main);
	};
	
	/* harmony default export */ var packages_image = (image_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/calendar/src/main.vue?vue&type=template&id=6d9756be&
	var mainvue_type_template_id_6d9756be_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("div", { staticClass: "el-calendar" }, [
	    _c("div", { staticClass: "el-calendar__header" }, [
	      _c("div", { staticClass: "el-calendar__title" }, [
	        _vm._v("\n      " + _vm._s(_vm.i18nDate) + "\n    ")
	      ]),
	      _vm.validatedRange.length === 0
	        ? _c(
	            "div",
	            { staticClass: "el-calendar__button-group" },
	            [
	              _c(
	                "el-button-group",
	                [
	                  _c(
	                    "el-button",
	                    {
	                      attrs: { type: "plain", size: "mini" },
	                      on: {
	                        click: function($event) {
	                          _vm.selectDate("prev-month")
	                        }
	                      }
	                    },
	                    [
	                      _vm._v(
	                        "\n          " +
	                          _vm._s(_vm.t("el.datepicker.prevMonth")) +
	                          "\n        "
	                      )
	                    ]
	                  ),
	                  _c(
	                    "el-button",
	                    {
	                      attrs: { type: "plain", size: "mini" },
	                      on: {
	                        click: function($event) {
	                          _vm.selectDate("today")
	                        }
	                      }
	                    },
	                    [
	                      _vm._v(
	                        "\n          " +
	                          _vm._s(_vm.t("el.datepicker.today")) +
	                          "\n        "
	                      )
	                    ]
	                  ),
	                  _c(
	                    "el-button",
	                    {
	                      attrs: { type: "plain", size: "mini" },
	                      on: {
	                        click: function($event) {
	                          _vm.selectDate("next-month")
	                        }
	                      }
	                    },
	                    [
	                      _vm._v(
	                        "\n          " +
	                          _vm._s(_vm.t("el.datepicker.nextMonth")) +
	                          "\n        "
	                      )
	                    ]
	                  )
	                ],
	                1
	              )
	            ],
	            1
	          )
	        : _vm._e()
	    ]),
	    _vm.validatedRange.length === 0
	      ? _c(
	          "div",
	          { key: "no-range", staticClass: "el-calendar__body" },
	          [
	            _c("date-table", {
	              attrs: {
	                date: _vm.date,
	                "selected-day": _vm.realSelectedDay,
	                "first-day-of-week": _vm.realFirstDayOfWeek
	              },
	              on: { pick: _vm.pickDay }
	            })
	          ],
	          1
	        )
	      : _c(
	          "div",
	          { key: "has-range", staticClass: "el-calendar__body" },
	          _vm._l(_vm.validatedRange, function(range, index) {
	            return _c("date-table", {
	              key: index,
	              attrs: {
	                date: range[0],
	                "selected-day": _vm.realSelectedDay,
	                range: range,
	                "hide-header": index !== 0,
	                "first-day-of-week": _vm.realFirstDayOfWeek
	              },
	              on: { pick: _vm.pickDay }
	            })
	          }),
	          1
	        )
	  ])
	}
	var mainvue_type_template_id_6d9756be_staticRenderFns = []
	mainvue_type_template_id_6d9756be_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/calendar/src/main.vue?vue&type=template&id=6d9756be&
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/date"
	var date_ = __webpack_require__(20);
	var date_default = /*#__PURE__*/__webpack_require__.n(date_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/calendar/src/date-table.vue?vue&type=script&lang=js&
	
	
	
	
	/* harmony default export */ var src_date_tablevue_type_script_lang_js_ = ({
	  props: {
	    selectedDay: String, // formated date yyyy-MM-dd
	    range: {
	      type: Array,
	      validator: function validator(val) {
	        if (!(val && val.length)) return true;
	        var start = val[0],
	            end = val[1];
	
	        return Object(date_util_["validateRangeInOneMonth"])(start, end);
	      }
	    },
	    date: Date,
	    hideHeader: Boolean,
	    firstDayOfWeek: Number
	  },
	
	  inject: ['elCalendar'],
	
	  methods: {
	    toNestedArr: function toNestedArr(days) {
	      return Object(date_util_["range"])(days.length / 7).map(function (_, index) {
	        var start = index * 7;
	        return days.slice(start, start + 7);
	      });
	    },
	    getFormateDate: function getFormateDate(day, type) {
	      if (!day || ['prev', 'current', 'next'].indexOf(type) === -1) {
	        throw new Error('invalid day or type');
	      }
	      var prefix = this.curMonthDatePrefix;
	      if (type === 'prev') {
	        prefix = this.prevMonthDatePrefix;
	      } else if (type === 'next') {
	        prefix = this.nextMonthDatePrefix;
	      }
	      day = ('00' + day).slice(-2);
	      return prefix + '-' + day;
	    },
	    getCellClass: function getCellClass(_ref) {
	      var text = _ref.text,
	          type = _ref.type;
	
	      var classes = [type];
	      if (type === 'current') {
	        var date = this.getFormateDate(text, type);
	        if (date === this.selectedDay) {
	          classes.push('is-selected');
	        }
	        if (date === this.formatedToday) {
	          classes.push('is-today');
	        }
	      }
	      return classes;
	    },
	    pickDay: function pickDay(_ref2) {
	      var text = _ref2.text,
	          type = _ref2.type;
	
	      var date = this.getFormateDate(text, type);
	      this.$emit('pick', date);
	    },
	    cellRenderProxy: function cellRenderProxy(_ref3) {
	      var text = _ref3.text,
	          type = _ref3.type;
	      var h = this.$createElement;
	
	      var render = this.elCalendar.$scopedSlots.dateCell;
	      if (!render) return h('span', [text]);
	
	      var day = this.getFormateDate(text, type);
	      var date = new Date(day);
	      var data = {
	        isSelected: this.selectedDay === day,
	        type: type + '-month',
	        day: day
	      };
	      return render({ date: date, data: data });
	    }
	  },
	
	  computed: {
	    WEEK_DAYS: function WEEK_DAYS() {
	      return Object(date_util_["getI18nSettings"])().dayNames;
	    },
	    prevMonthDatePrefix: function prevMonthDatePrefix() {
	      var temp = new Date(this.date.getTime());
	      temp.setDate(0);
	      return date_default.a.format(temp, 'yyyy-MM');
	    },
	    curMonthDatePrefix: function curMonthDatePrefix() {
	      return date_default.a.format(this.date, 'yyyy-MM');
	    },
	    nextMonthDatePrefix: function nextMonthDatePrefix() {
	      var temp = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 1);
	      return date_default.a.format(temp, 'yyyy-MM');
	    },
	    formatedToday: function formatedToday() {
	      return this.elCalendar.formatedToday;
	    },
	    isInRange: function isInRange() {
	      return this.range && this.range.length;
	    },
	    rows: function rows() {
	      var days = [];
	      // if range exists, should render days in range.
	      if (this.isInRange) {
	        var _range = this.range,
	            start = _range[0],
	            end = _range[1];
	
	        var currentMonthRange = Object(date_util_["range"])(end.getDate() - start.getDate() + 1).map(function (_, index) {
	          return {
	            text: start.getDate() + index,
	            type: 'current'
	          };
	        });
	        var remaining = currentMonthRange.length % 7;
	        remaining = remaining === 0 ? 0 : 7 - remaining;
	        var nextMonthRange = Object(date_util_["range"])(remaining).map(function (_, index) {
	          return {
	            text: index + 1,
	            type: 'next'
	          };
	        });
	        days = currentMonthRange.concat(nextMonthRange);
	      } else {
	        var date = this.date;
	        var firstDay = Object(date_util_["getFirstDayOfMonth"])(date);
	        firstDay = firstDay === 0 ? 7 : firstDay;
	        var firstDayOfWeek = typeof this.firstDayOfWeek === 'number' ? this.firstDayOfWeek : 1;
	        var prevMonthDays = Object(date_util_["getPrevMonthLastDays"])(date, firstDay - firstDayOfWeek).map(function (day) {
	          return {
	            text: day,
	            type: 'prev'
	          };
	        });
	        var currentMonthDays = Object(date_util_["getMonthDays"])(date).map(function (day) {
	          return {
	            text: day,
	            type: 'current'
	          };
	        });
	        days = [].concat(prevMonthDays, currentMonthDays);
	        var nextMonthDays = Object(date_util_["range"])(42 - days.length).map(function (_, index) {
	          return {
	            text: index + 1,
	            type: 'next'
	          };
	        });
	        days = days.concat(nextMonthDays);
	      }
	      return this.toNestedArr(days);
	    },
	    weekDays: function weekDays() {
	      var start = this.firstDayOfWeek;
	      var WEEK_DAYS = this.WEEK_DAYS;
	
	
	      if (typeof start !== 'number' || start === 0) {
	        return WEEK_DAYS.slice();
	      } else {
	        return WEEK_DAYS.slice(start).concat(WEEK_DAYS.slice(0, start));
	      }
	    }
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var h = arguments[0];
	
	    var thead = this.hideHeader ? null : h('thead', [this.weekDays.map(function (day) {
	      return h(
	        'th',
	        { key: day },
	        [day]
	      );
	    })]);
	    return h(
	      'table',
	      {
	        'class': {
	          'el-calendar-table': true,
	          'is-range': this.isInRange
	        },
	        attrs: { cellspacing: '0',
	          cellpadding: '0' }
	      },
	      [thead, h('tbody', [this.rows.map(function (row, index) {
	        return h(
	          'tr',
	          {
	            'class': {
	              'el-calendar-table__row': true,
	              'el-calendar-table__row--hide-border': index === 0 && _this.hideHeader
	            },
	            key: index },
	          [row.map(function (cell, key) {
	            return h(
	              'td',
	              { key: key,
	                'class': _this.getCellClass(cell),
	                on: {
	                  'click': _this.pickDay.bind(_this, cell)
	                }
	              },
	              [h(
	                'div',
	                { 'class': 'el-calendar-day' },
	                [_this.cellRenderProxy(cell)]
	              )]
	            );
	          })]
	        );
	      })])]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/calendar/src/date-table.vue?vue&type=script&lang=js&
	 /* harmony default export */ var calendar_src_date_tablevue_type_script_lang_js_ = (src_date_tablevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/calendar/src/date-table.vue
	var date_table_render, date_table_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var src_date_table_component = normalizeComponent(
	  calendar_src_date_tablevue_type_script_lang_js_,
	  date_table_render,
	  date_table_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var src_date_table_api; }
	src_date_table_component.options.__file = "packages/calendar/src/date-table.vue"
	/* harmony default export */ var src_date_table = (src_date_table_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/calendar/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	var validTypes = ['prev-month', 'today', 'next-month'];
	var weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
	var oneDay = 86400000;
	
	/* harmony default export */ var calendar_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElCalendar',
	
	  mixins: [locale_default.a],
	
	  components: {
	    DateTable: src_date_table,
	    ElButton: button_default.a,
	    ElButtonGroup: button_group_default.a
	  },
	
	  props: {
	    value: [Date, String, Number],
	    range: {
	      type: Array,
	      validator: function validator(range) {
	        if (Array.isArray(range)) {
	          return range.length === 2 && range.every(function (item) {
	            return typeof item === 'string' || typeof item === 'number' || item instanceof Date;
	          });
	        } else {
	          return true;
	        }
	      }
	    },
	    firstDayOfWeek: {
	      type: Number,
	      default: 1
	    }
	  },
	
	  provide: function provide() {
	    return {
	      elCalendar: this
	    };
	  },
	
	
	  methods: {
	    pickDay: function pickDay(day) {
	      this.realSelectedDay = day;
	    },
	    selectDate: function selectDate(type) {
	      if (validTypes.indexOf(type) === -1) {
	        throw new Error('invalid type ' + type);
	      }
	      var day = '';
	      if (type === 'prev-month') {
	        day = this.prevMonthDatePrefix + '-01';
	      } else if (type === 'next-month') {
	        day = this.nextMonthDatePrefix + '-01';
	      } else {
	        day = this.formatedToday;
	      }
	
	      if (day === this.formatedDate) return;
	      this.pickDay(day);
	    },
	    toDate: function toDate(val) {
	      if (!val) {
	        throw new Error('invalid val');
	      }
	      return val instanceof Date ? val : new Date(val);
	    },
	    rangeValidator: function rangeValidator(date, isStart) {
	      var firstDayOfWeek = this.realFirstDayOfWeek;
	      var expected = isStart ? firstDayOfWeek : firstDayOfWeek === 0 ? 6 : firstDayOfWeek - 1;
	      var message = (isStart ? 'start' : 'end') + ' of range should be ' + weekDays[expected] + '.';
	      if (date.getDay() !== expected) {
	        console.warn('[ElementCalendar]', message, 'Invalid range will be ignored.');
	        return false;
	      }
	      return true;
	    }
	  },
	
	  computed: {
	    prevMonthDatePrefix: function prevMonthDatePrefix() {
	      var temp = new Date(this.date.getTime());
	      temp.setDate(0);
	      return date_default.a.format(temp, 'yyyy-MM');
	    },
	    curMonthDatePrefix: function curMonthDatePrefix() {
	      return date_default.a.format(this.date, 'yyyy-MM');
	    },
	    nextMonthDatePrefix: function nextMonthDatePrefix() {
	      var temp = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 1);
	      return date_default.a.format(temp, 'yyyy-MM');
	    },
	    formatedDate: function formatedDate() {
	      return date_default.a.format(this.date, 'yyyy-MM-dd');
	    },
	    i18nDate: function i18nDate() {
	      var year = this.date.getFullYear();
	      var month = this.date.getMonth() + 1;
	      return year + ' ' + this.t('el.datepicker.year') + ' ' + this.t('el.datepicker.month' + month);
	    },
	    formatedToday: function formatedToday() {
	      return date_default.a.format(this.now, 'yyyy-MM-dd');
	    },
	
	
	    realSelectedDay: {
	      get: function get() {
	        if (!this.value) return this.selectedDay;
	        return this.formatedDate;
	      },
	      set: function set(val) {
	        this.selectedDay = val;
	        var date = new Date(val);
	        this.$emit('input', date);
	      }
	    },
	
	    date: function date() {
	      if (!this.value) {
	        if (this.realSelectedDay) {
	          var d = this.selectedDay.split('-');
	          return new Date(d[0], d[1] - 1, d[2]);
	        } else if (this.validatedRange.length) {
	          return this.validatedRange[0][0];
	        }
	        return this.now;
	      } else {
	        return this.toDate(this.value);
	      }
	    },
	
	
	    // if range is valid, we get a two-digit array
	    validatedRange: function validatedRange() {
	      var _this = this;
	
	      var range = this.range;
	      if (!range) return [];
	      range = range.reduce(function (prev, val, index) {
	        var date = _this.toDate(val);
	        if (_this.rangeValidator(date, index === 0)) {
	          prev = prev.concat(date);
	        }
	        return prev;
	      }, []);
	      if (range.length === 2) {
	        var _range = range,
	            start = _range[0],
	            end = _range[1];
	
	        if (start > end) {
	          console.warn('[ElementCalendar]end time should be greater than start time');
	          return [];
	        }
	        // start time and end time in one month
	        if (Object(date_util_["validateRangeInOneMonth"])(start, end)) {
	          return [[start, end]];
	        }
	        var data = [];
	        var startDay = new Date(start.getFullYear(), start.getMonth() + 1, 1);
	        var lastDay = this.toDate(startDay.getTime() - oneDay);
	        if (!Object(date_util_["validateRangeInOneMonth"])(startDay, end)) {
	          console.warn('[ElementCalendar]start time and end time interval must not exceed two months');
	          return [];
	        }
	        // 第一个月的时间范围
	        data.push([start, lastDay]);
	        // 下一月的时间范围，需要计算一下该月的第一个周起始日
	        var firstDayOfWeek = this.realFirstDayOfWeek;
	        var nextMontFirstDay = startDay.getDay();
	        var interval = 0;
	        if (nextMontFirstDay !== firstDayOfWeek) {
	          if (firstDayOfWeek === 0) {
	            interval = 7 - nextMontFirstDay;
	          } else {
	            interval = firstDayOfWeek - nextMontFirstDay;
	            interval = interval > 0 ? interval : 7 + interval;
	          }
	        }
	        startDay = this.toDate(startDay.getTime() + interval * oneDay);
	        if (startDay.getDate() < end.getDate()) {
	          data.push([startDay, end]);
	        }
	        return data;
	      }
	      return [];
	    },
	    realFirstDayOfWeek: function realFirstDayOfWeek() {
	      if (this.firstDayOfWeek < 1 || this.firstDayOfWeek > 6) {
	        return 0;
	      }
	      return Math.floor(this.firstDayOfWeek);
	    }
	  },
	
	  data: function data() {
	    return {
	      selectedDay: '',
	      now: new Date()
	    };
	  }
	});
	// CONCATENATED MODULE: ./packages/calendar/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_calendar_src_mainvue_type_script_lang_js_ = (calendar_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/calendar/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var calendar_src_main_component = normalizeComponent(
	  packages_calendar_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_6d9756be_render,
	  mainvue_type_template_id_6d9756be_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var calendar_src_main_api; }
	calendar_src_main_component.options.__file = "packages/calendar/src/main.vue"
	/* harmony default export */ var calendar_src_main = (calendar_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/calendar/index.js
	
	
	/* istanbul ignore next */
	calendar_src_main.install = function (Vue) {
	  Vue.component(calendar_src_main.name, calendar_src_main);
	};
	
	/* harmony default export */ var calendar = (calendar_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/backtop/src/main.vue?vue&type=template&id=257dd4a9&
	var mainvue_type_template_id_257dd4a9_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("transition", { attrs: { name: "el-fade-in" } }, [
	    _vm.visible
	      ? _c(
	          "div",
	          {
	            staticClass: "el-backtop",
	            style: {
	              right: _vm.styleRight,
	              bottom: _vm.styleBottom
	            },
	            on: {
	              click: function($event) {
	                $event.stopPropagation()
	                return _vm.handleClick($event)
	              }
	            }
	          },
	          [
	            _vm._t("default", [_c("el-icon", { attrs: { name: "caret-top" } })])
	          ],
	          2
	        )
	      : _vm._e()
	  ])
	}
	var mainvue_type_template_id_257dd4a9_staticRenderFns = []
	mainvue_type_template_id_257dd4a9_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/backtop/src/main.vue?vue&type=template&id=257dd4a9&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/backtop/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	var cubic = function cubic(value) {
	  return Math.pow(value, 3);
	};
	var easeInOutCubic = function easeInOutCubic(value) {
	  return value < 0.5 ? cubic(value * 2) / 2 : 1 - cubic((1 - value) * 2) / 2;
	};
	
	/* harmony default export */ var backtop_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElBacktop',
	
	  props: {
	    visibilityHeight: {
	      type: Number,
	      default: 200
	    },
	    target: [String],
	    right: {
	      type: Number,
	      default: 40
	    },
	    bottom: {
	      type: Number,
	      default: 40
	    }
	  },
	
	  data: function data() {
	    return {
	      el: null,
	      container: null,
	      visible: false
	    };
	  },
	
	
	  computed: {
	    styleBottom: function styleBottom() {
	      return this.bottom + 'px';
	    },
	    styleRight: function styleRight() {
	      return this.right + 'px';
	    }
	  },
	
	  mounted: function mounted() {
	    this.init();
	    this.throttledScrollHandler = throttle_default()(300, this.onScroll);
	    this.container.addEventListener('scroll', this.throttledScrollHandler);
	  },
	
	
	  methods: {
	    init: function init() {
	      this.container = document;
	      this.el = document.documentElement;
	      if (this.target) {
	        this.el = document.querySelector(this.target);
	        if (!this.el) {
	          throw new Error('target is not existed: ' + this.target);
	        }
	        this.container = this.el;
	      }
	    },
	    onScroll: function onScroll() {
	      var scrollTop = this.el.scrollTop;
	      this.visible = scrollTop >= this.visibilityHeight;
	    },
	    handleClick: function handleClick(e) {
	      this.scrollToTop();
	      this.$emit('click', e);
	    },
	    scrollToTop: function scrollToTop() {
	      var el = this.el;
	      var beginTime = Date.now();
	      var beginValue = el.scrollTop;
	      var rAF = window.requestAnimationFrame || function (func) {
	        return setTimeout(func, 16);
	      };
	      var frameFunc = function frameFunc() {
	        var progress = (Date.now() - beginTime) / 500;
	        if (progress < 1) {
	          el.scrollTop = beginValue * (1 - easeInOutCubic(progress));
	          rAF(frameFunc);
	        } else {
	          el.scrollTop = 0;
	        }
	      };
	      rAF(frameFunc);
	    }
	  },
	
	  beforeDestroy: function beforeDestroy() {
	    this.container.removeEventListener('scroll', this.throttledScrollHandler);
	  }
	});
	// CONCATENATED MODULE: ./packages/backtop/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_backtop_src_mainvue_type_script_lang_js_ = (backtop_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/backtop/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var backtop_src_main_component = normalizeComponent(
	  packages_backtop_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_257dd4a9_render,
	  mainvue_type_template_id_257dd4a9_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var backtop_src_main_api; }
	backtop_src_main_component.options.__file = "packages/backtop/src/main.vue"
	/* harmony default export */ var backtop_src_main = (backtop_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/backtop/index.js
	
	
	/* istanbul ignore next */
	backtop_src_main.install = function (Vue) {
	  Vue.component(backtop_src_main.name, backtop_src_main);
	};
	
	/* harmony default export */ var backtop = (backtop_src_main);
	// CONCATENATED MODULE: ./packages/infinite-scroll/src/main.js
	
	
	
	
	var getStyleComputedProperty = function getStyleComputedProperty(element, property) {
	  if (element === window) {
	    element = document.documentElement;
	  }
	
	  if (element.nodeType !== 1) {
	    return [];
	  }
	  // NOTE: 1 DOM access here
	  var css = window.getComputedStyle(element, null);
	  return property ? css[property] : css;
	};
	
	var entries = function entries(obj) {
	  return Object.keys(obj || {}).map(function (key) {
	    return [key, obj[key]];
	  });
	};
	
	var getPositionSize = function getPositionSize(el, prop) {
	  return el === window || el === document ? document.documentElement[prop] : el[prop];
	};
	
	var getOffsetHeight = function getOffsetHeight(el) {
	  return getPositionSize(el, 'offsetHeight');
	};
	
	var getClientHeight = function getClientHeight(el) {
	  return getPositionSize(el, 'clientHeight');
	};
	
	var scope = 'ElInfiniteScroll';
	var attributes = {
	  delay: {
	    type: Number,
	    default: 200
	  },
	  distance: {
	    type: Number,
	    default: 0
	  },
	  disabled: {
	    type: Boolean,
	    default: false
	  },
	  immediate: {
	    type: Boolean,
	    default: true
	  }
	};
	
	var main_getScrollOptions = function getScrollOptions(el, vm) {
	  if (!Object(types_["isHtmlElement"])(el)) return {};
	
	  return entries(attributes).reduce(function (map, _ref) {
	    var key = _ref[0],
	        option = _ref[1];
	    var type = option.type,
	        defaultValue = option.default;
	
	    var value = el.getAttribute('infinite-scroll-' + key);
	    value = Object(types_["isUndefined"])(vm[value]) ? value : vm[value];
	    switch (type) {
	      case Number:
	        value = Number(value);
	        value = Number.isNaN(value) ? defaultValue : value;
	        break;
	      case Boolean:
	        value = Object(types_["isDefined"])(value) ? value === 'false' ? false : Boolean(value) : defaultValue;
	        break;
	      default:
	        value = type(value);
	    }
	    map[key] = value;
	    return map;
	  }, {});
	};
	
	var getElementTop = function getElementTop(el) {
	  return el.getBoundingClientRect().top;
	};
	
	var main_handleScroll = function handleScroll(cb) {
	  var _scope = this[scope],
	      el = _scope.el,
	      vm = _scope.vm,
	      container = _scope.container,
	      observer = _scope.observer;
	
	  var _getScrollOptions = main_getScrollOptions(el, vm),
	      distance = _getScrollOptions.distance,
	      disabled = _getScrollOptions.disabled;
	
	  if (disabled) return;
	
	  var containerInfo = container.getBoundingClientRect();
	  if (!containerInfo.width && !containerInfo.height) return;
	
	  var shouldTrigger = false;
	
	  if (container === el) {
	    // be aware of difference between clientHeight & offsetHeight & window.getComputedStyle().height
	    var scrollBottom = container.scrollTop + getClientHeight(container);
	    shouldTrigger = container.scrollHeight - scrollBottom <= distance;
	  } else {
	    var heightBelowTop = getOffsetHeight(el) + getElementTop(el) - getElementTop(container);
	    var offsetHeight = getOffsetHeight(container);
	    var borderBottom = Number.parseFloat(getStyleComputedProperty(container, 'borderBottomWidth'));
	    shouldTrigger = heightBelowTop - offsetHeight + borderBottom <= distance;
	  }
	
	  if (shouldTrigger && Object(types_["isFunction"])(cb)) {
	    cb.call(vm);
	  } else if (observer) {
	    observer.disconnect();
	    this[scope].observer = null;
	  }
	};
	
	/* harmony default export */ var infinite_scroll_src_main = ({
	  name: 'InfiniteScroll',
	  inserted: function inserted(el, binding, vnode) {
	    var cb = binding.value;
	
	    var vm = vnode.context;
	    // only include vertical scroll
	    var container = Object(dom_["getScrollContainer"])(el, true);
	
	    var _getScrollOptions2 = main_getScrollOptions(el, vm),
	        delay = _getScrollOptions2.delay,
	        immediate = _getScrollOptions2.immediate;
	
	    var onScroll = debounce_default()(delay, main_handleScroll.bind(el, cb));
	
	    el[scope] = { el: el, vm: vm, container: container, onScroll: onScroll };
	
	    if (container) {
	      container.addEventListener('scroll', onScroll);
	
	      if (immediate) {
	        var observer = el[scope].observer = new MutationObserver(onScroll);
	        observer.observe(container, { childList: true, subtree: true });
	        onScroll();
	      }
	    }
	  },
	  unbind: function unbind(el) {
	    var _el$scope = el[scope],
	        container = _el$scope.container,
	        onScroll = _el$scope.onScroll;
	
	    if (container) {
	      container.removeEventListener('scroll', onScroll);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/infinite-scroll/index.js
	
	
	/* istanbul ignore next */
	infinite_scroll_src_main.install = function (Vue) {
	  Vue.directive(infinite_scroll_src_main.name, infinite_scroll_src_main);
	};
	
	/* harmony default export */ var infinite_scroll = (infinite_scroll_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/page-header/src/main.vue?vue&type=template&id=5070954c&
	var mainvue_type_template_id_5070954c_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("div", { staticClass: "el-page-header" }, [
	    _c(
	      "div",
	      {
	        staticClass: "el-page-header__left",
	        on: {
	          click: function($event) {
	            _vm.$emit("back")
	          }
	        }
	      },
	      [
	        _c("i", { staticClass: "el-icon-back" }),
	        _c(
	          "div",
	          { staticClass: "el-page-header__title" },
	          [_vm._t("title", [_vm._v(_vm._s(_vm.title))])],
	          2
	        )
	      ]
	    ),
	    _c(
	      "div",
	      { staticClass: "el-page-header__content" },
	      [_vm._t("content", [_vm._v(_vm._s(_vm.content))])],
	      2
	    )
	  ])
	}
	var mainvue_type_template_id_5070954c_staticRenderFns = []
	mainvue_type_template_id_5070954c_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/page-header/src/main.vue?vue&type=template&id=5070954c&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/page-header/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	/* harmony default export */ var page_header_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElPageHeader',
	
	  props: {
	    title: {
	      type: String,
	      default: function _default() {
	        return Object(lib_locale_["t"])('el.pageHeader.title');
	      }
	    },
	    content: String
	  }
	});
	// CONCATENATED MODULE: ./packages/page-header/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_page_header_src_mainvue_type_script_lang_js_ = (page_header_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/page-header/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var page_header_src_main_component = normalizeComponent(
	  packages_page_header_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_5070954c_render,
	  mainvue_type_template_id_5070954c_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var page_header_src_main_api; }
	page_header_src_main_component.options.__file = "packages/page-header/src/main.vue"
	/* harmony default export */ var page_header_src_main = (page_header_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/page-header/index.js
	
	
	/* istanbul ignore next */
	page_header_src_main.install = function (Vue) {
	  Vue.component(page_header_src_main.name, page_header_src_main);
	};
	
	/* harmony default export */ var page_header = (page_header_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-panel.vue?vue&type=template&id=34932346&
	var cascader_panelvue_type_template_id_34932346_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      class: ["el-cascader-panel", _vm.border && "is-bordered"],
	      on: { keydown: _vm.handleKeyDown }
	    },
	    _vm._l(_vm.menus, function(menu, index) {
	      return _c("cascader-menu", {
	        key: index,
	        ref: "menu",
	        refInFor: true,
	        attrs: { index: index, nodes: menu }
	      })
	    }),
	    1
	  )
	}
	var cascader_panelvue_type_template_id_34932346_staticRenderFns = []
	cascader_panelvue_type_template_id_34932346_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-panel.vue?vue&type=template&id=34932346&
	
	// EXTERNAL MODULE: external "element-ui/lib/radio"
	var radio_ = __webpack_require__(43);
	var radio_default = /*#__PURE__*/__webpack_require__.n(radio_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-node.vue?vue&type=script&lang=js&
	
	
	
	
	
	
	var stopPropagation = function stopPropagation(e) {
	  return e.stopPropagation();
	};
	
	/* harmony default export */ var cascader_nodevue_type_script_lang_js_ = ({
	  inject: ['panel'],
	
	  components: {
	    ElCheckbox: checkbox_default.a,
	    ElRadio: radio_default.a
	  },
	
	  props: {
	    node: {
	      required: true
	    },
	    nodeId: String
	  },
	
	  computed: {
	    config: function config() {
	      return this.panel.config;
	    },
	    isLeaf: function isLeaf() {
	      return this.node.isLeaf;
	    },
	    isDisabled: function isDisabled() {
	      return this.node.isDisabled;
	    },
	    checkedValue: function checkedValue() {
	      return this.panel.checkedValue;
	    },
	    isChecked: function isChecked() {
	      return this.node.isSameNode(this.checkedValue);
	    },
	    inActivePath: function inActivePath() {
	      return this.isInPath(this.panel.activePath);
	    },
	    inCheckedPath: function inCheckedPath() {
	      var _this = this;
	
	      if (!this.config.checkStrictly) return false;
	
	      return this.panel.checkedNodePaths.some(function (checkedPath) {
	        return _this.isInPath(checkedPath);
	      });
	    },
	    value: function value() {
	      return this.node.getValueByOption();
	    }
	  },
	
	  methods: {
	    handleExpand: function handleExpand() {
	      var _this2 = this;
	
	      var panel = this.panel,
	          node = this.node,
	          isDisabled = this.isDisabled,
	          config = this.config;
	      var multiple = config.multiple,
	          checkStrictly = config.checkStrictly;
	
	
	      if (!checkStrictly && isDisabled || node.loading) return;
	
	      if (config.lazy && !node.loaded) {
	        panel.lazyLoad(node, function () {
	          // do not use cached leaf value here, invoke this.isLeaf to get new value.
	          var isLeaf = _this2.isLeaf;
	
	
	          if (!isLeaf) _this2.handleExpand();
	          if (multiple) {
	            // if leaf sync checked state, else clear checked state
	            var checked = isLeaf ? node.checked : false;
	            _this2.handleMultiCheckChange(checked);
	          }
	        });
	      } else {
	        panel.handleExpand(node);
	      }
	    },
	    handleCheckChange: function handleCheckChange() {
	      var panel = this.panel,
	          value = this.value,
	          node = this.node;
	
	      panel.handleCheckChange(value);
	      panel.handleExpand(node);
	    },
	    handleMultiCheckChange: function handleMultiCheckChange(checked) {
	      this.node.doCheck(checked);
	      this.panel.calculateMultiCheckedValue();
	    },
	    isInPath: function isInPath(pathNodes) {
	      var node = this.node;
	
	      var selectedPathNode = pathNodes[node.level - 1] || {};
	      return selectedPathNode.uid === node.uid;
	    },
	    renderPrefix: function renderPrefix(h) {
	      var isLeaf = this.isLeaf,
	          isChecked = this.isChecked,
	          config = this.config;
	      var checkStrictly = config.checkStrictly,
	          multiple = config.multiple;
	
	
	      if (multiple) {
	        return this.renderCheckbox(h);
	      } else if (checkStrictly) {
	        return this.renderRadio(h);
	      } else if (isLeaf && isChecked) {
	        return this.renderCheckIcon(h);
	      }
	
	      return null;
	    },
	    renderPostfix: function renderPostfix(h) {
	      var node = this.node,
	          isLeaf = this.isLeaf;
	
	
	      if (node.loading) {
	        return this.renderLoadingIcon(h);
	      } else if (!isLeaf) {
	        return this.renderExpandIcon(h);
	      }
	
	      return null;
	    },
	    renderCheckbox: function renderCheckbox(h) {
	      var node = this.node,
	          config = this.config,
	          isDisabled = this.isDisabled;
	
	      var events = {
	        on: { change: this.handleMultiCheckChange },
	        nativeOn: {}
	      };
	
	      if (config.checkStrictly) {
	        // when every node is selectable, click event should not trigger expand event.
	        events.nativeOn.click = stopPropagation;
	      }
	
	      return h('el-checkbox', external_babel_helper_vue_jsx_merge_props_default()([{
	        attrs: {
	          value: node.checked,
	          indeterminate: node.indeterminate,
	          disabled: isDisabled
	        }
	      }, events]));
	    },
	    renderRadio: function renderRadio(h) {
	      var checkedValue = this.checkedValue,
	          value = this.value,
	          isDisabled = this.isDisabled;
	
	      // to keep same reference if value cause radio's checked state is calculated by reference comparision;
	
	      if (Object(util_["isEqual"])(value, checkedValue)) {
	        value = checkedValue;
	      }
	
	      return h(
	        'el-radio',
	        {
	          attrs: {
	            value: checkedValue,
	            label: value,
	            disabled: isDisabled
	          },
	          on: {
	            'change': this.handleCheckChange
	          },
	          nativeOn: {
	            'click': stopPropagation
	          }
	        },
	        [h('span')]
	      );
	    },
	    renderCheckIcon: function renderCheckIcon(h) {
	      return h('i', { 'class': 'el-icon-check el-cascader-node__prefix' });
	    },
	    renderLoadingIcon: function renderLoadingIcon(h) {
	      return h('i', { 'class': 'el-icon-loading el-cascader-node__postfix' });
	    },
	    renderExpandIcon: function renderExpandIcon(h) {
	      return h('i', { 'class': 'el-icon-arrow-right el-cascader-node__postfix' });
	    },
	    renderContent: function renderContent(h) {
	      var panel = this.panel,
	          node = this.node;
	
	      var render = panel.renderLabelFn;
	      var vnode = render ? render({ node: node, data: node.data }) : null;
	
	      return h(
	        'span',
	        { 'class': 'el-cascader-node__label' },
	        [vnode || node.label]
	      );
	    }
	  },
	
	  render: function render(h) {
	    var _this3 = this;
	
	    var inActivePath = this.inActivePath,
	        inCheckedPath = this.inCheckedPath,
	        isChecked = this.isChecked,
	        isLeaf = this.isLeaf,
	        isDisabled = this.isDisabled,
	        config = this.config,
	        nodeId = this.nodeId;
	    var expandTrigger = config.expandTrigger,
	        checkStrictly = config.checkStrictly,
	        multiple = config.multiple;
	
	    var disabled = !checkStrictly && isDisabled;
	    var events = { on: {} };
	
	    if (expandTrigger === 'click') {
	      events.on.click = this.handleExpand;
	    } else {
	      events.on.mouseenter = function (e) {
	        _this3.handleExpand();
	        _this3.$emit('expand', e);
	      };
	      events.on.focus = function (e) {
	        _this3.handleExpand();
	        _this3.$emit('expand', e);
	      };
	    }
	    if (isLeaf && !isDisabled && !checkStrictly && !multiple) {
	      events.on.click = this.handleCheckChange;
	    }
	
	    return h(
	      'li',
	      external_babel_helper_vue_jsx_merge_props_default()([{
	        attrs: {
	          role: 'menuitem',
	          id: nodeId,
	          'aria-expanded': inActivePath,
	          tabindex: disabled ? null : -1
	        },
	        'class': {
	          'el-cascader-node': true,
	          'is-selectable': checkStrictly,
	          'in-active-path': inActivePath,
	          'in-checked-path': inCheckedPath,
	          'is-active': isChecked,
	          'is-disabled': disabled
	        }
	      }, events]),
	      [this.renderPrefix(h), this.renderContent(h), this.renderPostfix(h)]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-node.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_cascader_nodevue_type_script_lang_js_ = (cascader_nodevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-node.vue
	var cascader_node_render, cascader_node_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var cascader_node_component = normalizeComponent(
	  src_cascader_nodevue_type_script_lang_js_,
	  cascader_node_render,
	  cascader_node_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var cascader_node_api; }
	cascader_node_component.options.__file = "packages/cascader-panel/src/cascader-node.vue"
	/* harmony default export */ var cascader_node = (cascader_node_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-menu.vue?vue&type=script&lang=js&
	
	
	
	
	
	
	
	/* harmony default export */ var cascader_menuvue_type_script_lang_js_ = ({
	  name: 'ElCascaderMenu',
	
	  mixins: [locale_default.a],
	
	  inject: ['panel'],
	
	  components: {
	    ElScrollbar: scrollbar_default.a,
	    CascaderNode: cascader_node
	  },
	
	  props: {
	    nodes: {
	      type: Array,
	      required: true
	    },
	    index: Number
	  },
	
	  data: function data() {
	    return {
	      activeNode: null,
	      hoverTimer: null,
	      id: Object(util_["generateId"])()
	    };
	  },
	
	
	  computed: {
	    isEmpty: function isEmpty() {
	      return !this.nodes.length;
	    },
	    menuId: function menuId() {
	      return 'cascader-menu-' + this.id + '-' + this.index;
	    }
	  },
	
	  methods: {
	    handleExpand: function handleExpand(e) {
	      this.activeNode = e.target;
	    },
	    handleMouseMove: function handleMouseMove(e) {
	      var activeNode = this.activeNode,
	          hoverTimer = this.hoverTimer;
	      var hoverZone = this.$refs.hoverZone;
	
	
	      if (!activeNode || !hoverZone) return;
	
	      if (activeNode.contains(e.target)) {
	        clearTimeout(hoverTimer);
	
	        var _$el$getBoundingClien = this.$el.getBoundingClientRect(),
	            left = _$el$getBoundingClien.left;
	
	        var startX = e.clientX - left;
	        var _$el = this.$el,
	            offsetWidth = _$el.offsetWidth,
	            offsetHeight = _$el.offsetHeight;
	
	        var top = activeNode.offsetTop;
	        var bottom = top + activeNode.offsetHeight;
	
	        hoverZone.innerHTML = '\n          <path style="pointer-events: auto;" fill="transparent" d="M' + startX + ' ' + top + ' L' + offsetWidth + ' 0 V' + top + ' Z" />\n          <path style="pointer-events: auto;" fill="transparent" d="M' + startX + ' ' + bottom + ' L' + offsetWidth + ' ' + offsetHeight + ' V' + bottom + ' Z" />\n        ';
	      } else if (!hoverTimer) {
	        this.hoverTimer = setTimeout(this.clearHoverZone, this.panel.config.hoverThreshold);
	      }
	    },
	    clearHoverZone: function clearHoverZone() {
	      var hoverZone = this.$refs.hoverZone;
	
	      if (!hoverZone) return;
	      hoverZone.innerHTML = '';
	    },
	    renderEmptyText: function renderEmptyText(h) {
	      return h(
	        'div',
	        { 'class': 'el-cascader-menu__empty-text' },
	        [this.t('el.cascader.noData')]
	      );
	    },
	    renderNodeList: function renderNodeList(h) {
	      var menuId = this.menuId;
	      var isHoverMenu = this.panel.isHoverMenu;
	
	      var events = { on: {} };
	
	      if (isHoverMenu) {
	        events.on.expand = this.handleExpand;
	      }
	
	      var nodes = this.nodes.map(function (node, index) {
	        var hasChildren = node.hasChildren;
	
	        return h('cascader-node', external_babel_helper_vue_jsx_merge_props_default()([{
	          key: node.uid,
	          attrs: { node: node,
	            'node-id': menuId + '-' + index,
	            'aria-haspopup': hasChildren,
	            'aria-owns': hasChildren ? menuId : null
	          }
	        }, events]));
	      });
	
	      return [].concat(nodes, [isHoverMenu ? h('svg', { ref: 'hoverZone', 'class': 'el-cascader-menu__hover-zone' }) : null]);
	    }
	  },
	
	  render: function render(h) {
	    var isEmpty = this.isEmpty,
	        menuId = this.menuId;
	
	    var events = { nativeOn: {} };
	
	    // optimize hover to expand experience (#8010)
	    if (this.panel.isHoverMenu) {
	      events.nativeOn.mousemove = this.handleMouseMove;
	      // events.nativeOn.mouseleave = this.clearHoverZone;
	    }
	
	    return h(
	      'el-scrollbar',
	      external_babel_helper_vue_jsx_merge_props_default()([{
	        attrs: {
	          tag: 'ul',
	          role: 'menu',
	          id: menuId,
	
	          'wrap-class': 'el-cascader-menu__wrap',
	          'view-class': {
	            'el-cascader-menu__list': true,
	            'is-empty': isEmpty
	          }
	        },
	        'class': 'el-cascader-menu' }, events]),
	      [isEmpty ? this.renderEmptyText(h) : this.renderNodeList(h)]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-menu.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_cascader_menuvue_type_script_lang_js_ = (cascader_menuvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-menu.vue
	var cascader_menu_render, cascader_menu_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var cascader_menu_component = normalizeComponent(
	  src_cascader_menuvue_type_script_lang_js_,
	  cascader_menu_render,
	  cascader_menu_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var cascader_menu_api; }
	cascader_menu_component.options.__file = "packages/cascader-panel/src/cascader-menu.vue"
	/* harmony default export */ var cascader_menu = (cascader_menu_component.exports);
	// CONCATENATED MODULE: ./packages/cascader-panel/src/node.js
	var node_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function src_node_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	
	
	
	var uid = 0;
	
	var src_node_Node = function () {
	  function Node(data, config, parentNode) {
	    src_node_classCallCheck(this, Node);
	
	    this.data = data;
	    this.config = config;
	    this.parent = parentNode || null;
	    this.level = !this.parent ? 1 : this.parent.level + 1;
	    this.uid = uid++;
	
	    this.initState();
	    this.initChildren();
	  }
	
	  Node.prototype.initState = function initState() {
	    var _config = this.config,
	        valueKey = _config.value,
	        labelKey = _config.label;
	
	
	    this.value = this.data[valueKey];
	    this.label = this.data[labelKey];
	    this.pathNodes = this.calculatePathNodes();
	    this.path = this.pathNodes.map(function (node) {
	      return node.value;
	    });
	    this.pathLabels = this.pathNodes.map(function (node) {
	      return node.label;
	    });
	
	    // lazy load
	    this.loading = false;
	    this.loaded = false;
	  };
	
	  Node.prototype.initChildren = function initChildren() {
	    var _this = this;
	
	    var config = this.config;
	
	    var childrenKey = config.children;
	    var childrenData = this.data[childrenKey];
	    this.hasChildren = Array.isArray(childrenData);
	    this.children = (childrenData || []).map(function (child) {
	      return new Node(child, config, _this);
	    });
	  };
	
	  Node.prototype.calculatePathNodes = function calculatePathNodes() {
	    var nodes = [this];
	    var parent = this.parent;
	
	    while (parent) {
	      nodes.unshift(parent);
	      parent = parent.parent;
	    }
	
	    return nodes;
	  };
	
	  Node.prototype.getPath = function getPath() {
	    return this.path;
	  };
	
	  Node.prototype.getValue = function getValue() {
	    return this.value;
	  };
	
	  Node.prototype.getValueByOption = function getValueByOption() {
	    return this.config.emitPath ? this.getPath() : this.getValue();
	  };
	
	  Node.prototype.getText = function getText(allLevels, separator) {
	    return allLevels ? this.pathLabels.join(separator) : this.label;
	  };
	
	  Node.prototype.isSameNode = function isSameNode(checkedValue) {
	    var value = this.getValueByOption();
	    return this.config.multiple && Array.isArray(checkedValue) ? checkedValue.some(function (val) {
	      return Object(util_["isEqual"])(val, value);
	    }) : Object(util_["isEqual"])(checkedValue, value);
	  };
	
	  Node.prototype.broadcast = function broadcast(event) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var handlerName = 'onParent' + Object(util_["capitalize"])(event);
	
	    this.children.forEach(function (child) {
	      if (child) {
	        // bottom up
	        child.broadcast.apply(child, [event].concat(args));
	        child[handlerName] && child[handlerName].apply(child, args);
	      }
	    });
	  };
	
	  Node.prototype.emit = function emit(event) {
	    var parent = this.parent;
	
	    var handlerName = 'onChild' + Object(util_["capitalize"])(event);
	    if (parent) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        args[_key2 - 1] = arguments[_key2];
	      }
	
	      parent[handlerName] && parent[handlerName].apply(parent, args);
	      parent.emit.apply(parent, [event].concat(args));
	    }
	  };
	
	  Node.prototype.onParentCheck = function onParentCheck(checked) {
	    if (!this.isDisabled) {
	      this.setCheckState(checked);
	    }
	  };
	
	  Node.prototype.onChildCheck = function onChildCheck() {
	    var children = this.children;
	
	    var validChildren = children.filter(function (child) {
	      return !child.isDisabled;
	    });
	    var checked = validChildren.length ? validChildren.every(function (child) {
	      return child.checked;
	    }) : false;
	
	    this.setCheckState(checked);
	  };
	
	  Node.prototype.setCheckState = function setCheckState(checked) {
	    var totalNum = this.children.length;
	    var checkedNum = this.children.reduce(function (c, p) {
	      var num = p.checked ? 1 : p.indeterminate ? 0.5 : 0;
	      return c + num;
	    }, 0);
	
	    this.checked = checked;
	    this.indeterminate = checkedNum !== totalNum && checkedNum > 0;
	  };
	
	  Node.prototype.syncCheckState = function syncCheckState(checkedValue) {
	    var value = this.getValueByOption();
	    var checked = this.isSameNode(checkedValue, value);
	
	    this.doCheck(checked);
	  };
	
	  Node.prototype.doCheck = function doCheck(checked) {
	    if (this.checked !== checked) {
	      if (this.config.checkStrictly) {
	        this.checked = checked;
	      } else {
	        // bottom up to unify the calculation of the indeterminate state
	        this.broadcast('check', checked);
	        this.setCheckState(checked);
	        this.emit('check');
	      }
	    }
	  };
	
	  node_createClass(Node, [{
	    key: 'isDisabled',
	    get: function get() {
	      var data = this.data,
	          parent = this.parent,
	          config = this.config;
	
	      var disabledKey = config.disabled;
	      var checkStrictly = config.checkStrictly;
	
	      return data[disabledKey] || !checkStrictly && parent && parent.isDisabled;
	    }
	  }, {
	    key: 'isLeaf',
	    get: function get() {
	      var data = this.data,
	          loaded = this.loaded,
	          hasChildren = this.hasChildren,
	          children = this.children;
	      var _config2 = this.config,
	          lazy = _config2.lazy,
	          leafKey = _config2.leaf;
	
	      if (lazy) {
	        var isLeaf = Object(shared_["isDef"])(data[leafKey]) ? data[leafKey] : loaded ? !children.length : false;
	        this.hasChildren = !isLeaf;
	        return isLeaf;
	      }
	      return !hasChildren;
	    }
	  }]);
	
	  return Node;
	}();
	
	/* harmony default export */ var src_node = (src_node_Node);
	// CONCATENATED MODULE: ./packages/cascader-panel/src/store.js
	function store_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	
	
	
	var flatNodes = function flatNodes(data, leafOnly) {
	  return data.reduce(function (res, node) {
	    if (node.isLeaf) {
	      res.push(node);
	    } else {
	      !leafOnly && res.push(node);
	      res = res.concat(flatNodes(node.children, leafOnly));
	    }
	    return res;
	  }, []);
	};
	
	var store_Store = function () {
	  function Store(data, config) {
	    store_classCallCheck(this, Store);
	
	    this.config = config;
	    this.initNodes(data);
	  }
	
	  Store.prototype.initNodes = function initNodes(data) {
	    var _this = this;
	
	    data = Object(util_["coerceTruthyValueToArray"])(data);
	    this.nodes = data.map(function (nodeData) {
	      return new src_node(nodeData, _this.config);
	    });
	    this.flattedNodes = this.getFlattedNodes(false, false);
	    this.leafNodes = this.getFlattedNodes(true, false);
	  };
	
	  Store.prototype.appendNode = function appendNode(nodeData, parentNode) {
	    var node = new src_node(nodeData, this.config, parentNode);
	    var children = parentNode ? parentNode.children : this.nodes;
	
	    children.push(node);
	  };
	
	  Store.prototype.appendNodes = function appendNodes(nodeDataList, parentNode) {
	    var _this2 = this;
	
	    nodeDataList = Object(util_["coerceTruthyValueToArray"])(nodeDataList);
	    nodeDataList.forEach(function (nodeData) {
	      return _this2.appendNode(nodeData, parentNode);
	    });
	  };
	
	  Store.prototype.getNodes = function getNodes() {
	    return this.nodes;
	  };
	
	  Store.prototype.getFlattedNodes = function getFlattedNodes(leafOnly) {
	    var cached = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    var cachedNodes = leafOnly ? this.leafNodes : this.flattedNodes;
	    return cached ? cachedNodes : flatNodes(this.nodes, leafOnly);
	  };
	
	  Store.prototype.getNodeByValue = function getNodeByValue(value) {
	    if (value) {
	      var nodes = this.getFlattedNodes(false, !this.config.lazy).filter(function (node) {
	        return Object(util_["valueEquals"])(node.path, value) || node.value === value;
	      });
	      return nodes && nodes.length ? nodes[0] : null;
	    }
	    return null;
	  };
	
	  return Store;
	}();
	
	/* harmony default export */ var cascader_panel_src_store = (store_Store);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-panel.vue?vue&type=script&lang=js&
	var cascader_panelvue_type_script_lang_js_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	var cascader_panelvue_type_script_lang_js_KeyCode = aria_utils_default.a.keys;
	
	var DefaultProps = {
	  expandTrigger: 'click', // or hover
	  multiple: false,
	  checkStrictly: false, // whether all nodes can be selected
	  emitPath: true, // wether to emit an array of all levels value in which node is located
	  lazy: false,
	  lazyLoad: util_["noop"],
	  value: 'value',
	  label: 'label',
	  children: 'children',
	  leaf: 'leaf',
	  disabled: 'disabled',
	  hoverThreshold: 500
	};
	
	var cascader_panelvue_type_script_lang_js_isLeaf = function isLeaf(el) {
	  return !el.getAttribute('aria-owns');
	};
	
	var getSibling = function getSibling(el, distance) {
	  var parentNode = el.parentNode;
	
	  if (parentNode) {
	    var siblings = parentNode.querySelectorAll('.el-cascader-node[tabindex="-1"]');
	    var index = Array.prototype.indexOf.call(siblings, el);
	    return siblings[index + distance] || null;
	  }
	  return null;
	};
	
	var getMenuIndex = function getMenuIndex(el, distance) {
	  if (!el) return;
	  var pieces = el.id.split('-');
	  return Number(pieces[pieces.length - 2]);
	};
	
	var focusNode = function focusNode(el) {
	  if (!el) return;
	  el.focus();
	  !cascader_panelvue_type_script_lang_js_isLeaf(el) && el.click();
	};
	
	var checkNode = function checkNode(el) {
	  if (!el) return;
	
	  var input = el.querySelector('input');
	  if (input) {
	    input.click();
	  } else if (cascader_panelvue_type_script_lang_js_isLeaf(el)) {
	    el.click();
	  }
	};
	
	/* harmony default export */ var cascader_panelvue_type_script_lang_js_ = ({
	  name: 'ElCascaderPanel',
	
	  components: {
	    CascaderMenu: cascader_menu
	  },
	
	  props: {
	    value: {},
	    options: Array,
	    props: Object,
	    border: {
	      type: Boolean,
	      default: true
	    },
	    renderLabel: Function
	  },
	
	  provide: function provide() {
	    return {
	      panel: this
	    };
	  },
	  data: function data() {
	    return {
	      checkedValue: null,
	      checkedNodePaths: [],
	      store: [],
	      menus: [],
	      activePath: [],
	      loadCount: 0
	    };
	  },
	
	
	  computed: {
	    config: function config() {
	      return merge_default()(cascader_panelvue_type_script_lang_js_extends({}, DefaultProps), this.props || {});
	    },
	    multiple: function multiple() {
	      return this.config.multiple;
	    },
	    checkStrictly: function checkStrictly() {
	      return this.config.checkStrictly;
	    },
	    leafOnly: function leafOnly() {
	      return !this.checkStrictly;
	    },
	    isHoverMenu: function isHoverMenu() {
	      return this.config.expandTrigger === 'hover';
	    },
	    renderLabelFn: function renderLabelFn() {
	      return this.renderLabel || this.$scopedSlots.default;
	    }
	  },
	
	  watch: {
	    options: {
	      handler: function handler() {
	        this.initStore();
	      },
	      immediate: true,
	      deep: true
	    },
	    value: function value() {
	      this.syncCheckedValue();
	      this.checkStrictly && this.calculateCheckedNodePaths();
	    },
	    checkedValue: function checkedValue(val) {
	      if (!Object(util_["isEqual"])(val, this.value)) {
	        this.checkStrictly && this.calculateCheckedNodePaths();
	        this.$emit('input', val);
	        this.$emit('change', val);
	      }
	    }
	  },
	
	  mounted: function mounted() {
	    if (!Object(util_["isEmpty"])(this.value)) {
	      this.syncCheckedValue();
	    }
	  },
	
	
	  methods: {
	    initStore: function initStore() {
	      var config = this.config,
	          options = this.options;
	
	      if (config.lazy && Object(util_["isEmpty"])(options)) {
	        this.lazyLoad();
	      } else {
	        this.store = new cascader_panel_src_store(options, config);
	        this.menus = [this.store.getNodes()];
	        this.syncMenuState();
	      }
	    },
	    syncCheckedValue: function syncCheckedValue() {
	      var value = this.value,
	          checkedValue = this.checkedValue;
	
	      if (!Object(util_["isEqual"])(value, checkedValue)) {
	        this.activePath = [];
	        this.checkedValue = value;
	        this.syncMenuState();
	      }
	    },
	    syncMenuState: function syncMenuState() {
	      var multiple = this.multiple,
	          checkStrictly = this.checkStrictly;
	
	      this.syncActivePath();
	      multiple && this.syncMultiCheckState();
	      checkStrictly && this.calculateCheckedNodePaths();
	      this.$nextTick(this.scrollIntoView);
	    },
	    syncMultiCheckState: function syncMultiCheckState() {
	      var _this = this;
	
	      var nodes = this.getFlattedNodes(this.leafOnly);
	
	      nodes.forEach(function (node) {
	        node.syncCheckState(_this.checkedValue);
	      });
	    },
	    syncActivePath: function syncActivePath() {
	      var _this2 = this;
	
	      var store = this.store,
	          multiple = this.multiple,
	          activePath = this.activePath,
	          checkedValue = this.checkedValue;
	
	
	      if (!Object(util_["isEmpty"])(activePath)) {
	        var nodes = activePath.map(function (node) {
	          return _this2.getNodeByValue(node.getValue());
	        });
	        this.expandNodes(nodes);
	      } else if (!Object(util_["isEmpty"])(checkedValue)) {
	        var value = multiple ? checkedValue[0] : checkedValue;
	        var checkedNode = this.getNodeByValue(value) || {};
	        var _nodes = (checkedNode.pathNodes || []).slice(0, -1);
	        this.expandNodes(_nodes);
	      } else {
	        this.activePath = [];
	        this.menus = [store.getNodes()];
	      }
	    },
	    expandNodes: function expandNodes(nodes) {
	      var _this3 = this;
	
	      nodes.forEach(function (node) {
	        return _this3.handleExpand(node, true /* silent */);
	      });
	    },
	    calculateCheckedNodePaths: function calculateCheckedNodePaths() {
	      var _this4 = this;
	
	      var checkedValue = this.checkedValue,
	          multiple = this.multiple;
	
	      var checkedValues = multiple ? Object(util_["coerceTruthyValueToArray"])(checkedValue) : [checkedValue];
	      this.checkedNodePaths = checkedValues.map(function (v) {
	        var checkedNode = _this4.getNodeByValue(v);
	        return checkedNode ? checkedNode.pathNodes : [];
	      });
	    },
	    handleKeyDown: function handleKeyDown(e) {
	      var target = e.target,
	          keyCode = e.keyCode;
	
	
	      switch (keyCode) {
	        case cascader_panelvue_type_script_lang_js_KeyCode.up:
	          var prev = getSibling(target, -1);
	          focusNode(prev);
	          break;
	        case cascader_panelvue_type_script_lang_js_KeyCode.down:
	          var next = getSibling(target, 1);
	          focusNode(next);
	          break;
	        case cascader_panelvue_type_script_lang_js_KeyCode.left:
	          var preMenu = this.$refs.menu[getMenuIndex(target) - 1];
	          if (preMenu) {
	            var expandedNode = preMenu.$el.querySelector('.el-cascader-node[aria-expanded="true"]');
	            focusNode(expandedNode);
	          }
	          break;
	        case cascader_panelvue_type_script_lang_js_KeyCode.right:
	          var nextMenu = this.$refs.menu[getMenuIndex(target) + 1];
	          if (nextMenu) {
	            var firstNode = nextMenu.$el.querySelector('.el-cascader-node[tabindex="-1"]');
	            focusNode(firstNode);
	          }
	          break;
	        case cascader_panelvue_type_script_lang_js_KeyCode.enter:
	          checkNode(target);
	          break;
	        case cascader_panelvue_type_script_lang_js_KeyCode.esc:
	        case cascader_panelvue_type_script_lang_js_KeyCode.tab:
	          this.$emit('close');
	          break;
	        default:
	          return;
	      }
	    },
	    handleExpand: function handleExpand(node, silent) {
	      var activePath = this.activePath;
	      var level = node.level;
	
	      var path = activePath.slice(0, level - 1);
	      var menus = this.menus.slice(0, level);
	
	      if (!node.isLeaf) {
	        path.push(node);
	        menus.push(node.children);
	      }
	
	      this.activePath = path;
	      this.menus = menus;
	
	      if (!silent) {
	        var pathValues = path.map(function (node) {
	          return node.getValue();
	        });
	        var activePathValues = activePath.map(function (node) {
	          return node.getValue();
	        });
	        if (!Object(util_["valueEquals"])(pathValues, activePathValues)) {
	          this.$emit('active-item-change', pathValues); // Deprecated
	          this.$emit('expand-change', pathValues);
	        }
	      }
	    },
	    handleCheckChange: function handleCheckChange(value) {
	      this.checkedValue = value;
	    },
	    lazyLoad: function lazyLoad(node, onFullfiled) {
	      var _this5 = this;
	
	      var config = this.config;
	
	      if (!node) {
	        node = node || { root: true, level: 0 };
	        this.store = new cascader_panel_src_store([], config);
	        this.menus = [this.store.getNodes()];
	      }
	      node.loading = true;
	      var resolve = function resolve(dataList) {
	        var parent = node.root ? null : node;
	        dataList && dataList.length && _this5.store.appendNodes(dataList, parent);
	        node.loading = false;
	        node.loaded = true;
	
	        // dispose default value on lazy load mode
	        if (Array.isArray(_this5.checkedValue)) {
	          var nodeValue = _this5.checkedValue[_this5.loadCount++];
	          var valueKey = _this5.config.value;
	          var leafKey = _this5.config.leaf;
	
	          if (Array.isArray(dataList) && dataList.filter(function (item) {
	            return item[valueKey] === nodeValue;
	          }).length > 0) {
	            var checkedNode = _this5.store.getNodeByValue(nodeValue);
	
	            if (!checkedNode.data[leafKey]) {
	              _this5.lazyLoad(checkedNode, function () {
	                _this5.handleExpand(checkedNode);
	              });
	            }
	
	            if (_this5.loadCount === _this5.checkedValue.length) {
	              _this5.$parent.computePresentText();
	            }
	          }
	        }
	
	        onFullfiled && onFullfiled(dataList);
	      };
	      config.lazyLoad(node, resolve);
	    },
	
	
	    /**
	     * public methods
	    */
	    calculateMultiCheckedValue: function calculateMultiCheckedValue() {
	      this.checkedValue = this.getCheckedNodes(this.leafOnly).map(function (node) {
	        return node.getValueByOption();
	      });
	    },
	    scrollIntoView: function scrollIntoView() {
	      if (this.$isServer) return;
	
	      var menus = this.$refs.menu || [];
	      menus.forEach(function (menu) {
	        var menuElement = menu.$el;
	        if (menuElement) {
	          var container = menuElement.querySelector('.el-scrollbar__wrap');
	          var activeNode = menuElement.querySelector('.el-cascader-node.is-active') || menuElement.querySelector('.el-cascader-node.in-active-path');
	          scroll_into_view_default()(container, activeNode);
	        }
	      });
	    },
	    getNodeByValue: function getNodeByValue(val) {
	      return this.store.getNodeByValue(val);
	    },
	    getFlattedNodes: function getFlattedNodes(leafOnly) {
	      var cached = !this.config.lazy;
	      return this.store.getFlattedNodes(leafOnly, cached);
	    },
	    getCheckedNodes: function getCheckedNodes(leafOnly) {
	      var checkedValue = this.checkedValue,
	          multiple = this.multiple;
	
	      if (multiple) {
	        var nodes = this.getFlattedNodes(leafOnly);
	        return nodes.filter(function (node) {
	          return node.checked;
	        });
	      } else {
	        return Object(util_["isEmpty"])(checkedValue) ? [] : [this.getNodeByValue(checkedValue)];
	      }
	    },
	    clearCheckedNodes: function clearCheckedNodes() {
	      var config = this.config,
	          leafOnly = this.leafOnly;
	      var multiple = config.multiple,
	          emitPath = config.emitPath;
	
	      if (multiple) {
	        this.getCheckedNodes(leafOnly).filter(function (node) {
	          return !node.isDisabled;
	        }).forEach(function (node) {
	          return node.doCheck(false);
	        });
	        this.calculateMultiCheckedValue();
	      } else {
	        this.checkedValue = emitPath ? [] : null;
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-panel.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_cascader_panelvue_type_script_lang_js_ = (cascader_panelvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-panel.vue
	
	
	
	
	
	/* normalize component */
	
	var cascader_panel_component = normalizeComponent(
	  src_cascader_panelvue_type_script_lang_js_,
	  cascader_panelvue_type_template_id_34932346_render,
	  cascader_panelvue_type_template_id_34932346_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var cascader_panel_api; }
	cascader_panel_component.options.__file = "packages/cascader-panel/src/cascader-panel.vue"
	/* harmony default export */ var cascader_panel = (cascader_panel_component.exports);
	// CONCATENATED MODULE: ./packages/cascader-panel/index.js
	
	
	/* istanbul ignore next */
	cascader_panel.install = function (Vue) {
	  Vue.component(cascader_panel.name, cascader_panel);
	};
	
	/* harmony default export */ var packages_cascader_panel = (cascader_panel);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/avatar/src/main.vue?vue&type=script&lang=js&
	
	/* harmony default export */ var avatar_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElAvatar',
	
	  props: {
	    size: {
	      type: [Number, String],
	      validator: function validator(val) {
	        if (typeof val === 'string') {
	          return ['large', 'medium', 'small'].includes(val);
	        }
	        return typeof val === 'number';
	      }
	    },
	    shape: {
	      type: String,
	      default: 'circle',
	      validator: function validator(val) {
	        return ['circle', 'square'].includes(val);
	      }
	    },
	    icon: String,
	    src: String,
	    alt: String,
	    srcSet: String,
	    error: Function,
	    fit: {
	      type: String,
	      default: 'cover'
	    }
	  },
	
	  data: function data() {
	    return {
	      isImageExist: true
	    };
	  },
	
	
	  computed: {
	    avatarClass: function avatarClass() {
	      var size = this.size,
	          icon = this.icon,
	          shape = this.shape;
	
	      var classList = ['el-avatar'];
	
	      if (size && typeof size === 'string') {
	        classList.push('el-avatar--' + size);
	      }
	
	      if (icon) {
	        classList.push('el-avatar--icon');
	      }
	
	      if (shape) {
	        classList.push('el-avatar--' + shape);
	      }
	
	      return classList.join(' ');
	    }
	  },
	
	  methods: {
	    handleError: function handleError() {
	      var error = this.error;
	
	      var errorFlag = error ? error() : undefined;
	      if (errorFlag !== false) {
	        this.isImageExist = false;
	      }
	    },
	    renderAvatar: function renderAvatar() {
	      var h = this.$createElement;
	      var icon = this.icon,
	          src = this.src,
	          alt = this.alt,
	          isImageExist = this.isImageExist,
	          srcSet = this.srcSet,
	          fit = this.fit;
	
	
	      if (isImageExist && src) {
	        return h('img', {
	          attrs: {
	            src: src,
	
	            alt: alt,
	            srcSet: srcSet
	          },
	          on: {
	            'error': this.handleError
	          },
	          style: { 'object-fit': fit } });
	      }
	
	      if (icon) {
	        return h('i', { 'class': icon });
	      }
	
	      return this.$slots.default;
	    }
	  },
	
	  render: function render() {
	    var h = arguments[0];
	    var avatarClass = this.avatarClass,
	        size = this.size;
	
	
	    var sizeStyle = typeof size === 'number' ? {
	      height: size + 'px',
	      width: size + 'px',
	      lineHeight: size + 'px'
	    } : {};
	
	    return h(
	      'span',
	      { 'class': avatarClass, style: sizeStyle },
	      [this.renderAvatar()]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/avatar/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_avatar_src_mainvue_type_script_lang_js_ = (avatar_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/avatar/src/main.vue
	var src_main_render, src_main_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var avatar_src_main_component = normalizeComponent(
	  packages_avatar_src_mainvue_type_script_lang_js_,
	  src_main_render,
	  src_main_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var avatar_src_main_api; }
	avatar_src_main_component.options.__file = "packages/avatar/src/main.vue"
	/* harmony default export */ var avatar_src_main = (avatar_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/avatar/index.js
	
	
	/* istanbul ignore next */
	avatar_src_main.install = function (Vue) {
	  Vue.component(avatar_src_main.name, avatar_src_main);
	};
	
	/* harmony default export */ var avatar = (avatar_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/drawer/src/main.vue?vue&type=template&id=a4885264&
	var mainvue_type_template_id_a4885264_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    {
	      attrs: { name: "el-drawer-fade" },
	      on: { "after-enter": _vm.afterEnter, "after-leave": _vm.afterLeave }
	    },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.visible,
	              expression: "visible"
	            }
	          ],
	          staticClass: "el-drawer__wrapper",
	          attrs: { tabindex: "-1" }
	        },
	        [
	          _c(
	            "div",
	            {
	              staticClass: "el-drawer__container",
	              class: _vm.visible && "el-drawer__open",
	              attrs: { role: "document", tabindex: "-1" },
	              on: {
	                click: function($event) {
	                  if ($event.target !== $event.currentTarget) {
	                    return null
	                  }
	                  return _vm.handleWrapperClick($event)
	                }
	              }
	            },
	            [
	              _c(
	                "div",
	                {
	                  ref: "drawer",
	                  staticClass: "el-drawer",
	                  class: [_vm.direction, _vm.customClass],
	                  style: _vm.isHorizontal
	                    ? "width: " + _vm.drawerSize
	                    : "height: " + _vm.drawerSize,
	                  attrs: {
	                    "aria-modal": "true",
	                    "aria-labelledby": "el-drawer__title",
	                    "aria-label": _vm.title,
	                    role: "dialog",
	                    tabindex: "-1"
	                  }
	                },
	                [
	                  _vm.withHeader
	                    ? _c(
	                        "header",
	                        {
	                          staticClass: "el-drawer__header",
	                          attrs: { id: "el-drawer__title" }
	                        },
	                        [
	                          _vm._t("title", [
	                            _c(
	                              "span",
	                              { attrs: { role: "heading", title: _vm.title } },
	                              [_vm._v(_vm._s(_vm.title))]
	                            )
	                          ]),
	                          _vm.showClose
	                            ? _c(
	                                "button",
	                                {
	                                  staticClass: "el-drawer__close-btn",
	                                  attrs: {
	                                    "aria-label":
	                                      "close " + (_vm.title || "drawer"),
	                                    type: "button"
	                                  },
	                                  on: { click: _vm.closeDrawer }
	                                },
	                                [
	                                  _c("i", {
	                                    staticClass:
	                                      "el-dialog__close el-icon el-icon-close"
	                                  })
	                                ]
	                              )
	                            : _vm._e()
	                        ],
	                        2
	                      )
	                    : _vm._e(),
	                  _vm.rendered
	                    ? _c(
	                        "section",
	                        { staticClass: "el-drawer__body" },
	                        [_vm._t("default")],
	                        2
	                      )
	                    : _vm._e()
	                ]
	              )
	            ]
	          )
	        ]
	      )
	    ]
	  )
	}
	var mainvue_type_template_id_a4885264_staticRenderFns = []
	mainvue_type_template_id_a4885264_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/drawer/src/main.vue?vue&type=template&id=a4885264&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/drawer/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	/* harmony default export */ var drawer_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElDrawer',
	  mixins: [popup_default.a, emitter_default.a],
	  props: {
	    appendToBody: {
	      type: Boolean,
	      default: false
	    },
	    beforeClose: {
	      type: Function
	    },
	    customClass: {
	      type: String,
	      default: ''
	    },
	    closeOnPressEscape: {
	      type: Boolean,
	      default: true
	    },
	    destroyOnClose: {
	      type: Boolean,
	      default: false
	    },
	    modal: {
	      type: Boolean,
	      default: true
	    },
	    direction: {
	      type: String,
	      default: 'rtl',
	      validator: function validator(val) {
	        return ['ltr', 'rtl', 'ttb', 'btt'].indexOf(val) !== -1;
	      }
	    },
	    modalAppendToBody: {
	      type: Boolean,
	      default: true
	    },
	    showClose: {
	      type: Boolean,
	      default: true
	    },
	    size: {
	      type: [Number, String],
	      default: '30%'
	    },
	    title: {
	      type: String,
	      default: ''
	    },
	    visible: {
	      type: Boolean
	    },
	    wrapperClosable: {
	      type: Boolean,
	      default: true
	    },
	    withHeader: {
	      type: Boolean,
	      default: true
	    }
	  },
	  computed: {
	    isHorizontal: function isHorizontal() {
	      return this.direction === 'rtl' || this.direction === 'ltr';
	    },
	    drawerSize: function drawerSize() {
	      return typeof this.size === 'number' ? this.size + 'px' : this.size;
	    }
	  },
	  data: function data() {
	    return {
	      closed: false,
	      prevActiveElement: null
	    };
	  },
	
	  watch: {
	    visible: function visible(val) {
	      var _this = this;
	
	      if (val) {
	        this.closed = false;
	        this.$emit('open');
	        if (this.appendToBody) {
	          document.body.appendChild(this.$el);
	        }
	        this.prevActiveElement = document.activeElement;
	      } else {
	        if (!this.closed) this.$emit('close');
	        this.$nextTick(function () {
	          if (_this.prevActiveElement) {
	            _this.prevActiveElement.focus();
	          }
	        });
	      }
	    }
	  },
	  methods: {
	    afterEnter: function afterEnter() {
	      this.$emit('opened');
	    },
	    afterLeave: function afterLeave() {
	      this.$emit('closed');
	    },
	    hide: function hide(cancel) {
	      if (cancel !== false) {
	        this.$emit('update:visible', false);
	        this.$emit('close');
	        if (this.destroyOnClose === true) {
	          this.rendered = false;
	        }
	        this.closed = true;
	      }
	    },
	    handleWrapperClick: function handleWrapperClick() {
	      if (this.wrapperClosable) {
	        this.closeDrawer();
	      }
	    },
	    closeDrawer: function closeDrawer() {
	      if (typeof this.beforeClose === 'function') {
	        this.beforeClose(this.hide);
	      } else {
	        this.hide();
	      }
	    },
	    handleClose: function handleClose() {
	      // This method here will be called by PopupManger, when the `closeOnPressEscape` was set to true
	      // pressing `ESC` will call this method, and also close the drawer.
	      // This method also calls `beforeClose` if there was one.
	      this.closeDrawer();
	    }
	  },
	  mounted: function mounted() {
	    if (this.visible) {
	      this.rendered = true;
	      this.open();
	    }
	  },
	  destroyed: function destroyed() {
	    // if appendToBody is true, remove DOM node after destroy
	    if (this.appendToBody && this.$el && this.$el.parentNode) {
	      this.$el.parentNode.removeChild(this.$el);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/drawer/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_drawer_src_mainvue_type_script_lang_js_ = (drawer_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/drawer/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var drawer_src_main_component = normalizeComponent(
	  packages_drawer_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_a4885264_render,
	  mainvue_type_template_id_a4885264_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var drawer_src_main_api; }
	drawer_src_main_component.options.__file = "packages/drawer/src/main.vue"
	/* harmony default export */ var drawer_src_main = (drawer_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/drawer/index.js
	
	
	/* istanbul ignore next */
	drawer_src_main.install = function (Vue) {
	  Vue.component(drawer_src_main.name, drawer_src_main);
	};
	
	/* harmony default export */ var drawer = (drawer_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/popconfirm/src/main.vue?vue&type=template&id=048de730&
	var mainvue_type_template_id_048de730_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "el-popover",
	    _vm._b(
	      {
	        attrs: { trigger: "click" },
	        model: {
	          value: _vm.visible,
	          callback: function($$v) {
	            _vm.visible = $$v
	          },
	          expression: "visible"
	        }
	      },
	      "el-popover",
	      _vm.$attrs,
	      false
	    ),
	    [
	      _c("div", { staticClass: "el-popconfirm" }, [
	        _c("p", { staticClass: "el-popconfirm__main" }, [
	          !_vm.hideIcon
	            ? _c("i", {
	                staticClass: "el-popconfirm__icon",
	                class: _vm.icon,
	                style: { color: _vm.iconColor }
	              })
	            : _vm._e(),
	          _vm._v("\n      " + _vm._s(_vm.title) + "\n    ")
	        ]),
	        _c(
	          "div",
	          { staticClass: "el-popconfirm__action" },
	          [
	            _c(
	              "el-button",
	              {
	                attrs: { size: "mini", type: _vm.cancelButtonType },
	                on: { click: _vm.cancel }
	              },
	              [
	                _vm._v(
	                  "\n        " +
	                    _vm._s(_vm.displayCancelButtonText) +
	                    "\n      "
	                )
	              ]
	            ),
	            _c(
	              "el-button",
	              {
	                attrs: { size: "mini", type: _vm.confirmButtonType },
	                on: { click: _vm.confirm }
	              },
	              [
	                _vm._v(
	                  "\n        " +
	                    _vm._s(_vm.displayConfirmButtonText) +
	                    "\n      "
	                )
	              ]
	            )
	          ],
	          1
	        )
	      ]),
	      _vm._t("reference", null, { slot: "reference" })
	    ],
	    2
	  )
	}
	var mainvue_type_template_id_048de730_staticRenderFns = []
	mainvue_type_template_id_048de730_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/popconfirm/src/main.vue?vue&type=template&id=048de730&
	
	// EXTERNAL MODULE: external "element-ui/lib/popover"
	var popover_ = __webpack_require__(44);
	var popover_default = /*#__PURE__*/__webpack_require__.n(popover_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/popconfirm/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var popconfirm_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElPopconfirm',
	  props: {
	    title: {
	      type: String
	    },
	    confirmButtonText: {
	      type: String
	    },
	    cancelButtonText: {
	      type: String
	    },
	    confirmButtonType: {
	      type: String,
	      default: 'primary'
	    },
	    cancelButtonType: {
	      type: String,
	      default: 'text'
	    },
	    icon: {
	      type: String,
	      default: 'el-icon-question'
	    },
	    iconColor: {
	      type: String,
	      default: '#f90'
	    },
	    hideIcon: {
	      type: Boolean,
	      default: false
	    }
	  },
	  components: {
	    ElPopover: popover_default.a,
	    ElButton: button_default.a
	  },
	  data: function data() {
	    return {
	      visible: false
	    };
	  },
	
	  computed: {
	    displayConfirmButtonText: function displayConfirmButtonText() {
	      return this.confirmButtonText || Object(lib_locale_["t"])('el.popconfirm.confirmButtonText');
	    },
	    displayCancelButtonText: function displayCancelButtonText() {
	      return this.cancelButtonText || Object(lib_locale_["t"])('el.popconfirm.cancelButtonText');
	    }
	  },
	  methods: {
	    confirm: function confirm() {
	      this.visible = false;
	      this.$emit('confirm');
	    },
	    cancel: function cancel() {
	      this.visible = false;
	      this.$emit('cancel');
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/popconfirm/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_popconfirm_src_mainvue_type_script_lang_js_ = (popconfirm_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/popconfirm/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var popconfirm_src_main_component = normalizeComponent(
	  packages_popconfirm_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_048de730_render,
	  mainvue_type_template_id_048de730_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var popconfirm_src_main_api; }
	popconfirm_src_main_component.options.__file = "packages/popconfirm/src/main.vue"
	/* harmony default export */ var popconfirm_src_main = (popconfirm_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/popconfirm/index.js
	
	
	/* istanbul ignore next */
	popconfirm_src_main.install = function (Vue) {
	  Vue.component(popconfirm_src_main.name, popconfirm_src_main);
	};
	
	/* harmony default export */ var popconfirm = (popconfirm_src_main);
	// CONCATENATED MODULE: ./src/index.js
	/* Automatically generated by './build/bin/build-entry.js' */
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var components = [packages_pagination, dialog, packages_autocomplete, packages_dropdown, packages_dropdown_menu, packages_dropdown_item, packages_menu, packages_submenu, packages_menu_item, packages_menu_item_group, packages_input, packages_input_number, packages_radio, packages_radio_group, packages_radio_button, packages_checkbox, packages_checkbox_button, packages_checkbox_group, packages_switch, packages_select, packages_option, packages_option_group, packages_button, packages_button_group, packages_table, packages_table_column, packages_date_picker, packages_time_select, packages_time_picker, popover, packages_tooltip, packages_breadcrumb, packages_breadcrumb_item, packages_form, packages_form_item, packages_tabs, packages_tab_pane, packages_tag, packages_tree, packages_alert, slider, packages_icon, packages_row, packages_col, packages_upload, packages_progress, packages_spinner, badge, card, rate, packages_steps, packages_step, carousel, scrollbar, carousel_item, packages_collapse, packages_collapse_item, packages_cascader, color_picker, transfer, packages_container, header, aside, packages_main, footer, timeline, timeline_item, packages_link, divider, packages_image, calendar, backtop, page_header, packages_cascader_panel, avatar, drawer, popconfirm, collapse_transition_default.a];
	
	var src_install = function install(Vue) {
	  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  lib_locale_default.a.use(opts.locale);
	  lib_locale_default.a.i18n(opts.i18n);
	
	  components.forEach(function (component) {
	    Vue.component(component.name, component);
	  });
	
	  Vue.use(infinite_scroll);
	  Vue.use(packages_loading.directive);
	
	  Vue.prototype.$ELEMENT = {
	    size: opts.size || '',
	    zIndex: opts.zIndex || 2000
	  };
	
	  Vue.prototype.$loading = packages_loading.service;
	  Vue.prototype.$msgbox = message_box;
	  Vue.prototype.$alert = message_box.alert;
	  Vue.prototype.$confirm = message_box.confirm;
	  Vue.prototype.$prompt = message_box.prompt;
	  Vue.prototype.$notify = notification;
	  Vue.prototype.$message = packages_message;
	};
	
	/* istanbul ignore if */
	if (typeof window !== 'undefined' && window.Vue) {
	  src_install(window.Vue);
	}
	
	/* harmony default export */ var src_0 = __webpack_exports__["default"] = ({
	  version: '2.15.2',
	  locale: lib_locale_default.a.use,
	  i18n: lib_locale_default.a.i18n,
	  install: src_install,
	  CollapseTransition: collapse_transition_default.a,
	  Loading: packages_loading,
	  Pagination: packages_pagination,
	  Dialog: dialog,
	  Autocomplete: packages_autocomplete,
	  Dropdown: packages_dropdown,
	  DropdownMenu: packages_dropdown_menu,
	  DropdownItem: packages_dropdown_item,
	  Menu: packages_menu,
	  Submenu: packages_submenu,
	  MenuItem: packages_menu_item,
	  MenuItemGroup: packages_menu_item_group,
	  Input: packages_input,
	  InputNumber: packages_input_number,
	  Radio: packages_radio,
	  RadioGroup: packages_radio_group,
	  RadioButton: packages_radio_button,
	  Checkbox: packages_checkbox,
	  CheckboxButton: packages_checkbox_button,
	  CheckboxGroup: packages_checkbox_group,
	  Switch: packages_switch,
	  Select: packages_select,
	  Option: packages_option,
	  OptionGroup: packages_option_group,
	  Button: packages_button,
	  ButtonGroup: packages_button_group,
	  Table: packages_table,
	  TableColumn: packages_table_column,
	  DatePicker: packages_date_picker,
	  TimeSelect: packages_time_select,
	  TimePicker: packages_time_picker,
	  Popover: popover,
	  Tooltip: packages_tooltip,
	  MessageBox: message_box,
	  Breadcrumb: packages_breadcrumb,
	  BreadcrumbItem: packages_breadcrumb_item,
	  Form: packages_form,
	  FormItem: packages_form_item,
	  Tabs: packages_tabs,
	  TabPane: packages_tab_pane,
	  Tag: packages_tag,
	  Tree: packages_tree,
	  Alert: packages_alert,
	  Notification: notification,
	  Slider: slider,
	  Icon: packages_icon,
	  Row: packages_row,
	  Col: packages_col,
	  Upload: packages_upload,
	  Progress: packages_progress,
	  Spinner: packages_spinner,
	  Message: packages_message,
	  Badge: badge,
	  Card: card,
	  Rate: rate,
	  Steps: packages_steps,
	  Step: packages_step,
	  Carousel: carousel,
	  Scrollbar: scrollbar,
	  CarouselItem: carousel_item,
	  Collapse: packages_collapse,
	  CollapseItem: packages_collapse_item,
	  Cascader: packages_cascader,
	  ColorPicker: color_picker,
	  Transfer: transfer,
	  Container: packages_container,
	  Header: header,
	  Aside: aside,
	  Main: packages_main,
	  Footer: footer,
	  Timeline: timeline,
	  TimelineItem: timeline_item,
	  Link: packages_link,
	  Divider: divider,
	  Image: packages_image,
	  Calendar: calendar,
	  Backtop: backtop,
	  InfiniteScroll: infinite_scroll,
	  PageHeader: page_header,
	  CascaderPanel: packages_cascader_panel,
	  Avatar: avatar,
	  Drawer: drawer,
	  Popconfirm: popconfirm
	});
	
	/***/ })
	/******/ ])["default"];

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 114);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 10:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(95);
	
	/***/ }),
	
	/***/ 114:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/input-number/src/input-number.vue?vue&type=template&id=42f8cf66&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      class: [
	        "el-input-number",
	        _vm.inputNumberSize ? "el-input-number--" + _vm.inputNumberSize : "",
	        { "is-disabled": _vm.inputNumberDisabled },
	        { "is-without-controls": !_vm.controls },
	        { "is-controls-right": _vm.controlsAtRight }
	      ],
	      on: {
	        dragstart: function($event) {
	          $event.preventDefault()
	        }
	      }
	    },
	    [
	      _vm.controls
	        ? _c(
	            "span",
	            {
	              directives: [
	                {
	                  name: "repeat-click",
	                  rawName: "v-repeat-click",
	                  value: _vm.decrease,
	                  expression: "decrease"
	                }
	              ],
	              staticClass: "el-input-number__decrease",
	              class: { "is-disabled": _vm.minDisabled },
	              attrs: { role: "button" },
	              on: {
	                keydown: function($event) {
	                  if (
	                    !("button" in $event) &&
	                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
	                  ) {
	                    return null
	                  }
	                  return _vm.decrease($event)
	                }
	              }
	            },
	            [
	              _c("i", {
	                class:
	                  "el-icon-" + (_vm.controlsAtRight ? "arrow-down" : "minus")
	              })
	            ]
	          )
	        : _vm._e(),
	      _vm.controls
	        ? _c(
	            "span",
	            {
	              directives: [
	                {
	                  name: "repeat-click",
	                  rawName: "v-repeat-click",
	                  value: _vm.increase,
	                  expression: "increase"
	                }
	              ],
	              staticClass: "el-input-number__increase",
	              class: { "is-disabled": _vm.maxDisabled },
	              attrs: { role: "button" },
	              on: {
	                keydown: function($event) {
	                  if (
	                    !("button" in $event) &&
	                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
	                  ) {
	                    return null
	                  }
	                  return _vm.increase($event)
	                }
	              }
	            },
	            [
	              _c("i", {
	                class: "el-icon-" + (_vm.controlsAtRight ? "arrow-up" : "plus")
	              })
	            ]
	          )
	        : _vm._e(),
	      _c("el-input", {
	        ref: "input",
	        attrs: {
	          value: _vm.displayValue,
	          placeholder: _vm.placeholder,
	          disabled: _vm.inputNumberDisabled,
	          size: _vm.inputNumberSize,
	          max: _vm.max,
	          min: _vm.min,
	          name: _vm.name,
	          label: _vm.label
	        },
	        on: {
	          blur: _vm.handleBlur,
	          focus: _vm.handleFocus,
	          input: _vm.handleInput,
	          change: _vm.handleInputChange
	        },
	        nativeOn: {
	          keydown: [
	            function($event) {
	              if (
	                !("button" in $event) &&
	                _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
	              ) {
	                return null
	              }
	              $event.preventDefault()
	              return _vm.increase($event)
	            },
	            function($event) {
	              if (
	                !("button" in $event) &&
	                _vm._k($event.keyCode, "down", 40, $event.key, [
	                  "Down",
	                  "ArrowDown"
	                ])
	              ) {
	                return null
	              }
	              $event.preventDefault()
	              return _vm.decrease($event)
	            }
	          ]
	        }
	      })
	    ],
	    1
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/input-number/src/input-number.vue?vue&type=template&id=42f8cf66&
	
	// EXTERNAL MODULE: external "element-ui/lib/input"
	var input_ = __webpack_require__(10);
	var input_default = /*#__PURE__*/__webpack_require__.n(input_);
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/focus"
	var focus_ = __webpack_require__(22);
	var focus_default = /*#__PURE__*/__webpack_require__.n(focus_);
	
	// EXTERNAL MODULE: ./src/directives/repeat-click.js
	var repeat_click = __webpack_require__(30);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/input-number/src/input-number.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var input_numbervue_type_script_lang_js_ = ({
	  name: 'ElInputNumber',
	  mixins: [focus_default()('input')],
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	  directives: {
	    repeatClick: repeat_click["a" /* default */]
	  },
	  components: {
	    ElInput: input_default.a
	  },
	  props: {
	    step: {
	      type: Number,
	      default: 1
	    },
	    stepStrictly: {
	      type: Boolean,
	      default: false
	    },
	    max: {
	      type: Number,
	      default: Infinity
	    },
	    min: {
	      type: Number,
	      default: -Infinity
	    },
	    value: {},
	    disabled: Boolean,
	    size: String,
	    controls: {
	      type: Boolean,
	      default: true
	    },
	    controlsPosition: {
	      type: String,
	      default: ''
	    },
	    name: String,
	    label: String,
	    placeholder: String,
	    precision: {
	      type: Number,
	      validator: function validator(val) {
	        return val >= 0 && val === parseInt(val, 10);
	      }
	    }
	  },
	  data: function data() {
	    return {
	      currentValue: 0,
	      userInput: null
	    };
	  },
	
	  watch: {
	    value: {
	      immediate: true,
	      handler: function handler(value) {
	        var newVal = value === undefined ? value : Number(value);
	        if (newVal !== undefined) {
	          if (isNaN(newVal)) {
	            return;
	          }
	
	          if (this.stepStrictly) {
	            var stepPrecision = this.getPrecision(this.step);
	            var precisionFactor = Math.pow(10, stepPrecision);
	            newVal = Math.round(newVal / this.step) * precisionFactor * this.step / precisionFactor;
	          }
	
	          if (this.precision !== undefined) {
	            newVal = this.toPrecision(newVal, this.precision);
	          }
	        }
	        if (newVal >= this.max) newVal = this.max;
	        if (newVal <= this.min) newVal = this.min;
	        this.currentValue = newVal;
	        this.userInput = null;
	        this.$emit('input', newVal);
	      }
	    }
	  },
	  computed: {
	    minDisabled: function minDisabled() {
	      return this._decrease(this.value, this.step) < this.min;
	    },
	    maxDisabled: function maxDisabled() {
	      return this._increase(this.value, this.step) > this.max;
	    },
	    numPrecision: function numPrecision() {
	      var value = this.value,
	          step = this.step,
	          getPrecision = this.getPrecision,
	          precision = this.precision;
	
	      var stepPrecision = getPrecision(step);
	      if (precision !== undefined) {
	        if (stepPrecision > precision) {
	          console.warn('[Element Warn][InputNumber]precision should not be less than the decimal places of step');
	        }
	        return precision;
	      } else {
	        return Math.max(getPrecision(value), stepPrecision);
	      }
	    },
	    controlsAtRight: function controlsAtRight() {
	      return this.controls && this.controlsPosition === 'right';
	    },
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    inputNumberSize: function inputNumberSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    inputNumberDisabled: function inputNumberDisabled() {
	      return this.disabled || !!(this.elForm || {}).disabled;
	    },
	    displayValue: function displayValue() {
	      if (this.userInput !== null) {
	        return this.userInput;
	      }
	
	      var currentValue = this.currentValue;
	
	      if (typeof currentValue === 'number') {
	        if (this.stepStrictly) {
	          var stepPrecision = this.getPrecision(this.step);
	          var precisionFactor = Math.pow(10, stepPrecision);
	          currentValue = Math.round(currentValue / this.step) * precisionFactor * this.step / precisionFactor;
	        }
	
	        if (this.precision !== undefined) {
	          currentValue = currentValue.toFixed(this.precision);
	        }
	      }
	
	      return currentValue;
	    }
	  },
	  methods: {
	    toPrecision: function toPrecision(num, precision) {
	      if (precision === undefined) precision = this.numPrecision;
	      return parseFloat(Math.round(num * Math.pow(10, precision)) / Math.pow(10, precision));
	    },
	    getPrecision: function getPrecision(value) {
	      if (value === undefined) return 0;
	      var valueString = value.toString();
	      var dotPosition = valueString.indexOf('.');
	      var precision = 0;
	      if (dotPosition !== -1) {
	        precision = valueString.length - dotPosition - 1;
	      }
	      return precision;
	    },
	    _increase: function _increase(val, step) {
	      if (typeof val !== 'number' && val !== undefined) return this.currentValue;
	
	      var precisionFactor = Math.pow(10, this.numPrecision);
	      // Solve the accuracy problem of JS decimal calculation by converting the value to integer.
	      return this.toPrecision((precisionFactor * val + precisionFactor * step) / precisionFactor);
	    },
	    _decrease: function _decrease(val, step) {
	      if (typeof val !== 'number' && val !== undefined) return this.currentValue;
	
	      var precisionFactor = Math.pow(10, this.numPrecision);
	
	      return this.toPrecision((precisionFactor * val - precisionFactor * step) / precisionFactor);
	    },
	    increase: function increase() {
	      if (this.inputNumberDisabled || this.maxDisabled) return;
	      var value = this.value || 0;
	      var newVal = this._increase(value, this.step);
	      this.setCurrentValue(newVal);
	    },
	    decrease: function decrease() {
	      if (this.inputNumberDisabled || this.minDisabled) return;
	      var value = this.value || 0;
	      var newVal = this._decrease(value, this.step);
	      this.setCurrentValue(newVal);
	    },
	    handleBlur: function handleBlur(event) {
	      this.$emit('blur', event);
	    },
	    handleFocus: function handleFocus(event) {
	      this.$emit('focus', event);
	    },
	    setCurrentValue: function setCurrentValue(newVal) {
	      var oldVal = this.currentValue;
	      if (typeof newVal === 'number' && this.precision !== undefined) {
	        newVal = this.toPrecision(newVal, this.precision);
	      }
	      if (newVal >= this.max) newVal = this.max;
	      if (newVal <= this.min) newVal = this.min;
	      if (oldVal === newVal) return;
	      this.userInput = null;
	      this.$emit('input', newVal);
	      this.$emit('change', newVal, oldVal);
	      this.currentValue = newVal;
	    },
	    handleInput: function handleInput(value) {
	      this.userInput = value;
	    },
	    handleInputChange: function handleInputChange(value) {
	      var newVal = value === '' ? undefined : Number(value);
	      if (!isNaN(newVal) || value === '') {
	        this.setCurrentValue(newVal);
	      }
	      this.userInput = null;
	    },
	    select: function select() {
	      this.$refs.input.select();
	    }
	  },
	  mounted: function mounted() {
	    var innerInput = this.$refs.input.$refs.input;
	    innerInput.setAttribute('role', 'spinbutton');
	    innerInput.setAttribute('aria-valuemax', this.max);
	    innerInput.setAttribute('aria-valuemin', this.min);
	    innerInput.setAttribute('aria-valuenow', this.currentValue);
	    innerInput.setAttribute('aria-disabled', this.inputNumberDisabled);
	  },
	  updated: function updated() {
	    if (!this.$refs || !this.$refs.input) return;
	    var innerInput = this.$refs.input.$refs.input;
	    innerInput.setAttribute('aria-valuenow', this.currentValue);
	  }
	});
	// CONCATENATED MODULE: ./packages/input-number/src/input-number.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_input_numbervue_type_script_lang_js_ = (input_numbervue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/input-number/src/input-number.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_input_numbervue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/input-number/src/input-number.vue"
	/* harmony default export */ var input_number = (component.exports);
	// CONCATENATED MODULE: ./packages/input-number/index.js
	
	
	/* istanbul ignore next */
	input_number.install = function (Vue) {
	  Vue.component(input_number.name, input_number);
	};
	
	/* harmony default export */ var packages_input_number = __webpack_exports__["default"] = (input_number);
	
	/***/ }),
	
	/***/ 2:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(17);
	
	/***/ }),
	
	/***/ 22:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(97);
	
	/***/ }),
	
	/***/ 30:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var element_ui_src_utils_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
	/* harmony import */ var element_ui_src_utils_dom__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(element_ui_src_utils_dom__WEBPACK_IMPORTED_MODULE_0__);
	
	
	/* harmony default export */ __webpack_exports__["a"] = ({
	  bind: function bind(el, binding, vnode) {
	    var interval = null;
	    var startTime = void 0;
	    var handler = function handler() {
	      return vnode.context[binding.expression].apply();
	    };
	    var clear = function clear() {
	      if (Date.now() - startTime < 100) {
	        handler();
	      }
	      clearInterval(interval);
	      interval = null;
	    };
	
	    Object(element_ui_src_utils_dom__WEBPACK_IMPORTED_MODULE_0__["on"])(el, 'mousedown', function (e) {
	      if (e.button !== 0) return;
	      startTime = Date.now();
	      Object(element_ui_src_utils_dom__WEBPACK_IMPORTED_MODULE_0__["once"])(document, 'mouseup', clear);
	      clearInterval(interval);
	      interval = setInterval(handler, 100);
	    });
	  }
	});
	
	/***/ })
	
	/******/ });

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = function (Vue) {
	
	  /**
	   * template
	   *
	   * @param {String} string
	   * @param {Array} ...args
	   * @return {String}
	   */
	
	  function template(string) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    if (args.length === 1 && _typeof(args[0]) === 'object') {
	      args = args[0];
	    }
	
	    if (!args || !args.hasOwnProperty) {
	      args = {};
	    }
	
	    return string.replace(RE_NARGS, function (match, prefix, i, index) {
	      var result = void 0;
	
	      if (string[index - 1] === '{' && string[index + match.length] === '}') {
	        return i;
	      } else {
	        result = (0, _util.hasOwn)(args, i) ? args[i] : null;
	        if (result === null || result === undefined) {
	          return '';
	        }
	
	        return result;
	      }
	    });
	  }
	
	  return template;
	};
	
	var _util = __webpack_require__(15);
	
	var RE_NARGS = /(%|)\{([0-9a-zA-Z_]+)\}/g;
	/**
	 *  String format template
	 *  - Inspired:
	 *    https://github.com/Matt-Esch/string-template/index.js
	 */

/***/ }),
/* 466 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  el: {
	    colorpicker: {
	      confirm: '确定',
	      clear: '清空'
	    },
	    datepicker: {
	      now: '此刻',
	      today: '今天',
	      cancel: '取消',
	      clear: '清空',
	      confirm: '确定',
	      selectDate: '选择日期',
	      selectTime: '选择时间',
	      startDate: '开始日期',
	      startTime: '开始时间',
	      endDate: '结束日期',
	      endTime: '结束时间',
	      prevYear: '前一年',
	      nextYear: '后一年',
	      prevMonth: '上个月',
	      nextMonth: '下个月',
	      year: '年',
	      month1: '1 月',
	      month2: '2 月',
	      month3: '3 月',
	      month4: '4 月',
	      month5: '5 月',
	      month6: '6 月',
	      month7: '7 月',
	      month8: '8 月',
	      month9: '9 月',
	      month10: '10 月',
	      month11: '11 月',
	      month12: '12 月',
	      // week: '周次',
	      weeks: {
	        sun: '日',
	        mon: '一',
	        tue: '二',
	        wed: '三',
	        thu: '四',
	        fri: '五',
	        sat: '六'
	      },
	      months: {
	        jan: '一月',
	        feb: '二月',
	        mar: '三月',
	        apr: '四月',
	        may: '五月',
	        jun: '六月',
	        jul: '七月',
	        aug: '八月',
	        sep: '九月',
	        oct: '十月',
	        nov: '十一月',
	        dec: '十二月'
	      }
	    },
	    select: {
	      loading: '加载中',
	      noMatch: '无匹配数据',
	      noData: '无数据',
	      placeholder: '请选择'
	    },
	    cascader: {
	      noMatch: '无匹配数据',
	      loading: '加载中',
	      placeholder: '请选择',
	      noData: '暂无数据'
	    },
	    pagination: {
	      goto: '前往',
	      pagesize: '条/页',
	      total: '共 {total} 条',
	      pageClassifier: '页'
	    },
	    messagebox: {
	      title: '提示',
	      confirm: '确定',
	      cancel: '取消',
	      error: '输入的数据不合法!'
	    },
	    upload: {
	      deleteTip: '按 delete 键可删除',
	      delete: '删除',
	      preview: '查看图片',
	      continue: '继续上传'
	    },
	    table: {
	      emptyText: '暂无数据',
	      confirmFilter: '筛选',
	      resetFilter: '重置',
	      clearFilter: '全部',
	      sumText: '合计'
	    },
	    tree: {
	      emptyText: '暂无数据'
	    },
	    transfer: {
	      noMatch: '无匹配数据',
	      noData: '无数据',
	      titles: ['列表 1', '列表 2'],
	      filterPlaceholder: '请输入搜索内容',
	      noCheckedFormat: '共 {total} 项',
	      hasCheckedFormat: '已选 {checked}/{total} 项'
	    },
	    image: {
	      error: '加载失败'
	    },
	    pageHeader: {
	      title: '返回'
	    },
	    popconfirm: {
	      confirmButtonText: '确定',
	      cancelButtonText: '取消'
	    }
	  }
	};

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 53);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(15);
	
	/***/ }),
	
	/***/ 33:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=template&id=7a44c642&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "li",
	    {
	      directives: [
	        {
	          name: "show",
	          rawName: "v-show",
	          value: _vm.visible,
	          expression: "visible"
	        }
	      ],
	      staticClass: "el-select-dropdown__item",
	      class: {
	        selected: _vm.itemSelected,
	        "is-disabled": _vm.disabled || _vm.groupDisabled || _vm.limitReached,
	        hover: _vm.hover
	      },
	      on: {
	        mouseenter: _vm.hoverItem,
	        click: function($event) {
	          $event.stopPropagation()
	          return _vm.selectOptionClick($event)
	        }
	      }
	    },
	    [_vm._t("default", [_c("span", [_vm._v(_vm._s(_vm.currentLabel))])])],
	    2
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=template&id=7a44c642&
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
	var emitter_ = __webpack_require__(4);
	var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/util"
	var util_ = __webpack_require__(3);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=script&lang=js&
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	/* harmony default export */ var optionvue_type_script_lang_js_ = ({
	  mixins: [emitter_default.a],
	
	  name: 'ElOption',
	
	  componentName: 'ElOption',
	
	  inject: ['select'],
	
	  props: {
	    value: {
	      required: true
	    },
	    label: [String, Number],
	    created: Boolean,
	    disabled: {
	      type: Boolean,
	      default: false
	    }
	  },
	
	  data: function data() {
	    return {
	      index: -1,
	      groupDisabled: false,
	      visible: true,
	      hitState: false,
	      hover: false
	    };
	  },
	
	
	  computed: {
	    isObject: function isObject() {
	      return Object.prototype.toString.call(this.value).toLowerCase() === '[object object]';
	    },
	    currentLabel: function currentLabel() {
	      return this.label || (this.isObject ? '' : this.value);
	    },
	    currentValue: function currentValue() {
	      return this.value || this.label || '';
	    },
	    itemSelected: function itemSelected() {
	      if (!this.select.multiple) {
	        return this.isEqual(this.value, this.select.value);
	      } else {
	        return this.contains(this.select.value, this.value);
	      }
	    },
	    limitReached: function limitReached() {
	      if (this.select.multiple) {
	        return !this.itemSelected && (this.select.value || []).length >= this.select.multipleLimit && this.select.multipleLimit > 0;
	      } else {
	        return false;
	      }
	    }
	  },
	
	  watch: {
	    currentLabel: function currentLabel() {
	      if (!this.created && !this.select.remote) this.dispatch('ElSelect', 'setSelected');
	    },
	    value: function value(val, oldVal) {
	      var _select = this.select,
	          remote = _select.remote,
	          valueKey = _select.valueKey;
	
	      if (!this.created && !remote) {
	        if (valueKey && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' && (typeof oldVal === 'undefined' ? 'undefined' : _typeof(oldVal)) === 'object' && val[valueKey] === oldVal[valueKey]) {
	          return;
	        }
	        this.dispatch('ElSelect', 'setSelected');
	      }
	    }
	  },
	
	  methods: {
	    isEqual: function isEqual(a, b) {
	      if (!this.isObject) {
	        return a === b;
	      } else {
	        var valueKey = this.select.valueKey;
	        return Object(util_["getValueByPath"])(a, valueKey) === Object(util_["getValueByPath"])(b, valueKey);
	      }
	    },
	    contains: function contains() {
	      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var target = arguments[1];
	
	      if (!this.isObject) {
	        return arr && arr.indexOf(target) > -1;
	      } else {
	        var valueKey = this.select.valueKey;
	        return arr && arr.some(function (item) {
	          return Object(util_["getValueByPath"])(item, valueKey) === Object(util_["getValueByPath"])(target, valueKey);
	        });
	      }
	    },
	    handleGroupDisabled: function handleGroupDisabled(val) {
	      this.groupDisabled = val;
	    },
	    hoverItem: function hoverItem() {
	      if (!this.disabled && !this.groupDisabled) {
	        this.select.hoverIndex = this.select.options.indexOf(this);
	      }
	    },
	    selectOptionClick: function selectOptionClick() {
	      if (this.disabled !== true && this.groupDisabled !== true) {
	        this.dispatch('ElSelect', 'handleOptionClick', [this, true]);
	      }
	    },
	    queryChange: function queryChange(query) {
	      this.visible = new RegExp(Object(util_["escapeRegexpString"])(query), 'i').test(this.currentLabel) || this.created;
	      if (!this.visible) {
	        this.select.filteredOptionsCount--;
	      }
	    }
	  },
	
	  created: function created() {
	    this.select.options.push(this);
	    this.select.cachedOptions.push(this);
	    this.select.optionsCount++;
	    this.select.filteredOptionsCount++;
	
	    this.$on('queryChange', this.queryChange);
	    this.$on('handleGroupDisabled', this.handleGroupDisabled);
	  },
	  beforeDestroy: function beforeDestroy() {
	    var _select2 = this.select,
	        selected = _select2.selected,
	        multiple = _select2.multiple;
	
	    var selectedOptions = multiple ? selected : [selected];
	    var index = this.select.cachedOptions.indexOf(this);
	    var selectedIndex = selectedOptions.indexOf(this);
	
	    // if option is not selected, remove it from cache
	    if (index > -1 && selectedIndex < 0) {
	      this.select.cachedOptions.splice(index, 1);
	    }
	    this.select.onOptionDestroy(this.select.options.indexOf(this));
	  }
	});
	// CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_optionvue_type_script_lang_js_ = (optionvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/select/src/option.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_optionvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/select/src/option.vue"
	/* harmony default export */ var src_option = __webpack_exports__["a"] = (component.exports);
	
	/***/ }),
	
	/***/ 4:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(27);
	
	/***/ }),
	
	/***/ 53:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _select_src_option__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33);
	
	
	/* istanbul ignore next */
	_select_src_option__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].install = function (Vue) {
	  Vue.component(_select_src_option__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].name, _select_src_option__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);
	};
	
	/* harmony default export */ __webpack_exports__["default"] = (_select_src_option__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 74);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 2:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(17);
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(15);
	
	/***/ }),
	
	/***/ 5:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(61);
	
	/***/ }),
	
	/***/ 7:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(3);
	
	/***/ }),
	
	/***/ 74:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/popover/src/main.vue?vue&type=template&id=52060272&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "span",
	    [
	      _c(
	        "transition",
	        {
	          attrs: { name: _vm.transition },
	          on: {
	            "after-enter": _vm.handleAfterEnter,
	            "after-leave": _vm.handleAfterLeave
	          }
	        },
	        [
	          _c(
	            "div",
	            {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value: !_vm.disabled && _vm.showPopper,
	                  expression: "!disabled && showPopper"
	                }
	              ],
	              ref: "popper",
	              staticClass: "el-popover el-popper",
	              class: [_vm.popperClass, _vm.content && "el-popover--plain"],
	              style: { width: _vm.width + "px" },
	              attrs: {
	                role: "tooltip",
	                id: _vm.tooltipId,
	                "aria-hidden":
	                  _vm.disabled || !_vm.showPopper ? "true" : "false"
	              }
	            },
	            [
	              _vm.title
	                ? _c("div", {
	                    staticClass: "el-popover__title",
	                    domProps: { textContent: _vm._s(_vm.title) }
	                  })
	                : _vm._e(),
	              _vm._t("default", [_vm._v(_vm._s(_vm.content))])
	            ],
	            2
	          )
	        ]
	      ),
	      _c(
	        "span",
	        { ref: "wrapper", staticClass: "el-popover__reference-wrapper" },
	        [_vm._t("reference")],
	        2
	      )
	    ],
	    1
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/popover/src/main.vue?vue&type=template&id=52060272&
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/vue-popper"
	var vue_popper_ = __webpack_require__(5);
	var vue_popper_default = /*#__PURE__*/__webpack_require__.n(vue_popper_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/dom"
	var dom_ = __webpack_require__(2);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/util"
	var util_ = __webpack_require__(3);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/popover/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	/* harmony default export */ var mainvue_type_script_lang_js_ = ({
	  name: 'ElPopover',
	
	  mixins: [vue_popper_default.a],
	
	  props: {
	    trigger: {
	      type: String,
	      default: 'click',
	      validator: function validator(value) {
	        return ['click', 'focus', 'hover', 'manual'].indexOf(value) > -1;
	      }
	    },
	    openDelay: {
	      type: Number,
	      default: 0
	    },
	    closeDelay: {
	      type: Number,
	      default: 200
	    },
	    title: String,
	    disabled: Boolean,
	    content: String,
	    reference: {},
	    popperClass: String,
	    width: {},
	    visibleArrow: {
	      default: true
	    },
	    arrowOffset: {
	      type: Number,
	      default: 0
	    },
	    transition: {
	      type: String,
	      default: 'fade-in-linear'
	    },
	    tabindex: {
	      type: Number,
	      default: 0
	    }
	  },
	
	  computed: {
	    tooltipId: function tooltipId() {
	      return 'el-popover-' + Object(util_["generateId"])();
	    }
	  },
	  watch: {
	    showPopper: function showPopper(val) {
	      if (this.disabled) {
	        return;
	      }
	      val ? this.$emit('show') : this.$emit('hide');
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    var reference = this.referenceElm = this.reference || this.$refs.reference;
	    var popper = this.popper || this.$refs.popper;
	
	    if (!reference && this.$refs.wrapper.children) {
	      reference = this.referenceElm = this.$refs.wrapper.children[0];
	    }
	    // 可访问性
	    if (reference) {
	      Object(dom_["addClass"])(reference, 'el-popover__reference');
	      reference.setAttribute('aria-describedby', this.tooltipId);
	      reference.setAttribute('tabindex', this.tabindex); // tab序列
	      popper.setAttribute('tabindex', 0);
	
	      if (this.trigger !== 'click') {
	        Object(dom_["on"])(reference, 'focusin', function () {
	          _this.handleFocus();
	          var instance = reference.__vue__;
	          if (instance && typeof instance.focus === 'function') {
	            instance.focus();
	          }
	        });
	        Object(dom_["on"])(popper, 'focusin', this.handleFocus);
	        Object(dom_["on"])(reference, 'focusout', this.handleBlur);
	        Object(dom_["on"])(popper, 'focusout', this.handleBlur);
	      }
	      Object(dom_["on"])(reference, 'keydown', this.handleKeydown);
	      Object(dom_["on"])(reference, 'click', this.handleClick);
	    }
	    if (this.trigger === 'click') {
	      Object(dom_["on"])(reference, 'click', this.doToggle);
	      Object(dom_["on"])(document, 'click', this.handleDocumentClick);
	    } else if (this.trigger === 'hover') {
	      Object(dom_["on"])(reference, 'mouseenter', this.handleMouseEnter);
	      Object(dom_["on"])(popper, 'mouseenter', this.handleMouseEnter);
	      Object(dom_["on"])(reference, 'mouseleave', this.handleMouseLeave);
	      Object(dom_["on"])(popper, 'mouseleave', this.handleMouseLeave);
	    } else if (this.trigger === 'focus') {
	      if (this.tabindex < 0) {
	        console.warn('[Element Warn][Popover]a negative taindex means that the element cannot be focused by tab key');
	      }
	      if (reference.querySelector('input, textarea')) {
	        Object(dom_["on"])(reference, 'focusin', this.doShow);
	        Object(dom_["on"])(reference, 'focusout', this.doClose);
	      } else {
	        Object(dom_["on"])(reference, 'mousedown', this.doShow);
	        Object(dom_["on"])(reference, 'mouseup', this.doClose);
	      }
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.cleanup();
	  },
	  deactivated: function deactivated() {
	    this.cleanup();
	  },
	
	
	  methods: {
	    doToggle: function doToggle() {
	      this.showPopper = !this.showPopper;
	    },
	    doShow: function doShow() {
	      this.showPopper = true;
	    },
	    doClose: function doClose() {
	      this.showPopper = false;
	    },
	    handleFocus: function handleFocus() {
	      Object(dom_["addClass"])(this.referenceElm, 'focusing');
	      if (this.trigger === 'click' || this.trigger === 'focus') this.showPopper = true;
	    },
	    handleClick: function handleClick() {
	      Object(dom_["removeClass"])(this.referenceElm, 'focusing');
	    },
	    handleBlur: function handleBlur() {
	      Object(dom_["removeClass"])(this.referenceElm, 'focusing');
	      if (this.trigger === 'click' || this.trigger === 'focus') this.showPopper = false;
	    },
	    handleMouseEnter: function handleMouseEnter() {
	      var _this2 = this;
	
	      clearTimeout(this._timer);
	      if (this.openDelay) {
	        this._timer = setTimeout(function () {
	          _this2.showPopper = true;
	        }, this.openDelay);
	      } else {
	        this.showPopper = true;
	      }
	    },
	    handleKeydown: function handleKeydown(ev) {
	      if (ev.keyCode === 27 && this.trigger !== 'manual') {
	        // esc
	        this.doClose();
	      }
	    },
	    handleMouseLeave: function handleMouseLeave() {
	      var _this3 = this;
	
	      clearTimeout(this._timer);
	      if (this.closeDelay) {
	        this._timer = setTimeout(function () {
	          _this3.showPopper = false;
	        }, this.closeDelay);
	      } else {
	        this.showPopper = false;
	      }
	    },
	    handleDocumentClick: function handleDocumentClick(e) {
	      var reference = this.reference || this.$refs.reference;
	      var popper = this.popper || this.$refs.popper;
	
	      if (!reference && this.$refs.wrapper.children) {
	        reference = this.referenceElm = this.$refs.wrapper.children[0];
	      }
	      if (!this.$el || !reference || this.$el.contains(e.target) || reference.contains(e.target) || !popper || popper.contains(e.target)) return;
	      this.showPopper = false;
	    },
	    handleAfterEnter: function handleAfterEnter() {
	      this.$emit('after-enter');
	    },
	    handleAfterLeave: function handleAfterLeave() {
	      this.$emit('after-leave');
	      this.doDestroy();
	    },
	    cleanup: function cleanup() {
	      if (this.openDelay || this.closeDelay) {
	        clearTimeout(this._timer);
	      }
	    }
	  },
	
	  destroyed: function destroyed() {
	    var reference = this.reference;
	
	    Object(dom_["off"])(reference, 'click', this.doToggle);
	    Object(dom_["off"])(reference, 'mouseup', this.doClose);
	    Object(dom_["off"])(reference, 'mousedown', this.doShow);
	    Object(dom_["off"])(reference, 'focusin', this.doShow);
	    Object(dom_["off"])(reference, 'focusout', this.doClose);
	    Object(dom_["off"])(reference, 'mousedown', this.doShow);
	    Object(dom_["off"])(reference, 'mouseup', this.doClose);
	    Object(dom_["off"])(reference, 'mouseleave', this.handleMouseLeave);
	    Object(dom_["off"])(reference, 'mouseenter', this.handleMouseEnter);
	    Object(dom_["off"])(document, 'click', this.handleDocumentClick);
	  }
	});
	// CONCATENATED MODULE: ./packages/popover/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_mainvue_type_script_lang_js_ = (mainvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/popover/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_mainvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/popover/src/main.vue"
	/* harmony default export */ var main = (component.exports);
	// CONCATENATED MODULE: ./packages/popover/src/directive.js
	var getReference = function getReference(el, binding, vnode) {
	  var _ref = binding.expression ? binding.value : binding.arg;
	  var popper = vnode.context.$refs[_ref];
	  if (popper) {
	    if (Array.isArray(popper)) {
	      popper[0].$refs.reference = el;
	    } else {
	      popper.$refs.reference = el;
	    }
	  }
	};
	
	/* harmony default export */ var directive = ({
	  bind: function bind(el, binding, vnode) {
	    getReference(el, binding, vnode);
	  },
	  inserted: function inserted(el, binding, vnode) {
	    getReference(el, binding, vnode);
	  }
	});
	// EXTERNAL MODULE: external "vue"
	var external_vue_ = __webpack_require__(7);
	var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
	
	// CONCATENATED MODULE: ./packages/popover/index.js
	
	
	
	
	external_vue_default.a.directive('popover', directive);
	
	/* istanbul ignore next */
	main.install = function (Vue) {
	  Vue.directive('popover', directive);
	  Vue.component(main.name, main);
	};
	main.directive = directive;
	
	/* harmony default export */ var popover = __webpack_exports__["default"] = (main);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 469 */
/***/ (function(module, exports) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 119);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 119:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/progress/src/progress.vue?vue&type=template&id=229ee406&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-progress",
	      class: [
	        "el-progress--" + _vm.type,
	        _vm.status ? "is-" + _vm.status : "",
	        {
	          "el-progress--without-text": !_vm.showText,
	          "el-progress--text-inside": _vm.textInside
	        }
	      ],
	      attrs: {
	        role: "progressbar",
	        "aria-valuenow": _vm.percentage,
	        "aria-valuemin": "0",
	        "aria-valuemax": "100"
	      }
	    },
	    [
	      _vm.type === "line"
	        ? _c("div", { staticClass: "el-progress-bar" }, [
	            _c(
	              "div",
	              {
	                staticClass: "el-progress-bar__outer",
	                style: { height: _vm.strokeWidth + "px" }
	              },
	              [
	                _c(
	                  "div",
	                  {
	                    staticClass: "el-progress-bar__inner",
	                    style: _vm.barStyle
	                  },
	                  [
	                    _vm.showText && _vm.textInside
	                      ? _c(
	                          "div",
	                          { staticClass: "el-progress-bar__innerText" },
	                          [_vm._v(_vm._s(_vm.content))]
	                        )
	                      : _vm._e()
	                  ]
	                )
	              ]
	            )
	          ])
	        : _c(
	            "div",
	            {
	              staticClass: "el-progress-circle",
	              style: { height: _vm.width + "px", width: _vm.width + "px" }
	            },
	            [
	              _c("svg", { attrs: { viewBox: "0 0 100 100" } }, [
	                _c("path", {
	                  staticClass: "el-progress-circle__track",
	                  style: _vm.trailPathStyle,
	                  attrs: {
	                    d: _vm.trackPath,
	                    stroke: "#e5e9f2",
	                    "stroke-width": _vm.relativeStrokeWidth,
	                    fill: "none"
	                  }
	                }),
	                _c("path", {
	                  staticClass: "el-progress-circle__path",
	                  style: _vm.circlePathStyle,
	                  attrs: {
	                    d: _vm.trackPath,
	                    stroke: _vm.stroke,
	                    fill: "none",
	                    "stroke-linecap": _vm.strokeLinecap,
	                    "stroke-width": _vm.percentage ? _vm.relativeStrokeWidth : 0
	                  }
	                })
	              ])
	            ]
	          ),
	      _vm.showText && !_vm.textInside
	        ? _c(
	            "div",
	            {
	              staticClass: "el-progress__text",
	              style: { fontSize: _vm.progressTextSize + "px" }
	            },
	            [
	              !_vm.status
	                ? [_vm._v(_vm._s(_vm.content))]
	                : _c("i", { class: _vm.iconClass })
	            ],
	            2
	          )
	        : _vm._e()
	    ]
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/progress/src/progress.vue?vue&type=template&id=229ee406&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/progress/src/progress.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var progressvue_type_script_lang_js_ = ({
	  name: 'ElProgress',
	  props: {
	    type: {
	      type: String,
	      default: 'line',
	      validator: function validator(val) {
	        return ['line', 'circle', 'dashboard'].indexOf(val) > -1;
	      }
	    },
	    percentage: {
	      type: Number,
	      default: 0,
	      required: true,
	      validator: function validator(val) {
	        return val >= 0 && val <= 100;
	      }
	    },
	    status: {
	      type: String,
	      validator: function validator(val) {
	        return ['success', 'exception', 'warning'].indexOf(val) > -1;
	      }
	    },
	    strokeWidth: {
	      type: Number,
	      default: 6
	    },
	    strokeLinecap: {
	      type: String,
	      default: 'round'
	    },
	    textInside: {
	      type: Boolean,
	      default: false
	    },
	    width: {
	      type: Number,
	      default: 126
	    },
	    showText: {
	      type: Boolean,
	      default: true
	    },
	    color: {
	      type: [String, Array, Function],
	      default: ''
	    },
	    format: Function
	  },
	  computed: {
	    barStyle: function barStyle() {
	      var style = {};
	      style.width = this.percentage + '%';
	      style.backgroundColor = this.getCurrentColor(this.percentage);
	      return style;
	    },
	    relativeStrokeWidth: function relativeStrokeWidth() {
	      return (this.strokeWidth / this.width * 100).toFixed(1);
	    },
	    radius: function radius() {
	      if (this.type === 'circle' || this.type === 'dashboard') {
	        return parseInt(50 - parseFloat(this.relativeStrokeWidth) / 2, 10);
	      } else {
	        return 0;
	      }
	    },
	    trackPath: function trackPath() {
	      var radius = this.radius;
	      var isDashboard = this.type === 'dashboard';
	      return '\n        M 50 50\n        m 0 ' + (isDashboard ? '' : '-') + radius + '\n        a ' + radius + ' ' + radius + ' 0 1 1 0 ' + (isDashboard ? '-' : '') + radius * 2 + '\n        a ' + radius + ' ' + radius + ' 0 1 1 0 ' + (isDashboard ? '' : '-') + radius * 2 + '\n        ';
	    },
	    perimeter: function perimeter() {
	      return 2 * Math.PI * this.radius;
	    },
	    rate: function rate() {
	      return this.type === 'dashboard' ? 0.75 : 1;
	    },
	    strokeDashoffset: function strokeDashoffset() {
	      var offset = -1 * this.perimeter * (1 - this.rate) / 2;
	      return offset + 'px';
	    },
	    trailPathStyle: function trailPathStyle() {
	      return {
	        strokeDasharray: this.perimeter * this.rate + 'px, ' + this.perimeter + 'px',
	        strokeDashoffset: this.strokeDashoffset
	      };
	    },
	    circlePathStyle: function circlePathStyle() {
	      return {
	        strokeDasharray: this.perimeter * this.rate * (this.percentage / 100) + 'px, ' + this.perimeter + 'px',
	        strokeDashoffset: this.strokeDashoffset,
	        transition: 'stroke-dasharray 0.6s ease 0s, stroke 0.6s ease'
	      };
	    },
	    stroke: function stroke() {
	      var ret = void 0;
	      if (this.color) {
	        ret = this.getCurrentColor(this.percentage);
	      } else {
	        switch (this.status) {
	          case 'success':
	            ret = '#13ce66';
	            break;
	          case 'exception':
	            ret = '#ff4949';
	            break;
	          case 'warning':
	            ret = '#e6a23c';
	            break;
	          default:
	            ret = '#20a0ff';
	        }
	      }
	      return ret;
	    },
	    iconClass: function iconClass() {
	      if (this.status === 'warning') {
	        return 'el-icon-warning';
	      }
	      if (this.type === 'line') {
	        return this.status === 'success' ? 'el-icon-circle-check' : 'el-icon-circle-close';
	      } else {
	        return this.status === 'success' ? 'el-icon-check' : 'el-icon-close';
	      }
	    },
	    progressTextSize: function progressTextSize() {
	      return this.type === 'line' ? 12 + this.strokeWidth * 0.4 : this.width * 0.111111 + 2;
	    },
	    content: function content() {
	      if (typeof this.format === 'function') {
	        return this.format(this.percentage) || '';
	      } else {
	        return this.percentage + '%';
	      }
	    }
	  },
	  methods: {
	    getCurrentColor: function getCurrentColor(percentage) {
	      if (typeof this.color === 'function') {
	        return this.color(percentage);
	      } else if (typeof this.color === 'string') {
	        return this.color;
	      } else {
	        return this.getLevelColor(percentage);
	      }
	    },
	    getLevelColor: function getLevelColor(percentage) {
	      var colorArray = this.getColorArray().sort(function (a, b) {
	        return a.percentage - b.percentage;
	      });
	
	      for (var i = 0; i < colorArray.length; i++) {
	        if (colorArray[i].percentage > percentage) {
	          return colorArray[i].color;
	        }
	      }
	      return colorArray[colorArray.length - 1].color;
	    },
	    getColorArray: function getColorArray() {
	      var color = this.color;
	      var span = 100 / color.length;
	      return color.map(function (seriesColor, index) {
	        if (typeof seriesColor === 'string') {
	          return {
	            color: seriesColor,
	            percentage: (index + 1) * span
	          };
	        }
	        return seriesColor;
	      });
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/progress/src/progress.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_progressvue_type_script_lang_js_ = (progressvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/progress/src/progress.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_progressvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/progress/src/progress.vue"
	/* harmony default export */ var progress = (component.exports);
	// CONCATENATED MODULE: ./packages/progress/index.js
	
	
	/* istanbul ignore next */
	progress.install = function (Vue) {
	  Vue.component(progress.name, progress);
	};
	
	/* harmony default export */ var packages_progress = __webpack_exports__["default"] = (progress);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 61);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 10:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(95);
	
	/***/ }),
	
	/***/ 12:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(145);
	
	/***/ }),
	
	/***/ 15:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(99);
	
	/***/ }),
	
	/***/ 16:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(101);
	
	/***/ }),
	
	/***/ 17:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(62);
	
	/***/ }),
	
	/***/ 21:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(60);
	
	/***/ }),
	
	/***/ 22:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(97);
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(15);
	
	/***/ }),
	
	/***/ 31:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(102);
	
	/***/ }),
	
	/***/ 33:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=template&id=7a44c642&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "li",
	    {
	      directives: [
	        {
	          name: "show",
	          rawName: "v-show",
	          value: _vm.visible,
	          expression: "visible"
	        }
	      ],
	      staticClass: "el-select-dropdown__item",
	      class: {
	        selected: _vm.itemSelected,
	        "is-disabled": _vm.disabled || _vm.groupDisabled || _vm.limitReached,
	        hover: _vm.hover
	      },
	      on: {
	        mouseenter: _vm.hoverItem,
	        click: function($event) {
	          $event.stopPropagation()
	          return _vm.selectOptionClick($event)
	        }
	      }
	    },
	    [_vm._t("default", [_c("span", [_vm._v(_vm._s(_vm.currentLabel))])])],
	    2
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=template&id=7a44c642&
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
	var emitter_ = __webpack_require__(4);
	var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/util"
	var util_ = __webpack_require__(3);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=script&lang=js&
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	/* harmony default export */ var optionvue_type_script_lang_js_ = ({
	  mixins: [emitter_default.a],
	
	  name: 'ElOption',
	
	  componentName: 'ElOption',
	
	  inject: ['select'],
	
	  props: {
	    value: {
	      required: true
	    },
	    label: [String, Number],
	    created: Boolean,
	    disabled: {
	      type: Boolean,
	      default: false
	    }
	  },
	
	  data: function data() {
	    return {
	      index: -1,
	      groupDisabled: false,
	      visible: true,
	      hitState: false,
	      hover: false
	    };
	  },
	
	
	  computed: {
	    isObject: function isObject() {
	      return Object.prototype.toString.call(this.value).toLowerCase() === '[object object]';
	    },
	    currentLabel: function currentLabel() {
	      return this.label || (this.isObject ? '' : this.value);
	    },
	    currentValue: function currentValue() {
	      return this.value || this.label || '';
	    },
	    itemSelected: function itemSelected() {
	      if (!this.select.multiple) {
	        return this.isEqual(this.value, this.select.value);
	      } else {
	        return this.contains(this.select.value, this.value);
	      }
	    },
	    limitReached: function limitReached() {
	      if (this.select.multiple) {
	        return !this.itemSelected && (this.select.value || []).length >= this.select.multipleLimit && this.select.multipleLimit > 0;
	      } else {
	        return false;
	      }
	    }
	  },
	
	  watch: {
	    currentLabel: function currentLabel() {
	      if (!this.created && !this.select.remote) this.dispatch('ElSelect', 'setSelected');
	    },
	    value: function value(val, oldVal) {
	      var _select = this.select,
	          remote = _select.remote,
	          valueKey = _select.valueKey;
	
	      if (!this.created && !remote) {
	        if (valueKey && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' && (typeof oldVal === 'undefined' ? 'undefined' : _typeof(oldVal)) === 'object' && val[valueKey] === oldVal[valueKey]) {
	          return;
	        }
	        this.dispatch('ElSelect', 'setSelected');
	      }
	    }
	  },
	
	  methods: {
	    isEqual: function isEqual(a, b) {
	      if (!this.isObject) {
	        return a === b;
	      } else {
	        var valueKey = this.select.valueKey;
	        return Object(util_["getValueByPath"])(a, valueKey) === Object(util_["getValueByPath"])(b, valueKey);
	      }
	    },
	    contains: function contains() {
	      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var target = arguments[1];
	
	      if (!this.isObject) {
	        return arr && arr.indexOf(target) > -1;
	      } else {
	        var valueKey = this.select.valueKey;
	        return arr && arr.some(function (item) {
	          return Object(util_["getValueByPath"])(item, valueKey) === Object(util_["getValueByPath"])(target, valueKey);
	        });
	      }
	    },
	    handleGroupDisabled: function handleGroupDisabled(val) {
	      this.groupDisabled = val;
	    },
	    hoverItem: function hoverItem() {
	      if (!this.disabled && !this.groupDisabled) {
	        this.select.hoverIndex = this.select.options.indexOf(this);
	      }
	    },
	    selectOptionClick: function selectOptionClick() {
	      if (this.disabled !== true && this.groupDisabled !== true) {
	        this.dispatch('ElSelect', 'handleOptionClick', [this, true]);
	      }
	    },
	    queryChange: function queryChange(query) {
	      this.visible = new RegExp(Object(util_["escapeRegexpString"])(query), 'i').test(this.currentLabel) || this.created;
	      if (!this.visible) {
	        this.select.filteredOptionsCount--;
	      }
	    }
	  },
	
	  created: function created() {
	    this.select.options.push(this);
	    this.select.cachedOptions.push(this);
	    this.select.optionsCount++;
	    this.select.filteredOptionsCount++;
	
	    this.$on('queryChange', this.queryChange);
	    this.$on('handleGroupDisabled', this.handleGroupDisabled);
	  },
	  beforeDestroy: function beforeDestroy() {
	    var _select2 = this.select,
	        selected = _select2.selected,
	        multiple = _select2.multiple;
	
	    var selectedOptions = multiple ? selected : [selected];
	    var index = this.select.cachedOptions.indexOf(this);
	    var selectedIndex = selectedOptions.indexOf(this);
	
	    // if option is not selected, remove it from cache
	    if (index > -1 && selectedIndex < 0) {
	      this.select.cachedOptions.splice(index, 1);
	    }
	    this.select.onOptionDestroy(this.select.options.indexOf(this));
	  }
	});
	// CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_optionvue_type_script_lang_js_ = (optionvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/select/src/option.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_optionvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/select/src/option.vue"
	/* harmony default export */ var src_option = __webpack_exports__["a"] = (component.exports);
	
	/***/ }),
	
	/***/ 37:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(144);
	
	/***/ }),
	
	/***/ 4:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(27);
	
	/***/ }),
	
	/***/ 5:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(61);
	
	/***/ }),
	
	/***/ 6:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(98);
	
	/***/ }),
	
	/***/ 61:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select.vue?vue&type=template&id=0e4aade6&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      directives: [
	        {
	          name: "clickoutside",
	          rawName: "v-clickoutside",
	          value: _vm.handleClose,
	          expression: "handleClose"
	        }
	      ],
	      staticClass: "el-select",
	      class: [_vm.selectSize ? "el-select--" + _vm.selectSize : ""],
	      on: {
	        click: function($event) {
	          $event.stopPropagation()
	          return _vm.toggleMenu($event)
	        }
	      }
	    },
	    [
	      _vm.multiple
	        ? _c(
	            "div",
	            {
	              ref: "tags",
	              staticClass: "el-select__tags",
	              style: { "max-width": _vm.inputWidth - 32 + "px", width: "100%" }
	            },
	            [
	              _vm.collapseTags && _vm.selected.length
	                ? _c(
	                    "span",
	                    [
	                      _c(
	                        "el-tag",
	                        {
	                          attrs: {
	                            closable: !_vm.selectDisabled,
	                            size: _vm.collapseTagSize,
	                            hit: _vm.selected[0].hitState,
	                            type: "info",
	                            "disable-transitions": ""
	                          },
	                          on: {
	                            close: function($event) {
	                              _vm.deleteTag($event, _vm.selected[0])
	                            }
	                          }
	                        },
	                        [
	                          _c("span", { staticClass: "el-select__tags-text" }, [
	                            _vm._v(_vm._s(_vm.selected[0].currentLabel))
	                          ])
	                        ]
	                      ),
	                      _vm.selected.length > 1
	                        ? _c(
	                            "el-tag",
	                            {
	                              attrs: {
	                                closable: false,
	                                size: _vm.collapseTagSize,
	                                type: "info",
	                                "disable-transitions": ""
	                              }
	                            },
	                            [
	                              _c(
	                                "span",
	                                { staticClass: "el-select__tags-text" },
	                                [_vm._v("+ " + _vm._s(_vm.selected.length - 1))]
	                              )
	                            ]
	                          )
	                        : _vm._e()
	                    ],
	                    1
	                  )
	                : _vm._e(),
	              !_vm.collapseTags
	                ? _c(
	                    "transition-group",
	                    { on: { "after-leave": _vm.resetInputHeight } },
	                    _vm._l(_vm.selected, function(item) {
	                      return _c(
	                        "el-tag",
	                        {
	                          key: _vm.getValueKey(item),
	                          attrs: {
	                            closable: !_vm.selectDisabled,
	                            size: _vm.collapseTagSize,
	                            hit: item.hitState,
	                            type: "info",
	                            "disable-transitions": ""
	                          },
	                          on: {
	                            close: function($event) {
	                              _vm.deleteTag($event, item)
	                            }
	                          }
	                        },
	                        [
	                          _c("span", { staticClass: "el-select__tags-text" }, [
	                            _vm._v(_vm._s(item.currentLabel))
	                          ])
	                        ]
	                      )
	                    }),
	                    1
	                  )
	                : _vm._e(),
	              _vm.filterable
	                ? _c("input", {
	                    directives: [
	                      {
	                        name: "model",
	                        rawName: "v-model",
	                        value: _vm.query,
	                        expression: "query"
	                      }
	                    ],
	                    ref: "input",
	                    staticClass: "el-select__input",
	                    class: [_vm.selectSize ? "is-" + _vm.selectSize : ""],
	                    style: {
	                      "flex-grow": "1",
	                      width: _vm.inputLength / (_vm.inputWidth - 32) + "%",
	                      "max-width": _vm.inputWidth - 42 + "px"
	                    },
	                    attrs: {
	                      type: "text",
	                      disabled: _vm.selectDisabled,
	                      autocomplete: _vm.autoComplete || _vm.autocomplete
	                    },
	                    domProps: { value: _vm.query },
	                    on: {
	                      focus: _vm.handleFocus,
	                      blur: function($event) {
	                        _vm.softFocus = false
	                      },
	                      keyup: _vm.managePlaceholder,
	                      keydown: [
	                        _vm.resetInputState,
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k($event.keyCode, "down", 40, $event.key, [
	                              "Down",
	                              "ArrowDown"
	                            ])
	                          ) {
	                            return null
	                          }
	                          $event.preventDefault()
	                          _vm.navigateOptions("next")
	                        },
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k($event.keyCode, "up", 38, $event.key, [
	                              "Up",
	                              "ArrowUp"
	                            ])
	                          ) {
	                            return null
	                          }
	                          $event.preventDefault()
	                          _vm.navigateOptions("prev")
	                        },
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k(
	                              $event.keyCode,
	                              "enter",
	                              13,
	                              $event.key,
	                              "Enter"
	                            )
	                          ) {
	                            return null
	                          }
	                          $event.preventDefault()
	                          return _vm.selectOption($event)
	                        },
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k($event.keyCode, "esc", 27, $event.key, [
	                              "Esc",
	                              "Escape"
	                            ])
	                          ) {
	                            return null
	                          }
	                          $event.stopPropagation()
	                          $event.preventDefault()
	                          _vm.visible = false
	                        },
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k(
	                              $event.keyCode,
	                              "delete",
	                              [8, 46],
	                              $event.key,
	                              ["Backspace", "Delete", "Del"]
	                            )
	                          ) {
	                            return null
	                          }
	                          return _vm.deletePrevTag($event)
	                        },
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
	                          ) {
	                            return null
	                          }
	                          _vm.visible = false
	                        }
	                      ],
	                      compositionstart: _vm.handleComposition,
	                      compositionupdate: _vm.handleComposition,
	                      compositionend: _vm.handleComposition,
	                      input: [
	                        function($event) {
	                          if ($event.target.composing) {
	                            return
	                          }
	                          _vm.query = $event.target.value
	                        },
	                        _vm.debouncedQueryChange
	                      ]
	                    }
	                  })
	                : _vm._e()
	            ],
	            1
	          )
	        : _vm._e(),
	      _c(
	        "el-input",
	        {
	          ref: "reference",
	          class: { "is-focus": _vm.visible },
	          attrs: {
	            type: "text",
	            placeholder: _vm.currentPlaceholder,
	            name: _vm.name,
	            id: _vm.id,
	            autocomplete: _vm.autoComplete || _vm.autocomplete,
	            size: _vm.selectSize,
	            disabled: _vm.selectDisabled,
	            readonly: _vm.readonly,
	            "validate-event": false,
	            tabindex: _vm.multiple && _vm.filterable ? "-1" : null
	          },
	          on: { focus: _vm.handleFocus, blur: _vm.handleBlur },
	          nativeOn: {
	            keyup: function($event) {
	              return _vm.debouncedOnInputChange($event)
	            },
	            keydown: [
	              function($event) {
	                if (
	                  !("button" in $event) &&
	                  _vm._k($event.keyCode, "down", 40, $event.key, [
	                    "Down",
	                    "ArrowDown"
	                  ])
	                ) {
	                  return null
	                }
	                $event.stopPropagation()
	                $event.preventDefault()
	                _vm.navigateOptions("next")
	              },
	              function($event) {
	                if (
	                  !("button" in $event) &&
	                  _vm._k($event.keyCode, "up", 38, $event.key, [
	                    "Up",
	                    "ArrowUp"
	                  ])
	                ) {
	                  return null
	                }
	                $event.stopPropagation()
	                $event.preventDefault()
	                _vm.navigateOptions("prev")
	              },
	              function($event) {
	                if (
	                  !("button" in $event) &&
	                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
	                ) {
	                  return null
	                }
	                $event.preventDefault()
	                return _vm.selectOption($event)
	              },
	              function($event) {
	                if (
	                  !("button" in $event) &&
	                  _vm._k($event.keyCode, "esc", 27, $event.key, [
	                    "Esc",
	                    "Escape"
	                  ])
	                ) {
	                  return null
	                }
	                $event.stopPropagation()
	                $event.preventDefault()
	                _vm.visible = false
	              },
	              function($event) {
	                if (
	                  !("button" in $event) &&
	                  _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
	                ) {
	                  return null
	                }
	                _vm.visible = false
	              }
	            ],
	            paste: function($event) {
	              return _vm.debouncedOnInputChange($event)
	            },
	            mouseenter: function($event) {
	              _vm.inputHovering = true
	            },
	            mouseleave: function($event) {
	              _vm.inputHovering = false
	            }
	          },
	          model: {
	            value: _vm.selectedLabel,
	            callback: function($$v) {
	              _vm.selectedLabel = $$v
	            },
	            expression: "selectedLabel"
	          }
	        },
	        [
	          _vm.$slots.prefix
	            ? _c("template", { slot: "prefix" }, [_vm._t("prefix")], 2)
	            : _vm._e(),
	          _c("template", { slot: "suffix" }, [
	            _c("i", {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value: !_vm.showClose,
	                  expression: "!showClose"
	                }
	              ],
	              class: [
	                "el-select__caret",
	                "el-input__icon",
	                "el-icon-" + _vm.iconClass
	              ]
	            }),
	            _vm.showClose
	              ? _c("i", {
	                  staticClass:
	                    "el-select__caret el-input__icon el-icon-circle-close",
	                  on: { click: _vm.handleClearClick }
	                })
	              : _vm._e()
	          ])
	        ],
	        2
	      ),
	      _c(
	        "transition",
	        {
	          attrs: { name: "el-zoom-in-top" },
	          on: {
	            "before-enter": _vm.handleMenuEnter,
	            "after-leave": _vm.doDestroy
	          }
	        },
	        [
	          _c(
	            "el-select-menu",
	            {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value: _vm.visible && _vm.emptyText !== false,
	                  expression: "visible && emptyText !== false"
	                }
	              ],
	              ref: "popper",
	              attrs: { "append-to-body": _vm.popperAppendToBody }
	            },
	            [
	              _c(
	                "el-scrollbar",
	                {
	                  directives: [
	                    {
	                      name: "show",
	                      rawName: "v-show",
	                      value: _vm.options.length > 0 && !_vm.loading,
	                      expression: "options.length > 0 && !loading"
	                    }
	                  ],
	                  ref: "scrollbar",
	                  class: {
	                    "is-empty":
	                      !_vm.allowCreate &&
	                      _vm.query &&
	                      _vm.filteredOptionsCount === 0
	                  },
	                  attrs: {
	                    tag: "ul",
	                    "wrap-class": "el-select-dropdown__wrap",
	                    "view-class": "el-select-dropdown__list"
	                  }
	                },
	                [
	                  _vm.showNewOption
	                    ? _c("el-option", {
	                        attrs: { value: _vm.query, created: "" }
	                      })
	                    : _vm._e(),
	                  _vm._t("default")
	                ],
	                2
	              ),
	              _vm.emptyText &&
	              (!_vm.allowCreate ||
	                _vm.loading ||
	                (_vm.allowCreate && _vm.options.length === 0))
	                ? [
	                    _vm.$slots.empty
	                      ? _vm._t("empty")
	                      : _c("p", { staticClass: "el-select-dropdown__empty" }, [
	                          _vm._v(
	                            "\n          " +
	                              _vm._s(_vm.emptyText) +
	                              "\n        "
	                          )
	                        ])
	                  ]
	                : _vm._e()
	            ],
	            2
	          )
	        ],
	        1
	      )
	    ],
	    1
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/select/src/select.vue?vue&type=template&id=0e4aade6&
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
	var emitter_ = __webpack_require__(4);
	var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/focus"
	var focus_ = __webpack_require__(22);
	var focus_default = /*#__PURE__*/__webpack_require__.n(focus_);
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/locale"
	var locale_ = __webpack_require__(6);
	var locale_default = /*#__PURE__*/__webpack_require__.n(locale_);
	
	// EXTERNAL MODULE: external "element-ui/lib/input"
	var input_ = __webpack_require__(10);
	var input_default = /*#__PURE__*/__webpack_require__.n(input_);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select-dropdown.vue?vue&type=template&id=06828748&
	var select_dropdownvue_type_template_id_06828748_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-select-dropdown el-popper",
	      class: [{ "is-multiple": _vm.$parent.multiple }, _vm.popperClass],
	      style: { minWidth: _vm.minWidth }
	    },
	    [_vm._t("default")],
	    2
	  )
	}
	var select_dropdownvue_type_template_id_06828748_staticRenderFns = []
	select_dropdownvue_type_template_id_06828748_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue?vue&type=template&id=06828748&
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/vue-popper"
	var vue_popper_ = __webpack_require__(5);
	var vue_popper_default = /*#__PURE__*/__webpack_require__.n(vue_popper_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select-dropdown.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var select_dropdownvue_type_script_lang_js_ = ({
	  name: 'ElSelectDropdown',
	
	  componentName: 'ElSelectDropdown',
	
	  mixins: [vue_popper_default.a],
	
	  props: {
	    placement: {
	      default: 'bottom-start'
	    },
	
	    boundariesPadding: {
	      default: 0
	    },
	
	    popperOptions: {
	      default: function _default() {
	        return {
	          gpuAcceleration: false
	        };
	      }
	    },
	
	    visibleArrow: {
	      default: true
	    },
	
	    appendToBody: {
	      type: Boolean,
	      default: true
	    }
	  },
	
	  data: function data() {
	    return {
	      minWidth: ''
	    };
	  },
	
	
	  computed: {
	    popperClass: function popperClass() {
	      return this.$parent.popperClass;
	    }
	  },
	
	  watch: {
	    '$parent.inputWidth': function $parentInputWidth() {
	      this.minWidth = this.$parent.$el.getBoundingClientRect().width + 'px';
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.referenceElm = this.$parent.$refs.reference.$el;
	    this.$parent.popperElm = this.popperElm = this.$el;
	    this.$on('updatePopper', function () {
	      if (_this.$parent.visible) _this.updatePopper();
	    });
	    this.$on('destroyPopper', this.destroyPopper);
	  }
	});
	// CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_select_dropdownvue_type_script_lang_js_ = (select_dropdownvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_select_dropdownvue_type_script_lang_js_,
	  select_dropdownvue_type_template_id_06828748_render,
	  select_dropdownvue_type_template_id_06828748_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/select/src/select-dropdown.vue"
	/* harmony default export */ var select_dropdown = (component.exports);
	// EXTERNAL MODULE: ./packages/select/src/option.vue + 4 modules
	var src_option = __webpack_require__(33);
	
	// EXTERNAL MODULE: external "element-ui/lib/tag"
	var tag_ = __webpack_require__(37);
	var tag_default = /*#__PURE__*/__webpack_require__.n(tag_);
	
	// EXTERNAL MODULE: external "element-ui/lib/scrollbar"
	var scrollbar_ = __webpack_require__(15);
	var scrollbar_default = /*#__PURE__*/__webpack_require__.n(scrollbar_);
	
	// EXTERNAL MODULE: external "throttle-debounce/debounce"
	var debounce_ = __webpack_require__(17);
	var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/clickoutside"
	var clickoutside_ = __webpack_require__(12);
	var clickoutside_default = /*#__PURE__*/__webpack_require__.n(clickoutside_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/resize-event"
	var resize_event_ = __webpack_require__(16);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/scroll-into-view"
	var scroll_into_view_ = __webpack_require__(31);
	var scroll_into_view_default = /*#__PURE__*/__webpack_require__.n(scroll_into_view_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/util"
	var util_ = __webpack_require__(3);
	
	// CONCATENATED MODULE: ./packages/select/src/navigation-mixin.js
	/* harmony default export */ var navigation_mixin = ({
	  data: function data() {
	    return {
	      hoverOption: -1
	    };
	  },
	
	
	  computed: {
	    optionsAllDisabled: function optionsAllDisabled() {
	      return this.options.filter(function (option) {
	        return option.visible;
	      }).every(function (option) {
	        return option.disabled;
	      });
	    }
	  },
	
	  watch: {
	    hoverIndex: function hoverIndex(val) {
	      var _this = this;
	
	      if (typeof val === 'number' && val > -1) {
	        this.hoverOption = this.options[val] || {};
	      }
	      this.options.forEach(function (option) {
	        option.hover = _this.hoverOption === option;
	      });
	    }
	  },
	
	  methods: {
	    navigateOptions: function navigateOptions(direction) {
	      var _this2 = this;
	
	      if (!this.visible) {
	        this.visible = true;
	        return;
	      }
	      if (this.options.length === 0 || this.filteredOptionsCount === 0) return;
	      if (!this.optionsAllDisabled) {
	        if (direction === 'next') {
	          this.hoverIndex++;
	          if (this.hoverIndex === this.options.length) {
	            this.hoverIndex = 0;
	          }
	        } else if (direction === 'prev') {
	          this.hoverIndex--;
	          if (this.hoverIndex < 0) {
	            this.hoverIndex = this.options.length - 1;
	          }
	        }
	        var option = this.options[this.hoverIndex];
	        if (option.disabled === true || option.groupDisabled === true || !option.visible) {
	          this.navigateOptions(direction);
	        }
	        this.$nextTick(function () {
	          return _this2.scrollToOption(_this2.hoverOption);
	        });
	      }
	    }
	  }
	});
	// EXTERNAL MODULE: external "element-ui/lib/utils/shared"
	var shared_ = __webpack_require__(21);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	/* harmony default export */ var selectvue_type_script_lang_js_ = ({
	  mixins: [emitter_default.a, locale_default.a, focus_default()('reference'), navigation_mixin],
	
	  name: 'ElSelect',
	
	  componentName: 'ElSelect',
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  provide: function provide() {
	    return {
	      'select': this
	    };
	  },
	
	
	  computed: {
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    readonly: function readonly() {
	      return !this.filterable || this.multiple || !Object(util_["isIE"])() && !Object(util_["isEdge"])() && !this.visible;
	    },
	    showClose: function showClose() {
	      var hasValue = this.multiple ? Array.isArray(this.value) && this.value.length > 0 : this.value !== undefined && this.value !== null && this.value !== '';
	      var criteria = this.clearable && !this.selectDisabled && this.inputHovering && hasValue;
	      return criteria;
	    },
	    iconClass: function iconClass() {
	      return this.remote && this.filterable ? '' : this.visible ? 'arrow-up is-reverse' : 'arrow-up';
	    },
	    debounce: function debounce() {
	      return this.remote ? 300 : 0;
	    },
	    emptyText: function emptyText() {
	      if (this.loading) {
	        return this.loadingText || this.t('el.select.loading');
	      } else {
	        if (this.remote && this.query === '' && this.options.length === 0) return false;
	        if (this.filterable && this.query && this.options.length > 0 && this.filteredOptionsCount === 0) {
	          return this.noMatchText || this.t('el.select.noMatch');
	        }
	        if (this.options.length === 0) {
	          return this.noDataText || this.t('el.select.noData');
	        }
	      }
	      return null;
	    },
	    showNewOption: function showNewOption() {
	      var _this = this;
	
	      var hasExistingOption = this.options.filter(function (option) {
	        return !option.created;
	      }).some(function (option) {
	        return option.currentLabel === _this.query;
	      });
	      return this.filterable && this.allowCreate && this.query !== '' && !hasExistingOption;
	    },
	    selectSize: function selectSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    selectDisabled: function selectDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    },
	    collapseTagSize: function collapseTagSize() {
	      return ['small', 'mini'].indexOf(this.selectSize) > -1 ? 'mini' : 'small';
	    },
	    propPlaceholder: function propPlaceholder() {
	      return typeof this.placeholder !== 'undefined' ? this.placeholder : this.t('el.select.placeholder');
	    }
	  },
	
	  components: {
	    ElInput: input_default.a,
	    ElSelectMenu: select_dropdown,
	    ElOption: src_option["a" /* default */],
	    ElTag: tag_default.a,
	    ElScrollbar: scrollbar_default.a
	  },
	
	  directives: { Clickoutside: clickoutside_default.a },
	
	  props: {
	    name: String,
	    id: String,
	    value: {
	      required: true
	    },
	    autocomplete: {
	      type: String,
	      default: 'off'
	    },
	    /** @Deprecated in next major version */
	    autoComplete: {
	      type: String,
	      validator: function validator(val) {
	         false && false;
	        return true;
	      }
	    },
	    automaticDropdown: Boolean,
	    size: String,
	    disabled: Boolean,
	    clearable: Boolean,
	    filterable: Boolean,
	    allowCreate: Boolean,
	    loading: Boolean,
	    popperClass: String,
	    remote: Boolean,
	    loadingText: String,
	    noMatchText: String,
	    noDataText: String,
	    remoteMethod: Function,
	    filterMethod: Function,
	    multiple: Boolean,
	    multipleLimit: {
	      type: Number,
	      default: 0
	    },
	    placeholder: {
	      type: String,
	      required: false
	    },
	    defaultFirstOption: Boolean,
	    reserveKeyword: Boolean,
	    valueKey: {
	      type: String,
	      default: 'value'
	    },
	    collapseTags: Boolean,
	    popperAppendToBody: {
	      type: Boolean,
	      default: true
	    }
	  },
	
	  data: function data() {
	    return {
	      options: [],
	      cachedOptions: [],
	      createdLabel: null,
	      createdSelected: false,
	      selected: this.multiple ? [] : {},
	      inputLength: 20,
	      inputWidth: 0,
	      initialInputHeight: 0,
	      cachedPlaceHolder: '',
	      optionsCount: 0,
	      filteredOptionsCount: 0,
	      visible: false,
	      softFocus: false,
	      selectedLabel: '',
	      hoverIndex: -1,
	      query: '',
	      previousQuery: null,
	      inputHovering: false,
	      currentPlaceholder: '',
	      menuVisibleOnFocus: false,
	      isOnComposition: false,
	      isSilentBlur: false
	    };
	  },
	
	
	  watch: {
	    selectDisabled: function selectDisabled() {
	      var _this2 = this;
	
	      this.$nextTick(function () {
	        _this2.resetInputHeight();
	      });
	    },
	    propPlaceholder: function propPlaceholder(val) {
	      this.cachedPlaceHolder = this.currentPlaceholder = val;
	    },
	    value: function value(val, oldVal) {
	      if (this.multiple) {
	        this.resetInputHeight();
	        if (val && val.length > 0 || this.$refs.input && this.query !== '') {
	          this.currentPlaceholder = '';
	        } else {
	          this.currentPlaceholder = this.cachedPlaceHolder;
	        }
	        if (this.filterable && !this.reserveKeyword) {
	          this.query = '';
	          this.handleQueryChange(this.query);
	        }
	      }
	      this.setSelected();
	      if (this.filterable && !this.multiple) {
	        this.inputLength = 20;
	      }
	      if (!Object(util_["valueEquals"])(val, oldVal)) {
	        this.dispatch('ElFormItem', 'el.form.change', val);
	      }
	    },
	    visible: function visible(val) {
	      var _this3 = this;
	
	      if (!val) {
	        this.broadcast('ElSelectDropdown', 'destroyPopper');
	        if (this.$refs.input) {
	          this.$refs.input.blur();
	        }
	        this.query = '';
	        this.previousQuery = null;
	        this.selectedLabel = '';
	        this.inputLength = 20;
	        this.menuVisibleOnFocus = false;
	        this.resetHoverIndex();
	        this.$nextTick(function () {
	          if (_this3.$refs.input && _this3.$refs.input.value === '' && _this3.selected.length === 0) {
	            _this3.currentPlaceholder = _this3.cachedPlaceHolder;
	          }
	        });
	        if (!this.multiple) {
	          if (this.selected) {
	            if (this.filterable && this.allowCreate && this.createdSelected && this.createdLabel) {
	              this.selectedLabel = this.createdLabel;
	            } else {
	              this.selectedLabel = this.selected.currentLabel;
	            }
	            if (this.filterable) this.query = this.selectedLabel;
	          }
	
	          if (this.filterable) {
	            this.currentPlaceholder = this.cachedPlaceHolder;
	          }
	        }
	      } else {
	        this.broadcast('ElSelectDropdown', 'updatePopper');
	        if (this.filterable) {
	          this.query = this.remote ? '' : this.selectedLabel;
	          this.handleQueryChange(this.query);
	          if (this.multiple) {
	            this.$refs.input.focus();
	          } else {
	            if (!this.remote) {
	              this.broadcast('ElOption', 'queryChange', '');
	              this.broadcast('ElOptionGroup', 'queryChange');
	            }
	
	            if (this.selectedLabel) {
	              this.currentPlaceholder = this.selectedLabel;
	              this.selectedLabel = '';
	            }
	          }
	        }
	      }
	      this.$emit('visible-change', val);
	    },
	    options: function options() {
	      var _this4 = this;
	
	      if (this.$isServer) return;
	      this.$nextTick(function () {
	        _this4.broadcast('ElSelectDropdown', 'updatePopper');
	      });
	      if (this.multiple) {
	        this.resetInputHeight();
	      }
	      var inputs = this.$el.querySelectorAll('input');
	      if ([].indexOf.call(inputs, document.activeElement) === -1) {
	        this.setSelected();
	      }
	      if (this.defaultFirstOption && (this.filterable || this.remote) && this.filteredOptionsCount) {
	        this.checkDefaultFirstOption();
	      }
	    }
	  },
	
	  methods: {
	    handleComposition: function handleComposition(event) {
	      var _this5 = this;
	
	      var text = event.target.value;
	      if (event.type === 'compositionend') {
	        this.isOnComposition = false;
	        this.$nextTick(function (_) {
	          return _this5.handleQueryChange(text);
	        });
	      } else {
	        var lastCharacter = text[text.length - 1] || '';
	        this.isOnComposition = !Object(shared_["isKorean"])(lastCharacter);
	      }
	    },
	    handleQueryChange: function handleQueryChange(val) {
	      var _this6 = this;
	
	      if (this.previousQuery === val || this.isOnComposition) return;
	      if (this.previousQuery === null && (typeof this.filterMethod === 'function' || typeof this.remoteMethod === 'function')) {
	        this.previousQuery = val;
	        return;
	      }
	      this.previousQuery = val;
	      this.$nextTick(function () {
	        if (_this6.visible) _this6.broadcast('ElSelectDropdown', 'updatePopper');
	      });
	      this.hoverIndex = -1;
	      if (this.multiple && this.filterable) {
	        this.$nextTick(function () {
	          var length = _this6.$refs.input.value.length * 15 + 20;
	          _this6.inputLength = _this6.collapseTags ? Math.min(50, length) : length;
	          _this6.managePlaceholder();
	          _this6.resetInputHeight();
	        });
	      }
	      if (this.remote && typeof this.remoteMethod === 'function') {
	        this.hoverIndex = -1;
	        this.remoteMethod(val);
	      } else if (typeof this.filterMethod === 'function') {
	        this.filterMethod(val);
	        this.broadcast('ElOptionGroup', 'queryChange');
	      } else {
	        this.filteredOptionsCount = this.optionsCount;
	        this.broadcast('ElOption', 'queryChange', val);
	        this.broadcast('ElOptionGroup', 'queryChange');
	      }
	      if (this.defaultFirstOption && (this.filterable || this.remote) && this.filteredOptionsCount) {
	        this.checkDefaultFirstOption();
	      }
	    },
	    scrollToOption: function scrollToOption(option) {
	      var target = Array.isArray(option) && option[0] ? option[0].$el : option.$el;
	      if (this.$refs.popper && target) {
	        var menu = this.$refs.popper.$el.querySelector('.el-select-dropdown__wrap');
	        scroll_into_view_default()(menu, target);
	      }
	      this.$refs.scrollbar && this.$refs.scrollbar.handleScroll();
	    },
	    handleMenuEnter: function handleMenuEnter() {
	      var _this7 = this;
	
	      this.$nextTick(function () {
	        return _this7.scrollToOption(_this7.selected);
	      });
	    },
	    emitChange: function emitChange(val) {
	      if (!Object(util_["valueEquals"])(this.value, val)) {
	        this.$emit('change', val);
	      }
	    },
	    getOption: function getOption(value) {
	      var option = void 0;
	      var isObject = Object.prototype.toString.call(value).toLowerCase() === '[object object]';
	      var isNull = Object.prototype.toString.call(value).toLowerCase() === '[object null]';
	      var isUndefined = Object.prototype.toString.call(value).toLowerCase() === '[object undefined]';
	
	      for (var i = this.cachedOptions.length - 1; i >= 0; i--) {
	        var cachedOption = this.cachedOptions[i];
	        var isEqual = isObject ? Object(util_["getValueByPath"])(cachedOption.value, this.valueKey) === Object(util_["getValueByPath"])(value, this.valueKey) : cachedOption.value === value;
	        if (isEqual) {
	          option = cachedOption;
	          break;
	        }
	      }
	      if (option) return option;
	      var label = !isObject && !isNull && !isUndefined ? value : '';
	      var newOption = {
	        value: value,
	        currentLabel: label
	      };
	      if (this.multiple) {
	        newOption.hitState = false;
	      }
	      return newOption;
	    },
	    setSelected: function setSelected() {
	      var _this8 = this;
	
	      if (!this.multiple) {
	        var option = this.getOption(this.value);
	        if (option.created) {
	          this.createdLabel = option.currentLabel;
	          this.createdSelected = true;
	        } else {
	          this.createdSelected = false;
	        }
	        this.selectedLabel = option.currentLabel;
	        this.selected = option;
	        if (this.filterable) this.query = this.selectedLabel;
	        return;
	      }
	      var result = [];
	      if (Array.isArray(this.value)) {
	        this.value.forEach(function (value) {
	          result.push(_this8.getOption(value));
	        });
	      }
	      this.selected = result;
	      this.$nextTick(function () {
	        _this8.resetInputHeight();
	      });
	    },
	    handleFocus: function handleFocus(event) {
	      if (!this.softFocus) {
	        if (this.automaticDropdown || this.filterable) {
	          this.visible = true;
	          if (this.filterable) {
	            this.menuVisibleOnFocus = true;
	          }
	        }
	        this.$emit('focus', event);
	      } else {
	        this.softFocus = false;
	      }
	    },
	    blur: function blur() {
	      this.visible = false;
	      this.$refs.reference.blur();
	    },
	    handleBlur: function handleBlur(event) {
	      var _this9 = this;
	
	      setTimeout(function () {
	        if (_this9.isSilentBlur) {
	          _this9.isSilentBlur = false;
	        } else {
	          _this9.$emit('blur', event);
	        }
	      }, 50);
	      this.softFocus = false;
	    },
	    handleClearClick: function handleClearClick(event) {
	      this.deleteSelected(event);
	    },
	    doDestroy: function doDestroy() {
	      this.$refs.popper && this.$refs.popper.doDestroy();
	    },
	    handleClose: function handleClose() {
	      this.visible = false;
	    },
	    toggleLastOptionHitState: function toggleLastOptionHitState(hit) {
	      if (!Array.isArray(this.selected)) return;
	      var option = this.selected[this.selected.length - 1];
	      if (!option) return;
	
	      if (hit === true || hit === false) {
	        option.hitState = hit;
	        return hit;
	      }
	
	      option.hitState = !option.hitState;
	      return option.hitState;
	    },
	    deletePrevTag: function deletePrevTag(e) {
	      if (e.target.value.length <= 0 && !this.toggleLastOptionHitState()) {
	        var value = this.value.slice();
	        value.pop();
	        this.$emit('input', value);
	        this.emitChange(value);
	      }
	    },
	    managePlaceholder: function managePlaceholder() {
	      if (this.currentPlaceholder !== '') {
	        this.currentPlaceholder = this.$refs.input.value ? '' : this.cachedPlaceHolder;
	      }
	    },
	    resetInputState: function resetInputState(e) {
	      if (e.keyCode !== 8) this.toggleLastOptionHitState(false);
	      this.inputLength = this.$refs.input.value.length * 15 + 20;
	      this.resetInputHeight();
	    },
	    resetInputHeight: function resetInputHeight() {
	      var _this10 = this;
	
	      if (this.collapseTags && !this.filterable) return;
	      this.$nextTick(function () {
	        if (!_this10.$refs.reference) return;
	        var inputChildNodes = _this10.$refs.reference.$el.childNodes;
	        var input = [].filter.call(inputChildNodes, function (item) {
	          return item.tagName === 'INPUT';
	        })[0];
	        var tags = _this10.$refs.tags;
	        var sizeInMap = _this10.initialInputHeight || 40;
	        input.style.height = _this10.selected.length === 0 ? sizeInMap + 'px' : Math.max(tags ? tags.clientHeight + (tags.clientHeight > sizeInMap ? 6 : 0) : 0, sizeInMap) + 'px';
	        if (_this10.visible && _this10.emptyText !== false) {
	          _this10.broadcast('ElSelectDropdown', 'updatePopper');
	        }
	      });
	    },
	    resetHoverIndex: function resetHoverIndex() {
	      var _this11 = this;
	
	      setTimeout(function () {
	        if (!_this11.multiple) {
	          _this11.hoverIndex = _this11.options.indexOf(_this11.selected);
	        } else {
	          if (_this11.selected.length > 0) {
	            _this11.hoverIndex = Math.min.apply(null, _this11.selected.map(function (item) {
	              return _this11.options.indexOf(item);
	            }));
	          } else {
	            _this11.hoverIndex = -1;
	          }
	        }
	      }, 300);
	    },
	    handleOptionSelect: function handleOptionSelect(option, byClick) {
	      var _this12 = this;
	
	      if (this.multiple) {
	        var value = (this.value || []).slice();
	        var optionIndex = this.getValueIndex(value, option.value);
	        if (optionIndex > -1) {
	          value.splice(optionIndex, 1);
	        } else if (this.multipleLimit <= 0 || value.length < this.multipleLimit) {
	          value.push(option.value);
	        }
	        this.$emit('input', value);
	        this.emitChange(value);
	        if (option.created) {
	          this.query = '';
	          this.handleQueryChange('');
	          this.inputLength = 20;
	        }
	        if (this.filterable) this.$refs.input.focus();
	      } else {
	        this.$emit('input', option.value);
	        this.emitChange(option.value);
	        this.visible = false;
	      }
	      this.isSilentBlur = byClick;
	      this.setSoftFocus();
	      if (this.visible) return;
	      this.$nextTick(function () {
	        _this12.scrollToOption(option);
	      });
	    },
	    setSoftFocus: function setSoftFocus() {
	      this.softFocus = true;
	      var input = this.$refs.input || this.$refs.reference;
	      if (input) {
	        input.focus();
	      }
	    },
	    getValueIndex: function getValueIndex() {
	      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var value = arguments[1];
	
	      var isObject = Object.prototype.toString.call(value).toLowerCase() === '[object object]';
	      if (!isObject) {
	        return arr.indexOf(value);
	      } else {
	        var valueKey = this.valueKey;
	        var index = -1;
	        arr.some(function (item, i) {
	          if (Object(util_["getValueByPath"])(item, valueKey) === Object(util_["getValueByPath"])(value, valueKey)) {
	            index = i;
	            return true;
	          }
	          return false;
	        });
	        return index;
	      }
	    },
	    toggleMenu: function toggleMenu() {
	      if (!this.selectDisabled) {
	        if (this.menuVisibleOnFocus) {
	          this.menuVisibleOnFocus = false;
	        } else {
	          this.visible = !this.visible;
	        }
	        if (this.visible) {
	          (this.$refs.input || this.$refs.reference).focus();
	        }
	      }
	    },
	    selectOption: function selectOption() {
	      if (!this.visible) {
	        this.toggleMenu();
	      } else {
	        if (this.options[this.hoverIndex]) {
	          this.handleOptionSelect(this.options[this.hoverIndex]);
	        }
	      }
	    },
	    deleteSelected: function deleteSelected(event) {
	      event.stopPropagation();
	      var value = this.multiple ? [] : '';
	      this.$emit('input', value);
	      this.emitChange(value);
	      this.visible = false;
	      this.$emit('clear');
	    },
	    deleteTag: function deleteTag(event, tag) {
	      var index = this.selected.indexOf(tag);
	      if (index > -1 && !this.selectDisabled) {
	        var value = this.value.slice();
	        value.splice(index, 1);
	        this.$emit('input', value);
	        this.emitChange(value);
	        this.$emit('remove-tag', tag.value);
	      }
	      event.stopPropagation();
	    },
	    onInputChange: function onInputChange() {
	      if (this.filterable && this.query !== this.selectedLabel) {
	        this.query = this.selectedLabel;
	        this.handleQueryChange(this.query);
	      }
	    },
	    onOptionDestroy: function onOptionDestroy(index) {
	      if (index > -1) {
	        this.optionsCount--;
	        this.filteredOptionsCount--;
	        this.options.splice(index, 1);
	      }
	    },
	    resetInputWidth: function resetInputWidth() {
	      this.inputWidth = this.$refs.reference.$el.getBoundingClientRect().width;
	    },
	    handleResize: function handleResize() {
	      this.resetInputWidth();
	      if (this.multiple) this.resetInputHeight();
	    },
	    checkDefaultFirstOption: function checkDefaultFirstOption() {
	      this.hoverIndex = -1;
	      // highlight the created option
	      var hasCreated = false;
	      for (var i = this.options.length - 1; i >= 0; i--) {
	        if (this.options[i].created) {
	          hasCreated = true;
	          this.hoverIndex = i;
	          break;
	        }
	      }
	      if (hasCreated) return;
	      for (var _i = 0; _i !== this.options.length; ++_i) {
	        var option = this.options[_i];
	        if (this.query) {
	          // highlight first options that passes the filter
	          if (!option.disabled && !option.groupDisabled && option.visible) {
	            this.hoverIndex = _i;
	            break;
	          }
	        } else {
	          // highlight currently selected option
	          if (option.itemSelected) {
	            this.hoverIndex = _i;
	            break;
	          }
	        }
	      }
	    },
	    getValueKey: function getValueKey(item) {
	      if (Object.prototype.toString.call(item.value).toLowerCase() !== '[object object]') {
	        return item.value;
	      } else {
	        return Object(util_["getValueByPath"])(item.value, this.valueKey);
	      }
	    }
	  },
	
	  created: function created() {
	    var _this13 = this;
	
	    this.cachedPlaceHolder = this.currentPlaceholder = this.propPlaceholder;
	    if (this.multiple && !Array.isArray(this.value)) {
	      this.$emit('input', []);
	    }
	    if (!this.multiple && Array.isArray(this.value)) {
	      this.$emit('input', '');
	    }
	
	    this.debouncedOnInputChange = debounce_default()(this.debounce, function () {
	      _this13.onInputChange();
	    });
	
	    this.debouncedQueryChange = debounce_default()(this.debounce, function (e) {
	      _this13.handleQueryChange(e.target.value);
	    });
	
	    this.$on('handleOptionClick', this.handleOptionSelect);
	    this.$on('setSelected', this.setSelected);
	  },
	  mounted: function mounted() {
	    var _this14 = this;
	
	    if (this.multiple && Array.isArray(this.value) && this.value.length > 0) {
	      this.currentPlaceholder = '';
	    }
	    Object(resize_event_["addResizeListener"])(this.$el, this.handleResize);
	
	    var reference = this.$refs.reference;
	    if (reference && reference.$el) {
	      var sizeMap = {
	        medium: 36,
	        small: 32,
	        mini: 28
	      };
	      var input = reference.$el.querySelector('input');
	      this.initialInputHeight = input.getBoundingClientRect().height || sizeMap[this.selectSize];
	    }
	    if (this.remote && this.multiple) {
	      this.resetInputHeight();
	    }
	    this.$nextTick(function () {
	      if (reference && reference.$el) {
	        _this14.inputWidth = reference.$el.getBoundingClientRect().width;
	      }
	    });
	    this.setSelected();
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.$el && this.handleResize) Object(resize_event_["removeResizeListener"])(this.$el, this.handleResize);
	  }
	});
	// CONCATENATED MODULE: ./packages/select/src/select.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_selectvue_type_script_lang_js_ = (selectvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/select/src/select.vue
	
	
	
	
	
	/* normalize component */
	
	var select_component = Object(componentNormalizer["a" /* default */])(
	  src_selectvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var select_api; }
	select_component.options.__file = "packages/select/src/select.vue"
	/* harmony default export */ var src_select = (select_component.exports);
	// CONCATENATED MODULE: ./packages/select/index.js
	
	
	/* istanbul ignore next */
	src_select.install = function (Vue) {
	  Vue.component(src_select.name, src_select);
	};
	
	/* harmony default export */ var packages_select = __webpack_exports__["default"] = (src_select);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 131);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 131:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/vue-popper"
	var vue_popper_ = __webpack_require__(5);
	var vue_popper_default = /*#__PURE__*/__webpack_require__.n(vue_popper_);
	
	// EXTERNAL MODULE: external "throttle-debounce/debounce"
	var debounce_ = __webpack_require__(17);
	var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/dom"
	var dom_ = __webpack_require__(2);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/util"
	var util_ = __webpack_require__(3);
	
	// EXTERNAL MODULE: external "vue"
	var external_vue_ = __webpack_require__(7);
	var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
	
	// CONCATENATED MODULE: ./packages/tooltip/src/main.js
	
	
	
	
	
	
	/* harmony default export */ var main = ({
	  name: 'ElTooltip',
	
	  mixins: [vue_popper_default.a],
	
	  props: {
	    openDelay: {
	      type: Number,
	      default: 0
	    },
	    disabled: Boolean,
	    manual: Boolean,
	    effect: {
	      type: String,
	      default: 'dark'
	    },
	    arrowOffset: {
	      type: Number,
	      default: 0
	    },
	    popperClass: String,
	    content: String,
	    visibleArrow: {
	      default: true
	    },
	    transition: {
	      type: String,
	      default: 'el-fade-in-linear'
	    },
	    popperOptions: {
	      default: function _default() {
	        return {
	          boundariesPadding: 10,
	          gpuAcceleration: false
	        };
	      }
	    },
	    enterable: {
	      type: Boolean,
	      default: true
	    },
	    hideAfter: {
	      type: Number,
	      default: 0
	    },
	    tabindex: {
	      type: Number,
	      default: 0
	    }
	  },
	
	  data: function data() {
	    return {
	      tooltipId: 'el-tooltip-' + Object(util_["generateId"])(),
	      timeoutPending: null,
	      focusing: false
	    };
	  },
	  beforeCreate: function beforeCreate() {
	    var _this = this;
	
	    if (this.$isServer) return;
	
	    this.popperVM = new external_vue_default.a({
	      data: { node: '' },
	      render: function render(h) {
	        return this.node;
	      }
	    }).$mount();
	
	    this.debounceClose = debounce_default()(200, function () {
	      return _this.handleClosePopper();
	    });
	  },
	  render: function render(h) {
	    var _this2 = this;
	
	    if (this.popperVM) {
	      this.popperVM.node = h(
	        'transition',
	        {
	          attrs: {
	            name: this.transition
	          },
	          on: {
	            'afterLeave': this.doDestroy
	          }
	        },
	        [h(
	          'div',
	          {
	            on: {
	              'mouseleave': function mouseleave() {
	                _this2.setExpectedState(false);_this2.debounceClose();
	              },
	              'mouseenter': function mouseenter() {
	                _this2.setExpectedState(true);
	              }
	            },
	
	            ref: 'popper',
	            attrs: { role: 'tooltip',
	              id: this.tooltipId,
	              'aria-hidden': this.disabled || !this.showPopper ? 'true' : 'false'
	            },
	            directives: [{
	              name: 'show',
	              value: !this.disabled && this.showPopper
	            }],
	
	            'class': ['el-tooltip__popper', 'is-' + this.effect, this.popperClass] },
	          [this.$slots.content || this.content]
	        )]
	      );
	    }
	
	    var firstElement = this.getFirstElement();
	    if (!firstElement) return null;
	
	    var data = firstElement.data = firstElement.data || {};
	    data.staticClass = this.addTooltipClass(data.staticClass);
	
	    return firstElement;
	  },
	  mounted: function mounted() {
	    var _this3 = this;
	
	    this.referenceElm = this.$el;
	    if (this.$el.nodeType === 1) {
	      this.$el.setAttribute('aria-describedby', this.tooltipId);
	      this.$el.setAttribute('tabindex', this.tabindex);
	      Object(dom_["on"])(this.referenceElm, 'mouseenter', this.show);
	      Object(dom_["on"])(this.referenceElm, 'mouseleave', this.hide);
	      Object(dom_["on"])(this.referenceElm, 'focus', function () {
	        if (!_this3.$slots.default || !_this3.$slots.default.length) {
	          _this3.handleFocus();
	          return;
	        }
	        var instance = _this3.$slots.default[0].componentInstance;
	        if (instance && instance.focus) {
	          instance.focus();
	        } else {
	          _this3.handleFocus();
	        }
	      });
	      Object(dom_["on"])(this.referenceElm, 'blur', this.handleBlur);
	      Object(dom_["on"])(this.referenceElm, 'click', this.removeFocusing);
	    }
	    // fix issue https://github.com/ElemeFE/element/issues/14424
	    if (this.value && this.popperVM) {
	      this.popperVM.$nextTick(function () {
	        if (_this3.value) {
	          _this3.updatePopper();
	        }
	      });
	    }
	  },
	
	  watch: {
	    focusing: function focusing(val) {
	      if (val) {
	        Object(dom_["addClass"])(this.referenceElm, 'focusing');
	      } else {
	        Object(dom_["removeClass"])(this.referenceElm, 'focusing');
	      }
	    }
	  },
	  methods: {
	    show: function show() {
	      this.setExpectedState(true);
	      this.handleShowPopper();
	    },
	    hide: function hide() {
	      this.setExpectedState(false);
	      this.debounceClose();
	    },
	    handleFocus: function handleFocus() {
	      this.focusing = true;
	      this.show();
	    },
	    handleBlur: function handleBlur() {
	      this.focusing = false;
	      this.hide();
	    },
	    removeFocusing: function removeFocusing() {
	      this.focusing = false;
	    },
	    addTooltipClass: function addTooltipClass(prev) {
	      if (!prev) {
	        return 'el-tooltip';
	      } else {
	        return 'el-tooltip ' + prev.replace('el-tooltip', '');
	      }
	    },
	    handleShowPopper: function handleShowPopper() {
	      var _this4 = this;
	
	      if (!this.expectedState || this.manual) return;
	      clearTimeout(this.timeout);
	      this.timeout = setTimeout(function () {
	        _this4.showPopper = true;
	      }, this.openDelay);
	
	      if (this.hideAfter > 0) {
	        this.timeoutPending = setTimeout(function () {
	          _this4.showPopper = false;
	        }, this.hideAfter);
	      }
	    },
	    handleClosePopper: function handleClosePopper() {
	      if (this.enterable && this.expectedState || this.manual) return;
	      clearTimeout(this.timeout);
	
	      if (this.timeoutPending) {
	        clearTimeout(this.timeoutPending);
	      }
	      this.showPopper = false;
	
	      if (this.disabled) {
	        this.doDestroy();
	      }
	    },
	    setExpectedState: function setExpectedState(expectedState) {
	      if (expectedState === false) {
	        clearTimeout(this.timeoutPending);
	      }
	      this.expectedState = expectedState;
	    },
	    getFirstElement: function getFirstElement() {
	      var slots = this.$slots.default;
	      if (!Array.isArray(slots)) return null;
	      var element = null;
	      for (var index = 0; index < slots.length; index++) {
	        if (slots[index] && slots[index].tag) {
	          element = slots[index];
	        };
	      }
	      return element;
	    }
	  },
	
	  beforeDestroy: function beforeDestroy() {
	    this.popperVM && this.popperVM.$destroy();
	  },
	  destroyed: function destroyed() {
	    var reference = this.referenceElm;
	    if (reference.nodeType === 1) {
	      Object(dom_["off"])(reference, 'mouseenter', this.show);
	      Object(dom_["off"])(reference, 'mouseleave', this.hide);
	      Object(dom_["off"])(reference, 'focus', this.handleFocus);
	      Object(dom_["off"])(reference, 'blur', this.handleBlur);
	      Object(dom_["off"])(reference, 'click', this.removeFocusing);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/tooltip/index.js
	
	
	/* istanbul ignore next */
	main.install = function (Vue) {
	  Vue.component(main.name, main);
	};
	
	/* harmony default export */ var tooltip = __webpack_exports__["default"] = (main);
	
	/***/ }),
	
	/***/ 17:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(62);
	
	/***/ }),
	
	/***/ 2:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(17);
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(15);
	
	/***/ }),
	
	/***/ 5:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(61);
	
	/***/ }),
	
	/***/ 7:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(3);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _dom = __webpack_require__(17);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Transition = function () {
	  function Transition() {
	    _classCallCheck(this, Transition);
	  }
	
	  Transition.prototype.beforeEnter = function beforeEnter(el) {
	    (0, _dom.addClass)(el, 'collapse-transition');
	    if (!el.dataset) el.dataset = {};
	
	    el.dataset.oldPaddingTop = el.style.paddingTop;
	    el.dataset.oldPaddingBottom = el.style.paddingBottom;
	
	    el.style.height = '0';
	    el.style.paddingTop = 0;
	    el.style.paddingBottom = 0;
	  };
	
	  Transition.prototype.enter = function enter(el) {
	    el.dataset.oldOverflow = el.style.overflow;
	    if (el.scrollHeight !== 0) {
	      el.style.height = el.scrollHeight + 'px';
	      el.style.paddingTop = el.dataset.oldPaddingTop;
	      el.style.paddingBottom = el.dataset.oldPaddingBottom;
	    } else {
	      el.style.height = '';
	      el.style.paddingTop = el.dataset.oldPaddingTop;
	      el.style.paddingBottom = el.dataset.oldPaddingBottom;
	    }
	
	    el.style.overflow = 'hidden';
	  };
	
	  Transition.prototype.afterEnter = function afterEnter(el) {
	    // for safari: remove class then reset height is necessary
	    (0, _dom.removeClass)(el, 'collapse-transition');
	    el.style.height = '';
	    el.style.overflow = el.dataset.oldOverflow;
	  };
	
	  Transition.prototype.beforeLeave = function beforeLeave(el) {
	    if (!el.dataset) el.dataset = {};
	    el.dataset.oldPaddingTop = el.style.paddingTop;
	    el.dataset.oldPaddingBottom = el.style.paddingBottom;
	    el.dataset.oldOverflow = el.style.overflow;
	
	    el.style.height = el.scrollHeight + 'px';
	    el.style.overflow = 'hidden';
	  };
	
	  Transition.prototype.leave = function leave(el) {
	    if (el.scrollHeight !== 0) {
	      // for safari: add class after set height, or it will jump to zero height suddenly, weired
	      (0, _dom.addClass)(el, 'collapse-transition');
	      el.style.height = 0;
	      el.style.paddingTop = 0;
	      el.style.paddingBottom = 0;
	    }
	  };
	
	  Transition.prototype.afterLeave = function afterLeave(el) {
	    (0, _dom.removeClass)(el, 'collapse-transition');
	    el.style.height = '';
	    el.style.overflow = el.dataset.oldOverflow;
	    el.style.paddingTop = el.dataset.oldPaddingTop;
	    el.style.paddingBottom = el.dataset.oldPaddingBottom;
	  };
	
	  return Transition;
	}();
	
	exports.default = {
	  name: 'ElCollapseTransition',
	  functional: true,
	  render: function render(h, _ref) {
	    var children = _ref.children;
	
	    var data = {
	      on: new Transition()
	    };
	
	    return h('transition', data, children);
	  }
	};

/***/ }),
/* 473 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (instance, callback) {
	  var speed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
	  var once = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  if (!instance || !callback) throw new Error('instance & callback is required');
	  var called = false;
	  var afterLeaveCallback = function afterLeaveCallback() {
	    if (called) return;
	    called = true;
	    if (callback) {
	      callback.apply(null, arguments);
	    }
	  };
	  if (once) {
	    instance.$once('after-leave', afterLeaveCallback);
	  } else {
	    instance.$on('after-leave', afterLeaveCallback);
	  }
	  setTimeout(function () {
	    afterLeaveCallback();
	  }, speed + 100);
	};
	
	; /**
	   * Bind after-leave event for vue instance. Make sure after-leave is called in any browsers.
	   *
	   * @param {Vue} instance Vue instance.
	   * @param {Function} callback callback of after-leave event
	   * @param {Number} speed the speed of transition, default value is 300ms
	   * @param {Boolean} once weather bind after-leave once. default value is false.
	   */

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _ariaUtils = __webpack_require__(100);
	
	var _ariaUtils2 = _interopRequireDefault(_ariaUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @constructor
	 * @desc Dialog object providing modal focus management.
	 *
	 * Assumptions: The element serving as the dialog container is present in the
	 * DOM and hidden. The dialog container has role='dialog'.
	 *
	 * @param dialogId
	 *          The ID of the element serving as the dialog container.
	 * @param focusAfterClosed
	 *          Either the DOM node or the ID of the DOM node to focus when the
	 *          dialog closes.
	 * @param focusFirst
	 *          Optional parameter containing either the DOM node or the ID of the
	 *          DOM node to focus when the dialog opens. If not specified, the
	 *          first focusable element in the dialog will receive focus.
	 */
	var aria = aria || {};
	var tabEvent;
	
	aria.Dialog = function (dialog, focusAfterClosed, focusFirst) {
	  var _this = this;
	
	  this.dialogNode = dialog;
	  if (this.dialogNode === null || this.dialogNode.getAttribute('role') !== 'dialog') {
	    throw new Error('Dialog() requires a DOM element with ARIA role of dialog.');
	  }
	
	  if (typeof focusAfterClosed === 'string') {
	    this.focusAfterClosed = document.getElementById(focusAfterClosed);
	  } else if ((typeof focusAfterClosed === 'undefined' ? 'undefined' : _typeof(focusAfterClosed)) === 'object') {
	    this.focusAfterClosed = focusAfterClosed;
	  } else {
	    this.focusAfterClosed = null;
	  }
	
	  if (typeof focusFirst === 'string') {
	    this.focusFirst = document.getElementById(focusFirst);
	  } else if ((typeof focusFirst === 'undefined' ? 'undefined' : _typeof(focusFirst)) === 'object') {
	    this.focusFirst = focusFirst;
	  } else {
	    this.focusFirst = null;
	  }
	
	  if (this.focusFirst) {
	    this.focusFirst.focus();
	  } else {
	    _ariaUtils2.default.focusFirstDescendant(this.dialogNode);
	  }
	
	  this.lastFocus = document.activeElement;
	  tabEvent = function tabEvent(e) {
	    _this.trapFocus(e);
	  };
	  this.addListeners();
	};
	
	aria.Dialog.prototype.addListeners = function () {
	  document.addEventListener('focus', tabEvent, true);
	};
	
	aria.Dialog.prototype.removeListeners = function () {
	  document.removeEventListener('focus', tabEvent, true);
	};
	
	aria.Dialog.prototype.closeDialog = function () {
	  var _this2 = this;
	
	  this.removeListeners();
	  if (this.focusAfterClosed) {
	    setTimeout(function () {
	      _this2.focusAfterClosed.focus();
	    });
	  }
	};
	
	aria.Dialog.prototype.trapFocus = function (event) {
	  if (_ariaUtils2.default.IgnoreUtilFocusChanges) {
	    return;
	  }
	  if (this.dialogNode.contains(event.target)) {
	    this.lastFocus = event.target;
	  } else {
	    _ariaUtils2.default.focusFirstDescendant(this.dialogNode);
	    if (this.lastFocus === document.activeElement) {
	      _ariaUtils2.default.focusLastDescendant(this.dialogNode);
	    }
	    this.lastFocus = document.activeElement;
	  }
	};
	
	exports.default = aria.Dialog;

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.validateRangeInOneMonth = exports.extractTimeFormat = exports.extractDateFormat = exports.nextYear = exports.prevYear = exports.nextMonth = exports.prevMonth = exports.changeYearMonthAndClampDate = exports.timeWithinRange = exports.limitTimeRange = exports.clearMilliseconds = exports.clearTime = exports.modifyWithTimeString = exports.modifyTime = exports.modifyDate = exports.range = exports.getRangeMinutes = exports.getMonthDays = exports.getPrevMonthLastDays = exports.getRangeHours = exports.getWeekNumber = exports.getStartDateOfMonth = exports.nextDate = exports.prevDate = exports.getFirstDayOfMonth = exports.getDayCountOfYear = exports.getDayCountOfMonth = exports.parseDate = exports.formatDate = exports.isDateObject = exports.isDate = exports.toDate = exports.getI18nSettings = undefined;
	
	var _date = __webpack_require__(146);
	
	var _date2 = _interopRequireDefault(_date);
	
	var _locale = __webpack_require__(96);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var weeks = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
	var months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
	
	var newArray = function newArray(start, end) {
	  var result = [];
	  for (var i = start; i <= end; i++) {
	    result.push(i);
	  }
	  return result;
	};
	
	var getI18nSettings = exports.getI18nSettings = function getI18nSettings() {
	  return {
	    dayNamesShort: weeks.map(function (week) {
	      return (0, _locale.t)('el.datepicker.weeks.' + week);
	    }),
	    dayNames: weeks.map(function (week) {
	      return (0, _locale.t)('el.datepicker.weeks.' + week);
	    }),
	    monthNamesShort: months.map(function (month) {
	      return (0, _locale.t)('el.datepicker.months.' + month);
	    }),
	    monthNames: months.map(function (month, index) {
	      return (0, _locale.t)('el.datepicker.month' + (index + 1));
	    }),
	    amPm: ['am', 'pm']
	  };
	};
	
	var toDate = exports.toDate = function toDate(date) {
	  return isDate(date) ? new Date(date) : null;
	};
	
	var isDate = exports.isDate = function isDate(date) {
	  if (date === null || date === undefined) return false;
	  if (isNaN(new Date(date).getTime())) return false;
	  if (Array.isArray(date)) return false; // deal with `new Date([ new Date() ]) -> new Date()`
	  return true;
	};
	
	var isDateObject = exports.isDateObject = function isDateObject(val) {
	  return val instanceof Date;
	};
	
	var formatDate = exports.formatDate = function formatDate(date, format) {
	  date = toDate(date);
	  if (!date) return '';
	  return _date2.default.format(date, format || 'yyyy-MM-dd', getI18nSettings());
	};
	
	var parseDate = exports.parseDate = function parseDate(string, format) {
	  return _date2.default.parse(string, format || 'yyyy-MM-dd', getI18nSettings());
	};
	
	var getDayCountOfMonth = exports.getDayCountOfMonth = function getDayCountOfMonth(year, month) {
	  if (month === 3 || month === 5 || month === 8 || month === 10) {
	    return 30;
	  }
	
	  if (month === 1) {
	    if (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0) {
	      return 29;
	    } else {
	      return 28;
	    }
	  }
	
	  return 31;
	};
	
	var getDayCountOfYear = exports.getDayCountOfYear = function getDayCountOfYear(year) {
	  var isLeapYear = year % 400 === 0 || year % 100 !== 0 && year % 4 === 0;
	  return isLeapYear ? 366 : 365;
	};
	
	var getFirstDayOfMonth = exports.getFirstDayOfMonth = function getFirstDayOfMonth(date) {
	  var temp = new Date(date.getTime());
	  temp.setDate(1);
	  return temp.getDay();
	};
	
	// see: https://stackoverflow.com/questions/3674539/incrementing-a-date-in-javascript
	// {prev, next} Date should work for Daylight Saving Time
	// Adding 24 * 60 * 60 * 1000 does not work in the above scenario
	var prevDate = exports.prevDate = function prevDate(date) {
	  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	  return new Date(date.getFullYear(), date.getMonth(), date.getDate() - amount);
	};
	
	var nextDate = exports.nextDate = function nextDate(date) {
	  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	  return new Date(date.getFullYear(), date.getMonth(), date.getDate() + amount);
	};
	
	var getStartDateOfMonth = exports.getStartDateOfMonth = function getStartDateOfMonth(year, month) {
	  var result = new Date(year, month, 1);
	  var day = result.getDay();
	
	  if (day === 0) {
	    return prevDate(result, 7);
	  } else {
	    return prevDate(result, day);
	  }
	};
	
	var getWeekNumber = exports.getWeekNumber = function getWeekNumber(src) {
	  if (!isDate(src)) return null;
	  var date = new Date(src.getTime());
	  date.setHours(0, 0, 0, 0);
	  // Thursday in current week decides the year.
	  date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
	  // January 4 is always in week 1.
	  var week1 = new Date(date.getFullYear(), 0, 4);
	  // Adjust to Thursday in week 1 and count number of weeks from date to week 1.
	  // Rounding should be fine for Daylight Saving Time. Its shift should never be more than 12 hours.
	  return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
	};
	
	var getRangeHours = exports.getRangeHours = function getRangeHours(ranges) {
	  var hours = [];
	  var disabledHours = [];
	
	  (ranges || []).forEach(function (range) {
	    var value = range.map(function (date) {
	      return date.getHours();
	    });
	
	    disabledHours = disabledHours.concat(newArray(value[0], value[1]));
	  });
	
	  if (disabledHours.length) {
	    for (var i = 0; i < 24; i++) {
	      hours[i] = disabledHours.indexOf(i) === -1;
	    }
	  } else {
	    for (var _i = 0; _i < 24; _i++) {
	      hours[_i] = false;
	    }
	  }
	
	  return hours;
	};
	
	var getPrevMonthLastDays = exports.getPrevMonthLastDays = function getPrevMonthLastDays(date, amount) {
	  if (amount <= 0) return [];
	  var temp = new Date(date.getTime());
	  temp.setDate(0);
	  var lastDay = temp.getDate();
	  return range(amount).map(function (_, index) {
	    return lastDay - (amount - index - 1);
	  });
	};
	
	var getMonthDays = exports.getMonthDays = function getMonthDays(date) {
	  var temp = new Date(date.getFullYear(), date.getMonth() + 1, 0);
	  var days = temp.getDate();
	  return range(days).map(function (_, index) {
	    return index + 1;
	  });
	};
	
	function setRangeData(arr, start, end, value) {
	  for (var i = start; i < end; i++) {
	    arr[i] = value;
	  }
	}
	
	var getRangeMinutes = exports.getRangeMinutes = function getRangeMinutes(ranges, hour) {
	  var minutes = new Array(60);
	
	  if (ranges.length > 0) {
	    ranges.forEach(function (range) {
	      var start = range[0];
	      var end = range[1];
	      var startHour = start.getHours();
	      var startMinute = start.getMinutes();
	      var endHour = end.getHours();
	      var endMinute = end.getMinutes();
	      if (startHour === hour && endHour !== hour) {
	        setRangeData(minutes, startMinute, 60, true);
	      } else if (startHour === hour && endHour === hour) {
	        setRangeData(minutes, startMinute, endMinute + 1, true);
	      } else if (startHour !== hour && endHour === hour) {
	        setRangeData(minutes, 0, endMinute + 1, true);
	      } else if (startHour < hour && endHour > hour) {
	        setRangeData(minutes, 0, 60, true);
	      }
	    });
	  } else {
	    setRangeData(minutes, 0, 60, true);
	  }
	  return minutes;
	};
	
	var range = exports.range = function range(n) {
	  // see https://stackoverflow.com/questions/3746725/create-a-javascript-array-containing-1-n
	  return Array.apply(null, { length: n }).map(function (_, n) {
	    return n;
	  });
	};
	
	var modifyDate = exports.modifyDate = function modifyDate(date, y, m, d) {
	  return new Date(y, m, d, date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
	};
	
	var modifyTime = exports.modifyTime = function modifyTime(date, h, m, s) {
	  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), h, m, s, date.getMilliseconds());
	};
	
	var modifyWithTimeString = exports.modifyWithTimeString = function modifyWithTimeString(date, time) {
	  if (date == null || !time) {
	    return date;
	  }
	  time = parseDate(time, 'HH:mm:ss');
	  return modifyTime(date, time.getHours(), time.getMinutes(), time.getSeconds());
	};
	
	var clearTime = exports.clearTime = function clearTime(date) {
	  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
	};
	
	var clearMilliseconds = exports.clearMilliseconds = function clearMilliseconds(date) {
	  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), 0);
	};
	
	var limitTimeRange = exports.limitTimeRange = function limitTimeRange(date, ranges) {
	  var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'HH:mm:ss';
	
	  // TODO: refactory a more elegant solution
	  if (ranges.length === 0) return date;
	  var normalizeDate = function normalizeDate(date) {
	    return _date2.default.parse(_date2.default.format(date, format), format);
	  };
	  var ndate = normalizeDate(date);
	  var nranges = ranges.map(function (range) {
	    return range.map(normalizeDate);
	  });
	  if (nranges.some(function (nrange) {
	    return ndate >= nrange[0] && ndate <= nrange[1];
	  })) return date;
	
	  var minDate = nranges[0][0];
	  var maxDate = nranges[0][0];
	
	  nranges.forEach(function (nrange) {
	    minDate = new Date(Math.min(nrange[0], minDate));
	    maxDate = new Date(Math.max(nrange[1], minDate));
	  });
	
	  var ret = ndate < minDate ? minDate : maxDate;
	  // preserve Year/Month/Date
	  return modifyDate(ret, date.getFullYear(), date.getMonth(), date.getDate());
	};
	
	var timeWithinRange = exports.timeWithinRange = function timeWithinRange(date, selectableRange, format) {
	  var limitedDate = limitTimeRange(date, selectableRange, format);
	  return limitedDate.getTime() === date.getTime();
	};
	
	var changeYearMonthAndClampDate = exports.changeYearMonthAndClampDate = function changeYearMonthAndClampDate(date, year, month) {
	  // clamp date to the number of days in `year`, `month`
	  // eg: (2010-1-31, 2010, 2) => 2010-2-28
	  var monthDate = Math.min(date.getDate(), getDayCountOfMonth(year, month));
	  return modifyDate(date, year, month, monthDate);
	};
	
	var prevMonth = exports.prevMonth = function prevMonth(date) {
	  var year = date.getFullYear();
	  var month = date.getMonth();
	  return month === 0 ? changeYearMonthAndClampDate(date, year - 1, 11) : changeYearMonthAndClampDate(date, year, month - 1);
	};
	
	var nextMonth = exports.nextMonth = function nextMonth(date) {
	  var year = date.getFullYear();
	  var month = date.getMonth();
	  return month === 11 ? changeYearMonthAndClampDate(date, year + 1, 0) : changeYearMonthAndClampDate(date, year, month + 1);
	};
	
	var prevYear = exports.prevYear = function prevYear(date) {
	  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	  var year = date.getFullYear();
	  var month = date.getMonth();
	  return changeYearMonthAndClampDate(date, year - amount, month);
	};
	
	var nextYear = exports.nextYear = function nextYear(date) {
	  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	  var year = date.getFullYear();
	  var month = date.getMonth();
	  return changeYearMonthAndClampDate(date, year + amount, month);
	};
	
	var extractDateFormat = exports.extractDateFormat = function extractDateFormat(format) {
	  return format.replace(/\W?m{1,2}|\W?ZZ/g, '').replace(/\W?h{1,2}|\W?s{1,3}|\W?a/gi, '').trim();
	};
	
	var extractTimeFormat = exports.extractTimeFormat = function extractTimeFormat(format) {
	  return format.replace(/\W?D{1,2}|\W?Do|\W?d{1,4}|\W?M{1,4}|\W?y{2,4}/g, '').trim();
	};
	
	var validateRangeInOneMonth = exports.validateRangeInOneMonth = function validateRangeInOneMonth(start, end) {
	  return start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear();
	};

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version {{version}}
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	
	//
	// Cross module loader
	// Supported: Node, AMD, Browser globals
	//
	;(function (root, factory) {
	    if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
	        // Node. Does not work with strict CommonJS, but
	        // only CommonJS-like environments that support module.exports,
	        // like Node.
	        module.exports = factory();
	    } else {
	        // Browser globals (root is window)
	        root.Popper = factory();
	    }
	})(undefined, function () {
	
	    'use strict';
	
	    var root = window;
	
	    // default options
	    var DEFAULTS = {
	        // placement of the popper
	        placement: 'bottom',
	
	        gpuAcceleration: true,
	
	        // shift popper from its origin by the given amount of pixels (can be negative)
	        offset: 0,
	
	        // the element which will act as boundary of the popper
	        boundariesElement: 'viewport',
	
	        // amount of pixel used to define a minimum distance between the boundaries and the popper
	        boundariesPadding: 5,
	
	        // popper will try to prevent overflow following this order,
	        // by default, then, it could overflow on the left and on top of the boundariesElement
	        preventOverflowOrder: ['left', 'right', 'top', 'bottom'],
	
	        // the behavior used by flip to change the placement of the popper
	        flipBehavior: 'flip',
	
	        arrowElement: '[x-arrow]',
	
	        arrowOffset: 0,
	
	        // list of functions used to modify the offsets before they are applied to the popper
	        modifiers: ['shift', 'offset', 'preventOverflow', 'keepTogether', 'arrow', 'flip', 'applyStyle'],
	
	        modifiersIgnored: [],
	
	        forceAbsolute: false
	    };
	
	    /**
	     * Create a new Popper.js instance
	     * @constructor Popper
	     * @param {HTMLElement} reference - The reference element used to position the popper
	     * @param {HTMLElement|Object} popper
	     *      The HTML element used as popper, or a configuration used to generate the popper.
	     * @param {String} [popper.tagName='div'] The tag name of the generated popper.
	     * @param {Array} [popper.classNames=['popper']] Array of classes to apply to the generated popper.
	     * @param {Array} [popper.attributes] Array of attributes to apply, specify `attr:value` to assign a value to it.
	     * @param {HTMLElement|String} [popper.parent=window.document.body] The parent element, given as HTMLElement or as query string.
	     * @param {String} [popper.content=''] The content of the popper, it can be text, html, or node; if it is not text, set `contentType` to `html` or `node`.
	     * @param {String} [popper.contentType='text'] If `html`, the `content` will be parsed as HTML. If `node`, it will be appended as-is.
	     * @param {String} [popper.arrowTagName='div'] Same as `popper.tagName` but for the arrow element.
	     * @param {Array} [popper.arrowClassNames='popper__arrow'] Same as `popper.classNames` but for the arrow element.
	     * @param {String} [popper.arrowAttributes=['x-arrow']] Same as `popper.attributes` but for the arrow element.
	     * @param {Object} options
	     * @param {String} [options.placement=bottom]
	     *      Placement of the popper accepted values: `top(-start, -end), right(-start, -end), bottom(-start, -right),
	     *      left(-start, -end)`
	     *
	     * @param {HTMLElement|String} [options.arrowElement='[x-arrow]']
	     *      The DOM Node used as arrow for the popper, or a CSS selector used to get the DOM node. It must be child of
	     *      its parent Popper. Popper.js will apply to the given element the style required to align the arrow with its
	     *      reference element.
	     *      By default, it will look for a child node of the popper with the `x-arrow` attribute.
	     *
	     * @param {Boolean} [options.gpuAcceleration=true]
	     *      When this property is set to true, the popper position will be applied using CSS3 translate3d, allowing the
	     *      browser to use the GPU to accelerate the rendering.
	     *      If set to false, the popper will be placed using `top` and `left` properties, not using the GPU.
	     *
	     * @param {Number} [options.offset=0]
	     *      Amount of pixels the popper will be shifted (can be negative).
	     *
	     * @param {String|Element} [options.boundariesElement='viewport']
	     *      The element which will define the boundaries of the popper position, the popper will never be placed outside
	     *      of the defined boundaries (except if `keepTogether` is enabled)
	     *
	     * @param {Number} [options.boundariesPadding=5]
	     *      Additional padding for the boundaries
	     *
	     * @param {Array} [options.preventOverflowOrder=['left', 'right', 'top', 'bottom']]
	     *      Order used when Popper.js tries to avoid overflows from the boundaries, they will be checked in order,
	     *      this means that the last ones will never overflow
	     *
	     * @param {String|Array} [options.flipBehavior='flip']
	     *      The behavior used by the `flip` modifier to change the placement of the popper when the latter is trying to
	     *      overlap its reference element. Defining `flip` as value, the placement will be flipped on
	     *      its axis (`right - left`, `top - bottom`).
	     *      You can even pass an array of placements (eg: `['right', 'left', 'top']` ) to manually specify
	     *      how alter the placement when a flip is needed. (eg. in the above example, it would first flip from right to left,
	     *      then, if even in its new placement, the popper is overlapping its reference element, it will be moved to top)
	     *
	     * @param {Array} [options.modifiers=[ 'shift', 'offset', 'preventOverflow', 'keepTogether', 'arrow', 'flip', 'applyStyle']]
	     *      List of functions used to modify the data before they are applied to the popper, add your custom functions
	     *      to this array to edit the offsets and placement.
	     *      The function should reflect the @params and @returns of preventOverflow
	     *
	     * @param {Array} [options.modifiersIgnored=[]]
	     *      Put here any built-in modifier name you want to exclude from the modifiers list
	     *      The function should reflect the @params and @returns of preventOverflow
	     *
	     * @param {Boolean} [options.removeOnDestroy=false]
	     *      Set to true if you want to automatically remove the popper when you call the `destroy` method.
	     */
	    function Popper(reference, popper, options) {
	        this._reference = reference.jquery ? reference[0] : reference;
	        this.state = {};
	
	        // if the popper variable is a configuration object, parse it to generate an HTMLElement
	        // generate a default popper if is not defined
	        var isNotDefined = typeof popper === 'undefined' || popper === null;
	        var isConfig = popper && Object.prototype.toString.call(popper) === '[object Object]';
	        if (isNotDefined || isConfig) {
	            this._popper = this.parse(isConfig ? popper : {});
	        }
	        // otherwise, use the given HTMLElement as popper
	        else {
	                this._popper = popper.jquery ? popper[0] : popper;
	            }
	
	        // with {} we create a new object with the options inside it
	        this._options = Object.assign({}, DEFAULTS, options);
	
	        // refactoring modifiers' list
	        this._options.modifiers = this._options.modifiers.map(function (modifier) {
	            // remove ignored modifiers
	            if (this._options.modifiersIgnored.indexOf(modifier) !== -1) return;
	
	            // set the x-placement attribute before everything else because it could be used to add margins to the popper
	            // margins needs to be calculated to get the correct popper offsets
	            if (modifier === 'applyStyle') {
	                this._popper.setAttribute('x-placement', this._options.placement);
	            }
	
	            // return predefined modifier identified by string or keep the custom one
	            return this.modifiers[modifier] || modifier;
	        }.bind(this));
	
	        // make sure to apply the popper position before any computation
	        this.state.position = this._getPosition(this._popper, this._reference);
	        setStyle(this._popper, { position: this.state.position, top: 0 });
	
	        // fire the first update to position the popper in the right place
	        this.update();
	
	        // setup event listeners, they will take care of update the position in specific situations
	        this._setupEventListeners();
	        return this;
	    }
	
	    //
	    // Methods
	    //
	    /**
	     * Destroy the popper
	     * @method
	     * @memberof Popper
	     */
	    Popper.prototype.destroy = function () {
	        this._popper.removeAttribute('x-placement');
	        this._popper.style.left = '';
	        this._popper.style.position = '';
	        this._popper.style.top = '';
	        this._popper.style[getSupportedPropertyName('transform')] = '';
	        this._removeEventListeners();
	
	        // remove the popper if user explicity asked for the deletion on destroy
	        if (this._options.removeOnDestroy) {
	            this._popper.remove();
	        }
	        return this;
	    };
	
	    /**
	     * Updates the position of the popper, computing the new offsets and applying the new style
	     * @method
	     * @memberof Popper
	     */
	    Popper.prototype.update = function () {
	        var data = { instance: this, styles: {} };
	
	        // store placement inside the data object, modifiers will be able to edit `placement` if needed
	        // and refer to _originalPlacement to know the original value
	        data.placement = this._options.placement;
	        data._originalPlacement = this._options.placement;
	
	        // compute the popper and reference offsets and put them inside data.offsets
	        data.offsets = this._getOffsets(this._popper, this._reference, data.placement);
	
	        // get boundaries
	        data.boundaries = this._getBoundaries(data, this._options.boundariesPadding, this._options.boundariesElement);
	
	        data = this.runModifiers(data, this._options.modifiers);
	
	        if (typeof this.state.updateCallback === 'function') {
	            this.state.updateCallback(data);
	        }
	    };
	
	    /**
	     * If a function is passed, it will be executed after the initialization of popper with as first argument the Popper instance.
	     * @method
	     * @memberof Popper
	     * @param {Function} callback
	     */
	    Popper.prototype.onCreate = function (callback) {
	        // the createCallbacks return as first argument the popper instance
	        callback(this);
	        return this;
	    };
	
	    /**
	     * If a function is passed, it will be executed after each update of popper with as first argument the set of coordinates and informations
	     * used to style popper and its arrow.
	     * NOTE: it doesn't get fired on the first call of the `Popper.update()` method inside the `Popper` constructor!
	     * @method
	     * @memberof Popper
	     * @param {Function} callback
	     */
	    Popper.prototype.onUpdate = function (callback) {
	        this.state.updateCallback = callback;
	        return this;
	    };
	
	    /**
	     * Helper used to generate poppers from a configuration file
	     * @method
	     * @memberof Popper
	     * @param config {Object} configuration
	     * @returns {HTMLElement} popper
	     */
	    Popper.prototype.parse = function (config) {
	        var defaultConfig = {
	            tagName: 'div',
	            classNames: ['popper'],
	            attributes: [],
	            parent: root.document.body,
	            content: '',
	            contentType: 'text',
	            arrowTagName: 'div',
	            arrowClassNames: ['popper__arrow'],
	            arrowAttributes: ['x-arrow']
	        };
	        config = Object.assign({}, defaultConfig, config);
	
	        var d = root.document;
	
	        var popper = d.createElement(config.tagName);
	        addClassNames(popper, config.classNames);
	        addAttributes(popper, config.attributes);
	        if (config.contentType === 'node') {
	            popper.appendChild(config.content.jquery ? config.content[0] : config.content);
	        } else if (config.contentType === 'html') {
	            popper.innerHTML = config.content;
	        } else {
	            popper.textContent = config.content;
	        }
	
	        if (config.arrowTagName) {
	            var arrow = d.createElement(config.arrowTagName);
	            addClassNames(arrow, config.arrowClassNames);
	            addAttributes(arrow, config.arrowAttributes);
	            popper.appendChild(arrow);
	        }
	
	        var parent = config.parent.jquery ? config.parent[0] : config.parent;
	
	        // if the given parent is a string, use it to match an element
	        // if more than one element is matched, the first one will be used as parent
	        // if no elements are matched, the script will throw an error
	        if (typeof parent === 'string') {
	            parent = d.querySelectorAll(config.parent);
	            if (parent.length > 1) {
	                console.warn('WARNING: the given `parent` query(' + config.parent + ') matched more than one element, the first one will be used');
	            }
	            if (parent.length === 0) {
	                throw 'ERROR: the given `parent` doesn\'t exists!';
	            }
	            parent = parent[0];
	        }
	        // if the given parent is a DOM nodes list or an array of nodes with more than one element,
	        // the first one will be used as parent
	        if (parent.length > 1 && parent instanceof Element === false) {
	            console.warn('WARNING: you have passed as parent a list of elements, the first one will be used');
	            parent = parent[0];
	        }
	
	        // append the generated popper to its parent
	        parent.appendChild(popper);
	
	        return popper;
	
	        /**
	         * Adds class names to the given element
	         * @function
	         * @ignore
	         * @param {HTMLElement} target
	         * @param {Array} classes
	         */
	        function addClassNames(element, classNames) {
	            classNames.forEach(function (className) {
	                element.classList.add(className);
	            });
	        }
	
	        /**
	         * Adds attributes to the given element
	         * @function
	         * @ignore
	         * @param {HTMLElement} target
	         * @param {Array} attributes
	         * @example
	         * addAttributes(element, [ 'data-info:foobar' ]);
	         */
	        function addAttributes(element, attributes) {
	            attributes.forEach(function (attribute) {
	                element.setAttribute(attribute.split(':')[0], attribute.split(':')[1] || '');
	            });
	        }
	    };
	
	    /**
	     * Helper used to get the position which will be applied to the popper
	     * @method
	     * @memberof Popper
	     * @param config {HTMLElement} popper element
	     * @param reference {HTMLElement} reference element
	     * @returns {String} position
	     */
	    Popper.prototype._getPosition = function (popper, reference) {
	        var container = getOffsetParent(reference);
	
	        if (this._options.forceAbsolute) {
	            return 'absolute';
	        }
	
	        // Decide if the popper will be fixed
	        // If the reference element is inside a fixed context, the popper will be fixed as well to allow them to scroll together
	        var isParentFixed = isFixed(reference, container);
	        return isParentFixed ? 'fixed' : 'absolute';
	    };
	
	    /**
	     * Get offsets to the popper
	     * @method
	     * @memberof Popper
	     * @access private
	     * @param {Element} popper - the popper element
	     * @param {Element} reference - the reference element (the popper will be relative to this)
	     * @returns {Object} An object containing the offsets which will be applied to the popper
	     */
	    Popper.prototype._getOffsets = function (popper, reference, placement) {
	        placement = placement.split('-')[0];
	        var popperOffsets = {};
	
	        popperOffsets.position = this.state.position;
	        var isParentFixed = popperOffsets.position === 'fixed';
	
	        //
	        // Get reference element position
	        //
	        var referenceOffsets = getOffsetRectRelativeToCustomParent(reference, getOffsetParent(popper), isParentFixed);
	
	        //
	        // Get popper sizes
	        //
	        var popperRect = getOuterSizes(popper);
	
	        //
	        // Compute offsets of popper
	        //
	
	        // depending by the popper placement we have to compute its offsets slightly differently
	        if (['right', 'left'].indexOf(placement) !== -1) {
	            popperOffsets.top = referenceOffsets.top + referenceOffsets.height / 2 - popperRect.height / 2;
	            if (placement === 'left') {
	                popperOffsets.left = referenceOffsets.left - popperRect.width;
	            } else {
	                popperOffsets.left = referenceOffsets.right;
	            }
	        } else {
	            popperOffsets.left = referenceOffsets.left + referenceOffsets.width / 2 - popperRect.width / 2;
	            if (placement === 'top') {
	                popperOffsets.top = referenceOffsets.top - popperRect.height;
	            } else {
	                popperOffsets.top = referenceOffsets.bottom;
	            }
	        }
	
	        // Add width and height to our offsets object
	        popperOffsets.width = popperRect.width;
	        popperOffsets.height = popperRect.height;
	
	        return {
	            popper: popperOffsets,
	            reference: referenceOffsets
	        };
	    };
	
	    /**
	     * Setup needed event listeners used to update the popper position
	     * @method
	     * @memberof Popper
	     * @access private
	     */
	    Popper.prototype._setupEventListeners = function () {
	        // NOTE: 1 DOM access here
	        this.state.updateBound = this.update.bind(this);
	        root.addEventListener('resize', this.state.updateBound);
	        // if the boundariesElement is window we don't need to listen for the scroll event
	        if (this._options.boundariesElement !== 'window') {
	            var target = getScrollParent(this._reference);
	            // here it could be both `body` or `documentElement` thanks to Firefox, we then check both
	            if (target === root.document.body || target === root.document.documentElement) {
	                target = root;
	            }
	            target.addEventListener('scroll', this.state.updateBound);
	            this.state.scrollTarget = target;
	        }
	    };
	
	    /**
	     * Remove event listeners used to update the popper position
	     * @method
	     * @memberof Popper
	     * @access private
	     */
	    Popper.prototype._removeEventListeners = function () {
	        // NOTE: 1 DOM access here
	        root.removeEventListener('resize', this.state.updateBound);
	        if (this._options.boundariesElement !== 'window' && this.state.scrollTarget) {
	            this.state.scrollTarget.removeEventListener('scroll', this.state.updateBound);
	            this.state.scrollTarget = null;
	        }
	        this.state.updateBound = null;
	    };
	
	    /**
	     * Computed the boundaries limits and return them
	     * @method
	     * @memberof Popper
	     * @access private
	     * @param {Object} data - Object containing the property "offsets" generated by `_getOffsets`
	     * @param {Number} padding - Boundaries padding
	     * @param {Element} boundariesElement - Element used to define the boundaries
	     * @returns {Object} Coordinates of the boundaries
	     */
	    Popper.prototype._getBoundaries = function (data, padding, boundariesElement) {
	        // NOTE: 1 DOM access here
	        var boundaries = {};
	        var width, height;
	        if (boundariesElement === 'window') {
	            var body = root.document.body,
	                html = root.document.documentElement;
	
	            height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
	            width = Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);
	
	            boundaries = {
	                top: 0,
	                right: width,
	                bottom: height,
	                left: 0
	            };
	        } else if (boundariesElement === 'viewport') {
	            var offsetParent = getOffsetParent(this._popper);
	            var scrollParent = getScrollParent(this._popper);
	            var offsetParentRect = getOffsetRect(offsetParent);
	
	            // Thanks the fucking native API, `document.body.scrollTop` & `document.documentElement.scrollTop`
	            var getScrollTopValue = function getScrollTopValue(element) {
	                return element == document.body ? Math.max(document.documentElement.scrollTop, document.body.scrollTop) : element.scrollTop;
	            };
	            var getScrollLeftValue = function getScrollLeftValue(element) {
	                return element == document.body ? Math.max(document.documentElement.scrollLeft, document.body.scrollLeft) : element.scrollLeft;
	            };
	
	            // if the popper is fixed we don't have to substract scrolling from the boundaries
	            var scrollTop = data.offsets.popper.position === 'fixed' ? 0 : getScrollTopValue(scrollParent);
	            var scrollLeft = data.offsets.popper.position === 'fixed' ? 0 : getScrollLeftValue(scrollParent);
	
	            boundaries = {
	                top: 0 - (offsetParentRect.top - scrollTop),
	                right: root.document.documentElement.clientWidth - (offsetParentRect.left - scrollLeft),
	                bottom: root.document.documentElement.clientHeight - (offsetParentRect.top - scrollTop),
	                left: 0 - (offsetParentRect.left - scrollLeft)
	            };
	        } else {
	            if (getOffsetParent(this._popper) === boundariesElement) {
	                boundaries = {
	                    top: 0,
	                    left: 0,
	                    right: boundariesElement.clientWidth,
	                    bottom: boundariesElement.clientHeight
	                };
	            } else {
	                boundaries = getOffsetRect(boundariesElement);
	            }
	        }
	        boundaries.left += padding;
	        boundaries.right -= padding;
	        boundaries.top = boundaries.top + padding;
	        boundaries.bottom = boundaries.bottom - padding;
	        return boundaries;
	    };
	
	    /**
	     * Loop trough the list of modifiers and run them in order, each of them will then edit the data object
	     * @method
	     * @memberof Popper
	     * @access public
	     * @param {Object} data
	     * @param {Array} modifiers
	     * @param {Function} ends
	     */
	    Popper.prototype.runModifiers = function (data, modifiers, ends) {
	        var modifiersToRun = modifiers.slice();
	        if (ends !== undefined) {
	            modifiersToRun = this._options.modifiers.slice(0, getArrayKeyIndex(this._options.modifiers, ends));
	        }
	
	        modifiersToRun.forEach(function (modifier) {
	            if (isFunction(modifier)) {
	                data = modifier.call(this, data);
	            }
	        }.bind(this));
	
	        return data;
	    };
	
	    /**
	     * Helper used to know if the given modifier depends from another one.
	     * @method
	     * @memberof Popper
	     * @param {String} requesting - name of requesting modifier
	     * @param {String} requested - name of requested modifier
	     * @returns {Boolean}
	     */
	    Popper.prototype.isModifierRequired = function (requesting, requested) {
	        var index = getArrayKeyIndex(this._options.modifiers, requesting);
	        return !!this._options.modifiers.slice(0, index).filter(function (modifier) {
	            return modifier === requested;
	        }).length;
	    };
	
	    //
	    // Modifiers
	    //
	
	    /**
	     * Modifiers list
	     * @namespace Popper.modifiers
	     * @memberof Popper
	     * @type {Object}
	     */
	    Popper.prototype.modifiers = {};
	
	    /**
	     * Apply the computed styles to the popper element
	     * @method
	     * @memberof Popper.modifiers
	     * @argument {Object} data - The data object generated by `update` method
	     * @returns {Object} The same data object
	     */
	    Popper.prototype.modifiers.applyStyle = function (data) {
	        // apply the final offsets to the popper
	        // NOTE: 1 DOM access here
	        var styles = {
	            position: data.offsets.popper.position
	        };
	
	        // round top and left to avoid blurry text
	        var left = Math.round(data.offsets.popper.left);
	        var top = Math.round(data.offsets.popper.top);
	
	        // if gpuAcceleration is set to true and transform is supported, we use `translate3d` to apply the position to the popper
	        // we automatically use the supported prefixed version if needed
	        var prefixedProperty;
	        if (this._options.gpuAcceleration && (prefixedProperty = getSupportedPropertyName('transform'))) {
	            styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	            styles.top = 0;
	            styles.left = 0;
	        }
	        // othwerise, we use the standard `left` and `top` properties
	        else {
	                styles.left = left;
	                styles.top = top;
	            }
	
	        // any property present in `data.styles` will be applied to the popper,
	        // in this way we can make the 3rd party modifiers add custom styles to it
	        // Be aware, modifiers could override the properties defined in the previous
	        // lines of this modifier!
	        Object.assign(styles, data.styles);
	
	        setStyle(this._popper, styles);
	
	        // set an attribute which will be useful to style the tooltip (use it to properly position its arrow)
	        // NOTE: 1 DOM access here
	        this._popper.setAttribute('x-placement', data.placement);
	
	        // if the arrow modifier is required and the arrow style has been computed, apply the arrow style
	        if (this.isModifierRequired(this.modifiers.applyStyle, this.modifiers.arrow) && data.offsets.arrow) {
	            setStyle(data.arrowElement, data.offsets.arrow);
	        }
	
	        return data;
	    };
	
	    /**
	     * Modifier used to shift the popper on the start or end of its reference element side
	     * @method
	     * @memberof Popper.modifiers
	     * @argument {Object} data - The data object generated by `update` method
	     * @returns {Object} The data object, properly modified
	     */
	    Popper.prototype.modifiers.shift = function (data) {
	        var placement = data.placement;
	        var basePlacement = placement.split('-')[0];
	        var shiftVariation = placement.split('-')[1];
	
	        // if shift shiftVariation is specified, run the modifier
	        if (shiftVariation) {
	            var reference = data.offsets.reference;
	            var popper = getPopperClientRect(data.offsets.popper);
	
	            var shiftOffsets = {
	                y: {
	                    start: { top: reference.top },
	                    end: { top: reference.top + reference.height - popper.height }
	                },
	                x: {
	                    start: { left: reference.left },
	                    end: { left: reference.left + reference.width - popper.width }
	                }
	            };
	
	            var axis = ['bottom', 'top'].indexOf(basePlacement) !== -1 ? 'x' : 'y';
	
	            data.offsets.popper = Object.assign(popper, shiftOffsets[axis][shiftVariation]);
	        }
	
	        return data;
	    };
	
	    /**
	     * Modifier used to make sure the popper does not overflows from it's boundaries
	     * @method
	     * @memberof Popper.modifiers
	     * @argument {Object} data - The data object generated by `update` method
	     * @returns {Object} The data object, properly modified
	     */
	    Popper.prototype.modifiers.preventOverflow = function (data) {
	        var order = this._options.preventOverflowOrder;
	        var popper = getPopperClientRect(data.offsets.popper);
	
	        var check = {
	            left: function left() {
	                var left = popper.left;
	                if (popper.left < data.boundaries.left) {
	                    left = Math.max(popper.left, data.boundaries.left);
	                }
	                return { left: left };
	            },
	            right: function right() {
	                var left = popper.left;
	                if (popper.right > data.boundaries.right) {
	                    left = Math.min(popper.left, data.boundaries.right - popper.width);
	                }
	                return { left: left };
	            },
	            top: function top() {
	                var top = popper.top;
	                if (popper.top < data.boundaries.top) {
	                    top = Math.max(popper.top, data.boundaries.top);
	                }
	                return { top: top };
	            },
	            bottom: function bottom() {
	                var top = popper.top;
	                if (popper.bottom > data.boundaries.bottom) {
	                    top = Math.min(popper.top, data.boundaries.bottom - popper.height);
	                }
	                return { top: top };
	            }
	        };
	
	        order.forEach(function (direction) {
	            data.offsets.popper = Object.assign(popper, check[direction]());
	        });
	
	        return data;
	    };
	
	    /**
	     * Modifier used to make sure the popper is always near its reference
	     * @method
	     * @memberof Popper.modifiers
	     * @argument {Object} data - The data object generated by _update method
	     * @returns {Object} The data object, properly modified
	     */
	    Popper.prototype.modifiers.keepTogether = function (data) {
	        var popper = getPopperClientRect(data.offsets.popper);
	        var reference = data.offsets.reference;
	        var f = Math.floor;
	
	        if (popper.right < f(reference.left)) {
	            data.offsets.popper.left = f(reference.left) - popper.width;
	        }
	        if (popper.left > f(reference.right)) {
	            data.offsets.popper.left = f(reference.right);
	        }
	        if (popper.bottom < f(reference.top)) {
	            data.offsets.popper.top = f(reference.top) - popper.height;
	        }
	        if (popper.top > f(reference.bottom)) {
	            data.offsets.popper.top = f(reference.bottom);
	        }
	
	        return data;
	    };
	
	    /**
	     * Modifier used to flip the placement of the popper when the latter is starting overlapping its reference element.
	     * Requires the `preventOverflow` modifier before it in order to work.
	     * **NOTE:** This modifier will run all its previous modifiers everytime it tries to flip the popper!
	     * @method
	     * @memberof Popper.modifiers
	     * @argument {Object} data - The data object generated by _update method
	     * @returns {Object} The data object, properly modified
	     */
	    Popper.prototype.modifiers.flip = function (data) {
	        // check if preventOverflow is in the list of modifiers before the flip modifier.
	        // otherwise flip would not work as expected.
	        if (!this.isModifierRequired(this.modifiers.flip, this.modifiers.preventOverflow)) {
	            console.warn('WARNING: preventOverflow modifier is required by flip modifier in order to work, be sure to include it before flip!');
	            return data;
	        }
	
	        if (data.flipped && data.placement === data._originalPlacement) {
	            // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
	            return data;
	        }
	
	        var placement = data.placement.split('-')[0];
	        var placementOpposite = getOppositePlacement(placement);
	        var variation = data.placement.split('-')[1] || '';
	
	        var flipOrder = [];
	        if (this._options.flipBehavior === 'flip') {
	            flipOrder = [placement, placementOpposite];
	        } else {
	            flipOrder = this._options.flipBehavior;
	        }
	
	        flipOrder.forEach(function (step, index) {
	            if (placement !== step || flipOrder.length === index + 1) {
	                return;
	            }
	
	            placement = data.placement.split('-')[0];
	            placementOpposite = getOppositePlacement(placement);
	
	            var popperOffsets = getPopperClientRect(data.offsets.popper);
	
	            // this boolean is used to distinguish right and bottom from top and left
	            // they need different computations to get flipped
	            var a = ['right', 'bottom'].indexOf(placement) !== -1;
	
	            // using Math.floor because the reference offsets may contain decimals we are not going to consider here
	            if (a && Math.floor(data.offsets.reference[placement]) > Math.floor(popperOffsets[placementOpposite]) || !a && Math.floor(data.offsets.reference[placement]) < Math.floor(popperOffsets[placementOpposite])) {
	                // we'll use this boolean to detect any flip loop
	                data.flipped = true;
	                data.placement = flipOrder[index + 1];
	                if (variation) {
	                    data.placement += '-' + variation;
	                }
	                data.offsets.popper = this._getOffsets(this._popper, this._reference, data.placement).popper;
	
	                data = this.runModifiers(data, this._options.modifiers, this._flip);
	            }
	        }.bind(this));
	        return data;
	    };
	
	    /**
	     * Modifier used to add an offset to the popper, useful if you more granularity positioning your popper.
	     * The offsets will shift the popper on the side of its reference element.
	     * @method
	     * @memberof Popper.modifiers
	     * @argument {Object} data - The data object generated by _update method
	     * @returns {Object} The data object, properly modified
	     */
	    Popper.prototype.modifiers.offset = function (data) {
	        var offset = this._options.offset;
	        var popper = data.offsets.popper;
	
	        if (data.placement.indexOf('left') !== -1) {
	            popper.top -= offset;
	        } else if (data.placement.indexOf('right') !== -1) {
	            popper.top += offset;
	        } else if (data.placement.indexOf('top') !== -1) {
	            popper.left -= offset;
	        } else if (data.placement.indexOf('bottom') !== -1) {
	            popper.left += offset;
	        }
	        return data;
	    };
	
	    /**
	     * Modifier used to move the arrows on the edge of the popper to make sure them are always between the popper and the reference element
	     * It will use the CSS outer size of the arrow element to know how many pixels of conjuction are needed
	     * @method
	     * @memberof Popper.modifiers
	     * @argument {Object} data - The data object generated by _update method
	     * @returns {Object} The data object, properly modified
	     */
	    Popper.prototype.modifiers.arrow = function (data) {
	        var arrow = this._options.arrowElement;
	        var arrowOffset = this._options.arrowOffset;
	
	        // if the arrowElement is a string, suppose it's a CSS selector
	        if (typeof arrow === 'string') {
	            arrow = this._popper.querySelector(arrow);
	        }
	
	        // if arrow element is not found, don't run the modifier
	        if (!arrow) {
	            return data;
	        }
	
	        // the arrow element must be child of its popper
	        if (!this._popper.contains(arrow)) {
	            console.warn('WARNING: `arrowElement` must be child of its popper element!');
	            return data;
	        }
	
	        // arrow depends on keepTogether in order to work
	        if (!this.isModifierRequired(this.modifiers.arrow, this.modifiers.keepTogether)) {
	            console.warn('WARNING: keepTogether modifier is required by arrow modifier in order to work, be sure to include it before arrow!');
	            return data;
	        }
	
	        var arrowStyle = {};
	        var placement = data.placement.split('-')[0];
	        var popper = getPopperClientRect(data.offsets.popper);
	        var reference = data.offsets.reference;
	        var isVertical = ['left', 'right'].indexOf(placement) !== -1;
	
	        var len = isVertical ? 'height' : 'width';
	        var side = isVertical ? 'top' : 'left';
	        var translate = isVertical ? 'translateY' : 'translateX';
	        var altSide = isVertical ? 'left' : 'top';
	        var opSide = isVertical ? 'bottom' : 'right';
	        var arrowSize = getOuterSizes(arrow)[len];
	
	        //
	        // extends keepTogether behavior making sure the popper and its reference have enough pixels in conjuction
	        //
	
	        // top/left side
	        if (reference[opSide] - arrowSize < popper[side]) {
	            data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowSize);
	        }
	        // bottom/right side
	        if (reference[side] + arrowSize > popper[opSide]) {
	            data.offsets.popper[side] += reference[side] + arrowSize - popper[opSide];
	        }
	
	        // compute center of the popper
	        var center = reference[side] + (arrowOffset || reference[len] / 2 - arrowSize / 2);
	
	        var sideValue = center - popper[side];
	
	        // prevent arrow from being placed not contiguously to its popper
	        sideValue = Math.max(Math.min(popper[len] - arrowSize - 8, sideValue), 8);
	        arrowStyle[side] = sideValue;
	        arrowStyle[altSide] = ''; // make sure to remove any old style from the arrow
	
	        data.offsets.arrow = arrowStyle;
	        data.arrowElement = arrow;
	
	        return data;
	    };
	
	    //
	    // Helpers
	    //
	
	    /**
	     * Get the outer sizes of the given element (offset size + margins)
	     * @function
	     * @ignore
	     * @argument {Element} element
	     * @returns {Object} object containing width and height properties
	     */
	    function getOuterSizes(element) {
	        // NOTE: 1 DOM access here
	        var _display = element.style.display,
	            _visibility = element.style.visibility;
	        element.style.display = 'block';element.style.visibility = 'hidden';
	        var calcWidthToForceRepaint = element.offsetWidth;
	
	        // original method
	        var styles = root.getComputedStyle(element);
	        var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
	        var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
	        var result = { width: element.offsetWidth + y, height: element.offsetHeight + x };
	
	        // reset element styles
	        element.style.display = _display;element.style.visibility = _visibility;
	        return result;
	    }
	
	    /**
	     * Get the opposite placement of the given one/
	     * @function
	     * @ignore
	     * @argument {String} placement
	     * @returns {String} flipped placement
	     */
	    function getOppositePlacement(placement) {
	        var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
	        return placement.replace(/left|right|bottom|top/g, function (matched) {
	            return hash[matched];
	        });
	    }
	
	    /**
	     * Given the popper offsets, generate an output similar to getBoundingClientRect
	     * @function
	     * @ignore
	     * @argument {Object} popperOffsets
	     * @returns {Object} ClientRect like output
	     */
	    function getPopperClientRect(popperOffsets) {
	        var offsets = Object.assign({}, popperOffsets);
	        offsets.right = offsets.left + offsets.width;
	        offsets.bottom = offsets.top + offsets.height;
	        return offsets;
	    }
	
	    /**
	     * Given an array and the key to find, returns its index
	     * @function
	     * @ignore
	     * @argument {Array} arr
	     * @argument keyToFind
	     * @returns index or null
	     */
	    function getArrayKeyIndex(arr, keyToFind) {
	        var i = 0,
	            key;
	        for (key in arr) {
	            if (arr[key] === keyToFind) {
	                return i;
	            }
	            i++;
	        }
	        return null;
	    }
	
	    /**
	     * Get CSS computed property of the given element
	     * @function
	     * @ignore
	     * @argument {Eement} element
	     * @argument {String} property
	     */
	    function getStyleComputedProperty(element, property) {
	        // NOTE: 1 DOM access here
	        var css = root.getComputedStyle(element, null);
	        return css[property];
	    }
	
	    /**
	     * Returns the offset parent of the given element
	     * @function
	     * @ignore
	     * @argument {Element} element
	     * @returns {Element} offset parent
	     */
	    function getOffsetParent(element) {
	        // NOTE: 1 DOM access here
	        var offsetParent = element.offsetParent;
	        return offsetParent === root.document.body || !offsetParent ? root.document.documentElement : offsetParent;
	    }
	
	    /**
	     * Returns the scrolling parent of the given element
	     * @function
	     * @ignore
	     * @argument {Element} element
	     * @returns {Element} offset parent
	     */
	    function getScrollParent(element) {
	        var parent = element.parentNode;
	
	        if (!parent) {
	            return element;
	        }
	
	        if (parent === root.document) {
	            // Firefox puts the scrollTOp value on `documentElement` instead of `body`, we then check which of them is
	            // greater than 0 and return the proper element
	            if (root.document.body.scrollTop || root.document.body.scrollLeft) {
	                return root.document.body;
	            } else {
	                return root.document.documentElement;
	            }
	        }
	
	        // Firefox want us to check `-x` and `-y` variations as well
	        if (['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow')) !== -1 || ['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow-x')) !== -1 || ['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow-y')) !== -1) {
	            // If the detected scrollParent is body, we perform an additional check on its parentNode
	            // in this way we'll get body if the browser is Chrome-ish, or documentElement otherwise
	            // fixes issue #65
	            return parent;
	        }
	        return getScrollParent(element.parentNode);
	    }
	
	    /**
	     * Check if the given element is fixed or is inside a fixed parent
	     * @function
	     * @ignore
	     * @argument {Element} element
	     * @argument {Element} customContainer
	     * @returns {Boolean} answer to "isFixed?"
	     */
	    function isFixed(element) {
	        if (element === root.document.body) {
	            return false;
	        }
	        if (getStyleComputedProperty(element, 'position') === 'fixed') {
	            return true;
	        }
	        return element.parentNode ? isFixed(element.parentNode) : element;
	    }
	
	    /**
	     * Set the style to the given popper
	     * @function
	     * @ignore
	     * @argument {Element} element - Element to apply the style to
	     * @argument {Object} styles - Object with a list of properties and values which will be applied to the element
	     */
	    function setStyle(element, styles) {
	        function is_numeric(n) {
	            return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
	        }
	        Object.keys(styles).forEach(function (prop) {
	            var unit = '';
	            // add unit if the value is numeric and is one of the following
	            if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && is_numeric(styles[prop])) {
	                unit = 'px';
	            }
	            element.style[prop] = styles[prop] + unit;
	        });
	    }
	
	    /**
	     * Check if the given variable is a function
	     * @function
	     * @ignore
	     * @argument {*} functionToCheck - variable to check
	     * @returns {Boolean} answer to: is a function?
	     */
	    function isFunction(functionToCheck) {
	        var getType = {};
	        return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	    }
	
	    /**
	     * Get the position of the given element, relative to its offset parent
	     * @function
	     * @ignore
	     * @param {Element} element
	     * @return {Object} position - Coordinates of the element and its `scrollTop`
	     */
	    function getOffsetRect(element) {
	        var elementRect = {
	            width: element.offsetWidth,
	            height: element.offsetHeight,
	            left: element.offsetLeft,
	            top: element.offsetTop
	        };
	
	        elementRect.right = elementRect.left + elementRect.width;
	        elementRect.bottom = elementRect.top + elementRect.height;
	
	        // position
	        return elementRect;
	    }
	
	    /**
	     * Get bounding client rect of given element
	     * @function
	     * @ignore
	     * @param {HTMLElement} element
	     * @return {Object} client rect
	     */
	    function getBoundingClientRect(element) {
	        var rect = element.getBoundingClientRect();
	
	        // whether the IE version is lower than 11
	        var isIE = navigator.userAgent.indexOf("MSIE") != -1;
	
	        // fix ie document bounding top always 0 bug
	        var rectTop = isIE && element.tagName === 'HTML' ? -element.scrollTop : rect.top;
	
	        return {
	            left: rect.left,
	            top: rectTop,
	            right: rect.right,
	            bottom: rect.bottom,
	            width: rect.right - rect.left,
	            height: rect.bottom - rectTop
	        };
	    }
	
	    /**
	     * Given an element and one of its parents, return the offset
	     * @function
	     * @ignore
	     * @param {HTMLElement} element
	     * @param {HTMLElement} parent
	     * @return {Object} rect
	     */
	    function getOffsetRectRelativeToCustomParent(element, parent, fixed) {
	        var elementRect = getBoundingClientRect(element);
	        var parentRect = getBoundingClientRect(parent);
	
	        if (fixed) {
	            var scrollParent = getScrollParent(parent);
	            parentRect.top += scrollParent.scrollTop;
	            parentRect.bottom += scrollParent.scrollTop;
	            parentRect.left += scrollParent.scrollLeft;
	            parentRect.right += scrollParent.scrollLeft;
	        }
	
	        var rect = {
	            top: elementRect.top - parentRect.top,
	            left: elementRect.left - parentRect.left,
	            bottom: elementRect.top - parentRect.top + elementRect.height,
	            right: elementRect.left - parentRect.left + elementRect.width,
	            width: elementRect.width,
	            height: elementRect.height
	        };
	        return rect;
	    }
	
	    /**
	     * Get the prefixed supported property name
	     * @function
	     * @ignore
	     * @argument {String} property (camelCase)
	     * @returns {String} prefixed property (camelCase)
	     */
	    function getSupportedPropertyName(property) {
	        var prefixes = ['', 'ms', 'webkit', 'moz', 'o'];
	
	        for (var i = 0; i < prefixes.length; i++) {
	            var toCheck = prefixes[i] ? prefixes[i] + property.charAt(0).toUpperCase() + property.slice(1) : property;
	            if (typeof root.document.body.style[toCheck] !== 'undefined') {
	                return toCheck;
	            }
	        }
	        return null;
	    }
	
	    /**
	     * The Object.assign() method is used to copy the values of all enumerable own properties from one or more source
	     * objects to a target object. It will return the target object.
	     * This polyfill doesn't support symbol properties, since ES5 doesn't have symbols anyway
	     * Source: https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
	     * @function
	     * @ignore
	     */
	    if (!Object.assign) {
	        Object.defineProperty(Object, 'assign', {
	            enumerable: false,
	            configurable: true,
	            writable: true,
	            value: function value(target) {
	                if (target === undefined || target === null) {
	                    throw new TypeError('Cannot convert first argument to object');
	                }
	
	                var to = Object(target);
	                for (var i = 1; i < arguments.length; i++) {
	                    var nextSource = arguments[i];
	                    if (nextSource === undefined || nextSource === null) {
	                        continue;
	                    }
	                    nextSource = Object(nextSource);
	
	                    var keysArray = Object.keys(nextSource);
	                    for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
	                        var nextKey = keysArray[nextIndex];
	                        var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
	                        if (desc !== undefined && desc.enumerable) {
	                            to[nextKey] = nextSource[nextKey];
	                        }
	                    }
	                }
	                return to;
	            }
	        });
	    }
	
	    return Popper;
	});

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _vue = __webpack_require__(3);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _dom = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hasModal = false;
	var hasInitZIndex = false;
	var zIndex = void 0;
	
	var getModal = function getModal() {
	  if (_vue2.default.prototype.$isServer) return;
	  var modalDom = PopupManager.modalDom;
	  if (modalDom) {
	    hasModal = true;
	  } else {
	    hasModal = false;
	    modalDom = document.createElement('div');
	    PopupManager.modalDom = modalDom;
	
	    modalDom.addEventListener('touchmove', function (event) {
	      event.preventDefault();
	      event.stopPropagation();
	    });
	
	    modalDom.addEventListener('click', function () {
	      PopupManager.doOnModalClick && PopupManager.doOnModalClick();
	    });
	  }
	
	  return modalDom;
	};
	
	var instances = {};
	
	var PopupManager = {
	  modalFade: true,
	
	  getInstance: function getInstance(id) {
	    return instances[id];
	  },
	
	  register: function register(id, instance) {
	    if (id && instance) {
	      instances[id] = instance;
	    }
	  },
	
	  deregister: function deregister(id) {
	    if (id) {
	      instances[id] = null;
	      delete instances[id];
	    }
	  },
	
	  nextZIndex: function nextZIndex() {
	    return PopupManager.zIndex++;
	  },
	
	  modalStack: [],
	
	  doOnModalClick: function doOnModalClick() {
	    var topItem = PopupManager.modalStack[PopupManager.modalStack.length - 1];
	    if (!topItem) return;
	
	    var instance = PopupManager.getInstance(topItem.id);
	    if (instance && instance.closeOnClickModal) {
	      instance.close();
	    }
	  },
	
	  openModal: function openModal(id, zIndex, dom, modalClass, modalFade) {
	    if (_vue2.default.prototype.$isServer) return;
	    if (!id || zIndex === undefined) return;
	    this.modalFade = modalFade;
	
	    var modalStack = this.modalStack;
	
	    for (var i = 0, j = modalStack.length; i < j; i++) {
	      var item = modalStack[i];
	      if (item.id === id) {
	        return;
	      }
	    }
	
	    var modalDom = getModal();
	
	    (0, _dom.addClass)(modalDom, 'v-modal');
	    if (this.modalFade && !hasModal) {
	      (0, _dom.addClass)(modalDom, 'v-modal-enter');
	    }
	    if (modalClass) {
	      var classArr = modalClass.trim().split(/\s+/);
	      classArr.forEach(function (item) {
	        return (0, _dom.addClass)(modalDom, item);
	      });
	    }
	    setTimeout(function () {
	      (0, _dom.removeClass)(modalDom, 'v-modal-enter');
	    }, 200);
	
	    if (dom && dom.parentNode && dom.parentNode.nodeType !== 11) {
	      dom.parentNode.appendChild(modalDom);
	    } else {
	      document.body.appendChild(modalDom);
	    }
	
	    if (zIndex) {
	      modalDom.style.zIndex = zIndex;
	    }
	    modalDom.tabIndex = 0;
	    modalDom.style.display = '';
	
	    this.modalStack.push({ id: id, zIndex: zIndex, modalClass: modalClass });
	  },
	
	  closeModal: function closeModal(id) {
	    var modalStack = this.modalStack;
	    var modalDom = getModal();
	
	    if (modalStack.length > 0) {
	      var topItem = modalStack[modalStack.length - 1];
	      if (topItem.id === id) {
	        if (topItem.modalClass) {
	          var classArr = topItem.modalClass.trim().split(/\s+/);
	          classArr.forEach(function (item) {
	            return (0, _dom.removeClass)(modalDom, item);
	          });
	        }
	
	        modalStack.pop();
	        if (modalStack.length > 0) {
	          modalDom.style.zIndex = modalStack[modalStack.length - 1].zIndex;
	        }
	      } else {
	        for (var i = modalStack.length - 1; i >= 0; i--) {
	          if (modalStack[i].id === id) {
	            modalStack.splice(i, 1);
	            break;
	          }
	        }
	      }
	    }
	
	    if (modalStack.length === 0) {
	      if (this.modalFade) {
	        (0, _dom.addClass)(modalDom, 'v-modal-leave');
	      }
	      setTimeout(function () {
	        if (modalStack.length === 0) {
	          if (modalDom.parentNode) modalDom.parentNode.removeChild(modalDom);
	          modalDom.style.display = 'none';
	          PopupManager.modalDom = undefined;
	        }
	        (0, _dom.removeClass)(modalDom, 'v-modal-leave');
	      }, 200);
	    }
	  }
	};
	
	Object.defineProperty(PopupManager, 'zIndex', {
	  configurable: true,
	  get: function get() {
	    if (!hasInitZIndex) {
	      zIndex = zIndex || (_vue2.default.prototype.$ELEMENT || {}).zIndex || 2000;
	      hasInitZIndex = true;
	    }
	    return zIndex;
	  },
	  set: function set(value) {
	    zIndex = value;
	  }
	});
	
	var getTopPopup = function getTopPopup() {
	  if (_vue2.default.prototype.$isServer) return;
	  if (PopupManager.modalStack.length > 0) {
	    var topPopup = PopupManager.modalStack[PopupManager.modalStack.length - 1];
	    if (!topPopup) return;
	    var instance = PopupManager.getInstance(topPopup.id);
	
	    return instance;
	  }
	};
	
	if (!_vue2.default.prototype.$isServer) {
	  // handle `esc` key when the popup is shown
	  window.addEventListener('keydown', function (event) {
	    if (event.keyCode === 27) {
	      var topPopup = getTopPopup();
	
	      if (topPopup && topPopup.closeOnPressEscape) {
	        topPopup.handleClose ? topPopup.handleClose() : topPopup.handleAction ? topPopup.handleAction('cancel') : topPopup.close();
	      }
	    }
	  });
	}
	
	exports.default = PopupManager;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.isVNode = isVNode;
	
	var _util = __webpack_require__(15);
	
	function isVNode(node) {
	  return node !== null && (typeof node === 'undefined' ? 'undefined' : _typeof(node)) === 'object' && (0, _util.hasOwn)(node, 'componentOptions');
	};

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(483);


/***/ }),
/* 480 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ExecutionEnvironment
	 */
	
	/*jslint evil: true */
	
	'use strict';
	
	var canUseDOM = !!(
	  typeof window !== 'undefined' &&
	  window.document &&
	  window.document.createElement
	);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners:
	    canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;


/***/ }),
/* 481 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2004-present Facebook. All Rights Reserved.
	 *
	 * @providesModule UserAgent_DEPRECATED
	 */
	
	/**
	 *  Provides entirely client-side User Agent and OS detection. You should prefer
	 *  the non-deprecated UserAgent module when possible, which exposes our
	 *  authoritative server-side PHP-based detection to the client.
	 *
	 *  Usage is straightforward:
	 *
	 *    if (UserAgent_DEPRECATED.ie()) {
	 *      //  IE
	 *    }
	 *
	 *  You can also do version checks:
	 *
	 *    if (UserAgent_DEPRECATED.ie() >= 7) {
	 *      //  IE7 or better
	 *    }
	 *
	 *  The browser functions will return NaN if the browser does not match, so
	 *  you can also do version compares the other way:
	 *
	 *    if (UserAgent_DEPRECATED.ie() < 7) {
	 *      //  IE6 or worse
	 *    }
	 *
	 *  Note that the version is a float and may include a minor version number,
	 *  so you should always use range operators to perform comparisons, not
	 *  strict equality.
	 *
	 *  **Note:** You should **strongly** prefer capability detection to browser
	 *  version detection where it's reasonable:
	 *
	 *    http://www.quirksmode.org/js/support.html
	 *
	 *  Further, we have a large number of mature wrapper functions and classes
	 *  which abstract away many browser irregularities. Check the documentation,
	 *  grep for things, or ask on javascript@lists.facebook.com before writing yet
	 *  another copy of "event || window.event".
	 *
	 */
	
	var _populated = false;
	
	// Browsers
	var _ie, _firefox, _opera, _webkit, _chrome;
	
	// Actual IE browser for compatibility mode
	var _ie_real_version;
	
	// Platforms
	var _osx, _windows, _linux, _android;
	
	// Architectures
	var _win64;
	
	// Devices
	var _iphone, _ipad, _native;
	
	var _mobile;
	
	function _populate() {
	  if (_populated) {
	    return;
	  }
	
	  _populated = true;
	
	  // To work around buggy JS libraries that can't handle multi-digit
	  // version numbers, Opera 10's user agent string claims it's Opera
	  // 9, then later includes a Version/X.Y field:
	  //
	  // Opera/9.80 (foo) Presto/2.2.15 Version/10.10
	  var uas = navigator.userAgent;
	  var agent = /(?:MSIE.(\d+\.\d+))|(?:(?:Firefox|GranParadiso|Iceweasel).(\d+\.\d+))|(?:Opera(?:.+Version.|.)(\d+\.\d+))|(?:AppleWebKit.(\d+(?:\.\d+)?))|(?:Trident\/\d+\.\d+.*rv:(\d+\.\d+))/.exec(uas);
	  var os    = /(Mac OS X)|(Windows)|(Linux)/.exec(uas);
	
	  _iphone = /\b(iPhone|iP[ao]d)/.exec(uas);
	  _ipad = /\b(iP[ao]d)/.exec(uas);
	  _android = /Android/i.exec(uas);
	  _native = /FBAN\/\w+;/i.exec(uas);
	  _mobile = /Mobile/i.exec(uas);
	
	  // Note that the IE team blog would have you believe you should be checking
	  // for 'Win64; x64'.  But MSDN then reveals that you can actually be coming
	  // from either x64 or ia64;  so ultimately, you should just check for Win64
	  // as in indicator of whether you're in 64-bit IE.  32-bit IE on 64-bit
	  // Windows will send 'WOW64' instead.
	  _win64 = !!(/Win64/.exec(uas));
	
	  if (agent) {
	    _ie = agent[1] ? parseFloat(agent[1]) : (
	          agent[5] ? parseFloat(agent[5]) : NaN);
	    // IE compatibility mode
	    if (_ie && document && document.documentMode) {
	      _ie = document.documentMode;
	    }
	    // grab the "true" ie version from the trident token if available
	    var trident = /(?:Trident\/(\d+.\d+))/.exec(uas);
	    _ie_real_version = trident ? parseFloat(trident[1]) + 4 : _ie;
	
	    _firefox = agent[2] ? parseFloat(agent[2]) : NaN;
	    _opera   = agent[3] ? parseFloat(agent[3]) : NaN;
	    _webkit  = agent[4] ? parseFloat(agent[4]) : NaN;
	    if (_webkit) {
	      // We do not add the regexp to the above test, because it will always
	      // match 'safari' only since 'AppleWebKit' appears before 'Chrome' in
	      // the userAgent string.
	      agent = /(?:Chrome\/(\d+\.\d+))/.exec(uas);
	      _chrome = agent && agent[1] ? parseFloat(agent[1]) : NaN;
	    } else {
	      _chrome = NaN;
	    }
	  } else {
	    _ie = _firefox = _opera = _chrome = _webkit = NaN;
	  }
	
	  if (os) {
	    if (os[1]) {
	      // Detect OS X version.  If no version number matches, set _osx to true.
	      // Version examples:  10, 10_6_1, 10.7
	      // Parses version number as a float, taking only first two sets of
	      // digits.  If only one set of digits is found, returns just the major
	      // version number.
	      var ver = /(?:Mac OS X (\d+(?:[._]\d+)?))/.exec(uas);
	
	      _osx = ver ? parseFloat(ver[1].replace('_', '.')) : true;
	    } else {
	      _osx = false;
	    }
	    _windows = !!os[2];
	    _linux   = !!os[3];
	  } else {
	    _osx = _windows = _linux = false;
	  }
	}
	
	var UserAgent_DEPRECATED = {
	
	  /**
	   *  Check if the UA is Internet Explorer.
	   *
	   *
	   *  @return float|NaN Version number (if match) or NaN.
	   */
	  ie: function() {
	    return _populate() || _ie;
	  },
	
	  /**
	   * Check if we're in Internet Explorer compatibility mode.
	   *
	   * @return bool true if in compatibility mode, false if
	   * not compatibility mode or not ie
	   */
	  ieCompatibilityMode: function() {
	    return _populate() || (_ie_real_version > _ie);
	  },
	
	
	  /**
	   * Whether the browser is 64-bit IE.  Really, this is kind of weak sauce;  we
	   * only need this because Skype can't handle 64-bit IE yet.  We need to remove
	   * this when we don't need it -- tracked by #601957.
	   */
	  ie64: function() {
	    return UserAgent_DEPRECATED.ie() && _win64;
	  },
	
	  /**
	   *  Check if the UA is Firefox.
	   *
	   *
	   *  @return float|NaN Version number (if match) or NaN.
	   */
	  firefox: function() {
	    return _populate() || _firefox;
	  },
	
	
	  /**
	   *  Check if the UA is Opera.
	   *
	   *
	   *  @return float|NaN Version number (if match) or NaN.
	   */
	  opera: function() {
	    return _populate() || _opera;
	  },
	
	
	  /**
	   *  Check if the UA is WebKit.
	   *
	   *
	   *  @return float|NaN Version number (if match) or NaN.
	   */
	  webkit: function() {
	    return _populate() || _webkit;
	  },
	
	  /**
	   *  For Push
	   *  WILL BE REMOVED VERY SOON. Use UserAgent_DEPRECATED.webkit
	   */
	  safari: function() {
	    return UserAgent_DEPRECATED.webkit();
	  },
	
	  /**
	   *  Check if the UA is a Chrome browser.
	   *
	   *
	   *  @return float|NaN Version number (if match) or NaN.
	   */
	  chrome : function() {
	    return _populate() || _chrome;
	  },
	
	
	  /**
	   *  Check if the user is running Windows.
	   *
	   *  @return bool `true' if the user's OS is Windows.
	   */
	  windows: function() {
	    return _populate() || _windows;
	  },
	
	
	  /**
	   *  Check if the user is running Mac OS X.
	   *
	   *  @return float|bool   Returns a float if a version number is detected,
	   *                       otherwise true/false.
	   */
	  osx: function() {
	    return _populate() || _osx;
	  },
	
	  /**
	   * Check if the user is running Linux.
	   *
	   * @return bool `true' if the user's OS is some flavor of Linux.
	   */
	  linux: function() {
	    return _populate() || _linux;
	  },
	
	  /**
	   * Check if the user is running on an iPhone or iPod platform.
	   *
	   * @return bool `true' if the user is running some flavor of the
	   *    iPhone OS.
	   */
	  iphone: function() {
	    return _populate() || _iphone;
	  },
	
	  mobile: function() {
	    return _populate() || (_iphone || _ipad || _android || _mobile);
	  },
	
	  nativeApp: function() {
	    // webviews inside of the native apps
	    return _populate() || _native;
	  },
	
	  android: function() {
	    return _populate() || _android;
	  },
	
	  ipad: function() {
	    return _populate() || _ipad;
	  }
	};
	
	module.exports = UserAgent_DEPRECATED;


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isEventSupported
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(480);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature =
	    document.implementation &&
	    document.implementation.hasFeature &&
	    // always returns true in newer browsers as per the standard.
	    // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	    document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM ||
	      capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule normalizeWheel
	 * @typechecks
	 */
	
	'use strict';
	
	var UserAgent_DEPRECATED = __webpack_require__(481);
	
	var isEventSupported = __webpack_require__(482);
	
	
	// Reasonable defaults
	var PIXEL_STEP  = 10;
	var LINE_HEIGHT = 40;
	var PAGE_HEIGHT = 800;
	
	/**
	 * Mouse wheel (and 2-finger trackpad) support on the web sucks.  It is
	 * complicated, thus this doc is long and (hopefully) detailed enough to answer
	 * your questions.
	 *
	 * If you need to react to the mouse wheel in a predictable way, this code is
	 * like your bestest friend. * hugs *
	 *
	 * As of today, there are 4 DOM event types you can listen to:
	 *
	 *   'wheel'                -- Chrome(31+), FF(17+), IE(9+)
	 *   'mousewheel'           -- Chrome, IE(6+), Opera, Safari
	 *   'MozMousePixelScroll'  -- FF(3.5 only!) (2010-2013) -- don't bother!
	 *   'DOMMouseScroll'       -- FF(0.9.7+) since 2003
	 *
	 * So what to do?  The is the best:
	 *
	 *   normalizeWheel.getEventType();
	 *
	 * In your event callback, use this code to get sane interpretation of the
	 * deltas.  This code will return an object with properties:
	 *
	 *   spinX   -- normalized spin speed (use for zoom) - x plane
	 *   spinY   -- " - y plane
	 *   pixelX  -- normalized distance (to pixels) - x plane
	 *   pixelY  -- " - y plane
	 *
	 * Wheel values are provided by the browser assuming you are using the wheel to
	 * scroll a web page by a number of lines or pixels (or pages).  Values can vary
	 * significantly on different platforms and browsers, forgetting that you can
	 * scroll at different speeds.  Some devices (like trackpads) emit more events
	 * at smaller increments with fine granularity, and some emit massive jumps with
	 * linear speed or acceleration.
	 *
	 * This code does its best to normalize the deltas for you:
	 *
	 *   - spin is trying to normalize how far the wheel was spun (or trackpad
	 *     dragged).  This is super useful for zoom support where you want to
	 *     throw away the chunky scroll steps on the PC and make those equal to
	 *     the slow and smooth tiny steps on the Mac. Key data: This code tries to
	 *     resolve a single slow step on a wheel to 1.
	 *
	 *   - pixel is normalizing the desired scroll delta in pixel units.  You'll
	 *     get the crazy differences between browsers, but at least it'll be in
	 *     pixels!
	 *
	 *   - positive value indicates scrolling DOWN/RIGHT, negative UP/LEFT.  This
	 *     should translate to positive value zooming IN, negative zooming OUT.
	 *     This matches the newer 'wheel' event.
	 *
	 * Why are there spinX, spinY (or pixels)?
	 *
	 *   - spinX is a 2-finger side drag on the trackpad, and a shift + wheel turn
	 *     with a mouse.  It results in side-scrolling in the browser by default.
	 *
	 *   - spinY is what you expect -- it's the classic axis of a mouse wheel.
	 *
	 *   - I dropped spinZ/pixelZ.  It is supported by the DOM 3 'wheel' event and
	 *     probably is by browsers in conjunction with fancy 3D controllers .. but
	 *     you know.
	 *
	 * Implementation info:
	 *
	 * Examples of 'wheel' event if you scroll slowly (down) by one step with an
	 * average mouse:
	 *
	 *   OS X + Chrome  (mouse)     -    4   pixel delta  (wheelDelta -120)
	 *   OS X + Safari  (mouse)     -  N/A   pixel delta  (wheelDelta  -12)
	 *   OS X + Firefox (mouse)     -    0.1 line  delta  (wheelDelta  N/A)
	 *   Win8 + Chrome  (mouse)     -  100   pixel delta  (wheelDelta -120)
	 *   Win8 + Firefox (mouse)     -    3   line  delta  (wheelDelta -120)
	 *
	 * On the trackpad:
	 *
	 *   OS X + Chrome  (trackpad)  -    2   pixel delta  (wheelDelta   -6)
	 *   OS X + Firefox (trackpad)  -    1   pixel delta  (wheelDelta  N/A)
	 *
	 * On other/older browsers.. it's more complicated as there can be multiple and
	 * also missing delta values.
	 *
	 * The 'wheel' event is more standard:
	 *
	 * http://www.w3.org/TR/DOM-Level-3-Events/#events-wheelevents
	 *
	 * The basics is that it includes a unit, deltaMode (pixels, lines, pages), and
	 * deltaX, deltaY and deltaZ.  Some browsers provide other values to maintain
	 * backward compatibility with older events.  Those other values help us
	 * better normalize spin speed.  Example of what the browsers provide:
	 *
	 *                          | event.wheelDelta | event.detail
	 *        ------------------+------------------+--------------
	 *          Safari v5/OS X  |       -120       |       0
	 *          Safari v5/Win7  |       -120       |       0
	 *         Chrome v17/OS X  |       -120       |       0
	 *         Chrome v17/Win7  |       -120       |       0
	 *                IE9/Win7  |       -120       |   undefined
	 *         Firefox v4/OS X  |     undefined    |       1
	 *         Firefox v4/Win7  |     undefined    |       3
	 *
	 */
	function normalizeWheel(/*object*/ event) /*object*/ {
	  var sX = 0, sY = 0,       // spinX, spinY
	      pX = 0, pY = 0;       // pixelX, pixelY
	
	  // Legacy
	  if ('detail'      in event) { sY = event.detail; }
	  if ('wheelDelta'  in event) { sY = -event.wheelDelta / 120; }
	  if ('wheelDeltaY' in event) { sY = -event.wheelDeltaY / 120; }
	  if ('wheelDeltaX' in event) { sX = -event.wheelDeltaX / 120; }
	
	  // side scrolling on FF with DOMMouseScroll
	  if ( 'axis' in event && event.axis === event.HORIZONTAL_AXIS ) {
	    sX = sY;
	    sY = 0;
	  }
	
	  pX = sX * PIXEL_STEP;
	  pY = sY * PIXEL_STEP;
	
	  if ('deltaY' in event) { pY = event.deltaY; }
	  if ('deltaX' in event) { pX = event.deltaX; }
	
	  if ((pX || pY) && event.deltaMode) {
	    if (event.deltaMode == 1) {          // delta in LINE units
	      pX *= LINE_HEIGHT;
	      pY *= LINE_HEIGHT;
	    } else {                             // delta in PAGE units
	      pX *= PAGE_HEIGHT;
	      pY *= PAGE_HEIGHT;
	    }
	  }
	
	  // Fall-back if spin cannot be determined
	  if (pX && !sX) { sX = (pX < 1) ? -1 : 1; }
	  if (pY && !sY) { sY = (pY < 1) ? -1 : 1; }
	
	  return { spinX  : sX,
	           spinY  : sY,
	           pixelX : pX,
	           pixelY : pY };
	}
	
	
	/**
	 * The best combination if you prefer spinX + spinY normalization.  It favors
	 * the older DOMMouseScroll for Firefox, as FF does not include wheelDelta with
	 * 'wheel' event, making spin speed determination impossible.
	 */
	normalizeWheel.getEventType = function() /*string*/ {
	  return (UserAgent_DEPRECATED.firefox())
	           ? 'DOMMouseScroll'
	           : (isEventSupported('wheel'))
	               ? 'wheel'
	               : 'mousewheel';
	};
	
	module.exports = normalizeWheel;


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.ResizeObserver = factory());
	}(this, (function () { 'use strict';
	
	    /**
	     * A collection of shims that provide minimal functionality of the ES6 collections.
	     *
	     * These implementations are not meant to be used outside of the ResizeObserver
	     * modules as they cover only a limited range of use cases.
	     */
	    /* eslint-disable require-jsdoc, valid-jsdoc */
	    var MapShim = (function () {
	        if (typeof Map !== 'undefined') {
	            return Map;
	        }
	        /**
	         * Returns index in provided array that matches the specified key.
	         *
	         * @param {Array<Array>} arr
	         * @param {*} key
	         * @returns {number}
	         */
	        function getIndex(arr, key) {
	            var result = -1;
	            arr.some(function (entry, index) {
	                if (entry[0] === key) {
	                    result = index;
	                    return true;
	                }
	                return false;
	            });
	            return result;
	        }
	        return /** @class */ (function () {
	            function class_1() {
	                this.__entries__ = [];
	            }
	            Object.defineProperty(class_1.prototype, "size", {
	                /**
	                 * @returns {boolean}
	                 */
	                get: function () {
	                    return this.__entries__.length;
	                },
	                enumerable: true,
	                configurable: true
	            });
	            /**
	             * @param {*} key
	             * @returns {*}
	             */
	            class_1.prototype.get = function (key) {
	                var index = getIndex(this.__entries__, key);
	                var entry = this.__entries__[index];
	                return entry && entry[1];
	            };
	            /**
	             * @param {*} key
	             * @param {*} value
	             * @returns {void}
	             */
	            class_1.prototype.set = function (key, value) {
	                var index = getIndex(this.__entries__, key);
	                if (~index) {
	                    this.__entries__[index][1] = value;
	                }
	                else {
	                    this.__entries__.push([key, value]);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.delete = function (key) {
	                var entries = this.__entries__;
	                var index = getIndex(entries, key);
	                if (~index) {
	                    entries.splice(index, 1);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.has = function (key) {
	                return !!~getIndex(this.__entries__, key);
	            };
	            /**
	             * @returns {void}
	             */
	            class_1.prototype.clear = function () {
	                this.__entries__.splice(0);
	            };
	            /**
	             * @param {Function} callback
	             * @param {*} [ctx=null]
	             * @returns {void}
	             */
	            class_1.prototype.forEach = function (callback, ctx) {
	                if (ctx === void 0) { ctx = null; }
	                for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
	                    var entry = _a[_i];
	                    callback.call(ctx, entry[1], entry[0]);
	                }
	            };
	            return class_1;
	        }());
	    })();
	
	    /**
	     * Detects whether window and document objects are available in current environment.
	     */
	    var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	    // Returns global object of a current environment.
	    var global$1 = (function () {
	        if (typeof global !== 'undefined' && global.Math === Math) {
	            return global;
	        }
	        if (typeof self !== 'undefined' && self.Math === Math) {
	            return self;
	        }
	        if (typeof window !== 'undefined' && window.Math === Math) {
	            return window;
	        }
	        // eslint-disable-next-line no-new-func
	        return Function('return this')();
	    })();
	
	    /**
	     * A shim for the requestAnimationFrame which falls back to the setTimeout if
	     * first one is not supported.
	     *
	     * @returns {number} Requests' identifier.
	     */
	    var requestAnimationFrame$1 = (function () {
	        if (typeof requestAnimationFrame === 'function') {
	            // It's required to use a bounded function because IE sometimes throws
	            // an "Invalid calling object" error if rAF is invoked without the global
	            // object on the left hand side.
	            return requestAnimationFrame.bind(global$1);
	        }
	        return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	    })();
	
	    // Defines minimum timeout before adding a trailing call.
	    var trailingTimeout = 2;
	    /**
	     * Creates a wrapper function which ensures that provided callback will be
	     * invoked only once during the specified delay period.
	     *
	     * @param {Function} callback - Function to be invoked after the delay period.
	     * @param {number} delay - Delay after which to invoke callback.
	     * @returns {Function}
	     */
	    function throttle (callback, delay) {
	        var leadingCall = false, trailingCall = false, lastCallTime = 0;
	        /**
	         * Invokes the original callback function and schedules new invocation if
	         * the "proxy" was called during current request.
	         *
	         * @returns {void}
	         */
	        function resolvePending() {
	            if (leadingCall) {
	                leadingCall = false;
	                callback();
	            }
	            if (trailingCall) {
	                proxy();
	            }
	        }
	        /**
	         * Callback invoked after the specified delay. It will further postpone
	         * invocation of the original function delegating it to the
	         * requestAnimationFrame.
	         *
	         * @returns {void}
	         */
	        function timeoutCallback() {
	            requestAnimationFrame$1(resolvePending);
	        }
	        /**
	         * Schedules invocation of the original function.
	         *
	         * @returns {void}
	         */
	        function proxy() {
	            var timeStamp = Date.now();
	            if (leadingCall) {
	                // Reject immediately following calls.
	                if (timeStamp - lastCallTime < trailingTimeout) {
	                    return;
	                }
	                // Schedule new call to be in invoked when the pending one is resolved.
	                // This is important for "transitions" which never actually start
	                // immediately so there is a chance that we might miss one if change
	                // happens amids the pending invocation.
	                trailingCall = true;
	            }
	            else {
	                leadingCall = true;
	                trailingCall = false;
	                setTimeout(timeoutCallback, delay);
	            }
	            lastCallTime = timeStamp;
	        }
	        return proxy;
	    }
	
	    // Minimum delay before invoking the update of observers.
	    var REFRESH_DELAY = 20;
	    // A list of substrings of CSS properties used to find transition events that
	    // might affect dimensions of observed elements.
	    var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	    // Check if MutationObserver is available.
	    var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	    /**
	     * Singleton controller class which handles updates of ResizeObserver instances.
	     */
	    var ResizeObserverController = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserverController.
	         *
	         * @private
	         */
	        function ResizeObserverController() {
	            /**
	             * Indicates whether DOM listeners have been added.
	             *
	             * @private {boolean}
	             */
	            this.connected_ = false;
	            /**
	             * Tells that controller has subscribed for Mutation Events.
	             *
	             * @private {boolean}
	             */
	            this.mutationEventsAdded_ = false;
	            /**
	             * Keeps reference to the instance of MutationObserver.
	             *
	             * @private {MutationObserver}
	             */
	            this.mutationsObserver_ = null;
	            /**
	             * A list of connected observers.
	             *
	             * @private {Array<ResizeObserverSPI>}
	             */
	            this.observers_ = [];
	            this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	            this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	        }
	        /**
	         * Adds observer to observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be added.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.addObserver = function (observer) {
	            if (!~this.observers_.indexOf(observer)) {
	                this.observers_.push(observer);
	            }
	            // Add listeners if they haven't been added yet.
	            if (!this.connected_) {
	                this.connect_();
	            }
	        };
	        /**
	         * Removes observer from observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be removed.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.removeObserver = function (observer) {
	            var observers = this.observers_;
	            var index = observers.indexOf(observer);
	            // Remove observer if it's present in registry.
	            if (~index) {
	                observers.splice(index, 1);
	            }
	            // Remove listeners if controller has no connected observers.
	            if (!observers.length && this.connected_) {
	                this.disconnect_();
	            }
	        };
	        /**
	         * Invokes the update of observers. It will continue running updates insofar
	         * it detects changes.
	         *
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.refresh = function () {
	            var changesDetected = this.updateObservers_();
	            // Continue running updates if changes have been detected as there might
	            // be future ones caused by CSS transitions.
	            if (changesDetected) {
	                this.refresh();
	            }
	        };
	        /**
	         * Updates every observer from observers list and notifies them of queued
	         * entries.
	         *
	         * @private
	         * @returns {boolean} Returns "true" if any observer has detected changes in
	         *      dimensions of it's elements.
	         */
	        ResizeObserverController.prototype.updateObservers_ = function () {
	            // Collect observers that have active observations.
	            var activeObservers = this.observers_.filter(function (observer) {
	                return observer.gatherActive(), observer.hasActive();
	            });
	            // Deliver notifications in a separate cycle in order to avoid any
	            // collisions between observers, e.g. when multiple instances of
	            // ResizeObserver are tracking the same element and the callback of one
	            // of them changes content dimensions of the observed target. Sometimes
	            // this may result in notifications being blocked for the rest of observers.
	            activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	            return activeObservers.length > 0;
	        };
	        /**
	         * Initializes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.connect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already added.
	            if (!isBrowser || this.connected_) {
	                return;
	            }
	            // Subscription to the "Transitionend" event is used as a workaround for
	            // delayed transitions. This way it's possible to capture at least the
	            // final state of an element.
	            document.addEventListener('transitionend', this.onTransitionEnd_);
	            window.addEventListener('resize', this.refresh);
	            if (mutationObserverSupported) {
	                this.mutationsObserver_ = new MutationObserver(this.refresh);
	                this.mutationsObserver_.observe(document, {
	                    attributes: true,
	                    childList: true,
	                    characterData: true,
	                    subtree: true
	                });
	            }
	            else {
	                document.addEventListener('DOMSubtreeModified', this.refresh);
	                this.mutationEventsAdded_ = true;
	            }
	            this.connected_ = true;
	        };
	        /**
	         * Removes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.disconnect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already removed.
	            if (!isBrowser || !this.connected_) {
	                return;
	            }
	            document.removeEventListener('transitionend', this.onTransitionEnd_);
	            window.removeEventListener('resize', this.refresh);
	            if (this.mutationsObserver_) {
	                this.mutationsObserver_.disconnect();
	            }
	            if (this.mutationEventsAdded_) {
	                document.removeEventListener('DOMSubtreeModified', this.refresh);
	            }
	            this.mutationsObserver_ = null;
	            this.mutationEventsAdded_ = false;
	            this.connected_ = false;
	        };
	        /**
	         * "Transitionend" event handler.
	         *
	         * @private
	         * @param {TransitionEvent} event
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
	            var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
	            // Detect whether transition may affect dimensions of an element.
	            var isReflowProperty = transitionKeys.some(function (key) {
	                return !!~propertyName.indexOf(key);
	            });
	            if (isReflowProperty) {
	                this.refresh();
	            }
	        };
	        /**
	         * Returns instance of the ResizeObserverController.
	         *
	         * @returns {ResizeObserverController}
	         */
	        ResizeObserverController.getInstance = function () {
	            if (!this.instance_) {
	                this.instance_ = new ResizeObserverController();
	            }
	            return this.instance_;
	        };
	        /**
	         * Holds reference to the controller's instance.
	         *
	         * @private {ResizeObserverController}
	         */
	        ResizeObserverController.instance_ = null;
	        return ResizeObserverController;
	    }());
	
	    /**
	     * Defines non-writable/enumerable properties of the provided target object.
	     *
	     * @param {Object} target - Object for which to define properties.
	     * @param {Object} props - Properties to be defined.
	     * @returns {Object} Target object.
	     */
	    var defineConfigurable = (function (target, props) {
	        for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
	            var key = _a[_i];
	            Object.defineProperty(target, key, {
	                value: props[key],
	                enumerable: false,
	                writable: false,
	                configurable: true
	            });
	        }
	        return target;
	    });
	
	    /**
	     * Returns the global object associated with provided element.
	     *
	     * @param {Object} target
	     * @returns {Object}
	     */
	    var getWindowOf = (function (target) {
	        // Assume that the element is an instance of Node, which means that it
	        // has the "ownerDocument" property from which we can retrieve a
	        // corresponding global object.
	        var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	        // Return the local global object if it's not possible extract one from
	        // provided element.
	        return ownerGlobal || global$1;
	    });
	
	    // Placeholder of an empty content rectangle.
	    var emptyRect = createRectInit(0, 0, 0, 0);
	    /**
	     * Converts provided string to a number.
	     *
	     * @param {number|string} value
	     * @returns {number}
	     */
	    function toFloat(value) {
	        return parseFloat(value) || 0;
	    }
	    /**
	     * Extracts borders size from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @param {...string} positions - Borders positions (top, right, ...)
	     * @returns {number}
	     */
	    function getBordersSize(styles) {
	        var positions = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            positions[_i - 1] = arguments[_i];
	        }
	        return positions.reduce(function (size, position) {
	            var value = styles['border-' + position + '-width'];
	            return size + toFloat(value);
	        }, 0);
	    }
	    /**
	     * Extracts paddings sizes from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @returns {Object} Paddings box.
	     */
	    function getPaddings(styles) {
	        var positions = ['top', 'right', 'bottom', 'left'];
	        var paddings = {};
	        for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
	            var position = positions_1[_i];
	            var value = styles['padding-' + position];
	            paddings[position] = toFloat(value);
	        }
	        return paddings;
	    }
	    /**
	     * Calculates content rectangle of provided SVG element.
	     *
	     * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	     *      to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getSVGContentRect(target) {
	        var bbox = target.getBBox();
	        return createRectInit(0, 0, bbox.width, bbox.height);
	    }
	    /**
	     * Calculates content rectangle of provided HTMLElement.
	     *
	     * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	     * @returns {DOMRectInit}
	     */
	    function getHTMLElementContentRect(target) {
	        // Client width & height properties can't be
	        // used exclusively as they provide rounded values.
	        var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
	        // By this condition we can catch all non-replaced inline, hidden and
	        // detached elements. Though elements with width & height properties less
	        // than 0.5 will be discarded as well.
	        //
	        // Without it we would need to implement separate methods for each of
	        // those cases and it's not possible to perform a precise and performance
	        // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	        // gives wrong results for elements with width & height less than 0.5.
	        if (!clientWidth && !clientHeight) {
	            return emptyRect;
	        }
	        var styles = getWindowOf(target).getComputedStyle(target);
	        var paddings = getPaddings(styles);
	        var horizPad = paddings.left + paddings.right;
	        var vertPad = paddings.top + paddings.bottom;
	        // Computed styles of width & height are being used because they are the
	        // only dimensions available to JS that contain non-rounded values. It could
	        // be possible to utilize the getBoundingClientRect if only it's data wasn't
	        // affected by CSS transformations let alone paddings, borders and scroll bars.
	        var width = toFloat(styles.width), height = toFloat(styles.height);
	        // Width & height include paddings and borders when the 'border-box' box
	        // model is applied (except for IE).
	        if (styles.boxSizing === 'border-box') {
	            // Following conditions are required to handle Internet Explorer which
	            // doesn't include paddings and borders to computed CSS dimensions.
	            //
	            // We can say that if CSS dimensions + paddings are equal to the "client"
	            // properties then it's either IE, and thus we don't need to subtract
	            // anything, or an element merely doesn't have paddings/borders styles.
	            if (Math.round(width + horizPad) !== clientWidth) {
	                width -= getBordersSize(styles, 'left', 'right') + horizPad;
	            }
	            if (Math.round(height + vertPad) !== clientHeight) {
	                height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	            }
	        }
	        // Following steps can't be applied to the document's root element as its
	        // client[Width/Height] properties represent viewport area of the window.
	        // Besides, it's as well not necessary as the <html> itself neither has
	        // rendered scroll bars nor it can be clipped.
	        if (!isDocumentElement(target)) {
	            // In some browsers (only in Firefox, actually) CSS width & height
	            // include scroll bars size which can be removed at this step as scroll
	            // bars are the only difference between rounded dimensions + paddings
	            // and "client" properties, though that is not always true in Chrome.
	            var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	            var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	            // Chrome has a rather weird rounding of "client" properties.
	            // E.g. for an element with content width of 314.2px it sometimes gives
	            // the client width of 315px and for the width of 314.7px it may give
	            // 314px. And it doesn't happen all the time. So just ignore this delta
	            // as a non-relevant.
	            if (Math.abs(vertScrollbar) !== 1) {
	                width -= vertScrollbar;
	            }
	            if (Math.abs(horizScrollbar) !== 1) {
	                height -= horizScrollbar;
	            }
	        }
	        return createRectInit(paddings.left, paddings.top, width, height);
	    }
	    /**
	     * Checks whether provided element is an instance of the SVGGraphicsElement.
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    var isSVGGraphicsElement = (function () {
	        // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	        // interface.
	        if (typeof SVGGraphicsElement !== 'undefined') {
	            return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	        }
	        // If it's so, then check that element is at least an instance of the
	        // SVGElement and that it has the "getBBox" method.
	        // eslint-disable-next-line no-extra-parens
	        return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
	            typeof target.getBBox === 'function'); };
	    })();
	    /**
	     * Checks whether provided element is a document element (<html>).
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    function isDocumentElement(target) {
	        return target === getWindowOf(target).document.documentElement;
	    }
	    /**
	     * Calculates an appropriate content rectangle for provided html or svg element.
	     *
	     * @param {Element} target - Element content rectangle of which needs to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getContentRect(target) {
	        if (!isBrowser) {
	            return emptyRect;
	        }
	        if (isSVGGraphicsElement(target)) {
	            return getSVGContentRect(target);
	        }
	        return getHTMLElementContentRect(target);
	    }
	    /**
	     * Creates rectangle with an interface of the DOMRectReadOnly.
	     * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	     *
	     * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	     * @returns {DOMRectReadOnly}
	     */
	    function createReadOnlyRect(_a) {
	        var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
	        // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	        var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	        var rect = Object.create(Constr.prototype);
	        // Rectangle's properties are not writable and non-enumerable.
	        defineConfigurable(rect, {
	            x: x, y: y, width: width, height: height,
	            top: y,
	            right: x + width,
	            bottom: height + y,
	            left: x
	        });
	        return rect;
	    }
	    /**
	     * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	     * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	     *
	     * @param {number} x - X coordinate.
	     * @param {number} y - Y coordinate.
	     * @param {number} width - Rectangle's width.
	     * @param {number} height - Rectangle's height.
	     * @returns {DOMRectInit}
	     */
	    function createRectInit(x, y, width, height) {
	        return { x: x, y: y, width: width, height: height };
	    }
	
	    /**
	     * Class that is responsible for computations of the content rectangle of
	     * provided DOM element and for keeping track of it's changes.
	     */
	    var ResizeObservation = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObservation.
	         *
	         * @param {Element} target - Element to be observed.
	         */
	        function ResizeObservation(target) {
	            /**
	             * Broadcasted width of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastWidth = 0;
	            /**
	             * Broadcasted height of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastHeight = 0;
	            /**
	             * Reference to the last observed content rectangle.
	             *
	             * @private {DOMRectInit}
	             */
	            this.contentRect_ = createRectInit(0, 0, 0, 0);
	            this.target = target;
	        }
	        /**
	         * Updates content rectangle and tells whether it's width or height properties
	         * have changed since the last broadcast.
	         *
	         * @returns {boolean}
	         */
	        ResizeObservation.prototype.isActive = function () {
	            var rect = getContentRect(this.target);
	            this.contentRect_ = rect;
	            return (rect.width !== this.broadcastWidth ||
	                rect.height !== this.broadcastHeight);
	        };
	        /**
	         * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	         * from the corresponding properties of the last observed content rectangle.
	         *
	         * @returns {DOMRectInit} Last observed content rectangle.
	         */
	        ResizeObservation.prototype.broadcastRect = function () {
	            var rect = this.contentRect_;
	            this.broadcastWidth = rect.width;
	            this.broadcastHeight = rect.height;
	            return rect;
	        };
	        return ResizeObservation;
	    }());
	
	    var ResizeObserverEntry = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObserverEntry.
	         *
	         * @param {Element} target - Element that is being observed.
	         * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
	         */
	        function ResizeObserverEntry(target, rectInit) {
	            var contentRect = createReadOnlyRect(rectInit);
	            // According to the specification following properties are not writable
	            // and are also not enumerable in the native implementation.
	            //
	            // Property accessors are not being used as they'd require to define a
	            // private WeakMap storage which may cause memory leaks in browsers that
	            // don't support this type of collections.
	            defineConfigurable(this, { target: target, contentRect: contentRect });
	        }
	        return ResizeObserverEntry;
	    }());
	
	    var ResizeObserverSPI = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback function that is invoked
	         *      when one of the observed elements changes it's content dimensions.
	         * @param {ResizeObserverController} controller - Controller instance which
	         *      is responsible for the updates of observer.
	         * @param {ResizeObserver} callbackCtx - Reference to the public
	         *      ResizeObserver instance which will be passed to callback function.
	         */
	        function ResizeObserverSPI(callback, controller, callbackCtx) {
	            /**
	             * Collection of resize observations that have detected changes in dimensions
	             * of elements.
	             *
	             * @private {Array<ResizeObservation>}
	             */
	            this.activeObservations_ = [];
	            /**
	             * Registry of the ResizeObservation instances.
	             *
	             * @private {Map<Element, ResizeObservation>}
	             */
	            this.observations_ = new MapShim();
	            if (typeof callback !== 'function') {
	                throw new TypeError('The callback provided as parameter 1 is not a function.');
	            }
	            this.callback_ = callback;
	            this.controller_ = controller;
	            this.callbackCtx_ = callbackCtx;
	        }
	        /**
	         * Starts observing provided element.
	         *
	         * @param {Element} target - Element to be observed.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.observe = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is already being observed.
	            if (observations.has(target)) {
	                return;
	            }
	            observations.set(target, new ResizeObservation(target));
	            this.controller_.addObserver(this);
	            // Force the update of observations.
	            this.controller_.refresh();
	        };
	        /**
	         * Stops observing provided element.
	         *
	         * @param {Element} target - Element to stop observing.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.unobserve = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is not being observed.
	            if (!observations.has(target)) {
	                return;
	            }
	            observations.delete(target);
	            if (!observations.size) {
	                this.controller_.removeObserver(this);
	            }
	        };
	        /**
	         * Stops observing all elements.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.disconnect = function () {
	            this.clearActive();
	            this.observations_.clear();
	            this.controller_.removeObserver(this);
	        };
	        /**
	         * Collects observation instances the associated element of which has changed
	         * it's content rectangle.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.gatherActive = function () {
	            var _this = this;
	            this.clearActive();
	            this.observations_.forEach(function (observation) {
	                if (observation.isActive()) {
	                    _this.activeObservations_.push(observation);
	                }
	            });
	        };
	        /**
	         * Invokes initial callback function with a list of ResizeObserverEntry
	         * instances collected from active resize observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.broadcastActive = function () {
	            // Do nothing if observer doesn't have active observations.
	            if (!this.hasActive()) {
	                return;
	            }
	            var ctx = this.callbackCtx_;
	            // Create ResizeObserverEntry instance for every active observation.
	            var entries = this.activeObservations_.map(function (observation) {
	                return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	            });
	            this.callback_.call(ctx, entries, ctx);
	            this.clearActive();
	        };
	        /**
	         * Clears the collection of active observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.clearActive = function () {
	            this.activeObservations_.splice(0);
	        };
	        /**
	         * Tells whether observer has active observations.
	         *
	         * @returns {boolean}
	         */
	        ResizeObserverSPI.prototype.hasActive = function () {
	            return this.activeObservations_.length > 0;
	        };
	        return ResizeObserverSPI;
	    }());
	
	    // Registry of internal observers. If WeakMap is not available use current shim
	    // for the Map collection as it has all required methods and because WeakMap
	    // can't be fully polyfilled anyway.
	    var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	    /**
	     * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	     * exposing only those methods and properties that are defined in the spec.
	     */
	    var ResizeObserver = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback that is invoked when
	         *      dimensions of the observed elements change.
	         */
	        function ResizeObserver(callback) {
	            if (!(this instanceof ResizeObserver)) {
	                throw new TypeError('Cannot call a class as a function.');
	            }
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            var controller = ResizeObserverController.getInstance();
	            var observer = new ResizeObserverSPI(callback, controller, this);
	            observers.set(this, observer);
	        }
	        return ResizeObserver;
	    }());
	    // Expose public methods of ResizeObserver.
	    [
	        'observe',
	        'unobserve',
	        'disconnect'
	    ].forEach(function (method) {
	        ResizeObserver.prototype[method] = function () {
	            var _a;
	            return (_a = observers.get(this))[method].apply(_a, arguments);
	        };
	    });
	
	    var index = (function () {
	        // Export existing implementation if available.
	        if (typeof global$1.ResizeObserver !== 'undefined') {
	            return global$1.ResizeObserver;
	        }
	        return ResizeObserver;
	    })();
	
	    return index;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	var throttle = __webpack_require__(104);
	var debounce = __webpack_require__(62);
	
	module.exports = {
		throttle: throttle,
		debounce: debounce
	};


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
	 * Vue.js v2.6.14
	 * (c) 2014-2021 Evan You
	 * Released under the MIT License.
	 */
	"use strict";var t=Object.freeze({});function e(t){return null==t}function n(t){return null!=t}function r(t){return!0===t}function o(t){return"string"==typeof t||"number"==typeof t||"symbol"==typeof t||"boolean"==typeof t}function i(t){return null!==t&&"object"==typeof t}var a=Object.prototype.toString;function s(t){return"[object Object]"===a.call(t)}function c(t){var e=parseFloat(String(t));return e>=0&&Math.floor(e)===e&&isFinite(t)}function u(t){return n(t)&&"function"==typeof t.then&&"function"==typeof t.catch}function l(t){return null==t?"":Array.isArray(t)||s(t)&&t.toString===a?JSON.stringify(t,null,2):String(t)}function f(t){var e=parseFloat(t);return isNaN(e)?t:e}function d(t,e){for(var n=Object.create(null),r=t.split(","),o=0;o<r.length;o++)n[r[o]]=!0;return e?function(t){return n[t.toLowerCase()]}:function(t){return n[t]}}var p=d("key,ref,slot,slot-scope,is");function v(t,e){if(t.length){var n=t.indexOf(e);if(n>-1)return t.splice(n,1)}}var h=Object.prototype.hasOwnProperty;function m(t,e){return h.call(t,e)}function y(t){var e=Object.create(null);return function(n){return e[n]||(e[n]=t(n))}}var g=/-(\w)/g,_=y(function(t){return t.replace(g,function(t,e){return e?e.toUpperCase():""})}),b=y(function(t){return t.charAt(0).toUpperCase()+t.slice(1)}),C=/\B([A-Z])/g,$=y(function(t){return t.replace(C,"-$1").toLowerCase()});var w=Function.prototype.bind?function(t,e){return t.bind(e)}:function(t,e){function n(n){var r=arguments.length;return r?r>1?t.apply(e,arguments):t.call(e,n):t.call(e)}return n._length=t.length,n};function A(t,e){e=e||0;for(var n=t.length-e,r=new Array(n);n--;)r[n]=t[n+e];return r}function x(t,e){for(var n in e)t[n]=e[n];return t}function k(t){for(var e={},n=0;n<t.length;n++)t[n]&&x(e,t[n]);return e}function O(t,e,n){}var S=function(t,e,n){return!1},E=function(t){return t};function T(t,e){if(t===e)return!0;var n=i(t),r=i(e);if(!n||!r)return!n&&!r&&String(t)===String(e);try{var o=Array.isArray(t),a=Array.isArray(e);if(o&&a)return t.length===e.length&&t.every(function(t,n){return T(t,e[n])});if(t instanceof Date&&e instanceof Date)return t.getTime()===e.getTime();if(o||a)return!1;var s=Object.keys(t),c=Object.keys(e);return s.length===c.length&&s.every(function(n){return T(t[n],e[n])})}catch(t){return!1}}function j(t,e){for(var n=0;n<t.length;n++)if(T(t[n],e))return n;return-1}function I(t){var e=!1;return function(){e||(e=!0,t.apply(this,arguments))}}var D="data-server-rendered",N=["component","directive","filter"],P=["beforeCreate","created","beforeMount","mounted","beforeUpdate","updated","beforeDestroy","destroyed","activated","deactivated","errorCaptured","serverPrefetch"],L={optionMergeStrategies:Object.create(null),silent:!1,productionTip:!1,devtools:!1,performance:!1,errorHandler:null,warnHandler:null,ignoredElements:[],keyCodes:Object.create(null),isReservedTag:S,isReservedAttr:S,isUnknownElement:S,getTagNamespace:O,parsePlatformTagName:E,mustUseProp:S,async:!0,_lifecycleHooks:P};function M(t,e,n,r){Object.defineProperty(t,e,{value:n,enumerable:!!r,writable:!0,configurable:!0})}var F=new RegExp("[^"+/a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/.source+".$_\\d]");var R,V="__proto__"in{},U="undefined"!=typeof window,H="undefined"!=typeof WXEnvironment&&!!WXEnvironment.platform,B=H&&WXEnvironment.platform.toLowerCase(),z=U&&window.navigator.userAgent.toLowerCase(),W=z&&/msie|trident/.test(z),q=z&&z.indexOf("msie 9.0")>0,K=z&&z.indexOf("edge/")>0,X=(z&&z.indexOf("android"),z&&/iphone|ipad|ipod|ios/.test(z)||"ios"===B),G=(z&&/chrome\/\d+/.test(z),z&&/phantomjs/.test(z),z&&z.match(/firefox\/(\d+)/)),Z={}.watch,J=!1;if(U)try{var Q={};Object.defineProperty(Q,"passive",{get:function(){J=!0}}),window.addEventListener("test-passive",null,Q)}catch(t){}var Y=function(){return void 0===R&&(R=!U&&!H&&"undefined"!=typeof global&&(global.process&&"server"===global.process.env.VUE_ENV)),R},tt=U&&window.__VUE_DEVTOOLS_GLOBAL_HOOK__;function et(t){return"function"==typeof t&&/native code/.test(t.toString())}var nt,rt="undefined"!=typeof Symbol&&et(Symbol)&&"undefined"!=typeof Reflect&&et(Reflect.ownKeys);nt="undefined"!=typeof Set&&et(Set)?Set:function(){function t(){this.set=Object.create(null)}return t.prototype.has=function(t){return!0===this.set[t]},t.prototype.add=function(t){this.set[t]=!0},t.prototype.clear=function(){this.set=Object.create(null)},t}();var ot=O,it=0,at=function(){this.id=it++,this.subs=[]};at.prototype.addSub=function(t){this.subs.push(t)},at.prototype.removeSub=function(t){v(this.subs,t)},at.prototype.depend=function(){at.target&&at.target.addDep(this)},at.prototype.notify=function(){for(var t=this.subs.slice(),e=0,n=t.length;e<n;e++)t[e].update()},at.target=null;var st=[];function ct(t){st.push(t),at.target=t}function ut(){st.pop(),at.target=st[st.length-1]}var lt=function(t,e,n,r,o,i,a,s){this.tag=t,this.data=e,this.children=n,this.text=r,this.elm=o,this.ns=void 0,this.context=i,this.fnContext=void 0,this.fnOptions=void 0,this.fnScopeId=void 0,this.key=e&&e.key,this.componentOptions=a,this.componentInstance=void 0,this.parent=void 0,this.raw=!1,this.isStatic=!1,this.isRootInsert=!0,this.isComment=!1,this.isCloned=!1,this.isOnce=!1,this.asyncFactory=s,this.asyncMeta=void 0,this.isAsyncPlaceholder=!1},ft={child:{configurable:!0}};ft.child.get=function(){return this.componentInstance},Object.defineProperties(lt.prototype,ft);var dt=function(t){void 0===t&&(t="");var e=new lt;return e.text=t,e.isComment=!0,e};function pt(t){return new lt(void 0,void 0,void 0,String(t))}function vt(t){var e=new lt(t.tag,t.data,t.children&&t.children.slice(),t.text,t.elm,t.context,t.componentOptions,t.asyncFactory);return e.ns=t.ns,e.isStatic=t.isStatic,e.key=t.key,e.isComment=t.isComment,e.fnContext=t.fnContext,e.fnOptions=t.fnOptions,e.fnScopeId=t.fnScopeId,e.asyncMeta=t.asyncMeta,e.isCloned=!0,e}var ht=Array.prototype,mt=Object.create(ht);["push","pop","shift","unshift","splice","sort","reverse"].forEach(function(t){var e=ht[t];M(mt,t,function(){for(var n=[],r=arguments.length;r--;)n[r]=arguments[r];var o,i=e.apply(this,n),a=this.__ob__;switch(t){case"push":case"unshift":o=n;break;case"splice":o=n.slice(2)}return o&&a.observeArray(o),a.dep.notify(),i})});var yt=Object.getOwnPropertyNames(mt),gt=!0;function _t(t){gt=t}var bt=function(t){var e;this.value=t,this.dep=new at,this.vmCount=0,M(t,"__ob__",this),Array.isArray(t)?(V?(e=mt,t.__proto__=e):function(t,e,n){for(var r=0,o=n.length;r<o;r++){var i=n[r];M(t,i,e[i])}}(t,mt,yt),this.observeArray(t)):this.walk(t)};function Ct(t,e){var n;if(i(t)&&!(t instanceof lt))return m(t,"__ob__")&&t.__ob__ instanceof bt?n=t.__ob__:gt&&!Y()&&(Array.isArray(t)||s(t))&&Object.isExtensible(t)&&!t._isVue&&(n=new bt(t)),e&&n&&n.vmCount++,n}function $t(t,e,n,r,o){var i=new at,a=Object.getOwnPropertyDescriptor(t,e);if(!a||!1!==a.configurable){var s=a&&a.get,c=a&&a.set;s&&!c||2!==arguments.length||(n=t[e]);var u=!o&&Ct(n);Object.defineProperty(t,e,{enumerable:!0,configurable:!0,get:function(){var e=s?s.call(t):n;return at.target&&(i.depend(),u&&(u.dep.depend(),Array.isArray(e)&&function t(e){for(var n=void 0,r=0,o=e.length;r<o;r++)(n=e[r])&&n.__ob__&&n.__ob__.dep.depend(),Array.isArray(n)&&t(n)}(e))),e},set:function(e){var r=s?s.call(t):n;e===r||e!=e&&r!=r||s&&!c||(c?c.call(t,e):n=e,u=!o&&Ct(e),i.notify())}})}}function wt(t,e,n){if(Array.isArray(t)&&c(e))return t.length=Math.max(t.length,e),t.splice(e,1,n),n;if(e in t&&!(e in Object.prototype))return t[e]=n,n;var r=t.__ob__;return t._isVue||r&&r.vmCount?n:r?($t(r.value,e,n),r.dep.notify(),n):(t[e]=n,n)}function At(t,e){if(Array.isArray(t)&&c(e))t.splice(e,1);else{var n=t.__ob__;t._isVue||n&&n.vmCount||m(t,e)&&(delete t[e],n&&n.dep.notify())}}bt.prototype.walk=function(t){for(var e=Object.keys(t),n=0;n<e.length;n++)$t(t,e[n])},bt.prototype.observeArray=function(t){for(var e=0,n=t.length;e<n;e++)Ct(t[e])};var xt=L.optionMergeStrategies;function kt(t,e){if(!e)return t;for(var n,r,o,i=rt?Reflect.ownKeys(e):Object.keys(e),a=0;a<i.length;a++)"__ob__"!==(n=i[a])&&(r=t[n],o=e[n],m(t,n)?r!==o&&s(r)&&s(o)&&kt(r,o):wt(t,n,o));return t}function Ot(t,e,n){return n?function(){var r="function"==typeof e?e.call(n,n):e,o="function"==typeof t?t.call(n,n):t;return r?kt(r,o):o}:e?t?function(){return kt("function"==typeof e?e.call(this,this):e,"function"==typeof t?t.call(this,this):t)}:e:t}function St(t,e){var n=e?t?t.concat(e):Array.isArray(e)?e:[e]:t;return n?function(t){for(var e=[],n=0;n<t.length;n++)-1===e.indexOf(t[n])&&e.push(t[n]);return e}(n):n}function Et(t,e,n,r){var o=Object.create(t||null);return e?x(o,e):o}xt.data=function(t,e,n){return n?Ot(t,e,n):e&&"function"!=typeof e?t:Ot(t,e)},P.forEach(function(t){xt[t]=St}),N.forEach(function(t){xt[t+"s"]=Et}),xt.watch=function(t,e,n,r){if(t===Z&&(t=void 0),e===Z&&(e=void 0),!e)return Object.create(t||null);if(!t)return e;var o={};for(var i in x(o,t),e){var a=o[i],s=e[i];a&&!Array.isArray(a)&&(a=[a]),o[i]=a?a.concat(s):Array.isArray(s)?s:[s]}return o},xt.props=xt.methods=xt.inject=xt.computed=function(t,e,n,r){if(!t)return e;var o=Object.create(null);return x(o,t),e&&x(o,e),o},xt.provide=Ot;var Tt=function(t,e){return void 0===e?t:e};function jt(t,e,n){if("function"==typeof e&&(e=e.options),function(t,e){var n=t.props;if(n){var r,o,i={};if(Array.isArray(n))for(r=n.length;r--;)"string"==typeof(o=n[r])&&(i[_(o)]={type:null});else if(s(n))for(var a in n)o=n[a],i[_(a)]=s(o)?o:{type:o};t.props=i}}(e),function(t,e){var n=t.inject;if(n){var r=t.inject={};if(Array.isArray(n))for(var o=0;o<n.length;o++)r[n[o]]={from:n[o]};else if(s(n))for(var i in n){var a=n[i];r[i]=s(a)?x({from:i},a):{from:a}}}}(e),function(t){var e=t.directives;if(e)for(var n in e){var r=e[n];"function"==typeof r&&(e[n]={bind:r,update:r})}}(e),!e._base&&(e.extends&&(t=jt(t,e.extends,n)),e.mixins))for(var r=0,o=e.mixins.length;r<o;r++)t=jt(t,e.mixins[r],n);var i,a={};for(i in t)c(i);for(i in e)m(t,i)||c(i);function c(r){var o=xt[r]||Tt;a[r]=o(t[r],e[r],n,r)}return a}function It(t,e,n,r){if("string"==typeof n){var o=t[e];if(m(o,n))return o[n];var i=_(n);if(m(o,i))return o[i];var a=b(i);return m(o,a)?o[a]:o[n]||o[i]||o[a]}}function Dt(t,e,n,r){var o=e[t],i=!m(n,t),a=n[t],s=Mt(Boolean,o.type);if(s>-1)if(i&&!m(o,"default"))a=!1;else if(""===a||a===$(t)){var c=Mt(String,o.type);(c<0||s<c)&&(a=!0)}if(void 0===a){a=function(t,e,n){if(!m(e,"default"))return;var r=e.default;if(t&&t.$options.propsData&&void 0===t.$options.propsData[n]&&void 0!==t._props[n])return t._props[n];return"function"==typeof r&&"Function"!==Pt(e.type)?r.call(t):r}(r,o,t);var u=gt;_t(!0),Ct(a),_t(u)}return a}var Nt=/^\s*function (\w+)/;function Pt(t){var e=t&&t.toString().match(Nt);return e?e[1]:""}function Lt(t,e){return Pt(t)===Pt(e)}function Mt(t,e){if(!Array.isArray(e))return Lt(e,t)?0:-1;for(var n=0,r=e.length;n<r;n++)if(Lt(e[n],t))return n;return-1}function Ft(t,e,n){ct();try{if(e)for(var r=e;r=r.$parent;){var o=r.$options.errorCaptured;if(o)for(var i=0;i<o.length;i++)try{if(!1===o[i].call(r,t,e,n))return}catch(t){Vt(t,r,"errorCaptured hook")}}Vt(t,e,n)}finally{ut()}}function Rt(t,e,n,r,o){var i;try{(i=n?t.apply(e,n):t.call(e))&&!i._isVue&&u(i)&&!i._handled&&(i.catch(function(t){return Ft(t,r,o+" (Promise/async)")}),i._handled=!0)}catch(t){Ft(t,r,o)}return i}function Vt(t,e,n){if(L.errorHandler)try{return L.errorHandler.call(null,t,e,n)}catch(e){e!==t&&Ut(e,null,"config.errorHandler")}Ut(t,e,n)}function Ut(t,e,n){if(!U&&!H||"undefined"==typeof console)throw t;console.error(t)}var Ht,Bt=!1,zt=[],Wt=!1;function qt(){Wt=!1;var t=zt.slice(0);zt.length=0;for(var e=0;e<t.length;e++)t[e]()}if("undefined"!=typeof Promise&&et(Promise)){var Kt=Promise.resolve();Ht=function(){Kt.then(qt),X&&setTimeout(O)},Bt=!0}else if(W||"undefined"==typeof MutationObserver||!et(MutationObserver)&&"[object MutationObserverConstructor]"!==MutationObserver.toString())Ht="undefined"!=typeof setImmediate&&et(setImmediate)?function(){setImmediate(qt)}:function(){setTimeout(qt,0)};else{var Xt=1,Gt=new MutationObserver(qt),Zt=document.createTextNode(String(Xt));Gt.observe(Zt,{characterData:!0}),Ht=function(){Xt=(Xt+1)%2,Zt.data=String(Xt)},Bt=!0}function Jt(t,e){var n;if(zt.push(function(){if(t)try{t.call(e)}catch(t){Ft(t,e,"nextTick")}else n&&n(e)}),Wt||(Wt=!0,Ht()),!t&&"undefined"!=typeof Promise)return new Promise(function(t){n=t})}var Qt=new nt;function Yt(t){!function t(e,n){var r,o;var a=Array.isArray(e);if(!a&&!i(e)||Object.isFrozen(e)||e instanceof lt)return;if(e.__ob__){var s=e.__ob__.dep.id;if(n.has(s))return;n.add(s)}if(a)for(r=e.length;r--;)t(e[r],n);else for(o=Object.keys(e),r=o.length;r--;)t(e[o[r]],n)}(t,Qt),Qt.clear()}var te=y(function(t){var e="&"===t.charAt(0),n="~"===(t=e?t.slice(1):t).charAt(0),r="!"===(t=n?t.slice(1):t).charAt(0);return{name:t=r?t.slice(1):t,once:n,capture:r,passive:e}});function ee(t,e){function n(){var t=arguments,r=n.fns;if(!Array.isArray(r))return Rt(r,null,arguments,e,"v-on handler");for(var o=r.slice(),i=0;i<o.length;i++)Rt(o[i],null,t,e,"v-on handler")}return n.fns=t,n}function ne(t,n,o,i,a,s){var c,u,l,f;for(c in t)u=t[c],l=n[c],f=te(c),e(u)||(e(l)?(e(u.fns)&&(u=t[c]=ee(u,s)),r(f.once)&&(u=t[c]=a(f.name,u,f.capture)),o(f.name,u,f.capture,f.passive,f.params)):u!==l&&(l.fns=u,t[c]=l));for(c in n)e(t[c])&&i((f=te(c)).name,n[c],f.capture)}function re(t,o,i){var a;t instanceof lt&&(t=t.data.hook||(t.data.hook={}));var s=t[o];function c(){i.apply(this,arguments),v(a.fns,c)}e(s)?a=ee([c]):n(s.fns)&&r(s.merged)?(a=s).fns.push(c):a=ee([s,c]),a.merged=!0,t[o]=a}function oe(t,e,r,o,i){if(n(e)){if(m(e,r))return t[r]=e[r],i||delete e[r],!0;if(m(e,o))return t[r]=e[o],i||delete e[o],!0}return!1}function ie(t){return o(t)?[pt(t)]:Array.isArray(t)?function t(i,a){var s=[];var c,u,l,f;for(c=0;c<i.length;c++)e(u=i[c])||"boolean"==typeof u||(l=s.length-1,f=s[l],Array.isArray(u)?u.length>0&&(ae((u=t(u,(a||"")+"_"+c))[0])&&ae(f)&&(s[l]=pt(f.text+u[0].text),u.shift()),s.push.apply(s,u)):o(u)?ae(f)?s[l]=pt(f.text+u):""!==u&&s.push(pt(u)):ae(u)&&ae(f)?s[l]=pt(f.text+u.text):(r(i._isVList)&&n(u.tag)&&e(u.key)&&n(a)&&(u.key="__vlist"+a+"_"+c+"__"),s.push(u)));return s}(t):void 0}function ae(t){return n(t)&&n(t.text)&&!1===t.isComment}function se(t,e){if(t){for(var n=Object.create(null),r=rt?Reflect.ownKeys(t):Object.keys(t),o=0;o<r.length;o++){var i=r[o];if("__ob__"!==i){for(var a=t[i].from,s=e;s;){if(s._provided&&m(s._provided,a)){n[i]=s._provided[a];break}s=s.$parent}if(!s&&"default"in t[i]){var c=t[i].default;n[i]="function"==typeof c?c.call(e):c}}}return n}}function ce(t,e){if(!t||!t.length)return{};for(var n={},r=0,o=t.length;r<o;r++){var i=t[r],a=i.data;if(a&&a.attrs&&a.attrs.slot&&delete a.attrs.slot,i.context!==e&&i.fnContext!==e||!a||null==a.slot)(n.default||(n.default=[])).push(i);else{var s=a.slot,c=n[s]||(n[s]=[]);"template"===i.tag?c.push.apply(c,i.children||[]):c.push(i)}}for(var u in n)n[u].every(ue)&&delete n[u];return n}function ue(t){return t.isComment&&!t.asyncFactory||" "===t.text}function le(t){return t.isComment&&t.asyncFactory}function fe(e,n,r){var o,i=Object.keys(n).length>0,a=e?!!e.$stable:!i,s=e&&e.$key;if(e){if(e._normalized)return e._normalized;if(a&&r&&r!==t&&s===r.$key&&!i&&!r.$hasNormal)return r;for(var c in o={},e)e[c]&&"$"!==c[0]&&(o[c]=de(n,c,e[c]))}else o={};for(var u in n)u in o||(o[u]=pe(n,u));return e&&Object.isExtensible(e)&&(e._normalized=o),M(o,"$stable",a),M(o,"$key",s),M(o,"$hasNormal",i),o}function de(t,e,n){var r=function(){var t=arguments.length?n.apply(null,arguments):n({}),e=(t=t&&"object"==typeof t&&!Array.isArray(t)?[t]:ie(t))&&t[0];return t&&(!e||1===t.length&&e.isComment&&!le(e))?void 0:t};return n.proxy&&Object.defineProperty(t,e,{get:r,enumerable:!0,configurable:!0}),r}function pe(t,e){return function(){return t[e]}}function ve(t,e){var r,o,a,s,c;if(Array.isArray(t)||"string"==typeof t)for(r=new Array(t.length),o=0,a=t.length;o<a;o++)r[o]=e(t[o],o);else if("number"==typeof t)for(r=new Array(t),o=0;o<t;o++)r[o]=e(o+1,o);else if(i(t))if(rt&&t[Symbol.iterator]){r=[];for(var u=t[Symbol.iterator](),l=u.next();!l.done;)r.push(e(l.value,r.length)),l=u.next()}else for(s=Object.keys(t),r=new Array(s.length),o=0,a=s.length;o<a;o++)c=s[o],r[o]=e(t[c],c,o);return n(r)||(r=[]),r._isVList=!0,r}function he(t,e,n,r){var o,i=this.$scopedSlots[t];i?(n=n||{},r&&(n=x(x({},r),n)),o=i(n)||("function"==typeof e?e():e)):o=this.$slots[t]||("function"==typeof e?e():e);var a=n&&n.slot;return a?this.$createElement("template",{slot:a},o):o}function me(t){return It(this.$options,"filters",t)||E}function ye(t,e){return Array.isArray(t)?-1===t.indexOf(e):t!==e}function ge(t,e,n,r,o){var i=L.keyCodes[e]||n;return o&&r&&!L.keyCodes[e]?ye(o,r):i?ye(i,t):r?$(r)!==e:void 0===t}function _e(t,e,n,r,o){if(n)if(i(n)){var a;Array.isArray(n)&&(n=k(n));var s=function(i){if("class"===i||"style"===i||p(i))a=t;else{var s=t.attrs&&t.attrs.type;a=r||L.mustUseProp(e,s,i)?t.domProps||(t.domProps={}):t.attrs||(t.attrs={})}var c=_(i),u=$(i);c in a||u in a||(a[i]=n[i],o&&((t.on||(t.on={}))["update:"+i]=function(t){n[i]=t}))};for(var c in n)s(c)}else;return t}function be(t,e){var n=this._staticTrees||(this._staticTrees=[]),r=n[t];return r&&!e?r:($e(r=n[t]=this.$options.staticRenderFns[t].call(this._renderProxy,null,this),"__static__"+t,!1),r)}function Ce(t,e,n){return $e(t,"__once__"+e+(n?"_"+n:""),!0),t}function $e(t,e,n){if(Array.isArray(t))for(var r=0;r<t.length;r++)t[r]&&"string"!=typeof t[r]&&we(t[r],e+"_"+r,n);else we(t,e,n)}function we(t,e,n){t.isStatic=!0,t.key=e,t.isOnce=n}function Ae(t,e){if(e)if(s(e)){var n=t.on=t.on?x({},t.on):{};for(var r in e){var o=n[r],i=e[r];n[r]=o?[].concat(o,i):i}}else;return t}function xe(t,e,n,r){e=e||{$stable:!n};for(var o=0;o<t.length;o++){var i=t[o];Array.isArray(i)?xe(i,e,n):i&&(i.proxy&&(i.fn.proxy=!0),e[i.key]=i.fn)}return r&&(e.$key=r),e}function ke(t,e){for(var n=0;n<e.length;n+=2){var r=e[n];"string"==typeof r&&r&&(t[e[n]]=e[n+1])}return t}function Oe(t,e){return"string"==typeof t?e+t:t}function Se(t){t._o=Ce,t._n=f,t._s=l,t._l=ve,t._t=he,t._q=T,t._i=j,t._m=be,t._f=me,t._k=ge,t._b=_e,t._v=pt,t._e=dt,t._u=xe,t._g=Ae,t._d=ke,t._p=Oe}function Ee(e,n,o,i,a){var s,c=this,u=a.options;m(i,"_uid")?(s=Object.create(i))._original=i:(s=i,i=i._original);var l=r(u._compiled),f=!l;this.data=e,this.props=n,this.children=o,this.parent=i,this.listeners=e.on||t,this.injections=se(u.inject,i),this.slots=function(){return c.$slots||fe(e.scopedSlots,c.$slots=ce(o,i)),c.$slots},Object.defineProperty(this,"scopedSlots",{enumerable:!0,get:function(){return fe(e.scopedSlots,this.slots())}}),l&&(this.$options=u,this.$slots=this.slots(),this.$scopedSlots=fe(e.scopedSlots,this.$slots)),u._scopeId?this._c=function(t,e,n,r){var o=Fe(s,t,e,n,r,f);return o&&!Array.isArray(o)&&(o.fnScopeId=u._scopeId,o.fnContext=i),o}:this._c=function(t,e,n,r){return Fe(s,t,e,n,r,f)}}function Te(t,e,n,r,o){var i=vt(t);return i.fnContext=n,i.fnOptions=r,e.slot&&((i.data||(i.data={})).slot=e.slot),i}function je(t,e){for(var n in e)t[_(n)]=e[n]}Se(Ee.prototype);var Ie={init:function(t,e){if(t.componentInstance&&!t.componentInstance._isDestroyed&&t.data.keepAlive){var r=t;Ie.prepatch(r,r)}else{(t.componentInstance=function(t,e){var r={_isComponent:!0,_parentVnode:t,parent:e},o=t.data.inlineTemplate;n(o)&&(r.render=o.render,r.staticRenderFns=o.staticRenderFns);return new t.componentOptions.Ctor(r)}(t,Ke)).$mount(e?t.elm:void 0,e)}},prepatch:function(e,n){var r=n.componentOptions;!function(e,n,r,o,i){var a=o.data.scopedSlots,s=e.$scopedSlots,c=!!(a&&!a.$stable||s!==t&&!s.$stable||a&&e.$scopedSlots.$key!==a.$key||!a&&e.$scopedSlots.$key),u=!!(i||e.$options._renderChildren||c);e.$options._parentVnode=o,e.$vnode=o,e._vnode&&(e._vnode.parent=o);if(e.$options._renderChildren=i,e.$attrs=o.data.attrs||t,e.$listeners=r||t,n&&e.$options.props){_t(!1);for(var l=e._props,f=e.$options._propKeys||[],d=0;d<f.length;d++){var p=f[d],v=e.$options.props;l[p]=Dt(p,v,n,e)}_t(!0),e.$options.propsData=n}r=r||t;var h=e.$options._parentListeners;e.$options._parentListeners=r,qe(e,r,h),u&&(e.$slots=ce(i,o.context),e.$forceUpdate())}(n.componentInstance=e.componentInstance,r.propsData,r.listeners,n,r.children)},insert:function(t){var e,n=t.context,r=t.componentInstance;r._isMounted||(r._isMounted=!0,Je(r,"mounted")),t.data.keepAlive&&(n._isMounted?((e=r)._inactive=!1,Ye.push(e)):Ze(r,!0))},destroy:function(t){var e=t.componentInstance;e._isDestroyed||(t.data.keepAlive?function t(e,n){if(n&&(e._directInactive=!0,Ge(e)))return;if(!e._inactive){e._inactive=!0;for(var r=0;r<e.$children.length;r++)t(e.$children[r]);Je(e,"deactivated")}}(e,!0):e.$destroy())}},De=Object.keys(Ie);function Ne(o,a,s,c,l){if(!e(o)){var f=s.$options._base;if(i(o)&&(o=f.extend(o)),"function"==typeof o){var d;if(e(o.cid)&&void 0===(o=function(t,o){if(r(t.error)&&n(t.errorComp))return t.errorComp;if(n(t.resolved))return t.resolved;var a=Ve;a&&n(t.owners)&&-1===t.owners.indexOf(a)&&t.owners.push(a);if(r(t.loading)&&n(t.loadingComp))return t.loadingComp;if(a&&!n(t.owners)){var s=t.owners=[a],c=!0,l=null,f=null;a.$on("hook:destroyed",function(){return v(s,a)});var d=function(t){for(var e=0,n=s.length;e<n;e++)s[e].$forceUpdate();t&&(s.length=0,null!==l&&(clearTimeout(l),l=null),null!==f&&(clearTimeout(f),f=null))},p=I(function(e){t.resolved=Ue(e,o),c?s.length=0:d(!0)}),h=I(function(e){n(t.errorComp)&&(t.error=!0,d(!0))}),m=t(p,h);return i(m)&&(u(m)?e(t.resolved)&&m.then(p,h):u(m.component)&&(m.component.then(p,h),n(m.error)&&(t.errorComp=Ue(m.error,o)),n(m.loading)&&(t.loadingComp=Ue(m.loading,o),0===m.delay?t.loading=!0:l=setTimeout(function(){l=null,e(t.resolved)&&e(t.error)&&(t.loading=!0,d(!1))},m.delay||200)),n(m.timeout)&&(f=setTimeout(function(){f=null,e(t.resolved)&&h(null)},m.timeout)))),c=!1,t.loading?t.loadingComp:t.resolved}}(d=o,f)))return function(t,e,n,r,o){var i=dt();return i.asyncFactory=t,i.asyncMeta={data:e,context:n,children:r,tag:o},i}(d,a,s,c,l);a=a||{},bn(o),n(a.model)&&function(t,e){var r=t.model&&t.model.prop||"value",o=t.model&&t.model.event||"input";(e.attrs||(e.attrs={}))[r]=e.model.value;var i=e.on||(e.on={}),a=i[o],s=e.model.callback;n(a)?(Array.isArray(a)?-1===a.indexOf(s):a!==s)&&(i[o]=[s].concat(a)):i[o]=s}(o.options,a);var p=function(t,r,o){var i=r.options.props;if(!e(i)){var a={},s=t.attrs,c=t.props;if(n(s)||n(c))for(var u in i){var l=$(u);oe(a,c,u,l,!0)||oe(a,s,u,l,!1)}return a}}(a,o);if(r(o.options.functional))return function(e,r,o,i,a){var s=e.options,c={},u=s.props;if(n(u))for(var l in u)c[l]=Dt(l,u,r||t);else n(o.attrs)&&je(c,o.attrs),n(o.props)&&je(c,o.props);var f=new Ee(o,c,a,i,e),d=s.render.call(null,f._c,f);if(d instanceof lt)return Te(d,o,f.parent,s);if(Array.isArray(d)){for(var p=ie(d)||[],v=new Array(p.length),h=0;h<p.length;h++)v[h]=Te(p[h],o,f.parent,s);return v}}(o,p,a,s,c);var h=a.on;if(a.on=a.nativeOn,r(o.options.abstract)){var m=a.slot;a={},m&&(a.slot=m)}!function(t){for(var e=t.hook||(t.hook={}),n=0;n<De.length;n++){var r=De[n],o=e[r],i=Ie[r];o===i||o&&o._merged||(e[r]=o?Pe(i,o):i)}}(a);var y=o.options.name||l;return new lt("vue-component-"+o.cid+(y?"-"+y:""),a,void 0,void 0,void 0,s,{Ctor:o,propsData:p,listeners:h,tag:l,children:c},d)}}}function Pe(t,e){var n=function(n,r){t(n,r),e(n,r)};return n._merged=!0,n}var Le=1,Me=2;function Fe(t,a,s,c,u,l){return(Array.isArray(s)||o(s))&&(u=c,c=s,s=void 0),r(l)&&(u=Me),function(t,o,a,s,c){if(n(a)&&n(a.__ob__))return dt();n(a)&&n(a.is)&&(o=a.is);if(!o)return dt();Array.isArray(s)&&"function"==typeof s[0]&&((a=a||{}).scopedSlots={default:s[0]},s.length=0);c===Me?s=ie(s):c===Le&&(s=function(t){for(var e=0;e<t.length;e++)if(Array.isArray(t[e]))return Array.prototype.concat.apply([],t);return t}(s));var u,l;if("string"==typeof o){var f;l=t.$vnode&&t.$vnode.ns||L.getTagNamespace(o),u=L.isReservedTag(o)?new lt(L.parsePlatformTagName(o),a,s,void 0,void 0,t):a&&a.pre||!n(f=It(t.$options,"components",o))?new lt(o,a,s,void 0,void 0,t):Ne(f,a,t,s,o)}else u=Ne(o,a,t,s);return Array.isArray(u)?u:n(u)?(n(l)&&function t(o,i,a){o.ns=i;"foreignObject"===o.tag&&(i=void 0,a=!0);if(n(o.children))for(var s=0,c=o.children.length;s<c;s++){var u=o.children[s];n(u.tag)&&(e(u.ns)||r(a)&&"svg"!==u.tag)&&t(u,i,a)}}(u,l),n(a)&&function(t){i(t.style)&&Yt(t.style);i(t.class)&&Yt(t.class)}(a),u):dt()}(t,a,s,c,u)}var Re,Ve=null;function Ue(t,e){return(t.__esModule||rt&&"Module"===t[Symbol.toStringTag])&&(t=t.default),i(t)?e.extend(t):t}function He(t){if(Array.isArray(t))for(var e=0;e<t.length;e++){var r=t[e];if(n(r)&&(n(r.componentOptions)||le(r)))return r}}function Be(t,e){Re.$on(t,e)}function ze(t,e){Re.$off(t,e)}function We(t,e){var n=Re;return function r(){null!==e.apply(null,arguments)&&n.$off(t,r)}}function qe(t,e,n){Re=t,ne(e,n||{},Be,ze,We,t),Re=void 0}var Ke=null;function Xe(t){var e=Ke;return Ke=t,function(){Ke=e}}function Ge(t){for(;t&&(t=t.$parent);)if(t._inactive)return!0;return!1}function Ze(t,e){if(e){if(t._directInactive=!1,Ge(t))return}else if(t._directInactive)return;if(t._inactive||null===t._inactive){t._inactive=!1;for(var n=0;n<t.$children.length;n++)Ze(t.$children[n]);Je(t,"activated")}}function Je(t,e){ct();var n=t.$options[e],r=e+" hook";if(n)for(var o=0,i=n.length;o<i;o++)Rt(n[o],t,null,t,r);t._hasHookEvent&&t.$emit("hook:"+e),ut()}var Qe=[],Ye=[],tn={},en=!1,nn=!1,rn=0;var on=0,an=Date.now;if(U&&!W){var sn=window.performance;sn&&"function"==typeof sn.now&&an()>document.createEvent("Event").timeStamp&&(an=function(){return sn.now()})}function cn(){var t,e;for(on=an(),nn=!0,Qe.sort(function(t,e){return t.id-e.id}),rn=0;rn<Qe.length;rn++)(t=Qe[rn]).before&&t.before(),e=t.id,tn[e]=null,t.run();var n=Ye.slice(),r=Qe.slice();rn=Qe.length=Ye.length=0,tn={},en=nn=!1,function(t){for(var e=0;e<t.length;e++)t[e]._inactive=!0,Ze(t[e],!0)}(n),function(t){var e=t.length;for(;e--;){var n=t[e],r=n.vm;r._watcher===n&&r._isMounted&&!r._isDestroyed&&Je(r,"updated")}}(r),tt&&L.devtools&&tt.emit("flush")}var un=0,ln=function(t,e,n,r,o){this.vm=t,o&&(t._watcher=this),t._watchers.push(this),r?(this.deep=!!r.deep,this.user=!!r.user,this.lazy=!!r.lazy,this.sync=!!r.sync,this.before=r.before):this.deep=this.user=this.lazy=this.sync=!1,this.cb=n,this.id=++un,this.active=!0,this.dirty=this.lazy,this.deps=[],this.newDeps=[],this.depIds=new nt,this.newDepIds=new nt,this.expression="","function"==typeof e?this.getter=e:(this.getter=function(t){if(!F.test(t)){var e=t.split(".");return function(t){for(var n=0;n<e.length;n++){if(!t)return;t=t[e[n]]}return t}}}(e),this.getter||(this.getter=O)),this.value=this.lazy?void 0:this.get()};ln.prototype.get=function(){var t;ct(this);var e=this.vm;try{t=this.getter.call(e,e)}catch(t){if(!this.user)throw t;Ft(t,e,'getter for watcher "'+this.expression+'"')}finally{this.deep&&Yt(t),ut(),this.cleanupDeps()}return t},ln.prototype.addDep=function(t){var e=t.id;this.newDepIds.has(e)||(this.newDepIds.add(e),this.newDeps.push(t),this.depIds.has(e)||t.addSub(this))},ln.prototype.cleanupDeps=function(){for(var t=this.deps.length;t--;){var e=this.deps[t];this.newDepIds.has(e.id)||e.removeSub(this)}var n=this.depIds;this.depIds=this.newDepIds,this.newDepIds=n,this.newDepIds.clear(),n=this.deps,this.deps=this.newDeps,this.newDeps=n,this.newDeps.length=0},ln.prototype.update=function(){this.lazy?this.dirty=!0:this.sync?this.run():function(t){var e=t.id;if(null==tn[e]){if(tn[e]=!0,nn){for(var n=Qe.length-1;n>rn&&Qe[n].id>t.id;)n--;Qe.splice(n+1,0,t)}else Qe.push(t);en||(en=!0,Jt(cn))}}(this)},ln.prototype.run=function(){if(this.active){var t=this.get();if(t!==this.value||i(t)||this.deep){var e=this.value;if(this.value=t,this.user){var n='callback for watcher "'+this.expression+'"';Rt(this.cb,this.vm,[t,e],this.vm,n)}else this.cb.call(this.vm,t,e)}}},ln.prototype.evaluate=function(){this.value=this.get(),this.dirty=!1},ln.prototype.depend=function(){for(var t=this.deps.length;t--;)this.deps[t].depend()},ln.prototype.teardown=function(){if(this.active){this.vm._isBeingDestroyed||v(this.vm._watchers,this);for(var t=this.deps.length;t--;)this.deps[t].removeSub(this);this.active=!1}};var fn={enumerable:!0,configurable:!0,get:O,set:O};function dn(t,e,n){fn.get=function(){return this[e][n]},fn.set=function(t){this[e][n]=t},Object.defineProperty(t,n,fn)}function pn(t){t._watchers=[];var e=t.$options;e.props&&function(t,e){var n=t.$options.propsData||{},r=t._props={},o=t.$options._propKeys=[];t.$parent&&_t(!1);var i=function(i){o.push(i);var a=Dt(i,e,n,t);$t(r,i,a),i in t||dn(t,"_props",i)};for(var a in e)i(a);_t(!0)}(t,e.props),e.methods&&function(t,e){t.$options.props;for(var n in e)t[n]="function"!=typeof e[n]?O:w(e[n],t)}(t,e.methods),e.data?function(t){var e=t.$options.data;s(e=t._data="function"==typeof e?function(t,e){ct();try{return t.call(e,e)}catch(t){return Ft(t,e,"data()"),{}}finally{ut()}}(e,t):e||{})||(e={});var n=Object.keys(e),r=t.$options.props,o=(t.$options.methods,n.length);for(;o--;){var i=n[o];r&&m(r,i)||(a=void 0,36!==(a=(i+"").charCodeAt(0))&&95!==a&&dn(t,"_data",i))}var a;Ct(e,!0)}(t):Ct(t._data={},!0),e.computed&&function(t,e){var n=t._computedWatchers=Object.create(null),r=Y();for(var o in e){var i=e[o],a="function"==typeof i?i:i.get;r||(n[o]=new ln(t,a||O,O,vn)),o in t||hn(t,o,i)}}(t,e.computed),e.watch&&e.watch!==Z&&function(t,e){for(var n in e){var r=e[n];if(Array.isArray(r))for(var o=0;o<r.length;o++)gn(t,n,r[o]);else gn(t,n,r)}}(t,e.watch)}var vn={lazy:!0};function hn(t,e,n){var r=!Y();"function"==typeof n?(fn.get=r?mn(e):yn(n),fn.set=O):(fn.get=n.get?r&&!1!==n.cache?mn(e):yn(n.get):O,fn.set=n.set||O),Object.defineProperty(t,e,fn)}function mn(t){return function(){var e=this._computedWatchers&&this._computedWatchers[t];if(e)return e.dirty&&e.evaluate(),at.target&&e.depend(),e.value}}function yn(t){return function(){return t.call(this,this)}}function gn(t,e,n,r){return s(n)&&(r=n,n=n.handler),"string"==typeof n&&(n=t[n]),t.$watch(e,n,r)}var _n=0;function bn(t){var e=t.options;if(t.super){var n=bn(t.super);if(n!==t.superOptions){t.superOptions=n;var r=function(t){var e,n=t.options,r=t.sealedOptions;for(var o in n)n[o]!==r[o]&&(e||(e={}),e[o]=n[o]);return e}(t);r&&x(t.extendOptions,r),(e=t.options=jt(n,t.extendOptions)).name&&(e.components[e.name]=t)}}return e}function Cn(t){this._init(t)}function $n(t){t.cid=0;var e=1;t.extend=function(t){t=t||{};var n=this,r=n.cid,o=t._Ctor||(t._Ctor={});if(o[r])return o[r];var i=t.name||n.options.name,a=function(t){this._init(t)};return(a.prototype=Object.create(n.prototype)).constructor=a,a.cid=e++,a.options=jt(n.options,t),a.super=n,a.options.props&&function(t){var e=t.options.props;for(var n in e)dn(t.prototype,"_props",n)}(a),a.options.computed&&function(t){var e=t.options.computed;for(var n in e)hn(t.prototype,n,e[n])}(a),a.extend=n.extend,a.mixin=n.mixin,a.use=n.use,N.forEach(function(t){a[t]=n[t]}),i&&(a.options.components[i]=a),a.superOptions=n.options,a.extendOptions=t,a.sealedOptions=x({},a.options),o[r]=a,a}}function wn(t){return t&&(t.Ctor.options.name||t.tag)}function An(t,e){return Array.isArray(t)?t.indexOf(e)>-1:"string"==typeof t?t.split(",").indexOf(e)>-1:(n=t,"[object RegExp]"===a.call(n)&&t.test(e));var n}function xn(t,e){var n=t.cache,r=t.keys,o=t._vnode;for(var i in n){var a=n[i];if(a){var s=a.name;s&&!e(s)&&kn(n,i,r,o)}}}function kn(t,e,n,r){var o=t[e];!o||r&&o.tag===r.tag||o.componentInstance.$destroy(),t[e]=null,v(n,e)}!function(e){e.prototype._init=function(e){var n=this;n._uid=_n++,n._isVue=!0,e&&e._isComponent?function(t,e){var n=t.$options=Object.create(t.constructor.options),r=e._parentVnode;n.parent=e.parent,n._parentVnode=r;var o=r.componentOptions;n.propsData=o.propsData,n._parentListeners=o.listeners,n._renderChildren=o.children,n._componentTag=o.tag,e.render&&(n.render=e.render,n.staticRenderFns=e.staticRenderFns)}(n,e):n.$options=jt(bn(n.constructor),e||{},n),n._renderProxy=n,n._self=n,function(t){var e=t.$options,n=e.parent;if(n&&!e.abstract){for(;n.$options.abstract&&n.$parent;)n=n.$parent;n.$children.push(t)}t.$parent=n,t.$root=n?n.$root:t,t.$children=[],t.$refs={},t._watcher=null,t._inactive=null,t._directInactive=!1,t._isMounted=!1,t._isDestroyed=!1,t._isBeingDestroyed=!1}(n),function(t){t._events=Object.create(null),t._hasHookEvent=!1;var e=t.$options._parentListeners;e&&qe(t,e)}(n),function(e){e._vnode=null,e._staticTrees=null;var n=e.$options,r=e.$vnode=n._parentVnode,o=r&&r.context;e.$slots=ce(n._renderChildren,o),e.$scopedSlots=t,e._c=function(t,n,r,o){return Fe(e,t,n,r,o,!1)},e.$createElement=function(t,n,r,o){return Fe(e,t,n,r,o,!0)};var i=r&&r.data;$t(e,"$attrs",i&&i.attrs||t,null,!0),$t(e,"$listeners",n._parentListeners||t,null,!0)}(n),Je(n,"beforeCreate"),function(t){var e=se(t.$options.inject,t);e&&(_t(!1),Object.keys(e).forEach(function(n){$t(t,n,e[n])}),_t(!0))}(n),pn(n),function(t){var e=t.$options.provide;e&&(t._provided="function"==typeof e?e.call(t):e)}(n),Je(n,"created"),n.$options.el&&n.$mount(n.$options.el)}}(Cn),function(t){var e={get:function(){return this._data}},n={get:function(){return this._props}};Object.defineProperty(t.prototype,"$data",e),Object.defineProperty(t.prototype,"$props",n),t.prototype.$set=wt,t.prototype.$delete=At,t.prototype.$watch=function(t,e,n){if(s(e))return gn(this,t,e,n);(n=n||{}).user=!0;var r=new ln(this,t,e,n);if(n.immediate){var o='callback for immediate watcher "'+r.expression+'"';ct(),Rt(e,this,[r.value],this,o),ut()}return function(){r.teardown()}}}(Cn),function(t){var e=/^hook:/;t.prototype.$on=function(t,n){var r=this;if(Array.isArray(t))for(var o=0,i=t.length;o<i;o++)r.$on(t[o],n);else(r._events[t]||(r._events[t]=[])).push(n),e.test(t)&&(r._hasHookEvent=!0);return r},t.prototype.$once=function(t,e){var n=this;function r(){n.$off(t,r),e.apply(n,arguments)}return r.fn=e,n.$on(t,r),n},t.prototype.$off=function(t,e){var n=this;if(!arguments.length)return n._events=Object.create(null),n;if(Array.isArray(t)){for(var r=0,o=t.length;r<o;r++)n.$off(t[r],e);return n}var i,a=n._events[t];if(!a)return n;if(!e)return n._events[t]=null,n;for(var s=a.length;s--;)if((i=a[s])===e||i.fn===e){a.splice(s,1);break}return n},t.prototype.$emit=function(t){var e=this._events[t];if(e){e=e.length>1?A(e):e;for(var n=A(arguments,1),r='event handler for "'+t+'"',o=0,i=e.length;o<i;o++)Rt(e[o],this,n,this,r)}return this}}(Cn),function(t){t.prototype._update=function(t,e){var n=this,r=n.$el,o=n._vnode,i=Xe(n);n._vnode=t,n.$el=o?n.__patch__(o,t):n.__patch__(n.$el,t,e,!1),i(),r&&(r.__vue__=null),n.$el&&(n.$el.__vue__=n),n.$vnode&&n.$parent&&n.$vnode===n.$parent._vnode&&(n.$parent.$el=n.$el)},t.prototype.$forceUpdate=function(){this._watcher&&this._watcher.update()},t.prototype.$destroy=function(){var t=this;if(!t._isBeingDestroyed){Je(t,"beforeDestroy"),t._isBeingDestroyed=!0;var e=t.$parent;!e||e._isBeingDestroyed||t.$options.abstract||v(e.$children,t),t._watcher&&t._watcher.teardown();for(var n=t._watchers.length;n--;)t._watchers[n].teardown();t._data.__ob__&&t._data.__ob__.vmCount--,t._isDestroyed=!0,t.__patch__(t._vnode,null),Je(t,"destroyed"),t.$off(),t.$el&&(t.$el.__vue__=null),t.$vnode&&(t.$vnode.parent=null)}}}(Cn),function(t){Se(t.prototype),t.prototype.$nextTick=function(t){return Jt(t,this)},t.prototype._render=function(){var t,e=this,n=e.$options,r=n.render,o=n._parentVnode;o&&(e.$scopedSlots=fe(o.data.scopedSlots,e.$slots,e.$scopedSlots)),e.$vnode=o;try{Ve=e,t=r.call(e._renderProxy,e.$createElement)}catch(n){Ft(n,e,"render"),t=e._vnode}finally{Ve=null}return Array.isArray(t)&&1===t.length&&(t=t[0]),t instanceof lt||(t=dt()),t.parent=o,t}}(Cn);var On=[String,RegExp,Array],Sn={KeepAlive:{name:"keep-alive",abstract:!0,props:{include:On,exclude:On,max:[String,Number]},methods:{cacheVNode:function(){var t=this.cache,e=this.keys,n=this.vnodeToCache,r=this.keyToCache;if(n){var o=n.tag,i=n.componentInstance,a=n.componentOptions;t[r]={name:wn(a),tag:o,componentInstance:i},e.push(r),this.max&&e.length>parseInt(this.max)&&kn(t,e[0],e,this._vnode),this.vnodeToCache=null}}},created:function(){this.cache=Object.create(null),this.keys=[]},destroyed:function(){for(var t in this.cache)kn(this.cache,t,this.keys)},mounted:function(){var t=this;this.cacheVNode(),this.$watch("include",function(e){xn(t,function(t){return An(e,t)})}),this.$watch("exclude",function(e){xn(t,function(t){return!An(e,t)})})},updated:function(){this.cacheVNode()},render:function(){var t=this.$slots.default,e=He(t),n=e&&e.componentOptions;if(n){var r=wn(n),o=this.include,i=this.exclude;if(o&&(!r||!An(o,r))||i&&r&&An(i,r))return e;var a=this.cache,s=this.keys,c=null==e.key?n.Ctor.cid+(n.tag?"::"+n.tag:""):e.key;a[c]?(e.componentInstance=a[c].componentInstance,v(s,c),s.push(c)):(this.vnodeToCache=e,this.keyToCache=c),e.data.keepAlive=!0}return e||t&&t[0]}}};!function(t){var e={get:function(){return L}};Object.defineProperty(t,"config",e),t.util={warn:ot,extend:x,mergeOptions:jt,defineReactive:$t},t.set=wt,t.delete=At,t.nextTick=Jt,t.observable=function(t){return Ct(t),t},t.options=Object.create(null),N.forEach(function(e){t.options[e+"s"]=Object.create(null)}),t.options._base=t,x(t.options.components,Sn),function(t){t.use=function(t){var e=this._installedPlugins||(this._installedPlugins=[]);if(e.indexOf(t)>-1)return this;var n=A(arguments,1);return n.unshift(this),"function"==typeof t.install?t.install.apply(t,n):"function"==typeof t&&t.apply(null,n),e.push(t),this}}(t),function(t){t.mixin=function(t){return this.options=jt(this.options,t),this}}(t),$n(t),function(t){N.forEach(function(e){t[e]=function(t,n){return n?("component"===e&&s(n)&&(n.name=n.name||t,n=this.options._base.extend(n)),"directive"===e&&"function"==typeof n&&(n={bind:n,update:n}),this.options[e+"s"][t]=n,n):this.options[e+"s"][t]}})}(t)}(Cn),Object.defineProperty(Cn.prototype,"$isServer",{get:Y}),Object.defineProperty(Cn.prototype,"$ssrContext",{get:function(){return this.$vnode&&this.$vnode.ssrContext}}),Object.defineProperty(Cn,"FunctionalRenderContext",{value:Ee}),Cn.version="2.6.14";var En=d("style,class"),Tn=d("input,textarea,option,select,progress"),jn=d("contenteditable,draggable,spellcheck"),In=d("events,caret,typing,plaintext-only"),Dn=function(t,e){return Fn(e)||"false"===e?"false":"contenteditable"===t&&In(e)?e:"true"},Nn=d("allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,default,defaultchecked,defaultmuted,defaultselected,defer,disabled,enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,required,reversed,scoped,seamless,selected,sortable,truespeed,typemustmatch,visible"),Pn="http://www.w3.org/1999/xlink",Ln=function(t){return":"===t.charAt(5)&&"xlink"===t.slice(0,5)},Mn=function(t){return Ln(t)?t.slice(6,t.length):""},Fn=function(t){return null==t||!1===t};function Rn(t){for(var e=t.data,r=t,o=t;n(o.componentInstance);)(o=o.componentInstance._vnode)&&o.data&&(e=Vn(o.data,e));for(;n(r=r.parent);)r&&r.data&&(e=Vn(e,r.data));return function(t,e){if(n(t)||n(e))return Un(t,Hn(e));return""}(e.staticClass,e.class)}function Vn(t,e){return{staticClass:Un(t.staticClass,e.staticClass),class:n(t.class)?[t.class,e.class]:e.class}}function Un(t,e){return t?e?t+" "+e:t:e||""}function Hn(t){return Array.isArray(t)?function(t){for(var e,r="",o=0,i=t.length;o<i;o++)n(e=Hn(t[o]))&&""!==e&&(r&&(r+=" "),r+=e);return r}(t):i(t)?function(t){var e="";for(var n in t)t[n]&&(e&&(e+=" "),e+=n);return e}(t):"string"==typeof t?t:""}var Bn={svg:"http://www.w3.org/2000/svg",math:"http://www.w3.org/1998/Math/MathML"},zn=d("html,body,base,head,link,meta,style,title,address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,menuitem,summary,content,element,shadow,template,blockquote,iframe,tfoot"),Wn=d("svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,foreignobject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view",!0),qn=function(t){return zn(t)||Wn(t)};var Kn=Object.create(null);var Xn=d("text,number,password,search,email,tel,url");var Gn=Object.freeze({createElement:function(t,e){var n=document.createElement(t);return"select"!==t?n:(e.data&&e.data.attrs&&void 0!==e.data.attrs.multiple&&n.setAttribute("multiple","multiple"),n)},createElementNS:function(t,e){return document.createElementNS(Bn[t],e)},createTextNode:function(t){return document.createTextNode(t)},createComment:function(t){return document.createComment(t)},insertBefore:function(t,e,n){t.insertBefore(e,n)},removeChild:function(t,e){t.removeChild(e)},appendChild:function(t,e){t.appendChild(e)},parentNode:function(t){return t.parentNode},nextSibling:function(t){return t.nextSibling},tagName:function(t){return t.tagName},setTextContent:function(t,e){t.textContent=e},setStyleScope:function(t,e){t.setAttribute(e,"")}}),Zn={create:function(t,e){Jn(e)},update:function(t,e){t.data.ref!==e.data.ref&&(Jn(t,!0),Jn(e))},destroy:function(t){Jn(t,!0)}};function Jn(t,e){var r=t.data.ref;if(n(r)){var o=t.context,i=t.componentInstance||t.elm,a=o.$refs;e?Array.isArray(a[r])?v(a[r],i):a[r]===i&&(a[r]=void 0):t.data.refInFor?Array.isArray(a[r])?a[r].indexOf(i)<0&&a[r].push(i):a[r]=[i]:a[r]=i}}var Qn=new lt("",{},[]),Yn=["create","activate","update","remove","destroy"];function tr(t,o){return t.key===o.key&&t.asyncFactory===o.asyncFactory&&(t.tag===o.tag&&t.isComment===o.isComment&&n(t.data)===n(o.data)&&function(t,e){if("input"!==t.tag)return!0;var r,o=n(r=t.data)&&n(r=r.attrs)&&r.type,i=n(r=e.data)&&n(r=r.attrs)&&r.type;return o===i||Xn(o)&&Xn(i)}(t,o)||r(t.isAsyncPlaceholder)&&e(o.asyncFactory.error))}function er(t,e,r){var o,i,a={};for(o=e;o<=r;++o)n(i=t[o].key)&&(a[i]=o);return a}var nr={create:rr,update:rr,destroy:function(t){rr(t,Qn)}};function rr(t,e){(t.data.directives||e.data.directives)&&function(t,e){var n,r,o,i=t===Qn,a=e===Qn,s=ir(t.data.directives,t.context),c=ir(e.data.directives,e.context),u=[],l=[];for(n in c)r=s[n],o=c[n],r?(o.oldValue=r.value,o.oldArg=r.arg,sr(o,"update",e,t),o.def&&o.def.componentUpdated&&l.push(o)):(sr(o,"bind",e,t),o.def&&o.def.inserted&&u.push(o));if(u.length){var f=function(){for(var n=0;n<u.length;n++)sr(u[n],"inserted",e,t)};i?re(e,"insert",f):f()}l.length&&re(e,"postpatch",function(){for(var n=0;n<l.length;n++)sr(l[n],"componentUpdated",e,t)});if(!i)for(n in s)c[n]||sr(s[n],"unbind",t,t,a)}(t,e)}var or=Object.create(null);function ir(t,e){var n,r,o=Object.create(null);if(!t)return o;for(n=0;n<t.length;n++)(r=t[n]).modifiers||(r.modifiers=or),o[ar(r)]=r,r.def=It(e.$options,"directives",r.name);return o}function ar(t){return t.rawName||t.name+"."+Object.keys(t.modifiers||{}).join(".")}function sr(t,e,n,r,o){var i=t.def&&t.def[e];if(i)try{i(n.elm,t,n,r,o)}catch(r){Ft(r,n.context,"directive "+t.name+" "+e+" hook")}}var cr=[Zn,nr];function ur(t,r){var o=r.componentOptions;if(!(n(o)&&!1===o.Ctor.options.inheritAttrs||e(t.data.attrs)&&e(r.data.attrs))){var i,a,s=r.elm,c=t.data.attrs||{},u=r.data.attrs||{};for(i in n(u.__ob__)&&(u=r.data.attrs=x({},u)),u)a=u[i],c[i]!==a&&lr(s,i,a,r.data.pre);for(i in(W||K)&&u.value!==c.value&&lr(s,"value",u.value),c)e(u[i])&&(Ln(i)?s.removeAttributeNS(Pn,Mn(i)):jn(i)||s.removeAttribute(i))}}function lr(t,e,n,r){r||t.tagName.indexOf("-")>-1?fr(t,e,n):Nn(e)?Fn(n)?t.removeAttribute(e):(n="allowfullscreen"===e&&"EMBED"===t.tagName?"true":e,t.setAttribute(e,n)):jn(e)?t.setAttribute(e,Dn(e,n)):Ln(e)?Fn(n)?t.removeAttributeNS(Pn,Mn(e)):t.setAttributeNS(Pn,e,n):fr(t,e,n)}function fr(t,e,n){if(Fn(n))t.removeAttribute(e);else{if(W&&!q&&"TEXTAREA"===t.tagName&&"placeholder"===e&&""!==n&&!t.__ieph){var r=function(e){e.stopImmediatePropagation(),t.removeEventListener("input",r)};t.addEventListener("input",r),t.__ieph=!0}t.setAttribute(e,n)}}var dr={create:ur,update:ur};function pr(t,r){var o=r.elm,i=r.data,a=t.data;if(!(e(i.staticClass)&&e(i.class)&&(e(a)||e(a.staticClass)&&e(a.class)))){var s=Rn(r),c=o._transitionClasses;n(c)&&(s=Un(s,Hn(c))),s!==o._prevClass&&(o.setAttribute("class",s),o._prevClass=s)}}var vr,hr={create:pr,update:pr},mr="__r",yr="__c";function gr(t,e,n){var r=vr;return function o(){null!==e.apply(null,arguments)&&Cr(t,o,n,r)}}var _r=Bt&&!(G&&Number(G[1])<=53);function br(t,e,n,r){if(_r){var o=on,i=e;e=i._wrapper=function(t){if(t.target===t.currentTarget||t.timeStamp>=o||t.timeStamp<=0||t.target.ownerDocument!==document)return i.apply(this,arguments)}}vr.addEventListener(t,e,J?{capture:n,passive:r}:n)}function Cr(t,e,n,r){(r||vr).removeEventListener(t,e._wrapper||e,n)}function $r(t,r){if(!e(t.data.on)||!e(r.data.on)){var o=r.data.on||{},i=t.data.on||{};vr=r.elm,function(t){if(n(t[mr])){var e=W?"change":"input";t[e]=[].concat(t[mr],t[e]||[]),delete t[mr]}n(t[yr])&&(t.change=[].concat(t[yr],t.change||[]),delete t[yr])}(o),ne(o,i,br,Cr,gr,r.context),vr=void 0}}var wr,Ar={create:$r,update:$r};function xr(t,r){if(!e(t.data.domProps)||!e(r.data.domProps)){var o,i,a=r.elm,s=t.data.domProps||{},c=r.data.domProps||{};for(o in n(c.__ob__)&&(c=r.data.domProps=x({},c)),s)o in c||(a[o]="");for(o in c){if(i=c[o],"textContent"===o||"innerHTML"===o){if(r.children&&(r.children.length=0),i===s[o])continue;1===a.childNodes.length&&a.removeChild(a.childNodes[0])}if("value"===o&&"PROGRESS"!==a.tagName){a._value=i;var u=e(i)?"":String(i);kr(a,u)&&(a.value=u)}else if("innerHTML"===o&&Wn(a.tagName)&&e(a.innerHTML)){(wr=wr||document.createElement("div")).innerHTML="<svg>"+i+"</svg>";for(var l=wr.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;l.firstChild;)a.appendChild(l.firstChild)}else if(i!==s[o])try{a[o]=i}catch(t){}}}}function kr(t,e){return!t.composing&&("OPTION"===t.tagName||function(t,e){var n=!0;try{n=document.activeElement!==t}catch(t){}return n&&t.value!==e}(t,e)||function(t,e){var r=t.value,o=t._vModifiers;if(n(o)){if(o.number)return f(r)!==f(e);if(o.trim)return r.trim()!==e.trim()}return r!==e}(t,e))}var Or={create:xr,update:xr},Sr=y(function(t){var e={},n=/:(.+)/;return t.split(/;(?![^(]*\))/g).forEach(function(t){if(t){var r=t.split(n);r.length>1&&(e[r[0].trim()]=r[1].trim())}}),e});function Er(t){var e=Tr(t.style);return t.staticStyle?x(t.staticStyle,e):e}function Tr(t){return Array.isArray(t)?k(t):"string"==typeof t?Sr(t):t}var jr,Ir=/^--/,Dr=/\s*!important$/,Nr=function(t,e,n){if(Ir.test(e))t.style.setProperty(e,n);else if(Dr.test(n))t.style.setProperty($(e),n.replace(Dr,""),"important");else{var r=Lr(e);if(Array.isArray(n))for(var o=0,i=n.length;o<i;o++)t.style[r]=n[o];else t.style[r]=n}},Pr=["Webkit","Moz","ms"],Lr=y(function(t){if(jr=jr||document.createElement("div").style,"filter"!==(t=_(t))&&t in jr)return t;for(var e=t.charAt(0).toUpperCase()+t.slice(1),n=0;n<Pr.length;n++){var r=Pr[n]+e;if(r in jr)return r}});function Mr(t,r){var o=r.data,i=t.data;if(!(e(o.staticStyle)&&e(o.style)&&e(i.staticStyle)&&e(i.style))){var a,s,c=r.elm,u=i.staticStyle,l=i.normalizedStyle||i.style||{},f=u||l,d=Tr(r.data.style)||{};r.data.normalizedStyle=n(d.__ob__)?x({},d):d;var p=function(t,e){var n,r={};if(e)for(var o=t;o.componentInstance;)(o=o.componentInstance._vnode)&&o.data&&(n=Er(o.data))&&x(r,n);(n=Er(t.data))&&x(r,n);for(var i=t;i=i.parent;)i.data&&(n=Er(i.data))&&x(r,n);return r}(r,!0);for(s in f)e(p[s])&&Nr(c,s,"");for(s in p)(a=p[s])!==f[s]&&Nr(c,s,null==a?"":a)}}var Fr={create:Mr,update:Mr},Rr=/\s+/;function Vr(t,e){if(e&&(e=e.trim()))if(t.classList)e.indexOf(" ")>-1?e.split(Rr).forEach(function(e){return t.classList.add(e)}):t.classList.add(e);else{var n=" "+(t.getAttribute("class")||"")+" ";n.indexOf(" "+e+" ")<0&&t.setAttribute("class",(n+e).trim())}}function Ur(t,e){if(e&&(e=e.trim()))if(t.classList)e.indexOf(" ")>-1?e.split(Rr).forEach(function(e){return t.classList.remove(e)}):t.classList.remove(e),t.classList.length||t.removeAttribute("class");else{for(var n=" "+(t.getAttribute("class")||"")+" ",r=" "+e+" ";n.indexOf(r)>=0;)n=n.replace(r," ");(n=n.trim())?t.setAttribute("class",n):t.removeAttribute("class")}}function Hr(t){if(t){if("object"==typeof t){var e={};return!1!==t.css&&x(e,Br(t.name||"v")),x(e,t),e}return"string"==typeof t?Br(t):void 0}}var Br=y(function(t){return{enterClass:t+"-enter",enterToClass:t+"-enter-to",enterActiveClass:t+"-enter-active",leaveClass:t+"-leave",leaveToClass:t+"-leave-to",leaveActiveClass:t+"-leave-active"}}),zr=U&&!q,Wr="transition",qr="animation",Kr="transition",Xr="transitionend",Gr="animation",Zr="animationend";zr&&(void 0===window.ontransitionend&&void 0!==window.onwebkittransitionend&&(Kr="WebkitTransition",Xr="webkitTransitionEnd"),void 0===window.onanimationend&&void 0!==window.onwebkitanimationend&&(Gr="WebkitAnimation",Zr="webkitAnimationEnd"));var Jr=U?window.requestAnimationFrame?window.requestAnimationFrame.bind(window):setTimeout:function(t){return t()};function Qr(t){Jr(function(){Jr(t)})}function Yr(t,e){var n=t._transitionClasses||(t._transitionClasses=[]);n.indexOf(e)<0&&(n.push(e),Vr(t,e))}function to(t,e){t._transitionClasses&&v(t._transitionClasses,e),Ur(t,e)}function eo(t,e,n){var r=ro(t,e),o=r.type,i=r.timeout,a=r.propCount;if(!o)return n();var s=o===Wr?Xr:Zr,c=0,u=function(){t.removeEventListener(s,l),n()},l=function(e){e.target===t&&++c>=a&&u()};setTimeout(function(){c<a&&u()},i+1),t.addEventListener(s,l)}var no=/\b(transform|all)(,|$)/;function ro(t,e){var n,r=window.getComputedStyle(t),o=(r[Kr+"Delay"]||"").split(", "),i=(r[Kr+"Duration"]||"").split(", "),a=oo(o,i),s=(r[Gr+"Delay"]||"").split(", "),c=(r[Gr+"Duration"]||"").split(", "),u=oo(s,c),l=0,f=0;return e===Wr?a>0&&(n=Wr,l=a,f=i.length):e===qr?u>0&&(n=qr,l=u,f=c.length):f=(n=(l=Math.max(a,u))>0?a>u?Wr:qr:null)?n===Wr?i.length:c.length:0,{type:n,timeout:l,propCount:f,hasTransform:n===Wr&&no.test(r[Kr+"Property"])}}function oo(t,e){for(;t.length<e.length;)t=t.concat(t);return Math.max.apply(null,e.map(function(e,n){return io(e)+io(t[n])}))}function io(t){return 1e3*Number(t.slice(0,-1).replace(",","."))}function ao(t,r){var o=t.elm;n(o._leaveCb)&&(o._leaveCb.cancelled=!0,o._leaveCb());var a=Hr(t.data.transition);if(!e(a)&&!n(o._enterCb)&&1===o.nodeType){for(var s=a.css,c=a.type,u=a.enterClass,l=a.enterToClass,d=a.enterActiveClass,p=a.appearClass,v=a.appearToClass,h=a.appearActiveClass,m=a.beforeEnter,y=a.enter,g=a.afterEnter,_=a.enterCancelled,b=a.beforeAppear,C=a.appear,$=a.afterAppear,w=a.appearCancelled,A=a.duration,x=Ke,k=Ke.$vnode;k&&k.parent;)x=k.context,k=k.parent;var O=!x._isMounted||!t.isRootInsert;if(!O||C||""===C){var S=O&&p?p:u,E=O&&h?h:d,T=O&&v?v:l,j=O&&b||m,D=O&&"function"==typeof C?C:y,N=O&&$||g,P=O&&w||_,L=f(i(A)?A.enter:A),M=!1!==s&&!q,F=uo(D),R=o._enterCb=I(function(){M&&(to(o,T),to(o,E)),R.cancelled?(M&&to(o,S),P&&P(o)):N&&N(o),o._enterCb=null});t.data.show||re(t,"insert",function(){var e=o.parentNode,n=e&&e._pending&&e._pending[t.key];n&&n.tag===t.tag&&n.elm._leaveCb&&n.elm._leaveCb(),D&&D(o,R)}),j&&j(o),M&&(Yr(o,S),Yr(o,E),Qr(function(){to(o,S),R.cancelled||(Yr(o,T),F||(co(L)?setTimeout(R,L):eo(o,c,R)))})),t.data.show&&(r&&r(),D&&D(o,R)),M||F||R()}}}function so(t,r){var o=t.elm;n(o._enterCb)&&(o._enterCb.cancelled=!0,o._enterCb());var a=Hr(t.data.transition);if(e(a)||1!==o.nodeType)return r();if(!n(o._leaveCb)){var s=a.css,c=a.type,u=a.leaveClass,l=a.leaveToClass,d=a.leaveActiveClass,p=a.beforeLeave,v=a.leave,h=a.afterLeave,m=a.leaveCancelled,y=a.delayLeave,g=a.duration,_=!1!==s&&!q,b=uo(v),C=f(i(g)?g.leave:g),$=o._leaveCb=I(function(){o.parentNode&&o.parentNode._pending&&(o.parentNode._pending[t.key]=null),_&&(to(o,l),to(o,d)),$.cancelled?(_&&to(o,u),m&&m(o)):(r(),h&&h(o)),o._leaveCb=null});y?y(w):w()}function w(){$.cancelled||(!t.data.show&&o.parentNode&&((o.parentNode._pending||(o.parentNode._pending={}))[t.key]=t),p&&p(o),_&&(Yr(o,u),Yr(o,d),Qr(function(){to(o,u),$.cancelled||(Yr(o,l),b||(co(C)?setTimeout($,C):eo(o,c,$)))})),v&&v(o,$),_||b||$())}}function co(t){return"number"==typeof t&&!isNaN(t)}function uo(t){if(e(t))return!1;var r=t.fns;return n(r)?uo(Array.isArray(r)?r[0]:r):(t._length||t.length)>1}function lo(t,e){!0!==e.data.show&&ao(e)}var fo=function(t){var i,a,s={},c=t.modules,u=t.nodeOps;for(i=0;i<Yn.length;++i)for(s[Yn[i]]=[],a=0;a<c.length;++a)n(c[a][Yn[i]])&&s[Yn[i]].push(c[a][Yn[i]]);function l(t){var e=u.parentNode(t);n(e)&&u.removeChild(e,t)}function f(t,e,o,i,a,c,l){if(n(t.elm)&&n(c)&&(t=c[l]=vt(t)),t.isRootInsert=!a,!function(t,e,o,i){var a=t.data;if(n(a)){var c=n(t.componentInstance)&&a.keepAlive;if(n(a=a.hook)&&n(a=a.init)&&a(t,!1),n(t.componentInstance))return p(t,e),v(o,t.elm,i),r(c)&&function(t,e,r,o){for(var i,a=t;a.componentInstance;)if(a=a.componentInstance._vnode,n(i=a.data)&&n(i=i.transition)){for(i=0;i<s.activate.length;++i)s.activate[i](Qn,a);e.push(a);break}v(r,t.elm,o)}(t,e,o,i),!0}}(t,e,o,i)){var f=t.data,d=t.children,m=t.tag;n(m)?(t.elm=t.ns?u.createElementNS(t.ns,m):u.createElement(m,t),g(t),h(t,d,e),n(f)&&y(t,e),v(o,t.elm,i)):r(t.isComment)?(t.elm=u.createComment(t.text),v(o,t.elm,i)):(t.elm=u.createTextNode(t.text),v(o,t.elm,i))}}function p(t,e){n(t.data.pendingInsert)&&(e.push.apply(e,t.data.pendingInsert),t.data.pendingInsert=null),t.elm=t.componentInstance.$el,m(t)?(y(t,e),g(t)):(Jn(t),e.push(t))}function v(t,e,r){n(t)&&(n(r)?u.parentNode(r)===t&&u.insertBefore(t,e,r):u.appendChild(t,e))}function h(t,e,n){if(Array.isArray(e))for(var r=0;r<e.length;++r)f(e[r],n,t.elm,null,!0,e,r);else o(t.text)&&u.appendChild(t.elm,u.createTextNode(String(t.text)))}function m(t){for(;t.componentInstance;)t=t.componentInstance._vnode;return n(t.tag)}function y(t,e){for(var r=0;r<s.create.length;++r)s.create[r](Qn,t);n(i=t.data.hook)&&(n(i.create)&&i.create(Qn,t),n(i.insert)&&e.push(t))}function g(t){var e;if(n(e=t.fnScopeId))u.setStyleScope(t.elm,e);else for(var r=t;r;)n(e=r.context)&&n(e=e.$options._scopeId)&&u.setStyleScope(t.elm,e),r=r.parent;n(e=Ke)&&e!==t.context&&e!==t.fnContext&&n(e=e.$options._scopeId)&&u.setStyleScope(t.elm,e)}function _(t,e,n,r,o,i){for(;r<=o;++r)f(n[r],i,t,e,!1,n,r)}function b(t){var e,r,o=t.data;if(n(o))for(n(e=o.hook)&&n(e=e.destroy)&&e(t),e=0;e<s.destroy.length;++e)s.destroy[e](t);if(n(e=t.children))for(r=0;r<t.children.length;++r)b(t.children[r])}function C(t,e,r){for(;e<=r;++e){var o=t[e];n(o)&&(n(o.tag)?($(o),b(o)):l(o.elm))}}function $(t,e){if(n(e)||n(t.data)){var r,o=s.remove.length+1;for(n(e)?e.listeners+=o:e=function(t,e){function n(){0==--n.listeners&&l(t)}return n.listeners=e,n}(t.elm,o),n(r=t.componentInstance)&&n(r=r._vnode)&&n(r.data)&&$(r,e),r=0;r<s.remove.length;++r)s.remove[r](t,e);n(r=t.data.hook)&&n(r=r.remove)?r(t,e):e()}else l(t.elm)}function w(t,e,r,o){for(var i=r;i<o;i++){var a=e[i];if(n(a)&&tr(t,a))return i}}function A(t,o,i,a,c,l){if(t!==o){n(o.elm)&&n(a)&&(o=a[c]=vt(o));var d=o.elm=t.elm;if(r(t.isAsyncPlaceholder))n(o.asyncFactory.resolved)?O(t.elm,o,i):o.isAsyncPlaceholder=!0;else if(r(o.isStatic)&&r(t.isStatic)&&o.key===t.key&&(r(o.isCloned)||r(o.isOnce)))o.componentInstance=t.componentInstance;else{var p,v=o.data;n(v)&&n(p=v.hook)&&n(p=p.prepatch)&&p(t,o);var h=t.children,y=o.children;if(n(v)&&m(o)){for(p=0;p<s.update.length;++p)s.update[p](t,o);n(p=v.hook)&&n(p=p.update)&&p(t,o)}e(o.text)?n(h)&&n(y)?h!==y&&function(t,r,o,i,a){for(var s,c,l,d=0,p=0,v=r.length-1,h=r[0],m=r[v],y=o.length-1,g=o[0],b=o[y],$=!a;d<=v&&p<=y;)e(h)?h=r[++d]:e(m)?m=r[--v]:tr(h,g)?(A(h,g,i,o,p),h=r[++d],g=o[++p]):tr(m,b)?(A(m,b,i,o,y),m=r[--v],b=o[--y]):tr(h,b)?(A(h,b,i,o,y),$&&u.insertBefore(t,h.elm,u.nextSibling(m.elm)),h=r[++d],b=o[--y]):tr(m,g)?(A(m,g,i,o,p),$&&u.insertBefore(t,m.elm,h.elm),m=r[--v],g=o[++p]):(e(s)&&(s=er(r,d,v)),e(c=n(g.key)?s[g.key]:w(g,r,d,v))?f(g,i,t,h.elm,!1,o,p):tr(l=r[c],g)?(A(l,g,i,o,p),r[c]=void 0,$&&u.insertBefore(t,l.elm,h.elm)):f(g,i,t,h.elm,!1,o,p),g=o[++p]);d>v?_(t,e(o[y+1])?null:o[y+1].elm,o,p,y,i):p>y&&C(r,d,v)}(d,h,y,i,l):n(y)?(n(t.text)&&u.setTextContent(d,""),_(d,null,y,0,y.length-1,i)):n(h)?C(h,0,h.length-1):n(t.text)&&u.setTextContent(d,""):t.text!==o.text&&u.setTextContent(d,o.text),n(v)&&n(p=v.hook)&&n(p=p.postpatch)&&p(t,o)}}}function x(t,e,o){if(r(o)&&n(t.parent))t.parent.data.pendingInsert=e;else for(var i=0;i<e.length;++i)e[i].data.hook.insert(e[i])}var k=d("attrs,class,staticClass,staticStyle,key");function O(t,e,o,i){var a,s=e.tag,c=e.data,u=e.children;if(i=i||c&&c.pre,e.elm=t,r(e.isComment)&&n(e.asyncFactory))return e.isAsyncPlaceholder=!0,!0;if(n(c)&&(n(a=c.hook)&&n(a=a.init)&&a(e,!0),n(a=e.componentInstance)))return p(e,o),!0;if(n(s)){if(n(u))if(t.hasChildNodes())if(n(a=c)&&n(a=a.domProps)&&n(a=a.innerHTML)){if(a!==t.innerHTML)return!1}else{for(var l=!0,f=t.firstChild,d=0;d<u.length;d++){if(!f||!O(f,u[d],o,i)){l=!1;break}f=f.nextSibling}if(!l||f)return!1}else h(e,u,o);if(n(c)){var v=!1;for(var m in c)if(!k(m)){v=!0,y(e,o);break}!v&&c.class&&Yt(c.class)}}else t.data!==e.text&&(t.data=e.text);return!0}return function(t,o,i,a){if(!e(o)){var c,l=!1,d=[];if(e(t))l=!0,f(o,d);else{var p=n(t.nodeType);if(!p&&tr(t,o))A(t,o,d,null,null,a);else{if(p){if(1===t.nodeType&&t.hasAttribute(D)&&(t.removeAttribute(D),i=!0),r(i)&&O(t,o,d))return x(o,d,!0),t;c=t,t=new lt(u.tagName(c).toLowerCase(),{},[],void 0,c)}var v=t.elm,h=u.parentNode(v);if(f(o,d,v._leaveCb?null:h,u.nextSibling(v)),n(o.parent))for(var y=o.parent,g=m(o);y;){for(var _=0;_<s.destroy.length;++_)s.destroy[_](y);if(y.elm=o.elm,g){for(var $=0;$<s.create.length;++$)s.create[$](Qn,y);var w=y.data.hook.insert;if(w.merged)for(var k=1;k<w.fns.length;k++)w.fns[k]()}else Jn(y);y=y.parent}n(h)?C([t],0,0):n(t.tag)&&b(t)}}return x(o,d,l),o.elm}n(t)&&b(t)}}({nodeOps:Gn,modules:[dr,hr,Ar,Or,Fr,U?{create:lo,activate:lo,remove:function(t,e){!0!==t.data.show?so(t,e):e()}}:{}].concat(cr)});q&&document.addEventListener("selectionchange",function(){var t=document.activeElement;t&&t.vmodel&&bo(t,"input")});var po={inserted:function(t,e,n,r){"select"===n.tag?(r.elm&&!r.elm._vOptions?re(n,"postpatch",function(){po.componentUpdated(t,e,n)}):vo(t,e,n.context),t._vOptions=[].map.call(t.options,yo)):("textarea"===n.tag||Xn(t.type))&&(t._vModifiers=e.modifiers,e.modifiers.lazy||(t.addEventListener("compositionstart",go),t.addEventListener("compositionend",_o),t.addEventListener("change",_o),q&&(t.vmodel=!0)))},componentUpdated:function(t,e,n){if("select"===n.tag){vo(t,e,n.context);var r=t._vOptions,o=t._vOptions=[].map.call(t.options,yo);if(o.some(function(t,e){return!T(t,r[e])}))(t.multiple?e.value.some(function(t){return mo(t,o)}):e.value!==e.oldValue&&mo(e.value,o))&&bo(t,"change")}}};function vo(t,e,n){ho(t,e,n),(W||K)&&setTimeout(function(){ho(t,e,n)},0)}function ho(t,e,n){var r=e.value,o=t.multiple;if(!o||Array.isArray(r)){for(var i,a,s=0,c=t.options.length;s<c;s++)if(a=t.options[s],o)i=j(r,yo(a))>-1,a.selected!==i&&(a.selected=i);else if(T(yo(a),r))return void(t.selectedIndex!==s&&(t.selectedIndex=s));o||(t.selectedIndex=-1)}}function mo(t,e){return e.every(function(e){return!T(e,t)})}function yo(t){return"_value"in t?t._value:t.value}function go(t){t.target.composing=!0}function _o(t){t.target.composing&&(t.target.composing=!1,bo(t.target,"input"))}function bo(t,e){var n=document.createEvent("HTMLEvents");n.initEvent(e,!0,!0),t.dispatchEvent(n)}function Co(t){return!t.componentInstance||t.data&&t.data.transition?t:Co(t.componentInstance._vnode)}var $o={model:po,show:{bind:function(t,e,n){var r=e.value,o=(n=Co(n)).data&&n.data.transition,i=t.__vOriginalDisplay="none"===t.style.display?"":t.style.display;r&&o?(n.data.show=!0,ao(n,function(){t.style.display=i})):t.style.display=r?i:"none"},update:function(t,e,n){var r=e.value;!r!=!e.oldValue&&((n=Co(n)).data&&n.data.transition?(n.data.show=!0,r?ao(n,function(){t.style.display=t.__vOriginalDisplay}):so(n,function(){t.style.display="none"})):t.style.display=r?t.__vOriginalDisplay:"none")},unbind:function(t,e,n,r,o){o||(t.style.display=t.__vOriginalDisplay)}}},wo={name:String,appear:Boolean,css:Boolean,mode:String,type:String,enterClass:String,leaveClass:String,enterToClass:String,leaveToClass:String,enterActiveClass:String,leaveActiveClass:String,appearClass:String,appearActiveClass:String,appearToClass:String,duration:[Number,String,Object]};function Ao(t){var e=t&&t.componentOptions;return e&&e.Ctor.options.abstract?Ao(He(e.children)):t}function xo(t){var e={},n=t.$options;for(var r in n.propsData)e[r]=t[r];var o=n._parentListeners;for(var i in o)e[_(i)]=o[i];return e}function ko(t,e){if(/\d-keep-alive$/.test(e.tag))return t("keep-alive",{props:e.componentOptions.propsData})}var Oo=function(t){return t.tag||le(t)},So=function(t){return"show"===t.name},Eo={name:"transition",props:wo,abstract:!0,render:function(t){var e=this,n=this.$slots.default;if(n&&(n=n.filter(Oo)).length){var r=this.mode,i=n[0];if(function(t){for(;t=t.parent;)if(t.data.transition)return!0}(this.$vnode))return i;var a=Ao(i);if(!a)return i;if(this._leaving)return ko(t,i);var s="__transition-"+this._uid+"-";a.key=null==a.key?a.isComment?s+"comment":s+a.tag:o(a.key)?0===String(a.key).indexOf(s)?a.key:s+a.key:a.key;var c=(a.data||(a.data={})).transition=xo(this),u=this._vnode,l=Ao(u);if(a.data.directives&&a.data.directives.some(So)&&(a.data.show=!0),l&&l.data&&!function(t,e){return e.key===t.key&&e.tag===t.tag}(a,l)&&!le(l)&&(!l.componentInstance||!l.componentInstance._vnode.isComment)){var f=l.data.transition=x({},c);if("out-in"===r)return this._leaving=!0,re(f,"afterLeave",function(){e._leaving=!1,e.$forceUpdate()}),ko(t,i);if("in-out"===r){if(le(a))return u;var d,p=function(){d()};re(c,"afterEnter",p),re(c,"enterCancelled",p),re(f,"delayLeave",function(t){d=t})}}return i}}},To=x({tag:String,moveClass:String},wo);function jo(t){t.elm._moveCb&&t.elm._moveCb(),t.elm._enterCb&&t.elm._enterCb()}function Io(t){t.data.newPos=t.elm.getBoundingClientRect()}function Do(t){var e=t.data.pos,n=t.data.newPos,r=e.left-n.left,o=e.top-n.top;if(r||o){t.data.moved=!0;var i=t.elm.style;i.transform=i.WebkitTransform="translate("+r+"px,"+o+"px)",i.transitionDuration="0s"}}delete To.mode;var No={Transition:Eo,TransitionGroup:{props:To,beforeMount:function(){var t=this,e=this._update;this._update=function(n,r){var o=Xe(t);t.__patch__(t._vnode,t.kept,!1,!0),t._vnode=t.kept,o(),e.call(t,n,r)}},render:function(t){for(var e=this.tag||this.$vnode.data.tag||"span",n=Object.create(null),r=this.prevChildren=this.children,o=this.$slots.default||[],i=this.children=[],a=xo(this),s=0;s<o.length;s++){var c=o[s];c.tag&&null!=c.key&&0!==String(c.key).indexOf("__vlist")&&(i.push(c),n[c.key]=c,(c.data||(c.data={})).transition=a)}if(r){for(var u=[],l=[],f=0;f<r.length;f++){var d=r[f];d.data.transition=a,d.data.pos=d.elm.getBoundingClientRect(),n[d.key]?u.push(d):l.push(d)}this.kept=t(e,null,u),this.removed=l}return t(e,null,i)},updated:function(){var t=this.prevChildren,e=this.moveClass||(this.name||"v")+"-move";t.length&&this.hasMove(t[0].elm,e)&&(t.forEach(jo),t.forEach(Io),t.forEach(Do),this._reflow=document.body.offsetHeight,t.forEach(function(t){if(t.data.moved){var n=t.elm,r=n.style;Yr(n,e),r.transform=r.WebkitTransform=r.transitionDuration="",n.addEventListener(Xr,n._moveCb=function t(r){r&&r.target!==n||r&&!/transform$/.test(r.propertyName)||(n.removeEventListener(Xr,t),n._moveCb=null,to(n,e))})}}))},methods:{hasMove:function(t,e){if(!zr)return!1;if(this._hasMove)return this._hasMove;var n=t.cloneNode();t._transitionClasses&&t._transitionClasses.forEach(function(t){Ur(n,t)}),Vr(n,e),n.style.display="none",this.$el.appendChild(n);var r=ro(n);return this.$el.removeChild(n),this._hasMove=r.hasTransform}}}};Cn.config.mustUseProp=function(t,e,n){return"value"===n&&Tn(t)&&"button"!==e||"selected"===n&&"option"===t||"checked"===n&&"input"===t||"muted"===n&&"video"===t},Cn.config.isReservedTag=qn,Cn.config.isReservedAttr=En,Cn.config.getTagNamespace=function(t){return Wn(t)?"svg":"math"===t?"math":void 0},Cn.config.isUnknownElement=function(t){if(!U)return!0;if(qn(t))return!1;if(t=t.toLowerCase(),null!=Kn[t])return Kn[t];var e=document.createElement(t);return t.indexOf("-")>-1?Kn[t]=e.constructor===window.HTMLUnknownElement||e.constructor===window.HTMLElement:Kn[t]=/HTMLUnknownElement/.test(e.toString())},x(Cn.options.directives,$o),x(Cn.options.components,No),Cn.prototype.__patch__=U?fo:O,Cn.prototype.$mount=function(t,e){return function(t,e,n){var r;return t.$el=e,t.$options.render||(t.$options.render=dt),Je(t,"beforeMount"),r=function(){t._update(t._render(),n)},new ln(t,r,O,{before:function(){t._isMounted&&!t._isDestroyed&&Je(t,"beforeUpdate")}},!0),n=!1,null==t.$vnode&&(t._isMounted=!0,Je(t,"mounted")),t}(this,t=t&&U?function(t){if("string"==typeof t){var e=document.querySelector(t);return e||document.createElement("div")}return t}(t):void 0,e)},U&&setTimeout(function(){L.devtools&&tt&&tt.emit("init",Cn)},0),module.exports=Cn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(200).setImmediate))

/***/ }),
/* 487 */,
/* 488 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if (media) {
			styleElement.setAttribute("media", media);
		}
	
		if (sourceMap) {
			// https://developer.chrome.com/devtools/docs/javascript-debugging
			// this makes source maps inside style tags work properly in Chrome
			css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */';
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}


/***/ })
]);


// WEBPACK FOOTER //
// static/js/vendor.2fe8f2cc186fa21c5755.js